!function(a,b){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){"use strict";var c=[],d=a.document,e=Object.getPrototypeOf,f=c.slice,g=c.concat,h=c.push,i=c.indexOf,j={},k=j.toString,l=j.hasOwnProperty,m=l.toString,n=m.call(Object),o={};function p(a,b){b=b||d;var c=b.createElement("script");c.text=a,b.head.appendChild(c).parentNode.removeChild(c)}var q="3.1.0",r=function(a,b){return new r.fn.init(a,b)},s=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,t=/^-ms-/,u=/-([a-z])/g,v=function(a,b){return b.toUpperCase()};r.fn=r.prototype={jquery:q,constructor:r,length:0,toArray:function(){return f.call(this)},get:function(a){return null!=a?a<0?this[a+this.length]:this[a]:f.call(this)},pushStack:function(a){var b=r.merge(this.constructor(),a);return b.prevObject=this,b},each:function(a){return r.each(this,a)},map:function(a){return this.pushStack(r.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(f.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(a<0?b:0);return this.pushStack(c>=0&&c<b?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:h,sort:c.sort,splice:c.splice},r.extend=r.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||r.isFunction(g)||(g={}),h===i&&(g=this,h--);h<i;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(r.isPlainObject(d)||(e=r.isArray(d)))?(e?(e=!1,f=c&&r.isArray(c)?c:[]):f=c&&r.isPlainObject(c)?c:{},g[b]=r.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},r.extend({expando:"jQuery"+(q+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===r.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){var b=r.type(a);return("number"===b||"string"===b)&&!isNaN(a-parseFloat(a))},isPlainObject:function(a){var b,c;return!(!a||"[object Object]"!==k.call(a))&&(!(b=e(a))||(c=l.call(b,"constructor")&&b.constructor,"function"==typeof c&&m.call(c)===n))},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?j[k.call(a)]||"object":typeof a},globalEval:function(a){p(a)},camelCase:function(a){return a.replace(t,"ms-").replace(u,v)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b){var c,d=0;if(w(a)){for(c=a.length;d<c;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(s,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(w(Object(a))?r.merge(c,"string"==typeof a?[a]:a):h.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:i.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;d<c;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;f<g;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,f=0,h=[];if(w(a))for(d=a.length;f<d;f++)e=b(a[f],f,c),null!=e&&h.push(e);else for(f in a)e=b(a[f],f,c),null!=e&&h.push(e);return g.apply([],h)},guid:1,proxy:function(a,b){var c,d,e;if("string"==typeof b&&(c=a[b],b=a,a=c),r.isFunction(a))return d=f.call(arguments,2),e=function(){return a.apply(b||this,d.concat(f.call(arguments)))},e.guid=a.guid=a.guid||r.guid++,e},now:Date.now,support:o}),"function"==typeof Symbol&&(r.fn[Symbol.iterator]=c[Symbol.iterator]),r.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(a,b){j["[object "+b+"]"]=b.toLowerCase()});function w(a){var b=!!a&&"length"in a&&a.length,c=r.type(a);return"function"!==c&&!r.isWindow(a)&&("array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a)}var x=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ga(),z=ga(),A=ga(),B=function(a,b){return a===b&&(l=!0),0},C={}.hasOwnProperty,D=[],E=D.pop,F=D.push,G=D.push,H=D.slice,I=function(a,b){for(var c=0,d=a.length;c<d;c++)if(a[c]===b)return c;return-1},J="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",K="[\\x20\\t\\r\\n\\f]",L="(?:\\\\.|[\\w-]|[^\0-\\xa0])+",M="\\["+K+"*("+L+")(?:"+K+"*([*^$|!~]?=)"+K+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+L+"))|)"+K+"*\\]",N=":("+L+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+M+")*)|.*)\\)|)",O=new RegExp(K+"+","g"),P=new RegExp("^"+K+"+|((?:^|[^\\\\])(?:\\\\.)*)"+K+"+$","g"),Q=new RegExp("^"+K+"*,"+K+"*"),R=new RegExp("^"+K+"*([>+~]|"+K+")"+K+"*"),S=new RegExp("="+K+"*([^\\]'\"]*?)"+K+"*\\]","g"),T=new RegExp(N),U=new RegExp("^"+L+"$"),V={ID:new RegExp("^#("+L+")"),CLASS:new RegExp("^\\.("+L+")"),TAG:new RegExp("^("+L+"|[*])"),ATTR:new RegExp("^"+M),PSEUDO:new RegExp("^"+N),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+K+"*(even|odd|(([+-]|)(\\d*)n|)"+K+"*(?:([+-]|)"+K+"*(\\d+)|))"+K+"*\\)|)","i"),bool:new RegExp("^(?:"+J+")$","i"),needsContext:new RegExp("^"+K+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+K+"*((?:-\\d)?\\d*)"+K+"*\\)|)(?=[^-]|$)","i")},W=/^(?:input|select|textarea|button)$/i,X=/^h\d$/i,Y=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,$=/[+~]/,_=new RegExp("\\\\([\\da-f]{1,6}"+K+"?|("+K+")|.)","ig"),aa=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:d<0?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},ba=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,ca=function(a,b){return b?"\0"===a?"\ufffd":a.slice(0,-1)+"\\"+a.charCodeAt(a.length-1).toString(16)+" ":"\\"+a},da=function(){m()},ea=sa(function(a){return a.disabled===!0},{dir:"parentNode",next:"legend"});try{G.apply(D=H.call(v.childNodes),v.childNodes),D[v.childNodes.length].nodeType}catch(a){G={apply:D.length?function(a,b){F.apply(a,H.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function fa(a,b,d,e){var f,h,j,k,l,o,r,s=b&&b.ownerDocument,w=b?b.nodeType:9;if(d=d||[],"string"!=typeof a||!a||1!==w&&9!==w&&11!==w)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==w&&(l=Z.exec(a)))if(f=l[1]){if(9===w){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(s&&(j=s.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(l[2])return G.apply(d,b.getElementsByTagName(a)),d;if((f=l[3])&&c.getElementsByClassName&&b.getElementsByClassName)return G.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+" "]&&(!q||!q.test(a))){if(1!==w)s=b,r=a;else if("object"!==b.nodeName.toLowerCase()){(k=b.getAttribute("id"))?k=k.replace(ba,ca):b.setAttribute("id",k=u),o=g(a),h=o.length;while(h--)o[h]="#"+k+" "+ra(o[h]);r=o.join(","),s=$.test(a)&&pa(b.parentNode)||b}if(r)try{return G.apply(d,s.querySelectorAll(r)),d}catch(a){}finally{k===u&&b.removeAttribute("id")}}}return i(a.replace(P,"$1"),b,d,e)}function ga(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ha(a){return a[u]=!0,a}function ia(a){var b=n.createElement("fieldset");try{return!!a(b)}catch(a){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ja(a,b){var c=a.split("|"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function ka(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&a.sourceIndex-b.sourceIndex;if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function la(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function na(a){return function(b){return"label"in b&&b.disabled===a||"form"in b&&b.disabled===a||"form"in b&&b.disabled===!1&&(b.isDisabled===a||b.isDisabled!==!a&&("label"in b||!ea(b))!==a)}}function oa(a){return ha(function(b){return b=+b,ha(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function pa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=fa.support={},f=fa.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return!!b&&"HTML"!==b.nodeName},m=fa.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),v!==n&&(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",da,!1):e.attachEvent&&e.attachEvent("onunload",da)),c.attributes=ia(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ia(function(a){return a.appendChild(n.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Y.test(n.getElementsByClassName),c.getById=ia(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}},d.filter.ID=function(a){var b=a.replace(_,aa);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(_,aa);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){if("undefined"!=typeof b.getElementsByClassName&&p)return b.getElementsByClassName(a)},r=[],q=[],(c.qsa=Y.test(n.querySelectorAll))&&(ia(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\r\\' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+K+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+K+"*(?:value|"+J+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ia(function(a){a.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var b=n.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+K+"*[*^$|!~]?="),2!==a.querySelectorAll(":enabled").length&&q.push(":enabled",":disabled"),o.appendChild(a).disabled=!0,2!==a.querySelectorAll(":disabled").length&&q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=Y.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ia(function(a){c.disconnectedMatch=s.call(a,"*"),s.call(a,"[s!='']:x"),r.push("!=",N)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=Y.test(o.compareDocumentPosition),t=b||Y.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?I(k,a)-I(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?I(k,a)-I(k,b):0;if(e===f)return ka(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?ka(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},fa.matches=function(a,b){return fa(a,null,null,b)},fa.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(S,"='$1']"),c.matchesSelector&&p&&!A[b+" "]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(a){}return fa(b,n,null,[a]).length>0},fa.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},fa.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&C.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},fa.escape=function(a){return(a+"").replace(ba,ca)},fa.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},fa.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=fa.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=fa.selectors={cacheLength:50,createPseudo:ha,match:V,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(_,aa),a[3]=(a[3]||a[4]||a[5]||"").replace(_,aa),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||fa.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&fa.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return V.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&T.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(_,aa).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+K+")"+a+"("+K+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=fa.attr(d,a);return null==e?"!="===b:!b||(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(O," ")+" ").indexOf(c)>-1:"|="===b&&(e===c||e.slice(0,c.length+1)===c+"-"))}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||fa.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ha(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=I(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ha(function(a){var b=[],c=[],d=h(a.replace(P,"$1"));return d[u]?ha(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ha(function(a){return function(b){return fa(a,b).length>0}}),contains:ha(function(a){return a=a.replace(_,aa),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ha(function(a){return U.test(a||"")||fa.error("unsupported lang: "+a),a=a.replace(_,aa).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:na(!1),disabled:na(!0),checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return X.test(a.nodeName)},input:function(a){return W.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:oa(function(){return[0]}),last:oa(function(a,b){return[b-1]}),eq:oa(function(a,b,c){return[c<0?c+b:c]}),even:oa(function(a,b){for(var c=0;c<b;c+=2)a.push(c);return a}),odd:oa(function(a,b){for(var c=1;c<b;c+=2)a.push(c);return a}),lt:oa(function(a,b,c){for(var d=c<0?c+b:c;--d>=0;)a.push(d);return a}),gt:oa(function(a,b,c){for(var d=c<0?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=la(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=ma(b);function qa(){}qa.prototype=d.filters=d.pseudos,d.setFilters=new qa,g=fa.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){c&&!(e=Q.exec(h))||(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=R.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(P," ")}),h=h.slice(c.length));for(g in d.filter)!(e=V[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?fa.error(a):z(a,i).slice(0)};function ra(a){for(var b=0,c=a.length,d="";b<c;b++)d+=a[b].value;return d}function sa(a,b,c){var d=b.dir,e=b.next,f=e||d,g=c&&"parentNode"===f,h=x++;return b.first?function(b,c,e){while(b=b[d])if(1===b.nodeType||g)return a(b,c,e)}:function(b,c,i){var j,k,l,m=[w,h];if(i){while(b=b[d])if((1===b.nodeType||g)&&a(b,c,i))return!0}else while(b=b[d])if(1===b.nodeType||g)if(l=b[u]||(b[u]={}),k=l[b.uniqueID]||(l[b.uniqueID]={}),e&&e===b.nodeName.toLowerCase())b=b[d]||b;else{if((j=k[f])&&j[0]===w&&j[1]===h)return m[2]=j[2];if(k[f]=m,m[2]=a(b,c,i))return!0}}}function ta(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ua(a,b,c){for(var d=0,e=b.length;d<e;d++)fa(a,b[d],c);return c}function va(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;h<i;h++)(f=a[h])&&(c&&!c(f,d,e)||(g.push(f),j&&b.push(h)));return g}function wa(a,b,c,d,e,f){return d&&!d[u]&&(d=wa(d)),e&&!e[u]&&(e=wa(e,f)),ha(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ua(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:va(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=va(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?I(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=va(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):G.apply(g,r)})}function xa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=sa(function(a){return a===b},h,!0),l=sa(function(a){return I(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];i<f;i++)if(c=d.relative[a[i].type])m=[sa(ta(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;e<f;e++)if(d.relative[a[e].type])break;return wa(i>1&&ta(m),i>1&&ra(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(P,"$1"),c,i<e&&xa(a.slice(i,e)),e<f&&xa(a=a.slice(e)),e<f&&ra(a))}m.push(c)}return ta(m)}function ya(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s="0",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG("*",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=E.call(i));u=va(u)}G.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&fa.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ha(f):f}return h=fa.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=xa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,ya(e,d)),f.selector=a}return f},i=fa.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(_,aa),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=V.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(_,aa),$.test(j[0].type)&&pa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&ra(j),!a)return G.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,!b||$.test(a)&&pa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ia(function(a){return 1&a.compareDocumentPosition(n.createElement("fieldset"))}),ia(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ja("type|href|height|width",function(a,b,c){if(!c)return a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ia(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ja("value",function(a,b,c){if(!c&&"input"===a.nodeName.toLowerCase())return a.defaultValue}),ia(function(a){return null==a.getAttribute("disabled")})||ja(J,function(a,b,c){var d;if(!c)return a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),fa}(a);r.find=x,r.expr=x.selectors,r.expr[":"]=r.expr.pseudos,r.uniqueSort=r.unique=x.uniqueSort,r.text=x.getText,r.isXMLDoc=x.isXML,r.contains=x.contains,r.escapeSelector=x.escape;var y=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&r(a).is(c))break;d.push(a)}return d},z=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},A=r.expr.match.needsContext,B=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i,C=/^.[^:#\[\.,]*$/;function D(a,b,c){if(r.isFunction(b))return r.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return r.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(C.test(b))return r.filter(b,a,c);b=r.filter(b,a)}return r.grep(a,function(a){return i.call(b,a)>-1!==c&&1===a.nodeType})}r.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?r.find.matchesSelector(d,a)?[d]:[]:r.find.matches(a,r.grep(b,function(a){return 1===a.nodeType}))},r.fn.extend({find:function(a){var b,c,d=this.length,e=this;if("string"!=typeof a)return this.pushStack(r(a).filter(function(){for(b=0;b<d;b++)if(r.contains(e[b],this))return!0}));for(c=this.pushStack([]),b=0;b<d;b++)r.find(a,e[b],c);return d>1?r.uniqueSort(c):c},filter:function(a){return this.pushStack(D(this,a||[],!1))},not:function(a){return this.pushStack(D(this,a||[],!0))},is:function(a){return!!D(this,"string"==typeof a&&A.test(a)?r(a):a||[],!1).length}});var E,F=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,G=r.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||E,"string"==typeof a){if(e="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:F.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof r?b[0]:b,r.merge(this,r.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),B.test(e[1])&&r.isPlainObject(b))for(e in b)r.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}return f=d.getElementById(e[2]),f&&(this[0]=f,this.length=1),this}return a.nodeType?(this[0]=a,this.length=1,this):r.isFunction(a)?void 0!==c.ready?c.ready(a):a(r):r.makeArray(a,this)};G.prototype=r.fn,E=r(d);var H=/^(?:parents|prev(?:Until|All))/,I={children:!0,contents:!0,next:!0,prev:!0};r.fn.extend({has:function(a){var b=r(a,this),c=b.length;return this.filter(function(){for(var a=0;a<c;a++)if(r.contains(this,b[a]))return!0})},closest:function(a,b){var c,d=0,e=this.length,f=[],g="string"!=typeof a&&r(a);if(!A.test(a))for(;d<e;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&r.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?r.uniqueSort(f):f)},index:function(a){return a?"string"==typeof a?i.call(r(a),this[0]):i.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(r.uniqueSort(r.merge(this.get(),r(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function J(a,b){while((a=a[b])&&1!==a.nodeType);return a}r.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return y(a,"parentNode")},parentsUntil:function(a,b,c){return y(a,"parentNode",c)},next:function(a){return J(a,"nextSibling")},prev:function(a){return J(a,"previousSibling")},nextAll:function(a){return y(a,"nextSibling")},prevAll:function(a){return y(a,"previousSibling")},nextUntil:function(a,b,c){return y(a,"nextSibling",c)},prevUntil:function(a,b,c){return y(a,"previousSibling",c)},siblings:function(a){return z((a.parentNode||{}).firstChild,a)},children:function(a){return z(a.firstChild)},contents:function(a){return a.contentDocument||r.merge([],a.childNodes)}},function(a,b){r.fn[a]=function(c,d){var e=r.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=r.filter(d,e)),this.length>1&&(I[a]||r.uniqueSort(e),H.test(a)&&e.reverse()),this.pushStack(e)}});var K=/\S+/g;function L(a){var b={};return r.each(a.match(K)||[],function(a,c){b[c]=!0}),b}r.Callbacks=function(a){a="string"==typeof a?L(a):r.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:"")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function b(c){r.each(c,function(c,d){r.isFunction(d)?a.unique&&j.has(d)||f.push(d):d&&d.length&&"string"!==r.type(d)&&b(d)})}(arguments),c&&!b&&i()),this},remove:function(){return r.each(arguments,function(a,b){var c;while((c=r.inArray(b,f,c))>-1)f.splice(c,1),c<=h&&h--}),this},has:function(a){return a?r.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c="",this},disabled:function(){return!f},lock:function(){return e=g=[],c||b||(f=c=""),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j};function M(a){return a}function N(a){throw a}function O(a,b,c){var d;try{a&&r.isFunction(d=a.promise)?d.call(a).done(b).fail(c):a&&r.isFunction(d=a.then)?d.call(a,b,c):b.call(void 0,a)}catch(a){c.call(void 0,a)}}r.extend({Deferred:function(b){var c=[["notify","progress",r.Callbacks("memory"),r.Callbacks("memory"),2],["resolve","done",r.Callbacks("once memory"),r.Callbacks("once memory"),0,"resolved"],["reject","fail",r.Callbacks("once memory"),r.Callbacks("once memory"),1,"rejected"]],d="pending",e={state:function(){return d},always:function(){return f.done(arguments).fail(arguments),this},catch:function(a){return e.then(null,a)},pipe:function(){var a=arguments;return r.Deferred(function(b){r.each(c,function(c,d){var e=r.isFunction(a[d[4]])&&a[d[4]];f[d[1]](function(){var a=e&&e.apply(this,arguments);a&&r.isFunction(a.promise)?a.promise().progress(b.notify).done(b.resolve).fail(b.reject):b[d[0]+"With"](this,e?[a]:arguments)})}),a=null}).promise()},then:function(b,d,e){var f=0;function g(b,c,d,e){return function(){var h=this,i=arguments,j=function(){var a,j;if(!(b<f)){if(a=d.apply(h,i),a===c.promise())throw new TypeError("Thenable self-resolution");j=a&&("object"==typeof a||"function"==typeof a)&&a.then,r.isFunction(j)?e?j.call(a,g(f,c,M,e),g(f,c,N,e)):(f++,j.call(a,g(f,c,M,e),g(f,c,N,e),g(f,c,M,c.notifyWith))):(d!==M&&(h=void 0,i=[a]),(e||c.resolveWith)(h,i))}},k=e?j:function(){try{j()}catch(a){r.Deferred.exceptionHook&&r.Deferred.exceptionHook(a,k.stackTrace),b+1>=f&&(d!==N&&(h=void 0,i=[a]),c.rejectWith(h,i))}};b?k():(r.Deferred.getStackHook&&(k.stackTrace=r.Deferred.getStackHook()),a.setTimeout(k))}}return r.Deferred(function(a){c[0][3].add(g(0,a,r.isFunction(e)?e:M,a.notifyWith)),c[1][3].add(g(0,a,r.isFunction(b)?b:M)),c[2][3].add(g(0,a,r.isFunction(d)?d:N))}).promise()},promise:function(a){return null!=a?r.extend(a,e):e}},f={};return r.each(c,function(a,b){var g=b[2],h=b[5];e[b[1]]=g.add,h&&g.add(function(){d=h},c[3-a][2].disable,c[0][2].lock),g.add(b[3].fire),f[b[0]]=function(){return f[b[0]+"With"](this===f?void 0:this,arguments),this},f[b[0]+"With"]=g.fireWith}),e.promise(f),b&&b.call(f,f),f},when:function(a){var b=arguments.length,c=b,d=Array(c),e=f.call(arguments),g=r.Deferred(),h=function(a){return function(c){d[a]=this,e[a]=arguments.length>1?f.call(arguments):c,--b||g.resolveWith(d,e)}};if(b<=1&&(O(a,g.done(h(c)).resolve,g.reject),"pending"===g.state()||r.isFunction(e[c]&&e[c].then)))return g.then();while(c--)O(e[c],h(c),g.reject);return g.promise()}});var P=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;r.Deferred.exceptionHook=function(b,c){a.console&&a.console.warn&&b&&P.test(b.name)&&a.console.warn("jQuery.Deferred exception: "+b.message,b.stack,c)},r.readyException=function(b){a.setTimeout(function(){throw b})};var Q=r.Deferred();r.fn.ready=function(a){return Q.then(a).catch(function(a){r.readyException(a)}),this},r.extend({isReady:!1,readyWait:1,holdReady:function(a){a?r.readyWait++:r.ready(!0)},ready:function(a){(a===!0?--r.readyWait:r.isReady)||(r.isReady=!0,a!==!0&&--r.readyWait>0||Q.resolveWith(d,[r]))}}),r.ready.then=Q.then;function R(){d.removeEventListener("DOMContentLoaded",R),a.removeEventListener("load",R),r.ready()}"complete"===d.readyState||"loading"!==d.readyState&&!d.documentElement.doScroll?a.setTimeout(r.ready):(d.addEventListener("DOMContentLoaded",R),a.addEventListener("load",R));var S=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===r.type(c)){e=!0;for(h in c)S(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,
r.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(r(a),c)})),b))for(;h<i;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},T=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function U(){this.expando=r.expando+U.uid++}U.uid=1,U.prototype={cache:function(a){var b=a[this.expando];return b||(b={},T(a)&&(a.nodeType?a[this.expando]=b:Object.defineProperty(a,this.expando,{value:b,configurable:!0}))),b},set:function(a,b,c){var d,e=this.cache(a);if("string"==typeof b)e[r.camelCase(b)]=c;else for(d in b)e[r.camelCase(d)]=b[d];return e},get:function(a,b){return void 0===b?this.cache(a):a[this.expando]&&a[this.expando][r.camelCase(b)]},access:function(a,b,c){return void 0===b||b&&"string"==typeof b&&void 0===c?this.get(a,b):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d=a[this.expando];if(void 0!==d){if(void 0!==b){r.isArray(b)?b=b.map(r.camelCase):(b=r.camelCase(b),b=b in d?[b]:b.match(K)||[]),c=b.length;while(c--)delete d[b[c]]}(void 0===b||r.isEmptyObject(d))&&(a.nodeType?a[this.expando]=void 0:delete a[this.expando])}},hasData:function(a){var b=a[this.expando];return void 0!==b&&!r.isEmptyObject(b)}};var V=new U,W=new U,X=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Y=/[A-Z]/g;function Z(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(Y,"-$&").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c="true"===c||"false"!==c&&("null"===c?null:+c+""===c?+c:X.test(c)?JSON.parse(c):c)}catch(a){}W.set(a,b,c)}else c=void 0;return c}r.extend({hasData:function(a){return W.hasData(a)||V.hasData(a)},data:function(a,b,c){return W.access(a,b,c)},removeData:function(a,b){W.remove(a,b)},_data:function(a,b,c){return V.access(a,b,c)},_removeData:function(a,b){V.remove(a,b)}}),r.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=W.get(f),1===f.nodeType&&!V.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=r.camelCase(d.slice(5)),Z(f,d,e[d])));V.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){W.set(this,a)}):S(this,function(b){var c;if(f&&void 0===b){if(c=W.get(f,a),void 0!==c)return c;if(c=Z(f,a),void 0!==c)return c}else this.each(function(){W.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){W.remove(this,a)})}}),r.extend({queue:function(a,b,c){var d;if(a)return b=(b||"fx")+"queue",d=V.get(a,b),c&&(!d||r.isArray(c)?d=V.access(a,b,r.makeArray(c)):d.push(c)),d||[]},dequeue:function(a,b){b=b||"fx";var c=r.queue(a,b),d=c.length,e=c.shift(),f=r._queueHooks(a,b),g=function(){r.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return V.get(a,c)||V.access(a,c,{empty:r.Callbacks("once memory").add(function(){V.remove(a,[b+"queue",c])})})}}),r.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?r.queue(this[0],a):void 0===b?this:this.each(function(){var c=r.queue(this,a,b);r._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&r.dequeue(this,a)})},dequeue:function(a){return this.each(function(){r.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=r.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=V.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var $=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,_=new RegExp("^(?:([+-])=|)("+$+")([a-z%]*)$","i"),aa=["Top","Right","Bottom","Left"],ba=function(a,b){return a=b||a,"none"===a.style.display||""===a.style.display&&r.contains(a.ownerDocument,a)&&"none"===r.css(a,"display")},ca=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};function da(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return r.css(a,b,"")},i=h(),j=c&&c[3]||(r.cssNumber[b]?"":"px"),k=(r.cssNumber[b]||"px"!==j&&+i)&&_.exec(r.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||".5",k/=f,r.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var ea={};function fa(a){var b,c=a.ownerDocument,d=a.nodeName,e=ea[d];return e?e:(b=c.body.appendChild(c.createElement(d)),e=r.css(b,"display"),b.parentNode.removeChild(b),"none"===e&&(e="block"),ea[d]=e,e)}function ga(a,b){for(var c,d,e=[],f=0,g=a.length;f<g;f++)d=a[f],d.style&&(c=d.style.display,b?("none"===c&&(e[f]=V.get(d,"display")||null,e[f]||(d.style.display="")),""===d.style.display&&ba(d)&&(e[f]=fa(d))):"none"!==c&&(e[f]="none",V.set(d,"display",c)));for(f=0;f<g;f++)null!=e[f]&&(a[f].style.display=e[f]);return a}r.fn.extend({show:function(){return ga(this,!0)},hide:function(){return ga(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){ba(this)?r(this).show():r(this).hide()})}});var ha=/^(?:checkbox|radio)$/i,ia=/<([a-z][^\/\0>\x20\t\r\n\f]+)/i,ja=/^$|\/(?:java|ecma)script/i,ka={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};ka.optgroup=ka.option,ka.tbody=ka.tfoot=ka.colgroup=ka.caption=ka.thead,ka.th=ka.td;function la(a,b){var c="undefined"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||"*"):"undefined"!=typeof a.querySelectorAll?a.querySelectorAll(b||"*"):[];return void 0===b||b&&r.nodeName(a,b)?r.merge([a],c):c}function ma(a,b){for(var c=0,d=a.length;c<d;c++)V.set(a[c],"globalEval",!b||V.get(b[c],"globalEval"))}var na=/<|&#?\w+;/;function oa(a,b,c,d,e){for(var f,g,h,i,j,k,l=b.createDocumentFragment(),m=[],n=0,o=a.length;n<o;n++)if(f=a[n],f||0===f)if("object"===r.type(f))r.merge(m,f.nodeType?[f]:f);else if(na.test(f)){g=g||l.appendChild(b.createElement("div")),h=(ia.exec(f)||["",""])[1].toLowerCase(),i=ka[h]||ka._default,g.innerHTML=i[1]+r.htmlPrefilter(f)+i[2],k=i[0];while(k--)g=g.lastChild;r.merge(m,g.childNodes),g=l.firstChild,g.textContent=""}else m.push(b.createTextNode(f));l.textContent="",n=0;while(f=m[n++])if(d&&r.inArray(f,d)>-1)e&&e.push(f);else if(j=r.contains(f.ownerDocument,f),g=la(l.appendChild(f),"script"),j&&ma(g),c){k=0;while(f=g[k++])ja.test(f.type||"")&&c.push(f)}return l}!function(){var a=d.createDocumentFragment(),b=a.appendChild(d.createElement("div")),c=d.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),o.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",o.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var pa=d.documentElement,qa=/^key/,ra=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,sa=/^([^.]*)(?:\.(.+)|)/;function ta(){return!0}function ua(){return!1}function va(){try{return d.activeElement}catch(a){}}function wa(a,b,c,d,e,f){var g,h;if("object"==typeof b){"string"!=typeof c&&(d=d||c,c=void 0);for(h in b)wa(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&("string"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=ua;else if(!e)return a;return 1===f&&(g=e,e=function(a){return r().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=r.guid++)),a.each(function(){r.event.add(this,b,e,d,c)})}r.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=V.get(a);if(q){c.handler&&(f=c,c=f.handler,e=f.selector),e&&r.find.matchesSelector(pa,e),c.guid||(c.guid=r.guid++),(i=q.events)||(i=q.events={}),(g=q.handle)||(g=q.handle=function(b){return"undefined"!=typeof r&&r.event.triggered!==b.type?r.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(K)||[""],j=b.length;while(j--)h=sa.exec(b[j])||[],n=p=h[1],o=(h[2]||"").split(".").sort(),n&&(l=r.event.special[n]||{},n=(e?l.delegateType:l.bindType)||n,l=r.event.special[n]||{},k=r.extend({type:n,origType:p,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&r.expr.match.needsContext.test(e),namespace:o.join(".")},f),(m=i[n])||(m=i[n]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,o,g)!==!1||a.addEventListener&&a.addEventListener(n,g)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),r.event.global[n]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=V.hasData(a)&&V.get(a);if(q&&(i=q.events)){b=(b||"").match(K)||[""],j=b.length;while(j--)if(h=sa.exec(b[j])||[],n=p=h[1],o=(h[2]||"").split(".").sort(),n){l=r.event.special[n]||{},n=(d?l.delegateType:l.bindType)||n,m=i[n]||[],h=h[2]&&new RegExp("(^|\\.)"+o.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&p!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,o,q.handle)!==!1||r.removeEvent(a,n,q.handle),delete i[n])}else for(n in i)r.event.remove(a,n+b[j],c,d,!0);r.isEmptyObject(i)&&V.remove(a,"handle events")}},dispatch:function(a){var b=r.event.fix(a),c,d,e,f,g,h,i=new Array(arguments.length),j=(V.get(this,"events")||{})[b.type]||[],k=r.event.special[b.type]||{};for(i[0]=b,c=1;c<arguments.length;c++)i[c]=arguments[c];if(b.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,b)!==!1){h=r.event.handlers.call(this,b,j),c=0;while((f=h[c++])&&!b.isPropagationStopped()){b.currentTarget=f.elem,d=0;while((g=f.handlers[d++])&&!b.isImmediatePropagationStopped())b.rnamespace&&!b.rnamespace.test(g.namespace)||(b.handleObj=g,b.data=g.data,e=((r.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==e&&(b.result=e)===!1&&(b.preventDefault(),b.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,b),b.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&("click"!==a.type||isNaN(a.button)||a.button<1))for(;i!==this;i=i.parentNode||this)if(1===i.nodeType&&(i.disabled!==!0||"click"!==a.type)){for(d=[],c=0;c<h;c++)f=b[c],e=f.selector+" ",void 0===d[e]&&(d[e]=f.needsContext?r(e,this).index(i)>-1:r.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},addProp:function(a,b){Object.defineProperty(r.Event.prototype,a,{enumerable:!0,configurable:!0,get:r.isFunction(b)?function(){if(this.originalEvent)return b(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[a]},set:function(b){Object.defineProperty(this,a,{enumerable:!0,configurable:!0,writable:!0,value:b})}})},fix:function(a){return a[r.expando]?a:new r.Event(a)},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==va()&&this.focus)return this.focus(),!1},delegateType:"focusin"},blur:{trigger:function(){if(this===va()&&this.blur)return this.blur(),!1},delegateType:"focusout"},click:{trigger:function(){if("checkbox"===this.type&&this.click&&r.nodeName(this,"input"))return this.click(),!1},_default:function(a){return r.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}}},r.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)},r.Event=function(a,b){return this instanceof r.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?ta:ua,this.target=a.target&&3===a.target.nodeType?a.target.parentNode:a.target,this.currentTarget=a.currentTarget,this.relatedTarget=a.relatedTarget):this.type=a,b&&r.extend(this,b),this.timeStamp=a&&a.timeStamp||r.now(),void(this[r.expando]=!0)):new r.Event(a,b)},r.Event.prototype={constructor:r.Event,isDefaultPrevented:ua,isPropagationStopped:ua,isImmediatePropagationStopped:ua,isSimulated:!1,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=ta,a&&!this.isSimulated&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=ta,a&&!this.isSimulated&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=ta,a&&!this.isSimulated&&a.stopImmediatePropagation(),this.stopPropagation()}},r.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,char:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(a){var b=a.button;return null==a.which&&qa.test(a.type)?null!=a.charCode?a.charCode:a.keyCode:!a.which&&void 0!==b&&ra.test(a.type)?1&b?1:2&b?3:4&b?2:0:a.which}},r.event.addProp),r.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){r.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return e&&(e===d||r.contains(d,e))||(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),r.fn.extend({on:function(a,b,c,d){return wa(this,a,b,c,d)},one:function(a,b,c,d){return wa(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,r(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return b!==!1&&"function"!=typeof b||(c=b,b=void 0),c===!1&&(c=ua),this.each(function(){r.event.remove(this,a,c,b)})}});var xa=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,ya=/<script|<style|<link/i,za=/checked\s*(?:[^=]|=\s*.checked.)/i,Aa=/^true\/(.*)/,Ba=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function Ca(a,b){return r.nodeName(a,"table")&&r.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a:a}function Da(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function Ea(a){var b=Aa.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function Fa(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(V.hasData(a)&&(f=V.access(a),g=V.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;c<d;c++)r.event.add(b,e,j[e][c])}W.hasData(a)&&(h=W.access(a),i=r.extend({},h),W.set(b,i))}}function Ga(a,b){var c=b.nodeName.toLowerCase();"input"===c&&ha.test(a.type)?b.checked=a.checked:"input"!==c&&"textarea"!==c||(b.defaultValue=a.defaultValue)}function Ha(a,b,c,d){b=g.apply([],b);var e,f,h,i,j,k,l=0,m=a.length,n=m-1,q=b[0],s=r.isFunction(q);if(s||m>1&&"string"==typeof q&&!o.checkClone&&za.test(q))return a.each(function(e){var f=a.eq(e);s&&(b[0]=q.call(this,e,f.html())),Ha(f,b,c,d)});if(m&&(e=oa(b,a[0].ownerDocument,!1,a,d),f=e.firstChild,1===e.childNodes.length&&(e=f),f||d)){for(h=r.map(la(e,"script"),Da),i=h.length;l<m;l++)j=e,l!==n&&(j=r.clone(j,!0,!0),i&&r.merge(h,la(j,"script"))),c.call(a[l],j,l);if(i)for(k=h[h.length-1].ownerDocument,r.map(h,Ea),l=0;l<i;l++)j=h[l],ja.test(j.type||"")&&!V.access(j,"globalEval")&&r.contains(k,j)&&(j.src?r._evalUrl&&r._evalUrl(j.src):p(j.textContent.replace(Ba,""),k))}return a}function Ia(a,b,c){for(var d,e=b?r.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||r.cleanData(la(d)),d.parentNode&&(c&&r.contains(d.ownerDocument,d)&&ma(la(d,"script")),d.parentNode.removeChild(d));return a}r.extend({htmlPrefilter:function(a){return a.replace(xa,"<$1></$2>")},clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=r.contains(a.ownerDocument,a);if(!(o.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||r.isXMLDoc(a)))for(g=la(h),f=la(a),d=0,e=f.length;d<e;d++)Ga(f[d],g[d]);if(b)if(c)for(f=f||la(a),g=g||la(h),d=0,e=f.length;d<e;d++)Fa(f[d],g[d]);else Fa(a,h);return g=la(h,"script"),g.length>0&&ma(g,!i&&la(a,"script")),h},cleanData:function(a){for(var b,c,d,e=r.event.special,f=0;void 0!==(c=a[f]);f++)if(T(c)){if(b=c[V.expando]){if(b.events)for(d in b.events)e[d]?r.event.remove(c,d):r.removeEvent(c,d,b.handle);c[V.expando]=void 0}c[W.expando]&&(c[W.expando]=void 0)}}}),r.fn.extend({detach:function(a){return Ia(this,a,!0)},remove:function(a){return Ia(this,a)},text:function(a){return S(this,function(a){return void 0===a?r.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=a)})},null,a,arguments.length)},append:function(){return Ha(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Ca(this,a);b.appendChild(a)}})},prepend:function(){return Ha(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Ca(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return Ha(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return Ha(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(r.cleanData(la(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null!=a&&a,b=null==b?a:b,this.map(function(){return r.clone(this,a,b)})},html:function(a){return S(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!ya.test(a)&&!ka[(ia.exec(a)||["",""])[1].toLowerCase()]){a=r.htmlPrefilter(a);try{for(;c<d;c++)b=this[c]||{},1===b.nodeType&&(r.cleanData(la(b,!1)),b.innerHTML=a);b=0}catch(a){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return Ha(this,arguments,function(b){var c=this.parentNode;r.inArray(this,a)<0&&(r.cleanData(la(this)),c&&c.replaceChild(b,this))},a)}}),r.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){r.fn[a]=function(a){for(var c,d=[],e=r(a),f=e.length-1,g=0;g<=f;g++)c=g===f?this:this.clone(!0),r(e[g])[b](c),h.apply(d,c.get());return this.pushStack(d)}});var Ja=/^margin/,Ka=new RegExp("^("+$+")(?!px)[a-z%]+$","i"),La=function(b){var c=b.ownerDocument.defaultView;return c&&c.opener||(c=a),c.getComputedStyle(b)};!function(){function b(){if(i){i.style.cssText="box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",i.innerHTML="",pa.appendChild(h);var b=a.getComputedStyle(i);c="1%"!==b.top,g="2px"===b.marginLeft,e="4px"===b.width,i.style.marginRight="50%",f="4px"===b.marginRight,pa.removeChild(h),i=null}}var c,e,f,g,h=d.createElement("div"),i=d.createElement("div");i.style&&(i.style.backgroundClip="content-box",i.cloneNode(!0).style.backgroundClip="",o.clearCloneStyle="content-box"===i.style.backgroundClip,h.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",h.appendChild(i),r.extend(o,{pixelPosition:function(){return b(),c},boxSizingReliable:function(){return b(),e},pixelMarginRight:function(){return b(),f},reliableMarginLeft:function(){return b(),g}}))}();function Ma(a,b,c){var d,e,f,g,h=a.style;return c=c||La(a),c&&(g=c.getPropertyValue(b)||c[b],""!==g||r.contains(a.ownerDocument,a)||(g=r.style(a,b)),!o.pixelMarginRight()&&Ka.test(g)&&Ja.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0!==g?g+"":g}function Na(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Oa=/^(none|table(?!-c[ea]).+)/,Pa={position:"absolute",visibility:"hidden",display:"block"},Qa={letterSpacing:"0",fontWeight:"400"},Ra=["Webkit","Moz","ms"],Sa=d.createElement("div").style;function Ta(a){if(a in Sa)return a;var b=a[0].toUpperCase()+a.slice(1),c=Ra.length;while(c--)if(a=Ra[c]+b,a in Sa)return a}function Ua(a,b,c){var d=_.exec(b);return d?Math.max(0,d[2]-(c||0))+(d[3]||"px"):b}function Va(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;f<4;f+=2)"margin"===c&&(g+=r.css(a,c+aa[f],!0,e)),d?("content"===c&&(g-=r.css(a,"padding"+aa[f],!0,e)),"margin"!==c&&(g-=r.css(a,"border"+aa[f]+"Width",!0,e))):(g+=r.css(a,"padding"+aa[f],!0,e),"padding"!==c&&(g+=r.css(a,"border"+aa[f]+"Width",!0,e)));return g}function Wa(a,b,c){var d,e=!0,f=La(a),g="border-box"===r.css(a,"boxSizing",!1,f);if(a.getClientRects().length&&(d=a.getBoundingClientRect()[b]),d<=0||null==d){if(d=Ma(a,b,f),(d<0||null==d)&&(d=a.style[b]),Ka.test(d))return d;e=g&&(o.boxSizingReliable()||d===a.style[b]),d=parseFloat(d)||0}return d+Va(a,b,c||(g?"border":"content"),e,f)+"px"}r.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Ma(a,"opacity");return""===c?"1":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{float:"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=r.camelCase(b),i=a.style;return b=r.cssProps[h]||(r.cssProps[h]=Ta(h)||h),g=r.cssHooks[b]||r.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,"string"===f&&(e=_.exec(c))&&e[1]&&(c=da(a,b,e),f="number"),null!=c&&c===c&&("number"===f&&(c+=e&&e[3]||(r.cssNumber[h]?"":"px")),o.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=r.camelCase(b);return b=r.cssProps[h]||(r.cssProps[h]=Ta(h)||h),g=r.cssHooks[b]||r.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=Ma(a,b,d)),"normal"===e&&b in Qa&&(e=Qa[b]),""===c||c?(f=parseFloat(e),c===!0||isFinite(f)?f||0:e):e}}),r.each(["height","width"],function(a,b){r.cssHooks[b]={get:function(a,c,d){if(c)return!Oa.test(r.css(a,"display"))||a.getClientRects().length&&a.getBoundingClientRect().width?Wa(a,b,d):ca(a,Pa,function(){return Wa(a,b,d)})},set:function(a,c,d){var e,f=d&&La(a),g=d&&Va(a,b,d,"border-box"===r.css(a,"boxSizing",!1,f),f);return g&&(e=_.exec(c))&&"px"!==(e[3]||"px")&&(a.style[b]=c,c=r.css(a,b)),Ua(a,c,g)}}}),r.cssHooks.marginLeft=Na(o.reliableMarginLeft,function(a,b){if(b)return(parseFloat(Ma(a,"marginLeft"))||a.getBoundingClientRect().left-ca(a,{marginLeft:0},function(){return a.getBoundingClientRect().left}))+"px"}),r.each({margin:"",padding:"",border:"Width"},function(a,b){r.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];d<4;d++)e[a+aa[d]+b]=f[d]||f[d-2]||f[0];return e}},Ja.test(a)||(r.cssHooks[a+b].set=Ua)}),r.fn.extend({css:function(a,b){return S(this,function(a,b,c){var d,e,f={},g=0;if(r.isArray(b)){for(d=La(a),e=b.length;g<e;g++)f[b[g]]=r.css(a,b[g],!1,d);return f}return void 0!==c?r.style(a,b,c):r.css(a,b)},a,b,arguments.length>1)}});function Xa(a,b,c,d,e){return new Xa.prototype.init(a,b,c,d,e)}r.Tween=Xa,Xa.prototype={constructor:Xa,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||r.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(r.cssNumber[c]?"":"px")},cur:function(){var a=Xa.propHooks[this.prop];return a&&a.get?a.get(this):Xa.propHooks._default.get(this)},run:function(a){var b,c=Xa.propHooks[this.prop];return this.options.duration?this.pos=b=r.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Xa.propHooks._default.set(this),this}},Xa.prototype.init.prototype=Xa.prototype,Xa.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=r.css(a.elem,a.prop,""),b&&"auto"!==b?b:0)},set:function(a){r.fx.step[a.prop]?r.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[r.cssProps[a.prop]]&&!r.cssHooks[a.prop]?a.elem[a.prop]=a.now:r.style(a.elem,a.prop,a.now+a.unit)}}},Xa.propHooks.scrollTop=Xa.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},r.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:"swing"},r.fx=Xa.prototype.init,r.fx.step={};var Ya,Za,$a=/^(?:toggle|show|hide)$/,_a=/queueHooks$/;function ab(){Za&&(a.requestAnimationFrame(ab),r.fx.tick())}function bb(){return a.setTimeout(function(){Ya=void 0}),Ya=r.now()}function cb(a,b){var c,d=0,e={height:a};for(b=b?1:0;d<4;d+=2-b)c=aa[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function db(a,b,c){for(var d,e=(gb.tweeners[b]||[]).concat(gb.tweeners["*"]),f=0,g=e.length;f<g;f++)if(d=e[f].call(c,b,a))return d}function eb(a,b,c){var d,e,f,g,h,i,j,k,l="width"in b||"height"in b,m=this,n={},o=a.style,p=a.nodeType&&ba(a),q=V.get(a,"fxshow");c.queue||(g=r._queueHooks(a,"fx"),null==g.unqueued&&(g.unqueued=0,h=g.empty.fire,g.empty.fire=function(){g.unqueued||h()}),g.unqueued++,m.always(function(){m.always(function(){g.unqueued--,r.queue(a,"fx").length||g.empty.fire()})}));for(d in b)if(e=b[d],$a.test(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}n[d]=q&&q[d]||r.style(a,d)}if(i=!r.isEmptyObject(b),i||!r.isEmptyObject(n)){l&&1===a.nodeType&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=q&&q.display,null==j&&(j=V.get(a,"display")),k=r.css(a,"display"),"none"===k&&(j?k=j:(ga([a],!0),j=a.style.display||j,k=r.css(a,"display"),ga([a]))),("inline"===k||"inline-block"===k&&null!=j)&&"none"===r.css(a,"float")&&(i||(m.done(function(){o.display=j}),null==j&&(k=o.display,j="none"===k?"":k)),o.display="inline-block")),c.overflow&&(o.overflow="hidden",m.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]})),i=!1;for(d in n)i||(q?"hidden"in q&&(p=q.hidden):q=V.access(a,"fxshow",{display:j}),f&&(q.hidden=!p),p&&ga([a],!0),m.done(function(){p||ga([a]),V.remove(a,"fxshow");for(d in n)r.style(a,d,n[d])})),i=db(p?q[d]:0,d,m),d in q||(q[d]=i.start,p&&(i.end=i.start,i.start=0))}}function fb(a,b){var c,d,e,f,g;for(c in a)if(d=r.camelCase(c),e=b[d],f=a[c],r.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=r.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function gb(a,b,c){var d,e,f=0,g=gb.prefilters.length,h=r.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=Ya||bb(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;g<i;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),f<1&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:r.extend({},b),opts:r.extend(!0,{specialEasing:{},easing:r.easing._default},c),originalProperties:b,originalOptions:c,startTime:Ya||bb(),duration:c.duration,tweens:[],createTween:function(b,c){var d=r.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;c<d;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for(fb(k,j.opts.specialEasing);f<g;f++)if(d=gb.prefilters[f].call(j,a,k,j.opts))return r.isFunction(d.stop)&&(r._queueHooks(j.elem,j.opts.queue).stop=r.proxy(d.stop,d)),d;return r.map(k,db,j),r.isFunction(j.opts.start)&&j.opts.start.call(a,j),r.fx.timer(r.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}r.Animation=r.extend(gb,{tweeners:{"*":[function(a,b){var c=this.createTween(a,b);return da(c.elem,a,_.exec(b),c),c}]},tweener:function(a,b){r.isFunction(a)?(b=a,a=["*"]):a=a.match(K);for(var c,d=0,e=a.length;d<e;d++)c=a[d],gb.tweeners[c]=gb.tweeners[c]||[],gb.tweeners[c].unshift(b)},prefilters:[eb],prefilter:function(a,b){b?gb.prefilters.unshift(a):gb.prefilters.push(a)}}),r.speed=function(a,b,c){var e=a&&"object"==typeof a?r.extend({},a):{complete:c||!c&&b||r.isFunction(a)&&a,duration:a,easing:c&&b||b&&!r.isFunction(b)&&b};return r.fx.off||d.hidden?e.duration=0:e.duration="number"==typeof e.duration?e.duration:e.duration in r.fx.speeds?r.fx.speeds[e.duration]:r.fx.speeds._default,null!=e.queue&&e.queue!==!0||(e.queue="fx"),e.old=e.complete,e.complete=function(){r.isFunction(e.old)&&e.old.call(this),e.queue&&r.dequeue(this,e.queue)},e},r.fn.extend({fadeTo:function(a,b,c,d){return this.filter(ba).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=r.isEmptyObject(a),f=r.speed(b,c,d),g=function(){var b=gb(this,r.extend({},a),f);(e||V.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=r.timers,g=V.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&_a.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));!b&&c||r.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=V.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=r.timers,g=d?d.length:0;for(c.finish=!0,r.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;b<g;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),r.each(["toggle","show","hide"],function(a,b){var c=r.fn[b];r.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(cb(b,!0),a,d,e)}}),r.each({slideDown:cb("show"),slideUp:cb("hide"),slideToggle:cb("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){r.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),r.timers=[],r.fx.tick=function(){var a,b=0,c=r.timers;for(Ya=r.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||r.fx.stop(),Ya=void 0},r.fx.timer=function(a){r.timers.push(a),a()?r.fx.start():r.timers.pop()},r.fx.interval=13,r.fx.start=function(){Za||(Za=a.requestAnimationFrame?a.requestAnimationFrame(ab):a.setInterval(r.fx.tick,r.fx.interval))},r.fx.stop=function(){a.cancelAnimationFrame?a.cancelAnimationFrame(Za):a.clearInterval(Za),Za=null},r.fx.speeds={slow:600,fast:200,_default:400},r.fn.delay=function(b,c){return b=r.fx?r.fx.speeds[b]||b:b,c=c||"fx",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a=d.createElement("input"),b=d.createElement("select"),c=b.appendChild(d.createElement("option"));a.type="checkbox",o.checkOn=""!==a.value,o.optSelected=c.selected,a=d.createElement("input"),a.value="t",a.type="radio",o.radioValue="t"===a.value}();var hb,ib=r.expr.attrHandle;r.fn.extend({attr:function(a,b){return S(this,r.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){r.removeAttr(this,a)})}}),r.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return"undefined"==typeof a.getAttribute?r.prop(a,b,c):(1===f&&r.isXMLDoc(a)||(e=r.attrHooks[b.toLowerCase()]||(r.expr.match.bool.test(b)?hb:void 0)),void 0!==c?null===c?void r.removeAttr(a,b):e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+""),c):e&&"get"in e&&null!==(d=e.get(a,b))?d:(d=r.find.attr(a,b),null==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!o.radioValue&&"radio"===b&&r.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d=0,e=b&&b.match(K);
if(e&&1===a.nodeType)while(c=e[d++])a.removeAttribute(c)}}),hb={set:function(a,b,c){return b===!1?r.removeAttr(a,c):a.setAttribute(c,c),c}},r.each(r.expr.match.bool.source.match(/\w+/g),function(a,b){var c=ib[b]||r.find.attr;ib[b]=function(a,b,d){var e,f,g=b.toLowerCase();return d||(f=ib[g],ib[g]=e,e=null!=c(a,b,d)?g:null,ib[g]=f),e}});var jb=/^(?:input|select|textarea|button)$/i,kb=/^(?:a|area)$/i;r.fn.extend({prop:function(a,b){return S(this,r.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[r.propFix[a]||a]})}}),r.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&r.isXMLDoc(a)||(b=r.propFix[b]||b,e=r.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=r.find.attr(a,"tabindex");return b?parseInt(b,10):jb.test(a.nodeName)||kb.test(a.nodeName)&&a.href?0:-1}}},propFix:{for:"htmlFor",class:"className"}}),o.optSelected||(r.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null},set:function(a){var b=a.parentNode;b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex)}}),r.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){r.propFix[this.toLowerCase()]=this});var lb=/[\t\r\n\f]/g;function mb(a){return a.getAttribute&&a.getAttribute("class")||""}r.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(r.isFunction(a))return this.each(function(b){r(this).addClass(a.call(this,b,mb(this)))});if("string"==typeof a&&a){b=a.match(K)||[];while(c=this[i++])if(e=mb(c),d=1===c.nodeType&&(" "+e+" ").replace(lb," ")){g=0;while(f=b[g++])d.indexOf(" "+f+" ")<0&&(d+=f+" ");h=r.trim(d),e!==h&&c.setAttribute("class",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(r.isFunction(a))return this.each(function(b){r(this).removeClass(a.call(this,b,mb(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof a&&a){b=a.match(K)||[];while(c=this[i++])if(e=mb(c),d=1===c.nodeType&&(" "+e+" ").replace(lb," ")){g=0;while(f=b[g++])while(d.indexOf(" "+f+" ")>-1)d=d.replace(" "+f+" "," ");h=r.trim(d),e!==h&&c.setAttribute("class",h)}}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):r.isFunction(a)?this.each(function(c){r(this).toggleClass(a.call(this,c,mb(this),b),b)}):this.each(function(){var b,d,e,f;if("string"===c){d=0,e=r(this),f=a.match(K)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else void 0!==a&&"boolean"!==c||(b=mb(this),b&&V.set(this,"__className__",b),this.setAttribute&&this.setAttribute("class",b||a===!1?"":V.get(this,"__className__")||""))})},hasClass:function(a){var b,c,d=0;b=" "+a+" ";while(c=this[d++])if(1===c.nodeType&&(" "+mb(c)+" ").replace(lb," ").indexOf(b)>-1)return!0;return!1}});var nb=/\r/g,ob=/[\x20\t\r\n\f]+/g;r.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=r.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,r(this).val()):a,null==e?e="":"number"==typeof e?e+="":r.isArray(e)&&(e=r.map(e,function(a){return null==a?"":a+""})),b=r.valHooks[this.type]||r.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=r.valHooks[e.type]||r.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(nb,""):null==c?"":c)}}}),r.extend({valHooks:{option:{get:function(a){var b=r.find.attr(a,"value");return null!=b?b:r.trim(r.text(a)).replace(ob," ")}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type,g=f?null:[],h=f?e+1:d.length,i=e<0?h:f?e:0;i<h;i++)if(c=d[i],(c.selected||i===e)&&!c.disabled&&(!c.parentNode.disabled||!r.nodeName(c.parentNode,"optgroup"))){if(b=r(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=r.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=r.inArray(r.valHooks.option.get(d),f)>-1)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),r.each(["radio","checkbox"],function(){r.valHooks[this]={set:function(a,b){if(r.isArray(b))return a.checked=r.inArray(r(a).val(),b)>-1}},o.checkOn||(r.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var pb=/^(?:focusinfocus|focusoutblur)$/;r.extend(r.event,{trigger:function(b,c,e,f){var g,h,i,j,k,m,n,o=[e||d],p=l.call(b,"type")?b.type:b,q=l.call(b,"namespace")?b.namespace.split("."):[];if(h=i=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!pb.test(p+r.event.triggered)&&(p.indexOf(".")>-1&&(q=p.split("."),p=q.shift(),q.sort()),k=p.indexOf(":")<0&&"on"+p,b=b[r.expando]?b:new r.Event(p,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=q.join("."),b.rnamespace=b.namespace?new RegExp("(^|\\.)"+q.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:r.makeArray(c,[b]),n=r.event.special[p]||{},f||!n.trigger||n.trigger.apply(e,c)!==!1)){if(!f&&!n.noBubble&&!r.isWindow(e)){for(j=n.delegateType||p,pb.test(j+p)||(h=h.parentNode);h;h=h.parentNode)o.push(h),i=h;i===(e.ownerDocument||d)&&o.push(i.defaultView||i.parentWindow||a)}g=0;while((h=o[g++])&&!b.isPropagationStopped())b.type=g>1?j:n.bindType||p,m=(V.get(h,"events")||{})[b.type]&&V.get(h,"handle"),m&&m.apply(h,c),m=k&&h[k],m&&m.apply&&T(h)&&(b.result=m.apply(h,c),b.result===!1&&b.preventDefault());return b.type=p,f||b.isDefaultPrevented()||n._default&&n._default.apply(o.pop(),c)!==!1||!T(e)||k&&r.isFunction(e[p])&&!r.isWindow(e)&&(i=e[k],i&&(e[k]=null),r.event.triggered=p,e[p](),r.event.triggered=void 0,i&&(e[k]=i)),b.result}},simulate:function(a,b,c){var d=r.extend(new r.Event,c,{type:a,isSimulated:!0});r.event.trigger(d,null,b)}}),r.fn.extend({trigger:function(a,b){return this.each(function(){r.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];if(c)return r.event.trigger(a,b,c,!0)}}),r.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(a,b){r.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),r.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}}),o.focusin="onfocusin"in a,o.focusin||r.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){r.event.simulate(b,a.target,r.event.fix(a))};r.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=V.access(d,b);e||d.addEventListener(a,c,!0),V.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=V.access(d,b)-1;e?V.access(d,b,e):(d.removeEventListener(a,c,!0),V.remove(d,b))}}});var qb=a.location,rb=r.now(),sb=/\?/;r.parseXML=function(b){var c;if(!b||"string"!=typeof b)return null;try{c=(new a.DOMParser).parseFromString(b,"text/xml")}catch(a){c=void 0}return c&&!c.getElementsByTagName("parsererror").length||r.error("Invalid XML: "+b),c};var tb=/\[\]$/,ub=/\r?\n/g,vb=/^(?:submit|button|image|reset|file)$/i,wb=/^(?:input|select|textarea|keygen)/i;function xb(a,b,c,d){var e;if(r.isArray(b))r.each(b,function(b,e){c||tb.test(a)?d(a,e):xb(a+"["+("object"==typeof e&&null!=e?b:"")+"]",e,c,d)});else if(c||"object"!==r.type(b))d(a,b);else for(e in b)xb(a+"["+e+"]",b[e],c,d)}r.param=function(a,b){var c,d=[],e=function(a,b){var c=r.isFunction(b)?b():b;d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(null==c?"":c)};if(r.isArray(a)||a.jquery&&!r.isPlainObject(a))r.each(a,function(){e(this.name,this.value)});else for(c in a)xb(c,a[c],b,e);return d.join("&")},r.fn.extend({serialize:function(){return r.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=r.prop(this,"elements");return a?r.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!r(this).is(":disabled")&&wb.test(this.nodeName)&&!vb.test(a)&&(this.checked||!ha.test(a))}).map(function(a,b){var c=r(this).val();return null==c?null:r.isArray(c)?r.map(c,function(a){return{name:b.name,value:a.replace(ub,"\r\n")}}):{name:b.name,value:c.replace(ub,"\r\n")}}).get()}});var yb=/%20/g,zb=/#.*$/,Ab=/([?&])_=[^&]*/,Bb=/^(.*?):[ \t]*([^\r\n]*)$/gm,Cb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Db=/^(?:GET|HEAD)$/,Eb=/^\/\//,Fb={},Gb={},Hb="*/".concat("*"),Ib=d.createElement("a");Ib.href=qb.href;function Jb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(K)||[];if(r.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function Kb(a,b,c,d){var e={},f=a===Gb;function g(h){var i;return e[h]=!0,r.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function Lb(a,b){var c,d,e=r.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&r.extend(!0,a,d),a}function Mb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}if(f)return f!==i[0]&&i.unshift(f),c[f]}function Nb(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a.throws)b=g(b);else try{b=g(b)}catch(a){return{state:"parsererror",error:g?a:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}r.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:qb.href,type:"GET",isLocal:Cb.test(qb.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Hb,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":r.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?Lb(Lb(a,r.ajaxSettings),b):Lb(r.ajaxSettings,a)},ajaxPrefilter:Jb(Fb),ajaxTransport:Jb(Gb),ajax:function(b,c){"object"==typeof b&&(c=b,b=void 0),c=c||{};var e,f,g,h,i,j,k,l,m,n,o=r.ajaxSetup({},c),p=o.context||o,q=o.context&&(p.nodeType||p.jquery)?r(p):r.event,s=r.Deferred(),t=r.Callbacks("once memory"),u=o.statusCode||{},v={},w={},x="canceled",y={readyState:0,getResponseHeader:function(a){var b;if(k){if(!h){h={};while(b=Bb.exec(g))h[b[1].toLowerCase()]=b[2]}b=h[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return k?g:null},setRequestHeader:function(a,b){return null==k&&(a=w[a.toLowerCase()]=w[a.toLowerCase()]||a,v[a]=b),this},overrideMimeType:function(a){return null==k&&(o.mimeType=a),this},statusCode:function(a){var b;if(a)if(k)y.always(a[y.status]);else for(b in a)u[b]=[u[b],a[b]];return this},abort:function(a){var b=a||x;return e&&e.abort(b),z(0,b),this}};if(s.promise(y),o.url=((b||o.url||qb.href)+"").replace(Eb,qb.protocol+"//"),o.type=c.method||c.type||o.method||o.type,o.dataTypes=(o.dataType||"*").toLowerCase().match(K)||[""],null==o.crossDomain){j=d.createElement("a");try{j.href=o.url,j.href=j.href,o.crossDomain=Ib.protocol+"//"+Ib.host!=j.protocol+"//"+j.host}catch(a){o.crossDomain=!0}}if(o.data&&o.processData&&"string"!=typeof o.data&&(o.data=r.param(o.data,o.traditional)),Kb(Fb,o,c,y),k)return y;l=r.event&&o.global,l&&0===r.active++&&r.event.trigger("ajaxStart"),o.type=o.type.toUpperCase(),o.hasContent=!Db.test(o.type),f=o.url.replace(zb,""),o.hasContent?o.data&&o.processData&&0===(o.contentType||"").indexOf("application/x-www-form-urlencoded")&&(o.data=o.data.replace(yb,"+")):(n=o.url.slice(f.length),o.data&&(f+=(sb.test(f)?"&":"?")+o.data,delete o.data),o.cache===!1&&(f=f.replace(Ab,""),n=(sb.test(f)?"&":"?")+"_="+rb++ +n),o.url=f+n),o.ifModified&&(r.lastModified[f]&&y.setRequestHeader("If-Modified-Since",r.lastModified[f]),r.etag[f]&&y.setRequestHeader("If-None-Match",r.etag[f])),(o.data&&o.hasContent&&o.contentType!==!1||c.contentType)&&y.setRequestHeader("Content-Type",o.contentType),y.setRequestHeader("Accept",o.dataTypes[0]&&o.accepts[o.dataTypes[0]]?o.accepts[o.dataTypes[0]]+("*"!==o.dataTypes[0]?", "+Hb+"; q=0.01":""):o.accepts["*"]);for(m in o.headers)y.setRequestHeader(m,o.headers[m]);if(o.beforeSend&&(o.beforeSend.call(p,y,o)===!1||k))return y.abort();if(x="abort",t.add(o.complete),y.done(o.success),y.fail(o.error),e=Kb(Gb,o,c,y)){if(y.readyState=1,l&&q.trigger("ajaxSend",[y,o]),k)return y;o.async&&o.timeout>0&&(i=a.setTimeout(function(){y.abort("timeout")},o.timeout));try{k=!1,e.send(v,z)}catch(a){if(k)throw a;z(-1,a)}}else z(-1,"No Transport");function z(b,c,d,h){var j,m,n,v,w,x=c;k||(k=!0,i&&a.clearTimeout(i),e=void 0,g=h||"",y.readyState=b>0?4:0,j=b>=200&&b<300||304===b,d&&(v=Mb(o,y,d)),v=Nb(o,v,y,j),j?(o.ifModified&&(w=y.getResponseHeader("Last-Modified"),w&&(r.lastModified[f]=w),w=y.getResponseHeader("etag"),w&&(r.etag[f]=w)),204===b||"HEAD"===o.type?x="nocontent":304===b?x="notmodified":(x=v.state,m=v.data,n=v.error,j=!n)):(n=x,!b&&x||(x="error",b<0&&(b=0))),y.status=b,y.statusText=(c||x)+"",j?s.resolveWith(p,[m,x,y]):s.rejectWith(p,[y,x,n]),y.statusCode(u),u=void 0,l&&q.trigger(j?"ajaxSuccess":"ajaxError",[y,o,j?m:n]),t.fireWith(p,[y,x]),l&&(q.trigger("ajaxComplete",[y,o]),--r.active||r.event.trigger("ajaxStop")))}return y},getJSON:function(a,b,c){return r.get(a,b,c,"json")},getScript:function(a,b){return r.get(a,void 0,b,"script")}}),r.each(["get","post"],function(a,b){r[b]=function(a,c,d,e){return r.isFunction(c)&&(e=e||d,d=c,c=void 0),r.ajax(r.extend({url:a,type:b,dataType:e,data:c,success:d},r.isPlainObject(a)&&a))}}),r._evalUrl=function(a){return r.ajax({url:a,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,throws:!0})},r.fn.extend({wrapAll:function(a){var b;return this[0]&&(r.isFunction(a)&&(a=a.call(this[0])),b=r(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this},wrapInner:function(a){return r.isFunction(a)?this.each(function(b){r(this).wrapInner(a.call(this,b))}):this.each(function(){var b=r(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=r.isFunction(a);return this.each(function(c){r(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(a){return this.parent(a).not("body").each(function(){r(this).replaceWith(this.childNodes)}),this}}),r.expr.pseudos.hidden=function(a){return!r.expr.pseudos.visible(a)},r.expr.pseudos.visible=function(a){return!!(a.offsetWidth||a.offsetHeight||a.getClientRects().length)},r.ajaxSettings.xhr=function(){try{return new a.XMLHttpRequest}catch(a){}};var Ob={0:200,1223:204},Pb=r.ajaxSettings.xhr();o.cors=!!Pb&&"withCredentials"in Pb,o.ajax=Pb=!!Pb,r.ajaxTransport(function(b){var c,d;if(o.cors||Pb&&!b.crossDomain)return{send:function(e,f){var g,h=b.xhr();if(h.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(g in b.xhrFields)h[g]=b.xhrFields[g];b.mimeType&&h.overrideMimeType&&h.overrideMimeType(b.mimeType),b.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest");for(g in e)h.setRequestHeader(g,e[g]);c=function(a){return function(){c&&(c=d=h.onload=h.onerror=h.onabort=h.onreadystatechange=null,"abort"===a?h.abort():"error"===a?"number"!=typeof h.status?f(0,"error"):f(h.status,h.statusText):f(Ob[h.status]||h.status,h.statusText,"text"!==(h.responseType||"text")||"string"!=typeof h.responseText?{binary:h.response}:{text:h.responseText},h.getAllResponseHeaders()))}},h.onload=c(),d=h.onerror=c("error"),void 0!==h.onabort?h.onabort=d:h.onreadystatechange=function(){4===h.readyState&&a.setTimeout(function(){c&&d()})},c=c("abort");try{h.send(b.hasContent&&b.data||null)}catch(a){if(c)throw a}},abort:function(){c&&c()}}}),r.ajaxPrefilter(function(a){a.crossDomain&&(a.contents.script=!1)}),r.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(a){return r.globalEval(a),a}}}),r.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),r.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(e,f){b=r("<script>").prop({charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&f("error"===a.type?404:200,a.type)}),d.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Qb=[],Rb=/(=)\?(?=&|$)|\?\?/;r.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Qb.pop()||r.expando+"_"+rb++;return this[a]=!0,a}}),r.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Rb.test(b.url)?"url":"string"==typeof b.data&&0===(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Rb.test(b.data)&&"data");if(h||"jsonp"===b.dataTypes[0])return e=b.jsonpCallback=r.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Rb,"$1"+e):b.jsonp!==!1&&(b.url+=(sb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||r.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?r(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Qb.push(e)),g&&r.isFunction(f)&&f(g[0]),g=f=void 0}),"script"}),o.createHTMLDocument=function(){var a=d.implementation.createHTMLDocument("").body;return a.innerHTML="<form></form><form></form>",2===a.childNodes.length}(),r.parseHTML=function(a,b,c){if("string"!=typeof a)return[];"boolean"==typeof b&&(c=b,b=!1);var e,f,g;return b||(o.createHTMLDocument?(b=d.implementation.createHTMLDocument(""),e=b.createElement("base"),e.href=d.location.href,b.head.appendChild(e)):b=d),f=B.exec(a),g=!c&&[],f?[b.createElement(f[1])]:(f=oa([a],b,g),g&&g.length&&r(g).remove(),r.merge([],f.childNodes))},r.fn.load=function(a,b,c){var d,e,f,g=this,h=a.indexOf(" ");return h>-1&&(d=r.trim(a.slice(h)),a=a.slice(0,h)),r.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&r.ajax({url:a,type:e||"GET",dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?r("<div>").append(r.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(this,f||[a.responseText,b,a])})}),this},r.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){r.fn[b]=function(a){return this.on(b,a)}}),r.expr.pseudos.animated=function(a){return r.grep(r.timers,function(b){return a===b.elem}).length};function Sb(a){return r.isWindow(a)?a:9===a.nodeType&&a.defaultView}r.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=r.css(a,"position"),l=r(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=r.css(a,"top"),i=r.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),r.isFunction(b)&&(b=b.call(a,c,r.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},r.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){r.offset.setOffset(this,a,b)});var b,c,d,e,f=this[0];if(f)return f.getClientRects().length?(d=f.getBoundingClientRect(),d.width||d.height?(e=f.ownerDocument,c=Sb(e),b=e.documentElement,{top:d.top+c.pageYOffset-b.clientTop,left:d.left+c.pageXOffset-b.clientLeft}):d):{top:0,left:0}},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===r.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),r.nodeName(a[0],"html")||(d=a.offset()),d={top:d.top+r.css(a[0],"borderTopWidth",!0),left:d.left+r.css(a[0],"borderLeftWidth",!0)}),{top:b.top-d.top-r.css(c,"marginTop",!0),left:b.left-d.left-r.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&"static"===r.css(a,"position"))a=a.offsetParent;return a||pa})}}),r.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c="pageYOffset"===b;r.fn[a]=function(d){return S(this,function(a,d,e){var f=Sb(a);return void 0===e?f?f[b]:a[d]:void(f?f.scrollTo(c?f.pageXOffset:e,c?e:f.pageYOffset):a[d]=e)},a,d,arguments.length)}}),r.each(["top","left"],function(a,b){r.cssHooks[b]=Na(o.pixelPosition,function(a,c){if(c)return c=Ma(a,b),Ka.test(c)?r(a).position()[b]+"px":c})}),r.each({Height:"height",Width:"width"},function(a,b){r.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){r.fn[d]=function(e,f){var g=arguments.length&&(c||"boolean"!=typeof e),h=c||(e===!0||f===!0?"margin":"border");return S(this,function(b,c,e){var f;return r.isWindow(b)?0===d.indexOf("outer")?b["inner"+a]:b.document.documentElement["client"+a]:9===b.nodeType?(f=b.documentElement,Math.max(b.body["scroll"+a],f["scroll"+a],b.body["offset"+a],f["offset"+a],f["client"+a])):void 0===e?r.css(b,c,h):r.style(b,c,e,h)},b,g?e:void 0,g)}})}),r.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}}),r.parseJSON=JSON.parse,"function"==typeof define&&define.amd&&define("jquery",[],function(){return r});var Tb=a.jQuery,Ub=a.$;return r.noConflict=function(b){return a.$===r&&(a.$=Ub),b&&a.jQuery===r&&(a.jQuery=Tb),r},b||(a.jQuery=a.$=r),r}),function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a(jQuery)}(function(a){a.ui=a.ui||{};var b=a.ui.version="1.12.0",c=0,d=Array.prototype.slice;a.cleanData=function(b){return function(c){var d,e,f;for(f=0;null!=(e=c[f]);f++)try{d=a._data(e,"events"),d&&d.remove&&a(e).triggerHandler("remove")}catch(a){}b(c)}}(a.cleanData),a.widget=function(b,c,d){var e,f,g,h={},i=b.split(".")[0];b=b.split(".")[1];var j=i+"-"+b;return d||(d=c,c=a.Widget),a.isArray(d)&&(d=a.extend.apply(null,[{}].concat(d))),a.expr[":"][j.toLowerCase()]=function(b){return!!a.data(b,j)},a[i]=a[i]||{},e=a[i][b],f=a[i][b]=function(a,b){return this._createWidget?void(arguments.length&&this._createWidget(a,b)):new f(a,b)},a.extend(f,e,{version:d.version,_proto:a.extend({},d),_childConstructors:[]}),g=new c,g.options=a.widget.extend({},g.options),a.each(d,function(b,d){return a.isFunction(d)?void(h[b]=function(){function a(){return c.prototype[b].apply(this,arguments)}function e(a){return c.prototype[b].apply(this,a)}return function(){var b=this._super,c=this._superApply,f;return this._super=a,this._superApply=e,f=d.apply(this,arguments),this._super=b,this._superApply=c,f}}()):void(h[b]=d)}),f.prototype=a.widget.extend(g,{widgetEventPrefix:e?g.widgetEventPrefix||b:b},h,{constructor:f,namespace:i,widgetName:b,widgetFullName:j}),e?(a.each(e._childConstructors,function(b,c){var d=c.prototype;a.widget(d.namespace+"."+d.widgetName,f,c._proto)}),delete e._childConstructors):c._childConstructors.push(f),a.widget.bridge(b,f),f},a.widget.extend=function(b){for(var c=d.call(arguments,1),e=0,f=c.length,g,h;e<f;e++)for(g in c[e])h=c[e][g],c[e].hasOwnProperty(g)&&void 0!==h&&(a.isPlainObject(h)?b[g]=a.isPlainObject(b[g])?a.widget.extend({},b[g],h):a.widget.extend({},h):b[g]=h);return b},a.widget.bridge=function(b,c){var e=c.prototype.widgetFullName||b;a.fn[b]=function(f){var g="string"==typeof f,h=d.call(arguments,1),i=this;return g?this.each(function(){var c,d=a.data(this,e);return"instance"===f?(i=d,!1):d?a.isFunction(d[f])&&"_"!==f.charAt(0)?(c=d[f].apply(d,h),c!==d&&void 0!==c?(i=c&&c.jquery?i.pushStack(c.get()):c,!1):void 0):a.error("no such method '"+f+"' for "+b+" widget instance"):a.error("cannot call methods on "+b+" prior to initialization; attempted to call method '"+f+"'")}):(h.length&&(f=a.widget.extend.apply(null,[f].concat(h))),this.each(function(){var b=a.data(this,e);b?(b.option(f||{}),b._init&&b._init()):a.data(this,e,new c(f,this))})),i}},a.Widget=function(){},a.Widget._childConstructors=[],a.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{classes:{},disabled:!1,create:null},_createWidget:function(b,d){d=a(d||this.defaultElement||this)[0],this.element=a(d),this.uuid=c++,this.eventNamespace="."+this.widgetName+this.uuid,this.bindings=a(),this.hoverable=a(),this.focusable=a(),this.classesElementLookup={},d!==this&&(a.data(d,this.widgetFullName,this),this._on(!0,this.element,{remove:function(a){a.target===d&&this.destroy()}}),this.document=a(d.style?d.ownerDocument:d.document||d),this.window=a(this.document[0].defaultView||this.document[0].parentWindow)),this.options=a.widget.extend({},this.options,this._getCreateOptions(),b),this._create(),this.options.disabled&&this._setOptionDisabled(this.options.disabled),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:function(){return{}},_getCreateEventData:a.noop,_create:a.noop,_init:a.noop,destroy:function(){var b=this;this._destroy(),a.each(this.classesElementLookup,function(a,c){b._removeClass(c,a)}),this.element.off(this.eventNamespace).removeData(this.widgetFullName),this.widget().off(this.eventNamespace).removeAttr("aria-disabled"),this.bindings.off(this.eventNamespace)},_destroy:a.noop,widget:function(){return this.element},option:function(b,c){var d=b,e,f,g;if(0===arguments.length)return a.widget.extend({},this.options);if("string"==typeof b)if(d={},e=b.split("."),b=e.shift(),e.length){for(f=d[b]=a.widget.extend({},this.options[b]),g=0;g<e.length-1;g++)f[e[g]]=f[e[g]]||{},f=f[e[g]];if(b=e.pop(),1===arguments.length)return void 0===f[b]?null:f[b];f[b]=c}else{if(1===arguments.length)return void 0===this.options[b]?null:this.options[b];d[b]=c}return this._setOptions(d),this},_setOptions:function(a){var b;for(b in a)this._setOption(b,a[b]);return this},_setOption:function(a,b){return"classes"===a&&this._setOptionClasses(b),this.options[a]=b,"disabled"===a&&this._setOptionDisabled(b),this},_setOptionClasses:function(b){var c,d,e;for(c in b)e=this.classesElementLookup[c],b[c]!==this.options.classes[c]&&e&&e.length&&(d=a(e.get()),this._removeClass(e,c),d.addClass(this._classes({element:d,keys:c,classes:b,add:!0})))},_setOptionDisabled:function(a){this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,!!a),a&&(this._removeClass(this.hoverable,null,"ui-state-hover"),this._removeClass(this.focusable,null,"ui-state-focus"))},enable:function(){return this._setOptions({disabled:!1})},disable:function(){return this._setOptions({disabled:!0})},_classes:function(b){var c=[],d=this;b=a.extend({element:this.element,classes:this.options.classes||{}},b);function e(e,f){var g,h;for(h=0;h<e.length;h++)g=d.classesElementLookup[e[h]]||a(),g=a(b.add?a.unique(g.get().concat(b.element.get())):g.not(b.element).get()),d.classesElementLookup[e[h]]=g,c.push(e[h]),f&&b.classes[e[h]]&&c.push(b.classes[e[h]])}return b.keys&&e(b.keys.match(/\S+/g)||[],!0),b.extra&&e(b.extra.match(/\S+/g)||[]),c.join(" ")},_removeClass:function(a,b,c){return this._toggleClass(a,b,c,!1)},_addClass:function(a,b,c){return this._toggleClass(a,b,c,!0)},_toggleClass:function(a,b,c,d){d="boolean"==typeof d?d:c;var e="string"==typeof a||null===a,f={extra:e?b:c,keys:e?a:b,element:e?this.element:a,add:d};return f.element.toggleClass(this._classes(f),d),this},_on:function(b,c,d){var e,f=this;"boolean"!=typeof b&&(d=c,c=b,b=!1),d?(c=e=a(c),this.bindings=this.bindings.add(c)):(d=c,c=this.element,e=this.widget()),a.each(d,function(d,g){function h(){if(b||f.options.disabled!==!0&&!a(this).hasClass("ui-state-disabled"))return("string"==typeof g?f[g]:g).apply(f,arguments)}"string"!=typeof g&&(h.guid=g.guid=g.guid||h.guid||a.guid++);var i=d.match(/^([\w:-]*)\s*(.*)$/),j=i[1]+f.eventNamespace,k=i[2];k?e.on(j,k,h):c.on(j,h)})},_off:function(b,c){c=(c||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,b.off(c).off(c),this.bindings=a(this.bindings.not(b).get()),this.focusable=a(this.focusable.not(b).get()),this.hoverable=a(this.hoverable.not(b).get())},_delay:function(a,b){function c(){return("string"==typeof a?d[a]:a).apply(d,arguments)}var d=this;return setTimeout(c,b||0)},_hoverable:function(b){this.hoverable=this.hoverable.add(b),this._on(b,{mouseenter:function(b){this._addClass(a(b.currentTarget),null,"ui-state-hover")},mouseleave:function(b){this._removeClass(a(b.currentTarget),null,"ui-state-hover")}})},_focusable:function(b){this.focusable=this.focusable.add(b),this._on(b,{focusin:function(b){this._addClass(a(b.currentTarget),null,"ui-state-focus")},focusout:function(b){this._removeClass(a(b.currentTarget),null,"ui-state-focus")}})},_trigger:function(b,c,d){var e,f,g=this.options[b];if(d=d||{},c=a.Event(c),c.type=(b===this.widgetEventPrefix?b:this.widgetEventPrefix+b).toLowerCase(),c.target=this.element[0],f=c.originalEvent)for(e in f)e in c||(c[e]=f[e]);return this.element.trigger(c,d),!(a.isFunction(g)&&g.apply(this.element[0],[c].concat(d))===!1||c.isDefaultPrevented())}},a.each({show:"fadeIn",hide:"fadeOut"},function(b,c){a.Widget.prototype["_"+b]=function(d,e,f){"string"==typeof e&&(e={effect:e});var g,h=e?e===!0||"number"==typeof e?c:e.effect||c:b;e=e||{},"number"==typeof e&&(e={duration:e}),g=!a.isEmptyObject(e),e.complete=f,e.delay&&d.delay(e.delay),g&&a.effects&&a.effects.effect[h]?d[b](e):h!==b&&d[h]?d[h](e.duration,e.easing,f):d.queue(function(c){a(this)[b](),f&&f.call(d[0]),c()})}});var e=a.widget;!function(){var b,c,d=Math.max,e=Math.abs,f=Math.round,g=/left|center|right/,h=/top|center|bottom/,i=/[\+\-]\d+(\.[\d]+)?%?/,j=/^\w+/,k=/%$/,l=a.fn.position;c=function(){var b=a("<div>").css("position","absolute").appendTo("body").offset({top:1.5,left:1.5}),d=1.5===b.offset().top;return b.remove(),c=function(){return d},d};function m(a,b,c){return[parseFloat(a[0])*(k.test(a[0])?b/100:1),parseFloat(a[1])*(k.test(a[1])?c/100:1)]}function n(b,c){return parseInt(a.css(b,c),10)||0}function o(b){var c=b[0];return 9===c.nodeType?{width:b.width(),height:b.height(),offset:{top:0,left:0}}:a.isWindow(c)?{width:b.width(),height:b.height(),offset:{top:b.scrollTop(),left:b.scrollLeft()}}:c.preventDefault?{width:0,height:0,offset:{top:c.pageY,left:c.pageX}}:{width:b.outerWidth(),height:b.outerHeight(),offset:b.offset()}}a.position={scrollbarWidth:function(){if(void 0!==b)return b;var c,d,e=a("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),f=e.children()[0];return a("body").append(e),c=f.offsetWidth,e.css("overflow","scroll"),d=f.offsetWidth,c===d&&(d=e[0].clientWidth),e.remove(),b=c-d},getScrollInfo:function(b){var c=b.isWindow||b.isDocument?"":b.element.css("overflow-x"),d=b.isWindow||b.isDocument?"":b.element.css("overflow-y"),e="scroll"===c||"auto"===c&&b.width<b.element[0].scrollWidth,f="scroll"===d||"auto"===d&&b.height<b.element[0].scrollHeight;return{width:f?a.position.scrollbarWidth():0,height:e?a.position.scrollbarWidth():0}},getWithinInfo:function(b){var c=a(b||window),d=a.isWindow(c[0]),e=!!c[0]&&9===c[0].nodeType,f=!d&&!e;return{element:c,isWindow:d,isDocument:e,offset:f?a(b).offset():{left:0,top:0},scrollLeft:c.scrollLeft(),scrollTop:c.scrollTop(),width:c.outerWidth(),height:c.outerHeight()}}},a.fn.position=function(b){
if(!b||!b.of)return l.apply(this,arguments);b=a.extend({},b);var k,p,q,r,s,t,u=a(b.of),v=a.position.getWithinInfo(b.within),w=a.position.getScrollInfo(v),x=(b.collision||"flip").split(" "),y={};return t=o(u),u[0].preventDefault&&(b.at="left top"),p=t.width,q=t.height,r=t.offset,s=a.extend({},r),a.each(["my","at"],function(){var a=(b[this]||"").split(" "),c,d;1===a.length&&(a=g.test(a[0])?a.concat(["center"]):h.test(a[0])?["center"].concat(a):["center","center"]),a[0]=g.test(a[0])?a[0]:"center",a[1]=h.test(a[1])?a[1]:"center",c=i.exec(a[0]),d=i.exec(a[1]),y[this]=[c?c[0]:0,d?d[0]:0],b[this]=[j.exec(a[0])[0],j.exec(a[1])[0]]}),1===x.length&&(x[1]=x[0]),"right"===b.at[0]?s.left+=p:"center"===b.at[0]&&(s.left+=p/2),"bottom"===b.at[1]?s.top+=q:"center"===b.at[1]&&(s.top+=q/2),k=m(y.at,p,q),s.left+=k[0],s.top+=k[1],this.each(function(){var g,h,i=a(this),j=i.outerWidth(),l=i.outerHeight(),o=n(this,"marginLeft"),t=n(this,"marginTop"),z=j+o+n(this,"marginRight")+w.width,A=l+t+n(this,"marginBottom")+w.height,B=a.extend({},s),C=m(y.my,i.outerWidth(),i.outerHeight());"right"===b.my[0]?B.left-=j:"center"===b.my[0]&&(B.left-=j/2),"bottom"===b.my[1]?B.top-=l:"center"===b.my[1]&&(B.top-=l/2),B.left+=C[0],B.top+=C[1],c()||(B.left=f(B.left),B.top=f(B.top)),g={marginLeft:o,marginTop:t},a.each(["left","top"],function(c,d){a.ui.position[x[c]]&&a.ui.position[x[c]][d](B,{targetWidth:p,targetHeight:q,elemWidth:j,elemHeight:l,collisionPosition:g,collisionWidth:z,collisionHeight:A,offset:[k[0]+C[0],k[1]+C[1]],my:b.my,at:b.at,within:v,elem:i})}),b.using&&(h=function(a){var c=r.left-B.left,f=c+p-j,g=r.top-B.top,h=g+q-l,k={target:{element:u,left:r.left,top:r.top,width:p,height:q},element:{element:i,left:B.left,top:B.top,width:j,height:l},horizontal:f<0?"left":c>0?"right":"center",vertical:h<0?"top":g>0?"bottom":"middle"};p<j&&e(c+f)<p&&(k.horizontal="center"),q<l&&e(g+h)<q&&(k.vertical="middle"),d(e(c),e(f))>d(e(g),e(h))?k.important="horizontal":k.important="vertical",b.using.call(this,a,k)}),i.offset(a.extend(B,{using:h}))})},a.ui.position={fit:{left:function(a,b){var c=b.within,e=c.isWindow?c.scrollLeft:c.offset.left,f=c.width,g=a.left-b.collisionPosition.marginLeft,h=e-g,i=g+b.collisionWidth-f-e,j;b.collisionWidth>f?h>0&&i<=0?(j=a.left+h+b.collisionWidth-f-e,a.left+=h-j):i>0&&h<=0?a.left=e:h>i?a.left=e+f-b.collisionWidth:a.left=e:h>0?a.left+=h:i>0?a.left-=i:a.left=d(a.left-g,a.left)},top:function(a,b){var c=b.within,e=c.isWindow?c.scrollTop:c.offset.top,f=b.within.height,g=a.top-b.collisionPosition.marginTop,h=e-g,i=g+b.collisionHeight-f-e,j;b.collisionHeight>f?h>0&&i<=0?(j=a.top+h+b.collisionHeight-f-e,a.top+=h-j):i>0&&h<=0?a.top=e:h>i?a.top=e+f-b.collisionHeight:a.top=e:h>0?a.top+=h:i>0?a.top-=i:a.top=d(a.top-g,a.top)}},flip:{left:function(a,b){var c=b.within,d=c.offset.left+c.scrollLeft,f=c.width,g=c.isWindow?c.scrollLeft:c.offset.left,h=a.left-b.collisionPosition.marginLeft,i=h-g,j=h+b.collisionWidth-f-g,k="left"===b.my[0]?-b.elemWidth:"right"===b.my[0]?b.elemWidth:0,l="left"===b.at[0]?b.targetWidth:"right"===b.at[0]?-b.targetWidth:0,m=-2*b.offset[0],n,o;i<0?(n=a.left+k+l+m+b.collisionWidth-f-d,(n<0||n<e(i))&&(a.left+=k+l+m)):j>0&&(o=a.left-b.collisionPosition.marginLeft+k+l+m-g,(o>0||e(o)<j)&&(a.left+=k+l+m))},top:function(a,b){var c=b.within,d=c.offset.top+c.scrollTop,f=c.height,g=c.isWindow?c.scrollTop:c.offset.top,h=a.top-b.collisionPosition.marginTop,i=h-g,j=h+b.collisionHeight-f-g,k="top"===b.my[1],l=k?-b.elemHeight:"bottom"===b.my[1]?b.elemHeight:0,m="top"===b.at[1]?b.targetHeight:"bottom"===b.at[1]?-b.targetHeight:0,n=-2*b.offset[1],o,p;i<0?(p=a.top+l+m+n+b.collisionHeight-f-d,(p<0||p<e(i))&&(a.top+=l+m+n)):j>0&&(o=a.top-b.collisionPosition.marginTop+l+m+n-g,(o>0||e(o)<j)&&(a.top+=l+m+n))}},flipfit:{left:function(){a.ui.position.flip.left.apply(this,arguments),a.ui.position.fit.left.apply(this,arguments)},top:function(){a.ui.position.flip.top.apply(this,arguments),a.ui.position.fit.top.apply(this,arguments)}}}}();var f=a.ui.position,g=a.extend(a.expr[":"],{data:a.expr.createPseudo?a.expr.createPseudo(function(b){return function(c){return!!a.data(c,b)}}):function(b,c,d){return!!a.data(b,d[3])}}),h=a.fn.extend({disableSelection:function(){var a="onselectstart"in document.createElement("div")?"selectstart":"mousedown";return function(){return this.on(a+".ui-disableSelection",function(a){a.preventDefault()})}}(),enableSelection:function(){return this.off(".ui-disableSelection")}}),i="ui-effects-",j="ui-effects-style",k="ui-effects-animated",l=a;a.effects={effect:{}},function(a,b){var c="backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",d=/^([\-+])=\s*(\d+\.?\d*)/,e=[{re:/rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(a){return[a[1],a[2],a[3],a[4]]}},{re:/rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(a){return[2.55*a[1],2.55*a[2],2.55*a[3],a[4]]}},{re:/#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,parse:function(a){return[parseInt(a[1],16),parseInt(a[2],16),parseInt(a[3],16)]}},{re:/#([a-f0-9])([a-f0-9])([a-f0-9])/,parse:function(a){return[parseInt(a[1]+a[1],16),parseInt(a[2]+a[2],16),parseInt(a[3]+a[3],16)]}},{re:/hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,space:"hsla",parse:function(a){return[a[1],a[2]/100,a[3]/100,a[4]]}}],f=a.Color=function(b,c,d,e){return new a.Color.fn.parse(b,c,d,e)},g={rgba:{props:{red:{idx:0,type:"byte"},green:{idx:1,type:"byte"},blue:{idx:2,type:"byte"}}},hsla:{props:{hue:{idx:0,type:"degrees"},saturation:{idx:1,type:"percent"},lightness:{idx:2,type:"percent"}}}},h={byte:{floor:!0,max:255},percent:{max:1},degrees:{mod:360,floor:!0}},i=f.support={},j=a("<p>")[0],k,l=a.each;j.style.cssText="background-color:rgba(1,1,1,.5)",i.rgba=j.style.backgroundColor.indexOf("rgba")>-1,l(g,function(a,b){b.cache="_"+a,b.props.alpha={idx:3,type:"percent",def:1}});function m(a,b,c){var d=h[b.type]||{};return null==a?c||!b.def?null:b.def:(a=d.floor?~~a:parseFloat(a),isNaN(a)?b.def:d.mod?(a+d.mod)%d.mod:0>a?0:d.max<a?d.max:a)}function n(b){var c=f(),d=c._rgba=[];return b=b.toLowerCase(),l(e,function(a,e){var f,h=e.re.exec(b),i=h&&e.parse(h),j=e.space||"rgba";if(i)return f=c[j](i),c[g[j].cache]=f[g[j].cache],d=c._rgba=f._rgba,!1}),d.length?("0,0,0,0"===d.join()&&a.extend(d,k.transparent),c):k[b]}f.fn=a.extend(f.prototype,{parse:function(c,d,e,h){if(c===b)return this._rgba=[null,null,null,null],this;(c.jquery||c.nodeType)&&(c=a(c).css(d),d=b);var i=this,j=a.type(c),o=this._rgba=[];return d!==b&&(c=[c,d,e,h],j="array"),"string"===j?this.parse(n(c)||k._default):"array"===j?(l(g.rgba.props,function(a,b){o[b.idx]=m(c[b.idx],b)}),this):"object"===j?(c instanceof f?l(g,function(a,b){c[b.cache]&&(i[b.cache]=c[b.cache].slice())}):l(g,function(b,d){var e=d.cache;l(d.props,function(a,b){if(!i[e]&&d.to){if("alpha"===a||null==c[a])return;i[e]=d.to(i._rgba)}i[e][b.idx]=m(c[a],b,!0)}),i[e]&&a.inArray(null,i[e].slice(0,3))<0&&(i[e][3]=1,d.from&&(i._rgba=d.from(i[e])))}),this):void 0},is:function(a){var b=f(a),c=!0,d=this;return l(g,function(a,e){var f,g=b[e.cache];return g&&(f=d[e.cache]||e.to&&e.to(d._rgba)||[],l(e.props,function(a,b){if(null!=g[b.idx])return c=g[b.idx]===f[b.idx]})),c}),c},_space:function(){var a=[],b=this;return l(g,function(c,d){b[d.cache]&&a.push(c)}),a.pop()},transition:function(a,b){var c=f(a),d=c._space(),e=g[d],i=0===this.alpha()?f("transparent"):this,j=i[e.cache]||e.to(i._rgba),k=j.slice();return c=c[e.cache],l(e.props,function(a,d){var e=d.idx,f=j[e],g=c[e],i=h[d.type]||{};null!==g&&(null===f?k[e]=g:(i.mod&&(g-f>i.mod/2?f+=i.mod:f-g>i.mod/2&&(f-=i.mod)),k[e]=m((g-f)*b+f,d)))}),this[d](k)},blend:function(b){if(1===this._rgba[3])return this;var c=this._rgba.slice(),d=c.pop(),e=f(b)._rgba;return f(a.map(c,function(a,b){return(1-d)*e[b]+d*a}))},toRgbaString:function(){var b="rgba(",c=a.map(this._rgba,function(a,b){return null==a?b>2?1:0:a});return 1===c[3]&&(c.pop(),b="rgb("),b+c.join()+")"},toHslaString:function(){var b="hsla(",c=a.map(this.hsla(),function(a,b){return null==a&&(a=b>2?1:0),b&&b<3&&(a=Math.round(100*a)+"%"),a});return 1===c[3]&&(c.pop(),b="hsl("),b+c.join()+")"},toHexString:function(b){var c=this._rgba.slice(),d=c.pop();return b&&c.push(~~(255*d)),"#"+a.map(c,function(a){return a=(a||0).toString(16),1===a.length?"0"+a:a}).join("")},toString:function(){return 0===this._rgba[3]?"transparent":this.toRgbaString()}}),f.fn.parse.prototype=f.fn;function o(a,b,c){return c=(c+1)%1,6*c<1?a+(b-a)*c*6:2*c<1?b:3*c<2?a+(b-a)*(2/3-c)*6:a}g.hsla.to=function(a){if(null==a[0]||null==a[1]||null==a[2])return[null,null,null,a[3]];var b=a[0]/255,c=a[1]/255,d=a[2]/255,e=a[3],f=Math.max(b,c,d),g=Math.min(b,c,d),h=f-g,i=f+g,j=.5*i,k,l;return k=g===f?0:b===f?60*(c-d)/h+360:c===f?60*(d-b)/h+120:60*(b-c)/h+240,l=0===h?0:j<=.5?h/i:h/(2-i),[Math.round(k)%360,l,j,null==e?1:e]},g.hsla.from=function(a){if(null==a[0]||null==a[1]||null==a[2])return[null,null,null,a[3]];var b=a[0]/360,c=a[1],d=a[2],e=a[3],f=d<=.5?d*(1+c):d+c-d*c,g=2*d-f;return[Math.round(255*o(g,f,b+1/3)),Math.round(255*o(g,f,b)),Math.round(255*o(g,f,b-1/3)),e]},l(g,function(c,e){var g=e.props,h=e.cache,i=e.to,j=e.from;f.fn[c]=function(c){if(i&&!this[h]&&(this[h]=i(this._rgba)),c===b)return this[h].slice();var d,e=a.type(c),k="array"===e||"object"===e?c:arguments,n=this[h].slice();return l(g,function(a,b){var c=k["object"===e?a:b.idx];null==c&&(c=n[b.idx]),n[b.idx]=m(c,b)}),j?(d=f(j(n)),d[h]=n,d):f(n)},l(g,function(b,e){f.fn[b]||(f.fn[b]=function(f){var g=a.type(f),h="alpha"===b?this._hsla?"hsla":"rgba":c,i=this[h](),j=i[e.idx],k;return"undefined"===g?j:("function"===g&&(f=f.call(this,j),g=a.type(f)),null==f&&e.empty?this:("string"===g&&(k=d.exec(f),k&&(f=j+parseFloat(k[2])*("+"===k[1]?1:-1))),i[e.idx]=f,this[h](i)))})})}),f.hook=function(b){var c=b.split(" ");l(c,function(b,c){a.cssHooks[c]={set:function(b,d){var e,g,h="";if("transparent"!==d&&("string"!==a.type(d)||(e=n(d)))){if(d=f(e||d),!i.rgba&&1!==d._rgba[3]){g="backgroundColor"===c?b.parentNode:b;while((""===h||"transparent"===h)&&g&&g.style)try{h=a.css(g,"backgroundColor"),g=g.parentNode}catch(a){}d=d.blend(h&&"transparent"!==h?h:"_default")}d=d.toRgbaString()}try{b.style[c]=d}catch(a){}}},a.fx.step[c]=function(b){b.colorInit||(b.start=f(b.elem,c),b.end=f(b.end),b.colorInit=!0),a.cssHooks[c].set(b.elem,b.start.transition(b.end,b.pos))}})},f.hook(c),a.cssHooks.borderColor={expand:function(a){var b={};return l(["Top","Right","Bottom","Left"],function(c,d){b["border"+d+"Color"]=a}),b}},k=a.Color.names={aqua:"#00ffff",black:"#000000",blue:"#0000ff",fuchsia:"#ff00ff",gray:"#808080",green:"#008000",lime:"#00ff00",maroon:"#800000",navy:"#000080",olive:"#808000",purple:"#800080",red:"#ff0000",silver:"#c0c0c0",teal:"#008080",white:"#ffffff",yellow:"#ffff00",transparent:[null,null,null,0],_default:"#ffffff"}}(l),function(){var b=["add","remove","toggle"],c={border:1,borderBottom:1,borderColor:1,borderLeft:1,borderRight:1,borderTop:1,borderWidth:1,margin:1,padding:1};a.each(["borderLeftStyle","borderRightStyle","borderBottomStyle","borderTopStyle"],function(b,c){a.fx.step[c]=function(a){("none"!==a.end&&!a.setAttr||1===a.pos&&!a.setAttr)&&(l.style(a.elem,c,a.end),a.setAttr=!0)}});function d(b){var c,d,e=b.ownerDocument.defaultView?b.ownerDocument.defaultView.getComputedStyle(b,null):b.currentStyle,f={};if(e&&e.length&&e[0]&&e[e[0]]){d=e.length;while(d--)c=e[d],"string"==typeof e[c]&&(f[a.camelCase(c)]=e[c])}else for(c in e)"string"==typeof e[c]&&(f[c]=e[c]);return f}function e(b,d){var e={},f,g;for(f in d)g=d[f],b[f]!==g&&(c[f]||!a.fx.step[f]&&isNaN(parseFloat(g))||(e[f]=g));return e}a.fn.addBack||(a.fn.addBack=function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}),a.effects.animateClass=function(c,f,g,h){var i=a.speed(f,g,h);return this.queue(function(){var f=a(this),g=f.attr("class")||"",h,j=i.children?f.find("*").addBack():f;j=j.map(function(){var b=a(this);return{el:b,start:d(this)}}),h=function(){a.each(b,function(a,b){c[b]&&f[b+"Class"](c[b])})},h(),j=j.map(function(){return this.end=d(this.el[0]),this.diff=e(this.start,this.end),this}),f.attr("class",g),j=j.map(function(){var b=this,c=a.Deferred(),d=a.extend({},i,{queue:!1,complete:function(){c.resolve(b)}});return this.el.animate(this.diff,d),c.promise()}),a.when.apply(a,j.get()).done(function(){h(),a.each(arguments,function(){var b=this.el;a.each(this.diff,function(a){b.css(a,"")})}),i.complete.call(f[0])})})},a.fn.extend({addClass:function(b){return function(c,d,e,f){return d?a.effects.animateClass.call(this,{add:c},d,e,f):b.apply(this,arguments)}}(a.fn.addClass),removeClass:function(b){return function(c,d,e,f){return arguments.length>1?a.effects.animateClass.call(this,{remove:c},d,e,f):b.apply(this,arguments)}}(a.fn.removeClass),toggleClass:function(b){return function(c,d,e,f,g){return"boolean"==typeof d||void 0===d?e?a.effects.animateClass.call(this,d?{add:c}:{remove:c},e,f,g):b.apply(this,arguments):a.effects.animateClass.call(this,{toggle:c},d,e,f)}}(a.fn.toggleClass),switchClass:function(b,c,d,e,f){return a.effects.animateClass.call(this,{add:c,remove:b},d,e,f)}})}(),function(){a.expr&&a.expr.filters&&a.expr.filters.animated&&(a.expr.filters.animated=function(b){return function(c){return!!a(c).data(k)||b(c)}}(a.expr.filters.animated)),a.uiBackCompat!==!1&&a.extend(a.effects,{save:function(a,b){for(var c=0,d=b.length;c<d;c++)null!==b[c]&&a.data(i+b[c],a[0].style[b[c]])},restore:function(a,b){for(var c,d=0,e=b.length;d<e;d++)null!==b[d]&&(c=a.data(i+b[d]),a.css(b[d],c))},setMode:function(a,b){return"toggle"===b&&(b=a.is(":hidden")?"show":"hide"),b},createWrapper:function(b){if(b.parent().is(".ui-effects-wrapper"))return b.parent();var c={width:b.outerWidth(!0),height:b.outerHeight(!0),float:b.css("float")},d=a("<div></div>").addClass("ui-effects-wrapper").css({fontSize:"100%",background:"transparent",border:"none",margin:0,padding:0}),e={width:b.width(),height:b.height()},f=document.activeElement;try{f.id}catch(a){f=document.body}return b.wrap(d),(b[0]===f||a.contains(b[0],f))&&a(f).trigger("focus"),d=b.parent(),"static"===b.css("position")?(d.css({position:"relative"}),b.css({position:"relative"})):(a.extend(c,{position:b.css("position"),zIndex:b.css("z-index")}),a.each(["top","left","bottom","right"],function(a,d){c[d]=b.css(d),isNaN(parseInt(c[d],10))&&(c[d]="auto")}),b.css({position:"relative",top:0,left:0,right:"auto",bottom:"auto"})),b.css(e),d.css(c).show()},removeWrapper:function(b){var c=document.activeElement;return b.parent().is(".ui-effects-wrapper")&&(b.parent().replaceWith(b),(b[0]===c||a.contains(b[0],c))&&a(c).trigger("focus")),b}}),a.extend(a.effects,{version:"1.12.0",define:function(b,c,d){return d||(d=c,c="effect"),a.effects.effect[b]=d,a.effects.effect[b].mode=c,d},scaledDimensions:function(a,b,c){if(0===b)return{height:0,width:0,outerHeight:0,outerWidth:0};var d="horizontal"!==c?(b||100)/100:1,e="vertical"!==c?(b||100)/100:1;return{height:a.height()*e,width:a.width()*d,outerHeight:a.outerHeight()*e,outerWidth:a.outerWidth()*d}},clipToBox:function(a){return{width:a.clip.right-a.clip.left,height:a.clip.bottom-a.clip.top,left:a.clip.left,top:a.clip.top}},unshift:function(a,b,c){var d=a.queue();b>1&&d.splice.apply(d,[1,0].concat(d.splice(b,c))),a.dequeue()},saveStyle:function(a){a.data(j,a[0].style.cssText)},restoreStyle:function(a){a[0].style.cssText=a.data(j)||"",a.removeData(j)},mode:function(a,b){var c=a.is(":hidden");return"toggle"===b&&(b=c?"show":"hide"),(c?"hide"===b:"show"===b)&&(b="none"),b},getBaseline:function(a,b){var c,d;switch(a[0]){case"top":c=0;break;case"middle":c=.5;break;case"bottom":c=1;break;default:c=a[0]/b.height}switch(a[1]){case"left":d=0;break;case"center":d=.5;break;case"right":d=1;break;default:d=a[1]/b.width}return{x:d,y:c}},createPlaceholder:function(b){var c,d=b.css("position"),e=b.position();return b.css({marginTop:b.css("marginTop"),marginBottom:b.css("marginBottom"),marginLeft:b.css("marginLeft"),marginRight:b.css("marginRight")}).outerWidth(b.outerWidth()).outerHeight(b.outerHeight()),/^(static|relative)/.test(d)&&(d="absolute",c=a("<"+b[0].nodeName+">").insertAfter(b).css({display:/^(inline|ruby)/.test(b.css("display"))?"inline-block":"block",visibility:"hidden",marginTop:b.css("marginTop"),marginBottom:b.css("marginBottom"),marginLeft:b.css("marginLeft"),marginRight:b.css("marginRight"),float:b.css("float")}).outerWidth(b.outerWidth()).outerHeight(b.outerHeight()).addClass("ui-effects-placeholder"),b.data(i+"placeholder",c)),b.css({position:d,left:e.left,top:e.top}),c},removePlaceholder:function(a){var b=i+"placeholder",c=a.data(b);c&&(c.remove(),a.removeData(b))},cleanUp:function(b){a.effects.restoreStyle(b),a.effects.removePlaceholder(b)},setTransition:function(b,c,d,e){return e=e||{},a.each(c,function(a,c){var f=b.cssUnit(c);f[0]>0&&(e[c]=f[0]*d+f[1])}),e}});function b(b,c,d,e){return a.isPlainObject(b)&&(c=b,b=b.effect),b={effect:b},null==c&&(c={}),a.isFunction(c)&&(e=c,d=null,c={}),("number"==typeof c||a.fx.speeds[c])&&(e=d,d=c,c={}),a.isFunction(d)&&(e=d,d=null),c&&a.extend(b,c),d=d||c.duration,b.duration=a.fx.off?0:"number"==typeof d?d:d in a.fx.speeds?a.fx.speeds[d]:a.fx.speeds._default,b.complete=e||c.complete,b}function c(b){return!(b&&"number"!=typeof b&&!a.fx.speeds[b])||("string"==typeof b&&!a.effects.effect[b]||(!!a.isFunction(b)||"object"==typeof b&&!b.effect))}a.fn.extend({effect:function(){var c=b.apply(this,arguments),d=a.effects.effect[c.effect],e=d.mode,f=c.queue,g=f||"fx",h=c.complete,i=c.mode,j=[],l=function(b){var c=a(this),d=a.effects.mode(c,i)||e;c.data(k,!0),j.push(d),e&&("show"===d||d===e&&"hide"===d)&&c.show(),e&&"none"===d||a.effects.saveStyle(c),a.isFunction(b)&&b()};if(a.fx.off||!d)return i?this[i](c.duration,h):this.each(function(){h&&h.call(this)});function m(b){var f=a(this);function g(){f.removeData(k),a.effects.cleanUp(f),"hide"===c.mode&&f.hide(),l()}function l(){a.isFunction(h)&&h.call(f[0]),a.isFunction(b)&&b()}c.mode=j.shift(),a.uiBackCompat===!1||e?"none"===c.mode?(f[i](),l()):d.call(f[0],c,g):(f.is(":hidden")?"hide"===i:"show"===i)?(f[i](),l()):d.call(f[0],c,l)}return f===!1?this.each(l).each(m):this.queue(g,l).queue(g,m)},show:function(a){return function(d){if(c(d))return a.apply(this,arguments);var e=b.apply(this,arguments);return e.mode="show",this.effect.call(this,e)}}(a.fn.show),hide:function(a){return function(d){if(c(d))return a.apply(this,arguments);var e=b.apply(this,arguments);return e.mode="hide",this.effect.call(this,e)}}(a.fn.hide),toggle:function(a){return function(d){if(c(d)||"boolean"==typeof d)return a.apply(this,arguments);var e=b.apply(this,arguments);return e.mode="toggle",this.effect.call(this,e)}}(a.fn.toggle),cssUnit:function(b){var c=this.css(b),d=[];return a.each(["em","px","%","pt"],function(a,b){c.indexOf(b)>0&&(d=[parseFloat(c),b])}),d},cssClip:function(a){return a?this.css("clip","rect("+a.top+"px "+a.right+"px "+a.bottom+"px "+a.left+"px)"):d(this.css("clip"),this)},transfer:function(b,c){var d=a(this),e=a(b.to),f="fixed"===e.css("position"),g=a("body"),h=f?g.scrollTop():0,i=f?g.scrollLeft():0,j=e.offset(),k={top:j.top-h,left:j.left-i,height:e.innerHeight(),width:e.innerWidth()},l=d.offset(),m=a("<div class='ui-effects-transfer'></div>").appendTo("body").addClass(b.className).css({top:l.top-h,left:l.left-i,height:d.innerHeight(),width:d.innerWidth(),position:f?"fixed":"absolute"}).animate(k,b.duration,b.easing,function(){m.remove(),a.isFunction(c)&&c()})}});function d(a,b){var c=b.outerWidth(),d=b.outerHeight(),e=/^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,f=e.exec(a)||["",0,c,d,0];return{top:parseFloat(f[1])||0,right:"auto"===f[2]?c:parseFloat(f[2]),bottom:"auto"===f[3]?d:parseFloat(f[3]),left:parseFloat(f[4])||0}}a.fx.step.clip=function(b){b.clipInit||(b.start=a(b.elem).cssClip(),"string"==typeof b.end&&(b.end=d(b.end,b.elem)),b.clipInit=!0),a(b.elem).cssClip({top:b.pos*(b.end.top-b.start.top)+b.start.top,right:b.pos*(b.end.right-b.start.right)+b.start.right,bottom:b.pos*(b.end.bottom-b.start.bottom)+b.start.bottom,left:b.pos*(b.end.left-b.start.left)+b.start.left})}}(),function(){var b={};a.each(["Quad","Cubic","Quart","Quint","Expo"],function(a,c){b[c]=function(b){return Math.pow(b,a+2)}}),a.extend(b,{Sine:function(a){return 1-Math.cos(a*Math.PI/2)},Circ:function(a){return 1-Math.sqrt(1-a*a)},Elastic:function(a){return 0===a||1===a?a:-Math.pow(2,8*(a-1))*Math.sin((80*(a-1)-7.5)*Math.PI/15)},Back:function(a){return a*a*(3*a-2)},Bounce:function(a){var b,c=4;while(a<((b=Math.pow(2,--c))-1)/11);return 1/Math.pow(4,3-c)-7.5625*Math.pow((3*b-2)/22-a,2)}}),a.each(b,function(b,c){a.easing["easeIn"+b]=c,a.easing["easeOut"+b]=function(a){return 1-c(1-a)},a.easing["easeInOut"+b]=function(a){return a<.5?c(2*a)/2:1-c(a*-2+2)/2}})}();var m=a.effects,n=a.effects.define("blind","hide",function(b,c){var d={up:["bottom","top"],vertical:["bottom","top"],down:["top","bottom"],left:["right","left"],horizontal:["right","left"],right:["left","right"]},e=a(this),f=b.direction||"up",g=e.cssClip(),h={clip:a.extend({},g)},i=a.effects.createPlaceholder(e);h.clip[d[f][0]]=h.clip[d[f][1]],"show"===b.mode&&(e.cssClip(h.clip),i&&i.css(a.effects.clipToBox(h)),h.clip=g),i&&i.animate(a.effects.clipToBox(h),b.duration,b.easing),e.animate(h,{queue:!1,duration:b.duration,easing:b.easing,complete:c})}),o=a.effects.define("bounce",function(b,c){var d,e,f,g=a(this),h=b.mode,i="hide"===h,j="show"===h,k=b.direction||"up",l=b.distance,m=b.times||5,n=2*m+(j||i?1:0),o=b.duration/n,p=b.easing,q="up"===k||"down"===k?"top":"left",r="up"===k||"left"===k,s=0,t=g.queue().length;for(a.effects.createPlaceholder(g),f=g.css(q),l||(l=g["top"===q?"outerHeight":"outerWidth"]()/3),j&&(e={opacity:1},e[q]=f,g.css("opacity",0).css(q,r?2*-l:2*l).animate(e,o,p)),i&&(l/=Math.pow(2,m-1)),e={},e[q]=f;s<m;s++)d={},d[q]=(r?"-=":"+=")+l,g.animate(d,o,p).animate(e,o,p),l=i?2*l:l/2;i&&(d={opacity:0},d[q]=(r?"-=":"+=")+l,g.animate(d,o,p)),g.queue(c),a.effects.unshift(g,t,n+1)}),p=a.effects.define("clip","hide",function(b,c){var d,e={},f=a(this),g=b.direction||"vertical",h="both"===g,i=h||"horizontal"===g,j=h||"vertical"===g;d=f.cssClip(),e.clip={top:j?(d.bottom-d.top)/2:d.top,right:i?(d.right-d.left)/2:d.right,bottom:j?(d.bottom-d.top)/2:d.bottom,left:i?(d.right-d.left)/2:d.left},a.effects.createPlaceholder(f),"show"===b.mode&&(f.cssClip(e.clip),e.clip=d),f.animate(e,{queue:!1,duration:b.duration,easing:b.easing,complete:c})}),q=a.effects.define("drop","hide",function(b,c){var d,e=a(this),f=b.mode,g="show"===f,h=b.direction||"left",i="up"===h||"down"===h?"top":"left",j="up"===h||"left"===h?"-=":"+=",k="+="===j?"-=":"+=",l={opacity:0};a.effects.createPlaceholder(e),d=b.distance||e["top"===i?"outerHeight":"outerWidth"](!0)/2,l[i]=j+d,g&&(e.css(l),l[i]=k+d,l.opacity=1),e.animate(l,{queue:!1,duration:b.duration,easing:b.easing,complete:c})}),r=a.effects.define("explode","hide",function(b,c){var d,e,f,g,h,i,j=b.pieces?Math.round(Math.sqrt(b.pieces)):3,k=j,l=a(this),m=b.mode,n="show"===m,o=l.show().css("visibility","hidden").offset(),p=Math.ceil(l.outerWidth()/k),q=Math.ceil(l.outerHeight()/j),r=[];function s(){r.push(this),r.length===j*k&&t()}for(d=0;d<j;d++)for(g=o.top+d*q,i=d-(j-1)/2,e=0;e<k;e++)f=o.left+e*p,h=e-(k-1)/2,l.clone().appendTo("body").wrap("<div></div>").css({position:"absolute",visibility:"visible",left:-e*p,top:-d*q}).parent().addClass("ui-effects-explode").css({position:"absolute",overflow:"hidden",width:p,height:q,left:f+(n?h*p:0),top:g+(n?i*q:0),opacity:n?0:1}).animate({left:f+(n?0:h*p),top:g+(n?0:i*q),opacity:n?1:0},b.duration||500,b.easing,s);function t(){l.css({visibility:"visible"}),a(r).remove(),c()}}),s=a.effects.define("fade","toggle",function(b,c){var d="show"===b.mode;a(this).css("opacity",d?0:1).animate({opacity:d?1:0},{queue:!1,duration:b.duration,easing:b.easing,complete:c})}),t=a.effects.define("fold","hide",function(b,c){var d=a(this),e=b.mode,f="show"===e,g="hide"===e,h=b.size||15,i=/([0-9]+)%/.exec(h),j=!!b.horizFirst,k=j?["right","bottom"]:["bottom","right"],l=b.duration/2,m=a.effects.createPlaceholder(d),n=d.cssClip(),o={clip:a.extend({},n)},p={clip:a.extend({},n)},q=[n[k[0]],n[k[1]]],r=d.queue().length;i&&(h=parseInt(i[1],10)/100*q[g?0:1]),o.clip[k[0]]=h,p.clip[k[0]]=h,p.clip[k[1]]=0,f&&(d.cssClip(p.clip),m&&m.css(a.effects.clipToBox(p)),p.clip=n),d.queue(function(c){m&&m.animate(a.effects.clipToBox(o),l,b.easing).animate(a.effects.clipToBox(p),l,b.easing),c()}).animate(o,l,b.easing).animate(p,l,b.easing).queue(c),a.effects.unshift(d,r,4)}),u=a.effects.define("highlight","show",function(b,c){var d=a(this),e={backgroundColor:d.css("backgroundColor")};"hide"===b.mode&&(e.opacity=0),a.effects.saveStyle(d),d.css({backgroundImage:"none",backgroundColor:b.color||"#ffff99"}).animate(e,{queue:!1,duration:b.duration,easing:b.easing,complete:c})}),v=a.effects.define("size",function(b,c){var d,e,f,g=a(this),h=["fontSize"],i=["borderTopWidth","borderBottomWidth","paddingTop","paddingBottom"],j=["borderLeftWidth","borderRightWidth","paddingLeft","paddingRight"],k=b.mode,l="effect"!==k,m=b.scale||"both",n=b.origin||["middle","center"],o=g.css("position"),p=g.position(),q=a.effects.scaledDimensions(g),r=b.from||q,s=b.to||a.effects.scaledDimensions(g,0);a.effects.createPlaceholder(g),"show"===k&&(f=r,r=s,s=f),e={from:{y:r.height/q.height,x:r.width/q.width},to:{y:s.height/q.height,x:s.width/q.width}},"box"!==m&&"both"!==m||(e.from.y!==e.to.y&&(r=a.effects.setTransition(g,i,e.from.y,r),s=a.effects.setTransition(g,i,e.to.y,s)),e.from.x!==e.to.x&&(r=a.effects.setTransition(g,j,e.from.x,r),s=a.effects.setTransition(g,j,e.to.x,s))),"content"!==m&&"both"!==m||e.from.y!==e.to.y&&(r=a.effects.setTransition(g,h,e.from.y,r),s=a.effects.setTransition(g,h,e.to.y,s)),n&&(d=a.effects.getBaseline(n,q),r.top=(q.outerHeight-r.outerHeight)*d.y+p.top,r.left=(q.outerWidth-r.outerWidth)*d.x+p.left,s.top=(q.outerHeight-s.outerHeight)*d.y+p.top,s.left=(q.outerWidth-s.outerWidth)*d.x+p.left),g.css(r),"content"!==m&&"both"!==m||(i=i.concat(["marginTop","marginBottom"]).concat(h),j=j.concat(["marginLeft","marginRight"]),g.find("*[width]").each(function(){var c=a(this),d=a.effects.scaledDimensions(c),f={height:d.height*e.from.y,width:d.width*e.from.x,outerHeight:d.outerHeight*e.from.y,outerWidth:d.outerWidth*e.from.x},g={height:d.height*e.to.y,width:d.width*e.to.x,outerHeight:d.height*e.to.y,outerWidth:d.width*e.to.x};e.from.y!==e.to.y&&(f=a.effects.setTransition(c,i,e.from.y,f),g=a.effects.setTransition(c,i,e.to.y,g)),e.from.x!==e.to.x&&(f=a.effects.setTransition(c,j,e.from.x,f),g=a.effects.setTransition(c,j,e.to.x,g)),l&&a.effects.saveStyle(c),c.css(f),c.animate(g,b.duration,b.easing,function(){l&&a.effects.restoreStyle(c)})})),g.animate(s,{queue:!1,duration:b.duration,easing:b.easing,complete:function(){var b=g.offset();0===s.opacity&&g.css("opacity",r.opacity),l||(g.css("position","static"===o?"relative":o).offset(b),a.effects.saveStyle(g)),c()}})}),w=a.effects.define("scale",function(b,c){var d=a(this),e=b.mode,f=parseInt(b.percent,10)||(0===parseInt(b.percent,10)?0:"effect"!==e?0:100),g=a.extend(!0,{from:a.effects.scaledDimensions(d),to:a.effects.scaledDimensions(d,f,b.direction||"both"),origin:b.origin||["middle","center"]},b);b.fade&&(g.from.opacity=1,g.to.opacity=0),a.effects.effect.size.call(this,g,c)}),x=a.effects.define("puff","hide",function(b,c){var d=a.extend(!0,{},b,{fade:!0,percent:parseInt(b.percent,10)||150});a.effects.effect.scale.call(this,d,c)}),y=a.effects.define("pulsate","show",function(b,c){var d=a(this),e=b.mode,f="show"===e,g="hide"===e,h=f||g,i=2*(b.times||5)+(h?1:0),j=b.duration/i,k=0,l=1,m=d.queue().length;for(!f&&d.is(":visible")||(d.css("opacity",0).show(),k=1);l<i;l++)d.animate({opacity:k},j,b.easing),k=1-k;d.animate({opacity:k},j,b.easing),d.queue(c),a.effects.unshift(d,m,i+1)}),z=a.effects.define("shake",function(b,c){var d=1,e=a(this),f=b.direction||"left",g=b.distance||20,h=b.times||3,i=2*h+1,j=Math.round(b.duration/i),k="up"===f||"down"===f?"top":"left",l="up"===f||"left"===f,m={},n={},o={},p=e.queue().length;for(a.effects.createPlaceholder(e),m[k]=(l?"-=":"+=")+g,n[k]=(l?"+=":"-=")+2*g,o[k]=(l?"-=":"+=")+2*g,e.animate(m,j,b.easing);d<h;d++)e.animate(n,j,b.easing).animate(o,j,b.easing);e.animate(n,j,b.easing).animate(m,j/2,b.easing).queue(c),a.effects.unshift(e,p,i+1)}),A=a.effects.define("slide","show",function(b,c){var d,e,f=a(this),g={up:["bottom","top"],down:["top","bottom"],left:["right","left"],right:["left","right"]},h=b.mode,i=b.direction||"left",j="up"===i||"down"===i?"top":"left",k="up"===i||"left"===i,l=b.distance||f["top"===j?"outerHeight":"outerWidth"](!0),m={};a.effects.createPlaceholder(f),d=f.cssClip(),e=f.position()[j],m[j]=(k?-1:1)*l+e,m.clip=f.cssClip(),m.clip[g[i][1]]=m.clip[g[i][0]],"show"===h&&(f.cssClip(m.clip),f.css(j,m[j]),m.clip=d,m[j]=e),f.animate(m,{queue:!1,duration:b.duration,easing:b.easing,complete:c})}),m;a.uiBackCompat!==!1&&(m=a.effects.define("transfer",function(b,c){a(this).transfer(b,c)}));var B=m;a.ui.focusable=function(b,c){var d,e,f,g,h,i=b.nodeName.toLowerCase();return"area"===i?(d=b.parentNode,e=d.name,!(!b.href||!e||"map"!==d.nodeName.toLowerCase())&&(f=a("img[usemap='#"+e+"']"),f.length>0&&f.is(":visible"))):(/^(input|select|textarea|button|object)$/.test(i)?(g=!b.disabled,g&&(h=a(b).closest("fieldset")[0],h&&(g=!h.disabled))):g="a"===i?b.href||c:c,g&&a(b).is(":visible")&&C(a(b)))};function C(a){var b=a.css("visibility");while("inherit"===b)a=a.parent(),b=a.css("visibility");return"hidden"!==b}a.extend(a.expr[":"],{focusable:function(b){return a.ui.focusable(b,null!=a.attr(b,"tabindex"))}});var D=a.ui.focusable,E=a.fn.form=function(){return"string"==typeof this[0].form?this.closest("form"):a(this[0].form)},F=a.ui.formResetMixin={_formResetHandler:function(){var b=a(this);setTimeout(function(){var c=b.data("ui-form-reset-instances");a.each(c,function(){this.refresh()})})},_bindFormResetHandler:function(){if(this.form=this.element.form(),this.form.length){var a=this.form.data("ui-form-reset-instances")||[];a.length||this.form.on("reset.ui-form-reset",this._formResetHandler),a.push(this),this.form.data("ui-form-reset-instances",a)}},_unbindFormResetHandler:function(){if(this.form.length){var b=this.form.data("ui-form-reset-instances");b.splice(a.inArray(this,b),1),b.length?this.form.data("ui-form-reset-instances",b):this.form.removeData("ui-form-reset-instances").off("reset.ui-form-reset")}}};"1.7"===a.fn.jquery.substring(0,3)&&(a.each(["Width","Height"],function(b,c){var d="Width"===c?["Left","Right"]:["Top","Bottom"],e=c.toLowerCase(),f={innerWidth:a.fn.innerWidth,innerHeight:a.fn.innerHeight,outerWidth:a.fn.outerWidth,outerHeight:a.fn.outerHeight};function g(b,c,e,f){return a.each(d,function(){c-=parseFloat(a.css(b,"padding"+this))||0,e&&(c-=parseFloat(a.css(b,"border"+this+"Width"))||0),f&&(c-=parseFloat(a.css(b,"margin"+this))||0)}),c}a.fn["inner"+c]=function(b){return void 0===b?f["inner"+c].call(this):this.each(function(){a(this).css(e,g(this,b)+"px")})},a.fn["outer"+c]=function(b,d){return"number"!=typeof b?f["outer"+c].call(this,b):this.each(function(){a(this).css(e,g(this,b,!0,d)+"px")})}}),a.fn.addBack=function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))});var G=a.ui.keyCode={BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38},H=a.ui.escapeSelector=function(){var a=/([!"#$%&'()*+,.\/:;<=>?@[\]^`{|}~])/g;return function(b){return b.replace(a,"\\$1")}}(),I=a.fn.labels=function(){var b,c,d,e,f;return this[0].labels&&this[0].labels.length?this.pushStack(this[0].labels):(e=this.eq(0).parents("label"),d=this.attr("id"),d&&(b=this.eq(0).parents().last(),f=b.add(b.length?b.siblings():this.siblings()),
c="label[for='"+a.ui.escapeSelector(d)+"']",e=e.add(f.find(c).addBack(c))),this.pushStack(e))},J=a.fn.scrollParent=function(b){var c=this.css("position"),d="absolute"===c,e=b?/(auto|scroll|hidden)/:/(auto|scroll)/,f=this.parents().filter(function(){var b=a(this);return(!d||"static"!==b.css("position"))&&e.test(b.css("overflow")+b.css("overflow-y")+b.css("overflow-x"))}).eq(0);return"fixed"!==c&&f.length?f:a(this[0].ownerDocument||document)},K=a.extend(a.expr[":"],{tabbable:function(b){var c=a.attr(b,"tabindex"),d=null!=c;return(!d||c>=0)&&a.ui.focusable(b,d)}}),L=a.fn.extend({uniqueId:function(){var a=0;return function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++a)})}}(),removeUniqueId:function(){return this.each(function(){/^ui-id-\d+$/.test(this.id)&&a(this).removeAttr("id")})}}),M=a.widget("ui.accordion",{version:"1.12.0",options:{active:0,animate:{},classes:{"ui-accordion-header":"ui-corner-top","ui-accordion-header-collapsed":"ui-corner-all","ui-accordion-content":"ui-corner-bottom"},collapsible:!1,event:"click",header:"> li > :first-child, > :not(li):even",heightStyle:"auto",icons:{activeHeader:"ui-icon-triangle-1-s",header:"ui-icon-triangle-1-e"},activate:null,beforeActivate:null},hideProps:{borderTopWidth:"hide",borderBottomWidth:"hide",paddingTop:"hide",paddingBottom:"hide",height:"hide"},showProps:{borderTopWidth:"show",borderBottomWidth:"show",paddingTop:"show",paddingBottom:"show",height:"show"},_create:function(){var b=this.options;this.prevShow=this.prevHide=a(),this._addClass("ui-accordion","ui-widget ui-helper-reset"),this.element.attr("role","tablist"),b.collapsible||b.active!==!1&&null!=b.active||(b.active=0),this._processPanels(),b.active<0&&(b.active+=this.headers.length),this._refresh()},_getCreateEventData:function(){return{header:this.active,panel:this.active.length?this.active.next():a()}},_createIcons:function(){var b,c,d=this.options.icons;d&&(b=a("<span>"),this._addClass(b,"ui-accordion-header-icon","ui-icon "+d.header),b.prependTo(this.headers),c=this.active.children(".ui-accordion-header-icon"),this._removeClass(c,d.header)._addClass(c,null,d.activeHeader)._addClass(this.headers,"ui-accordion-icons"))},_destroyIcons:function(){this._removeClass(this.headers,"ui-accordion-icons"),this.headers.children(".ui-accordion-header-icon").remove()},_destroy:function(){var a;this.element.removeAttr("role"),this.headers.removeAttr("role aria-expanded aria-selected aria-controls tabIndex").removeUniqueId(),this._destroyIcons(),a=this.headers.next().css("display","").removeAttr("role aria-hidden aria-labelledby").removeUniqueId(),"content"!==this.options.heightStyle&&a.css("height","")},_setOption:function(a,b){return"active"===a?void this._activate(b):("event"===a&&(this.options.event&&this._off(this.headers,this.options.event),this._setupEvents(b)),this._super(a,b),"collapsible"!==a||b||this.options.active!==!1||this._activate(0),void("icons"===a&&(this._destroyIcons(),b&&this._createIcons())))},_setOptionDisabled:function(a){this._super(a),this.element.attr("aria-disabled",a),this._toggleClass(null,"ui-state-disabled",!!a),this._toggleClass(this.headers.add(this.headers.next()),null,"ui-state-disabled",!!a)},_keydown:function(b){if(!b.altKey&&!b.ctrlKey){var c=a.ui.keyCode,d=this.headers.length,e=this.headers.index(b.target),f=!1;switch(b.keyCode){case c.RIGHT:case c.DOWN:f=this.headers[(e+1)%d];break;case c.LEFT:case c.UP:f=this.headers[(e-1+d)%d];break;case c.SPACE:case c.ENTER:this._eventHandler(b);break;case c.HOME:f=this.headers[0];break;case c.END:f=this.headers[d-1]}f&&(a(b.target).attr("tabIndex",-1),a(f).attr("tabIndex",0),a(f).trigger("focus"),b.preventDefault())}},_panelKeyDown:function(b){b.keyCode===a.ui.keyCode.UP&&b.ctrlKey&&a(b.currentTarget).prev().trigger("focus")},refresh:function(){var b=this.options;this._processPanels(),b.active===!1&&b.collapsible===!0||!this.headers.length?(b.active=!1,this.active=a()):b.active===!1?this._activate(0):this.active.length&&!a.contains(this.element[0],this.active[0])?this.headers.length===this.headers.find(".ui-state-disabled").length?(b.active=!1,this.active=a()):this._activate(Math.max(0,b.active-1)):b.active=this.headers.index(this.active),this._destroyIcons(),this._refresh()},_processPanels:function(){var a=this.headers,b=this.panels;this.headers=this.element.find(this.options.header),this._addClass(this.headers,"ui-accordion-header ui-accordion-header-collapsed","ui-state-default"),this.panels=this.headers.next().filter(":not(.ui-accordion-content-active)").hide(),this._addClass(this.panels,"ui-accordion-content","ui-helper-reset ui-widget-content"),b&&(this._off(a.not(this.headers)),this._off(b.not(this.panels)))},_refresh:function(){var b,c=this.options,d=c.heightStyle,e=this.element.parent();this.active=this._findActive(c.active),this._addClass(this.active,"ui-accordion-header-active","ui-state-active")._removeClass(this.active,"ui-accordion-header-collapsed"),this._addClass(this.active.next(),"ui-accordion-content-active"),this.active.next().show(),this.headers.attr("role","tab").each(function(){var b=a(this),c=b.uniqueId().attr("id"),d=b.next(),e=d.uniqueId().attr("id");b.attr("aria-controls",e),d.attr("aria-labelledby",c)}).next().attr("role","tabpanel"),this.headers.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1}).next().attr({"aria-hidden":"true"}).hide(),this.active.length?this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0}).next().attr({"aria-hidden":"false"}):this.headers.eq(0).attr("tabIndex",0),this._createIcons(),this._setupEvents(c.event),"fill"===d?(b=e.height(),this.element.siblings(":visible").each(function(){var c=a(this),d=c.css("position");"absolute"!==d&&"fixed"!==d&&(b-=c.outerHeight(!0))}),this.headers.each(function(){b-=a(this).outerHeight(!0)}),this.headers.next().each(function(){a(this).height(Math.max(0,b-a(this).innerHeight()+a(this).height()))}).css("overflow","auto")):"auto"===d&&(b=0,this.headers.next().each(function(){var c=a(this).is(":visible");c||a(this).show(),b=Math.max(b,a(this).css("height","").height()),c||a(this).hide()}).height(b))},_activate:function(b){var c=this._findActive(b)[0];c!==this.active[0]&&(c=c||this.active[0],this._eventHandler({target:c,currentTarget:c,preventDefault:a.noop}))},_findActive:function(b){return"number"==typeof b?this.headers.eq(b):a()},_setupEvents:function(b){var c={keydown:"_keydown"};b&&a.each(b.split(" "),function(a,b){c[b]="_eventHandler"}),this._off(this.headers.add(this.headers.next())),this._on(this.headers,c),this._on(this.headers.next(),{keydown:"_panelKeyDown"}),this._hoverable(this.headers),this._focusable(this.headers)},_eventHandler:function(b){var c,d,e=this.options,f=this.active,g=a(b.currentTarget),h=g[0]===f[0],i=h&&e.collapsible,j=i?a():g.next(),k=f.next(),l={oldHeader:f,oldPanel:k,newHeader:i?a():g,newPanel:j};b.preventDefault(),h&&!e.collapsible||this._trigger("beforeActivate",b,l)===!1||(e.active=!i&&this.headers.index(g),this.active=h?a():g,this._toggle(l),this._removeClass(f,"ui-accordion-header-active","ui-state-active"),e.icons&&(c=f.children(".ui-accordion-header-icon"),this._removeClass(c,null,e.icons.activeHeader)._addClass(c,null,e.icons.header)),h||(this._removeClass(g,"ui-accordion-header-collapsed")._addClass(g,"ui-accordion-header-active","ui-state-active"),e.icons&&(d=g.children(".ui-accordion-header-icon"),this._removeClass(d,null,e.icons.header)._addClass(d,null,e.icons.activeHeader)),this._addClass(g.next(),"ui-accordion-content-active")))},_toggle:function(b){var c=b.newPanel,d=this.prevShow.length?this.prevShow:b.oldPanel;this.prevShow.add(this.prevHide).stop(!0,!0),this.prevShow=c,this.prevHide=d,this.options.animate?this._animate(c,d,b):(d.hide(),c.show(),this._toggleComplete(b)),d.attr({"aria-hidden":"true"}),d.prev().attr({"aria-selected":"false","aria-expanded":"false"}),c.length&&d.length?d.prev().attr({tabIndex:-1,"aria-expanded":"false"}):c.length&&this.headers.filter(function(){return 0===parseInt(a(this).attr("tabIndex"),10)}).attr("tabIndex",-1),c.attr("aria-hidden","false").prev().attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0})},_animate:function(a,b,c){var d,e,f,g=this,h=0,i=a.css("box-sizing"),j=a.length&&(!b.length||a.index()<b.index()),k=this.options.animate||{},l=j&&k.down||k,m=function(){g._toggleComplete(c)};return"number"==typeof l&&(f=l),"string"==typeof l&&(e=l),e=e||l.easing||k.easing,f=f||l.duration||k.duration,b.length?a.length?(d=a.show().outerHeight(),b.animate(this.hideProps,{duration:f,easing:e,step:function(a,b){b.now=Math.round(a)}}),void a.hide().animate(this.showProps,{duration:f,easing:e,complete:m,step:function(a,c){c.now=Math.round(a),"height"!==c.prop?"content-box"===i&&(h+=c.now):"content"!==g.options.heightStyle&&(c.now=Math.round(d-b.outerHeight()-h),h=0)}})):b.animate(this.hideProps,f,e,m):a.animate(this.showProps,f,e,m)},_toggleComplete:function(a){var b=a.oldPanel,c=b.prev();this._removeClass(b,"ui-accordion-content-active"),this._removeClass(c,"ui-accordion-header-active")._addClass(c,"ui-accordion-header-collapsed"),b.length&&(b.parent()[0].className=b.parent()[0].className),this._trigger("activate",null,a)}}),N=a.ui.safeActiveElement=function(a){var b;try{b=a.activeElement}catch(c){b=a.body}return b||(b=a.body),b.nodeName||(b=a.body),b},O=a.widget("ui.menu",{version:"1.12.0",defaultElement:"<ul>",delay:300,options:{icons:{submenu:"ui-icon-caret-1-e"},items:"> *",menus:"ul",position:{my:"left top",at:"right top"},role:"menu",blur:null,focus:null,select:null},_create:function(){this.activeMenu=this.element,this.mouseHandled=!1,this.element.uniqueId().attr({role:this.options.role,tabIndex:0}),this._addClass("ui-menu","ui-widget ui-widget-content"),this._on({"mousedown .ui-menu-item":function(a){a.preventDefault()},"click .ui-menu-item":function(b){var c=a(b.target),d=a(a.ui.safeActiveElement(this.document[0]));!this.mouseHandled&&c.not(".ui-state-disabled").length&&(this.select(b),b.isPropagationStopped()||(this.mouseHandled=!0),c.has(".ui-menu").length?this.expand(b):!this.element.is(":focus")&&d.closest(".ui-menu").length&&(this.element.trigger("focus",[!0]),this.active&&1===this.active.parents(".ui-menu").length&&clearTimeout(this.timer)))},"mouseenter .ui-menu-item":function(b){if(!this.previousFilter){var c=a(b.target).closest(".ui-menu-item"),d=a(b.currentTarget);c[0]===d[0]&&(this._removeClass(d.siblings().children(".ui-state-active"),null,"ui-state-active"),this.focus(b,d))}},mouseleave:"collapseAll","mouseleave .ui-menu":"collapseAll",focus:function(a,b){var c=this.active||this.element.find(this.options.items).eq(0);b||this.focus(a,c)},blur:function(b){this._delay(function(){var c=!a.contains(this.element[0],a.ui.safeActiveElement(this.document[0]));c&&this.collapseAll(b)})},keydown:"_keydown"}),this.refresh(),this._on(this.document,{click:function(a){this._closeOnDocumentClick(a)&&this.collapseAll(a),this.mouseHandled=!1}})},_destroy:function(){var b=this.element.find(".ui-menu-item").removeAttr("role aria-disabled"),c=b.children(".ui-menu-item-wrapper").removeUniqueId().removeAttr("tabIndex role aria-haspopup");this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeAttr("role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex").removeUniqueId().show(),c.children().each(function(){var b=a(this);b.data("ui-menu-submenu-caret")&&b.remove()})},_keydown:function(b){var c,d,e,f,g=!0;switch(b.keyCode){case a.ui.keyCode.PAGE_UP:this.previousPage(b);break;case a.ui.keyCode.PAGE_DOWN:this.nextPage(b);break;case a.ui.keyCode.HOME:this._move("first","first",b);break;case a.ui.keyCode.END:this._move("last","last",b);break;case a.ui.keyCode.UP:this.previous(b);break;case a.ui.keyCode.DOWN:this.next(b);break;case a.ui.keyCode.LEFT:this.collapse(b);break;case a.ui.keyCode.RIGHT:this.active&&!this.active.is(".ui-state-disabled")&&this.expand(b);break;case a.ui.keyCode.ENTER:case a.ui.keyCode.SPACE:this._activate(b);break;case a.ui.keyCode.ESCAPE:this.collapse(b);break;default:g=!1,d=this.previousFilter||"",e=String.fromCharCode(b.keyCode),f=!1,clearTimeout(this.filterTimer),e===d?f=!0:e=d+e,c=this._filterMenuItems(e),c=f&&c.index(this.active.next())!==-1?this.active.nextAll(".ui-menu-item"):c,c.length||(e=String.fromCharCode(b.keyCode),c=this._filterMenuItems(e)),c.length?(this.focus(b,c),this.previousFilter=e,this.filterTimer=this._delay(function(){delete this.previousFilter},1e3)):delete this.previousFilter}g&&b.preventDefault()},_activate:function(a){this.active&&!this.active.is(".ui-state-disabled")&&(this.active.children("[aria-haspopup='true']").length?this.expand(a):this.select(a))},refresh:function(){var b,c,d,e,f,g=this,h=this.options.icons.submenu,i=this.element.find(this.options.menus);this._toggleClass("ui-menu-icons",null,!!this.element.find(".ui-icon").length),d=i.filter(":not(.ui-menu)").hide().attr({role:this.options.role,"aria-hidden":"true","aria-expanded":"false"}).each(function(){var b=a(this),c=b.prev(),d=a("<span>").data("ui-menu-submenu-caret",!0);g._addClass(d,"ui-menu-icon","ui-icon "+h),c.attr("aria-haspopup","true").prepend(d),b.attr("aria-labelledby",c.attr("id"))}),this._addClass(d,"ui-menu","ui-widget ui-widget-content ui-front"),b=i.add(this.element),c=b.find(this.options.items),c.not(".ui-menu-item").each(function(){var b=a(this);g._isDivider(b)&&g._addClass(b,"ui-menu-divider","ui-widget-content")}),e=c.not(".ui-menu-item, .ui-menu-divider"),f=e.children().not(".ui-menu").uniqueId().attr({tabIndex:-1,role:this._itemRole()}),this._addClass(e,"ui-menu-item")._addClass(f,"ui-menu-item-wrapper"),c.filter(".ui-state-disabled").attr("aria-disabled","true"),this.active&&!a.contains(this.element[0],this.active[0])&&this.blur()},_itemRole:function(){return{menu:"menuitem",listbox:"option"}[this.options.role]},_setOption:function(a,b){if("icons"===a){var c=this.element.find(".ui-menu-icon");this._removeClass(c,null,this.options.icons.submenu)._addClass(c,null,b.submenu)}this._super(a,b)},_setOptionDisabled:function(a){this._super(a),this.element.attr("aria-disabled",String(a)),this._toggleClass(null,"ui-state-disabled",!!a)},focus:function(a,b){var c,d,e;this.blur(a,a&&"focus"===a.type),this._scrollIntoView(b),this.active=b.first(),d=this.active.children(".ui-menu-item-wrapper"),this._addClass(d,null,"ui-state-active"),this.options.role&&this.element.attr("aria-activedescendant",d.attr("id")),e=this.active.parent().closest(".ui-menu-item").children(".ui-menu-item-wrapper"),this._addClass(e,null,"ui-state-active"),a&&"keydown"===a.type?this._close():this.timer=this._delay(function(){this._close()},this.delay),c=b.children(".ui-menu"),c.length&&a&&/^mouse/.test(a.type)&&this._startOpening(c),this.activeMenu=b.parent(),this._trigger("focus",a,{item:b})},_scrollIntoView:function(b){var c,d,e,f,g,h;this._hasScroll()&&(c=parseFloat(a.css(this.activeMenu[0],"borderTopWidth"))||0,d=parseFloat(a.css(this.activeMenu[0],"paddingTop"))||0,e=b.offset().top-this.activeMenu.offset().top-c-d,f=this.activeMenu.scrollTop(),g=this.activeMenu.height(),h=b.outerHeight(),e<0?this.activeMenu.scrollTop(f+e):e+h>g&&this.activeMenu.scrollTop(f+e-g+h))},blur:function(a,b){b||clearTimeout(this.timer),this.active&&(this._removeClass(this.active.children(".ui-menu-item-wrapper"),null,"ui-state-active"),this._trigger("blur",a,{item:this.active}),this.active=null)},_startOpening:function(a){clearTimeout(this.timer),"true"===a.attr("aria-hidden")&&(this.timer=this._delay(function(){this._close(),this._open(a)},this.delay))},_open:function(b){var c=a.extend({of:this.active},this.options.position);clearTimeout(this.timer),this.element.find(".ui-menu").not(b.parents(".ui-menu")).hide().attr("aria-hidden","true"),b.show().removeAttr("aria-hidden").attr("aria-expanded","true").position(c)},collapseAll:function(b,c){clearTimeout(this.timer),this.timer=this._delay(function(){var d=c?this.element:a(b&&b.target).closest(this.element.find(".ui-menu"));d.length||(d=this.element),this._close(d),this.blur(b),this._removeClass(d.find(".ui-state-active"),null,"ui-state-active"),this.activeMenu=d},this.delay)},_close:function(a){a||(a=this.active?this.active.parent():this.element),a.find(".ui-menu").hide().attr("aria-hidden","true").attr("aria-expanded","false")},_closeOnDocumentClick:function(b){return!a(b.target).closest(".ui-menu").length},_isDivider:function(a){return!/[^\-\u2014\u2013\s]/.test(a.text())},collapse:function(a){var b=this.active&&this.active.parent().closest(".ui-menu-item",this.element);b&&b.length&&(this._close(),this.focus(a,b))},expand:function(a){var b=this.active&&this.active.children(".ui-menu ").find(this.options.items).first();b&&b.length&&(this._open(b.parent()),this._delay(function(){this.focus(a,b)}))},next:function(a){this._move("next","first",a)},previous:function(a){this._move("prev","last",a)},isFirstItem:function(){return this.active&&!this.active.prevAll(".ui-menu-item").length},isLastItem:function(){return this.active&&!this.active.nextAll(".ui-menu-item").length},_move:function(a,b,c){var d;this.active&&(d="first"===a||"last"===a?this.active["first"===a?"prevAll":"nextAll"](".ui-menu-item").eq(-1):this.active[a+"All"](".ui-menu-item").eq(0)),d&&d.length&&this.active||(d=this.activeMenu.find(this.options.items)[b]()),this.focus(c,d)},nextPage:function(b){var c,d,e;return this.active?void(this.isLastItem()||(this._hasScroll()?(d=this.active.offset().top,e=this.element.height(),this.active.nextAll(".ui-menu-item").each(function(){return c=a(this),c.offset().top-d-e<0}),this.focus(b,c)):this.focus(b,this.activeMenu.find(this.options.items)[this.active?"last":"first"]()))):void this.next(b)},previousPage:function(b){var c,d,e;return this.active?void(this.isFirstItem()||(this._hasScroll()?(d=this.active.offset().top,e=this.element.height(),this.active.prevAll(".ui-menu-item").each(function(){return c=a(this),c.offset().top-d+e>0}),this.focus(b,c)):this.focus(b,this.activeMenu.find(this.options.items).first()))):void this.next(b)},_hasScroll:function(){return this.element.outerHeight()<this.element.prop("scrollHeight")},select:function(b){this.active=this.active||a(b.target).closest(".ui-menu-item");var c={item:this.active};this.active.has(".ui-menu").length||this.collapseAll(b,!0),this._trigger("select",b,c)},_filterMenuItems:function(b){var c=b.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&"),d=new RegExp("^"+c,"i");return this.activeMenu.find(this.options.items).filter(".ui-menu-item").filter(function(){return d.test(a.trim(a(this).children(".ui-menu-item-wrapper").text()))})}});a.widget("ui.autocomplete",{version:"1.12.0",defaultElement:"<input>",options:{appendTo:null,autoFocus:!1,delay:300,minLength:1,position:{my:"left top",at:"left bottom",collision:"none"},source:null,change:null,close:null,focus:null,open:null,response:null,search:null,select:null},requestIndex:0,pending:0,_create:function(){var b,c,d,e=this.element[0].nodeName.toLowerCase(),f="textarea"===e,g="input"===e;this.isMultiLine=f||!g&&this._isContentEditable(this.element),this.valueMethod=this.element[f||g?"val":"text"],this.isNewMenu=!0,this._addClass("ui-autocomplete-input"),this.element.attr("autocomplete","off"),this._on(this.element,{keydown:function(e){if(this.element.prop("readOnly"))return b=!0,d=!0,void(c=!0);b=!1,d=!1,c=!1;var f=a.ui.keyCode;switch(e.keyCode){case f.PAGE_UP:b=!0,this._move("previousPage",e);break;case f.PAGE_DOWN:b=!0,this._move("nextPage",e);break;case f.UP:b=!0,this._keyEvent("previous",e);break;case f.DOWN:b=!0,this._keyEvent("next",e);break;case f.ENTER:this.menu.active&&(b=!0,e.preventDefault(),this.menu.select(e));break;case f.TAB:this.menu.active&&this.menu.select(e);break;case f.ESCAPE:this.menu.element.is(":visible")&&(this.isMultiLine||this._value(this.term),this.close(e),e.preventDefault());break;default:c=!0,this._searchTimeout(e)}},keypress:function(d){if(b)return b=!1,void(this.isMultiLine&&!this.menu.element.is(":visible")||d.preventDefault());if(!c){var e=a.ui.keyCode;switch(d.keyCode){case e.PAGE_UP:this._move("previousPage",d);break;case e.PAGE_DOWN:this._move("nextPage",d);break;case e.UP:this._keyEvent("previous",d);break;case e.DOWN:this._keyEvent("next",d)}}},input:function(a){return d?(d=!1,void a.preventDefault()):void this._searchTimeout(a)},focus:function(){this.selectedItem=null,this.previous=this._value()},blur:function(a){return this.cancelBlur?void delete this.cancelBlur:(clearTimeout(this.searching),this.close(a),void this._change(a))}}),this._initSource(),this.menu=a("<ul>").appendTo(this._appendTo()).menu({role:null}).hide().menu("instance"),this._addClass(this.menu.element,"ui-autocomplete","ui-front"),this._on(this.menu.element,{mousedown:function(b){b.preventDefault(),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur,this.element[0]!==a.ui.safeActiveElement(this.document[0])&&this.element.trigger("focus")})},menufocus:function(b,c){var d,e;return this.isNewMenu&&(this.isNewMenu=!1,b.originalEvent&&/^mouse/.test(b.originalEvent.type))?(this.menu.blur(),void this.document.one("mousemove",function(){a(b.target).trigger(b.originalEvent)})):(e=c.item.data("ui-autocomplete-item"),!1!==this._trigger("focus",b,{item:e})&&b.originalEvent&&/^key/.test(b.originalEvent.type)&&this._value(e.value),d=c.item.attr("aria-label")||e.value,void(d&&a.trim(d).length&&(this.liveRegion.children().hide(),a("<div>").text(d).appendTo(this.liveRegion))))},menuselect:function(b,c){var d=c.item.data("ui-autocomplete-item"),e=this.previous;this.element[0]!==a.ui.safeActiveElement(this.document[0])&&(this.element.trigger("focus"),this.previous=e,this._delay(function(){this.previous=e,this.selectedItem=d})),!1!==this._trigger("select",b,{item:d})&&this._value(d.value),this.term=this._value(),this.close(b),this.selectedItem=d}}),this.liveRegion=a("<div>",{role:"status","aria-live":"assertive","aria-relevant":"additions"}).appendTo(this.document[0].body),this._addClass(this.liveRegion,null,"ui-helper-hidden-accessible"),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_destroy:function(){clearTimeout(this.searching),this.element.removeAttr("autocomplete"),this.menu.element.remove(),this.liveRegion.remove()},_setOption:function(a,b){this._super(a,b),"source"===a&&this._initSource(),"appendTo"===a&&this.menu.element.appendTo(this._appendTo()),"disabled"===a&&b&&this.xhr&&this.xhr.abort()},_isEventTargetInWidget:function(b){var c=this.menu.element[0];return b.target===this.element[0]||b.target===c||a.contains(c,b.target)},_closeOnClickOutside:function(a){this._isEventTargetInWidget(a)||this.close()},_appendTo:function(){var b=this.options.appendTo;return b&&(b=b.jquery||b.nodeType?a(b):this.document.find(b).eq(0)),b&&b[0]||(b=this.element.closest(".ui-front, dialog")),b.length||(b=this.document[0].body),b},_initSource:function(){var b,c,d=this;a.isArray(this.options.source)?(b=this.options.source,this.source=function(c,d){d(a.ui.autocomplete.filter(b,c.term))}):"string"==typeof this.options.source?(c=this.options.source,this.source=function(b,e){d.xhr&&d.xhr.abort(),d.xhr=a.ajax({url:c,data:b,dataType:"json",success:function(a){e(a)},error:function(){e([])}})}):this.source=this.options.source},_searchTimeout:function(a){clearTimeout(this.searching),this.searching=this._delay(function(){var b=this.term===this._value(),c=this.menu.element.is(":visible"),d=a.altKey||a.ctrlKey||a.metaKey||a.shiftKey;b&&(!b||c||d)||(this.selectedItem=null,this.search(null,a))},this.options.delay)},search:function(a,b){return a=null!=a?a:this._value(),this.term=this._value(),a.length<this.options.minLength?this.close(b):this._trigger("search",b)!==!1?this._search(a):void 0},_search:function(a){this.pending++,this._addClass("ui-autocomplete-loading"),this.cancelSearch=!1,this.source({term:a},this._response())},_response:function(){var b=++this.requestIndex;return a.proxy(function(a){b===this.requestIndex&&this.__response(a),this.pending--,this.pending||this._removeClass("ui-autocomplete-loading")},this)},__response:function(a){a&&(a=this._normalize(a)),this._trigger("response",null,{content:a}),!this.options.disabled&&a&&a.length&&!this.cancelSearch?(this._suggest(a),this._trigger("open")):this._close()},close:function(a){this.cancelSearch=!0,this._close(a)},_close:function(a){this._off(this.document,"mousedown"),this.menu.element.is(":visible")&&(this.menu.element.hide(),this.menu.blur(),this.isNewMenu=!0,this._trigger("close",a))},_change:function(a){this.previous!==this._value()&&this._trigger("change",a,{item:this.selectedItem})},_normalize:function(b){return b.length&&b[0].label&&b[0].value?b:a.map(b,function(b){return"string"==typeof b?{label:b,value:b}:a.extend({},b,{label:b.label||b.value,value:b.value||b.label})})},_suggest:function(b){var c=this.menu.element.empty();this._renderMenu(c,b),this.isNewMenu=!0,this.menu.refresh(),c.show(),this._resizeMenu(),c.position(a.extend({of:this.element},this.options.position)),this.options.autoFocus&&this.menu.next(),this._on(this.document,{mousedown:"_closeOnClickOutside"})},_resizeMenu:function(){var a=this.menu.element;a.outerWidth(Math.max(a.width("").outerWidth()+1,this.element.outerWidth()))},_renderMenu:function(b,c){var d=this;a.each(c,function(a,c){d._renderItemData(b,c)})},_renderItemData:function(a,b){return this._renderItem(a,b).data("ui-autocomplete-item",b)},_renderItem:function(b,c){return a("<li>").append(a("<div>").text(c.label)).appendTo(b)},_move:function(a,b){return this.menu.element.is(":visible")?this.menu.isFirstItem()&&/^previous/.test(a)||this.menu.isLastItem()&&/^next/.test(a)?(this.isMultiLine||this._value(this.term),void this.menu.blur()):void this.menu[a](b):void this.search(null,b)},widget:function(){return this.menu.element},_value:function(){return this.valueMethod.apply(this.element,arguments)},_keyEvent:function(a,b){this.isMultiLine&&!this.menu.element.is(":visible")||(this._move(a,b),b.preventDefault())},_isContentEditable:function(a){if(!a.length)return!1;var b=a.prop("contentEditable");return"inherit"===b?this._isContentEditable(a.parent()):"true"===b}}),a.extend(a.ui.autocomplete,{escapeRegex:function(a){return a.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")},filter:function(b,c){var d=new RegExp(a.ui.autocomplete.escapeRegex(c),"i");return a.grep(b,function(a){return d.test(a.label||a.value||a)})}}),a.widget("ui.autocomplete",a.ui.autocomplete,{options:{messages:{noResults:"No search results.",results:function(a){return a+(a>1?" results are":" result is")+" available, use up and down arrow keys to navigate."}}},__response:function(b){var c;this._superApply(arguments),this.options.disabled||this.cancelSearch||(c=b&&b.length?this.options.messages.results(b.length):this.options.messages.noResults,this.liveRegion.children().hide(),a("<div>").text(c).appendTo(this.liveRegion))}});var P=a.ui.autocomplete,Q=/ui-corner-([a-z]){2,6}/g,R=a.widget("ui.controlgroup",{version:"1.12.0",defaultElement:"<div>",options:{direction:"horizontal",disabled:null,onlyVisible:!0,items:{button:"input[type=button], input[type=submit], input[type=reset], button, a",controlgroupLabel:".ui-controlgroup-label",checkboxradio:"input[type='checkbox'], input[type='radio']",selectmenu:"select",spinner:".ui-spinner-input"}},_create:function(){this._enhance()},_enhance:function(){this.element.attr("role","toolbar"),this.refresh()},_destroy:function(){this._callChildMethod("destroy"),this.childWidgets.removeData("ui-controlgroup-data"),this.element.removeAttr("role"),this.options.items.controlgroupLabel&&this.element.find(this.options.items.controlgroupLabel).find(".ui-controlgroup-label-contents").contents().unwrap()},_initWidgets:function(){var b=this,c=[];a.each(this.options.items,function(d,e){var f,g={};if(e)return"controlgroupLabel"===d?(f=b.element.find(e),f.each(function(){var b=a(this);b.children(".ui-controlgroup-label-contents").length||b.contents().wrapAll("<span class='ui-controlgroup-label-contents'></span>")}),b._addClass(f,null,"ui-widget ui-widget-content ui-state-default"),void(c=c.concat(f.get()))):void(a.fn[d]&&(b["_"+d+"Options"]&&(g=b["_"+d+"Options"]("middle")),b.element.find(e).each(function(){var e=a(this),f=e[d]("instance"),h=a.widget.extend({},g);if("button"!==d||!e.parent(".ui-spinner").length){f||(f=e[d]()[d]("instance")),f&&(h.classes=b._resolveClassesValues(h.classes,f)),e[d](h);var i=e[d]("widget");a.data(i[0],"ui-controlgroup-data",f?f:e[d]("instance")),c.push(i[0])}})))}),this.childWidgets=a(a.unique(c)),this._addClass(this.childWidgets,"ui-controlgroup-item")},_callChildMethod:function(b){this.childWidgets.each(function(){var c=a(this),d=c.data("ui-controlgroup-data");d&&d[b]&&d[b]()})},_updateCornerClass:function(a,b){var c="ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all",d=this._buildSimpleOptions(b,"label").classes.label;this._removeClass(a,null,c),this._addClass(a,null,d)},_buildSimpleOptions:function(a,b){var c="vertical"===this.options.direction,d={classes:{}};return d.classes[b]={middle:"",first:"ui-corner-"+(c?"top":"left"),last:"ui-corner-"+(c?"bottom":"right"),only:"ui-corner-all"}[a],d},_spinnerOptions:function(a){var b=this._buildSimpleOptions(a,"ui-spinner");return b.classes["ui-spinner-up"]="",b.classes["ui-spinner-down"]="",b},_buttonOptions:function(a){return this._buildSimpleOptions(a,"ui-button")},_checkboxradioOptions:function(a){return this._buildSimpleOptions(a,"ui-checkboxradio-label")},_selectmenuOptions:function(a){var b="vertical"===this.options.direction;return{width:!!b&&"auto",classes:{middle:{"ui-selectmenu-button-open":"","ui-selectmenu-button-closed":""},first:{"ui-selectmenu-button-open":"ui-corner-"+(b?"top":"tl"),"ui-selectmenu-button-closed":"ui-corner-"+(b?"top":"left")},last:{"ui-selectmenu-button-open":b?"":"ui-corner-tr","ui-selectmenu-button-closed":"ui-corner-"+(b?"bottom":"right")},only:{"ui-selectmenu-button-open":"ui-corner-top","ui-selectmenu-button-closed":"ui-corner-all"}}[a]}},_resolveClassesValues:function(b,c){var d={};return a.each(b,function(a){var e=c.options.classes[a]||"";e=e.replace(Q,"").trim(),d[a]=(e+" "+b[a]).replace(/\s+/g," ")}),d},_setOption:function(a,b){return"direction"===a&&this._removeClass("ui-controlgroup-"+this.options.direction),this._super(a,b),"disabled"===a?void this._callChildMethod(b?"disable":"enable"):void this.refresh()},refresh:function(){var b,c=this;this._addClass("ui-controlgroup ui-controlgroup-"+this.options.direction),"horizontal"===this.options.direction&&this._addClass(null,"ui-helper-clearfix"),this._initWidgets(),b=this.childWidgets,this.options.onlyVisible&&(b=b.filter(":visible")),b.length&&(a.each(["first","last"],function(a,d){var e=b[d]().data("ui-controlgroup-data");if(e&&c["_"+e.widgetName+"Options"]){var f=c["_"+e.widgetName+"Options"](1===b.length?"only":d);f.classes=c._resolveClassesValues(f.classes,e),e.element[e.widgetName](f)}else c._updateCornerClass(b[d](),d)}),this._callChildMethod("refresh"))}});a.widget("ui.checkboxradio",[a.ui.formResetMixin,{version:"1.12.0",options:{disabled:null,label:null,icon:!0,classes:{"ui-checkboxradio-label":"ui-corner-all","ui-checkboxradio-icon":"ui-corner-all"}},_getCreateOptions:function(){var b,c,d=this,e=this._super()||{};return this._readType(),c=this.element.labels(),this.label=a(c[c.length-1]),this.label.length||a.error("No label found for checkboxradio widget"),this.originalLabel="",this.label.contents().not(this.element).each(function(){d.originalLabel+=3===this.nodeType?a(this).text():this.outerHTML}),this.originalLabel&&(e.label=this.originalLabel),b=this.element[0].disabled,null!=b&&(e.disabled=b),e},_create:function(){var a=this.element[0].checked;this._bindFormResetHandler(),null==this.options.disabled&&(this.options.disabled=this.element[0].disabled),this._setOption("disabled",this.options.disabled),this._addClass("ui-checkboxradio","ui-helper-hidden-accessible"),this._addClass(this.label,"ui-checkboxradio-label","ui-button ui-widget"),
"radio"===this.type&&this._addClass(this.label,"ui-checkboxradio-radio-label"),this.options.label&&this.options.label!==this.originalLabel?this._updateLabel():this.originalLabel&&(this.options.label=this.originalLabel),this._enhance(),a&&(this._addClass(this.label,"ui-checkboxradio-checked","ui-state-active"),this.icon&&this._addClass(this.icon,null,"ui-state-hover")),this._on({change:"_toggleClasses",focus:function(){this._addClass(this.label,null,"ui-state-focus ui-visual-focus")},blur:function(){this._removeClass(this.label,null,"ui-state-focus ui-visual-focus")}})},_readType:function(){var b=this.element[0].nodeName.toLowerCase();this.type=this.element[0].type,"input"===b&&/radio|checkbox/.test(this.type)||a.error("Can't create checkboxradio on element.nodeName="+b+" and element.type="+this.type)},_enhance:function(){this._updateIcon(this.element[0].checked)},widget:function(){return this.label},_getRadioGroup:function(){var b,c=this.element[0].name,d="input[name='"+a.ui.escapeSelector(c)+"']";return c?(b=this.form.length?a(this.form[0].elements).filter(d):a(d).filter(function(){return 0===a(this).form().length}),b.not(this.element)):a([])},_toggleClasses:function(){var b=this.element[0].checked;this._toggleClass(this.label,"ui-checkboxradio-checked","ui-state-active",b),this.options.icon&&"checkbox"===this.type&&this._toggleClass(this.icon,null,"ui-icon-check ui-state-checked",b)._toggleClass(this.icon,null,"ui-icon-blank",!b),"radio"===this.type&&this._getRadioGroup().each(function(){var b=a(this).checkboxradio("instance");b&&b._removeClass(b.label,"ui-checkboxradio-checked","ui-state-active")})},_destroy:function(){this._unbindFormResetHandler(),this.icon&&(this.icon.remove(),this.iconSpace.remove())},_setOption:function(a,b){if("label"!==a||b)return this._super(a,b),"disabled"===a?(this._toggleClass(this.label,null,"ui-state-disabled",b),void(this.element[0].disabled=b)):void this.refresh()},_updateIcon:function(b){var c="ui-icon ui-icon-background ";this.options.icon?(this.icon||(this.icon=a("<span>"),this.iconSpace=a("<span> </span>"),this._addClass(this.iconSpace,"ui-checkboxradio-icon-space")),"checkbox"===this.type?(c+=b?"ui-icon-check ui-state-checked":"ui-icon-blank",this._removeClass(this.icon,null,b?"ui-icon-blank":"ui-icon-check")):c+="ui-icon-blank",this._addClass(this.icon,"ui-checkboxradio-icon",c),b||this._removeClass(this.icon,null,"ui-icon-check ui-state-checked"),this.icon.prependTo(this.label).after(this.iconSpace)):void 0!==this.icon&&(this.icon.remove(),this.iconSpace.remove(),delete this.icon)},_updateLabel:function(){this.label.contents().not(this.element.add(this.icon).add(this.iconSpace)).remove(),this.label.append(this.options.label)},refresh:function(){var a=this.element[0].checked,b=this.element[0].disabled;this._updateIcon(a),this._toggleClass(this.label,"ui-checkboxradio-checked","ui-state-active",a),null!==this.options.label&&this._updateLabel(),b!==this.options.disabled&&this._setOptions({disabled:b})}}]);var S=a.ui.checkboxradio;a.widget("ui.button",{version:"1.12.0",defaultElement:"<button>",options:{classes:{"ui-button":"ui-corner-all"},disabled:null,icon:null,iconPosition:"beginning",label:null,showLabel:!0},_getCreateOptions:function(){var a,b=this._super()||{};return this.isInput=this.element.is("input"),a=this.element[0].disabled,null!=a&&(b.disabled=a),this.originalLabel=this.isInput?this.element.val():this.element.html(),this.originalLabel&&(b.label=this.originalLabel),b},_create:function(){!this.option.showLabel&!this.options.icon&&(this.options.showLabel=!0),null==this.options.disabled&&(this.options.disabled=this.element[0].disabled||!1),this.hasTitle=!!this.element.attr("title"),this.options.label&&this.options.label!==this.originalLabel&&(this.isInput?this.element.val(this.options.label):this.element.html(this.options.label)),this._addClass("ui-button","ui-widget"),this._setOption("disabled",this.options.disabled),this._enhance(),this.element.is("a")&&this._on({keyup:function(b){b.keyCode===a.ui.keyCode.SPACE&&(b.preventDefault(),this.element[0].click?this.element[0].click():this.element.trigger("click"))}})},_enhance:function(){this.element.is("button")||this.element.attr("role","button"),this.options.icon&&(this._updateIcon("icon",this.options.icon),this._updateTooltip())},_updateTooltip:function(){this.title=this.element.attr("title"),this.options.showLabel||this.title||this.element.attr("title",this.options.label)},_updateIcon:function(b,c){var d="iconPosition"!==b,e=d?this.options.iconPosition:c,f="top"===e||"bottom"===e;this.icon?d&&this._removeClass(this.icon,null,this.options.icon):(this.icon=a("<span>"),this._addClass(this.icon,"ui-button-icon","ui-icon"),this.options.showLabel||this._addClass("ui-button-icon-only")),d&&this._addClass(this.icon,null,c),this._attachIcon(e),f?(this._addClass(this.icon,null,"ui-widget-icon-block"),this.iconSpace&&this.iconSpace.remove()):(this.iconSpace||(this.iconSpace=a("<span> </span>"),this._addClass(this.iconSpace,"ui-button-icon-space")),this._removeClass(this.icon,null,"ui-wiget-icon-block"),this._attachIconSpace(e))},_destroy:function(){this.element.removeAttr("role"),this.icon&&this.icon.remove(),this.iconSpace&&this.iconSpace.remove(),this.hasTitle||this.element.removeAttr("title")},_attachIconSpace:function(a){this.icon[/^(?:end|bottom)/.test(a)?"before":"after"](this.iconSpace)},_attachIcon:function(a){this.element[/^(?:end|bottom)/.test(a)?"append":"prepend"](this.icon)},_setOptions:function(a){var b=void 0===a.showLabel?this.options.showLabel:a.showLabel,c=void 0===a.icon?this.options.icon:a.icon;b||c||(a.showLabel=!0),this._super(a)},_setOption:function(a,b){"icon"===a&&(b?this._updateIcon(a,b):this.icon&&(this.icon.remove(),this.iconSpace&&this.iconSpace.remove())),"iconPosition"===a&&this._updateIcon(a,b),"showLabel"===a&&(this._toggleClass("ui-button-icon-only",null,!b),this._updateTooltip()),"label"===a&&(this.isInput?this.element.val(b):(this.element.html(b),this.icon&&(this._attachIcon(this.options.iconPosition),this._attachIconSpace(this.options.iconPosition)))),this._super(a,b),"disabled"===a&&(this._toggleClass(null,"ui-state-disabled",b),this.element[0].disabled=b,b&&this.element.blur())},refresh:function(){var a=this.element.is("input, button")?this.element[0].disabled:this.element.hasClass("ui-button-disabled");a!==this.options.disabled&&this._setOptions({disabled:a}),this._updateTooltip()}}),a.uiBackCompat!==!1&&(a.widget("ui.button",a.ui.button,{options:{text:!0,icons:{primary:null,secondary:null}},_create:function(){this.options.showLabel&&!this.options.text&&(this.options.showLabel=this.options.text),!this.options.showLabel&&this.options.text&&(this.options.text=this.options.showLabel),this.options.icon||!this.options.icons.primary&&!this.options.icons.secondary?this.options.icon&&(this.options.icons.primary=this.options.icon):this.options.icons.primary?this.options.icon=this.options.icons.primary:(this.options.icon=this.options.icons.secondary,this.options.iconPosition="end"),this._super()},_setOption:function(a,b){return"text"===a?void this._super("showLabel",b):("showLabel"===a&&(this.options.text=b),"icon"===a&&(this.options.icons.primary=b),"icons"===a&&(b.primary?(this._super("icon",b.primary),this._super("iconPosition","beginning")):b.secondary&&(this._super("icon",b.secondary),this._super("iconPosition","end"))),void this._superApply(arguments))}}),a.fn.button=function(b){return function(){return!this.length||this.length&&"INPUT"!==this[0].tagName||this.length&&"INPUT"===this[0].tagName&&"checkbox"!==this.attr("type")&&"radio"!==this.attr("type")?b.apply(this,arguments):(a.ui.checkboxradio||a.error("Checkboxradio widget missing"),0===arguments.length?this.checkboxradio({icon:!1}):this.checkboxradio.apply(this,arguments))}}(a.fn.button),a.fn.buttonset=function(){return a.ui.controlgroup||a.error("Controlgroup widget missing"),"option"===arguments[0]&&"items"===arguments[1]&&arguments[2]?this.controlgroup.apply(this,[arguments[0],"items.button",arguments[2]]):"option"===arguments[0]&&"items"===arguments[1]?this.controlgroup.apply(this,[arguments[0],"items.button"]):("object"==typeof arguments[0]&&arguments[0].items&&(arguments[0].items={button:arguments[0].items}),this.controlgroup.apply(this,arguments))});var T=a.ui.button;a.extend(a.ui,{datepicker:{version:"1.12.0"}});var U;function V(a){var b,c;while(a.length&&a[0]!==document){if(b=a.css("position"),("absolute"===b||"relative"===b||"fixed"===b)&&(c=parseInt(a.css("zIndex"),10),!isNaN(c)&&0!==c))return c;a=a.parent()}return 0}function W(){this._curInst=null,this._keyEvent=!1,this._disabledInputs=[],this._datepickerShowing=!1,this._inDialog=!1,this._mainDivId="ui-datepicker-div",this._inlineClass="ui-datepicker-inline",this._appendClass="ui-datepicker-append",this._triggerClass="ui-datepicker-trigger",this._dialogClass="ui-datepicker-dialog",this._disableClass="ui-datepicker-disabled",this._unselectableClass="ui-datepicker-unselectable",this._currentClass="ui-datepicker-current-day",this._dayOverClass="ui-datepicker-days-cell-over",this.regional=[],this.regional[""]={closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"mm/dd/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""},this._defaults={showOn:"focus",showAnim:"fadeIn",showOptions:{},defaultDate:null,appendText:"",buttonText:"...",buttonImage:"",buttonImageOnly:!1,hideIfNoPrevNext:!1,navigationAsDateFormat:!1,gotoCurrent:!1,changeMonth:!1,changeYear:!1,yearRange:"c-10:c+10",showOtherMonths:!1,selectOtherMonths:!1,showWeek:!1,calculateWeek:this.iso8601Week,shortYearCutoff:"+10",minDate:null,maxDate:null,duration:"fast",beforeShowDay:null,beforeShow:null,onSelect:null,onChangeMonthYear:null,onClose:null,numberOfMonths:1,showCurrentAtPos:0,stepMonths:1,stepBigMonths:12,altField:"",altFormat:"",constrainInput:!0,showButtonPanel:!1,autoSize:!1,disabled:!1},a.extend(this._defaults,this.regional[""]),this.regional.en=a.extend(!0,{},this.regional[""]),this.regional["en-US"]=a.extend(!0,{},this.regional.en),this.dpDiv=X(a("<div id='"+this._mainDivId+"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))}a.extend(W.prototype,{markerClassName:"hasDatepicker",maxRows:4,_widgetDatepicker:function(){return this.dpDiv},setDefaults:function(a){return Z(this._defaults,a||{}),this},_attachDatepicker:function(b,c){var d,e,f;d=b.nodeName.toLowerCase(),e="div"===d||"span"===d,b.id||(this.uuid+=1,b.id="dp"+this.uuid),f=this._newInst(a(b),e),f.settings=a.extend({},c||{}),"input"===d?this._connectDatepicker(b,f):e&&this._inlineDatepicker(b,f)},_newInst:function(b,c){var d=b[0].id.replace(/([^A-Za-z0-9_\-])/g,"\\\\$1");return{id:d,input:b,selectedDay:0,selectedMonth:0,selectedYear:0,drawMonth:0,drawYear:0,inline:c,dpDiv:c?X(a("<div class='"+this._inlineClass+" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")):this.dpDiv}},_connectDatepicker:function(b,c){var d=a(b);c.append=a([]),c.trigger=a([]),d.hasClass(this.markerClassName)||(this._attachments(d,c),d.addClass(this.markerClassName).on("keydown",this._doKeyDown).on("keypress",this._doKeyPress).on("keyup",this._doKeyUp),this._autoSize(c),a.data(b,"datepicker",c),c.settings.disabled&&this._disableDatepicker(b))},_attachments:function(b,c){var d,e,f,g=this._get(c,"appendText"),h=this._get(c,"isRTL");c.append&&c.append.remove(),g&&(c.append=a("<span class='"+this._appendClass+"'>"+g+"</span>"),b[h?"before":"after"](c.append)),b.off("focus",this._showDatepicker),c.trigger&&c.trigger.remove(),d=this._get(c,"showOn"),"focus"!==d&&"both"!==d||b.on("focus",this._showDatepicker),"button"!==d&&"both"!==d||(e=this._get(c,"buttonText"),f=this._get(c,"buttonImage"),c.trigger=a(this._get(c,"buttonImageOnly")?a("<img/>").addClass(this._triggerClass).attr({src:f,alt:e,title:e}):a("<button type='button'></button>").addClass(this._triggerClass).html(f?a("<img/>").attr({src:f,alt:e,title:e}):e)),b[h?"before":"after"](c.trigger),c.trigger.on("click",function(){return a.datepicker._datepickerShowing&&a.datepicker._lastInput===b[0]?a.datepicker._hideDatepicker():a.datepicker._datepickerShowing&&a.datepicker._lastInput!==b[0]?(a.datepicker._hideDatepicker(),a.datepicker._showDatepicker(b[0])):a.datepicker._showDatepicker(b[0]),!1}))},_autoSize:function(a){if(this._get(a,"autoSize")&&!a.inline){var b,c,d,e,f=new Date(2009,11,20),g=this._get(a,"dateFormat");g.match(/[DM]/)&&(b=function(a){for(c=0,d=0,e=0;e<a.length;e++)a[e].length>c&&(c=a[e].length,d=e);return d},f.setMonth(b(this._get(a,g.match(/MM/)?"monthNames":"monthNamesShort"))),f.setDate(b(this._get(a,g.match(/DD/)?"dayNames":"dayNamesShort"))+20-f.getDay())),a.input.attr("size",this._formatDate(a,f).length)}},_inlineDatepicker:function(b,c){var d=a(b);d.hasClass(this.markerClassName)||(d.addClass(this.markerClassName).append(c.dpDiv),a.data(b,"datepicker",c),this._setDate(c,this._getDefaultDate(c),!0),this._updateDatepicker(c),this._updateAlternate(c),c.settings.disabled&&this._disableDatepicker(b),c.dpDiv.css("display","block"))},_dialogDatepicker:function(b,c,d,e,f){var g,h,i,j,k,l=this._dialogInst;return l||(this.uuid+=1,g="dp"+this.uuid,this._dialogInput=a("<input type='text' id='"+g+"' style='position: absolute; top: -100px; width: 0px;'/>"),this._dialogInput.on("keydown",this._doKeyDown),a("body").append(this._dialogInput),l=this._dialogInst=this._newInst(this._dialogInput,!1),l.settings={},a.data(this._dialogInput[0],"datepicker",l)),Z(l.settings,e||{}),c=c&&c.constructor===Date?this._formatDate(l,c):c,this._dialogInput.val(c),this._pos=f?f.length?f:[f.pageX,f.pageY]:null,this._pos||(h=document.documentElement.clientWidth,i=document.documentElement.clientHeight,j=document.documentElement.scrollLeft||document.body.scrollLeft,k=document.documentElement.scrollTop||document.body.scrollTop,this._pos=[h/2-100+j,i/2-150+k]),this._dialogInput.css("left",this._pos[0]+20+"px").css("top",this._pos[1]+"px"),l.settings.onSelect=d,this._inDialog=!0,this.dpDiv.addClass(this._dialogClass),this._showDatepicker(this._dialogInput[0]),a.blockUI&&a.blockUI(this.dpDiv),a.data(this._dialogInput[0],"datepicker",l),this},_destroyDatepicker:function(b){var c,d=a(b),e=a.data(b,"datepicker");d.hasClass(this.markerClassName)&&(c=b.nodeName.toLowerCase(),a.removeData(b,"datepicker"),"input"===c?(e.append.remove(),e.trigger.remove(),d.removeClass(this.markerClassName).off("focus",this._showDatepicker).off("keydown",this._doKeyDown).off("keypress",this._doKeyPress).off("keyup",this._doKeyUp)):"div"!==c&&"span"!==c||d.removeClass(this.markerClassName).empty(),U===e&&(U=null))},_enableDatepicker:function(b){var c,d,e=a(b),f=a.data(b,"datepicker");e.hasClass(this.markerClassName)&&(c=b.nodeName.toLowerCase(),"input"===c?(b.disabled=!1,f.trigger.filter("button").each(function(){this.disabled=!1}).end().filter("img").css({opacity:"1.0",cursor:""})):"div"!==c&&"span"!==c||(d=e.children("."+this._inlineClass),d.children().removeClass("ui-state-disabled"),d.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!1)),this._disabledInputs=a.map(this._disabledInputs,function(a){return a===b?null:a}))},_disableDatepicker:function(b){var c,d,e=a(b),f=a.data(b,"datepicker");e.hasClass(this.markerClassName)&&(c=b.nodeName.toLowerCase(),"input"===c?(b.disabled=!0,f.trigger.filter("button").each(function(){this.disabled=!0}).end().filter("img").css({opacity:"0.5",cursor:"default"})):"div"!==c&&"span"!==c||(d=e.children("."+this._inlineClass),d.children().addClass("ui-state-disabled"),d.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!0)),this._disabledInputs=a.map(this._disabledInputs,function(a){return a===b?null:a}),this._disabledInputs[this._disabledInputs.length]=b)},_isDisabledDatepicker:function(a){if(!a)return!1;for(var b=0;b<this._disabledInputs.length;b++)if(this._disabledInputs[b]===a)return!0;return!1},_getInst:function(b){try{return a.data(b,"datepicker")}catch(a){throw"Missing instance data for this datepicker"}},_optionDatepicker:function(b,c,d){var e,f,g,h,i=this._getInst(b);return 2===arguments.length&&"string"==typeof c?"defaults"===c?a.extend({},a.datepicker._defaults):i?"all"===c?a.extend({},i.settings):this._get(i,c):null:(e=c||{},"string"==typeof c&&(e={},e[c]=d),void(i&&(this._curInst===i&&this._hideDatepicker(),f=this._getDateDatepicker(b,!0),g=this._getMinMaxDate(i,"min"),h=this._getMinMaxDate(i,"max"),Z(i.settings,e),null!==g&&void 0!==e.dateFormat&&void 0===e.minDate&&(i.settings.minDate=this._formatDate(i,g)),null!==h&&void 0!==e.dateFormat&&void 0===e.maxDate&&(i.settings.maxDate=this._formatDate(i,h)),"disabled"in e&&(e.disabled?this._disableDatepicker(b):this._enableDatepicker(b)),this._attachments(a(b),i),this._autoSize(i),this._setDate(i,f),this._updateAlternate(i),this._updateDatepicker(i))))},_changeDatepicker:function(a,b,c){this._optionDatepicker(a,b,c)},_refreshDatepicker:function(a){var b=this._getInst(a);b&&this._updateDatepicker(b)},_setDateDatepicker:function(a,b){var c=this._getInst(a);c&&(this._setDate(c,b),this._updateDatepicker(c),this._updateAlternate(c))},_getDateDatepicker:function(a,b){var c=this._getInst(a);return c&&!c.inline&&this._setDateFromField(c,b),c?this._getDate(c):null},_doKeyDown:function(b){var c,d,e,f=a.datepicker._getInst(b.target),g=!0,h=f.dpDiv.is(".ui-datepicker-rtl");if(f._keyEvent=!0,a.datepicker._datepickerShowing)switch(b.keyCode){case 9:a.datepicker._hideDatepicker(),g=!1;break;case 13:return e=a("td."+a.datepicker._dayOverClass+":not(."+a.datepicker._currentClass+")",f.dpDiv),e[0]&&a.datepicker._selectDay(b.target,f.selectedMonth,f.selectedYear,e[0]),c=a.datepicker._get(f,"onSelect"),c?(d=a.datepicker._formatDate(f),c.apply(f.input?f.input[0]:null,[d,f])):a.datepicker._hideDatepicker(),!1;case 27:a.datepicker._hideDatepicker();break;case 33:a.datepicker._adjustDate(b.target,b.ctrlKey?-a.datepicker._get(f,"stepBigMonths"):-a.datepicker._get(f,"stepMonths"),"M");break;case 34:a.datepicker._adjustDate(b.target,b.ctrlKey?+a.datepicker._get(f,"stepBigMonths"):+a.datepicker._get(f,"stepMonths"),"M");break;case 35:(b.ctrlKey||b.metaKey)&&a.datepicker._clearDate(b.target),g=b.ctrlKey||b.metaKey;break;case 36:(b.ctrlKey||b.metaKey)&&a.datepicker._gotoToday(b.target),g=b.ctrlKey||b.metaKey;break;case 37:(b.ctrlKey||b.metaKey)&&a.datepicker._adjustDate(b.target,h?1:-1,"D"),g=b.ctrlKey||b.metaKey,b.originalEvent.altKey&&a.datepicker._adjustDate(b.target,b.ctrlKey?-a.datepicker._get(f,"stepBigMonths"):-a.datepicker._get(f,"stepMonths"),"M");break;case 38:(b.ctrlKey||b.metaKey)&&a.datepicker._adjustDate(b.target,-7,"D"),g=b.ctrlKey||b.metaKey;break;case 39:(b.ctrlKey||b.metaKey)&&a.datepicker._adjustDate(b.target,h?-1:1,"D"),g=b.ctrlKey||b.metaKey,b.originalEvent.altKey&&a.datepicker._adjustDate(b.target,b.ctrlKey?+a.datepicker._get(f,"stepBigMonths"):+a.datepicker._get(f,"stepMonths"),"M");break;case 40:(b.ctrlKey||b.metaKey)&&a.datepicker._adjustDate(b.target,7,"D"),g=b.ctrlKey||b.metaKey;break;default:g=!1}else 36===b.keyCode&&b.ctrlKey?a.datepicker._showDatepicker(this):g=!1;g&&(b.preventDefault(),b.stopPropagation())},_doKeyPress:function(b){var c,d,e=a.datepicker._getInst(b.target);if(a.datepicker._get(e,"constrainInput"))return c=a.datepicker._possibleChars(a.datepicker._get(e,"dateFormat")),d=String.fromCharCode(null==b.charCode?b.keyCode:b.charCode),b.ctrlKey||b.metaKey||d<" "||!c||c.indexOf(d)>-1},_doKeyUp:function(b){var c,d=a.datepicker._getInst(b.target);if(d.input.val()!==d.lastVal)try{c=a.datepicker.parseDate(a.datepicker._get(d,"dateFormat"),d.input?d.input.val():null,a.datepicker._getFormatConfig(d)),c&&(a.datepicker._setDateFromField(d),a.datepicker._updateAlternate(d),a.datepicker._updateDatepicker(d))}catch(a){}return!0},_showDatepicker:function(b){if(b=b.target||b,"input"!==b.nodeName.toLowerCase()&&(b=a("input",b.parentNode)[0]),!a.datepicker._isDisabledDatepicker(b)&&a.datepicker._lastInput!==b){var c,d,e,f,g,h,i;c=a.datepicker._getInst(b),a.datepicker._curInst&&a.datepicker._curInst!==c&&(a.datepicker._curInst.dpDiv.stop(!0,!0),c&&a.datepicker._datepickerShowing&&a.datepicker._hideDatepicker(a.datepicker._curInst.input[0])),d=a.datepicker._get(c,"beforeShow"),e=d?d.apply(b,[b,c]):{},e!==!1&&(Z(c.settings,e),c.lastVal=null,a.datepicker._lastInput=b,a.datepicker._setDateFromField(c),a.datepicker._inDialog&&(b.value=""),a.datepicker._pos||(a.datepicker._pos=a.datepicker._findPos(b),a.datepicker._pos[1]+=b.offsetHeight),f=!1,a(b).parents().each(function(){return f|="fixed"===a(this).css("position"),!f}),g={left:a.datepicker._pos[0],top:a.datepicker._pos[1]},a.datepicker._pos=null,c.dpDiv.empty(),c.dpDiv.css({position:"absolute",display:"block",top:"-1000px"}),a.datepicker._updateDatepicker(c),g=a.datepicker._checkOffset(c,g,f),c.dpDiv.css({position:a.datepicker._inDialog&&a.blockUI?"static":f?"fixed":"absolute",display:"none",left:g.left+"px",top:g.top+"px"}),c.inline||(h=a.datepicker._get(c,"showAnim"),i=a.datepicker._get(c,"duration"),c.dpDiv.css("z-index",V(a(b))+1),a.datepicker._datepickerShowing=!0,a.effects&&a.effects.effect[h]?c.dpDiv.show(h,a.datepicker._get(c,"showOptions"),i):c.dpDiv[h||"show"](h?i:null),a.datepicker._shouldFocusInput(c)&&c.input.trigger("focus"),a.datepicker._curInst=c))}},_updateDatepicker:function(b){this.maxRows=4,U=b,b.dpDiv.empty().append(this._generateHTML(b)),this._attachHandlers(b);var c,d=this._getNumberOfMonths(b),e=d[1],f=17,g=b.dpDiv.find("."+this._dayOverClass+" a");g.length>0&&Y.apply(g.get(0)),b.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""),e>1&&b.dpDiv.addClass("ui-datepicker-multi-"+e).css("width",f*e+"em"),b.dpDiv[(1!==d[0]||1!==d[1]?"add":"remove")+"Class"]("ui-datepicker-multi"),b.dpDiv[(this._get(b,"isRTL")?"add":"remove")+"Class"]("ui-datepicker-rtl"),b===a.datepicker._curInst&&a.datepicker._datepickerShowing&&a.datepicker._shouldFocusInput(b)&&b.input.trigger("focus"),b.yearshtml&&(c=b.yearshtml,setTimeout(function(){c===b.yearshtml&&b.yearshtml&&b.dpDiv.find("select.ui-datepicker-year:first").replaceWith(b.yearshtml),c=b.yearshtml=null},0))},_shouldFocusInput:function(a){return a.input&&a.input.is(":visible")&&!a.input.is(":disabled")&&!a.input.is(":focus")},_checkOffset:function(b,c,d){var e=b.dpDiv.outerWidth(),f=b.dpDiv.outerHeight(),g=b.input?b.input.outerWidth():0,h=b.input?b.input.outerHeight():0,i=document.documentElement.clientWidth+(d?0:a(document).scrollLeft()),j=document.documentElement.clientHeight+(d?0:a(document).scrollTop());return c.left-=this._get(b,"isRTL")?e-g:0,c.left-=d&&c.left===b.input.offset().left?a(document).scrollLeft():0,c.top-=d&&c.top===b.input.offset().top+h?a(document).scrollTop():0,c.left-=Math.min(c.left,c.left+e>i&&i>e?Math.abs(c.left+e-i):0),c.top-=Math.min(c.top,c.top+f>j&&j>f?Math.abs(f+h):0),c},_findPos:function(b){var c,d=this._getInst(b),e=this._get(d,"isRTL");while(b&&("hidden"===b.type||1!==b.nodeType||a.expr.filters.hidden(b)))b=b[e?"previousSibling":"nextSibling"];return c=a(b).offset(),[c.left,c.top]},_hideDatepicker:function(b){var c,d,e,f,g=this._curInst;!g||b&&g!==a.data(b,"datepicker")||this._datepickerShowing&&(c=this._get(g,"showAnim"),d=this._get(g,"duration"),e=function(){a.datepicker._tidyDialog(g)},a.effects&&(a.effects.effect[c]||a.effects[c])?g.dpDiv.hide(c,a.datepicker._get(g,"showOptions"),d,e):g.dpDiv["slideDown"===c?"slideUp":"fadeIn"===c?"fadeOut":"hide"](c?d:null,e),c||e(),this._datepickerShowing=!1,f=this._get(g,"onClose"),f&&f.apply(g.input?g.input[0]:null,[g.input?g.input.val():"",g]),this._lastInput=null,this._inDialog&&(this._dialogInput.css({position:"absolute",left:"0",top:"-100px"}),a.blockUI&&(a.unblockUI(),a("body").append(this.dpDiv))),this._inDialog=!1)},_tidyDialog:function(a){a.dpDiv.removeClass(this._dialogClass).off(".ui-datepicker-calendar")},_checkExternalClick:function(b){if(a.datepicker._curInst){var c=a(b.target),d=a.datepicker._getInst(c[0]);(c[0].id===a.datepicker._mainDivId||0!==c.parents("#"+a.datepicker._mainDivId).length||c.hasClass(a.datepicker.markerClassName)||c.closest("."+a.datepicker._triggerClass).length||!a.datepicker._datepickerShowing||a.datepicker._inDialog&&a.blockUI)&&(!c.hasClass(a.datepicker.markerClassName)||a.datepicker._curInst===d)||a.datepicker._hideDatepicker()}},_adjustDate:function(b,c,d){var e=a(b),f=this._getInst(e[0]);this._isDisabledDatepicker(e[0])||(this._adjustInstDate(f,c+("M"===d?this._get(f,"showCurrentAtPos"):0),d),this._updateDatepicker(f))},_gotoToday:function(b){var c,d=a(b),e=this._getInst(d[0]);this._get(e,"gotoCurrent")&&e.currentDay?(e.selectedDay=e.currentDay,e.drawMonth=e.selectedMonth=e.currentMonth,e.drawYear=e.selectedYear=e.currentYear):(c=new Date,e.selectedDay=c.getDate(),e.drawMonth=e.selectedMonth=c.getMonth(),e.drawYear=e.selectedYear=c.getFullYear()),this._notifyChange(e),this._adjustDate(d)},_selectMonthYear:function(b,c,d){var e=a(b),f=this._getInst(e[0]);f["selected"+("M"===d?"Month":"Year")]=f["draw"+("M"===d?"Month":"Year")]=parseInt(c.options[c.selectedIndex].value,10),this._notifyChange(f),this._adjustDate(e)},_selectDay:function(b,c,d,e){var f,g=a(b);a(e).hasClass(this._unselectableClass)||this._isDisabledDatepicker(g[0])||(f=this._getInst(g[0]),f.selectedDay=f.currentDay=a("a",e).html(),f.selectedMonth=f.currentMonth=c,f.selectedYear=f.currentYear=d,this._selectDate(b,this._formatDate(f,f.currentDay,f.currentMonth,f.currentYear)))},_clearDate:function(b){var c=a(b);this._selectDate(c,"")},_selectDate:function(b,c){var d,e=a(b),f=this._getInst(e[0]);c=null!=c?c:this._formatDate(f),f.input&&f.input.val(c),this._updateAlternate(f),d=this._get(f,"onSelect"),d?d.apply(f.input?f.input[0]:null,[c,f]):f.input&&f.input.trigger("change"),f.inline?this._updateDatepicker(f):(this._hideDatepicker(),this._lastInput=f.input[0],"object"!=typeof f.input[0]&&f.input.trigger("focus"),this._lastInput=null)},_updateAlternate:function(b){var c,d,e,f=this._get(b,"altField");f&&(c=this._get(b,"altFormat")||this._get(b,"dateFormat"),d=this._getDate(b),e=this.formatDate(c,d,this._getFormatConfig(b)),a(f).val(e))},noWeekends:function(a){var b=a.getDay();return[b>0&&b<6,""]},iso8601Week:function(a){var b,c=new Date(a.getTime());return c.setDate(c.getDate()+4-(c.getDay()||7)),b=c.getTime(),c.setMonth(0),c.setDate(1),Math.floor(Math.round((b-c)/864e5)/7)+1},parseDate:function(b,c,d){if(null==b||null==c)throw"Invalid arguments";if(c="object"==typeof c?c.toString():c+"",""===c)return null;var e,f,g,h=0,i=(d?d.shortYearCutoff:null)||this._defaults.shortYearCutoff,j="string"!=typeof i?i:(new Date).getFullYear()%100+parseInt(i,10),k=(d?d.dayNamesShort:null)||this._defaults.dayNamesShort,l=(d?d.dayNames:null)||this._defaults.dayNames,m=(d?d.monthNamesShort:null)||this._defaults.monthNamesShort,n=(d?d.monthNames:null)||this._defaults.monthNames,o=-1,p=-1,q=-1,r=-1,s=!1,t,u=function(a){var c=e+1<b.length&&b.charAt(e+1)===a;return c&&e++,c},v=function(a){var b=u(a),d="@"===a?14:"!"===a?20:"y"===a&&b?4:"o"===a?3:2,e="y"===a?d:1,f=new RegExp("^\\d{"+e+","+d+"}"),g=c.substring(h).match(f);if(!g)throw"Missing number at position "+h;return h+=g[0].length,parseInt(g[0],10)},w=function(b,d,e){var f=-1,g=a.map(u(b)?e:d,function(a,b){return[[b,a]]}).sort(function(a,b){return-(a[1].length-b[1].length)});if(a.each(g,function(a,b){var d=b[1];if(c.substr(h,d.length).toLowerCase()===d.toLowerCase())return f=b[0],h+=d.length,!1}),f!==-1)return f+1;throw"Unknown name at position "+h},x=function(){if(c.charAt(h)!==b.charAt(e))throw"Unexpected literal at position "+h;h++};for(e=0;e<b.length;e++)if(s)"'"!==b.charAt(e)||u("'")?x():s=!1;else switch(b.charAt(e)){case"d":q=v("d");break;case"D":w("D",k,l);break;case"o":r=v("o");break;case"m":p=v("m");break;case"M":p=w("M",m,n);break;case"y":o=v("y");break;case"@":t=new Date(v("@")),o=t.getFullYear(),p=t.getMonth()+1,q=t.getDate();break;case"!":t=new Date((v("!")-this._ticksTo1970)/1e4),o=t.getFullYear(),p=t.getMonth()+1,q=t.getDate();break;case"'":u("'")?x():s=!0;break;default:x()}if(h<c.length&&(g=c.substr(h),!/^\s+/.test(g)))throw"Extra/unparsed characters found in date: "+g;if(o===-1?o=(new Date).getFullYear():o<100&&(o+=(new Date).getFullYear()-(new Date).getFullYear()%100+(o<=j?0:-100)),r>-1){p=1,q=r;do{if(f=this._getDaysInMonth(o,p-1),q<=f)break;p++,q-=f}while(!0)}if(t=this._daylightSavingAdjust(new Date(o,p-1,q)),t.getFullYear()!==o||t.getMonth()+1!==p||t.getDate()!==q)throw"Invalid date";return t},ATOM:"yy-mm-dd",COOKIE:"D, dd M yy",ISO_8601:"yy-mm-dd",RFC_822:"D, d M y",RFC_850:"DD, dd-M-y",RFC_1036:"D, d M y",RFC_1123:"D, d M yy",RFC_2822:"D, d M yy",RSS:"D, d M y",TICKS:"!",TIMESTAMP:"@",W3C:"yy-mm-dd",_ticksTo1970:24*(718685+Math.floor(492.5)-Math.floor(19.7)+Math.floor(4.925))*60*60*1e7,formatDate:function(a,b,c){if(!b)return"";var d,e=(c?c.dayNamesShort:null)||this._defaults.dayNamesShort,f=(c?c.dayNames:null)||this._defaults.dayNames,g=(c?c.monthNamesShort:null)||this._defaults.monthNamesShort,h=(c?c.monthNames:null)||this._defaults.monthNames,i=function(b){var c=d+1<a.length&&a.charAt(d+1)===b;return c&&d++,c},j=function(a,b,c){var d=""+b;if(i(a))while(d.length<c)d="0"+d;return d},k=function(a,b,c,d){return i(a)?d[b]:c[b]},l="",m=!1;if(b)for(d=0;d<a.length;d++)if(m)"'"!==a.charAt(d)||i("'")?l+=a.charAt(d):m=!1;else switch(a.charAt(d)){case"d":l+=j("d",b.getDate(),2);break;case"D":l+=k("D",b.getDay(),e,f);break;case"o":l+=j("o",Math.round((new Date(b.getFullYear(),b.getMonth(),b.getDate()).getTime()-new Date(b.getFullYear(),0,0).getTime())/864e5),3);break;case"m":l+=j("m",b.getMonth()+1,2);break;case"M":l+=k("M",b.getMonth(),g,h);break;case"y":l+=i("y")?b.getFullYear():(b.getFullYear()%100<10?"0":"")+b.getFullYear()%100;break;case"@":l+=b.getTime();break;case"!":l+=1e4*b.getTime()+this._ticksTo1970;break;case"'":i("'")?l+="'":m=!0;break;default:l+=a.charAt(d)}return l},_possibleChars:function(a){var b,c="",d=!1,e=function(c){var d=b+1<a.length&&a.charAt(b+1)===c;return d&&b++,d};for(b=0;b<a.length;b++)if(d)"'"!==a.charAt(b)||e("'")?c+=a.charAt(b):d=!1;else switch(a.charAt(b)){case"d":case"m":case"y":case"@":c+="0123456789";break;case"D":case"M":return null;case"'":e("'")?c+="'":d=!0;break;default:c+=a.charAt(b)}return c},_get:function(a,b){return void 0!==a.settings[b]?a.settings[b]:this._defaults[b]},_setDateFromField:function(a,b){if(a.input.val()!==a.lastVal){var c=this._get(a,"dateFormat"),d=a.lastVal=a.input?a.input.val():null,e=this._getDefaultDate(a),f=e,g=this._getFormatConfig(a);try{f=this.parseDate(c,d,g)||e}catch(a){d=b?"":d}a.selectedDay=f.getDate(),a.drawMonth=a.selectedMonth=f.getMonth(),a.drawYear=a.selectedYear=f.getFullYear(),a.currentDay=d?f.getDate():0,a.currentMonth=d?f.getMonth():0,a.currentYear=d?f.getFullYear():0,this._adjustInstDate(a)}},_getDefaultDate:function(a){return this._restrictMinMax(a,this._determineDate(a,this._get(a,"defaultDate"),new Date))},_determineDate:function(b,c,d){var e=function(a){var b=new Date;return b.setDate(b.getDate()+a),b},f=function(c){try{return a.datepicker.parseDate(a.datepicker._get(b,"dateFormat"),c,a.datepicker._getFormatConfig(b))}catch(a){}var d=(c.toLowerCase().match(/^c/)?a.datepicker._getDate(b):null)||new Date,e=d.getFullYear(),f=d.getMonth(),g=d.getDate(),h=/([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,i=h.exec(c);while(i){switch(i[2]||"d"){case"d":case"D":g+=parseInt(i[1],10);break;case"w":case"W":g+=7*parseInt(i[1],10);break;case"m":case"M":f+=parseInt(i[1],10),g=Math.min(g,a.datepicker._getDaysInMonth(e,f));break;case"y":case"Y":e+=parseInt(i[1],10),g=Math.min(g,a.datepicker._getDaysInMonth(e,f));
}i=h.exec(c)}return new Date(e,f,g)},g=null==c||""===c?d:"string"==typeof c?f(c):"number"==typeof c?isNaN(c)?d:e(c):new Date(c.getTime());return g=g&&"Invalid Date"===g.toString()?d:g,g&&(g.setHours(0),g.setMinutes(0),g.setSeconds(0),g.setMilliseconds(0)),this._daylightSavingAdjust(g)},_daylightSavingAdjust:function(a){return a?(a.setHours(a.getHours()>12?a.getHours()+2:0),a):null},_setDate:function(a,b,c){var d=!b,e=a.selectedMonth,f=a.selectedYear,g=this._restrictMinMax(a,this._determineDate(a,b,new Date));a.selectedDay=a.currentDay=g.getDate(),a.drawMonth=a.selectedMonth=a.currentMonth=g.getMonth(),a.drawYear=a.selectedYear=a.currentYear=g.getFullYear(),e===a.selectedMonth&&f===a.selectedYear||c||this._notifyChange(a),this._adjustInstDate(a),a.input&&a.input.val(d?"":this._formatDate(a))},_getDate:function(a){var b=!a.currentYear||a.input&&""===a.input.val()?null:this._daylightSavingAdjust(new Date(a.currentYear,a.currentMonth,a.currentDay));return b},_attachHandlers:function(b){var c=this._get(b,"stepMonths"),d="#"+b.id.replace(/\\\\/g,"\\");b.dpDiv.find("[data-handler]").map(function(){var b={prev:function(){a.datepicker._adjustDate(d,-c,"M")},next:function(){a.datepicker._adjustDate(d,+c,"M")},hide:function(){a.datepicker._hideDatepicker()},today:function(){a.datepicker._gotoToday(d)},selectDay:function(){return a.datepicker._selectDay(d,+this.getAttribute("data-month"),+this.getAttribute("data-year"),this),!1},selectMonth:function(){return a.datepicker._selectMonthYear(d,this,"M"),!1},selectYear:function(){return a.datepicker._selectMonthYear(d,this,"Y"),!1}};a(this).on(this.getAttribute("data-event"),b[this.getAttribute("data-handler")])})},_generateHTML:function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O=new Date,P=this._daylightSavingAdjust(new Date(O.getFullYear(),O.getMonth(),O.getDate())),Q=this._get(a,"isRTL"),R=this._get(a,"showButtonPanel"),S=this._get(a,"hideIfNoPrevNext"),T=this._get(a,"navigationAsDateFormat"),U=this._getNumberOfMonths(a),V=this._get(a,"showCurrentAtPos"),W=this._get(a,"stepMonths"),X=1!==U[0]||1!==U[1],Y=this._daylightSavingAdjust(a.currentDay?new Date(a.currentYear,a.currentMonth,a.currentDay):new Date(9999,9,9)),Z=this._getMinMaxDate(a,"min"),$=this._getMinMaxDate(a,"max"),_=a.drawMonth-V,aa=a.drawYear;if(_<0&&(_+=12,aa--),$){b=this._daylightSavingAdjust(new Date($.getFullYear(),$.getMonth()-U[0]*U[1]+1,$.getDate())),b=Z&&b<Z?Z:b;while(this._daylightSavingAdjust(new Date(aa,_,1))>b)_--,_<0&&(_=11,aa--)}for(a.drawMonth=_,a.drawYear=aa,c=this._get(a,"prevText"),c=T?this.formatDate(c,this._daylightSavingAdjust(new Date(aa,_-W,1)),this._getFormatConfig(a)):c,d=this._canAdjustMonth(a,-1,aa,_)?"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='"+c+"'><span class='ui-icon ui-icon-circle-triangle-"+(Q?"e":"w")+"'>"+c+"</span></a>":S?"":"<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+c+"'><span class='ui-icon ui-icon-circle-triangle-"+(Q?"e":"w")+"'>"+c+"</span></a>",e=this._get(a,"nextText"),e=T?this.formatDate(e,this._daylightSavingAdjust(new Date(aa,_+W,1)),this._getFormatConfig(a)):e,f=this._canAdjustMonth(a,1,aa,_)?"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='"+e+"'><span class='ui-icon ui-icon-circle-triangle-"+(Q?"w":"e")+"'>"+e+"</span></a>":S?"":"<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+e+"'><span class='ui-icon ui-icon-circle-triangle-"+(Q?"w":"e")+"'>"+e+"</span></a>",g=this._get(a,"currentText"),h=this._get(a,"gotoCurrent")&&a.currentDay?Y:P,g=T?this.formatDate(g,h,this._getFormatConfig(a)):g,i=a.inline?"":"<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>"+this._get(a,"closeText")+"</button>",j=R?"<div class='ui-datepicker-buttonpane ui-widget-content'>"+(Q?i:"")+(this._isInRange(a,h)?"<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>"+g+"</button>":"")+(Q?"":i)+"</div>":"",k=parseInt(this._get(a,"firstDay"),10),k=isNaN(k)?0:k,l=this._get(a,"showWeek"),m=this._get(a,"dayNames"),n=this._get(a,"dayNamesMin"),o=this._get(a,"monthNames"),p=this._get(a,"monthNamesShort"),q=this._get(a,"beforeShowDay"),r=this._get(a,"showOtherMonths"),s=this._get(a,"selectOtherMonths"),t=this._getDefaultDate(a),u="",w=0;w<U[0];w++){for(x="",this.maxRows=4,y=0;y<U[1];y++){if(z=this._daylightSavingAdjust(new Date(aa,_,a.selectedDay)),A=" ui-corner-all",B="",X){if(B+="<div class='ui-datepicker-group",U[1]>1)switch(y){case 0:B+=" ui-datepicker-group-first",A=" ui-corner-"+(Q?"right":"left");break;case U[1]-1:B+=" ui-datepicker-group-last",A=" ui-corner-"+(Q?"left":"right");break;default:B+=" ui-datepicker-group-middle",A=""}B+="'>"}for(B+="<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix"+A+"'>"+(/all|left/.test(A)&&0===w?Q?f:d:"")+(/all|right/.test(A)&&0===w?Q?d:f:"")+this._generateMonthYearHeader(a,_,aa,Z,$,w>0||y>0,o,p)+"</div><table class='ui-datepicker-calendar'><thead><tr>",C=l?"<th class='ui-datepicker-week-col'>"+this._get(a,"weekHeader")+"</th>":"",v=0;v<7;v++)D=(v+k)%7,C+="<th scope='col'"+((v+k+6)%7>=5?" class='ui-datepicker-week-end'":"")+"><span title='"+m[D]+"'>"+n[D]+"</span></th>";for(B+=C+"</tr></thead><tbody>",E=this._getDaysInMonth(aa,_),aa===a.selectedYear&&_===a.selectedMonth&&(a.selectedDay=Math.min(a.selectedDay,E)),F=(this._getFirstDayOfMonth(aa,_)-k+7)%7,G=Math.ceil((F+E)/7),H=X&&this.maxRows>G?this.maxRows:G,this.maxRows=H,I=this._daylightSavingAdjust(new Date(aa,_,1-F)),J=0;J<H;J++){for(B+="<tr>",K=l?"<td class='ui-datepicker-week-col'>"+this._get(a,"calculateWeek")(I)+"</td>":"",v=0;v<7;v++)L=q?q.apply(a.input?a.input[0]:null,[I]):[!0,""],M=I.getMonth()!==_,N=M&&!s||!L[0]||Z&&I<Z||$&&I>$,K+="<td class='"+((v+k+6)%7>=5?" ui-datepicker-week-end":"")+(M?" ui-datepicker-other-month":"")+(I.getTime()===z.getTime()&&_===a.selectedMonth&&a._keyEvent||t.getTime()===I.getTime()&&t.getTime()===z.getTime()?" "+this._dayOverClass:"")+(N?" "+this._unselectableClass+" ui-state-disabled":"")+(M&&!r?"":" "+L[1]+(I.getTime()===Y.getTime()?" "+this._currentClass:"")+(I.getTime()===P.getTime()?" ui-datepicker-today":""))+"'"+(M&&!r||!L[2]?"":" title='"+L[2].replace(/'/g,"&#39;")+"'")+(N?"":" data-handler='selectDay' data-event='click' data-month='"+I.getMonth()+"' data-year='"+I.getFullYear()+"'")+">"+(M&&!r?"&#xa0;":N?"<span class='ui-state-default'>"+I.getDate()+"</span>":"<a class='ui-state-default"+(I.getTime()===P.getTime()?" ui-state-highlight":"")+(I.getTime()===Y.getTime()?" ui-state-active":"")+(M?" ui-priority-secondary":"")+"' href='#'>"+I.getDate()+"</a>")+"</td>",I.setDate(I.getDate()+1),I=this._daylightSavingAdjust(I);B+=K+"</tr>"}_++,_>11&&(_=0,aa++),B+="</tbody></table>"+(X?"</div>"+(U[0]>0&&y===U[1]-1?"<div class='ui-datepicker-row-break'></div>":""):""),x+=B}u+=x}return u+=j,a._keyEvent=!1,u},_generateMonthYearHeader:function(a,b,c,d,e,f,g,h){var i,j,k,l,m,n,o,p,q=this._get(a,"changeMonth"),r=this._get(a,"changeYear"),s=this._get(a,"showMonthAfterYear"),t="<div class='ui-datepicker-title'>",u="";if(f||!q)u+="<span class='ui-datepicker-month'>"+g[b]+"</span>";else{for(i=d&&d.getFullYear()===c,j=e&&e.getFullYear()===c,u+="<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>",k=0;k<12;k++)(!i||k>=d.getMonth())&&(!j||k<=e.getMonth())&&(u+="<option value='"+k+"'"+(k===b?" selected='selected'":"")+">"+h[k]+"</option>");u+="</select>"}if(s||(t+=u+(!f&&q&&r?"":"&#xa0;")),!a.yearshtml)if(a.yearshtml="",f||!r)t+="<span class='ui-datepicker-year'>"+c+"</span>";else{for(l=this._get(a,"yearRange").split(":"),m=(new Date).getFullYear(),n=function(a){var b=a.match(/c[+\-].*/)?c+parseInt(a.substring(1),10):a.match(/[+\-].*/)?m+parseInt(a,10):parseInt(a,10);return isNaN(b)?m:b},o=n(l[0]),p=Math.max(o,n(l[1]||"")),o=d?Math.max(o,d.getFullYear()):o,p=e?Math.min(p,e.getFullYear()):p,a.yearshtml+="<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";o<=p;o++)a.yearshtml+="<option value='"+o+"'"+(o===c?" selected='selected'":"")+">"+o+"</option>";a.yearshtml+="</select>",t+=a.yearshtml,a.yearshtml=null}return t+=this._get(a,"yearSuffix"),s&&(t+=(!f&&q&&r?"":"&#xa0;")+u),t+="</div>"},_adjustInstDate:function(a,b,c){var d=a.selectedYear+("Y"===c?b:0),e=a.selectedMonth+("M"===c?b:0),f=Math.min(a.selectedDay,this._getDaysInMonth(d,e))+("D"===c?b:0),g=this._restrictMinMax(a,this._daylightSavingAdjust(new Date(d,e,f)));a.selectedDay=g.getDate(),a.drawMonth=a.selectedMonth=g.getMonth(),a.drawYear=a.selectedYear=g.getFullYear(),"M"!==c&&"Y"!==c||this._notifyChange(a)},_restrictMinMax:function(a,b){var c=this._getMinMaxDate(a,"min"),d=this._getMinMaxDate(a,"max"),e=c&&b<c?c:b;return d&&e>d?d:e},_notifyChange:function(a){var b=this._get(a,"onChangeMonthYear");b&&b.apply(a.input?a.input[0]:null,[a.selectedYear,a.selectedMonth+1,a])},_getNumberOfMonths:function(a){var b=this._get(a,"numberOfMonths");return null==b?[1,1]:"number"==typeof b?[1,b]:b},_getMinMaxDate:function(a,b){return this._determineDate(a,this._get(a,b+"Date"),null)},_getDaysInMonth:function(a,b){return 32-this._daylightSavingAdjust(new Date(a,b,32)).getDate()},_getFirstDayOfMonth:function(a,b){return new Date(a,b,1).getDay()},_canAdjustMonth:function(a,b,c,d){var e=this._getNumberOfMonths(a),f=this._daylightSavingAdjust(new Date(c,d+(b<0?b:e[0]*e[1]),1));return b<0&&f.setDate(this._getDaysInMonth(f.getFullYear(),f.getMonth())),this._isInRange(a,f)},_isInRange:function(a,b){var c,d,e=this._getMinMaxDate(a,"min"),f=this._getMinMaxDate(a,"max"),g=null,h=null,i=this._get(a,"yearRange");return i&&(c=i.split(":"),d=(new Date).getFullYear(),g=parseInt(c[0],10),h=parseInt(c[1],10),c[0].match(/[+\-].*/)&&(g+=d),c[1].match(/[+\-].*/)&&(h+=d)),(!e||b.getTime()>=e.getTime())&&(!f||b.getTime()<=f.getTime())&&(!g||b.getFullYear()>=g)&&(!h||b.getFullYear()<=h)},_getFormatConfig:function(a){var b=this._get(a,"shortYearCutoff");return b="string"!=typeof b?b:(new Date).getFullYear()%100+parseInt(b,10),{shortYearCutoff:b,dayNamesShort:this._get(a,"dayNamesShort"),dayNames:this._get(a,"dayNames"),monthNamesShort:this._get(a,"monthNamesShort"),monthNames:this._get(a,"monthNames")}},_formatDate:function(a,b,c,d){b||(a.currentDay=a.selectedDay,a.currentMonth=a.selectedMonth,a.currentYear=a.selectedYear);var e=b?"object"==typeof b?b:this._daylightSavingAdjust(new Date(d,c,b)):this._daylightSavingAdjust(new Date(a.currentYear,a.currentMonth,a.currentDay));return this.formatDate(this._get(a,"dateFormat"),e,this._getFormatConfig(a))}});function X(b){var c="button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return b.on("mouseout",c,function(){a(this).removeClass("ui-state-hover"),this.className.indexOf("ui-datepicker-prev")!==-1&&a(this).removeClass("ui-datepicker-prev-hover"),this.className.indexOf("ui-datepicker-next")!==-1&&a(this).removeClass("ui-datepicker-next-hover")}).on("mouseover",c,Y)}function Y(){a.datepicker._isDisabledDatepicker(U.inline?U.dpDiv.parent()[0]:U.input[0])||(a(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"),a(this).addClass("ui-state-hover"),this.className.indexOf("ui-datepicker-prev")!==-1&&a(this).addClass("ui-datepicker-prev-hover"),this.className.indexOf("ui-datepicker-next")!==-1&&a(this).addClass("ui-datepicker-next-hover"))}function Z(b,c){a.extend(b,c);for(var d in c)null==c[d]&&(b[d]=c[d]);return b}a.fn.datepicker=function(b){if(!this.length)return this;a.datepicker.initialized||(a(document).on("mousedown",a.datepicker._checkExternalClick),a.datepicker.initialized=!0),0===a("#"+a.datepicker._mainDivId).length&&a("body").append(a.datepicker.dpDiv);var c=Array.prototype.slice.call(arguments,1);return"string"!=typeof b||"isDisabled"!==b&&"getDate"!==b&&"widget"!==b?"option"===b&&2===arguments.length&&"string"==typeof arguments[1]?a.datepicker["_"+b+"Datepicker"].apply(a.datepicker,[this[0]].concat(c)):this.each(function(){"string"==typeof b?a.datepicker["_"+b+"Datepicker"].apply(a.datepicker,[this].concat(c)):a.datepicker._attachDatepicker(this,b)}):a.datepicker["_"+b+"Datepicker"].apply(a.datepicker,[this[0]].concat(c))},a.datepicker=new W,a.datepicker.initialized=!1,a.datepicker.uuid=(new Date).getTime(),a.datepicker.version="1.12.0";var $=a.datepicker,_=a.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase()),aa=!1;a(document).on("mouseup",function(){aa=!1});var ba=a.widget("ui.mouse",{version:"1.12.0",options:{cancel:"input, textarea, button, select, option",distance:1,delay:0},_mouseInit:function(){var b=this;this.element.on("mousedown."+this.widgetName,function(a){return b._mouseDown(a)}).on("click."+this.widgetName,function(c){if(!0===a.data(c.target,b.widgetName+".preventClickEvent"))return a.removeData(c.target,b.widgetName+".preventClickEvent"),c.stopImmediatePropagation(),!1}),this.started=!1},_mouseDestroy:function(){this.element.off("."+this.widgetName),this._mouseMoveDelegate&&this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(b){if(!aa){this._mouseMoved=!1,this._mouseStarted&&this._mouseUp(b),this._mouseDownEvent=b;var c=this,d=1===b.which,e=!("string"!=typeof this.options.cancel||!b.target.nodeName)&&a(b.target).closest(this.options.cancel).length;return!(d&&!e&&this._mouseCapture(b))||(this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){c.mouseDelayMet=!0},this.options.delay)),this._mouseDistanceMet(b)&&this._mouseDelayMet(b)&&(this._mouseStarted=this._mouseStart(b)!==!1,!this._mouseStarted)?(b.preventDefault(),!0):(!0===a.data(b.target,this.widgetName+".preventClickEvent")&&a.removeData(b.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(a){return c._mouseMove(a)},this._mouseUpDelegate=function(a){return c._mouseUp(a)},this.document.on("mousemove."+this.widgetName,this._mouseMoveDelegate).on("mouseup."+this.widgetName,this._mouseUpDelegate),b.preventDefault(),aa=!0,!0))}},_mouseMove:function(b){if(this._mouseMoved){if(a.ui.ie&&(!document.documentMode||document.documentMode<9)&&!b.button)return this._mouseUp(b);if(!b.which)if(b.originalEvent.altKey||b.originalEvent.ctrlKey||b.originalEvent.metaKey||b.originalEvent.shiftKey)this.ignoreMissingWhich=!0;else if(!this.ignoreMissingWhich)return this._mouseUp(b)}return(b.which||b.button)&&(this._mouseMoved=!0),this._mouseStarted?(this._mouseDrag(b),b.preventDefault()):(this._mouseDistanceMet(b)&&this._mouseDelayMet(b)&&(this._mouseStarted=this._mouseStart(this._mouseDownEvent,b)!==!1,this._mouseStarted?this._mouseDrag(b):this._mouseUp(b)),!this._mouseStarted)},_mouseUp:function(b){this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,b.target===this._mouseDownEvent.target&&a.data(b.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(b)),this._mouseDelayTimer&&(clearTimeout(this._mouseDelayTimer),delete this._mouseDelayTimer),this.ignoreMissingWhich=!1,aa=!1,b.preventDefault()},_mouseDistanceMet:function(a){return Math.max(Math.abs(this._mouseDownEvent.pageX-a.pageX),Math.abs(this._mouseDownEvent.pageY-a.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}}),ca=a.ui.plugin={add:function(b,c,d){var e,f=a.ui[b].prototype;for(e in d)f.plugins[e]=f.plugins[e]||[],f.plugins[e].push([c,d[e]])},call:function(a,b,c,d){var e,f=a.plugins[b];if(f&&(d||a.element[0].parentNode&&11!==a.element[0].parentNode.nodeType))for(e=0;e<f.length;e++)a.options[f[e][0]]&&f[e][1].apply(a.element,c)}},da=a.ui.safeBlur=function(b){b&&"body"!==b.nodeName.toLowerCase()&&a(b).trigger("blur")};a.widget("ui.draggable",a.ui.mouse,{version:"1.12.0",widgetEventPrefix:"drag",options:{addClasses:!0,appendTo:"parent",axis:!1,connectToSortable:!1,containment:!1,cursor:"auto",cursorAt:!1,grid:!1,handle:!1,helper:"original",iframeFix:!1,opacity:!1,refreshPositions:!1,revert:!1,revertDuration:500,scope:"default",scroll:!0,scrollSensitivity:20,scrollSpeed:20,snap:!1,snapMode:"both",snapTolerance:20,stack:!1,zIndex:!1,drag:null,start:null,stop:null},_create:function(){"original"===this.options.helper&&this._setPositionRelative(),this.options.addClasses&&this._addClass("ui-draggable"),this._setHandleClassName(),this._mouseInit()},_setOption:function(a,b){this._super(a,b),"handle"===a&&(this._removeHandleClassName(),this._setHandleClassName())},_destroy:function(){return(this.helper||this.element).is(".ui-draggable-dragging")?void(this.destroyOnClear=!0):(this._removeHandleClassName(),void this._mouseDestroy())},_mouseCapture:function(b){var c=this.options;return this._blurActiveElement(b),!(this.helper||c.disabled||a(b.target).closest(".ui-resizable-handle").length>0)&&(this.handle=this._getHandle(b),!!this.handle&&(this._blockFrames(c.iframeFix===!0?"iframe":c.iframeFix),!0))},_blockFrames:function(b){this.iframeBlocks=this.document.find(b).map(function(){var b=a(this);return a("<div>").css("position","absolute").appendTo(b.parent()).outerWidth(b.outerWidth()).outerHeight(b.outerHeight()).offset(b.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_blurActiveElement:function(b){var c=a.ui.safeActiveElement(this.document[0]),d=a(b.target);this._getHandle(b)&&d.closest(c).length||a.ui.safeBlur(c)},_mouseStart:function(b){var c=this.options;return this.helper=this._createHelper(b),this._addClass(this.helper,"ui-draggable-dragging"),this._cacheHelperProportions(),a.ui.ddmanager&&(a.ui.ddmanager.current=this),this._cacheMargins(),this.cssPosition=this.helper.css("position"),this.scrollParent=this.helper.scrollParent(!0),this.offsetParent=this.helper.offsetParent(),this.hasFixedAncestor=this.helper.parents().filter(function(){return"fixed"===a(this).css("position")}).length>0,this.positionAbs=this.element.offset(),this._refreshOffsets(b),this.originalPosition=this.position=this._generatePosition(b,!1),this.originalPageX=b.pageX,this.originalPageY=b.pageY,c.cursorAt&&this._adjustOffsetFromHelper(c.cursorAt),this._setContainment(),this._trigger("start",b)===!1?(this._clear(),!1):(this._cacheHelperProportions(),a.ui.ddmanager&&!c.dropBehaviour&&a.ui.ddmanager.prepareOffsets(this,b),this._mouseDrag(b,!0),a.ui.ddmanager&&a.ui.ddmanager.dragStart(this,b),!0)},_refreshOffsets:function(a){this.offset={top:this.positionAbs.top-this.margins.top,left:this.positionAbs.left-this.margins.left,scroll:!1,parent:this._getParentOffset(),relative:this._getRelativeOffset()},this.offset.click={left:a.pageX-this.offset.left,top:a.pageY-this.offset.top}},_mouseDrag:function(b,c){if(this.hasFixedAncestor&&(this.offset.parent=this._getParentOffset()),this.position=this._generatePosition(b,!0),this.positionAbs=this._convertPositionTo("absolute"),!c){var d=this._uiHash();if(this._trigger("drag",b,d)===!1)return this._mouseUp(new a.Event("mouseup",b)),!1;this.position=d.position}return this.helper[0].style.left=this.position.left+"px",this.helper[0].style.top=this.position.top+"px",a.ui.ddmanager&&a.ui.ddmanager.drag(this,b),!1},_mouseStop:function(b){var c=this,d=!1;return a.ui.ddmanager&&!this.options.dropBehaviour&&(d=a.ui.ddmanager.drop(this,b)),this.dropped&&(d=this.dropped,this.dropped=!1),"invalid"===this.options.revert&&!d||"valid"===this.options.revert&&d||this.options.revert===!0||a.isFunction(this.options.revert)&&this.options.revert.call(this.element,d)?a(this.helper).animate(this.originalPosition,parseInt(this.options.revertDuration,10),function(){c._trigger("stop",b)!==!1&&c._clear()}):this._trigger("stop",b)!==!1&&this._clear(),!1},_mouseUp:function(b){return this._unblockFrames(),a.ui.ddmanager&&a.ui.ddmanager.dragStop(this,b),this.handleElement.is(b.target)&&this.element.trigger("focus"),a.ui.mouse.prototype._mouseUp.call(this,b)},cancel:function(){return this.helper.is(".ui-draggable-dragging")?this._mouseUp(new a.Event("mouseup",{target:this.element[0]})):this._clear(),this},_getHandle:function(b){return!this.options.handle||!!a(b.target).closest(this.element.find(this.options.handle)).length},_setHandleClassName:function(){this.handleElement=this.options.handle?this.element.find(this.options.handle):this.element,this._addClass(this.handleElement,"ui-draggable-handle")},_removeHandleClassName:function(){this._removeClass(this.handleElement,"ui-draggable-handle")},_createHelper:function(b){var c=this.options,d=a.isFunction(c.helper),e=d?a(c.helper.apply(this.element[0],[b])):"clone"===c.helper?this.element.clone().removeAttr("id"):this.element;return e.parents("body").length||e.appendTo("parent"===c.appendTo?this.element[0].parentNode:c.appendTo),d&&e[0]===this.element[0]&&this._setPositionRelative(),e[0]===this.element[0]||/(fixed|absolute)/.test(e.css("position"))||e.css("position","absolute"),e},_setPositionRelative:function(){/^(?:r|a|f)/.test(this.element.css("position"))||(this.element[0].style.position="relative")},_adjustOffsetFromHelper:function(b){"string"==typeof b&&(b=b.split(" ")),a.isArray(b)&&(b={left:+b[0],top:+b[1]||0}),"left"in b&&(this.offset.click.left=b.left+this.margins.left),"right"in b&&(this.offset.click.left=this.helperProportions.width-b.right+this.margins.left),"top"in b&&(this.offset.click.top=b.top+this.margins.top),"bottom"in b&&(this.offset.click.top=this.helperProportions.height-b.bottom+this.margins.top)},_isRootNode:function(a){return/(html|body)/i.test(a.tagName)||a===this.document[0]},_getParentOffset:function(){var b=this.offsetParent.offset(),c=this.document[0];return"absolute"===this.cssPosition&&this.scrollParent[0]!==c&&a.contains(this.scrollParent[0],this.offsetParent[0])&&(b.left+=this.scrollParent.scrollLeft(),b.top+=this.scrollParent.scrollTop()),this._isRootNode(this.offsetParent[0])&&(b={top:0,left:0}),{top:b.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:b.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"!==this.cssPosition)return{top:0,left:0};var a=this.element.position(),b=this._isRootNode(this.scrollParent[0]);return{top:a.top-(parseInt(this.helper.css("top"),10)||0)+(b?0:this.scrollParent.scrollTop()),left:a.left-(parseInt(this.helper.css("left"),10)||0)+(b?0:this.scrollParent.scrollLeft())}},_cacheMargins:function(){this.margins={left:parseInt(this.element.css("marginLeft"),10)||0,top:parseInt(this.element.css("marginTop"),10)||0,right:parseInt(this.element.css("marginRight"),10)||0,bottom:parseInt(this.element.css("marginBottom"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var b,c,d,e=this.options,f=this.document[0];return this.relativeContainer=null,e.containment?"window"===e.containment?void(this.containment=[a(window).scrollLeft()-this.offset.relative.left-this.offset.parent.left,a(window).scrollTop()-this.offset.relative.top-this.offset.parent.top,a(window).scrollLeft()+a(window).width()-this.helperProportions.width-this.margins.left,a(window).scrollTop()+(a(window).height()||f.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]):"document"===e.containment?void(this.containment=[0,0,a(f).width()-this.helperProportions.width-this.margins.left,(a(f).height()||f.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]):e.containment.constructor===Array?void(this.containment=e.containment):("parent"===e.containment&&(e.containment=this.helper[0].parentNode),c=a(e.containment),d=c[0],void(d&&(b=/(scroll|auto)/.test(c.css("overflow")),this.containment=[(parseInt(c.css("borderLeftWidth"),10)||0)+(parseInt(c.css("paddingLeft"),10)||0),(parseInt(c.css("borderTopWidth"),10)||0)+(parseInt(c.css("paddingTop"),10)||0),(b?Math.max(d.scrollWidth,d.offsetWidth):d.offsetWidth)-(parseInt(c.css("borderRightWidth"),10)||0)-(parseInt(c.css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left-this.margins.right,(b?Math.max(d.scrollHeight,d.offsetHeight):d.offsetHeight)-(parseInt(c.css("borderBottomWidth"),10)||0)-(parseInt(c.css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top-this.margins.bottom],this.relativeContainer=c))):void(this.containment=null)},_convertPositionTo:function(a,b){b||(b=this.position);var c="absolute"===a?1:-1,d=this._isRootNode(this.scrollParent[0]);return{top:b.top+this.offset.relative.top*c+this.offset.parent.top*c-("fixed"===this.cssPosition?-this.offset.scroll.top:d?0:this.offset.scroll.top)*c,left:b.left+this.offset.relative.left*c+this.offset.parent.left*c-("fixed"===this.cssPosition?-this.offset.scroll.left:d?0:this.offset.scroll.left)*c}},_generatePosition:function(a,b){var c,d,e,f,g=this.options,h=this._isRootNode(this.scrollParent[0]),i=a.pageX,j=a.pageY;return h&&this.offset.scroll||(this.offset.scroll={top:this.scrollParent.scrollTop(),left:this.scrollParent.scrollLeft()}),b&&(this.containment&&(this.relativeContainer?(d=this.relativeContainer.offset(),c=[this.containment[0]+d.left,this.containment[1]+d.top,this.containment[2]+d.left,this.containment[3]+d.top]):c=this.containment,a.pageX-this.offset.click.left<c[0]&&(i=c[0]+this.offset.click.left),a.pageY-this.offset.click.top<c[1]&&(j=c[1]+this.offset.click.top),a.pageX-this.offset.click.left>c[2]&&(i=c[2]+this.offset.click.left),a.pageY-this.offset.click.top>c[3]&&(j=c[3]+this.offset.click.top)),g.grid&&(e=g.grid[1]?this.originalPageY+Math.round((j-this.originalPageY)/g.grid[1])*g.grid[1]:this.originalPageY,j=c?e-this.offset.click.top>=c[1]||e-this.offset.click.top>c[3]?e:e-this.offset.click.top>=c[1]?e-g.grid[1]:e+g.grid[1]:e,f=g.grid[0]?this.originalPageX+Math.round((i-this.originalPageX)/g.grid[0])*g.grid[0]:this.originalPageX,i=c?f-this.offset.click.left>=c[0]||f-this.offset.click.left>c[2]?f:f-this.offset.click.left>=c[0]?f-g.grid[0]:f+g.grid[0]:f),"y"===g.axis&&(i=this.originalPageX),"x"===g.axis&&(j=this.originalPageY)),{top:j-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.offset.scroll.top:h?0:this.offset.scroll.top),left:i-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.offset.scroll.left:h?0:this.offset.scroll.left)}},_clear:function(){this._removeClass(this.helper,"ui-draggable-dragging"),this.helper[0]===this.element[0]||this.cancelHelperRemoval||this.helper.remove(),this.helper=null,this.cancelHelperRemoval=!1,this.destroyOnClear&&this.destroy()},_trigger:function(b,c,d){return d=d||this._uiHash(),a.ui.plugin.call(this,b,[c,d,this],!0),/^(drag|start|stop)/.test(b)&&(this.positionAbs=this._convertPositionTo("absolute"),d.offset=this.positionAbs),a.Widget.prototype._trigger.call(this,b,c,d)},plugins:{},_uiHash:function(){return{helper:this.helper,position:this.position,originalPosition:this.originalPosition,offset:this.positionAbs}}}),a.ui.plugin.add("draggable","connectToSortable",{start:function(b,c,d){var e=a.extend({},c,{item:d.element});d.sortables=[],a(d.options.connectToSortable).each(function(){var c=a(this).sortable("instance");c&&!c.options.disabled&&(d.sortables.push(c),c.refreshPositions(),c._trigger("activate",b,e))})},stop:function(b,c,d){var e=a.extend({},c,{item:d.element});d.cancelHelperRemoval=!1,a.each(d.sortables,function(){var a=this;a.isOver?(a.isOver=0,d.cancelHelperRemoval=!0,a.cancelHelperRemoval=!1,a._storedCSS={position:a.placeholder.css("position"),top:a.placeholder.css("top"),left:a.placeholder.css("left")},a._mouseStop(b),a.options.helper=a.options._helper):(a.cancelHelperRemoval=!0,a._trigger("deactivate",b,e))})},drag:function(b,c,d){a.each(d.sortables,function(){var e=!1,f=this;f.positionAbs=d.positionAbs,f.helperProportions=d.helperProportions,f.offset.click=d.offset.click,f._intersectsWith(f.containerCache)&&(e=!0,a.each(d.sortables,function(){return this.positionAbs=d.positionAbs,this.helperProportions=d.helperProportions,this.offset.click=d.offset.click,this!==f&&this._intersectsWith(this.containerCache)&&a.contains(f.element[0],this.element[0])&&(e=!1),e})),e?(f.isOver||(f.isOver=1,d._parent=c.helper.parent(),f.currentItem=c.helper.appendTo(f.element).data("ui-sortable-item",!0),f.options._helper=f.options.helper,f.options.helper=function(){return c.helper[0]},b.target=f.currentItem[0],f._mouseCapture(b,!0),f._mouseStart(b,!0,!0),f.offset.click.top=d.offset.click.top,f.offset.click.left=d.offset.click.left,f.offset.parent.left-=d.offset.parent.left-f.offset.parent.left,f.offset.parent.top-=d.offset.parent.top-f.offset.parent.top,d._trigger("toSortable",b),d.dropped=f.element,a.each(d.sortables,function(){this.refreshPositions()}),d.currentItem=d.element,f.fromOutside=d),f.currentItem&&(f._mouseDrag(b),c.position=f.position)):f.isOver&&(f.isOver=0,f.cancelHelperRemoval=!0,f.options._revert=f.options.revert,f.options.revert=!1,f._trigger("out",b,f._uiHash(f)),f._mouseStop(b,!0),f.options.revert=f.options._revert,f.options.helper=f.options._helper,f.placeholder&&f.placeholder.remove(),c.helper.appendTo(d._parent),d._refreshOffsets(b),c.position=d._generatePosition(b,!0),d._trigger("fromSortable",b),d.dropped=!1,a.each(d.sortables,function(){this.refreshPositions()}))})}}),a.ui.plugin.add("draggable","cursor",{start:function(b,c,d){var e=a("body"),f=d.options;e.css("cursor")&&(f._cursor=e.css("cursor")),e.css("cursor",f.cursor)},stop:function(b,c,d){var e=d.options;e._cursor&&a("body").css("cursor",e._cursor)}}),a.ui.plugin.add("draggable","opacity",{start:function(b,c,d){var e=a(c.helper),f=d.options;e.css("opacity")&&(f._opacity=e.css("opacity")),e.css("opacity",f.opacity)},stop:function(b,c,d){var e=d.options;e._opacity&&a(c.helper).css("opacity",e._opacity)}}),a.ui.plugin.add("draggable","scroll",{start:function(a,b,c){c.scrollParentNotHidden||(c.scrollParentNotHidden=c.helper.scrollParent(!1)),c.scrollParentNotHidden[0]!==c.document[0]&&"HTML"!==c.scrollParentNotHidden[0].tagName&&(c.overflowOffset=c.scrollParentNotHidden.offset())},drag:function(b,c,d){var e=d.options,f=!1,g=d.scrollParentNotHidden[0],h=d.document[0];g!==h&&"HTML"!==g.tagName?(e.axis&&"x"===e.axis||(d.overflowOffset.top+g.offsetHeight-b.pageY<e.scrollSensitivity?g.scrollTop=f=g.scrollTop+e.scrollSpeed:b.pageY-d.overflowOffset.top<e.scrollSensitivity&&(g.scrollTop=f=g.scrollTop-e.scrollSpeed)),e.axis&&"y"===e.axis||(d.overflowOffset.left+g.offsetWidth-b.pageX<e.scrollSensitivity?g.scrollLeft=f=g.scrollLeft+e.scrollSpeed:b.pageX-d.overflowOffset.left<e.scrollSensitivity&&(g.scrollLeft=f=g.scrollLeft-e.scrollSpeed))):(e.axis&&"x"===e.axis||(b.pageY-a(h).scrollTop()<e.scrollSensitivity?f=a(h).scrollTop(a(h).scrollTop()-e.scrollSpeed):a(window).height()-(b.pageY-a(h).scrollTop())<e.scrollSensitivity&&(f=a(h).scrollTop(a(h).scrollTop()+e.scrollSpeed))),e.axis&&"y"===e.axis||(b.pageX-a(h).scrollLeft()<e.scrollSensitivity?f=a(h).scrollLeft(a(h).scrollLeft()-e.scrollSpeed):a(window).width()-(b.pageX-a(h).scrollLeft())<e.scrollSensitivity&&(f=a(h).scrollLeft(a(h).scrollLeft()+e.scrollSpeed)))),f!==!1&&a.ui.ddmanager&&!e.dropBehaviour&&a.ui.ddmanager.prepareOffsets(d,b)}}),a.ui.plugin.add("draggable","snap",{start:function(b,c,d){var e=d.options;d.snapElements=[],a(e.snap.constructor!==String?e.snap.items||":data(ui-draggable)":e.snap).each(function(){var b=a(this),c=b.offset();this!==d.element[0]&&d.snapElements.push({item:this,width:b.outerWidth(),height:b.outerHeight(),top:c.top,left:c.left})})},drag:function(b,c,d){var e,f,g,h,i,j,k,l,m,n,o=d.options,p=o.snapTolerance,q=c.offset.left,r=q+d.helperProportions.width,s=c.offset.top,t=s+d.helperProportions.height;for(m=d.snapElements.length-1;m>=0;m--)i=d.snapElements[m].left-d.margins.left,
j=i+d.snapElements[m].width,k=d.snapElements[m].top-d.margins.top,l=k+d.snapElements[m].height,r<i-p||q>j+p||t<k-p||s>l+p||!a.contains(d.snapElements[m].item.ownerDocument,d.snapElements[m].item)?(d.snapElements[m].snapping&&d.options.snap.release&&d.options.snap.release.call(d.element,b,a.extend(d._uiHash(),{snapItem:d.snapElements[m].item})),d.snapElements[m].snapping=!1):("inner"!==o.snapMode&&(e=Math.abs(k-t)<=p,f=Math.abs(l-s)<=p,g=Math.abs(i-r)<=p,h=Math.abs(j-q)<=p,e&&(c.position.top=d._convertPositionTo("relative",{top:k-d.helperProportions.height,left:0}).top),f&&(c.position.top=d._convertPositionTo("relative",{top:l,left:0}).top),g&&(c.position.left=d._convertPositionTo("relative",{top:0,left:i-d.helperProportions.width}).left),h&&(c.position.left=d._convertPositionTo("relative",{top:0,left:j}).left)),n=e||f||g||h,"outer"!==o.snapMode&&(e=Math.abs(k-s)<=p,f=Math.abs(l-t)<=p,g=Math.abs(i-q)<=p,h=Math.abs(j-r)<=p,e&&(c.position.top=d._convertPositionTo("relative",{top:k,left:0}).top),f&&(c.position.top=d._convertPositionTo("relative",{top:l-d.helperProportions.height,left:0}).top),g&&(c.position.left=d._convertPositionTo("relative",{top:0,left:i}).left),h&&(c.position.left=d._convertPositionTo("relative",{top:0,left:j-d.helperProportions.width}).left)),!d.snapElements[m].snapping&&(e||f||g||h||n)&&d.options.snap.snap&&d.options.snap.snap.call(d.element,b,a.extend(d._uiHash(),{snapItem:d.snapElements[m].item})),d.snapElements[m].snapping=e||f||g||h||n)}}),a.ui.plugin.add("draggable","stack",{start:function(b,c,d){var e,f=d.options,g=a.makeArray(a(f.stack)).sort(function(b,c){return(parseInt(a(b).css("zIndex"),10)||0)-(parseInt(a(c).css("zIndex"),10)||0)});g.length&&(e=parseInt(a(g[0]).css("zIndex"),10)||0,a(g).each(function(b){a(this).css("zIndex",e+b)}),this.css("zIndex",e+g.length))}}),a.ui.plugin.add("draggable","zIndex",{start:function(b,c,d){var e=a(c.helper),f=d.options;e.css("zIndex")&&(f._zIndex=e.css("zIndex")),e.css("zIndex",f.zIndex)},stop:function(b,c,d){var e=d.options;e._zIndex&&a(c.helper).css("zIndex",e._zIndex)}});var ea=a.ui.draggable;a.widget("ui.resizable",a.ui.mouse,{version:"1.12.0",widgetEventPrefix:"resize",options:{alsoResize:!1,animate:!1,animateDuration:"slow",animateEasing:"swing",aspectRatio:!1,autoHide:!1,classes:{"ui-resizable-se":"ui-icon ui-icon-gripsmall-diagonal-se"},containment:!1,ghost:!1,grid:!1,handles:"e,s,se",helper:!1,maxHeight:null,maxWidth:null,minHeight:10,minWidth:10,zIndex:90,resize:null,start:null,stop:null},_num:function(a){return parseFloat(a)||0},_isNumber:function(a){return!isNaN(parseFloat(a))},_hasScroll:function(b,c){if("hidden"===a(b).css("overflow"))return!1;var d=c&&"left"===c?"scrollLeft":"scrollTop",e=!1;return b[d]>0||(b[d]=1,e=b[d]>0,b[d]=0,e)},_create:function(){var b,c=this.options,d=this;this._addClass("ui-resizable"),a.extend(this,{_aspectRatio:!!c.aspectRatio,aspectRatio:c.aspectRatio,originalElement:this.element,_proportionallyResizeElements:[],_helper:c.helper||c.ghost||c.animate?c.helper||"ui-resizable-helper":null}),this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i)&&(this.element.wrap(a("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({position:this.element.css("position"),width:this.element.outerWidth(),height:this.element.outerHeight(),top:this.element.css("top"),left:this.element.css("left")})),this.element=this.element.parent().data("ui-resizable",this.element.resizable("instance")),this.elementIsWrapper=!0,b={marginTop:this.originalElement.css("marginTop"),marginRight:this.originalElement.css("marginRight"),marginBottom:this.originalElement.css("marginBottom"),marginLeft:this.originalElement.css("marginLeft")},this.element.css(b),this.originalElement.css("margin",0),this.originalResizeStyle=this.originalElement.css("resize"),this.originalElement.css("resize","none"),this._proportionallyResizeElements.push(this.originalElement.css({position:"static",zoom:1,display:"block"})),this.originalElement.css(b),this._proportionallyResize()),this._setupHandles(),c.autoHide&&a(this.element).on("mouseenter",function(){c.disabled||(d._removeClass("ui-resizable-autohide"),d._handles.show())}).on("mouseleave",function(){c.disabled||d.resizing||(d._addClass("ui-resizable-autohide"),d._handles.hide())}),this._mouseInit()},_destroy:function(){this._mouseDestroy();var b,c=function(b){a(b).removeData("resizable").removeData("ui-resizable").off(".resizable").find(".ui-resizable-handle").remove()};return this.elementIsWrapper&&(c(this.element),b=this.element,this.originalElement.css({position:b.css("position"),width:b.outerWidth(),height:b.outerHeight(),top:b.css("top"),left:b.css("left")}).insertAfter(b),b.remove()),this.originalElement.css("resize",this.originalResizeStyle),c(this.originalElement),this},_setOption:function(a,b){switch(this._super(a,b),a){case"handles":this._removeHandles(),this._setupHandles()}},_setupHandles:function(){var b=this.options,c,d,e,f,g,h=this;if(this.handles=b.handles||(a(".ui-resizable-handle",this.element).length?{n:".ui-resizable-n",e:".ui-resizable-e",s:".ui-resizable-s",w:".ui-resizable-w",se:".ui-resizable-se",sw:".ui-resizable-sw",ne:".ui-resizable-ne",nw:".ui-resizable-nw"}:"e,s,se"),this._handles=a(),this.handles.constructor===String)for("all"===this.handles&&(this.handles="n,e,s,w,se,sw,ne,nw"),e=this.handles.split(","),this.handles={},d=0;d<e.length;d++)c=a.trim(e[d]),f="ui-resizable-"+c,g=a("<div>"),this._addClass(g,"ui-resizable-handle "+f),g.css({zIndex:b.zIndex}),this.handles[c]=".ui-resizable-"+c,this.element.append(g);this._renderAxis=function(b){var c,d,e,f;b=b||this.element;for(c in this.handles)this.handles[c].constructor===String?this.handles[c]=this.element.children(this.handles[c]).first().show():(this.handles[c].jquery||this.handles[c].nodeType)&&(this.handles[c]=a(this.handles[c]),this._on(this.handles[c],{mousedown:h._mouseDown})),this.elementIsWrapper&&this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i)&&(d=a(this.handles[c],this.element),f=/sw|ne|nw|se|n|s/.test(c)?d.outerHeight():d.outerWidth(),e=["padding",/ne|nw|n/.test(c)?"Top":/se|sw|s/.test(c)?"Bottom":/^e$/.test(c)?"Right":"Left"].join(""),b.css(e,f),this._proportionallyResize()),this._handles=this._handles.add(this.handles[c])},this._renderAxis(this.element),this._handles=this._handles.add(this.element.find(".ui-resizable-handle")),this._handles.disableSelection(),this._handles.on("mouseover",function(){h.resizing||(this.className&&(g=this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)),h.axis=g&&g[1]?g[1]:"se")}),b.autoHide&&(this._handles.hide(),this._addClass("ui-resizable-autohide"))},_removeHandles:function(){this._handles.remove()},_mouseCapture:function(b){var c,d,e=!1;for(c in this.handles)d=a(this.handles[c])[0],(d===b.target||a.contains(d,b.target))&&(e=!0);return!this.options.disabled&&e},_mouseStart:function(b){var c,d,e,f=this.options,g=this.element;return this.resizing=!0,this._renderProxy(),c=this._num(this.helper.css("left")),d=this._num(this.helper.css("top")),f.containment&&(c+=a(f.containment).scrollLeft()||0,d+=a(f.containment).scrollTop()||0),this.offset=this.helper.offset(),this.position={left:c,top:d},this.size=this._helper?{width:this.helper.width(),height:this.helper.height()}:{width:g.width(),height:g.height()},this.originalSize=this._helper?{width:g.outerWidth(),height:g.outerHeight()}:{width:g.width(),height:g.height()},this.sizeDiff={width:g.outerWidth()-g.width(),height:g.outerHeight()-g.height()},this.originalPosition={left:c,top:d},this.originalMousePosition={left:b.pageX,top:b.pageY},this.aspectRatio="number"==typeof f.aspectRatio?f.aspectRatio:this.originalSize.width/this.originalSize.height||1,e=a(".ui-resizable-"+this.axis).css("cursor"),a("body").css("cursor","auto"===e?this.axis+"-resize":e),this._addClass("ui-resizable-resizing"),this._propagate("start",b),!0},_mouseDrag:function(b){var c,d,e=this.originalMousePosition,f=this.axis,g=b.pageX-e.left||0,h=b.pageY-e.top||0,i=this._change[f];return this._updatePrevProperties(),!!i&&(c=i.apply(this,[b,g,h]),this._updateVirtualBoundaries(b.shiftKey),(this._aspectRatio||b.shiftKey)&&(c=this._updateRatio(c,b)),c=this._respectSize(c,b),this._updateCache(c),this._propagate("resize",b),d=this._applyChanges(),!this._helper&&this._proportionallyResizeElements.length&&this._proportionallyResize(),a.isEmptyObject(d)||(this._updatePrevProperties(),this._trigger("resize",b,this.ui()),this._applyChanges()),!1)},_mouseStop:function(b){this.resizing=!1;var c,d,e,f,g,h,i,j=this.options,k=this;return this._helper&&(c=this._proportionallyResizeElements,d=c.length&&/textarea/i.test(c[0].nodeName),e=d&&this._hasScroll(c[0],"left")?0:k.sizeDiff.height,f=d?0:k.sizeDiff.width,g={width:k.helper.width()-f,height:k.helper.height()-e},h=parseFloat(k.element.css("left"))+(k.position.left-k.originalPosition.left)||null,i=parseFloat(k.element.css("top"))+(k.position.top-k.originalPosition.top)||null,j.animate||this.element.css(a.extend(g,{top:i,left:h})),k.helper.height(k.size.height),k.helper.width(k.size.width),this._helper&&!j.animate&&this._proportionallyResize()),a("body").css("cursor","auto"),this._removeClass("ui-resizable-resizing"),this._propagate("stop",b),this._helper&&this.helper.remove(),!1},_updatePrevProperties:function(){this.prevPosition={top:this.position.top,left:this.position.left},this.prevSize={width:this.size.width,height:this.size.height}},_applyChanges:function(){var a={};return this.position.top!==this.prevPosition.top&&(a.top=this.position.top+"px"),this.position.left!==this.prevPosition.left&&(a.left=this.position.left+"px"),this.size.width!==this.prevSize.width&&(a.width=this.size.width+"px"),this.size.height!==this.prevSize.height&&(a.height=this.size.height+"px"),this.helper.css(a),a},_updateVirtualBoundaries:function(a){var b,c,d,e,f,g=this.options;f={minWidth:this._isNumber(g.minWidth)?g.minWidth:0,maxWidth:this._isNumber(g.maxWidth)?g.maxWidth:1/0,minHeight:this._isNumber(g.minHeight)?g.minHeight:0,maxHeight:this._isNumber(g.maxHeight)?g.maxHeight:1/0},(this._aspectRatio||a)&&(b=f.minHeight*this.aspectRatio,d=f.minWidth/this.aspectRatio,c=f.maxHeight*this.aspectRatio,e=f.maxWidth/this.aspectRatio,b>f.minWidth&&(f.minWidth=b),d>f.minHeight&&(f.minHeight=d),c<f.maxWidth&&(f.maxWidth=c),e<f.maxHeight&&(f.maxHeight=e)),this._vBoundaries=f},_updateCache:function(a){this.offset=this.helper.offset(),this._isNumber(a.left)&&(this.position.left=a.left),this._isNumber(a.top)&&(this.position.top=a.top),this._isNumber(a.height)&&(this.size.height=a.height),this._isNumber(a.width)&&(this.size.width=a.width)},_updateRatio:function(a){var b=this.position,c=this.size,d=this.axis;return this._isNumber(a.height)?a.width=a.height*this.aspectRatio:this._isNumber(a.width)&&(a.height=a.width/this.aspectRatio),"sw"===d&&(a.left=b.left+(c.width-a.width),a.top=null),"nw"===d&&(a.top=b.top+(c.height-a.height),a.left=b.left+(c.width-a.width)),a},_respectSize:function(a){var b=this._vBoundaries,c=this.axis,d=this._isNumber(a.width)&&b.maxWidth&&b.maxWidth<a.width,e=this._isNumber(a.height)&&b.maxHeight&&b.maxHeight<a.height,f=this._isNumber(a.width)&&b.minWidth&&b.minWidth>a.width,g=this._isNumber(a.height)&&b.minHeight&&b.minHeight>a.height,h=this.originalPosition.left+this.originalSize.width,i=this.originalPosition.top+this.originalSize.height,j=/sw|nw|w/.test(c),k=/nw|ne|n/.test(c);return f&&(a.width=b.minWidth),g&&(a.height=b.minHeight),d&&(a.width=b.maxWidth),e&&(a.height=b.maxHeight),f&&j&&(a.left=h-b.minWidth),d&&j&&(a.left=h-b.maxWidth),g&&k&&(a.top=i-b.minHeight),e&&k&&(a.top=i-b.maxHeight),a.width||a.height||a.left||!a.top?a.width||a.height||a.top||!a.left||(a.left=null):a.top=null,a},_getPaddingPlusBorderDimensions:function(a){for(var b=0,c=[],d=[a.css("borderTopWidth"),a.css("borderRightWidth"),a.css("borderBottomWidth"),a.css("borderLeftWidth")],e=[a.css("paddingTop"),a.css("paddingRight"),a.css("paddingBottom"),a.css("paddingLeft")];b<4;b++)c[b]=parseFloat(d[b])||0,c[b]+=parseFloat(e[b])||0;return{height:c[0]+c[2],width:c[1]+c[3]}},_proportionallyResize:function(){if(this._proportionallyResizeElements.length)for(var a,b=0,c=this.helper||this.element;b<this._proportionallyResizeElements.length;b++)a=this._proportionallyResizeElements[b],this.outerDimensions||(this.outerDimensions=this._getPaddingPlusBorderDimensions(a)),a.css({height:c.height()-this.outerDimensions.height||0,width:c.width()-this.outerDimensions.width||0})},_renderProxy:function(){var b=this.element,c=this.options;this.elementOffset=b.offset(),this._helper?(this.helper=this.helper||a("<div style='overflow:hidden;'></div>"),this._addClass(this.helper,this._helper),this.helper.css({width:this.element.outerWidth(),height:this.element.outerHeight(),position:"absolute",left:this.elementOffset.left+"px",top:this.elementOffset.top+"px",zIndex:++c.zIndex}),this.helper.appendTo("body").disableSelection()):this.helper=this.element},_change:{e:function(a,b){return{width:this.originalSize.width+b}},w:function(a,b){var c=this.originalSize,d=this.originalPosition;return{left:d.left+b,width:c.width-b}},n:function(a,b,c){var d=this.originalSize,e=this.originalPosition;return{top:e.top+c,height:d.height-c}},s:function(a,b,c){return{height:this.originalSize.height+c}},se:function(b,c,d){return a.extend(this._change.s.apply(this,arguments),this._change.e.apply(this,[b,c,d]))},sw:function(b,c,d){return a.extend(this._change.s.apply(this,arguments),this._change.w.apply(this,[b,c,d]))},ne:function(b,c,d){return a.extend(this._change.n.apply(this,arguments),this._change.e.apply(this,[b,c,d]))},nw:function(b,c,d){return a.extend(this._change.n.apply(this,arguments),this._change.w.apply(this,[b,c,d]))}},_propagate:function(b,c){a.ui.plugin.call(this,b,[c,this.ui()]),"resize"!==b&&this._trigger(b,c,this.ui())},plugins:{},ui:function(){return{originalElement:this.originalElement,element:this.element,helper:this.helper,position:this.position,size:this.size,originalSize:this.originalSize,originalPosition:this.originalPosition}}}),a.ui.plugin.add("resizable","animate",{stop:function(b){var c=a(this).resizable("instance"),d=c.options,e=c._proportionallyResizeElements,f=e.length&&/textarea/i.test(e[0].nodeName),g=f&&c._hasScroll(e[0],"left")?0:c.sizeDiff.height,h=f?0:c.sizeDiff.width,i={width:c.size.width-h,height:c.size.height-g},j=parseFloat(c.element.css("left"))+(c.position.left-c.originalPosition.left)||null,k=parseFloat(c.element.css("top"))+(c.position.top-c.originalPosition.top)||null;c.element.animate(a.extend(i,k&&j?{top:k,left:j}:{}),{duration:d.animateDuration,easing:d.animateEasing,step:function(){var d={width:parseFloat(c.element.css("width")),height:parseFloat(c.element.css("height")),top:parseFloat(c.element.css("top")),left:parseFloat(c.element.css("left"))};e&&e.length&&a(e[0]).css({width:d.width,height:d.height}),c._updateCache(d),c._propagate("resize",b)}})}}),a.ui.plugin.add("resizable","containment",{start:function(){var b,c,d,e,f,g,h,i=a(this).resizable("instance"),j=i.options,k=i.element,l=j.containment,m=l instanceof a?l.get(0):/parent/.test(l)?k.parent().get(0):l;m&&(i.containerElement=a(m),/document/.test(l)||l===document?(i.containerOffset={left:0,top:0},i.containerPosition={left:0,top:0},i.parentData={element:a(document),left:0,top:0,width:a(document).width(),height:a(document).height()||document.body.parentNode.scrollHeight}):(b=a(m),c=[],a(["Top","Right","Left","Bottom"]).each(function(a,d){c[a]=i._num(b.css("padding"+d))}),i.containerOffset=b.offset(),i.containerPosition=b.position(),i.containerSize={height:b.innerHeight()-c[3],width:b.innerWidth()-c[1]},d=i.containerOffset,e=i.containerSize.height,f=i.containerSize.width,g=i._hasScroll(m,"left")?m.scrollWidth:f,h=i._hasScroll(m)?m.scrollHeight:e,i.parentData={element:m,left:d.left,top:d.top,width:g,height:h}))},resize:function(b){var c,d,e,f,g=a(this).resizable("instance"),h=g.options,i=g.containerOffset,j=g.position,k=g._aspectRatio||b.shiftKey,l={top:0,left:0},m=g.containerElement,n=!0;m[0]!==document&&/static/.test(m.css("position"))&&(l=i),j.left<(g._helper?i.left:0)&&(g.size.width=g.size.width+(g._helper?g.position.left-i.left:g.position.left-l.left),k&&(g.size.height=g.size.width/g.aspectRatio,n=!1),g.position.left=h.helper?i.left:0),j.top<(g._helper?i.top:0)&&(g.size.height=g.size.height+(g._helper?g.position.top-i.top:g.position.top),k&&(g.size.width=g.size.height*g.aspectRatio,n=!1),g.position.top=g._helper?i.top:0),e=g.containerElement.get(0)===g.element.parent().get(0),f=/relative|absolute/.test(g.containerElement.css("position")),e&&f?(g.offset.left=g.parentData.left+g.position.left,g.offset.top=g.parentData.top+g.position.top):(g.offset.left=g.element.offset().left,g.offset.top=g.element.offset().top),c=Math.abs(g.sizeDiff.width+(g._helper?g.offset.left-l.left:g.offset.left-i.left)),d=Math.abs(g.sizeDiff.height+(g._helper?g.offset.top-l.top:g.offset.top-i.top)),c+g.size.width>=g.parentData.width&&(g.size.width=g.parentData.width-c,k&&(g.size.height=g.size.width/g.aspectRatio,n=!1)),d+g.size.height>=g.parentData.height&&(g.size.height=g.parentData.height-d,k&&(g.size.width=g.size.height*g.aspectRatio,n=!1)),n||(g.position.left=g.prevPosition.left,g.position.top=g.prevPosition.top,g.size.width=g.prevSize.width,g.size.height=g.prevSize.height)},stop:function(){var b=a(this).resizable("instance"),c=b.options,d=b.containerOffset,e=b.containerPosition,f=b.containerElement,g=a(b.helper),h=g.offset(),i=g.outerWidth()-b.sizeDiff.width,j=g.outerHeight()-b.sizeDiff.height;b._helper&&!c.animate&&/relative/.test(f.css("position"))&&a(this).css({left:h.left-e.left-d.left,width:i,height:j}),b._helper&&!c.animate&&/static/.test(f.css("position"))&&a(this).css({left:h.left-e.left-d.left,width:i,height:j})}}),a.ui.plugin.add("resizable","alsoResize",{start:function(){var b=a(this).resizable("instance"),c=b.options;a(c.alsoResize).each(function(){var b=a(this);b.data("ui-resizable-alsoresize",{width:parseFloat(b.width()),height:parseFloat(b.height()),left:parseFloat(b.css("left")),top:parseFloat(b.css("top"))})})},resize:function(b,c){var d=a(this).resizable("instance"),e=d.options,f=d.originalSize,g=d.originalPosition,h={height:d.size.height-f.height||0,width:d.size.width-f.width||0,top:d.position.top-g.top||0,left:d.position.left-g.left||0};a(e.alsoResize).each(function(){var b=a(this),d=a(this).data("ui-resizable-alsoresize"),e={},f=b.parents(c.originalElement[0]).length?["width","height"]:["width","height","top","left"];a.each(f,function(a,b){var c=(d[b]||0)+(h[b]||0);c&&c>=0&&(e[b]=c||null)}),b.css(e)})},stop:function(){a(this).removeData("ui-resizable-alsoresize")}}),a.ui.plugin.add("resizable","ghost",{start:function(){var b=a(this).resizable("instance"),c=b.size;b.ghost=b.originalElement.clone(),b.ghost.css({opacity:.25,display:"block",position:"relative",height:c.height,width:c.width,margin:0,left:0,top:0}),b._addClass(b.ghost,"ui-resizable-ghost"),a.uiBackCompat!==!1&&"string"==typeof b.options.ghost&&b.ghost.addClass(this.options.ghost),b.ghost.appendTo(b.helper)},resize:function(){var b=a(this).resizable("instance");b.ghost&&b.ghost.css({position:"relative",height:b.size.height,width:b.size.width})},stop:function(){var b=a(this).resizable("instance");b.ghost&&b.helper&&b.helper.get(0).removeChild(b.ghost.get(0))}}),a.ui.plugin.add("resizable","grid",{resize:function(){var b,c=a(this).resizable("instance"),d=c.options,e=c.size,f=c.originalSize,g=c.originalPosition,h=c.axis,i="number"==typeof d.grid?[d.grid,d.grid]:d.grid,j=i[0]||1,k=i[1]||1,l=Math.round((e.width-f.width)/j)*j,m=Math.round((e.height-f.height)/k)*k,n=f.width+l,o=f.height+m,p=d.maxWidth&&d.maxWidth<n,q=d.maxHeight&&d.maxHeight<o,r=d.minWidth&&d.minWidth>n,s=d.minHeight&&d.minHeight>o;d.grid=i,r&&(n+=j),s&&(o+=k),p&&(n-=j),q&&(o-=k),/^(se|s|e)$/.test(h)?(c.size.width=n,c.size.height=o):/^(ne)$/.test(h)?(c.size.width=n,c.size.height=o,c.position.top=g.top-m):/^(sw)$/.test(h)?(c.size.width=n,c.size.height=o,c.position.left=g.left-l):((o-k<=0||n-j<=0)&&(b=c._getPaddingPlusBorderDimensions(this)),o-k>0?(c.size.height=o,c.position.top=g.top-m):(o=k-b.height,c.size.height=o,c.position.top=g.top+f.height-o),n-j>0?(c.size.width=n,c.position.left=g.left-l):(n=j-b.width,c.size.width=n,c.position.left=g.left+f.width-n))}});var fa=a.ui.resizable;a.widget("ui.dialog",{version:"1.12.0",options:{appendTo:"body",autoOpen:!0,buttons:[],classes:{"ui-dialog":"ui-corner-all","ui-dialog-titlebar":"ui-corner-all"},closeOnEscape:!0,closeText:"Close",draggable:!0,hide:null,height:"auto",maxHeight:null,maxWidth:null,minHeight:150,minWidth:150,modal:!1,position:{my:"center",at:"center",of:window,collision:"fit",using:function(b){var c=a(this).css(b).offset().top;c<0&&a(this).css("top",b.top-c)}},resizable:!0,show:null,title:null,width:300,beforeClose:null,close:null,drag:null,dragStart:null,dragStop:null,focus:null,open:null,resize:null,resizeStart:null,resizeStop:null},sizeRelatedOptions:{buttons:!0,height:!0,maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0,width:!0},resizableRelatedOptions:{maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0},_create:function(){this.originalCss={display:this.element[0].style.display,width:this.element[0].style.width,minHeight:this.element[0].style.minHeight,maxHeight:this.element[0].style.maxHeight,height:this.element[0].style.height},this.originalPosition={parent:this.element.parent(),index:this.element.parent().children().index(this.element)},this.originalTitle=this.element.attr("title"),null==this.options.title&&null!=this.originalTitle&&(this.options.title=this.originalTitle),this.options.disabled&&(this.options.disabled=!1),this._createWrapper(),this.element.show().removeAttr("title").appendTo(this.uiDialog),this._addClass("ui-dialog-content","ui-widget-content"),this._createTitlebar(),this._createButtonPane(),this.options.draggable&&a.fn.draggable&&this._makeDraggable(),this.options.resizable&&a.fn.resizable&&this._makeResizable(),this._isOpen=!1,this._trackFocus()},_init:function(){this.options.autoOpen&&this.open()},_appendTo:function(){var b=this.options.appendTo;return b&&(b.jquery||b.nodeType)?a(b):this.document.find(b||"body").eq(0)},_destroy:function(){var a,b=this.originalPosition;this._untrackInstance(),this._destroyOverlay(),this.element.removeUniqueId().css(this.originalCss).detach(),this.uiDialog.remove(),this.originalTitle&&this.element.attr("title",this.originalTitle),a=b.parent.children().eq(b.index),a.length&&a[0]!==this.element[0]?a.before(this.element):b.parent.append(this.element)},widget:function(){return this.uiDialog},disable:a.noop,enable:a.noop,close:function(b){var c=this;this._isOpen&&this._trigger("beforeClose",b)!==!1&&(this._isOpen=!1,this._focusedElement=null,this._destroyOverlay(),this._untrackInstance(),this.opener.filter(":focusable").trigger("focus").length||a.ui.safeBlur(a.ui.safeActiveElement(this.document[0])),this._hide(this.uiDialog,this.options.hide,function(){c._trigger("close",b)}))},isOpen:function(){return this._isOpen},moveToTop:function(){this._moveToTop()},_moveToTop:function(b,c){var d=!1,e=this.uiDialog.siblings(".ui-front:visible").map(function(){return+a(this).css("z-index")}).get(),f=Math.max.apply(null,e);return f>=+this.uiDialog.css("z-index")&&(this.uiDialog.css("z-index",f+1),d=!0),d&&!c&&this._trigger("focus",b),d},open:function(){var b=this;return this._isOpen?void(this._moveToTop()&&this._focusTabbable()):(this._isOpen=!0,this.opener=a(a.ui.safeActiveElement(this.document[0])),this._size(),this._position(),this._createOverlay(),this._moveToTop(null,!0),this.overlay&&this.overlay.css("z-index",this.uiDialog.css("z-index")-1),this._show(this.uiDialog,this.options.show,function(){b._focusTabbable(),b._trigger("focus")}),this._makeFocusTarget(),void this._trigger("open"))},_focusTabbable:function(){var a=this._focusedElement;a||(a=this.element.find("[autofocus]")),a.length||(a=this.element.find(":tabbable")),a.length||(a=this.uiDialogButtonPane.find(":tabbable")),a.length||(a=this.uiDialogTitlebarClose.filter(":tabbable")),a.length||(a=this.uiDialog),a.eq(0).trigger("focus")},_keepFocus:function(b){function c(){var b=a.ui.safeActiveElement(this.document[0]),c=this.uiDialog[0]===b||a.contains(this.uiDialog[0],b);c||this._focusTabbable()}b.preventDefault(),c.call(this),this._delay(c)},_createWrapper:function(){this.uiDialog=a("<div>").hide().attr({tabIndex:-1,role:"dialog"}).appendTo(this._appendTo()),this._addClass(this.uiDialog,"ui-dialog","ui-widget ui-widget-content ui-front"),this._on(this.uiDialog,{keydown:function(b){if(this.options.closeOnEscape&&!b.isDefaultPrevented()&&b.keyCode&&b.keyCode===a.ui.keyCode.ESCAPE)return b.preventDefault(),void this.close(b);if(b.keyCode===a.ui.keyCode.TAB&&!b.isDefaultPrevented()){var c=this.uiDialog.find(":tabbable"),d=c.filter(":first"),e=c.filter(":last");b.target!==e[0]&&b.target!==this.uiDialog[0]||b.shiftKey?b.target!==d[0]&&b.target!==this.uiDialog[0]||!b.shiftKey||(this._delay(function(){e.trigger("focus")}),b.preventDefault()):(this._delay(function(){d.trigger("focus")}),b.preventDefault())}},mousedown:function(a){this._moveToTop(a)&&this._focusTabbable()}}),this.element.find("[aria-describedby]").length||this.uiDialog.attr({"aria-describedby":this.element.uniqueId().attr("id")})},_createTitlebar:function(){var b;this.uiDialogTitlebar=a("<div>"),this._addClass(this.uiDialogTitlebar,"ui-dialog-titlebar","ui-widget-header ui-helper-clearfix"),this._on(this.uiDialogTitlebar,{mousedown:function(b){a(b.target).closest(".ui-dialog-titlebar-close")||this.uiDialog.trigger("focus")}}),this.uiDialogTitlebarClose=a("<button type='button'></button>").button({label:a("<a>").text(this.options.closeText).html(),icon:"ui-icon-closethick",showLabel:!1}).appendTo(this.uiDialogTitlebar),this._addClass(this.uiDialogTitlebarClose,"ui-dialog-titlebar-close"),this._on(this.uiDialogTitlebarClose,{click:function(a){a.preventDefault(),this.close(a)}}),b=a("<span>").uniqueId().prependTo(this.uiDialogTitlebar),this._addClass(b,"ui-dialog-title"),this._title(b),this.uiDialogTitlebar.prependTo(this.uiDialog),this.uiDialog.attr({"aria-labelledby":b.attr("id")})},_title:function(a){this.options.title?a.text(this.options.title):a.html("&#160;")},_createButtonPane:function(){this.uiDialogButtonPane=a("<div>"),this._addClass(this.uiDialogButtonPane,"ui-dialog-buttonpane","ui-widget-content ui-helper-clearfix"),this.uiButtonSet=a("<div>").appendTo(this.uiDialogButtonPane),this._addClass(this.uiButtonSet,"ui-dialog-buttonset"),this._createButtons()},_createButtons:function(){var b=this,c=this.options.buttons;return this.uiDialogButtonPane.remove(),this.uiButtonSet.empty(),a.isEmptyObject(c)||a.isArray(c)&&!c.length?void this._removeClass(this.uiDialog,"ui-dialog-buttons"):(a.each(c,function(c,d){var e,f;d=a.isFunction(d)?{click:d,text:c}:d,d=a.extend({type:"button"},d),e=d.click,f={icon:d.icon,iconPosition:d.iconPosition,showLabel:d.showLabel},delete d.click,delete d.icon,delete d.iconPosition,delete d.showLabel,a("<button></button>",d).button(f).appendTo(b.uiButtonSet).on("click",function(){e.apply(b.element[0],arguments)})}),this._addClass(this.uiDialog,"ui-dialog-buttons"),void this.uiDialogButtonPane.appendTo(this.uiDialog))},_makeDraggable:function(){var b=this,c=this.options;function d(a){return{position:a.position,offset:a.offset}}this.uiDialog.draggable({cancel:".ui-dialog-content, .ui-dialog-titlebar-close",handle:".ui-dialog-titlebar",containment:"document",start:function(c,e){b._addClass(a(this),"ui-dialog-dragging"),b._blockFrames(),b._trigger("dragStart",c,d(e))},drag:function(a,c){b._trigger("drag",a,d(c))},stop:function(e,f){var g=f.offset.left-b.document.scrollLeft(),h=f.offset.top-b.document.scrollTop();c.position={my:"left top",at:"left"+(g>=0?"+":"")+g+" top"+(h>=0?"+":"")+h,of:b.window},b._removeClass(a(this),"ui-dialog-dragging"),b._unblockFrames(),b._trigger("dragStop",e,d(f))}})},_makeResizable:function(){var b=this,c=this.options,d=c.resizable,e=this.uiDialog.css("position"),f="string"==typeof d?d:"n,e,s,w,se,sw,ne,nw";function g(a){return{originalPosition:a.originalPosition,originalSize:a.originalSize,position:a.position,size:a.size}}this.uiDialog.resizable({cancel:".ui-dialog-content",containment:"document",alsoResize:this.element,maxWidth:c.maxWidth,maxHeight:c.maxHeight,minWidth:c.minWidth,minHeight:this._minHeight(),handles:f,start:function(c,d){b._addClass(a(this),"ui-dialog-resizing"),b._blockFrames(),b._trigger("resizeStart",c,g(d))},resize:function(a,c){b._trigger("resize",a,g(c))},stop:function(d,e){var f=b.uiDialog.offset(),h=f.left-b.document.scrollLeft(),i=f.top-b.document.scrollTop();c.height=b.uiDialog.height(),c.width=b.uiDialog.width(),c.position={my:"left top",at:"left"+(h>=0?"+":"")+h+" top"+(i>=0?"+":"")+i,of:b.window},b._removeClass(a(this),"ui-dialog-resizing"),b._unblockFrames(),b._trigger("resizeStop",d,g(e))}}).css("position",e)},_trackFocus:function(){this._on(this.widget(),{focusin:function(b){this._makeFocusTarget(),this._focusedElement=a(b.target)}})},_makeFocusTarget:function(){this._untrackInstance(),this._trackingInstances().unshift(this)},_untrackInstance:function(){var b=this._trackingInstances(),c=a.inArray(this,b);c!==-1&&b.splice(c,1)},_trackingInstances:function(){var a=this.document.data("ui-dialog-instances");return a||(a=[],this.document.data("ui-dialog-instances",a)),a},_minHeight:function(){var a=this.options;return"auto"===a.height?a.minHeight:Math.min(a.minHeight,a.height)},_position:function(){var a=this.uiDialog.is(":visible");a||this.uiDialog.show(),this.uiDialog.position(this.options.position),a||this.uiDialog.hide()},_setOptions:function(b){var c=this,d=!1,e={};a.each(b,function(a,b){c._setOption(a,b),a in c.sizeRelatedOptions&&(d=!0),a in c.resizableRelatedOptions&&(e[a]=b)}),d&&(this._size(),this._position()),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option",e)},_setOption:function(b,c){var d,e,f=this.uiDialog;"disabled"!==b&&(this._super(b,c),"appendTo"===b&&this.uiDialog.appendTo(this._appendTo()),"buttons"===b&&this._createButtons(),"closeText"===b&&this.uiDialogTitlebarClose.button({label:a("<a>").text(""+this.options.closeText).html()}),"draggable"===b&&(d=f.is(":data(ui-draggable)"),d&&!c&&f.draggable("destroy"),!d&&c&&this._makeDraggable()),"position"===b&&this._position(),"resizable"===b&&(e=f.is(":data(ui-resizable)"),e&&!c&&f.resizable("destroy"),e&&"string"==typeof c&&f.resizable("option","handles",c),e||c===!1||this._makeResizable()),"title"===b&&this._title(this.uiDialogTitlebar.find(".ui-dialog-title")))},_size:function(){var a,b,c,d=this.options;this.element.show().css({width:"auto",minHeight:0,maxHeight:"none",height:0}),d.minWidth>d.width&&(d.width=d.minWidth),a=this.uiDialog.css({height:"auto",width:d.width}).outerHeight(),b=Math.max(0,d.minHeight-a),c="number"==typeof d.maxHeight?Math.max(0,d.maxHeight-a):"none","auto"===d.height?this.element.css({minHeight:b,maxHeight:c,height:"auto"}):this.element.height(Math.max(0,d.height-a)),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option","minHeight",this._minHeight())},_blockFrames:function(){this.iframeBlocks=this.document.find("iframe").map(function(){var b=a(this);return a("<div>").css({position:"absolute",width:b.outerWidth(),height:b.outerHeight()}).appendTo(b.parent()).offset(b.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_allowInteraction:function(b){return!!a(b.target).closest(".ui-dialog").length||!!a(b.target).closest(".ui-datepicker").length},_createOverlay:function(){if(this.options.modal){var b=!0;this._delay(function(){b=!1}),this.document.data("ui-dialog-overlays")||this._on(this.document,{focusin:function(a){b||this._allowInteraction(a)||(a.preventDefault(),this._trackingInstances()[0]._focusTabbable())}}),this.overlay=a("<div>").appendTo(this._appendTo()),this._addClass(this.overlay,null,"ui-widget-overlay ui-front"),this._on(this.overlay,{
mousedown:"_keepFocus"}),this.document.data("ui-dialog-overlays",(this.document.data("ui-dialog-overlays")||0)+1)}},_destroyOverlay:function(){if(this.options.modal&&this.overlay){var a=this.document.data("ui-dialog-overlays")-1;a?this.document.data("ui-dialog-overlays",a):(this._off(this.document,"focusin"),this.document.removeData("ui-dialog-overlays")),this.overlay.remove(),this.overlay=null}}}),a.uiBackCompat!==!1&&a.widget("ui.dialog",a.ui.dialog,{options:{dialogClass:""},_createWrapper:function(){this._super(),this.uiDialog.addClass(this.options.dialogClass)},_setOption:function(a,b){"dialogClass"===a&&this.uiDialog.removeClass(this.options.dialogClass).addClass(b),this._superApply(arguments)}});var ga=a.ui.dialog;a.widget("ui.droppable",{version:"1.12.0",widgetEventPrefix:"drop",options:{accept:"*",addClasses:!0,greedy:!1,scope:"default",tolerance:"intersect",activate:null,deactivate:null,drop:null,out:null,over:null},_create:function(){var b,c=this.options,d=c.accept;this.isover=!1,this.isout=!0,this.accept=a.isFunction(d)?d:function(a){return a.is(d)},this.proportions=function(){return arguments.length?void(b=arguments[0]):b?b:b={width:this.element[0].offsetWidth,height:this.element[0].offsetHeight}},this._addToManager(c.scope),c.addClasses&&this._addClass("ui-droppable")},_addToManager:function(b){a.ui.ddmanager.droppables[b]=a.ui.ddmanager.droppables[b]||[],a.ui.ddmanager.droppables[b].push(this)},_splice:function(a){for(var b=0;b<a.length;b++)a[b]===this&&a.splice(b,1)},_destroy:function(){var b=a.ui.ddmanager.droppables[this.options.scope];this._splice(b)},_setOption:function(b,c){if("accept"===b)this.accept=a.isFunction(c)?c:function(a){return a.is(c)};else if("scope"===b){var d=a.ui.ddmanager.droppables[this.options.scope];this._splice(d),this._addToManager(c)}this._super(b,c)},_activate:function(b){var c=a.ui.ddmanager.current;this._addActiveClass(),c&&this._trigger("activate",b,this.ui(c))},_deactivate:function(b){var c=a.ui.ddmanager.current;this._removeActiveClass(),c&&this._trigger("deactivate",b,this.ui(c))},_over:function(b){var c=a.ui.ddmanager.current;c&&(c.currentItem||c.element)[0]!==this.element[0]&&this.accept.call(this.element[0],c.currentItem||c.element)&&(this._addHoverClass(),this._trigger("over",b,this.ui(c)))},_out:function(b){var c=a.ui.ddmanager.current;c&&(c.currentItem||c.element)[0]!==this.element[0]&&this.accept.call(this.element[0],c.currentItem||c.element)&&(this._removeHoverClass(),this._trigger("out",b,this.ui(c)))},_drop:function(b,c){var d=c||a.ui.ddmanager.current,e=!1;return!(!d||(d.currentItem||d.element)[0]===this.element[0])&&(this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function(){var c=a(this).droppable("instance");if(c.options.greedy&&!c.options.disabled&&c.options.scope===d.options.scope&&c.accept.call(c.element[0],d.currentItem||d.element)&&ha(d,a.extend(c,{offset:c.element.offset()}),c.options.tolerance,b))return e=!0,!1}),!e&&(!!this.accept.call(this.element[0],d.currentItem||d.element)&&(this._removeActiveClass(),this._removeHoverClass(),this._trigger("drop",b,this.ui(d)),this.element)))},ui:function(a){return{draggable:a.currentItem||a.element,helper:a.helper,position:a.position,offset:a.positionAbs}},_addHoverClass:function(){this._addClass("ui-droppable-hover")},_removeHoverClass:function(){this._removeClass("ui-droppable-hover")},_addActiveClass:function(){this._addClass("ui-droppable-active")},_removeActiveClass:function(){this._removeClass("ui-droppable-active")}});var ha=a.ui.intersect=function(){function a(a,b,c){return a>=b&&a<b+c}return function(b,c,d,e){if(!c.offset)return!1;var f=(b.positionAbs||b.position.absolute).left+b.margins.left,g=(b.positionAbs||b.position.absolute).top+b.margins.top,h=f+b.helperProportions.width,i=g+b.helperProportions.height,j=c.offset.left,k=c.offset.top,l=j+c.proportions().width,m=k+c.proportions().height;switch(d){case"fit":return j<=f&&h<=l&&k<=g&&i<=m;case"intersect":return j<f+b.helperProportions.width/2&&h-b.helperProportions.width/2<l&&k<g+b.helperProportions.height/2&&i-b.helperProportions.height/2<m;case"pointer":return a(e.pageY,k,c.proportions().height)&&a(e.pageX,j,c.proportions().width);case"touch":return(g>=k&&g<=m||i>=k&&i<=m||g<k&&i>m)&&(f>=j&&f<=l||h>=j&&h<=l||f<j&&h>l);default:return!1}}}();a.ui.ddmanager={current:null,droppables:{default:[]},prepareOffsets:function(b,c){var d,e,f=a.ui.ddmanager.droppables[b.options.scope]||[],g=c?c.type:null,h=(b.currentItem||b.element).find(":data(ui-droppable)").addBack();a:for(d=0;d<f.length;d++)if(!(f[d].options.disabled||b&&!f[d].accept.call(f[d].element[0],b.currentItem||b.element))){for(e=0;e<h.length;e++)if(h[e]===f[d].element[0]){f[d].proportions().height=0;continue a}f[d].visible="none"!==f[d].element.css("display"),f[d].visible&&("mousedown"===g&&f[d]._activate.call(f[d],c),f[d].offset=f[d].element.offset(),f[d].proportions({width:f[d].element[0].offsetWidth,height:f[d].element[0].offsetHeight}))}},drop:function(b,c){var d=!1;return a.each((a.ui.ddmanager.droppables[b.options.scope]||[]).slice(),function(){this.options&&(!this.options.disabled&&this.visible&&ha(b,this,this.options.tolerance,c)&&(d=this._drop.call(this,c)||d),!this.options.disabled&&this.visible&&this.accept.call(this.element[0],b.currentItem||b.element)&&(this.isout=!0,this.isover=!1,this._deactivate.call(this,c)))}),d},dragStart:function(b,c){b.element.parentsUntil("body").on("scroll.droppable",function(){b.options.refreshPositions||a.ui.ddmanager.prepareOffsets(b,c)})},drag:function(b,c){b.options.refreshPositions&&a.ui.ddmanager.prepareOffsets(b,c),a.each(a.ui.ddmanager.droppables[b.options.scope]||[],function(){if(!this.options.disabled&&!this.greedyChild&&this.visible){var d,e,f,g=ha(b,this,this.options.tolerance,c),h=!g&&this.isover?"isout":g&&!this.isover?"isover":null;h&&(this.options.greedy&&(e=this.options.scope,f=this.element.parents(":data(ui-droppable)").filter(function(){return a(this).droppable("instance").options.scope===e}),f.length&&(d=a(f[0]).droppable("instance"),d.greedyChild="isover"===h)),d&&"isover"===h&&(d.isover=!1,d.isout=!0,d._out.call(d,c)),this[h]=!0,this["isout"===h?"isover":"isout"]=!1,this["isover"===h?"_over":"_out"].call(this,c),d&&"isout"===h&&(d.isout=!1,d.isover=!0,d._over.call(d,c)))}})},dragStop:function(b,c){b.element.parentsUntil("body").off("scroll.droppable"),b.options.refreshPositions||a.ui.ddmanager.prepareOffsets(b,c)}},a.uiBackCompat!==!1&&a.widget("ui.droppable",a.ui.droppable,{options:{hoverClass:!1,activeClass:!1},_addActiveClass:function(){this._super(),this.options.activeClass&&this.element.addClass(this.options.activeClass)},_removeActiveClass:function(){this._super(),this.options.activeClass&&this.element.removeClass(this.options.activeClass)},_addHoverClass:function(){this._super(),this.options.hoverClass&&this.element.addClass(this.options.hoverClass)},_removeHoverClass:function(){this._super(),this.options.hoverClass&&this.element.removeClass(this.options.hoverClass)}});var ia=a.ui.droppable,ja=a.widget("ui.progressbar",{version:"1.12.0",options:{classes:{"ui-progressbar":"ui-corner-all","ui-progressbar-value":"ui-corner-left","ui-progressbar-complete":"ui-corner-right"},max:100,value:0,change:null,complete:null},min:0,_create:function(){this.oldValue=this.options.value=this._constrainedValue(),this.element.attr({role:"progressbar","aria-valuemin":this.min}),this._addClass("ui-progressbar","ui-widget ui-widget-content"),this.valueDiv=a("<div>").appendTo(this.element),this._addClass(this.valueDiv,"ui-progressbar-value","ui-widget-header"),this._refreshValue()},_destroy:function(){this.element.removeAttr("role aria-valuemin aria-valuemax aria-valuenow"),this.valueDiv.remove()},value:function(a){return void 0===a?this.options.value:(this.options.value=this._constrainedValue(a),void this._refreshValue())},_constrainedValue:function(a){return void 0===a&&(a=this.options.value),this.indeterminate=a===!1,"number"!=typeof a&&(a=0),!this.indeterminate&&Math.min(this.options.max,Math.max(this.min,a))},_setOptions:function(a){var b=a.value;delete a.value,this._super(a),this.options.value=this._constrainedValue(b),this._refreshValue()},_setOption:function(a,b){"max"===a&&(b=Math.max(this.min,b)),this._super(a,b)},_setOptionDisabled:function(a){this._super(a),this.element.attr("aria-disabled",a),this._toggleClass(null,"ui-state-disabled",!!a)},_percentage:function(){return this.indeterminate?100:100*(this.options.value-this.min)/(this.options.max-this.min)},_refreshValue:function(){var b=this.options.value,c=this._percentage();this.valueDiv.toggle(this.indeterminate||b>this.min).width(c.toFixed(0)+"%"),this._toggleClass(this.valueDiv,"ui-progressbar-complete",null,b===this.options.max)._toggleClass("ui-progressbar-indeterminate",null,this.indeterminate),this.indeterminate?(this.element.removeAttr("aria-valuenow"),this.overlayDiv||(this.overlayDiv=a("<div>").appendTo(this.valueDiv),this._addClass(this.overlayDiv,"ui-progressbar-overlay"))):(this.element.attr({"aria-valuemax":this.options.max,"aria-valuenow":b}),this.overlayDiv&&(this.overlayDiv.remove(),this.overlayDiv=null)),this.oldValue!==b&&(this.oldValue=b,this._trigger("change")),b===this.options.max&&this._trigger("complete")}}),ka=a.widget("ui.selectable",a.ui.mouse,{version:"1.12.0",options:{appendTo:"body",autoRefresh:!0,distance:0,filter:"*",tolerance:"touch",selected:null,selecting:null,start:null,stop:null,unselected:null,unselecting:null},_create:function(){var b=this;this._addClass("ui-selectable"),this.dragged=!1,this.refresh=function(){b.elementPos=a(b.element[0]).offset(),b.selectees=a(b.options.filter,b.element[0]),b._addClass(b.selectees,"ui-selectee"),b.selectees.each(function(){var c=a(this),d=c.offset(),e={left:d.left-b.elementPos.left,top:d.top-b.elementPos.top};a.data(this,"selectable-item",{element:this,$element:c,left:e.left,top:e.top,right:e.left+c.outerWidth(),bottom:e.top+c.outerHeight(),startselected:!1,selected:c.hasClass("ui-selected"),selecting:c.hasClass("ui-selecting"),unselecting:c.hasClass("ui-unselecting")})})},this.refresh(),this._mouseInit(),this.helper=a("<div>"),this._addClass(this.helper,"ui-selectable-helper")},_destroy:function(){this.selectees.removeData("selectable-item"),this._mouseDestroy()},_mouseStart:function(b){var c=this,d=this.options;this.opos=[b.pageX,b.pageY],this.elementPos=a(this.element[0]).offset(),this.options.disabled||(this.selectees=a(d.filter,this.element[0]),this._trigger("start",b),a(d.appendTo).append(this.helper),this.helper.css({left:b.pageX,top:b.pageY,width:0,height:0}),d.autoRefresh&&this.refresh(),this.selectees.filter(".ui-selected").each(function(){var d=a.data(this,"selectable-item");d.startselected=!0,b.metaKey||b.ctrlKey||(c._removeClass(d.$element,"ui-selected"),d.selected=!1,c._addClass(d.$element,"ui-unselecting"),d.unselecting=!0,c._trigger("unselecting",b,{unselecting:d.element}))}),a(b.target).parents().addBack().each(function(){var d,e=a.data(this,"selectable-item");if(e)return d=!b.metaKey&&!b.ctrlKey||!e.$element.hasClass("ui-selected"),c._removeClass(e.$element,d?"ui-unselecting":"ui-selected")._addClass(e.$element,d?"ui-selecting":"ui-unselecting"),e.unselecting=!d,e.selecting=d,e.selected=d,d?c._trigger("selecting",b,{selecting:e.element}):c._trigger("unselecting",b,{unselecting:e.element}),!1}))},_mouseDrag:function(b){if(this.dragged=!0,!this.options.disabled){var c,d=this,e=this.options,f=this.opos[0],g=this.opos[1],h=b.pageX,i=b.pageY;return f>h&&(c=h,h=f,f=c),g>i&&(c=i,i=g,g=c),this.helper.css({left:f,top:g,width:h-f,height:i-g}),this.selectees.each(function(){var c=a.data(this,"selectable-item"),j=!1,k={};c&&c.element!==d.element[0]&&(k.left=c.left+d.elementPos.left,k.right=c.right+d.elementPos.left,k.top=c.top+d.elementPos.top,k.bottom=c.bottom+d.elementPos.top,"touch"===e.tolerance?j=!(k.left>h||k.right<f||k.top>i||k.bottom<g):"fit"===e.tolerance&&(j=k.left>f&&k.right<h&&k.top>g&&k.bottom<i),j?(c.selected&&(d._removeClass(c.$element,"ui-selected"),c.selected=!1),c.unselecting&&(d._removeClass(c.$element,"ui-unselecting"),c.unselecting=!1),c.selecting||(d._addClass(c.$element,"ui-selecting"),c.selecting=!0,d._trigger("selecting",b,{selecting:c.element}))):(c.selecting&&((b.metaKey||b.ctrlKey)&&c.startselected?(d._removeClass(c.$element,"ui-selecting"),c.selecting=!1,d._addClass(c.$element,"ui-selected"),c.selected=!0):(d._removeClass(c.$element,"ui-selecting"),c.selecting=!1,c.startselected&&(d._addClass(c.$element,"ui-unselecting"),c.unselecting=!0),d._trigger("unselecting",b,{unselecting:c.element}))),c.selected&&(b.metaKey||b.ctrlKey||c.startselected||(d._removeClass(c.$element,"ui-selected"),c.selected=!1,d._addClass(c.$element,"ui-unselecting"),c.unselecting=!0,d._trigger("unselecting",b,{unselecting:c.element})))))}),!1}},_mouseStop:function(b){var c=this;return this.dragged=!1,a(".ui-unselecting",this.element[0]).each(function(){var d=a.data(this,"selectable-item");c._removeClass(d.$element,"ui-unselecting"),d.unselecting=!1,d.startselected=!1,c._trigger("unselected",b,{unselected:d.element})}),a(".ui-selecting",this.element[0]).each(function(){var d=a.data(this,"selectable-item");c._removeClass(d.$element,"ui-selecting")._addClass(d.$element,"ui-selected"),d.selecting=!1,d.selected=!0,d.startselected=!0,c._trigger("selected",b,{selected:d.element})}),this._trigger("stop",b),this.helper.remove(),!1}}),la=a.widget("ui.selectmenu",[a.ui.formResetMixin,{version:"1.12.0",defaultElement:"<select>",options:{appendTo:null,classes:{"ui-selectmenu-button-open":"ui-corner-top","ui-selectmenu-button-closed":"ui-corner-all"},disabled:null,icons:{button:"ui-icon-triangle-1-s"},position:{my:"left top",at:"left bottom",collision:"none"},width:!1,change:null,close:null,focus:null,open:null,select:null},_create:function(){var b=this.element.uniqueId().attr("id");this.ids={element:b,button:b+"-button",menu:b+"-menu"},this._drawButton(),this._drawMenu(),this._bindFormResetHandler(),this._rendered=!1,this.menuItems=a()},_drawButton:function(){var b,c=this,d=this._parseOption(this.element.find("option:selected"),this.element[0].selectedIndex);this.labels=this.element.labels().attr("for",this.ids.button),this._on(this.labels,{click:function(a){this.button.focus(),a.preventDefault()}}),this.element.hide(),this.button=a("<span>",{tabindex:this.options.disabled?-1:0,id:this.ids.button,role:"combobox","aria-expanded":"false","aria-autocomplete":"list","aria-owns":this.ids.menu,"aria-haspopup":"true",title:this.element.attr("title")}).insertAfter(this.element),this._addClass(this.button,"ui-selectmenu-button ui-selectmenu-button-closed","ui-button ui-widget"),b=a("<span>").appendTo(this.button),this._addClass(b,"ui-selectmenu-icon","ui-icon "+this.options.icons.button),this.buttonItem=this._renderButtonItem(d).appendTo(this.button),this.options.width!==!1&&this._resizeButton(),this._on(this.button,this._buttonEvents),this.button.one("focusin",function(){c._rendered||c._refreshMenu()})},_drawMenu:function(){var b=this;this.menu=a("<ul>",{"aria-hidden":"true","aria-labelledby":this.ids.button,id:this.ids.menu}),this.menuWrap=a("<div>").append(this.menu),this._addClass(this.menuWrap,"ui-selectmenu-menu","ui-front"),this.menuWrap.appendTo(this._appendTo()),this.menuInstance=this.menu.menu({classes:{"ui-menu":"ui-corner-bottom"},role:"listbox",select:function(a,c){a.preventDefault(),b._setSelection(),b._select(c.item.data("ui-selectmenu-item"),a)},focus:function(a,c){var d=c.item.data("ui-selectmenu-item");null!=b.focusIndex&&d.index!==b.focusIndex&&(b._trigger("focus",a,{item:d}),b.isOpen||b._select(d,a)),b.focusIndex=d.index,b.button.attr("aria-activedescendant",b.menuItems.eq(d.index).attr("id"))}}).menu("instance"),this.menuInstance._off(this.menu,"mouseleave"),this.menuInstance._closeOnDocumentClick=function(){return!1},this.menuInstance._isDivider=function(){return!1}},refresh:function(){this._refreshMenu(),this.buttonItem.replaceWith(this.buttonItem=this._renderButtonItem(this._getSelectedItem().data("ui-selectmenu-item")||{})),null===this.options.width&&this._resizeButton()},_refreshMenu:function(){var a,b=this.element.find("option");this.menu.empty(),this._parseOptions(b),this._renderMenu(this.menu,this.items),this.menuInstance.refresh(),this.menuItems=this.menu.find("li").not(".ui-selectmenu-optgroup").find(".ui-menu-item-wrapper"),this._rendered=!0,b.length&&(a=this._getSelectedItem(),this.menuInstance.focus(null,a),this._setAria(a.data("ui-selectmenu-item")),this._setOption("disabled",this.element.prop("disabled")))},open:function(a){this.options.disabled||(this._rendered?(this._removeClass(this.menu.find(".ui-state-active"),null,"ui-state-active"),this.menuInstance.focus(null,this._getSelectedItem())):this._refreshMenu(),this.menuItems.length&&(this.isOpen=!0,this._toggleAttr(),this._resizeMenu(),this._position(),this._on(this.document,this._documentClick),this._trigger("open",a)))},_position:function(){this.menuWrap.position(a.extend({of:this.button},this.options.position))},close:function(a){this.isOpen&&(this.isOpen=!1,this._toggleAttr(),this.range=null,this._off(this.document),this._trigger("close",a))},widget:function(){return this.button},menuWidget:function(){return this.menu},_renderButtonItem:function(b){var c=a("<span>");return this._setText(c,b.label),this._addClass(c,"ui-selectmenu-text"),c},_renderMenu:function(b,c){var d=this,e="";a.each(c,function(c,f){var g;f.optgroup!==e&&(g=a("<li>",{text:f.optgroup}),d._addClass(g,"ui-selectmenu-optgroup","ui-menu-divider"+(f.element.parent("optgroup").prop("disabled")?" ui-state-disabled":"")),g.appendTo(b),e=f.optgroup),d._renderItemData(b,f)})},_renderItemData:function(a,b){return this._renderItem(a,b).data("ui-selectmenu-item",b)},_renderItem:function(b,c){var d=a("<li>"),e=a("<div>",{title:c.element.attr("title")});return c.disabled&&this._addClass(d,null,"ui-state-disabled"),this._setText(e,c.label),d.append(e).appendTo(b)},_setText:function(a,b){b?a.text(b):a.html("&#160;")},_move:function(a,b){var c,d,e=".ui-menu-item";this.isOpen?c=this.menuItems.eq(this.focusIndex).parent("li"):(c=this.menuItems.eq(this.element[0].selectedIndex).parent("li"),e+=":not(.ui-state-disabled)"),d="first"===a||"last"===a?c["first"===a?"prevAll":"nextAll"](e).eq(-1):c[a+"All"](e).eq(0),d.length&&this.menuInstance.focus(b,d)},_getSelectedItem:function(){return this.menuItems.eq(this.element[0].selectedIndex).parent("li")},_toggle:function(a){this[this.isOpen?"close":"open"](a)},_setSelection:function(){var a;this.range&&(window.getSelection?(a=window.getSelection(),a.removeAllRanges(),a.addRange(this.range)):this.range.select(),this.button.focus())},_documentClick:{mousedown:function(b){this.isOpen&&(a(b.target).closest(".ui-selectmenu-menu, #"+a.ui.escapeSelector(this.ids.button)).length||this.close(b))}},_buttonEvents:{mousedown:function(){var a;window.getSelection?(a=window.getSelection(),a.rangeCount&&(this.range=a.getRangeAt(0))):this.range=document.selection.createRange()},click:function(a){this._setSelection(),this._toggle(a)},keydown:function(b){var c=!0;switch(b.keyCode){case a.ui.keyCode.TAB:case a.ui.keyCode.ESCAPE:this.close(b),c=!1;break;case a.ui.keyCode.ENTER:this.isOpen&&this._selectFocusedItem(b);break;case a.ui.keyCode.UP:b.altKey?this._toggle(b):this._move("prev",b);break;case a.ui.keyCode.DOWN:b.altKey?this._toggle(b):this._move("next",b);break;case a.ui.keyCode.SPACE:this.isOpen?this._selectFocusedItem(b):this._toggle(b);break;case a.ui.keyCode.LEFT:this._move("prev",b);break;case a.ui.keyCode.RIGHT:this._move("next",b);break;case a.ui.keyCode.HOME:case a.ui.keyCode.PAGE_UP:this._move("first",b);break;case a.ui.keyCode.END:case a.ui.keyCode.PAGE_DOWN:this._move("last",b);break;default:this.menu.trigger(b),c=!1}c&&b.preventDefault()}},_selectFocusedItem:function(a){var b=this.menuItems.eq(this.focusIndex).parent("li");b.hasClass("ui-state-disabled")||this._select(b.data("ui-selectmenu-item"),a)},_select:function(a,b){var c=this.element[0].selectedIndex;this.element[0].selectedIndex=a.index,this.buttonItem.replaceWith(this.buttonItem=this._renderButtonItem(a)),this._setAria(a),this._trigger("select",b,{item:a}),a.index!==c&&this._trigger("change",b,{item:a}),this.close(b)},_setAria:function(a){var b=this.menuItems.eq(a.index).attr("id");this.button.attr({"aria-labelledby":b,"aria-activedescendant":b}),this.menu.attr("aria-activedescendant",b)},_setOption:function(a,b){if("icons"===a){var c=this.button.find("span.ui-icon");this._removeClass(c,null,this.options.icons.button)._addClass(c,null,b.button)}this._super(a,b),"appendTo"===a&&this.menuWrap.appendTo(this._appendTo()),"width"===a&&this._resizeButton()},_setOptionDisabled:function(a){this._super(a),this.menuInstance.option("disabled",a),this.button.attr("aria-disabled",a),this._toggleClass(this.button,null,"ui-state-disabled",a),this.element.prop("disabled",a),a?(this.button.attr("tabindex",-1),this.close()):this.button.attr("tabindex",0)},_appendTo:function(){var b=this.options.appendTo;return b&&(b=b.jquery||b.nodeType?a(b):this.document.find(b).eq(0)),b&&b[0]||(b=this.element.closest(".ui-front, dialog")),b.length||(b=this.document[0].body),b},_toggleAttr:function(){this.button.attr("aria-expanded",this.isOpen),this._removeClass(this.button,"ui-selectmenu-button-"+(this.isOpen?"closed":"open"))._addClass(this.button,"ui-selectmenu-button-"+(this.isOpen?"open":"closed"))._toggleClass(this.menuWrap,"ui-selectmenu-open",null,this.isOpen),this.menu.attr("aria-hidden",!this.isOpen)},_resizeButton:function(){var a=this.options.width;return a===!1?void this.button.css("width",""):(null===a&&(a=this.element.show().outerWidth(),this.element.hide()),void this.button.outerWidth(a))},_resizeMenu:function(){this.menu.outerWidth(Math.max(this.button.outerWidth(),this.menu.width("").outerWidth()+1))},_getCreateOptions:function(){var a=this._super();return a.disabled=this.element.prop("disabled"),a},_parseOptions:function(b){var c=this,d=[];b.each(function(b,e){d.push(c._parseOption(a(e),b))}),this.items=d},_parseOption:function(a,b){var c=a.parent("optgroup");return{element:a,index:b,value:a.val(),label:a.text(),optgroup:c.attr("label")||"",disabled:c.prop("disabled")||a.prop("disabled")}},_destroy:function(){this._unbindFormResetHandler(),this.menuWrap.remove(),this.button.remove(),this.element.show(),this.element.removeUniqueId(),this.labels.attr("for",this.ids.element)}}]),ma=a.widget("ui.slider",a.ui.mouse,{version:"1.12.0",widgetEventPrefix:"slide",options:{animate:!1,classes:{"ui-slider":"ui-corner-all","ui-slider-handle":"ui-corner-all","ui-slider-range":"ui-corner-all ui-widget-header"},distance:0,max:100,min:0,orientation:"horizontal",range:!1,step:1,value:0,values:null,change:null,slide:null,start:null,stop:null},numPages:5,_create:function(){this._keySliding=!1,this._mouseSliding=!1,this._animateOff=!0,this._handleIndex=null,this._detectOrientation(),this._mouseInit(),this._calculateNewMax(),this._addClass("ui-slider ui-slider-"+this.orientation,"ui-widget ui-widget-content"),this._refresh(),this._animateOff=!1},_refresh:function(){this._createRange(),this._createHandles(),this._setupEvents(),this._refreshValue()},_createHandles:function(){var b,c,d=this.options,e=this.element.find(".ui-slider-handle"),f="<span tabindex='0'></span>",g=[];for(c=d.values&&d.values.length||1,e.length>c&&(e.slice(c).remove(),e=e.slice(0,c)),b=e.length;b<c;b++)g.push(f);this.handles=e.add(a(g.join("")).appendTo(this.element)),this._addClass(this.handles,"ui-slider-handle","ui-state-default"),this.handle=this.handles.eq(0),this.handles.each(function(b){a(this).data("ui-slider-handle-index",b)})},_createRange:function(){var b=this.options;b.range?(b.range===!0&&(b.values?b.values.length&&2!==b.values.length?b.values=[b.values[0],b.values[0]]:a.isArray(b.values)&&(b.values=b.values.slice(0)):b.values=[this._valueMin(),this._valueMin()]),this.range&&this.range.length?(this._removeClass(this.range,"ui-slider-range-min ui-slider-range-max"),this.range.css({left:"",bottom:""})):(this.range=a("<div>").appendTo(this.element),this._addClass(this.range,"ui-slider-range")),"min"!==b.range&&"max"!==b.range||this._addClass(this.range,"ui-slider-range-"+b.range)):(this.range&&this.range.remove(),this.range=null)},_setupEvents:function(){this._off(this.handles),this._on(this.handles,this._handleEvents),this._hoverable(this.handles),this._focusable(this.handles)},_destroy:function(){this.handles.remove(),this.range&&this.range.remove(),this._mouseDestroy()},_mouseCapture:function(b){var c,d,e,f,g,h,i,j,k=this,l=this.options;return!l.disabled&&(this.elementSize={width:this.element.outerWidth(),height:this.element.outerHeight()},this.elementOffset=this.element.offset(),c={x:b.pageX,y:b.pageY},d=this._normValueFromMouse(c),e=this._valueMax()-this._valueMin()+1,this.handles.each(function(b){var c=Math.abs(d-k.values(b));(e>c||e===c&&(b===k._lastChangedValue||k.values(b)===l.min))&&(e=c,f=a(this),g=b)}),h=this._start(b,g),h!==!1&&(this._mouseSliding=!0,this._handleIndex=g,this._addClass(f,null,"ui-state-active"),f.trigger("focus"),i=f.offset(),j=!a(b.target).parents().addBack().is(".ui-slider-handle"),this._clickOffset=j?{left:0,top:0}:{left:b.pageX-i.left-f.width()/2,top:b.pageY-i.top-f.height()/2-(parseInt(f.css("borderTopWidth"),10)||0)-(parseInt(f.css("borderBottomWidth"),10)||0)+(parseInt(f.css("marginTop"),10)||0)},this.handles.hasClass("ui-state-hover")||this._slide(b,g,d),this._animateOff=!0,!0))},_mouseStart:function(){return!0},_mouseDrag:function(a){var b={x:a.pageX,y:a.pageY},c=this._normValueFromMouse(b);return this._slide(a,this._handleIndex,c),!1},_mouseStop:function(a){return this._removeClass(this.handles,null,"ui-state-active"),this._mouseSliding=!1,this._stop(a,this._handleIndex),this._change(a,this._handleIndex),this._handleIndex=null,this._clickOffset=null,this._animateOff=!1,!1},_detectOrientation:function(){this.orientation="vertical"===this.options.orientation?"vertical":"horizontal"},_normValueFromMouse:function(a){var b,c,d,e,f;return"horizontal"===this.orientation?(b=this.elementSize.width,c=a.x-this.elementOffset.left-(this._clickOffset?this._clickOffset.left:0)):(b=this.elementSize.height,c=a.y-this.elementOffset.top-(this._clickOffset?this._clickOffset.top:0)),d=c/b,d>1&&(d=1),d<0&&(d=0),"vertical"===this.orientation&&(d=1-d),e=this._valueMax()-this._valueMin(),f=this._valueMin()+d*e,this._trimAlignValue(f)},_uiHash:function(a,b,c){var d={handle:this.handles[a],handleIndex:a,value:void 0!==b?b:this.value()};return this._hasMultipleValues()&&(d.value=void 0!==b?b:this.values(a),d.values=c||this.values()),d},_hasMultipleValues:function(){return this.options.values&&this.options.values.length},_start:function(a,b){return this._trigger("start",a,this._uiHash(b))},_slide:function(a,b,c){var d,e,f=this.value(),g=this.values();this._hasMultipleValues()&&(e=this.values(b?0:1),f=this.values(b),2===this.options.values.length&&this.options.range===!0&&(c=0===b?Math.min(e,c):Math.max(e,c)),g[b]=c),c!==f&&(d=this._trigger("slide",a,this._uiHash(b,c,g)),d!==!1&&(this._hasMultipleValues()?this.values(b,c):this.value(c)))},_stop:function(a,b){this._trigger("stop",a,this._uiHash(b))},_change:function(a,b){this._keySliding||this._mouseSliding||(this._lastChangedValue=b,this._trigger("change",a,this._uiHash(b)))},value:function(a){return arguments.length?(this.options.value=this._trimAlignValue(a),this._refreshValue(),void this._change(null,0)):this._value()},values:function(b,c){var d,e,f;if(arguments.length>1)return this.options.values[b]=this._trimAlignValue(c),this._refreshValue(),void this._change(null,b);if(!arguments.length)return this._values();if(!a.isArray(arguments[0]))return this._hasMultipleValues()?this._values(b):this.value();for(d=this.options.values,e=arguments[0],f=0;f<d.length;f+=1)d[f]=this._trimAlignValue(e[f]),this._change(null,f);this._refreshValue()},_setOption:function(b,c){var d,e=0;switch("range"===b&&this.options.range===!0&&("min"===c?(this.options.value=this._values(0),this.options.values=null):"max"===c&&(this.options.value=this._values(this.options.values.length-1),this.options.values=null)),a.isArray(this.options.values)&&(e=this.options.values.length),this._super(b,c),b){case"orientation":this._detectOrientation(),this._removeClass("ui-slider-horizontal ui-slider-vertical")._addClass("ui-slider-"+this.orientation),this._refreshValue(),this.options.range&&this._refreshRange(c),this.handles.css("horizontal"===c?"bottom":"left","");break;case"value":this._animateOff=!0,this._refreshValue(),this._change(null,0),this._animateOff=!1;break;case"values":for(this._animateOff=!0,this._refreshValue(),d=e-1;d>=0;d--)this._change(null,d);this._animateOff=!1;break;case"step":case"min":case"max":this._animateOff=!0,this._calculateNewMax(),this._refreshValue(),this._animateOff=!1;break;case"range":this._animateOff=!0,this._refresh(),this._animateOff=!1}},_setOptionDisabled:function(a){this._super(a),this._toggleClass(null,"ui-state-disabled",!!a)},_value:function(){var a=this.options.value;return a=this._trimAlignValue(a)},_values:function(a){var b,c,d;if(arguments.length)return b=this.options.values[a],b=this._trimAlignValue(b);if(this._hasMultipleValues()){for(c=this.options.values.slice(),d=0;d<c.length;d+=1)c[d]=this._trimAlignValue(c[d]);return c}return[]},_trimAlignValue:function(a){if(a<=this._valueMin())return this._valueMin();if(a>=this._valueMax())return this._valueMax();var b=this.options.step>0?this.options.step:1,c=(a-this._valueMin())%b,d=a-c;return 2*Math.abs(c)>=b&&(d+=c>0?b:-b),parseFloat(d.toFixed(5))},_calculateNewMax:function(){var a=this.options.max,b=this._valueMin(),c=this.options.step,d=Math.round((a-b)/c)*c;a=d+b,a>this.options.max&&(a-=c),this.max=parseFloat(a.toFixed(this._precision()))},_precision:function(){var a=this._precisionOf(this.options.step);return null!==this.options.min&&(a=Math.max(a,this._precisionOf(this.options.min))),a},_precisionOf:function(a){var b=a.toString(),c=b.indexOf(".");return c===-1?0:b.length-c-1},_valueMin:function(){return this.options.min},_valueMax:function(){return this.max},_refreshRange:function(a){"vertical"===a&&this.range.css({width:"",left:""}),"horizontal"===a&&this.range.css({height:"",bottom:""})},_refreshValue:function(){var b,c,d,e,f,g=this.options.range,h=this.options,i=this,j=!this._animateOff&&h.animate,k={};this._hasMultipleValues()?this.handles.each(function(d){c=(i.values(d)-i._valueMin())/(i._valueMax()-i._valueMin())*100,k["horizontal"===i.orientation?"left":"bottom"]=c+"%",a(this).stop(1,1)[j?"animate":"css"](k,h.animate),i.options.range===!0&&("horizontal"===i.orientation?(0===d&&i.range.stop(1,1)[j?"animate":"css"]({left:c+"%"},h.animate),1===d&&i.range[j?"animate":"css"]({width:c-b+"%"},{queue:!1,duration:h.animate})):(0===d&&i.range.stop(1,1)[j?"animate":"css"]({bottom:c+"%"},h.animate),1===d&&i.range[j?"animate":"css"]({height:c-b+"%"},{queue:!1,duration:h.animate}))),b=c}):(d=this.value(),e=this._valueMin(),f=this._valueMax(),c=f!==e?(d-e)/(f-e)*100:0,k["horizontal"===this.orientation?"left":"bottom"]=c+"%",this.handle.stop(1,1)[j?"animate":"css"](k,h.animate),"min"===g&&"horizontal"===this.orientation&&this.range.stop(1,1)[j?"animate":"css"]({width:c+"%"},h.animate),"max"===g&&"horizontal"===this.orientation&&this.range.stop(1,1)[j?"animate":"css"]({width:100-c+"%"},h.animate),"min"===g&&"vertical"===this.orientation&&this.range.stop(1,1)[j?"animate":"css"]({height:c+"%"},h.animate),"max"===g&&"vertical"===this.orientation&&this.range.stop(1,1)[j?"animate":"css"]({height:100-c+"%"},h.animate))},_handleEvents:{keydown:function(b){var c,d,e,f,g=a(b.target).data("ui-slider-handle-index");switch(b.keyCode){case a.ui.keyCode.HOME:case a.ui.keyCode.END:case a.ui.keyCode.PAGE_UP:case a.ui.keyCode.PAGE_DOWN:case a.ui.keyCode.UP:case a.ui.keyCode.RIGHT:case a.ui.keyCode.DOWN:case a.ui.keyCode.LEFT:if(b.preventDefault(),!this._keySliding&&(this._keySliding=!0,this._addClass(a(b.target),null,"ui-state-active"),
c=this._start(b,g),c===!1))return}switch(f=this.options.step,d=e=this._hasMultipleValues()?this.values(g):this.value(),b.keyCode){case a.ui.keyCode.HOME:e=this._valueMin();break;case a.ui.keyCode.END:e=this._valueMax();break;case a.ui.keyCode.PAGE_UP:e=this._trimAlignValue(d+(this._valueMax()-this._valueMin())/this.numPages);break;case a.ui.keyCode.PAGE_DOWN:e=this._trimAlignValue(d-(this._valueMax()-this._valueMin())/this.numPages);break;case a.ui.keyCode.UP:case a.ui.keyCode.RIGHT:if(d===this._valueMax())return;e=this._trimAlignValue(d+f);break;case a.ui.keyCode.DOWN:case a.ui.keyCode.LEFT:if(d===this._valueMin())return;e=this._trimAlignValue(d-f)}this._slide(b,g,e)},keyup:function(b){var c=a(b.target).data("ui-slider-handle-index");this._keySliding&&(this._keySliding=!1,this._stop(b,c),this._change(b,c),this._removeClass(a(b.target),null,"ui-state-active"))}}}),na=a.widget("ui.sortable",a.ui.mouse,{version:"1.12.0",widgetEventPrefix:"sort",ready:!1,options:{appendTo:"parent",axis:!1,connectWith:!1,containment:!1,cursor:"auto",cursorAt:!1,dropOnEmpty:!0,forcePlaceholderSize:!1,forceHelperSize:!1,grid:!1,handle:!1,helper:"original",items:"> *",opacity:!1,placeholder:!1,revert:!1,scroll:!0,scrollSensitivity:20,scrollSpeed:20,scope:"default",tolerance:"intersect",zIndex:1e3,activate:null,beforeStop:null,change:null,deactivate:null,out:null,over:null,receive:null,remove:null,sort:null,start:null,stop:null,update:null},_isOverAxis:function(a,b,c){return a>=b&&a<b+c},_isFloating:function(a){return/left|right/.test(a.css("float"))||/inline|table-cell/.test(a.css("display"))},_create:function(){this.containerCache={},this._addClass("ui-sortable"),this.refresh(),this.offset=this.element.offset(),this._mouseInit(),this._setHandleClassName(),this.ready=!0},_setOption:function(a,b){this._super(a,b),"handle"===a&&this._setHandleClassName()},_setHandleClassName:function(){var b=this;this._removeClass(this.element.find(".ui-sortable-handle"),"ui-sortable-handle"),a.each(this.items,function(){b._addClass(this.instance.options.handle?this.item.find(this.instance.options.handle):this.item,"ui-sortable-handle")})},_destroy:function(){this._mouseDestroy();for(var a=this.items.length-1;a>=0;a--)this.items[a].item.removeData(this.widgetName+"-item");return this},_mouseCapture:function(b,c){var d=null,e=!1,f=this;return!this.reverting&&(!this.options.disabled&&"static"!==this.options.type&&(this._refreshItems(b),a(b.target).parents().each(function(){if(a.data(this,f.widgetName+"-item")===f)return d=a(this),!1}),a.data(b.target,f.widgetName+"-item")===f&&(d=a(b.target)),!!d&&(!(this.options.handle&&!c&&(a(this.options.handle,d).find("*").addBack().each(function(){this===b.target&&(e=!0)}),!e))&&(this.currentItem=d,this._removeCurrentsFromItems(),!0))))},_mouseStart:function(b,c,d){var e,f,g=this.options;if(this.currentContainer=this,this.refreshPositions(),this.helper=this._createHelper(b),this._cacheHelperProportions(),this._cacheMargins(),this.scrollParent=this.helper.scrollParent(),this.offset=this.currentItem.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},a.extend(this.offset,{click:{left:b.pageX-this.offset.left,top:b.pageY-this.offset.top},parent:this._getParentOffset(),relative:this._getRelativeOffset()}),this.helper.css("position","absolute"),this.cssPosition=this.helper.css("position"),this.originalPosition=this._generatePosition(b),this.originalPageX=b.pageX,this.originalPageY=b.pageY,g.cursorAt&&this._adjustOffsetFromHelper(g.cursorAt),this.domPosition={prev:this.currentItem.prev()[0],parent:this.currentItem.parent()[0]},this.helper[0]!==this.currentItem[0]&&this.currentItem.hide(),this._createPlaceholder(),g.containment&&this._setContainment(),g.cursor&&"auto"!==g.cursor&&(f=this.document.find("body"),this.storedCursor=f.css("cursor"),f.css("cursor",g.cursor),this.storedStylesheet=a("<style>*{ cursor: "+g.cursor+" !important; }</style>").appendTo(f)),g.opacity&&(this.helper.css("opacity")&&(this._storedOpacity=this.helper.css("opacity")),this.helper.css("opacity",g.opacity)),g.zIndex&&(this.helper.css("zIndex")&&(this._storedZIndex=this.helper.css("zIndex")),this.helper.css("zIndex",g.zIndex)),this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName&&(this.overflowOffset=this.scrollParent.offset()),this._trigger("start",b,this._uiHash()),this._preserveHelperProportions||this._cacheHelperProportions(),!d)for(e=this.containers.length-1;e>=0;e--)this.containers[e]._trigger("activate",b,this._uiHash(this));return a.ui.ddmanager&&(a.ui.ddmanager.current=this),a.ui.ddmanager&&!g.dropBehaviour&&a.ui.ddmanager.prepareOffsets(this,b),this.dragging=!0,this._addClass(this.helper,"ui-sortable-helper"),this._mouseDrag(b),!0},_mouseDrag:function(b){var c,d,e,f,g=this.options,h=!1;for(this.position=this._generatePosition(b),this.positionAbs=this._convertPositionTo("absolute"),this.lastPositionAbs||(this.lastPositionAbs=this.positionAbs),this.options.scroll&&(this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName?(this.overflowOffset.top+this.scrollParent[0].offsetHeight-b.pageY<g.scrollSensitivity?this.scrollParent[0].scrollTop=h=this.scrollParent[0].scrollTop+g.scrollSpeed:b.pageY-this.overflowOffset.top<g.scrollSensitivity&&(this.scrollParent[0].scrollTop=h=this.scrollParent[0].scrollTop-g.scrollSpeed),this.overflowOffset.left+this.scrollParent[0].offsetWidth-b.pageX<g.scrollSensitivity?this.scrollParent[0].scrollLeft=h=this.scrollParent[0].scrollLeft+g.scrollSpeed:b.pageX-this.overflowOffset.left<g.scrollSensitivity&&(this.scrollParent[0].scrollLeft=h=this.scrollParent[0].scrollLeft-g.scrollSpeed)):(b.pageY-this.document.scrollTop()<g.scrollSensitivity?h=this.document.scrollTop(this.document.scrollTop()-g.scrollSpeed):this.window.height()-(b.pageY-this.document.scrollTop())<g.scrollSensitivity&&(h=this.document.scrollTop(this.document.scrollTop()+g.scrollSpeed)),b.pageX-this.document.scrollLeft()<g.scrollSensitivity?h=this.document.scrollLeft(this.document.scrollLeft()-g.scrollSpeed):this.window.width()-(b.pageX-this.document.scrollLeft())<g.scrollSensitivity&&(h=this.document.scrollLeft(this.document.scrollLeft()+g.scrollSpeed))),h!==!1&&a.ui.ddmanager&&!g.dropBehaviour&&a.ui.ddmanager.prepareOffsets(this,b)),this.positionAbs=this._convertPositionTo("absolute"),this.options.axis&&"y"===this.options.axis||(this.helper[0].style.left=this.position.left+"px"),this.options.axis&&"x"===this.options.axis||(this.helper[0].style.top=this.position.top+"px"),c=this.items.length-1;c>=0;c--)if(d=this.items[c],e=d.item[0],f=this._intersectsWithPointer(d),f&&d.instance===this.currentContainer&&!(e===this.currentItem[0]||this.placeholder[1===f?"next":"prev"]()[0]===e||a.contains(this.placeholder[0],e)||"semi-dynamic"===this.options.type&&a.contains(this.element[0],e))){if(this.direction=1===f?"down":"up","pointer"!==this.options.tolerance&&!this._intersectsWithSides(d))break;this._rearrange(b,d),this._trigger("change",b,this._uiHash());break}return this._contactContainers(b),a.ui.ddmanager&&a.ui.ddmanager.drag(this,b),this._trigger("sort",b,this._uiHash()),this.lastPositionAbs=this.positionAbs,!1},_mouseStop:function(b,c){if(b){if(a.ui.ddmanager&&!this.options.dropBehaviour&&a.ui.ddmanager.drop(this,b),this.options.revert){var d=this,e=this.placeholder.offset(),f=this.options.axis,g={};f&&"x"!==f||(g.left=e.left-this.offset.parent.left-this.margins.left+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollLeft)),f&&"y"!==f||(g.top=e.top-this.offset.parent.top-this.margins.top+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollTop)),this.reverting=!0,a(this.helper).animate(g,parseInt(this.options.revert,10)||500,function(){d._clear(b)})}else this._clear(b,c);return!1}},cancel:function(){if(this.dragging){this._mouseUp({target:null}),"original"===this.options.helper?(this.currentItem.css(this._storedCSS),this._removeClass(this.currentItem,"ui-sortable-helper")):this.currentItem.show();for(var b=this.containers.length-1;b>=0;b--)this.containers[b]._trigger("deactivate",null,this._uiHash(this)),this.containers[b].containerCache.over&&(this.containers[b]._trigger("out",null,this._uiHash(this)),this.containers[b].containerCache.over=0)}return this.placeholder&&(this.placeholder[0].parentNode&&this.placeholder[0].parentNode.removeChild(this.placeholder[0]),"original"!==this.options.helper&&this.helper&&this.helper[0].parentNode&&this.helper.remove(),a.extend(this,{helper:null,dragging:!1,reverting:!1,_noFinalSort:null}),this.domPosition.prev?a(this.domPosition.prev).after(this.currentItem):a(this.domPosition.parent).prepend(this.currentItem)),this},serialize:function(b){var c=this._getItemsAsjQuery(b&&b.connected),d=[];return b=b||{},a(c).each(function(){var c=(a(b.item||this).attr(b.attribute||"id")||"").match(b.expression||/(.+)[\-=_](.+)/);c&&d.push((b.key||c[1]+"[]")+"="+(b.key&&b.expression?c[1]:c[2]))}),!d.length&&b.key&&d.push(b.key+"="),d.join("&")},toArray:function(b){var c=this._getItemsAsjQuery(b&&b.connected),d=[];return b=b||{},c.each(function(){d.push(a(b.item||this).attr(b.attribute||"id")||"")}),d},_intersectsWith:function(a){var b=this.positionAbs.left,c=b+this.helperProportions.width,d=this.positionAbs.top,e=d+this.helperProportions.height,f=a.left,g=f+a.width,h=a.top,i=h+a.height,j=this.offset.click.top,k=this.offset.click.left,l="x"===this.options.axis||d+j>h&&d+j<i,m="y"===this.options.axis||b+k>f&&b+k<g,n=l&&m;return"pointer"===this.options.tolerance||this.options.forcePointerForContainers||"pointer"!==this.options.tolerance&&this.helperProportions[this.floating?"width":"height"]>a[this.floating?"width":"height"]?n:f<b+this.helperProportions.width/2&&c-this.helperProportions.width/2<g&&h<d+this.helperProportions.height/2&&e-this.helperProportions.height/2<i},_intersectsWithPointer:function(a){var b,c,d="x"===this.options.axis||this._isOverAxis(this.positionAbs.top+this.offset.click.top,a.top,a.height),e="y"===this.options.axis||this._isOverAxis(this.positionAbs.left+this.offset.click.left,a.left,a.width),f=d&&e;return!!f&&(b=this._getDragVerticalDirection(),c=this._getDragHorizontalDirection(),this.floating?"right"===c||"down"===b?2:1:b&&("down"===b?2:1))},_intersectsWithSides:function(a){var b=this._isOverAxis(this.positionAbs.top+this.offset.click.top,a.top+a.height/2,a.height),c=this._isOverAxis(this.positionAbs.left+this.offset.click.left,a.left+a.width/2,a.width),d=this._getDragVerticalDirection(),e=this._getDragHorizontalDirection();return this.floating&&e?"right"===e&&c||"left"===e&&!c:d&&("down"===d&&b||"up"===d&&!b)},_getDragVerticalDirection:function(){var a=this.positionAbs.top-this.lastPositionAbs.top;return 0!==a&&(a>0?"down":"up")},_getDragHorizontalDirection:function(){var a=this.positionAbs.left-this.lastPositionAbs.left;return 0!==a&&(a>0?"right":"left")},refresh:function(a){return this._refreshItems(a),this._setHandleClassName(),this.refreshPositions(),this},_connectWith:function(){var a=this.options;return a.connectWith.constructor===String?[a.connectWith]:a.connectWith},_getItemsAsjQuery:function(b){var c,d,e,f,g=[],h=[],i=this._connectWith();if(i&&b)for(c=i.length-1;c>=0;c--)for(e=a(i[c],this.document[0]),d=e.length-1;d>=0;d--)f=a.data(e[d],this.widgetFullName),f&&f!==this&&!f.options.disabled&&h.push([a.isFunction(f.options.items)?f.options.items.call(f.element):a(f.options.items,f.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),f]);h.push([a.isFunction(this.options.items)?this.options.items.call(this.element,null,{options:this.options,item:this.currentItem}):a(this.options.items,this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),this]);function j(){g.push(this)}for(c=h.length-1;c>=0;c--)h[c][0].each(j);return a(g)},_removeCurrentsFromItems:function(){var b=this.currentItem.find(":data("+this.widgetName+"-item)");this.items=a.grep(this.items,function(a){for(var c=0;c<b.length;c++)if(b[c]===a.item[0])return!1;return!0})},_refreshItems:function(b){this.items=[],this.containers=[this];var c,d,e,f,g,h,i,j,k=this.items,l=[[a.isFunction(this.options.items)?this.options.items.call(this.element[0],b,{item:this.currentItem}):a(this.options.items,this.element),this]],m=this._connectWith();if(m&&this.ready)for(c=m.length-1;c>=0;c--)for(e=a(m[c],this.document[0]),d=e.length-1;d>=0;d--)f=a.data(e[d],this.widgetFullName),f&&f!==this&&!f.options.disabled&&(l.push([a.isFunction(f.options.items)?f.options.items.call(f.element[0],b,{item:this.currentItem}):a(f.options.items,f.element),f]),this.containers.push(f));for(c=l.length-1;c>=0;c--)for(g=l[c][1],h=l[c][0],d=0,j=h.length;d<j;d++)i=a(h[d]),i.data(this.widgetName+"-item",g),k.push({item:i,instance:g,width:0,height:0,left:0,top:0})},refreshPositions:function(b){this.floating=!!this.items.length&&("x"===this.options.axis||this._isFloating(this.items[0].item)),this.offsetParent&&this.helper&&(this.offset.parent=this._getParentOffset());var c,d,e,f;for(c=this.items.length-1;c>=0;c--)d=this.items[c],d.instance!==this.currentContainer&&this.currentContainer&&d.item[0]!==this.currentItem[0]||(e=this.options.toleranceElement?a(this.options.toleranceElement,d.item):d.item,b||(d.width=e.outerWidth(),d.height=e.outerHeight()),f=e.offset(),d.left=f.left,d.top=f.top);if(this.options.custom&&this.options.custom.refreshContainers)this.options.custom.refreshContainers.call(this);else for(c=this.containers.length-1;c>=0;c--)f=this.containers[c].element.offset(),this.containers[c].containerCache.left=f.left,this.containers[c].containerCache.top=f.top,this.containers[c].containerCache.width=this.containers[c].element.outerWidth(),this.containers[c].containerCache.height=this.containers[c].element.outerHeight();return this},_createPlaceholder:function(b){b=b||this;var c,d=b.options;d.placeholder&&d.placeholder.constructor!==String||(c=d.placeholder,d.placeholder={element:function(){var d=b.currentItem[0].nodeName.toLowerCase(),e=a("<"+d+">",b.document[0]);return b._addClass(e,"ui-sortable-placeholder",c||b.currentItem[0].className)._removeClass(e,"ui-sortable-helper"),"tbody"===d?b._createTrPlaceholder(b.currentItem.find("tr").eq(0),a("<tr>",b.document[0]).appendTo(e)):"tr"===d?b._createTrPlaceholder(b.currentItem,e):"img"===d&&e.attr("src",b.currentItem.attr("src")),c||e.css("visibility","hidden"),e},update:function(a,e){c&&!d.forcePlaceholderSize||(e.height()||e.height(b.currentItem.innerHeight()-parseInt(b.currentItem.css("paddingTop")||0,10)-parseInt(b.currentItem.css("paddingBottom")||0,10)),e.width()||e.width(b.currentItem.innerWidth()-parseInt(b.currentItem.css("paddingLeft")||0,10)-parseInt(b.currentItem.css("paddingRight")||0,10)))}}),b.placeholder=a(d.placeholder.element.call(b.element,b.currentItem)),b.currentItem.after(b.placeholder),d.placeholder.update(b,b.placeholder)},_createTrPlaceholder:function(b,c){var d=this;b.children().each(function(){a("<td>&#160;</td>",d.document[0]).attr("colspan",a(this).attr("colspan")||1).appendTo(c)})},_contactContainers:function(b){var c,d,e,f,g,h,i,j,k,l,m=null,n=null;for(c=this.containers.length-1;c>=0;c--)if(!a.contains(this.currentItem[0],this.containers[c].element[0]))if(this._intersectsWith(this.containers[c].containerCache)){if(m&&a.contains(this.containers[c].element[0],m.element[0]))continue;m=this.containers[c],n=c}else this.containers[c].containerCache.over&&(this.containers[c]._trigger("out",b,this._uiHash(this)),this.containers[c].containerCache.over=0);if(m)if(1===this.containers.length)this.containers[n].containerCache.over||(this.containers[n]._trigger("over",b,this._uiHash(this)),this.containers[n].containerCache.over=1);else{for(e=1e4,f=null,k=m.floating||this._isFloating(this.currentItem),g=k?"left":"top",h=k?"width":"height",l=k?"pageX":"pageY",d=this.items.length-1;d>=0;d--)a.contains(this.containers[n].element[0],this.items[d].item[0])&&this.items[d].item[0]!==this.currentItem[0]&&(i=this.items[d].item.offset()[g],j=!1,b[l]-i>this.items[d][h]/2&&(j=!0),Math.abs(b[l]-i)<e&&(e=Math.abs(b[l]-i),f=this.items[d],this.direction=j?"up":"down"));if(!f&&!this.options.dropOnEmpty)return;if(this.currentContainer===this.containers[n])return void(this.currentContainer.containerCache.over||(this.containers[n]._trigger("over",b,this._uiHash()),this.currentContainer.containerCache.over=1));f?this._rearrange(b,f,null,!0):this._rearrange(b,null,this.containers[n].element,!0),this._trigger("change",b,this._uiHash()),this.containers[n]._trigger("change",b,this._uiHash(this)),this.currentContainer=this.containers[n],this.options.placeholder.update(this.currentContainer,this.placeholder),this.containers[n]._trigger("over",b,this._uiHash(this)),this.containers[n].containerCache.over=1}},_createHelper:function(b){var c=this.options,d=a.isFunction(c.helper)?a(c.helper.apply(this.element[0],[b,this.currentItem])):"clone"===c.helper?this.currentItem.clone():this.currentItem;return d.parents("body").length||a("parent"!==c.appendTo?c.appendTo:this.currentItem[0].parentNode)[0].appendChild(d[0]),d[0]===this.currentItem[0]&&(this._storedCSS={width:this.currentItem[0].style.width,height:this.currentItem[0].style.height,position:this.currentItem.css("position"),top:this.currentItem.css("top"),left:this.currentItem.css("left")}),d[0].style.width&&!c.forceHelperSize||d.width(this.currentItem.width()),d[0].style.height&&!c.forceHelperSize||d.height(this.currentItem.height()),d},_adjustOffsetFromHelper:function(b){"string"==typeof b&&(b=b.split(" ")),a.isArray(b)&&(b={left:+b[0],top:+b[1]||0}),"left"in b&&(this.offset.click.left=b.left+this.margins.left),"right"in b&&(this.offset.click.left=this.helperProportions.width-b.right+this.margins.left),"top"in b&&(this.offset.click.top=b.top+this.margins.top),"bottom"in b&&(this.offset.click.top=this.helperProportions.height-b.bottom+this.margins.top)},_getParentOffset:function(){this.offsetParent=this.helper.offsetParent();var b=this.offsetParent.offset();return"absolute"===this.cssPosition&&this.scrollParent[0]!==this.document[0]&&a.contains(this.scrollParent[0],this.offsetParent[0])&&(b.left+=this.scrollParent.scrollLeft(),b.top+=this.scrollParent.scrollTop()),(this.offsetParent[0]===this.document[0].body||this.offsetParent[0].tagName&&"html"===this.offsetParent[0].tagName.toLowerCase()&&a.ui.ie)&&(b={top:0,left:0}),{top:b.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:b.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"===this.cssPosition){var a=this.currentItem.position();return{top:a.top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:a.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}}return{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.currentItem.css("marginLeft"),10)||0,top:parseInt(this.currentItem.css("marginTop"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var b,c,d,e=this.options;"parent"===e.containment&&(e.containment=this.helper[0].parentNode),"document"!==e.containment&&"window"!==e.containment||(this.containment=[0-this.offset.relative.left-this.offset.parent.left,0-this.offset.relative.top-this.offset.parent.top,"document"===e.containment?this.document.width():this.window.width()-this.helperProportions.width-this.margins.left,("document"===e.containment?this.document.height()||document.body.parentNode.scrollHeight:this.window.height()||this.document[0].body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]),/^(document|window|parent)$/.test(e.containment)||(b=a(e.containment)[0],c=a(e.containment).offset(),d="hidden"!==a(b).css("overflow"),this.containment=[c.left+(parseInt(a(b).css("borderLeftWidth"),10)||0)+(parseInt(a(b).css("paddingLeft"),10)||0)-this.margins.left,c.top+(parseInt(a(b).css("borderTopWidth"),10)||0)+(parseInt(a(b).css("paddingTop"),10)||0)-this.margins.top,c.left+(d?Math.max(b.scrollWidth,b.offsetWidth):b.offsetWidth)-(parseInt(a(b).css("borderLeftWidth"),10)||0)-(parseInt(a(b).css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left,c.top+(d?Math.max(b.scrollHeight,b.offsetHeight):b.offsetHeight)-(parseInt(a(b).css("borderTopWidth"),10)||0)-(parseInt(a(b).css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top])},_convertPositionTo:function(b,c){c||(c=this.position);var d="absolute"===b?1:-1,e="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&a.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,f=/(html|body)/i.test(e[0].tagName);return{top:c.top+this.offset.relative.top*d+this.offset.parent.top*d-("fixed"===this.cssPosition?-this.scrollParent.scrollTop():f?0:e.scrollTop())*d,left:c.left+this.offset.relative.left*d+this.offset.parent.left*d-("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():f?0:e.scrollLeft())*d}},_generatePosition:function(b){var c,d,e=this.options,f=b.pageX,g=b.pageY,h="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&a.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,i=/(html|body)/i.test(h[0].tagName);return"relative"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&this.scrollParent[0]!==this.offsetParent[0]||(this.offset.relative=this._getRelativeOffset()),this.originalPosition&&(this.containment&&(b.pageX-this.offset.click.left<this.containment[0]&&(f=this.containment[0]+this.offset.click.left),b.pageY-this.offset.click.top<this.containment[1]&&(g=this.containment[1]+this.offset.click.top),b.pageX-this.offset.click.left>this.containment[2]&&(f=this.containment[2]+this.offset.click.left),b.pageY-this.offset.click.top>this.containment[3]&&(g=this.containment[3]+this.offset.click.top)),e.grid&&(c=this.originalPageY+Math.round((g-this.originalPageY)/e.grid[1])*e.grid[1],g=this.containment?c-this.offset.click.top>=this.containment[1]&&c-this.offset.click.top<=this.containment[3]?c:c-this.offset.click.top>=this.containment[1]?c-e.grid[1]:c+e.grid[1]:c,d=this.originalPageX+Math.round((f-this.originalPageX)/e.grid[0])*e.grid[0],f=this.containment?d-this.offset.click.left>=this.containment[0]&&d-this.offset.click.left<=this.containment[2]?d:d-this.offset.click.left>=this.containment[0]?d-e.grid[0]:d+e.grid[0]:d)),{top:g-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.scrollParent.scrollTop():i?0:h.scrollTop()),left:f-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():i?0:h.scrollLeft())}},_rearrange:function(a,b,c,d){c?c[0].appendChild(this.placeholder[0]):b.item[0].parentNode.insertBefore(this.placeholder[0],"down"===this.direction?b.item[0]:b.item[0].nextSibling),this.counter=this.counter?++this.counter:1;var e=this.counter;this._delay(function(){e===this.counter&&this.refreshPositions(!d)})},_clear:function(a,b){this.reverting=!1;var c,d=[];if(!this._noFinalSort&&this.currentItem.parent().length&&this.placeholder.before(this.currentItem),this._noFinalSort=null,this.helper[0]===this.currentItem[0]){for(c in this._storedCSS)"auto"!==this._storedCSS[c]&&"static"!==this._storedCSS[c]||(this._storedCSS[c]="");this.currentItem.css(this._storedCSS),this._removeClass(this.currentItem,"ui-sortable-helper")}else this.currentItem.show();this.fromOutside&&!b&&d.push(function(a){this._trigger("receive",a,this._uiHash(this.fromOutside))}),!this.fromOutside&&this.domPosition.prev===this.currentItem.prev().not(".ui-sortable-helper")[0]&&this.domPosition.parent===this.currentItem.parent()[0]||b||d.push(function(a){this._trigger("update",a,this._uiHash())}),this!==this.currentContainer&&(b||(d.push(function(a){this._trigger("remove",a,this._uiHash())}),d.push(function(a){return function(b){a._trigger("receive",b,this._uiHash(this))}}.call(this,this.currentContainer)),d.push(function(a){return function(b){a._trigger("update",b,this._uiHash(this))}}.call(this,this.currentContainer))));function e(a,b,c){return function(d){c._trigger(a,d,b._uiHash(b))}}for(c=this.containers.length-1;c>=0;c--)b||d.push(e("deactivate",this,this.containers[c])),this.containers[c].containerCache.over&&(d.push(e("out",this,this.containers[c])),this.containers[c].containerCache.over=0);if(this.storedCursor&&(this.document.find("body").css("cursor",this.storedCursor),this.storedStylesheet.remove()),this._storedOpacity&&this.helper.css("opacity",this._storedOpacity),this._storedZIndex&&this.helper.css("zIndex","auto"===this._storedZIndex?"":this._storedZIndex),this.dragging=!1,b||this._trigger("beforeStop",a,this._uiHash()),this.placeholder[0].parentNode.removeChild(this.placeholder[0]),this.cancelHelperRemoval||(this.helper[0]!==this.currentItem[0]&&this.helper.remove(),this.helper=null),!b){for(c=0;c<d.length;c++)d[c].call(this,a);this._trigger("stop",a,this._uiHash())}return this.fromOutside=!1,!this.cancelHelperRemoval},_trigger:function(){a.Widget.prototype._trigger.apply(this,arguments)===!1&&this.cancel()},_uiHash:function(b){var c=b||this;return{helper:c.helper,placeholder:c.placeholder||a([]),position:c.position,originalPosition:c.originalPosition,offset:c.positionAbs,item:c.currentItem,sender:b?b.element:null}}});function oa(a){return function(){var b=this.element.val();a.apply(this,arguments),this._refresh(),b!==this.element.val()&&this._trigger("change")}}a.widget("ui.spinner",{version:"1.12.0",defaultElement:"<input>",widgetEventPrefix:"spin",options:{classes:{"ui-spinner":"ui-corner-all","ui-spinner-down":"ui-corner-br","ui-spinner-up":"ui-corner-tr"},culture:null,icons:{down:"ui-icon-triangle-1-s",up:"ui-icon-triangle-1-n"},incremental:!0,max:null,min:null,numberFormat:null,page:10,step:1,change:null,spin:null,start:null,stop:null},_create:function(){this._setOption("max",this.options.max),this._setOption("min",this.options.min),this._setOption("step",this.options.step),""!==this.value()&&this._value(this.element.val(),!0),this._draw(),this._on(this._events),this._refresh(),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_getCreateOptions:function(){var b=this._super(),c=this.element;return a.each(["min","max","step"],function(a,d){var e=c.attr(d);null!=e&&e.length&&(b[d]=e)}),b},_events:{keydown:function(a){this._start(a)&&this._keydown(a)&&a.preventDefault()},keyup:"_stop",focus:function(){this.previous=this.element.val()},blur:function(a){return this.cancelBlur?void delete this.cancelBlur:(this._stop(),this._refresh(),void(this.previous!==this.element.val()&&this._trigger("change",a)))},mousewheel:function(a,b){if(b){if(!this.spinning&&!this._start(a))return!1;this._spin((b>0?1:-1)*this.options.step,a),clearTimeout(this.mousewheelTimer),this.mousewheelTimer=this._delay(function(){this.spinning&&this._stop(a)},100),a.preventDefault()}},"mousedown .ui-spinner-button":function(b){var c;c=this.element[0]===a.ui.safeActiveElement(this.document[0])?this.previous:this.element.val();function d(){var b=this.element[0]===a.ui.safeActiveElement(this.document[0]);b||(this.element.trigger("focus"),this.previous=c,this._delay(function(){this.previous=c}))}b.preventDefault(),d.call(this),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur,d.call(this)}),this._start(b)!==!1&&this._repeat(null,a(b.currentTarget).hasClass("ui-spinner-up")?1:-1,b)},"mouseup .ui-spinner-button":"_stop","mouseenter .ui-spinner-button":function(b){if(a(b.currentTarget).hasClass("ui-state-active"))return this._start(b)!==!1&&void this._repeat(null,a(b.currentTarget).hasClass("ui-spinner-up")?1:-1,b)},"mouseleave .ui-spinner-button":"_stop"},_enhance:function(){this.uiSpinner=this.element.attr("autocomplete","off").wrap("<span>").parent().append("<a></a><a></a>")},_draw:function(){this._enhance(),this._addClass(this.uiSpinner,"ui-spinner","ui-widget ui-widget-content"),this._addClass("ui-spinner-input"),this.element.attr("role","spinbutton"),this.buttons=this.uiSpinner.children("a").attr("tabIndex",-1).attr("aria-hidden",!0).button({classes:{"ui-button":""}}),this._removeClass(this.buttons,"ui-corner-all"),this._addClass(this.buttons.first(),"ui-spinner-button ui-spinner-up"),this._addClass(this.buttons.last(),"ui-spinner-button ui-spinner-down"),this.buttons.first().button({icon:this.options.icons.up,showLabel:!1}),this.buttons.last().button({icon:this.options.icons.down,showLabel:!1}),this.buttons.height()>Math.ceil(.5*this.uiSpinner.height())&&this.uiSpinner.height()>0&&this.uiSpinner.height(this.uiSpinner.height())},_keydown:function(b){var c=this.options,d=a.ui.keyCode;switch(b.keyCode){case d.UP:return this._repeat(null,1,b),!0;case d.DOWN:return this._repeat(null,-1,b),!0;case d.PAGE_UP:return this._repeat(null,c.page,b),!0;case d.PAGE_DOWN:return this._repeat(null,-c.page,b),!0}return!1},_start:function(a){return!(!this.spinning&&this._trigger("start",a)===!1)&&(this.counter||(this.counter=1),this.spinning=!0,!0)},_repeat:function(a,b,c){a=a||500,clearTimeout(this.timer),this.timer=this._delay(function(){this._repeat(40,b,c)},a),this._spin(b*this.options.step,c)},_spin:function(a,b){var c=this.value()||0;this.counter||(this.counter=1),c=this._adjustValue(c+a*this._increment(this.counter)),this.spinning&&this._trigger("spin",b,{value:c})===!1||(this._value(c),this.counter++)},_increment:function(b){var c=this.options.incremental;return c?a.isFunction(c)?c(b):Math.floor(b*b*b/5e4-b*b/500+17*b/200+1):1},_precision:function(){var a=this._precisionOf(this.options.step);return null!==this.options.min&&(a=Math.max(a,this._precisionOf(this.options.min))),a},_precisionOf:function(a){var b=a.toString(),c=b.indexOf(".");return c===-1?0:b.length-c-1},_adjustValue:function(a){var b,c,d=this.options;return b=null!==d.min?d.min:0,c=a-b,c=Math.round(c/d.step)*d.step,a=b+c,a=parseFloat(a.toFixed(this._precision())),null!==d.max&&a>d.max?d.max:null!==d.min&&a<d.min?d.min:a},_stop:function(a){this.spinning&&(clearTimeout(this.timer),clearTimeout(this.mousewheelTimer),this.counter=0,this.spinning=!1,this._trigger("stop",a))},_setOption:function(a,b){var c,d,e;return"culture"===a||"numberFormat"===a?(c=this._parse(this.element.val()),this.options[a]=b,void this.element.val(this._format(c))):("max"!==a&&"min"!==a&&"step"!==a||"string"==typeof b&&(b=this._parse(b)),"icons"===a&&(d=this.buttons.first().find(".ui-icon"),this._removeClass(d,null,this.options.icons.up),this._addClass(d,null,b.up),e=this.buttons.last().find(".ui-icon"),this._removeClass(e,null,this.options.icons.down),this._addClass(e,null,b.down)),void this._super(a,b))},_setOptionDisabled:function(a){this._super(a),this._toggleClass(this.uiSpinner,null,"ui-state-disabled",!!a),this.element.prop("disabled",!!a),this.buttons.button(a?"disable":"enable")},_setOptions:oa(function(a){this._super(a)}),_parse:function(a){return"string"==typeof a&&""!==a&&(a=window.Globalize&&this.options.numberFormat?Globalize.parseFloat(a,10,this.options.culture):+a),""===a||isNaN(a)?null:a},_format:function(a){return""===a?"":window.Globalize&&this.options.numberFormat?Globalize.format(a,this.options.numberFormat,this.options.culture):a},_refresh:function(){this.element.attr({"aria-valuemin":this.options.min,"aria-valuemax":this.options.max,"aria-valuenow":this._parse(this.element.val())})},isValid:function(){var a=this.value();return null!==a&&a===this._adjustValue(a)},_value:function(a,b){var c;""!==a&&(c=this._parse(a),null!==c&&(b||(c=this._adjustValue(c)),a=this._format(c))),this.element.val(a),this._refresh()},_destroy:function(){this.element.prop("disabled",!1).removeAttr("autocomplete role aria-valuemin aria-valuemax aria-valuenow"),this.uiSpinner.replaceWith(this.element)},stepUp:oa(function(a){this._stepUp(a)}),_stepUp:function(a){this._start()&&(this._spin((a||1)*this.options.step),this._stop())},stepDown:oa(function(a){
this._stepDown(a)}),_stepDown:function(a){this._start()&&(this._spin((a||1)*-this.options.step),this._stop())},pageUp:oa(function(a){this._stepUp((a||1)*this.options.page)}),pageDown:oa(function(a){this._stepDown((a||1)*this.options.page)}),value:function(a){return arguments.length?void oa(this._value).call(this,a):this._parse(this.element.val())},widget:function(){return this.uiSpinner}}),a.uiBackCompat!==!1&&a.widget("ui.spinner",a.ui.spinner,{_enhance:function(){this.uiSpinner=this.element.attr("autocomplete","off").wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml())},_uiSpinnerHtml:function(){return"<span>"},_buttonHtml:function(){return"<a></a><a></a>"}});var pa=a.ui.spinner;a.widget("ui.tabs",{version:"1.12.0",delay:300,options:{active:null,classes:{"ui-tabs":"ui-corner-all","ui-tabs-nav":"ui-corner-all","ui-tabs-panel":"ui-corner-bottom","ui-tabs-tab":"ui-corner-top"},collapsible:!1,event:"click",heightStyle:"content",hide:null,show:null,activate:null,beforeActivate:null,beforeLoad:null,load:null},_isLocal:function(){var a=/#.*$/;return function(b){var c,d;c=b.href.replace(a,""),d=location.href.replace(a,"");try{c=decodeURIComponent(c)}catch(a){}try{d=decodeURIComponent(d)}catch(a){}return b.hash.length>1&&c===d}}(),_create:function(){var b=this,c=this.options;this.running=!1,this._addClass("ui-tabs","ui-widget ui-widget-content"),this._toggleClass("ui-tabs-collapsible",null,c.collapsible),this._processTabs(),c.active=this._initialActive(),a.isArray(c.disabled)&&(c.disabled=a.unique(c.disabled.concat(a.map(this.tabs.filter(".ui-state-disabled"),function(a){return b.tabs.index(a)}))).sort()),this.options.active!==!1&&this.anchors.length?this.active=this._findActive(c.active):this.active=a(),this._refresh(),this.active.length&&this.load(c.active)},_initialActive:function(){var b=this.options.active,c=this.options.collapsible,d=location.hash.substring(1);return null===b&&(d&&this.tabs.each(function(c,e){if(a(e).attr("aria-controls")===d)return b=c,!1}),null===b&&(b=this.tabs.index(this.tabs.filter(".ui-tabs-active"))),null!==b&&b!==-1||(b=!!this.tabs.length&&0)),b!==!1&&(b=this.tabs.index(this.tabs.eq(b)),b===-1&&(b=!c&&0)),!c&&b===!1&&this.anchors.length&&(b=0),b},_getCreateEventData:function(){return{tab:this.active,panel:this.active.length?this._getPanelForTab(this.active):a()}},_tabKeydown:function(b){var c=a(a.ui.safeActiveElement(this.document[0])).closest("li"),d=this.tabs.index(c),e=!0;if(!this._handlePageNav(b)){switch(b.keyCode){case a.ui.keyCode.RIGHT:case a.ui.keyCode.DOWN:d++;break;case a.ui.keyCode.UP:case a.ui.keyCode.LEFT:e=!1,d--;break;case a.ui.keyCode.END:d=this.anchors.length-1;break;case a.ui.keyCode.HOME:d=0;break;case a.ui.keyCode.SPACE:return b.preventDefault(),clearTimeout(this.activating),void this._activate(d);case a.ui.keyCode.ENTER:return b.preventDefault(),clearTimeout(this.activating),void this._activate(d!==this.options.active&&d);default:return}b.preventDefault(),clearTimeout(this.activating),d=this._focusNextTab(d,e),b.ctrlKey||b.metaKey||(c.attr("aria-selected","false"),this.tabs.eq(d).attr("aria-selected","true"),this.activating=this._delay(function(){this.option("active",d)},this.delay))}},_panelKeydown:function(b){this._handlePageNav(b)||b.ctrlKey&&b.keyCode===a.ui.keyCode.UP&&(b.preventDefault(),this.active.trigger("focus"))},_handlePageNav:function(b){return b.altKey&&b.keyCode===a.ui.keyCode.PAGE_UP?(this._activate(this._focusNextTab(this.options.active-1,!1)),!0):b.altKey&&b.keyCode===a.ui.keyCode.PAGE_DOWN?(this._activate(this._focusNextTab(this.options.active+1,!0)),!0):void 0},_findNextTab:function(b,c){var d=this.tabs.length-1;function e(){return b>d&&(b=0),b<0&&(b=d),b}while(a.inArray(e(),this.options.disabled)!==-1)b=c?b+1:b-1;return b},_focusNextTab:function(a,b){return a=this._findNextTab(a,b),this.tabs.eq(a).trigger("focus"),a},_setOption:function(a,b){return"active"===a?void this._activate(b):(this._super(a,b),"collapsible"===a&&(this._toggleClass("ui-tabs-collapsible",null,b),b||this.options.active!==!1||this._activate(0)),"event"===a&&this._setupEvents(b),void("heightStyle"===a&&this._setupHeightStyle(b)))},_sanitizeSelector:function(a){return a?a.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g,"\\$&"):""},refresh:function(){var b=this.options,c=this.tablist.children(":has(a[href])");b.disabled=a.map(c.filter(".ui-state-disabled"),function(a){return c.index(a)}),this._processTabs(),b.active!==!1&&this.anchors.length?this.active.length&&!a.contains(this.tablist[0],this.active[0])?this.tabs.length===b.disabled.length?(b.active=!1,this.active=a()):this._activate(this._findNextTab(Math.max(0,b.active-1),!1)):b.active=this.tabs.index(this.active):(b.active=!1,this.active=a()),this._refresh()},_refresh:function(){this._setOptionDisabled(this.options.disabled),this._setupEvents(this.options.event),this._setupHeightStyle(this.options.heightStyle),this.tabs.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1}),this.panels.not(this._getPanelForTab(this.active)).hide().attr({"aria-hidden":"true"}),this.active.length?(this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0}),this._addClass(this.active,"ui-tabs-active","ui-state-active"),this._getPanelForTab(this.active).show().attr({"aria-hidden":"false"})):this.tabs.eq(0).attr("tabIndex",0)},_processTabs:function(){var b=this,c=this.tabs,d=this.anchors,e=this.panels;this.tablist=this._getList().attr("role","tablist"),this._addClass(this.tablist,"ui-tabs-nav","ui-helper-reset ui-helper-clearfix ui-widget-header"),this.tablist.on("mousedown"+this.eventNamespace,"> li",function(b){a(this).is(".ui-state-disabled")&&b.preventDefault()}).on("focus"+this.eventNamespace,".ui-tabs-anchor",function(){a(this).closest("li").is(".ui-state-disabled")&&this.blur()}),this.tabs=this.tablist.find("> li:has(a[href])").attr({role:"tab",tabIndex:-1}),this._addClass(this.tabs,"ui-tabs-tab","ui-state-default"),this.anchors=this.tabs.map(function(){return a("a",this)[0]}).attr({role:"presentation",tabIndex:-1}),this._addClass(this.anchors,"ui-tabs-anchor"),this.panels=a(),this.anchors.each(function(c,d){var e,f,g,h=a(d).uniqueId().attr("id"),i=a(d).closest("li"),j=i.attr("aria-controls");b._isLocal(d)?(e=d.hash,g=e.substring(1),f=b.element.find(b._sanitizeSelector(e))):(g=i.attr("aria-controls")||a({}).uniqueId()[0].id,e="#"+g,f=b.element.find(e),f.length||(f=b._createPanel(g),f.insertAfter(b.panels[c-1]||b.tablist)),f.attr("aria-live","polite")),f.length&&(b.panels=b.panels.add(f)),j&&i.data("ui-tabs-aria-controls",j),i.attr({"aria-controls":g,"aria-labelledby":h}),f.attr("aria-labelledby",h)}),this.panels.attr("role","tabpanel"),this._addClass(this.panels,"ui-tabs-panel","ui-widget-content"),c&&(this._off(c.not(this.tabs)),this._off(d.not(this.anchors)),this._off(e.not(this.panels)))},_getList:function(){return this.tablist||this.element.find("ol, ul").eq(0)},_createPanel:function(b){return a("<div>").attr("id",b).data("ui-tabs-destroy",!0)},_setOptionDisabled:function(b){var c,d,e;for(a.isArray(b)&&(b.length?b.length===this.anchors.length&&(b=!0):b=!1),e=0;d=this.tabs[e];e++)c=a(d),b===!0||a.inArray(e,b)!==-1?(c.attr("aria-disabled","true"),this._addClass(c,null,"ui-state-disabled")):(c.removeAttr("aria-disabled"),this._removeClass(c,null,"ui-state-disabled"));this.options.disabled=b,this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,b===!0)},_setupEvents:function(b){var c={};b&&a.each(b.split(" "),function(a,b){c[b]="_eventHandler"}),this._off(this.anchors.add(this.tabs).add(this.panels)),this._on(!0,this.anchors,{click:function(a){a.preventDefault()}}),this._on(this.anchors,c),this._on(this.tabs,{keydown:"_tabKeydown"}),this._on(this.panels,{keydown:"_panelKeydown"}),this._focusable(this.tabs),this._hoverable(this.tabs)},_setupHeightStyle:function(b){var c,d=this.element.parent();"fill"===b?(c=d.height(),c-=this.element.outerHeight()-this.element.height(),this.element.siblings(":visible").each(function(){var b=a(this),d=b.css("position");"absolute"!==d&&"fixed"!==d&&(c-=b.outerHeight(!0))}),this.element.children().not(this.panels).each(function(){c-=a(this).outerHeight(!0)}),this.panels.each(function(){a(this).height(Math.max(0,c-a(this).innerHeight()+a(this).height()))}).css("overflow","auto")):"auto"===b&&(c=0,this.panels.each(function(){c=Math.max(c,a(this).height("").height())}).height(c))},_eventHandler:function(b){var c=this.options,d=this.active,e=a(b.currentTarget),f=e.closest("li"),g=f[0]===d[0],h=g&&c.collapsible,i=h?a():this._getPanelForTab(f),j=d.length?this._getPanelForTab(d):a(),k={oldTab:d,oldPanel:j,newTab:h?a():f,newPanel:i};b.preventDefault(),f.hasClass("ui-state-disabled")||f.hasClass("ui-tabs-loading")||this.running||g&&!c.collapsible||this._trigger("beforeActivate",b,k)===!1||(c.active=!h&&this.tabs.index(f),this.active=g?a():f,this.xhr&&this.xhr.abort(),j.length||i.length||a.error("jQuery UI Tabs: Mismatching fragment identifier."),i.length&&this.load(this.tabs.index(f),b),this._toggle(b,k))},_toggle:function(b,c){var d=this,e=c.newPanel,f=c.oldPanel;this.running=!0;function g(){d.running=!1,d._trigger("activate",b,c)}function h(){d._addClass(c.newTab.closest("li"),"ui-tabs-active","ui-state-active"),e.length&&d.options.show?d._show(e,d.options.show,g):(e.show(),g())}f.length&&this.options.hide?this._hide(f,this.options.hide,function(){d._removeClass(c.oldTab.closest("li"),"ui-tabs-active","ui-state-active"),h()}):(this._removeClass(c.oldTab.closest("li"),"ui-tabs-active","ui-state-active"),f.hide(),h()),f.attr("aria-hidden","true"),c.oldTab.attr({"aria-selected":"false","aria-expanded":"false"}),e.length&&f.length?c.oldTab.attr("tabIndex",-1):e.length&&this.tabs.filter(function(){return 0===a(this).attr("tabIndex")}).attr("tabIndex",-1),e.attr("aria-hidden","false"),c.newTab.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0})},_activate:function(b){var c,d=this._findActive(b);d[0]!==this.active[0]&&(d.length||(d=this.active),c=d.find(".ui-tabs-anchor")[0],this._eventHandler({target:c,currentTarget:c,preventDefault:a.noop}))},_findActive:function(b){return b===!1?a():this.tabs.eq(b)},_getIndex:function(b){return"string"==typeof b&&(b=this.anchors.index(this.anchors.filter("[href$='"+a.ui.escapeSelector(b)+"']"))),b},_destroy:function(){this.xhr&&this.xhr.abort(),this.tablist.removeAttr("role").off(this.eventNamespace),this.anchors.removeAttr("role tabIndex").removeUniqueId(),this.tabs.add(this.panels).each(function(){a.data(this,"ui-tabs-destroy")?a(this).remove():a(this).removeAttr("role tabIndex aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded")}),this.tabs.each(function(){var b=a(this),c=b.data("ui-tabs-aria-controls");c?b.attr("aria-controls",c).removeData("ui-tabs-aria-controls"):b.removeAttr("aria-controls")}),this.panels.show(),"content"!==this.options.heightStyle&&this.panels.css("height","")},enable:function(b){var c=this.options.disabled;c!==!1&&(void 0===b?c=!1:(b=this._getIndex(b),c=a.isArray(c)?a.map(c,function(a){return a!==b?a:null}):a.map(this.tabs,function(a,c){return c!==b?c:null})),this._setOptionDisabled(c))},disable:function(b){var c=this.options.disabled;if(c!==!0){if(void 0===b)c=!0;else{if(b=this._getIndex(b),a.inArray(b,c)!==-1)return;c=a.isArray(c)?a.merge([b],c).sort():[b]}this._setOptionDisabled(c)}},load:function(b,c){b=this._getIndex(b);var d=this,e=this.tabs.eq(b),f=e.find(".ui-tabs-anchor"),g=this._getPanelForTab(e),h={tab:e,panel:g},i=function(a,b){"abort"===b&&d.panels.stop(!1,!0),d._removeClass(e,"ui-tabs-loading"),g.removeAttr("aria-busy"),a===d.xhr&&delete d.xhr};this._isLocal(f[0])||(this.xhr=a.ajax(this._ajaxSettings(f,c,h)),this.xhr&&"canceled"!==this.xhr.statusText&&(this._addClass(e,"ui-tabs-loading"),g.attr("aria-busy","true"),this.xhr.done(function(a,b,e){setTimeout(function(){g.html(a),d._trigger("load",c,h),i(e,b)},1)}).fail(function(a,b){setTimeout(function(){i(a,b)},1)})))},_ajaxSettings:function(b,c,d){var e=this;return{url:b.attr("href"),beforeSend:function(b,f){return e._trigger("beforeLoad",c,a.extend({jqXHR:b,ajaxSettings:f},d))}}},_getPanelForTab:function(b){var c=a(b).attr("aria-controls");return this.element.find(this._sanitizeSelector("#"+c))}}),a.uiBackCompat!==!1&&a.widget("ui.tabs",a.ui.tabs,{_processTabs:function(){this._superApply(arguments),this._addClass(this.tabs,"ui-tab")}});var qa=a.ui.tabs;a.widget("ui.tooltip",{version:"1.12.0",options:{classes:{"ui-tooltip":"ui-corner-all ui-widget-shadow"},content:function(){var b=a(this).attr("title")||"";return a("<a>").text(b).html()},hide:!0,items:"[title]:not([disabled])",position:{my:"left top+15",at:"left bottom",collision:"flipfit flip"},show:!0,track:!1,close:null,open:null},_addDescribedBy:function(b,c){var d=(b.attr("aria-describedby")||"").split(/\s+/);d.push(c),b.data("ui-tooltip-id",c).attr("aria-describedby",a.trim(d.join(" ")))},_removeDescribedBy:function(b){var c=b.data("ui-tooltip-id"),d=(b.attr("aria-describedby")||"").split(/\s+/),e=a.inArray(c,d);e!==-1&&d.splice(e,1),b.removeData("ui-tooltip-id"),d=a.trim(d.join(" ")),d?b.attr("aria-describedby",d):b.removeAttr("aria-describedby")},_create:function(){this._on({mouseover:"open",focusin:"open"}),this.tooltips={},this.parents={},this.liveRegion=a("<div>").attr({role:"log","aria-live":"assertive","aria-relevant":"additions"}).appendTo(this.document[0].body),this._addClass(this.liveRegion,null,"ui-helper-hidden-accessible"),this.disabledTitles=a([])},_setOption:function(b,c){var d=this;this._super(b,c),"content"===b&&a.each(this.tooltips,function(a,b){d._updateContent(b.element)})},_setOptionDisabled:function(a){this[a?"_disable":"_enable"]()},_disable:function(){var b=this;a.each(this.tooltips,function(c,d){var e=a.Event("blur");e.target=e.currentTarget=d.element[0],b.close(e,!0)}),this.disabledTitles=this.disabledTitles.add(this.element.find(this.options.items).addBack().filter(function(){var b=a(this);if(b.is("[title]"))return b.data("ui-tooltip-title",b.attr("title")).removeAttr("title")}))},_enable:function(){this.disabledTitles.each(function(){var b=a(this);b.data("ui-tooltip-title")&&b.attr("title",b.data("ui-tooltip-title"))}),this.disabledTitles=a([])},open:function(b){var c=this,d=a(b?b.target:this.element).closest(this.options.items);d.length&&!d.data("ui-tooltip-id")&&(d.attr("title")&&d.data("ui-tooltip-title",d.attr("title")),d.data("ui-tooltip-open",!0),b&&"mouseover"===b.type&&d.parents().each(function(){var b=a(this),d;b.data("ui-tooltip-open")&&(d=a.Event("blur"),d.target=d.currentTarget=this,c.close(d,!0)),b.attr("title")&&(b.uniqueId(),c.parents[this.id]={element:this,title:b.attr("title")},b.attr("title",""))}),this._registerCloseHandlers(b,d),this._updateContent(d,b))},_updateContent:function(a,b){var c,d=this.options.content,e=this,f=b?b.type:null;return"string"==typeof d||d.nodeType||d.jquery?this._open(b,a,d):(c=d.call(a[0],function(c){e._delay(function(){a.data("ui-tooltip-open")&&(b&&(b.type=f),this._open(b,a,c))})}),void(c&&this._open(b,a,c)))},_open:function(b,c,d){var e,f,g,h,i=a.extend({},this.options.position);function j(a){i.of=a,f.is(":hidden")||f.position(i)}if(d){if(e=this._find(c))return void e.tooltip.find(".ui-tooltip-content").html(d);c.is("[title]")&&(b&&"mouseover"===b.type?c.attr("title",""):c.removeAttr("title")),e=this._tooltip(c),f=e.tooltip,this._addDescribedBy(c,f.attr("id")),f.find(".ui-tooltip-content").html(d),this.liveRegion.children().hide(),h=a("<div>").html(f.find(".ui-tooltip-content").html()),h.removeAttr("name").find("[name]").removeAttr("name"),h.removeAttr("id").find("[id]").removeAttr("id"),h.appendTo(this.liveRegion),this.options.track&&b&&/^mouse/.test(b.type)?(this._on(this.document,{mousemove:j}),j(b)):f.position(a.extend({of:c},this.options.position)),f.hide(),this._show(f,this.options.show),this.options.track&&this.options.show&&this.options.show.delay&&(g=this.delayedShow=setInterval(function(){f.is(":visible")&&(j(i.of),clearInterval(g))},a.fx.interval)),this._trigger("open",b,{tooltip:f})}},_registerCloseHandlers:function(b,c){var d={keyup:function(b){if(b.keyCode===a.ui.keyCode.ESCAPE){var d=a.Event(b);d.currentTarget=c[0],this.close(d,!0)}}};c[0]!==this.element[0]&&(d.remove=function(){this._removeTooltip(this._find(c).tooltip)}),b&&"mouseover"!==b.type||(d.mouseleave="close"),b&&"focusin"!==b.type||(d.focusout="close"),this._on(!0,c,d)},close:function(b){var c,d=this,e=a(b?b.currentTarget:this.element),f=this._find(e);return f?(c=f.tooltip,void(f.closing||(clearInterval(this.delayedShow),e.data("ui-tooltip-title")&&!e.attr("title")&&e.attr("title",e.data("ui-tooltip-title")),this._removeDescribedBy(e),f.hiding=!0,c.stop(!0),this._hide(c,this.options.hide,function(){d._removeTooltip(a(this))}),e.removeData("ui-tooltip-open"),this._off(e,"mouseleave focusout keyup"),e[0]!==this.element[0]&&this._off(e,"remove"),this._off(this.document,"mousemove"),b&&"mouseleave"===b.type&&a.each(this.parents,function(b,c){a(c.element).attr("title",c.title),delete d.parents[b]}),f.closing=!0,this._trigger("close",b,{tooltip:c}),f.hiding||(f.closing=!1)))):void e.removeData("ui-tooltip-open")},_tooltip:function(b){var c=a("<div>").attr("role","tooltip"),d=a("<div>").appendTo(c),e=c.uniqueId().attr("id");return this._addClass(d,"ui-tooltip-content"),this._addClass(c,"ui-tooltip","ui-widget ui-widget-content"),c.appendTo(this._appendTo(b)),this.tooltips[e]={element:b,tooltip:c}},_find:function(a){var b=a.data("ui-tooltip-id");return b?this.tooltips[b]:null},_removeTooltip:function(a){a.remove(),delete this.tooltips[a.attr("id")]},_appendTo:function(a){var b=a.closest(".ui-front, dialog");return b.length||(b=this.document[0].body),b},_destroy:function(){var b=this;a.each(this.tooltips,function(c,d){var e=a.Event("blur"),f=d.element;e.target=e.currentTarget=f[0],b.close(e,!0),a("#"+c).remove(),f.data("ui-tooltip-title")&&(f.attr("title")||f.attr("title",f.data("ui-tooltip-title")),f.removeData("ui-tooltip-title"))}),this.liveRegion.remove()}}),a.uiBackCompat!==!1&&a.widget("ui.tooltip",a.ui.tooltip,{options:{tooltipClass:null},_tooltip:function(){var a=this._superApply(arguments);return this.options.tooltipClass&&a.tooltip.addClass(this.options.tooltipClass),a}});var ra=a.ui.tooltip}),"function"!=typeof Object.create&&(Object.create=function(a){function b(){}return b.prototype=a,new b}),function(a,b,c){var d={init:function(b,c){var d=this;d.$elem=a(c),d.options=a.extend({},a.fn.owlCarousel.options,d.$elem.data(),b),d.userOptions=b,d.loadContent()},loadContent:function(){var b=this,c;function d(a){var c,d="";if("function"==typeof b.options.jsonSuccess)b.options.jsonSuccess.apply(this,[a]);else{for(c in a.owl)a.owl.hasOwnProperty(c)&&(d+=a.owl[c].item);b.$elem.html(d)}b.logIn()}"function"==typeof b.options.beforeInit&&b.options.beforeInit.apply(this,[b.$elem]),"string"==typeof b.options.jsonPath?(c=b.options.jsonPath,a.getJSON(c,d)):b.logIn()},logIn:function(){var a=this;a.$elem.data("owl-originalStyles",a.$elem.attr("style")).data("owl-originalClasses",a.$elem.attr("class")),a.$elem.css({opacity:0}),a.orignalItems=a.options.items,a.checkBrowser(),a.wrapperWidth=0,a.checkVisible=null,a.setVars()},setVars:function(){var a=this;return 0!==a.$elem.children().length&&(a.baseClass(),a.eventTypes(),a.$userItems=a.$elem.children(),a.itemsAmount=a.$userItems.length,a.wrapItems(),a.$owlItems=a.$elem.find(".owl-item"),a.$owlWrapper=a.$elem.find(".owl-wrapper"),a.playDirection="next",a.prevItem=0,a.prevArr=[0],a.currentItem=0,a.customEvents(),void a.onStartup())},onStartup:function(){var a=this;a.updateItems(),a.calculateAll(),a.buildControls(),a.updateControls(),a.response(),a.moveEvents(),a.stopOnHover(),a.owlStatus(),a.options.transitionStyle!==!1&&a.transitionTypes(a.options.transitionStyle),a.options.autoPlay===!0&&(a.options.autoPlay=5e3),a.play(),a.$elem.find(".owl-wrapper").css("display","block"),a.$elem.is(":visible")?a.$elem.css("opacity",1):a.watchVisibility(),a.onstartup=!1,a.eachMoveUpdate(),"function"==typeof a.options.afterInit&&a.options.afterInit.apply(this,[a.$elem])},eachMoveUpdate:function(){var a=this;a.options.lazyLoad===!0&&a.lazyLoad(),a.options.autoHeight===!0&&a.autoHeight(),a.onVisibleItems(),"function"==typeof a.options.afterAction&&a.options.afterAction.apply(this,[a.$elem])},updateVars:function(){var a=this;"function"==typeof a.options.beforeUpdate&&a.options.beforeUpdate.apply(this,[a.$elem]),a.watchVisibility(),a.updateItems(),a.calculateAll(),a.updatePosition(),a.updateControls(),a.eachMoveUpdate(),"function"==typeof a.options.afterUpdate&&a.options.afterUpdate.apply(this,[a.$elem])},reload:function(){var a=this;b.setTimeout(function(){a.updateVars()},0)},watchVisibility:function(){var a=this;return a.$elem.is(":visible")===!1&&(a.$elem.css({opacity:0}),b.clearInterval(a.autoPlayInterval),b.clearInterval(a.checkVisible),void(a.checkVisible=b.setInterval(function(){a.$elem.is(":visible")&&(a.reload(),a.$elem.animate({opacity:1},200),b.clearInterval(a.checkVisible))},500)))},wrapItems:function(){var a=this;a.$userItems.wrapAll('<div class="owl-wrapper">').wrap('<div class="owl-item"></div>'),a.$elem.find(".owl-wrapper").wrap('<div class="owl-wrapper-outer">'),a.wrapperOuter=a.$elem.find(".owl-wrapper-outer"),a.$elem.css("display","block")},baseClass:function(){var a=this,b=a.$elem.hasClass(a.options.baseClass),c=a.$elem.hasClass(a.options.theme);b||a.$elem.addClass(a.options.baseClass),c||a.$elem.addClass(a.options.theme)},updateItems:function(){var b=this,c,d;if(b.options.responsive===!1)return!1;if(b.options.singleItem===!0)return b.options.items=b.orignalItems=1,b.options.itemsCustom=!1,b.options.itemsDesktop=!1,b.options.itemsDesktopSmall=!1,b.options.itemsTablet=!1,b.options.itemsTabletSmall=!1,b.options.itemsMobile=!1,!1;if(c=a(b.options.responsiveBaseWidth).width(),c>(b.options.itemsDesktop[0]||b.orignalItems)&&(b.options.items=b.orignalItems),b.options.itemsCustom!==!1)for(b.options.itemsCustom.sort(function(a,b){return a[0]-b[0]}),d=0;d<b.options.itemsCustom.length;d+=1)b.options.itemsCustom[d][0]<=c&&(b.options.items=b.options.itemsCustom[d][1]);else c<=b.options.itemsDesktop[0]&&b.options.itemsDesktop!==!1&&(b.options.items=b.options.itemsDesktop[1]),c<=b.options.itemsDesktopSmall[0]&&b.options.itemsDesktopSmall!==!1&&(b.options.items=b.options.itemsDesktopSmall[1]),c<=b.options.itemsTablet[0]&&b.options.itemsTablet!==!1&&(b.options.items=b.options.itemsTablet[1]),c<=b.options.itemsTabletSmall[0]&&b.options.itemsTabletSmall!==!1&&(b.options.items=b.options.itemsTabletSmall[1]),c<=b.options.itemsMobile[0]&&b.options.itemsMobile!==!1&&(b.options.items=b.options.itemsMobile[1]);b.options.items>b.itemsAmount&&b.options.itemsScaleUp===!0&&(b.options.items=b.itemsAmount)},response:function(){var c=this,d,e;return c.options.responsive===!0&&(e=a(b).width(),c.resizer=function(){a(b).width()!==e&&(c.options.autoPlay!==!1&&b.clearInterval(c.autoPlayInterval),b.clearTimeout(d),d=b.setTimeout(function(){e=a(b).width(),c.updateVars()},c.options.responsiveRefreshRate))},void a(b).resize(c.resizer))},updatePosition:function(){var a=this;a.jumpTo(a.currentItem),a.options.autoPlay!==!1&&a.checkAp()},appendItemsSizes:function(){var b=this,c=0,d=b.itemsAmount-b.options.items;b.$owlItems.each(function(e){var f=a(this);f.css({width:b.itemWidth}).data("owl-item",Number(e)),e%b.options.items!==0&&e!==d||e>d||(c+=1),f.data("owl-roundPages",c)})},appendWrapperSizes:function(){var a=this,b=a.$owlItems.length*a.itemWidth;a.$owlWrapper.css({width:2*b,left:0}),a.appendItemsSizes()},calculateAll:function(){var a=this;a.calculateWidth(),a.appendWrapperSizes(),a.loops(),a.max()},calculateWidth:function(){var a=this;a.itemWidth=Math.round(a.$elem.width()/a.options.items)},max:function(){var a=this,b=(a.itemsAmount*a.itemWidth-a.options.items*a.itemWidth)*-1;return a.options.items>a.itemsAmount?(a.maximumItem=0,b=0,a.maximumPixels=0):(a.maximumItem=a.itemsAmount-a.options.items,a.maximumPixels=b),b},min:function(){return 0},loops:function(){var b=this,c=0,d=0,e,f,g;for(b.positionsInArray=[0],b.pagesInArray=[],e=0;e<b.itemsAmount;e+=1)d+=b.itemWidth,b.positionsInArray.push(-d),b.options.scrollPerPage===!0&&(f=a(b.$owlItems[e]),g=f.data("owl-roundPages"),g!==c&&(b.pagesInArray[c]=b.positionsInArray[e],c=g))},buildControls:function(){var b=this;b.options.navigation!==!0&&b.options.pagination!==!0||(b.owlControls=a('<div class="owl-controls"/>').toggleClass("clickable",!b.browser.isTouch).appendTo(b.$elem)),b.options.pagination===!0&&b.buildPagination(),b.options.navigation===!0&&b.buildButtons()},buildButtons:function(){var b=this,c=a('<div class="owl-buttons"/>');b.owlControls.append(c),b.buttonPrev=a("<div/>",{class:"owl-prev",html:b.options.navigationText[0]||""}),b.buttonNext=a("<div/>",{class:"owl-next",html:b.options.navigationText[1]||""}),c.append(b.buttonPrev).append(b.buttonNext),c.on("touchstart.owlControls mousedown.owlControls",'div[class^="owl"]',function(a){a.preventDefault()}),c.on("touchend.owlControls mouseup.owlControls",'div[class^="owl"]',function(c){c.preventDefault(),a(this).hasClass("owl-next")?b.next():b.prev()})},buildPagination:function(){var b=this;b.paginationWrapper=a('<div class="owl-pagination"/>'),b.owlControls.append(b.paginationWrapper),b.paginationWrapper.on("touchend.owlControls mouseup.owlControls",".owl-page",function(c){c.preventDefault(),Number(a(this).data("owl-page"))!==b.currentItem&&b.goTo(Number(a(this).data("owl-page")),!0)})},updatePagination:function(){var b=this,c,d,e,f,g,h;if(b.options.pagination===!1)return!1;for(b.paginationWrapper.html(""),c=0,d=b.itemsAmount-b.itemsAmount%b.options.items,f=0;f<b.itemsAmount;f+=1)f%b.options.items===0&&(c+=1,d===f&&(e=b.itemsAmount-b.options.items),g=a("<div/>",{class:"owl-page"}),h=a("<span></span>",{text:b.options.paginationNumbers===!0?c:"",class:b.options.paginationNumbers===!0?"owl-numbers":""}),g.append(h),g.data("owl-page",d===f?e:f),g.data("owl-roundPages",c),b.paginationWrapper.append(g));b.checkPagination()},checkPagination:function(){var b=this;return b.options.pagination!==!1&&void b.paginationWrapper.find(".owl-page").each(function(){a(this).data("owl-roundPages")===a(b.$owlItems[b.currentItem]).data("owl-roundPages")&&(b.paginationWrapper.find(".owl-page").removeClass("active"),a(this).addClass("active"))})},checkNavigation:function(){var a=this;return a.options.navigation!==!1&&void(a.options.rewindNav===!1&&(0===a.currentItem&&0===a.maximumItem?(a.buttonPrev.addClass("disabled"),a.buttonNext.addClass("disabled")):0===a.currentItem&&0!==a.maximumItem?(a.buttonPrev.addClass("disabled"),a.buttonNext.removeClass("disabled")):a.currentItem===a.maximumItem?(a.buttonPrev.removeClass("disabled"),a.buttonNext.addClass("disabled")):0!==a.currentItem&&a.currentItem!==a.maximumItem&&(a.buttonPrev.removeClass("disabled"),a.buttonNext.removeClass("disabled"))))},updateControls:function(){var a=this;a.updatePagination(),a.checkNavigation(),a.owlControls&&(a.options.items>=a.itemsAmount?a.owlControls.hide():a.owlControls.show())},destroyControls:function(){var a=this;a.owlControls&&a.owlControls.remove()},next:function(a){var b=this;if(b.isTransition)return!1;if(b.currentItem+=b.options.scrollPerPage===!0?b.options.items:1,b.currentItem>b.maximumItem+(b.options.scrollPerPage===!0?b.options.items-1:0)){if(b.options.rewindNav!==!0)return b.currentItem=b.maximumItem,!1;b.currentItem=0,a="rewind"}b.goTo(b.currentItem,a)},prev:function(a){var b=this;if(b.isTransition)return!1;if(b.options.scrollPerPage===!0&&b.currentItem>0&&b.currentItem<b.options.items?b.currentItem=0:b.currentItem-=b.options.scrollPerPage===!0?b.options.items:1,b.currentItem<0){if(b.options.rewindNav!==!0)return b.currentItem=0,!1;b.currentItem=b.maximumItem,a="rewind"}b.goTo(b.currentItem,a)},goTo:function(a,c,d){var e=this,f;return!e.isTransition&&("function"==typeof e.options.beforeMove&&e.options.beforeMove.apply(this,[e.$elem]),a>=e.maximumItem?a=e.maximumItem:a<=0&&(a=0),e.currentItem=e.owl.currentItem=a,e.options.transitionStyle!==!1&&"drag"!==d&&1===e.options.items&&e.browser.support3d===!0?(e.swapSpeed(0),e.browser.support3d===!0?e.transition3d(e.positionsInArray[a]):e.css2slide(e.positionsInArray[a],1),e.afterGo(),e.singleItemTransition(),!1):(f=e.positionsInArray[a],e.browser.support3d===!0?(e.isCss3Finish=!1,c===!0?(e.swapSpeed("paginationSpeed"),b.setTimeout(function(){e.isCss3Finish=!0},e.options.paginationSpeed)):"rewind"===c?(e.swapSpeed(e.options.rewindSpeed),b.setTimeout(function(){e.isCss3Finish=!0},e.options.rewindSpeed)):(e.swapSpeed("slideSpeed"),b.setTimeout(function(){e.isCss3Finish=!0},e.options.slideSpeed)),e.transition3d(f)):c===!0?e.css2slide(f,e.options.paginationSpeed):"rewind"===c?e.css2slide(f,e.options.rewindSpeed):e.css2slide(f,e.options.slideSpeed),void e.afterGo()))},jumpTo:function(a){var b=this;"function"==typeof b.options.beforeMove&&b.options.beforeMove.apply(this,[b.$elem]),a>=b.maximumItem||a===-1?a=b.maximumItem:a<=0&&(a=0),b.swapSpeed(0),b.browser.support3d===!0?b.transition3d(b.positionsInArray[a]):b.css2slide(b.positionsInArray[a],1),b.currentItem=b.owl.currentItem=a,b.afterGo()},afterGo:function(){var a=this;a.prevArr.push(a.currentItem),a.prevItem=a.owl.prevItem=a.prevArr[a.prevArr.length-2],a.prevArr.shift(0),a.prevItem!==a.currentItem&&(a.checkPagination(),a.checkNavigation(),a.eachMoveUpdate(),a.options.autoPlay!==!1&&a.checkAp()),"function"==typeof a.options.afterMove&&a.prevItem!==a.currentItem&&a.options.afterMove.apply(this,[a.$elem])},stop:function(){var a=this;a.apStatus="stop",b.clearInterval(a.autoPlayInterval)},checkAp:function(){var a=this;"stop"!==a.apStatus&&a.play()},play:function(){var a=this;return a.apStatus="play",a.options.autoPlay!==!1&&(b.clearInterval(a.autoPlayInterval),void(a.autoPlayInterval=b.setInterval(function(){a.next(!0)},a.options.autoPlay)))},swapSpeed:function(a){var b=this;"slideSpeed"===a?b.$owlWrapper.css(b.addCssSpeed(b.options.slideSpeed)):"paginationSpeed"===a?b.$owlWrapper.css(b.addCssSpeed(b.options.paginationSpeed)):"string"!=typeof a&&b.$owlWrapper.css(b.addCssSpeed(a))},addCssSpeed:function(a){return{"-webkit-transition":"all "+a+"ms ease","-moz-transition":"all "+a+"ms ease","-o-transition":"all "+a+"ms ease",transition:"all "+a+"ms ease"}},removeTransition:function(){return{"-webkit-transition":"","-moz-transition":"","-o-transition":"",transition:""}},doTranslate:function(a){return{"-webkit-transform":"translate3d("+a+"px, 0px, 0px)","-moz-transform":"translate3d("+a+"px, 0px, 0px)","-o-transform":"translate3d("+a+"px, 0px, 0px)","-ms-transform":"translate3d("+a+"px, 0px, 0px)",transform:"translate3d("+a+"px, 0px,0px)"}},transition3d:function(a){var b=this;b.$owlWrapper.css(b.doTranslate(a))},css2move:function(a){var b=this;b.$owlWrapper.css({left:a})},css2slide:function(a,b){var c=this;c.isCssFinish=!1,c.$owlWrapper.stop(!0,!0).animate({left:a},{duration:b||c.options.slideSpeed,complete:function(){c.isCssFinish=!0}})},checkBrowser:function(){var a=this,d="translate3d(0px, 0px, 0px)",e=c.createElement("div"),f,g,h,i;e.style.cssText="  -moz-transform:"+d+"; -ms-transform:"+d+"; -o-transform:"+d+"; -webkit-transform:"+d+"; transform:"+d,f=/translate3d\(0px, 0px, 0px\)/g,g=e.style.cssText.match(f),h=null!==g&&1===g.length,i="ontouchstart"in b||b.navigator.msMaxTouchPoints,a.browser={support3d:h,isTouch:i}},moveEvents:function(){var a=this;a.options.mouseDrag===!1&&a.options.touchDrag===!1||(a.gestures(),a.disabledEvents())},eventTypes:function(){var a=this,b=["s","e","x"];a.ev_types={},a.options.mouseDrag===!0&&a.options.touchDrag===!0?b=["touchstart.owl mousedown.owl","touchmove.owl mousemove.owl","touchend.owl touchcancel.owl mouseup.owl"]:a.options.mouseDrag===!1&&a.options.touchDrag===!0?b=["touchstart.owl","touchmove.owl","touchend.owl touchcancel.owl"]:a.options.mouseDrag===!0&&a.options.touchDrag===!1&&(b=["mousedown.owl","mousemove.owl","mouseup.owl"]),a.ev_types.start=b[0],a.ev_types.move=b[1],a.ev_types.end=b[2];
},disabledEvents:function(){var b=this;b.$elem.on("dragstart.owl",function(a){a.preventDefault()}),b.$elem.on("mousedown.disableTextSelect",function(b){return a(b.target).is("input, textarea, select, option")})},gestures:function(){var d=this,e={offsetX:0,offsetY:0,baseElWidth:0,relativePos:0,position:null,minSwipe:null,maxSwipe:null,sliding:null,dargging:null,targetElement:null};d.isCssFinish=!0;function f(a){if(void 0!==a.touches)return{x:a.touches[0].pageX,y:a.touches[0].pageY};if(void 0===a.touches){if(void 0!==a.pageX)return{x:a.pageX,y:a.pageY};if(void 0===a.pageX)return{x:a.clientX,y:a.clientY}}}function g(b){"on"===b?(a(c).on(d.ev_types.move,i),a(c).on(d.ev_types.end,j)):"off"===b&&(a(c).off(d.ev_types.move),a(c).off(d.ev_types.end))}function h(c){var h=c.originalEvent||c||b.event,i;if(3===h.which)return!1;if(!(d.itemsAmount<=d.options.items)){if(d.isCssFinish===!1&&!d.options.dragBeforeAnimFinish)return!1;if(d.isCss3Finish===!1&&!d.options.dragBeforeAnimFinish)return!1;d.options.autoPlay!==!1&&b.clearInterval(d.autoPlayInterval),d.browser.isTouch===!0||d.$owlWrapper.hasClass("grabbing")||d.$owlWrapper.addClass("grabbing"),d.newPosX=0,d.newRelativeX=0,a(this).css(d.removeTransition()),i=a(this).position(),e.relativePos=i.left,e.offsetX=f(h).x-i.left,e.offsetY=f(h).y-i.top,g("on"),e.sliding=!1,e.targetElement=h.target||h.srcElement}}function i(g){var h=g.originalEvent||g||b.event,i,j;d.newPosX=f(h).x-e.offsetX,d.newPosY=f(h).y-e.offsetY,d.newRelativeX=d.newPosX-e.relativePos,"function"==typeof d.options.startDragging&&e.dragging!==!0&&0!==d.newRelativeX&&(e.dragging=!0,d.options.startDragging.apply(d,[d.$elem])),(d.newRelativeX>8||d.newRelativeX<-8)&&d.browser.isTouch===!0&&(void 0!==h.preventDefault?h.preventDefault():h.returnValue=!1,e.sliding=!0),(d.newPosY>10||d.newPosY<-10)&&e.sliding===!1&&a(c).off("touchmove.owl"),i=function(){return d.newRelativeX/5},j=function(){return d.maximumPixels+d.newRelativeX/5},d.newPosX=Math.max(Math.min(d.newPosX,i()),j()),d.browser.support3d===!0?d.transition3d(d.newPosX):d.css2move(d.newPosX)}function j(c){var f=c.originalEvent||c||b.event,h,i,j;f.target=f.target||f.srcElement,e.dragging=!1,d.browser.isTouch!==!0&&d.$owlWrapper.removeClass("grabbing"),d.newRelativeX<0?d.dragDirection=d.owl.dragDirection="left":d.dragDirection=d.owl.dragDirection="right",0!==d.newRelativeX&&(h=d.getNewPosition(),d.goTo(h,!1,"drag"),e.targetElement===f.target&&d.browser.isTouch!==!0&&(a(f.target).on("click.disable",function(b){b.stopImmediatePropagation(),b.stopPropagation(),b.preventDefault(),a(b.target).off("click.disable")}),i=a._data(f.target,"events").click,j=i.pop(),i.splice(0,0,j))),g("off")}d.$elem.on(d.ev_types.start,".owl-wrapper",h)},getNewPosition:function(){var a=this,b=a.closestItem();return b>a.maximumItem?(a.currentItem=a.maximumItem,b=a.maximumItem):a.newPosX>=0&&(b=0,a.currentItem=0),b},closestItem:function(){var b=this,c=b.options.scrollPerPage===!0?b.pagesInArray:b.positionsInArray,d=b.newPosX,e=null;return a.each(c,function(f,g){d-b.itemWidth/20>c[f+1]&&d-b.itemWidth/20<g&&"left"===b.moveDirection()?(e=g,b.options.scrollPerPage===!0?b.currentItem=a.inArray(e,b.positionsInArray):b.currentItem=f):d+b.itemWidth/20<g&&d+b.itemWidth/20>(c[f+1]||c[f]-b.itemWidth)&&"right"===b.moveDirection()&&(b.options.scrollPerPage===!0?(e=c[f+1]||c[c.length-1],b.currentItem=a.inArray(e,b.positionsInArray)):(e=c[f+1],b.currentItem=f+1))}),b.currentItem},moveDirection:function(){var a=this,b;return a.newRelativeX<0?(b="right",a.playDirection="next"):(b="left",a.playDirection="prev"),b},customEvents:function(){var a=this;a.$elem.on("owl.next",function(){a.next()}),a.$elem.on("owl.prev",function(){a.prev()}),a.$elem.on("owl.play",function(b,c){a.options.autoPlay=c,a.play(),a.hoverStatus="play"}),a.$elem.on("owl.stop",function(){a.stop(),a.hoverStatus="stop"}),a.$elem.on("owl.goTo",function(b,c){a.goTo(c)}),a.$elem.on("owl.jumpTo",function(b,c){a.jumpTo(c)})},stopOnHover:function(){var a=this;a.options.stopOnHover===!0&&a.browser.isTouch!==!0&&a.options.autoPlay!==!1&&(a.$elem.on("mouseover",function(){a.stop()}),a.$elem.on("mouseout",function(){"stop"!==a.hoverStatus&&a.play()}))},lazyLoad:function(){var b=this,c,d,e,f,g;if(b.options.lazyLoad===!1)return!1;for(c=0;c<b.itemsAmount;c+=1)d=a(b.$owlItems[c]),"loaded"!==d.data("owl-loaded")&&(e=d.data("owl-item"),f=d.find(".lazyOwl"),"string"==typeof f.data("src")?(void 0===d.data("owl-loaded")&&(f.hide(),d.addClass("loading").data("owl-loaded","checked")),g=b.options.lazyFollow!==!0||e>=b.currentItem,g&&e<b.currentItem+b.options.items&&f.length&&b.lazyPreload(d,f)):d.data("owl-loaded","loaded"))},lazyPreload:function(a,c){var d=this,e=0,f;"DIV"===c.prop("tagName")?(c.css("background-image","url("+c.data("src")+")"),f=!0):c[0].src=c.data("src");function g(){a.data("owl-loaded","loaded").removeClass("loading"),c.removeAttr("data-src"),"fade"===d.options.lazyEffect?c.fadeIn(400):c.show(),"function"==typeof d.options.afterLazyLoad&&d.options.afterLazyLoad.apply(this,[d.$elem])}function h(){e+=1,d.completeImg(c.get(0))||f===!0?g():e<=100?b.setTimeout(h,100):g()}h()},autoHeight:function(){var c=this,d=a(c.$owlItems[c.currentItem]).find("img"),e;function f(){var d=a(c.$owlItems[c.currentItem]).height();c.wrapperOuter.css("height",d+"px"),c.wrapperOuter.hasClass("autoHeight")||b.setTimeout(function(){c.wrapperOuter.addClass("autoHeight")},0)}function g(){e+=1,c.completeImg(d.get(0))?f():e<=100?b.setTimeout(g,100):c.wrapperOuter.css("height","")}void 0!==d.get(0)?(e=0,g()):f()},completeImg:function(a){var b;return!!a.complete&&(b=typeof a.naturalWidth,"undefined"===b||0!==a.naturalWidth)},onVisibleItems:function(){var b=this,c;for(b.options.addClassActive===!0&&b.$owlItems.removeClass("active"),b.visibleItems=[],c=b.currentItem;c<b.currentItem+b.options.items;c+=1)b.visibleItems.push(c),b.options.addClassActive===!0&&a(b.$owlItems[c]).addClass("active");b.owl.visibleItems=b.visibleItems},transitionTypes:function(a){var b=this;b.outClass="owl-"+a+"-out",b.inClass="owl-"+a+"-in"},singleItemTransition:function(){var a=this,b=a.outClass,c=a.inClass,d=a.$owlItems.eq(a.currentItem),e=a.$owlItems.eq(a.prevItem),f=Math.abs(a.positionsInArray[a.currentItem])+a.positionsInArray[a.prevItem],g=Math.abs(a.positionsInArray[a.currentItem])+a.itemWidth/2,h="webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend";a.isTransition=!0,a.$owlWrapper.addClass("owl-origin").css({"-webkit-transform-origin":g+"px","-moz-perspective-origin":g+"px","perspective-origin":g+"px"});function i(a){return{position:"relative",left:a+"px"}}e.css(i(f,10)).addClass(b).on(h,function(){a.endPrev=!0,e.off(h),a.clearTransStyle(e,b)}),d.addClass(c).on(h,function(){a.endCurrent=!0,d.off(h),a.clearTransStyle(d,c)})},clearTransStyle:function(a,b){var c=this;a.css({position:"",left:""}).removeClass(b),c.endPrev&&c.endCurrent&&(c.$owlWrapper.removeClass("owl-origin"),c.endPrev=!1,c.endCurrent=!1,c.isTransition=!1)},owlStatus:function(){var a=this;a.owl={userOptions:a.userOptions,baseElement:a.$elem,userItems:a.$userItems,owlItems:a.$owlItems,currentItem:a.currentItem,prevItem:a.prevItem,visibleItems:a.visibleItems,isTouch:a.browser.isTouch,browser:a.browser,dragDirection:a.dragDirection}},clearEvents:function(){var d=this;d.$elem.off(".owl owl mousedown.disableTextSelect"),a(c).off(".owl owl"),a(b).off("resize",d.resizer)},unWrap:function(){var a=this;0!==a.$elem.children().length&&(a.$owlWrapper.unwrap(),a.$userItems.unwrap().unwrap(),a.owlControls&&a.owlControls.remove()),a.clearEvents(),a.$elem.attr("style",a.$elem.data("owl-originalStyles")||"").attr("class",a.$elem.data("owl-originalClasses"))},destroy:function(){var a=this;a.stop(),b.clearInterval(a.checkVisible),a.unWrap(),a.$elem.removeData()},reinit:function(b){var c=this,d=a.extend({},c.userOptions,b);c.unWrap(),c.init(d,c.$elem)},addItem:function(a,b){var c=this,d;return!!a&&(0===c.$elem.children().length?(c.$elem.append(a),c.setVars(),!1):(c.unWrap(),d=void 0===b||b===-1?-1:b,d>=c.$userItems.length||d===-1?c.$userItems.eq(-1).after(a):c.$userItems.eq(d).before(a),void c.setVars()))},removeItem:function(a){var b=this,c;return 0!==b.$elem.children().length&&(c=void 0===a||a===-1?-1:a,b.unWrap(),b.$userItems.eq(c).remove(),void b.setVars())}};a.fn.owlCarousel=function(b){return this.each(function(){if(a(this).data("owl-init")===!0)return!1;a(this).data("owl-init",!0);var c=Object.create(d);c.init(b,this),a.data(this,"owlCarousel",c)})},a.fn.owlCarousel.options={items:5,itemsCustom:!1,itemsDesktop:[1199,4],itemsDesktopSmall:[979,3],itemsTablet:[768,2],itemsTabletSmall:!1,itemsMobile:[479,1],singleItem:!1,itemsScaleUp:!1,slideSpeed:200,paginationSpeed:800,rewindSpeed:1e3,autoPlay:!1,stopOnHover:!1,navigation:!1,navigationText:["prev","next"],rewindNav:!0,scrollPerPage:!1,pagination:!0,paginationNumbers:!1,responsive:!0,responsiveRefreshRate:200,responsiveBaseWidth:b,baseClass:"owl-carousel",theme:"owl-theme",lazyLoad:!1,lazyFollow:!0,lazyEffect:"fade",autoHeight:!1,jsonPath:!1,jsonSuccess:!1,dragBeforeAnimFinish:!0,mouseDrag:!0,touchDrag:!0,addClassActive:!1,transitionStyle:!1,beforeUpdate:!1,afterUpdate:!1,beforeInit:!1,afterInit:!1,beforeMove:!1,afterMove:!1,afterAction:!1,startDragging:!1,afterLazyLoad:!1}}(jQuery,window,document),function(a,b){"function"==typeof define&&define.amd?define(b):"object"==typeof module&&"object"==typeof module.exports?module.exports=b():a.Cldr=b()}(this,function(){var a=Array.isArray||function(a){return"[object Array]"===Object.prototype.toString.call(a)},b=function(b,c){if(a(b)&&(b=b.join("/")),"string"!=typeof b)throw new Error('invalid path "'+b+'"');return b=b.replace(/^\//,"").replace(/^cldr\//,""),b=b.replace(/{[a-zA-Z]+}/g,function(a){return a=a.replace(/^{([^}]*)}$/,"$1"),c[a]}),b.split("/")},c=function(a,b){var c,d;if(a.some)return a.some(b);for(c=0,d=a.length;c<d;c++)if(b(a[c],c,a))return!0;return!1},d=function(a,b,d,e){var f,g,h=d[0],i=d[1],j=a.localeSep,k=d[2],l=d.slice(3,4);return e=e||{},"und"!==h&&"Zzzz"!==i&&"ZZ"!==k?[h,i,k].concat(l):"undefined"!=typeof b.get("supplemental/likelySubtags")?(g=c([[h,i,k],[h,k],[h,i],[h],["und",i]],function(a){return f=!/\b(Zzzz|ZZ)\b/.test(a.join(j))&&b.get(["supplemental/likelySubtags",a.join(j)])}),g?(f=f.split(j),["und"!==h?h:f[0],"Zzzz"!==i?i:f[1],"ZZ"!==k?k:f[2]].concat(l)):e.force?b.get("supplemental/likelySubtags/und").split(j):void 0):void 0},e=function(a,b,e){var f,g,h=e[0],i=e[1],j=e[2],k=e[3];return g=c([[[h,"Zzzz","ZZ"],[h]],[[h,"Zzzz",j],[h,j]],[[h,i,"ZZ"],[h,i]]],function(c){var g=d(a,b,c[0]);return f=c[1],g&&g[0]===e[0]&&g[1]===e[1]&&g[2]===e[2]}),g?(k&&f.push(k),f):e},f=function(a){var b,c,d=[];return a=a.replace(/_/,"-"),b=a.split("-u-"),b[1]&&(b[1]=b[1].split("-t-"),a=b[0]+(b[1][1]?"-t-"+b[1][1]:""),d[4]=b[1][0]),c=a.split("-t-")[0],b=c.match(/^(([a-z]{2,3})(-([A-Z][a-z]{3}))?(-([A-Z]{2}|[0-9]{3}))?)((-([a-zA-Z0-9]{5,8}|[0-9][a-zA-Z0-9]{3}))*)$|^(root)$/),null===b?["und","Zzzz","ZZ"]:(d[0]=b[10]||b[2]||"und",d[1]=b[4]||"Zzzz",d[2]=b[6]||"ZZ",b[7]&&b[7].length&&(d[3]=b[7].slice(1)),d)},g=function(a,b){var c,d;if(a.forEach)return a.forEach(b);for(c=0,d=a.length;c<d;c++)b(a[c],c,a)},h=function(a,b,c){var h=a._availableBundleMap,i=a._availableBundleMapQueue;return i.length&&(g(i,function(c){var g,j,k,l;l=f(c),j=d(a,b,l),k=e(a,b,j),k=k.join(a.localeSep),g=i[k],g&&g.length<c.length||(h[k]=c)}),a._availableBundleMapQueue=[]),h[c]||null},i=function(a){var b,c=[];if(Object.keys)return Object.keys(a);for(b in a)c.push(b);return c},j=function(a,b){var c,d;return d=a+(b&&JSON?": "+JSON.stringify(b):""),c=new Error(d),c.code=a,g(i(b),function(a){c[a]=b[a]}),c},k=function(a,b,c){if(!b)throw j(a,c)},l=function(a,b){k("E_MISSING_PARAMETER","undefined"!=typeof a,{name:b})},m=function(a,b,c,d){k("E_INVALID_PAR_TYPE",c,{expected:d,name:b,value:a})},n=function(b,c){m(b,c,"string"==typeof b||a(b),"String or Array")},o=function(a){return null!==a&&""+a=="[object Object]"},p=function(a,b){m(a,b,"undefined"==typeof a||o(a),"Plain Object")},q=function(a,b){m(a,b,"string"==typeof a,"a string")},r=function(a,b){var c,d=a,e=b.length;for(c=0;c<e-1;c++)if(d=d[b[c]],!d)return;return d[b[c]]},s=function(a,b){var c,d=a._availableBundleMapQueue,e=r(b,["main"]);if(e)for(c in e)e.hasOwnProperty(c)&&"root"!==c&&d.indexOf(c)===-1&&d.push(c)},t=function(b){return a(b)?b:[b]},u=function(){var b=function(){var c={},d=[].slice.call(arguments,0);return g(d,function(d){var e;for(e in d)e in c&&"object"==typeof c[e]&&!a(c[e])?c[e]=b(c[e],d[e]):c[e]=d[e]}),c};return b}(),v=function(a,b,c){var d,e,f;for(l(c[0],"json"),d=0;d<c.length;d++)for(f=t(c[d]),e=0;e<f.length;e++)p(f[e],"json"),b=u(b,f[e]),s(a,f[e]);return b},w=function(a,c,d){var e=b(c,d);return r(a._resolved,e)},x=function(a){this.init(a)};return x._alwaysArray=t,x._coreLoad=v,x._createError=j,x._itemGetResolved=w,x._jsonMerge=u,x._pathNormalize=b,x._resourceGet=r,x._validatePresence=l,x._validateType=m,x._validateTypePath=n,x._validateTypePlainObject=p,x._availableBundleMap={},x._availableBundleMapQueue=[],x._resolved={},x.localeSep="-",x.load=function(){x._resolved=v(x,x._resolved,arguments)},x.prototype.init=function(a){var b,c,g,i,j,k,m,n,o,p=x.localeSep,r="";l(a,"locale"),q(a,"locale"),k=f(a),5===k.length&&(n=k.pop(),r=p+"u"+p+n,k[3]||k.pop()),o=k[3],g=d(x,this,k,{force:!0})||k,c=g[0],j=g[1],m=g[2],i=e(x,this,g).join(p),this.attributes=b={bundle:h(x,this,i),minLanguageId:i+r,maxLanguageId:g.join(p)+r,language:c,script:j,territory:m,region:m,variant:o},n&&("-"+n).replace(/-[a-z]{3,8}|(-[a-z]{2})-([a-z]{3,8})/g,function(a,c,d){c?b["u"+c]=d:b["u"+a]=!0}),this.locale=a},x.prototype.get=function(a){return l(a,"path"),n(a,"path"),w(x,a,this.attributes)},x.prototype.main=function(a){return l(a,"path"),n(a,"path"),k("E_MISSING_BUNDLE",null!==this.attributes.bundle,{locale:this.locale}),a=t(a),this.get(["main/{bundle}"].concat(a))},x}),function(a){"function"==typeof define&&define.amd?define(["../cldr"],a):"object"==typeof module&&"object"==typeof module.exports?module.exports=a(require("../cldr")):a(Cldr)}(function(a){var b=a._pathNormalize,c=a._validatePresence,d=a._validateType,e;e=function(){function a(){}var b=a.prototype,c=this,d=c.EventEmitter;function e(a,b){var c=a.length;while(c--)if(a[c].listener===b)return c;return-1}function f(a){return function b(){return this[a].apply(this,arguments)}}return b.getListeners=function a(b){var c=this._getEvents(),d,e;if(b instanceof RegExp){d={};for(e in c)c.hasOwnProperty(e)&&b.test(e)&&(d[e]=c[e])}else d=c[b]||(c[b]=[]);return d},b.flattenListeners=function a(b){var c=[],d;for(d=0;d<b.length;d+=1)c.push(b[d].listener);return c},b.getListenersAsObject=function a(b){var c=this.getListeners(b),d;return c instanceof Array&&(d={},d[b]=c),d||c},b.addListener=function a(b,c){var d=this.getListenersAsObject(b),f="object"==typeof c,g;for(g in d)d.hasOwnProperty(g)&&e(d[g],c)===-1&&d[g].push(f?c:{listener:c,once:!1});return this},b.on=f("addListener"),b.addOnceListener=function a(b,c){return this.addListener(b,{listener:c,once:!0})},b.once=f("addOnceListener"),b.defineEvent=function a(b){return this.getListeners(b),this},b.defineEvents=function a(b){for(var c=0;c<b.length;c+=1)this.defineEvent(b[c]);return this},b.removeListener=function a(b,c){var d=this.getListenersAsObject(b),f,g;for(g in d)d.hasOwnProperty(g)&&(f=e(d[g],c),f!==-1&&d[g].splice(f,1));return this},b.off=f("removeListener"),b.addListeners=function a(b,c){return this.manipulateListeners(!1,b,c)},b.removeListeners=function a(b,c){return this.manipulateListeners(!0,b,c)},b.manipulateListeners=function a(b,c,d){var e,f,g=b?this.removeListener:this.addListener,h=b?this.removeListeners:this.addListeners;if("object"!=typeof c||c instanceof RegExp){e=d.length;while(e--)g.call(this,c,d[e])}else for(e in c)c.hasOwnProperty(e)&&(f=c[e])&&("function"==typeof f?g.call(this,e,f):h.call(this,e,f));return this},b.removeEvent=function a(b){var c=typeof b,d=this._getEvents(),e;if("string"===c)delete d[b];else if(b instanceof RegExp)for(e in d)d.hasOwnProperty(e)&&b.test(e)&&delete d[e];else delete this._events;return this},b.removeAllListeners=f("removeEvent"),b.emitEvent=function a(b,c){var d=this.getListenersAsObject(b),e,f,g,h;for(g in d)if(d.hasOwnProperty(g)){f=d[g].length;while(f--)e=d[g][f],e.once===!0&&this.removeListener(b,e.listener),h=e.listener.apply(this,c||[]),h===this._getOnceReturnValue()&&this.removeListener(b,e.listener)}return this},b.trigger=f("emitEvent"),b.emit=function a(b){var c=Array.prototype.slice.call(arguments,1);return this.emitEvent(b,c)},b.setOnceReturnValue=function a(b){return this._onceReturnValue=b,this},b._getOnceReturnValue=function a(){return!this.hasOwnProperty("_onceReturnValue")||this._onceReturnValue},b._getEvents=function a(){return this._events||(this._events={})},a.noConflict=function b(){return c.EventEmitter=d,a},a}();var f=function(a,b){d(a,b,"undefined"==typeof a||"function"==typeof a,"Function")},g,h,i=new e;function j(a,b){d(a,b,"string"==typeof a||a instanceof RegExp,"String or RegExp")}function k(a,b){return function(d,e){return c(d,"event"),j(d,"event"),c(e,"listener"),f(e,"listener"),b[a].apply(b,arguments)}}function l(a){return k("off",a)}function m(a){return k("on",a)}function n(a){return k("once",a)}a.off=l(i),a.on=m(i),a.once=n(i),h=a.prototype.init,a.prototype.init=function(){var a;this.ee=a=new e,this.off=l(a),this.on=m(a),this.once=n(a),h.apply(this,arguments)};function o(){g=a.prototype.get,a.prototype.get=function(a){var c=g.apply(this,arguments);return a=b(a,this.attributes).join("/"),i.trigger("get",[a,c]),this.ee.trigger("get",[a,c]),c}}return a._eventInit=o,o(),a}),function(a){"function"==typeof define&&define.amd?define(["../cldr"],a):"object"==typeof module&&"object"==typeof module.exports?module.exports=a(require("../cldr")):a(Cldr)}(function(a){var b=a._alwaysArray,c=function(a){var c,d;return c=function(c){return function(d){return d=b(d),a.get([c].concat(d))}},d=c("supplemental"),d.weekData=c("supplemental/weekData"),d.weekData.firstDay=function(){return a.get("supplemental/weekData/firstDay/{territory}")||a.get("supplemental/weekData/firstDay/001")},d.weekData.minDays=function(){var b=a.get("supplemental/weekData/minDays/{territory}")||a.get("supplemental/weekData/minDays/001");return parseInt(b,10)},d.timeData=c("supplemental/timeData"),d.timeData.allowed=function(){return a.get("supplemental/timeData/{territory}/_allowed")||a.get("supplemental/timeData/001/_allowed")},d.timeData.preferred=function(){return a.get("supplemental/timeData/{territory}/_preferred")||a.get("supplemental/timeData/001/_preferred")},d},d=a.prototype.init;return a.prototype.init=function(){d.apply(this,arguments),this.supplemental=c(this)},a}),function(a,b){"function"==typeof define&&define.amd?define(["cldr","cldr/event"],b):"object"==typeof exports?module.exports=b(require("cldrjs")):a.Globalize=b(a.Cldr)}(this,function(a){var b=function(a){return"string"==typeof a?a:"number"==typeof a?""+a:JSON.stringify(a)},c=function(a,c){return a=a.replace(/{[0-9a-zA-Z-_. ]+}/g,function(a){return a=a.replace(/^{([^}]*)}$/,"$1"),b(c[a])})},d=function(){var a=arguments[0],b=[].slice.call(arguments,1);return b.forEach(function(b){var c;for(c in b)a[c]=b[c]}),a},e=function(a,b,e){var f;return b=a+(b?": "+c(b,e):""),f=new Error(b),f.code=a,d(f,e),f},f=function(a){return[].reduce.call(a,function(a,b){var c=b.charCodeAt(0);return a=(a<<5)-a+c,0|a},0)},g=function(a,b,c,d){var e;return d=d||JSON.stringify(c),e=f(a+b+d),e>0?"a"+e:"b"+Math.abs(e)},h=function(a){if(void 0!==a.name)return a.name;var b=/^function\s+([\w\$]+)\s*\(/.exec(a.toString());return b&&b.length>0?b[1]:void 0},i=function(a,b,c,d){var e=JSON.stringify(a),f=h(c),i=b.locale;return f?(c.runtimeKey=g(f,i,null,e),c.generatorString=function(){return'Globalize("'+i+'").'+f+"("+e.slice(1,-1)+")"},c.runtimeArgs=d,c):c},j=function(a,b,c,d){if(!c)throw e(a,b,d)},k=function(a){return Array.isArray(a)?a:a?[a]:[]},l=function(a,b,c){var d;c=c||{},d=k(c.skip).some(function(b){return b.test(a)}),j("E_MISSING_CLDR","Missing required CLDR content `{path}`.",b||d,{path:a})},m=function(a){j("E_DEFAULT_LOCALE_NOT_DEFINED","Default locale has not been defined.",void 0!==a,{})},n=function(a,b){j("E_MISSING_PARAMETER","Missing required parameter `{name}`.",void 0!==a,{name:b})},o=function(a,b,c,d){j("E_PAR_OUT_OF_RANGE","Parameter `{name}` has value `{value}` out of range [{minimum}, {maximum}].",void 0===a||a>=c&&a<=d,{maximum:d,minimum:c,name:b,value:a})},p=function(a,b,c,d){j("E_INVALID_PAR_TYPE","Invalid `{name}` parameter ({value}). {expected} expected.",c,{expected:d,name:b,value:a})},q=function(b,c){p(b,c,void 0===b||"string"==typeof b||b instanceof a,"String or Cldr instance")},r=function(a){return null!==a&&""+a=="[object Object]"},s=function(a,b){p(a,b,void 0===a||r(a),"Plain Object")},t=function(b){return b instanceof a?b:new a(b)},u=function(a){return a.replace(/([.*+?^=!:${}()|\[\]\/\\])/g,"\\$1")},v=function(a,b,c){var d;for("string"!=typeof a&&(a=String(a)),d=a.length;d<b;d+=1)a=c?a+"0":"0"+a;return a};function w(a){a.once("get",l),a.get("supplemental/likelySubtags")}function x(a){return this instanceof x?(n(a,"locale"),q(a,"locale"),this.cldr=t(a),void w(this.cldr)):new x(a)}return x.load=function(){a.load.apply(a,arguments)},x.locale=function(a){return q(a,"locale"),arguments.length&&(this.cldr=t(a),w(this.cldr)),this.cldr},x._alwaysArray=k,x._createError=e,x._formatMessage=c,x._isPlainObject=r,x._objectExtend=d,x._regexpEscape=u,x._runtimeBind=i,x._stringPad=v,x._validate=j,x._validateCldr=l,x._validateDefaultLocale=m,x._validateParameterPresence=n,x._validateParameterRange=o,x._validateParameterTypePlainObject=s,x._validateParameterType=p,x}),function(a,b){"function"==typeof define&&define.amd?define(["cldr","../globalize","cldr/event"],b):"object"==typeof exports?module.exports=b(require("cldrjs"),require("globalize")):b(a.Cldr,a.Globalize)}(this,function(a,b){var c=b._alwaysArray,d=b._createError,e=b._isPlainObject,f=b._runtimeBind,g=b._validateDefaultLocale,h=b._validate,i=b._validateParameterPresence,j=b._validateParameterType,k=b._validateParameterTypePlainObject,l;l=function(){b._parse=function(){function a(a,b){function c(){this.constructor=a}c.prototype=b.prototype,a.prototype=new c}function b(a,b,c,d,e,f){this.message=a,this.expected=b,this.found=c,this.offset=d,this.line=e,this.column=f,this.name="SyntaxError"}a(b,Error);function c(a){var c=arguments.length>1?arguments[1]:{},d={},e={start:Ma},f=Ma,g=[],h=function(a){return{type:"messageFormatPattern",statements:a}},i=d,j="{",k={type:"literal",value:"{",description:'"{"'},l=null,m=",",n={type:"literal",value:",",description:'","'},o="}",p={type:"literal",value:"}",description:'"}"'},q=function(a,b){var c={type:"messageFormatElement",argumentIndex:a};return b&&b.length?c.elementFormat=b[1]:c.output=!0,c},r="plural",s={type:"literal",value:"plural",description:'"plural"'},t=function(a,b){return{type:"elementFormat",key:a,val:b}},u="selectordinal",v={type:"literal",value:"selectordinal",description:'"selectordinal"'},w="select",x={type:"literal",value:"select",description:'"select"'},y=function(a,b){return{type:"elementFormat",key:a,val:b}},z=function(a,b){return{type:"pluralFormatPattern",pluralForms:b,offset:a||0}},A="offset",B={type:"literal",value:"offset",description:'"offset"'},C=":",D={type:"literal",value:":",description:'":"'},E=function(a){return a},F=function(a,b){return{key:a,val:b}},G=function(a){return a},H="=",I={type:"literal",value:"=",description:'"="'},J=function(a){return{type:"selectFormatPattern",pluralForms:a}},K=function(a){return a},L="#",M={type:"literal",value:"#",description:'"#"'},N=function(){return{type:"octothorpe"}},O=function(a){return{type:"string",val:a.join("")}},P={type:"other",description:"identifier"},Q=/^[0-9a-zA-Z$_]/,R={type:"class",value:"[0-9a-zA-Z$_]",description:"[0-9a-zA-Z$_]"},S=/^[^ \t\n\r,.+={}]/,T={type:"class",value:"[^ \\t\\n\\r,.+={}]",description:"[^ \\t\\n\\r,.+={}]"},U=function(a){return a},V=function(a){return a.join("")},W=/^[^{}#\\\0-\x1F\x7f \t\n\r]/,X={type:"class",value:"[^{}#\\\\\\0-\\x1F\x7f \\t\\n\\r]",description:"[^{}#\\\\\\0-\\x1F\x7f \\t\\n\\r]"},Y=function(a){return a},Z="\\\\",$={type:"literal",value:"\\\\",description:'"\\\\\\\\"'},_=function(){return"\\"},aa="\\#",ba={type:"literal",value:"\\#",description:'"\\\\#"'},ca=function(){return"#"},da="\\{",ea={type:"literal",value:"\\{",description:'"\\\\{"'},fa=function(){return"{"},ga="\\}",ha={type:"literal",value:"\\}",description:'"\\\\}"'},ia=function(){return"}"},ja="\\u",ka={type:"literal",value:"\\u",description:'"\\\\u"'},la=function(a,b,c,d){return String.fromCharCode(parseInt("0x"+a+b+c+d))},ma=/^[0-9]/,na={type:"class",value:"[0-9]",description:"[0-9]"},oa=function(a){return parseInt(a.join(""),10)},pa=/^[0-9a-fA-F]/,qa={type:"class",value:"[0-9a-fA-F]",description:"[0-9a-fA-F]"},ra={type:"other",description:"whitespace"},sa=function(a){return a.join("")},ta=/^[ \t\n\r]/,ua={type:"class",value:"[ \\t\\n\\r]",description:"[ \\t\\n\\r]"},va=0,wa=0,xa=0,ya={line:1,column:1,seenCR:!1},za=0,Aa=[],Ba=0,Ca;if("startRule"in c){if(!(c.startRule in e))throw new Error("Can't start parsing from rule \""+c.startRule+'".');f=e[c.startRule]}function Da(){return a.substring(wa,va)}function Ea(){return wa}function Fa(){return Ja(wa).line}function Ga(){return Ja(wa).column}function Ha(a){throw La(null,[{type:"other",description:a}],wa)}function Ia(a){throw La(a,null,wa)}function Ja(b){function c(b,c,d){var e,f;for(e=c;e<d;e++)f=a.charAt(e),"\n"===f?(b.seenCR||b.line++,b.column=1,b.seenCR=!1):"\r"===f||"\u2028"===f||"\u2029"===f?(b.line++,b.column=1,b.seenCR=!0):(b.column++,b.seenCR=!1)}return xa!==b&&(xa>b&&(xa=0,ya={line:1,column:1,seenCR:!1}),c(ya,xa,b),xa=b),ya}function Ka(a){va<za||(va>za&&(za=va,Aa=[]),Aa.push(a))}function La(c,d,e){function f(a){var b=1;a.sort(function(a,b){return a.description<b.description?-1:a.description>b.description?1:0});while(b<a.length)a[b-1]===a[b]?a.splice(b,1):b++}function g(a,b){function c(a){function b(a){return a.charCodeAt(0).toString(16).toUpperCase()}return a.replace(/\\/g,"\\\\").replace(/"/g,'\\"').replace(/\x08/g,"\\b").replace(/\t/g,"\\t").replace(/\n/g,"\\n").replace(/\f/g,"\\f").replace(/\r/g,"\\r").replace(/[\x00-\x07\x0B\x0E\x0F]/g,function(a){return"\\x0"+b(a)}).replace(/[\x10-\x1F\x80-\xFF]/g,function(a){return"\\x"+b(a)}).replace(/[\u0180-\u0FFF]/g,function(a){return"\\u0"+b(a)}).replace(/[\u1080-\uFFFF]/g,function(a){return"\\u"+b(a)})}var d=new Array(a.length),e,f,g;for(g=0;g<a.length;g++)d[g]=a[g].description;return e=a.length>1?d.slice(0,-1).join(", ")+" or "+d[a.length-1]:d[0],f=b?'"'+c(b)+'"':"end of input","Expected "+e+" but "+f+" found."}var h=Ja(e),i=e<a.length?a.charAt(e):null;return null!==d&&f(d),new b(null!==c?c:g(d,i),d,i,e,h.line,h.column)}function Ma(){var a;return a=Na()}function Na(){var a,b,c;a=va,b=[],c=Oa(),c===d&&(c=Ya(),c===d&&(c=Xa()));while(c!==d)b.push(c),c=Oa(),c===d&&(c=Ya(),c===d&&(c=Xa()));return b!==d&&(wa=a,b=h(b)),a=b}function Oa(){var b,c,e,f,g,h,r;return b=va,123===a.charCodeAt(va)?(c=j,va++):(c=d,0===Ba&&Ka(k)),c!==d?(e=cb(),e!==d?(f=Za(),f!==d?(g=va,44===a.charCodeAt(va)?(h=m,va++):(h=d,0===Ba&&Ka(n)),h!==d?(r=Pa(),r!==d?(h=[h,r],g=h):(va=g,g=i)):(va=g,g=i),g===d&&(g=l),g!==d?(h=cb(),h!==d?(125===a.charCodeAt(va)?(r=o,va++):(r=d,0===Ba&&Ka(p)),r!==d?(wa=b,c=q(f,g),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i),b}function Pa(){var b,c,e,f,g,h,j,k;if(b=va,c=cb(),c!==d?(a.substr(va,6)===r?(e=r,va+=6):(e=d,0===Ba&&Ka(s)),e!==d?(f=cb(),f!==d?(44===a.charCodeAt(va)?(g=m,va++):(g=d,0===Ba&&Ka(n)),g!==d?(h=cb(),h!==d?(j=Qa(),j!==d?(k=cb(),k!==d?(wa=b,c=t(e,j),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i),b===d&&(b=va,c=cb(),c!==d?(a.substr(va,13)===u?(e=u,va+=13):(e=d,0===Ba&&Ka(v)),e!==d?(f=cb(),f!==d?(44===a.charCodeAt(va)?(g=m,va++):(g=d,0===Ba&&Ka(n)),g!==d?(h=cb(),h!==d?(j=Qa(),j!==d?(k=cb(),k!==d?(wa=b,c=t(e,j),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i),b===d&&(b=va,c=cb(),c!==d?(a.substr(va,6)===w?(e=w,va+=6):(e=d,0===Ba&&Ka(x)),e!==d?(f=cb(),f!==d?(44===a.charCodeAt(va)?(g=m,va++):(g=d,0===Ba&&Ka(n)),g!==d?(h=cb(),h!==d?(j=Ua(),j!==d?(k=cb(),k!==d?(wa=b,c=t(e,j),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i),b===d)))if(b=va,c=cb(),c!==d)if(e=Za(),e!==d){f=[],g=Wa();while(g!==d)f.push(g),g=Wa();f!==d?(wa=b,c=y(e,f),b=c):(va=b,b=i)}else va=b,b=i;else va=b,b=i;return b}function Qa(){var a,b,c,e;if(a=va,b=Ra(),b===d&&(b=l),b!==d){if(c=[],e=Sa(),e!==d)while(e!==d)c.push(e),e=Sa();else c=i;c!==d?(wa=a,b=z(b,c),a=b):(va=a,a=i)}else va=a,a=i;return a}function Ra(){var b,c,e,f,g,h,j,k;return b=va,c=cb(),c!==d?(a.substr(va,6)===A?(e=A,va+=6):(e=d,0===Ba&&Ka(B)),e!==d?(f=cb(),f!==d?(58===a.charCodeAt(va)?(g=C,va++):(g=d,0===Ba&&Ka(D)),g!==d?(h=cb(),h!==d?(j=ab(),j!==d?(k=cb(),k!==d?(wa=b,c=E(j),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i),b}function Sa(){var b,c,e,f,g,h,l,m,n;return b=va,c=cb(),c!==d?(e=Ta(),e!==d?(f=cb(),f!==d?(123===a.charCodeAt(va)?(g=j,va++):(g=d,0===Ba&&Ka(k)),g!==d?(h=cb(),h!==d?(l=Na(),l!==d?(m=cb(),m!==d?(125===a.charCodeAt(va)?(n=o,va++):(n=d,0===Ba&&Ka(p)),n!==d?(wa=b,c=F(e,l),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i),b}function Ta(){var b,c,e;return b=va,c=Za(),c!==d&&(wa=b,c=G(c)),b=c,b===d&&(b=va,61===a.charCodeAt(va)?(c=H,va++):(c=d,0===Ba&&Ka(I)),c!==d?(e=ab(),e!==d?(wa=b,c=E(e),b=c):(va=b,b=i)):(va=b,b=i)),b}function Ua(){var a,b,c;if(a=va,b=[],c=Va(),c!==d)while(c!==d)b.push(c),c=Va();else b=i;return b!==d&&(wa=a,b=J(b)),a=b}function Va(){var b,c,e,f,g,h,l,m,n;return b=va,c=cb(),c!==d?(e=Za(),e!==d?(f=cb(),f!==d?(123===a.charCodeAt(va)?(g=j,va++):(g=d,0===Ba&&Ka(k)),g!==d?(h=cb(),h!==d?(l=Na(),l!==d?(m=cb(),m!==d?(125===a.charCodeAt(va)?(n=o,va++):(n=d,0===Ba&&Ka(p)),n!==d?(wa=b,c=F(e,l),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i),b}function Wa(){var b,c,e,f,g,h;return b=va,c=cb(),c!==d?(44===a.charCodeAt(va)?(e=m,va++):(e=d,0===Ba&&Ka(n)),e!==d?(f=cb(),f!==d?(g=Za(),g!==d?(h=cb(),h!==d?(wa=b,c=K(g),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i),b}function Xa(){var b,c;return b=va,35===a.charCodeAt(va)?(c=L,va++):(c=d,0===Ba&&Ka(M)),c!==d&&(wa=b,c=N()),b=c}function Ya(){var a,b,c;if(a=va,b=[],c=$a(),c===d&&(c=db()),c!==d)while(c!==d)b.push(c),c=$a(),c===d&&(c=db());else b=i;return b!==d&&(wa=a,b=O(b)),a=b}function Za(){var b,c,e,f,g,h,j;if(Ba++,b=va,c=cb(),c!==d){if(e=va,f=va,Q.test(a.charAt(va))?(g=a.charAt(va),va++):(g=d,0===Ba&&Ka(R)),g!==d){h=[],S.test(a.charAt(va))?(j=a.charAt(va),va++):(j=d,0===Ba&&Ka(T));while(j!==d)h.push(j),S.test(a.charAt(va))?(j=a.charAt(va),va++):(j=d,0===Ba&&Ka(T));h!==d?(g=[g,h],f=g):(va=f,f=i)}else va=f,f=i;f!==d&&(f=a.substring(e,va)),e=f,e!==d?(f=cb(),f!==d?(wa=b,c=U(e),b=c):(va=b,b=i)):(va=b,b=i)}else va=b,b=i;return Ba--,b===d&&(c=d,0===Ba&&Ka(P)),b}function $a(){var a,b,c;if(a=va,b=[],c=_a(),c!==d)while(c!==d)b.push(c),c=_a();else b=i;return b!==d&&(wa=a,b=V(b)),a=b}function _a(){var b,c,e,f,g,h;return b=va,W.test(a.charAt(va))?(c=a.charAt(va),va++):(c=d,0===Ba&&Ka(X)),c!==d&&(wa=b,c=Y(c)),b=c,b===d&&(b=va,a.substr(va,2)===Z?(c=Z,va+=2):(c=d,0===Ba&&Ka($)),c!==d&&(wa=b,c=_()),b=c,b===d&&(b=va,a.substr(va,2)===aa?(c=aa,va+=2):(c=d,0===Ba&&Ka(ba)),c!==d&&(wa=b,c=ca()),b=c,b===d&&(b=va,a.substr(va,2)===da?(c=da,va+=2):(c=d,0===Ba&&Ka(ea)),c!==d&&(wa=b,c=fa()),b=c,b===d&&(b=va,a.substr(va,2)===ga?(c=ga,va+=2):(c=d,0===Ba&&Ka(ha)),c!==d&&(wa=b,c=ia()),b=c,b===d&&(b=va,a.substr(va,2)===ja?(c=ja,va+=2):(c=d,0===Ba&&Ka(ka)),c!==d?(e=bb(),e!==d?(f=bb(),f!==d?(g=bb(),g!==d?(h=bb(),h!==d?(wa=b,c=la(e,f,g,h),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)))))),b}function ab(){var b,c,e;
if(b=va,c=[],ma.test(a.charAt(va))?(e=a.charAt(va),va++):(e=d,0===Ba&&Ka(na)),e!==d)while(e!==d)c.push(e),ma.test(a.charAt(va))?(e=a.charAt(va),va++):(e=d,0===Ba&&Ka(na));else c=i;return c!==d&&(wa=b,c=oa(c)),b=c}function bb(){var b;return pa.test(a.charAt(va))?(b=a.charAt(va),va++):(b=d,0===Ba&&Ka(qa)),b}function cb(){var a,b,c;Ba++,a=va,b=[],c=db();while(c!==d)b.push(c),c=db();return b!==d&&(wa=a,b=sa(b)),a=b,Ba--,a===d&&(b=d,0===Ba&&Ka(ra)),a}function db(){var b;return ta.test(a.charAt(va))?(b=a.charAt(va),va++):(b=d,0===Ba&&Ka(ua)),b}if(Ca=f(),Ca!==d&&va===a.length)return Ca;throw Ca!==d&&va<a.length&&Ka({type:"end",description:"end of input"}),La(null,Aa,za)}return{SyntaxError:b,parse:c}}().parse;function a(a,b){if(/^[A-Z_$][0-9A-Z_$]*$/i.test(a))return b?b+"."+a:a;var c=JSON.stringify(a);return b?b+"["+c+"]":c}function b(a,b,c){if(this.lc=[a],this.runtime.pluralFuncs={},this.runtime.pluralFuncs[this.lc[0]]=b,this.runtime.fmt={},c)for(var d in c)this.runtime.fmt[d]=c[d]}return b.plurals={},b.formatters={},b.prototype.runtime={number:function(a,b){if(isNaN(a))throw new Error("'"+a+"' isn't a number.");return a-(b||0)},plural:function(a,b,c,d,e){if({}.hasOwnProperty.call(d,a))return d[a]();b&&(a-=b);var f=c(a,e);return f in d?d[f]():d.other()},select:function(a,b){return{}.hasOwnProperty.call(b,a)?b[a]():b.other()},pluralFuncs:{},fmt:{},toString:function(){var b=function(c,d){if("object"!=typeof c){var e=c.toString().replace(/^(function )\w*/,"$1"),f=/([ \t]*)\S.*$/.exec(e);return f?e.replace(new RegExp("^"+f[1],"mg"),""):e}var g=[];for(var h in c)"toString"!=h&&(0==d?g.push("var "+h+" = "+b(c[h],d+1)+";\n"):g.push(a(h)+": "+b(c[h],d+1)));if(0==d)return g.join("");if(0==g.length)return"{}";var f="  ";while(--d)f+="  ";return"{\n"+g.join(",\n").replace(/^/gm,f)+"\n}"};return b(this,0)}},b.prototype._precompile=function(c,d){d=d||{keys:{},offset:{}};var e=[],f,g,h=[];switch(c.type){case"messageFormatPattern":for(f=0;f<c.statements.length;++f)e.push(this._precompile(c.statements[f],d));return g=e.join(" + ")||'""',d.pf_count?g:"function(d) { return "+g+"; }";case"messageFormatElement":return d.pf_count=d.pf_count||0,c.output?a(c.argumentIndex,"d"):(d.keys[d.pf_count]=c.argumentIndex,this._precompile(c.elementFormat,d));case"elementFormat":switch(h=[a(d.keys[d.pf_count],"d")],c.key){case"select":return h.push(this._precompile(c.val,d)),"select("+h.join(", ")+")";case"selectordinal":return h=h.concat([0,a(this.lc[0],"pluralFuncs"),this._precompile(c.val,d),1]),"plural("+h.join(", ")+")";case"plural":return d.offset[d.pf_count||0]=c.val.offset||0,h=h.concat([d.offset[d.pf_count]||0,a(this.lc[0],"pluralFuncs"),this._precompile(c.val,d)]),"plural("+h.join(", ")+")";default:return this.withIntlSupport&&!(c.key in this.runtime.fmt)&&c.key in b.formatters&&(g=b.formatters[c.key],this.runtime.fmt[c.key]="function"==typeof g(this)?g(this):g),h.push(JSON.stringify(this.lc)),c.val&&c.val.length&&h.push(JSON.stringify(1==c.val.length?c.val[0]:c.val)),"fmt."+c.key+"("+h.join(", ")+")"}case"pluralFormatPattern":case"selectFormatPattern":d.pf_count=d.pf_count||0,"selectFormatPattern"==c.type&&(d.offset[d.pf_count]=0);var i=!0;for(f=0;f<c.pluralForms.length;++f){var j=c.pluralForms[f].key;"other"===j&&(i=!1);var k=JSON.parse(JSON.stringify(d));k.pf_count++,e.push(a(j)+": function() { return "+this._precompile(c.pluralForms[f].val,k)+";}")}if(i)throw new Error("No 'other' form found in "+c.type+" "+d.pf_count);return"{ "+e.join(", ")+" }";case"string":return JSON.stringify(c.val||"");case"octothorpe":return d.pf_count?(h=[a(d.keys[d.pf_count-1],"d")],d.offset[d.pf_count-1]&&h.push(d.offset[d.pf_count-1]),"number("+h.join(", ")+")"):'"#"';default:throw new Error("Bad AST type: "+c.type)}},b.prototype.compile=function(c,d){var e={},f=this.lc,g=function(a,c){try{var d=b._parse(c);return a._precompile(d)}catch(a){throw new Error((d?"Precompiler":"Parser")+" error: "+a.toString())}},h=function(b,c){if(c||(c=0),"object"!=typeof b)return b;for(var d=[],e="",f=0;f<c;++f)e+="  ";for(var g in b)d.push("\n"+e+"  "+a(g)+": "+h(b[g],c+1));return"{"+d.join(",")+"\n"+e+"}"};if("string"==typeof c){var i=new Function("number, plural, select, pluralFuncs, fmt","return "+g(this,c));return i(this.runtime.number,this.runtime.plural,this.runtime.select,this.runtime.pluralFuncs,this.runtime.fmt)}d=d||{};for(var j in c)if(d.locale&&(this.lc=d.locale[j]&&[].concat(d.locale[j])||f),"string"==typeof c[j])try{e[j]=g(this,c[j])}catch(a){throw a.message=a.message.replace(":"," with `"+j+"`:"),a}else{e[j]={};for(var k in c[j])try{e[j][k]=g(this,c[j][k])}catch(a){throw a.message=a.message.replace(":"," with `"+k+"` in `"+j+"`:"),a}}this.lc=f;var l=this.runtime.toString()+"\n";switch(d.global||""){case"exports":var m=[];for(var n in e)m.push(a(n,"exports")+" = "+h(e[n]));return new Function(l+m.join(";\n"));case"module.exports":return new Function(l+"module.exports = "+h(e));case"":return new Function(l+"return "+h(e));default:return new Function("G",l+a(d.global,"G")+" = "+h(e))}},b}();var m=function(){return d("E_MISSING_PLURAL_MODULE","Plural module not loaded.")},n=function(a){h("E_MISSING_MESSAGE_BUNDLE","Missing message bundle for locale `{locale}`.",a.attributes.bundle&&void 0!==a.get("globalize-messages/{bundle}"),{locale:a.locale})},o=function(a,b){a=a.join("/"),h("E_MISSING_MESSAGE","Missing required message content `{path}`.",void 0!==b,{path:a})},p=function(a,b){a=a.join("/"),h("E_INVALID_MESSAGE","Invalid message content `{path}`. {expected} expected.","string"==typeof b,{expected:"a string",path:a})},q=function(a,b){j(a,b,void 0===a||e(a)||Array.isArray(a),"Array or Plain Object")},r=function(a){return function b(c){return"number"!=typeof c&&"string"!=typeof c||(c=[].slice.call(arguments,0)),q(c,"variables"),a(c)}},s=function(a,b){var c=a.locale,d=b.toString;return b.toString=function(){var a,e,f,g={};return f=d.call(b),/number\(/.test(f)&&(g.number="messageFormat.number"),/plural\(/.test(f)&&(g.plural="messageFormat.plural"),/select\(/.test(f)&&(g.select="messageFormat.select"),f.replace(/pluralFuncs(\[([^\]]+)\]|\.([a-zA-Z]+))/,function(a){return g.pluralFuncs='{"'+c+'": Globalize("'+c+'").pluralGenerator()}',a}),a=Object.keys(g).join(", "),e=Object.keys(g).map(function(a){return g[a]}).join(", "),"(function( "+a+" ) {\n  return "+f+"\n})("+e+")"},b},t=[].slice;return b.loadMessages=function(b){var c,d={"globalize-messages":b,main:{}};i(b,"json"),k(b,"json");for(c in b)b.hasOwnProperty(c)&&(d.main[c]={});a.load(d)},b.messageFormatter=b.prototype.messageFormatter=function(a){var b,d,e,h,k,q=t.call(arguments,0);return i(a,"path"),j(a,"path","string"==typeof a||Array.isArray(a),"a String nor an Array"),a=c(a),b=this.cldr,g(b),n(b),e=b.get(["globalize-messages/{bundle}"].concat(a)),o(a,e),Array.isArray(e)&&(e=e.join(" ")),p(a,e),h=void 0!==this.plural?this.pluralGenerator():m,d=new l(b.locale,h).compile(e),k=r(d),f(q,b,k,[s(b,d),h]),k},b.formatMessage=b.prototype.formatMessage=function(a){return this.messageFormatter(a).apply({},t.call(arguments,1))},b}),function(a,b){"function"==typeof define&&define.amd?define(["cldr","../globalize","cldr/event","cldr/supplemental"],b):"object"==typeof exports?module.exports=b(require("cldrjs"),require("globalize")):b(a.Cldr,a.Globalize)}(this,function(a,b){var c=b._createError,d=b._objectExtend,e=b._regexpEscape,f=b._runtimeBind,g=b._stringPad,h=b._validateCldr,i=b._validateDefaultLocale,j=b._validateParameterPresence,k=b._validateParameterRange,l=b._validateParameterType,m=b._validateParameterTypePlainObject,n=function(a){return c("E_UNSUPPORTED","Unsupported {feature}.",{feature:a})},o=function(a,b){l(a,b,void 0===a||"number"==typeof a,"Number")},p=function(a,b){l(a,b,void 0===a||"string"==typeof a,"a string")},q=function(a,b,c){var d,e=b,f="",g=",",h=!!c;a=String(a).split("."),d=a[0].length;while(d>e)f=a[0].slice(d-e,d)+(f.length?g:"")+f,d-=e,h&&(e=c,h=!1);return a[0]=a[0].slice(0,d)+(f.length?g:"")+f,a.join(".")},r=function(a,b,c,d,e,f){return d?(a=f?e(a,f):e(a,{exponent:-d}),c&&(a=String(a).split("."),a[1]=g(a[1]||"",c,!0),a=a.join("."))):a=e(a),a=String(a),b&&(a=a.split("."),a[0]=g(a[0],b),a=a.join(".")),a},s=function(a,b,c){var d;return a=a.toPrecision(b+2),d=Math.ceil(Math.log(Math.abs(a))/Math.log(10)),d-=b,c(a,{exponent:d})},t=function(a,b,c,d){var e,f;if(b>c&&(c=b),e=s(a,b,d),f=s(a,c,d),a=+e===+f?e:f,a=(+a).toString(10),/e/.test(a))throw n({feature:"integers out of (1e21, 1e-7)"});return b-a.replace(/^0+|\./g,"").length>0&&(a=a.split("."),a[1]=g(a[1]||"",b-a[0].replace(/^0+/,"").length,!0),a=a.join(".")),a},u=function(a,b){var c,d,e,f,g,h,i,j,k,l,m,n,o,p,s,u,v,w;return k=b[1],g=b[2],f=b[3],d=b[4],h=b[5],e=b[6],s=b[7],m=b[8],u=b[9],p=b[15],c=b[16],i=b[17],w=b[18],j=b[19],isNaN(a)?i:(a<0?(n=b[12],l=b[13],v=b[14]):(n=b[11],l=b[0],v=b[10]),isFinite(a)?(o=l,n.indexOf("%")!==-1?a*=100:n.indexOf("\u2030")!==-1&&(a*=1e3),a=isNaN(h*e)?r(a,g,f,d,p,s):t(a,h,e,p),a=a.replace(/^-/,""),m&&(a=q(a,m,u)),o+=a,o+=v,o.replace(/('([^']|'')+'|'')|./g,function(a,b){return b?(b=b.replace(/''/,"'"),b.length>2&&(b=b.slice(1,-1)),b):(a=a.replace(/[.,\-+E%\u2030]/,function(a){return w[a]}),j&&(a=a.replace(/[0-9]/,function(a){return j[+a]})),a)})):l+c+v)},v=function(a){return function b(c){return j(c,"value"),o(c,"value"),u(c,a)}},w=function(a){var b=a.attributes["u-nu"];return b?("traditio"===b&&(b="traditional"),["native","traditional","finance"].indexOf(b)!==-1?a.main(["numbers/otherNumberingSystems",b]):b):a.main("numbers/defaultNumberingSystem")},x=function(a){var b,c=w(a);if("latn"!==c){if(b=a.supplemental(["numberingSystems",c]),"numeric"!==b._type)throw n("`"+b._type+"` numbering system");return b._digits}},y=/^(('[^']+'|''|[^*#@0,.E])*)(\*.)?((([#,]*[0,]*0+)(\.0*[0-9]*#*)?)|([#,]*@+#*))(E\+?0+)?(('[^']+'|''|[^*#@0,.E])*)$/,z=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,o,p,q,r,s,t;if(a=a.match(y),!a)throw new Error("Invalid pattern: "+a);if(m=a[1],l=a[3],e=a[4],s=a[8],q=a[9],t=a[10],s?s.replace(/(@+)(#*)/,function(a,b,c){k=b.length,h=k+c.length}):(d=a[7],f=a[6],d&&(d.replace(/[0-9]+/,function(a){i=a}),i?(p=+("0."+i),i=i.length):i=0,g=d.length-1),f.replace(/0+$/,function(a){j=a.length})),q)throw n({feature:"scientific notation (not implemented)"});if(l)throw n({feature:"padding (not implemented)"});return(b=e.lastIndexOf(","))!==-1&&(c=e.split(".")[0],o=c.length-b-1,(c=e.lastIndexOf(",",b-1))!==-1&&(r=b-1-c)),[m,l,j,i,g,k,h,p,o,r,t]},A=function(a,b){return b.main(["numbers/symbols-numberSystem-"+w(b),a])},B={".":"decimal",",":"group","%":"percentSign","+":"plusSign","-":"minusSign",E:"exponential","\u2030":"perMille"},C=function(a){var b,c={};for(b in B)c[b]=A(B[b],a);return c},D=function(a){return isNaN(a)?NaN:Math[a<0?"ceil":"floor"](a)},E=function(a){return a=a||"round",a="truncate"===a?D:Math[a],function(b,c){var d,e;if(b=+b,isNaN(b))return NaN;if("object"==typeof c&&c.exponent){if(d=+c.exponent,e=1,0===d)return a(b);if("number"!=typeof d||d%1!==0)return NaN}else{if(e=+c||1,1===e)return a(b);if(isNaN(e))return NaN;e=e.toExponential().split("e"),d=+e[1],e=+e[0]}return b=b.toString().split("e"),b[0]=+b[0]/e,b[1]=b[1]?+b[1]-d:-d,b=a(+(b[0]+"e"+b[1])),b=b.toString().split("e"),b[0]=+b[0]*e,b[1]=b[1]?+b[1]+d:d,+(b[0]+"e"+b[1])}},F=function(a,b,c){var d,e,f,g,h,i,j;function k(a,b){a in c&&(j[b]=c[a])}return c=c||{},a=a.split(";"),h=a[0],d=a[1]||"-"+h,f=z(d),e=f[0],g=f[10],i=E(c.round),i.generatorString=function(){return"numberRound("+(c.round?'"'+c.round+'"':"")+")"},j=z(h).concat([h,e+h+g,e,g,i,A("infinity",b),A("nan",b),C(b),x(b)]),k("minimumIntegerDigits",2),k("minimumFractionDigits",3),k("maximumFractionDigits",4),k("minimumSignificantDigits",5),k("maximumSignificantDigits",6),c.useGrouping===!1&&(j[8]=null),"minimumFractionDigits"in c&&!("maximumFractionDigits"in c)?j[4]=Math.max(j[3],j[4]):!("minimumFractionDigits"in c)&&"maximumFractionDigits"in c&&(j[3]=Math.min(j[3],j[4])),j},G=/^([^0-9]*)(([0-9,]*[0-9]+)(\.[0-9]+)?)(E[+-]?[0-9]+)?([^0-9]*)$/,H=function(a,b){var c,d,f,g,h,i,j,k,l,m,n;if(d=b[0],g=b[1],j=b[2],k=b[3],f=b[4],c=a.match(d))l=1/0,m=a.slice(0,c.length),n=a.slice(c.length+1);else{if(i=new RegExp(Object.keys(g).map(function(a){return e(a)}).join("|"),"g"),a=a.replace(i,function(a){return g[a]}),f&&(h=new RegExp(Object.keys(f).map(function(a){return e(a)}).join("|"),"g"),a=a.replace(h,function(a){return f[a]})),"."===a.charAt(0)&&(a="0"+a),a=a.match(G),!a)return NaN;if(m=a[1],n=a[6],l=a[2].replace(/,/g,""),a[5]&&(l+=a[5]),l=+l,isNaN(l))return NaN;a[0].indexOf("%")!==-1?(l/=100,n=n.replace("%","")):a[0].indexOf("\u2030")!==-1&&(l/=1e3,n=n.replace("\u2030",""))}return m===j&&n===k&&(l*=-1),l},I=function(a){return function b(c){return j(c,"value"),p(c,"value"),H(c,a)}},J=function(a){var b,c={};for(b in B)c[A(B[b],a)]=b;return c},K=function(a,b){var c,e,f,g,h=x(b);return a=a.split(";"),f=a[1]||"-"+a[0],g=z(f),h&&(c=h.split("").reduce(function(a,b,c){return a[b]=String(c),a},{}),e="0123456789".split("").reduce(function(a,b){return a[b]="invalid",a},{}),c=d(e,c)),[A("infinity",b),d({},B,J(b)),g[0],g[10].replace("%","").replace("\u2030",""),c]},L=function(a,b){if("decimal"!==a&&"percent"!==a)throw new Error("Invalid style");return b.main(["numbers",a+"Formats-numberSystem-"+w(b),"standard"])};function M(a){var b=a[2],c=a[3],d=a[4],e=a[5],f=a[6];if(isNaN(e*f)){if(!isNaN(e)||!isNaN(f))throw new Error("Neither or both the minimum and maximum significant digits must be present");k(b,"minimumIntegerDigits",1,21),k(c,"minimumFractionDigits",0,20),k(d,"maximumFractionDigits",c,20)}else k(e,"minimumSignificantDigits",1,21),k(f,"maximumSignificantDigits",e,21)}return b.numberFormatter=b.prototype.numberFormatter=function(a){var b,c,d,e,g;return m(a,"options"),a=a||{},c=this.cldr,b=[a],i(c),c.on("get",h),d=a.raw?a.raw:L(a.style||"decimal",c),e=F(d,c,a),c.off("get",h),M(e),g=v(e),f(b,c,g,[e]),g},b.numberParser=b.prototype.numberParser=function(a){var b,c,d,e,g;return m(a,"options"),a=a||{},c=this.cldr,b=[a],i(c),c.on("get",h),d=a.raw?a.raw:L(a.style||"decimal",c),e=K(d,c),c.off("get",h),g=I(e),f(b,c,g,[e]),g},b.formatNumber=b.prototype.formatNumber=function(a,b){return j(a,"value"),o(a,"value"),this.numberFormatter(b)(a)},b.parseNumber=b.prototype.parseNumber=function(a,b){return j(a,"value"),p(a,"value"),this.numberParser(b)(a)},b._createErrorUnsupportedFeature=n,b._numberNumberingSystem=w,b._numberPattern=L,b._numberSymbol=A,b._stringPad=g,b._validateParameterTypeNumber=o,b._validateParameterTypeString=p,b}),function(a,b){"function"==typeof define&&define.amd?define(["cldr","../globalize","./number","cldr/event","cldr/supplemental"],b):"object"==typeof exports?module.exports=b(require("cldrjs"),require("globalize")):b(a.Cldr,a.Globalize)}(this,function(a,b){var c=b._alwaysArray,d=b._formatMessage,e=b._numberNumberingSystem,f=b._numberPattern,g=b._runtimeBind,h=b._stringPad,i=b._validateCldr,j=b._validateDefaultLocale,k=b._validateParameterPresence,l=b._validateParameterType,m=b._validateParameterTypeNumber,n=b._validateParameterTypePlainObject,o=function(a,b){l(a,b,void 0===a||"string"==typeof a&&/^[A-Za-z]{3}$/.test(a),"3-letter currency code string as defined by ISO 4217")},p=function(a,b,c){var d,e="",f=c.supplemental(["currencyData/fractions",a])||c.supplemental("currencyData/fractions/DEFAULT");return d=+f._digits,d&&(e="."+h("0",d).slice(0,-1)+f._rounding),b.replace(/\.(#+|0*[0-9]|0+[0-9]?)/g,e)},q=function(a,b){var c,d={};for(c in a)b.test(c)&&(d[c]=a[c]);return d},r=function(a){return q(a.main(["numbers","currencyFormats-numberSystem-"+e(a)]),/^unitPattern/)},s=function(a,b){var c=f("decimal",b);return c=p(a,c,b),{currency:a,pattern:c,unitPatterns:r(b)}},t=function(a,b,c){var e,f,g=c.displayNames||{},h=c.unitPatterns;return e=g["displayName-count-"+b]||g["displayName-count-other"]||g.displayName||c.currency,f=h["unitPattern-count-"+b]||h["unitPattern-count-other"],d(f,[a,e])},u=function(a,b,c){var d;return d=b&&c?function d(e){return k(e,"value"),m(e,"value"),t(a(e),b(e),c)}:function b(c){return a(c)}},v=function(a,b){var c=s(a,b);return c.displayNames=q(b.main(["numbers/currencies",a]),/^displayName/),c},w=/[\0-#%-\*,-;\?-\]_a-\{\}\x7F-\xA1\xA7\xAA\xAB\xAD\xB2\xB3\xB5-\xB7\xB9-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376-\u0383\u0386-\u03F5\u03F7-\u0481\u0483-\u058C\u0590-\u0605\u0609\u060A\u060C\u060D\u0610-\u06DD\u06DF-\u06E8\u06EA-\u06FC\u06FF-\u07F5\u07F7-\u09F1\u09F4-\u09F9\u09FC-\u0AF0\u0AF2-\u0B6F\u0B71-\u0BF2\u0BFB-\u0C7E\u0C80-\u0D78\u0D7A-\u0E3E\u0E40-\u0F00\u0F04-\u0F12\u0F14\u0F18\u0F19\u0F20-\u0F33\u0F35\u0F37\u0F39-\u0FBD\u0FC6\u0FCD\u0FD0-\u0FD4\u0FD9-\u109D\u10A0-\u138F\u139A-\u17DA\u17DC-\u193F\u1941-\u19DD\u1A00-\u1B60\u1B6B-\u1B73\u1B7D-\u1FBC\u1FBE\u1FC2-\u1FCC\u1FD0-\u1FDC\u1FE0-\u1FEC\u1FF0-\u1FFC\u1FFF-\u2043\u2045-\u2051\u2053-\u2079\u207D-\u2089\u208D-\u209F\u20BE-\u20FF\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u218F\u2308-\u230B\u2329\u232A\u23FB-\u23FF\u2427-\u243F\u244B-\u249B\u24EA-\u24FF\u2768-\u2793\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2B74\u2B75\u2B96\u2B97\u2BBA-\u2BBC\u2BC9\u2BD2-\u2CE4\u2CEB-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u3003\u3005-\u3011\u3014-\u301F\u3021-\u3035\u3038-\u303D\u3040-\u309A\u309D-\u318F\u3192-\u3195\u31A0-\u31BF\u31E4-\u31FF\u321F-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u32FF\u3400-\u4DBF\u4E00-\uA48F\uA4C7-\uA6FF\uA717-\uA71F\uA722-\uA788\uA78B-\uA827\uA82C-\uA835\uA83A-\uAA76\uAA7A-\uAB5A\uAB5C-\uD7FF\uDC00-\uFB28\uFB2A-\uFBB1\uFBC2-\uFDFB\uFDFE-\uFE61\uFE63\uFE67\uFE68\uFE6A-\uFF03\uFF05-\uFF0A\uFF0C-\uFF1B\uFF1F-\uFF3D\uFF3F\uFF41-\uFF5B\uFF5D\uFF5F-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF]|\uD800[\uDC00-\uDD36\uDD40-\uDD78\uDD8A\uDD8B\uDD8D-\uDD8F\uDD9C-\uDD9F\uDDA1-\uDDCF\uDDFD-\uDFFF]|[\uD801\uD803-\uD819\uD81B-\uD82E\uD830-\uD833\uD836-\uD83A\uD83F-\uDBFF][\uDC00-\uDFFF]|\uD802[\uDC00-\uDC76\uDC79-\uDEC7\uDEC9-\uDFFF]|\uD81A[\uDC00-\uDF3B\uDF40-\uDF44\uDF46-\uDFFF]|\uD82F[\uDC00-\uDC9B\uDC9D-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDD65-\uDD69\uDD6D-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDDDE-\uDDFF\uDE42-\uDE44\uDE46-\uDEFF\uDF57-\uDFFF]|\uD835[\uDC00-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFFF]|\uD83B[\uDC00-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDD0F\uDD2F\uDD6C-\uDD6F\uDD9B-\uDDE5\uDE03-\uDE0F\uDE3B-\uDE3F\uDE49-\uDE4F\uDE52-\uDEFF\uDF2D-\uDF2F\uDF7E\uDF7F\uDFCF-\uDFD3\uDFF8-\uDFFF]|\uD83D[\uDCFF\uDD4B-\uDD4F\uDD7A\uDDA4\uDE43\uDE44\uDED0-\uDEDF\uDEED-\uDEEF\uDEF4-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDFFF]|[\uD800-\uDBFF]/,x=function(a,b,c){var d,f,g={"[:digit:]":/\d/,"[:^S:]":w},h=b.main(["numbers/currencies",a,"symbol"]);return d=["beforeCurrency","afterCurrency"].map(function(a){return b.main(["numbers","currencyFormats-numberSystem-"+e(b),"currencySpacing",a])}),f=b.main(["numbers","currencyFormats-numberSystem-"+e(b),"accounting"===c.style?"accounting":"standard"]),f=p(a,f,b).split(";").map(function(a){return a.split("\xa4").map(function(a,b){var c=g[d[b].currencyMatch],e=g[d[b].surroundingMatch],f="";return c=c.test(h.charAt(b?h.length-1:0)),e=e.test(a.charAt(b?0:a.length-1).replace(/[#@,.]/g,"0")),c&&a&&e&&(f=d[b].insertBetween),(b?f:"")+a+(b?"":f)}).join("'"+h+"'")}).join(";"),{pattern:f}},y=function(a,b){var d,e={};b=c(b);for(d in a)b.indexOf(d)===-1&&(e[d]=a[d]);return e};function z(a,b){i(a,b,{skip:[/supplemental\/currencyData\/fractions\/[A-Za-z]{3}$/]})}return b.currencyFormatter=b.prototype.currencyFormatter=function(a,b){var c,d,e,f,h,i,l;return k(a,"currency"),o(a,"currency"),n(b,"options"),d=this.cldr,b=b||{},c=[a,b],l=b.style||"symbol",j(d),d.on("get",z),h={accounting:x,code:s,name:v,symbol:x}[l](a,d,b),d.off("get",z),b=y(b,"style"),b.raw=h.pattern,"symbol"===l||"accounting"===l?(e=this.numberFormatter(b),i=u(e),g(c,d,i,[e])):(e=this.numberFormatter(b),f=this.pluralGenerator(),i=u(e,f,h),g(c,d,i,[e,f,h])),i},b.currencyParser=b.prototype.currencyParser=function(){},b.formatCurrency=b.prototype.formatCurrency=function(a,b,c){return k(a,"value"),m(a,"value"),this.currencyFormatter(b,c)(a)},b.parseCurrency=b.prototype.parseCurrency=function(){},b}),function(a,b){"function"==typeof define&&define.amd?define(["cldr","../globalize","./number","cldr/event","cldr/supplemental"],b):"object"==typeof exports?module.exports=b(require("cldrjs"),require("globalize")):b(a.Cldr,a.Globalize)}(this,function(a,b){var c=b._createError,d=b._createErrorUnsupportedFeature,e=b._formatMessage,f=b._numberSymbol,g=b._regexpEscape,h=b._runtimeBind,i=b._stringPad,j=b._validateCldr,k=b._validateDefaultLocale,l=b._validateParameterPresence,m=b._validateParameterType,n=b._validateParameterTypePlainObject,o=b._validateParameterTypeString,p=function(a,b){m(a,b,void 0===a||a instanceof Date,"Date")},q=function(a,b){return c("E_INVALID_PAR_VALUE","Invalid `{name}` value ({value}).",{name:a,value:b})},r=function(a,b){var c,d,f,g,h;function i(a,c,d){return e(b.main(["dates/calendars/gregorian/dateTimeFormats",a]),[d,c])}switch(!0){case"skeleton"in a:f=a.skeleton,d=b.main(["dates/calendars/gregorian/dateTimeFormats/availableFormats",f]),d||(g=f.split(/[^hHKkmsSAzZOvVXx]/).slice(-1)[0],c=f.split(/[^GyYuUrQqMLlwWdDFgEec]/)[0],h=/(MMMM|LLLL).*[Ec]/.test(c)?"full":/MMMM/g.test(c)?"long":/MMM/g.test(c)||/LLL/g.test(c)?"medium":"short",d=i(h,b.main(["dates/calendars/gregorian/dateTimeFormats/availableFormats",c]),b.main(["dates/calendars/gregorian/dateTimeFormats/availableFormats",g])));break;case"date"in a:case"time"in a:d=b.main(["dates/calendars/gregorian","date"in a?"dateFormats":"timeFormats",a.date||a.time]);break;case"datetime"in a:d=i(a.datetime,b.main(["dates/calendars/gregorian/dateFormats",a.datetime]),b.main(["dates/calendars/gregorian/timeFormats",a.datetime]));break;case"raw"in a:d=a.raw;break;default:throw q({name:"options",value:a})}return d},s=function(a,b){return(a.getDay()-b+7)%7},t=function(a,b){var c=864e5;return(b.getTime()-a.getTime())/c},u=function(a,b){switch(a=new Date(a.getTime()),b){case"year":a.setMonth(0);case"month":a.setDate(1);case"day":a.setHours(0);case"hour":a.setMinutes(0);case"minute":a.setSeconds(0);case"second":a.setMilliseconds(0)}return a},v=function(a){return Math.floor(t(u(a,"year"),a))},w=function(a){return a-u(a,"day")},x=/([a-z])\1*|'([^']|'')+'|''|./gi,y=function(a,b,c,d){var e,f=a.getTimezoneOffset();return e=Math.abs(f),d=d||{1:function(a){return i(a,1)},2:function(a){return i(a,2)}},b.split(";")[f>0?1:0].replace(":",c).replace(/HH?/,function(a){return d[a.length](Math.floor(e/60))}).replace(/mm/,function(){return d[2](e%60)})},z=["sun","mon","tue","wed","thu","fri","sat"],A=function(a,b,c){var d=c.timeSeparator;return c.pattern.replace(x,function(e){var f,g=e.charAt(0),h=e.length;switch("j"===g&&(g=c.preferredTime),"Z"===g&&(h<4?(g="x",h=4):h<5?(g="O",h=4):(g="X",h=5)),g){case"G":f=c.eras[a.getFullYear()<0?0:1];break;case"y":f=a.getFullYear(),2===h&&(f=String(f),f=+f.substr(f.length-2));break;case"Y":f=new Date(a.getTime()),f.setDate(f.getDate()+7-s(a,c.firstDay)-c.firstDay-c.minDays),f=f.getFullYear(),2===h&&(f=String(f),f=+f.substr(f.length-2));break;case"Q":case"q":f=Math.ceil((a.getMonth()+1)/3),h>2&&(f=c.quarters[g][h][f]);break;case"M":case"L":f=a.getMonth()+1,h>2&&(f=c.months[g][h][f]);break;case"w":f=s(u(a,"year"),c.firstDay),f=Math.ceil((v(a)+f)/7)-(7-f>=c.minDays?0:1);break;case"W":f=s(u(a,"month"),c.firstDay),f=Math.ceil((a.getDate()+f)/7)-(7-f>=c.minDays?0:1);break;case"d":f=a.getDate();break;case"D":f=v(a)+1;break;case"F":f=Math.floor(a.getDate()/7)+1;break;case"e":case"c":if(h<=2){f=s(a,c.firstDay)+1;break}case"E":f=z[a.getDay()],f=c.days[g][h][f];break;case"a":f=c.dayPeriods[a.getHours()<12?"am":"pm"];break;case"h":f=a.getHours()%12||12;break;case"H":f=a.getHours();break;case"K":f=a.getHours()%12;break;case"k":f=a.getHours()||24;break;case"m":f=a.getMinutes();break;case"s":f=a.getSeconds();break;case"S":f=Math.round(a.getMilliseconds()*Math.pow(10,h-3));break;case"A":f=Math.round(w(a)*Math.pow(10,h-3));break;case"z":case"O":0===a.getTimezoneOffset()?f=c.gmtZeroFormat:(f=y(a,h<4?"+H;-H":c.tzLongHourFormat,d,b),f=c.gmtFormat.replace(/\{0\}/,f));break;case"X":if(0===a.getTimezoneOffset()){f="Z";break}case"x":f=1===h?"+HH;-HH":h%2?"+HH:mm;-HH:mm":"+HHmm;-HHmm",f=y(a,f,":");break;case":":f=d;break;case"'":e=e.replace(/''/,"'"),h>2&&(e=e.slice(1,-1)),f=e;break;default:f=e}return"number"==typeof f&&(f=b[h](f)),f})},B=function(a,b){return function c(d){return l(d,"value"),p(d,"value"),A(d,a,b)}},C=function(a){return z.indexOf(a.supplemental.weekData.firstDay())},D=function(a,b){var c={numberFormatters:{},pattern:a,timeSeparator:f("timeSeparator",b)},e=["abbreviated","wide","narrow"];function g(a){c.numberFormatters[a]=i("",a)}return a.replace(x,function(a){var f,h=a.charAt(0),i=a.length;switch("j"===h&&(c.preferredTime=h=b.supplemental.timeData.preferred()),"Z"===h&&4===i&&(h="O",i=4),h){case"G":c.eras=b.main(["dates/calendars/gregorian/eras",i<=3?"eraAbbr":4===i?"eraNames":"eraNarrow"]);break;case"y":f=!0;break;case"Y":c.firstDay=C(b),c.minDays=b.supplemental.weekData.minDays(),f=!0;break;case"u":case"U":throw d({feature:"year pattern `"+h+"`"});case"Q":case"q":i>2?(c.quarters||(c.quarters={}),c.quarters[h]||(c.quarters[h]={}),c.quarters[h][i]=b.main(["dates/calendars/gregorian/quarters","Q"===h?"format":"stand-alone",e[i-3]])):f=!0;break;case"M":case"L":i>2?(c.months||(c.months={}),c.months[h]||(c.months[h]={}),c.months[h][i]=b.main(["dates/calendars/gregorian/months","M"===h?"format":"stand-alone",e[i-3]])):f=!0;break;case"w":case"W":c.firstDay=C(b),c.minDays=b.supplemental.weekData.minDays(),f=!0;break;case"d":case"D":case"F":f=!0;break;case"g":throw d({feature:"Julian day pattern `g`"});case"e":case"c":if(i<=2){c.firstDay=C(b),f=!0;break}case"E":c.days||(c.days={}),c.days[h]||(c.days[h]={}),6===i?c.days[h][i]=b.main(["dates/calendars/gregorian/days","c"===h?"stand-alone":"format","short"])||b.main(["dates/calendars/gregorian/days","c"===h?"stand-alone":"format","abbreviated"]):c.days[h][i]=b.main(["dates/calendars/gregorian/days","c"===h?"stand-alone":"format",e[i<3?0:i-3]]);break;case"a":c.dayPeriods=b.main("dates/calendars/gregorian/dayPeriods/format/wide");break;case"h":case"H":case"K":case"k":case"m":case"s":case"S":case"A":f=!0;break;case"z":case"O":c.gmtFormat=b.main("dates/timeZoneNames/gmtFormat"),c.gmtZeroFormat=b.main("dates/timeZoneNames/gmtZeroFormat"),c.tzLongHourFormat=b.main("dates/timeZoneNames/hourFormat");case"Z":case"X":case"x":g(1),g(2);break;case"v":case"V":throw d({feature:"timezone pattern `"+h+"`"})}f&&g(i)}),c},E=function(a){return 1===new Date(a,1,29).getMonth()},F=function(a){return new Date(a.getFullYear(),a.getMonth()+1,0).getDate()},G=function(a,b){var c=new Date(a.getFullYear(),a.getMonth()+1,0).getDate();a.setDate(b<1?1:b<c?b:c)},H=function(a,b){var c=a.getDate();a.setDate(1),a.setMonth(b),G(a,c)},I=function(a,b,c){return a<b||a>c},J=function(a,b,c){var e,f,g,h,i,j,k,l,m,n=0,o=1,p=2,q=3,r=4,s=5,t=6,v=new Date,w=[],x=["year","month","day","hour","minute","second","milliseconds"];if(!b.length)return null;if(m=b.every(function(a){var b,m,u,x;if("literal"===a.type)return!0;switch(m=a.type.charAt(0),x=a.type.length,"j"===m&&(m=c.preferredTimeData),m){case"G":w.push(n),i=+a.value;break;case"y":if(u=a.value,2===x){if(I(u,0,99))return!1;b=100*Math.floor(v.getFullYear()/100),u+=b,u>v.getFullYear()+20&&(u-=100)}v.setFullYear(u),w.push(n);break;case"Y":throw d({feature:"year pattern `"+m+"`"});case"Q":case"q":break;case"M":case"L":if(u=x<=2?a.value:+a.value,I(u,1,12))return!1;h=u,w.push(o);break;case"w":case"W":break;case"d":f=a.value,w.push(p);break;case"D":g=a.value,w.push(p);break;case"F":break;case"e":case"c":case"E":break;case"a":e=a.value;break;case"h":if(u=a.value,I(u,1,12))return!1;j=k=!0,v.setHours(12===u?0:u),w.push(q);break;case"K":if(u=a.value,I(u,0,11))return!1;j=k=!0,v.setHours(u),w.push(q);break;case"k":if(u=a.value,I(u,1,24))return!1;j=!0,v.setHours(24===u?0:u),w.push(q);break;case"H":if(u=a.value,I(u,0,23))return!1;j=!0,v.setHours(u),w.push(q);break;case"m":if(u=a.value,I(u,0,59))return!1;v.setMinutes(u),w.push(r);break;case"s":if(u=a.value,I(u,0,59))return!1;v.setSeconds(u),w.push(s);break;case"A":v.setHours(0),v.setMinutes(0),v.setSeconds(0);case"S":u=Math.round(a.value*Math.pow(10,3-x)),v.setMilliseconds(u),w.push(t);break;case"Z":case"z":case"O":case"X":case"x":l=a.value-v.getTimezoneOffset()}return!0}),!m)return null;if(j&&!(!e^k))return null;if(0===i&&v.setFullYear(v.getFullYear()*-1+1),void 0!==h&&H(v,h-1),void 0!==f){if(I(f,1,F(v)))return null;v.setDate(f)}else if(void 0!==g){if(I(g,1,E(v.getFullYear())?366:365))return null;v.setMonth(0),v.setDate(g)}return k&&"pm"===e&&v.setHours(v.getHours()+12),l&&v.setMinutes(v.getMinutes()+l),w=Math.max.apply(null,w),v=u(v,x[w])},K=/[0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]|\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDD16-\uDD1B\uDE40-\uDE47\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDE60-\uDE7E]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD805[\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9]|\uD806[\uDCE0-\uDCF2]|\uD809[\uDC00-\uDC6E]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59\uDF5B-\uDF61]|\uD834[\uDF60-\uDF71]|\uD835[\uDFCE-\uDFFF]|\uD83A[\uDCC7-\uDCCF]|\uD83C[\uDD00-\uDD0C]/,L=function(a,b,c){var d,e=c.timeSeparator,f=[],h=["abbreviated","wide","narrow"];return d=c.pattern.match(x).every(function(d){var i,j,k,l,m={};function n(b,c){var d=a.match(b);return c=c||function(a){return+a},!!d&&(d.length<8?m.value=60*(d[1]?-c(d[1]):c(d[4])):m.value=60*(d[1]?-c(d[1]):c(d[7]))+(d[1]?-c(d[4]):c(d[10])),!0)}function o(a,b,c){var d;return b||(b="{0}"),d=a.replace("+","\\+").replace(/HH|mm/g,"(("+K.source+")("+K.source+"))").replace(/H|m/g,"(("+K.source+")("+K.source+")?)"),c&&(d=d.replace(/:/g,c)),d=d.split(";").map(function(a){return b.replace("{0}",a)}).join("|"),new RegExp(d)}function p(){if(1===j)return k=!0,l=K}function q(){if(1===j)return k=!0,l=new RegExp("("+K.source+")("+K.source+")?")}function r(){if(2===j)return k=!0,l=new RegExp("("+K.source+")("+K.source+")")}function s(b){var d,e,f=c[b.join("/")];for(d in f)if(e=new RegExp("^"+f[d]),e.test(a))return m.value=d,l=new RegExp(f[d]);return null}switch(m.type=d,i=d.charAt(0),j=d.length,"Z"===i&&(j<4?(i="x",j=4):j<5?(i="O",j=4):(i="X",j=5)),i){case"G":s(["gregorian/eras",j<=3?"eraAbbr":4===j?"eraNames":"eraNarrow"]);break;case"y":case"Y":k=!0,l=1===j?new RegExp("("+K.source+")+"):2===j?new RegExp("("+K.source+")("+K.source+")"):new RegExp("("+K.source+"){"+j+",}");break;case"Q":case"q":p()||r()||s(["gregorian/quarters","Q"===i?"format":"stand-alone",h[j-3]]);break;case"M":case"L":q()||r()||s(["gregorian/months","M"===i?"format":"stand-alone",h[j-3]]);break;case"D":j<=3&&(k=!0,l=new RegExp("("+K.source+"){"+j+",3}"));break;case"W":case"F":
p();break;case"e":case"c":if(j<=2){p()||r();break}case"E":6===j?s(["gregorian/days",["c"===i?"stand-alone":"format"],"short"])||s(["gregorian/days",["c"===i?"stand-alone":"format"],"abbreviated"]):s(["gregorian/days",["c"===i?"stand-alone":"format"],h[j<3?0:j-3]]);break;case"a":s(["gregorian/dayPeriods/format/wide"]);break;case"w":case"d":case"h":case"H":case"K":case"k":case"j":case"m":case"s":q()||r();break;case"S":k=!0,l=new RegExp("("+K.source+"){"+j+"}");break;case"A":k=!0,l=new RegExp("("+K.source+"){"+(j+5)+"}");break;case"z":case"O":if(a===c["timeZoneNames/gmtZeroFormat"])m.value=0,l=new RegExp(c["timeZoneNames/gmtZeroFormat"]);else if(l=o(j<4?"+H;-H":c["timeZoneNames/hourFormat"],c["timeZoneNames/gmtFormat"],e),!n(l,b))return null;break;case"X":if("Z"===a){m.value=0,l=/Z/;break}case"x":if(l=o(1===j?"+HH;-HH":j%2?"+HH:mm;-HH:mm":"+HHmm;-HHmm"),!n(l))return null;break;case"'":m.type="literal",d=d.replace(/''/,"'"),j>2&&(d=d.slice(1,-1)),l=new RegExp(g(d));break;default:m.type="literal",l=/./}return!!l&&(a=a.replace(new RegExp("^"+l.source),function(a){return m.lexeme=a,k&&(m.value=b(a)),""}),!!m.lexeme&&(f.push(m),!0))}),""!==a&&(d=!1),d?f:[]},M=function(a,b,c){return function d(e){var f;return l(e,"value"),o(e,"value"),f=L(e,a,c),J(e,f,b)||null}},N=function(a){return{preferredTimeData:a.supplemental.timeData.preferred()}},O=function(a,b){var c={pattern:a,timeSeparator:f("timeSeparator",b)},e=["abbreviated","wide","narrow"];function g(a,b){c[a.replace(/^.*\/dates\//,"").replace(/calendars\//,"")]=b}return b.on("get",g),a.match(x).forEach(function(a){var c,f;switch(c=a.charAt(0),f=a.length,"Z"===c&&f<5&&(c="O",f=4),c){case"G":b.main(["dates/calendars/gregorian/eras",f<=3?"eraAbbr":4===f?"eraNames":"eraNarrow"]);break;case"u":case"U":throw d({feature:"year pattern `"+c+"`"});case"Q":case"q":f>2&&b.main(["dates/calendars/gregorian/quarters","Q"===c?"format":"stand-alone",e[f-3]]);break;case"M":case"L":f>2&&b.main(["dates/calendars/gregorian/months","M"===c?"format":"stand-alone",e[f-3]]);break;case"g":throw d({feature:"Julian day pattern `g`"});case"e":case"c":if(f<=2)break;case"E":6===f?b.main(["dates/calendars/gregorian/days",["c"===c?"stand-alone":"format"],"short"])||b.main(["dates/calendars/gregorian/days",["c"===c?"stand-alone":"format"],"abbreviated"]):b.main(["dates/calendars/gregorian/days",["c"===c?"stand-alone":"format"],e[f<3?0:f-3]]);break;case"a":b.main(["dates/calendars/gregorian/dayPeriods/format/wide"]);break;case"z":case"O":b.main("dates/timeZoneNames/gmtFormat"),b.main("dates/timeZoneNames/gmtZeroFormat"),b.main("dates/timeZoneNames/hourFormat");break;case"v":case"V":throw d({feature:"timezone pattern `"+c+"`"})}}),b.off("get",g),c};function P(a,b){j(a,b,{skip:[/dates\/calendars\/gregorian\/dateTimeFormats\/availableFormats/,/dates\/calendars\/gregorian\/days\/.*\/short/,/supplemental\/timeData\/(?!001)/,/supplemental\/weekData\/(?!001)/]})}return b.dateFormatter=b.prototype.dateFormatter=function(a){var b,c,d,e,f,g,i;n(a,"options"),c=this.cldr,a=a||{skeleton:"yMd"},b=[a],k(c),c.on("get",P),f=r(a,c),g=D(f,c),c.off("get",P),d=g.numberFormatters,delete g.numberFormatters;for(e in d)d[e]=this.numberFormatter({raw:d[e]});return i=B(d,g),h(b,c,i,[d,g]),i},b.dateParser=b.prototype.dateParser=function(a){var b,c,d,e,f,g,i;return n(a,"options"),c=this.cldr,a=a||{skeleton:"yMd"},b=[a],k(c),c.on("get",P),f=r(a,c),g=O(f,c),e=N(c),c.off("get",P),d=this.numberParser({raw:"0"}),i=M(d,e,g),h(b,c,i,[d,e,g]),i},b.formatDate=b.prototype.formatDate=function(a,b){return l(a,"value"),p(a,"value"),this.dateFormatter(b)(a)},b.parseDate=b.prototype.parseDate=function(a,b){return l(a,"value"),o(a,"value"),this.dateParser(b)(a)},b}),"undefined"!=typeof GenericEventListener&&GenericEventListener&&GenericEventListener.topicNamespace||(GenericEventListener={_loaded:!1,_useHostedCMLib:!1,initializer:function(){},load:function(){load(!1)},load:function(a){this._loaded===!1&&(wcTopic.subscribe("/wc/analytics/pageview",$.proxy(this.handlePageView,this)),wcTopic.subscribe("/wc/analytics/productview",$.proxy(this.handleProductView,this)),wcTopic.subscribe("/wc/analytics/cartview",$.proxy(this.handleCartView,this)),wcTopic.subscribe("/wc/analytics/addcart",$.proxy(this.handleAddCart,this)),wcTopic.subscribe("/wc/analytics/element",$.proxy(this.handleElement,this)),wcTopic.subscribe("/wc/analytics/registration",$.proxy(this.handleRegistration,this)),wcTopic.subscribe("/wc/analytics/conversionevent",$.proxy(this.handleConversionEvent,this)),this._loaded=!0,a===!0&&(this._useHostedCMLib=!0))},handlePageView:function(a){},handleProductView:function(a){},handleCartView:function(a){},handleAddCart:function(a){},handleElement:function(a){},handleRegistration:function(a){},handleConversionEvent:function(a){}}),"undefined"!=typeof CoremetricsEventListener&&CoremetricsEventListener&&CoremetricsEventListener.topicNamespace||(CoremetricsEventListener=$.extend(GenericEventListener,{PARAM_STORE_ID:"storeId",handlePageView:function(a){var b=!1;b&&window.alert("handlePageView");var c="pagename",d="pageType",e="category",f="searchTerms",g="searchCount",h="options",i="debug",j="extraParams",k="attributes",l="useDDX",m="true",n=document.title,o=null,p=null,q=null,r=null,s=null,t=null,u=this._getStoreId(),v=new Array,w=!1,y=!1;for(x in a)if(x===h){var z=a[x];z===l&&(w=!0)}else if(x===i){var A=a[x];A===m&&(y=!0)}else x===c?n=a[x]:x===d?o=a[x]:x===e?p="null"===a[x]||""===a[x]?null:a[x]:x===f?q="null"===a[x]||""===a[x]?null:a[x]:x===g?r="null"===a[x]||""===a[x]?null:a[x]:x===this.PARAM_STORE_ID?u=a[x]:w?x===j?t=a[x]:x===k&&(s=a[x]):(v.push(a[x]),null!==t?t+=", ":t="",t+=null==a[x]||"null"===a[x]?"null":'"'===a[x].charAt(0)&&'"'===a[x].charAt(a[x].length-1)?a[x]:'"'+a[x]+'"');w?(null!=n&&"null"!==n&&"'null'"!==n||(n=""),null!=q&&"null"!==q&&"'null'"!==q||(q=""),null!=r&&"null"!==r&&"'null'"!==r||(r=""),null!=p&&"null"!==p&&"'null'"!==p||(p=""),null!=s&&"null"!==s&&"'null'"!==s||(s=""),null!=t&&"null"!==t&&"'null'"!==t||(t=""),null!=o&&"null"!==o&&"'null'"!==o||(o=""),"undefined"==typeof digitalData&&(digitalData={}),digitalData.page={pageInfo:{pageID:n,onsiteSearchTerm:q,onsiteSearchResults:r},category:{primaryCategory:p},attributes:{exploreAttributes:s,extraFields:t}},digitalData.pageInstanceID=o,b&&window.alert(JSON.stringify(digitalData))):(this._useHostedCMLib?v.unshift(n,p,q,r):v.unshift(n,p,q,r,u),cmCreatePageviewTag.apply({},v));var B=JSON.stringify(a),a=document.getElementById("cm-pageview");if(y&&null!==a){if(w){var C="digitalData = { ";C+="page:{pageInfo:{pageID: '"+n+"', onsiteSearchTerm: '"+q+"', onsiteSearchResults: '"+r+"'}, category:{primaryCategory: '"+p+"'},",C+="attributes:{exploreAttributes: '"+s+"' ,extraFields: '"+t+"'}},",C+="pageInstanceID: '"+o+"' };",b&&window.alert(C)}else{var C="cmCreatePageviewTag(";C+=null!==n&&""!==n&&"null"!==n?'"'+n+'", ':"null, ",C+=null!==p&&""!==p&&"null"!==p?'"'+p+'", ':"null, ",C+=null!==q&&""!==q&&"null"!==q?'"'+q+'", ':"null, ",C+=null!==r&&""!==r&&"null"!==r?'"'+r+'"':"null",this._useHostedCMLib||(C+=null!==u&&""!==u&&"null"!==u?', "'+u+'"':", null"),null!==t&&(C+=", "+t),C+=");"}var D=document.createTextNode(B);a.appendChild(D),a.appendChild(document.createElement("br"));var E=document.createTextNode(C);a.appendChild(E),a.appendChild(document.createElement("br"))}},handleConversionEvent:function(a){var b=!1;b&&window.alert("handleConversionEvent");var c="eventId",d="category",e="actionType",f="points",g="options",h="debug",i="extraParams",j="attributes",k="useDDX",l="true",m=null,n=null,o=null,p=null,q=null,r=null,s=this._getStoreId(),t=new Array,u=!1,v=!1;for(x in a)if(x===g)var w=a[x];else if(x===h){var y=a[x];y===l&&(v=!0)}else x===c?m=a[x]:x===d?n=a[x]:x===e?o=a[x]:x===f?p=a[x]:u?x===i?r=a[x]:x===j&&(q=a[x]):t.push(a[x]);u?(null!=m&&"null"!==m&&"'null'"!==m||(m=""),null!=o&&"null"!==o&&"'null'"!==o||(o=""),null!=p&&"null"!==p&&"'null'"!==p||(p=""),null!=n&&"null"!==n&&"'null'"!==n||(n=""),null!=q&&"null"!==q&&"'null'"!==q||(q=""),null!=r&&"null"!==r&&"'null'"!==r||(r=""),"undefined"==typeof digitalData&&(digitalData={},digitalData.pageInstanceID="wcs-standardpage_wcs-conversionevent"),digitalData.event=[{eventInfo:{eventName:m,eventAction:o,eventPoints:p},category:{primaryCategory:n},attributes:{exploreAttributes:q,extraFields:r}}],b&&window.alert(JSON.stringify(digitalData))):(t.unshift(m,o,n,p),cmCreateConversionEventTag.apply({},t));var z=JSON.stringify(a),a=document.getElementById("cm-conversionevent");if(v&&null!==a){if(u){var A="digitalData = { ";null!==digitalData.pageInstanceID&&""!==digitalData.pageInstanceID&&(A+="pageInstanceID:'"+digitalData.pageInstanceID+"', "),A+="event:[{eventInfo:{eventName: '"+m+"', eventAction: '"+o+"', eventPoints: '"+p+"'}, category:{primaryCategory: '"+n+"'}, attributes:{exploreAttributes: '"+q+"', extraFields: '"+r+"'}}]}",b&&window.alert(A)}else{var A="cmCreateConversionEventTag(";A+=null!==m&&""!==m?'"'+m+'", ':"null, ",A+=null!==o&&""!==o?'"'+o+'", ':"null, ",A+=null!==n&&""!==n?'"'+n+'", ':"null, ",A+=null!==p&&""!==p?'"'+p+'"':"null",A+=");"}var B=document.createTextNode(z);a.appendChild(B),a.appendChild(document.createElement("br"));var C=document.createTextNode(A);a.appendChild(C),a.appendChild(document.createElement("br"))}},handleProductView:function(a){var b=!1;b&&window.alert("handleProductView");var c="productId",d="name",e="category",f="masterCategory",g="virtualCategory",h="attributes",i="useDDX",j="true",k=null,l=null,m=null,n=null,o=null,p=null,q=this._getStoreId(),r=null,s=!1,t=!1;if(a.options===i&&(s=!0),a.debug===j&&(t=!0),a.product&&$.isArray(a.product)){s&&("undefined"==typeof digitalData&&(digitalData={},digitalData.pageInstanceID="wcs-standardpage_wcs-productdetail"),digitalData.product=new Array);for(var u=a.product,v=0;v<u.length;v++){var w=u[v],y=new Array;for(x in w)x===c?k=w[x]:x===d?l=w[x]:x===e?m=w[x]:x===f?n=w[x]:x===this.PARAM_STORE_ID?q=w[x]:s?x===h?o=w[x]:x===g&&(p=w[x]):(y.push(w[x]),null!==r?r+=", ":r="",r+=null==w[x]||"null"===w[x]?"null":'"'===w[x].charAt(0)&&'"'===w[x].charAt(w[x].length-1)?w[x]:'"'+w[x]+'"');if(null==k||null==l||null==m||null==n);else{s?(null!=k&&"null"!==k&&"'null'"!==k||(k=""),null!=l&&"null"!==l&&"'null'"!==l||(l=""),null!=m&&"null"!==m&&"'null'"!==m||(m=""),null!=p&&"null"!==p&&"'null'"!==p||(p=""),null!=o&&"null"!==o&&"'null'"!==o||(o=""),digitalData.product[v]={productInfo:{productID:k,productName:l},category:{primaryCategory:m,virtualCategory:p},attributes:{exploreAttributes:o}},b&&window.alert(JSON.stringify(digitalData))):(this._useHostedCMLib?y.unshift(k,l,m):y.unshift(null,k,l,m,q,"N",n),cmCreateProductviewTag.apply({},y));var z=JSON.stringify(a),a=document.getElementById("cm-productview");if(t&&null!==a){if(s){var A="digitalData.product["+v+"] = { ";A+="productInfo:{productID: '"+k+"', productName: '"+l+"'},category:{primaryCategory: '"+m+"', virtualCategory: '"+p+"'},attributes:{exploreAttributes: '"+o+"'}};",b&&window.alert(A)}else{var A="";A=this._useHostedCMLib?"cmCreateProductviewTag(":"cmCreateProductviewTag(null, ",A+=null!==k&&""!==k?'"'+k+'", ':"null, ",null!==l&&""!==l?(l=l.replace(/\"/g,'\\"'),A+='"'+l+'", '):A+="null, ",A+=null!==m&&""!==m?'"'+m+'"':"null",this._useHostedCMLib||(A+=null!==q&&""!==q?', "'+q+'", "N", ':', null, "N", ',A+=null!==n&&""!==n?'"'+n+'"':"null"),null!==r&&(A+=", "+r),A+=");"}var B=document.createTextNode(z);a.appendChild(B),a.appendChild(document.createElement("br"));var C=document.createTextNode(A);a.appendChild(C),a.appendChild(document.createElement("br"))}}}}},handleCartView:function(a){var b=!1;b&&window.alert("handleCartView");var c="productId",d="name",e="category",f="masterCategory",g="quantity",h="price",i="currency",j="extraParams",k="attributes",l="useDDX",m="true",n="false",o=null,p=null,q=null,r=!1,s=!0,t=!1;a.options===l&&(r=!0),a.useCMSetupOther===m?s=!0:a.useCMSetupOther===n&&(s=!1),a.debug===m&&(t=!0);var u=!1;if(a.cart&&$.isArray(a.cart)){r&&("undefined"==typeof digitalData&&(digitalData={},digitalData.pageInstanceID="wcs-standardpage_wcs-cart"),digitalData.cart={},digitalData.cart.item=new Array);for(var v=a.cart,w=0;w<v.length;w++){var y=null,z=null,A=null,B=null,C=null,D=null,E=null,F=this._getStoreId(),G=new Array,p=null,H=v[w];for(x in H)x===c?y=H[x]:x===d?z=H[x]:x===e?A=H[x]:x===f?B=H[x]:x===g?C=H[x]:x===h?D=H[x]:x===i?E=H[x]:x===this.PARAM_STORE_ID?F=H[x]:r?x===k?o=H[x]:x===j&&(p=H[x]):(G.push(H[x]),null!==p?p+=", ":p="",p+=null==H[x]||"null"===H[x]?"null":'"'===H[x].charAt(0)&&'"'===H[x].charAt(H[x].length-1)?H[x]:'"'+H[x]+'"');if(null==y||null==z||null==A||null==B||null==C||null==D||null==E);else{if(r)null!=y&&"null"!==y&&"'null'"!==y||(y=""),null!=z&&"null"!==z&&"'null'"!==z||(z=""),null!=C&&"null"!==C&&"'null'"!==C||(C=""),null!=D&&"null"!==D&&"'null'"!==D||(D=""),null!=E&&"null"!==E&&"'null'"!==E||(E=""),null!=A&&"null"!==A&&"'null'"!==A||(A=""),null!=q&&"null"!==q&&"'null'"!==q||(q=""),null!=o&&"null"!==o&&"'null'"!==o||(o=""),null!=p&&"null"!==p&&"'null'"!==p||(p=""),digitalData.cart.item[w]={},digitalData.cart.item[w]={productInfo:{productID:y,productName:z},quantity:C,price:D,currency:E,category:{primaryCategory:A,virtualCategory:q},attributes:{exploreAttributes:o,extraFields:p}},s&&cmSetupOther({cm_currencyCode:'"'+E+'"'}),b&&window.alert(JSON.stringify(digitalData));else if(u=!0,this._useHostedCMLib){cmSetCurrencyCode(E);var I=document.getElementById("cm-shopAction");if(t&&null!==I){var J='cmSetCurrencyCode("'+E+'");',K=document.createTextNode(J);I.appendChild(K),I.appendChild(document.createElement("br"))}G.unshift(y,z,C,D,A),cmCreateShopAction5Tag.apply({},G)}else G.unshift(y,z,C,D,A,F,E,B),cmCreateShopAction5Tag.apply({},G);var L=JSON.stringify(a),a=document.getElementById("cm-shopAction");if(t&&null!==a){if(r){var M="digitalData.cart.item["+w+"] = { ";M+="productInfo:{productID: '"+y+"', productName: '"+z+"'}, quantity: '"+C+"', price: '"+D+"', currency: '"+E+"', category:{primaryCategory: '"+A+"', virtualCategory: '"+q+"'}, attributes:{exploreAttributes: '"+o+"', extraFields: '"+p+"'}};",s&&(M+='cmSetupOther({"cm_currencyCode":"'+E+'"});'),b&&window.alert(M)}else{var M="cmCreateShopAction5Tag(";M+=null!==y&&""!==y?'"'+y+'", ':"null, ",null!==z&&""!==z?(z=z.replace(/\"/g,'\\"'),M+='"'+z+'", '):M+="null, ",M+=null!==C&&""!==C?'"'+C+'", ':"null, ",M+=null!==D&&""!==D?'"'+D+'", ':"null, ",M+=null!==A&&""!==A?'"'+A+'"':"null",this._useHostedCMLib||(M+=null!==F&&""!==F?', "'+F+'", ':", null, ",M+=null!==E&&""!==E?'"'+E+'", ':"null, ",M+=null!==B&&""!==B?'"'+B+'"':"null"),null!==p&&(M+=", "+p),M+=");"}var N=document.createTextNode(L);a.appendChild(N),a.appendChild(document.createElement("br"));var O=document.createTextNode(M);a.appendChild(O),a.appendChild(document.createElement("br"))}}}}if(u){cmDisplayShop5s();var I=document.getElementById("cm-shopAction");if(t&&null!==I){var J="cmDisplayShop5s();",K=document.createTextNode(J);I.appendChild(K),I.appendChild(document.createElement("br"))}}},handleAddCart:function(a){var b=!1;b&&window.alert("handleAddCart");var c="productId",d="name",e="category",f="masterCategory",g="quantity",h="price",i="currency",j="extraParams",k="attributes",l="useDDX",m="true",n="false",o=null,p=null,q=null,r=!1,s=!0,t=!1;a.useCMSetupOther===m?s=!0:a.useCMSetupOther===n&&(s=!1),a.debug===m&&(t=!0);var u=!1;if(a.cart&&$.isArray(a.cart)){r&&("undefined"==typeof digitalData&&(digitalData={},digitalData.pageInstanceID="wcs-standardpage_wcs-cart"),digitalData.cart={},digitalData.cart.item=new Array);for(var v=a.cart,w=0;w<v.length;w++){var y=null,z=null,A=null,B=null,C=null,D=null,E=null,F=this._getStoreId(),G=new Array,p=null,H=v[w];for(x in H)x===c?y=H[x]:x===d?z=H[x]:x===e?A=H[x]:x===f?B=H[x]:x===g?C=H[x]:x===h?D=H[x]:x===i?E=H[x]:x===this.PARAM_STORE_ID?F=H[x]:r?x===k?o=H[x]:x===j&&(p=H[x]):(G.push(H[x]),null!==p?p+=", ":p="",p+=null==H[x]||"null"===H[x]?"null":'"'===H[x].charAt(0)&&'"'===H[x].charAt(H[x].length-1)?H[x]:'"'+H[x]+'"');if(null==y||null==z||null==A||null==B||null==C||null==D||null==E);else{if(r)null!=y&&"null"!==y&&"'null'"!==y||(y=""),null!=z&&"null"!==z&&"'null'"!==z||(z=""),null!=C&&"null"!==C&&"'null'"!==C||(C=""),null!=D&&"null"!==D&&"'null'"!==D||(D=""),null!=E&&"null"!==E&&"'null'"!==E||(E=""),null!=A&&"null"!==A&&"'null'"!==A||(A=""),null!=q&&"null"!==q&&"'null'"!==q||(q=""),null!=o&&"null"!==o&&"'null'"!==o||(o=""),null!=p&&"null"!==p&&"'null'"!==p||(p=""),digitalData.cart.item[w]={},digitalData.cart.item[w]={productInfo:{productID:y,productName:z},quantity:C,price:D,currency:E,category:{primaryCategory:A,virtualCategory:q},attributes:{exploreAttributes:o,extraFields:p}},s&&cmSetupOther({cm_currencyCode:'"'+E+'"'}),b&&window.alert(JSON.stringify(digitalData));else if(u=!0,this._useHostedCMLib){cmSetCurrencyCode(E);var I=document.getElementById("cm-shopAction");if(t&&null!==I){var J='cmSetCurrencyCode("'+E+'");',K=document.createTextNode(J);I.appendChild(K),I.appendChild(document.createElement("br"))}G.unshift(y,z,C,D,A),cmCreateShopAction5Tag.apply({},G)}else G.unshift(y,z,C,D,A,F,E,B),cmCreateShopAction5Tag.apply({},G);var L=JSON.stringify(a),a=document.getElementById("cm-shopAction");if(t&&null!==a){if(r){var M="digitalData.cart.item["+w+"] = { ";M+="productInfo:{productID: '"+y+"', productName: '"+z+"'}, quantity: '"+C+"', price: '"+D+"', currency: '"+E+"', category:{primaryCategory: '"+A+"', virtualCategory: '"+q+"'}, attributes:{exploreAttributes: '"+o+"', extraFields: '"+p+"'}};",s&&(M+='cmSetupOther({"cm_currencyCode":"'+E+'"});'),b&&window.alert(M)}else{var M="cmCreateShopAction5Tag(";M+=null!==y&&""!==y?'"'+y+'", ':"null, ",null!==z&&""!==z?(z=z.replace(/\"/g,'\\"'),M+='"'+z+'", '):M+="null, ",M+=null!==C&&""!==C?'"'+C+'", ':"null, ",M+=null!==D&&""!==D?'"'+D+'", ':"null, ",M+=null!==A&&""!==A?'"'+A+'"':"null",this._useHostedCMLib||(M+=null!==F&&""!==F?', "'+F+'", ':", null, ",M+=null!==E&&""!==E?'"'+E+'", ':"null, ",M+=null!==B&&""!==B?'"'+B+'"':"null"),null!==p&&(M+=", "+p),M+=");"}var N=document.createTextNode(L);a.appendChild(N),a.appendChild(document.createElement("br"));var O=document.createTextNode(M);a.appendChild(O),a.appendChild(document.createElement("br"))}}}}if(u){cmDisplayShop5s();var I=document.getElementById("cm-shopAction");if(t&&null!==I){var J="cmDisplayShop5s();",K=document.createTextNode(J);I.appendChild(K),I.appendChild(document.createElement("br"))}}},handleElement:function(a){var b=!1;b&&window.alert("handleElement");var c="elementId",d="category",e="pageId",f="pageCategory",g="location",h="options",i="debug",j="extraParams",k="useDDX",l="true",m=null,n=null,o=null,p=null,q=null,r=null,s=this._getStoreId(),t=new Array,u=!1,v=!1;for(x in a)if(x===h){var w=a[x];w===k&&(u=!0)}else if(x===i){var y=a[x];y===l&&(v=!0)}else x===c?m=a[x]:x===d?n=a[x]:x===e?o=a[x]:x===f?p=a[x]:x===g?q=a[x]:x===this.PARAM_STORE_ID?s=a[x]:u?x===j&&(r=a[x]):t.push(a[x]);if(null==m);else{u?(null!=m&&"null"!==m&&"'null'"!==m||(m=""),null!=n&&"null"!==n&&"'null'"!==n||(n=""),null!=r&&"null"!==r&&"'null'"!==r||(r=""),"undefined"==typeof digitalData&&(digitalData={},digitalData.pageInstanceID="wcs-standardpage_wcs-element"),digitalData.component=[{componentInfo:{componentID:m},category:{primaryCategory:n},attributes:{exploreAttributes:r}}],b&&window.alert(JSON.stringify(digitalData))):this._useHostedCMLib?(t.unshift(m,n),cmCreateElementTag.apply({},t)):(t.unshift(m,n,o,p,q,s),cmCreatePageElementTag.apply({},t));var z=JSON.stringify(a),a=document.getElementById("cm-element");if(v&&null!==a){if(u){var A="digitalData = { ";null!==digitalData.pageInstanceID&&""!==digitalData.pageInstanceID&&(A+="pageInstanceID:'"+digitalData.pageInstanceID+"', "),A+="component:[{componentInfo:{componentID: '"+m+"'},category:{primaryCategory: '"+n+"'},attributes:{exploreAttributes: '"+r+"'}}]}",b&&window.alert(A)}else{var A="";A=this._useHostedCMLib?"cmCreateElementTag(":"cmCreatePageElementTag(",A+=null!==m&&""!==m?'"'+m+'", ':"null, ",A+=null!==n&&""!==n?'"'+n+'"':"null",this._useHostedCMLib||(A+=null!==o&&""!==o?', "'+o+'", ':", null, ",A+=null!==p&&""!==p?'"'+p+'", ':"null, ",A+=null!==q&&""!==q?'"'+q+'", ':"null, ",A+=null!==s&&""!==s?'"'+s+'"':"null"),A+=");"}var B=document.createTextNode(z);a.appendChild(B),a.appendChild(document.createElement("br"));var C=document.createTextNode(A);a.appendChild(C),a.appendChild(document.createElement("br"))}}},handleRegistration:function(a){var b=!1;b&&window.alert("handleRegistration");var c="userId",d="userEmail",e="userCity",f="userState",g="userZip",h="newsletterName",i="subscribedFlag",j="storeId",k="userCountry",l="age",m="gender",n="maritalStatus",o="numChildren",p="numInHousehold",q="companyName",r="hobbies",s="income",t="extraParams0",u="options",v="debug",w="extraParams",y="useDDX",z="true",A=null,B=null,C=null,D=null,E=null,F=null,G=null,H=null,I=null,J=null,K=null,L=null,M=null,N=null,O=null,P=null,Q=null,R=this._getStoreId(),S=new Array,T=null,U=!1,V=!1;for(x in a)if(x===u){var W=a[x];W===y&&(U=!0)}else if(x===v){var X=a[x];X===z&&(V=!0)}else if(x===c)A=a[x];else if(x===d)B=a[x];else if(x===e)C=a[x];else if(x===f)D=a[x];else if(x===g)E=a[x];else if(x===h)F=a[x];else if(x===i)G=a[x];else if(x===j)R=a[x];else if(x===k)H=a[x];else if(x===l){var Y=a[x];I="0"===Y||""===Y?"null":Y}else if(x===m){var Y=a[x];J=""===Y?"null":Y}else if(x===n){var Y=a[x];K=""===Y?"null":Y}else if(x===o){var Y=a[x];L="0"===Y||""===Y?"null":Y}else if(x===p){var Y=a[x];M="0"===Y||""===Y?"null":Y}else if(x===q){var Y=a[x];N=""===Y?"null":Y}else if(x===r){var Y=a[x];O=""===Y?"null":Y}else if(x===s){var Y=a[x];P="0"===Y||""===Y?"null":Y}else if(x===t){var Y=a[x];Q="0"===Y||""===Y?"null":Y}else U?x===w&&(T=a[x]):(S.push(a[x]),T=null==T?'"'+a[x]+'"':', "'+a[x]+'"');var Z="";this._useHostedCMLib||U?(null!=I&&"null"!==I||(I=""),null!=J&&"null"!==J||(J=""),null!=K&&"null"!==K||(K=""),null!=L&&"null"!==L||(L=""),null!=M&&"null"!==M||(M=""),null!=N&&"null"!==N||(N=""),null!=O&&"null"!==O||(O=""),null!=P&&"null"!==P||(P=""),Z=I+"-_-"+J+"-_-"+K+"-_-"+L+"-_-"+M+"-_-"+N+"-_-"+O+"-_-"+P,null!==Q&&"null"!==Q&&(Z+="-_-"+Q),S.unshift(A,B,C,D,E,H,Z)):S.unshift(A,B,C,D,E,F,G,R,H,I,J,K,L,M,N,O,P),U?(null!=A&&"null"!==A&&"'null'"!==A||(A=""),null!=B&&"null"!==B&&"'null'"!==B||(B=""),null!=Z&&"null"!==Z&&"'null'"!==Z||(Z=""),null!=C&&"null"!==C&&"'null'"!==C||(C=""),null!=D&&"null"!==D&&"'null'"!==D||(D=""),null!=E&&"null"!==E&&"'null'"!==E||(E=""),null!=H&&"null"!==H&&"'null'"!==H||(H=""),"undefined"==typeof digitalData&&(digitalData={},digitalData.pageInstanceID="wcs-standardpage_wcs-registration"),digitalData.user=[{profile:[{profileInfo:{profileID:A,profileEmail:B,exploreAttributes:Z},address:{city:C,state_province:D,postalcode:E,country:H}}]}],b&&window.alert(JSON.stringify(digitalData))):cmCreateRegistrationTag.apply({},S);var $=JSON.stringify(a),a=document.getElementById("cm-registration");if(V&&null!==a){if(U){var _="digitalData = { ";null!==digitalData.pageInstanceID&&""!==digitalData.pageInstanceID&&(_+="pageInstanceID:'"+digitalData.pageInstanceID+"', "),_+="user:[{profile:[{profileInfo:{profileID: '"+A+"', profileEmail: '"+B+"', exploreAttributes: '"+Z+"'}, address:{city: '"+C+"', state_province: '"+D+"',postalcode: '"+E+"', country: '"+H+"'}}]}]}",b&&window.alert(_)}else{var _="cmCreateRegistrationTag(";_+=null!==A&&""!==A&&"null"!==A?'"'+A+'", ':"null, ",_+=null!==B&&""!==B&&"null"!==B?'"'+B+'", ':"null, ",_+=null!==C&&""!==C&&"null"!==C?'"'+C+'", ':"null, ",_+=null!==D&&""!==D&&"null"!==D?'"'+D+'", ':"null, ",_+=null!==E&&""!==E&&"null"!==E?'"'+E+'", ':"null, ",this._useHostedCMLib||(_+=null!==F&&""!==F&&"null"!==F?'"'+F+'", ':"null, ",_+=null!==G&&""!==G&&"null"!==G?'"'+G+'", ':"null, ",_+=null!==R&&""!==R&&"null"!==R?'"'+R+'", ':"null, "),_+=null!==H&&""!==H&&"null"!==H?'"'+H+'", ':"null, ",this._useHostedCMLib?_+='"'+Z+'"':(_+=null!==I&&""!==I&&"null"!==I?'"'+I+'", ':"null, ",_+=null!==J&&""!==J&&"null"!==J?'"'+J+'", ':"null, ",_+=null!==K&&""!==K&&"null"!==K?'"'+K+'", ':"null, ",_+=null!==L&&""!==L&&"null"!==L?'"'+L+'", ':"null, ",_+=null!==M&&""!==M&&"null"!==M?'"'+M+'", ':"null, ",_+=null!==N&&""!==N&&"null"!==N?'"'+N+'", ':"null, ",_+=null!==O&&""!==O&&"null"!==O?'"'+O+'", ':"null, ",_+=null!==P&&""!==P&&"null"!==P?'"'+P+'"':"null"),null!==T&&(_+=", "+T),_+=");"}var aa=document.createTextNode($);a.appendChild(aa),a.appendChild(document.createElement("br"));var ba=document.createTextNode(_);a.appendChild(ba),a.appendChild(document.createElement("br"))}},_getStoreId:function(){for(var a=window.location.search.substr(1).split("&"),b=0;b<a.length;b++){var c=a[b].split("=");if(2===c.length&&c[0]===this.PARAM_STORE_ID)return c[1]}return null}}));var arrayUtils=arrayUtils||{stableSort:function(a,b){var c=a.map(function(a,b){return{element:a,index:b}});return c.sort(function(a,c){var d=b(a.element,c.element);return 0===d?a.index-c.index:d}).map(function(a){return a.element})},verifyTransitiveProperty:function(a,b){var c;for(c=0;c<a.length-1;c++)if(!b(a[c],a[c+1]))return!1;return!0},isEmpty:function(a){return 0===a.length},last:function(a){if(!this.isEmpty(a))return a[a.length-1]},arrTo2D:function(a,b){if("undefined"==typeof b)throw"The number of columns to divide the array into is undefined";var c=[];while(a.length)c.push(a.splice(0,b));return c}},KeyCodes=KeyCodes||{TAB:9,RETURN:13,SHIFT:16,SPACE:32,ESCAPE:27,LEFT_ARROW:37,UP_ARROW:38,RIGHT_ARROW:39,DOWN_ARROW:40};wcTopic={_topics:{},_getIdArray:function(a){var b=new Array;if("array"===$.type(a)||"object"===$.type(a))for(var c in a)b.push(a[c]);else"string"===$.type(a)?b.push(a):console.error("jQuery.Topic - ids has an unsupported type: "+$.type(a));return b},_processIds:function(a){var b=this._getIdArray(a);for(var c in b){var d=b[c];this._topics[d]||(this._topics[d]=$.Topic(d))}return b},subscribe:function(a,b){var c=this._processIds(a);for(var d in c)this._topics[c[d]].subscribe(b)},publish:function(a,b){var c=this._processIds(a),d;for(var e in c)d=Array.prototype.slice.call(arguments,1),this._topics[c[e]].publish.apply(null,d)},subscribeOnce:function(a,b,c){var d=this._processIds(a);for(var e in d)this._topics[d[e]].subscribeOnce(b,c)}},jQuery.Topic=function(a){var b=jQuery.Callbacks("unique"),c={id:a,publish:b.fire,subscribe:b.add,subscribeOnce:function(a,c){if($.isFunction(a)){var d=function(){a.apply(c||this,arguments),b.remove(d)};b.add(d)}else a.forEach(function(a){if($.isFunction(a)){var d=function(){a.apply(c||this,arguments),b.remove(d)};b.add(d)}else console.err(a+" is not a function")})},unsubscribe:b.remove};return c};var Utils=Utils||{once:function(a,b){var c;return function(){return a&&(c=a.apply(b||this,arguments),a=null),c}},stopEvent:function(a){a.preventDefault(),a.stopPropagation()},getTextDirection:function(a){var b=null;return window.getComputedStyle?b=window.getComputedStyle(a,null).direction:a.currentStyle&&(b=a.currentStyle.direction),b},isOpera:function(){return!!navigator.userAgent.match(/Opera|OPR\//)},has_ios:function(){return navigator.userAgent.match(/(iPod|iPhone|iPad)/)},isChrome:function(){return/chrom(e|ium)/.test(navigator.userAgent.toLowerCase())},hasTouch:function(){return"ontouchstart"in window||navigator.MaxTouchPoints>0||navigator.msMaxTouchPoints>0},get_IE_version:function(){var a=window.navigator.userAgent,b=a.indexOf("MSIE ");if(b>0)return parseInt(a.substring(b+5,a.indexOf(".",b)),10);var c=a.indexOf("Trident/");if(c>0){var d=a.indexOf("rv:");return parseInt(a.substring(d+3,a.indexOf(".",d)),10)}var e=a.indexOf("Edge/");return e>0?parseInt(a.substring(e+5,a.indexOf(".",e)),10):void 0},keys:function(a){var b=[],c;for(c in a)a.hasOwnProperty(c)&&b.push(c);return b},iterate_obj_in_order:function(a,b,c){var d=this.keys(a),e=d.length,f,g;for(d.sort(b),f=0;f<e;f++)if(g=d[f],c(g,a[g]))break},varExists:function(a){return null!==a&&"undefined"!=typeof a},existsAndNotEmpty:function(a){return this.varExists(a)&&a.length},is_null_or_undefined:function(a){return null===a||"undefined"==typeof a},isNullOrUndefined:function(a){return null===a||"undefined"==typeof a},isUndefined:function(a){return"undefined"==typeof a},isUndefinedOrEmpty:function(a){return"undefined"==typeof a||0===a.length},isObject:function(a){return null!==a&&"object"==typeof a},isString:function(a){return"string"==typeof a},queryToObject:function(a){var b='{"'+a.split("&").map(function(a){return a.replace("=",'":"')}).join('","')+'"}';return a?JSON.parse(b,function(a,b){return""===a?b:decodeURIComponent(b)}):{}},updateQueryStringParameter:function(a,b,c){var d={};if(this.isString(b))d[b]=c;else{if(!this.isObject(b))throw"Invalid key parameter, expected a String or an Object, got: "+b;if(this.isUndefined(c)){if($.isEmptyObject(b))return console.warn("The given parameters are empty"),a}else console.warn("Value parameter passed, but will not be used: "+c);d=b}return $.each(d,function(b,c){var d=new RegExp("([?|&])"+b+"=.*?(&|#|$)","i");if(a.match(d))a=a.replace(d,"$1"+b+"="+c+"$2");else{var e="";a.indexOf("#")!==-1&&(e=a.replace(/.*#/,"#"),a=a.replace(/#.*/,""));var f=a.indexOf("?")!==-1?"&":"?";a=a+f+b+"="+c+e}}),a},addDays:function(a,b){var c=new Date(a);return c.setDate(c.getDate()+b),c},addMilliseconds:function(a,b){return new Date(a.getTime()+b)},set_option:function(a,b,c,d){if(this.is_null_or_undefined(a.options[b])){var e=$(a.element).data(c);this.is_null_or_undefined(e)?a.option(b,d):a.option(b,e)}},toggleHyperlink:function(a,b){if(a.is("a"))if(b){a.off("click.utils");var c=a.data("utils.toggleHyperlink");a.attr("onclick",c.onclick)}else a.on("click.utils",function(a){a.preventDefault()}),a.data("utils.toggleHyperlink",{onclick:a.attr("onclick")}),a.removeAttr("onclick");else console.err("not a hyperlink: "+a)},position:function(a){var b=$(a),c=b.offset();return{x:c.left,y:c.top,w:b.width(),h:b.height()}},isEmptyOrWhiteSpace:function(a){return""===$.trim(a)},isBoolean:function(a){return"boolean"===$.type(a)},selectAll:function(a){if(a.length>0){var b=$(a[0]),c;for(c=1;c<a.length;c++)b=b.add(a[c]);return b}return $()},elementExists:function(a){return $(a).length>0},ifSelectorExists:function(a,b,c){var d=$(a);if(d.length)return c?$.proxy(b,c)(d):b(d)},selectExistingElement:function(a){return a.map(function(a){return $(a)}).find(function(a){return a.length})},replaceAttr:function(a,b,c){a.attr(b,c(a.attr(b)))},scrollIntoView:function(a){var b=$(a).offset().top,c=$(window).scrollTop();b<c?$(a)[0].scrollIntoView(!0):b+$(a).height()>c+$(window).height()&&$(a)[0].scrollIntoView(!1)},onOnce:function(a,b,c,d,e){var f=b+"."+c;this.isString(d)?a.off(f).on(f,d,e):(e=d,a.off(f).on(f,e))},substituteStringWithObj:function(a,b){return a.replace(/{(\w+(\.*\w*)*)}/g,function(a,c){if("undefined"!=typeof b){var d=b,e=c.substr(0,c.indexOf("."));c=c.substr(c.indexOf(".")+1,c.length);while(""!==e)d=d[e],e=c.substr(0,c.indexOf(".")),c=c.substr(c.indexOf(".")+1,c.length);return""!==c&&(d=d[c]),"undefined"!=typeof d?d:a}return a})},substituteStringWithMap:function(a,b){return a=a.replace(/\{([0-9])\}/g,function(a,c){return b[c]})},getLocalizationMessage:function(a,b){if(GlobalizeLoaded)return Globalize.formatMessage(a,b)},formatCurrency:function(a,b){if(a=a.replace(/[^0-9\.\,]/g,""),b)var c=b.currency,d=b.locale;if(c||(c=WCParamJS.commandContextCurrency),GlobalizeLoaded)return d?(a=Globalize(d).parseNumber(a),Globalize(d).formatCurrency(a,c,b)):(a=Globalize.parseNumber(a),Globalize.formatCurrency(a,c,b))},parseNumber:function(a){if(a=a.replace(/[^0-9\.\,]/g,""),GlobalizeLoaded)return Globalize.parseNumber(a)},formatNumber:function(a,b){if(a=a.replace(/[^0-9\.\,]/g,""),GlobalizeLoaded)return a=Globalize.parseNumber(a),Globalize.formatNumber(a,b)},getLocale:function(){return navigator.languages?navigator.languages[0]:navigator.language||navigator.userLanguage},round:function(a,b){return Number(Math.round(a+"e"+b)+"e-"+b)},toBoolean:function(a){return!!a},arrContains:function(a,b){return $.inArray(b,a)!==-1},notNullOrWhiteSpace:function(a){return null!==a&&0!==$.trim(a).length},findInObj:function(a,b){var c;return $(a).each(function(a,d){
if(b(a,d))return c=a,!1}),c},areSiblings:function(a,b){var c=function(a,b){return $(a).siblings().is($(b))};return!(!arrayUtils.verifyTransitiveProperty(a,c)||!arrayUtils.verifyTransitiveProperty(b,c))&&(!(!arrayUtils.isEmpty(a)&&!arrayUtils.isEmpty(b))||c(arrayUtils.last(a),b[0]))},sameParent:function(a){},getObject:function(a){if(""!==a){var b=a.split("."),c=window[b[0]];for(i=1;i<b.length;i++){if(!c)break;c=c[b[i]]}return c}},idExists:function(){if(0===arguments.length)return console.warn("No arguments passed to idExists"),!0;for(var a=0;a<arguments.length;a++)if(!$(arguments[a].length))return!1;return!0},aop_after:function(a,b,c){var d=$.proxy(a[b],a);a[b]=function(){return d.apply(this,arguments),c(arguments)}},substituteString:function(a,b){return a=a.replace(/\$\{([0-9])\}/g,function(a,b){return subsMap[b]})}};jQuery(document).ready(function($){$.widget("wc.refreshWidget",{url:void 0,ariaMessage:void 0,ariaLiveId:void 0,options:{formId:void 0,renderContextChangedHandler:null,postRefreshHandler:null},_create:function(){this.element.attr("refreshurl")&&(this.url=this.element.attr("refreshurl")),this.url||console.warn("Warning: refreshurl is not defined for refresh area: "+this.element.attr("id")),"RefreshArea"!==this.element.attr("wcType")&&console.error("Error: wcType is not set to 'RefreshArea' for refresh area: "+this.element.attr("id")),this.element.attr("declareFunction")||console.error("Error: declareFunction is not set for refresh area: "+this.element.attr("id")),this.element.attr("ariaMessage")&&(this.ariaMessage=this.element.attr("ariaMessage")),this.element.attr("ariaLiveId")&&(this.ariaMessage=this.element.attr("ariaLiveId"))},updateUrl:function(a){this.url=a},updateFormId:function(a){this.options.formId=a},refresh:function(parameters){var domNode=this.element,widget=this;!this.url&&this.element.attr("refreshurl")&&(this.url=this.element.attr("refreshurl"));var formNode=null;if(this.options.formId&&(formNode=$("#"+this.options.formId)),parameters?parameters.requesttype||(parameters.requesttype="ajax"):parameters={requesttype:"ajax"},!this.url)return void console.error("refreshurl is not specified for refresh area: "+domNode.attr("id"));this.url=this.url.replace(/amp;/g,"");var mergedParameters=parameters;if("object"==typeof wcCommonRequestParameters){mergedParameters={},$.extend(mergedParameters,parameters);for(var parameterName in wcCommonRequestParameters)this._isParameterExcluded(this.url,parameterName)?console.debug("parameter "+parameterName+" is excluded"):mergedParameters.parameterName=wcCommonRequestParameters.parameterName}if($.isArray(mergedParameters)){var keyValuePairs={};for(var paramKey in mergedParameters)$.isArray(mergedParameters[paramKey])?mergedParameters[paramKey].length>0&&(keyValuePairs[paramKey]=mergedParameters[paramKey]):keyValuePairs[paramKey]=mergedParameters[paramKey];mergedParameters=keyValuePairs,console.debug("mergedParameters after modifying = "+JSON.stringify(mergedParameters))}var failureHandler=function(a,b){console.error("failed to refresh widget "+domNode.attr("id")),wcTopic.publish("ajaxRequestCompleted")},successHandler=function(data,status){function getIds(a,b){var c="";if(mergedParameters&&mergedParameters[a]&&(c=mergedParameters[a]),""===c&&null!=formNode&&formNode[a]&&(c=formNode[a],null!=formNode[a].value&&(c=formNode[a].value)),""===c&&b){var d=b;if(d.indexOf(a)!==-1){d=d.substring(d.indexOf(a));var e=d.split("&"),f=e[0].split("=");c=f[1]}}return c}function parseJsonCommentFiltered(str){str=str.replace("/*",""),str=str.replace("*/","");var json=eval("("+str+")");return json}var storeId=getIds("storeId",widget.url),catalogId=getIds("catalogId",widget.url),langId=getIds("langId",widget.url),errorCodeBegin=data.indexOf("errorCode");function serverErrorHandler(a){if(console.debug("error condition encountered - error code: "+a),a.indexOf("2550")!==-1)console.debug("error type: ERR_DIDNT_LOGON - the customer did not log on to the system."),console.debug("redirecting to URL: AjaxLogonForm?storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId+"&myAcctMain=1"),document.location.href="AjaxLogonForm?storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId+"&myAcctMain=1";else if(a.indexOf("2510")!==-1){console.debug("error type: ERR_SESSION_TIMEOUT - use session has timed out");var b=parseJsonCommentFiltered(data),c="Logoff?";if("true"==b.exceptionData.isBecomeUser&&(c="RestoreOriginalUserSetInSession?URL=Logoff&"),"true"==b.exceptionData.rememberMe){var d=c+"rememberMe=true&storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId;console.debug("try to logoff, get URL="+d),$.ajax({type:"GET",url:d,data:mergedParameters,success:function(a,b){console.debug("User logged off. Reload current page to avoid data inconsistence..."),document.location.reload()},error:function(a){document.location.href="ReLogonFormView?rememberMe=true&storeId="+storeId}})}else console.debug("redirecting to URL: "+c+"URL=ReLogonFormView&storeId="+storeId),document.location.href=c+"URL=ReLogonFormView&storeId="+storeId}else a.indexOf("2520")!==-1?(console.debug("error type: ERR_PROHIBITED_CHAR - detected prohibited characters in request"),console.debug("redirecting to URL: ProhibitedCharacterErrorView?storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId),document.location.href="ProhibitedCharacterErrorView?storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId):errorCodeString.indexOf("2540")!==-1?(console.debug("error type: ERR_CSRF - cross site request forgery attempt was detected"),console.debug("redirecting to URL: CrossSiteRequestForgeryErrorView?storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId),document.location.href="CrossSiteRequestForgeryErrorView?storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId):errorCodeString.indexOf("CMN1039E")!==-1&&(console.debug("error type: _ERR_INVALID_COOKIE - cookie error was detected"),console.debug("redirecting to URL: CookieErrorView?storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId),document.location.href="CookieErrorView?storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId)}if(errorCodeBegin!=-1){var errorCodeEnd=data.indexOf(",",errorCodeBegin),errorCodeString=data.substring(errorCodeBegin,errorCodeEnd);serverErrorHandler(errorCodeString)}else domNode.html(data),WCWidgetParser.parse(domNode),null!=widget.options.postRefreshHandler&&widget.options.postRefreshHandler(widget.element);wcTopic.publish("ajaxRequestCompleted"),widget._updateLiveRegion()},ajaxParams={data:formNode?formNode.serialize()+"&"+$.param(mergedParameters):mergedParameters,url:this.url,type:"POST",traditional:!0,success:successHandler,error:failureHandler};$.ajax(ajaxParams)},renderContextChanged:function(a){null!=this.options.renderContextChangedHandler&&this.options.renderContextChangedHandler(a)},_updateLiveRegion:function(){if($("#"+this.ariaLiveId+"_ACCE_Label").css("display","block"),""!==this.ariaMessage&&""!==this.ariaLiveId){var a=document.createTextNode(this.ariaMessage),b=document.getElementById(this.ariaLiveId);if(b){while(b.firstChild)b.removeChild(b.firstChild);b.appendChild(a)}}}})}(jQuery)),wcRenderContext={contextArray:{},getRefreshAreaIds:function(a){return this.checkIdDefined(a)?this.contextArray[a].refreshAreaIds:void console.error("wcRenderContext.getRefreshAreaIds: Common render context "+a+" is not defined")},getRenderContextProperties:function(a){return this.checkIdDefined(a)?this.contextArray[a].contextProperties:void console.error("wcRenderContext.getRenderContextProperties: Common render context "+a+" is not defined")},addRefreshAreaId:function(a,b){return this.checkIdDefined(a)?void(Utils.arrContains(this.contextArray[a].refreshAreaIds,b)||this.contextArray[a].refreshAreaIds.push(b)):void console.error("wcRenderContext.addRefreshAreaId: Common render context "+a+" is not defined")},declare:function(a,b,c){if(this.checkIdDefined(a))return void console.error("Common render context with id =  "+a+" already exits.Please use a different id");if(!$.isArray(b))return void console.error("refresh area ids should be an array, got: "+b);""===c&&(c={});var d={id:a,refreshAreaIds:b,contextProperties:c,currentRCProperties:{}};this.contextArray[a]=d,this._syncRCProperties(a)},updateRenderContext:function(a,b){if(!this.checkIdDefined(a))return void console.error("wcRenderContext.updateRenderContext: Common render context "+a+" is not defined");var c=this.getRenderContextProperties(a);for(var d in b){var e=b[d];e!=c[d]&&(Utils.isUndefined(e)?delete c[d]:c[d]=e)}var f=this.getRefreshAreaIds(a);$.each(f,function(a,b){var c=$("#"+b);c.refreshWidget("renderContextChanged",c)}),wcTopic.publish(a+"/RenderContextChanged",{actionId:a+"/RenderContextChanged"}),this._syncRCProperties(a)},testForChangedRC:function(a,b){for(var c=!1,d=0;d<b.length;d++){var e=b[d];if(this.contextArray[a].currentRCProperties[e]!=this.contextArray[a].contextProperties[e]){c=!0;break}}return c},checkIdDefined:function(a){return Utils.toBoolean(this.contextArray[a])},_syncRCProperties:function(a){var b=this.getRenderContextProperties(a),c=$.extend({},b);this.contextArray[a].currentRCProperties=c}},function($){$.wcServicePlugin=function(options){var settings=$.extend({id:void 0,actionId:void 0,url:void 0,formId:void 0,successHandler:void 0,failureHandler:void 0},options),validateParameters=function(a){return!0},validateForm=function(a){return!0},successTest=function(a){return!a.errorMessage&&!a.errorMessageKey},_isParameterExcluded=function(a,b){try{if("object"==typeof URLConfig)if("object"==typeof URLConfig.excludedURLPatterns)for(var c in URLConfig.excludedURLPatterns){var d=URLConfig.excludedURLPatterns[c],e=c;if("object"==typeof d&&(d.urlPattern&&(e=d.urlPattern),console.debug("URL pattern to match : "+e),e=new RegExp(e),a.match(e))){var f=d.excludedParameters;for(var g in f)if(parametername==g)return!0}}else console.debug("The parameter "+b+" is not excluded");else console.debug("No URLConfig defined.")}catch(a){console.debug("An error occured while trying to exclude "+a)}return!1},output={setFormId:function(a){settings.formId=a},setActionId:function(a){settings.actionId=a},setUrl:function(a){settings.url=a},setParam:function(a,b){settings[a]=b},getParam:function(a){return settings[a]},invoke:function(parameters){var valid=!0,formNode=null;settings.formId&&(formNode=$("#"+settings.formId)),formNode&&(valid=validateForm(formNode)),valid&&(valid=validateParameters(parameters));function addAuthToken(a){try{return $("#csrf_authToken").length?a.authToken=$("#csrf_authToken").val():console.debug("auth token is missing from the HTML DOM"),!0}catch(a){console.debug("An error occured while trying to add authToken to request "+a)}return!1}parameters?parameters.requesttype||(parameters.requesttype="ajax"):(parameters={},parameters.requesttype="ajax"),addAuthToken(parameters);var mergedParameters=parameters;if("object"==typeof wcCommonRequestParameters){mergedParameters={},$.extend(mergedParameters,parameters);for(var parameterName in wcCommonRequestParameters)_isParameterExcluded(this.url,parameterName)?console.debug("parameter "+parameterName+" is excluded"):mergedParameters.parameterName=wcCommonRequestParameters.parameterName}if($.isArray(mergedParameters)){var keyValuePairs={};for(var paramKey in mergedParameters)$.isArray(mergedParameters[paramKey])?mergedParameters[paramKey].length>0&&(keyValuePairs[paramKey]=mergedParameters[paramKey]):keyValuePairs[paramKey]=mergedParameters[paramKey];mergedParameters=keyValuePairs,console.debug("mergedParameters after modifying = "+JSON.stringify(mergedParameters))}var successHandler=function(a,b){function c(a,b){var c="";if(mergedParameters&&mergedParameters[a]&&(c=mergedParameters[a]),""==c&&null!=formNode&&formNode[a]&&(c=formNode[a],null!=formNode[a].value&&(c=formNode[a].value)),""==c&&b){var d=b;if(d.indexOf(a)!=-1){d=d.substring(d.indexOf(a));var e=d.split("&"),f=e[0].split("=");c=f[1]}}return c}var d=c("storeId",settings.url),e=c("catalogId",settings.url),f=c("langId",settings.url);function g(c){if("2500"==c){var g=a.originatingCommand;g=g.replace("?","%3F"),g=g.replace(/&amp;/g,"%26"),g=g.replace(/&/g,"%26"),g=g.replace(/=/g,"%3D"),g="LogonForm?nextUrl="+g+"&storeId="+d+"&catalogId="+e+"&langId="+f+"&myAcctMain=1",console.debug("error type: ERR_USER_NOT_LOGGED_ON - only registered user can invoke the command"),console.debug("redirecting to URL: "+g),document.location.href=g}else if("2550"==c){var g=a.originatingCommand;g=g.replace("?","%3F"),g=g.replace(/&amp;/g,"%26"),g=g.replace(/&/g,"%26"),g=g.replace(/=/g,"%3D"),g="AjaxLogonForm?nextUrl="+g+"&storeId="+d+"&catalogId="+e+"&langId="+f+"&myAcctMain=1",console.debug("error type: ERR_DIDNT_LOGON - the customer did not log on to the system."),console.debug("redirecting to URL: "+g),document.location.href=g}else if("2530"==c){var g=a.originatingCommand;g=g.replace("?","%3F"),g=g.replace(/&amp;/g,"%26"),g=g.replace(/&/g,"%26"),g=g.replace(/=/g,"%3D"),g="PasswordReEnterErrorView?nextUrl="+g+"&storeId="+d+"&catalogId="+e+"&langId="+f,console.debug("error type: ERR_PASSWORD_REREQUEST - password is required"),console.debug("redirecting to URL: "+g),document.location.href=g}else if("2510"==c){console.debug("error type: ERR_SESSION_TIMEOUT - use session has timed out");var h="Logoff?";if("true"==a.exceptionData.isBecomeUser&&(h="RestoreOriginalUserSetInSession?URL=Logoff&"),"true"==a.exceptionData.rememberMe){var g=h+"rememberMe=true&storeId="+d+"&catalogId="+e+"&langId="+f;console.debug("try to logoff, get URL="+g),$.ajax({type:"GET",url:g,data:mergedParameters,success:function(a,b){console.debug("User logged off. Reload current page to avoid data inconsistence..."),document.location.reload()},error:function(a){document.location.href="ReLogonFormView?rememberMe=true&storeId="+d}})}else console.debug("redirecting to URL: "+h+"URL=ReLogonFormView&storeId="+d),document.location.href=h+"URL=ReLogonFormView&storeId="+d}else"2520"==c?(console.debug("error type: ERR_PROHIBITED_CHAR - detected prohibited characters in request"),console.debug("redirecting to URL: ProhibitedCharacterErrorView?storeId="+d+"&catalogId="+e+"&langId="+f),document.location.href="ProhibitedCharacterErrorView?storeId="+d+"&catalogId="+e+"&langId="+f):"2540"==c?(console.debug("error type: ERR_CSRF - cross site request forgery attempt was detected"),console.debug("redirecting to URL: CrossSiteRequestForgeryErrorView?storeId="+d+"&catalogId="+e+"&langId="+f),document.location.href="CrossSiteRequestForgeryErrorView?storeId="+d+"&catalogId="+e+"&langId="+f):"CMN1039E"==c?(console.debug("error type: _ERR_INVALID_COOKIE - cookie error was detected"),console.debug("redirecting to URL: CookieErrorView?storeId="+d+"&catalogId="+e+"&langId="+f),document.location.href="CookieErrorView?storeId="+d+"&catalogId="+e+"&langId="+f):settings.failureHandler&&(console.debug("calling service.failureHandler"),settings.failureHandler(a,b));wcTopic.publish("ajaxRequestCompleted")}console.debug("response from ajax call:");for(var h in a)console.debug("  "+h+"="+a[h]);if(successTest(a)){if(settings.successHandler){var i=$(this).attr("data");i=i?JSON.parse('{"'+i.replace(/&/g,'","').replace(/=/g,'":"')+'"}',function(a,b){return""===a?b:decodeURIComponent(b)}):{},settings.successHandler(a,i),console.debug("success: publishing modelChanged event")}settings.actionId&&(console.debug("triggering action: "+settings.actionId),wcTopic.publish(settings.actionId,{actionId:settings.actionId,data:a}))}else console.debug("error condition encountered - error code: "+a.errorCode),g(a.errorCode)},failureHandler=function(a,b){console.debug("Warning: communication error while making the service call");var c=a.errorMessage;c?alert(c):(c=a.errorMessageKey,c?alert(c):alert("Service request error."))};if(console.debug("service formId = "+settings.formId),valid){wcTopic.publish("ajaxRequestInitiated");var stripComment=function(a,b,c){var d=a.indexOf(b),e=-1,f="",g="";return d!=-1&&(e=a.indexOf(c)),e!=-1&&(f=a.substr(0,d),g=a.substr(e+c.length),a=f+g),a.indexOf(b)!=-1&&(a=stripComment(a,b,c)),a},ajaxParams={url:settings.url,type:"POST",data:formNode?formNode.serialize()+"&"+$.param(mergedParameters,!0):mergedParameters,traditional:!0,dataFilter:function(str){str=str.replace("/*",""),str=str.replace("*/",""),str.indexOf("<!--")!=-1&&(str=stripComment(str,"<!--","-->")),str.indexOf("<%--")!=-1&&(str=stripComment(str,"<%--","--%>"));var json=eval("("+str+")");return json},success:successHandler,error:failureHandler};$.ajax(ajaxParams)}}};return output}}(jQuery),wcService={wcServices:{},getServiceById:function(a){return this.wcServices[a]},declare:function(a){a.id&&(this.wcServices[a.id]=$.wcServicePlugin(a))},invoke:function(a,b){var c=this.getServiceById(a);c?c.invoke(b):console.error("Attempt to invoke an unregistered service: "+a)}};var WCWidgetParser;!function(a){WCWidgetParser=WCWidgetParser||{widgetDefinitions:{dialog:{fcnName:"Dialog"},autocomplete:{fcnName:"autocomplete"},tabs:{fcnName:"tabs"},datepicker:{fcnName:"datepicker",defaultOptions:{showOtherMonths:!0,changeYear:!0,dayNamesMin:["S","M","T","W","T","F","S"],altFormat:"yy-mm-dd",dateFormat:"mm/dd/yy"}},"wc.WCDialog":{fcnName:"WCDialog"},"wc.Carousel":{fcnName:"Carousel"},"wc.Grid":{fcnName:"Grid"},"wc.tooltip":{fcnName:"wcToolTip"},"wc.Select":{fcnName:"Select"},"wc.ValidationTextbox":{fcnName:"ValidationTextbox"}},_parse_widget:function(b,c,d){var e=this.widgetDefinitions[c];if(!e)return void console.error("Widget type: "+c+" not registered");var f=e.fcnName,g=e.default_options||{};if(d=d||{},Utils.isObject(d)||a.isArray(d)){var h=a.extend({},g,d);b[f]?b[f](h):console.error("Function: "+f+" does not exist")}else b[f](g),console.error("The given html option is neither an Object nor an array (the default options will be used instead): "+d)},parse:function(b){var c=[];a("[data-widget-type]",b).each(a.proxy(function(b,d){var e=a(d),f=e.data("widget-type"),g=e.data("widget-options");a.isArray(f)?Utils.varExists(g)&&!a.isArray(g)?console.error("widgetName is an array but widgetOptions is not: "+g):f.length!==g.length?console.error("widgetName and widgetOptions have different lengths"):f.forEach(function(a,b){c.push({element:e,widgetName:a,widgetOptions:g[b]})}):c.push({element:e,widgetName:f,widgetOptions:g})},this));var d=function(a,b){return a.widgetOptions&&a.widgetOptions.parseOrder?b.widgetOptions&&b.widgetOptions.parseOrder?a.widgetOptions.parseOrder-b.widgetOptions.parseOrder:-1:b.widgetOptions&&b.widgetOptions.parseOrder?1:0},e=function(a,b){return a.element.is(":visible")?b.element.is(":visible")?0:-1:b.element.is(":visible")?1:0};c=arrayUtils.stableSort(c,function(a,b){var c=d(a,b);return 0===c&&(c=e(a,b)),c}),a.each(c,a.proxy(function(a,b){this._parse_widget(b.element,b.widgetName,b.widgetOptions)},this))},parseRefreshArea:function(b){a("[wcType='RefreshArea']",b).each(function(b,c){var d=a(c).attr("declareFunction"),e,f,g=null;if(d){var h=d.indexOf(".");h>0&&(e=d.substr(0,h));var i=d.indexOf("(");if(i>0){f=d.substr(h+1,i-h-1);var j=d.slice(i+1,d.length-1);j=j.replace(/"/g,"").replace(/'/g,"").replace(/ /g,""),g=j.split(",")}else f=d.substr(h+1)}f&&(e?Utils.isUndefined(window[e])?console.error("Namespace "+e+" is not defined"):Utils.isUndefined(window[e][f])?console.error("Function "+f+" is not defined under namespace "+e):window[e][f](g):Utils.isUndefined(window[f])?console.error(f+" is not defined!"):a.isFunction(window[f])?window[f](g):console.error(window[f]+" is not a function!"))})}},a(document).ready(function(){WCWidgetParser.parse(),WCWidgetParser.parseRefreshArea()})}(jQuery),function(){$.widget("wc.Carousel",$.Widget,{options:{prevButton:null,nextButton:null,paginationButtons:null,contentContainer:"div.content",overflowVisible:!1,owlCarouselOptions:{autoHeight:!1,autoWidth:!0,pagination:!1,slideSpeed:2e3,afterMove:function(a){this.options.paginationButtons&&this.paginationButtons.removeClass("selected").eq(this.owlCarousel.currentItem).attr("class","selected")},afterUpdate:function(){this._togglePrevNextButtons()}}},_proxyFunction:function(a){$.isFunction(this.options.owlCarouselOptions[a])&&(this.options.owlCarouselOptions[a]=$.proxy(this.options.owlCarouselOptions[a],this))},_create:function(){if(this._super(this),this.content=$(this.options.contentContainer,this.element),this._proxyFunction("afterMove"),this._proxyFunction("afterUpdate"),this.options.columnCountByWidth){var a=this.options.columnCountByWidth;if(Utils.isObject(a)){var b=$(window).width(),c=Object.keys(a).map(function(a){return parseInt(a,10)});c.sort(function(a,b){return a-b}),c=c.map(function(b){return[b,a[b.toString()]]}),this.options.owlCarouselOptions.itemsCustom=c}else console.error("columnCountByWidth is not an object: "+this.options.columnCountByWidth)}this.owlCarousel=this.content.owlCarousel(this.options.owlCarouselOptions).data("owlCarousel"),this.options.overflowVisible&&$(".owl-wrapper-outer",this.element).addClass("overflow-visible"),$(window).resize($.proxy(function(){this.owlCarousel.reload(),this._togglePrevNextButtons()},this)),this._add_event_handlers(),this._togglePrevNextButtons()},_togglePrevNextButtons:function(){var a=this.owlCarousel.itemsAmount>this.owlCarousel.options.items;a?(this.options.nextButton&&this.$nextButton.show(),this.options.prevButton&&this.$prevButton.show()):(this.options.nextButton&&this.$nextButton.hide(),this.options.prevButton&&this.$prevButton.hide())},_add_event_handlers:function(){var a=this.owlCarousel;this.element.on("resized.owl.carousel",function(){console.log("resized")}),this.options.prevButton&&(this.$prevButton=$(this.options.prevButton,this.element),this.$prevButton.click(function(b){a.prev(),b.preventDefault()})),this.options.nextButton&&(this.$nextButton=$(this.options.nextButton,this.element),this.$nextButton.click(function(b){a.next(),b.preventDefault()})),this.options.paginationButtons&&(this.paginationButtons=$(this.options.paginationButtons,this.element),this.paginationButtons.first().attr("class","selected"),this.paginationButtons.each(function(b,c){$(c).click(function(c){a.goTo(b),c.preventDefault()})}))},_destroy:function(){this.owlCarousel.destroy()}})}(),function(a){a.widget("wc.Grid",a.Widget,{options:{columnCount:1,rowCount:null,elementSelector:"div.grid-element",useColumnWrapper:!1,columnWrapperClass:"grid-column-wrapper"},optionChangedHandlers:{columnCount:function(){this._columnCountUpdated()},columnCountByWidth:function(){this.resize()},elementSelector:function(){this.$elements=void 0}},columnContainerClass:{1:"ui-grid-solo",2:"ui-grid-a",3:"ui-grid-b",4:"ui-grid-c",5:"ui-grid-d",6:"ui-grid-e",7:"ui-grid-f",8:"ui-grid-g",9:"ui-grid-h"},currentColumnContainerClass:null,columnClass:{1:"ui-block-a",2:"ui-block-b",3:"ui-block-c",4:"ui-block-d",5:"ui-block-e",6:"ui-block-f",7:"ui-block-g",8:"ui-block-h",9:"ui-block-i"},_setOption:function(a,b){this._super(a,b),this.optionChangedHandlers[a]&&this.optionChangedHandlers[a].call(this)},_getColumnContainerClass:function(a){var b=this.columnContainerClass[String(a)];if(b)return b;throw"Unsupported, too many columns: "+a},_columnCountUpdated:function(){this.$elements=this.$elements||a(this.options.elementSelector,this.element);var b=this.$elements,c=b.parent(),d=this.options.columnCount,e=this.options.rowCount;if(d){if(0===d)throw"Column count must be greater than 0!";if(e){if(0===e)throw"rowCount must be greater than 0!";if(b.length>d*e)throw"The number of elements ("+b.length+") cannot fit into a "+d+" by "+e+" grid"}else e=Math.ceil(b.length/d)}else{if(!e)throw"Row count and column count not defined!";if(0===e)throw"rowCount must be greater than 0!";d=Math.ceil(b.length/e)}this.options.useColumnWrapper&&c.hasClass(this.options.columnWrapperClass)&&(b.unwrap(),c=b.parent()),this.currentColumnContainerClass&&c.removeClass(this.currentColumnContainerClass),this.currentColumnContainerClass=this._getColumnContainerClass(d),c.addClass(this.currentColumnContainerClass);var f=arrayUtils.arrTo2D(a.makeArray(b),d),g;for(g=0;g<d;g++){var h=a(f.filter(function(a){return a.length>g}).map(function(a){return a[g]}));this.options.useColumnWrapper?(h=h.detach(),$wrapper=a('<div class="'+this.options.columnWrapperClass+" "+this.columnClass[g+1]+'"></div>'),c.append($wrapper),$wrapper.append(h)):h.removeClass(this.allColumnClass).addClass(this.columnClass[g+1])}},_validateElements:function(){if(!Utils.areSiblings(a(this.options.elementSelector,this.element),a([])))throw"Grid elements must all be under the same parent"},_create:function(){this._super(this),this.allColumnClass=a.map(this.columnClass,function(a,b){return a}).join(" "),this._validateElements(),this.option("columnCount",this._calculateColumnBasedOnClientWidth()),a(window).resize(a.proxy(function(){this.resize()},this))},_calculateColumnBasedOnClientWidth:function(){var a=1,b=this.element.get(0).clientWidth;return this.options.columnCountByWidth&&Utils.iterate_obj_in_order(this.options.columnCountByWidth,function(a,b){return parseInt(b)-parseInt(a)},function(c,d){if(b>=parseInt(c))return a=d,!0}),a},resize:function(){var a=this._calculateColumnBasedOnClientWidth();a!==this.options.columnCount&&this.option("columnCount",a)}})}(jQuery),function($){$.widget("wc.Select",$.ui.selectmenu,{options:{wcMenuClass:"",useValueAsLink:!1},_create:function(){if(this._super(this),this.options.useValueAsLink)Utils.isUndefined(this.element.attr("onChange"))||console.warn("onChange defined for select menu, but it will be ignored since useValueAsLink is set to true"),this.options.change=function(){var a=$(this).val();Utils.existsAndNotEmpty(a)?window.location=a:console.error("the url is not defined")};else if(void 0!==this.element.attr("onChange")){var onChange=this.element.attr("onChange").replace(/javascript:/i,"");this.options.change=function(event,data){eval(onChange)}}var selectedOption=$(this.element).find("[selected='selected']");selectedOption.length&&$(this.element[0]).prop("selectedIndex",selectedOption.index())},open:function(a){this._super(this),this.menuItems&&(this._removeClass(this.menu.find(".ui-state-select"),null,"ui-state-select"),this._addClass(this._getSelectedItem().children(),null,"ui-state-select"),this.menuInstance.focus(null,this._getSelectedItem()))},close:function(a){this._super(this),this._removeClass(this.menu.find(".ui-state-select"),null,"ui-state-select"),this._addClass(this._getSelectedItem().children(),null,"ui-state-select")},_drawButton:function(){this._super(this),this.button.addClass(this.element.attr("class")),this.button.addClass(this.element.attr("baseclass")),this.button.attr("style","")},_drawMenu:function(){var a=this;this._super(this),this.menu.menu({focus:function(b,c){var d=c.item.data("ui-selectmenu-item");d&&a.menuItems.eq(d.index).focus()}}).css("font-size",this.buttonItem.css("font-size"));var b=this.options.wcMenuClass;void 0!==b&&null!==b&&""!==b&&this.menu.addClass(b)},_position:function(){this._super(this),this.reposition(this.menuWrap,this.button)},reposition:function(a,b){this.menuWrap.css("z-index",1e3),this.menu.css("height","auto");var c=a.height(),d=a.position().top-$(window).scrollTop(),e=$(window).height()-d;d>$(window).height()/2&&c>e?d>c?this.menuWrap.css("top",a.position().top-c-b.outerHeight()):(this.menuWrap.css("top",a.position().top-d),this.menu.css("height",d-b.outerHeight())):c>e&&this.menu.css("height",e)},_renderItem:function(a,b){return this._super(a,b),a.children().last().attr("value",b.value),a.children().children().last().attr("style",b.element[0].style.cssText),a.children().last()},refresh_noResizeButton:function(){this._refreshMenu(),$(this.element[0]).prop("selectedIndex")>-1&&this._setText(this.buttonItem,this._getSelectedItem().text())}})}(jQuery),function(){$.widget("wc.ValidationTextbox",$.Widget,{options:{canBeEmpty:!0,trimBeforeValidation:!0,errorClass:"error",submitButtonDisabledClass:"disabled",invalidMessage:null},_create:function(){this._super(this),this.options.regExp&&(this.regExp=new RegExp(this.options.regExp)),this.element.addClass("wcValidationTextbox"),this.options.submitButton&&(this.submitButton=$(this.options.submitButton)),this.element.bind("input propertychange",$.proxy(function(a){this.validationAndErrorHandler()&&this.options.onValidInput&&this.options.onValidInput($(this.element).prop("value"))},this))},toggleSubmitButton:function(a){this.options.submitButton&&this.submitButton.length&&(a?this.submitButton.removeClass(this.options.submitButtonDisabledClass):this.submitButton.addClass(this.options.submitButtonDisabledClass),this.submitButton.is("a")?Utils.toggleHyperlink(this.submitButton,a):this.submitButton.is("input")?this.submitButton.prop("disabled",!a):console.err("don't know how to disable: "+this.submitButton))},validateFormat:function(a){return Utils.isBoolean(this.options.canBeEmpty)&&""===a?this.options.canBeEmpty:!(this.options.regExp&&!this.regExp.test(a))},validationAndErrorHandler:function(){var a=$(this.element),b=this.element.val();this.options.trimBeforeValidation&&(b=$.trim(b));var c=null;return this.validateFormat(b)||(c=this.options.invalidMessage),null==c&&null!=this.options.customValidateFunction&&void 0!=this.options.customValidateFunction&&(c=this.options.customValidateFunction()),null==c?(a.hasClass(this.options.errorClass)&&(a.removeClass(this.options.errorClass),this.tooltip&&(this.tooltip.destroy(),this.tooltip=null),this.toggleSubmitButton(!0)),!0):(this.tooltip&&this.element.data("tooltip-content")&&this.element.data("tooltip-content")!=c?(this.element.data("tooltip-content",c),this.tooltip.tooltip.find(".content").text(c),this.tooltip.show_popup()):this.tooltip?this.tooltip.show_popup():a.hasClass(this.options.errorClass)||(a.addClass(this.options.errorClass),this.element.data("tooltip-content",c),this.tooltip=this.element.wcToolTip().data("custom-wcToolTip"),this.tooltip.show_popup(),this.toggleSubmitButton(!1)),!1)}})}(),function(){$.widget("wc.WCDialog",$.ui.dialog,{options:{show_title:!1,autoOpen:!1,timeout:null,autoClose:!1,close_button_selector:"a.closeButton",close_on_primary_click:!0,relatedSource:null,modal:!0,width:"auto"},_create:function(){this._super(this),this.options.show_title||this.element.siblings("div.ui-dialog-titlebar").hide(),this.element.attr("data-widget-type","wc.WCDialog"),$(window).resize($.proxy(function(){this.reposition()},this)),this._add_event_handlers()},_add_event_handlers:function(){if(this.options.close_button_selector&&(this.close_button=$(this.options.close_button_selector,this.element).on("click.WCDialog",$.proxy(function(){this.close()},this))),this.options.primary_button_selector&&(this.primary_button=$(this.options.primary_button_selector,this.element).on("click.WCDialog",$.proxy(function(){this.options.close_on_primary_click&&this.close()},this))),this.options.secondary_button_selector&&(this.secondary_button=$(this.options.secondary_button_selector,this.element).on("click.WCDialog",$.proxy(function(){this.close()},this))),this.options.timeout||this.options.autoClose){var a=this,b,c=function(){b&&(clearTimeout(b),b=null)},d=function(){b&&c(),b=setTimeout(function(){a.close()},a.options.timeout)};this.option.timeout&&(this.element.on("wcdialogopen",d),this.element.on("wcdialogclose",c),this.element.on("mouseover",function(b){c(),a.element.on("mouseleave",d)})),this.options.autoClose&&a.element.add($(a.options.relatedSource)).on("mouseleave",function(b){$.contains(a.element.get(0),b.toElement)||$.contains($(a.options.relatedSource).get(0),b.toElement)||a.close()})}},reposition:function(){var a=this.element.parent("div.ui-widget-content:first[role='dialog']");0===a.height()&&a.height(this.element.height()),0===a.width()&&a.width(this.element.width());var b=this.option("position");this.option("position",b)},bringToFront:function(a){var b=0;a=$(a||".ui-dialog"),a.each(function(a,c){var d=$(c).css("z-index");$.isNumeric(d)&&(d=parseInt(d),d>b&&(b=d))}),this.element.parent(".ui-dialog").css("z-index",parseInt(b)+1)},update_content:function(a){var b=$(a).detach();
this.element.html(b.html()),this.reposition(),this._add_event_handlers()}})}(),function(a){a.widget("custom.wcToolTip",{options:{accessibilityKey:null},_create:function(){var a=this;this.element.on("mouseenter.wcToolTip",function(){a.show_popup()}),this.element.on("mouseleave.wcToolTip",function(){a.hide_popup()}),null!==this.options.accessibilityKey&&this.element.on("keydown.wcToolTip",function(b){b.keyCode===a.options.accessibilityKey&&a.show_popup()})},show_popup:function(){if(this.tooltip)this.tooltip.show();else{var b=a(this.element).data("tooltip-header"),c=a(this.element).data("tooltip-content");c&&b?this.tooltip=a("<div class='WCTooltip'><div class='container'><div class='connector'></div><div class='header'>"+b+"</div><div class='content' >"+c+"</div></div></div>"):b?this.tooltip=a("<div class='WCTooltip'><div class='container' style='padding:8px;' ><div class='connector'></div>"+b+"</div></div>"):c?this.tooltip=a("<div class='WCTooltip'><div class='container'><div class='connector'></div><div class='content' >"+c+"</div></div></div>"):this.tooltip=a(""),this.element.after(this.tooltip)}this.tooltip.position({my:"center top",at:"center bottom",of:this.element,collision:"none"})},hide_popup:function(){this.tooltip&&this.tooltip.hide()},_destroy:function(){this.tooltip&&(this.tooltip.hide(),this.tooltip.remove()),this.element.off("mouseenter.wcToolTip"),this.element.off("mouseleave.wcToolTip")}})}(jQuery);

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/*global jQuery, $, window, setTimeout, clearTimeout, Utils */

/*
 * Carousel (extends $.Widget)
 * Wraps around a third party plugin - Owl Carousel. Owl Carousel is just a jQuery plugin
 * so it's not written as a jQuery UI Widget, otherwise we would extend the Owl Carousel Widget.
 *
 */
(function () {

    /*
     * New options (in addition to ones inherited from $.Widget):
     *
     * OPTIONAL:
     * prevButton: {string}
     *             jQuery selector for the previous button, can have falsy 
     *             value if there is no previous button.
     * nextButton: {string} 
     *             jQuery selector for the next button, can have falsy value
     *             if there is no previous button.
     * paginationButtons: {string}
     *             jQuery selector for the previous button, can have falsy 
     *             value if there are no pagination buttons.
     * overflowVisible: {boolean} 
     *             true if content that overflows the container should be shown,
     *             false otherwise.
     * REQUIRED:
     * (None)
     */
    $.widget("wc.Carousel", $.Widget, {
        options: {
            prevButton: null,
            nextButton: null,
            paginationButtons: null,
            contentContainer: "div.content",
            overflowVisible: false,
            owlCarouselOptions: {
                autoHeight: false,
                autoWidth: true,
                pagination: false, // We're generating our own pagination control
                slideSpeed: 2000,
                addClassActive: true,
                baseClass: "owl-carousel carouselCMC",
                //touchDrag: false, // Need to disable touch drag if we want this to work
                // with gridster
                //mouseDrag: false,
                afterMove: function (elem) {                    
                    if (this.options.paginationButtons) {                        
                        this.paginationButtons.removeClass("selected")
                        // Highlight the selected element after pagination move
                        .eq(this.owlCarousel.currentItem).attr("class", "selected");
                    }                    
                },
                afterUpdate: function() {
                    // Only hide/show next/prev buttons after update has finished
                    this._togglePrevNextButtons();
                },
                afterInit: function() {
                    defautBehaviourOwlCarousel($(this)[0].$elem[0].parentElement.attributes[0].textContent);
                }
            }
        },

        /**
        * Attach "this" to a function passed to the owlCarousel option
        */
        _proxyFunction: function(optionName) {
            if ($.isFunction(this.options.owlCarouselOptions[optionName])) {
                this.options.owlCarouselOptions[optionName] = $.proxy(this.options.owlCarouselOptions[optionName], this);
            }
        },
        
        _create: function () {
            this._super(this);

            // Stores a handle to the underlying Owl Carousel
            this.content = $(this.options.contentContainer, this.element);
            this._proxyFunction("afterMove");
            this._proxyFunction("afterUpdate");
            
            if (this.options.columnCountByWidth) {
                var columnCountByWidth = this.options.columnCountByWidth;
                if (Utils.isObject(columnCountByWidth)) {
                    var windowWidth = $(window).width(),
                        // Grab all the screen sizes and sort them
                        screenSizes = Object.keys(columnCountByWidth)
                                            .map(function(str) {
                                                return parseInt(str, 10);
                                            });
                    screenSizes.sort(function(a, b) { return a - b });
                    screenSizes = screenSizes.map(function(size) {
                        return [size, columnCountByWidth[size.toString()]];
                    });
                    this.options.owlCarouselOptions.itemsCustom = screenSizes;
                } else {
                    console.error("columnCountByWidth is not an object: " + this.options.columnCountByWidth);
                }
            }
            
            this.owlCarousel = this.content.owlCarousel(this.options.owlCarouselOptions).data('owlCarousel');

            if (this.options.overflowVisible) {
                $(".owl-wrapper-outer", this.element).addClass("overflow-visible");
            }
            
            $(window).resize($.proxy(function() {
                this.owlCarousel.reload();
                this._togglePrevNextButtons();
            }, this));
            
            
            
//            $(window).resize($.proxy(function () {
//                // Reposition the dialog after window resize, otherwise
//                // the dialog will stay in the same position
//                this.reposition();
//            }, this));

            this._add_event_handlers();
            this._togglePrevNextButtons();
        },

        /**
        * Show/hide custom pagination buttons depending on the number of items 
        * being shown
        */
        _togglePrevNextButtons: function() {
            // Require pagination if the total number of items is greater than
            // the number of items being shown
            var requirePagination = (this.owlCarousel && this.owlCarousel.itemsAmount > this.owlCarousel.options.items);
            
            if (requirePagination) {
                if (this.options.nextButton) {
                    this.$nextButton.show();
                }      
                if (this.options.prevButton) {
                    this.$prevButton.show();
                }  
            } else {
                if (this.options.nextButton) {
                    this.$nextButton.hide();
                }      
                if (this.options.prevButton) {
                    this.$prevButton.hide();
                }  
            }
        },
        
        _add_event_handlers: function () {
            var carousel = this.owlCarousel;

            this.element.on("resized.owl.carousel", function() {
                console.log("resized");
            });
            // Pagination Controls
            // Previous button
            if (this.options.prevButton) {
                this.$prevButton = $(this.options.prevButton, this.element);
                this.$prevButton.click(function (e) {
                    carousel.prev();
                    e.preventDefault();
                });           
            }

            // Next button
            if (this.options.nextButton) {
                this.$nextButton = $(this.options.nextButton, this.element);
                this.$nextButton.click(function (e) {
                    carousel.next();
                    e.preventDefault();
                });
            }           

            // Pagination buttons (either dots or numbers)
            // Highlight the first element on startup
            if (this.options.paginationButtons) {
                this.paginationButtons = $(this.options.paginationButtons, this.element);
                this.paginationButtons.first().attr("class", "selected");
                this.paginationButtons.each(function(i, button) {
                    $(button).click(function(e) {
                        carousel.goTo(i);
                        e.preventDefault();
                    });                    
                });
            }            
        },
        
        _destroy: function () {
            this.owlCarousel.destroy();
            
            // remove the event handlers
            //this.element.off("mouseenter.wcToolTip");  
            //this.element.off("mouseleave.wcToolTip");  
        }

    });

}());
/*
 * Common utilities for all brands in the NERD project
 */

/**
 * isMobile https://github.com/kaimallea/isMobile
 * This function detects mobile devices and then it then creates a JavaScript object with the results.
 * version 0.5.1
 */
!function(e){var n=/iPhone/i,t=/iPod/i,r=/iPad/i,a=/\bAndroid(?:.+)Mobile\b/i,p=/Android/i,l=/\bAndroid(?:.+)SD4930UR\b/i,b=/\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i,f=/Windows Phone/i,u=/\bWindows(?:.+)ARM\b/i,c=/BlackBerry/i,s=/BB10/i,v=/Opera Mini/i,h=/\b(CriOS|Chrome)(?:.+)Mobile/i,w=/\Mobile(?:.+)Firefox\b/i;function m(e,i){return e.test(i)}function i(e){var i=e||("undefined"!=typeof navigator?navigator.userAgent:""),o=i.split("[FBAN");void 0!==o[1]&&(i=o[0]),void 0!==(o=i.split("Twitter"))[1]&&(i=o[0]);var d={apple:{phone:m(n,i)&&!m(f,i),ipod:m(t,i),tablet:!m(n,i)&&m(r,i)&&!m(f,i),device:(m(n,i)||m(t,i)||m(r,i))&&!m(f,i)},amazon:{phone:m(l,i),tablet:!m(l,i)&&m(b,i),device:m(l,i)||m(b,i)},android:{phone:!m(f,i)&&m(l,i)||!m(f,i)&&m(a,i),tablet:!m(f,i)&&!m(l,i)&&!m(a,i)&&(m(b,i)||m(p,i)),device:!m(f,i)&&(m(l,i)||m(b,i)||m(a,i)||m(p,i))},windows:{phone:m(f,i),tablet:m(u,i),device:m(f,i)||m(u,i)},other:{blackberry:m(c,i),blackberry10:m(s,i),opera:m(v,i),firefox:m(w,i),chrome:m(h,i),device:m(c,i)||m(s,i)||m(v,i)||m(w,i)||m(h,i)}};return d.any=d.apple.device||d.android.device||d.windows.device||d.other.device,d.phone=d.apple.phone||d.android.phone||d.windows.phone,d.tablet=d.apple.tablet||d.android.tablet||d.windows.tablet,d}"undefined"!=typeof module&&module.exports&&"undefined"==typeof window?module.exports=i:"undefined"!=typeof module&&module.exports&&"undefined"!=typeof window?module.exports=i():"function"==typeof define&&define.amd?define([],e.isMobile=i()):e.isMobile=i()}(this);

/**
 * replaceAll function. Replaces all occurrences of a string (since the js replace function only replaces the first one)
 * @param {String} search String to search for
 * @param {String} replacement Replacement string
 * @returns String with all replacements done
 */
String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};

function plog(str){
    console.log(new Date().toISOString()+"::PSL::"+str);
}
/** custom function  **/
window.setQueryParams = function (url, params) { // case 2
    let pasreUrl = url.split('?')[0];
    let result =  pasreUrl + params;
    return result;
}

window.setAttr = function (id, attributeName, url, params) { // per jsp
    let tag = document.getElementById(id)
    if (tag)  tag.setAttribute(attributeName, window.setQueryParams(url, params))
}

/**
 * HB-1995 Checkout | Payment | AMEX card: add field validation CVV should have 4 digits (3 if cc is not amex)
 */

/**
 * This function check if the credit card passed as parameter is an American Express
 * Following this guide: https://www.cybersource.com/developers/getting_started/test_and_manage/best_practices/card_type_id/
 * Amex rules are: Valid length: 15 digits. First digit must be a 3 and second digit must be a 4 or 7.
 *
 * @param {String} ccNumber Credit card number with or without spaces
 * @param {boolean} strictTest If false this function will only test the first digits condition
 */
function isAmexCreditCard(ccNumber, strictTest){
    var ccNumberParsed;
    if (ccNumber.includes(" ")){
        ccNumberParsed = ccNumber.split(" ");
        ccNumberParsed = ccNumberParsed.join("");
    } else {
        ccNumberParsed = ccNumber;
    }
    if (ccNumberParsed.length<2){
        return false;
    }else{
        var ccHead = ccNumberParsed.substring(0,2);
        //Check if the credit card is American Express
        if (ccHead != "34" && ccHead != "37"){
            return false;
        } else {
            if (strictTest){
                if (ccNumberParsed.length == 15){
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }
    }
}




function addDirectToCart(moco) {
	  //Declare a service for retrieving catalog entry detailed information for an item...
	isAdd2CartClicked=true;
	
	 var parameters = {
           moco : moco 
       };

	 
  wcService.declare({
      id: "GetCatalogEntryByMocoCmd",
      actionId: "GetCatalogEntryByMocoCmd",
      url: "GetCatalogEntryByMocoCmd",
      
      successHandler: function (serviceResponse) {
    	  //productDisplayJS.productAdd2Cart('entitledItem_'+serviceResponse.catentry);
    	  productDisplayJS.Add2ShopCartAjax('entitledItem_'+serviceResponse.catentry,1, false);
          productPageAdd2Cart();
          
          showDropdown=true;
          
          if (showDropdown && isVogue) {
        	  $('#shoppingCart').addClass('open');
              $('#MiniShopCartProductAdded').show();
              update_content = true;
              //We have added item to cart..So display the drop down with item added message..
              positionMiniShopCartDropDown("widget_minishopcart", 'MiniShopCartProductAdded', 'orderItemAdded');
              showDropdown = false;
              populateProductAddedDropdown();
          }
      },
      failureHandler: function (serviceResponse) {
          console.debug("We can't add to cart Item "+moco);
      }
  });
	 
  wcService.invoke("GetCatalogEntryByMocoCmd", parameters);
  
}





function GetCardType(number) {

	var retval="";
	
	var re = new RegExp("^4");
	if (number.match(re) != null)
		retval = "Visa";

	// Mastercard
	// Updated for Mastercard 2017 BINs expansion
    re = new RegExp("^5[1-5]");
    if (number.match(re) != null)
    	retval = "MasterCard";

	// AMEX
	re = new RegExp("^3[47]");
	if (number.match(re) != null)
		retval = "Amex";

	// Discover
	re = new RegExp(
			"^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
	if (number.match(re) != null)
		retval = "Discover";

	// Diners
	re = new RegExp("^36");
	if (number.match(re) != null)
		retval = "Diners";

	// Diners - Carte Blanche
	re = new RegExp("^30[0-5]");
	if (number.match(re) != null)
		retval = "Diners";

	// JCB
	re = new RegExp("^35(2[89]|[3-8][0-9])");
	if (number.match(re) != null)
		retval =  "JCB";

	
	if(retval != '')
		return retval;
	else
		return "CC";

}

/**
 * This function changes the maxlength of the CVV input field, according to the
 * card number input value
 * 
 * @param {String}
 *            ccInputId Id of the credit card input field
 * @param {String}
 *            cvvInputId Id of the cvv input field
 */
function updateCVVInputLength(ccInputId, cvvInputId){
    var ccNumber = document.getElementById(ccInputId).value;
    var maxVal = 3;
    if (isAmexCreditCard(ccNumber, false)){
        maxVal = 4;
    }
    document.getElementById(cvvInputId).setAttribute("maxlength", maxVal);
}

/**
 * This function tests if the cvv length is valid for the credit card number passed as paramenter
 * Currently the logic is:
 *  If the card is Amex and ccv lenght = 4, then return true,
 *  if the card is not Amex and ccv lenght = 3, then return true,
 *  otherwise return false
 *
 * @param {String} ccNumber Credit card number
 * @param {String} cvv CVV number
 */
function matchCreditCardCVV(ccNumber, cvv){
    if (isAmexCreditCard(ccNumber, false)){
        //is American Express
        if (cvv.length==4){
            return true;
        }else{
            return false;
        }
    } else {
        //not American Express
        if (cvv.length==3){
            return true;
        }else{
            return false;
        }
    }
}

/* HB-1995 END ******************************************************************************/

/**
 * This function validates the maxlength of the CVV input field, according to the type of card card gotten from the input value of the card field
 *
 * @param {String} ccInputId Id of the credit card input field
 * @param {String} cvvInputId Id of the cvv input field
 */
function validateCVVInputLength(ccInputId, cvvInputId) {
    var ccNumber = document.getElementById(ccInputId).value;
    var maxVal = 3;
    if (isAmexCreditCard(ccNumber, false)){
        maxVal = 4;
    }
    var ccvInputValue = document.getElementById(cvvInputId).value;
    if (undefined != ccvInputValue && "" !== ccvInputValue) {
    	if (ccvInputValue.length != maxVal) {
    		$("#wrongCVVLength").css("display", "block");
    	} else {
    		$("#wrongCVVLength").css("display", "none");
    	}
    }
}

/**
 * getGoogleAddress(countryCode, zipCode, language, callbackFunction)
 *
 * This function provides a common interface to access the Google Address API.
 * First it makes an async call to Google API sending required parameters and,
 * when the response is received, it parses the data to fit our requirements.
 * Finally launches callbackFunction sending the parsed data object as parameter.
 *
 * Usage: e.g. (Named function)     getGoogleAddress("ES","15001", "es", myFunction);
 *             (Anonymous function) getGoogleAddress("ES","15001", "es", function(data){
 *                                      //Your code here
 *                                      //At this point data is an object with all the address info
 *                                  });
 *
 * Parsed address object:
 *      {
 *          status : <success | error>,
 *          error_description : <error description (only when status = error)>,
 *          address :
 *              {
 *                  city : <city name>,
 *                  country : <country name>,
 *                  country_short : <short country name>,
 *                  locality : <locality name>,
 *                  neighborhood : <neighborhoodId name>,
 *                  prov_state : <province name (state in the US), e.g."Citta Metropolitana di Milano">,
 *                  prov_state_short : <short province name (state in the US) e.g."MI">
 *                  zipcode : <zip code>
 *              },
 *          raw :
 *              {
 *                  <data object received from Google API>
 *              }
 *      }
 *
 * Usage samples:
 *    getGoogleAddress("US","10462", "en", showAddressData);
 *    getGoogleAddress("ES","15001", "es", showAddressData);
 *    getGoogleAddress("IT","20099", "it", showAddressData);
 *    getGoogleAddress("FR","20099", "it", showAddressData);
 *    getGoogleAddress("US","10462", "en", function(result){
 *        if (result.status == "error"){
 *            console.log(result.error_description);
 *        } else {
 *            console.log(result);
 *        }
 *    });
 *
 *
 * @param {String} countryCode e.g."ES"
 * @param {String} zipCode e.g."15001"
 * @param {String} language e.g. "es"
 * @param {function} callbackFunction
 */
function getGoogleAddress(countryCode, zipCode, language, callbackFunction){
    try{
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            componentRestrictions: {
              country: countryCode,
              postalCode: zipCode
            }
          }, function(results, status) {
            
                if(status != "OK"){
                    if(AddressHelper.zipCodeNotFound ||status == "ZERO_RESULTS") {
                        zipCodeError = false;
                    }
                    else {
                        zipCodeError = true
                    }
                }
                else{
                    zipCodeError=false;
                }
                
                findAddressInformation(results);
            
          });
    }catch(e){
        console.log("getGoogleAddress : the promise constructor cannot be invoked directly");
    }
    

      function findAddressInformation (results){
            var city = null;
            var locality = null;
            var neighborhood = null;
            var maxNeighborhoodlenght = 31;
            var province = null;
            var province_short = null;
            var postalCode = null;
            var administrativeArea2 = null;
            var administrativeArea1 = null;
            var administrativeArea3 = null;
            var administrativeArea2_short = null;
            var administrativeArea1_short = null;
            var administrativeArea3_short = null;
            var country = null;
            var country_short = null;
            var responseObj={};
            var addressData={};

            if (results == null || results[0] == null ||  results[0].address_components == null || results[0].address_components.length == 0
                    || (results[0].address_components.length == 1 && results[0].address_components[0].types[0] == "country")) {

                responseObj.status = "error";
                responseObj.error_description = "zipcode_not_found";
                responseObj.raw = results;

            } else {

                if (results != null && results[0] != null) {
                    var addressComponents = results[0].address_components;
                    for (var i = 0; i < addressComponents.length; i++) {

                        if (addressComponents[i].types[0] == "postal_code") {
                            postalCode = addressComponents[i].long_name;
                        }
                        //getting city
                        if (addressComponents[i].types[0] == "postal_town") {
                            city = addressComponents[i].long_name;
                        }
                        if (addressComponents[i].types[0] == "country") {
                            country = addressComponents[i].long_name;
                            country_short = addressComponents[i].short_name;
                        }
                        //getting locality
                        if (addressComponents[i].types[0] == "locality") {
                            locality = addressComponents[i].long_name;
                        }
                        if (addressComponents[i].types[0] == "neighborhood") {
                            neighborhood = (addressComponents[i].long_name).substring(0,maxNeighborhoodlenght);
                        }
                        if (addressComponents[i].types[2] == "sublocality_level_1") {
                            neighborhood = (addressComponents[i].long_name).substring(0,maxNeighborhoodlenght);
                        }
                        //getting administrative Area1 (state)
                        if (addressComponents[i].types[0] == "administrative_area_level_1") {
                            administrativeArea1 = addressComponents[i].long_name;
                            administrativeArea1_short = addressComponents[i].short_name;
                        }
                        //getting administrative Area2
                        if (addressComponents[i].types[0] == "administrative_area_level_2") {
                            administrativeArea2 = addressComponents[i].long_name;
                            administrativeArea2_short = addressComponents[i].short_name;
                        }
                        //getting administrative Area3
                        if (addressComponents[i].types[0] == "administrative_area_level_3") {
                            administrativeArea3 = addressComponents[i].long_name;
                            administrativeArea3_short = addressComponents[i].short_name;
                        }
                    }
                }

                if (city == null) {

                    if (locality == null){
                        if (neighborhood == null){
                            if (administrativeArea3 == null){
                                city = administrativeArea2;
                            } else {
                                city = administrativeArea3;
                            }
                        } else {
                            city = neighborhood;
                        }
                    } else {
                        city = locality;
                    }
                }

                // For america and canada administrativeArea1 represents the province
                // For italy and spain this value is stored on administrativeArea2
                if (country_short === 'ES') {
                    province = administrativeArea2;
                    province_short = zipCode.substring(0,2);
                    //HB-5761: revert HB-5556
                    //province_short = administrativeArea2_short; 
                } else if (country_short === 'IT') {
                    province = administrativeArea2;
                    province_short = administrativeArea2_short;
                } else {
                    province = administrativeArea1;
                    province_short = administrativeArea1_short;
                }

                addressData.city = city;
                addressData.locality = locality;
                addressData.neighborhood = neighborhood;
                addressData.prov_state = province;
                addressData.prov_state_short = province_short;
                addressData.country = country;
                addressData.country_short = country_short;
                addressData.zipcode = postalCode;

                /*
                addressData.administrativeArea1 = administrativeArea1;
                addressData.administrativeArea2 = administrativeArea2;
                addressData.administrativeArea3 = administrativeArea3;
                addressData.administrativeArea1_short = administrativeArea1_short;
                addressData.administrativeArea2_short = administrativeArea2_short;
                addressData.administrativeArea3_short = administrativeArea3_short;
                */
                
                responseObj.status = "success";
                responseObj.address = addressData;
                responseObj.raw = results;

                
            }
            callbackFunction(responseObj);
        
      }


}

function getGoogleAddressPromise(countryCode, zipCode, language){
   return new Promise(function(resolve, reject) {
                var geocoder = new google.maps.Geocoder();
        
                geocoder.geocode({
                    componentRestrictions: {
                    country: countryCode,
                    postalCode: zipCode
                }
                }, function(results, status) {
                        var data= {
                        results:"",
                         status:""
                        }
                    if (status == 'OK') {
                        zipCodeError=false;
                        data.results=results;
                        data.status= status;
                        resolve(data);
                    } else {     	
                        reject(function(data){
                            console.log("UnregisteredCheckout.jsp::","Zip code unknown");
                        });
       
                    }
       
                  });
    });
      
}

function convertGoogleAddressResponse(data){
    var responseObj = {};

    if (data.status != "OK"){
        responseObj.status = "error";
        responseObj.error_description = "google_api_error";
        responseObj.raw = data;
    } else {
        var addressData = {};

        var city = null;
        var locality = null;
        var neighborhood = null;
        var province = null;
        var province_short = null;
        var postalCode = null;
        var administrativeArea2 = null;
        var administrativeArea1 = null;
        var administrativeArea3 = null;
        var administrativeArea2_short = null;
        var administrativeArea1_short = null;
        var administrativeArea3_short = null;
        var country = null;
        var country_short = null;

        if (data == null || data.results[0] == null ||  data.results[0].address_components == null || data.results[0].address_components.length == 0
                || (data.results[0].address_components.length == 1 && data.results[0].address_components[0].types[0] == "country")) {

            responseObj.status = "error";
            responseObj.error_description = "zipcode_not_found";
            responseObj.raw = data;

        } else {

            if (data != null && data.results[0] != null) {
                var addressComponents = data.results[0].address_components;
                for (var i = 0; i < addressComponents.length; i++) {

                    if (addressComponents[i].types[0] == "postal_code") {
                        postalCode = addressComponents[i].long_name;
                    }
                    //getting city
                    if (addressComponents[i].types[0] == "postal_town") {
                        city = addressComponents[i].long_name;
                    }
                    if (addressComponents[i].types[0] == "country") {
                        country = addressComponents[i].long_name;
                        country_short = addressComponents[i].short_name;
                    }
                    //getting locality
                    if (addressComponents[i].types[0] == "locality") {
                        locality = addressComponents[i].long_name;
                    }
                    if (addressComponents[i].types[0] == "neighborhood") {
                        neighborhood = addressComponents[i].long_name;
                    }
                    if (addressComponents[i].types[2] == "sublocality_level_1") {
                        neighborhood = addressComponents[i].long_name;
                    }
                    //getting administrative Area1 (state)
                    if (addressComponents[i].types[0] == "administrative_area_level_1") {
                        administrativeArea1 = addressComponents[i].long_name;
                        administrativeArea1_short = addressComponents[i].short_name;
                    }
                    //getting administrative Area2
                    if (addressComponents[i].types[0] == "administrative_area_level_2") {
                        administrativeArea2 = addressComponents[i].long_name;
                        administrativeArea2_short = addressComponents[i].short_name;
                    }
                    //getting administrative Area3
                    if (addressComponents[i].types[0] == "administrative_area_level_3") {
                        administrativeArea3 = addressComponents[i].long_name;
                        administrativeArea3_short = addressComponents[i].short_name;
                    }
                }
            }

            if (city == null) {
                //city = locality == null ? (neighborhood == null ? (administrativeArea3 == null ? administrativeArea2 : administrativeArea3) : neighborhood) : locality;
                if (locality == null){
                    if (neighborhood == null){
                        if (administrativeArea3 == null){
                            city = administrativeArea2;
                        } else {
                            city = administrativeArea3;
                        }
                    } else {
                        city = neighborhood;
                    }
                } else {
                    city = locality;
                }
            }

            // For america and canada administrativeArea1 represents the province
            // For italy and spain this value is stored on administrativeArea2
            if (country_short === 'ES') {
                province = administrativeArea2;
                //province_short = postalCode.substring(0,2);
                //fix
                province_short = administrativeArea2_short;
            } else if (country_short === 'IT') {
                province = administrativeArea2;
                province_short = administrativeArea2_short;
            } else {
                province = administrativeArea1;
                province_short = administrativeArea1_short;
            }

            addressData.city = city;
            addressData.locality = locality;
            addressData.neighborhood = neighborhood;
            addressData.prov_state = province;
            addressData.prov_state_short = province_short;
            addressData.country = country;
            addressData.country_short = country_short;
            addressData.zipcode = postalCode;

            responseObj.status = "success";
            responseObj.address = addressData;
            responseObj.raw = data;
        }
    }

    return responseObj;
}

function getUserAddressListPromise(){
    var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
    return $.ajax({
        method: "GET",
        url: url,
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        data: {
            "timestamp": Date.now()
        },
        dataType: "json"
    });
}

function updateCurrentOrderShippingDatePromise(){
    var time = "0700";
    if (document.querySelector('input[name="shippingSelectTime"]:checked').value == "noon") {
        time = "1200";
    } else if (document.querySelector('input[name="shippingSelectTime"]:checked').value == "night") {
        time = "1800";
    }

    var date = $("#datepicker-holder").datepicker('getDate');
    var formattedDate = $.datepicker.formatDate("yymmdd", date);

    $.ajax({
        type: "POST",
        url: "AjaxShippingDateUpdate?requestType=update&shippingDate=" + formattedDate + time + "&ordersId=.&storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId,
        headers: {
            "Cache-Control": "no-cache, no-store, must-revalidate"
        }
    });
}



/**
 * This function transform a jQuery ajax error response to a string error message
 * Usage:
 *   $.ajax({
 *       ...
 *       success: function (data) {
 *           ...
 *       },
 *       error: function(jqXHR, exception){
 *           console.log(METHODNAME + "::Ajax error: " + getAjaxErrorMessage(jqXHR, exception));
 *       },
 *       complete: function(){
 *           ...
 *       }
 *   });
 *
 * @param {Object} jqXHR
 * @param {String} exception
 * @returns {String} Error message
 */
function getAjaxErrorMessage(jqXHR, exception){
    var msg = "";
    if (jqXHR.status === 0) {
        msg = "Not connected.\n Verify Network.";
    } else if (jqXHR.status == 404) {
        msg = "Requested page not found. [404]";
    } else if (jqXHR.status == 500) {
        msg = "Internal Server Error [500].";
    } else if (exception === "parsererror") {
        msg = "Requested JSON parse failed.";
    } else if (exception === "timeout") {
        msg = "Time out error.";
    } else if (exception === "abort") {
        msg = "Ajax request aborted.";
    } else {
        msg = "Uncaught Error.\n" + jqXHR.responseText;
    }

    return msg;
}
/**
 * @desc Compare arrays
 * @param {Array} array
 * @see https://stackoverflow.com/questions/7837456/how-to-compare-arrays-in-javascript?page=1&tab=votes#tab-top
 * @return True or False
 */

// Warn if overriding existing method
if (Array.prototype.equals)
    console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code.");

// Attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function(array) {
    // If the other array is a falsy value, return
    if (!array) return false;

    // Compare lengths - can save a lot of time
    if (this.length != array.length) return false;

    for (var i = 0, l=this.length; i < l; i++) {
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // Recurse into the nested arrays
            if (!this[i].equals(array[i])) return false;
        } else if (this[i] != array[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
    }
    return true;
}

// Hide method from for-in loops
Object.defineProperty(Array.prototype, "equals", {enumerable: false});

/**
 * Add NodeList.forEach and Element.remove support to IE9+
 */
(function() {
    if (typeof NodeList.prototype.forEach !== "function"){
        NodeList.prototype.forEach = Array.prototype.forEach;
    }
    if (typeof Element.prototype.remove !== "function"){
        Element.prototype.remove = function(){
            this.parentElement.removeChild(this);
        }
    }
})();

/**
 * This function creates a cookie named 'WC_X_LoggedUser=No' when the user is G (guest).
 * If the storeUserType changes to registered, the cookie is deleted by the function.
 * This function helps Akamai to determinate if the jsp should be cached or not.
 * NERD-761
 * 23-11-23
 * hb-14987 --> in this function is been added sessionStorage["logged"] = 'false'; 
 * 				to indicated the user is not logged
 * 			    
 */

loggedUserCookieManager();

function loggedUserCookieManager(){
    //If the user is G=Guest, creates the cookie
    if (storeUserType === "G"){
        document.cookie="WC_X_LoggedUser=No;;path=/";

    }
    //Otherwise, the cookie is deleted
    else{
        var today = new Date();
        today.setTime(today.getTime() - 1000);
        var expires = "expires="+today.toUTCString();
        document.cookie="WC_X_LoggedUser=;" + expires + ";path=/";
    }
}




function getTaxesFromZipCodePromise(srcForm){
    if (!AddressHelper.hasTaxes){
        return "";
    }else{
        var isCheckOut = (document.querySelectorAll("#page.checkout").length != 0 ||$("#page.checkout-page").length != 0)

        var city = srcForm.city.value;
        var state = srcForm.state.value;
        var zipcode = srcForm.zipCode.value;

        // submit AjaxOrderCalculate request
        var params = [];

        params.storeId      = WCParamJS.storeId;
        params.catalogId    = WCParamJS.catalogId;
        params.langId       = WCParamJS.langId;

        params.updatePrices = "0";
        if(isCheckOut){
            params.orderId = ".";
        } else {
            params.orderId = $('#wcs_calTax_notification #orderId').val();
        }

        params.addressFlag = true;
        params.isDeliveryAddressAdded = false;
        params.zipCode = zipcode != null ? zipcode : "";
        params.city = city != null ? city : "";
        params.state = state != null ? state : "";
        params.country = "us";
        params.isZipChange = true;//isZipChange;

        var url = getAbsoluteURL() + "AjaxOrderCalculate?";
        for (var param  in params) {
            url += param + "=" + params[param] + "&";
        }
        url += "calculationUsageId=-1&";
        url += "calculationUsageId=-2&";
        url += "calculationUsageId=-3&";
        url += "calculationUsageId=-4";

        //Make the call to AjaxOrderCalculate
        return $.ajax({
            url: url,
            type: 'POST',
        });
    }
}

function goToOrderShippingBillingViewOnClickHandler(event){
    form1 = document.forms['shippingAddressCreateEditFormDiv_1'];
    form2 = document.forms['billingAddressCreateEditFormDiv_1'];
    /*if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
    	form3 = document.forms['recipient_detail']; //form for PickUpInStore
    }*/ 
    let isFormNoError = true; //true if form is without error in checkout 
    var sameaddressCheckbox = document.getElementById("SameShippingAndBillingAddress");
    if(AddressHelper.zipCodeNotFound){
    	var stateDiv = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1');
    	var stateHiddenDiv = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1_hidden');
    	if(stateDiv != null && stateDiv.value != "") {
    		stateHiddenDiv.value = stateDiv.value;
    	} 
    }
    
    console.log("PSL::UnregisteredCheckout.jsp::addressId_formS_"+storeDirectory+"::"+addressId_formS);
    console.log("PSL::UnregisteredCheckout.jsp::addressId_formB_"+storeDirectory+"::"+addressId_formB);
    
    AddressBookFormJS.checkAddressCopyAndCopyIfNeeded('shippingAddressCreateEditFormDiv_1','billingAddressCreateEditFormDiv_1',countryCode);
    
    //START CODE BOSS
    //if((!($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup') && isOliver) || isPersol){
    form2.email1.value=form1.email1.value;
    if(isFormNoError){
        isFormNoError = AddressHelper.validateEmail('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_email1_1"/>');
    }else {
        AddressHelper.validateEmail('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_email1_1"/>')
    }
    /*}else{
    	form2.email1.value=form3.email1.value;
      	AddressHelper.validateEmail('recipient_detail__email1"/>');
    } */  
    //END CODE BOSS
    var formValidationError = false;
    
    
    if(AddressHelper.zipCodeNotFound){
    	  AddressHelper.joinNewsletter('shippingAddressCreateEditFormDiv_1', WCParamJS.langId, WCParamJS.storeId);

          //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
          //calling the rest service. If success then address exist else address does not exist.
          var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
          $.ajax({
              method: "GET",
              url: url,
              headers: {
                  "Content-Type": "application/json",
                  "Cache-Control": "no-cache, no-store, must-revalidate"
              },
              dataType: "json",
              success:function(data, textStatus, jqXHR){
                  if (typeof data.contact === 'undefined'){
                      plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
                      AddressHelper.saveUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv1');
                  } else {
                      for (var i = 0; i<data.contact.length; i++){
                          if (data.contact[i].nickName == 'MyAddress_Shipping'){
                              plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
                              AddressHelper.updateUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, sameaddressCheckbox.checked, orderShippingBillingViewURL);
                              break;
                          }
                      }
                  }
              },
              error:function(jqXHR, exception){
                  plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
              }
          });
    }
    else {
        /*if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
        	if(AddressHelper.validateAddressForm(form3)) {
        		/*
        		 * //REPLACE BOSS: 
        		 * 70128 with zipcode of pickupstore
        		 * we will take this zipcode by the tab services
        		 
        		getGoogleAddressPromise(countryCode, '70128', storeLanguage) 
		        .then(function(data){
		        	var addressObj = convertGoogleAddressResponse(data);
		            if (addressObj.status != "success"){
		                formValidationError = true;
		                throw "zipCode " + '70128' + " not valid for country "+countryCode;
		            } else {
		            	/*
		            	 * REPLACE BOSS: 
		            	 * var city will be the city of store
		            	 * we will take this city by the tab services
		            	
		            	var city = document.getElementById("WC__ShoppingCartAddressEntryForm_billingAddressCreateEditFormDiv_1_city_1").value;
		            	var addObjCity= addressObj["address"]["city"];
		            	if(city != addObjCity){
		            		addressObj["address"]["city"]= city;
		            		addressObj["address"]["locality"] = city;
		            	}
		                AddressHelper.fillFormAddressFromAddressDataObject(form3, addressObj);
		            }
		        })
		        .then(function(data){
		            return getTaxesFromZipCodePromise(form3);
		        }).then(function(data){
		        	//Billing Address
		            return getGoogleAddressPromise(countryCode, form2.zipCode.value, storeLanguage)
		        }).then(function(data){
		        	var addressObj = convertGoogleAddressResponse(data);
		            if (addressObj.status != "success"){
		            	formValidationError = true;
		                throw "zipCode " + form2.zipCode.value + " not valid for country " + countryCode;
		            } else {
		            	AddressHelper.fillFormAddressFromAddressDataObject(form2, addressObj);
		            }
		            return getUserAddressListPromise();
		        }).then(function(data){
			    	if (typeof data.contact !== 'undefined'){
			        	for (var i = 0; i<data.contact.length; i++){
			            	if (data.contact[i].nickName == 'MyAddress_Shipping' || data.contact[i].nickName == 'MyAddress_Billing'){
			                	AddressHelper.updateAddressCookies(data.contact[i].addressId, data.contact[i].addressType);
			                    plog("CommonUtilities.js::goToOrderShippingBillingViewOnClickHandler::"+ data.contact[i].nickName +" found: shippingAddressId: " + data.contact[i].addressId +", shippingAddressType: " + data.contact[i].addressType);
			                }
			            }
			        }
			    }, function(err){
			    	 console.log(err);
			    }).then(function(){
		            if (!AddressHelper.validateAddressForm(form3)){
		                formValidationError = true;
		            }
		            if (!AddressHelper.validateAddressForm(form2)){
		            	formValidationError = true;
		           	}
		            if (formValidationError){
		                restoreAjaxButtons();
		                console.log("UnregisteredCheckout.jsp::Form validation error");
		                return;
		            }
		            
		            AddressHelper.joinNewsletter('recipient_detail', WCParamJS.langId, WCParamJS.storeId);
		            
		            //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
		            //calling the rest service. If success then address exist else address does not exist.
		            
		            var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
		            $.ajax({
		                method: "GET",
		                url: url,
		                headers: {
		                    "Content-Type": "application/json",
		                    "Cache-Control": "no-cache, no-store, must-revalidate"
		                },
		                dataType: "json",
		                success:function(data, textStatus, jqXHR){
		                    if (typeof data.contact === 'undefined'){
		                        plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
		                        AddressHelper.saveUnregisteredCheckoutAddress('recipient_detail', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv2');
		                    } else {
		                        for (var i = 0; i<data.contact.length; i++){
		                            if (data.contact[i].nickName == 'MyAddress_Shipping'){
		                                plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
		                                AddressHelper.updateUnregisteredCheckoutAddress('recipient_detail', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, false, orderShippingBillingViewURL);
		                                break;
		                            }
		                        }
		                    }
		                },
		                error:function(jqXHR, exception){
		                    plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
		                }
		            });
		
		            moveToError();
		
		        }); 
        	}
        }else{*/
	    	if(AddressHelper.validateAddressForm(form1)) {
                if(isFormNoError)
                    isFormNoError  = true;
		    getGoogleAddressPromise(countryCode, form1.zipCode.value, storeLanguage)
		        .then(function(data){
		            var addressObj = convertGoogleAddressResponse(data);
		            if (addressObj.status != "success"){
		                formValidationError = true;
		                throw "zipCode " + form1.zipCode.value + " not valid for country "+countryCode;
		            } else {
		            	var city = document.getElementById("WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1").value;
		            	var addObjCity= addressObj["address"]["city"];
		            	if(city != addObjCity){
		            		addressObj["address"]["city"]= city;
		            		addressObj["address"]["locality"] = city;
		            	}
		                AddressHelper.fillFormAddressFromAddressDataObject(form1, addressObj);
		            }
		        })
		        .then(function(data){
		            return getTaxesFromZipCodePromise(form1);
		        })
		        .then(function(data){
		            if (!sameaddressCheckbox.checked){
		                return getGoogleAddressPromise(countryCode, form2.zipCode.value, storeLanguage)
		            }
		        })
		        .then(function(data){
		            if (!sameaddressCheckbox.checked){
		                var addressObj = convertGoogleAddressResponse(data);
		                if (addressObj.status != "success"){
		                    formValidationError = true;
		                    throw "zipCode " + form2.zipCode.value + " not valid for country " + countryCode;
		                } else {
		                    AddressHelper.fillFormAddressFromAddressDataObject(form2, addressObj);
		                }
		            }
		
		            return getUserAddressListPromise();
		        })
		        .then(
		            function(data){
		                if (typeof data.contact !== 'undefined'){
		                    for (var i = 0; i<data.contact.length; i++){
		                        if (data.contact[i].nickName == 'MyAddress_Shipping' || data.contact[i].nickName == 'MyAddress_Billing'){
		                            AddressHelper.updateAddressCookies(data.contact[i].addressId, data.contact[i].addressType);
		                            plog("CommonUtilities.js::goToOrderShippingBillingViewOnClickHandler::"+ data.contact[i].nickName +" found: shippingAddressId: " + data.contact[i].addressId +", shippingAddressType: " + data.contact[i].addressType);
		                        }
		                    }
		                }
		            }, function(err){
		                console.log(err);
		            })
		        .then(function(){
		            if (!AddressHelper.validateAddressForm(form1)){
		                formValidationError = true;
		            }
		            if (!sameaddressCheckbox.checked){
		                if (!AddressHelper.validateAddressForm(form2)){
		                    formValidationError = true;
		                }
		            }
		            if (formValidationError){
		                restoreAjaxButtons();
		                console.log("UnregisteredCheckout.jsp::Form validation error");
		                return;
		            }
		
		            AddressHelper.joinNewsletter('shippingAddressCreateEditFormDiv_1', WCParamJS.langId, WCParamJS.storeId);
		
		            //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
		            //calling the rest service. If success then address exist else address does not exist.
		            var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
		            $.ajax({
		                method: "GET",
		                url: url,
		                headers: {
		                    "Content-Type": "application/json",
		                    "Cache-Control": "no-cache, no-store, must-revalidate"
		                },
		                dataType: "json",
		                success:function(data, textStatus, jqXHR){
		                    if (typeof data.contact === 'undefined'){
		                        plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
		                        AddressHelper.saveUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv1');
		                    } else {
		                        for (var i = 0; i<data.contact.length; i++){
		                            if (data.contact[i].nickName == 'MyAddress_Shipping'){
		                                plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
		                                AddressHelper.updateUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, sameaddressCheckbox.checked, orderShippingBillingViewURL);
		                                break;
		                            }
		                        }
		                    }
		                },
		                error:function(jqXHR, exception){
		                    plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
		                }
		            });
		
		            moveToError();
		
		        })
	    	}else{
                isFormNoError = false;
            }
       // }
    }
    
    //BEGIN SMS NOTIFICATION 
    AddressHelper.joinSMS();
    //END SMS
    
    if(!isFormNoError){ 
        //ERROR IN SHIPPING FORM 
        newTealiumPushFormError('Shipping address','Please provide a valid city,zip code, etc'); 
    }  
}


// NERD-760 Functions that help Akamai to determinate if it is necesary to activate the cache depending if the user is logged and / or if there are items on cart

/**
 * This function calls updateItemsInCartBadge() passing it the number of items that have been added to the cart by the user.
 * NERD-762
 */
function getNumberOfItemsInCart(){
    if(personInfo.userId !== '-1002' || (isVogue && document.querySelectorAll('.pdp').length > 0)){
        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self/shipping_info";
        getAjaxCallInfo(url, null, numberOfItemsInCartCallback);

        function numberOfItemsInCartCallback(response) {
            if(response.recordSetTotal !== '0') {
                var url = "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self";
                getAjaxCallInfo(url, null, orderitemsInfoInCartCallback);
            } else {
                updateItemsInCartBadge(response.recordSetTotal);
            }
        }
        function orderitemsInfoInCartCallback(response) {
        	var total= 0;
        	if(response != undefined && response.recordSetTotal != 0) {
        		total = response.recordSetTotal;
        		response.orderItem.forEach(function(item) {
        			if(item.partNumber.includes('Service') || item.partNumber.endsWith("SV") || item.partNumber.endsWith("PG") ) { //non contare engraving, lenti e servizi 
        				total-=1;
                    }
        		});
        		
        	}
        	updateItemsInCartBadge(total);
            /**if(response.orderItem) {
                for(var i = 0; i < response.orderItem.length; i++) {
                    if((response.orderItem[i].xitem_field2 && (response.orderItem[i].xitem_field2).indexOf("|") !== -1)
                     || (response.orderItem[i].partNumber && (response.orderItem[i].partNumber).indexOf("K-") !== -1)) {
                        total--;
                    }
                }
                updateItemsInCartBadge(total);
            }*/
        }
    }
}

/**
 * This function updates the number rendered into the shoping bag badge according to the number of items included in the cart.
 * As well, if the amount is equal to 0, adds the class 'empty' to the element.
 * @param {*} itemsInCartBadge Amount of items added to the cart by the user.
 * NERD-762
 */

var itemsInCartBadge = "0";
function updateItemsInCartBadge(paramItemsInCart){

    var itemsInCartBadgeElement;
    if (document.getElementById("minishopcart_total") !== null) {
        itemsInCartBadgeElement = document.getElementById("minishopcart_total");
    } else {
        itemsInCartBadgeElement = "0";
    }
    itemsInCartBadge = paramItemsInCart;
    itemsInCartBadgeElement.innerHTML  = itemsInCartBadge;

    if (itemsInCartBadgeElement.innerHTML === "0"){
        itemsInCartBadgeElement.classList.add("empty");
    }

    if(isPersol && paramItemsInCart > 0){
    	var minicartHtml = $('#minishopcart_total');
    	if(minicartHtml.length == 0){
    	minicartHtml = $('<div/>',{id: 'minishopcart_total', class: 'minishopcart-quantity-number'});
    	}
    	minicartHtml.text(paramItemsInCart);
    	$('#widget_minishopcart').prepend(minicartHtml);
    }
    
    if(isVogue) {
        var shopElem =  document.getElementById('shoppingCart');
        var isPDP = document.querySelectorAll('.pdp').length > 0;
        if(isPDP) {
            if(!isAdd2CartClicked && personInfo.userId === '-1002') {
                shopElem.classList.remove('fill');
            } else if(isAdd2CartClicked) {
                shopElem.classList.remove('fill','added');
                shopElem.classList.add('added');
                isAdd2CartClicked = false;
            } else if(!isAdd2CartClicked && personInfo.userId !== '-1002' && paramItemsInCart !== '0' && paramItemsInCart !== '') {
                shopElem.classList.add('fill');
            }
        } else {
            if(itemsInCartBadgeElement.innerHTML !== "0") {
                shopElem.classList.add('fill');
            } else {
                shopElem.classList.remove('fill');
            }
        }
    }
}

/**
 * Function that make a GET ajax call and execute a callback if success
 * @param {string} url - the url to make the ajax call
 * @param {object} params - ajax call params if its needed
 * @param {function} callback - function that it will be executed if ajax call is success
 */
function getAjaxCallInfo(url, params, callback) {
    var parameters = {};
    if(params) {
        parameters = params;
    }
    parameters["timestamp"] = Date.now();
    $.ajax({
        url: url,
        type: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        dataType: "json",
        data: parameters,
        success: function (response, textStatus, request) {
            callback(response);
        },
        error: function(response){
            console.log(response);
            if(typeof pageType != "undefined")
				callback(response);
        }
    });
}

// BEGIN NERD-795 PSD2 | Front-end | Adaptation
// Those functions are called from servicesDeclaration.js AjaxSubmitOrder service
    /**
     * This function creates a dark overlay with a loader spinner that fits the whole page and adds a 'noScroll' class to the body.
     * The scope is to improve the UX while the PSD2 payment is in process.
     */
    function createPaymentLoaderOverlay(){
        $("body").append("<div class='paymentLoaderOverlay'></div>");
        $('body').addClass('noScroll');
    }
/**
 * This function deletes a dark overlay with a loader spiner that fits the whole page and removes a 'noScroll' class from the body.
 */
    function deletePaymentLoaderOverlay(){
        $(".paymentLoaderOverlay").remove();
        $('body').removeClass('noScroll');
    }
/**
 * This function deletes a dark overlay with a loader spiner when any error message is closed by clicking on its closing buton
 */
    $(function(){
        $('#clickableErrorMessageImg').click(deletePaymentLoaderOverlay);

    });

// END NERD-795 PSD2 | Front-end | Adaptation
// BEGIN HB-3160: recover parameter from URL generic function.
/**
 * Recover a parameter from URL, returning the default value if does not exist.
 *
 * @param parameter Parameter name
 * @param defaultValue Parameter default value when it does not exist in URL
 * @return Parameter value
 */
function getUrlParam(parameter, defaultvalue){
    var urlparameter = defaultvalue;
    if(window.location.href.indexOf(parameter) > -1){
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        urlparameter = vars[parameter];
        if (urlparameter === undefined || urlparameter === null) {
            urlparameter = defaultvalue;
        }
    }
    return urlparameter;
}
// END HB-3160

/**
 * HB-3032 | All | Analytics | Do not push to Tealium certain payment response codes
 * This variable is used in Stores/WebContent/<Brand>SAS/javascript/ServicesDeclaration.js, in failureHandler of AjaxRESTOrderSubmit service
 *
 * Those response values are not application errors so they should not be shown in Analytics
 * 202 - Expired card
 * 203 - Card refused
 * 204 - Insufficient funds
 * 205 - Stolen card
 * 208 - Inactive card
 * 209 - CVN doesn't match
 * 210 - Reached the credit limit
 * 211 - Invalid CVN
 * 230 - Soft decline
 * 231 - Invalid account number
 * 233 - General decline
 * 481 - Decision manager decline (now managed by Forter)
 */

var paymentResponseCodesNotWCSError = [
    "PLUGIN_RC_202",
    "PLUGIN_RC_203",
    "PLUGIN_RC_204",
    "PLUGIN_RC_205",
    "PLUGIN_RC_208",
    "PLUGIN_RC_209",
    "PLUGIN_RC_210",
    "PLUGIN_RC_211",
    "PLUGIN_RC_230",
    "PLUGIN_RC_231",
    "PLUGIN_RC_233",
    "PLUGIN_RC_481"
];

var paymentErrorMessageMeaning = {};

paymentErrorMessageMeaning["PLUGIN_RC_202"] = "Expired card";
paymentErrorMessageMeaning["PLUGIN_RC_203"] = "Card refused";
paymentErrorMessageMeaning["PLUGIN_RC_204"] = "Insufficient funds";
paymentErrorMessageMeaning["PLUGIN_RC_205"] = "Stolen card";
paymentErrorMessageMeaning["PLUGIN_RC_208"] = "Inactive card";
paymentErrorMessageMeaning["PLUGIN_RC_209"] = "CVN doesn't match";
paymentErrorMessageMeaning["PLUGIN_RC_210"] = "Reached the credit limit";
paymentErrorMessageMeaning["PLUGIN_RC_211"] = "Invalid CVN";
paymentErrorMessageMeaning["PLUGIN_RC_230"] = "Soft decline";
paymentErrorMessageMeaning["PLUGIN_RC_231"] = "Invalid account number";
paymentErrorMessageMeaning["PLUGIN_RC_233"] = "General decline";
paymentErrorMessageMeaning["PLUGIN_RC_481"] = "Decision manager decline";

function sendPaymentErrorMessageToTealium(errorMessageKey, errorMessage){
    if (paymentResponseCodesNotWCSError.includes(errorMessageKey)){
        pushErrorToTealium('Client', "Cybersource Error " + errorMessageKey + " (" + paymentErrorMessageMeaning[errorMessageKey] + ")", 'Error in CyberSource occurred on payment of order',CheckoutHelperJS.getOrderId());
    } else {
        //pushErrorToTealium('Server', errorMessage, 'Error occurred on payment of order <' + CheckoutHelperJS.getOrderId() + '>');
    	//HB-3186
    	pushErrorToTealium('Server', errorMessage, 'Error occurred on payment of order',CheckoutHelperJS.getOrderId());
    }
}

// HB-3032 END

function getAjaxPromise(url) {
    var parameters = {};
    parameters["timestamp"] = Date.now();

    return $.ajax({
        url: url,
        type: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        dataType: "json",
        data: parameters
    });
}

function removeErrorMessagesFromElement(element){
    $(element).find(".error-messages-section").remove();
    $('#WC_PromotionCodeDisplay_div_2').removeClass('error');
}

function addErrorMessageToElement(element, message){
    var el = $(element);
    var noErrorSection = false;

    if ($(el).find(".error-messages-section").length==0){
        if(el.attr('id')== 'PromotionCodeForm' && (isOliver ||isPersol) ){ //only checkout 3.0
            $('#WC_PromotionCodeDisplay_div_2').addClass('error');
            $('#PromotionCodeForm #PromotionCodeForm_upper .input-style').after("<div class='error-messages-section'></div>");
        }else{
        $(el).append("<div class='error-messages-section'></div>");
        }
        noErrorSection = true;
    }

    el = $(element).find(".error-messages-section");

    if (noErrorSection || $(el).find(".error-message.error-message-md5-"+md5(message).toString()).length==0){
    	if((isVogue || isPersol) && document.cookie.includes('X_WC_PR_SEGMENTS')){
    		$('#PromotionCodeForm .error-message').remove();
    		$('#PromotionCodeForm input#promoCode.error , #PromotionCodeForm input#coupon-value.error').removeClass('ea_input');
    	}
    	var finalMessage = "<div class='error-message error-message-md5-"+ md5(message).toString() +"'>" + message + "</div>";
        $(el).append(finalMessage);
    }
}

/* detect mobile*/ 
window.mobilecheck = function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

window.tabletPortraitCheck = function(){
    var tabletPortrait = false;
    var mq =  window.matchMedia( "screen and (min-width:1024");
    var portrait =  window.matchMedia("(orientation: portrait)");
    if(!mq.matches  && portrait.matches){
        tabletPortrait = true; 
    }
    return tabletPortrait;
}

/* function to manage header z-index in pdp mobile  */
function checkMobilePdpPage(){
    if((window.mobilecheck() || window.tabletPortraitCheck()) && $('#page').hasClass('pdp')){
        return true
    }
}

//its also used in WCAG.js too
function productPageAdd2Cart(wishlistProductId) {

    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;

	if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
			showCTAloaderClip();
		}else{
			showCTAloader("productPageAdd2Cart");
		}
	} else if (isPersol || isOliver){
        if (!isWishlistPage){
            showCTAloader("productPageAdd2Cart");
        } else {
            showWishlistCTAloader(wishlistProductId);
        }
    }

    var waitForEl = function(selector, callback) {
        if ($(selector).length) {
            callback();
        } else {
            setTimeout(function() {
                waitForEl(selector, callback);
            }, 1000);
        }
    };

    var selector = '[aria-describedby="MiniShopCartProductAdded"]';

    waitForEl(selector, function() {

    	if(isPersol && !productDisplayJS.priceSwitched){
    		if($('#current-clipon-catentry').length > 0 && $('#current-clipon-catentry').attr('isAdded') == 'true'){
	    			var clip_on_selected = $('.product-clip-on.selected').attr('catentryClip');
	    			var clip_on_sku_selected = $('#current-clipon-catentry').val();
	    			var offer_price = arrayOfClip[clip_on_selected].skus[clip_on_sku_selected].price;
	                var list_price = arrayOfClip[clip_on_selected].skus[clip_on_sku_selected].listprice;
	                productDisplayJS.lastPriceSaved = document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText;
	                document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
	                productDisplayJS.lastOfferPriceSaved = document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText;
    		} else {
	            var offer_price = !isWishlistPage ? document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText : document.getElementById('offerPrice_'+wishlistProductId).innerText;
	            //document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastPriceSaved;
	            productDisplayJS.lastPriceSaved = offer_price;
	            var list_price = !isWishlistPage ? document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText : document.getElementById('listPrice_'+wishlistProductId).innerText;
	            if (!isWishlistPage) {
	                document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
	            } else {
	                document.getElementById('listPrice_'+wishlistProductId).innerText = productDisplayJS.lastOfferPriceSaved;
	            }
	            productDisplayJS.lastOfferPriceSaved = list_price;
    		}
            
            
           
            /*
             // Show complete pair offer price if frame has a promotion
             // Now handled by LensConfigurator

                if (completePairTotalPrice != undefined && completePairTotalPrice[frameId] != undefined && completePairTotalPrice[frameId][selectedLendCatentryId] != undefined) {
                    var frameId = $("#roxLenses").val();
                    var selectedLensID = $("#presc--lens--id").val();
                    var hasPromotion = completePairTotalPrice[frameId][selectedLensID]['hasPromotion'] != undefined ? completePairTotalPrice[frameId][selectedLensID]['hasPromotion'] : false;
                    if (hasPromotion) {
                        var completePairOfferPrice = completePairTotalPrice[frameId][selectedLensID]['offerPrice'];
                        var completePairListPrice = completePairTotalPrice[frameId][selectedLensID]['listPrice']; 
                        $('.priceCart')[0].innerText = WCCurrencyJS.format(completePairOfferPrice);
                        $('#minicartPST.price__list')[0].innerText = WCCurrencyJS.format(completePairListPrice);
                        document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
                    }
                }
            */
	    	if(affirmEnabled && !isWishlistPage) {
	    		customizeAffirmPrice();
	    	}
	    	productDisplayJS.priceSwitched = true;
            
    	}
    	else if(isOliver && !productDisplayJS.priceSwitched) {
    		var elements = !isWishlistPage ? document.querySelectorAll('[id=offerPrice_'+productParent+']') : document.querySelectorAll('[id=offerPrice_'+wishlistProductId+']');
    		var div;
    		for(var i = 0; i<elements.length;i++) {
    			if(elements[i].nodeName == "DIV") {
    				div = elements[i];
    			}
    		}
    		if(div != undefined) {
    			var temp = div.getElementsByClassName('price__unity')[0].innerText;
    			productDisplayJS.lastPriceSaved = temp;
        		div.getElementsByClassName('price__unity')[0].innerText = productDisplayJS.lastPriceSaved;
        	}
    		
    		var temp = !isWishlistPage ? document.getElementById('listPrice_'+productParent).innerText : document.getElementById('listPrice_'+wishlistProductId).innerText;
    		if (!isWishlistPage){
                document.getElementById('listPrice_'+productParent).innerText=productDisplayJS.lastOfferPriceSaved;
            } else {
                document.getElementById('listPrice_'+wishlistProductId).innerText=productDisplayJS.lastOfferPriceSaved;
            }
            
    		productDisplayJS.lastOfferPriceSaved = temp;
    		if(affirmEnabled && !isWishlistPage) {
	    		customizeAffirmPrice();
	    	}
    		productDisplayJS.priceSwitched = true;
    	}
        //reset size
        $('.options_dropdown_column input').each(function( index,input ) {
            if(isOliver){
                var stringCmp = "normal"
            }else{
                var stringCmp = "standard"
            }         
            if(input.value.toLowerCase().includes(stringCmp)){
                $('.options_dropdown_column .size-option-selected span').html(input.value);
            }
        //reset z-index bottom-scrollable-section
        $('.bottom-scrollable-section').css('z-index', "3"); 
            
        });
    	// work the magic
        var defaultPaymentPlacement = $("#defaultPaymentPlacement").val();
        showDefaultPaymentPlacement(defaultPaymentPlacement);
        $('[aria-describedby="MiniShopCartProductAdded"]').addClass("opend");
        // $('#page-overflow-wrapper').addClass('overflow-hidden');
        if($('#page').hasClass('pdp') && brandCode=="OP"){
            $('body').addClass('no-scroll');
        }

        if($('#page').hasClass('pdp') && brandCode=="PO"){
            $('#header').css('z-index', '1000') 
        }

        $(".minishopcartadded--fade").show(); 
        if($('#page').hasClass('pdp') && brandCode=="OP"){
            if(!$('#header').is(":visible")) $('#header').slideDown()
            hideHeaderTimeout.cancel();
        }
        if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
    		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
    			setTimeout(function() {
    				hideCTAloaderClip();
                }, 1000)
    		}else{
    			setTimeout(function() {
                    hideCTALoader("productPageAdd2Cart");
                }, 1000)
    		}
    	} else if (isPersol || isOliver){
            if (!isWishlistPage){
                setTimeout(function() {
                    hideCTALoader("productPageAdd2Cart");
                }, 1000)
            } else {
                setTimeout(function() {
                    hideWishlistCTALoader(wishlistProductId);
                }, 1000)
            }
        }

        if (minicartYMALCallback != undefined) {
            minicartYMALCallback.onWidgetLoaded();
        }

        //HB-7718 
        //check if the add to cart is related to upsell
        var isUpsell = false;
        if($('#upsell-added-inicart').length > 0){
            isUpsell = true;
        }

        //START Early Access
        if (isPersol){
        	var offer_price;
        	var list_price;
        	
            //Wishlist
            if (isWishlistPage) window.lastOfferPrice = returnLastOfferPrice();
            //Wishlist

            //if a upsell products is been added in cart we must use the offerprice and listprice of the upsell product
        	//this listprice and offerprice are in a div created in updateLastOfferUpsell() in store-presol.js
        	//after this we must delete the div with upsell product's listprice and offerprice.
        	if($('#current-clipon-catentry').length > 0 && $('#current-clipon-catentry').attr('isAdded') == 'true'){
	        		var str_offer_price = offer_price.trim();
	            	var str_list_price = list_price.trim();
        	} else {
        		var str_offer_price = returnLastOfferPrice().trim();
            	var str_list_price = productDisplayJS.lastOfferPriceSaved.trim();
        	}
        	
        	//SETTING PRICE IN MINICART
        	if(!isUpsell){
        		if(productDisplayJS.engraving){
        			 str_offer_price = document.getElementById('offerPrice_'+productDisplayJS.baseCatalogEntryId+"_1").innerHTML;
        			 if(productDisplayJS.lastOfferPriceSaved!==""){
        				 str_list_price = document.getElementById('listPrice_'+productDisplayJS.baseCatalogEntryId+"_1").innerHTML;
        			 }
        		}
        		$('#MiniShopCartProdPrice_' + $('#orderItemId').val() + '.product_total .priceCart').html(str_offer_price);
        		
        		
        		if(str_offer_price != str_list_price && !str_list_price.includes("NaN")){
        			document.getElementById("minicartPST").innerHTML=str_list_price;
        		}
                if (!isWishlistPage){
	        		if(!($('#current-clipon-catentry').length > 0 && $('#current-clipon-catentry').attr('isAdded') == 'true')){
		        		offer_price = document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText;
		        		list_price = document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText;
	        		}
                } else {
                    offer_price = document.getElementById('offerPrice_'+wishlistProductId).innerText;
                    list_price = document.getElementById('listPrice_'+wishlistProductId).innerText;
                } 
        	}else{
        		if($('#upsell-added-inicart #upsell-offer-price').text().length > 0){
        			$('#MiniShopCartProdPrice_' + $('#orderItemId').val() + '.product_total .priceCart').html($('#upsell-added-inicart #upsell-offer-price').text());
        		}
        		offer_price = $('#upsell-added-inicart #upsell-offer-price').text();
        		list_price = $('#upsell-added-inicart #upsell-list-price').text();
                //hide carousel for new upsell
                hideCarouselRecommend('#minicartYMAL');
        	}
        	
        	//upload PST in minicart
            if((document.cookie.includes('X_WC_PR_SEGMENTS') || isUpsell) && list_price.length > 0){
            	if(parseFloat(list_price.replace( /^\D+/g, '')) != parseFloat(offer_price.replace( /^\D+/g, ''))){
            		$('#minicartPST.price__list')[0].innerText = list_price;
            	}
            	
            	if(isUpsell){
            		$('#upsell-added-inicart').remove();
            	}
            }
        }else{
            if(isUpsell){
                //hide carousel for new upsell
                $('#upsell-added-inicart').remove();
                hideCarouselRecommend('#minicartYMAL');
            }
        }
        //END Early Access

        //Show badge in minicart
        if (isOliver || isPersol){
            if ( $('.minicart-badge .prescription_added').length > 0 || $('.minicart-badge .product_polarized').length > 0) {
                if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                    $(".minicart-badge").show();
                } else $(".minicart-badge.mobile").show();
            }
        }

        //added manifest map in localStorage
        if(localStorage != undefined){
            if(localStorage['manifestMap']!= undefined){ 
                try {
                    var manifestMapMerged = $.extend($.parseJSON(localStorage['manifestMap']),$.parseJSON($("#manifestMap").val()));
                    localStorage.setItem('manifestMap', JSON.stringify(manifestMapMerged));
                }
                catch(e) {
                    localStorage.setItem('manifestMap',$("#manifestMap").val());
                }
            }else{

                localStorage.setItem('manifestMap',$("#manifestMap").val());
            }

            if (isOliver || isPersol) {
                // var upSellPartNumber = $("#upSellPartnumber").val();
                // const upSellPartnumberArray = upSellPartNumber.split(" ").slice(1);
                if (isWishlistPage){
                    replaceImageMinicart($("#cartDropdown .product_image img"));
                } else {
                    replaceImageMinicart($("#cartDropdown .product_image img"), partNumber);
                }
                replaceImageMinicart($("#cartSuggestion .owl-item.active .product_image  img:nth-child(2)"));
                $("#skeleton-minicart").hide();
                $("#cartDropdown .product_image img").eq(0).show();
            }
        
        }

    });
}

function changeHeaderIndex(isOpening){
    isOpening ? $('#header').css('z-index', '1001') :  $('#header').css('z-index', '600')
}
function changeFooterIndex(isOpening){
    isOpening ? $('#footerWrapper').css('z-index', '1002') :  $('#footerWrapper').css('z-index', '600')
}

function hideCarouselRecommend(container){
    switch(container){
      case "#minicartYMAL":
        if(isPersol) $('#widget_minishopcart_popup_1').addClass('disable-carousel');
      default:
        $(container).hide();
      break;
    }
}
function getPreOrderBadge(attributes) {
    var preOrder = null;
    preOrder = attributes.find(x=>(x.identifier == 'PREORDER' && x.usage == 'Descriptive'));
    if(isPreOrderActive && preOrder) {
        var preOrderVal = preOrder.values[0].value ? preOrder.values[0].value.toString().toLowerCase() : null;
        if(preOrderVal && preOrderVal == 'true') {
            return preOrder.identifier;
        }
    }
}


function printBadges(attributes){
    /**
     * OP Badge Hierarchy
     * PremiumMaterials > Exclusive > Pre-release > New > Clip Available
    */
    if(isOliver) {
        var newRelease = null;
        var exclusive = null;
        var clipsAvailable = null;
        var premiumMaterial = null;
        var preRelease = null;
        
        premiumMaterial = attributes.find(x=>(x.identifier == 'FRAMEMATERIAL_FACET' && x.usage == 'Descriptive'));
        if(premiumMaterial) {
            premiumMaterial = premiumMaterial.values[0].value ? premiumMaterial.values[0].value.toString().toLowerCase(): null;
            if(premiumMaterial && (premiumMaterial === 'horn' || premiumMaterial === 'solid gold' || premiumMaterial === 'gold'))
                return $('#premiumMaterial').val();
        }
        exclusive = attributes.find(x=>(x.identifier == 'EXCLUSIVE' && x.usage == 'Descriptive')); 
        if(exclusive){
            var exclusiveVal = exclusive.values[0].value ?  exclusive.values[0].value.toString().toLowerCase() : null;
            if(exclusiveVal && exclusiveVal == 'true')
                return exclusive.name;
        } 
        preRelease = attributes.find(x=>(x.identifier == 'PRE_RELEASE' && x.usage == 'Descriptive')); 
        if(preRelease) {
            var preReleaseVal = preRelease.values[0].value ? preRelease.values[0].value.toString().toLowerCase():null;
            if(preReleaseVal && preReleaseVal =='true')
                return preRelease.name;
        }
        newRelease = attributes.find(x=>(x.identifier == 'NEWRELEASES' && x.usage == 'Descriptive'));
        if(newRelease) {
            var newReleaseVal = newRelease.values[0].value ? newRelease.values[0].value.toString().toLowerCase(): null;
            if(newReleaseVal && (newReleaseVal =='true' || newRelease.values[0].value =='new')){
                if (WCParamJS.countryCode.toUpperCase() != 'DE' && WCParamJS.countryCode.toUpperCase() != 'AT') {
                    return 'New';
                } else {
                    return 'Neu';
                }
            }
        }
        clipsAvailable = attributes.find(x=>(x.identifier == 'MATCH_WITH_CLIPS' && x.usage == 'Descriptive'));
        if(clipsAvailable) {
            var clipsAvailableVal = clipsAvailable.values[0].value ? clipsAvailable.values[0].value.toString().toLowerCase() : null;
            if(clipsAvailableVal && clipsAvailableVal =='true')
                return  $('#clipAvailable').val();
        }  
    }
     /**
     * PO Badge Hierarchy
     * Limited Edition > Exclusive > PremiumMaterials > New
    */
    if(isPersol){
        
        var premiumMaterial = null;
        var exclusive = null;
        var newRelease = null;
        var limited = null;
        
       
        limited = attributes.find(x=>(x.identifier == 'LIMITED_EDITION' && x.usage == 'Descriptive'));
        if(limited) {
            var limitedEditionVal = limited.values[0].value ? limited.values[0].value.toString().toLowerCase() : null;
            if( limitedEditionVal && limitedEditionVal == 'true')
                return limited.name;
        }
        exclusive = attributes.find(x=>(x.identifier == 'EXCLUSIVE' && x.usage == 'Descriptive')); 
        if(exclusive){
            var exclusiveVal = exclusive.values[0].value ?  exclusive.values[0].value.toString().toLowerCase() : null;
            if(exclusiveVal && exclusiveVal == 'true')
                return exclusive.name;
        } 
        premiumMaterial = attributes.find(x=>(x.identifier == 'FRAMEMATERIAL_FACET' && x.usage == 'Descriptive'));
        if(premiumMaterial) {
            premiumMaterial = premiumMaterial.values[0].value ? premiumMaterial.values[0].value.toString().toLowerCase(): null;
            if(premiumMaterial && (premiumMaterial === 'horn' || premiumMaterial === 'solid gold' || premiumMaterial === 'gold'))
                return $('#premiumMaterial').val();
        }
        newRelease = attributes.find(x=>(x.identifier == 'NEWRELEASES' && x.usage == 'Descriptive'));
        if(newRelease) {
            var newReleaseVal = newRelease.values[0].value ? newRelease.values[0].value.toString().toLowerCase(): null;
            if(newReleaseVal && (newReleaseVal =='true' || newRelease.values[0].value =='new')){
                if (WCParamJS.countryCode.toUpperCase() != 'DE' && WCParamJS.countryCode.toUpperCase() != 'AT') {
                    return 'New';
                } else {
                    return 'Neu';
                }
            }
        }
    }

    return "";
}

//Begin of EMAIL_ME
function printStatus(product){
    
    if(isEcommerceStoreJS == 'TRUE' && !(typeof product['inventory'] === 'undefined')){
        
        var comingSoon = product['inventory']['ranking'] == '1' && product['inventory']['flComingSoon'] == 'true';
        var soldOut = product['inventory']['ranking'] == '0';
        var comingSoonBack = product['inventory']['ranking'] == '1' && product['inventory']['flComingSoon'] == 'false';
        if(soldOut == false && comingSoonBack == false && comingSoon == false){
            return false; //se non ci sono badge da mostrare ritorna falso ==>serve per il controllo in CatalogENtryList_Oliver/persol_ui.jspf 
        }else{
            return {'SoldOut': SOLD_OUT_STATUS ,
                        'isSoldOut': soldOut , 
                        'Coming': COMING_SOON_STATUS, 
                        'isComing': comingSoon,
                        'ComingSoonBack': COMING_SOON_BACK_STATUS,
                        'isComingSoonBack': comingSoonBack,
                        }
        }
                    
    }   else{
        return false;
    }    
    
}
//End of EMAIL_ME




function getPolarized (attributes,isClass) {
    var polarized = null;
    var isPolar = false;
    if (attributes != undefined) {
        polarized = attributes.find(x=>(x.identifier == 'POLARIZED' && x.usage == 'Descriptive'));
        var polarizedValue = polarized && polarized.values[0].value ? polarized.values[0].value.toString().toLowerCase(): 'false';
        if(polarizedValue == 'true' || polarizedValue == 'yes') {
            polarized = polarized.name;
            if(polarized == null){
                polarized = POLARIZED_TEXT;
            }
            isPolar= true;
        }
        else polarized=null;
    }
    return isClass ? isPolar : polarized;    
}

function getTransitionBadge (attributes,isClass) {
    var transition = null;
    var isTransition = false;

    if (attributes != undefined) {
        transition = attributes.find(x=>(x.identifier == 'TRANSITIONS' && x.usage == 'Descriptive'));
        var transitionValue = transition && transition.values[0].value ? transition.values[0].value.toString().toLowerCase(): 'false';
        if(transitionValue == 'true' || transitionValue == 'yes') {
            transition = transition.name;
            if(transition == null){
                transition = TRANSITION_TEXT;
            }
            isTransition= true;
        }
        else transition=null;
    }
    return isClass ? isTransition : transition;
}


function isPrescription(attributes){
    var isRoxable=false;
    for (var index = 0; index < attributes.length; index++) {
    
           
            if ( attributes[index].identifier == 'IS_ROXABLE') {
                isRoxable = (attributes[index].values[0].value.toLowerCase() == 'yes' || attributes[index].values[0].value.toLowerCase() == 'true');
                break;
            }else{
                isRoxable = false;
            }
        
    }
    return isRoxable;
}



function getElementPosition(idClass) {
    var element = $(idClass);
    var offset = element.offset();

    return {
        'top': offset.top,
        'right': offset.left + element.outerWidth(),
        'bottom': offset.top + element.outerHeight(),
        'left': offset.left,
    };
};
          
function getParameterByName(name) {
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
   };

function replaceImage(picture,typeImg){
        var urlBase_Persol = "https://assets2.persol.com/is/image/";
        var urlBase_Oliver = "https://assets2.oliverpeoples.com/is/image/";
        var urlBaseAccessories_Oliver = "https://assets.oliverpeoples.com/extra/image/OliverPeoples/accessories/";
        var urlBaseAccessories_Persol = "https://assets.persol.com/extra/image/TargetOptical/accessories/";
        var FOLDER_NAME_Persol = "Persol";
        var FOLDER_NAME_Oliver = "OliverPeoples";
        var SUFFIX_AKAMAI_WS = "_manifest_2.json";
        var FOLDER_ACCESSORIES_IMAGES_PERSOL = "https://assets.persol.com/extra/image/Persol/accessories/";
        var FOLDER_ACCESSORIES_IMAGES_OLIVER = "https://assets.oliverpeoples.com/extra/image/OliverPeoples/accessories/";
        var productPartNumber;
        if(isOliver){
            var ymalAkamaiPolicy = '?impolicy=HB_parameters&sclw=0.5&sclh=0.5';
        }else if(isPersol){
            var ymalAkamaiPolicy = '?impolicy=HB_parameters&sclw=0.5&sclh=0.5';
        }
        if (screenWidthPx <= 400) {
            ymalAkamaiPolicy = ymalAkamaiPolicy.replace('&sclw=0.5&sclh=0.5','&wid=400');
        } else if (400 < screenWidthPx && screenWidthPx <= 750) {
            ymalAkamaiPolicy = ymalAkamaiPolicy.replace('&sclw=0.5&sclh=0.5','&wid=800');
        } else if (1200 < screenWidthPx) {
            ymalAkamaiPolicy = ymalAkamaiPolicy.replace('&sclw=0.5&sclh=0.5','&wid=2000');
        }

        //get partnumber and create url for call to manifest
        for(var i = 0; i < picture.length; i++) {
        	if(picture[i].className == 'lazy catalog__image--front'){
        		productPartNumber= picture[i].dataset.partnumber;
        		if(isPersol){
                    var akamaiAPI = urlBase_Persol + FOLDER_NAME_Persol + '/' + productPartNumber + SUFFIX_AKAMAI_WS;
                }else{
                    var akamaiAPI = urlBase_Oliver + FOLDER_NAME_Oliver + '/' + productPartNumber + SUFFIX_AKAMAI_WS;
                }
        	}else{
        		for(var j = 0; j < picture[i].childNodes.length; j++){
                    if(picture[i].childNodes[j].nodeName == 'IMG'){
                        productPartNumber= picture[0].childNodes[5].dataset['partnumber'];
                        if(isPersol){
                            var akamaiAPI = urlBase_Persol + FOLDER_NAME_Persol + '/' + productPartNumber + SUFFIX_AKAMAI_WS;
                        }else{
                            var akamaiAPI = urlBase_Oliver + FOLDER_NAME_Oliver + '/' + productPartNumber + SUFFIX_AKAMAI_WS;
                        }                        
                    }
                }
        	}            
        }
        var thumbnail="";
        var hasImage=false;
         //call service (manifest)
        $.ajax({
            url: akamaiAPI,
            dataType: "json",
            success: function(data) {
                //check if there is the required image
                for (var i = 0; i < data.items.length; i++) {
                    var imageFileKey = data.items[i].file_key;
                    if (imageFileKey.includes(typeImg)) {
                        hasImage= true;
                    }
                }

            }, error: function(requestObject, error, errorThrown){
                console.error("error in rest call to manifest",error);
            }, complete: function(){
                if(hasImage){//if it exists  create URL images
                    if(isPersol){
                        thumbnail= baseUrlAkamaiIMPO + classicPathAkamaiIMPO + productPartNumber +"__"+ typeImg+'.png' + ymalAkamaiPolicy;
                    }else{
                        thumbnail = baseUrlAkamaiIMOP + classicPathAkamaiIMOP + productPartNumber +"__"+ typeImg+'.png'+ymalAkamaiPolicy;
                    } 
                }else{ //else put 001 image or 002 image
                        if(isPersol && typeImg == 'STD__shad__fr'){
                            thumbnail=  window.setQueryParams(catalogEntryDetails.thumbnail , ymalAkamaiPolicy);
                        }else if(isPersol && typeImg == 'STD__shad__qt'){
                            thumbnail=  window.setQueryParams(catalogEntryDetails.thumbnail2 , ymalAkamaiPolicy); 
                        }else if(isOliver && typeImg == 'STD__shad__fr'){
                            thumbnail = window.setQueryParams(catalogEntryDetails.thumbnail , ymalAkamaiPolicy);
                        }else if(isOliver && typeImg == 'STD__shad__qt'){
                            thumbnail = window.setQueryParams(catalogEntryDetails.thumbnail2 , ymalAkamaiPolicy);
                        }      
                }
                //replace picture srcset
                for(var g = 0; g < picture.length; g++) {
                	if(picture[g].className == 'lazy catalog__image--front'){
                		thumbnail = thumbnail.split('=')[0] + '=HB_parameters_transp&wid=720&cropnorth=-9&cropsouth=-9';
                		picture[g].dataset["srcset"]= thumbnail;
                	}else{
                		for(var j = 0; j < picture[g].childNodes.length; j++){
                            if(picture[g].childNodes[j].nodeName == "SOURCE"){
                               picture[g].childNodes[j].dataset["srcset"]= thumbnail;
                            }
                        }
                	}
                }
            }
        });
}

function replaceTileImgByDevice(url,pattern,tileType) {
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;
    if (typeof url == 'string') {
        var screenWidthPx = Math.round(window.innerWidth*window.devicePixelRatio);
        if (screenWidthPx < 400/* mobile */) {
            if (tileType == 'small') {
                return url.replace(pattern,'wid=375');
            } else if (tileType == 'big') {
                return url.replace(pattern,'wid=400');
            }
        } else if (400 < screenWidthPx && screenWidthPx <= 750/* tablet */) {
            if (tileType == 'small') {
                return url.replace(pattern,'wid=375');
            } else if (tileType == 'big') {
                return url.replace(pattern,'wid=500');
            } else if (tileType == 'lowerCarousel') {
                return url.replace(pattern,'wid=100');
            }
        } else if (750 < screenWidthPx && screenWidthPx <= 1200/* desktop 1x */) {
            if (tileType == 'small') {
                if(isWishlistPage){
                    return url.replace(pattern,'wid=800');
                }else{
                    return url.replace(pattern,'wid=400');
                } 
            } else if (tileType == 'big') {
                return url.replace(pattern,'wid=800');
            } else if (tileType == 'lowerCarousel') {
                return url.replace(pattern,'wid=150');
            }
        } else if (1200 < screenWidthPx)/* desktop 2x */ {
            if (tileType == 'small') {
                return url.replace(pattern,'wid=800');
            } else if (tileType == 'big') {
                return url.replace(pattern,'wid=1600');
            } else if (tileType == 'lowerCarousel') {
                return url.replace(pattern,'wid=300');
            }
        }
    }
    return url;
}

function removeIOSRubberEffect( element ) {
	element.addEventListener( "touchstart", function () {
		var top = element.scrollTop, totalScroll = element.scrollHeight, currentScroll = top + element.offsetHeight;
		if ( top === 0 ) {
			element.scrollTop = 1;
		} else if ( currentScroll === totalScroll ) {
			element.scrollTop = top - 1;
		}
	} );
}

function handleSwipeBounce(){
    var startX = 0, startY = 0;

    $('.owl-wrapper').on( "touchstart", function(e){
            e=(e.touches)?e.touches[0]:e;//e.touches[0] is for ios
            startX = e.clientX;
            startY = e.clientY; 
    } );

    $('.owl-wrapper').on( "touchmove", function(event){
        var e=(event.touches)?event.touches[0]:event;//e.touches[0] is for ios
        var deltaX = Math.abs(e.clientX - startX);
        var deltaY = Math.abs(e.clientY - startY);

        if(deltaX > deltaY) {
          event.preventDefault();
        }
    });

    $('.owl-item').on( "touchend", function(e){ 
        if (isOliver) {
            $('body').css('overflow', 'auto'); 
        }
    });
}

function disableScrollingByClass() {
    document.ontouchmove = function ( event ) {

        var isTouchMoveAllowed = true, target = event.target;
    
        while ( target !== null ) {
            if ( target.classList && target.classList.contains( 'disable-scrolling' ) ) {
                isTouchMoveAllowed = false;
                break;
            }
            target = target.parentNode;
        }
    
        if ( !isTouchMoveAllowed ) {
            event.preventDefault();
        }
    
    };
}

function manageScrollOverlay(isOpen){
    /*
    if (window.mobilecheck() || window.tabletPortraitCheck()) {
        if (isOpen) {
            if (myPane !== undefined){
                myPane.disableDrag();
                bodyScrollLock.enableBodyScroll(document.querySelector('#draggable-cta-section'));
            }
            $("#fixed-top--mobile").hide();
        } else {
            if (myPane !== undefined) {
                myPane.enableDrag();
                bodyScrollLock.disableBodyScroll(document.querySelector('#draggable-cta-section'));
            }
            $("#fixed-top--mobile").show();
        }
    }
    */
}
/** jQuery Get Browser Plugin
 * @version: 1.01
 * @author: Pablo E. Fernández (islavisual@gmail.com).
 * Copyright 2016-2018 Islavisual. 
 * Licensed under MIT (https://github.com/islavisual/getBrowser/blob/master/LICENSE). 
 * Last update: 07/02/2018
 **/
 !function(e){e.extend({browser:function(){var e,r=navigator.userAgent,t=r.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i)||[];/trident/i.test(t[1])&&(e=/\brv[ :]+(\d+)/g.exec(r)||[],t[1]="Internet Explorer",t[2]=e[1]),"Chrome"===t[1]&&(e=r.match(/\b(OPR|Edge)\/(\d+)/),t[1]=null!=e?e.slice(1).join(" ").replace("OPR","Opera"):"Chrome"),t=t[2]?[t[1],t[2]]:[navigator.appName,navigator.appVersion,"-?"],null!=(e=r.match(/version\/(\d+)/i))&&t.splice(1,1,e[1]);var o=/firefox/.test(navigator.userAgent.toLowerCase())&&!/webkit    /.test(navigator.userAgent.toLowerCase()),a=/webkit/.test(navigator.userAgent.toLowerCase()),s=/opera/.test(navigator.userAgent.toLowerCase()),n=/edge/.test(navigator.userAgent.toLowerCase())||/msie/.test(navigator.userAgent.toLowerCase())||/msie (\d+\.\d+);/.test(navigator.userAgent.toLowerCase())||/trident.*rv[ :]*(\d+\.\d+)/.test(navigator.userAgent.toLowerCase()),i=n?"":a?"-webkit-":o?"-moz-":"";return{name:t[0],version:t[1],firefox:o,opera:s,msie:n,chrome:a,prefix:i}}}),jQuery.browser=e.browser()}(jQuery);

 /** Handle multiple promises */
 function all(array,promises) {
     var deferred = $.Deferred();
     var fulfilled = 0, length = array.length;
     var results = [];
     if (length === 0) {
         deferred.resolve(results);
     } else {
             for (var index=0; index<array.length; index++) {
            	 
            	 (function (index) {
            		 var upc = array[index];
                     promises[upc].then(function(response){
                       results[index] = response;
                       fulfilled++;
                       if (fulfilled === length) {
                           deferred.resolve(results);
                       }
                     });
            	 }(index));
                 
           }
     }
     return deferred.promise();
 };
 
 /** getScript with cache */
 jQuery.cachedScript = function(url,options) {
   // Allow user to set any option except for dataType, cache, and url
   options = $.extend(options || {},{
     dataType: "script",
     cache: true,
     url: url
   });
   // Use $.ajax() since it is more flexible than $.getScript
   // Return the jqXHR object so we can chain callbacks
   return jQuery.ajax(options);
 };
 
//left: 37, up: 38, right: 39, down: 40,
//spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
var keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefault(e) {
	e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
	if (keys[e.keyCode]) {
	  preventDefault(e);
	  return false;
	}
}

//modern Chrome requires { passive: false } when adding event
var supportsPassive = false;
try {
window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
	get: function () { supportsPassive = true; } 
}));
} catch(e) {}

var wheelOpt = supportsPassive ? { passive: false } : false;
var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

//call this to Disable
function disableScroll() {
	window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
	window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
	window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
	window.addEventListener('keydown', preventDefaultForScrollKeys, false);
}

//call this to Enable
function enableScroll() {
	window.removeEventListener('DOMMouseScroll', preventDefault, false);
	window.removeEventListener(wheelEvent, preventDefault, wheelOpt); 
	window.removeEventListener('touchmove', preventDefault, wheelOpt);
	window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
}

function capitalizeEachWord(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
    }
    // Directly return the joined string
    return splitStr.join(' '); 
 }



function iOSversion() {
	if (/iP(hone|od|ad)/.test(navigator.platform)) {
		// supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
	    var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
	    return parseInt(v[1], 10);
	}
}
/**
 * Check if we are in Chrome on an iOS device
 * becase function isSafari returns true even when we are in chrome
 * @returns true if is chrome on iOS, false otherwise
 */
function isChromeOnIOS() { 
    return navigator.userAgent.indexOf('CriOS') >= 0;
}

 
/* START Early Access */

function getPriceByCustomerSegment(priceObj) {
    if (isPersol || isVogue){
        //  Check User Customer Segment using cookie
        if (document.cookie.includes("X_WC_PR_SEGMENTS") && window.customerSegment != undefined){
            //  Get price for my customer segment
            if (priceObj["price_"+window.customerSegment] != undefined && priceObj["price_"+window.customerSegment] != ""){
                price = priceObj["price_"+window.customerSegment];
            } else price = priceObj.price;
        } else price = priceObj.price;
    } else if (isOliver){
        price = priceObj.price;
    }
    return price; //  Return price
}

function returnLastOfferPrice() {
    var lastOfferPrice;
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;
    var minicartAddedId = $("#cartDropdown .products.added .product").attr("data-minicart-id");
  
    if (!isWishlistPage) {
      if(productParent[0]){
        if ((window.mobilecheck() || window.tabletPortraitCheck()) && !isPersol){
            lastOfferPrice = document.querySelectorAll('#offerPrice_'+productParent[0])[1].innerText;
        } else if((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol){
          lastOfferPrice = document.getElementById('offerPrice_'+productParent[0]).innerHTML;
        }else if(isVogue){
        	lastOfferPrice = document.getElementsByClassName('offerPrice_'+productParent[0]).innerHTML;
        }else{
          lastOfferPrice = document.getElementById('offerPrice_'+productParent[0]).innerText;
        }
      }
    } else {
      lastOfferPrice = document.getElementById('offerPrice_'+ minicartAddedId).innerText;
    }

    return lastOfferPrice;
}

/* END Early Access */

//checkout 3.0

function goToOrderPaymentViewOnClickHandler(event){
    
    form1 = document.forms['shippingAddressCreateEditFormDiv_1'];
    form2 = document.forms['billingAddressCreateEditFormDiv_1'];
    /*if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
    	form3 = document.forms['recipient_detail']; //form for PickUpInStore
    }*/ 
    var sameaddressCheckbox = document.getElementById("SameShippingAndBillingAddress");
    if(AddressHelper.zipCodeNotFound){
    	var stateDiv = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1');
    	var stateHiddenDiv = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1_hidden');
    	if(stateDiv != null && stateDiv.value != "") {
    		stateHiddenDiv.value = stateDiv.value;
    	} 
    }

    console.log("PSL::UnregisteredCheckout.jsp::addressId_formS_"+storeDirectory+"::"+addressId_formS);
    console.log("PSL::UnregisteredCheckout.jsp::addressId_formB_"+storeDirectory+"::"+addressId_formB);
    
    AddressBookFormJS.checkAddressCopyAndCopyIfNeeded('shippingAddressCreateEditFormDiv_1','billingAddressCreateEditFormDiv_1',countryCode);
    
    //START CODE BOSS
    //if((!($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup') && isOliver) || isPersol){
    	//form2.email1.value=form1.email1.value;
    let isFormNoError = AddressHelper.validateEmail('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_email1_1"/>');
    /*}else{
    	form2.email1.value=form3.email1.value;
      	AddressHelper.validateEmail('recipient_detail__email1"/>');
    } */  
    //END CODE BOSS
    var formValidationError = false;
    
    if(AddressHelper.zipCodeNotFound){
    	  AddressHelper.joinNewsletter('shippingAddressCreateEditFormDiv_1', WCParamJS.langId, WCParamJS.storeId);

          //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
          //calling the rest service. If success then address exist else address does not exist.
          var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
          $.ajax({
              method: "GET",
              url: url,
              headers: {
                  "Content-Type": "application/json",
                  "Cache-Control": "no-cache, no-store, must-revalidate"
              },
              dataType: "json",
              success:function(data, textStatus, jqXHR){
            	  var addressValidate = true;
		        	if($('#addressValidationActive').val() == 'true'){
		        		if($('#addressValidationFirstTime').val() == 'true'){
		        			addressValidate = callAddressValidation( $('#shippingAddressCreateEditFormDiv_1 [name="address1"]').val(),  $('#shippingAddressCreateEditFormDiv_1 [name="zipCode"]').val());	
		        		}
		          }
                  if(addressValidate){
                	  if (typeof data.contact === 'undefined'){
                          plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
                          AddressHelper.saveUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv1');
                      } else {
                          for (var i = 0; i<data.contact.length; i++){
                              if (data.contact[i].nickName == 'MyAddress_Shipping'){
                                  plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
                                  AddressHelper.updateUnregisteredCheckoutAddressAndGoPaymentStep('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, sameaddressCheckbox.checked, orderShippingBillingViewURL);
                                  break;
                              }
                          }
                      }
                      /* START - OP BOSS */
                      if (isOliver) {
                        if($('div[shipmodecode="ShipToStore"]').length > 0){
                            var url = null;
                            if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'ShipToStore'){
                                url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/orders/bossOrder/pushInfo?orderId=" + $checkoutObj.cartData.orderId + "&storeCode=" + storeCode + "&storeName=" + storeName + "&storePhone=" + storePhone + "&storeEmail=" + storeEmail + "&storeHours=" + JSON.stringify(storeHours) + "&storeDirections="  +  encodeURIComponent(storeDirection);
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    success: function (data) {
                                        console.log(data);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        console.log(data);
                                    }
                                });
                            }else{
                                url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/orders/bossOrder/deleteInfo?orderId=" + $checkoutObj.cartData.orderId;
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    success: function (data) {
                                        console.log(data);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        console.log(data);
                                    }
                                });
                            }
                        }
                    }
                    /* END - OP BOSS */  
                  }else{
                	  restoreAjaxButtons();
                  }
              },
              error:function(jqXHR, exception){
                  plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
              }
          });
    }
    else {
        
        if(AddressHelper.validateAddressForm(form1)) {
            //if(isFormNoError)//isFormNoError check if one of th input field in checkoutform is with error in this case if email is with error with need to send error to analytics 
                isFormNoError = true;
		    getGoogleAddressPromise(countryCode, form1.zipCode.value, storeLanguage)
		        .then(function(data){
		            var addressObj = convertGoogleAddressResponse(data);
		            if (addressObj.status != "success"){
		                formValidationError = true;
		                throw "zipCode " + form1.zipCode.value + " not valid for country "+countryCode;
		            } else {
		            	var city = document.getElementById("WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1").value;
		            	var addObjCity= addressObj["address"]["city"];
		            	if(city != addObjCity){
		            		addressObj["address"]["city"]= city;
		            		addressObj["address"]["locality"] = city;
		            	}
		                AddressHelper.fillFormAddressFromAddressDataObject(form1, addressObj);
		            }
		        })
		        .then(function(data){
		            return getTaxesFromZipCodePromise(form1);
		        })
		        .then(function(data){
		            if (!sameaddressCheckbox.checked){
		                return getGoogleAddressPromise(countryCode, form2.zipCode.value, storeLanguage)
		            }
		        })
		        .then(function(data){
		            if (!sameaddressCheckbox.checked){
		                var addressObj = convertGoogleAddressResponse(data);
		                if (addressObj.status != "success"){
		                    formValidationError = true;
		                    throw "zipCode " + form2.zipCode.value + " not valid for country " + countryCode;
		                } else {
		                    AddressHelper.fillFormAddressFromAddressDataObject(form2, addressObj);
		                }
		            }
		
		            return getUserAddressListPromise();
		        })
		        .then(
		            function(data){
		                if (typeof data.contact !== 'undefined'){
		                    for (var i = 0; i<data.contact.length; i++){
		                        if (data.contact[i].nickName == 'MyAddress_Shipping' || data.contact[i].nickName == 'MyAddress_Billing'){
		                            AddressHelper.updateAddressCookies(data.contact[i].addressId, data.contact[i].addressType);
		                            plog("CommonUtilities.js::goToOrderPaymentsViewOnClickHandler::"+ data.contact[i].nickName +" found: shippingAddressId: " + data.contact[i].addressId +", shippingAddressType: " + data.contact[i].addressType);
		                        }
		                    }
		                }
		            }, function(err){
		                console.log(err);
		            })
		        .then(function(){
		            if (!AddressHelper.validateAddressForm(form1)){
		                formValidationError = true;
		            }
		            if (!sameaddressCheckbox.checked){
		                if (!AddressHelper.validateAddressForm(form2)){
		                    formValidationError = true;
		                }
		            }
		            if (formValidationError){
		                restoreAjaxButtons();
		                console.log("UnregisteredCheckout.jsp::Form validation error");
		                return;
		            }
		            
		            var addressValidate = true;
		        	if($('#addressValidationActive').val() == 'true'){
		        		if($('#addressValidationFirstTime').val() == 'true'){
		        			addressValidate = callAddressValidation( $('#shippingAddressCreateEditFormDiv_1 [name="address1"]').val(),  $('#shippingAddressCreateEditFormDiv_1 [name="zipCode"]').val());	
		        		}
		        	}
		        	
		        	if(addressValidate){
			            AddressHelper.joinNewsletter('shippingAddressCreateEditFormDiv_1', WCParamJS.langId, WCParamJS.storeId);
	
			            //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
			            //calling the rest service. If success then address exist else address does not exist.
			            var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
			            $.ajax({
			                method: "GET",
			                url: url,
			                headers: {
			                    "Content-Type": "application/json",
			                    "Cache-Control": "no-cache, no-store, must-revalidate"
			                },
			                dataType: "json",
			                success:function(data, textStatus, jqXHR){
			                    if (typeof data.contact === 'undefined'){
			                        plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
			                        AddressHelper.saveUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv1');
			                    } else {
			                        for (var i = 0; i<data.contact.length; i++){
			                            if (data.contact[i].nickName == 'MyAddress_Shipping'){
			                                plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
			                                AddressHelper.updateUnregisteredCheckoutAddressAndGoPaymentStep('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, sameaddressCheckbox.checked, orderShippingBillingViewURL);
			                                break;
			                            }
			                        }
			                    }
			                },
			                error:function(jqXHR, exception){
			                    plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
			                }
			            });
			
			            moveToError();
		        	}else{
		        		restoreAjaxButtons();
		        	}
		        }).then(function(){
                    if (isOliver) {
                        if($('div[shipmodecode="ShipToStore"]').length > 0){
                            var url = null;
                            if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'ShipToStore'){
                                url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/orders/bossOrder/pushInfo?orderId=" + $checkoutObj.cartData.orderId + "&storeCode=" + storeCode + "&storeName=" + storeName + "&storePhone=" + storePhone + "&storeEmail=" + storeEmail + "&storeHours=" + JSON.stringify(storeHours) + "&storeDirections="  +  encodeURIComponent(storeDirection);
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    success: function (data) {
                                        console.log(data);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        console.log(data);
                                    }
                                });
                            }else{
                                url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/orders/bossOrder/deleteInfo?orderId=" + $checkoutObj.cartData.orderId;
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    success: function (data) {
                                        console.log(data);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        console.log(data);
                                    }
                                });
                            }
                        }
		            }
		        })
        }else{
            isFormNoError = false;
        }
       // }
    }
    
    //BEGIN SMS NOTIFICATION 
    AddressHelper.joinSMS();
    //END SMS
    
    if(!isFormNoError)
        //ERROR IN SHIPPING FORM 
        newTealiumPushFormError('Shipping address','Please provide a valid city,zip code, etc');   
}

function parseStoreHours(storeHours){
	var weekDays = getWeekDays(locale.replace('_','-'));
	var hourString = titleCase(weekDays[0]);
	var existAnotherWithTheSameHours = '';
	//we start from second day
	for(var i = 1; i < storeHours.length; i++){
		if(storeHours[i].opening === storeHours[i-1].opening && storeHours[i].closing === storeHours[i-1].closing){
			if (existAnotherWithTheSameHours == ''){
				existAnotherWithTheSameHours = ' - ';
			}
		}else{
			if(storeHours[i-1].isClosed){
				if(i == 1){
					hourString = hourString + ': ' + $('#textClosed').attr('value') + ' | ' + titleCase(weekDays[i]);	
				}else{
					hourString = hourString + existAnotherWithTheSameHours +  titleCase(weekDays[i - 1]) + ': ' + $('#textClosed').attr('value') + ' | ' + titleCase(weekDays[i]);	
				}
			}else{
				if(i == 1){
					hourString = hourString + ': ' + storeHours[i-1].opening + ' - ' + storeHours[i-1].closing +  ' | ' + titleCase(weekDays[i]);
				}else{
					hourString = hourString + existAnotherWithTheSameHours +  titleCase(weekDays[i - 1]) + ': ' + storeHours[i-1].opening + ' - ' + storeHours[i-1].closing +  ' | ' + titleCase(weekDays[i]);	
				}
			}
			existAnotherWithTheSameHours =  '';
		}
	}
	
	if( existAnotherWithTheSameHours == '' ){
		if(storeHours[storeHours.length-1].isClosed){
			hourString = hourString + ': ' + $('#textClosed').attr('value');
		}else{
			hourString = hourString + ': ' + storeHours[storeHours.length-1].opening + ' - ' + storeHours[storeHours.length-1].closing;
		}
	}else{
		if(storeHours[storeHours.length-1].isClosed){
			hourString = hourString + existAnotherWithTheSameHours + titleCase(weekDays[weekDays.length-1]) + ': ' + $('#textClosed').attr('value');
		}else{
			hourString = hourString + existAnotherWithTheSameHours + titleCase(weekDays[weekDays.length-1]) +  ': ' + storeHours[storeHours.length-1].opening + ' - ' + storeHours[storeHours.length-1].closing;
		}
	}
	return hourString.replaceAll('"','');
}

function titleCase(string){
	return string[0].toUpperCase() + string.slice(1).toLowerCase();
}

function getWeekDays(locale){
    var baseDate = new Date(Date.UTC(2017, 0, 2)); // just a Monday
    var weekDays = [];
    for(i = 0; i < 7; i++){       
        weekDays.push(baseDate.toLocaleDateString(locale, { weekday: 'long' }));
        baseDate.setDate(baseDate.getDate() + 1);       
    }

    //HB-9317. This fix is related to common weeksdays order in America. In USA , Sunday is considered the first day of week. This 
    // caused a strange parsing in storeHours. We have aligne the weekdays orders to the classic one.
    if(locale=='en-US' && weekDays[0]=='Sunday'){
        weekDays = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];
    }
    return weekDays;
}


function iPhoneVersion() {
	  var iHeight = window.screen.height;
	  var iWidth = window.screen.width;

	  
	  if (iWidth === 390 && iHeight === 844) {
		    return "12-13";
	  }
	  
	  if (iWidth === 414 && iHeight === 896) {
		    return "11";
	  }

	  if (iWidth === 414 && iHeight === 896) {
	    return "Xmax-Xr";
	  }
	  else if (iWidth === 375 && iHeight === 812) {
	    return "X-Xs";
	  }
	  else if (iWidth === 320 && iHeight === 480) {
	    return "4";
	  }
	  else if (iWidth === 375 && iHeight === 667) {
	    return "6-7";
	  }
	  else if (iWidth === 414 && iHeight === 736) {
	    return "6+";
	  }
	  else if (iWidth === 320 && iHeight === 568) {
	    return "5";
	  }
	  else if (iHeight <= 480) {
	    return "2-3";
	  }
	  return 'none';
	}



//checkout 3.0

/* START - Online Return Form */

function cleanCartForShipOrder(isReturnForm = false,callback) {
    if(personInfo.userId !== '-1002') {
        
        var url = '/wcs/resources/store/' + WCParamJS.storeId + '/cart/@self';
        function deleteCart(url,callback) {
            $.ajax({
                url: url,
                type: 'DELETE',
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache, no-store, must-revalidate"
                },
                dataType: "json",
                data: [],
                success: function (response, textStatus, request) {
                    if (typeof callback != 'undefined') {
                        callback(response);
                    }
                },
                error: function(response){
                    if (typeof callback != 'undefined') {
                        callback(response);
                    }
                }
            });
        }

        if (isReturnForm) {
            //  When Return Form, simply delete the cart
            deleteCart(url,callback);
        } else {
            //  When in classic cart, delete the cart after checking it is a Ship Order
            getAjaxCallInfo(url, null, function(response) {
                let isShipOrder = false;
                if (response.orderItem !== undefined) {
                    response.orderItem.forEach(function(item) {
                        if (item.partNumber == 'RETURN_SHIPPING_CHARGE_SKU') {
                            isShipOrder = true;
                        }
                    });
                }
                if (isShipOrder) {
                    deleteCart(url,callback);
                }
            });
        }

    }
}

/* END - Online Return Form */

function checkPasswordStrenght(passwordField) {
    var password = passwordField.value;
    const conditionThreshold = 5;
    var sumConditions = 0;
    if(RegExp('(?=.{8,})').test(password)) { //at least 8 characters long
        $('#password_length').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_length').attr("checked",false);
        sumConditions--;
    }

    if(RegExp('(?=.*[A-Z])').test(password)) {//at least one uppercase letter
        $('#password_uppercase').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_uppercase').attr("checked",false);
        sumConditions--;
    }

    if(RegExp('(?=.*[a-z])').test(password)) { //at least one lowercase letter
        $('#password_lowercase').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_lowercase').attr("checked",false);
        sumConditions--;
    }

    if(RegExp('(?=.*[0-9])').test(password)) { //at least one digit 
        $('#password_number').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_number').attr("checked",false);
        sumConditions--;
    }

    if(RegExp('([^A-Za-z0-9])').test(password)) { //at least one special character
        $('#password_special').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_special').attr("checked",false);
        sumConditions--;
    }
    console.log(sumConditions==conditionThreshold);
    return sumConditions==conditionThreshold;
}

function checkPasswordFieldAndSubmit(form) {
	
	if(form.validationCode.value == ''){
		$('.password-policies-title').addClass('hidden');
		$('#validationCodeError').removeClass('hidden');
	}else{
	 if(checkPasswordStrenght(form.logonPassword)){
	        $('.password-policies-title').removeClass('hidden');
	        $('.password-policies-title-error').addClass('hidden');
	        $('[name="logonPassword"').removeClass('error');
	        submitSpecifiedForm(form);
	    }
		else {
			$('.password-policies-title').addClass('hidden');
	        $('.password-policies-title-error').removeClass('hidden');
	        $('[name="logonPassword"').addClass('error')
		}
	}
   
}

function openPasswordPolicyDiv() {
    $('.password-policies-container').show();
    $('.input-style--password').addClass('passPolicyOpen'); //Persol
}


/*Check specific browser version*/
navigator.sayswho= (function(){
    var N= navigator.appName, ua= navigator.userAgent, tem;
    var M= ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i);
    if(M && (tem= ua.match(/version\/([\.\d]+)/i))!= null) M[2]= tem[1];
    M= M? [M[1], M[2]]: [N, navigator.appVersion,'-?'];
    return M;
})();

function getAttributeValue(attributes,identifier) {
    var val = attributes.map(function(attribute) {
        return (attribute.identifier === identifier) ? attribute.values[0].value : null;
    }).filter((value) => { return value != null })[0];
    //console.log('getAttributeValue: ' + identifier + ' = ' + val);
    return typeof val != 'undefined' ? val : '';
}

function getAttributeIdentifier(attributes,identifier) {
    var val = attributes.map(function(attribute) {
        return (attribute.identifier === identifier) ? attribute.values[0].identifier : null;
    }).filter((value) => { return value != null })[0];
    //console.log('getAttributeValue: ' + identifier + ' = ' + val);
    return typeof val != 'undefined' ? val : '';
}
function getConvertedDistance(distance) {
    //var inchMeasure = 25.4;
	var cleanNumber = "";
	
	if(typeof distance != 'undefined'){
		cleanNumber = distance.replace(/\D/g,'');
	}
    return '('+ cleanNumber + ' mm)';
}

function showKlarnaPlacements(){
    $('.pdp .klarna-mess-pdp').show();
    $('.pdp .klarna-minicart, .wishListDisplay .klarna-minicart').show();
    $('.minicart-klarna').show();
    $(".checkout__klarna").show();
    $('#vat_klarna:not(#cartSuggestion .content .espot-complete-order-upsell #vat_klarna)').show();
}

async function sha256(message) {
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);                    

    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string                  
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}

//Resolve promise for sha256
function getSha256Promise(message) {
    const result = sha256(message);
    return result instanceof Promise ? result : Promise.resolve(result);
}

//Return FALSE if VARIABLE DOESN'T CONTAINS VALUE; Return TRUE if VARIABLE CONTAINS VALUE;
function checkIsNull(variable){
    if(typeof(variable)!='undefined' &&  variable != '' && variable != null)
        return false;
    else
        return true;
}

window.addEventListener('load', (event) => {
    if (typeof fn_FrameAdvisor === 'function') {
        fn_FrameAdvisor();
    }
});


//CRM Banner - this function opens up promo popups with a promocode in cart on PO and VO
function fn_CartPromoCode(promoCode,copyPromoCode) {
    if (isPersol || isVogue){    
        if (typeof promoCode !== 'undefined' && typeof copyPromoCode !== 'undefined' ||
        promoCode != "" && copyPromoCode != "") {
        	window.isCRMPromo = true;
        	if(isVogue){
        		if($('#promoCodeCRM').length < 1){
        			$('#headerWidget').append('<input type="hidden" id="promoCodeCRM" name="promoCodeCRM" value="' + promoCode +'" autocomplete="off">');
        		}
        		if($('#copyPromoCodeCRM').length < 1){
        			$('#headerWidget').append("<input type='hidden' id='copyPromoCodeCRM' name='copyPromoCodeCRM' value='"+ copyPromoCode.replaceAll("'", '"') +"' autocomplete='off'>");
        		}
        		promoCode = $('#promoCodeCRM').val();
        		copyPromoCode = $('#copyPromoCodeCRM').val();
        	}
            $("#cart-crm-promocode-box-banner").addClass("showed").removeClass("hidden");
            $(".cart-crm-banner .promo-description").html(copyPromoCode);

            if (isVogue) {
                $("#cart-crm-promocode-box-banner .use-promocode-container").off("click").on("click", function(){
                    if ($("#promo-form-title.dropdown").hasClass("opend")){
                        $("#promo-form-title.dropdown").removeClass("opend");
                    }else{
                        $('#promo-form-title.dropdown').removeClass("opend");
                        $("#promo-form-title.dropdown").addClass("opend");
                    }
                });

                if ((window.mobilecheck() || window.tabletPortraitCheck())) {
                    $("#promo-form-title.dropdown").addClass("available-promocode");
                }

                CRMRemovePromoCode();
            }

            if (isPersol) {
                $("#cart-crm-promo-banner").addClass("showed").removeClass("hidden");
                $("#promotions .wrapperPromotions .promotion-code__label").addClass("available-promocode");

                $(".promotion-code__label.available-promocode, .use-promocode-container").on("click", function(){
                    $(".promocode-box-reminder .apply-promocode-cta").on("click", function(event){
                        event.stopPropagation();
                    });
                    if(isVogue){
                    	if ($("#promotion-code__input").is(":checked")){
                            $(".promotion-code__label.available-promocode").addClass("expanded");
                        } else {
                            $(".promotion-code__label.available-promocode").removeClass("expanded");
                        }
                    }else{
                    	if ($("#promotion-code__input").is(":checked")){
                    		$(".promotion-code__label.available-promocode").removeClass("expanded");
                        } else {
                        	$(".promotion-code__label.available-promocode").addClass("expanded");
                        }
                    }
                    
                });
            }

            $('.cart-crm-banner .apply-promocode-cta').off('click').on('click', function(){
                if (isPersol) {
                    if ($("input#promoCode").val() == "") {
                        $("input#promoCode").val(promoCode.toString());
                        $(".promocode-button-wrapper button").click();
                    }
                } else if (isVogue) {
                    if ($("input#coupon-value").val() == "") {
                        $("input#coupon-value").val(promoCode.toString());
                        $(".promotion_button button").click();
                    }
                }

            });
        } else {
            window.isCRMPromo = false;
        }
    }
}

function CRMRemovePromoCode (){
    if ($("#isPromocodeApplied").val() == 'true') {
        $("#cart-crm-promocode-box-banner").addClass("hidden").removeClass("showed");
        $(".visibleOrderDiscount td").css("color", "#000");
        $("#appliedPromotionCodes").hide();
        $("#CRMappliedPromotionCodes").show();
        $(".removePromotionLink").hide();
        $(".CRMremovePromotionLink").css("display","flex");
        if (!(window.mobilecheck() || window.tabletPortraitCheck())){
            $("#PromotionCodeForm").css("padding-bottom", "16px");
        } else {
            $("#promo-form-title").css("border-bottom", "none");
        }
    } else {
        $("#cart-crm-promocode-box-banner").addClass("showed").removeClass("hidden");
        $("#CRMappliedPromotionCodes").hide();
    }
}

//retrive all parameters from url
function getAllUrlParams() {
	var queryString = window.location.href.split('?')[1];
	var obj = {};

    if (queryString) {
        queryString = queryString.split('#')[0];
        var arr = queryString.split('&');

        for (var i = 0; i < arr.length; i++) {
            var a = arr[i].split('=');

            var paramName = a[0];
            var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

            paramName = paramName.toLowerCase();
            if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

            if (paramName.match(/\[(\d+)?\]$/)) {
                var key = paramName.replace(/\[(\d+)?\]/, '');
                if (!obj[key]) obj[key] = [];

                if (paramName.match(/\[\d+\]$/)) {
                    var index = /\[(\d+)\]/.exec(paramName)[1];
                    obj[key][index] = paramValue;
                } else {
                    obj[key].push(paramValue);
                }
            } else {
                if (!obj[paramName]) {
                    obj[paramName] = paramValue;
                } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                    obj[paramName] = [obj[paramName]];
                    obj[paramName].push(paramValue);
                } else {
                    obj[paramName].push(paramValue);
                }
            }
        }
    }

    return obj;
}


/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.9.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 0) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
            }
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }
        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        // If any child element receives focus within the slider we need to pause the autoplay
        _.$slider
            .off('focus.slick blur.slick')
            .on(
                'focus.slick',
                '*',
                function(event) {
                    var $sf = $(this);

                    setTimeout(function() {
                        if( _.options.pauseOnFocus ) {
                            if ($sf.is(':focus')) {
                                _.focussed = true;
                                _.autoPlay();
                            }
                        }
                    }, 0);
                }
            ).on(
                'blur.slick',
                '*',
                function(event) {
                    var $sf = $(this);

                    // When a blur occurs on any elements within the slider we become unfocused
                    if( _.options.pauseOnFocus ) {
                        _.focussed = false;
                        _.autoPlay();
                    }
                }
            );
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                 ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                coef = -1

                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2
                    }
                }
                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, swipeTarget, centerOffset;

        centerOffset = _.options.centerMode === true ? Math.floor(_.$list.width() / 2) : 0;
        swipeTarget = (_.swipeLeft * -1) + centerOffset;

        if (_.options.swipeToSlide === true) {

            _.$slideTrack.find('.slick-slide').each(function(index, slide) {

                var slideOuterWidth, slideOffset, slideRightBoundary;
                slideOuterWidth = $(slide).outerWidth();
                slideOffset = slide.offsetLeft;
                if (_.options.centerMode !== true) {
                    slideOffset += (slideOuterWidth / 2);
                }

                slideRightBoundary = slideOffset + (slideOuterWidth);

                if (swipeTarget < slideRightBoundary) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this,
                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
                    return (val >= 0) && (val < _.slideCount);
                });

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });

                if (slideControlIndex !== -1) {
                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
                   if ($('#' + ariaButtonControl).length) {
                     $(this).attr({
                         'aria-describedby': ariaButtonControl
                     });
                   }
                }
            });

            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $(this).attr({
                    'role': 'presentation'
                });

                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': (i + 1) + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });

            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }

        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
          if (_.options.focusOnChange) {
            _.$slides.eq(i).attr({'tabindex': '0'});
          } else {
            _.$slides.eq(i).removeAttr('tabindex');
          }
        }

        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
            }
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageSrcSet = $(this).attr('data-srcset'),
                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {

                            if (imageSrcSet) {
                                image
                                    .attr('srcset', imageSrcSet );

                                if (imageSizes) {
                                    image
                                        .attr('sizes', imageSizes );
                                }
                            }

                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy data-srcset data-sizes')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();

                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                if (imageSrcSet) {
                    image
                        .attr('srcset', imageSrcSet );

                    if (imageSizes) {
                        image
                            .attr('sizes', imageSizes );
                    }
                }

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy data-srcset data-sizes')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                    _.$slides
                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                    .removeClass('slick-active')
                    .end();

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));

!function(n){"use strict";function t(n,t){var r=(65535&n)+(65535&t);return(n>>16)+(t>>16)+(r>>16)<<16|65535&r}function r(n,t){return n<<t|n>>>32-t}function e(n,e,o,u,c,f){return t(r(t(t(e,n),t(u,f)),c),o)}function o(n,t,r,o,u,c,f){return e(t&r|~t&o,n,t,u,c,f)}function u(n,t,r,o,u,c,f){return e(t&o|r&~o,n,t,u,c,f)}function c(n,t,r,o,u,c,f){return e(t^r^o,n,t,u,c,f)}function f(n,t,r,o,u,c,f){return e(r^(t|~o),n,t,u,c,f)}function i(n,r){n[r>>5]|=128<<r%32,n[14+(r+64>>>9<<4)]=r;var e,i,a,d,h,l=1732584193,g=-271733879,v=-1732584194,m=271733878;for(e=0;e<n.length;e+=16)i=l,a=g,d=v,h=m,g=f(g=f(g=f(g=f(g=c(g=c(g=c(g=c(g=u(g=u(g=u(g=u(g=o(g=o(g=o(g=o(g,v=o(v,m=o(m,l=o(l,g,v,m,n[e],7,-680876936),g,v,n[e+1],12,-389564586),l,g,n[e+2],17,606105819),m,l,n[e+3],22,-1044525330),v=o(v,m=o(m,l=o(l,g,v,m,n[e+4],7,-176418897),g,v,n[e+5],12,1200080426),l,g,n[e+6],17,-1473231341),m,l,n[e+7],22,-45705983),v=o(v,m=o(m,l=o(l,g,v,m,n[e+8],7,1770035416),g,v,n[e+9],12,-1958414417),l,g,n[e+10],17,-42063),m,l,n[e+11],22,-1990404162),v=o(v,m=o(m,l=o(l,g,v,m,n[e+12],7,1804603682),g,v,n[e+13],12,-40341101),l,g,n[e+14],17,-1502002290),m,l,n[e+15],22,1236535329),v=u(v,m=u(m,l=u(l,g,v,m,n[e+1],5,-165796510),g,v,n[e+6],9,-1069501632),l,g,n[e+11],14,643717713),m,l,n[e],20,-373897302),v=u(v,m=u(m,l=u(l,g,v,m,n[e+5],5,-701558691),g,v,n[e+10],9,38016083),l,g,n[e+15],14,-660478335),m,l,n[e+4],20,-405537848),v=u(v,m=u(m,l=u(l,g,v,m,n[e+9],5,568446438),g,v,n[e+14],9,-1019803690),l,g,n[e+3],14,-187363961),m,l,n[e+8],20,1163531501),v=u(v,m=u(m,l=u(l,g,v,m,n[e+13],5,-1444681467),g,v,n[e+2],9,-51403784),l,g,n[e+7],14,1735328473),m,l,n[e+12],20,-1926607734),v=c(v,m=c(m,l=c(l,g,v,m,n[e+5],4,-378558),g,v,n[e+8],11,-2022574463),l,g,n[e+11],16,1839030562),m,l,n[e+14],23,-35309556),v=c(v,m=c(m,l=c(l,g,v,m,n[e+1],4,-1530992060),g,v,n[e+4],11,1272893353),l,g,n[e+7],16,-155497632),m,l,n[e+10],23,-1094730640),v=c(v,m=c(m,l=c(l,g,v,m,n[e+13],4,681279174),g,v,n[e],11,-358537222),l,g,n[e+3],16,-722521979),m,l,n[e+6],23,76029189),v=c(v,m=c(m,l=c(l,g,v,m,n[e+9],4,-640364487),g,v,n[e+12],11,-421815835),l,g,n[e+15],16,530742520),m,l,n[e+2],23,-995338651),v=f(v,m=f(m,l=f(l,g,v,m,n[e],6,-198630844),g,v,n[e+7],10,1126891415),l,g,n[e+14],15,-1416354905),m,l,n[e+5],21,-57434055),v=f(v,m=f(m,l=f(l,g,v,m,n[e+12],6,1700485571),g,v,n[e+3],10,-1894986606),l,g,n[e+10],15,-1051523),m,l,n[e+1],21,-2054922799),v=f(v,m=f(m,l=f(l,g,v,m,n[e+8],6,1873313359),g,v,n[e+15],10,-30611744),l,g,n[e+6],15,-1560198380),m,l,n[e+13],21,1309151649),v=f(v,m=f(m,l=f(l,g,v,m,n[e+4],6,-145523070),g,v,n[e+11],10,-1120210379),l,g,n[e+2],15,718787259),m,l,n[e+9],21,-343485551),l=t(l,i),g=t(g,a),v=t(v,d),m=t(m,h);return[l,g,v,m]}function a(n){var t,r="",e=32*n.length;for(t=0;t<e;t+=8)r+=String.fromCharCode(n[t>>5]>>>t%32&255);return r}function d(n){var t,r=[];for(r[(n.length>>2)-1]=void 0,t=0;t<r.length;t+=1)r[t]=0;var e=8*n.length;for(t=0;t<e;t+=8)r[t>>5]|=(255&n.charCodeAt(t/8))<<t%32;return r}function h(n){return a(i(d(n),8*n.length))}function l(n,t){var r,e,o=d(n),u=[],c=[];for(u[15]=c[15]=void 0,o.length>16&&(o=i(o,8*n.length)),r=0;r<16;r+=1)u[r]=909522486^o[r],c[r]=1549556828^o[r];return e=i(u.concat(d(t)),512+8*t.length),a(i(c.concat(e),640))}function g(n){var t,r,e="";for(r=0;r<n.length;r+=1)t=n.charCodeAt(r),e+="0123456789abcdef".charAt(t>>>4&15)+"0123456789abcdef".charAt(15&t);return e}function v(n){return unescape(encodeURIComponent(n))}function m(n){return h(v(n))}function p(n){return g(m(n))}function s(n,t){return l(v(n),v(t))}function C(n,t){return g(s(n,t))}function A(n,t,r){return t?r?s(t,n):C(t,n):r?m(n):p(n)}"function"==typeof define&&define.amd?define(function(){return A}):"object"==typeof module&&module.exports?module.exports=A:n.md5=A}(this);

// TEALIUM BEGIN

// Common tealium code for all brands

if(typeof tealium_data2track === 'undefined'){
    tealium_data2track = [];
}

function getSunOpticalCategoryName(categoryName){
    var catTokenArray = categoryName.split("-");

    for (var i=0; i<catTokenArray.length; i++){
        var currentToken = catTokenArray[i].toLowerCase();
        switch (currentToken){
            case "optical":
                return "OPTICS";
            case "sun":
                return "SUN";
            case "contact_lens":
                return "CONTACT LENSES";
            case "accessories":
                return "ACCESSORIES";
        }
    }
    // HB-1585: other than SUN/OPTICS, return empty, for now.
    return "";
}

/*HB-5614*/
function getCategoryName(categoryName,splitCrit){
    var catTokenArray = categoryName.split(splitCrit);

    for (var i=0; i<catTokenArray.length; i++){
        var currentToken = catTokenArray[i].toLowerCase();
        switch (currentToken){
            case "optical":
                return "OPTICS";
            case "sun":
                return "SUN";
            case "contact_lens":
                return "CONTACT LENSES";
            case "accessories":
                return "ACCESSORIES";
        }
    }
    return "";
}
/*End 5614*/

//Equivalent to $(document).ready() in plain javascript
document.addEventListener("DOMContentLoaded", function(event) {
    addTrackingToCarouselLinks();

    if (isOliver){
        hardCodeDataElementIdsOP();
    }
});

/* HB-11391 BEGIN Add data-element-id tracking on Carousel links */
function addTrackingToCarouselLinks(){
    $(document).off('click','.owl-carousel a').on('click','.owl-carousel a',onClickHandler);

    function onClickHandler(){
	    tealium_data2track.push({
	        id:'Click',
	        Click_FocusElement:this,
	        Tracking_Type: 'hiddenaction'
	    });
    }
}
/* HB-11391 END */

/* HB-2405 BEGIN Add Analytics tracking in catalog entry widget */
function hardCodeDataElementIdsOP(){
    var elements = document.querySelectorAll(".home-page [data-slot-id='3'] [data-element-id='X_product']");
    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        element.setAttribute("data-element-id","X_zone2_product");
    }

    elements = document.querySelectorAll(".home-page [data-slot-id='4'] [data-element-id='X_product']");
    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        element.setAttribute("data-element-id","X_NewArrivals_product");
    }
}
/* HB-2405 END */

/* HB-2885 BEGIN Add analytics info to MyAccount */
function updateTealiumUserInfo(){
    var userEmailOptin = 0;
    var userEmail;
    var userId;

    getAjaxPromise("/wcs/resources/store/" + WCParamJS.storeId + "/person/@self")
    .then(function(userData){
        if (typeof userData.email1 !== 'undefined' && userData.email1 != ""){
            userEmail = userData.email1;
            userId = userData.userId;
            return getAjaxPromise("/wcs/resources/store/" + WCParamJS.storeId + "/customNewsletterInfo/byEmail/" + userData.email1);
        }
    })
    .then(function(newsletterData){
        if(typeof newsletterData.newsletterInfo.email !== 'undefined'){
            //The user is in the newsletter
            userEmailOptin = 1;
        }

        var obj = {
            'id' : 'Account-Create',
            'User_LoginStatus' : 'Logged',
            'User_VtoStatus' : '',
            'User_EmailOptin' : userEmailOptin,
            'User_Email_MD5' : md5(userEmail).toString(),
            'User_Phone_MD5' : userEmail.toString(),
            'User_Phone_SHA256' : userEmail.toString(),
            'User_Segments' : '',
            'User_Id' : userId
        }
        tealium_data2track.push(obj);
        console.log("TEALIUM::User info updated and sent");
    })
    .catch(function(error){
        console.log(error);
    });
}
/* HB-2885 END */

/*HB-5965 */
function pushDiscountCode(obj) {
	 tealium_data2track.push(obj);
     sessionStorage.Order_DiscountCode = obj.Order_DiscountCode.split(' ')[0];
     sessionStorage.Order_DiscountName = obj.Order_DiscountName;
     console.log("TEALIUM::Discount Code info updated and sent");
	
}
// TEALIUM END

function validatePhoneForE164(phoneNumber) {
    const regEx = /^\+[1-9]\d{10,14}$/;

    return regEx.test(phoneNumber);
}
/**
 * bxSlider v4.2.12
 * Copyright 2013-2015 Steven Wanderski
 * Written while drinking Belgian ales and listening to jazz
 * Licensed under MIT (http://opensource.org/licenses/MIT)
 */

;(function($) {

  var defaults = {

    // GENERAL
    mode: 'horizontal',
    slideSelector: '',
    infiniteLoop: true,
    hideControlOnEnd: false,
    speed: 500,
    easing: null,
    slideMargin: 0,
    startSlide: 0,
    randomStart: false,
    captions: false,
    ticker: false,
    tickerHover: false,
    adaptiveHeight: false,
    adaptiveHeightSpeed: 500,
    video: false,
    useCSS: true,
    preloadImages: 'visible',
    responsive: true,
    slideZIndex: 50,
    wrapperClass: 'bx-wrapper',

    // TOUCH
    touchEnabled: true,
    swipeThreshold: 50,
    oneToOneTouch: true,
    preventDefaultSwipeX: true,
    preventDefaultSwipeY: false,

    // ACCESSIBILITY
    ariaLive: true,
    ariaHidden: true,

    // KEYBOARD
    keyboardEnabled: false,

    // PAGER
    pager: true,
    pagerType: 'full',
    pagerShortSeparator: ' / ',
    pagerSelector: null,
    buildPager: null,
    pagerCustom: null,

    // CONTROLS
    controls: true,
    nextText: 'Next',
    prevText: 'Prev',
    nextSelector: null,
    prevSelector: null,
    autoControls: false,
    startText: 'Start',
    stopText: 'Stop',
    autoControlsCombine: false,
    autoControlsSelector: null,

    // AUTO
    auto: false,
    pause: 4000,
    autoStart: true,
    autoDirection: 'next',
    stopAutoOnClick: false,
    autoHover: false,
    autoDelay: 0,
    autoSlideForOnePage: false,

    // CAROUSEL
    minSlides: 1,
    maxSlides: 1,
    moveSlides: 0,
    slideWidth: 0,
    shrinkItems: false,

    // CALLBACKS
    onSliderLoad: function() { return true; },
    onSlideBefore: function() { return true; },
    onSlideAfter: function() { return true; },
    onSlideNext: function() { return true; },
    onSlidePrev: function() { return true; },
    onSliderResize: function() { return true; }
  };

  $.fn.bxSlider = function(options) {

    if (this.length === 0) {
      return this;
    }

    // support multiple elements
    if (this.length > 1) {
      this.each(function() {
        $(this).bxSlider(options);
      });
      return this;
    }

    // create a namespace to be used throughout the plugin
    var slider = {},
    // set a reference to our slider element
    el = this,
    // get the original window dimens (thanks a lot IE)
    windowWidth = $(window).width(),
    windowHeight = $(window).height();

    // Return if slider is already initialized
    if ($(el).data('bxSlider')) { return; }

    /**
     * ===================================================================================
     * = PRIVATE FUNCTIONS
     * ===================================================================================
     */

    /**
     * Initializes namespace settings to be used throughout plugin
     */
    var init = function() {
      // Return if slider is already initialized
      if ($(el).data('bxSlider')) { return; }
      // merge user-supplied options with the defaults
      slider.settings = $.extend({}, defaults, options);
      // parse slideWidth setting
      slider.settings.slideWidth = parseInt(slider.settings.slideWidth);
      // store the original children
      slider.children = el.children(slider.settings.slideSelector);
      // check if actual number of slides is less than minSlides / maxSlides
      if (slider.children.length < slider.settings.minSlides) { slider.settings.minSlides = slider.children.length; }
      if (slider.children.length < slider.settings.maxSlides) { slider.settings.maxSlides = slider.children.length; }
      // if random start, set the startSlide setting to random number
      if (slider.settings.randomStart) { slider.settings.startSlide = Math.floor(Math.random() * slider.children.length); }
      // store active slide information
      slider.active = { index: slider.settings.startSlide };
      // store if the slider is in carousel mode (displaying / moving multiple slides)
      slider.carousel = slider.settings.minSlides > 1 || slider.settings.maxSlides > 1 ? true : false;
      // if carousel, force preloadImages = 'all'
      if (slider.carousel) { slider.settings.preloadImages = 'all'; }
      // calculate the min / max width thresholds based on min / max number of slides
      // used to setup and update carousel slides dimensions
      slider.minThreshold = (slider.settings.minSlides * slider.settings.slideWidth) + ((slider.settings.minSlides - 1) * slider.settings.slideMargin);
      slider.maxThreshold = (slider.settings.maxSlides * slider.settings.slideWidth) + ((slider.settings.maxSlides - 1) * slider.settings.slideMargin);
      // store the current state of the slider (if currently animating, working is true)
      slider.working = false;
      // initialize the controls object
      slider.controls = {};
      // initialize an auto interval
      slider.interval = null;
      // determine which property to use for transitions
      slider.animProp = slider.settings.mode === 'vertical' ? 'top' : 'left';
      // determine if hardware acceleration can be used
      slider.usingCSS = slider.settings.useCSS && slider.settings.mode !== 'fade' && (function() {
        // create our test div element
        var div = document.createElement('div'),
        // css transition properties
        props = ['WebkitPerspective', 'MozPerspective', 'OPerspective', 'msPerspective'];
        // test for each property
        for (var i = 0; i < props.length; i++) {
          if (div.style[props[i]] !== undefined) {
            slider.cssPrefix = props[i].replace('Perspective', '').toLowerCase();
            slider.animProp = '-' + slider.cssPrefix + '-transform';
            return true;
          }
        }
        return false;
      }());
      // if vertical mode always make maxSlides and minSlides equal
      if (slider.settings.mode === 'vertical') { slider.settings.maxSlides = slider.settings.minSlides; }
      // save original style data
      el.data('origStyle', el.attr('style'));
      el.children(slider.settings.slideSelector).each(function() {
        $(this).data('origStyle', $(this).attr('style'));
      });

      // perform all DOM / CSS modifications
      setup();
    };

    /**
     * Performs all DOM and CSS modifications
     */
    var setup = function() {
      var preloadSelector = slider.children.eq(slider.settings.startSlide); // set the default preload selector (visible)

      // wrap el in a wrapper
      el.wrap('<div class="' + slider.settings.wrapperClass + '"><div class="bx-viewport"></div></div>');
      // store a namespace reference to .bx-viewport
      slider.viewport = el.parent();

      // add aria-live if the setting is enabled and ticker mode is disabled
      if (slider.settings.ariaLive && !slider.settings.ticker) {
        slider.viewport.attr('aria-live', 'polite');
      }
      // add a loading div to display while images are loading
      slider.loader = $('<div class="bx-loading" />');
      slider.viewport.prepend(slider.loader);
      // set el to a massive width, to hold any needed slides
      // also strip any margin and padding from el
      el.css({
        width: slider.settings.mode === 'horizontal' ? (slider.children.length * 1000 + 215) + '%' : 'auto',
        position: 'relative'
      });
      // if using CSS, add the easing property
      if (slider.usingCSS && slider.settings.easing) {
        el.css('-' + slider.cssPrefix + '-transition-timing-function', slider.settings.easing);
      // if not using CSS and no easing value was supplied, use the default JS animation easing (swing)
      } else if (!slider.settings.easing) {
        slider.settings.easing = 'swing';
      }
      // make modifications to the viewport (.bx-viewport)
      slider.viewport.css({
        width: '100%',
        overflow: 'hidden',
        position: 'relative'
      });
      slider.viewport.parent().css({
        maxWidth: getViewportMaxWidth()
      });
      // apply css to all slider children
      slider.children.css({
        float: slider.settings.mode === 'horizontal' ? 'left' : 'none',
        listStyle: 'none',
        position: 'relative'
      });
      // apply the calculated width after the float is applied to prevent scrollbar interference
      slider.children.css('width', getSlideWidth());
      // if slideMargin is supplied, add the css
      if (slider.settings.mode === 'horizontal' && slider.settings.slideMargin > 0) { slider.children.css('marginRight', slider.settings.slideMargin); }
      if (slider.settings.mode === 'vertical' && slider.settings.slideMargin > 0) { slider.children.css('marginBottom', slider.settings.slideMargin); }
      // if "fade" mode, add positioning and z-index CSS
      if (slider.settings.mode === 'fade') {
        slider.children.css({
          position: 'absolute',
          zIndex: 0,
          display: 'none'
        });
        // prepare the z-index on the showing element
        slider.children.eq(slider.settings.startSlide).css({zIndex: slider.settings.slideZIndex, display: 'block'});
      }
      // create an element to contain all slider controls (pager, start / stop, etc)
      slider.controls.el = $('<div class="bx-controls" />');
      // if captions are requested, add them
      if (slider.settings.captions) { appendCaptions(); }
      // check if startSlide is last slide
      slider.active.last = slider.settings.startSlide === getPagerQty() - 1;
      // if video is true, set up the fitVids plugin
      if (slider.settings.video) { el.fitVids(); }
      if (slider.settings.preloadImages === 'all' || slider.settings.ticker) { preloadSelector = slider.children; }
      // only check for control addition if not in "ticker" mode
      if (!slider.settings.ticker) {
        // if controls are requested, add them
        if (slider.settings.controls) { appendControls(); }
        // if auto is true, and auto controls are requested, add them
        if (slider.settings.auto && slider.settings.autoControls) { appendControlsAuto(); }
        // if pager is requested, add it
        if (slider.settings.pager) { appendPager(); }
        // if any control option is requested, add the controls wrapper
        if (slider.settings.controls || slider.settings.autoControls || slider.settings.pager) { slider.viewport.after(slider.controls.el); }
      // if ticker mode, do not allow a pager
      } else {
        slider.settings.pager = false;
      }
      loadElements(preloadSelector, start);
    };

    var loadElements = function(selector, callback) {
      var total = selector.find('img:not([src=""]), iframe').length,
      count = 0;
      if (total === 0) {
        callback();
        return;
      }
      selector.find('img:not([src=""]), iframe').each(function() {
        $(this).one('load error', function() {
          if (++count === total) { callback(); }
        }).each(function() {
          if (this.complete) { $(this).trigger('load'); }
        });
      });
    };

    /**
     * Start the slider
     */
    var start = function() {
      // if infinite loop, prepare additional slides
      if (slider.settings.infiniteLoop && slider.settings.mode !== 'fade' && !slider.settings.ticker) {
        var slice    = slider.settings.mode === 'vertical' ? slider.settings.minSlides : slider.settings.maxSlides,
        sliceAppend  = slider.children.slice(0, slice).clone(true).addClass('bx-clone'),
        slicePrepend = slider.children.slice(-slice).clone(true).addClass('bx-clone');
        if (slider.settings.ariaHidden) {
          sliceAppend.attr('aria-hidden', true);
          slicePrepend.attr('aria-hidden', true);
        }
        el.append(sliceAppend).prepend(slicePrepend);
      }
      // remove the loading DOM element
      slider.loader.remove();
      // set the left / top position of "el"
      setSlidePosition();
      // if "vertical" mode, always use adaptiveHeight to prevent odd behavior
      if (slider.settings.mode === 'vertical') { slider.settings.adaptiveHeight = true; }
      // set the viewport height
      slider.viewport.height(getViewportHeight());
      // make sure everything is positioned just right (same as a window resize)
      el.redrawSlider();
      // onSliderLoad callback
      slider.settings.onSliderLoad.call(el, slider.active.index);
      // slider has been fully initialized
      slider.initialized = true;
      // bind the resize call to the window
      if (slider.settings.responsive) { $(window).bind('resize', resizeWindow); }
      // if auto is true and has more than 1 page, start the show
      if (slider.settings.auto && slider.settings.autoStart && (getPagerQty() > 1 || slider.settings.autoSlideForOnePage)) { initAuto(); }
      // if ticker is true, start the ticker
      if (slider.settings.ticker) { initTicker(); }
      // if pager is requested, make the appropriate pager link active
      if (slider.settings.pager) { updatePagerActive(slider.settings.startSlide); }
      // check for any updates to the controls (like hideControlOnEnd updates)
      if (slider.settings.controls) { updateDirectionControls(); }
      // if touchEnabled is true, setup the touch events
      if (slider.settings.touchEnabled && !slider.settings.ticker) { initTouch(); }
      // if keyboardEnabled is true, setup the keyboard events
      if (slider.settings.keyboardEnabled && !slider.settings.ticker) {
        $(document).keydown(keyPress);
      }
    };

    /**
     * Returns the calculated height of the viewport, used to determine either adaptiveHeight or the maxHeight value
     */
    var getViewportHeight = function() {
      var height = 0;
      // first determine which children (slides) should be used in our height calculation
      var children = $();
      // if mode is not "vertical" and adaptiveHeight is false, include all children
      if (slider.settings.mode !== 'vertical' && !slider.settings.adaptiveHeight) {
        children = slider.children;
      } else {
        // if not carousel, return the single active child
        if (!slider.carousel) {
          children = slider.children.eq(slider.active.index);
        // if carousel, return a slice of children
        } else {
          // get the individual slide index
          var currentIndex = slider.settings.moveSlides === 1 ? slider.active.index : slider.active.index * getMoveBy();
          // add the current slide to the children
          children = slider.children.eq(currentIndex);
          // cycle through the remaining "showing" slides
          for (i = 1; i <= slider.settings.maxSlides - 1; i++) {
            // if looped back to the start
            if (currentIndex + i >= slider.children.length) {
              children = children.add(slider.children.eq(i - 1));
            } else {
              children = children.add(slider.children.eq(currentIndex + i));
            }
          }
        }
      }
      // if "vertical" mode, calculate the sum of the heights of the children
      if (slider.settings.mode === 'vertical') {
        children.each(function(index) {
          height += $(this).outerHeight();
        });
        // add user-supplied margins
        if (slider.settings.slideMargin > 0) {
          height += slider.settings.slideMargin * (slider.settings.minSlides - 1);
        }
      // if not "vertical" mode, calculate the max height of the children
      } else {
        height = Math.max.apply(Math, children.map(function() {
          return $(this).outerHeight(false);
        }).get());
      }

      if (slider.viewport.css('box-sizing') === 'border-box') {
        height += parseFloat(slider.viewport.css('padding-top')) + parseFloat(slider.viewport.css('padding-bottom')) +
              parseFloat(slider.viewport.css('border-top-width')) + parseFloat(slider.viewport.css('border-bottom-width'));
      } else if (slider.viewport.css('box-sizing') === 'padding-box') {
        height += parseFloat(slider.viewport.css('padding-top')) + parseFloat(slider.viewport.css('padding-bottom'));
      }

      return height;
    };

    /**
     * Returns the calculated width to be used for the outer wrapper / viewport
     */
    var getViewportMaxWidth = function() {
      var width = '100%';
      if (slider.settings.slideWidth > 0) {
        if (slider.settings.mode === 'horizontal') {
          width = (slider.settings.maxSlides * slider.settings.slideWidth) + ((slider.settings.maxSlides - 1) * slider.settings.slideMargin);
        } else {
          width = slider.settings.slideWidth;
        }
      }
      return width;
    };

    /**
     * Returns the calculated width to be applied to each slide
     */
    var getSlideWidth = function() {
      var newElWidth = slider.settings.slideWidth, // start with any user-supplied slide width
      wrapWidth      = slider.viewport.width();    // get the current viewport width
      // if slide width was not supplied, or is larger than the viewport use the viewport width
      if (slider.settings.slideWidth === 0 ||
        (slider.settings.slideWidth > wrapWidth && !slider.carousel) ||
        slider.settings.mode === 'vertical') {
        newElWidth = wrapWidth;
      // if carousel, use the thresholds to determine the width
      } else if (slider.settings.maxSlides > 1 && slider.settings.mode === 'horizontal') {
        if (wrapWidth > slider.maxThreshold) {
          return newElWidth;
        } else if (wrapWidth < slider.minThreshold) {
          newElWidth = (wrapWidth - (slider.settings.slideMargin * (slider.settings.minSlides - 1))) / slider.settings.minSlides;
        } else if (slider.settings.shrinkItems) {
          newElWidth = Math.floor((wrapWidth + slider.settings.slideMargin) / (Math.ceil((wrapWidth + slider.settings.slideMargin) / (newElWidth + slider.settings.slideMargin))) - slider.settings.slideMargin);
        }
      }
      return newElWidth;
    };

    /**
     * Returns the number of slides currently visible in the viewport (includes partially visible slides)
     */
    var getNumberSlidesShowing = function() {
      var slidesShowing = 1,
      childWidth = null;
      if (slider.settings.mode === 'horizontal' && slider.settings.slideWidth > 0) {
        // if viewport is smaller than minThreshold, return minSlides
        if (slider.viewport.width() < slider.minThreshold) {
          slidesShowing = slider.settings.minSlides;
        // if viewport is larger than maxThreshold, return maxSlides
        } else if (slider.viewport.width() > slider.maxThreshold) {
          slidesShowing = slider.settings.maxSlides;
        // if viewport is between min / max thresholds, divide viewport width by first child width
        } else {
          childWidth = slider.children.first().width() + slider.settings.slideMargin;
          slidesShowing = Math.floor((slider.viewport.width() +
            slider.settings.slideMargin) / childWidth);
        }
      // if "vertical" mode, slides showing will always be minSlides
      } else if (slider.settings.mode === 'vertical') {
        slidesShowing = slider.settings.minSlides;
      }
      return slidesShowing;
    };

    /**
     * Returns the number of pages (one full viewport of slides is one "page")
     */
    var getPagerQty = function() {
      var pagerQty = 0,
      breakPoint = 0,
      counter = 0;
      // if moveSlides is specified by the user
      if (slider.settings.moveSlides > 0) {
        if (slider.settings.infiniteLoop) {
          pagerQty = Math.ceil(slider.children.length / getMoveBy());
        } else {
          // when breakpoint goes above children length, counter is the number of pages
          while (breakPoint < slider.children.length) {
            ++pagerQty;
            breakPoint = counter + getNumberSlidesShowing();
            counter += slider.settings.moveSlides <= getNumberSlidesShowing() ? slider.settings.moveSlides : getNumberSlidesShowing();
          }
        }
      // if moveSlides is 0 (auto) divide children length by sides showing, then round up
      } else {
        pagerQty = Math.ceil(slider.children.length / getNumberSlidesShowing());
      }
      return pagerQty;
    };

    /**
     * Returns the number of individual slides by which to shift the slider
     */
    var getMoveBy = function() {
      // if moveSlides was set by the user and moveSlides is less than number of slides showing
      if (slider.settings.moveSlides > 0 && slider.settings.moveSlides <= getNumberSlidesShowing()) {
        return slider.settings.moveSlides;
      }
      // if moveSlides is 0 (auto)
      return getNumberSlidesShowing();
    };

    /**
     * Sets the slider's (el) left or top position
     */
    var setSlidePosition = function() {
      var position, lastChild, lastShowingIndex;
      // if last slide, not infinite loop, and number of children is larger than specified maxSlides
      if (slider.children.length > slider.settings.maxSlides && slider.active.last && !slider.settings.infiniteLoop) {
        if (slider.settings.mode === 'horizontal') {
          // get the last child's position
          lastChild = slider.children.last();
          position = lastChild.position();
          // set the left position
          setPositionProperty(-(position.left - (slider.viewport.width() - lastChild.outerWidth())), 'reset', 0);
        } else if (slider.settings.mode === 'vertical') {
          // get the last showing index's position
          lastShowingIndex = slider.children.length - slider.settings.minSlides;
          position = slider.children.eq(lastShowingIndex).position();
          // set the top position
          setPositionProperty(-position.top, 'reset', 0);
        }
      // if not last slide
      } else {
        // get the position of the first showing slide
        position = slider.children.eq(slider.active.index * getMoveBy()).position();
        // check for last slide
        if (slider.active.index === getPagerQty() - 1) { slider.active.last = true; }
        // set the respective position
        if (position !== undefined) {
          if (slider.settings.mode === 'horizontal') { setPositionProperty(-position.left, 'reset', 0); }
          else if (slider.settings.mode === 'vertical') { setPositionProperty(-position.top, 'reset', 0); }
        }
      }
    };

    /**
     * Sets the el's animating property position (which in turn will sometimes animate el).
     * If using CSS, sets the transform property. If not using CSS, sets the top / left property.
     *
     * @param value (int)
     *  - the animating property's value
     *
     * @param type (string) 'slide', 'reset', 'ticker'
     *  - the type of instance for which the function is being
     *
     * @param duration (int)
     *  - the amount of time (in ms) the transition should occupy
     *
     * @param params (array) optional
     *  - an optional parameter containing any variables that need to be passed in
     */
    var setPositionProperty = function(value, type, duration, params) {
      var animateObj, propValue;
      // use CSS transform
      if (slider.usingCSS) {
        // determine the translate3d value
        propValue = slider.settings.mode === 'vertical' ? 'translate3d(0, ' + value + 'px, 0)' : 'translate3d(' + value + 'px, 0, 0)';
        // add the CSS transition-duration
        el.css('-' + slider.cssPrefix + '-transition-duration', duration / 1000 + 's');
        if (type === 'slide') {
          // set the property value
          el.css(slider.animProp, propValue);
          if (duration !== 0) {
            // bind a callback method - executes when CSS transition completes
            el.bind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function(e) {
              //make sure it's the correct one
              if (!$(e.target).is(el)) { return; }
              // unbind the callback
              el.unbind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
              updateAfterSlideTransition();
            });
          } else { //duration = 0
            updateAfterSlideTransition();
          }
        } else if (type === 'reset') {
          el.css(slider.animProp, propValue);
        } else if (type === 'ticker') {
          // make the transition use 'linear'
          el.css('-' + slider.cssPrefix + '-transition-timing-function', 'linear');
          el.css(slider.animProp, propValue);
          if (duration !== 0) {
            el.bind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function(e) {
              //make sure it's the correct one
              if (!$(e.target).is(el)) { return; }
              // unbind the callback
              el.unbind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
              // reset the position
              setPositionProperty(params.resetValue, 'reset', 0);
              // start the loop again
              tickerLoop();
            });
          } else { //duration = 0
            setPositionProperty(params.resetValue, 'reset', 0);
            tickerLoop();
          }
        }
      // use JS animate
      } else {
        animateObj = {};
        animateObj[slider.animProp] = value;
        if (type === 'slide') {
          el.animate(animateObj, duration, slider.settings.easing, function() {
            updateAfterSlideTransition();
          });
        } else if (type === 'reset') {
          el.css(slider.animProp, value);
        } else if (type === 'ticker') {
          el.animate(animateObj, duration, 'linear', function() {
            setPositionProperty(params.resetValue, 'reset', 0);
            // run the recursive loop after animation
            tickerLoop();
          });
        }
      }
    };

    /**
     * Populates the pager with proper amount of pages
     */
    var populatePager = function() {
      var pagerHtml = '',
      linkContent = '',
      pagerQty = getPagerQty();
      // loop through each pager item
      for (var i = 0; i < pagerQty; i++) {
        linkContent = '';
        // if a buildPager function is supplied, use it to get pager link value, else use index + 1
        if (slider.settings.buildPager && $.isFunction(slider.settings.buildPager) || slider.settings.pagerCustom) {
          linkContent = slider.settings.buildPager(i);
          slider.pagerEl.addClass('bx-custom-pager');
        } else {
          linkContent = i + 1;
          slider.pagerEl.addClass('bx-default-pager');
        }
        // var linkContent = slider.settings.buildPager && $.isFunction(slider.settings.buildPager) ? slider.settings.buildPager(i) : i + 1;
        // add the markup to the string
        pagerHtml += '<div class="bx-pager-item"><a href="" data-slide-index="' + i + '" class="bx-pager-link">' + linkContent + '</a></div>';
      }
      // populate the pager element with pager links
      slider.pagerEl.html(pagerHtml);
    };

    /**
     * Appends the pager to the controls element
     */
    var appendPager = function() {
      if (!slider.settings.pagerCustom) {
        // create the pager DOM element
        slider.pagerEl = $('<div class="bx-pager" />');
        // if a pager selector was supplied, populate it with the pager
        if (slider.settings.pagerSelector) {
          $(slider.settings.pagerSelector).html(slider.pagerEl);
        // if no pager selector was supplied, add it after the wrapper
        } else {
          slider.controls.el.addClass('bx-has-pager').append(slider.pagerEl);
        }
        // populate the pager
        populatePager();
      } else {
        slider.pagerEl = $(slider.settings.pagerCustom);
      }
      // assign the pager click binding
      slider.pagerEl.on('click touchend', 'a', clickPagerBind);
    };

    /**
     * Appends prev / next controls to the controls element
     */
    var appendControls = function() {
      slider.controls.next = $('<a class="bx-next" href="">' + slider.settings.nextText + '</a>');
      slider.controls.prev = $('<a class="bx-prev" href="">' + slider.settings.prevText + '</a>');
      // bind click actions to the controls
      slider.controls.next.bind('click touchend', clickNextBind);
      slider.controls.prev.bind('click touchend', clickPrevBind);
      // if nextSelector was supplied, populate it
      if (slider.settings.nextSelector) {
        $(slider.settings.nextSelector).append(slider.controls.next);
      }
      // if prevSelector was supplied, populate it
      if (slider.settings.prevSelector) {
        $(slider.settings.prevSelector).append(slider.controls.prev);
      }
      // if no custom selectors were supplied
      if (!slider.settings.nextSelector && !slider.settings.prevSelector) {
        // add the controls to the DOM
        slider.controls.directionEl = $('<div class="bx-controls-direction" />');
        // add the control elements to the directionEl
        slider.controls.directionEl.append(slider.controls.prev).append(slider.controls.next);
        // slider.viewport.append(slider.controls.directionEl);
        slider.controls.el.addClass('bx-has-controls-direction').append(slider.controls.directionEl);
      }
    };

    /**
     * Appends start / stop auto controls to the controls element
     */
    var appendControlsAuto = function() {
      slider.controls.start = $('<div class="bx-controls-auto-item"><a class="bx-start" href="">' + slider.settings.startText + '</a></div>');
      slider.controls.stop = $('<div class="bx-controls-auto-item"><a class="bx-stop" href="">' + slider.settings.stopText + '</a></div>');
      // add the controls to the DOM
      slider.controls.autoEl = $('<div class="bx-controls-auto" />');
      // bind click actions to the controls
      slider.controls.autoEl.on('click', '.bx-start', clickStartBind);
      slider.controls.autoEl.on('click', '.bx-stop', clickStopBind);
      // if autoControlsCombine, insert only the "start" control
      if (slider.settings.autoControlsCombine) {
        slider.controls.autoEl.append(slider.controls.start);
      // if autoControlsCombine is false, insert both controls
      } else {
        slider.controls.autoEl.append(slider.controls.start).append(slider.controls.stop);
      }
      // if auto controls selector was supplied, populate it with the controls
      if (slider.settings.autoControlsSelector) {
        $(slider.settings.autoControlsSelector).html(slider.controls.autoEl);
      // if auto controls selector was not supplied, add it after the wrapper
      } else {
        slider.controls.el.addClass('bx-has-controls-auto').append(slider.controls.autoEl);
      }
      // update the auto controls
      updateAutoControls(slider.settings.autoStart ? 'stop' : 'start');
    };

    /**
     * Appends image captions to the DOM
     */
    var appendCaptions = function() {
      // cycle through each child
      slider.children.each(function(index) {
        // get the image title attribute
        var title = $(this).find('img:first').attr('title');
        // append the caption
        if (title !== undefined && ('' + title).length) {
          $(this).append('<div class="bx-caption"><span>' + title + '</span></div>');
        }
      });
    };

    /**
     * Click next binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickNextBind = function(e) {
      e.preventDefault();
      if (slider.controls.el.hasClass('disabled')) { return; }
      // if auto show is running, stop it
      if (slider.settings.auto && slider.settings.stopAutoOnClick) { el.stopAuto(); }
      el.goToNextSlide();
    };

    /**
     * Click prev binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickPrevBind = function(e) {
      e.preventDefault();
      if (slider.controls.el.hasClass('disabled')) { return; }
      // if auto show is running, stop it
      if (slider.settings.auto && slider.settings.stopAutoOnClick) { el.stopAuto(); }
      el.goToPrevSlide();
    };

    /**
     * Click start binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickStartBind = function(e) {
      el.startAuto();
      e.preventDefault();
    };

    /**
     * Click stop binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickStopBind = function(e) {
      el.stopAuto();
      e.preventDefault();
    };

    /**
     * Click pager binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickPagerBind = function(e) {
      var pagerLink, pagerIndex;
      e.preventDefault();
      if (slider.controls.el.hasClass('disabled')) {
        return;
      }
      // if auto show is running, stop it
      if (slider.settings.auto  && slider.settings.stopAutoOnClick) { el.stopAuto(); }
      pagerLink = $(e.currentTarget);
      if (pagerLink.attr('data-slide-index') !== undefined) {
        pagerIndex = parseInt(pagerLink.attr('data-slide-index'));
        // if clicked pager link is not active, continue with the goToSlide call
        if (pagerIndex !== slider.active.index) { el.goToSlide(pagerIndex); }
      }
    };

    /**
     * Updates the pager links with an active class
     *
     * @param slideIndex (int)
     *  - index of slide to make active
     */
    var updatePagerActive = function(slideIndex) {
      // if "short" pager type
      var len = slider.children.length; // nb of children
      if (slider.settings.pagerType === 'short') {
        if (slider.settings.maxSlides > 1) {
          len = Math.ceil(slider.children.length / slider.settings.maxSlides);
        }
        slider.pagerEl.html((slideIndex + 1) + slider.settings.pagerShortSeparator + len);
        return;
      }
      // remove all pager active classes
      slider.pagerEl.find('a').removeClass('active');
      // apply the active class for all pagers
      slider.pagerEl.each(function(i, el) { $(el).find('a').eq(slideIndex).addClass('active'); });
    };

    /**
     * Performs needed actions after a slide transition
     */
    var updateAfterSlideTransition = function() {
      // if infinite loop is true
      if (slider.settings.infiniteLoop) {
        var position = '';
        // first slide
        if (slider.active.index === 0) {
          // set the new position
          position = slider.children.eq(0).position();
        // carousel, last slide
        } else if (slider.active.index === getPagerQty() - 1 && slider.carousel) {
          position = slider.children.eq((getPagerQty() - 1) * getMoveBy()).position();
        // last slide
        } else if (slider.active.index === slider.children.length - 1) {
          position = slider.children.eq(slider.children.length - 1).position();
        }
        if (position) {
          if (slider.settings.mode === 'horizontal') { setPositionProperty(-position.left, 'reset', 0); }
          else if (slider.settings.mode === 'vertical') { setPositionProperty(-position.top, 'reset', 0); }
        }
      }
      // declare that the transition is complete
      slider.working = false;
      // onSlideAfter callback
      slider.settings.onSlideAfter.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index);
    };

    /**
     * Updates the auto controls state (either active, or combined switch)
     *
     * @param state (string) "start", "stop"
     *  - the new state of the auto show
     */
    var updateAutoControls = function(state) {
      // if autoControlsCombine is true, replace the current control with the new state
      if (slider.settings.autoControlsCombine) {
        slider.controls.autoEl.html(slider.controls[state]);
      // if autoControlsCombine is false, apply the "active" class to the appropriate control
      } else {
        slider.controls.autoEl.find('a').removeClass('active');
        slider.controls.autoEl.find('a:not(.bx-' + state + ')').addClass('active');
      }
    };

    /**
     * Updates the direction controls (checks if either should be hidden)
     */
    var updateDirectionControls = function() {
      if (getPagerQty() === 1) {
        slider.controls.prev.addClass('disabled');
        slider.controls.next.addClass('disabled');
      } else if (!slider.settings.infiniteLoop && slider.settings.hideControlOnEnd) {
        // if first slide
        if (slider.active.index === 0) {
          slider.controls.prev.addClass('disabled');
          slider.controls.next.removeClass('disabled');
        // if last slide
        } else if (slider.active.index === getPagerQty() - 1) {
          slider.controls.next.addClass('disabled');
          slider.controls.prev.removeClass('disabled');
        // if any slide in the middle
        } else {
          slider.controls.prev.removeClass('disabled');
          slider.controls.next.removeClass('disabled');
        }
      }
    };

    /**
     * Initializes the auto process
     */
    var initAuto = function() {
      // if autoDelay was supplied, launch the auto show using a setTimeout() call
      if (slider.settings.autoDelay > 0) {
        var timeout = setTimeout(el.startAuto, slider.settings.autoDelay);
      // if autoDelay was not supplied, start the auto show normally
      } else {
        el.startAuto();

        //add focus and blur events to ensure its running if timeout gets paused
        $(window).focus(function() {
          el.startAuto();
        }).blur(function() {
          el.stopAuto();
        });
      }
      // if autoHover is requested
      if (slider.settings.autoHover) {
        // on el hover
        el.hover(function() {
          // if the auto show is currently playing (has an active interval)
          if (slider.interval) {
            // stop the auto show and pass true argument which will prevent control update
            el.stopAuto(true);
            // create a new autoPaused value which will be used by the relative "mouseout" event
            slider.autoPaused = true;
          }
        }, function() {
          // if the autoPaused value was created be the prior "mouseover" event
          if (slider.autoPaused) {
            // start the auto show and pass true argument which will prevent control update
            el.startAuto(true);
            // reset the autoPaused value
            slider.autoPaused = null;
          }
        });
      }
    };

    /**
     * Initializes the ticker process
     */
    var initTicker = function() {
      var startPosition = 0,
      position, transform, value, idx, ratio, property, newSpeed, totalDimens;
      // if autoDirection is "next", append a clone of the entire slider
      if (slider.settings.autoDirection === 'next') {
        el.append(slider.children.clone().addClass('bx-clone'));
      // if autoDirection is "prev", prepend a clone of the entire slider, and set the left position
      } else {
        el.prepend(slider.children.clone().addClass('bx-clone'));
        position = slider.children.first().position();
        startPosition = slider.settings.mode === 'horizontal' ? -position.left : -position.top;
      }
      setPositionProperty(startPosition, 'reset', 0);
      // do not allow controls in ticker mode
      slider.settings.pager = false;
      slider.settings.controls = false;
      slider.settings.autoControls = false;
      // if autoHover is requested
      if (slider.settings.tickerHover) {
        if (slider.usingCSS) {
          idx = slider.settings.mode === 'horizontal' ? 4 : 5;
          slider.viewport.hover(function() {
            transform = el.css('-' + slider.cssPrefix + '-transform');
            value = parseFloat(transform.split(',')[idx]);
            setPositionProperty(value, 'reset', 0);
          }, function() {
            totalDimens = 0;
            slider.children.each(function(index) {
              totalDimens += slider.settings.mode === 'horizontal' ? $(this).outerWidth(true) : $(this).outerHeight(true);
            });
            // calculate the speed ratio (used to determine the new speed to finish the paused animation)
            ratio = slider.settings.speed / totalDimens;
            // determine which property to use
            property = slider.settings.mode === 'horizontal' ? 'left' : 'top';
            // calculate the new speed
            newSpeed = ratio * (totalDimens - (Math.abs(parseInt(value))));
            tickerLoop(newSpeed);
          });
        } else {
          // on el hover
          slider.viewport.hover(function() {
            el.stop();
          }, function() {
            // calculate the total width of children (used to calculate the speed ratio)
            totalDimens = 0;
            slider.children.each(function(index) {
              totalDimens += slider.settings.mode === 'horizontal' ? $(this).outerWidth(true) : $(this).outerHeight(true);
            });
            // calculate the speed ratio (used to determine the new speed to finish the paused animation)
            ratio = slider.settings.speed / totalDimens;
            // determine which property to use
            property = slider.settings.mode === 'horizontal' ? 'left' : 'top';
            // calculate the new speed
            newSpeed = ratio * (totalDimens - (Math.abs(parseInt(el.css(property)))));
            tickerLoop(newSpeed);
          });
        }
      }
      // start the ticker loop
      tickerLoop();
    };

    /**
     * Runs a continuous loop, news ticker-style
     */
    var tickerLoop = function(resumeSpeed) {
      var speed = resumeSpeed ? resumeSpeed : slider.settings.speed,
      position = {left: 0, top: 0},
      reset = {left: 0, top: 0},
      animateProperty, resetValue, params;

      // if "next" animate left position to last child, then reset left to 0
      if (slider.settings.autoDirection === 'next') {
        position = el.find('.bx-clone').first().position();
      // if "prev" animate left position to 0, then reset left to first non-clone child
      } else {
        reset = slider.children.first().position();
      }
      animateProperty = slider.settings.mode === 'horizontal' ? -position.left : -position.top;
      resetValue = slider.settings.mode === 'horizontal' ? -reset.left : -reset.top;
      params = {resetValue: resetValue};
      setPositionProperty(animateProperty, 'ticker', speed, params);
    };

    /**
     * Check if el is on screen
     */
    var isOnScreen = function(el) {
      var win = $(window),
      viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
      },
      bounds = el.offset();

      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height();
      bounds.right = bounds.left + el.outerWidth();
      bounds.bottom = bounds.top + el.outerHeight();

      return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    };

    /**
     * Initializes keyboard events
     */
    var keyPress = function(e) {
      var activeElementTag = document.activeElement.tagName.toLowerCase(),
      tagFilters = 'input|textarea',
      p = new RegExp(activeElementTag,['i']),
      result = p.exec(tagFilters);

      if (result == null && isOnScreen(el)) {
        if (e.keyCode === 39) {
          clickNextBind(e);
          return false;
        } else if (e.keyCode === 37) {
          clickPrevBind(e);
          return false;
        }
      }
    };

    /**
     * Initializes touch events
     */
    var initTouch = function() {
      // initialize object to contain all touch values
      slider.touch = {
        start: {x: 0, y: 0},
        end: {x: 0, y: 0}
      };
      slider.viewport.bind('touchstart MSPointerDown pointerdown', onTouchStart);

      //for browsers that have implemented pointer events and fire a click after
      //every pointerup regardless of whether pointerup is on same screen location as pointerdown or not
      slider.viewport.on('click', '.bxslider a', function(e) {
        if (slider.viewport.hasClass('click-disabled')) {
          e.preventDefault();
          slider.viewport.removeClass('click-disabled');
        }
      });
    };

    /**
     * Event handler for "touchstart"
     *
     * @param e (event)
     *  - DOM event object
     */
    var onTouchStart = function(e) {
      //disable slider controls while user is interacting with slides to avoid slider freeze that happens on touch devices when a slide swipe happens immediately after interacting with slider controls
      slider.controls.el.addClass('disabled');

      if (slider.working) {
        e.preventDefault();
        slider.controls.el.removeClass('disabled');
      } else {
        // record the original position when touch starts
        slider.touch.originalPos = el.position();
        var orig = e.originalEvent,
        touchPoints = (typeof orig.changedTouches !== 'undefined') ? orig.changedTouches : [orig];
        // record the starting touch x, y coordinates
        slider.touch.start.x = touchPoints[0].pageX;
        slider.touch.start.y = touchPoints[0].pageY;

        if (slider.viewport.get(0).setPointerCapture) {
          slider.pointerId = orig.pointerId;
          slider.viewport.get(0).setPointerCapture(slider.pointerId);
        }
        // bind a "touchmove" event to the viewport
        slider.viewport.bind('touchmove MSPointerMove pointermove', onTouchMove);
        // bind a "touchend" event to the viewport
        slider.viewport.bind('touchend MSPointerUp pointerup', onTouchEnd);
        slider.viewport.bind('MSPointerCancel pointercancel', onPointerCancel);
      }
    };

    /**
     * Cancel Pointer for Windows Phone
     *
     * @param e (event)
     *  - DOM event object
     */
    var onPointerCancel = function(e) {
      /* onPointerCancel handler is needed to deal with situations when a touchend
      doesn't fire after a touchstart (this happens on windows phones only) */
      setPositionProperty(slider.touch.originalPos.left, 'reset', 0);

      //remove handlers
      slider.controls.el.removeClass('disabled');
      slider.viewport.unbind('MSPointerCancel pointercancel', onPointerCancel);
      slider.viewport.unbind('touchmove MSPointerMove pointermove', onTouchMove);
      slider.viewport.unbind('touchend MSPointerUp pointerup', onTouchEnd);
      if (slider.viewport.get(0).releasePointerCapture) {
        slider.viewport.get(0).releasePointerCapture(slider.pointerId);
      }
    };

    /**
     * Event handler for "touchmove"
     *
     * @param e (event)
     *  - DOM event object
     */
    var onTouchMove = function(e) {
      var orig = e.originalEvent,
      touchPoints = (typeof orig.changedTouches !== 'undefined') ? orig.changedTouches : [orig],
      // if scrolling on y axis, do not prevent default
      xMovement = Math.abs(touchPoints[0].pageX - slider.touch.start.x),
      yMovement = Math.abs(touchPoints[0].pageY - slider.touch.start.y),
      value = 0,
      change = 0;

      // x axis swipe
      if ((xMovement * 3) > yMovement && slider.settings.preventDefaultSwipeX) {
        e.preventDefault();
      // y axis swipe
      } else if ((yMovement * 3) > xMovement && slider.settings.preventDefaultSwipeY) {
        e.preventDefault();
      }
      if (slider.settings.mode !== 'fade' && slider.settings.oneToOneTouch) {
        // if horizontal, drag along x axis
        if (slider.settings.mode === 'horizontal') {
          change = touchPoints[0].pageX - slider.touch.start.x;
          value = slider.touch.originalPos.left + change;
        // if vertical, drag along y axis
        } else {
          change = touchPoints[0].pageY - slider.touch.start.y;
          value = slider.touch.originalPos.top + change;
        }
        setPositionProperty(value, 'reset', 0);
      }
    };

    /**
     * Event handler for "touchend"
     *
     * @param e (event)
     *  - DOM event object
     */
    var onTouchEnd = function(e) {
      slider.viewport.unbind('touchmove MSPointerMove pointermove', onTouchMove);
      //enable slider controls as soon as user stops interacing with slides
      slider.controls.el.removeClass('disabled');
      var orig    = e.originalEvent,
      touchPoints = (typeof orig.changedTouches !== 'undefined') ? orig.changedTouches : [orig],
      value       = 0,
      distance    = 0;
      // record end x, y positions
      slider.touch.end.x = touchPoints[0].pageX;
      slider.touch.end.y = touchPoints[0].pageY;
      // if fade mode, check if absolute x distance clears the threshold
      if (slider.settings.mode === 'fade') {
        distance = Math.abs(slider.touch.start.x - slider.touch.end.x);
        if (distance >= slider.settings.swipeThreshold) {
          if (slider.touch.start.x > slider.touch.end.x) {
            el.goToNextSlide();
          } else {
            el.goToPrevSlide();
          }
          el.stopAuto();
        }
      // not fade mode
      } else {
        // calculate distance and el's animate property
        if (slider.settings.mode === 'horizontal') {
          distance = slider.touch.end.x - slider.touch.start.x;
          value = slider.touch.originalPos.left;
        } else {
          distance = slider.touch.end.y - slider.touch.start.y;
          value = slider.touch.originalPos.top;
        }
        // if not infinite loop and first / last slide, do not attempt a slide transition
        if (!slider.settings.infiniteLoop && ((slider.active.index === 0 && distance > 0) || (slider.active.last && distance < 0))) {
          setPositionProperty(value, 'reset', 200);
        } else {
          // check if distance clears threshold
          if (Math.abs(distance) >= slider.settings.swipeThreshold) {
            if (distance < 0) {
              el.goToNextSlide();
            } else {
              el.goToPrevSlide();
            }
            el.stopAuto();
          } else {
            // el.animate(property, 200);
            setPositionProperty(value, 'reset', 200);
          }
        }
      }
      slider.viewport.unbind('touchend MSPointerUp pointerup', onTouchEnd);
      if (slider.viewport.get(0).releasePointerCapture) {
        slider.viewport.get(0).releasePointerCapture(slider.pointerId);
      }
    };

    /**
     * Window resize event callback
     */
    var resizeWindow = function(e) {
      // don't do anything if slider isn't initialized.
      if (!slider.initialized) { return; }
      // Delay if slider working.
      if (slider.working) {
        window.setTimeout(resizeWindow, 10);
      } else {
        // get the new window dimens (again, thank you IE)
        var windowWidthNew = $(window).width(),
        windowHeightNew = $(window).height();
        // make sure that it is a true window resize
        // *we must check this because our dinosaur friend IE fires a window resize event when certain DOM elements
        // are resized. Can you just die already?*
        if (windowWidth !== windowWidthNew || windowHeight !== windowHeightNew) {
          // set the new window dimens
          windowWidth = windowWidthNew;
          windowHeight = windowHeightNew;
          // update all dynamic elements
          el.redrawSlider();
          // Call user resize handler
          slider.settings.onSliderResize.call(el, slider.active.index);
        }
      }
    };

    /**
     * Adds an aria-hidden=true attribute to each element
     *
     * @param startVisibleIndex (int)
     *  - the first visible element's index
     */
    var applyAriaHiddenAttributes = function(startVisibleIndex) {
      var numberOfSlidesShowing = getNumberSlidesShowing();
      // only apply attributes if the setting is enabled and not in ticker mode
      if (slider.settings.ariaHidden && !slider.settings.ticker) {
        // add aria-hidden=true to all elements
        slider.children.attr('aria-hidden', 'true');
        // get the visible elements and change to aria-hidden=false
        slider.children.slice(startVisibleIndex, startVisibleIndex + numberOfSlidesShowing).attr('aria-hidden', 'false');
      }
    };

    /**
     * Returns index according to present page range
     *
     * @param slideOndex (int)
     *  - the desired slide index
     */
    var setSlideIndex = function(slideIndex) {
      if (slideIndex < 0) {
        if (slider.settings.infiniteLoop) {
          return getPagerQty() - 1;
        }else {
          //we don't go to undefined slides
          return slider.active.index;
        }
      // if slideIndex is greater than children length, set active index to 0 (this happens during infinite loop)
      } else if (slideIndex >= getPagerQty()) {
        if (slider.settings.infiniteLoop) {
          return 0;
        } else {
          //we don't move to undefined pages
          return slider.active.index;
        }
      // set active index to requested slide
      } else {
        return slideIndex;
      }
    };

    /**
     * ===================================================================================
     * = PUBLIC FUNCTIONS
     * ===================================================================================
     */

    /**
     * Performs slide transition to the specified slide
     *
     * @param slideIndex (int)
     *  - the destination slide's index (zero-based)
     *
     * @param direction (string)
     *  - INTERNAL USE ONLY - the direction of travel ("prev" / "next")
     */
    el.goToSlide = function(slideIndex, direction) {
      // onSlideBefore, onSlideNext, onSlidePrev callbacks
      // Allow transition canceling based on returned value
      var performTransition = true,
      moveBy = 0,
      position = {left: 0, top: 0},
      lastChild = null,
      lastShowingIndex, eq, value, requestEl;
      // store the old index
      slider.oldIndex = slider.active.index;
      //set new index
      slider.active.index = setSlideIndex(slideIndex);

      // if plugin is currently in motion, ignore request
      if (slider.working || slider.active.index === slider.oldIndex) { return; }
      // declare that plugin is in motion
      slider.working = true;

      performTransition = slider.settings.onSlideBefore.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index);

      // If transitions canceled, reset and return
      if (typeof (performTransition) !== 'undefined' && !performTransition) {
        slider.active.index = slider.oldIndex; // restore old index
        slider.working = false; // is not in motion
        return;
      }

      if (direction === 'next') {
        // Prevent canceling in future functions or lack there-of from negating previous commands to cancel
        if (!slider.settings.onSlideNext.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index)) {
          performTransition = false;
        }
      } else if (direction === 'prev') {
        // Prevent canceling in future functions or lack there-of from negating previous commands to cancel
        if (!slider.settings.onSlidePrev.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index)) {
          performTransition = false;
        }
      }

      // check if last slide
      slider.active.last = slider.active.index >= getPagerQty() - 1;
      // update the pager with active class
      if (slider.settings.pager || slider.settings.pagerCustom) { updatePagerActive(slider.active.index); }
      // // check for direction control update
      if (slider.settings.controls) { updateDirectionControls(); }
      // if slider is set to mode: "fade"
      if (slider.settings.mode === 'fade') {
        // if adaptiveHeight is true and next height is different from current height, animate to the new height
        if (slider.settings.adaptiveHeight && slider.viewport.height() !== getViewportHeight()) {
          slider.viewport.animate({height: getViewportHeight()}, slider.settings.adaptiveHeightSpeed);
        }
        // fade out the visible child and reset its z-index value
        slider.children.filter(':visible').fadeOut(slider.settings.speed).css({zIndex: 0});
        // fade in the newly requested slide
        slider.children.eq(slider.active.index).css('zIndex', slider.settings.slideZIndex + 1).fadeIn(slider.settings.speed, function() {
          $(this).css('zIndex', slider.settings.slideZIndex);
          updateAfterSlideTransition();
        });
      // slider mode is not "fade"
      } else {
        // if adaptiveHeight is true and next height is different from current height, animate to the new height
        if (slider.settings.adaptiveHeight && slider.viewport.height() !== getViewportHeight()) {
          slider.viewport.animate({height: getViewportHeight()}, slider.settings.adaptiveHeightSpeed);
        }
        // if carousel and not infinite loop
        if (!slider.settings.infiniteLoop && slider.carousel && slider.active.last) {
          if (slider.settings.mode === 'horizontal') {
            // get the last child position
            lastChild = slider.children.eq(slider.children.length - 1);
            position = lastChild.position();
            // calculate the position of the last slide
            moveBy = slider.viewport.width() - lastChild.outerWidth();
          } else {
            // get last showing index position
            lastShowingIndex = slider.children.length - slider.settings.minSlides;
            position = slider.children.eq(lastShowingIndex).position();
          }
          // horizontal carousel, going previous while on first slide (infiniteLoop mode)
        } else if (slider.carousel && slider.active.last && direction === 'prev') {
          // get the last child position
          eq = slider.settings.moveSlides === 1 ? slider.settings.maxSlides - getMoveBy() : ((getPagerQty() - 1) * getMoveBy()) - (slider.children.length - slider.settings.maxSlides);
          lastChild = el.children('.bx-clone').eq(eq);
          position = lastChild.position();
        // if infinite loop and "Next" is clicked on the last slide
        } else if (direction === 'next' && slider.active.index === 0) {
          // get the last clone position
          position = el.find('> .bx-clone').eq(slider.settings.maxSlides).position();
          slider.active.last = false;
        // normal non-zero requests
        } else if (slideIndex >= 0) {
          //parseInt is applied to allow floats for slides/page
          requestEl = slideIndex * parseInt(getMoveBy());
          position = slider.children.eq(requestEl).position();
        }

        /* If the position doesn't exist
         * (e.g. if you destroy the slider on a next click),
         * it doesn't throw an error.
         */
        if (typeof (position) !== 'undefined') {
          value = slider.settings.mode === 'horizontal' ? -(position.left - moveBy) : -position.top;
          // plugin values to be animated
          setPositionProperty(value, 'slide', slider.settings.speed);
        } else {
          slider.working = false;
        }
      }
      if (slider.settings.ariaHidden) { applyAriaHiddenAttributes(slider.active.index * getMoveBy()); }
    };

    /**
     * Transitions to the next slide in the show
     */
    el.goToNextSlide = function() {
      // if infiniteLoop is false and last page is showing, disregard call
      if (!slider.settings.infiniteLoop && slider.active.last) { return; }
      var pagerIndex = parseInt(slider.active.index) + 1;
      el.goToSlide(pagerIndex, 'next');
    };

    /**
     * Transitions to the prev slide in the show
     */
    el.goToPrevSlide = function() {
      // if infiniteLoop is false and last page is showing, disregard call
      if (!slider.settings.infiniteLoop && slider.active.index === 0) { return; }
      var pagerIndex = parseInt(slider.active.index) - 1;
      el.goToSlide(pagerIndex, 'prev');
    };

    /**
     * Starts the auto show
     *
     * @param preventControlUpdate (boolean)
     *  - if true, auto controls state will not be updated
     */
    el.startAuto = function(preventControlUpdate) {
      // if an interval already exists, disregard call
      if (slider.interval) { return; }
      // create an interval
      slider.interval = setInterval(function() {
        if (slider.settings.autoDirection === 'next') {
          el.goToNextSlide();
        } else {
          el.goToPrevSlide();
        }
      }, slider.settings.pause);
      // if auto controls are displayed and preventControlUpdate is not true
      if (slider.settings.autoControls && preventControlUpdate !== true) { updateAutoControls('stop'); }
    };

    /**
     * Stops the auto show
     *
     * @param preventControlUpdate (boolean)
     *  - if true, auto controls state will not be updated
     */
    el.stopAuto = function(preventControlUpdate) {
      // if no interval exists, disregard call
      if (!slider.interval) { return; }
      // clear the interval
      clearInterval(slider.interval);
      slider.interval = null;
      // if auto controls are displayed and preventControlUpdate is not true
      if (slider.settings.autoControls && preventControlUpdate !== true) { updateAutoControls('start'); }
    };

    /**
     * Returns current slide index (zero-based)
     */
    el.getCurrentSlide = function() {
      return slider.active.index;
    };

    /**
     * Returns current slide element
     */
    el.getCurrentSlideElement = function() {
      return slider.children.eq(slider.active.index);
    };

    /**
     * Returns a slide element
     * @param index (int)
     *  - The index (zero-based) of the element you want returned.
     */
    el.getSlideElement = function(index) {
      return slider.children.eq(index);
    };

    /**
     * Returns number of slides in show
     */
    el.getSlideCount = function() {
      return slider.children.length;
    };

    /**
     * Return slider.working variable
     */
    el.isWorking = function() {
      return slider.working;
    };

    /**
     * Update all dynamic slider elements
     */
    el.redrawSlider = function() {
      // resize all children in ratio to new screen size
      slider.children.add(el.find('.bx-clone')).outerWidth(getSlideWidth());
      // adjust the height
      slider.viewport.css('height', getViewportHeight());
      // update the slide position
      if (!slider.settings.ticker) { setSlidePosition(); }
      // if active.last was true before the screen resize, we want
      // to keep it last no matter what screen size we end on
      if (slider.active.last) { slider.active.index = getPagerQty() - 1; }
      // if the active index (page) no longer exists due to the resize, simply set the index as last
      if (slider.active.index >= getPagerQty()) { slider.active.last = true; }
      // if a pager is being displayed and a custom pager is not being used, update it
      if (slider.settings.pager && !slider.settings.pagerCustom) {
        populatePager();
        updatePagerActive(slider.active.index);
      }
      if (slider.settings.ariaHidden) { applyAriaHiddenAttributes(slider.active.index * getMoveBy()); }
    };

    /**
     * Destroy the current instance of the slider (revert everything back to original state)
     */
    el.destroySlider = function() {
      // don't do anything if slider has already been destroyed
      if (!slider.initialized) { return; }
      slider.initialized = false;
      $('.bx-clone', this).remove();
      slider.children.each(function() {
        if ($(this).data('origStyle') !== undefined) {
          $(this).attr('style', $(this).data('origStyle'));
        } else {
          $(this).removeAttr('style');
        }
      });
      if ($(this).data('origStyle') !== undefined) {
        this.attr('style', $(this).data('origStyle'));
      } else {
        $(this).removeAttr('style');
      }
      $(this).unwrap().unwrap();
      if (slider.controls.el) { slider.controls.el.remove(); }
      if (slider.controls.next) { slider.controls.next.remove(); }
      if (slider.controls.prev) { slider.controls.prev.remove(); }
      if (slider.pagerEl && slider.settings.controls && !slider.settings.pagerCustom) { slider.pagerEl.remove(); }
      $('.bx-caption', this).remove();
      if (slider.controls.autoEl) { slider.controls.autoEl.remove(); }
      clearInterval(slider.interval);
      if (slider.settings.responsive) { $(window).unbind('resize', resizeWindow); }
      if (slider.settings.keyboardEnabled) { $(document).unbind('keydown', keyPress); }
      //remove self reference in data
      $(this).removeData('bxSlider');
    };

    /**
     * Reload the slider (revert all DOM changes, and re-initialize)
     */
    el.reloadSlider = function(settings) {
      if (settings !== undefined) { options = settings; }
      el.destroySlider();
      init();
      //store reference to self in order to access public functions later
      $(el).data('bxSlider', this);
    };

    init();

    $(el).data('bxSlider', this);

    // returns the current jQuery object
    return this;
  };

})(jQuery);

/*! jCarousel - v0.3.5 - 2017-03-15
* http://sorgalla.com/jcarousel/
* Copyright (c) 2006-2017 Jan Sorgalla; Licensed MIT */
!function(a){"use strict";var b=a.jCarousel={};b.version="0.3.5";var c=/^([+\-]=)?(.+)$/;b.parseTarget=function(a){var b=!1,d="object"!=typeof a?c.exec(a):null;return d?(a=parseInt(d[2],10)||0,d[1]&&(b=!0,"-="===d[1]&&(a*=-1))):"object"!=typeof a&&(a=parseInt(a,10)||0),{target:a,relative:b}},b.detectCarousel=function(a){for(var b;a.length>0;){if(b=a.filter("[data-jcarousel]"),b.length>0)return b;if(b=a.find("[data-jcarousel]"),b.length>0)return b;a=a.parent()}return null},b.base=function(c){return{version:b.version,_options:{},_element:null,_carousel:null,_init:a.noop,_create:a.noop,_destroy:a.noop,_reload:a.noop,create:function(){return this._element.attr("data-"+c.toLowerCase(),!0).data(c,this),!1===this._trigger("create")?this:(this._create(),this._trigger("createend"),this)},destroy:function(){return!1===this._trigger("destroy")?this:(this._destroy(),this._trigger("destroyend"),this._element.removeData(c).removeAttr("data-"+c.toLowerCase()),this)},reload:function(a){return!1===this._trigger("reload")?this:(a&&this.options(a),this._reload(),this._trigger("reloadend"),this)},element:function(){return this._element},options:function(b,c){if(0===arguments.length)return a.extend({},this._options);if("string"==typeof b){if(void 0===c)return void 0===this._options[b]?null:this._options[b];this._options[b]=c}else this._options=a.extend({},this._options,b);return this},carousel:function(){return this._carousel||(this._carousel=b.detectCarousel(this.options("carousel")||this._element),this._carousel||a.error('Could not detect carousel for plugin "'+c+'"')),this._carousel},_trigger:function(b,d,e){var f,g=!1;return e=[this].concat(e||[]),(d||this._element).each(function(){f=a.Event((c+":"+b).toLowerCase()),a(this).trigger(f,e),f.isDefaultPrevented()&&(g=!0)}),!g}}},b.plugin=function(c,d){var e=a[c]=function(b,c){this._element=a(b),this.options(c),this._init(),this.create()};return e.fn=e.prototype=a.extend({},b.base(c),d),a.fn[c]=function(b){var d=Array.prototype.slice.call(arguments,1),f=this;return"string"==typeof b?this.each(function(){var e=a(this).data(c);if(!e)return a.error("Cannot call methods on "+c+' prior to initialization; attempted to call method "'+b+'"');if(!a.isFunction(e[b])||"_"===b.charAt(0))return a.error('No such method "'+b+'" for '+c+" instance");var g=e[b].apply(e,d);return g!==e&&void 0!==g?(f=g,!1):void 0}):this.each(function(){var d=a(this).data(c);d instanceof e?d.reload(b):new e(this,b)}),f},e}}(jQuery),function(a,b){"use strict";var c=a(b),d=function(a){return parseFloat(a)||0};a.jCarousel.plugin("jcarousel",{animating:!1,tail:0,inTail:!1,resizeState:null,resizeTimer:null,lt:null,vertical:!1,rtl:!1,circular:!1,underflow:!1,relative:!1,_options:{list:function(){return this.element().children().eq(0)},items:function(){return this.list().children()},animation:400,transitions:!1,wrap:null,vertical:null,rtl:null,center:!1},_list:null,_items:null,_target:a(),_first:a(),_last:a(),_visible:a(),_fullyvisible:a(),_init:function(){var a=this;return a.resizeState=c.width()+"x"+c.height(),this.onWindowResize=function(){a.resizeTimer&&clearTimeout(a.resizeTimer),a.resizeTimer=setTimeout(function(){var b=c.width()+"x"+c.height();b!==a.resizeState&&(a.resizeState=b,a.reload())},100)},this},_create:function(){this._reload(),c.on("resize.jcarousel",this.onWindowResize)},_destroy:function(){c.off("resize.jcarousel",this.onWindowResize)},_reload:function(){this.vertical=this.options("vertical"),null==this.vertical&&(this.vertical=this.list().height()>this.list().width()),this.rtl=this.options("rtl"),null==this.rtl&&(this.rtl=function(b){if("rtl"===(""+b.attr("dir")).toLowerCase())return!0;var c=!1;return b.parents("[dir]").each(function(){if(/rtl/i.test(a(this).attr("dir")))return c=!0,!1}),c}(this._element)),this.lt=this.vertical?"top":"left",this.relative="relative"===this.list().css("position"),this._list=null,this._items=null;var b=this.index(this._target)>=0?this._target:this.closest();this.circular="circular"===this.options("wrap"),this.underflow=!1;var c={left:0,top:0};return b.length>0&&(this._prepare(b),this.list().find("[data-jcarousel-clone]").remove(),this._items=null,this.underflow=this._fullyvisible.length>=this.items().length,this.circular=this.circular&&!this.underflow,c[this.lt]=this._position(b)+"px"),this.move(c),this},list:function(){if(null===this._list){var b=this.options("list");this._list=a.isFunction(b)?b.call(this):this._element.find(b)}return this._list},items:function(){if(null===this._items){var b=this.options("items");this._items=(a.isFunction(b)?b.call(this):this.list().find(b)).not("[data-jcarousel-clone]")}return this._items},index:function(a){return this.items().index(a)},closest:function(){var b,c=this,e=this.list().position()[this.lt],f=a(),g=!1,h=this.vertical?"bottom":this.rtl&&!this.relative?"left":"right";return this.rtl&&this.relative&&!this.vertical&&(e+=this.list().width()-this.clipping()),this.items().each(function(){if(f=a(this),g)return!1;var i=c.dimension(f);if((e+=i)>=0){if(b=i-d(f.css("margin-"+h)),!(Math.abs(e)-i+b/2<=0))return!1;g=!0}}),f},target:function(){return this._target},first:function(){return this._first},last:function(){return this._last},visible:function(){return this._visible},fullyvisible:function(){return this._fullyvisible},hasNext:function(){if(!1===this._trigger("hasnext"))return!0;var a=this.options("wrap"),b=this.items().length-1,c=this.options("center")?this._target:this._last;return!!(b>=0&&!this.underflow&&(a&&"first"!==a||this.index(c)<b||this.tail&&!this.inTail))},hasPrev:function(){if(!1===this._trigger("hasprev"))return!0;var a=this.options("wrap");return!!(this.items().length>0&&!this.underflow&&(a&&"last"!==a||this.index(this._first)>0||this.tail&&this.inTail))},clipping:function(){return this._element["inner"+(this.vertical?"Height":"Width")]()},dimension:function(a){return a["outer"+(this.vertical?"Height":"Width")](!0)},scroll:function(b,c,d){if(this.animating)return this;if(!1===this._trigger("scroll",null,[b,c]))return this;a.isFunction(c)&&(d=c,c=!0);var e=a.jCarousel.parseTarget(b);if(e.relative){var f,g,h,i,j,k,l,m,n=this.items().length-1,o=Math.abs(e.target),p=this.options("wrap");if(e.target>0){var q=this.index(this._last);if(q>=n&&this.tail)this.inTail?"both"===p||"last"===p?this._scroll(0,c,d):a.isFunction(d)&&d.call(this,!1):this._scrollTail(c,d);else if(f=this.index(this._target),this.underflow&&f===n&&("circular"===p||"both"===p||"last"===p)||!this.underflow&&q===n&&("both"===p||"last"===p))this._scroll(0,c,d);else if(h=f+o,this.circular&&h>n){for(m=n,j=this.items().get(-1);m++<h;)j=this.items().eq(0),k=this._visible.index(j)>=0,k&&j.after(j.clone(!0).attr("data-jcarousel-clone",!0)),this.list().append(j),k||(l={},l[this.lt]=this.dimension(j),this.moveBy(l)),this._items=null;this._scroll(j,c,d)}else this._scroll(Math.min(h,n),c,d)}else if(this.inTail)this._scroll(Math.max(this.index(this._first)-o+1,0),c,d);else if(g=this.index(this._first),f=this.index(this._target),i=this.underflow?f:g,h=i-o,i<=0&&(this.underflow&&"circular"===p||"both"===p||"first"===p))this._scroll(n,c,d);else if(this.circular&&h<0){for(m=h,j=this.items().get(0);m++<0;){j=this.items().eq(-1),k=this._visible.index(j)>=0,k&&j.after(j.clone(!0).attr("data-jcarousel-clone",!0)),this.list().prepend(j),this._items=null;var r=this.dimension(j);l={},l[this.lt]=-r,this.moveBy(l)}this._scroll(j,c,d)}else this._scroll(Math.max(h,0),c,d)}else this._scroll(e.target,c,d);return this._trigger("scrollend"),this},moveBy:function(a,b){var c=this.list().position(),e=1,f=0;return this.rtl&&!this.vertical&&(e=-1,this.relative&&(f=this.list().width()-this.clipping())),a.left&&(a.left=c.left+f+d(a.left)*e+"px"),a.top&&(a.top=c.top+f+d(a.top)*e+"px"),this.move(a,b)},move:function(b,c){c=c||{};var d=this.options("transitions"),e=!!d,f=!!d.transforms,g=!!d.transforms3d,h=c.duration||0,i=this.list();if(!e&&h>0)return void i.animate(b,c);var j=c.complete||a.noop,k={};if(e){var l={transitionDuration:i.css("transitionDuration"),transitionTimingFunction:i.css("transitionTimingFunction"),transitionProperty:i.css("transitionProperty")},m=j;j=function(){a(this).css(l),m.call(this)},k={transitionDuration:(h>0?h/1e3:0)+"s",transitionTimingFunction:d.easing||c.easing,transitionProperty:h>0?function(){return f||g?"all":b.left?"left":"top"}():"none",transform:"none"}}g?k.transform="translate3d("+(b.left||0)+","+(b.top||0)+",0)":f?k.transform="translate("+(b.left||0)+","+(b.top||0)+")":a.extend(k,b),e&&h>0&&i.one("transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd",j),i.css(k),h<=0&&i.each(function(){j.call(this)})},_scroll:function(b,c,d){if(this.animating)return a.isFunction(d)&&d.call(this,!1),this;if("object"!=typeof b?b=this.items().eq(b):void 0===b.jquery&&(b=a(b)),0===b.length)return a.isFunction(d)&&d.call(this,!1),this;this.inTail=!1,this._prepare(b);var e=this._position(b);if(e===this.list().position()[this.lt])return a.isFunction(d)&&d.call(this,!1),this;var f={};return f[this.lt]=e+"px",this._animate(f,c,d),this},_scrollTail:function(b,c){if(this.animating||!this.tail)return a.isFunction(c)&&c.call(this,!1),this;var d=this.list().position()[this.lt];this.rtl&&this.relative&&!this.vertical&&(d+=this.list().width()-this.clipping()),this.rtl&&!this.vertical?d+=this.tail:d-=this.tail,this.inTail=!0;var e={};return e[this.lt]=d+"px",this._update({target:this._target.next(),fullyvisible:this._fullyvisible.slice(1).add(this._visible.last())}),this._animate(e,b,c),this},_animate:function(b,c,d){if(d=d||a.noop,!1===this._trigger("animate"))return d.call(this,!1),this;this.animating=!0;var e=this.options("animation"),f=a.proxy(function(){this.animating=!1;var a=this.list().find("[data-jcarousel-clone]");a.length>0&&(a.remove(),this._reload()),this._trigger("animateend"),d.call(this,!0)},this),g="object"==typeof e?a.extend({},e):{duration:e},h=g.complete||a.noop;return c===!1?g.duration=0:void 0!==a.fx.speeds[g.duration]&&(g.duration=a.fx.speeds[g.duration]),g.complete=function(){f(),h.call(this)},this.move(b,g),this},_prepare:function(b){var c,e,f,g,h=this.index(b),i=h,j=this.dimension(b),k=this.clipping(),l=this.vertical?"bottom":this.rtl?"left":"right",m=this.options("center"),n={target:b,first:b,last:b,visible:b,fullyvisible:j<=k?b:a()};if(m&&(j/=2,k/=2),j<k)for(;;){if(c=this.items().eq(++i),0===c.length){if(!this.circular)break;if(c=this.items().eq(0),b.get(0)===c.get(0))break;if(e=this._visible.index(c)>=0,e&&c.after(c.clone(!0).attr("data-jcarousel-clone",!0)),this.list().append(c),!e){var o={};o[this.lt]=this.dimension(c),this.moveBy(o)}this._items=null}if(0===(g=this.dimension(c)))break;if(j+=g,n.last=c,n.visible=n.visible.add(c),f=d(c.css("margin-"+l)),j-f<=k&&(n.fullyvisible=n.fullyvisible.add(c)),j>=k)break}if(!this.circular&&!m&&j<k)for(i=h;;){if(--i<0)break;if(c=this.items().eq(i),0===c.length)break;if(0===(g=this.dimension(c)))break;if(j+=g,n.first=c,n.visible=n.visible.add(c),f=d(c.css("margin-"+l)),j-f<=k&&(n.fullyvisible=n.fullyvisible.add(c)),j>=k)break}return this._update(n),this.tail=0,m||"circular"===this.options("wrap")||"custom"===this.options("wrap")||this.index(n.last)!==this.items().length-1||(j-=d(n.last.css("margin-"+l)))>k&&(this.tail=j-k),this},_position:function(a){var b=this._first,c=b.position()[this.lt],d=this.options("center"),e=d?this.clipping()/2-this.dimension(b)/2:0;return this.rtl&&!this.vertical?(c-=this.relative?this.list().width()-this.dimension(b):this.clipping()-this.dimension(b),c+=e):c-=e,!d&&(this.index(a)>this.index(b)||this.inTail)&&this.tail?(c=this.rtl&&!this.vertical?c-this.tail:c+this.tail,this.inTail=!0):this.inTail=!1,-c},_update:function(b){var c,d=this,e={target:this._target,first:this._first,last:this._last,visible:this._visible,fullyvisible:this._fullyvisible},f=this.index(b.first||e.first)<this.index(e.first),g=function(c){var g=[],h=[];b[c].each(function(){e[c].index(this)<0&&g.push(this)}),e[c].each(function(){b[c].index(this)<0&&h.push(this)}),f?g=g.reverse():h=h.reverse(),d._trigger(c+"in",a(g)),d._trigger(c+"out",a(h)),d["_"+c]=b[c]};for(c in b)g(c);return this}})}(jQuery,window),function(a){"use strict";a.jcarousel.fn.scrollIntoView=function(b,c,d){var e,f=a.jCarousel.parseTarget(b),g=this.index(this._fullyvisible.first()),h=this.index(this._fullyvisible.last());if((e=f.relative?f.target<0?Math.max(0,g+f.target):h+f.target:"object"!=typeof f.target?f.target:this.index(f.target))<g)return this.scroll(e,c,d);if(e>=g&&e<=h)return a.isFunction(d)&&d.call(this,!1),this;for(var i,j=this.items(),k=this.clipping(),l=this.vertical?"bottom":this.rtl?"left":"right",m=0;;){if(i=j.eq(e),0===i.length)break;if((m+=this.dimension(i))>=k){m-(parseFloat(i.css("margin-"+l))||0)!==k&&e++;break}if(e<=0)break;e--}return this.scroll(e,c,d)}}(jQuery),function(a){"use strict";a.jCarousel.plugin("jcarouselControl",{_options:{target:"+=1",event:"click",method:"scroll"},_active:null,_init:function(){this.onDestroy=a.proxy(function(){this._destroy(),this.carousel().one("jcarousel:createend",a.proxy(this._create,this))},this),this.onReload=a.proxy(this._reload,this),this.onEvent=a.proxy(function(b){b.preventDefault();var c=this.options("method");a.isFunction(c)?c.call(this):this.carousel().jcarousel(this.options("method"),this.options("target"))},this)},_create:function(){this.carousel().one("jcarousel:destroy",this.onDestroy).on("jcarousel:reloadend jcarousel:scrollend",this.onReload),this._element.on(this.options("event")+".jcarouselcontrol",this.onEvent),this._reload()},_destroy:function(){this._element.off(".jcarouselcontrol",this.onEvent),this.carousel().off("jcarousel:destroy",this.onDestroy).off("jcarousel:reloadend jcarousel:scrollend",this.onReload)},_reload:function(){var b,c=a.jCarousel.parseTarget(this.options("target")),d=this.carousel();if(c.relative)b=d.jcarousel(c.target>0?"hasNext":"hasPrev");else{var e="object"!=typeof c.target?d.jcarousel("items").eq(c.target):c.target;b=d.jcarousel("target").index(e)>=0}return this._active!==b&&(this._trigger(b?"active":"inactive"),this._active=b),this}})}(jQuery),function(a){"use strict";a.jCarousel.plugin("jcarouselPagination",{_options:{perPage:null,item:function(a){return'<a href="#'+a+'">'+a+"</a>"},event:"click",method:"scroll"},_carouselItems:null,_pages:{},_items:{},_currentPage:null,_init:function(){this.onDestroy=a.proxy(function(){this._destroy(),this.carousel().one("jcarousel:createend",a.proxy(this._create,this))},this),this.onReload=a.proxy(this._reload,this),this.onScroll=a.proxy(this._update,this)},_create:function(){this.carousel().one("jcarousel:destroy",this.onDestroy).on("jcarousel:reloadend",this.onReload).on("jcarousel:scrollend",this.onScroll),this._reload()},_destroy:function(){this._clear(),this.carousel().off("jcarousel:destroy",this.onDestroy).off("jcarousel:reloadend",this.onReload).off("jcarousel:scrollend",this.onScroll),this._carouselItems=null},_reload:function(){var b=this.options("perPage");if(this._pages={},this._items={},a.isFunction(b)&&(b=b.call(this)),null==b)this._pages=this._calculatePages();else for(var c,d=parseInt(b,10)||0,e=this._getCarouselItems(),f=1,g=0;;){if(c=e.eq(g++),0===c.length)break;this._pages[f]?this._pages[f]=this._pages[f].add(c):this._pages[f]=c,g%d==0&&f++}this._clear();var h=this,i=this.carousel().data("jcarousel"),j=this._element,k=this.options("item"),l=this._getCarouselItems().length;a.each(this._pages,function(b,c){var d=h._items[b]=a(k.call(h,b,c));d.on(h.options("event")+".jcarouselpagination",a.proxy(function(){var a=c.eq(0);if(i.circular){var d=i.index(i.target()),e=i.index(a);parseFloat(b)>parseFloat(h._currentPage)?e<d&&(a="+="+(l-d+e)):e>d&&(a="-="+(d+(l-e)))}i[this.options("method")](a)},h)),j.append(d)}),this._update()},_update:function(){var b,c=this.carousel().jcarousel("target");a.each(this._pages,function(a,d){if(d.each(function(){if(c.is(this))return b=a,!1}),b)return!1}),this._currentPage!==b&&(this._trigger("inactive",this._items[this._currentPage]),this._trigger("active",this._items[b])),this._currentPage=b},items:function(){return this._items},reloadCarouselItems:function(){return this._carouselItems=null,this},_clear:function(){this._element.empty(),this._currentPage=null},_calculatePages:function(){for(var a,b,c=this.carousel().data("jcarousel"),d=this._getCarouselItems(),e=c.clipping(),f=0,g=0,h=1,i={};;){if(a=d.eq(g++),0===a.length)break;b=c.dimension(a),f+b>e&&(h++,f=0),f+=b,i[h]?i[h]=i[h].add(a):i[h]=a}return i},_getCarouselItems:function(){return this._carouselItems||(this._carouselItems=this.carousel().jcarousel("items")),this._carouselItems}})}(jQuery),function(a,b){"use strict";var c,d,e={hidden:"visibilitychange",mozHidden:"mozvisibilitychange",msHidden:"msvisibilitychange",webkitHidden:"webkitvisibilitychange"};a.each(e,function(a,e){if(void 0!==b[a])return c=a,d=e,!1}),a.jCarousel.plugin("jcarouselAutoscroll",{_options:{target:"+=1",interval:3e3,autostart:!0},_timer:null,_started:!1,_init:function(){this.onDestroy=a.proxy(function(){this._destroy(),this.carousel().one("jcarousel:createend",a.proxy(this._create,this))},this),this.onAnimateEnd=a.proxy(this._start,this),this.onVisibilityChange=a.proxy(function(){b[c]?this._stop():this._start()},this)},_create:function(){this.carousel().one("jcarousel:destroy",this.onDestroy),a(b).on(d,this.onVisibilityChange),this.options("autostart")&&this.start()},_destroy:function(){this._stop(),this.carousel().off("jcarousel:destroy",this.onDestroy),a(b).off(d,this.onVisibilityChange)},_start:function(){if(this._stop(),this._started)return this.carousel().one("jcarousel:animateend",this.onAnimateEnd),this._timer=setTimeout(a.proxy(function(){this.carousel().jcarousel("scroll",this.options("target"))},this),this.options("interval")),this},_stop:function(){return this._timer&&(this._timer=clearTimeout(this._timer)),this.carousel().off("jcarousel:animateend",this.onAnimateEnd),this},start:function(){return this._started=!0,this._start(),this},stop:function(){return this._started=!1,this._stop(),this}})}(jQuery,document);
function declareControllerForMainAndAddressDiv() {
  var e = $("#content_wrapper");
  wcRenderContext.addRefreshAreaId(
    "contextForMainAndAddressDiv",
    "content_wrapper"
  );
  var t = wcRenderContext.getRenderContextProperties(
    "contextForMainAndAddressDiv"
  );
  e.refreshWidget({
    renderContextChangedHandler: function () {
      CheckoutHelperJS.showHideDivs(t.showArea, t.hideArea);
    },
  });
}

function declareTraditionalShipmentDetailsController() {
  var myWidgetObj = $("#WC_ShipmentDisplay_div_17");
  wcRenderContext.addRefreshAreaId(
    "traditionalShipmentDetailsContext",
    "WC_ShipmentDisplay_div_17"
  );
  var myRCProperties = wcRenderContext.getRenderContextProperties(
      "traditionalShipmentDetailsContext"
    ),
    events = $.extend(
      {},
      order_updated,
      {
        OrderShippingInfoUpdate: "OrderShippingInfoUpdate",
      },
      {
        AjaxDeleteOrderItemForShippingBillingPage:
          "AjaxDeleteOrderItemForShippingBillingPage",
      },
      {
        AjaxDeleteOrderItemForShippingBillingPage:
          "AjaxDeleteOrderItemForShippingBillingPage",
      },
      {
        AjaxPrepareOrderForShipChargeUpdate:
          "AjaxPrepareOrderForShipChargeUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate:
          "OrderItemAddressShipInstructionsUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate1:
          "OrderItemAddressShipInstructionsUpdate1",
      },
      {
        AjaxAddUnboundPaymentInstructionToThisOrder:
          "AjaxAddUnboundPaymentInstructionToThisOrder",
      },
      {
        AjaxDeleteUnboundPaymentInstructionFromThisOrder:
          "AjaxDeleteUnboundPaymentInstructionFromThisOrder",
      },
      {
        OrderItemAddressShipMethodUpdate: "OrderItemAddressShipMethodUpdate",
      }
    );
  wcTopic.subscribe(events, function (e) {
    myWidgetObj.refreshWidget("refresh", myRCProperties),
      "OrderItemAddressShipMethodUpdate" != e.actionId &&
        (submitRequest(), cursor_wait());
  }),
    myWidgetObj.refreshWidget({
      renderContextChangedHandler: function () {
        wcRenderContext.testForChangedRC("traditionalShipmentDetailsContext", [
          "beginIndex",
        ]) && myWidgetObj.refreshWidget("refresh", myRCProperties);
      },
      postRefreshHandler: function () {
        resetRequest(),
          cursor_clear(),
          "true" == myRCProperties.initializeJS &&
            ($('input[id^="orderItem_"]').each(function (i, orderItem) {
              var initJS =
                "addReqListsJS" +
                orderItem.value +
                " = new AddToRequisitionListsJS(" +
                myRCProperties.storeId +
                "," +
                myRCProperties.catalogId +
                "," +
                myRCProperties.langId +
                ',"' +
                orderItem.value +
                'requisitionListContent","' +
                orderItem.value +
                'requisitionListSelect","' +
                orderItem.value +
                'createNewListMenu","' +
                orderItem.value +
                'listTypeMenu","' +
                orderItem.value +
                'newListNameInput","' +
                orderItem.value +
                'listType","' +
                orderItem.value +
                'productAdded","","AddToRequisitionListsJS' +
                orderItem.value +
                '");addReqListsJS' +
                orderItem.value +
                '.setCatEntryId("' +
                $(
                  "#catalogId_" +
                    orderItem.id.substring(orderItem.id.indexOf("_") + 1)
                ).val() +
                '");';
              eval(initJS);
            }),
            $('div[id^="shoppingListScript_"]').each(function (e, t) {
              $.globalEval(t.innerHTML);
            }));
      },
    });
}

function declareShippingAddressSelectBoxAreaController() {
  var e = $("#shippingAddressSelectBoxArea");
  wcRenderContext.addRefreshAreaId(
    "shippingAddressDropDownBoxContext",
    "shippingAddressSelectBoxArea"
  );
  var t = wcRenderContext.getRenderContextProperties(
      "shippingAddressDropDownBoxContext"
    ),
    r = $.extend(
      {},
      address_updated,
      {
        AjaxUpdateOrderItemsAddressId: "AjaxUpdateOrderItemsAddressId",
      },
      {
        AddBillingAddressInCheckOut: "AddBillingAddressInCheckOut",
      }
    );
  wcTopic.subscribe(r, function (r) {
    r.actionId in address_updated
      ? (wcRenderContext.updateRenderContext("contextForMainAndAddressDiv", {
          showArea: "mainContents",
          hideArea: "editAddressContents",
        }),
        (selectedAddressId = r.data.addressId),
        (t.addressId = selectedAddressId),
        0 != CheckoutHelperJS.orderItemIds.length &&
          CheckoutHelperJS.updateAddressIdOFItemsOnCreateEditAddress(
            selectedAddressId[0]
          ),
        cursor_clear())
      : "AjaxUpdateOrderItemsAddressId" == r.actionId
      ? (e.refreshWidget("refresh", t), cursor_clear())
      : "AddBillingAddressInCheckOut" == r.actionId &&
        "ShippingAndBilling" == r.data.addBillingAddressInCheckOutAddressType &&
        document.getElementById("singleShipmentAddress") &&
        ((t.addressId = document.getElementById("singleShipmentAddress").value),
        e.refreshWidget("refresh", t),
        cursor_clear());
  }),
    e.refreshWidget({
      postRefreshHandler: function () {
        null != CheckoutHelperJS.getLastAddressLinkIdToFocus() &&
          "undefined" != CheckoutHelperJS.getLastAddressLinkIdToFocus() &&
          "" != CheckoutHelperJS.getLastAddressLinkIdToFocus() &&
          document
            .getElementById(CheckoutHelperJS.getLastAddressLinkIdToFocus())
            .focus(),
          declareShippingAddressDisplayAreaController();
      },
    });
}

function declareCurrentOrderTotalsAreaController() {
  var e = $("#WC_ShipmentDisplay_div_18");
  wcRenderContext.addRefreshAreaId(
    "currentOrder_Context",
    "WC_ShipmentDisplay_div_18"
  );
  var t = wcRenderContext.getRenderContextProperties("currentOrder_Context"),
    r = $.extend(
      {},
      order_updated,
      {
        AjaxDeleteOrderItemForShippingBillingPage:
          "AjaxDeleteOrderItemForShippingBillingPage",
      },
      {
        OrderItemAddressShipMethodUpdate: "OrderItemAddressShipMethodUpdate",
      },
      {
        AjaxPrepareOrderForShipChargeUpdate:
          "AjaxPrepareOrderForShipChargeUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate:
          "OrderItemAddressShipInstructionsUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate1:
          "OrderItemAddressShipInstructionsUpdate1",
      },
      {
        AjaxUpdateOrderAfterAddressUpdate: "AjaxUpdateOrderAfterAddressUpdate",
      },
      {
        AjaxAddShippingAndBillingAddressForPersonDuringCheckout:
          "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
      },
      {
        AjaxPrepareOrderForPaymentSubmit: "AjaxPrepareOrderForPaymentSubmit",
      }
    );
  wcTopic.subscribe(r, function (r) {
    e.refreshWidget("refresh", t);
  }),
    e.refreshWidget({
      postRefreshHandler: function () {
        $("#discountDetailsSection").length &&
          $("#discountDetailsSection").css("display", "block"),
          $("#appliedPromotionCodes").length &&
            $("#appliedPromotionCodes").css("display", "block");
      },
    });
}

function declareSingleShipmentShipChargeController() {
  var e = $("#WC_SingleShipmentDisplay_ShipCharge_Area");
  wcRenderContext.addRefreshAreaId(
    "singleShipmentShipChargeContext",
    "WC_SingleShipmentDisplay_ShipCharge_Area"
  );
  var t = wcRenderContext.getRenderContextProperties(
    "singleShipmentShipChargeContext"
  );
  wcTopic.subscribe(["OrderItemAddressShipMethodUpdate"], function () {
    SBControllersDeclarationJS.shipChargeEnabled &&
      e.refreshWidget("refresh", t);
  }),
    e.refreshWidget({
      postRefreshHandler: function () {
        cursor_clear();
      },
    });
}

function declareBillingAddressSelectBoxAreaController(e) {
  ("object" == typeof e || "array" == typeof e) && (e = e[0]);
  var t = $("#" + e);
  wcRenderContext.addRefreshAreaId("billingAddressDropDownBoxContext", e);
  var r = wcRenderContext.getRenderContextProperties(
    "billingAddressDropDownBoxContext"
  );
  wcTopic.subscribe(
    [
      "AddBillingAddressInCheckOut",
      "UpdateBillingAddressInCheckout",
      "AjaxUpdateAddressForPerson",
      "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
      "AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout",
    ],
    function (e) {
      var s = t.attr("objectId"),
        a = r["billingAddress" + s];
      "" == r["paymentTCId" + s]
        ? t.refreshWidget("updateUrl", r["billingURL" + s])
        : t.refreshWidget(
            "updateUrl",
            r["billingURL" + s] + "&paymentTCId=" + r["paymentTCId" + s]
          ),
        -1 == r["billingAddress" + s]
          ? ((a = e.data.addressId),
            t.refreshWidget("refresh", {
              paymentAreaNumber: s,
              selectedAddressId: a,
              paymentMethodSelected: r["payment" + s],
            }),
            (r["billingAddress" + s] = a),
            s <= CheckoutPayments.numberOfPaymentMethods &&
              CheckoutPayments.updatePaymentObject(s, "billing_address_id"))
          : 0 == r["billingAddress" + s]
          ? t.refreshWidget("refresh", {
              paymentAreaNumber: s,
              paymentMethodSelected: r["payment" + s],
            })
          : (document.getElementById("singleShipmentAddress") &&
              ((shippingAddressId = document.getElementById(
                "singleShipmentAddress"
              ).value),
              (billingAddressId = document.getElementById(
                "billing_address_id_" + s
              ).value),
              shippingAddressId == billingAddressId &&
                s <= CheckoutPayments.numberOfPaymentMethods &&
                "AjaxAddAddressForPerson" != e.data.originalServiceId &&
                (a = e.data.addressId)),
            t.refreshWidget("refresh", {
              paymentAreaNumber: s,
              selectedAddressId: a,
              paymentMethodSelected: r["payment" + s],
            }),
            s <= CheckoutPayments.numberOfPaymentMethods &&
              CheckoutPayments.updatePaymentObject(s, "billing_address_id"));
    }
  ),
    t.refreshWidget({
      renderContextChangedHandler: function () {
        var e = t.attr("objectId");
        if (
          wcRenderContext.testForChangedRC("billingAddressDropDownBoxContext", [
            "payment" + e,
          ]) ||
          wcRenderContext.testForChangedRC("billingAddressDropDownBoxContext", [
            "paymentTCId" + e,
          ])
        ) {
          "" == r["paymentTCId" + e]
            ? t.refreshWidget("updateUrl", r["billingURL" + e])
            : t.refreshWidget(
                "updateUrl",
                r["billingURL" + e] + "&paymentTCId=" + r["paymentTCId" + e]
              );
          var s = $("#billing_address_id_" + e).val();
          t.refreshWidget("refresh", {
            paymentAreaNumber: e,
            selectedAddressId: s,
            paymentMethodSelected: r["payment" + e],
          });
        }
      },
      postRefreshHandler: function () {
        var e = t.attr("objectId");
        CheckoutHelperJS.showHideEditBillingAddressLink(
          document.getElementsByName("billing_address_id")[e - 1],
          e
        ),
          cursor_clear();
        var r = CheckoutHelperJS.getLastAddressLinkIdToFocus();
        if (numAjaxRequests >= 0 && null != r && "undefined" != r && "" != r)
          if (null != document.getElementById(r))
            document.getElementById(r).focus();
          else {
            var s = r.split("_"),
              a = parseInt(s[s.length - 1]) + 1 + "";
            if (r.indexOf("WC_ShippingAddressSelectMultiple_link_2_") > -1) {
              var i = "WC_ShippingAddressSelectMultiple_link_2_" + a;
              null != document.getElementById(i) &&
                document.getElementById(i).focus();
            } else {
              var i = "WC_ShippingAddressSelectMultiple_link_3_" + a;
              null != document.getElementById(i) &&
                document.getElementById(i).focus();
            }
          }
        declareBillingAddressDisplayAreaController(
          "billingAddressDisplayArea_" + e
        );
      },
    });
}

function declareBillingAddressDisplayAreaController(e) {
  ("object" == typeof e || "array" == typeof e) && (e = e[0]);
  var t = $("#" + e);
  wcRenderContext.addRefreshAreaId("billingAddressDropDownBoxContext", e);
  var r = wcRenderContext.getRenderContextProperties(
    "billingAddressDropDownBoxContext"
  );
  t.refreshWidget({
    renderContextChangedHandler: function () {
      var s = r.areaNumber,
        a = e;
      if (
        wcRenderContext.testForChangedRC("billingAddressDropDownBoxContext", [
          "billingAddress" + s,
        ]) &&
        a.charAt(a.length - 1) == s
      ) {
        var i = r["billingAddress" + s];
        t.refreshWidget("refresh", {
          addressId: i,
        });
      }
    },
    postRefreshHandler: function () {
      var e = r.areaNumber;
      CheckoutHelperJS.showHideEditBillingAddressLink(
        document.getElementsByName("billing_address_id")[e - 1],
        e
      ),
        cursor_clear();
    },
  });
}

function declareOrderTotalController() {
  var e = $("#orderTotalAmountArea");
  wcRenderContext.addRefreshAreaId("paymentContext", "orderTotalAmountArea");
  var t =
    (wcRenderContext.getRenderContextProperties("paymentContext"),
    $.extend(
      {},
      order_updated,
      {
        OrderItemAddressShipMethodUpdate: "OrderItemAddressShipMethodUpdate",
      },
      {
        AjaxPrepareOrderForShipChargeUpdate:
          "AjaxPrepareOrderForShipChargeUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate:
          "OrderItemAddressShipInstructionsUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate1:
          "OrderItemAddressShipInstructionsUpdate1",
      },
      {
        AjaxUpdateOrderAfterAddressUpdate: "AjaxUpdateOrderAfterAddressUpdate",
      },
      {
        AjaxDeleteOrderItemForShippingBillingPage:
          "AjaxDeleteOrderItemForShippingBillingPage",
      },
      {
        AjaxUpdateOrderItemsAddressId: "AjaxUpdateOrderItemsAddressId",
      }
    ));
  wcTopic.subscribe(t, function () {
    cursor_wait(), CheckoutPayments.getTotalInJSON();
  }),
    e.refreshWidget({
      postRefreshHandler: function (e) {
        cursor_clear();
      },
    });
}

function declarePaymentAreaController(e) {
  "object" == typeof e && (e = e[0]);
  var t = $("#" + e);
  wcRenderContext.addRefreshAreaId("paymentContext", e);
  var r = wcRenderContext.getRenderContextProperties("paymentContext"),
    s = e[e.length - 1];
  t.refreshWidget({
    renderContextChangedHandler: function () {
      r.currentPaymentArea == s &&
        (wcRenderContext.testForChangedRC("paymentContext", ["payment" + s]) ||
          wcRenderContext.testForChangedRC("paymentContext", [
            "paymentTCId" + s,
          ]) ||
          (wcRenderContext.testForChangedRC("paymentContext", ["piAmount"]) &&
            supportPaymentTypePromotions)) &&
        ("empty" == r["payment" + s]
          ? (viewName = "EmptySnippetView")
          : (viewName = paymentSnippetsURLMap[r["payment" + s]]),
        t.refreshWidget("updateUrl", viewName + paymentAreaUrlParam),
        supportPaymentTypePromotions
          ? 1 != CheckoutPayments.numberOfPaymentMethods
            ? t.refreshWidget("refresh", r)
            : 1 == CheckoutPayments.numberOfPaymentMethods &&
              2 > s &&
              t.refreshWidget("refresh", r)
          : t.refreshWidget("refresh", r));
    },
    postRefreshHandler: function () {
      if (!supportPaymentTypePromotions) {
        var e = $("#OrderTotalAmount").val();
        CheckoutPayments.updateAmountFields(e);
      }
      var t = "paymentArea" + s;
      TealeafWCJS.rebind(t);
      wcRenderContext.updateRenderContext("billingAddressDropDownBoxContext", {
        addressKey:
          document.getElementsByName("billing_address_id")[s - 1].value,
        areaNumber: s,
      }),
        cursor_clear();
    },
  });
}

function declareShippingAddressDisplayAreaController() {
  var e = $("#shippingAddressDisplayArea");
  wcRenderContext.addRefreshAreaId(
    "shippingAddressContext",
    "shippingAddressDisplayArea"
  );
  var t = wcRenderContext.getRenderContextProperties("shippingAddressContext");
  e.refreshWidget({
    renderContextChangedHandler: function () {
      if (
        wcRenderContext.testForChangedRC("shippingAddressContext", [
          "shippingAddress",
        ])
      ) {
        var r = t.shippingAddress;
        e.refreshWidget("refresh", {
          addressId: r,
        });
      }
      cursor_clear();
    },
  });
}

function declareEditShippingAdddressAreaController() {
  var e = $("#editShippingAddressArea1");
  wcRenderContext.addRefreshAreaId(
    "editShippingAddressContext",
    "editShippingAddressArea1"
  );
  var t = wcRenderContext.getRenderContextProperties(
      "editShippingAddressContext"
    ),
    r = $.extend({}, address_updated, {
      UpdateBillingAddressInCheckout: "UpdateBillingAddressInCheckout",
    });
  wcTopic.subscribe(r, function (e) {
    2 == shipmentTypeId &&
      (wcRenderContext.updateRenderContext("contextForMainAndAddressDiv", {
        showArea: "mainContents",
        hideArea: "editAddressContents",
      }),
      (selectedAddressId = e.data.addressId),
      CheckoutHelperJS.updateAddressIdOFItemsOnCreateEditAddress(
        selectedAddressId[0]
      ),
      cursor_clear());
  }),
    e.refreshWidget({
      renderContextChangedHandler: function () {
        if (
          wcRenderContext.testForChangedRC("editShippingAddressContext", [
            "shippingAddress",
          ])
        ) {
          var r = t.shippingAddress;
          t.shippingAddress = 0;
          var s = t.addressType;
          e.refreshWidget("refresh", {
            addressId: r,
            addressType: s,
          });
        }
      },
      postRefreshHandler: function () {
        cursor_clear(),
          AddressHelper.loadStatesUI(
            "shopcartAddressForm",
            "",
            "stateDiv",
            "state",
            !0
          ),
          TealeafWCJS.rebind("centered_single_column_form");
      },
    });
}

function declareMultipleShipmentOrderDetailsRefreshArea() {
  var e = "WC_MultipleShipmentDisplay_div_18",
    t = "multipleShipmentDetailsContext";
  wcRenderContext.checkIdDefined(t) ||
    wcRenderContext.declare(t, [], {
      shipmentDetailsArea: "update",
    });
  var r = wcRenderContext.getRenderContextProperties(t),
    s = $("#" + e);
  wcRenderContext.addRefreshAreaId(t, e);
  var a = $.extend({}, order_updated, {
    AjaxUpdateOrderItemsAddressId: "AjaxUpdateOrderItemsAddressId",
    AjaxDeleteOrderItemForShippingBillingPage:
      "AjaxDeleteOrderItemForShippingBillingPage",
    OrderItemAddressShipMethodUpdate: "OrderItemAddressShipMethodUpdate",
    AjaxPrepareOrderForShipChargeUpdate: "AjaxPrepareOrderForShipChargeUpdate",
    OrderItemAddressShipInstructionsUpdate:
      "OrderItemAddressShipInstructionsUpdate",
    OrderItemAddressShipInstructionsUpdate1:
      "OrderItemAddressShipInstructionsUpdate1",
    AjaxAddUnboundPaymentInstructionToThisOrder:
      "AjaxAddUnboundPaymentInstructionToThisOrder",
    AjaxDeleteUnboundPaymentInstructionFromThisOrder:
      "AjaxDeleteUnboundPaymentInstructionFromThisOrder",
    AddBillingAddressInCheckOut: "AddBillingAddressInCheckOut",
  });
  wcTopic.subscribe(a, function (e) {
    CheckoutHelperJS.RequestShippingDateAction ||
    ("AddBillingAddressInCheckOut" == e.actionId &&
      "Billing" == e.addBillingAddressInCheckOutAddressType)
      ? (CheckoutHelperJS.RequestShippingDateAction = !1)
      : (s.refreshWidget("refresh", r), submitRequest(), cursor_wait());
  });
  var i = function () {
      wcRenderContext.testForChangedRC(t, ["beginIndex"]) &&
        s.refreshWidget("refresh", r);
    },
    n = function () {
      if (
        (resetRequest(),
        cursor_clear(),
        "true" == r.initializeJS &&
          ($('input[id^="orderItem_"]').each(function (e, t) {
            $.globalEval($("#addToRequisitionListScript_" + t.value).html());
            var r = "addReqListsJS" + t.value;
            $.globalEval(
              "if(typeof " +
                r +
                ' !== "undefined") {' +
                r +
                '.setCatEntryId("' +
                document.getElementById(
                  "catalogId_" + t.id.substring(t.id.indexOf("_") + 1)
                ).value +
                '");}'
            );
          }),
          $('div[id^="shoppingListScript_"]').each(function (e, t) {
            $.globalEval($(t).html());
          })),
        numAjaxRequests >= 0 &&
          null != CheckoutHelperJS.getLastAddressLinkIdToFocus() &&
          "undefined" != CheckoutHelperJS.getLastAddressLinkIdToFocus() &&
          "" != CheckoutHelperJS.getLastAddressLinkIdToFocus())
      )
        if (
          null !=
          document.getElementById(
            CheckoutHelperJS.getLastAddressLinkIdToFocus()
          )
        )
          document
            .getElementById(CheckoutHelperJS.getLastAddressLinkIdToFocus())
            .focus();
        else {
          var e = CheckoutHelperJS.getLastAddressLinkIdToFocus(),
            t = e.split("_"),
            s = parseInt(t[t.length - 1]) + 1 + "";
          if (e.indexOf("WC_ShippingAddressSelectMultiple_link_2_") > -1) {
            var a = "WC_ShippingAddressSelectMultiple_link_2_" + s;
            null != document.getElementById(a) &&
              document.getElementById(a).focus();
          } else {
            var a = "WC_ShippingAddressSelectMultiple_link_3_" + s;
            null != document.getElementById(a) &&
              document.getElementById(a).focus();
          }
        }
      else if ("" != CheckoutHelperJS.getLastFocus() && tabPressed) {
        if (
          ((tabPressed = !1),
          null != document.getElementById(CheckoutHelperJS.getLastFocus()))
        )
          document.getElementById(CheckoutHelperJS.getLastFocus()).focus();
        else {
          var e = CheckoutHelperJS.getLastFocus(),
            t = e.split("_"),
            s = parseInt(t[t.length - 1]) + 1 + "";
          if (e.indexOf("WC_ShippingAddressSelectMultiple_link_2_") > -1) {
            var a = "WC_ShippingAddressSelectMultiple_link_2_" + s;
            null != document.getElementById(a) &&
              document.getElementById(a).focus();
          } else {
            var a = "WC_ShippingAddressSelectMultiple_link_3_" + s;
            null != document.getElementById(a) &&
              document.getElementById(a).focus();
          }
        }
        CheckoutHelperJS.setLastFocus("");
      }
    };
  s.refreshWidget({
    renderContextChangedHandler: i,
    postRefreshHandler: n,
  });
}

function declareMultipleShipmentShipChargeRefreshArea() {
  var e = "multipleShipmentShipChargeContext",
    t = "WC_MultipleShipmentDisplay_ShipCharge_Area",
    r = $("#" + t);
  wcRenderContext.checkIdDefined(e) || wcRenderContext.declare(e, [], null);
  var s = wcRenderContext.getRenderContextProperties(e);
  wcRenderContext.addRefreshAreaId(e, t),
    wcTopic.subscribe(
      [
        "OrderItemAddressShipMethodUpdate",
        "AjaxDeleteOrderItemForShippingBillingPage",
      ],
      function (e) {
        SBControllersDeclarationJS.shipChargeEnabled &&
          ("OrderItemAddressShipMethodUpdate" == e.actionId &&
            r.refreshWidget("refresh", s),
          "AjaxDeleteOrderItemForShippingBillingPage" == e.actionId &&
            r.refreshWidget("refresh", s));
      }
    );
  var a = function () {
    cursor_clear();
  };
  r.refreshWidget({
    postRefreshHandler: a,
  });
}

function declareDOMEditShippingAdddressAreaController() {
  var e = "editShippingAddressContext",
    t = "editShippingAddressArea1",
    r = $("#" + t),
    s = wcRenderContext.getRenderContextProperties(e);
  wcRenderContext.addRefreshAreaId(e, t),
    wcTopic.subscribe(address_updated, function () {
      wcRenderContext.updateRenderContext("contextForMainAndAddressDiv", {
        showArea: "mainContents",
        hideArea: "editAddressContents",
      }),
        cursor_clear();
    }),
    r.refreshWidget({
      renderContextChangedHandler: function () {
        if (wcRenderContext.testForChangedRC(e, ["shippingAddress"])) {
          var t = s.shippingAddress;
          s.shippingAddress = 0;
          var a = s.addressType;
          r.refreshWidget("refresh", {
            addressId: t,
            addressType: a,
          });
        }
      },
      postRefreshHandler: function () {
        cursor_clear();
      },
    });
}

function nullCartTotalCookie(e) {
  setCookie("WC_CartTotal_" + e, null, {
    expires: -1,
    path: "/",
    domain: cookieDomain,
  });
  for (var t = document.cookie.split(";"), r = 0; r < t.length; r++) {
    var s = t[r].indexOf("="),
      a = t[r].substr(0, s),
      i = t[r].substr(s + 1);
    if (
      ((a = a.replace(/^\s+|\s+$/g, "")),
      (i = i.replace(/^\s+|\s+$/g, "")),
      i == e)
    ) {
      setCookie(a, null, {
        expires: -1,
        path: "/",
        domain: cookieDomain,
      });
      break;
    }
  }
}

function initializeInactivityWarning() {
  "G" != storeUserType &&
    0 != inactivityTimeout &&
    document.cookie.indexOf("WC_USERACTIVITY_") > 0 &&
    (null != inactivityTimeoutTracker && clearTimeout(inactivityTimeoutTracker),
    (inactivityTimeoutTracker = setTimeout(
      showInactivityWarningDialog,
      inactivityTimeout - inactivityWarningDialogBuffer
    )));
}

function showInactivityWarningDialog() {
  $("#inactivityWarningPopup").data("wc-WCDialog").open(),
    null != dialogTimeoutTracker && clearTimeout(dialogTimeoutTracker),
    (dialogTimeoutTracker = setTimeout(
      hideInactivityWarningDialog,
      inactivityWarningDialogDisplayTimer
    ));
}

function hideInactivityWarningDialog() {
  $("#inactivityWarningPopup").hide();
}

function resetServerInactivity() {
  $.post({
    url: getAbsoluteURL() + "Ping",
    success: function (e, t, r) {
      e.success
        ? initializeInactivityWarning()
        : console.error("Ping service failed");
    },
    error: function (e, t, r) {
      console.error("Ping service failed");
    },
  });
}

function byId(e) {
  return document.getElementById(e);
}

function focusSetter() {
  $("#MiniCartFocusReceiver1").length
    ? $("#MiniCartFocusReceiver1").focus()
    : $("#MiniCartFocusReceiver2").focus();
}

function determineFocus(e) {
  e.shiftKey &&
    e.keyCode === KeyCodes.TAB &&
    (e.srcElement
      ? "MiniCartFocusReceiver1" == e.srcElement.id
        ? ($("#WC_MiniShopCartDisplay_link_5").focus(), Utils.stopEvent(e))
        : "MiniCartFocusReceiver2" == e.srcElement.id &&
          ($("#MiniCartFocusReceiver2").focus(), Utils.stopEvent(e))
      : "MiniCartFocusReceiver1" == e.target.id
      ? ($("#WC_MiniShopCartDisplay_link_5").focus(), Utils.stopEvent(e))
      : "MiniCartFocusReceiver2" == e.target.id &&
        ($("#MiniCartFocusReceiver2").focus(), Utils.stopEvent(e)));
}

function destroyDialog(e) {
  void 0 == e && (e = "quick_cart_container");
  var t = $("#" + e).data("wc-WCDialog");
  t && t.destroy(),
    void 0 != e && "quick_cart_container" == e
      ? (dropDownDlg = null)
      : (productAddedDropDownDlg = null);
}

function loadLink(e) {
  document.location.href = e;
}

function clearSearchField() {
  (searchText = $("#SimpleSearchForm_SearchTerm").val()),
    searchText == $("#searchTextHolder").html()
      ? $("#SimpleSearchForm_SearchTerm").val("")
      : (document.getElementById("SimpleSearchForm_SearchTerm").select(),
        showAutoSuggestIfResults(),
        (autoSuggestHover = !1));
}

function fillSearchField() {
  "" == $("#SimpleSearchForm_SearchTerm").val() &&
    ((document.getElementById("SimpleSearchForm_SearchTerm").className =
      "search_input gray_color"),
    $("#SimpleSearchForm_SearchTerm").val($("#searchTextHolder").html())),
    autoSuggestHover || showAutoSuggest(!1);
}

function showDropDownMenu() {
  $("#header_menu_dropdown").css("display", "block"),
    $("#outerCartContainer").css("display", "block");
}

function cursor_wait(e) {
  var t = !0;
  1 == e && Utils.isOpera() && (t = !1),
    t && ENV_SHOWLOADER && setTimeout("showProgressBar()", 500);
}

function showProgressBar() {
  requestSubmitted && displayProgressBar();
}

function displayProgressBar() {
  var e = $("#progress_bar_dialog").data("wc-WCDialog");
  if (e) {
    var t = $("#progress_bar");
    t.css("display", "block"),
      "" !== this.currentId
        ? e.option("position", {
            my: "left top",
            at: "right top",
            of: $("#" + this.currentId),
          })
        : (t.css("left", ""), t.css("top", ""), e.element.html(t)),
      e.open(),
      setTimeout("cursor_clear()", 18e5);
  }
}

function setCurrentId(e) {
  requestSubmitted || "" !== this.currentId || (this.currentId = e);
}

function trim(e) {
  word = e.toString();
  for (var t = 0, r = word.length - 1; " " == word.charAt(t); ) t++;
  for (; " " == word.charAt(r); ) r -= 1;
  return t > r ? word.substring(t, t) : word.substring(t, r + 1);
}

function cursor_clear() {
  //requestSubmitted = !1, wcTopic.publish("requestSubmittedChanged", requestSubmitted), showLoadingInternal(false, null);
  (requestSubmitted = !1),
    wcTopic.publish("requestSubmittedChanged", requestSubmitted);
  var e = $("#progress_bar_dialog").data("wc-WCDialog"),
    t = document.getElementById("progress_bar");
  null != e &&
    (null != t && $(t).css("display", "none"),
    e.close(),
    (this.currentId = ""));
}

function escapeXml(e, t) {
  return (
    t &&
      (e = e
        .replace(/&(?!(quot;|#34;|#034;|#x27;|#39;|#039;))/gm, "&amp;")
        .replace(/</gm, "&lt;")
        .replace(/>/gm, "&gt;")),
    (e = e.replace(/"/gm, "&#034;").replace(/'/gm, "&#039;"))
  );
}

function submitRequest() {
  return requestSubmitted
    ? !1
    : ((requestSubmitted = !0),
      wcTopic.publish("requestSubmittedChanged", requestSubmitted),
      !0);
}

function resetRequest() {
  (requestSubmitted = !1),
    wcTopic.publish("requestSubmittedChanged", requestSubmitted);
}

function setPageLocation(e) {
  submitRequest() && (document.location.href = e);
}

function submitSpecifiedForm(e) {
  submitRequest() &&
    (console.debug("form.action == " + e.action), processAndSubmitForm(e));
}

function getLocation(e) {
  var t = e;
  t.match(/^[a-zA-Z]+:\/\//) || (t = "http://" + t);
  var r = document.createElement("a");
  return (r.href = t), r;
}

function getReturnUrl(e) {
  var t,
    r = this.getLocation(decodeURIComponent(e));
  (t = r.hostname === location.hostname ? e : "about:blank"),
    (location.href = t);
}

function matchUrlProtocol(e) {
  if (!stringStartsWith(e, "http")) return e;
  var t = document.location.href,
    r = t.lastIndexOf("s", 4),
    s = e,
    a = s.lastIndexOf("s", 4);
  return (
    -1 != r && -1 == a
      ? (s = s.substring(0, 4) + "s" + s.substring(4))
      : -1 == r && -1 != a && (s = s.substring(0, 4) + s.substring(5)),
    s
  );
}

function hideElementById(e) {
  $("#" + e).css("display", "none");
}

function showElementById(e) {
  if (
    e == "billingAddressCreateEditFormDiv_1" &&
    (window.mobilecheck() || window.tabletPortraitCheck())
  ) {
    $("#" + e).css("display", "flex");
  } else {
    $("#" + e).css("display", "block");
  }
}

function hideBackgroundImage(e) {
  $(e).css("backgroundImage", "none");
}

function showBackgroundImage(e) {
  $(e).css(
    "backgroundImage",
    "url(" +
      getImageDirectoryPath() +
      getStyleDirectoryPath() +
      "product_hover_background.png)"
  );
}

function checkIE8Browser() {
  Utils.get_IE_version() &&
    Utils.get_IE_version() <= 8 &&
    (correctBrowser = !0);
}

function ApprovalToolLink(e, t) {
  return (
    checkIE8Browser(),
    correctBrowser
      ? void (RFQwindow = window.open(t))
      : void MessageHelper.formErrorHandleClient(
          e,
          MessageHelper.messages.ERROR_INCORRECT_BROWSER
        )
  );
}

function updateViewAndBeginIndexForCurrencyChange() {
  $("#fastFinderResultControls").length &&
  "" != document.getElementById("fastFinderResultControls")
    ? (null != document.SetCurrencyPreferenceForm.pageView &&
        (document.SetCurrencyPreferenceForm.pageView.value =
          document.FastFinderForm.pageView.value),
      null != document.SetCurrencyPreferenceForm.beginIndex &&
        (document.SetCurrencyPreferenceForm.beginIndex.value =
          document.FastFinderForm.beginIndex.value))
    : $("#CategoryDisplay_Widget").length &&
      "" != document.getElementById("CategoryDisplay_Widget")
    ? ("" !==
        wcRenderContext.getRenderContextProperties("CategoryDisplay_Context")
          .properties.pageView &&
        null != document.SetCurrencyPreferenceForm.pageView &&
        (document.SetCurrencyPreferenceForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "CategoryDisplay_Context"
          ).properties.pageView),
      "" !==
        wcRenderContext.getRenderContextProperties("CategoryDisplay_Context")
          .properties.beginIndex &&
        null != document.SetCurrencyPreferenceForm.beginIndex &&
        (document.SetCurrencyPreferenceForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "CategoryDisplay_Context"
          ).properties.beginIndex))
    : $("#Search_Result_Summary").length &&
      "" != document.getElementById("Search_Result_Summary")
    ? ("" !==
        wcRenderContext.getRenderContextProperties(
          "catalogSearchResultDisplay_Context"
        ).properties.searchResultsView &&
        null != document.SetCurrencyPreferenceForm.pageView &&
        (document.SetCurrencyPreferenceForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "catalogSearchResultDisplay_Context"
          ).properties.searchResultsView),
      "" !==
        wcRenderContext.getRenderContextProperties(
          "catalogSearchResultDisplay_Context"
        ).properties.searchResultsPageNum &&
        null != document.SetCurrencyPreferenceForm.beginIndex &&
        (document.SetCurrencyPreferenceForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "catalogSearchResultDisplay_Context"
          ).properties.searchResultsPageNum))
    : $("#Search_Result_Summary2").length &&
      "" != document.getElementById("Search_Result_Summary2") &&
      ("" !==
        wcRenderContext.getRenderContextProperties(
          "contentSearchResultDisplay_Context"
        ).properties.searchResultsView &&
        null != document.SetCurrencyPreferenceForm.pageView &&
        (document.SetCurrencyPreferenceForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "contentSearchResultDisplay_Context"
          ).properties.searchResultsView),
      "" !==
        wcRenderContext.getRenderContextProperties(
          "contentSearchResultDisplay_Context"
        ).properties.searchResultsPageNum &&
        null != document.SetCurrencyPreferenceForm.beginIndex &&
        (document.SetCurrencyPreferenceForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "contentSearchResultDisplay_Context"
          ).properties.searchResultsPageNum));
  try {
    (void 0 != window.top._ceaCollabDialog ||
      null != window.top._ceaCollabDialog) &&
      ($("#SetCurrencyPreferenceForm")[0].URL.value =
        $("#SetCurrencyPreferenceForm")[0].URL.value +
        "&coshopChangeCurrency=" +
        $("#currencySelection").find(":selected").text());
  } catch (e) {
    console.log(e);
  }
}

function updateViewAndBeginIndexForLanguageChange() {
  $("#fastFinderResultControls").length &&
  "" != document.getElementById("fastFinderResultControls")
    ? (null != document.LanguageSelectionForm.pageView &&
        (document.LanguageSelectionForm.pageView.value =
          document.FastFinderForm.pageView.value),
      null != document.LanguageSelectionForm.beginIndex &&
        (document.LanguageSelectionForm.beginIndex.value =
          document.FastFinderForm.beginIndex.value))
    : $("#CategoryDisplay_Widget").length &&
      "" != document.getElementById("CategoryDisplay_Widget")
    ? ("" !==
        wcRenderContext.getRenderContextProperties("CategoryDisplay_Context")
          .properties.pageView &&
        null != document.LanguageSelectionForm.pageView &&
        (document.LanguageSelectionForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "CategoryDisplay_Context"
          ).properties.pageView),
      "" !==
        wcRenderContext.getRenderContextProperties("CategoryDisplay_Context")
          .properties.beginIndex &&
        null != document.LanguageSelectionForm.beginIndex &&
        (document.LanguageSelectionForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "CategoryDisplay_Context"
          ).properties.beginIndex))
    : $("#Search_Result_Summary").length &&
      "" != document.getElementById("Search_Result_Summary")
    ? ("" !==
        wcRenderContext.getRenderContextProperties(
          "catalogSearchResultDisplay_Context"
        ).properties.searchResultsView &&
        null != document.LanguageSelectionForm.pageView &&
        (document.LanguageSelectionForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "catalogSearchResultDisplay_Context"
          ).properties.searchResultsView),
      "" !==
        wcRenderContext.getRenderContextProperties(
          "catalogSearchResultDisplay_Context"
        ).properties.searchResultsPageNum &&
        null != document.LanguageSelectionForm.beginIndex &&
        (document.LanguageSelectionForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "catalogSearchResultDisplay_Context"
          ).properties.searchResultsPageNum))
    : $("#Search_Result_Summary2").length &&
      "" != document.getElementById("Search_Result_Summary2") &&
      ("" !==
        wcRenderContext.getRenderContextProperties(
          "contentSearchResultDisplay_Context"
        ).properties.searchResultsView &&
        null != document.LanguageSelectionForm.pageView &&
        (document.LanguageSelectionForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "contentSearchResultDisplay_Context"
          ).properties.searchResultsView),
      "" !==
        wcRenderContext.getRenderContextProperties(
          "contentSearchResultDisplay_Context"
        ).properties.searchResultsPageNum &&
        null != document.LanguageSelectionForm.beginIndex &&
        (document.LanguageSelectionForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "contentSearchResultDisplay_Context"
          ).properties.searchResultsPageNum));
  try {
    (void 0 != window.top._ceaCollabDialog ||
      null != window.top._ceaCollabDialog) &&
      $("#LanguageSelectionForm").attr(
        "action",
        $("#LanguageSelectionForm").attr("action") +
          "&langId=" +
          $("#languageSelection").find(":selected").text()
      );
  } catch (e) {
    console.log(e);
  }
}

function showHeaderLinksInTwoLines() {
  $("#header_links").length &&
    ($("#header_links").width() > 750 &&
      ($("#header_links1").css("display", "block"),
      $("#headerHomeLink").css("display", "none"),
      $("#headerShopCartLink").css("display", "none")),
    $("#header_links").css("visibility", "visible"));
}

function showLinksInOneLine() {
  $("#header_links").css("visibility", "visible");
}

function isNonNegativeInteger(e) {
  var t = new RegExp(/^\d*$/);
  return null != e && "" !== e && t.test(e);
}

function isPositiveInteger(e) {
  return isNonNegativeInteger(e) && 0 != e;
}

function closeAllDialogs() {
  $("[data-widget-type='wc.WCDialog']").each(function (e, t) {
    $(t).hide();
  });
}

function setWarningMessageCookie(e) {
  setCookie("signon_warning_cookie", e, {
    path: "/",
    domain: cookieDomain,
  });
}

function removeCookie(e) {
  setCookie(e, null, {
    expires: -1,
  });
}

function getCookie(e) {
  for (var t = document.cookie.split(";"), r = 0; r < t.length; r++) {
    var s = t[r].indexOf("="),
      a = t[r].substr(0, s);
    if (((a = a.replace(/^\s+|\s+$/g, "")), a == e))
      return decodeURIComponent(t[r].substr(s + 1));
  }
}

function deleteOnBehalfRoleCookie() {
  var e = getCookie("WC_OnBehalf_Role_" + WCParamJS.storeId);
  null != e &&
    setCookie("WC_OnBehalf_Role_" + WCParamJS.storeId, null, {
      expires: -1,
      path: "/",
      domain: cookieDomain,
    });
}

function getCookieName_BeginningWith(e) {
  for (var t = document.cookie.split(";"), r = 0; r < t.length; r++) {
    var s = t[r].indexOf("="),
      a = t[r].substr(0, s);
    if (((a = a.replace(/^\s+|\s+$/g, "")), stringStartsWith(a, e))) return a;
  }
}

function stringStartsWith(e, t) {
  return t.length > 0 && e.substring(0, t.length) === t;
}

function isStorePreview(e, t) {
  return e.indexOf(t) > -1;
}

function hideESpotInfoPopup(e, t) {
  if (null == t || "keypress" != t.type || t.keyCode === KeyCodes.ESCAPE) {
    var r = $("#" + e);
    r.length && r.data("wc-WCDialog").close();
  }
}

function showESpotInfoPopup(e, t) {
  if (
    (null == t || "keypress" != t.type || t.keyCode === KeyCodes.RETURN) &&
    parent.checkPopupAllowed()
  ) {
    var r = $("#" + e).data("wc-WCDialog");
    r &&
      (r.bringToFront(),
      r.bringToFront($(".ESpotInfo")),
      r.open(),
      r.reposition());
  }
}

function incrementNumAjaxRequest() {
  "undefined" != numAjaxRequests && numAjaxRequests++;
}

function decrementNumAjaxRequest() {
  "undefined" != numAjaxRequests && 0 != numAjaxRequests && numAjaxRequests--;
}

function updateParamObject(e, t, r, s, a) {
  if ((null == e && (e = []), null != e[t] && s))
    if ($.isArray(e[t])) null != a && "" !== a ? (e[t][a] = r) : e[t].push(r);
    else {
      var i = e[t];
      (e[t] = []), e[t].push(i), e[t].push(r);
    }
  else if (null != a && "" !== a && -1 != a) e[t + "_" + a] = r;
  else if (-1 == a) {
    for (var n = 1; null != e[t + "_" + n]; ) n++;
    e[t + "_" + n] = r;
  } else e[t] = r;
  return e;
}

function showSection(e) {
  $("#" + e).css("visibility", "visible");
}

function hideSection(e) {
  $("#" + e).css("visibility", "");
}

function shiftTabHideSection(e, t) {
  t.shiftKey && t.keyCode === KeyCodes.TAB && hideSection(e);
}

function tabHideSection(e, t, r) {
  t.shiftKey ||
    t.keyCode !== KeyCodes.TAB ||
    (null != r && $("#" + r).focus(), hideSection(e), Utils.stopEvent(t));
}

function saveShiftTabPress(e) {
  1 == e.shiftKey && e.keyCode === KeyCodes.TAB && (tabPressed = !0);
}

function saveTabPress(e) {
  0 == e.shiftKey && e.keyCode === KeyCodes.TAB && (tabPressed = !0);
}

function setFocus(e) {
  tabPressed && ((tabPressed = !1), document.getElementById(e).focus());
}

function increaseHeight(e, t) {
  var r = document.getElementById(e).offsetHeight;
  $("#" + e).css("height", r + t + "px");
}

function redirectToSignOn(e) {
  var t = "Header_GlobalLogin";
  setCookie("WC_RedirectToPage_" + WCParamJS.storeId, e, {
    path: "/",
    domain: cookieDomain,
  }),
    GlobalLoginJS.InitHTTPSecure(t);
}

function handlePopup(e, t) {
  currentPopup == t ? (document.location.href = e) : (currentPopup = t);
}

function isAndroid() {
  if (null == android && null != navigator && null != navigator.userAgent) {
    var e = navigator.userAgent.toLowerCase();
    android = e.indexOf("android") > -1;
  }
  return android;
}

function isIOS() {
  if (null == ios && null != navigator && null != navigator.userAgent) {
    var e = navigator.userAgent.toLowerCase();
    ios =
      e.indexOf("ipad") > -1 ||
      e.indexOf("mac") > -1 ||
      e.indexOf("iphone") > -1 ||
      e.indexOf("ipod") > -1;
  }
  return ios;
}

function outlineSpots() {
  $(document.body).addClass("editMode"),
    $(".carousel > .content").css("zIndex", "auto"),
    $(".ESpotInfo").css("display", "block"),
    $(".searchScore").css("display", "block"),
    $(".editManagedContent").css("display", "block"),
    $(
      ".genericESpot,.product,.searchResultSpot,.productDetail,.categorySpot"
    ).each(function (e, t) {
      if ($(t).hasClass("emptyESpot")) {
        var r = $(".ESpotInfo", t)[0].offsetWidth + 4,
          s = $(".ESpotInfo", t)[0].offsetHeight + 4;
        $(t).attr("_width", $(t).css("width")),
          $(t).attr("_height", $(t).css("height")),
          $(t).css({
            width: +r + "px",
            height: s + "px",
          });
      }
      $(".borderCaption").length
        ? $(t).prepend("<div class='borderCaption'></div>")
        : $(".borderCaption", t).css({
            display: "block",
          }),
        t.addEventListener
          ? (t.addEventListener(
              "mouseover",
              function (e) {
                window.parent.frames[0].isSpotsShown() &&
                  ($(".caption").css("display", "none"),
                  $(".caption", this).first().css({
                    display: "block",
                  }),
                  e.stopPropagation());
              },
              !1
            ),
            t.addEventListener(
              "mouseout",
              function (e) {
                window.parent.frames[0].isSpotsShown() &&
                  ($(".caption", this).css({
                    display: "none",
                  }),
                  e.stopPropagation());
              },
              !1
            ))
          : t.attachEvent &&
            ((t.onmouseover = (function (e) {
              return function () {
                window.parent.frames[0].isSpotsShown() &&
                  ($(".caption").css("display", "none"),
                  $(".caption", e).first().css({
                    display: "block",
                  }),
                  (window.event.cancelBubble = !0));
              };
            })(t)),
            (t.onmouseleave = (function (e) {
              return function () {
                window.parent.frames[0].isSpotsShown() &&
                  ($(".caption", e).css({
                    display: "none",
                  }),
                  (window.event.cancelBubble = !0));
              };
            })(t)));
    });
}

function hideSpots() {
  $(document.body).removeClass("editMode"),
    $(".carousel > .content").css("zIndex", ""),
    $(".ESpotInfo").css("display", "none"),
    $(".caption").css("display", "none"),
    $(".searchScore").css("display", "none"),
    $(".editManagedContent").css("display", "none"),
    $(".borderCaption").css("display", "none"),
    $(".emptyESpot").each(function (e, t) {
      $(t).css({
        width: $(t).attr("_width") + "px",
      }),
        $(t).css({
          height: $(t).attr("_height") + "px",
        });
    });
}

function logout(e) {
  setDeleteCartCookie(),
    setCookie("WC_FIRST_SESSION_POPUP_" + storeDirectory, "false", {
      path: "/",
      domain: cookieDomain,
    }),
    (document.location.href = e);
}

function switchLanguageCurrency(e) {
  var t = document.location.href,
    r = "/" + $("#currentLanguageSEO").val() + "/";
  if (
    (-1 !== t.indexOf("SearchDisplay") ||
      -1 !== t.indexOf("CategoryDisplay")) &&
    -1 !== t.indexOf("#")
  ) {
    var s = t.split("#");
    t = s[0];
  }
  var a = t;
  if (
    -1 !== t.indexOf(r) &&
    document.getElementById(
      "langSEO" +
        document.getElementById("languageSelection").options[
          document.getElementById("languageSelection").selectedIndex
        ].value
    )
  ) {
    var i =
      "/" +
      document.getElementById(
        "langSEO" +
          document.getElementById("languageSelection").options[
            document.getElementById("languageSelection").selectedIndex
          ].value
      ).value +
      "/";
    a = t.replace(r, i);
  }
  if (-1 !== a.indexOf("&")) {
    var n = a.split("&");
    a = "";
    for (var o = 0; o < n.length; o++)
      -1 === n[o].indexOf("langId=")
        ? (a = "" === a ? n[o] : a + "&" + n[o])
        : n[o].indexOf("langId=") > 0 &&
          (0 == o
            ? (a = n[0].substring(0, n[0].indexOf("langId=")))
            : (a += "&"),
          (a =
            a +
            "langId=" +
            document.getElementById("languageSelection").options[
              document.getElementById("languageSelection").selectedIndex
            ].value));
  }
  (a = switchLanguageCurrencyFilter(a)),
    (document.forms[e].URL.value = a),
    (document.forms[e].languageSelectionHidden.value =
      document.getElementById("languageSelection").options[
        document.getElementById("languageSelection").selectedIndex
      ].value),
    $("#widget_language_and_currency_popup").data("wc-WCDialog").close(),
    "function" == typeof changeStoreViewLanguage &&
      changeStoreViewLanguage(document.forms[e].languageSelectionHidden.value),
    document.getElementById(e).submit();
}

function switchLanguageCurrencyFilter(e) {
  var t = [],
    r = [
      {
        key: "registerNew",
        value: "Y",
      },
    ];
  t.push({
    exclude: "UserRegistrationAdd",
    replace: "UserRegistrationForm",
    param: r,
  });
  for (var s = 0; s < t.length; s++)
    if (e.indexOf(t[s].exclude) > 0) {
      if (((e = e.replace(t[s].exclude, t[s].replace)), void 0 != t[s].param))
        for (var a = t[s].param, i = 0; i < a.length; i++)
          e = appendToURL(e, a[i].key, a[i].value, !1);
      break;
    }
  return e;
}

function isParameterExcluded(e, t) {
  try {
    if ("object" == typeof URLConfig)
      if ("object" == typeof URLConfig.excludedURLPatterns)
        for (var r in URLConfig.excludedURLPatterns) {
          var s = URLConfig.excludedURLPatterns[r],
            a = r;
          if (
            "object" == typeof s &&
            (s.urlPattern && (a = s.urlPattern),
            console.debug("URL pattern to match : " + a),
            (a = new RegExp(a)),
            e.match(a))
          ) {
            var i = s.excludedParameters;
            for (var n in i) if (parametername == n) return !0;
          }
        }
      else console.debug("The parameter " + t + " is not excluded");
    else console.debug("No URLConfig defined.");
  } catch (o) {
    console.debug("An error occured while trying to exclude " + o);
  }
  return !1;
}

function appendToURL(e, t, r, s) {
  s = null == s ? !1 : s;
  var a = new RegExp(t + "=[^&]+"),
    i = t + "=" + r;
  return (
    -1 !== e.indexOf(i) ||
      (!a.test(e) || s
        ? ((e += -1 === e.indexOf("?") ? "?" : "&"), (e += i))
        : (e = e.replace(a, i))),
    e
  );
}

function appendWcCommonRequestParameters(e, t) {
  if (((t = null == t ? !1 : t), "object" == typeof wcCommonRequestParameters))
    for (var r in wcCommonRequestParameters)
      isParameterExcluded(e, r) ||
        (e = appendToURL(e, r, wcCommonRequestParameters[r], t));
  return e;
}

function updateFormWithWcCommonRequestParameters(e, t) {
  if (((t = null == t ? !1 : t), "object" == typeof wcCommonRequestParameters))
    for (var r in wcCommonRequestParameters)
      if (
        void 0 !== e.action &&
        null !== e.action &&
        !isParameterExcluded(e.action, r)
      ) {
        var s = !1;
        $("input[name='" + r + "']", e).each(function (a, i) {
          i.value == wcCommonRequestParameters[r]
            ? (s = !0)
            : t || e.removeChild(i);
        }),
          s ||
            ("get" == e.method
              ? $("<input></input>", {
                  name: r,
                  type: "hidden",
                  value: wcCommonRequestParameters[r],
                }).appendTo(e)
              : (e.action = appendToURL(
                  e.action,
                  r,
                  wcCommonRequestParameters[r],
                  t
                )));
      }
}

function addAuthToken(e) {
  try {
    return (
      $("#csrf_authToken").length
        ? $("<input></input>", {
            name: "authToken",
            type: "hidden",
            value: $("#csrf_authToken").val(),
          }).appendTo(e)
        : console.debug("auth token is missing from the HTML DOM"),
      !0
    );
  } catch (t) {
    console.debug(
      "An error occured while trying to add authToken to the form..." + t
    );
  }
  return !1;
}

function processAndSubmitForm(e) {
  updateFormWithWcCommonRequestParameters(e), addAuthToken(e), e.submit();
}

function getCommonParametersQueryString() {
  return (
    "storeId=" +
    WCParamJS.storeId +
    "&langId=" +
    WCParamJS.langId +
    "&catalogId=" +
    WCParamJS.catalogId
  );
}

function getFinalViewURL(e) {
  var t = e.indexOf("finalView");
  if (-1 != t) {
    var r = e.indexOf("&", t);
    if (-1 == r) var s = e.substring(t + 10);
    else var s = e.substring(t + 10, r);
    var a = e.indexOf("?"),
      i = e.substring(a + 1, t);
    if (-1 == r) var n = "";
    else var n = e.substring(r);
    "&" == i.charAt(i.length - 1) && (i = i.substring(0, i.length - 1)),
      "&" == i.charAt(0) && (i = i.substring(1)),
      "&" == n.charAt(n.length - 1) && (n = n.substring(0, n.length - 1)),
      "&" == n.charAt(0) && (n = n.substring(1));
    var o = "";
    return (
      "" !== i
        ? ((o = s + "?" + i), "" !== n && (o = o + "&" + n))
        : (o = s + "?" + n),
      o
    );
  }
  return "";
}

function invokeItemAdd(e) {
  wcService.getServiceById("MyAcctAjaxAddOrderItem").url = e;
  var t = [];
  (t.PasswordRequestAuthenticated = "TRUE"),
    submitRequest() &&
      (cursor_wait(),
      setCookie("WC_nextURL_" + WCParamJS.storeId, null, {
        expires: -1,
        path: "/",
        domain: cookieDomain,
      }),
      wcService.invoke("MyAcctAjaxAddOrderItem", t));
}

function invokeOtherService(e) {
  wcService.getServiceById("MyAcctGenericService").url = e;
  var t = {
    PasswordRequestAuthenticated: "TRUE",
  };
  submitRequest() &&
    (cursor_wait(),
    setCookie("WC_nextURL_" + WCParamJS.storeId, null, {
      expires: -1,
      path: "/",
      domain: cookieDomain,
    }),
    wcService.invoke("MyAcctGenericService", t));
}

function setCookie(e, t, r) {
  var s = function (e, t, r) {
    r || (r = {});
    var s = r.expires;
    if (s) {
      if ("number" == typeof s) {
        var a = new Date();
        a.setTime(a.getTime() + 24 * s * 60 * 60 * 1e3), (s = a);
      }
      s.toUTCString ? (r.expires = s.toUTCString()) : (r.expires = s);
    }
    t = encodeURIComponent(t);
    var i = e + "=" + t;
    for (var e in r) {
      i += "; " + e;
      var n = r[e];
      n !== !0 && (i += "=" + n);
    }
    document.cookie = i;
  };
  if (r) {
    var a = r;
    for (var i in a) a[i] || delete a[i];
    s(e, t, a);
  } else s(e, t);
}

function getBaseTextDir() {
  var e = getCookie(_BTD_PREFS);
  return e ? e : "";
}

function setBaseTextDir(e) {
  var t = getCookie(_BTD_PREFS);
  t != e && setCookie(_BTD_PREFS, e.toLowerCase());
}

function isRTLValue(e) {
  for (var t in e) {
    if (isBidiChar(e.charCodeAt(t))) return !0;
    if (isLatinChar(e.charCodeAt(t))) return !1;
  }
  return !1;
}

function isBidiChar(e) {
  return e >= 1488 && 1535 >= e
    ? !0
    : e >= 1536 && 1631 >= e
    ? !0
    : e >= 1642 && 1775 >= e
    ? !0
    : e >= 1786 && 2047 >= e
    ? !0
    : e >= 64285 && 65023 >= e
    ? !0
    : e >= 65136 && 65276 >= e
    ? !0
    : !1;
}

function isLatinChar(e) {
  return (e > 64 && 91 > e) || (e > 96 && 123 > e) ? !0 : !1;
}

function resolveBaseTextDir(e, t) {
  return "auto" == t ? (isRTLValue(e) ? "rtl" : "ltr") : t;
}

function handleTextDirection(e) {
  var t = getBaseTextDir();
  null != e &&
    "" !== t &&
    ["INPUT", "TEXTAREA"].indexOf(e.tagName) > -1 &&
    $(e).css("direction", resolveBaseTextDir(e.value, t));
}

function enforceTextDirectionOnPage() {
  var e = getBaseTextDir();
  "" !== e &&
    $(".bidiAware").each(function (t, r) {
      r.dir = $(r).css(
        "direction",
        resolveBaseTextDir(r.value || r.text || r.outerText || r.innerHTML, e)
      );
    });
}

function commonServiceFailureHandler(e) {
  e.errorMessage
    ? MessageHelper.displayErrorMessage(e.errorMessage)
    : e.errorMessageKey && MessageHelper.displayErrorMessage(e.errorMessageKey),
    cursor_clear();
}

function isChrome() {
  return (
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
  );
}

function isSafari() {
  return (
    /Safari/.test(navigator.userAgent) &&
    /Apple Computer/.test(navigator.vendor)
  );
}

function successHandlerForURLChainingService(e) {
  if (
    (console.debug("Success Handler of AjaxCustomServiceForURLChaining", e),
    null != this.postRefreshHandlerParameters &&
      "" !== this.postRefreshHandlerParameters)
  ) {
    var t = "";
    (nextServiceURLObject = this.postRefreshHandlerParameters.splice(0, 1)[0]),
      console.debug("nextServiceURLObject ", nextServiceURLObject);
    if (
      null != nextServiceURLObject &&
      "undefined" != typeof nextServiceURLObject
    ) {
      var t = nextServiceURLObject.URL,
        r = nextServiceURLObject.requestType,
        s = nextServiceURLObject.requestParams;
      console.debug("nextServiceURL ", t),
        console.debug("requestType ", r),
        console.debug("requestParams ", s);
    }
    if ("" !== t)
      if ("GET" == r) {
        -1 === t.indexOf("?") &&
          (t = t + "?" + getCommonParametersQueryString());
        for (var a in s) t = t + "&" + a + "=" + s[a];
        document.location.href = t;
      } else {
        var i = getCustomServiceForURLChaining(
          t,
          this.postRefreshHandlerParameters
        );
        wcService.invoke(i.getParam("id"), s);
      }
    else
      console.debug(
        "End of URL chaining with AjaxCustomServiceForURLChaining service"
      );
  }
}

function getCustomServiceForURLChaining(e, t, r) {
  var s = wcService.getServiceById("AjaxCustomServiceForURLChaining");
  return (
    (null == s || void 0 == s) &&
      (console.debug("Start creating AjaxCustomServiceForURLChaining"),
      wcService.declare({
        id: "AjaxCustomServiceForURLChaining",
        actionId: "AjaxCustomServiceForURLChaining",
        url: "",
        formId: "",
        successHandler: successHandlerForURLChainingService,
        failureHandler: commonServiceFailureHandler,
      }),
      (s = wcService.getServiceById("AjaxCustomServiceForURLChaining"))),
    null != e &&
      "undefined" != e &&
      (stringStartsWith("url", "http")
        ? s.setUrl(e)
        : s.setUrl(getAbsoluteURL() + e)),
    null != t && "undefined" != t
      ? s.setParam("postRefreshHandlerParameters", t)
      : s.setParam("postRefreshHandlerParameters", null),
    null != r && "undefined" != r ? s.setFormId(r) : s.setFormId(null),
    console.debug("Return AjaxCustomServiceForURLChaining", s),
    s
  );
}

function declareDeptDropdownRefreshArea(e) {
  wcRenderContext.declare("departmentSubMenuContext", [e], {
    targetId: "",
  });
  var t = function () {
      $("#" + e).refreshWidget(
        "refresh",
        wcRenderContext.getRenderContextProperties("departmentSubMenuContext")
      );
    },
    r = function () {
      updateDepartmentsMenu(),
        activate(
          document.getElementById(
            wcRenderContext.getRenderContextProperties(
              "departmentSubMenuContext"
            ).targetId
          )
        ),
        cursor_clear();
    };
  $("#" + e).refreshWidget({
    renderContextChangedHandler: t,
    postRefreshHandler: r,
  });
}

function ShoppingListJS(
  storeParams,
  catEntryParams,
  shoppingListNames,
  jsObjectName
) {
  (this.storeParams = storeParams),
    (this.catEntryParams = catEntryParams),
    (this.catEntryParams.quantity = 1),
    (this.shoppingListNames = shoppingListNames),
    (this.addItemAfterCreate = !1),
    (this.jsObjectName = jsObjectName),
    (this.dropDownVisible = !1),
    (this.dropDownInFocus = !1),
    (this.dropDownOpen = !1),
    (this.exceptionFlag = !1),
    (this.mouseOnArrow = !1),
    (this.pageName = ""),
    (this.itemId = -1);
  var eventName = "";
  (this.nameToDelete = ""),
    (this.orderItemId = ""),
    (this.actionBeingPerformed = ""),
    "shoppingListJS" != jsObjectName &&
      ((this.pageName = jsObjectName.replace("shoppingListJS", "")),
      (eventName = this.pageName + "_")),
    (this.setCatEntryQuantity = function (e) {
      var e = $.parseJSON(e);
      if ($.isPlainObject(e)) {
        var t = this.catEntryParams.components[e.baseItemId];
        t.id != e.baseItemId && 0 != e.id && (t.id = e.id),
          (t.quantity = e.quantity);
      } else this.catEntryParams.quantity = e;
    }),
    (this.setCatEntryAttributes = function (e) {
      this.catEntryParams.attributes = $.parseJSON(e);
    }),
    (this.setItemId = function (e) {
      this.itemId = e;
    }),
    (this.hideDropDown = function () {
      var e = $("#" + this.pageName + "shoppingListDropDown");
      if (e) {
        $(e).css("display", "none"),
          $("#" + this.pageName + "addToShoppingListBtn .drop")
            .first()
            .focus(),
          (this.dropDownVisible = !1),
          (this.dropDownInFocus = !1),
          (this.dropDownOpen = !1);
        var t = $(".widget_quick_info_popup .content_right_border").first();
        void 0 != t && $(t).css("height", "auto");
      }
    }),
    (this.showDropDown = function () {
      if (0 == this.dropDownOpen) {
        var e = $(".widget_quick_info_popup .content_right_border").first(),
          t = ($(e).height(), "#" + this.pageName + "shoppingListDropDown");
        if (
          ($(t).css("display", ""),
          (this.dropDownVisible = !0),
          $(
            "#" + this.pageName + "shoppingListDropDown.dropdown_list div"
          ).removeClass("focused"),
          $("#quickInfoRefreshArea") && $("#QuickInfoshoppingListDropDown"))
        ) {
          $("#quickInfoRefreshArea").height(),
            $("QuickInfoshoppingListDropDown").height(),
            $(e).height();
        }
        this.dropDownOpen = !0;
      } else this.hideDropDown();
    }),
    (this.showPopup = function (e) {
      this.hideDropDown(), this.clearPopupText();
      var t = $("#" + this.pageName + e + "ShoppingListPopup").data(
          "wc-WCDialog"
        ),
        r = $("#" + this.pageName + "newListName");
      t.option("close_on_primary_click", !1),
        this.hideErrorMessage(),
        this.hideEditErrorMessage(),
        t
          ? (closeAllDialogs(),
            t.close(),
            setTimeout(function () {
              t.open(),
                "create" === e
                  ? $(r).focus()
                  : "edit" === e && $("#editListName").focus();
            }, 250))
          : console.debug(e + "ShoppingListPopup does not exist");
    }),
    (this.showSuccessDialog = function () {
      var e = $("#" + this.pageName + "shoppingListCreateSuccessPopup").data(
        "wc-WCDialog"
      );
      e &&
        "" !== this.actionBeingPerformed &&
        ($("#" + this.pageName + "successMessageAreaText").html(
          Utils.getLocalizationMessage("LIST_CREATED")
        ),
        e.open(),
        (this.actionBeingPerformed = ""));
    }),
    (this.showMessageDialog = function (e) {
      var t = $("#" + this.pageName + "shoppingListCreateSuccessPopup").data(
        "wc-WCDialog"
      );
      t &&
        ($("#" + this.pageName + "successMessageAreaText").html(e), t.open());
    }),
    (this.hideMessageDialog = function () {
      var e = $("#" + this.pageName + "shoppingListCreateSuccessPopup").data(
        "wc-WCDialog"
      );
      e && e.close();
    }),
    (this.showErrorMessage = function (e) {
      document.getElementById(this.pageName + "shoppingListErrorMessageArea") &&
        document.getElementById(
          this.pageName + "shoppingListErrorMessageText"
        ) &&
        ((document.getElementById(
          this.pageName + "shoppingListErrorMessageText"
        ).innerHTML = e),
        (document.getElementById(
          this.pageName + "shoppingListErrorMessageArea"
        ).style.display = "block"));
    }),
    (this.hideErrorMessage = function () {
      document.getElementById(this.pageName + "shoppingListErrorMessageArea") &&
        document.getElementById(
          this.pageName + "shoppingListErrorMessageText"
        ) &&
        ((document.getElementById(
          this.pageName + "shoppingListErrorMessageText"
        ).innerHTML = ""),
        (document.getElementById(
          this.pageName + "shoppingListErrorMessageArea"
        ).style.display = "none"));
    }),
    (this.showEditErrorMessage = function (e) {
      document.getElementById("editShoppingListErrorMessageArea") &&
        document.getElementById("editShoppingListErrorMessageText") &&
        ((document.getElementById(
          "editShoppingListErrorMessageText"
        ).innerHTML = e),
        (document.getElementById(
          "editShoppingListErrorMessageArea"
        ).style.display = "block"));
    }),
    (this.hideEditErrorMessage = function () {
      document.getElementById("editShoppingListErrorMessageArea") &&
        document.getElementById("editShoppingListErrorMessageText") &&
        ((document.getElementById(
          "editShoppingListErrorMessageText"
        ).innerHTML = ""),
        (document.getElementById(
          "editShoppingListErrorMessageArea"
        ).style.display = "none"));
    }),
    (this.create = function () {
      var e = trim($("#" + this.pageName + "newListName").val()),
        t = $("#" + this.pageName + "newListName").maxLength,
        r = Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME");
      if (this.empty(e))
        this.showErrorMessage(Utils.getLocalizationMessage("ERR_NAME_EMPTY"));
      else if (MessageHelper.isValidUTF8length(e, t))
        if (e == r)
          this.showErrorMessage(
            Utils.getLocalizationMessage("ERR_NAME_SHOPPING_LIST")
          );
        else if (this.isDuplicate(e))
          this.showErrorMessage(
            Utils.getLocalizationMessage("ERR_NAME_DUPLICATE")
          );
        else if (this.validateWishName(e)) {
          var s = this.setCommonParams();
          if (((s.name = e), !submitRequest())) return;
          cursor_wait(),
            wcService.invoke("ShoppingListServiceCreate", s),
            (this.actionBeingPerformed = "create");
        } else
          this.showErrorMessage(
            Utils.getLocalizationMessage("INVALID_NAME_SHOPPING_LIST")
          );
      else
        this.showErrorMessage(Utils.getLocalizationMessage("ERR_NAME_TOOLONG"));
    }),
    (this.createDefaultListAndAddItem = function (e, t, r) {
      if ((t && "" != t && (this.orderItemId = t), "-1" == e)) {
        var s = this.setCommonParams();
        if (
          ((s.name = Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME")),
          !submitRequest())
        )
          return;
        cursor_wait(),
          (this.addItemAfterCreate = !0),
          wcService.invoke("ShoppingListServiceCreate", s);
      } else
        t && "" != t ? this.addToListAndDelete(e, t, r) : this.addToList(e, r);
    }),
    (this.addToList = function (e, t) {
      this.hideDropDown();
      var r = this.setCommonParams();
      r.giftListId = e;
      var s = this.catEntryParams.id;
      if (
        "itembean" == this.catEntryParams.type.toLowerCase() ||
        "packagebean" == this.catEntryParams.type.toLowerCase() ||
        "preddynakitbean" == this.catEntryParams.type.toLowerCase() ||
        "dynamickitbean" == this.catEntryParams.type.toLowerCase()
      )
        updateParamObject(r, "catEntryId", this.catEntryParams.id, !1, -1),
          updateParamObject(
            r,
            "quantity",
            this.catEntryParams.quantity,
            !1,
            -1
          );
      else if ("bundlebean" == this.catEntryParams.type.toLowerCase()) {
        var a = !0;
        for (baseItemId in this.catEntryParams.components)
          if (
            this.catEntryParams.components[baseItemId].skus &&
            this.catEntryParams.components[baseItemId].skus.length > 1
          ) {
            var i = this.catEntryParams.components[baseItemId].resolved;
            if (null == i || "undefined" == i || 0 == i) {
              a = !1;
              break;
            }
          }
        if (!a)
          return void MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("ERR_RESOLVING_SKU")
          );
        for (baseItemId in this.catEntryParams.components)
          updateParamObject(
            r,
            "catEntryId",
            this.catEntryParams.components[baseItemId].id,
            !1,
            -1
          ),
            updateParamObject(
              r,
              "quantity",
              this.catEntryParams.components[baseItemId].quantity,
              !1,
              -1
            );
      } else {
        var n = this.itemId;
        if ((-1 == n && (n = this.resolveSKU()), -1 == n))
          return void MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("ERR_RESOLVING_SKU")
          );
        (s = n),
          updateParamObject(r, "catEntryId", n, !1, -1),
          updateParamObject(
            r,
            "quantity",
            this.catEntryParams.quantity,
            !1,
            -1
          );
      }
      "shoppingListJS" != this.jsObjectName && QuickInfoJS.close(),
        submitRequest() &&
          (cursor_wait(),
          ShoppingListDialogJS.setDialogParams(this.storeParams, {
            catEntryId: s,
            thumbnail: "imgPath",
            focusElement: t,
          }),
          wcService.invoke("ShoppingListServiceAddItem", r));
    }),
    (this.isDuplicate = function (e) {
      var e = this.escapeXml(e, !0);
      return 1 == this.shoppingListNames[e.toUpperCase()];
    }),
    (this.updateDefaultListId = function (e) {
      (this.shoppingListNames[
        Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME")
      ] = 1),
        $("#" + this.pageName + "addToShoppingList") &&
          $("#" + this.pageName + "addToShoppingList").attr(
            "href",
            '"javascript:" + this.jsObjectName + ".createDefaultListAndAddItem(" + listId + ");"'
          );
    }),
    (this.updateShoppingList = function (e, t, r) {
      var s = this.escapeXml(t, !1);
      (this.shoppingListNames[s.toUpperCase()] = 1),
        !r ||
          ("edit" != r && "delete" != r) ||
          (this.shoppingListNames[this.nameToDelete.toUpperCase()] = -1);
      var a = $("#" + this.pageName + "ShoppingListDivider");
      if (a) {
        var i = "javascript: this.className = 'created_list';";
        if (-1 == this.pageName.indexOf("OI"))
          $("#" + this.pageName + "ShoppingListDivider").before(
            '<div role="menuitem" id="' +
              this.pageName +
              "ShoppingList_" +
              e +
              '" class="created_list" onfocus="javascript:' +
              jsObjectName +
              ".focusList('" +
              e +
              '\'); "  onblur="' +
              i +
              '" onclick="javascript:' +
              jsObjectName +
              ".addToList('" +
              e +
              '\');"><a role="menuitem" id="' +
              this.pageName +
              "ShoppingListLink_" +
              e +
              '" href="javascript:' +
              jsObjectName +
              ".addToList('" +
              e +
              '\');" onfocus="javascript:' +
              jsObjectName +
              ".focusListLink('" +
              e +
              "');\">" +
              t +
              "</a></div>"
          );
        else {
          var n = this.pageName.replace("OI", "");
          $("#" + this.pageName + "ShoppingListDivider").before(
            '<div role="menuitem" id="' +
              this.pageName +
              "ShoppingList_" +
              e +
              '" class="created_list" onfocus="javascript:' +
              jsObjectName +
              ".focusList('" +
              e +
              '\'); "  onblur="' +
              i +
              '" onclick="javascript:' +
              jsObjectName +
              ".addToListAndDelete('" +
              e +
              "','" +
              n +
              '\');"><a role="menuitem" id="' +
              this.pageName +
              "ShoppingListLink_" +
              e +
              '" href="javascript:' +
              jsObjectName +
              ".addToListAndDelete('" +
              e +
              "','" +
              n +
              '\');" onfocus="javascript:' +
              jsObjectName +
              ".focusListLink('" +
              e +
              "');\">" +
              t +
              "</a></div>"
          );
        }
      }
    }),
    (this.clearPopupText = function () {
      $("#" + this.pageName + "newListName").val("");
    }),
    (this.escapeXml = function (e, t) {
      return (
        t &&
          (e = e
            .replace(/&/gm, "&amp;")
            .replace(/</gm, "&lt;")
            .replace(/>/gm, "&gt;")),
        (e = e.replace(/"/gm, "&#034;").replace(/'/gm, "&#039;"))
      );
    }),
    (this.resolveSKU = function () {
      if (1 == this.catEntryParams.skus.length)
        return this.catEntryParams.skus[0].id;
      for (idx = 0; idx < this.catEntryParams.skus.length; idx++) {
        var e = 0,
          t = 0;
        for (attribute in this.catEntryParams.skus[idx].attributes) {
          if (
            (t++,
            !this.catEntryParams.attributes ||
              this.catEntryParams.skus[idx].attributes[attribute] !=
                this.catEntryParams.attributes[attribute])
          )
            break;
          e++;
        }
        if (0 != e && e == t) return this.catEntryParams.skus[idx].id;
      }
      return -1;
    }),
    (this.setCommonParams = function () {
      var e = {};
      return (
        (e.storeId = this.storeParams.storeId),
        (e.catalogId = this.storeParams.catalogId),
        (e.langId = this.storeParams.langId),
        e
      );
    }),
    (this.empty = function (e) {
      return null == e || void 0 == e || "" == e;
    }),
    (this.redirectToSignOn = function () {
      var e = document.location.href,
        t = "Header_GlobalLogin";
      setCookie("WC_RedirectToPage_" + WCParamJS.storeId, e, {
        path: "/",
        domain: cookieDomain,
      }),
        GlobalLoginJS.InitHTTPSecure(t);
    }),
    (this.focusList = function (e) {
      this.focusListByElementId(this.pageName + "ShoppingList_" + e);
    }),
    (this.focusListByElementId = function (e) {
      $("#" + e).hasClass("focused") ||
        $("#" + e.replace("ShoppingList", "ShoppingListLink")).focus();
    }),
    (this.focusListLink = function (e) {
      $(
        "#" + this.pageName + "shoppingListDropDown.dropdown_list div"
      ).removeClass("focused"),
        $("#" + this.pageName + "ShoppingList_" + e).addClass("focused");
    }),
    (this.updateShoppingListAndAddItem = function (e) {
      e.listName == Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME")
        ? this.updateDefaultListId(e.listId)
        : this.updateShoppingList(e.listId, e.listName, e.action),
        this.addItemAfterCreate
          ? ((this.addItemAfterCreate = !1),
            "" != this.orderItemId
              ? this.addToListAndDelete(e.listId, this.orderItemId)
              : this.addToList(e.listId))
          : "add" == e.action && this.showSuccessDialog();
    }),
    (this.navigateDropDown = function (e) {
      var t = this;
      if (e.keyCode === KeyCodes.UP_ARROW) {
        Utils.stopEvent(e);
        var r = !1,
          s = $(
            "#" +
              t.pageName +
              "shoppingListDropDown.dropdown_list div.created_list"
          );
        s.each(function (e, a) {
          !r &&
            $(a).hasClass("focused") &&
            (0 == e
              ? t.focusListByElementId($(s).get(s.length - 1).id)
              : t.focusListByElementId($(s).get(e - 1).id),
            (r = !0));
        });
      } else if (e.keyCode === KeyCodes.DOWN_ARROW) {
        Utils.stopEvent(e);
        var r = !1,
          s = $(
            "#" +
              t.pageName +
              "shoppingListDropDown.dropdown_list div.created_list"
          );
        s.each(function (e, a) {
          !r &&
            $(a).hasClass("focused") &&
            (s.length - 1 == e
              ? t.focusListByElementId($(s).get(0).id)
              : t.focusListByElementId($(s).get(e + 1).id),
            (r = !0));
        });
      } else
        (e.keyCode === KeyCodes.ESCAPE || e.keyCode === KeyCodes.TAB) &&
          (Utils.stopEvent(e), this.hideDropDown());
    }),
    (this.hideIfNoFocus = function () {
      !this.dropDownVisible ||
        this.dropDownInFocus ||
        this.mouseOnArrow ||
        this.hideDropDown();
    }),
    (this.hasFocus = function (e) {
      $(document).on("contextmenu", function (e) {
        1 == e.which
          ? (this.dropDownInFocus = !0)
          : (this.dropDownInFocus = !1);
      });
    }),
    (this.edit = function () {
      var e = trim($("#editListName").val()),
        t = e.maxLength,
        r = Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME");
      if (this.empty(e))
        this.showEditErrorMessage(
          Utils.getLocalizationMessage("ERR_NAME_EMPTY")
        );
      else if (MessageHelper.isValidUTF8length(e, t))
        if (e == r)
          this.showEditErrorMessage(
            Utils.getLocalizationMessage("ERR_NAME_SHOPPING_LIST")
          );
        else if (this.isDuplicate(e))
          this.showEditErrorMessage(
            Utils.getLocalizationMessage("ERR_NAME_DUPLICATE")
          );
        else if (this.validateWishName(e)) {
          var s = this.setCommonParams();
          s.name = e;
          var a = $("#multipleWishlistController_select");
          if (
            (null != a &&
              "undefined" != a &&
              0 != a.value &&
              ((s.giftListId = $("#multipleWishlistController_select").val()),
              (this.nameToDelete = $(
                "#multipleWishlistController_select options:dropdown.selectedIndex"
              ).text())),
            $("#editShoppingListPopup").data("wc-WCDialog").close(),
            !submitRequest())
          )
            return;
          cursor_wait(), wcService.invoke("ShoppingListServiceUpdate", s);
        } else
          this.showErrorMessage(
            Utils.getLocalizationMessage("INVALID_NAME_SHOPPING_LIST")
          );
      else
        this.showEditErrorMessage(
          Utils.getLocalizationMessage("ERR_NAME_TOOLONG")
        );
    }),
    (this.deleteList = function () {
      var e = this.setCommonParams(),
        t = $("#multipleWishlistController_select");
      null != t &&
        "undefined" != t &&
        0 != t.value &&
        ((e.giftListId = $("#multipleWishlistController_select").val()),
        (this.nameToDelete = $(
          "#multipleWishlistController_select options:dropdown.selectedIndex"
        ).text())),
        $("#deleteShoppingListPopup").data("wc-WCDialog").close(),
        submitRequest() &&
          (cursor_wait(), wcService.invoke("ShoppingListServiceDelete", e));
    }),
    (this.refreshLinkState = function () {
      var e = $("#multipleWishlistController_select")[0];
      if (null != e) {
        var t = $("#multipleWishlistController_select")[0].options[
            e.selectedIndex
          ].text,
          r = Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME");
        t == r
          ? ($("#editDivider").css("display", "none"),
            $("#edit_popup_link").css("display", "none"),
            $("#deleteDivider").css("display", "none"),
            $("#delete_popup_link").css("display", "none"))
          : ($("#editDivider").css("display", "block"),
            $("#edit_popup_link").css("display", "block"),
            $("#deleteDivider").css("display", "block"),
            $("#delete_popup_link").css("display", "block"));
      }
    }),
    (this.addToListAndDelete = function (e, t, r) {
      (this.orderItemId = t),
        wcTopic.publish("modelChanged/AnalyticsConversionEvent"),
        this.hideDropDown();
      var s = this.setCommonParams();
      (s.giftListId = e),
        (s.catEntryId_1 = this.catEntryParams.id),
        (s.quantity_1 = 1),
        submitRequest() &&
          (cursor_wait(),
          ShoppingListDialogJS.setDialogParams(this.storeParams, {
            catEntryId: this.catEntryParams.id,
            name: this.catEntryParams.name,
            image: this.catEntryParams.image,
            thumbnail: "imgPath",
            focusElement: r,
          }),
          wcService.invoke("ShoppingListServiceAddItemAndRemoveFromCart", s));
    }),
    (this.deleteItemFromCart = function () {
      if ("" != this.orderItemId) {
        var e = this.orderItemId;
        (this.orderItemId = ""),
          "" != e && CheckoutHelperJS.deleteFromCart(e, !0);
      }
    }),
    (this.validateWishName = function (e) {
      var t = "~!@#$%^&*()+=[]{};:,<>?/|`";
      t += " '\"\\/";
      for (var r = 0; r < e.length; r++)
        if (t.indexOf(e.substring(r, r + 1)) >= 0) return !1;
      return !0;
    }),
    (this.setResolved = function (e, t) {
      this.catEntryParams.components[e].resolved = t;
    }),
    $(document.documentElement).on("mousedown", $.proxy("hideIfNoFocus", this));
  for (baseItemId in this.catEntryParams.components)
    wcTopic.subscribe(
      "DefiningAttributes_Resolved_" + baseItemId,
      function (catEntryId, productId) {
        eval(jsObjectName + ".setResolved('" + productId + "', true)");
      }
    ),
      wcTopic.subscribe(
        "DefiningAttributes_Changed_" + baseItemId,
        function (catEntryId, productId) {
          0 == catEntryId &&
            eval(jsObjectName + ".setResolved('" + productId + "', false)");
        }
      );
}
if (
  (("undefined" != typeof analyticsJS &&
    analyticsJS &&
    analyticsJS.topicNamespace) ||
    (analyticsJS = {
      storeId: 0,
      catalogId: 0,
      urlPath: null,
      miniShopCartTitle: "MiniShoppingCart",
      jsonPageView: "AnalyticsPageView",
      jsonProductView: "AnalyticsProductView",
      jsonElementView: "AnalyticsElementView",
      jsonShopcartView: "AnalyticsShopcartView",
      jsonAddCart: "AnalyticsShopcartView",
      jsonRegistrationView: "AnalyticsRegistrationView",
      jsonConversionEventView: "AnalyticsConversionEventView",
      topicNamespace: "/wc/analytics/",
      pageView: "pageview",
      productView: "productview",
      cartView: "cartview",
      addCart: "addcart",
      element: "element",
      registration: "registration",
      conversionEvent: "conversionevent",
      pageViewControl: !1,
      incTaxInUnitPriceForCart: "F",
      cartViewActionIdList: ["AjaxDeleteOrderItem", "AjaxUpdateOrderItem"],
      addCartActionIdList: ["AddOrderItem", "AjaxAddOrderItemWithShipingInfo"],
      wishlistPageIdList: [
        "AjaxInterestItemAdd",
        "InterestItemDelete",
        "AjaxRestWishListAddItem",
        "AjaxRestWishListRemoveItem",
        "ShoppingListServiceAddItem",
      ],
      conversionEventList: [
        "AjaxInterestItemAdd",
        "AjaxRestWishListAddItem",
        "AjaxInterestItemAddAndDeleteFromCart",
        "ShoppingListServiceAddItem",
        "AnalyticsConversionEvent",
      ],
      publishAnalyticsView: function (e, t, r) {
        var s = this,
          a = {
            url: getAbsoluteURL() + e,
            method: "GET",
            dataType: "json",
            data: $.extend(
              {
                storeId: s.storeId,
                catalogId: s.catalogId,
              },
              t
            ),
            error: function (e, t) {
              wcTopic.publish("ajaxRequestCompleted");
            },
            success: function (e, t) {
              r.call(s, e), wcTopic.publish("ajaxRequestCompleted");
            },
          };
        wcTopic.publish("ajaxRequestInitiated"), $.ajax(a);
      },
      publishTopic: function (e, t) {
        var r = this.makeTopic(e);
        wcTopic.publish(r, t);
      },
      publishPageView: function (e) {
        var t = this;
        this.publishAnalyticsView(t.jsonPageView, e, function (e) {
          t.publishTopic(t.pageView, e);
        });
      },
      publishConversionEventView: function (e) {
        var t = this;
        this.publishAnalyticsView(t.jsonConversionEventView, e, function (e) {
          t.publishTopic(t.conversionEvent, e);
        });
      },
      publishCartView: function () {
        var e = this;
        this.publishAnalyticsView(
          e.jsonShopcartView,
          {
            storeId: e.storeId,
            incTaxInPrice: e.incTaxInUnitPriceForCart,
          },
          function (t) {
            e.publishTopic(e.cartView, t);
          }
        );
      },
      publishAddCart: function () {
        var e = this;
        this.publishAnalyticsView(
          e.jsonAddCart,
          {
            storeId: e.storeId,
            incTaxInPrice: e.incTaxInUnitPriceForCart,
          },
          function (t) {
            e.publishTopic(e.addCart, t);
          }
        );
      },
      publishRegistrationView: function () {
        var e = this;
        this.publishAnalyticsView(
          e.jsonRegistrationView,
          {
            storeId: e.storeId,
          },
          function (t) {
            e.publishTopic(e.registration, t);
          }
        );
      },
      makeTopic: function (e) {
        return [this.topicNamespace, e].join("");
      },
      getMiniShopCartPageCategory: function () {
        return "MiniShoppingCart";
      },
      getMiniShopCartPageName: function () {
        return ["MiniShoppingCart: ", document.title].join("");
      },
      getMiniShopCartPageViewData: function (e) {
        var t = this.getMiniShopCartPageName(),
          r = this.getMiniShopCartPageCategory();
        return {
          pagename: t,
          category: r,
        };
      },
      publishMiniShopCartPageView: function (e) {
        var t = this;
        if (!t.pageViewControl) {
          t.lockPageView();
          var r = this.getMiniShopCartPageViewData(e);
          this.publishPageView(r);
        }
      },
      lockPageView: function () {
        (this.pageViewControl = !0),
          setTimeout("analyticsJS.pageViewControl = false;", 3e3);
      },
      registerMiniShopCartCartView: function () {
        var e = this;
        $(this.cartViewActionIdList).each(function (t, r) {
          wcTopic.subscribe("modelChanged/" + r, function () {
            e.publishCartView();
          });
        }),
          $(this.addCartActionIdList).each(function (t, r) {
            wcTopic.subscribe("modelChanged/" + r, function () {
              e.publishAddCart();
            });
          });
      },
      loadShopCartHandler: function (e) {
        var t = this;
        e === !0 && (t.incTaxInUnitPriceForCart = "T"),
          t.registerMiniShopCartCartView(),
          t.registerShopCartPaginationPageView(),
          t.registerShippingBillingAddressEditPageView();
      },
      loadShopCartPaginationHandler: function () {
        var e = this;
        e.registerShopCartPaginationPageView();
      },
      registerShopCartPaginationPageView: function () {
        var e = this;
        wcTopic.subscribe(
          "ShopCartPaginationDisplay_Context/RenderContextChanged",
          function () {
            var t = {
              pagename: document.title,
            };
            e.publishPageView(t);
          }
        ),
          wcTopic.subscribe(
            "OrderItemPaginationDisplay_Context/RenderContextChanged",
            function () {
              var t = {
                pagename: document.title,
              };
              e.publishPageView(t);
            }
          ),
          wcTopic.subscribe(
            "traditionalShipmentDetailsContext/RenderContextChanged",
            function () {
              var t = {
                pagename: document.title,
              };
              e.publishPageView(t);
            }
          ),
          wcTopic.subscribe(
            "MSOrderItemPaginationDisplay_Context/RenderContextChanged",
            function () {
              var t = {
                pagename: document.title,
              };
              e.publishPageView(t);
            }
          );
      },
      registerShippingBillingAddressEditPageView: function () {
        var e = this;
        wcTopic.subscribe(
          "editShippingAddressContext/RenderContextChanged",
          function () {
            var t = {
              pagename: document.title,
              category: "Shipping and biling address",
            };
            e.publishPageView(t);
          }
        );
      },
      registerStoreLocatorPageViews: function () {
        var e = this;
        wcTopic.subscribe(
          "selectedStoreListContext/RenderContextChanged",
          function () {
            var t = {
              pagename: document.title,
              category: "Store locator",
            };
            e.publishPageView(t);
          }
        ),
          wcTopic.subscribe(
            "storeLocatorResultsContext/RenderContextChanged",
            function () {
              var t = {
                pagename: document.title,
                category: "Store locator",
              };
              e.publishPageView(t);
            }
          );
      },
      loadStoreLocatorPageViews: function () {
        var e = this;
        $(document).ready(function () {
          e.registerStoreLocatorPageViews();
        });
      },
      registerWishlistHandler: function () {
        var e = this,
          t =
            ("Personal Wishlist:" + document.title,
            {
              eventId: "AddToWishlist",
            });
        $(this.conversionEventList).each(function (r, s) {
          wcTopic.subscribe("modelChanged/" + s, function () {
            e.publishConversionEventView(t);
          });
        });
      },
      loadWishlistHandler: function () {
        var e = this;
        $(document).ready(function () {
          e.registerWishlistHandler();
        });
      },
      publishShopCartLoginTags: function () {
        var e = this;
        $(document).ready(function () {
          e.publishRegistrationView(), e.publishCartView();
        });
      },
      registerProductQuickInfoView: function () {
        var e = this;
        "undefined" != typeof QuickInfoJS &&
          Utils.aop_after(QuickInfoJS, "showDetails", function (t) {
            var r = t[0];
            e.publishAnalyticsView(
              e.jsonProductView,
              {
                productId: r,
                storeId: e.storeId,
              },
              function (t) {
                e.publishTopic(e.productView, t);
              }
            );
          });
      },
      loadProductQuickInfoHandler: function () {
        var e = this;
        $(document).ready(function () {
          e.registerProductQuickInfoView();
        });
      },
      loadPagingHandler: function () {
        var e = this;
        $(document).ready(function () {
          var t = {
              forward: "page forward",
              backward: "page backward",
            },
            r = [
              ["Common", "goBack", t.backward],
              ["Common", "goForard", t.forward],
              ["Common.HistoryTracker.prototype", "back", t.backward],
              ["Common.HistoryTracker.prototype", "forward", t.forward],
            ];
          $(r).each(function (t, r) {
            var s = Utils.getObject(r[0]),
              a = r[1],
              i = r[2];
            $(s).on(a, function () {
              e.publishPageView({
                pagename: document.title,
                category: i,
              });
            });
          });
        });
      },
      registerSearchResultPageView: function (
        resultInfoDivId,
        registerPageViewNow,
        advSearchFormDivId
      ) {
        var realSearch = !0,
          scope = this;
        if (registerPageViewNow && $("#" + resultInfoDivId).length) {
          var resultInfo = eval(
              "(" + $("#" + resultInfoDivId).html() + ")"
            ).searchResult,
            pageViewData = {
              pagename: document.title,
            };
          "" !== resultInfo.searchTerms &&
            ((pageViewData =
              "0" !== resultInfo.totalResultCount
                ? {
                    pagename:
                      "Search Successful:" + resultInfo.currentPageNumber,
                  }
                : {
                    pagename: "Search Unsuccessful",
                  }),
            resultInfo.searchTerms.length > 0 &&
              ((pageViewData.searchTerms = resultInfo.searchTerms),
              (pageViewData.searchCount = resultInfo.totalResultCount)),
            (pageViewData.category = "Search Results")),
            (pageViewData.attributes = resultInfo.attributes),
            scope.publishPageView(pageViewData);
        }
      },
      loadSearchResultHandler: function (e, t, r) {
        var s = this;
        wcTopic.subscribe("CMPageRefreshEvent", function () {
          s.registerSearchResultPageView(e, t, r);
        });
      },
      registerPaymentPageView: function (e) {
        var t = this;
        Utils.aop_after(e, "setNumberOfPaymentMethods", function (e) {
          var r = e[1];
          t.publishPageView({
            pagename: r.value,
            category: "payment method",
          }),
            (r = null);
        });
      },
      loadPaymentPageView: function (e) {
        var t = this;
        $(document).ready(function () {
          t.registerPaymentPageView(e);
        });
      },
    }),
  (categoryDisplayJS = {
    entitledItems: [],
    selectedProducts: {},
    selectedAttributes: {},
    errorMessages: {},
    langId: "-1",
    storeId: "",
    catalogId: "",
    orderId: "",
    contextChanged: !1,
    isHistory: !1,
    merchandisingAssociationItems: [],
    baseCatalogEntryDetails: [],
    associationThumbnailIndex: 1,
    totalAssociationCount: 0,
    baseItemAddedToCart: !1,
    merchandisingProductAssociationAddToCart: !1,
    merchandisingProductAssociationForm: "",
    isParentBundleBean: !1,
    userType: "",
    moreInfoUrl: "",
    displayPrevAssociation: "",
    displayNextAssociation: "",
    defaultItemArray: [],
    currentPageType: "",
    currentCatalogEntryId: "",
    entitledItemJsonObject: null,
    isPopup: !1,
    displayPriceRange: !0,
    itemPriceJsonOject: [],
    allSwatchesArray: [],
    setCommonParameters: function (e, t, r, s) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.userType = s);
    },
    setEntitledItems: function (e) {
      this.entitledItems = e;
    },
    setSelectedAttribute: function (e, t) {
      console.debug(e + " : " + t),
        (this.selectedAttributes[e] = t),
        (this.moreInfoUrl = this.moreInfoUrl + "&" + e + "=" + t);
    },
    setSelectedAttributeJS: function (e, t) {
      console.debug(
        e.replace(/'/g, "&#039;") + " : " + t.replace(/'/g, "&#039;")
      ),
        (this.selectedAttributes[e.replace(/'/g, "&#039;")] = t.replace(
          /'/g,
          "&#039;"
        )),
        (this.moreInfoUrl =
          this.moreInfoUrl +
          "&" +
          e.replace(/'/g, "&#039;") +
          "=" +
          t.replace(/'/g, "&#039;"));
    },
    displayPriceServiceResponse: function (e, t) {
      (categoryDisplayJS.itemPriceJsonOject[
        e.catalogEntry.catalogEntryIdentifier.uniqueID
      ] = e),
        categoryDisplayJS.displayPrice(e.catalogEntry);
    },
    displayPrice: function (e) {
      var t,
        r = categoryDisplayJS.isPopup;
      if (
        (1 == r &&
          ($("#productPrice").html(e.offerPrice),
          $("#productName").html(e.description[0].name),
          $("#productSKUValue").html(
            e.catalogEntryIdentifier.externalIdentifier.partNumber
          )),
        0 == r)
      ) {
        var s = "";
        if (
          ((s =
            !e.listPriced || e.listPrice <= e.offerPrice
              ? "<span class='price bold'>" +
                MessageHelper.messages.PRICE +
                " </span><span class='price bold'>" +
                e.offerPrice +
                "</span>"
              : "<span class='price bold'>" +
                MessageHelper.messages.PRICE +
                " </span><span class='price listPrice bold'>" +
                e.listPrice +
                "</span><div class='price offerprice bold'>" +
                e.offerPrice +
                "</div>"),
          (s += "<br />"),
          1 == categoryDisplayJS.displayPriceRange)
        )
          for (var a in e.priceRange)
            "null" != e.priceRange[a].endingNumberOfUnits
              ? ((t = MessageHelper.messages.TieredPricingDisp),
                (t = t.replace("{0}", e.priceRange[a].startingNumberOfUnits)),
                (t = t.replace("{1}", e.priceRange[a].endingNumberOfUnits)),
                (t = t.replace("{2}", e.priceRange[a].localizedPrice)),
                (s = s + "<span class='price bold'>" + t + "</span>"))
              : ((t = MessageHelper.messages.TieredPricingDispLast),
                (t = t.replace("{0}", e.priceRange[a].startingNumberOfUnits)),
                (t = t.replace("{1}", e.priceRange[a].localizedPrice)),
                (s = s + "<span class='price bold'>" + t + "</span>")),
              (s += "<br />");
        $("#WC_CachedProductOnlyDisplay_div_4").html(s),
          $("#catalog_link").html(e.description[0].name);
      }
    },
    setSelectedAttributeOfProduct: function (e, t, r) {
      (selectedAttributesForProduct = {}),
        this.selectedProducts[e] &&
          (selectedAttributesForProduct = this.selectedProducts[e]),
        (selectedAttributesForProduct[t] = r),
        (this.selectedProducts[e] = selectedAttributesForProduct);
    },
    getCatalogEntryId: function () {
      var e = [];
      for (attribute in this.selectedAttributes)
        e.push(attribute + "_|_" + this.selectedAttributes[attribute]);
      return this.resolveSKU(e);
    },
    getImageForSKU: function () {
      var e = [];
      for (attribute in this.selectedAttributes)
        e.push(attribute + "_|_" + this.selectedAttributes[attribute]);
      return this.resolveImageForSKU(e);
    },
    getCatalogEntryIdforProduct: function (e) {
      var t = [];
      for (attribute in e) t.push(attribute + "_|_" + e[attribute]);
      return this.resolveSKU(t);
    },
    resolveSKU: function (e) {
      console.debug("Resolving SKU >> " + e + ">>" + this.entitledItems);
      var t = "",
        r = e.length;
      for (x in this.entitledItems) {
        var t = this.entitledItems[x].catentry_id,
          s = this.entitledItems[x].Attributes,
          a = 0;
        for (index in s) a++;
        if (0 == r && 0 == a) return t;
        if (0 != a && r >= a) {
          var i = 0;
          for (attributeName in e) {
            var n = e[attributeName];
            n in s && i++;
          }
          if (a == i)
            return console.debug("CatEntryId:" + t + " for Attribute: " + e), t;
        }
      }
      return null;
    },
    resolveImageForSKU: function (e) {
      console.debug("Resolving SKU >> " + e + ">>" + this.entitledItems);
      var t = "",
        r = e.length;
      for (x in this.entitledItems) {
        var t = this.entitledItems[x].ItemImage,
          s = this.entitledItems[x].Attributes,
          a = 0;
        for (index in s) a++;
        if (0 == r && 0 == a) return t;
        if (0 != a && r >= a) {
          var i = 0;
          for (attributeName in e) {
            var n = e[attributeName];
            n in s && i++;
          }
          if (a == i)
            return console.debug("ItemImage:" + t + " for Attribute: " + e), t;
        }
      }
      return null;
    },
    addToAllSwatchsArray: function (e, t, r) {
      if (!this.existInAllSwatchsArray(e, t)) {
        var s = [];
        (s[0] = e),
          (s[1] = t),
          (s[2] = r),
          (s[4] = document.getElementById("swatch_" + t).onclick),
          this.allSwatchesArray.push(s);
      }
    },
    existInAllSwatchsArray: function (e, t) {
      for (var r = 0; r < this.allSwatchesArray.length; r++) {
        var s = this.allSwatchesArray[r][0],
          a = this.allSwatchesArray[r][1];
        if (s == e && a == t) return !0;
      }
      return !1;
    },
    updateParamObject: function (e, t, r, s, a) {
      if ((null == e && (e = []), null != e[t] && s))
        if ($.isArray(e[t]))
          null != a && "" !== a ? (e[t][a] = r) : e[t].push(r);
        else {
          var i = e[t];
          (e[t] = []), e[t].push(i), e[t].push(r);
        }
      else if (null != a && "" !== a && -1 != a) e[t + "_" + a] = r;
      else if (-1 == a) {
        for (var n = 1; null != e[t + "_" + n]; ) n++;
        e[t + "_" + n] = r;
      } else e[t] = r;
      return e;
    },
    setDefaultItem: function (e, t) {
      this.defaultItemArray[e] = t;
    },
    getDefaultItem: function (e) {
      return this.defaultItemArray[e];
    },
    AddBundle2ShopCartAjax: function (e) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var t = [];
      (t.storeId = this.storeId),
        (t.catalogId = this.catalogId),
        (t.langId = this.langId),
        (t.orderId = "."),
        (t.calculateOrder = "0"),
        (t.inventoryValidation = "true");
      for (var r = e.numberOfProduct.value, s = 1; r >= s; s++) {
        var a = e["catEntryId_" + s].value;
        this.selectedProducts[a] &&
          (a = this.getCatalogEntryIdforProduct(this.selectedProducts[a]));
        var i = e["quantity_" + s].value;
        if (null == i || "" === i || 0 >= i)
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.QUANTITY_INPUT_ERROR
          );
        if (null == i || "" === i || null == a)
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU
          );
        this.updateParamObject(t, "catEntryId", a, !1, -1),
          this.updateParamObject(t, "quantity", i, !1, -1),
          (this.baseItemAddedToCart = !0);
        var n = document.getElementsByName(
          "contractSelectForm_contractId_" + a
        );
        if (null != n && "undefined" != n)
          for (j = 0; j < n.length; j++)
            if (n[j].checked) {
              e["contractId_" + s].value = n[j].value;
              break;
            }
        var o = e["contractId_" + s].value;
        null != o &&
          "" !== o &&
          this.updateParamObject(t, "contractId", o, !1, -1);
      }
      submitRequest() &&
        (cursor_wait(), wcService.invoke("AjaxAddOrderItem", t));
    },
    AddBundle2ShopCart: function (e) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      e.URL.value = "AjaxOrderItemDisplayView";
      for (var t = e.numberOfProduct.value, r = 1; t >= r; r++) {
        var s = e["catEntryId_" + r].value;
        if (this.selectedProducts[s]) {
          if (
            ((s = this.getCatalogEntryIdforProduct(this.selectedProducts[s])),
            null == s)
          )
            return void MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERR_RESOLVING_SKU
            );
          e["catEntryId_" + r].value = s;
        }
        var a = e["quantity_" + r].value;
        if (null == a || "" === a || 0 >= a)
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.QUANTITY_INPUT_ERROR
          );
        var i = document.getElementsByName(
          "contractSelectForm_contractId_" + s
        );
        if (null != i && "undefined" != i)
          for (j = 0; j < i.length; j++)
            if (i[j].checked) {
              e["contractId_" + r].value = i[j].value;
              break;
            }
      }
      submitRequest() && processAndSubmitForm(e);
    },
    Add2ShopCart: function (entitledItemId, form, quantity, isPopup) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId();
      if (null != catalogEntryId) {
        if (this.merchandisingProductAssociationAddToCart)
          return void this.AddAssociation2ShopCart(catalogEntryId, quantity);
        (form.catEntryId.value = catalogEntryId),
          (form.productId.value = catalogEntryId),
          this.AddItem2ShopCart(form, quantity),
          hidePopup("second_level_category_popup");
      } else
        1 == isPopup
          ? ($("#second_level_category_popup").css("zIndex", "1"),
            MessageHelper.formErrorHandleClient(
              "addToCartLink",
              MessageHelper.messages.ERR_RESOLVING_SKU
            ))
          : MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERR_RESOLVING_SKU
            );
    },
    AddItem2ShopCart: function (e, t) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      if (!isPositiveInteger(t))
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.QUANTITY_INPUT_ERROR
        );
      e.quantity.value = t;
      var r = document.getElementsByName("contractSelectForm_contractId");
      if (null != r && "undefined" != r)
        for (i = 0; i < r.length; i++)
          if (r[i].checked) {
            e.contractId.value = r[i].value;
            break;
          }
      submitRequest() && processAndSubmitForm(e);
    },
    Add2ShopCartAjax: function (
      entitledItemId,
      quantity,
      isPopup,
      customParams
    ) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId();
      null != catalogEntryId
        ? (this.AddItem2ShopCartAjax(catalogEntryId, quantity, customParams),
          (this.baseItemAddedToCart = !0),
          hidePopup("second_level_category_popup"))
        : 1 == isPopup
        ? ($("#second_level_category_popup").css("zIndex", "1"),
          MessageHelper.formErrorHandleClient(
            "addToCartLinkAjax",
            MessageHelper.messages.ERR_RESOLVING_SKU
          ))
        : (MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU
          ),
          (this.baseItemAddedToCart = !1));
    },
    setEntitledItemJsonObject: function (e) {
      this.entitledItemJsonObject = e;
    },
    getEntitledItemJsonObject: function () {
      return this.entitledItemJsonObject;
    },
    ReplaceItemAjax: function (entitledItemId, quantity) {
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId(),
        removeOrderItemId = "",
        removeOrderItemId = replaceOrderItemId,
        typeId = document.getElementById("shipmentTypeId"),
        addressId = "",
        shipModeId = "";
      null != typeId &&
        "" !== typeId &&
        ("2" == typeId.value
          ? ((addressId = document.getElementById(
              "MS_ShipmentAddress_" + removeOrderItemId
            ).value),
            (shipModeId = document.getElementById(
              "MS_ShippingMode_" + removeOrderItemId
            ).value))
          : ((addressId = $("#addressId_all").val()),
            (shipModeId = $("#shipModeId_all").val()))),
        null != catalogEntryId
          ? "" !== removeOrderItemId &&
            this.ReplaceItemAjaxHelper(
              catalogEntryId,
              quantity,
              removeOrderItemId,
              addressId,
              shipModeId
            )
          : MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERR_RESOLVING_SKU
            );
    },
    ReplaceItemNonAjax: function (entitledItemId, quantity, form) {
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId(),
        removeOrderItemId = "",
        removeOrderItemId = replaceOrderItemId;
      if (null != catalogEntryId)
        if ("" === removeOrderItemId);
        else {
          form.orderItemId.value = removeOrderItemId;
          var addressId, shipModeId;
          if (
            (0 == quantity && console.debug("An invalid quantity was selected"),
            null != form.shipmentTypeId && "" !== form.shipmenTypeId
              ? ("2" == form.shipmentTypeId.value
                  ? ((addressId = document.getElementById(
                      "MS_ShipmentAddress_" + removeOrderItemId
                    ).value),
                    (shipModeId = document.getElementById(
                      "MS_ShippingMode_" + removeOrderItemId
                    ).value))
                  : ((addressId = $("#addressId_all").val()),
                    (shipModeId = $("#shipModeId_all").val())),
                (form.URL.value =
                  "RESTOrderItemAdd?calculationUsage=-1,-2,-3,-4,-5,-6,-7&catEntryId=" +
                  catalogEntryId +
                  "&quantity=" +
                  quantity +
                  "&addressId=" +
                  addressId +
                  "&shipModeId=" +
                  shipModeId +
                  "&URL=RESTOrderShipInfoUpdate?URL=" +
                  form.URL.value))
              : (form.URL.value =
                  "RESTOrderItemAdd?calculationUsage=-1,-2,-3,-4,-5,-6,-7&catEntryId=" +
                  catalogEntryId +
                  "&quantity=" +
                  quantity +
                  "&URL=" +
                  form.URL.value),
            !submitRequest())
          )
            return;
          processAndSubmitForm(form);
        }
      else
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERR_RESOLVING_SKU
        );
    },
    AddItem2ShopCartAjax: function (e, t, r) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var s = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        orderId: ".",
      };
      (s.calculateOrder = "0"), (s.inventoryValidation = "true");
      var a = "AjaxAddOrderItem",
        i = "AjaxAddOrderItem_shopCart";
      if ($.isArray(e) && $.isArray(t))
        for (var n = 0; n < e.length; n++) {
          if (!isPositiveInteger(t[n]))
            return void MessageHelper.displayErrorMessage(
              MessageHelper.messages.QUANTITY_INPUT_ERROR
            );
          (s["catEntryId_" + (n + 1)] = e[n]),
            (s["quantity_" + (n + 1)] = t[n]);
        }
      else {
        if (!isPositiveInteger(t))
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.QUANTITY_INPUT_ERROR
          );
        (s.catEntryId = e), (s.quantity = t);
      }
      if (null != r && "undefined" != r) {
        for (n in r) s[n] = r[n];
        "dynamicKit" == r.catalogEntryType &&
          ((a = "AjaxAddPreConfigurationToCart"),
          (i = "AjaxAddPreConfigurationToCart_shopCart"));
      }
      var o = document.getElementsByName("contractSelectForm_contractId");
      if (null != o && "undefined" != o)
        for (n = 0; n < o.length; n++)
          if (o[n].checked) {
            s.contractId = o[n].value;
            break;
          }
      submitRequest() &&
        (cursor_wait(),
        wcService.invoke(a, s),
        (this.baseItemAddedToCart = !0),
        document.getElementById("headerShopCartLink") &&
        "none" != document.getElementById("headerShopCartLink").style.display
          ? $("#headerShopCart").focus()
          : $("#headerShopCart1").focus());
    },
    ConfigureDynamicKit: function (e, t, r) {
      var s = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        catEntryId: e,
        quantity: t,
      };
      if (!isPositiveInteger(t))
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.QUANTITY_INPUT_ERROR
        );
      var a = document.getElementsByName("contractSelectForm_contractId");
      if (null != a && "undefined" != a)
        for (n = 0; n < a.length; n++)
          if (a[n].checked) {
            s.contractId = a[n].value;
            break;
          }
      if (null != r && "undefined" != r) for (n in r) s[n] = r[n];
      if (submitRequest()) {
        cursor_wait();
        var i = "ConfigureView",
          n = 0;
        for (param in s) i += (0 == n++ ? "?" : "&") + param + "=" + s[param];
        document.location.href =
          getAbsoluteURL() + appendWcCommonRequestParameters(i);
      }
    },
    ReplaceItemAjaxHelper: function (e, t, r, s, a) {
      var i = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        orderItemId: r,
        orderId:
          null != this.orderId &&
          "undefined" != this.orderId &&
          "" !== this.orderId
            ? this.orderId
            : ".",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (i.calculationUsage = "-1,-2,-5,-6,-7")
        : (i.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      var n = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        catEntryId: e,
        quantity: t,
        orderId:
          null != this.orderId &&
          "undefined" != this.orderId &&
          "" !== this.orderId
            ? this.orderId
            : ".",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (n.calculationUsage = "-1,-2,-5,-6,-7")
        : (n.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      var o = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        orderId:
          null != this.orderId &&
          "undefined" != this.orderId &&
          "" !== this.orderId
            ? this.orderId
            : ".",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (o.calculationUsage = "-1,-2,-5,-6,-7")
        : (o.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (o.allocate = "***"),
        (o.backorder = "***"),
        (o.remerge = "***"),
        (o.check = "*n");
      var d = !1;
      null != s &&
        "" !== s &&
        null != a &&
        "" !== a &&
        ((o.addressId = s), (o.shipModeId = a), (d = !0)),
        wcService.declare({
          id: "AjaxReplaceItem",
          actionId: "AjaxReplaceItem",
          url: "AjaxRESTOrderItemDelete",
          formId: "",
          successHandler: function (e) {
            d
              ? wcService.invoke("AjaxAddOrderItemTemp", n)
              : wcService.invoke("AjaxAddOrderItem", n);
          },
          failureHandler: function (e) {
            e.errorMessage
              ? MessageHelper.displayErrorMessage(e.errorMessage)
              : e.errorMessageKey &&
                MessageHelper.displayErrorMessage(e.errorMessageKey),
              cursor_clear();
          },
        }),
        wcService.declare({
          id: "AjaxAddOrderItemTemp",
          actionId: "AjaxAddOrderItemTemp",
          url: "AjaxRESTOrderItemAdd",
          formId: "",
          successHandler: function (e) {
            wcService.invoke("OrderItemAddressShipMethodUpdate", o);
          },
          failureHandler: function (e) {
            MessageHelper.displayErrorMessage(e.errorMessageKey);
          },
        }),
        submitRequest() &&
          (cursor_wait(), wcService.invoke("AjaxReplaceItem", i));
    },
    AddBundle2WishList: function (e) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
      for (var t = e.numberOfProduct.value, r = 1; t >= r; r++) {
        var s = e["catEntryId_" + r].value;
        if (this.selectedProducts[s]) {
          if (
            ((s = this.getCatalogEntryIdforProduct(this.selectedProducts[s])),
            null == s)
          )
            return void MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERR_RESOLVING_SKU
            );
          e["catEntryId_" + r].value = s;
        }
      }
      (e.action = "InterestItemAdd"),
        (e.page.value = "customerlinkwishlist"),
        "G" == this.userType
          ? (e.URL.value = "InterestItemDisplay")
          : (e.URL.value = "AjaxLogonForm"),
        submitRequest() && processAndSubmitForm(e);
    },
    AddBundle2WishListAjax: function (e) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
      var t = [];
      (t.storeId = this.storeId),
        (t.catalogId = this.catalogId),
        (t.langId = this.langId),
        (t.updateable = 0),
        (t.orderId = ".");
      var r = [];
      r = e.catEntryIDS.value.toString().split(",");
      for (var s = 0; s < r.length; s++) {
        var a = document.getElementById("quantity_" + r[s]).value,
          i = r[s];
        if (
          (this.selectedProducts[r[s]] &&
            (i = this.getCatalogEntryIdforProduct(this.selectedProducts[r[s]])),
          (0 == a || null == a) && (a = 1),
          null == a || "" === a || null == i)
        )
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU
          );
        this.updateParamObject(t, "catEntryId", i, !1, -1),
          this.updateParamObject(t, "quantity", a, !1, -1);
      }
      submitRequest() &&
        (cursor_wait(), wcService.invoke("AjaxInterestItemAdd", t));
    },
    Add2WishListAjaxByID: function (e) {
      if (null != e) {
        isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
        var t = {
          storeId: this.storeId,
          catalogId: this.catalogId,
          langId: this.langId,
          catEntryId: e,
          updateable: 0,
          URL: "SuccessfulAJAXRequest",
        };
        if (
          ($("#controllerURLWishlist").length &&
            $("#WishlistDisplay_Widget").refreshWidget(
              "updateUrl",
              $("#controllerURLWishlist").val()
            ),
          !submitRequest())
        )
          return;
        cursor_wait(), wcService.invoke("AjaxInterestItemAdd", t);
      } else
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERR_RESOLVING_SKU
        );
    },
    Add2WishListAjax: function (entitledItemId) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId();
      this.Add2WishListAjaxByID(catalogEntryId);
    },
    AddItem2WishListAjax: function (e) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
      var t = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        catEntryId: e,
        updateable: 0,
        URL: "SuccessfulAJAXRequest",
      };
      $("#controllerURLWishlist").length &&
        $("#WishlistDisplay_Widget").refreshWidget(
          "updateUrl",
          $("#controllerURLWishlist").val()
        ),
        submitRequest() &&
          (cursor_wait(), wcService.invoke("AjaxInterestItemAdd", t));
    },
    Add2WishList: function (entitledItemId, form) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId();
      this.Add2WishListByID(catalogEntryId, form);
    },
    Add2WishListByID: function (e, t) {
      if (
        (isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM"),
        null != e)
      ) {
        if (
          ((t.productId.value = e),
          (t.catEntryId.value = e),
          (t.action = "InterestItemAdd"),
          (t.page.value = "customerlinkwishlist"),
          "G" == this.userType
            ? (t.URL.value = "InterestItemDisplay")
            : (t.URL.value = "AjaxLogonForm"),
          (t.quantity.value = "1"),
          !submitRequest())
        )
          return;
        processAndSubmitForm(t);
      } else
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERR_RESOLVING_SKU
        );
    },
    AddItem2WishList: function (e) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM"),
        (e.action = "InterestItemAdd"),
        (e.quantity.value = "1"),
        (e.page.value = "customerlinkwishlist"),
        "G" == this.userType
          ? (e.URL.value = "InterestItemDisplay")
          : (e.URL.value = "AjaxLogonForm"),
        submitRequest() && processAndSubmitForm(e);
    },
    initializeMerchandisingAssociation: function (thumbnailIndex) {
      var associationDisplay = document.getElementById(
          "marchandisingAssociationDisplay"
        ),
        totalPriceMsg = $("#totalPriceMsg").val(),
        baseCatEntryJSON = eval("(" + $("#baseCatEntryDetails").html() + ")");
      this.baseCatalogEntryDetails = baseCatEntryJSON;
      var basePrice = this.baseCatalogEntryDetails[0].baseCatEntry_Price;
      this.totalAssociationCount =
        this.baseCatalogEntryDetails[0].totalAssociations;
      var identifierJSON = "associatedCatEntries_" + thumbnailIndex,
        associationEntryJSON = eval("(" + $("#" + identifierJSON).html() + ")");
      this.merchandisingAssociationItems = associationEntryJSON;
      var totalPrice =
          parseFloat(basePrice) +
          parseFloat(this.merchandisingAssociationItems[0].catEntry_Price),
        dragType = "";
      "ProductBean" == this.merchandisingAssociationItems[0].catEntry_Type
        ? (dragType = "product")
        : "ItemBean" == this.merchandisingAssociationItems[0].catEntry_Type
        ? (dragType = "item")
        : "PackageBean" == this.merchandisingAssociationItems[0].catEntry_Type
        ? (dragType = "package")
        : "BundleBean" == this.merchandisingAssociationItems[0].catEntry_Type &&
          (dragType = "bundle");
      var widgetHTML = "";
      if ($("#addToCartLink").length) {
        var url =
          "AjaxOrderItemDisplayView?storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&langId=" +
          this.langId;
        widgetHTML =
          widgetHTML +
          "<form name='OrderItemAddForm_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' action='RESTOrderItemAdd' method='post' id='OrderItemAddForm_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'>\n<input type='hidden' name='storeId' value='" +
          this.storeId +
          "' id='OrderItemAddForm_storeId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='orderId' value='.' id='OrderItemAddForm_orderId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='catalogId' value='" +
          this.catalogId +
          "' id='OrderItemAddForm_orderId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='URL' value='" +
          url +
          "' id='OrderItemAddForm_url_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='errorViewName' value='InvalidInputErrorView' id='OrderItemAddForm_errorViewName_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='catEntryId' value='" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' id='OrderItemAddForm_catEntryId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='productId' value='" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' id='OrderItemAddForm_productId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' value='1' name='quantity' id='OrderItemAddForm_quantity_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' value='' name='page' id='OrderItemAddForm_page_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' value='-1,-2,-3,-4,-5,-6,-7' name='calculationUsage' id='OrderItemAddForm_calcUsage_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' value='0' name='updateable' id='OrderItemAddForm_updateable_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' value='' name='giftListId' id='OrderItemAddForm_giftListId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n</form>\n";
      }
      (widgetHTML += "<div class='scroller' id='WC_CategoryDisplayJS_div_1'>"),
        this.totalAssociationCount > 1 &&
          (this.associationThumbnailIndex < this.totalAssociationCount &&
            (widgetHTML +=
              "      <a href='Javascript:categoryDisplayJS.showNextAssociation()'  id='WC_ProductAssociation_UpArrow_Link_1'>"),
          (widgetHTML =
            widgetHTML +
            "      <img src='" +
            this.baseCatalogEntryDetails[0].storeImage_Path +
            "i_up_arrow.png' alt='" +
            this.displayNextAssociation +
            "'/></a>")),
        (widgetHTML =
          widgetHTML +
          " <br /><div id='baseContent_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'"),
        "true" == this.merchandisingAssociationItems[0].showProductQuickView
          ? (widgetHTML =
              widgetHTML +
              " onmouseover='showPopupButton(" +
              this.merchandisingAssociationItems[0].catEntry_Identifier +
              ");' onmouseout='hidePopupButton(" +
              this.merchandisingAssociationItems[0].catEntry_Identifier +
              ");'>")
          : (widgetHTML += " >"),
        (widgetHTML =
          widgetHTML +
          "  <a href='" +
          this.merchandisingAssociationItems[0].catEntry_ProductLink +
          "'  id='img" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' onfocus='showPopupButton(" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          ");'>"),
        (widgetHTML =
          widgetHTML +
          "     <img src='" +
          this.merchandisingAssociationItems[0].catEntry_Thumbnail +
          "' alt='" +
          this.merchandisingAssociationItems[0].catEntry_ShortDescription +
          "' class='img' width='70' height='70'/>  </a><br />"),
        "true" == this.merchandisingAssociationItems[0].showProductQuickView &&
          (widgetHTML =
            widgetHTML +
            " <div id='popupButton_" +
            this.merchandisingAssociationItems[0].catEntry_Identifier +
            "' class='main_quickinfo_button'><span class='secondary_button' >\n<span class='button_container' >\n<span class='button_bg' >\n<span class='button_top'>\n<span class='button_bottom'>\n<a id='QuickInfoButton_" +
            this.merchandisingAssociationItems[0].catEntry_Identifier +
            "' href='#' onclick='javaScript:var actionListImageAcct = new popupActionProperties(); actionListImageAcct.showWishList=" +
            this.merchandisingAssociationItems[0].associationProductBuyable +
            "; actionListImageAcct.showAddToCart=" +
            this.merchandisingAssociationItems[0].associationProductBuyable +
            "; showPopup(" +
            this.merchandisingAssociationItems[0].catEntry_Identifier +
            ",event,null,null,actionListImageAcct);' onkeypress='javaScript:var actionListImageAcct = new popupActionProperties(); actionListImageAcct.showWishList=" +
            this.merchandisingAssociationItems[0].associationProductBuyable +
            "; actionListImageAcct.showAddToCart=" +
            this.merchandisingAssociationItems[0].associationProductBuyable +
            "; showPopup(" +
            this.merchandisingAssociationItems[0].catEntry_Identifier +
            ",event,null,null,actionListImageAcct);' onblur='hidePopupButton(" +
            this.merchandisingAssociationItems[0].catEntry_Identifier +
            ");' role='wairole:button' waistate:haspopup='true'>" +
            this.merchandisingAssociationItems[0].showProductQuickViewLable +
            "</a></span>\n</span>\n</span>\n</span>\n</span>\n</div>\n"),
        (widgetHTML += "</div>"),
        this.totalAssociationCount > 1 &&
          (this.associationThumbnailIndex > 1 &&
            (widgetHTML +=
              "      <a href='Javascript:categoryDisplayJS.showPreviousAssociation()'  id='WC_ProductAssociation_DownArrow_Link_1'>"),
          (widgetHTML =
            widgetHTML +
            "        <img src='" +
            this.baseCatalogEntryDetails[0].storeImage_Path +
            "i_down_arrow.png' alt='" +
            this.displayPrevAssociation +
            "'/></a>"));
      var comboText =
        this.baseCatalogEntryDetails[0].associatedProductsName.replace(
          /%0/,
          this.baseCatalogEntryDetails[0].baseCatEntry_Name
        );
      (comboText = comboText.replace(
        /%1/,
        this.merchandisingAssociationItems[0].catEntry_Name
      )),
        (widgetHTML =
          widgetHTML +
          "</div><div class='combo_text' id='WC_CategoryDisplayJS_div_2'>\n <h1 id='maHeader' class='status_msg'>" +
          comboText +
          "</h1>\n   <span id='maPrice' class='grey'>" +
          totalPriceMsg +
          Utils.formatCurrency(totalPrice.toFixed(2), {
            currency: this.baseCatalogEntryDetails[0].currency,
          }) +
          "</span>\n</div>\n"),
        (widgetHTML =
          widgetHTML +
          "<input type='hidden' id='compareImgPath_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' value='" +
          this.merchandisingAssociationItems[0].catEntry_Thumbnail_compare +
          "'/><input type='hidden' id='compareProductDetailsPath_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' value='" +
          this.merchandisingAssociationItems[0].catEntry_ProductLink +
          "'/><input type='hidden' id='compareImgDescription_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' value='" +
          this.merchandisingAssociationItems[0].catEntry_ShortDescription +
          "'/>"),
        (associationDisplay.innerHTML = null),
        (associationDisplay.innerHTML = widgetHTML),
        WCWidgetParser.parse(associationDisplay),
        WCWidgetParser.parseRefreshArea(associationDisplay);
    },
    showNextAssociation: function () {
      this.associationThumbnailIndex < this.totalAssociationCount &&
        ((this.associationThumbnailIndex = this.associationThumbnailIndex + 1),
        this.initializeMerchandisingAssociation(
          this.associationThumbnailIndex
        ));
    },
    showPreviousAssociation: function () {
      this.associationThumbnailIndex > 1 &&
        ((this.associationThumbnailIndex = this.associationThumbnailIndex - 1),
        this.initializeMerchandisingAssociation(
          this.associationThumbnailIndex
        ));
    },
    AddAssociation2ShopCartAjax: function (baseProductId, baseProductQuantity) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var identifierJSON =
          "associatedCatEntries_" + this.associationThumbnailIndex,
        associationEntryJSON = eval("(" + $("#" + identifierJSON).html() + ")");
      if (
        ((this.merchandisingAssociationItems = associationEntryJSON),
        (this.baseItemAddedToCart = !1),
        "ProductBean" == this.merchandisingAssociationItems[0].catEntry_Type)
      )
        this.Add2ShopCartAjax(baseProductId, baseProductQuantity),
          this.baseItemAddedToCart &&
            showPopup(
              this.merchandisingAssociationItems[0].catEntry_Identifier,
              function (e) {
                return e;
              },
              "marchandisingAssociationDisplay"
            );
      else if (
        ["ItemBean", "PackageBean", "BundleBean"].indexOf(
          this.merchandisingAssociationItems[0].catEntry_Type
        ) > -1
      ) {
        var entitledItemJSON = eval("(" + $("#" + baseProductId).html() + ")");
        this.setEntitledItems(entitledItemJSON);
        var catalogEntryId = this.getCatalogEntryId(),
          params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            orderId: ".",
          };
        if (((params.calculateOrder = "0"), null == catalogEntryId))
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU
          );
        if (
          (this.updateParamObject(params, "catEntryId", catalogEntryId, !1, -1),
          this.updateParamObject(
            params,
            "quantity",
            baseProductQuantity,
            !1,
            -1
          ),
          "BundleBean" == this.merchandisingAssociationItems[0].catEntry_Type)
        ) {
          var form = document.getElementById(
              this.merchandisingAssociationItems[0].catEntry_BundleFormId
            ),
            catEntryArray = [];
          catEntryArray = form.catEntryIDS.value.toString().split(",");
          for (var i = 0; i < catEntryArray.length; i++) {
            var qty = document.getElementById(
                "quantity_" + catEntryArray[i]
              ).value,
              catEntryId = catEntryArray[i];
            if (
              (this.getDefaultItem(catEntryArray[i]) &&
                (catEntryId = this.getDefaultItem(catEntryArray[i])),
              (0 == qty || null == qty) && (qty = 1),
              null == qty || "" === qty || null == catEntryId)
            )
              return void MessageHelper.displayErrorMessage(
                MessageHelper.messages.ERR_RESOLVING_SKU
              );
            this.updateParamObject(params, "catEntryId", catEntryId, !1, -1),
              this.updateParamObject(params, "quantity", qty, !1, -1);
          }
        } else
          this.updateParamObject(
            params,
            "catEntryId",
            this.merchandisingAssociationItems[0].catEntry_Identifier,
            !1,
            -1
          ),
            this.updateParamObject(params, "quantity", 1, !1, -1);
        if (!submitRequest()) return;
        cursor_wait(), wcService.invoke("AjaxAddOrderItem", params);
      }
    },
    AddAssociation2ShopCart: function (e, t) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var r = this.merchandisingProductAssociationForm;
      if (
        ((this.merchandisingProductAssociationAddToCart = !1),
        this.isParentBundleBean)
      ) {
        var s = [];
        s = r.catEntryIDS.value.toString().split(",");
        for (var a = 1, i = 0; i < s.length; i++) {
          var n = document.getElementById("quantity_" + s[i]).value,
            o = s[i];
          if (
            (this.selectedProducts[s[i]] &&
              (o = this.getCatalogEntryIdforProduct(
                this.selectedProducts[s[i]]
              )),
            (0 == n || null == n) && (n = 1),
            null == n || "" === n || null == o)
          )
            return void MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERR_RESOLVING_SKU
            );
          var d = document.createElement("input");
          $(d).attr("id", "OrderItemAddForm_catEntryId_" + o),
            $(d).attr("type", "hidden"),
            $(d).attr("name", "catEntryId_" + a),
            $(d).attr("value", o),
            (a += 1),
            r.appendChild(d);
        }
        var l = document.createElement("input");
        $(l).attr("id", "OrderItemAddForm_catEntryId_" + e),
          $(l).attr("type", "hidden"),
          $(l).attr("name", "catEntryId_" + a),
          $(l).attr("value", e),
          r.appendChild(l);
        var c = document.createElement("input");
        $(c).attr("id", "OrderItemAddForm_quantity_" + e),
          $(c).attr("type", "hidden"),
          $(c).attr("name", "quantity_" + a),
          $(c).attr("value", t),
          r.appendChild(c),
          (r.URL.value = "AjaxOrderItemDisplayView"),
          (this.isParentBundleBean = !1);
      } else
        (r.catEntryId_2.value = e),
          (r.productId_2.value = e),
          (r.quantity_2.value = t);
      submitRequest() &&
        (processAndSubmitForm(r),
        (this.merchandisingProductAssociationForm = ""));
    },
    setOrderId: function (e) {
      this.orderId = e;
    },
    addToNewListFromProductDetail: function (
      entitledItemId,
      quantityElemId,
      currentPage
    ) {
      MessageHelper.hideAndClearMessage();
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId();
      return null == catalogEntryId
        ? (MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU_REQ_LIST
          ),
          void (
            $("#second_level_category_popup").length &&
            hidePopup("second_level_category_popup")
          ))
        : void this.addItemToNewListFromProductDetail(
            catalogEntryId,
            quantityElemId,
            currentPage
          );
    },
    addItemToNewListFromProductDetail: function (e, t, r) {
      if ((MessageHelper.hideAndClearMessage(), null != e)) {
        var s = $("#" + t).val();
        if (null == s || "" === s || 0 >= s || !RequisitionList.isNumber(s))
          return (
            MessageHelper.displayErrorMessage(
              MessageHelper.messages.QUANTITY_INPUT_ERROR
            ),
            void (
              $("#second_level_category_popup").length &&
              hidePopup("second_level_category_popup")
            )
          );
        var a = "AjaxLogonForm?page=createrequisitionlist",
          i = document.createElement("form");
        $(i).attr("method", "POST");
        var n = document.createElement("input");
        $(n).attr("type", "hidden"),
          $(n).attr("value", r),
          $(n).attr("name", "previousPage"),
          i.appendChild(n),
          (i.action =
            a +
            "&catEntryId=" +
            e +
            "&quantity=" +
            s +
            "&storeId=" +
            this.storeId +
            "&catalogId=" +
            this.catalogId +
            "&langId=" +
            this.langId),
          document.body.appendChild(i),
          processAndSubmitForm(i);
      } else
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERR_RESOLVING_SKU_REQ_LIST
        );
    },
    addBundleToNewListFromProductDetail: function (e, t) {
      for (
        var r = e.numberOfProduct.value,
          s = "AjaxLogonForm?page=createrequisitionlist",
          a = 1;
        r >= a;
        a++
      ) {
        var i = e["catEntryId_" + a].value;
        this.selectedProducts[i] &&
          (i = this.getCatalogEntryIdforProduct(this.selectedProducts[i]));
        var n = e["quantity_" + a].value;
        if (null == n || "" === n || 0 >= n || !RequisitionList.isNumber(n))
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.QUANTITY_INPUT_ERROR
          );
        if (null == i)
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU_REQ_LIST
          );
        s = s + "&catEntryId=" + i + "&quantity=" + n;
      }
      var o = document.createElement("input");
      $(o).attr("type", "hidden"),
        $(o).attr("value", t),
        $(o).attr("name", "previousPage"),
        e.appendChild(o),
        (s =
          s +
          "&numberOfProduct=" +
          e.numberOfProduct.value +
          "&storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&langId=" +
          this.langId),
        (e.action = s),
        processAndSubmitForm(e);
    },
    setCurrentPageType: function (e) {
      this.currentPageType = e;
    },
    setCurrentCatalogEntryId: function (e) {
      this.currentCatalogEntryId = e;
    },
    handleCategorySubscription: function (e) {
      var t = document.forms[e],
        r = {
          DM_ReqCmd: t.DM_ReqCmd.value,
          storeId: t.storeId.value,
          catalogId: t.catalogId.value,
          langId: t.langId.value,
          categoryId: t.categoryId.value,
        };
      submitRequest() &&
        (cursor_wait(), wcService.invoke("AjaxCategorySubscribe", r));
    },
  }),
  (compareProductJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    compareReturnName: "",
    returnUrl: "",
    cookieKeyPrefix: "CompareItems_",
    cookieDelimiter: ";",
    maxNumberProductsAllowedToCompare: 4,
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.compareReturnName = s),
        (this.returnUrl = decodeURIComponent(a));
    },
    clear: function () {
      MessageHelper.hideAndClearMessage();
      var e = this.cookieKeyPrefix + this.storeId;
      if (
        (setCookie(e, "", {
          path: "/",
          domain: cookieDomain,
        }),
        $.remove("#compareDropZoneImgDiv"),
        $("#compareDropZoneImg").length &&
          $("#compareDropZoneImg").css("display", "block"),
        $("#compareProductPage").length && $("#compareProductPage").val())
      ) {
        var t =
          "CompareProductsDisplay?storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&langId=" +
          this.langId +
          "&compareReturnName=" +
          this.compareReturnName +
          "&returnUrl=" +
          encodeURIComponent(appendWcCommonRequestParameters(this.returnUrl));
        document.location.href = appendWcCommonRequestParameters(t);
      }
      MessageHelper.displayStatusMessage(
        MessageHelper.messages.COMPARE_ITEMS_CLEAR
      );
    },
    remove: function (e) {
      var t = this.cookieKeyPrefix + this.storeId,
        r = getCookie(t);
      if (null != r) {
        if ("" == $.trim(r))
          setCookie(t, null, {
            expires: -1,
          });
        else {
          var s = r.split(this.cookieDelimiter),
            a = "";
          for (index in s)
            s[index] != e &&
              (a = "" === a ? s[index] : a + this.cookieDelimiter + s[index]);
          setCookie(t, a, {
            path: "/",
            domain: cookieDomain,
          });
        }
        this.compareProducts();
      }
    },
    Add2CompareAjax: function (e, t, r, s) {
      MessageHelper.hideAndClearMessage(),
        $("#compareProductParentId_" + e).length &&
          void 0 != document.getElementById("compareProductParentId_" + e) &&
          (e = document.getElementById("compareProductParentId_" + e).value);
      var a = this.cookieKeyPrefix + this.storeId,
        i = getCookie(a);
      if (null != i && (-1 !== i.indexOf(e) || null == e))
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.COMPARE_ITEM_EXISTS
        );
      var n = 0;
      if (
        (null != i && "" !== i && (n = i.split(this.cookieDelimiter).length),
        n < parseInt(this.maxNumberProductsAllowedToCompare))
      ) {
        var o = "";
        if (
          ((o = null == i || "" === i ? e : i + this.cookieDelimiter + e),
          setCookie(a, o, {
            path: "/",
            domain: cookieDomain,
          }),
          0 == n &&
            ($("#compareDropZoneImg").css("display", "none"),
            $("#compareZone").after(
              "<div id='compareDropZoneImgDiv' style='width:100%'><table><tbody id='compareItemsTable'><tr id='compareRow'></tr></tbody></table></div>"
            )),
          $("#compareDropZoneImgDiv").length)
        ) {
          var d = (
            '<td id="compareCatentry' +
            e +
            '"><div id="compareCatentryContainer' +
            e +
            '"><div id="compare_img_' +
            e +
            '" class="compare_img"><a id="imgcatBrowseCompare_Item_' +
            e +
            '" href="' +
            r +
            '"><img height="40" width="40" border="0" alt="' +
            s +
            '" title="' +
            s +
            '" src="' +
            t +
            '"></img>\n</a></div><div id="compare_info_' +
            e +
            '" class="compare_info"><div id="compare_product_desc_' +
            e +
            '" class="compare_product_desc">' +
            s +
            "</div></div></div></td>"
          )
            .replace(/\"/g, "'")
            .replace(/\r|\n|\r\n|\n\r/g, "");
          $("#compareRow").after(d);
        }
        $("#compareProductPage").length &&
          "undefined" != document.getElementById("compareProductPage") &&
          $("#compareProductPage").val() &&
          this.compareProducts(),
          MessageHelper.displayStatusMessage(
            MessageHelper.messages.COMPAREZONE_ADDED
          );
      } else
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.COMPATE_MAX_ITEMS
        );
    },
    compareProducts: function () {
      var e =
          "CompareProductsDisplay?storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&langId=" +
          this.langId +
          "&compareReturnName=" +
          this.compareReturnName,
        t = this.cookieKeyPrefix + this.storeId,
        r = getCookie(t);
      if (Utils.notNullOrWhiteSpace(r)) {
        var s = r.split(this.cookieDelimiter);
        for (index in s) e = e + "&catentryId=" + s[index];
      }
      (e =
        appendWcCommonRequestParameters(e) +
        "&returnUrl=" +
        encodeURIComponent(appendWcCommonRequestParameters(this.returnUrl))),
        (document.location.href = getAbsoluteURL() + e);
    },
    init: function () {
      wcTopic.subscribe("/dnd/drop", function (e, t, r, s) {
        e != s && s.deleteSelectedNodes();
        var a = "",
          i = "",
          n = "",
          o = e.parent.id;
        if ("compareZone" == s.parent.id) {
          if (
            void 0 != getCookie("coShoppingDisableDnd") &&
            "true" == getCookie("coShoppingDisableDnd")
          )
            return void wcTopic.publish("/wc/collaboration/dndDisabled", []);
          var d = o.indexOf("_", 0);
          d >= 0 && (o = o.substring(d + 1)),
            $("#compareImgPath_" + o).length &&
              void 0 != document.getElementById("compareImgPath_" + o) &&
              (i = document.getElementById("compareImgPath_" + o).value),
            $("#compareProductDetailsPath_" + o).length &&
              void 0 !=
                document.getElementById("compareProductDetailsPath_" + o) &&
              (a = document.getElementById(
                "compareProductDetailsPath_" + o
              ).value),
            $("#compareImgDescription_" + o).length &&
              void 0 != document.getElementById("compareImgDescription_" + o) &&
              (n = document.getElementById("compareImgDescription_" + o).value),
            $("#compareProductParentId_" + o).length &&
              void 0 !=
                document.getElementById("compareProductParentId_" + o) &&
              (o = document.getElementById(
                "compareProductParentId_" + o
              ).value),
            compareProductJS.Add2CompareAjax(o, i, a, n);
        }
      });
      var e = this.cookieKeyPrefix + this.storeId;
      getCookie(e);
    },
  }),
  null == CheckoutPaymentsBis || "object" != typeof CheckoutPaymentsBis)
)
  var CheckoutPaymentsBis = new Object();
(CheckoutPaymentsBis = {
  errorMessages: {},
  numberOfPaymentMethods: 1,
  langId: "-1",
  storeId: "",
  catalogId: "",
  dirtyFlag: !1,
  jQlocale: "",
  maxNumberOfPaymentMethodsSupported: 3,
  paymentObjects: new Array(),
  paymentsToDelete: new Array(),
  paymentsToAdd: new Array(),
  paymentsToUpdate: new Array(),
  prevNumberOfPaymentMethods: 1,
  purchaseOrderNumber: "",
  paymentSpecificAddress: !1,
  quickCheckoutProfileForPaymentFlag: !1,
  currentPaymentMethodChanged: 1,
  setLocale: function (e) {
    this.jQlocale = e;
  },
  setQuickCheckoutProfileForPaymentFlag: function (e) {
    this.quickCheckoutProfileForPaymentFlag = e;
  },
  setErrorMessage: function (e, t) {
    this.errorMessages[e] = t;
  },
  setCommonParameters: function (e, t, r) {
    (this.langId = e), (this.storeId = t), (this.catalogId = r);
  },
  setNumPaymentIndicator: function (e) {
    var t = document.getElementById("paymentSection2");
    if ("block" == t.style.display)
      for (i = 1; i < e; i++) {
        var r = document.getElementById("paymentHeading" + i);
        r.style.display = "block";
      }
    else document.getElementById("paymentHeading1").style.display = "none";
  },
  setNumberOfPaymentMethods: function (e, t, r) {
    for (this.numberOfPaymentMethods = t.value, i = 1; i <= e; i++) {
      var s = document.getElementById(r + i);
      void 0 != s &&
        (i <= t.value
          ? (s.style.display = "block")
          : (s.style.display = "none"));
    }
    var a = document.getElementById("OrderTotalAmount").value;
    this.updateAmountFields(a), this.setNumPaymentIndicator(t.value);
  },
  clearPaymentFormData: function (e) {
    " " !== this.getValue(e, "cc_brand") && (e.cc_brand.value = " "),
      " " !== this.getValue(e, "cc_cvc") && (e.cc_cvc.value = " "),
      " " !== this.getValue(e, "account") && (e.account.value = " "),
      " " !== this.getValue(e, "payment_token") &&
        (e.payment_token.value = " "),
      " " !== this.getValue(e, "expire_month") && (e.expire_month.value = " "),
      " " !== this.getValue(e, "expire_year") && (e.expire_year.value = " "),
      " " !== this.getValue(e, "check_routing_number") &&
        (e.check_routing_number.value = " "),
      " " !== this.getValue(e, "checkingAccountNumber") &&
        (e.checkingAccountNumber.value = " "),
      " " !== this.getValue(e, "checkRoutingNumber") &&
        (e.checkRoutingNumber.value = " "),
      " " !== this.getValue(e, "numberOfInstallments") &&
        (e.numberOfInstallments.value = " ");
  },
  loadPaymentSnippet: function (e, t) {
    var r = document.forms["PaymentForm" + t];
    this.clearPaymentFormData(r);
    var s = e.value.split("_"),
      a = s[0],
      i = "";
    null != s[1] && (i = s[1]),
      this.paymentSpecificAddress &&
        ((wcRenderContext.getRenderContextProperties(
          "billingAddressDropDownBoxContext"
        )["payment" + t] = a),
        (wcRenderContext.getRenderContextProperties(
          "billingAddressDropDownBoxContext"
        )["paymentTCId" + t] = i),
        wcRenderContext.updateRenderContext(
          "billingAddressDropDownBoxContext"
        )),
      MessageHelper.hideAndClearMessage();
    for (var n = 0, o = 1; t > o; o++) {
      var d = document.forms["PaymentForm" + o];
      null == d.piAmount ||
        "" == d.piAmount.value ||
        isNaN(d.piAmount.value) ||
        (n = 1 * n + 1 * d.piAmount.value);
    }
    var l = "payment" + t,
      c = r.buyerOrgDN.value,
      u = r.orderId.value,
      m = r.piAmount.value,
      g = {};
    (g[l] = a),
      (g["paymentTCId" + t] = i),
      (g.currentPaymentArea = t),
      (g.payMethodId = a),
      (g.currentTotal = n),
      (g.paymentTCId = i),
      (g.buyerOrgDN = c),
      (g.orderId = u),
      (g.piAmount = m),
      wcRenderContext.updateRenderContext("paymentContext", g);
    var p = document.forms["PaymentForm" + t];
    if ("PayInStore" == a) {
      var h = document.getElementById("billingAddressSelectBoxArea_" + t);
      (h.style.display = "none"),
        p.billing_address_id && (p.billing_address_id.value = "");
    } else {
      var h = document.getElementById("billingAddressSelectBoxArea_" + t);
      (h.style.display = "block"),
        "" == p.billing_address_id && (p.billing_address_id.value = "-1");
    }
  },
  loadPaymentSnippetLocally: function (e, t) {
    var r = e.value.split("_"),
      s = r[0],
      a = "",
      i = "",
      n = "",
      o = document.forms["PaymentForm" + t];
    if (
      (null == o.piAmount ||
        "" == o.piAmount.value ||
        isNaN(o.piAmount.value) ||
        (i = o.piAmount.value),
      null == o.piAmount_display ||
        "" == o.piAmount_display.value ||
        isNaN(o.piAmount_display.value) ||
        (n = o.piAmount_display.value),
      null != r[1])
    ) {
      var d = r[1];
      a = $("#PIInfo_Div_" + s + "_" + t + "_" + d).html();
    } else a = $("#PIInfo_Div_" + s + "_" + t).html();
    var l = document.getElementById("paymentFormDiv" + t);
    l.html(a),
      "" != i && (o.piAmount.value = i),
      "" != n && (o.piAmount_display.value = n);
    var c = document.getElementById("OrderTotalAmount").value;
    this.updateAmountFields(c);
  },
  processCheckout: function (e, t) {
    if (
      (!CheckoutHelperJS.isSinglePageCheckout() ||
        this.validatePaymentTotals(e)) &&
      ((void 0 == t || null == t) && (t = !1),
      !CheckoutHelperJS.checkForDirtyFlag())
    ) {
      if ("1" == CheckoutHelperJS.getShipmentTypeId()) {
        if (null != document.getElementById("requestShippingDateCheckbox")) {
          var r = $("#requestedShippingDate");
          if (!r.ValidationTextbox("validationAndErrorHandler"))
            return void r.focus();
        }
      } else {
        var s = document.getElementById("totalNumberOfItems");
        if (null != s)
          for (var a = 0; a < s.value; a++) {
            var i = document.getElementById("orderItem_" + (a + 1));
            if (null != i) {
              var n = i.value,
                o = $("#MS_requestShippingDateCheckbox_" + n)[0];
              if (null != o) {
                var r = $("#MS_requestedShippingDate_" + n);
                if (!r.ValidationTextbox("validationAndErrorHandler"))
                  return void r.focus();
              }
            }
          }
      }
      if (null != document.getElementById("scheduleOrderInputSection")) {
        var d = document.getElementById("ScheduleOrderFrequency"),
          l = $("#ScheduleOrderStartDate"),
          c = document.getElementById("makeRecurringOrderMandatory");
        if (
          ("undefined" == d.value && null != l.val()) ||
          (c && "true" == c.value && "undefined" == d.value)
        )
          return void MessageHelper.formErrorHandleClient(
            d.id,
            MessageHelper.messages.SCHEDULE_ORDER_MISSING_FREQUENCY
          );
        if ("undefined" != d.value && null == l.val())
          return void MessageHelper.formErrorHandleClient(
            l[0].id,
            MessageHelper.messages.SCHEDULE_ORDER_MISSING_START_DATE
          );
        if (!CheckoutHelperJS.validateDate(l, "ScheduleOrderStartDate")) return;
      }
      var u = document.getElementById("numberOfPaymentMethods");
      if (u)
        for (var m = u.value, a = 1; m >= a; a++) {
          var g = document.forms[e + a];
          if ("select-one" == g.payMethodId.type)
            for (var p = 0; p < g.payMethodId.options.length; p++) {
              var h = g.payMethodId.options[p].value.split("_")[0];
              g.payMethodId.options[p].value = h;
            }
        }
      if (!t && !CheckoutHelperJS.isSinglePageCheckout()) {
        var I = [];
        if (
          ((I.storeId = this.storeId),
          (I.catalogId = this.catalogId),
          (I.langId = this.langId),
          (I.orderId = "."),
          !submitRequest())
        )
          return;
        return (
          cursor_wait(),
          void wcService.invoke("AjaxPrepareOrderBeforePaymentCapture", I)
        );
      }
      if (t) this.processPIAndCheckout(e, t);
      else {
        var I = [];
        if (
          ((I.storeId = this.storeId),
          (I.catalogId = this.catalogId),
          (I.langId = this.langId),
          !submitRequest())
        )
          return;
        cursor_wait(), wcService.invoke("AjaxPrepareOrderBeforeSubmit", I);
      }
    }
  },
  processPIAndCheckout: function (e, t) {
    if (
      (void 0 == t || null == t
        ? (t = !1)
        : ("true" == t || "false" == t) && (t = "true" === t),
      this.checkValidPaymentInstructions(e))
    ) {
      var r = document.forms[e + "1"];
      "Y" == this.getValue(r, "valueFromProfileOrder") &&
        (this.setQuickCheckoutProfileForPaymentFlag("true"),
        this.updatePaymentObject(1, "account"));
      for (
        var s = parseInt(this.maxNumberOfPaymentMethodsSupported), a = 1;
        s >= a;
        a++
      ) {
        var i = this.retrievePaymentObject(a);
        null != i &&
          (("delete" != i.action && "re-add" != i.action) ||
            "" == i.piId ||
            this.setPaymentsToDelete(a),
          ("add" == i.action || "re-add" == i.action) &&
            this.setPaymentsToAdd(a),
          "update" == i.action && "" != i.piId && this.setPaymentsToUpdate(a));
      }
      this.getPaymentsToDelete().length > 0
        ? this.deletePaymentInstructions()
        : this.getPaymentsToAdd().length > 0
        ? this.addPaymentInstructions()
        : this.getPaymentsToUpdate().length > 0
        ? this.updatePaymentInstructions()
        : (CheckoutPayments.setCommonParameters(
            SBServicesDeclarationJS.langId,
            SBServicesDeclarationJS.storeId,
            SBServicesDeclarationJS.catalogId
          ),
          CheckoutPayments.showSummaryPage(),
          cursor_clear()),
        CheckoutHelperJS.setFieldDirtyFlag(!1);
    }
  },
  showSummaryPage: function () {
    null != document.getElementById("scheduleOrderInputSection") &&
      CheckoutHelperJS.prepareOrderSchedule();
    var e = encodeURIComponent(this.purchaseOrderNumber),
      t = "";
    "1" == CheckoutHelperJS.getShipmentTypeId()
      ? ((t =
          "SingleShipmentOrderSummaryView?langId=" +
          this.langId +
          "&storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&purchaseorder_id=" +
          e +
          "&quickCheckoutProfileForPayment=" +
          this.quickCheckoutProfileForPaymentFlag),
        (document.location.href = appendWcCommonRequestParameters(t)))
      : ((t =
          "MultipleShipmentOrderSummaryView?langId=" +
          this.langId +
          "&storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&purchaseorder_id=" +
          e +
          "&quickCheckoutProfileForPayment=" +
          this.quickCheckoutProfileForPaymentFlag),
        (document.location.href = appendWcCommonRequestParameters(t)));
  },
  showBillingPage: function () {
    document.location.href = appendWcCommonRequestParameters(
      "OrderBillingView?langId=" +
        this.langId +
        "&storeId=" +
        this.storeId +
        "&catalogId=" +
        this.catalogId +
        "&forceShipmentType=" +
        CheckoutHelperJS.getShipmentTypeId()
    );
  },
  populateProtocolData: function (e, t) {
    return (
      (t = this.updateParamObject(
        t,
        "storeId",
        this.getValue(e, "storeId"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "payment_token",
        this.getValue(e, "payment_token"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "catalogId",
        this.getValue(e, "catalogId"),
        !0
      )),
      (t = this.updateParamObject(t, "langId", this.getValue(e, "langId"), !0)),
      (t = this.updateParamObject(
        t,
        "valueFromProfileOrder",
        this.getValue(e, "valueFromProfileOrder"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "valueFromPaymentTC",
        this.getValue(e, "valueFromPaymentTC"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "paymentTCId",
        this.getValue(e, "paymentTCId"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "payMethodId",
        this.getValue(e, "payMethodId"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "piAmount",
        this.getValue(e, "piAmount"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "billing_address_id",
        this.getValue(e, "billing_address_id"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "cc_brand",
        this.getValue(e, "cc_brand"),
        !0
      )),
      (t = this.updateParamObject(t, "cc_cvc", this.getValue(e, "cc_cvc"), !0)),
      (t = this.updateParamObject(
        t,
        "account",
        this.getValue(e, "account"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "expire_month",
        this.getValue(e, "expire_month"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "expire_year",
        this.getValue(e, "expire_year"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "check_routing_number",
        this.getValue(e, "check_routing_number"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "checkingAccountNumber",
        this.getValue(e, "checkingAccountNumber"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "checkRoutingNumber",
        this.getValue(e, "checkRoutingNumber"),
        !0
      )),
      (t = this.updateParamObject(t, "requesttype", "ajax", !0)),
      e.authToken &&
        (t = this.updateParamObject(
          t,
          "authToken",
          this.getValue(e, "authToken"),
          !0
        )),
      t
    );
  },
  populateProtocolDataForGivenFields: function (e, t, r) {
    for (var s = 0; s < r.length; s++) {
      var a = r[s];
      t = this.updateParamObject(t, a, this.getValue(e, a), !0);
    }
    return (t = this.updateParamObject(t, "requesttype", "ajax", !0));
  },
  getSelected: function (e, t) {
    if (null != e[t]) {
      var r = e[t],
        s = r.selectedIndex;
      return -1 !== s ? r.options[s].text : "";
    }
    return "";
  },
  getValue: function (e, t) {
    return null != e[t] ? e[t].value : " ";
  },
  trim: function (e) {
    word = e.toString();
    for (var t = 0, r = word.length - 1; " " == word.charAt(t); ) t++;
    for (; " " == word.charAt(r); ) r -= 1;
    return t > r ? word.substring(t, t) : word.substring(t, r + 1);
  },
  isNumber: function (e) {
    for (var t = "0123456789", e = this.trim(e), r = 0; r < e.length; r++)
      if (-1 == t.indexOf(e.charAt(r))) return !1;
    return !0;
  },
  formatAmountDisplayForLocale: function (e) {
    var t = document.getElementById("piAmount_" + e),
      r = document.getElementById("piAmount_" + e + "_display");
    if ("ar-eg" == this.jQlocale)
      var s = Utils.formatNumber(t.value, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    else if (
      0 === this.jQlocale.indexOf("zh") ||
      0 === this.jQlocale.indexOf("ja") ||
      0 === this.jQlocale.indexOf("ko")
    )
      var s = Utils.formatNumber(t.value, {
        locale: this.jQlocale,
        maximumFractionDigits: 1,
      });
    else
      var s = Utils.formatNumber(t.value, {
        locale: this.jQlocale,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    (r.value != s || "ar-eg" == this.jQlocale) && (r.value = s);
  },
  validateAmount: function (e, t) {
    var r = document.forms[e + t];
    (r.piAmount_display.value = r.piAmount_display.value.replace(
      /^\s+|\s+$/g,
      ""
    )),
      (r.piAmount_display.value = r.piAmount_display.value.replace(
        /\xa0/g,
        ""
      ));
    var s = r.piAmount_display.value;
    if ("ar-eg" == this.jQlocale) {
      s = s.replace(",", "");
      var a = Utils.formatNumber(s, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    } else var a = Utils.parseNumber(s);
    if (
      (a != r.piAmount.value && (r.piAmount.value = a),
      null != r.piAmount && "" == r.piAmount.value)
    )
      return (
        MessageHelper.formErrorHandleClient(
          r.piAmount_display,
          this.errorMessages.EDPPaymentMethods_NO_AMOUNT
        ),
        !1
      );
    if (null != r.piAmount && parseFloat(r.piAmount.value) < 0)
      return (
        MessageHelper.formErrorHandleClient(
          r.piAmount_display,
          this.errorMessages.EDPPaymentMethods_AMOUNT_LT_ZERO
        ),
        !1
      );
    if (null != r.piAmount && isNaN(r.piAmount.value))
      return (
        MessageHelper.formErrorHandleClient(
          r.piAmount_display,
          this.errorMessages.EDPPaymentMethods_AMOUNT_NAN
        ),
        !1
      );
    var i = {};
    return (
      (i["paymentAreaAmount" + t] = a),
      wcRenderContext.updateRenderContext("paymentContext", i),
      !0
    );
  },
  validatePaymentTotals: function (e) {
    for (
      var t = parseFloat(0),
        r = document.getElementById("OrderTotalAmount").value,
        s = 1;
      s <= this.numberOfPaymentMethods;
      s++
    ) {
      var a = document.forms[e + s];
      if (!this.validateAmount(e, s)) return !1;
      t += parseFloat(a.piAmount.value);
      var i = t.toFixed(2);
      t = parseFloat(i);
    }
    if (t == r) return !0;
    var n = document.getElementsByName("piAmount_display")[0];
    return r > t
      ? (MessageHelper.formErrorHandleClient(
          n,
          this.errorMessages.EDPPaymentMethods_CANNOT_RECONCILE_PAYMENT_AMT
        ),
        !1)
      : t > r
      ? (MessageHelper.formErrorHandleClient(
          n,
          this.errorMessages
            .EDPPaymentMethods_PAYMENT_AMOUNT_LARGER_THAN_ORDER_AMOUNT
        ),
        !1)
      : (MessageHelper.formErrorHandleClient(
          n,
          this.errorMessages.EDPPaymentMethods_PAYMENT_AMOUNT_PROBLEM
        ),
        !1);
  },
  isBillingAddressValid: function (e) {
    for (var t = 1; t <= this.numberOfPaymentMethods; t++) {
      var r = document.forms[e + t],
        s = r.billing_address_isValid;
      if (s && "false" == s.value) return !1;
    }
    return !0;
  },
  checkValidPaymentInstructions: function (e) {
    for (var t = 1; t <= this.numberOfPaymentMethods; t++) {
      var r = document.forms[e + t],
        s = " ";
      null != r["mandatoryFields_" + t] &&
        (s = r["mandatoryFields_" + t].value);
      var a = document.forms.purchaseOrderNumberInfo;
      if (a) {
        if (
          ((this.purchaseOrderNumber = a.purchase_order_number.value),
          "true" == a.purchaseOrderNumberRequired.value &&
            "" == a.purchase_order_number.value)
        )
          return (
            MessageHelper.formErrorHandleClient(
              a.purchase_order_number,
              this.errorMessages.ERROR_PONumberEmpty
            ),
            !1
          );
        if (
          !MessageHelper.isValidUTF8length(a.purchase_order_number.value, 128)
        )
          return (
            MessageHelper.formErrorHandleClient(
              a.purchase_order_number,
              this.errorMessages.ERROR_PONumberTooLong
            ),
            !1
          );
      }
      if (
        "select-one" == r.payMethodId.type &&
        "empty" ==
          r.payMethodId.options[r.payMethodId.options.selectedIndex].value
      )
        return (
          MessageHelper.formErrorHandleClient(
            r.payMethodId,
            this.errorMessages.EDPPaymentMethods_NO_PAYMENT_SELECTED
          ),
          !1
        );
      if (
        (CheckoutHelperJS.isPaymentDataDirty(t) &&
          null != document.getElementById("account_" + t) &&
          (document.getElementById("account_" + t).value =
            document.getElementById("account1_" + t).value),
        null != document.getElementById("expire_month_" + t) ||
          null != document.getElementById("expire_year_" + t))
      ) {
        var i = new Date(
            r.curr_year.value,
            r.curr_month.value - 1,
            r.curr_date.value
          ),
          n = 1,
          o = 1;
        null != document.getElementById("expire_month_" + t) &&
          ((o =
            new Number(document.getElementById("expire_month_" + t).value) + 1),
          o > 13 && (o = 1));
        var d = 2e3;
        null != document.getElementById("expire_year_" + t) &&
          (d = new Date(
            document.getElementById("expire_year_" + t).value,
            o - 1,
            n
          ));
      }
      if (null != r.piAmount && parseFloat(r.piAmount.value) < 0)
        return (
          MessageHelper.formErrorHandleClient(
            r.piAmount_display,
            this.errorMessages.EDPPaymentMethods_AMOUNT_LT_ZERO
          ),
          !1
        );
      if (
        -1 != s.indexOf("account_" + t) &&
        null != document.getElementById("account_" + t) &&
        "" == document.getElementById("account_" + t).value
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_NO_ACCOUNT_NUMBER
          ),
          !1
        );
      if (
        -1 != s.indexOf("expire_month_" + t) &&
        -1 != s.indexOf("expire_year_" + t) &&
        null != document.getElementById("expire_month_" + t) &&
        null != document.getElementById("expire_year_" + t) &&
        i >= d
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_INVALID_EXPIRY_DATE
          ),
          !1
        );
      if (null != r.piAmount && "" == r.piAmount.value)
        return (
          MessageHelper.formErrorHandleClient(
            r.piAmount_display,
            this.errorMessages.EDPPaymentMethods_NO_AMOUNT
          ),
          !1
        );
      if (null != r.piAmount && isNaN(r.piAmount.value))
        return (
          MessageHelper.formErrorHandleClient(
            r.piAmount_display,
            this.errorMessages.EDPPaymentMethods_AMOUNT_NAN
          ),
          !1
        );
      if (
        -1 != s.indexOf("check_routing_number_" + t) &&
        null != document.getElementById("check_routing_number_" + t) &&
        "" == document.getElementById("check_routing_number_" + t).value
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_NO_ROUTING_NUMBER
          ),
          !1
        );
      if (
        -1 != s.indexOf("CheckAccount_" + t) &&
        null != document.getElementById("CheckAccount_" + t) &&
        "" == document.getElementById("CheckAccount_" + t).value
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_NO_BANK_ACCOUNT_NO
          ),
          !1
        );
      if (
        -1 != s.indexOf("billing_address_id") &&
        null != r.billing_address_id &&
        ("" == r.billing_address_id.value || "-1" == r.billing_address_id.value)
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_NO_BILLING_ADDRESS
          ),
          !1
        );
      if (
        CheckoutHelperJS.isPaymentDataDirty(t) &&
        -1 != s.indexOf("cc_cvc_" + t) &&
        null != document.getElementById("cc_cvc_" + t) &&
        null != this.trim(document.getElementById("cc_cvc_" + t).value) &&
        "" != this.trim(document.getElementById("cc_cvc_" + t).value) &&
        !this.isNumber(document.getElementById("cc_cvc_" + t).value)
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_CVV_NOT_NUMERIC
          ),
          !1
        );
    }
    return this.isBillingAddressValid(e)
      ? CheckoutHelperJS.isSinglePageCheckout() || this.validatePaymentTotals(e)
        ? !0
        : !1
      : (MessageHelper.displayErrorMessage(
          this.errorMessages.EDPPaymentMethods_BILLING_ADDRESS_INVALID
        ),
        !1);
  },
  updateExistingPiId: function (e, t) {
    if (null != e) {
      var r = document.forms[e + 1];
      r.existingPiId.value = t;
    }
  },
  updateParamObject: function (e, t, r, s, a) {
    if ((null == e && (e = []), null != e[t] && s))
      if ($.isArray(e[t])) null != a && "" != a ? (e[t][a] = r) : e[t].push(r);
      else {
        var i = e[t];
        (e[t] = []), e[t].push(i), e[t].push(r);
      }
    else if (null != a && "" != a && -1 != a) e[t + "_" + a] = r;
    else if (-1 == a) {
      for (var n = 1; null != e[t + "_" + n]; ) n++;
      e[t + "_" + n] = r;
    } else e[t] = r;
    return e;
  },
  saveBillingAddressDropDownBoxContextProperties: function (e, t) {
    for (var r = 1; 4 > r; r++) {
      var s = document.forms["PaymentForm" + r];
      if (s) {
        if (null != s.billing_address_id) {
          var a = s.billing_address_id.value;
          "create" == e && t == r && (a = "-1"),
            (wcRenderContext.getRenderContextProperties(
              "billingAddressDropDownBoxContext"
            )["billingAddress" + r] = a);
        }
      } else if (!(null == s && r > 1)) return;
    }
    if ("edit" == e) {
      var s = document.forms["PaymentForm" + t];
      if (s)
        for (var a = s.billing_address_id.value, r = 1; 4 > r; r++) {
          var i = document.forms["PaymentForm" + r];
          if (i) {
            var n = i.billing_address_id.value;
            n == a &&
              (wcRenderContext.getRenderContextProperties(
                "billingAddressDropDownBoxContext"
              )["billingAddress" + r] = "-1");
          }
        }
    }
  },
  createBillingAddress: function (e, t) {
    this.saveBillingAddressDropDownBoxContextProperties("create", e),
      CheckoutHelperJS.createAddress(-1, t);
  },
  displayBillingAddressDetails: function (e, t, r) {
    if (
      (-1 != e.value &&
        (document.getElementById("selectedAddressId_" + t).value = e.value),
      this.saveBillingAddressDropDownBoxContextProperties("create", "-1"),
      -1 != e.value)
    ) {
      wcRenderContext.updateRenderContext("billingAddressDropDownBoxContext", {
        addressKey: e.value,
        areaNumber: t,
      });
    }
  },
  getTotalInJSON: function (e, t, r) {
    var s = {};
    (s.operation = e),
      (s.piFormName = t),
      (s.skipOrderPrepare = r),
      (s.storeId = this.storeId),
      (s.catalogId = this.catalogId),
      (s.langId = this.langId);
    var a = appendWcCommonRequestParameters("orderTotalAsJSON");
    wcTopic.publish("ajaxRequestInitiated"),
      $.ajax({
        url: a,
        method: "POST",
        dataType: "json",
        data: s,
        context: this,
        success: CheckoutPayments.updateAmountFieldsWithTotalInJSON,
        error: function (e, t, r) {
          console.debug("error - inside CheckoutPayments.getTotalInJSON()"),
            console.debug(r),
            wcTopic.publish("ajaxRequestCompleted");
        },
      });
  },
  updateAmountFieldsWithTotalInJSON: function (e, t, r) {
    null != e &&
      void 0 != e &&
      CheckoutPayments.updateAmountFields(
        e.orderTotal,
        e.operation,
        e.piFormName,
        e.skipOrderPrepare
      ),
      wcTopic.publish("ajaxRequestCompleted");
  },
  updateAmountFields: function (e, t, r, s) {
    var a,
      i = 0;
    if (
      ((this.numberOfPaymentMethods = document.getElementById(
        "numberOfPaymentMethods"
      ).value),
      null != document.getElementById("OrderTotalAmount") &&
        (document.getElementById("OrderTotalAmount").value = e),
      1 == this.numberOfPaymentMethods)
    )
      return (
        (a = document.forms.PaymentForm1),
        null == a.piAmount ||
          "" == a.piAmount.value ||
          isNaN(a.piAmount.value) ||
          ((a.piAmount.value = e),
          (a.piAmount_display.value = e),
          this.formatAmountDisplayForLocale("1"),
          null != this.retrievePaymentObject(1) &&
            this.updatePaymentObject(1, "piAmount")),
        void (void 0 != t && "OrderPrepare" == t
          ? this.processPIAndCheckout(r, s)
          : ((void 0 != t && "loadPaymentSnippet" == t) ||
              supportPaymentTypePromotions) &&
            this.currentPaymentMethodChanged &&
            (this.loadPaymentSnippet(
              document.getElementById(
                "payMethodId_" + this.currentPaymentMethodChanged
              ),
              this.currentPaymentMethodChanged
            ),
            this.updatePaymentObject(
              this.currentPaymentMethodChanged,
              "payMethodId"
            )))
      );
    for (var n = 1; n <= this.numberOfPaymentMethods; n++)
      (a = document.forms["PaymentForm" + n]),
        null == a.piAmount ||
          "" == a.piAmount.value ||
          isNaN(a.piAmount.value) ||
          (i = 1 * i + 1 * a.piAmount.value);
    var o = e - i;
    if (((o = Math.round(100 * o) / 100), o > 0)) {
      var d = this.numberOfPaymentMethods;
      (a = document.forms["PaymentForm" + d]),
        null == a.piAmount ||
          "" == a.piAmount.value ||
          isNaN(a.piAmount.value) ||
          ((a.piAmount.value = parseFloat(a.piAmount.value) + parseFloat(o)),
          (a.piAmount_display.value = a.piAmount.value),
          this.formatAmountDisplayForLocale(d),
          null != this.retrievePaymentObject(d) &&
            this.updatePaymentObject(d, "piAmount"));
    } else {
      o = -1 * o;
      for (var l = this.numberOfPaymentMethods; l > 0; l--)
        if (
          ((a = document.forms["PaymentForm" + l]),
          null != a.piAmount &&
            "" != a.piAmount.value &&
            !isNaN(a.piAmount.value))
        ) {
          if (a.piAmount.value > o) {
            var c = a.piAmount.value - o;
            (a.piAmount.value = Math.round(100 * c) / 100),
              (a.piAmount_display.value = a.piAmount.value),
              this.formatAmountDisplayForLocale(l),
              null != this.retrievePaymentObject(l) &&
                this.updatePaymentObject(l, "piAmount"),
              (o = 0);
            break;
          }
          (o -= a.piAmount.value),
            (a.piAmount.value = 0),
            null != this.retrievePaymentObject(l) &&
              this.updatePaymentObject(l, "piAmount"),
            this.formatAmountDisplayForLocale(l);
        }
    }
    void 0 != t && "OrderPrepare" == t
      ? this.processPIAndCheckout(r, s)
      : void 0 != t &&
        "loadPaymentSnippet" == t &&
        this.currentPaymentMethodChanged &&
        (this.loadPaymentSnippet(
          document.getElementById(
            "payMethodId_" + this.currentPaymentMethodChanged
          ),
          this.currentPaymentMethodChanged
        ),
        this.updatePaymentObject(
          this.currentPaymentMethodChanged,
          "payMethodId"
        ));
  },
  removeCreditCardNumberAndCVV: function (e, t, r) {
    CheckoutHelperJS.isPaymentDataDirty(e) ||
      (t &&
        (null == document.forms["PaymentForm" + e].valueFromProfileOrder ||
          "Y" !=
            document.forms["PaymentForm" + e].valueFromProfileOrder.value) &&
        $("#account1_" + e).length &&
        $("#account1_" + e).val(""),
      r && $("#cc_cvc_" + e).length && $("#cc_cvc_" + e).val(""));
  },
  initializePaymentAreaDataDirtyFlags: function () {
    (CheckoutHelperJS.dataDirty[1] = !1),
      (CheckoutHelperJS.dataDirty[2] = !1),
      (CheckoutHelperJS.dataDirty[3] = !1);
  },
  initializeOverallPaymentObjects: function () {
    (this.prevNumberOfPaymentMethods = document.getElementById(
      "numberOfPaymentMethods"
    ).value),
      (this.numberOfPaymentMethods = parseInt(
        $("#numberOfPaymentMethods").val()
      ));
    for (
      var e = parseInt(this.maxNumberOfPaymentMethodsSupported), t = 1;
      e >= t;
      t++
    )
      this.initializePaymentObject(t);
    var r = document.forms.PaymentForm1.existingPiId.value,
      s = null;
    if (
      document.forms.PaymentForm1.unboundPiId &&
      ((s = document.forms.PaymentForm1.unboundPiId.value),
      null != s && "" != s)
    )
      var a = s.split(",");
    if (null != r && "" != r)
      for (var i = r.split(","), t = 0; t < i.length; t++) {
        var n = t + 1;
        if (
          ((this.retrievePaymentObject(n).piId = i[t]),
          (document.forms["PaymentForm" + n].piId.value = i[t]),
          n > this.numberOfPaymentMethods &&
            (this.retrievePaymentObject(n).action = "delete"),
          supportPaymentTypePromotions && null != s && "" != s)
        )
          for (var o = 0; o < a.length; o++)
            if (this.retrievePaymentObject(n).piId == a[o]) {
              this.retrievePaymentObject(n).action = "re-add";
              break;
            }
      }
    else this.retrievePaymentObject(1).action = "add";
    !supportPaymentTypePromotions ||
      ("Y" !=
        this.getValue(document.forms.PaymentForm1, "valueFromProfileOrder") &&
        "PayInStore" !=
          this.getValue(document.forms.PaymentForm1, "payMethodId")) ||
      (requestSubmitted
        ? (this.updatePaymentTypePromotionForProfileCheckoutHandler =
            wcTopic.subscribe("requestSubmittedChanged", function (e) {
              e ||
                (CheckoutPayments.updatePaymentTypePromotionForProfileCheckoutHandler.remove(),
                CheckoutPayments.updateUnboundPaymentToOrder());
            }))
        : this.updateUnboundPaymentToOrder());
  },
  initializePaymentObject: function (e) {
    var t = new Array();
    (t.piId = ""),
      (t.action = ""),
      (t.fields = new Array()),
      (t.options = ""),
      this.storePaymentObject(e, t);
  },
  storePaymentObject: function (e, t) {
    this.paymentObjects[e] = t;
  },
  retrievePaymentObject: function (e) {
    return this.paymentObjects[e];
  },
  updatePaymentObject: function (e, t) {
    var r = this.retrievePaymentObject(e);
    if (null != r) {
      if (
        (console.debug(t + " was changed."),
        "" == r.piId
          ? ((r.action = "add"),
            console.debug(
              "The action property in the payment object associated with payment area " +
                e +
                " was updated to 'add'."
            ))
          : "piAmount" == t &&
            "add" != r.action &&
            "delete" != r.action &&
            "re-add" != r.action
          ? ((r.action = "update"),
            console.debug(
              "The action property in the payment object associated with payment area " +
                e +
                " was updated to 'update'."
            ))
          : ((r.action = "re-add"),
            console.debug(
              "The action property in the payment object associated with payment area " +
                e +
                " was updated to 're-add'."
            )),
        "piAmount" == t)
      ) {
        for (var s = !1, a = 0; a < r.fields.length; a++)
          if (r.fields[a] == t) {
            s = !0;
            break;
          }
        s || r.fields.push(t);
      }
    } else
      console.debug(
        "CheckoutPayemnts.updatePaymentObject -- payment object not found."
      );
  },
  setPaymentsToDelete: function (e) {
    this.paymentsToDelete.push(e);
  },
  getPaymentsToDelete: function () {
    return this.paymentsToDelete;
  },
  setPaymentsToAdd: function (e) {
    this.paymentsToAdd.push(e);
  },
  getPaymentsToAdd: function () {
    return this.paymentsToAdd;
  },
  setPaymentsToUpdate: function (e) {
    this.paymentsToUpdate.push(e);
  },
  getPaymentsToUpdate: function () {
    return this.paymentsToUpdate;
  },
  deletePaymentInstructions: function () {
    var e = [];
    if (((e.piId = new Array()), this.getPaymentsToDelete().length > 0)) {
      var t = this.getPaymentsToDelete().pop();
      e.piId.push(document.forms["PaymentForm" + t].piId.value),
        (e.storeId = this.storeId),
        (e.catalogId = this.catalogId),
        (e.paymentAreaNumber = t),
        (e.langId = this.langId),
        null != document.forms.PaymentForm1.authToken &&
          (e.authToken = document.forms.PaymentForm1.authToken.value),
        (e.orderId = ".");
    }
    submitRequest() &&
      (cursor_wait(),
      wcService.invoke("AjaxDeletePaymentInstructionFromThisOrder", e));
  },
  addPaymentInstructions: function () {
    var e = [];
    if (this.getPaymentsToAdd().length > 0) {
      var t = this.getPaymentsToAdd().pop(),
        r = document.forms["PaymentForm" + t];
      e = this.populateProtocolData(r, e);
    }
    submitRequest() &&
      (cursor_wait(),
      wcService.invoke("AjaxAddPaymentInstructionToThisOrder", e));
  },
  updatePaymentInstructions: function () {
    var e = [];
    if (this.getPaymentsToUpdate().length > 0) {
      var t = this.getPaymentsToUpdate().pop(),
        r = document.forms["PaymentForm" + t],
        s = this.retrievePaymentObject(t);
      s.fields.push("storeId"),
        s.fields.push("catalogId"),
        s.fields.push("langId"),
        s.fields.push("piId"),
        s.fields.push("payMethodId"),
        s.fields.push("authToken"),
        s.fields.push("orderId"),
        (document.forms["PaymentForm" + t].paymentDataEditable.value = !1),
        s.fields.push("paymentDataEditable"),
        (e = this.populateProtocolDataForGivenFields(r, e, s.fields));
    }
    submitRequest() &&
      (cursor_wait(),
      wcService.invoke("AjaxUpdatePaymentInstructionInThisOrder", e));
  },
  reinitializePaymentObjects: function (e) {
    supportPaymentTypePromotions && this.updateUnboundPaymentToOrder();
    var t = parseInt(e.value),
      r = parseInt(this.prevNumberOfPaymentMethods),
      s = parseInt(this.maxNumberOfPaymentMethodsSupported);
    if (r > t)
      for (var a = t + 1; s >= a; a++) {
        var i = this.retrievePaymentObject(a);
        "" == i.piId
          ? (i.action = "")
          : ((i.action = "delete"),
            console.debug(
              "The action in the payment object associated with payment area " +
                a +
                " was updated to 'delete'."
            ));
      }
    else if (t > r)
      for (var a = r + 1; s >= a; a++) {
        var i = this.retrievePaymentObject(a);
        "" != i.piId
          ? a > t && s >= a
            ? ("delete" == i.action,
              console.debug(
                "The action in the payment object associated with payment area " +
                  a +
                  " was updated to 'delete'."
              ))
            : ("re-add" == i.action,
              console.debug(
                "The action in the payment object associated with payment area " +
                  a +
                  " was updated to 're-add'."
              ))
          : (this.initializePaymentObject(a),
            console.debug(
              "A new payment object was initialized to be associated with payment area " +
                a +
                "."
            ));
      }
    this.prevNumberOfPaymentMethods = t;
  },
  setPaymentFormPiId: function (e, t) {
    var r = document.forms["PaymentForm" + e];
    r && (r.piId.value = t);
  },
  updateUnboundPaymentToOrder: function (e) {
    this.currentPaymentMethodChanged = e;
    var t = document.forms.PaymentForm1,
      r = this.getValue(t, "piId");
    if (null != r && "" != r) {
      var s = [];
      if (
        ((s.storeId = this.storeId),
        (s.catalogId = this.catalogId),
        (s.langId = this.langId),
        (s.orderId = "."),
        (s.piId = ""),
        !submitRequest())
      )
        return;
      cursor_wait(),
        wcService.invoke("AjaxDeleteUnboundPaymentInstructionFromThisOrder", s);
    } else
      this.isSinglePaymentType()
        ? this.addNewUnboundPaymentInstruction()
        : e &&
          (this.loadPaymentSnippet(
            document.getElementById("payMethodId_" + e),
            e
          ),
          this.updatePaymentObject(e, "payMethodId"));
  },
  addNewUnboundPaymentInstruction: function () {
    var e = document.forms.PaymentForm1,
      t = [];
    if (
      ((t.storeId = this.storeId),
      (t.catalogId = this.catalogId),
      (t.langId = this.langId),
      null != document.forms.PaymentForm1.authToken &&
        (t.authToken = document.forms.PaymentForm1.authToken.value),
      (t.payMethodId = this.getValue(e, "payMethodId", !0)),
      (t.unbound = !0),
      "empty" != t.payMethodId && "" != t.payMethodId)
    ) {
      if (!submitRequest()) return;
      cursor_wait(),
        wcService.invoke("AjaxAddUnboundPaymentInstructionToThisOrder", t);
    }
  },
  isSinglePaymentType: function () {
    for (
      var e = document.forms.PaymentForm1,
        t = this.getValue(e, "payMethodId"),
        r = "empty" != t && "" != t,
        s = 2;
      r && s <= this.numberOfPaymentMethods;
      s++
    ) {
      var a = document.forms["PaymentForm" + s],
        i = this.getValue(a, "payMethodId");
      r = i == t;
    }
    return r;
  },
}),
  (PromotionChoiceOfFreeGiftsJS = {
    disableApplyButton: !1,
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    updateRewardChoices: function (e, t, r, s) {
      if (this.disableApplyButton) return !1;
      var a = [],
        i = [],
        n = [],
        o = 0;
      (a.storeId = this.storeId),
        (a.orderId = s),
        (a.rewardOptionId = r),
        CheckoutHelperJS.shoppingCartPage
          ? (a.calculationUsage = "-1,-2,-5,-6,-7")
          : (a.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      for (var d = 0; t > d; d++)
        document.getElementById("no_gifts").checked ||
          (document.getElementById("SelectFreeGift_" + (d + 1)).checked &&
            ((i[o] = document.getElementById(
              "CatalogEntryID_" + (d + 1)
            ).value),
            (n[o] = document.getElementById(
              "GiftItemQuantity_" + (d + 1)
            ).value),
            o++));
      (a.catEntryId = i),
        (a.quantity = n),
        submitRequest() &&
          (cursor_wait(),
          wcService.invoke("AjaxUpdateRewardOption", a),
          setTimeout($.proxy(this, "hidePopup", "free_gifts_popup"), 200),
          $("#free_gifts_popup").data("wc-WCDialog").close());
    },
    checkNumberOfAllowedItems: function (e) {
      var t = 1,
        r = 0;
      for (
        this.disableApplyButton = !1;
        document.getElementById("SelectFreeGift_" + t);

      )
        document.getElementById("SelectFreeGift_" + t).checked && r++, t++;
      if (r > e)
        null != document.getElementById("message") &&
          ((document.getElementById("message").className = "error"),
          (document.getElementById("message").innerHTML =
            MessageHelper.messages.PROMOTION_FREE_GIFTS_POPUP_ERROR_EXCEED_GIFT_QUANTITY)),
          (this.disableApplyButton = !0);
      else if (r > 0) {
        if (1 == r)
          var s =
            MessageHelper.messages
              .PROMOTION_FREE_GIFTS_POPUP_NUMBER_OF_SELECTIONS_ONE;
        else {
          var s =
            MessageHelper.messages
              .PROMOTION_FREE_GIFTS_POPUP_NUMBER_OF_SELECTIONS;
          s = s.replace(/%0/, r);
        }
        null != document.getElementById("message") &&
          ((document.getElementById("message").className = "status_message"),
          (document.getElementById("message").innerHTML = s));
      } else
        0 == r &&
          (null != document.getElementById("message") &&
            (document.getElementById("message").innerHTML = "&nbsp;"),
          (this.disableApplyButton = !0));
    },
    rewardChoicesEnabledStatus: function () {
      var e = 1;
      if (document.getElementById("no_gifts").checked)
        for (
          this.disableApplyButton = !1,
            null != document.getElementById("message") &&
              (document.getElementById("message").innerHTML = "&nbsp;");
          document.getElementById("SelectFreeGift_" + e);

        )
          (document.getElementById("SelectFreeGift_" + e).checked = !1),
            (document.getElementById("SelectFreeGift_" + e).disabled = !0),
            e++;
      else {
        for (; document.getElementById("SelectFreeGift_" + e); )
          (document.getElementById("SelectFreeGift_" + e).disabled = !1), e++;
        this.checkNumberOfAllowedItems(), this.checkFreeGiftsAvailability();
      }
    },
    showFreeGiftsDialog: function () {
      this.checkNumberOfAllowedItems(),
        $("#free_gifts_popup").data("wc-WCDialog").open(),
        this.checkFreeGiftsAvailability();
    },
    checkFreeGiftsAvailability: function () {
      for (
        var e = 1, t = 0;
        document.getElementById("OnlineAvailability_" + e);

      )
        "Available" !=
          document.getElementById("OnlineAvailability_" + e).value &&
        "Backorderable" !=
          document.getElementById("OnlineAvailability_" + e).value
          ? ((document.getElementById("SelectFreeGift_" + e).checked = !1),
            (document.getElementById("SelectFreeGift_" + e).disabled = !0))
          : t++,
          e++;
      0 == t && (this.disableApplyButton = !0);
    },
    hideFreeGiftsPopup: function (e, t) {
      if (null == t || "keypress" != t.type || t.keyCode == KeyCodes.ESCAPE) {
        var r = $("#" + e).data("wc-WCDialog");
        r && r.close();
      }
    },
  }),
  ("undefined" != typeof PunchoutJS &&
    PunchoutJS &&
    PunchoutJS.topicNamespace) ||
    (PunchoutJS = {
      divId: "",
      sameWindow: !0,
      displayPopup: function () {
        if (!$("#punchout_popup_container").length)
          return void console.debug(
            "PunchoutJS.displayPopup: element with Id punchout_popup_container was not found on the page."
          );
        $("#punchout_popup_container").show();
        var e = $("<div id='pageMask'/>").appendTo($("body"));
        $(e).css({
          position: "absolute",
          "z-index": 949,
          top: "0px",
          left: "0px",
          width: $("body").innerWidth() + "px",
          height: $("body").innerHeight() + "px",
          background: "#000",
          opacity: "0.40",
        }),
          setTimeout("$('#punchout_popup_close_icon').focus()", 1e3);
      },
      handleResponse: function (e) {
        var t = this.divId,
          r = this.sameWindow,
          s = document.getElementById(t),
          a = s.innerHTML.replace(/(^\s*)|(\s*$)/g, ""),
          i = a.toLowerCase();
        if (0 !== i.indexOf("<form") && 0 !== i.indexOf("&lt;form")) {
          0 !== i.indexOf("<a") && 0 !== i.indexOf("&lt;a")
            ? (s.innerHTML = '<a name="punchout_anchor" href="' + a + '" />')
            : (s.innerHTML = a);
          var n = s.childNodes[0];
          r
            ? (window.location = n.href)
            : ((n.target = "_blank"), window.open(n.href));
        } else {
          s.innerHTML = a;
          var o = s.childNodes[0];
          (o.name = "punchout_form"),
            r ? o.submit() : ((o.target = "_blank"), o.submit());
        }
      },
      pay: function (e, t, r, s, a) {
        (this.divId = s),
          (this.sameWindow = a),
          (params = []),
          (params.storeId = e),
          (params.orderId = t),
          (params.piId = r);
        var i = document.forms.punchoutPaymentRedirectForm_AuthTokenInfo,
          n = i.punchoutPaymentRedirect_authToken.value;
        (params.authToken = n),
          submitRequest() &&
            (cursor_wait(), wcService.invoke("AjaxPunchoutPay", params));
      },
      handleKeyPress: function (e) {
        e.keyCode !== KeyCodes.TAB &&
          e.keyCode !== KeyCodes.SHIFT &&
          location.reload();
      },
      focusElement: function (e) {
        $("#" + e).length ||
          console.debug(
            "PunchoutJS.focusElement: element with Id " +
              e +
              " was not found on the page."
          ),
          $("#" + e).focus();
      },
    }),
  (ShipmodeSelectionExtJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    BOPISEnabled: !1,
    orderItemId: "",
    isPickUpInStore: function () {
      var e = this.getShipTypeValue();
      return "pickUp" == e ? !0 : !1;
    },
    getShipTypeValue: function () {
      if (void 0 != document.BOPIS_FORM)
        for (var e = 0; e < document.BOPIS_FORM.shipType.length; e++)
          if (document.BOPIS_FORM.shipType[e].checked)
            return document.BOPIS_FORM.shipType[e].value;
    },
    getShipTypeValueFromCookieForOrder: function (e) {
      var t = getCookie("WC_shipTypeValueOrderId");
      if (t == e) {
        var r = getCookie("WC_shipTypeValue");
        return r;
      }
      return "";
    },
    setShipTypeValueToCookieForOrder: function (e, t) {
      var r = e;
      if (null != r && "undefined" != r && "" != r) {
        var s = getCookie("WC_shipTypeValueOrderId");
        s != t &&
          (setCookie("WC_shipTypeValueOrderId", null, {
            expires: -1,
          }),
          setCookie("WC_shipTypeValueOrderId", t, {
            path: "/",
            domain: cookieDomain,
          }));
        var a = this.getShipTypeValueFromCookieForOrder(t);
        r != a &&
          (setCookie("WC_shipTypeValue", null, {
            expires: -1,
          }),
          setCookie("WC_shipTypeValue", r, {
            path: "/",
            domain: cookieDomain,
          }));
      }
      "pickUp" == r
        ? document.getElementById("scheduling_options") &&
          ((document.getElementById("scheduling_options").style.display =
            "none"),
          setCookie("WC_recurringOrder_" + t, "false", {
            path: "/",
            domain: cookieDomain,
          }),
          document.getElementById("recurringOrder") &&
            (document.getElementById("recurringOrder").checked = !1),
          this.hideShowNonRecurringOrderMsg(t))
        : "shopOnline" == r &&
          document.getElementById("scheduling_options") &&
          ((document.getElementById("scheduling_options").style.display =
            "block"),
          this.hideShowNonRecurringOrderMsg(t));
    },
    displaySavedShipmentTypeForOrder: function (e) {
      var t = getCookie("WC_shipTypeValueOrderId");
      if (t != e)
        setCookie("WC_shipTypeValueOrderId", null, {
          expires: -1,
        }),
          setCookie("WC_shipTypeValue", null, {
            expires: -1,
          });
      else {
        var r = this.getShipTypeValueFromCookieForOrder(e);
        "pickUp" == r
          ? 0 == document.getElementById("shipTypePickUp").disabled
            ? ((document.getElementById("shipTypePickUp").checked = !0),
              document.getElementById("scheduling_options") &&
                ((document.getElementById("scheduling_options").style.display =
                  "none"),
                setCookie("WC_recurringOrder_" + e, "false", {
                  path: "/",
                  domain: cookieDomain,
                }),
                document.getElementById("recurringOrder") &&
                  (document.getElementById("recurringOrder").checked = !1)))
            : ((document.getElementById("shipTypeOnline").checked = !0),
              document.getElementById("scheduling_options") &&
                (document.getElementById("scheduling_options").style.display =
                  "block"),
              this.setShipTypeValueToCookieForOrder("shopOnline", e))
          : "shopOnline" == r &&
            ((document.getElementById("shipTypeOnline").checked = !0),
            document.getElementById("scheduling_options") &&
              (document.getElementById("scheduling_options").style.display =
                "block"));
      }
      this.hideShowNonRecurringOrderMsg(e, !0);
    },
    hideShowNonRecurringOrderMsg: function (e, t) {
      if (
        ((document.getElementById("recurringOrder") &&
          document.getElementById("recurringOrder").checked &&
          document.getElementById("shipTypeOnline") &&
          document.getElementById("shipTypeOnline").checked) ||
        (document.getElementById("recurringOrder") &&
          document.getElementById("recurringOrder").checked &&
          null == document.getElementById("shipTypeOnline"))
          ? setCookie("WC_recurringOrder_" + e, "true", {
              path: "/",
              domain: cookieDomain,
            })
          : setCookie("WC_recurringOrder_" + e, "false", {
              path: "/",
              domain: cookieDomain,
            }),
        document.getElementById("nonRecurringOrderItems") &&
          "" != document.getElementById("nonRecurringOrderItems").value)
      ) {
        if (
          document.getElementById("nonRecurringOrderItemsCount") &&
          document.getElementById("numOrderItemsInOrder")
        ) {
          var r = document.getElementById("numOrderItemsInOrder").value,
            s = document.getElementById("nonRecurringOrderItemsCount").value;
          if (r == s && document.getElementById("scheduling_options"))
            return (
              (document.getElementById("scheduling_options").style.display =
                "none"),
              setCookie("WC_recurringOrder_" + e, "false", {
                path: "/",
                domain: cookieDomain,
              }),
              void (
                document.getElementById("recurringOrder") &&
                (document.getElementById("recurringOrder").checked = !1)
              )
            );
        }
        for (
          var a = document.getElementById("nonRecurringOrderItems").value,
            i = a.split(","),
            n = 0;
          n < i.length;
          n++
        )
          document.getElementById("nonRecurringItem_" + i[n]) &&
            ((document.getElementById("recurringOrder") &&
              document.getElementById("recurringOrder").checked &&
              document.getElementById("shipTypeOnline") &&
              document.getElementById("shipTypeOnline").checked) ||
            (document.getElementById("recurringOrder") &&
              document.getElementById("recurringOrder").checked &&
              null == document.getElementById("shipTypeOnline"))
              ? (document.getElementById(
                  "nonRecurringItem_" + i[n]
                ).style.display = "block")
              : (document.getElementById(
                  "nonRecurringItem_" + i[n]
                ).style.display = "none"));
        ((document.getElementById("recurringOrder") &&
          document.getElementById("recurringOrder").checked &&
          document.getElementById("shipTypeOnline") &&
          document.getElementById("shipTypeOnline").checked &&
          !t) ||
          (document.getElementById("recurringOrder") &&
            document.getElementById("recurringOrder").checked &&
            null == document.getElementById("shipTypeOnline") &&
            !t)) &&
          MessageHelper.displayErrorMessage(
            MessageHelper.messages.RECURRINGORDER_ERROR
          );
      }
    },
    registeredUserContinue: function (e, t) {
      if (CheckoutHelperJS.getFieldDirtyFlag())
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERROR_UPDATE_FIRST_SHOPPING_CART
        );
      if (submitRequest())
        if (this.isBOPISEnabled() && this.isPickUpInStore())
          document.location.href = appendWcCommonRequestParameters(t);
        else {
          var r =
              ("RESTOrderItemUpdate?remerge=***&check=*n&allocate=***&backorder=***&calculationUsage=-1,-2,-3,-4,-5,-6,-7&calculateOrder=1&orderItemId=" +
                this.orderItemId +
                "&errorViewName=AjaxOrderItemDisplayView&orderId=.&URL=",
              []),
            s = "AjaxRESTOrderItemUpdate",
            a = [];
          (a.remerge = "***"),
            (a.check = "*n"),
            (a.allocate = "***"),
            (a.backorder = "***"),
            (a.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
            (a.calculateOrder = "1"),
            (a.orderItemId = this.orderItemId),
            (a.orderId = "."),
            (a.storeId = this.storeId),
            r.push({
              URL: e,
              requestType: "GET",
              requestParams: {},
            });
          var i = getCustomServiceForURLChaining(s, r, null);
          i.invoke(a);
        }
    },
    guestShopperContinue: function (e, t) {
      if (CheckoutHelperJS.getFieldDirtyFlag())
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERROR_UPDATE_FIRST_SHOPPING_CART
        );
      if (submitRequest()) {
        var r = [];
        if (this.isBOPISEnabled() && this.isPickUpInStore()) {
          var s = $("#existingPaymentInstructionId").val();
          if ("" != s) {
            for (var a = s.split(","), i = 1; i < a.length; i++)
              r.push({
                URL: "AjaxRESTOrderPIDelete",
                requestParams: {
                  piId: a[i],
                },
              });
            r.push({
              URL: t,
              requestType: "GET",
            });
            var n = [];
            n.piId = a[0];
            var o = getCustomServiceForURLChaining(
              "AjaxRESTOrderPIDelete",
              r,
              null
            );
            o.invoke(n);
          } else document.location.href = t;
        } else {
          var n = [];
          (n.remerge = "***"),
            (n.check = "*n"),
            (n.allocate = "***"),
            (n.backorder = "***"),
            (n.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
            (n.calculateOrder = "1"),
            (n.orderItemId = this.orderItemId),
            (n.orderId = "."),
            (n.storeId = this.storeId);
          var r = [];
          r.push({
            URL: e,
            requestType: "GET",
            requestParams: {
              guestChkout: "1",
            },
          });
          var o = getCustomServiceForURLChaining(
            "AjaxRESTOrderItemUpdate",
            r,
            null
          );
          o.invoke(n);
        }
      }
    },
    guestShopperLogon: function (e, t, r) {
      if (CheckoutHelperJS.getFieldDirtyFlag())
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERROR_UPDATE_FIRST_SHOPPING_CART
        );
      var s = "";
      (s = this.isBOPISEnabled() && this.isPickUpInStore() ? r : t),
        (document.AjaxLogon.URL.value = s),
        (document.location.href = e);
    },
    updateCartWithQuickCheckoutProfile: function (e) {
      if (this.isBOPISEnabled() && this.isPickUpInStore())
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.message_QUICK_CHKOUT_ERR
        );
      else {
        if (CheckoutHelperJS.getFieldDirtyFlag())
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERROR_UPDATE_FIRST_SHOPPING_CART
          );
        CheckoutHelperJS.setCommonParameters(
          this.langId,
          this.storeId,
          this.catalogId
        ),
          CheckoutHelperJS.updateCartWithQuickCheckoutProfile(e);
      }
    },
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    setOrderItemId: function (e) {
      this.orderItemId = e;
    },
    setBOPISEnabled: function (e) {
      this.BOPISEnabled = e;
    },
    isBOPISEnabled: function () {
      return this.BOPISEnabled;
    },
    submitStoreSelectionForm: function (e) {
      var t = PhysicalStoreCookieJSStore.getPickUpStoreIdFromCookie();
      null != t && "" != t
        ? ((e.physicalStoreId.value = t), processAndSubmitForm(e))
        : null != document.getElementById("storeSelection_NextButton")
        ? MessageHelper.formErrorHandleClient(
            document.getElementById("storeSelection_NextButton"),
            MessageHelper.messages.message_NO_STORE
          )
        : MessageHelper.displayErrorMessage(
            MessageHelper.messages.message_NO_STORE
          );
    },
    submitAddressForm: function (e, t, r) {
      var s = document.forms[e];
      "" != t && AddressHelper.setStateDivName(t);
      var a = !1;
      $("#payInStorePaymentOption").is(":checked") && (a = !0);
      var i = [],
        n = [];
      if (r)
        var o = null,
          d = null;
      else if (AddressHelper.validateAddressForm(s))
        var o = $(s).attr("action"),
          d = s.id;
      var l = $("#existingPaymentInstructionId").val();
      if ("" != l) {
        var c = l.split(",");
        if (null == o) {
          var o = "AjaxRESTOrderPIDelete";
          n.piId = c[0];
        } else
          i.push({
            URL: "AjaxRESTOrderPIDelete",
            requestParams: {
              piId: c[0],
            },
          });
        for (var u = 1; u < c.length; u++)
          i.push({
            URL: "AjaxRESTOrderPIDelete",
            requestParams: {
              piId: c[u],
            },
          });
      }
      var m = [];
      (m.remerge = "***"),
        (m.check = "*n"),
        (m.allocate = "***"),
        (m.backorder = "***"),
        (m.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (m.calculateOrder = "1"),
        (m.orderItemId = this.orderItemId),
        (m.orderId = "."),
        (m.storeId = this.storeId),
        null == o
          ? ((o = "AjaxRESTOrderItemUpdate"), (n = m))
          : i.push({
              URL: "AjaxRESTOrderItemUpdate",
              requestParams: m,
            }),
        i.push({
          URL: "DOMOrderShippingBillingView",
          requestType: "GET",
          requestParams: {
            payInStore: a,
          },
        });
      var g = getCustomServiceForURLChaining(o, i, d);
      g.invoke(n);
    },
  }),
  (SBControllersDeclarationJS = {
    singlePageCheckout: !0,
    shipChargeEnabled: !1,
    setRefreshURL: function (e, t) {
      $("#" + e).attr("refreshurl", t);
    },
    setSinglePageCheckout: function (e) {
      this.singlePageCheckout = e;
    },
    isSinglePageCheckout: function () {
      return this.singlePageCheckout;
    },
    setShipChargeEnabled: function (e) {
      this.shipChargeEnabled = e;
    },
  }),
  (SBServicesDeclarationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    singlePageCheckout: !0,
    orderPrepare: !1,
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    setSinglePageCheckout: function (e) {
      this.singlePageCheckout = e;
    },
    isSinglePageCheckout: function () {
      return this.singlePageCheckout;
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemAddAndDeleteFromCart",
    actionId: "AjaxInterestItemAddAndDeleteFromCart",
    url: "AjaxInterestItemAdd",
    formId: "",
    successHandler: function (e) {
      cursor_clear(), CheckoutHelperJS.deleteFromCart(e.orderItemId);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderItemAddressShipMethodUpdate",
    actionId: "OrderItemAddressShipMethodUpdate",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderShipChargeUpdate",
    actionId: "AjaxOrderShipChargeUpdate",
    url: "AjaxShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t = [];
      (t.orderId = "."),
        (t.storeId = CheckoutHelperJS.storeId),
        (t.catalogId = CheckoutHelperJS.catalogId),
        (t.langId = CheckoutHelperJS.langId),
        wcService.invoke("AjaxPrepareOrderForShipChargeUpdate", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPrepareOrderForShipChargeUpdate",
    actionId: "AjaxPrepareOrderForShipChargeUpdate",
    url: getAbsoluteURL() + "AjaxRESTOrderPrepare",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderItemAddressShipInstructionsUpdate",
    actionId: "OrderItemAddressShipInstructionsUpdate",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t = [];
      if (
        ((t.orderId = "."),
        (t.storeId = CheckoutHelperJS.storeId),
        (t.catalogId = CheckoutHelperJS.catalogId),
        (t.langId = CheckoutHelperJS.langId),
        (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (t.calculateOrder = "1"),
        null != document.getElementById("shipInstructions"))
      ) {
        var r = document.getElementById("shipInstructions").value,
          s = document.getElementById("orderItem_1").value;
        (t.shipInstructions = r),
          (t.orderItemId = s),
          wcService.invoke("OrderItemAddressShipInstructionsUpdate1", t);
      } else MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderItemAddressShipInstructionsUpdate1",
    actionId: "OrderItemAddressShipInstructionsUpdate1",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderItemAddressShipMethodUpdate1",
    actionId: "OrderItemAddressShipMethodUpdate1",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t = CheckoutHelperJS.storeId,
        r = CheckoutHelperJS.catalogId,
        s = CheckoutHelperJS.langId,
        a = e.orderId,
        i = document.getElementById("orderItem_1").value,
        n = document.getElementById("commonShipModeId").value;
      if (null != n && "undefined" != n) var o = n;
      else var o = document.getElementById("MS_ShippingMode_" + i).value;
      var d = [],
        l = "AjaxRESTOrderShipInfoUpdate",
        c = [];
      (c.remerge = "***"),
        (c.check = "*n"),
        (c.allocate = "***"),
        (c.backorder = "***"),
        (c.storeId = t),
        (c.catalogId = r),
        (c.langId = s),
        (c.orderId = a),
        (c.shipModeId = o),
        (c.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (c.calculateOrder = "1");
      var u = document.getElementById("purchase_order_number");
      if (u) {
        var m = u.value;
        null != m && "undefined" != m && "" != m && (c.purchaseorder_id = m);
      }
      (valueFromProfileOrderElement =
        document.getElementsByName("valueFromProfileOrder")[0] &&
        "Y" == valueFromProfileOrderElement.value) &&
        (c.quickCheckoutProfileForPayment = "true"),
        d.push({
          URL: "OrderShippingBillingView",
          requestType: "GET",
          requestParams: {},
        });
      var g = getCustomServiceForURLChaining(l, d, null);
      g.invoke(c);
    },
    failureHandler: function (e) {
      "_ERR_INVALID_ADDR" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERROR_SWITCH_SINGLE_SHIPMENT
          )
        : e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateOrderItemsAddressId",
    actionId: "AjaxUpdateOrderItemsAddressId",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        (CheckoutHelperJS.orderItemIds = []),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AddBillingAddressInCheckOut",
    actionId: "AddBillingAddressInCheckOut",
    url: "AjaxPersonChangeServiceAddressAdd",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        wcRenderContext.updateRenderContext("contextForMainAndAddressDiv", {
          showArea: "mainContents",
          hideArea: "editAddressContents",
        }),
        "" != this.formId &&
          document.getElementById(this.formId) &&
          (e.addBillingAddressInCheckOutAddressType = document.getElementById(
            this.formId
          ).addressType.value);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "UpdateBillingAddressInCheckout",
    actionId: "UpdateBillingAddressInCheckout",
    url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        wcRenderContext.updateRenderContext("contextForMainAndAddressDiv", {
          showArea: "mainContents",
          hideArea: "editAddressContents",
        });
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderShippingInfoUpdate",
    actionId: "OrderShippingInfoUpdate",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPrepareOrderBeforeSubmit",
    actionId: "AjaxPrepareOrderBeforeSubmit",
    url: "AjaxRESTOrderPrepare",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        CheckoutPayments.getTotalInJSON("OrderPrepare", "PaymentForm", !1);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPrepareOrderBeforePaymentCapture",
    actionId: "AjaxPrepareOrderBeforePaymentCapture",
    url: "AjaxRESTOrderPrepare",
    formId: "",
    successHandler: function (e) {
      CheckoutPayments.setCommonParameters(
        SBServicesDeclarationJS.langId,
        SBServicesDeclarationJS.storeId,
        SBServicesDeclarationJS.catalogId
      ),
        CheckoutPayments.showBillingPage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSetAddressIdOfOrderItems",
    actionId: "AjaxSetAddressIdOfOrderItems",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t =
        "OrderShippingBillingView?orderId=" +
        (e.orderId ? e.orderId : ".") +
        "&langId=" +
        e.langId +
        "&storeId=" +
        e.storeId +
        "&catalogId=" +
        e.catalogId +
        "&showRegTag=T";
      document.location.href = appendWcCommonRequestParameters(t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        (document.getElementById(
          "OrderShippingBillingErrorArea"
        ).style.display = "block"),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSetShipModeIdForOrder",
    actionId: "AjaxSetShipModeIdForOrder",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t =
        "OrderShippingBillingView?langId=" +
        SBServicesDeclarationJS.langId +
        "&storeId=" +
        SBServicesDeclarationJS.storeId +
        "&catalogId=" +
        SBServicesDeclarationJS.catalogId;
      document.location.href = appendWcCommonRequestParameters(t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        (document.getElementById(
          "OrderShippingBillingErrorArea"
        ).style.display = "block"),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSetRequestedShipDateForOrder",
    actionId: "AjaxSetRequestedShipDateForOrder",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t =
        "OrderShippingBillingView?orderId=" +
        (e.orderId ? e.orderId : ".") +
        "&langId=" +
        SBServicesDeclarationJS.langId +
        "&storeId=" +
        SBServicesDeclarationJS.storeId +
        "&catalogId=" +
        SBServicesDeclarationJS.catalogId +
        "&showRegTag=T";
      document.location.href = appendWcCommonRequestParameters(t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        (document.getElementById(
          "OrderShippingBillingErrorArea"
        ).style.display = "block"),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
    actionId: "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
    url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
    formId: "",
    successHandler: function (e) {
      "" != this.formId &&
        (e.originalServiceId = document.getElementById(
          this.formId
        ).originalServiceId.value),
        MessageHelper.hideAndClearMessage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout",
    actionId: "AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout",
    url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
    formId: "",
    successHandler: function (e) {
      "" != this.formId &&
        (e.originalServiceId = document.getElementById(
          this.formId
        ).originalServiceId.value),
        MessageHelper.hideAndClearMessage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeletePaymentInstructionFromThisOrder",
    actionId: "AjaxDeletePaymentInstructionFromThisOrder",
    url: "AjaxRESTOrderPIDelete",
    formId: "",
    successHandler: function (e) {
      var t = CheckoutPayments.retrievePaymentObject(e.paymentAreaNumber);
      if (
        ("undefined" != typeof t && (t.piId = ""),
        cursor_clear(),
        CheckoutPayments.getPaymentsToDelete().length < 1)
      )
        if ((cursor_clear(), CheckoutPayments.getPaymentsToAdd().length > 0))
          CheckoutPayments.addPaymentInstructions();
        else if (CheckoutPayments.getPaymentsToUpdate().length > 0)
          CheckoutPayments.updatePaymentInstructions();
        else {
          if (!submitRequest()) return;
          cursor_wait(),
            CheckoutPayments.setCommonParameters(
              SBServicesDeclarationJS.langId,
              SBServicesDeclarationJS.storeId,
              SBServicesDeclarationJS.catalogId
            ),
            CheckoutPayments.showSummaryPage(),
            cursor_clear();
        }
      else CheckoutPayments.deletePaymentInstructions();
    },
    failureHandler: function (e) {
      (CheckoutPayments.paymentsToDelete = new Array()),
        e.errorMessage
          ? MessageHelper.displayErrorMessage(e.errorMessage)
          : e.errorMessageKey &&
            MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddPaymentInstructionToThisOrder",
    actionId: "AjaxAddPaymentInstructionToThisOrder",
    url: "AjaxRESTOrderPIAdd",
    formId: "",
    successHandler: function (e) {
      cursor_clear();
      if (CheckoutPayments.getPaymentsToAdd().length < 1) {
        if (CheckoutPayments.getPaymentsToUpdate().length > 0) {
          CheckoutPayments.updatePaymentInstructions();
        } else {
          if (!submitRequest()) {
            return;
          }

          //setCurrentId('singleOrderSummary');
          resetRequest();
          //showLoadingInternal(true,'shippingBillingPageNext');
          CheckoutHelperJS.checkoutOrder(
            CheckoutHelperJS.getSavedParameter("tempOrderId"),
            CheckoutHelperJS.getSavedParameter("tempUserType"),
            CheckoutHelperJS.getSavedParameter("tempEmailAddresses"),
            CheckoutHelperJS.getSavedParameter("tempIsQuote")
          );
        }
      } else {
        CheckoutPayments.addPaymentInstructions();
      }
    },
    failureHandler: function (e) {
      (CheckoutPayments.paymentsToAdd = new Array()),
        e.errorMessage
          ? MessageHelper.displayErrorMessage(e.errorMessage)
          : e.errorMessageKey &&
            MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear(),
        supportPaymentTypePromotions &&
          1 == CheckoutPayments.numberOfPaymentMethods &&
          CheckoutPayments.addNewUnboundPaymentInstruction();
    },
  }),
  wcService.declare({
    id: "AjaxUpdatePaymentInstructionInThisOrder",
    actionId: "AjaxUpdatePaymentInstructionInThisOrder",
    url: "AjaxRESTOrderPIUpdate",
    formId: "",
    successHandler: function (e) {
      if ((cursor_clear(), CheckoutPayments.getPaymentsToUpdate().length < 1)) {
        if (!submitRequest()) return;
        cursor_wait(),
          CheckoutPayments.setCommonParameters(
            SBServicesDeclarationJS.langId,
            SBServicesDeclarationJS.storeId,
            SBServicesDeclarationJS.catalogId
          ),
          CheckoutPayments.showSummaryPage(),
          cursor_clear();
      } else CheckoutPayments.updatePaymentInstructions();
    },
    failureHandler: function (e) {
      (CheckoutPayments.paymentsToUpdate = new Array()),
        e.errorMessage
          ? MessageHelper.displayErrorMessage(e.errorMessage)
          : e.errorMessageKey &&
            MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddUnboundPaymentInstructionToThisOrder",
    actionId: "AjaxAddUnboundPaymentInstructionToThisOrder",
    url: "AjaxRESTOrderPIAdd",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        CheckoutPayments.setPaymentFormPiId(1, e.paymentInstruction[0].piId),
        (CheckoutPayments.paymentObjects[1].piId =
          e.paymentInstruction[0].piId),
        (CheckoutPayments.paymentObjects[1].action = "re-add");
      var t = [];
      (t.orderId = e.orderId),
        (t.storeId = CheckoutHelperJS.storeId),
        (t.catalogId = CheckoutHelperJS.catalogId),
        (t.langId = CheckoutHelperJS.langId),
        cursor_wait(),
        wcService.invoke("AjaxPrepareOrderForPaymentSubmit", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeleteUnboundPaymentInstructionFromThisOrder",
    actionId: "AjaxDeleteUnboundPaymentInstructionFromThisOrder",
    url: "AjaxRESTOrderPIDelete",
    formId: "",
    successHandler: function (e) {
      cursor_clear();
      for (var t = 1; t < CheckoutPayments.paymentObjects.length; t++)
        $("#account1_" + t).length &&
          (CheckoutPayments.removeCreditCardNumberAndCVV(t, !0, !0),
          CheckoutHelperJS.paymentDataDirty(t, !0)),
          CheckoutPayments.setPaymentFormPiId(t, ""),
          (CheckoutPayments.paymentObjects[t].piId = ""),
          t > CheckoutPayments.numberOfPaymentMethods
            ? (CheckoutPayments.paymentObjects[t].action = "")
            : (CheckoutPayments.paymentObjects[t].action = "add");
      if (CheckoutPayments.isSinglePaymentType())
        CheckoutPayments.addNewUnboundPaymentInstruction();
      else {
        var r = [];
        (r.orderId = e.orderId),
          (r.storeId = CheckoutHelperJS.storeId),
          (r.catalogId = CheckoutHelperJS.catalogId),
          (r.langId = CheckoutHelperJS.langId),
          cursor_wait(),
          wcService.invoke("AjaxPrepareOrderForPaymentSubmit", r);
      }
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPrepareOrderForPaymentSubmit",
    actionId: "AjaxPrepareOrderForPaymentSubmit",
    url: "AjaxRESTOrderPrepare",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        CheckoutPayments.getTotalInJSON(
          "loadPaymentSnippet",
          "PaymentForm",
          !0
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  flowEnabled.SideBySideIntegration &&
    ((CallCenterIntegrationJS = function () {
      (this.lookUpMode = "lookup"),
        (this.normalMode = "normal"),
        (this.setUpCookies = function (e) {
          var t = "WCC_Mode_" + WCParamJS.storeId;
          void 0 != e &&
            null != e &&
            (e.length > 0
              ? setCookie("WCC_Mode_" + WCParamJS.storeId, escapeXml(e, !0), {
                  path: "/",
                  domain: cookieDomain,
                })
              : removeCookie(t));
        }),
        (this.updateWCParamJS = function (e, t) {
          WCParamJS[e] = t;
        }),
        (this.consumeAddToCartEvent = function (e, t) {
          var r = getCookie("WCC_Mode_" + WCParamJS.storeId);
          return r == this.lookUpMode
            ? ((e.action = "Sending_Product"),
              $.extend(e, t),
              (e = JSON.stringify(e)),
              console.debug(e),
              window.parent.postMessage(e, WCParamJS.wcc_integration_origin),
              !0)
            : !1;
        }),
        (this.postActionMessage = function (e, t) {
          var r = getCookie("WCC_Mode_" + WCParamJS.storeId);
          return r == this.lookUpMode || r == this.normalMode
            ? ((e.action = t),
              (e = JSON.stringify(e)),
              window.parent.postMessage(e, WCParamJS.wcc_integration_origin),
              !0)
            : void 0;
        }),
        window.addEventListener("message", function (e) {
          if (e.origin != WCParamJS.wcc_integration_origin)
            return void console.warn(
              "Unexpected WCC Integration server - " + e.origin
            );
          try {
            console.debug(e.data);
            var t = JSON.parse(e.data);
            if (t.action && "Requesting_Cart_Details" === t.action) {
              var r = getCookie("WC_CartOrderId_" + WCParamJS.storeId),
                s = {};
              (s.storeId = WCParamJS.storeId),
                (s.action = "Sending_Cart"),
                (s.custId = WCParamJS.logonId),
                (s.orderId = r),
                e.source.postMessage(JSON.stringify(s), e.origin);
            } else t.action && "ADD_TO_EXTERNAL_CART_SUCCESS" === t.action ? cursor_clear() : t.action && "TERMINATE_ON_BEHALF_SESSION" === t.action ? "undefined" != typeof GlobalLoginShopOnBehalfJS && void 0 != GlobalLoginShopOnBehalfJS && null != GlobalLoginShopOnBehalfJS && GlobalLoginShopOnBehalfJS.restoreCSRSessionAndRedirect(t.redirectURL) : t.action && "SET_USER_IN_SESSION" === t.action && "undefined" != typeof registeredCustomersJS && void 0 != registeredCustomersJS && null != registeredCustomersJS && registeredCustomersJS.setUserInSession(t.userId, t.userName, t.redirectURL);
          } catch (a) {
            console.warn("Unexpected message: " + e.data);
          }
        });
    }),
    $(document).ready(function () {
      callCenterIntegrationJS = new CallCenterIntegrationJS();
    })),
  (shoppingActionsJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    userType: "",
    baseItemAddedToCart: !1,
    entitledItems: [],
    entitledItemJsonObject: null,
    selectedAttributesList: {},
    moreInfoUrl: "",
    isPopup: !1,
    displayPriceRange: !0,
    itemPriceJsonOject: [],
    allSwatchesArrayList: {},
    skuImageId: "",
    cookieKeyPrefix: "CompareItems_",
    cookieDelimiter: ";",
    maxNumberProductsAllowedToCompare: 4,
    minNumberProductsAllowedToCompare: 2,
    baseCatalogEntryId: 0,
    selectedProducts: {},
    productList: {},
    currencySymbol: "",
    compareReturnName: "",
    searchTerm: "",
    search01: "'",
    search02: '"',
    replaceStr01: /\\\'/g,
    replaceStr02: /\\\"/g,
    ampersandChar: /&/g,
    ampersandEntityName: "&amp;",
    productAddedList: {},
    setCompareReturnName: function (e) {
      this.compareReturnName = e;
    },
    setSearchTerm: function (e) {
      this.searchTerm = e;
    },
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.userType = s),
        (this.currencySymbol = a);
    },
    setEntitledItems: function (e) {
      this.entitledItems = e;
    },
    getCatalogEntryId: function (e) {
      var t = [],
        r = this.selectedAttributesList[e];
      for (attribute in r) t.push(attribute + "_|_" + r[attribute]);
      return this.resolveSKU(t);
    },
    getCatalogEntryIdforProduct: function (e) {
      var t = [];
      for (attribute in e) t.push(attribute + "_|_" + e[attribute]);
      return this.resolveSKU(t);
    },
    getEntitledItemJsonObject: function () {
      return this.entitledItemJsonObject;
    },
    resolveSKU: function (e) {
      console.debug("Resolving SKU >> " + e + ">>" + this.entitledItems);
      var t = "",
        r = e.length;
      if (1 == this.entitledItems.length)
        return this.entitledItems[0].catentry_id;
      for (x in this.entitledItems) {
        var t = this.entitledItems[x].catentry_id,
          s = this.entitledItems[x].Attributes,
          a = 0;
        for (index in s) a++;
        if (0 == r && 0 == a) return t;
        if (0 != a && r >= a) {
          var i = 0;
          for (attributeName in e) {
            var n = e[attributeName],
              o = n.replace(this.search02, this.search01);
            (n in s || o in s) && i++;
          }
          if (a == i)
            return (
              console.debug("CatEntryId:" + t + " for Attribute: " + e),
              this.disableBuyButtonforUnbuyable(x),
              t
            );
        }
      }
      return null;
    },
    setSelectedAttribute: function (e, t, r, s, a) {
      console.debug(e + " : " + t);
      var i = this.selectedAttributesList[r];
      null == i && (i = {}),
        (t = t.replace(this.replaceStr01, this.search01)),
        (t = t.replace(this.replaceStr02, this.search02)),
        (t = t.replace(this.ampersandChar, this.ampersandEntityName)),
        (i[e] = t),
        (this.moreInfoUrl = this.moreInfoUrl + "&" + e + "=" + t),
        (this.selectedAttributesList[r] = i),
        this.changeProdImage(r, e, t, s, a);
    },
    setSelectedAttributeOfProduct: function (
      productId,
      selectedAttributeName,
      selectedAttributeValue,
      isSingleSKU
    ) {
      var selectedAttributesForProduct = null;
      (selectedAttributesForProduct = this.selectedProducts[productId]
        ? this.selectedProducts[productId]
        : {}),
        null != selectedAttributeName &&
          "" != selectedAttributeName &&
          (selectedAttributesForProduct[selectedAttributeName] =
            selectedAttributeValue),
        (this.selectedProducts[productId] = selectedAttributesForProduct);
      var entitledItemJSON = eval(
        "(" + $("#entitledItem_" + productId).html() + ")"
      );
      this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryIdforProduct(
        selectedAttributesForProduct
      );
      if (null == catalogEntryId) catalogEntryId = 0;
      else if (
        (this.changePrice("entitledItem_" + productId, !1, !0, productId),
        "undefined" != typeof MerchandisingAssociationJS &&
          null != MerchandisingAssociationJS.baseItemParams &&
          "BundleBean" == MerchandisingAssociationJS.baseItemParams.type)
      )
        for (
          idx = 0;
          idx < MerchandisingAssociationJS.baseItemParams.components.length;
          idx++
        )
          productId ==
            MerchandisingAssociationJS.baseItemParams.components[idx]
              .productId &&
            (MerchandisingAssociationJS.baseItemParams.components[idx].id =
              catalogEntryId);
      var productDetails = null;
      this.productList[productId]
        ? (productDetails = this.productList[productId])
        : ((productDetails = {}),
          (this.productList[productId] = productDetails),
          (productDetails.baseItemId = productId)),
        (productDetails.id = catalogEntryId),
        productDetails.quantity &&
          wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails)),
        isSingleSKU ||
          (0 != catalogEntryId
            ? wcTopic.publish(
                "DefiningAttributes_Resolved_" + productId,
                catalogEntryId,
                productId
              )
            : wcTopic.publish(
                "DefiningAttributes_Changed_" + productId,
                catalogEntryId,
                productId
              ));
    },
    Add2ShopCartAjax: function (
      entitledItemId,
      quantity,
      isPopup,
      customParams
    ) {
      var dialog = $("#quick_cart_container").data("wc-WCDialog");
      if ((dialog && dialog.close(), browseOnly))
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ERROR_ADD2CART_BROWSE_ONLY")
        );
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId(entitledItemId);
      if (null != catalogEntryId) {
        var productId = entitledItemId.substring(
          entitledItemId.indexOf("_") + 1
        );
        this.AddItem2ShopCartAjax(
          catalogEntryId,
          quantity,
          customParams,
          productId
        ),
          (this.baseItemAddedToCart = !0);
      } else
        1 == isPopup
          ? ($("#second_level_category_popup").css("zIndex", "1"),
            MessageHelper.formErrorHandleClient(
              "addToCartLinkAjax",
              Utils.getLocalizationMessage("ERR_RESOLVING_SKU")
            ))
          : (MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage("ERR_RESOLVING_SKU")
            ),
            (this.baseItemAddedToCart = !1));
    },
    AddItem2ShopCartAjax: function (e, t, r, s) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ERROR_ADD2CART_BROWSE_ONLY")
        );
      var a = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        orderId: ".",
      };
      (a.inventoryValidation = "true"), (a.calculateOrder = "0");
      var i = "AddOrderItem";
      if (((this.productAddedList = {}), Array.isArray(e) && Array.isArray(t)))
        for (var n = 0; n < e.length; n++) {
          if (!isPositiveInteger(t[n]))
            return void MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage("QUANTITY_INPUT_ERROR")
            );
          (a["catEntryId_" + (n + 1)] = e[n]),
            (a["quantity_" + (n + 1)] = t[n]);
        }
      else {
        if (!isPositiveInteger(t))
          return void MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("QUANTITY_INPUT_ERROR")
          );
        (a.catEntryId = e), (a.quantity = t);
        var o = {};
        for (attr in this.selectedAttributesList["entitledItem_" + s])
          o[attr] = this.selectedAttributesList["entitledItem_" + s][attr];
        void 0 == s
          ? this.saveAddedProductInfo(t, e, e, o)
          : this.saveAddedProductInfo(t, s, e, o);
      }
      if (null != r && "undefined" != r) {
        for (n in r) a[n] = r[n];
        "dynamicKit" == r.catalogEntryType && (i = "AddPreConfigurationToCart");
      }
      var d = document.getElementsByName("contractSelectForm_contractId");
      if (null != d && "undefined" != d)
        for (n = 0; n < d.length; n++)
          if (d[n].checked) {
            a.contractId = d[n].value;
            break;
          }
      submitRequest() &&
        (cursor_wait(),
        wcService.invoke(i, a),
        (this.baseItemAddedToCart = !0),
        document.getElementById("headerShopCartLink") &&
        "none" != document.getElementById("headerShopCartLink").style.display
          ? $("#headerShopCart").focus()
          : $("#headerShopCart1").focus());
    },
    AddBundle2ShopCartAjax: function () {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ERROR_ADD2CART_BROWSE_ONLY")
        );
      var e = "AddOrderItem",
        t = {
          storeId: this.storeId,
          catalogId: this.catalogId,
          langId: this.langId,
          orderId: ".",
          inventoryValidation: "true",
          calculateOrder: "0",
        },
        r = 1;
      this.productAddedList = {};
      for (productId in this.productList) {
        var s = this.productList[productId],
          a = Utils.parseNumber(s.quantity);
        if (0 != a) {
          if (0 == s.id)
            return void MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage("ERR_RESOLVING_SKU")
            );
          if (isNaN(a) || 0 > a)
            return void MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage("QUANTITY_INPUT_ERROR")
            );
          (t["catEntryId_" + r] = s.id),
            (t["quantity_" + r++] = a),
            (this.baseItemAddedToCart = !0),
            this.saveAddedProductInfo(
              a,
              productId,
              s.id,
              this.selectedProducts[productId]
            );
        }
      }
      submitRequest() && (cursor_wait(), wcService.invoke(e, t));
    },
    resetProductAddedList: function () {
      shoppingActionsJS.productAddedList = {};
    },
    saveAddedProductInfo: function (e, t, r, s) {
      var a = "";
      $("#ProductInfoName_" + t).length
        ? (a = document.getElementById("ProductInfoName_" + t).value)
        : $("#ProductInfoName_" + r).length &&
          (a = document.getElementById("ProductInfoName_" + r).value);
      var i = "";
      $("#ProductInfoImage_" + t).length
        ? (i = document.getElementById("ProductInfoImage_" + t).value)
        : $("#ProductInfoImage_" + r).length &&
          (i = document.getElementById("ProductInfoImage_" + r).value);
      var n = "";
      $("#ProductInfoPrice_" + t).length
        ? (n = document.getElementById("ProductInfoPrice_" + t).value)
        : $("#ProductInfoPrice_" + r).length &&
          (n = document.getElementById("ProductInfoPrice_" + r).value);
      var o = [a, i, n, e, s];
      t != r ? (this.productAddedList[r] = o) : (this.productAddedList[t] = o),
        wcTopic.publish("ProductInfo_Added", this.productAddedList);
    },
    setSKUImageId: function (e) {
      this.skuImageId = e;
    },
    getImageForSKU: function (e, t) {
      var r = [],
        s = this.selectedAttributesList[e];
      for (attribute in s) r.push(attribute + "_|_" + s[attribute]);
      return this.resolveImageForSKU(r, t);
    },
    resolveImageForSKU: function (e, t) {
      console.debug("Resolving SKU >> " + e + ">>" + this.entitledItems);
      var r = "",
        s = e.length;
      for (x in this.entitledItems) {
        if (null != t) var r = this.entitledItems[x][t];
        else var r = this.entitledItems[x].ItemImage467;
        var a = this.entitledItems[x].Attributes,
          i = 0;
        for (index in a) i++;
        if (0 == s && 0 == i) return r;
        if (0 != i && s >= i) {
          var n = 0;
          for (attributeName in e) {
            var o = e[attributeName];
            o in a && n++;
          }
          if (i == n) {
            console.debug("ItemImage:" + r + " for Attribute: " + e),
              this.disableBuyButtonforUnbuyable(x);
            var d = [];
            return (
              d.push(r),
              d.push(this.entitledItems[x].ItemThumbnailImage),
              null != this.entitledItems[x].ItemAngleThumbnail &&
                void 0 != this.entitledItems[x].ItemAngleThumbnail &&
                (d.push(this.entitledItems[x].ItemAngleThumbnail),
                d.push(this.entitledItems[x].ItemAngleFullImage)),
              d
            );
          }
        }
      }
      return null;
    },
    disableBuyButtonforUnbuyable: function (e) {
      var t = this.entitledItems[e].buyable,
        r = document.getElementById(
          "listViewAdd2Cart_" + this.entitledItems[e].productId
        );
      null != t &&
        null != r &&
        ("false" == t
          ? (r.className += " add2CartButtonDisabled")
          : (r.className = r.className.replace(" add2CartButtonDisabled", "")));
    },
    changeViewImages: function (e, t) {
      var r = 0;
      for (x in e) {
        var s = r;
        r++,
          $("#WC_CachedProductOnlyDisplay_images_1_" + r).attr("src", e[x]),
          $("#WC_CachedProductOnlyDisplay_links_1_" + r).length &&
            $("#WC_CachedProductOnlyDisplay_links_1_" + r).attr(
              "href",
              "JavaScript:changeThumbNail('productAngleLi" +
                s +
                "','" +
                t[x] +
                "');"
            ),
          $("#productAngleLi" + s).length &&
            "selected" === $("#productAngleLi" + s).attr("className") &&
            changeThumbNail("productAngleLi" + s, t[x]);
      }
    },
    changeProdImage: function (
      entitledItemId,
      swatchAttrName,
      swatchAttrValue,
      skuImageId,
      imageField
    ) {
      $("#" + entitledItemId).length &&
        (entitledItemJSON = eval("(" + $("#" + entitledItemId).html() + ")")),
        this.setEntitledItems(entitledItemJSON);
      var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1),
        skuImage = null,
        imageArr = shoppingActionsJS.getImageForSKU(entitledItemId, imageField);
      if (
        (null != imageArr && (skuImage = imageArr[0]),
        void 0 != skuImageId && this.setSKUImageId(skuImageId),
        null != skuImage)
      ) {
        if ($("#" + this.skuImageId).length) {
          (document.getElementById(this.skuImageId).src = skuImage),
            $("#ProductInfoImage_" + productId).length &&
              (document.getElementById("ProductInfoImage_" + productId).value =
                skuImage);
          var itemAngleThumbnail = imageArr[2],
            itemAngleFullImage = imageArr[3];
          null != itemAngleThumbnail &&
            void 0 != itemAngleThumbnail &&
            shoppingActionsJS.changeViewImages(
              itemAngleThumbnail,
              itemAngleFullImage
            );
        }
      } else {
        var imageFound = !1;
        for (x in this.entitledItems) {
          var Attributes = this.entitledItems[x].Attributes;
          if (null != imageField)
            var itemImage = this.entitledItems[x][imageField];
          else var itemImage = this.entitledItems[x].ItemImage467;
          var itemAngleThumbnail = this.entitledItems[x].ItemAngleThumbnail,
            itemAngleFullImage = this.entitledItems[x].ItemAngleFullImage;
          for (y in Attributes) {
            var index = y.indexOf("_|_"),
              entitledSwatchName = y.substring(0, index),
              entitledSwatchValue = y.substring(index + 3);
            if (
              entitledSwatchName == swatchAttrName &&
              entitledSwatchValue == swatchAttrValue
            ) {
              $("#" + this.skuImageId).length &&
                ($("#" + this.skuImageId).attr("src", itemImage),
                null !=
                  document.getElementById("ProductInfoImage_" + productId) &&
                  (document.getElementById(
                    "ProductInfoImage_" + productId
                  ).value = itemImage)),
                null != itemAngleThumbnail &&
                  void 0 != itemAngleThumbnail &&
                  shoppingActionsJS.changeViewImages(
                    itemAngleThumbnail,
                    itemAngleFullImage
                  ),
                (imageFound = !0);
              break;
            }
          }
          if (imageFound) break;
        }
      }
    },
    updateSwatchListView: function () {
      for (
        var swatchArray = $("a[id^='swatch_array_']"), i = 0;
        i < swatchArray.length;
        i++
      ) {
        var swatchArrayElement = swatchArray[i];
        eval($(swatchArrayElement).attr("href"));
      }
      for (
        var swatchSkuImage = $("a[id^='swatch_setSkuImage_']"), i = 0;
        i < swatchSkuImage.length;
        i++
      ) {
        var swatchSkuImageElement = swatchSkuImage[i];
        eval($(swatchSkuImageElement).attr("href"));
      }
      for (
        var swatchDefault = $("a[id^='swatch_selectDefault_']"), i = 0;
        i < swatchDefault.length;
        i++
      ) {
        var swatchDefaultElement = swatchDefault[i];
        eval($(swatchDefaultElement).attr("href"));
      }
    },
    selectSwatch: function (e, t, r, s, a, i, n) {
      if (!$("#swatch_" + r + "_" + t).hasClass("color_swatch_disabled")) {
        var o = this.selectedAttributesList[r];
        for (attribute in o) {
          if (attribute == e && o[attribute] != t) {
            var d = document.getElementById("swatch_" + r + "_" + o[attribute]);
            (d.className = "color_swatch"),
              (d.src = d.src.replace("_disabled.png", "_enabled.png")),
              (document.getElementById(
                "swatch_link_" + r + "_" + o[attribute]
              ).title = d.alt);
          }
          null !=
            document.getElementById("swatch_link_" + r + "_" + o[attribute]) &&
            document
              .getElementById("swatch_link_" + r + "_" + o[attribute])
              .setAttribute("aria-checked", "false");
        }
        this.makeSwatchSelection(e, t, r, s, a, i, n);
      }
    },
    makeSwatchSelection: function (e, t, r, s, a, i, n) {
      this.setSelectedAttribute(e, t, r, i, n),
        (document.getElementById("swatch_" + r + "_" + t).className =
          "color_swatch_selected"),
        document
          .getElementById("swatch_link_" + r + "_" + t)
          .setAttribute("aria-checked", "true"),
        (document.getElementById(
          "swatch_selection_label_" + r + "_" + e
        ).className = "header color_swatch_label"),
        "none" ==
          document.getElementById("swatch_selection_" + r + "_" + e).style
            .display &&
          (document.getElementById(
            "swatch_selection_" + r + "_" + e
          ).style.display = "inline"),
        null != a
          ? (document.getElementById(
              "swatch_selection_" + r + "_" + e
            ).innerHTML = a)
          : (document.getElementById(
              "swatch_selection_" + r + "_" + e
            ).innerHTML = t),
        this.updateSwatchImages(e, r, s, n);
    },
    addToAllSwatchsArray: function (e, t, r, s, a) {
      var i = this.allSwatchesArrayList[s];
      if ((null == i && (i = []), !this.existInAllSwatchsArray(e, t, i))) {
        var n = [];
        (n[0] = e),
          (n[1] = t),
          (n[2] = r),
          (n[4] = document.getElementById(
            "swatch_link_" + s + "_" + t
          ).onclick),
          (n[5] = null),
          (n[6] = a),
          i.push(n),
          (this.allSwatchesArrayList[s] = i);
      }
    },
    existInAllSwatchsArray: function (e, t, r) {
      for (var s = 0; s < r.length; s++) {
        var a = r[s][0],
          i = r[s][1];
        if (a == e && i == t) return !0;
      }
      return !1;
    },
    makeDefaultSwatchSelection: function (entitledItemId, doNotDisable) {
      0 == this.entitledItems.length &&
        ($("#" + entitledItemId).length &&
          (entitledItemJSON = eval("(" + $("#" + entitledItemId).html() + ")")),
        this.setEntitledItems(entitledItemJSON));
      for (x in this.entitledItems) {
        var Attributes = this.entitledItems[x].Attributes;
        for (y in Attributes) {
          var index = y.indexOf("_|_"),
            swatchName = y.substring(0, index),
            swatchValue = y.substring(index + 3);
          this.makeSwatchSelection(
            swatchName,
            swatchValue,
            entitledItemId,
            doNotDisable,
            null,
            imageField
          );
        }
        break;
      }
    },
    updateSwatchImages: function (e, t, r, s) {
      for (
        var a = [],
          i = this.selectedAttributesList[t],
          n = i[e],
          o = this.allSwatchesArrayList[t],
          d = 0;
        d < o.length;
        d++
      ) {
        var l = o[d][0],
          c = o[d][1],
          u = o[d][2],
          m = (o[d][3], o[d][4]),
          g = o[d][6];
        if (l != r && l != e) {
          var p = [];
          (p[0] = l),
            (p[1] = c),
            (p[2] = u),
            (p[4] = m),
            (p[5] = !1),
            (p[6] = g),
            a.push(p);
        }
      }
      for (x in this.entitledItems) {
        var h = this.entitledItems[x].Attributes;
        for (y in h) {
          var I = y.indexOf("_|_"),
            f = y.substring(0, I),
            S = y.substring(I + 3);
          if (f == e && S == n)
            for (z in h) {
              var v = z.indexOf("_|_"),
                _ = z.substring(0, v),
                C = z.substring(v + 3);
              if (y != z)
                for (d in a) {
                  var A = a[d][0],
                    E = a[d][1];
                  _ == A && C == E && (a[d][5] = !0);
                }
            }
        }
      }
      var b = [];
      for (d in a) {
        var A = a[d][0],
          E = a[d][1],
          M = (a[d][2], a[d][3], a[d][4]),
          O = a[d][5];
        if (O) {
          if (
            "color_swatch_selected" !=
            document.getElementById("swatch_" + t + "_" + E).className
          ) {
            var R = document.getElementById("swatch_" + t + "_" + E);
            (R.className = "color_swatch"),
              (R.src = R.src.replace("_disabled.png", "_enabled.png")),
              (document.getElementById("swatch_link_" + t + "_" + E).title =
                R.alt);
          }
          document
            .getElementById("swatch_link_" + t + "_" + E)
            .setAttribute("aria-disabled", "false"),
            (document.getElementById("swatch_link_" + t + "_" + E).onclick = M);
        } else if (A != r) {
          var R = document.getElementById("swatch_" + t + "_" + E),
            P = document.getElementById("swatch_link_" + t + "_" + E);
          (R.className = "color_swatch_disabled"),
            (P.onclick = null),
            (R.src = R.src.replace("_enabled.png", "_disabled.png"));
          Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [R.alt]);
          document
            .getElementById("swatch_link_" + t + "_" + E)
            .setAttribute("aria-disabled", "true"),
            i[A] == E && b.push(a[d]);
        }
      }
      for (d in b) {
        var T = b[d][0],
          D = b[d][1];
        for (d in a) {
          var A = a[d][0],
            E = a[d][1],
            w = a[d][6],
            O = a[d][5];
          if (A == T && E != D && O) {
            this.makeSwatchSelection(A, E, t, r, w, s);
            break;
          }
        }
      }
    },
    changePrice: function (
      entitledItemId,
      isPopup,
      displayPriceRange,
      productId
    ) {
      (this.displayPriceRange = displayPriceRange), (this.isPopup = isPopup);
      var entitledItemJSON;
      entitledItemJSON =
        $("#" + entitledItemId).length && !this.isPopup
          ? eval("(" + $("#" + entitledItemId).html() + ")")
          : this.getEntitledItemJsonObject();
      var catalogEntryId = null;
      if (
        (this.setEntitledItems(entitledItemJSON),
        this.selectedProducts[productId])
      )
        var catalogEntryId = this.getCatalogEntryIdforProduct(
          this.selectedProducts[productId]
        );
      else var catalogEntryId = this.getCatalogEntryId(entitledItemId);
      if (null != catalogEntryId)
        if (
          null != this.itemPriceJsonOject[catalogEntryId] &&
          "undefined" != this.itemPriceJsonOject[catalogEntryId]
        )
          this.displayPrice(
            this.itemPriceJsonOject[catalogEntryId].catalogEntry,
            productId
          ),
            console.debug(
              "ShoppingActions.changePrice: using stored json object."
            );
        else {
          var parameters = {
            storeId: this.storeId,
            langId: this.langId,
            catalogId: this.catalogId,
            catalogEntryId: catalogEntryId,
            productId: productId,
          };
          wcService.declare({
            id: "getCatalogEntryDetailsSA",
            actionId: "getCatalogEntryDetailsSA",
            url:
              getAbsoluteURL() +
              appendWcCommonRequestParameters("GetCatalogEntryDetailsByIDView"),
            formId: "",
            successHandler: function (e, t) {
              shoppingActionsJS.displayPriceServiceResponse(e, t);
            },
            failureHandler: function (e, t) {
              console.debug(
                "ShoppingActions.changePrice: Unexpected error occurred during an xhrPost request."
              );
            },
          }),
            wcService.invoke("getCatalogEntryDetailsSA", parameters);
        }
      else
        console.debug(
          "ShoppingActions.changePrice: all attributes are not selected."
        );
    },
    displayPriceServiceResponse: function (e, t) {
      var r = t.productId;
      (shoppingActionsJS.itemPriceJsonOject[
        e.catalogEntry.catalogEntryIdentifier.uniqueID
      ] = e),
        shoppingActionsJS.displayPrice(e.catalogEntry, r);
    },
    displayPrice: function (e, t) {
      var r,
        s = shoppingActionsJS.isPopup;
      if (
        (1 == s &&
          ($("#productPrice").html(e.offerPrice),
          (document.getElementById("productName").innerHTML =
            e.description[0].name),
          (document.getElementById("productSKUValue").innerHTML =
            e.catalogEntryIdentifier.externalIdentifier.partNumber)),
        0 == s)
      ) {
        var a = "",
          i = Utils.parseNumber(e.listPrice),
          n = Utils.parseNumber(e.offerPrice);
        if (
          (this.setPriceInProductList(t, n),
          (a =
            !e.listPriced || n >= i
              ? "<span id='offerPrice_" +
                e.catalogEntryIdentifier.uniqueID +
                "' class='price'>" +
                e.offerPrice +
                "</span>"
              : "<span id='listPrice_" +
                e.catalogEntryIdentifier.uniqueID +
                "' class='old_price'>" +
                e.listPrice +
                "</span><span id='offerPrice_" +
                e.catalogEntryIdentifier.uniqueID +
                "' class='price'>" +
                e.offerPrice +
                "</span>"),
          (document.getElementById("price_display_" + t).innerHTML =
            a +
            "<input type='hidden' id='ProductInfoPrice_" +
            e.catalogEntryIdentifier.uniqueID +
            "' value='" +
            e.offerPrice +
            "'/>"),
          (a = ""),
          1 == shoppingActionsJS.displayPriceRange)
        )
          for (var o in e.priceRange)
            e.priceRange[o].endingNumberOfUnits ==
            e.priceRange[o].startingNumberOfUnits
              ? ((r = Utils.getLocalizationMessage("PQ_PRICE_X", {
                  0: e.priceRange[o].startingNumberOfUnits,
                })),
                (a = a + "<p>" + r))
              : "null" != e.priceRange[o].endingNumberOfUnits
              ? ((r = Utils.getLocalizationMessage("PQ_PRICE_X_TO_Y", {
                  0: e.priceRange[o].startingNumberOfUnits,
                  1: e.priceRange[o].endingNumberOfUnits,
                })),
                (a = a + "<p>" + r))
              : ((r = Utils.getLocalizationMessage("PQ_PRICE_X_OR_MORE", {
                  0: e.priceRange[o].startingNumberOfUnits,
                })),
                (a = a + "<p>" + r)),
              (a =
                a +
                " <span class='price'>" +
                e.priceRange[o].localizedPrice +
                "</span></p>");
        var d = document.getElementById("productLevelPriceRange_" + t),
          l = document.getElementById("itemLevelPriceRange_" + t);
        null != d && null == l
          ? (d.style.display = "")
          : "" != a && null != l
          ? ((a = Utils.getLocalizationMessage("PQ_PURCHASE") + a),
            (l.innerHTML = a),
            (l.style.display = ""),
            null != d && (d.style.display = "none"))
          : "" == a &&
            (null != l && (l.style.display = "none"),
            null != d && (d.style.display = ""));
        var c = $("#product_name_" + t + " > a");
        1 == c.length
          ? $(c[0]).html(e.description[0].name)
          : $("#product_name_" + t) &&
            $("#product_name_" + t).html(e.description[0].name),
          $("#widget_product_info_viewer > div[id^='PageHeading_']").length &&
            $("#widget_product_info_viewer > div[id^='PageHeading_']").each(
              function (t, r) {
                null != r.childNodes &&
                  3 == r.childNodes.length &&
                  (r.childNodes[1].innerHTML = e.description[0].name);
              }
            ),
          null != document.getElementById("ProductInfoName_" + t) &&
            (document.getElementById("ProductInfoName_" + t).value =
              e.description[0].name),
          document.getElementById("product_shortdescription_" + t) &&
            (document.getElementById(
              "product_shortdescription_" + t
            ).innerHTML = e.description[0].shortDescription),
          document.getElementById("product_SKU_" + t) &&
            (document.getElementById("product_SKU_" + t).innerHTML =
              Utils.getLocalizationMessage("SKU") +
              " " +
              e.catalogEntryIdentifier.externalIdentifier.partNumber);
      }
    },
    showWCDialogPopup: function (e) {
      var t = $("#" + e).data("wc-WCDialog");
      t
        ? (t.open(), $("#" + e).css("display", "block"))
        : console.debug(e + " does not exist");
    },
    notifyAttributeChange: function (e) {
      this.baseCatalogEntryId = e;
      this.selectedAttributesList["entitledItem_" + e];
      wcTopic.publish("DefiningAttributes_Resolved_" + e, e, -1);
    },
    notifyQuantityChange: function (e) {
      wcTopic.publish("Quantity_Changed", e);
    },
    initCompare: function (e) {
      if ("compare" == e || "catalogEntryList" == e) this.checkForCompare();
      else {
        var t = this.cookieKeyPrefix + this.storeId,
          r = "";
        setCookie(t, r, {
          path: "/",
          domain: cookieDomain,
        });
      }
    },
    changeCompareBox: function (e, t) {
      (box = document.getElementById(e)),
        (box.checked = !box.checked),
        this.addOrRemoveFromCompare(t, box.checked);
    },
    addOrRemoveFromCompare: function (e, t) {
      t ? this.addToCompare(e) : this.removeFromCompare(e);
    },
    addToCompare: function (e) {
      var t = this.cookieKeyPrefix + this.storeId,
        r = getCookie(t);
      if (null != r && (-1 != r.indexOf(e) || null == e))
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("COMPARE_ITEM_EXISTS")
        );
      var s = 0;
      if (
        (null != r && "" !== r && (s = r.split(this.cookieDelimiter).length),
        s < parseInt(this.maxNumberProductsAllowedToCompare))
      ) {
        var a = "";
        (a = null == r || "" === r ? e : r + this.cookieDelimiter + e),
          setCookie(t, a, {
            path: "/",
            domain: cookieDomain,
          }),
          shoppingActionsJS.checkForCompare();
      } else
        this.showWCDialogPopup("widget_product_comparison_popup"),
          (document.getElementById("comparebox_" + e).checked = !1),
          console.debug("You can only compare up to 4 products");
    },
    removeFromCompare: function (e) {
      var t = this.cookieKeyPrefix + this.storeId,
        r = getCookie(t),
        s = 0;
      if (null != r) {
        if ("" == r.trim())
          setCookie(t, null, {
            expires: -1,
          });
        else {
          var a = r.split(this.cookieDelimiter),
            i = "";
          for (index in a)
            a[index] != e &&
              (i = "" === i ? a[index] : i + this.cookieDelimiter + a[index]);
          setCookie(t, i, {
            path: "/",
            domain: cookieDomain,
          }),
            (s = i.split(this.cookieDelimiter).length);
        }
        shoppingActionsJS.checkForCompare();
      }
    },
    compareProducts: function (e, t) {
      var r = appendWcCommonRequestParameters(
        "CompareProductsDisplayView?storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&langId=" +
          this.langId +
          "&compareReturnName=" +
          encodeURIComponent(this.compareReturnName) +
          "&searchTerm=" +
          this.searchTerm
      );
      "" != e.top_category && (r = r + "&top_category=" + e.top_category),
        "" != e.parent_category_rn &&
          (r = r + "&parent_category_rn=" + e.parent_category_rn),
        "" != e.categoryId && (r = r + "&categoryId=" + e.categoryId),
        void 0 != t && "" != t && (r = r + "&manufacturer=" + t);
      var s = this.cookieKeyPrefix + this.storeId,
        a = getCookie(s);
      null != a && "" != a.trim() && (r = r + "&catentryId=" + a);
      var i = appendWcCommonRequestParameters(location.href);
      -1 === i.indexOf("?")
        ? (i += "?fromPage=compare")
        : -1 === i.indexOf("fromPage=compare") && (i += "&fromPage=compare"),
        (r = r + "&returnUrl=" + encodeURIComponent(i)),
        (location.href = getAbsoluteURL() + r);
    },
    setProductQuantity: function (e, t, r, s) {
      var a = null;
      this.productList[t]
        ? (a = this.productList[t])
        : ((a = {}),
          (this.productList[t] = a),
          (a.baseItemId = t),
          "item" == e ? (a.id = t) : (a.id = 0)),
        (a.quantity = r),
        wcTopic.publish("Quantity_Changed", JSON.stringify(a)),
        (a.price = Utils.parseNumber(s));
    },
    quantityChanged: function (e, t) {
      if (this.productList[e]) {
        var r = this.productList[e];
        if (
          ((r.quantity = t.trim()),
          wcTopic.publish("Quantity_Changed", JSON.stringify(r)),
          null != MerchandisingAssociationJS &&
            null != MerchandisingAssociationJS.baseItemParams &&
            "BundleBean" == MerchandisingAssociationJS.baseItemParams.type)
        )
          for (
            idx = 0;
            idx < MerchandisingAssociationJS.baseItemParams.components.length;
            idx++
          )
            (e ==
              MerchandisingAssociationJS.baseItemParams.components[idx]
                .productId ||
              e ==
                MerchandisingAssociationJS.baseItemParams.components[idx].id) &&
              (MerchandisingAssociationJS.baseItemParams.components[
                idx
              ].quantity = r.quantity);
      }
    },
    setPriceInProductList: function (e, t) {
      var r = this.productList[e];
      r && (r.price = t);
    },
    selectBundleItemSwatch: function (e, t, r, s) {
      if (
        !$("#swatch_" + e + "_" + t + "_" + r).hasClass("color_swatch_disabled")
      ) {
        if ($("#entitledItem_" + e).length) {
          var a,
            i = t + "_" + r;
          a = JSON.stringify($("#entitledItem_" + e).html());
          var n = [];
          for (idx in a) {
            var o = !1,
              d = a[idx];
            for (attribute in d.Attributes)
              if (i == attribute) {
                o = !0;
                break;
              }
            if (o)
              for (attribute in d.Attributes) {
                var l = attribute.substring(0, attribute.lastIndexOf("_|_"));
                l != s && l != t && n.push(attribute);
              }
          }
          var c = [],
            u = [];
          for (idx in a) {
            var d = a[idx];
            for (attribute in d.Attributes) {
              var l = attribute.substring(0, attribute.lastIndexOf("_|_"));
              if (l != s && l != t) {
                var m = "swatch_" + e + "_" + attribute,
                  g = m.replace("swatch_", "swatch_link_");
                if (n.indexOf(attribute) > -1)
                  $("#" + m).hasClass("color_swatch_selected") ||
                    ((document.getElementById(m).className = "color_swatch"),
                    (document.getElementById(m).src = document
                      .getElementById(m)
                      .src.replace("_disabled.png", "_enabled.png")),
                    (document.getElementById(g).title =
                      document.getElementById(m).alt),
                    document
                      .getElementById(g)
                      .setAttribute("aria-disabled", "false"));
                else if (-1 === c.indexOf(attribute)) {
                  c.push(attribute),
                    $("#" + m).hasClass("color_swatch_selected") && u.push(m),
                    (document.getElementById(m).className =
                      "color_swatch_disabled"),
                    (document.getElementById(m).src = document
                      .getElementById(m)
                      .src.replace("_enabled.png", "_disabled.png"));
                  var p = document.getElementById(m).alt;
                  Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [p]);
                  $("#" + g).attr("aria-disabled", "true");
                }
              }
              null !=
                document.getElementById("swatch_link_" + e + "_" + attribute) &&
                document
                  .getElementById("swatch_link_" + e + "_" + attribute)
                  .setAttribute("aria-checked", "false");
            }
          }
          for (idx in u) {
            var h = u[idx],
              I = h.substring(0, h.lastIndexOf("_|_")),
              y = !1;
            $("[id^='" + I + "']").each(function (e, t, r) {
              if (!y && $(t).hasClass("color_swatch")) {
                var a = t.id.split("_");
                shoppingActionsJS.selectBundleItemSwatch(a[1], a[2], a[3], s),
                  shoppingActionsJS.setSelectedAttributeOfProduct(
                    a[1],
                    a[2],
                    a[3],
                    !1
                  ),
                  (y = !0);
              }
            });
          }
        }
        "none" == $("#swatch_selection_" + e + "_" + t).css("display") &&
          $("#swatch_selection_" + e + "_" + t).css("display", "inline"),
          $("#swatch_selection_" + e + "_" + t).html(r);
        var f = "swatch_" + e + "_" + t + "_",
          S = "swatch_link_" + e + "_" + t + "_";
        $("img[id^='" + f + "']").each(function (e, t, r) {
          $(t).hasClass("color_swatch_disabled")
            ? $(t).removeClass("color_swatch")
            : $(t).addClass("color_swatch"),
            $(t).removeClass("color_swatch_selected");
        }),
          $("#" + f + r).attr("className", "color_swatch_selected"),
          document.getElementById(S + r).setAttribute("aria-checked", "true"),
          this.setSelectedAttributeOfProduct(e, t, r, !1),
          this.changeBundleItemImage(e, t, r, "productThumbNailImage_" + e);
      }
    },
    changeBundleItemImage: function (
      catalogEntryId,
      swatchAttrName,
      swatchAttrValue,
      skuImageId
    ) {
      var entitledItemId = "entitledItem_" + catalogEntryId;
      $("#" + entitledItemId).length &&
        (entitledItemJSON = eval("(" + $("#" + entitledItemId).html() + ")")),
        this.setEntitledItems(entitledItemJSON);
      var skuImage = null,
        imageArr = shoppingActionsJS.getImageForBundleItem(catalogEntryId);
      if (
        (null != imageArr && (skuImage = imageArr[1]),
        void 0 != skuImageId && this.setSKUImageId(skuImageId),
        null != skuImage)
      )
        null != $("#" + this.skuImageId) &&
          ((document.getElementById(this.skuImageId).src = skuImage),
          null !=
            document.getElementById("ProductInfoImage_" + catalogEntryId) &&
            (document.getElementById(
              "ProductInfoImage_" + catalogEntryId
            ).value = skuImage));
      else {
        var imageFound = !1;
        for (x in this.entitledItems) {
          var Attributes = this.entitledItems[x].Attributes,
            itemImage = this.entitledItems[x].ItemThumbnailImage;
          for (y in Attributes) {
            var index = y.indexOf("_|_"),
              entitledSwatchName = y.substring(0, index),
              entitledSwatchValue = y.substring(index + 3);
            if (
              entitledSwatchName == swatchAttrName &&
              entitledSwatchValue == swatchAttrValue
            ) {
              (document.getElementById(this.skuImageId).src = itemImage),
                null !=
                  document.getElementById(
                    "ProductInfoImage_" + catalogEntryId
                  ) &&
                  (document.getElementById(
                    "ProductInfoImage_" + catalogEntryId
                  ).value = itemImage),
                (imageFound = !0);
              break;
            }
          }
          if (imageFound) break;
        }
      }
    },
    getImageForBundleItem: function (e) {
      var t = [],
        r = this.selectedProducts[e];
      for (attribute in r) t.push(attribute + "_|_" + r[attribute]);
      return this.resolveImageForSKU(t);
    },
    checkForCompare: function () {
      var e = getCookie(
        shoppingActionsJS.cookieKeyPrefix + shoppingActionsJS.storeId
      );
      e = e ? e.split(shoppingActionsJS.cookieDelimiter) : [];
      var t = $(".compareCheckboxLabels > label");
      $(".compare_target").each(function (r, s) {
        var a = $('input[type="checkbox"]', s)[0];
        a.checked = -1 !== e.indexOf(a.value);
        var i = a.checked ? (e.length > 1 ? 2 : 1) : 0;
        s.setAttribute("data-state", i.toString());
        var n = $('label[for="' + a.id + '"]', s)[0];
        $(n).html($(t[i]).html());
      });
    },
    replaceItemAjaxHelper: function (e, t, r, s, a, i) {
      var n = {
        storeId: WCParamJS.storeId,
        catalogId: WCParamJS.catalogId,
        langId: WCParamJS.langId,
        orderItemId: r,
        orderId: ".",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (n.calculationUsage = "-1,-2,-5,-6,-7")
        : (n.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      var o = {
        storeId: WCParamJS.storeId,
        catalogId: WCParamJS.catalogId,
        langId: WCParamJS.langId,
        catEntryId: e,
        quantity: t,
        orderId: ".",
        calculateOrder: "1",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (o.calculationUsage = "-1,-2,-5,-6,-7")
        : (o.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      var d = {
        storeId: WCParamJS.storeId,
        catalogId: WCParamJS.catalogId,
        langId: WCParamJS.langId,
        orderId: ".",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (d.calculationUsage = "-1,-2,-5,-6,-7")
        : (d.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      var l = !1,
        c = !0;
      null != s && "" !== s && (d.addressId = s),
        null != a && "" !== a && (d.shipModeId = a),
        null != i && "" !== i && ((d.physicalStoreId = i), (c = !1)),
        null == d.shipModeId ||
          (null == d.addressId && null == d.physicalStoreId) ||
          (l = !0),
        c &&
          ((d.allocate = "***"),
          (d.backorder = "***"),
          (d.remerge = "***"),
          (d.check = "*n")),
        wcService.declare({
          id: "AjaxReplaceItem",
          actionId: "AjaxReplaceItem",
          url: "AjaxRESTOrderItemDelete",
          formId: "",
          successHandler: function (e) {
            l
              ? wcService.invoke("AjaxAddOrderItemTemp", o)
              : wcService.invoke("AjaxAddOrderItem", o);
          },
          failureHandler: function (e) {
            e.errorMessage
              ? MessageHelper.displayErrorMessage(e.errorMessage)
              : e.errorMessageKey &&
                MessageHelper.displayErrorMessage(e.errorMessageKey),
              cursor_clear();
          },
        }),
        wcService.declare({
          id: "AjaxAddOrderItemTemp",
          actionId: "AjaxAddOrderItemTemp",
          url: "AjaxRESTOrderItemAdd",
          formId: "",
          successHandler: function (e) {
            (d.orderItemId =
              null != e.orderItem && null != e.orderItem[0].orderItemId
                ? e.orderItem[0].orderItemId
                : e.orderItemId),
              MessageHelper.displayStatusMessage(
                MessageHelper.messages.SHOPCART_ADDED
              ),
              wcService.invoke("OrderItemAddressShipMethodUpdate", d);
          },
          failureHandler: function (e) {
            MessageHelper.displayErrorMessage(e.errorMessageKey);
          },
        }),
        submitRequest() &&
          (cursor_wait(), wcService.invoke("AjaxReplaceItem", n));
    },
    customizeDynamicKit: function (e, t, r) {
      var s = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        catEntryId: e,
        quantity: t,
      };
      if (!isPositiveInteger(t))
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("QUANTITY_INPUT_ERROR")
        );
      var a = document.getElementsByName("contractSelectForm_contractId");
      if (null != a && "undefined" != a)
        for (n = 0; n < a.length; n++)
          if (a[n].checked) {
            s.contractId = a[n].value;
            break;
          }
      if (null != r && "undefined" != r) for (n in r) s[n] = r[n];
      if (submitRequest()) {
        cursor_wait();
        var i = "ConfigureView",
          n = 0;
        for (param in s) i += (0 == n++ ? "?" : "&") + param + "=" + s[param];
        document.location.href =
          getAbsoluteURL() + appendWcCommonRequestParameters(i);
      }
    },
  }),
  wcTopic.subscribe(
    "ProductInfo_Reset",
    shoppingActionsJS.resetProductAddedList
  ),
  $(document).ready(function () {
    var e = Utils.get_IE_version();
    9 > e &&
      $(document).on(
        "click",
        '.compare_target > input[type="checkbox"]:click',
        function (e) {
          this.blur(), this.focus();
        }
      );
  }),
  (shoppingActionsServicesDeclarationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
  }),
  wcService.declare({
    id: "AddOrderItem",
    actionId: "AddOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemAdd",
    formId: "",
    successHandler: function (e) {
      if (
        (MessageHelper.hideAndClearMessage(), cursor_clear(), shoppingActionsJS)
      ) {
        var t = $('div[id^="attrValue_"]');
        if (null != $(".definingAttributes")[0])
          var t = $(".definingAttributes");
        else if (null != $(".product_sizes")[0]) var t = $(".product_sizes");
        else if (null != $(".product_info")[0]) var t = $(".product_info");
        for (var r = new Array(), s = 0; s < t.length; s++)
          for (
            var a = t[s].querySelectorAll(".dijitSelect"), i = 0;
            i < a.length;
            i++
          )
            r = r.concat(a[i]);
        for (var n = new Array(), s = 0; s < r.length; s++)
          n[s] = dijit.registry.byNode(r[s]);
        for (var o = !0, s = 0; s < n.length; s++)
          n[s].options.length > 2 && (o = !1);
        if (!o) {
          (shoppingActionsJS.selectedAttributes = new Object()),
            wcTopic.publish(
              "DefiningAttributes_Resolved_" +
                shoppingActionsJS.baseCatalogEntryId,
              shoppingActionsJS.baseCatalogEntryId,
              -1
            );
          for (var s = 0; s < n.length; s++) null != n[s] && (n[s].value = "");
        }
      }
      null != typeof ShipmodeSelectionExtJS &&
        "undefined" != typeof ShipmodeSelectionExtJS &&
        ShipmodeSelectionExtJS.setOrderItemId(
          null != e.orderItem && null != e.orderItem[0].orderItemId
            ? e.orderItem[0].orderItemId
            : e.orderItemId
        ),
        wcTopic.publish("ProductAddedToCart");
    },
    failureHandler: function (e) {
      if (e.errorMessage)
        if ("_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey)
          MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER")
          );
        else if ("_ERR_RETRIEVE_PRICE" == e.errorMessageKey) {
          var t = Utils.getLocalizationMessage("GENERICERR_MAINTEXT", {
            0: Utils.getLocalizationMessage("GENERICERR_CONTACT_US"),
          });
          MessageHelper.displayErrorMessage(t);
        } else if ("_API_CANT_RESOLVE_FFMCENTER" == e.errorMessageKey) {
          MessageHelper.displayErrorMessage(API_CANT_RESOLVE_FFMCENTER_MSG);
        } else MessageHelper.displayErrorMessage(e.errorMessage);
      else
        e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
      e.errorCode && wcTopic.publish("OrderError", e), cursor_clear();
    },
  }),
  wcService.declare({
    id: "AddPreConfigurationToCart",
    actionId: "AddOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
    formId: "",
    successHandler: function (e) {
      if (
        (MessageHelper.hideAndClearMessage(), cursor_clear(), shoppingActionsJS)
      ) {
        for (
          var t = document.getElementsByName("attrValue"), r = !0, s = 0;
          s < t.length;
          s++
        )
          t[s].options.length > 1 && (r = !1);
        if (!r) {
          shoppingActionsJS.selectedAttributes = new Object();
          for (var s = 0; s < t.length; s++)
            null != t[s] && ((t[s].value = ""), t[s].onchange());
        }
      }
      null != typeof ShipmodeSelectionExtJS &&
        "undefined" != typeof ShipmodeSelectionExtJS &&
        ShipmodeSelectionExtJS.setOrderItemId(e.orderItem[0].orderItemId);
    },
    failureHandler: function (e) {
      if (e.errorMessage)
        if ("_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey)
          MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER")
          );
        else if ("_ERR_RETRIEVE_PRICE" == e.errorMessageKey) {
          var t = Utils.getLocalizationMessage("GENERICERR_MAINTEXT", {
            0: Utils.getLocalizationMessage("GENERICERR_CONTACT_US"),
          });
          MessageHelper.displayErrorMessage(t);
        } else if ("_API_CANT_RESOLVE_FFMCENTER" == e.errorMessageKey) {
          MessageHelper.displayErrorMessage(API_CANT_RESOLVE_FFMCENTER_MSG);
        } else MessageHelper.displayErrorMessage(e.errorMessage);
      else
        e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
      cursor_clear();
    },
  }),
  (CommonContextsJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    setContextProperty: function (e, t, r) {
      wcRenderContext.getRenderContextProperties(e)[t] = r;
    },
  }),
  wcRenderContext.declare("multipleShipmentDetailsContext", [], {
    shipmentDetailsArea: "update",
  }),
  wcRenderContext.declare("singleShipmentShipChargeContext", [], null),
  wcRenderContext.declare("multipleShipmentShipChargeContext", [], null),
  wcRenderContext.declare("traditionalShipmentDetailsContext", [], {
    shipmentDetailsArea: "update",
  }),
  wcRenderContext.declare("currentOrder_Context", [], null),
  wcRenderContext.declare("editShippingAddressContext", [], {
    shippingAddress: "0",
    addressType: "ShippingAndBilling",
  }),
  wcRenderContext.declare("shippingAddressContext", [], {
    shippingAddress: "0",
  }),
  wcRenderContext.declare("billingAddressDropDownBoxContext", [], {
    billingAddress1: "0",
    billingAddress2: "0",
    billingAddress3: "0",
    billingURL1: "",
    billingURL2: "",
    billingURL3: "",
    areaNumber: "0",
    payment1: "",
    payment2: "",
    payment3: "",
    paymentTCId1: "",
    paymentTCId2: "",
    paymentTCId3: "",
  }),
  wcRenderContext.declare("paymentContext", [], {
    payment1: "empty",
    payment2: "empty",
    payment3: "empty",
    currentAreaNumber: "1",
    billingMode1: "none",
    billingMode2: "none",
    billingMode3: "none",
    currentTotal: "0",
  }),
  wcRenderContext.declare("contextForMainAndAddressDiv", [], {
    showArea: "0",
    hideArea: "0",
  }),
  wcRenderContext.declare("shippingAddressDropDownBoxContext", [], {}),
  wcRenderContext.declare("CategoryDisplay_Context", [], {
    pageView: "",
    beginIndex: "",
  }),
  wcRenderContext.declare("SubCategoryDisplay_Context", [], null),
  wcRenderContext.declare("ShopCartPaginationDisplay_Context", [], {}),
  wcRenderContext.declare("PendingOrderPaginationDisplay_Context", [], {}),
  wcRenderContext.declare("PendingOrderDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("OrderItemPaginationDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("OrderDetailPaginationDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("MSOrderItemPaginationDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("CouponDisplay_Context", [], null),
  wcRenderContext.declare("PromotionFreeGifts_Context", [], {}),
  wcRenderContext.declare("ListOrdersDisplay_Context", [], {
    startNumber: "0",
  }),
  wcRenderContext.declare("ScheduledOrdersStatusDisplay_Context", [], {
    beginIndex: "0",
    selectedTab: "Scheduled",
  }),
  wcRenderContext.declare("ProcessedOrdersStatusDisplay_Context", [], {
    beginIndex: "0",
    selectedTab: "PreviouslyProcessed",
  }),
  wcRenderContext.declare("WaitingForApprovalOrdersStatusDisplay_Context", [], {
    beginIndex: "0",
    selectedTab: "WaitingForApproval",
  }),
  wcRenderContext.declare("BrowsingHistoryContext", [], {
    status: "init",
  }),
  wcRenderContext.declare("BrowsingHistoryDisplay_Context", [], {
    currentPage: "0",
    pageView: "",
  }),
  wcRenderContext.declare("CategorySubscriptionContext", [], null),
  wcRenderContext.declare("RecurringOrderDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("SubscriptionDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("RecentRecurringOrderDisplay_Context", [], {
    beginIndex: "0",
    isMyAccountMainPage: "true",
  }),
  wcRenderContext.declare("RecentSubscriptionDisplay_Context", [], {
    beginIndex: "0",
    isMyAccountMainPage: "true",
  }),
  wcRenderContext.declare("RecurringOrderChildOrdersDisplay_Context", [], {
    beginIndex: "0",
    orderId: "",
  }),
  wcRenderContext.declare("SubscriptionChildOrdersDisplay_Context", [], {
    beginIndex: "0",
    orderItemId: "",
    subscriptionName: "",
  }),
  wcRenderContext.declare("QuickInfoContext", ["quickInfoRefreshArea"], {}),
  wcRenderContext.declare("DiscountDetailsContext", [], null),
  wcRenderContext.declare("QuickInfoDiscountDetailsContext", [], {}),
  wcRenderContext.declare("DoubleContentAreaESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("ScrollableESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("TopCategoriesESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("CategoryFeaturedProductsESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("HomeHeroESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("HomeLeftESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("HomeRightTopESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("HomeRightBottomESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("TallDoubleContentAreaESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("TopCategoryHeroESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("TopCategoryTallDoubleESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("AttachmentPagination_Context", [], {
    beginIndex: "0",
  }),
  (CommonControllersDeclarationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    setRefreshURL: function (e, t) {
      $("#" + e).attr("refreshurl", t);
    },
    declareAccountCouponRefreshArea: function () {
      var e = $("#CouponDisplay_Widget");
      wcTopic.subscribe(
        ["AjaxCouponsAddRemove", "AjaxWalletItemProcessServiceDelete"],
        function () {
          e.refreshWidget("refresh");
        }
      ),
        e.refreshWidget();
    },
    declareShopCartDisplayRefreshArea: function () {
      var e = $("#ShopCartDisplay"),
        t = wcRenderContext.getRenderContextProperties(
          "ShopCartPaginationDisplay_Context"
        );
      wcTopic.subscribe(order_updated, function () {
        e.refreshWidget("refresh", t), submitRequest(), cursor_wait();
      });
      var r = function () {
        resetRequest(),
          null != typeof savedOrdersJS &&
            "undefined" != typeof savedOrdersJS &&
            savedOrdersJS.isCurrentOrderPage(!0),
          $("#discountDetailsSection").css("display", "block"),
          $("#appliedPromotionCodes").css("display", "block");
        var e = t.orderId;
        $("#currentOrderId").length &&
          (e = document.getElementById("currentOrderId").value),
          ShipmodeSelectionExtJS.displaySavedShipmentTypeForOrder(e),
          $("#OrderFirstItemId").length &&
            (ShipmodeSelectionExtJS.orderItemId =
              document.getElementById("OrderFirstItemId").value),
          cursor_clear(),
          "function" == typeof showApplePayButtons && showApplePayButtons();
      };
      e.refreshWidget({
        postRefreshHandler: r,
      });
    },
    declareShopCartPagingDisplayRefreshArea: function () {
      var e = $("#ShopCartPagingDisplay");
      wcRenderContext.addRefreshAreaId(
        "ShopCartPaginationDisplay_Context",
        "ShopCartPagingDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
          "ShopCartPaginationDisplay_Context"
        ),
        r = function () {
          wcRenderContext.testForChangedRC(
            "ShopCartPaginationDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
          var e = t.orderId;
          document.getElementById("currentOrderId") &&
            (e = document.getElementById("currentOrderId").value),
            ShipmodeSelectionExtJS.displaySavedShipmentTypeForOrder(e),
            $('div[id^="shoppingListScript_"]').each(function (e, t) {
              $.globalEval($(t).html());
            }),
            $('input[id^="orderItem_"]').each(function (e, t) {
              null != $("addToRequisitionListScript_" + t.value) &&
                $.globalEval(
                  $("addToRequisitionListScript_" + t.value).innerHTML
                ),
                0 != $("addReqListsJS_" + t.value).length &&
                  $.globalEval(
                    "addReqListsJS" +
                      t.value +
                      '.setCatEntryId("' +
                      $("catalogId_" + t.id.substring(t.id.indexOf("_") + 1))
                        .value +
                      '");'
                  );
            });
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declarePromotionFreeGiftsDisplayRefreshArea: function () {
      var e = $("#PromotionFreeGiftsDisplay");
      wcRenderContext.addRefreshAreaId(
        "PromotionFreeGifts_Context",
        "PromotionFreeGiftsDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
          "PromotionFreeGifts_Context"
        ),
        r = function () {
          e.refreshWidget("refresh", t);
        },
        s = function () {
          PromotionChoiceOfFreeGiftsJS.showFreeGiftsDialog();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareRecentRecurringOrderDisplayRefreshArea: function () {
      var e = $("#RecentRecurringOrderDisplay");
      wcRenderContext.addRefreshAreaId(
        "RecentRecurringOrderDisplay_Context",
        "RecentRecurringOrderDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "RecentRecurringOrderDisplay_Context"
      );
      wcTopic.subscribe("AjaxCancelSubscription", function () {
        e.refreshWidget("refresh", t);
      });
      var r = function () {
        cursor_clear();
      };
      e.refreshWidget({
        postRefreshHandler: r,
      });
    },
    declareRecentSubscriptionDisplayRefreshArea: function () {
      var e = $("#RecentSubscriptionDisplay");
      wcRenderContext.addRefreshAreaId(
        "RecentSubscriptionDisplay_Context",
        "RecentSubscriptionDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "RecentSubscriptionDisplay_Context"
      );
      wcTopic.subscribe("AjaxCancelSubscription", function () {
        e.refreshWidget("refresh", t);
      });
      var r = function () {
        cursor_clear();
      };
      e.refreshWidget({
        postRefreshHandler: r,
      });
    },
    declareOrderItemPaginationDisplayRefreshArea: function (e) {
      ("object" == typeof e || "array" == typeof e) && (e = e[0]);
      var t = $("#" + e);
      wcRenderContext.addRefreshAreaId("OrderItemPaginationDisplay_Context", e);
      var r = wcRenderContext.getRenderContextProperties(
          "OrderItemPaginationDisplay_Context"
        ),
        s = function () {
          wcRenderContext.testForChangedRC(
            "OrderItemPaginationDisplay_Context",
            ["beginIndex"]
          ) && t.refreshWidget("refresh", r);
        },
        a = function () {
          cursor_clear(),
            "true" == r.analytics &&
              wcTopic.publish(
                "order_contents_ProductRec",
                $("#orderPartNumbers").val()
              );
        };
      t.refreshWidget({
        renderContextChangedHandler: s,
        postRefreshHandler: a,
      });
    },
    declareRecurOrderDisplayRefreshArea: function () {
      var e = $("#RecurringOrderDisplay");
      wcRenderContext.addRefreshAreaId(
        "RecurringOrderDisplay_Context",
        "RecurringOrderDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "RecurringOrderDisplay_Context"
      );
      wcTopic.subscribe("AjaxCancelSubscription", function () {
        e.refreshWidget("refresh", t);
      });
      var r = function () {
          wcRenderContext.testForChangedRC("RecurringOrderDisplay_Context", [
            "beginIndex",
          ]) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareRecurOrderChildOrdersRefreshArea: function () {
      var e = $("#RecurringOrderChildOrdersDisplay"),
        t = wcRenderContext.getRenderContextProperties(
          "RecurringOrderChildOrdersDisplay_Context"
        ),
        r = function () {
          wcRenderContext.testForChangedRC(
            "RecurringOrderChildOrdersDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareSubscriptionDisplayRefreshArea: function () {
      var e = $("#SubscriptionDisplay");
      wcRenderContext.addRefreshAreaId(
        "SubscriptionDisplay_Context",
        "SubscriptionDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "SubscriptionDisplay_Context"
      );
      wcTopic.subscribe("AjaxCancelSubscription", function () {
        e.refreshWidget("refresh", t);
      });
      var r = function () {
          wcRenderContext.testForChangedRC("SubscriptionDisplay_Context", [
            "beginIndex",
          ]) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareSubscriptionChildOrdersRefreshArea: function () {
      var e = $("#SubscriptionChildOrdersDisplay"),
        t = wcRenderContext.getRenderContextProperties(
          "SubscriptionChildOrdersDisplay_Context"
        ),
        r = function () {
          wcRenderContext.testForChangedRC(
            "SubscriptionChildOrdersDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareQuickInfoDetails: function () {
      var e = $("#quickInfoRefreshArea"),
        t = wcRenderContext.getRenderContextProperties("QuickInfoContext");
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          if ($("#catEntryParamsForJS").length)
            var e = $.parseJSON($("#catEntryParamsForJS").val());
          if ($("#QuickInfostoreParams").length) {
            var t = $("#QuickInfostoreParams").val(),
              r = $("#QuickInfoshoppingListNames").val();
            (shoppingListJSQuickInfo = new ShoppingListJS(
              $.parseJSON(t),
              e,
              $.parseJSON(r),
              "shoppingListJSQuickInfo"
            )),
              this.quickInfoEvenSubscribed ||
                ((this.quickInfoEvenSubscribed = !0),
                wcTopic.subscribe(
                  "DefiningAttributes_Resolved",
                  function (e, t) {
                    shoppingListJSQuickInfo.setItemId(e, t);
                  }
                ),
                wcTopic.subscribe("QuickInfo_attributesChanged", function (e) {
                  shoppingListJSQuickInfo.setCatEntryAttributes(e);
                }),
                wcTopic.subscribe("Quantity_Changed", function (e) {
                  shoppingListJSQuickInfo.setCatEntryQuantity(e);
                }),
                wcTopic.subscribe("ShoppingList_Changed", function (e) {
                  shoppingListJSQuickInfo.updateShoppingListAndAddItem(e);
                }),
                wcTopic.subscribe("ShoppingListItem_Added", function () {
                  shoppingListJSQuickInfo.deleteItemFromCart();
                }),
                $("#QuickInfoaddToShoppingListDropdown").on(
                  "mouseover",
                  function () {
                    shoppingListJSQuickInfo.mouseOnArrow = !0;
                  }
                ),
                $("#QuickInfoShoppingList_0").on("mouseover", function () {
                  (shoppingListJSQuickInfo.exceptionFlag = !0),
                    $("#QuickInfoShoppingListLink_0").focus();
                }));
            var s = e.id;
            null != s &&
              "" != s &&
              wcRenderContext.updateRenderContext(
                "QuickInfoDiscountDetailsContext",
                {
                  productId: e.id,
                }
              );
          }
          $("#catEntryParamsForJS").length &&
            (QuickInfoJS.catEntryParams = $.parseJSON(
              $("#catEntryParamsForJS").val()
            ));
          var a = $("#quickInfoPopup").data("wc-WCDialog");
          a
            ? (closeAllDialogs(),
              "" == QuickInfoJS.itemId
                ? (QuickInfoJS.setCatEntryQuantity(1),
                  QuickInfoJS.selectDefaultSwatch())
                : QuickInfoJS.selectCurrentAttributes(),
              a.open(),
              "undefined" != typeof TealeafWCJS &&
                TealeafWCJS.rebind("quickInfoPopup"))
            : console.debug("quickInfoPopup does not exist"),
            cursor_clear();
        },
      });
    },
    declareQuickInfoDiscountDetailsController: function () {
      var e = $("#quickInfoDiscountDetailsRefreshArea");
      wcRenderContext.addRefreshAreaId(
        "QuickInfoDiscountDetailsContext",
        "quickInfoDiscountDetailsRefreshArea"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "QuickInfoDiscountDetailsContext"
      );
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          cursor_clear();
        },
      });
    },
    declareMSOrderItemPagingDisplayRefreshArea: function (e) {
      var t = "MSOrderItemPaginationDisplay_Context";
      "object" == typeof e && (e = e[0]);
      var r = $("#" + e);
      wcRenderContext.checkIdDefined(t) || wcRenderContext.declare(t, [], null);
      var s = wcRenderContext.getRenderContextProperties(t);
      wcRenderContext.addRefreshAreaId(t, e),
        (renderContextChangedHandler = function () {
          wcRenderContext.testForChangedRC(t, ["beginIndex"]) &&
            r.refreshWidget("refresh", s);
        }),
        (postRefreshHandler = function () {
          cursor_clear(),
            "true" == s.analytics &&
              wcTopic.publish(
                "order_contents_ProductRec",
                $("#orderPartNumbers").value
              );
        }),
        r.refreshWidget({
          renderContextChangedHandler: renderContextChangedHandler,
          postRefreshHandler: postRefreshHandler,
        });
    },
    declareSSFSOrderItemPaginationDisplayController: function () {
      var e = $("#OrderConfirmPagingDisplay");
      wcRenderContext.addRefreshAreaId(
        "OrderItemPaginationDisplay_Context",
        "OrderConfirmPagingDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "OrderItemPaginationDisplay_Context"
      );
      e.refreshWidget({
        renderContextChangedHandler: function () {
          wcRenderContext.testForChangedRC(
            "OrderItemPaginationDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          var e = document.getElementById("jsonOrderStr").innerHTML,
            r = t.beginIndex,
            s = t.pageSize;
          sterlingIntegrationJS.populateOrderLineInfoForSingleShipment(e, r, s),
            cursor_clear();
        },
      });
    },
    declareSSFSMSOrderItemPaginationDisplayController: function () {
      var e = $("#MSOrderDetailPagingDisplay");
      wcRenderContext.addRefreshAreaId(
        "MSOrderItemPaginationDisplay_Context",
        "MSOrderDetailPagingDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "MSOrderItemPaginationDisplay_Context"
      );
      e.refreshWidget({
        renderContextChangedHandler: function () {
          wcRenderContext.testForChangedRC(
            "MSOrderItemPaginationDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          var e = document.getElementById("jsonOrderStr").innerHTML,
            r = t.beginIndex,
            s = t.pageSize;
          sterlingIntegrationJS.populateOrderLineInfoForMultipleShipment(
            e,
            r,
            s
          ),
            cursor_clear();
        },
      });
    },
  }),
  wcService.declare({
    id: "AjaxAddPreConfigurationToCart",
    actionId: "AjaxAddOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
    formId: "",
    successHandler: function (e) {
      if (
        (MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_ADDED
        ),
        cursor_clear(),
        categoryDisplayJS)
      ) {
        for (
          var t = document.getElementsByName("attrValue"), r = !0, s = 0;
          s < t.length;
          s++
        )
          t[s].options.length > 1 && (r = !1);
        if (!r) {
          categoryDisplayJS.selectedAttributes = [];
          for (var s = 0; s < t.length; s++) null != t[s] && (t[s].value = "");
        }
      }
      null != typeof ShipmodeSelectionExtJS &&
        "undefined" != typeof ShipmodeSelectionExtJS &&
        ShipmodeSelectionExtJS.setOrderItemId(e.orderItem[0].orderItemId);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_CONTRACT_EXPIRED_GOTO_ORDER
            )
          : "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddPreConfigurationToCart_shopCart",
    actionId: "AjaxAddOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
    formId: "",
    successHandler: function (e) {
      var t = appendWcCommonRequestParameters(
        "AjaxOrderItemDisplayView?storeId=" +
          ServicesDeclarationJS.storeId +
          "&catalogId=" +
          ServicesDeclarationJS.catalogId +
          "&langId=" +
          ServicesDeclarationJS.langId
      );
      document.location.href = t;
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_CONTRACT_EXPIRED_GOTO_ORDER
            )
          : "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  });
var GeolocationJS = {
  showPosition: function (e) {
    void 0 !== e &&
      null != e &&
      storeLocatorJSStore.refreshResultsFromNearest(
        e.coords.latitude,
        e.coords.longitude
      );
  },
  locationError: function (e) {
    var t;
    switch (e.code) {
      case e.PERMISSION_DENIED:
        t = "LBS_ERROR_PERMISSION_DENIED";
        break;
      case e.POSITION_UNAVAILABLE:
        t = "LBS_ERROR_NO_USER_CURRENT_LOC";
        break;
      case e.TIMEOUT:
        t = "LBS_ERROR_TIMEOUT";
    }
    storeLocatorJSStore.refreshResultsWithLocationError(t);
  },
  launch: function () {
    navigator.geolocation &&
      navigator.geolocation.getCurrentPosition(
        GeolocationJS.showPosition,
        GeolocationJS.locationError,
        {
          timeout: 1e4,
          enableHighAccuracy: !0,
        }
      );
  },
};
("undefined" != typeof MessageHelper &&
  MessageHelper &&
  MessageHelper.topicNamespace) ||
  (MessageHelper = {
    messages: {},
    identifier: "",
    focusElement: "",
    getCurrentYear: function () {
      return new Date().getFullYear();
    },
    getCurrentMonth: function () {
      return new Date().getMonth() + 1;
    },
    getCurrentDay: function () {
      return new Date().getDate();
    },
    getRenderContextProperty: function (e, t) {
      if (
        (console.debug(
          "enter getRenderContextProperty with propertyName = " + t
        ),
        null == e)
      )
        return console.debug("context is null. Return null..."), null;
      var r = e.properties[t];
      return console.debug("the found property value is: " + r), r;
    },
    setMessage: function (e, t) {
      this.messages[e] = t;
    },
    setFocusElement: function (e) {
      this.focusElement = e;
    },
    showHideMessageArea: function (e) {
      cursor_clear(), (null == e || void 0 == e) && (e = 0);
      var t = $("#MessageArea");
      null !== $("#MessageArea_ACCE_Title") &&
        $("#MessageArea_ACCE_Title").css("display", "block"),
        $(t).fadeIn(200);
    },
    hideMessageArea: function () {
      cursor_clear();
      var e = "";
      "" !== this.focusElement &&
        null !== $("#" + this.focusElement) &&
        (e = $("#" + this.focusElement));
      var t = $("#MessageArea");
      null !== $("#MessageArea_ACCE_Title") &&
        $("#MessageArea_ACCE_Title").css("display", "none"),
        null != document.getElementById(e) && e.focus(),
        $(t).fadeOut(500),
        $("#ErrorMessageText").html(""),
        (this.focusElement = "");
    },
    displayErrorMessage: function (e, t, r) {
      if (
        ((null == t || void 0 == t) && (t = 0),
        (void 0 == r || null == r || 1 == r) &&
          null != this.messages.ERROR_MESSAGE_TYPE &&
          "undefined" != this.messages.ERROR_MESSAGE_TYPE)
      ) {
        var s = this.messages.ERROR_MESSAGE_TYPE;
        e = s + e;
      }
      this.setMessageAreaStyle("error_icon"),
        $("#ErrorMessageText").html(e),
        this.showHideMessageArea(t),
        $("#clickableErrorMessageImg").focus(),
        setTimeout(function () {
          null !== $("#ErrorMessageText") && $("#ErrorMessageText").focus();
        }, 1e3),
        "undefined" != typeof TealeafWCJS &&
          TealeafWCJS.logClientValidationCustomEvent({
            fieldId: "-1",
            message: e,
          });
    },
    setMessageAreaStyle: function (e) {
      $("#success_icon").css("display", "none"),
        $("#error_icon").css("display", "none"),
        null != $("#" + e) && $("#" + e).css("display", "inline");
    },
    displayStatusMessage: function (e, t) {
      (null == t || void 0 == t) && (t = 0),
        this.setMessageAreaStyle("success_icon"),
        $("#ErrorMessageText").html(e),
        this.showHideMessageArea(t),
        $("#clickableErrorMessageImg").focus(),
        setTimeout(function () {
          null !== $("#ErrorMessageText") && $("#ErrorMessageText").focus();
        }, 1e3);
    },
    hideAndClearMessage: function () {
      $("#ErrorMessageText").html(""), $("#MessageArea").css("display", "none");
    },
    adjustCoordinates: function (e) {
      if ("none" != $("#MessageArea").css("display")) {
        var t = $("#page"),
          r = $("#MessageArea");
        if (null != t && null != r) {
          var s = $(t).position(),
            a = $(t).width();
          (null == e || void 0 == e) && (e = 0),
            $(r).css({
              width: a + 20 + "px",
              left: s.left - 10 + "px",
              top: s.top + e + "px",
            });
        }
      }
    },
    formErrorHandle: function (e, t) {
      this.formErrorHandleClient(e.errorMessageParam, e.errorMessage);
    },
    formErrorHandleClient: function (e, t) {
      e.id && (e = e.id);
      var r = $("#" + e);
      if (null == t)
        return void console.debug(
          "formErrorHandleClient: The error message is null."
        );
      if (r) {
        if (Utils.has_ios())
          this.setMessageAreaStyle("error_icon"),
            $("#MessageArea").css("display", "block"),
            $("#ErrorMessageText").html(t),
            window.setTimeout(function () {
              window.scrollTo(0, 0);
            }, 0);
        else if (this.identifier != e + "_tooltip") {
          r.focus(), (this.identifier = e + "_tooltip");
          var s = document.createElement("span"),
            a = getImageDirectoryPath();
          if (
            (Utils.get_IE_version() < 7
              ? (s.innerHTML =
                  t +
                  "<iframe id='errorMessageIFrame' scrolling='no' frameborder='0' src='" +
                  a +
                  "images/empty.gif'></iframe>")
              : (s.innerHTML = t),
            Utils.hasTouch())
          ) {
            var i = this;
            setTimeout(function () {
              var r = this;
              (this.tooltip = $(
                "<div class='WCTooltip'><div class='container' style='padding:5px;' ><div class='connector''></div>" +
                  t +
                  "</div></div>"
              )),
                $("#" + e).after(this.tooltip),
                this.tooltip.position({
                  my: "center top",
                  at: "center bottom",
                  of: $("#" + e),
                }),
                $("#" + e).blur(function () {
                  r.tooltip && (r.tooltip.hide(), r.tooltip.remove()),
                    MessageHelper.clearCurrentIdentifier();
                });
            }, 1e3);
          } else {
            var i = this;
            (this.tooltip = $(
              "<div class='WCTooltip'><div class='container' style='padding:5px;' ><div class='connector''></div>" +
                t +
                "</div></div>"
            )),
              $("#" + e).after(this.tooltip),
              this.tooltip.position({
                my: "center top",
                at: "center bottom",
                of: $("#" + e),
              }),
              $("#" + e).blur(function () {
                i.tooltip && (i.tooltip.hide(), i.tooltip.remove()),
                  MessageHelper.clearCurrentIdentifier();
              });
          }
        }
        "undefined" != typeof TealeafWCJS &&
          TealeafWCJS.logClientValidationCustomEvent({
            fieldId: r.id,
            message: t,
          });
      }
    },
    hideFormErrorHandle: function () {
      null != this.tooltip &&
        (this.tooltip.destroyRecursive(),
        (this.tooltip = null),
        this.clearCurrentIdentifier());
    },
    clearCurrentIdentifier: function () {
      this.identifier = "";
    },
    emptyFunc: function (e) {},
    containsDoubleByte: function (e) {
      for (var t = new String(e), r = 127, s = 0; s < t.length; s++)
        if (((chr = t.charCodeAt(s)), chr > r)) return !0;
      return !1;
    },
    isValidEmail: function (e) {
      return this.containsDoubleByte(e)
        ? !1
        : 0 == e.length
        ? !0
        : e.length < 5
        ? !1
        : e.indexOf(" ") > 0
        ? !1
        : e.indexOf("@") < 1
        ? !1
        : e.lastIndexOf(".") < e.indexOf("@") + 2
        ? !1
        : e.lastIndexOf(".") >= e.length - 2
        ? !1
        : !0;
    },
    isValidUTF8length: function (e, t) {
      return this.utf8StringByteLength(e) > t ? !1 : !0;
    },
    utf8StringByteLength: function (e) {
      if (null === e) return 0;
      var t = String(e),
        r = 127,
        s = 2047,
        a = t.length;
      for (i = 0; i < t.length; i++)
        (chr = t.charCodeAt(i)), chr > r && (a += 1), chr > s && (a += 1);
      return a;
    },
    IsNumeric: function (e, t) {
      if (t) var r = "0123456789.";
      else var r = "0123456789";
      var s,
        a = !0;
      for (i = 0; i < e.length && 1 == a; i++)
        (s = e.charAt(i)), -1 == r.indexOf(s) && (a = !1);
      return a;
    },
    IsValidPhone: function (e) {
      var t,
        r = "0123456789()-+ ",
        s = !0;
      for (i = 0; i < e.length && 1 == s; i++)
        (t = e.charAt(i)), -1 == r.indexOf(t) && (s = !1);
      return s;
    },
    showConfirmationDialog: function (e, t) {
      $("#confirmationPopupMessage").html(t);
      var r = $("#confirmationPopup").data("wc-WCDialog"),
        s = "click.MessageHelper";
      r.primary_button.one(s, function (t) {
        t.preventDefault(),
          r.secondary_button.off(s),
          wcTopic.publish(e, {
            action: "YES",
          });
      }),
        r.secondary_button.one(s, function (t) {
          t.preventDefault(),
            r.primary_button.off(s),
            wcTopic.publish(e, {
              action: "NO",
            });
        }),
        r.open();
    },
  }),
  (quickOrderJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    skuErrorMessage: "",
    qtyErrorMessage: "",
    numberOfItemsSupportedPerQuickOrder: "12",
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.skuErrorMessage = s),
        (this.qtyErrorMessage = a);
    },
    addToOrderAjax: function (e) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          storeNLS.ERROR_ADD2CART_BROWSE_ONLY
        );
      var t = [],
        r = document.forms[e];
      (t.storeId = r.storeId.value),
        (t.catalogId = r.catalogId.value),
        (t.langId = r.langId.value),
        (t.calculateOrder = "0");
      for (
        var s = 0, a = 1;
        a <= this.numberOfItemsSupportedPerQuickOrder;
        a++
      ) {
        var i = r["partNumber_" + a].id,
          n = r["quantity_" + a].id,
          o = trim(r["partNumber_" + a].value),
          d = trim(r["quantity_" + a].value);
        if ((null != o && "" != o) || (null != d && "" != d)) {
          if (null == o || "" == o)
            return void MessageHelper.formErrorHandleClient(
              i,
              this.skuErrorMessage
            );
          if (!isPositiveInteger(d))
            return void MessageHelper.formErrorHandleClient(
              n,
              this.qtyErrorMessage
            );
          (s += 1),
            (r["partNumber_" + a].value = o),
            (r["quantity_" + a].value = d),
            this.updateParamObject(
              t,
              "partNumber_" + s,
              r["partNumber_" + a].value
            ),
            this.updateParamObject(
              t,
              "quantity_" + s,
              r["quantity_" + a].value
            );
        }
      }
      if (s > 0) {
        if (!submitRequest()) return;
        cursor_wait(), wcService.invoke("QuickOrderAddOrderItem", t);
      }
    },
    updateParamObject: function (e, t, r, s) {
      if ((null == e && (e = []), null != s && "" !== s && -1 !== s))
        e[t + "_" + s] = r;
      else if (-1 === s) {
        for (var a = 1; null != e[t + "_" + a]; ) a++;
        e[t + "_" + a] = r;
      } else e[t] = r;
      return e;
    },
    clearForm: function (e) {
      for (var t = document.forms[e], r = 0; r < t.elements.length; r++)
        "text" == t.elements[r].type && (t.elements[r].value = "");
    },
  }),
  wcService.declare({
    id: "QuickOrderAddOrderItem",
    actionId: "AjaxAddOrderItem",
    url: "AjaxRESTOrderAddPreConfigurationToCart",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_ADDED
        ),
        cursor_clear(),
        quickOrderJS.clearForm("MQuickOrderForm");
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_CONTRACT_EXPIRED_GOTO_ORDER
            )
          : "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  ("undefined" != typeof ResponsiveJS &&
    null != ResponsiveJS &&
    ResponsiveJS) ||
    (ResponsiveJS = {
      init: function () {
        $("#footerCustomerService").on(
          "click",
          $.proxy(ResponsiveJS._cSToggleAndShow, ResponsiveJS)
        ),
          $("#footerCorporateInfo").on(
            "click",
            $.proxy(ResponsiveJS._cIToggleAndShow, ResponsiveJS)
          ),
          $("#footerExplore").on(
            "click",
            $.proxy(ResponsiveJS._eToggleAndShow, ResponsiveJS)
          ),
          $("#footerFollowUs").on(
            "click",
            $.proxy(ResponsiveJS._FUToggleAndShow, ResponsiveJS)
          );
      },
      _cSToggleAndShow: function (e) {
        this.toggle($("#cSTog")), this.show($("#expandCS"));
      },
      _cIToggleAndShow: function (e) {
        this.toggle($("#cITog")), this.show($("#expandCI"));
      },
      _eToggleAndShow: function (e) {
        this.toggle($("#eTog")), this.show($("#expandE"));
      },
      _FUToggleAndShow: function (e) {
        this.toggle($("#fUTog")), this.show($("#expandFU"));
      },
      toggle: function (e) {
        var t = e;
        null != t &&
          ("-161px -1px" == t.style.backgroundPosition
            ? ((t.style.backgroundPosition = "-181px -1px"),
              (t.style.width = "12px"),
              (t.style.height = "6px"),
              (t.style.left = "6px"),
              (t.style.top = "14px"))
            : ((t.style.backgroundPosition = "-161px -1px"),
              (t.style.width = "6px"),
              (t.style.height = "12px"),
              (t.style.left = "10px"),
              (t.style.top = "10px")));
      },
      show: function (e) {
        (srcElement = e),
          null != srcElement &&
            ("block" == srcElement.style.display
              ? (close("searchDropdown"), (srcElement.style.display = "none"))
              : ($(".subDeptDropdown ").each(function (e, t) {
                  close(t.id);
                }),
                close("departmentsDropdown"),
                close("qLinkDropdown"),
                close("mobileSearchDropdown"),
                close("searchDropdown"),
                close("pageDropdown"),
                close("sortDropdown"),
                (srcElement.style.display = "block")));
      },
    }),
  (ServicesDeclarationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemAddAndDeleteFromCart",
    actionId: "AjaxInterestItemAddAndDeleteFromCart",
    url: getAbsoluteURL() + "AjaxInterestItemAdd",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        resetRequest(),
        CheckoutHelperJS.deleteFromCart(e.orderItemId, !0),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.WISHLIST_ADDED
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddOrderItem",
    actionId: "AjaxAddOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemAdd",
    formId: "",
    successHandler: function (e) {
      if (
        (MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_ADDED
        ),
        cursor_clear(),
        categoryDisplayJS)
      ) {
        for (
          var t = document.getElementsByName("attrValue"), r = !0, s = 0;
          s < t.length;
          s++
        )
          t[s].options.length > 1 && (r = !1);
        if (!r) {
          categoryDisplayJS.selectedAttributes = [];
          for (var s = 0; s < t.length; s++) null != t[s] && (t[s].value = "");
        }
      }
      null != typeof ShipmodeSelectionExtJS &&
        "undefined" != typeof ShipmodeSelectionExtJS &&
        ShipmodeSelectionExtJS.setOrderItemId(
          null != e.orderItem && null != e.orderItem[0].orderItemId
            ? e.orderItem[0].orderItemId
            : e.orderItemId
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_CONTRACT_EXPIRED_GOTO_ORDER
            )
          : "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddOrderItem_shopCart",
    actionId: "AjaxAddOrderItem",
    url: getAbsoluteURL() + "AjaxOrderChangeServiceItemAdd",
    formId: "",
    successHandler: function (e) {
      document.location.href = appendWcCommonRequestParameters(
        "AjaxOrderItemDisplayView?storeId=" +
          ServicesDeclarationJS.storeId +
          "&catalogId=" +
          ServicesDeclarationJS.catalogId +
          "&langId=" +
          ServicesDeclarationJS.langId
      );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_CONTRACT_EXPIRED_GOTO_ORDER
            )
          : "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeleteOrderItem",
    actionId: "AjaxDeleteOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_REMOVEITEM
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        e.errorCode && wcTopic.publish("OrderError", e),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeleteOrderItemForShippingBillingPage",
    actionId: "AjaxDeleteOrderItemForShippingBillingPage",
    url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_REMOVEITEM
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeleteOrderItemFromCart",
    actionId: "AjaxDeleteOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
    formId: "",
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeleteOrderItem1",
    actionId: "AjaxDeleteOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_REMOVEITEM
        ),
        CheckoutHelperJS.pendingOrderDetailsPage
          ? cursor_clear()
          : (setDeleteCartCookie(),
            CheckoutHelperJS.shoppingCartPage
              ? (document.location.href = appendWcCommonRequestParameters(
                  "AjaxOrderItemDisplayView?storeId=" +
                    ServicesDeclarationJS.storeId +
                    "&catalogId=" +
                    ServicesDeclarationJS.catalogId +
                    "&langId=" +
                    ServicesDeclarationJS.langId
                ))
              : (document.location.href = appendWcCommonRequestParameters(
                  "OrderShippingBillingView?storeId=" +
                    ServicesDeclarationJS.storeId +
                    "&catalogId=" +
                    ServicesDeclarationJS.catalogId +
                    "&langId=" +
                    ServicesDeclarationJS.langId +
                    "&orderId=" +
                    e.orderId
                )));
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateOrderItem",
    actionId: "AjaxUpdateOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.hideFormErrorHandle(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE_QTY_UPDATE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        e.errorCode && wcTopic.publish("OrderError", e),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateOrderItem1",
    actionId: "AjaxUpdateOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
    formId: "",
    successHandler: function (e) {
      CheckoutHelperJS.pendingOrderDetailsPage
        ? cursor_clear()
        : CheckoutHelperJS.shoppingCartPage &&
          (document.location.href = appendWcCommonRequestParameters(
            "AjaxOrderItemDisplayView?storeId=" +
              ServicesDeclarationJS.storeId +
              "&catalogId=" +
              ServicesDeclarationJS.catalogId +
              "&langId=" +
              ServicesDeclarationJS.langId
          ));
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE_QTY_UPDATE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateOrderShippingInfo",
    actionId: "AjaxUpdateOrderShippingInfo",
    url: getAbsoluteURL() + "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPrepareOrderForSubmit",
    actionId: "AjaxPrepareOrderForSubmit",
    url: getAbsoluteURL() + "AjaxRESTOrderPrepare",
    formId: "",
    successHandler: function (e) {
      CheckoutHelperJS.setOrderPrepared("true"),
        CheckoutHelperJS.checkoutOrder(
          CheckoutHelperJS.getSavedParameter("tempOrderId"),
          CheckoutHelperJS.getSavedParameter("tempUserType"),
          CheckoutHelperJS.getSavedParameter("tempEmailAddresses"),
          CheckoutHelperJS.getSavedParameter("tempIsQuote")
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSubmitOrder",
    actionId: "AjaxSubmitOrder",
    url: getAbsoluteURL() + "AjaxRESTOrderSubmit",
    formId: "",
    successHandler: function (e) {
      nullCartTotalCookie(e.orderId);
      var t = CheckoutHelperJS.getShipmentTypeId();
      document.location.href = appendWcCommonRequestParameters(
        "OrderShippingBillingConfirmationView?storeId=" +
          ServicesDeclarationJS.storeId +
          "&catalogId=" +
          ServicesDeclarationJS.catalogId +
          "&langId=" +
          ServicesDeclarationJS.langId +
          "&orderId=" +
          e.orderId +
          "&shipmentTypeId=" +
          t
      );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSubmitQuote",
    actionId: "AjaxSubmitQuote",
    url: getAbsoluteURL() + "AjaxSubmitQuote",
    formId: "",
    successHandler: function (e) {
      var t =
        "OrderShippingBillingConfirmationView?storeId=" +
        ServicesDeclarationJS.storeId +
        "&catalogId=" +
        ServicesDeclarationJS.catalogId +
        "&langId=" +
        ServicesDeclarationJS.langId +
        "&orderId=" +
        CheckoutHelperJS.getOrderId() +
        "&shipmentTypeId=" +
        CheckoutHelperJS.getShipmentTypeId() +
        "&isQuote=true&quoteId=" +
        e.outOrderId;
      void 0 != e.outExternalQuoteId &&
        null != e.outExternalQuoteId &&
        (t += t + "&externalQuoteId=" + e.outExternalQuoteId),
        (document.location.href = appendWcCommonRequestParameters(t));
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddAddressForPerson",
    actionId: "AjaxAddAddressForPerson",
    url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
    formId: "",
    successHandler: function (e) {
      AddressHelper.updateOrderAfterAddressUpdate(),
        MessageHelper.hideAndClearMessage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateAddressForPerson",
    actionId: "AjaxUpdateAddressForPerson",
    url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
    formId: "",
    successHandler: function (e) {
      AddressHelper.updateOrderAfterAddressUpdate(),
        MessageHelper.hideAndClearMessage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateOrderAfterAddressUpdate",
    actionId: "AjaxUpdateOrderAfterAddressUpdate",
    url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemAdd",
    actionId: "AjaxInterestItemAdd",
    url: getAbsoluteURL() + "AjaxInterestItemAdd",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        cursor_clear(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.WISHLIST_ADDED
        ),
        categoryDisplayJS && (categoryDisplayJS.selectedAttributes = []);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemAdd_shopCart",
    actionId: "AjaxInterestItemAdd",
    url: getAbsoluteURL() + "AjaxInterestItemAdd",
    formId: "",
    successHandler: function (e) {
      document.location.href = appendWcCommonRequestParameters(
        "AjaxOrderItemDisplayView?storeId=" +
          ServicesDeclarationJS.storeId +
          "&catalogId=" +
          ServicesDeclarationJS.catalogId +
          "&langId=" +
          ServicesDeclarationJS.langId
      );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemDelete",
    actionId: "AjaxInterestItemDelete",
    url: getAbsoluteURL() + "AjaxInterestItemDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemListMessage",
    actionId: "AjaxInterestItemListMessage",
    url: getAbsoluteURL() + "AjaxInterestItemListMessage",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPromotionCodeManage",
    actionId: "AjaxPromotionCodeManage",
    url: getAbsoluteURL() + "AjaxRESTPromotionCodeApply",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.orderItemId = ""),
        (t.orderId = e.orderId),
        CheckoutHelperJS.shoppingCartPage
          ? (t.calculationUsage = "-1,-2,-5,-6,-7")
          : (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (t.calculateOrder = "1"),
        wcService.invoke("AjaxUpdateOrderItem", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPromotionCodeDelete",
    actionId: "AjaxPromotionCodeManage",
    url: getAbsoluteURL() + "AjaxRESTPromotionCodeRemove",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.orderItemId = ""),
        (t.orderId = e.orderId),
        CheckoutHelperJS.shoppingCartPage
          ? (t.calculationUsage = "-1,-2,-5,-6,-7")
          : (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (t.calculateOrder = "1"),
        wcService.invoke("AjaxUpdateOrderItem", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxCouponsAdd",
    actionId: "AjaxCouponsAddRemove",
    url: getAbsoluteURL() + "AjaxRESTCouponsAdd",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.orderItemId = ""),
        (t.orderId = e.orderId),
        CheckoutHelperJS.shoppingCartPage
          ? (t.calculationUsage = "-1,-2,-5,-6,-7")
          : (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (t.calculateOrder = "1"),
        wcService.invoke("AjaxUpdateOrderItem", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxCouponsRemove",
    actionId: "AjaxCouponsAddRemove",
    url: getAbsoluteURL() + "AjaxRESTCouponsRemove",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.orderItemId = ""),
        (t.orderId = e.orderId),
        CheckoutHelperJS.shoppingCartPage
          ? (t.calculationUsage = "-1,-2,-5,-6,-7")
          : (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (t.calculateOrder = "1"),
        wcService.invoke("AjaxUpdateOrderItem", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ScheduleOrder",
    actionId: "ScheduleOrder",
    url: getAbsoluteURL() + "AjaxRESTScheduleOrder",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
      var t = document.getElementById("orderIdToSchedule").value,
        r = e.orderId;
      nullCartTotalCookie(e.orderId);
      var s = CheckoutHelperJS.getShipmentTypeId(),
        a = "";
      null !=
        document.forms.purchaseOrderNumberInfo.purchase_order_number.value &&
        (a =
          document.forms.purchaseOrderNumberInfo.purchase_order_number.value);
      var i =
        "RESTOrderCancel?orderId=" +
        t +
        "&storeId=" +
        ServicesDeclarationJS.storeId +
        "&catalogId=" +
        ServicesDeclarationJS.catalogId +
        "&langId=" +
        ServicesDeclarationJS.langId +
        "&URL=OrderShippingBillingConfirmationView%3ForderId%3D" +
        r +
        "%26originalOrderId%3D" +
        t +
        "%26shipmentTypeId%3D" +
        s +
        "%26purchaseOrderNumber%3D" +
        a;
      document.location.href = appendWcCommonRequestParameters(i);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "SubmitRecurringOrder",
    actionId: "SubmitRecurringOrder",
    url: getAbsoluteURL() + "AjaxRESTSubmitRecurringOrSubscription",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), nullCartTotalCookie(e.orderId);
      var t = CheckoutHelperJS.getShipmentTypeId(),
        r =
          "OrderShippingBillingConfirmationView?storeId=" +
          ServicesDeclarationJS.storeId +
          "&catalogId=" +
          ServicesDeclarationJS.catalogId +
          "&langId=" +
          ServicesDeclarationJS.langId +
          "&orderId=" +
          e.orderId +
          "&shipmentTypeId=" +
          t;
      (document.location.href = appendWcCommonRequestParameters(r)),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateRewardOption",
    actionId: "AjaxUpdateRewardOption",
    url: getAbsoluteURL() + "AjaxRESTOrderRewardOptionUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderCreate",
    actionId: "AjaxOrderCreate",
    url: getAbsoluteURL() + "AjaxOrderCreate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.ORDER_CREATED
        ),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_CREATED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSingleOrderCancel",
    actionId: "AjaxSingleOrderCancel",
    url: getAbsoluteURL() + "AjaxRESTOrderCancel",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.ORDERS_CANCELLED
        ),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_CANCELLED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderCancel",
    actionId: "AjaxOrderCancel",
    url: getAbsoluteURL() + "AjaxRESTOrderCancel",
    formId: "",
    successHandler: function (e) {
      savedOrdersJS.cancelSavedOrder(!1);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_CANCELLED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderSave",
    actionId: "AjaxOrderSave",
    url: getAbsoluteURL() + "AjaxOrderCopy",
    formId: "",
    successHandler: function (e) {
      savedOrdersJS.saveOrder(!1);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_SAVED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSetPendingOrder",
    actionId: "AjaxSetPendingOrder",
    url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.ORDER_SET_CURRENT
        ),
        savedOrdersJS.determinePageForward("AjaxSetPendingOrder"),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode || "CMN1024E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_SET_CURRENT
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdatePendingOrder",
    actionId: "AjaxUpdatePendingOrder",
    url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
    formId: "",
    successHandler: function (e) {
      savedOrdersJS.determinePageForward("AjaxUpdatePendingOrder"),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_SET_CURRENT
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSingleOrderCopy",
    actionId: "AjaxSingleOrderCopy",
    url: getAbsoluteURL() + "AjaxOrderCopy",
    formId: "",
    successHandler: function (e) {
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.URL = ""),
        (t.updatePrices = "1"),
        (t.orderId = e.orderId),
        (t.calculationUsageId = "-1"),
        wcService.invoke("AjaxSingleOrderCalculate", t),
        MessageHelper.hideAndClearMessage();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_COPIED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderCopy",
    actionId: "AjaxOrderCopy",
    url: getAbsoluteURL() + "AjaxOrderCopy",
    formId: "",
    successHandler: function (e) {
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.URL = ""),
        (t.updatePrices = "1"),
        (t.orderId = e.orderId),
        (t.calculationUsageId = "-1"),
        wcService.invoke("AjaxOrderCalculate", t),
        MessageHelper.hideAndClearMessage();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_COPIED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSingleOrderCalculate",
    actionId: "AjaxSingleOrderCalculate",
    url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(MessageHelper.messages.ORDER_COPIED),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_COPIED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxCurrentOrderCalculate",
    actionId: "AjaxCurrentOrderCalculate",
    url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.ORDER_SET_CURRENT
        ),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_COPIED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderCalculate",
    actionId: "AjaxOrderCalculate",
    url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), savedOrdersJS.copyOrder(!1);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_COPIED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPunchoutPay",
    actionId: "AjaxPunchoutPay",
    url: "AjaxRESTOrderRePay",
    formId: "",
    successHandler: function (e) {
      PunchoutJS.handleResponse(e.orderId),
        MessageHelper.hideAndClearMessage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxCategorySubscribe",
    actionId: "AjaxCategorySubscribe",
    url: "AjaxRESTMarketingTriggerProcessServiceEvaluate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SUBSCRIPTION_UPDATED
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  });
var order_updated = {
    AjaxAddOrderItem: "AjaxAddOrderItem",
    AjaxAddOrderItemWithShipingInfo: "AjaxAddOrderItemWithShipingInfo",
    AjaxDeleteOrderItem: "AjaxDeleteOrderItem",
    AjaxUpdateOrderItem: "AjaxUpdateOrderItem",
    AjaxUpdateOrderShippingInfo: "AjaxUpdateOrderShippingInfo",
    AjaxOrderCalculate: "AjaxOrderCalculate",
    AjaxLogoff: "AjaxLogoff",
    AjaxSetPendingOrder: "AjaxSetPendingOrder",
    AjaxUpdatePendingOrder: "AjaxUpdatePendingOrder",
    AjaxSingleOrderCancel: "AjaxSingleOrderCancel",
    AjaxUpdateRewardOption: "AjaxUpdateRewardOption",
  },
  address_updated = {
    AjaxDeleteAddressForPerson: "AjaxDeleteAddressForPerson",
    AjaxAddAddressForPerson: "AjaxAddAddressForPerson",
    AjaxUpdateAddressForPerson: "AjaxUpdateAddressForPerson",
    AjaxAddShippingAndBillingAddressForPersonDuringCheckout:
      "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
    AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout:
      "AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout",
  },
  user_changed = {
    AjaxLogonService: "AjaxLogonService",
    AjaxLogoff: "AjaxLogoff",
  },
  wishlist_changed = {
    AjaxInterestItemAdd: "AjaxInterestItemAdd",
    AjaxInterestItemDelete: "AjaxInterestItemDelete",
    AjaxLogonService: "AjaxLogonService",
    AjaxLogoff: "AjaxLogoff",
  };
wcTopic.subscribe("ajaxRequestInitiated", incrementNumAjaxRequest),
  wcTopic.subscribe("ajaxRequestCompleted", decrementNumAjaxRequest),
  wcTopic.subscribe("ajaxRequestCompleted", initializeInactivityWarning),
  wcTopic.subscribe("OrderError", function (e) {
    "CMN4512I" == e.errorCode &&
      (setDeleteCartCookie(), loadMiniCart(null, null));
  });
var showDropdown = !1,
  dropDownDlg = null,
  productAddedDropDownDlg = null,
  originalMiniCartWidth = 0,
  isIE = document.all ? !0 : !1,
  correctBrowser = !1,
  requestSubmitted = !0,
  currentId = "",
  numAjaxRequests = 0,
  widgetsList = [],
  tabPressed = !1,
  currentPopup = "",
  android = null,
  ios = null,
  cookieDomain = "",
  _BTD_PREFS = "WC_Base_Text_Direction",
  detectedLocale = Utils.getLocale();
wcService.declare({
  id: "MyAcctAjaxAddOrderItem",
  actionId: "AjaxAddOrderItem",
  url: "",
  formId: "",
  successHandler: function (e) {
    MessageHelper.hideAndClearMessage(),
      MessageHelper.displayStatusMessage(
        Utils.getLocalizationMessage("SHOPCART_ADDED")
      ),
      setCookie("WC_nextURL_" + WCParamJS.storeId, null, {
        expires: -1,
        path: "/",
        domain: cookieDomain,
      }),
      cursor_clear();
  },
  failureHandler: function (e) {
    e.errorMessage
      ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER")
          )
        : MessageHelper.displayErrorMessage(e.errorMessage)
      : e.errorMessageKey &&
        MessageHelper.displayErrorMessage(e.errorMessageKey),
      cursor_clear();
  },
}),
  wcService.declare({
    id: "MyAcctGenericService",
    actionId: "",
    url: "",
    formId: "",
    successHandler: function (e) {
      setCookie("WC_nextURL_" + WCParamJS.storeId, null, {
        expires: -1,
        path: "/",
        domain: cookieDomain,
      }),
        MessageHelper.hideAndClearMessage(),
        (finalViewURL = getFinalViewURL(this.url)),
        "" !== finalViewURL
          ? (document.location.href = finalViewURL)
          : (MessageHelper.displayStatusMessage(
              Utils.getLocalizationMessage("MYACCOUNT_ACTION_PERFORMED")
            ),
            cursor_clear());
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  (PhysicalStoreCookieJSStore = {
    storeArray: null,
    arrayMaxSize: 5,
    getStoreIdsFromCookie: function () {
      var e = getCookie("WC_physicalStores");
      if (((this.storeArray = new Array()), null != e)) {
        var t = "",
          r = e,
          s = e.length,
          a = r.indexOf(",");
        if (a > 0) {
          for (; a >= 0; )
            (t = r.substring(0, a)),
              this.addToStoreArray(t),
              (r = r.substring(a + 1, s)),
              (s = r.length),
              (a = r.indexOf(","));
          (t = r), this.addToStoreArray(t);
        } else s > 0 && this.addToStoreArray(r);
      }
      return this.storeArray;
    },
    isAddOneStoreIdExceedMax: function () {
      var e = !1;
      return this.getNumStores() + 1 > this.arrayMaxSize && (e = !0), e;
    },
    setStoreIdsToCookie: function () {
      var e = "";
      for (i = 0; i < this.storeArray.length; i++)
        (e += this.storeArray[i]), i < this.storeArray.length - 1 && (e += ",");
      0 == e.length
        ? setCookie("WC_physicalStores", null, {
            path: "/",
            expires: -1,
            domain: cookieDomain,
          })
        : setCookie("WC_physicalStores", e, {
            path: "/",
            domain: cookieDomain,
          });
    },
    addToStoreArray: function (e) {
      for (
        null == this.storeArray && this.getStoreIdsFromCookie(), i = 0;
        i < this.storeArray.length;
        i++
      )
        if (this.storeArray[i] == e) return;
      this.storeArray.length < this.arrayMaxSize && this.storeArray.push(e);
    },
    addToCookie: function (e) {
      this.addToStoreArray(e), this.setStoreIdsToCookie();
    },
    removeFromStoreArray: function (e) {
      null == this.storeArray && this.getStoreIdsFromCookie();
      var t = -1;
      for (i = 0; i < this.storeArray.length; i++)
        this.storeArray[i] == e && ((t = i), (i = this.storeArray.length));
      this.storeArray.splice(t, 1);
    },
    removeFromCookie: function (e) {
      this.removeFromStoreArray(e), this.setStoreIdsToCookie();
    },
    clearStoreArray: function () {
      this.storeArray = new Array();
    },
    clearCookie: function () {
      this.clearStoreArray(), this.setStoreIdsToCookie();
    },
    getNumStores: function () {
      return (
        null == this.storeArray && this.getStoreIdsFromCookie(),
        this.storeArray.length
      );
    },
    getPickUpStoreIdFromCookie: function () {
      var e = getCookie("WC_pickUpStore");
      return e;
    },
    setPickUpStoreIdToCookie: function (e) {
      var t = e;
      if (null != t && "undefined" != t && "" != t) {
        var r = this.getPickUpStoreIdFromCookie();
        t != r &&
          (setCookie("WC_pickUpStore", null, {
            path: "/",
            expires: -1,
            domain: cookieDomain,
          }),
          setCookie("WC_pickUpStore", t, {
            path: "/",
            domain: cookieDomain,
          }));
      }
    },
    clearPickUpStoreIdFromCookie: function (e) {
      var t = e;
      if (null != t && "undefined" != t && "" != t) {
        var r = this.getPickUpStoreIdFromCookie();
        t == r &&
          setCookie("WC_pickUpStore", null, {
            path: "/",
            expires: -1,
            domain: cookieDomain,
          });
      }
    },
    getValueFromCookie: function (e) {
      var t = getCookie(e);
      return t;
    },
    setValueToCookie: function (e, t) {
      var r = t;
      if (null != r && "undefined" != r && "" != r) {
        var s = this.getValueFromCookie(e);
        r != s &&
          (setCookie(e, null, {
            path: "/",
            expires: -1,
            domain: cookieDomain,
          }),
          setCookie(e, r, {
            path: "/",
            domain: cookieDomain,
          }));
      }
    },
    clearValueFromCookie: function (e) {
      var t = this.getValueFromCookie(e);
      null != t &&
        "undefined" != t &&
        setCookie(e, null, {
          path: "/",
          expires: -1,
          domain: cookieDomain,
        });
    },
  }),
  (storeLocatorJSStore = {
    initProvinceSelections: function () {
      var e = $("#selectCountry").prop("selectedIndex");
      if (e > -1) {
        var t = e,
          r = storeLocatorJSStore.getSavedCountrySelectionIndex();
        null != r &&
          r != e &&
          ((t = r), ($("#selectCountry")[0].options[t].selected = !0)),
          wcRenderContext.updateRenderContext("provinceSelectionsContext", {
            countryId: $("#selectCountry")[0].options[t].value,
          });
      }
    },
    refreshCities: function () {
      var e = $("#selectState").prop("selectedIndex");
      if (e > -1) {
        var t = e,
          r = storeLocatorJSStore.getSavedProvinceSelectionIndex();
        null != r &&
          r != e &&
          ((t = r), ($("#selectState")[0].options[t].selected = !0)),
          wcRenderContext.updateRenderContext("citySelectionsContext", {
            provinceId: $("#selectState")[0].options[t].value,
          });
      }
    },
    refreshSearchResults: function (e) {
      var t = $("#selectCity").selectedIndex;
      if (t > -1) {
        var r = t,
          s = storeLocatorJSStore.getSavedCitySelectionIndex();
        null != s &&
          s != t &&
          ((r = s),
          ($("#selectCountry")[0].options[r].value("selectCity").options[
            r
          ].selected = !0));
        var a = PhysicalStoreCookieJSStore.getValueFromCookie("WC_stFind");
        null != a &&
          wcRenderContext.updateRenderContext("storeLocatorResultsContext", {
            cityId: document
              .getElementById("selectCountry")
              .options[r].value("selectCity").options[r].value,
            fromPage: e,
          });
      }
    },
    addPhysicalStore: function (e, t) {
      if (1 == PhysicalStoreCookieJSStore.isAddOneStoreIdExceedMax())
        return null !=
          document.getElementById("addPhysicalStoreToCookieButton" + t)
          ? (MessageHelper.formErrorHandleClient(
              "addPhysicalStoreToCookieButton" + t,
              MessageHelper.messages.EXCEED_PHYSICAL_STORE_SIZE
            ),
            !1)
          : (MessageHelper.displayErrorMessage(
              MessageHelper.messages.EXCEED_PHYSICAL_STORE_SIZE
            ),
            !1);
      if (submitRequest())
        return (
          cursor_wait(),
          PhysicalStoreCookieJSStore.addToCookie(e),
          storeLocatorJSStore.showRemoveOption(e),
          !0
        );
    },
    removePhysicalStore: function (e) {
      PhysicalStoreCookieJSStore.removeFromCookie(e),
        PhysicalStoreCookieJSStore.clearPickUpStoreIdFromCookie(e),
        storeLocatorJSStore.showAddOption(e);
    },
    showRemoveOption: function (e) {
      var t = $("#addPhysicalStoreToCookieDisabled" + e),
        r = $("#addPhysicalStoreToCookie" + e);
      null != t && "undefined" != t && $(t).css("display", "block"),
        null != r && "undefined" != r && $(r).css("display", "none");
    },
    showAddOption: function (e) {
      var t = $("#addPhysicalStoreToCookieDisabled" + e),
        r = $("#addPhysicalStoreToCookie" + e);
      null != t && "undefined" != t && $(t).css("display", "none"),
        null != r && "undefined" != r && $(r).css("display", "block");
    },
    manageCookieFromCity: function () {
      PhysicalStoreCookieJSStore.setValueToCookie("WC_stFind", 1);
    },
    refreshResultsFromCity: function (e, t) {
      return e.selectCity.selectedIndex < 0
        ? void MessageHelper.formErrorHandleClient(
            e.selectCity.id,
            MessageHelper.messages.MISSING_CITY
          )
        : (storeLocatorJSStore.manageCookieFromCity(),
          void wcRenderContext.updateRenderContext(
            "storeLocatorResultsContext",
            {
              cityId: e.selectCity.options[e.selectCity.selectedIndex].value,
              fromPage: t,
              geoCodeLatitude: "",
              geoCodeLongitude: "",
              errorMsgKey: "",
            }
          ));
    },
    refreshResultsFromNearest: function (e, t) {
      PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stCntry"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stProv"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stCity"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind"),
        wcRenderContext.updateRenderContext("storeLocatorResultsContext", {
          geoCodeLatitude: e,
          geoCodeLongitude: t,
          errorMsgKey: "",
        });
    },
    refreshResultsWithLocationError: function (e) {
      PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind"),
        wcRenderContext.updateRenderContext("storeLocatorResultsContext", {
          errorMsgKey: e,
        });
    },
    refreshStoreList: function (e) {
      wcRenderContext.updateRenderContext("selectedStoreListContext", {
        fromPage: e,
      });
    },
    removeFromStoreList: function (e, t) {
      var r = PhysicalStoreCookieJSStore.getNumStores();
      if (0 == r) this.refreshStoreList(e);
      else {
        var s = document.getElementById(t);
        s.remove();
      }
    },
    hideStoreList: function () {
      var e = $("#selectedStoreList"),
        t = $("#showStoreListHeader"),
        r = $("#hideStoreListHeader");
      null != e && "undefined" != e && $(e).css("display", "none"),
        null != t && "undefined" != t && $(t).css("display", "block"),
        null != r && "undefined" != r && $(r).css("display", "none");
    },
    showStoreList: function () {
      var e = $("#selectedStoreList"),
        t = $("#showStoreListHeader"),
        r = $("#hideStoreListHeader");
      null != e && "undefined" != e && $(e).css("display", "block"),
        null != t && "undefined" != t && $(t).css("display", "none"),
        null != r && "undefined" != r && $(r).css("display", "block");
    },
    changeCountrySelection: function (e) {
      PhysicalStoreCookieJSStore.setValueToCookie("WC_stCntry", e),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stProv"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stCity"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind"),
        wcRenderContext.updateRenderContext("provinceSelectionsContext", {
          countryId: e,
        });
    },
    changeProvinceSelection: function (e) {
      PhysicalStoreCookieJSStore.setValueToCookie("WC_stProv", e),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stCity"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind"),
        wcRenderContext.updateRenderContext("citySelectionsContext", {
          provinceId: e,
        });
    },
    changeCitySelection: function (e) {
      PhysicalStoreCookieJSStore.setValueToCookie("WC_stCity", e),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind");
    },
    getSavedCountrySelectionIndex: function () {
      var e = null,
        t = PhysicalStoreCookieJSStore.getValueFromCookie("WC_stCntry");
      if (null != t) {
        var r = $("#selectCountry");
        if (null != r && "undefined" != r) {
          var s = r.length;
          for (i = 0; i < s; i++)
            t == r[0].options[i].value && ((e = i), (i = s));
        }
      }
      return e;
    },
    getSavedProvinceSelectionIndex: function () {
      var e = null,
        t = PhysicalStoreCookieJSStore.getValueFromCookie("WC_stProv");
      if (null != t) {
        var r = $("#selectState");
        if (null != r && "undefined" != r) {
          var s = r.length;
          for (i = 0; i < s; i++)
            t == r[0].options[i].value && ((e = i), (i = s));
        }
      }
      return e;
    },
    getSavedCitySelectionIndex: function () {
      var e = null,
        t = PhysicalStoreCookieJSStore.getValueFromCookie("WC_stCity");
      if (null != t) {
        var r = $("#selectCity");
        if (null != r && "undefined" != r) {
          var s = r[0].options.length;
          for (i = 0; i < s; i++)
            t == r[0].options[i].value && ((e = i), (i = s));
        }
      }
      return e;
    },
  }),
  (StoreLocatorContextsJSStore = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    orderId: "",
    fromPage: "StoreLocator",
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.orderId = s),
        (this.fromPage = a);
    },
    setContextProperty: function (e, t, r) {
      wcRenderContext.getRenderContextProperties(e)[t] = r;
    },
  }),
  wcRenderContext.declare(
    "provinceSelectionsContext",
    ["provinceSelections"],
    ""
  ),
  wcRenderContext.declare("citySelectionsContext", ["citySelections"], ""),
  wcRenderContext.declare(
    "storeLocatorResultsContext",
    ["storeLocatorResults"],
    ""
  ),
  wcRenderContext.declare(
    "selectedStoreListContext",
    ["selectedStoreList"],
    ""
  ),
  (StoreLocatorControllersDeclarationJSStore = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    orderId: "",
    fromPage: "StoreLocator",
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.orderId = s),
        (this.fromPage = a);
    },
    provinceSelectionsRefreshArea: function () {
      var e = $("#provinceSelections"),
        t = wcRenderContext.getRenderContextProperties(
          "provinceSelectionsContext"
        );
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          cursor_wait(), e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          storeLocatorJSStore.refreshCities(), cursor_clear();
        },
      });
    },
    citySelectionsRefreshController: function () {
      var e = $("#citySelections"),
        t = wcRenderContext.getRenderContextProperties("citySelectionsContext");
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          cursor_wait(), e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function (e) {
          storeLocatorJSStore.refreshSearchResults(
            StoreLocatorControllersDeclarationJSStore.fromPage
          ),
            cursor_clear();
        },
      });
    },
    storeLocatorResultsRefreshController: function () {
      var e = $("#storeLocatorResults"),
        t = wcRenderContext.getRenderContextProperties(
          "storeLocatorResultsContext"
        );
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          cursor_wait(), e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          var e = $("#bopis_table");
          null != e && "undefined" != e && e.focus();
          var t = $("#no_store_message");
          null != t && "undefined" != t && t.focus(), cursor_clear();
        },
      });
    },
    selectedStoreListRefreshController: function () {
      var e = $("#selectedStoreList"),
        t = wcRenderContext.getRenderContextProperties(
          "selectedStoreListContext"
        );
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          cursor_wait(), e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          var e = $("#bopis_table");
          null != e && "undefined" != e && e.focus(), cursor_clear();
        },
      });
    },
  }),
  (AddressBookFormJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    addressDeleted: "false",
    addressNew: "false",
    pageVar: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    getControllerActionHandler: function (e, t) {
      console.debug(
        "entering getControllerActionHandler(controller, handlerKey, actionName): " +
          t
      );
      var r = AddressBookFormJS[t + "s"][e];
      return r
        ? function (e, t, s) {
            r(e, t, s);
          }
        : function (e, t, r) {
            console.debug("empty handler. This is a no-op");
          };
    },
    addressFormAreaActions: {
      create: function (e, t, r) {
        t.refresh(r.renderContext.properties),
          (r.renderContext.properties.addressFormAreaState = "create");
      },
      edit: function (e, t, r) {
        console.debug("starting to getting editing area"),
          t.refresh(r.renderContext.properties),
          (r.renderContext.properties.addressFormAreaState = "edit");
      },
      clean: function (e, t, r) {
        t.setInnerHTML(""),
          (r.renderContext.properties.addressFormAreaState = "clean");
      },
      handleModelChange: function (e, t, r) {
        t.setInnerHTML(""),
          (r.renderContext.properties.addressFormAreaState = "clean");
      },
    },
    addressDisplayAreaActions: {
      reload: function (e, t, r) {
        console.debug("reloading " + t), t.refresh(r.renderContext.properties);
      },
      handleModelChange: function (e, t, r) {
        console.debug("reloading " + t), t.refresh(r.renderContext.properties);
      },
    },
    statesDisplayAreaActions: {
      countryUpdated: function (e, t, r) {
        console.debug("IN countryUpdated handler: message = " + e);
        var s = r.renderContext.properties.paramPrefix;
        t.widgetId.match(s)
          ? (console.debug(
              "matchin paramPrefix: " + s + " refreshing " + t.widgetId
            ),
            t.refresh(r.renderContext.properties))
          : console.debug("no maching paramPrefix " + s);
      },
    },
    toggleAddressDisplay: function (e, t, r) {
      console.debug("toggle address display");
      var s = e.options[e.selectedIndex].value;
      $("." + t).each(function (e, t) {
        var a = r + s;
        t.id == a && "MyBillingAddress" != s
          ? $(t).css("display", "block")
          : $(t).css("display", "none");
      });
    },
    populateTextFields: function (e, t, r) {
      if ("block" == document.getElementById("adding").style.display) {
        var s = document.getElementById("adding");
        hideElementById(s);
        var a = document.getElementById("normal");
        a.style.display = "block";
      }
      for (
        var i = e.options[e.selectedIndex].value, n = r.sbAddress, o = 0;
        o < n.length;
        o++
      )
        n[o].value == t[i].addressType && (n[o].checked = "checked");
      (r.nickName.value = t[i].nickName),
        (r.firstName.value = t[i].firstName),
        (r.lastName.value = t[i].lastName),
        (r.address1.value = t[i].address1),
        (r.address2.value = t[i].address2),
        (r.country.value = t[i].country),
        (r.zipCode.value = t[i].zipCode),
        (r.email1.value = t[i].email1),
        (r.phone1.value = t[i].phone1),
        (r.city.value = t[i].city),
        AddressHelper.loadStatesUI("AddressForm", "", "stateDiv", "state"),
        (r.state.value = t[i].state),
        r.middleName && (r.middleName.value = t[i].middleName),
        (document.getElementById("addr_title").innerHTML =
          "<h2 class='status_msg'>" + t[i].nickName + "</h2>");
    },
    populateTextFieldsOnLoad: function (e, t, r) {
      for (
        var s = e.options[e.selectedIndex].value, a = r.sbAddress, i = 0;
        i < a.length;
        i++
      )
        a[i].value == t[s].addressType && (a[i].checked = "checked");
      (r.nickName.value = t[s].nickName),
        (r.firstName.value = t[s].firstName),
        (r.lastName.value = t[s].lastName),
        (r.address1.value = t[s].address1),
        (r.address2.value = t[s].address2),
        (r.state.value = t[s].state),
        (r.country.value = t[s].country),
        (r.zipCode.value = t[s].zipCode),
        (r.email1.value = t[s].email1),
        (r.phone1.value = t[s].phone1),
        (r.city.value = t[s].city),
        r.middleName && (r.middleName.value = t[s].middleName),
        AddressHelper.loadStatesUI("AddressForm", "", "stateDiv", "state", !0),
        (document.getElementById("addr_title").innerHTML =
          "<h2 class='status_msg'>" + t[s].nickName + "</h2>");
    },
    clearTextFields: function (e) {
      (e.nickName.value = ""),
        (e.firstName.value = ""),
        (e.lastName.value = ""),
        (e.address1.value = ""),
        (e.address2.value = ""),
        (e.city.value = ""),
        (e.state.value = ""),
        (e.country.value = ""),
        (e.zipCode.value = ""),
        (e.email1.value = ""),
        (e.phone1.value = ""),
        e.middleName && (e.middleName.value = "");
    },
    showAdd: function () {
      var e = document.getElementById("normal");
      hideElementById(e);
      var t = document.getElementById("adding");
      t.style.display = "block";
    },
    copyBillingFormNew: function (e, t) {
      var r = document.forms[e],
        s = document.forms[t],
        a = document.getElementById("SameShippingAndBillingAddress");
      a.checked &&
        (hideElementById("shippingAddressCreateEditFormDiv_1"),
        (s.firstName.value = r.firstName.value),
        (s.lastName.value = r.lastName.value),
        (s.address1.value = r.address1.value),
        (s.address2.value = r.address2.value),
        (s.city.value = r.city.value),
        isIE
          ? (document.getElementById("stateDiv2").firstChild.value =
              document.getElementById("stateDiv1").firstChild.value)
          : (s.state.value = r.state.value),
        (s.zipCode.value = r.zipCode.value),
        (s.country.value = r.country.value),
        (s.phone1.value = r.phone1.value),
        (s.email1.value = r.email1.value),
        r.middleName && (s.middleName.value = r.middleName.value)),
        a.checked ||
          (showElementById("shippingAddressCreateEditFormDiv_1"),
          (s.firstName.value = ""),
          (s.lastName.value = ""),
          (s.address1.value = ""),
          (s.address2.value = ""),
          (s.city.value = ""),
          isIE
            ? (document.getElementById("stateDiv2").firstChild.value = "")
            : (s.state.value = ""),
          (s.zipCode.value = ""),
          (s.phone1.value = ""),
          (s.email1.value = ""),
          s.middleName && (s.middleName.value = ""));
    },
  }),
  (LogonForm = {
    SubmitAjaxLogin: function (e) {
      this.validateAjaxLogin(e) &&
        submitRequest() &&
        (setDeleteCartCookie(), e.submit());
    },
    validateAjaxLogin: function (e) {
      return (
        (reWhiteSpace = new RegExp(/^\s+$/)),
        (null != e.logonId && reWhiteSpace.test(e.logonId.value)) ||
        "" == e.logonId.value
          ? (MessageHelper.formErrorHandleClient(
              e.logonId.id,
              MessageHelper.messages.LOGON_REQUIRED_FIELD_ENTER
            ),
            !1)
          : (null != e.logonPassword &&
              reWhiteSpace.test(e.logonPassword.value)) ||
            "" == e.logonPassword.value
          ? (MessageHelper.formErrorHandleClient(
              e.logonPassword.id,
              MessageHelper.messages.PASSWORD_REQUIRED_FIELD_ENTER
            ),
            !1)
          : !0
      );
    },
    prepareSubmit: function (e) {
      if (
        "true" == CSRWCParamJS.env_shopOnBehalfSessionEstablished ||
        "true" == CSRWCParamJS.env_shopOnBehalfEnabled_CSR
      ) {
        var t = Math.random(),
          r = t.toString(36).slice(-7),
          s = Math.floor(9 * t + 1);
        (r += s),
          (null == $("#logonPassword").val() ||
            "" == $("#logonPassword").val()) &&
            $("<input>")
              .attr({
                type: "hidden",
                value: r,
                name: "logonPassword",
                id: "logonPassword",
              })
              .appendTo("form"),
          (null == $("#logonPasswordVerify").val() ||
            "" == $("#logonPasswordVerify").val()) &&
            $("<input>")
              .attr({
                type: "hidden",
                value: r,
                name: "logonPasswordVerify",
                id: "logonPasswordVerify",
              })
              .appendTo("form"),
          (null == $("#passwordExpired").val() ||
            "" == $("#passwordExpired").val()) &&
            $("#passwordExpired").val("1");
      }
      this.validatePrepareForm(e) /*&& submitRequest()*/ &&
        (setCookie("WC_SHOW_USER_ACTIVATION_" + WCParamJS.storeId, "true", {
          path: "/",
          domain: cookieDomain,
        }),
        "true" == CSRWCParamJS.env_shopOnBehalfEnabled_CSR ||
        ("true" == CSRWCParamJS.env_shopOnBehalfSessionEstablished &&
          null != e.userId &&
          null != e.userId.value)
          ? null != registeredCustomersJS &&
            registeredCustomersJS.createRegisteredUser(e.landingURL_CSR.value)
          : e.submit());
    },
    validatePrepareForm: function (e) {
      if (
        ((reWhiteSpace = new RegExp(/^\s+$/)),
        (null != e.logonId && reWhiteSpace.test(e.logonId.value)) ||
          "" == e.logonId.value)
      )
        return (
          MessageHelper.formErrorHandleClient(
            e.logonId.id,
            MessageHelper.messages.ERROR_LogonIdEmpty
          ),
          !1
        );
      if (
        "function" == typeof this.validateLoginId &&
        !this.validateLoginId(e.logonId)
      )
        return !1;
      if (null != e.ancestorOrgs) {
        if ("" == e.ancestorOrgs.value)
          return (
            MessageHelper.formErrorHandleClient(
              e.ancestorOrgs.id,
              MessageHelper.messages.ERROR_OrgNameEmpty
            ),
            !1
          );
        if ("Default Organization" == e.ancestorOrgs.value)
          return (
            MessageHelper.formErrorHandleClient(
              e.ancestorOrgs.id,
              MessageHelper.messages.ERROR_DefaultOrgRegistration
            ),
            !1
          );
      }
      return (null != e.logonPassword &&
        reWhiteSpace.test(e.logonPassword.value)) ||
        "" == e.logonPassword.value
        ? (MessageHelper.formErrorHandleClient(
            e.logonPassword.id,
            MessageHelper.messages.ERROR_PasswordEmpty
          ),
          !1)
        : (null != e.logonPasswordVerify &&
            reWhiteSpace.test(e.logonPasswordVerify.value)) ||
          "" == e.logonPasswordVerify.value
        ? (MessageHelper.formErrorHandleClient(
            e.logonPasswordVerify.id,
            MessageHelper.messages.ERROR_VerifyPasswordEmpty
          ),
          !1)
        : e.logonPassword.value != e.logonPasswordVerify.value
        ? (MessageHelper.formErrorHandleClient(
            e.logonPasswordVerify.id,
            MessageHelper.messages.PWDREENTER_DO_NOT_MATCH
          ),
          !1)
        : AddressHelper.validateAddressForm(e)
        ? (e.sendMeEmail && e.sendMeEmail.checked
            ? (e.receiveEmail.value = !0)
            : (e.receiveEmail.value = !1),
          e.sendMeSMSNotification && e.sendMeSMSNotification.checked
            ? (e.receiveSMSNotification.value = !0)
            : (e.receiveSMSNotification.value = !1),
          e.sendMeSMSPreference && e.sendMeSMSPreference.checked
            ? (e.receiveSMS.value = !0)
            : (e.receiveSMS.value = !1),
          (null == e.mobileDeviceEnabled ||
            "true" != e.mobileDeviceEnabled.value ||
            MyAccountDisplay.validateMobileDevice(e)) &&
          (null == e.birthdayEnabled ||
            "true" != e.birthdayEnabled.value ||
            MyAccountDisplay.validateBirthday(e))
            ? !0
            : !1)
        : !1;
    },
    validateAge: function (e) {
      var t = parseInt(e.birth_year.value),
        r = parseInt(e.birth_month.value),
        s = parseInt(e.birth_date.value);
      if (0 != t && 0 != r && 0 != s) {
        var a = parseInt(e.curr_year.value),
          i = parseInt(e.curr_month.value),
          n = parseInt(e.curr_date.value);
        13 > a - t
          ? alert(MessageHelper.messages.AGE_WARNING_ALERT)
          : a - t == 13 &&
            (r > i
              ? alert(MessageHelper.messages.AGE_WARNING_ALERT)
              : i == r &&
                s > n &&
                alert(MessageHelper.messages.AGE_WARNING_ALERT));
      }
    },
    checkAge: function (e) {
      1 == e.age.value && alert(MessageHelper.messages.AGE_WARNING_ALERT);
    },
  }),
  (MultipleWishLists = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    defaultListId: null,
    addItemAfterCreate: !1,
    preferredDefaultWishListName: "",
    wishListPrefix: "",
    updateAfterSwitch: !1,
    maxCharsToDisplay: 30,
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    switchList: function (e) {
      submitRequest() &&
        (cursor_wait(),
        $("#multipleWishlistController_select").attr("disabled", "true"),
        (this.updateAfterSwitch = !0),
        this.setAsDefault(e));
    },
    updateContextPostSwitch: function (e) {
      this.updateAfterSwitch &&
        (wcRenderContext.updateRenderContext("WishlistDisplay_Context", {
          giftListId: e,
        }),
        wcRenderContext.updateRenderContext("WishlistSelect_Context", {
          giftListId: e,
        })),
        (this.updateAfterSwitch = !1);
    },
    removeItem: function (e) {
      var t = {};
      if (
        ((t.storeId = this.storeId),
        (t.catalogId = this.catalogId),
        (t.langId = this.langId),
        (t.quantity = 0),
        null != $("#multipleWishlistController_select") &&
          "undefined" != $("#multipleWishlistController_select") &&
          0 != $("#multipleWishlistController_select").val() &&
          ((t.giftListId = $("#multipleWishlistController_select").val()),
          !this.empty(e)))
      ) {
        if (((t.giftListItemId = e), !submitRequest())) return;
        cursor_wait(), wcService.invoke("ShoppingListServiceRemoveItem", t);
      }
    },
    getWishListIdForEmail: function (e) {
      var t = document.getElementById(e);
      null != $("#multipleWishlistController_select") &&
        "undefined" != $("#multipleWishlistController_select") &&
        0 != $("#multipleWishlistController_select").val() &&
        (t.giftListId.value = $("#multipleWishlistController_select").val());
    },
    checkSOAEmailForm: function (e) {
      $("#WishListEmailSucMsg_Div").css("display", "none");
      var t = document.getElementById(e);
      return (
        (t.sender_name.value = t.sender_name.value.replace(/^\s+/g, "")),
        (t.recipient.value = t.recipient.value.replace(/^\s+/g, "")),
        "" == t.recipient.value
          ? void MessageHelper.formErrorHandleClient(
              document.getElementById("SendWishListForm_Recipient_Email").id,
              Utils.getLocalizationMessage("WISHLIST_MISSINGEMAIL")
            )
          : MultipleWishLists.validateWishListEmailString(t.recipient.value)
          ? "" == t.sender_name.value
            ? void MessageHelper.formErrorHandleClient(
                document.getElementById("SendWishListForm_Sender_Name").id,
                Utils.getLocalizationMessage("WISHLIST_MISSINGNAME")
              )
            : MultipleWishLists.validateWishListEmailString(
                t.sender_email.value
              )
            ? "" == t.giftListId.value ||
              "false" == t.wishListHasItem.value ||
              "-1" == t.giftListId.value
              ? void MessageHelper.displayErrorMessage(
                  Utils.getLocalizationMessage("WISHLIST_EMPTY")
                )
              : MultipleWishLists.validateSenderName(t.sender_name.value)
              ? ((t.recipientEmail.value = t.recipient.value),
                (t.recipient.value = ""),
                (t.senderName.value = t.sender_name.value),
                "" != t.sender_email.value &&
                  (t.senderEmail.value = t.sender_email.value),
                "" != t.wishlist_message.value &&
                  (t.message.value = t.wishlist_message.value),
                void (
                  submitRequest() &&
                  (cursor_wait(),
                  wcService
                    .getServiceById("AjaxGiftListAnnouncement")
                    .setFormId(e),
                  wcService.invoke("AjaxGiftListAnnouncement"),
                  (t.senderEmail.value =
                    "SOAWishListEmail@SOAWishListEmail.com"),
                  (t.message.value = "SOAWishListEmail"))
                ))
              : ((t.sender_name.value = ""),
                void MessageHelper.displayErrorMessage(
                  Utils.getLocalizationMessage("WISHLIST_INVALIDSENDERNAME")
                ))
            : void MessageHelper.formErrorHandleClient(
                document.getElementById("SendWishListForm_Sender_Email").id,
                Utils.getLocalizationMessage("WISHLIST_INVALIDEMAILFORMAT")
              )
          : void MessageHelper.formErrorHandleClient(
              document.getElementById("SendWishListForm_Recipient_Email").id,
              Utils.getLocalizationMessage("WISHLIST_INVALIDEMAILFORMAT")
            )
      );
    },
    setAsDefault: function (e) {
      if ("-1" != e) {
        var t = {};
        (t.storeId = this.storeId),
          (t.catalogId = this.catalogId),
          (t.langId = this.langId),
          (t.giftListId = e),
          (t.giftListState = "Default"),
          cursor_wait(),
          wcService.invoke("AjaxGiftListServiceChangeGiftListStatus", t);
      } else
        MultipleWishLists.setDefaultListId("-1"),
          MultipleWishLists.updateContextPostSwitch("-1");
    },
    empty: function (e) {
      return null == e || void 0 == e || "" == e;
    },
    setDefaultListId: function (e) {
      this.defaultListId = e;
    },
    getDefaultListId: function () {
      return this.defaultListId;
    },
    setPreferredDefaultWishListName: function (e) {
      this.preferredDefaultWishListName = e;
    },
    setWishListPrefix: function (e) {
      this.wishListPrefix = e;
    },
    validateSenderName: function (e) {
      var t = "~!@#$%^&*()+=[]{};:,<>?/|`";
      t += "    '\"\\/";
      for (var r = 0; r < e.length; r++)
        if (t.indexOf(e.substring(r, r + 1)) >= 0) return !1;
      return !0;
    },
    validateWishListEmailString: function (e) {
      for (var t = !0, r = e.split(","), s = 0; s < r.length; s++)
        MessageHelper.isValidEmail(r[s]) || (t = !1);
      return t;
    },
  }),
  (MyAccountControllersDeclarationJS = {
    declareProcessedOrdersStatusDisplayRefreshArea: function () {
      var e = $("#ProcessedOrdersStatusDisplay"),
        t = wcRenderContext.getRenderContextProperties(
          "ProcessedOrdersStatusDisplay_Context"
        ),
        r = function () {
          wcRenderContext.testForChangedRC(
            "ProcessedOrdersStatusDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareWaitingForApprovalOrdersStatusDisplayRefreshArea: function () {
      var e = $("#WaitingForApprovalOrdersStatusDisplay"),
        t = wcRenderContext.getRenderContextProperties(
          "WaitingForApprovalOrdersStatusDisplay_Context"
        ),
        r = function () {
          wcRenderContext.testForChangedRC(
            "WaitingForApprovalOrdersStatusDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
  }),
  (MyAccountDisplay = {
    contextChanged: !1,
    isHistory: !1,
    currentSelection: "",
    currentTabId: "PreviouslyProcessed",
    isPreferredLanguageUpdated: !1,
    dropDownDlg: null,
    currentOrderTabId: "recurring_order_details",
    subscriptionDate: "",
    subscriptionOrderId: "",
    subscriptionOrderItemId: "",
    setPreferredLanguageUpdated: function (e) {
      this.isPreferredLanguageUpdated = e;
    },
    getPreferredLanguageUpdated: function () {
      return this.isPreferredLanguageUpdated;
    },
    setSubscriptionDate: function (e) {
      this.subscriptionDate = e;
    },
    getLastRecordInfo: function (e, t, r, s) {
      var a;
      r.split(";");
      return (
        s
          ? 1 == e || "" == e || void 0 == e
            ? (a = "" != t && void 0 != t ? t : " ")
            : "" != r &&
              void 0 != r &&
              (a =
                "" != t && void 0 != t
                  ? r.concat(";").concat(t)
                  : r.concat(";").concat(" "))
          : "" != r &&
            void 0 != r &&
            (a =
              r.lastIndexOf(";") > -1
                ? r.substring(0, r.lastIndexOf(";"))
                : ""),
        a
      );
    },
    updateRenderContextForPagination: function (e, t, r, s, a, i, n, o, d) {
      var l,
        c = this.getLastRecordInfo(a, i, n, o);
      (l = o ? parseInt(t) + parseInt(r) : parseInt(t) - parseInt(r)),
        wcRenderContext.updateRenderContext(e, {
          beginIndex: l,
          pageSize: r,
          isQuote: s,
          lastExternalOrderIds: c,
          recordSetTotal: d,
        });
    },
    escapeXML: function (e) {
      return e
        ? e
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/\"/g, "&quot;")
            .replace(/\'/g, "&#039;")
        : ProcessAuthoringConstants.EMPTY;
    },
    getSubscriptionDate: function () {
      var e = parseInt(this.subscriptionDate.substring(0, 4), 10),
        t = parseInt(this.subscriptionDate.substring(5, 7), 10),
        r = parseInt(this.subscriptionDate.substring(8, 10), 10);
      2 == t
        ? e % 4 == 0 && e % 100 != 0 && e % 400 == 0
          ? 29 != r
            ? ((r += 1), 10 > r && (r = "0" + r), (t = "02"))
            : ((r = "01"), (t = "03"))
          : 28 != r
          ? ((r += 1), 10 > r && (r = "0" + r), (t = "02"))
          : ((r = "01"), (t = "03"))
        : 12 == t
        ? 31 != r
          ? ((r += 1), 10 > r && (r = "0" + r), (t = "12"))
          : ((r = "01"), (t = "01"), (e += 1))
        : 4 == t || 6 == t || 9 == t || 11 == t
        ? (30 != r
            ? ((r += 1), 10 > r && (r = "0" + r))
            : ((r = "01"), (t += 1)),
          10 > t && (t = "0" + t))
        : (31 != r
            ? ((r += 1), 10 > r && (r = "0" + r))
            : ((r = "01"), (t += 1)),
          10 > t && (t = "0" + t));
      var s = this.subscriptionDate.indexOf("T", 0),
        a = this.subscriptionDate.indexOf("Z", s),
        i = this.subscriptionDate.substring(s + 1, a),
        n = e + "-" + t + "-" + r + "T" + i + "Z";
      return n;
    },
    setOff: function (e) {
      (document.getElementById(e + "_On").style.display = "none"),
        (document.getElementById(e + "_Off").style.display = "inline"),
        (document.getElementById(e).style.display = "none");
    },
    setOn: function (e) {
      (document.getElementById(e + "_On").style.display = "inline"),
        (document.getElementById(e + "_Off").style.display = "none"),
        (document.getElementById(e).style.display = "block");
    },
    selectTab: function (e) {
      (this.currentSelection = "trackOrderStatus"),
        this.setOff(this.currentTabId),
        this.setOn(e),
        (this.currentTabId = e);
    },
    prepareOrderCopy: function (e) {
      submitRequest() &&
        (cursor_wait(),
        wcService.getServiceById("OrderCopy").setUrl(e),
        wcService.invoke("OrderCopy"));
    },
    prepareSSFSOrderCopy: function (e) {
      submitRequest() &&
        (cursor_wait(),
        wcService.getServiceById("SSFSOrderCopy").setUrl(e),
        wcService.invoke("SSFSOrderCopy"));
    },
    prepareSubscriptionRenew: function (e) {
      submitRequest() &&
        (cursor_wait(),
        (wcService.getServiceById("SubscriptionRenew").url = e),
        wcService.invoke("SubscriptionRenew"));
    },
    cancelScheduledOrder: function (e) {
      if (submitRequest()) {
        cursor_wait();
        var t = [];
        (t.orderId = e),
          (t.URL = ""),
          (t.storeId = MyAccountServicesDeclarationJS.storeId),
          (t.catalogId = MyAccountServicesDeclarationJS.catalogId),
          (t.langId = MyAccountServicesDeclarationJS.langId),
          wcService.invoke("AjaxScheduledOrderCancel", t);
      }
    },
    changeSelection: function (e) {
      var t = e.indexOf("currentSelection", 0);
      if ("-1" != t)
        var r = e.indexOf("Slct", t),
          s = e.substring(t + 17, r);
      if (
        (this.currentSelection &&
          (document
            .getElementById(this.currentSelection)
            .setAttribute("class", ""),
          document
            .getElementById(this.currentSelection)
            .setAttribute("className", "")),
        (document.getElementById("MyAccountBreadcrumbLink").style.display =
          "none"),
        document.getElementById("RecurringOrderBreadcrumb") &&
          ((document.getElementById("RecurringOrderBreadcrumb").style.display =
            "none"),
          (document.getElementById("RecurringOrderBreadcrumb1").style.display =
            "none")),
        document.getElementById("SubscriptionBreadcrumb") &&
          ((document.getElementById("SubscriptionBreadcrumb").style.display =
            "none"),
          (document.getElementById("SubscriptionBreadcrumb1").style.display =
            "none")),
        document.getElementById("OrderHistoryBreadcrumb") &&
          ((document.getElementById("OrderHistoryBreadcrumb").style.display =
            "none"),
          (document.getElementById("OrderHistoryBreadcrumb1").style.display =
            "none")),
        s)
      )
        if ("trackOrderStatus" == s)
          document.getElementById("OrderHistoryBreadcrumb1").style.display =
            "inline";
        else if ("OrderDetail" == s) {
          document.getElementById("OrderHistoryBreadcrumb").style.display =
            "inline";
          var a = e.indexOf("breadCrumb", 0);
          if ("-1" != a)
            var i = e.indexOf("Brcmb", a),
              n = e.substring(a + 11, i);
          (n = n.replace(/%[0-9]*B/g, " ")),
            (document.getElementById(
              "OrderHistoryDetailBreadcrumbLink"
            ).innerHTML = n.replace(/\+/g, " "));
        } else if ("trackRecurringOrderStatus" == s)
          document.getElementById("RecurringOrderBreadcrumb1").style.display =
            "inline";
        else if ("RecurringOrderDetail" == s) {
          document.getElementById("RecurringOrderBreadcrumb").style.display =
            "inline";
          var a = e.indexOf("breadCrumb", 0);
          if ("-1" != a)
            var i = e.indexOf("Brcmb", a),
              n = e.substring(a + 11, i);
          (n = n.replace(/%[0-9]*B/g, " ")),
            (document.getElementById(
              "RecurringOrderDetailBreadcrumbLink"
            ).innerHTML = n.replace(/\+/g, " "));
        } else if ("trackSubscriptionStatus" == s)
          document.getElementById("SubscriptionBreadcrumb1").style.display =
            "inline";
        else if ("SubscriptionDetail" == s) {
          document.getElementById("SubscriptionBreadcrumb").style.display =
            "inline";
          var a = e.indexOf("breadCrumb", 0);
          if ("-1" != a)
            var i = e.indexOf("Brcmb", a),
              n = e.substring(a + 11, i);
          (n = n.replace(/%[0-9]*B/g, " ")),
            (document.getElementById(
              "SubscriptionDetailBreadcrumbLink"
            ).innerHTML = n.replace(/\+/g, " "));
        } else
          document.getElementById(s) &&
            ((document.getElementById("MyAccountBreadcrumbLink").style.display =
              "inline"),
            document.getElementById(s).setAttribute("class", "strong"),
            document.getElementById(s).setAttribute("className", "strong"),
            (this.currentSelection = s));
      else
        document.getElementById("MyAccountBreadcrumbLink").style.display =
          "inline";
    },
    prepareSubmit: function (e, t, r) {
      if (
        AddressHelper.validateAddressForm(e) &&
        (e.sendMeEmail && e.sendMeEmail.checked
          ? (e.receiveEmail.value = !0)
          : (e.receiveEmail.value = !1),
        e.sendMeSMSNotification && e.sendMeSMSNotification.checked
          ? (e.receiveSMSNotification.value = !0)
          : (e.receiveSMSNotification.value = !1),
        e.sendMeSMSPreference && e.sendMeSMSPreference.checked
          ? (e.receiveSMS.value = !0)
          : (e.receiveSMS.value = !1),
        (null == e.mobileDeviceEnabled ||
          "true" != e.mobileDeviceEnabled.value ||
          this.validateMobileDevice(e)) &&
          (null == e.birthdayEnabled ||
            "true" != e.birthdayEnabled.value ||
            this.validateBirthday(e)) &&
          submitRequest() &&
          (processAndSubmitForm(e),
          "true" != CSRWCParamJS.env_shopOnBehalfSessionEstablished))
      ) {
        var s = getCookie("WC_LogonUserId_" + WCParamJS.storeId);
        trim(s) != e.firstName.value + " " + e.lastName.value &&
          setCookie(
            "WC_LogonUserId_" + WCParamJS.storeId,
            e.firstName.value + " " + e.lastName.value,
            {
              path: "/",
              domain: cookieDomain,
            }
          );
      }
    },
    popupWindow: function (e) {
      window.open(e, "mywindow", "status=1,scrollbars=1,resizable=1");
    },
    deleteCoupon: function (e, t) {
      var r = document.forms[e];
      if (((r.couponId.value = t), (r.taskType.value = "D"), submitRequest())) {
        var s = wcService.getServiceById("AjaxRESTWalletCouponsDelete");
        s.setFormId(e),
          cursor_wait(),
          wcService.invoke("AjaxRESTWalletCouponsDelete");
      }
    },
    cancelRecurringOrder: function (e, t) {
      if (submitRequest()) {
        cursor_wait(),
          $("[data-widget-type='wc.WCDialog'][data-popupIndex='" + t + "']")
            .data("wc-WCDialog")
            .destroy();
        var r = {
          subscriptionId: e,
          URL: "",
          storeId: MyAccountServicesDeclarationJS.storeId,
          catalogId: MyAccountServicesDeclarationJS.catalogId,
          langId: MyAccountServicesDeclarationJS.langId,
        };
        wcService.invoke("AjaxCancelSubscription", r);
      }
    },
    updateContract: function (e, t, r) {
      var s = document.forms[e],
        a = !1;
      if (submitRequest()) {
        if (void 0 != s.contractId.length) {
          for (var i = 0; i < s.contractId.length; i++)
            if (s.contractId[i].checked) {
              a = !0;
              break;
            }
          if (!a) {
            for (var n = t.split(";"), o = 0; o < n.length; o++)
              document.getElementById(
                "WC_B2BMyAccountParticipantRole_checkbox_" + n[o]
              ).checked = !0;
            MessageHelper.displayErrorMessage(r), resetRequest();
          }
        } else
          s.contractId.checked
            ? (a = !0)
            : ((document.getElementById(
                "WC_B2BMyAccountParticipantRole_checkbox_" + s.contractId.value
              ).checked = !0),
              MessageHelper.displayErrorMessage(r),
              resetRequest());
        a && processAndSubmitForm(s);
      }
    },
    updateOrganization: function (e) {
      var t = document.forms[e];
      submitRequest() && processAndSubmitForm(t);
    },
    HistoryTracker: function (e, t, r) {
      (this.workAreaModeValue = e), (this.elementId = t), (this.changeUrl = r);
    },
    validateBirthday: function (e) {
      if (
        null != e.birth_year &&
        null != e.birth_month &&
        null != e.birth_date
      ) {
        if (
          0 != e.birth_year.value ||
          0 != e.birth_month.value ||
          0 != e.birth_date.value
        ) {
          if (0 == e.birth_month.value)
            return (
              MessageHelper.formErrorHandleClient(
                e.birth_month.id + "-button",
                MessageHelper.messages.ERROR_SpecifyMonth
              ),
              !1
            );
          if (0 == e.birth_date.value)
            return (
              MessageHelper.formErrorHandleClient(
                e.birth_date.id + "-button",
                MessageHelper.messages.ERROR_SpecifyDate
              ),
              !1
            );
          var t = 29;
          0 != e.birth_year.value && e.birth_year.value % 4 != 0 && (t = 28);
          for (var r = ["4", "6", "9", "11"], s = !1, a = 0; a < r.length; a++)
            if (r[a] == e.birth_month.value) {
              s = !0;
              break;
            }
          if (s && e.birth_date.value > 30)
            return (
              MessageHelper.formErrorHandleClient(
                e.birth_date.id + "-button",
                MessageHelper.messages.ERROR_InvalidDate1
              ),
              !1
            );
          if (2 == e.birth_month.value && e.birth_date.value > t)
            return (
              MessageHelper.formErrorHandleClient(
                e.birth_date.id + "-button",
                MessageHelper.messages.ERROR_InvalidDate1
              ),
              !1
            );
          if (
            null != e.curr_year &&
            null != e.curr_month &&
            null != e.curr_date
          ) {
            var i = parseInt(e.birth_year.value),
              n = parseInt(e.birth_month.value),
              o = parseInt(e.birth_date.value),
              d = parseInt(e.curr_year.value),
              l = parseInt(e.curr_month.value),
              c = parseInt(e.curr_date.value);
            if (i > d)
              return (
                MessageHelper.formErrorHandleClient(
                  e.birth_year.id + "-button",
                  MessageHelper.messages.ERROR_InvalidDate2
                ),
                !1
              );
            if (i == d && n > l)
              return (
                MessageHelper.formErrorHandleClient(
                  e.birth_month.id + "-button",
                  MessageHelper.messages.ERROR_InvalidDate2
                ),
                !1
              );
            if (i == d && n == l && o > c)
              return (
                MessageHelper.formErrorHandleClient(
                  e.birth_date.id + "-button",
                  MessageHelper.messages.ERROR_InvalidDate2
                ),
                !1
              );
            if (null != e.dateOfBirthTemp)
              if (0 != e.birth_month.value && 0 != e.birth_date.value) {
                var u = i,
                  m = n,
                  g = o;
                0 == i && (u = 1896),
                  10 > n && (m = "0" + n),
                  10 > o && (g = "0" + o),
                  (e.dateOfBirthTemp.value = u + "-" + m + "-" + g),
                  (document.getElementById(e.dateOfBirthTemp.id).name =
                    "dateOfBirth");
              } else e.dateOfBirthTemp.value = null;
          }
          return !0;
        }
        if (null != e.dateOfBirthTemp) {
          e.dateOfBirthTemp.value = "";
          if (null != document.getElementById(e.dateOfBirthTemp.id)) {
            document.getElementById(e.dateOfBirthTemp.id).name = "dateOfBirth";
          }
        }

        return (isGDPR && !gdpr_error) || !isGDPR;
      }
      return !0;
    },
    validateMobileDevice: function (e) {
      if (null != e.mobilePhone1 && "" != e.mobilePhone1) {
        if (!MessageHelper.isValidUTF8length(e.mobilePhone1.value, 32))
          return (
            MessageHelper.formErrorHandleClient(
              e.mobilePhone1.id,
              MessageHelper.messages.ERROR_PhoneTooLong
            ),
            !1
          );
        if (!MessageHelper.IsValidPhone(e.mobilePhone1.value))
          return (
            MessageHelper.formErrorHandleClient(
              e.mobilePhone1.id,
              MessageHelper.messages.ERROR_INVALIDPHONE
            ),
            !1
          );
      }
      return !0;
    },
    showActionsPopup: function (e, t) {
      if (null == e || e.keyCode == KeyCodes.DOWN_ARROW) {
        var r = $("#" + t).data("wc-WCDialog");
        r && ((this.dropDownDlg = r), this.dropDownDlg.open());
      }
    },
    showPopup: function (e, t, r, s) {
      var a = $("#Cancel_" + e + "_popup").data("wc-WCDialog");
      null != a
        ? (closeAllDialogs(),
          a.element.attr("data-popupIndex", r),
          a.open(),
          document
            .getElementById("Cancel_yes_" + e)
            .setAttribute(
              "onclick",
              "MyAccountDisplay.cancelRecurringOrder(" + t + "," + r + ");"
            ),
          document.getElementById("cancel_notice_" + e) &&
            document.getElementById(s) &&
            $("#cancel_notice_" + e).html($("#" + s).val()))
        : console.debug("Cancel_subscription_popup does not exist");
    },
    selectRecurringOrderTab: function (e) {
      this.setOff(this.currentOrderTabId),
        this.setOn(e),
        (this.currentOrderTabId = e);
    },
  }),
  (MyAccountServicesDeclarationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
  }),
  wcService.declare({
    id: "InterestItemDelete",
    actionId: "InterestItemDelete",
    url: "AjaxInterestItemDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.displayStatusMessage(
        MessageHelper.messages.WISHLIST_REMOVEITEM
      );
      for (var t in e) console.debug(t + "=" + e[t]);
      cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemAdd",
    actionId: "AjaxInterestItemAdd",
    url: "AjaxInterestItemAdd",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        cursor_clear(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.WISHLIST_ADDED
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "InterestItemListMessage",
    actionId: "InterestItemListMessage",
    url: "AjaxInterestItemListMessage",
    formId: "",
    successHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AddBillingAddress",
    actionId: "AddBillingAddress",
    url: "AjaxPersonChangeServiceAddressAdd",
    formId: "",
    successHandler: function (e) {
      CheckoutHelperJS.updateAddressIdForOrderItem(e.addressId);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
    },
  }),
  wcService.declare({
    id: "AddShippingAddress",
    actionId: "AddShippingAddress",
    url: "AjaxPersonChangeServiceAddressAdd",
    formId: "",
    successHandler: function (e) {
      CheckoutHelperJS.updateAddressIdForOrderItem(e.addressId);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
    },
  }),
  wcService.declare({
    id: "UpdateBillingAddress",
    actionId: "UpdateBillingAddress",
    url: "AjaxPersonChangeServiceAddressUpdate",
    formId: "",
    successHandler: function (e) {
      console.log("PSL::store.js::UpdateBillingAddress::successHandler::");
      CheckoutHelperJS.updateAddressIdForOrderItem(e.addressId);
      /* HB-407 BEGIN */
      resetRequest();
      javascript: AddressHelper.saveAddress(
        "UpdateShippingAddress",
        "shippingAddressCreateEditFormDiv_1"
      );
      /* HB-407 END */
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
    },
  }),
  wcService.declare({
    id: "UpdateShippingAddress",
    actionId: "UpdateShippingAddress",
    url: "AjaxPersonChangeServiceAddressUpdate",
    formId: "",
    successHandler: function (e) {
      console.log("store.js::UpdateShippingAddress::successHandler");
      CheckoutHelperJS.updateAddressIdForOrderItem(e.addressId);
    },
    failureHandler: function (e) {
      console.log("store.js::UpdateShippingAddress::failureHandler");
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
    },
  }),
  wcService.declare({
    id: "AjaxCouponsAddRemove",
    actionId: "AjaxCouponsAddRemove",
    url: "AjaxCouponsAddRemove",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxRESTWalletCouponsDelete",
    actionId: "AjaxCouponsAddRemove",
    url: "AjaxRESTWalletCouponsDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxWalletItemProcessServiceDelete",
    actionId: "AjaxWalletItemProcessServiceDelete",
    url: "AjaxWalletItemProcessServiceDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxCancelSubscription",
    actionId: "AjaxCancelSubscription",
    url: "AjaxRESTRecurringOrSubscriptionCancel",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        cursor_clear(),
        closeAllDialogs(),
        "RecurringOrder" == e.subscriptionType
          ? "PendingCancel" == e.state
            ? MessageHelper.displayStatusMessage(
                MessageHelper.messages.SCHEDULE_ORDER_PENDING_CANCEL_MSG
              )
            : MessageHelper.displayStatusMessage(
                MessageHelper.messages.SCHEDULE_ORDER_CANCEL_MSG
              )
          : "PendingCancel" == e.state
          ? MessageHelper.displayStatusMessage(
              MessageHelper.messages.SUBSCRIPTION_PENDING_CANCEL_MSG
            )
          : MessageHelper.displayStatusMessage(
              MessageHelper.messages.SUBSCRIPTION_CANCEL_MSG
            );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderCopy",
    actionId: "OrderCopy",
    url: "AjaxRESTOrderCopy",
    formId: "",
    successHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      if (null != e.newOrderItemsCount && e.newOrderItemsCount <= 0)
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.CANNOT_REORDER_ANY_MSG
        );
      else {
        setDeleteCartCookie();
        var r = [],
          s = "AjaxRESTOrderPrepare",
          a = [];
        (a.orderId = e.orderId),
          r.push({
            URL: "AjaxCheckoutDisplayView",
            requestType: "GET",
            requestParams: {},
          });
        var i = getCustomServiceForURLChaining(s, r, null);
        wcService.invoke(i.getParam("id"), a);
      }
    },
    failureHandler: function (e) {
      "_ERR_PROD_NOT_ORDERABLE" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.PRODUCT_NOT_BUYABLE
          )
        : "_ERR_INVALID_ADDR" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "SSFSOrderCopy",
    actionId: "SSFSOrderCopy",
    url: "AjaxSSFSOrderCopy",
    formId: "",
    successHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      setDeleteCartCookie(),
        (document.location.href = appendWcCommonRequestParameters(
          "AjaxCheckoutDisplayView?langId=" +
            MyAccountServicesDeclarationJS.langId +
            "&storeId=" +
            MyAccountServicesDeclarationJS.storeId +
            "&catalogId=" +
            MyAccountServicesDeclarationJS.catalogId
        ));
    },
    failureHandler: function (e) {
      "_ERR_PROD_NOT_ORDERABLE" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.PRODUCT_NOT_BUYABLE
          )
        : "_ERR_INVALID_ADDR" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.INVALID_CONTRACT
          )
        : e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "SubscriptionRenew",
    actionId: "SubscriptionRenew",
    url: "AjaxRESTOrderCopy",
    formId: "",
    successHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      var r = [];
      (r.storeId = MyAccountServicesDeclarationJS.storeId),
        (r.catalogId = MyAccountServicesDeclarationJS.catalogId),
        (r.langId = MyAccountServicesDeclarationJS.langId),
        (r.orderId = e.orderId),
        (r.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (r.requestedShipDate = MyAccountDisplay.getSubscriptionDate()),
        (MyAccountDisplay.subscriptionOrderId = e.orderId),
        (MyAccountDisplay.subscriptionOrderItemId = e.orderItemId[0]),
        wcService.invoke("SetRequestedShippingDate", r);
    },
    failureHandler: function (e) {
      "_ERR_PROD_NOT_ORDERABLE" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.PRODUCT_NOT_BUYABLE
          )
        : "_ERR_INVALID_ADDR" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.INVALID_CONTRACT
          )
        : e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "SetRequestedShippingDate",
    actionId: "SetRequestedShippingDate",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        (document.location.href = appendWcCommonRequestParameters(
          "RESTOrderPrepare?langId=" +
            MyAccountServicesDeclarationJS.langId +
            "&storeId=" +
            MyAccountServicesDeclarationJS.storeId +
            "&catalogId=" +
            MyAccountServicesDeclarationJS.catalogId +
            "&orderId=" +
            e.orderId +
            "&URL=AjaxCheckoutDisplayView?langId=" +
            MyAccountServicesDeclarationJS.langId +
            "&storeId=" +
            MyAccountServicesDeclarationJS.storeId +
            "&catalogId=" +
            MyAccountServicesDeclarationJS.catalogId
        ));
    },
    failureHandler: function (e) {
      if (
        "_ERR_ORDER_ITEM_FUTURE_SHIP_DATE_OVER_MAXOFFSET" == e.errorMessageKey
      ) {
        var t = [];
        (t.storeId = MyAccountServicesDeclarationJS.storeId),
          (t.catalogId = MyAccountServicesDeclarationJS.catalogId),
          (t.langId = MyAccountServicesDeclarationJS.langId),
          (t.orderId = MyAccountDisplay.subscriptionOrderId),
          (t.orderItemId = MyAccountDisplay.subscriptionOrderItemId),
          (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
          wcService.invoke("RemoveSubscriptionItem", t),
          MessageHelper.displayStatusMessage(
            MessageHelper.messages.CANNOT_RENEW_NOW_MSG
          );
      } else
        e.errorMessage
          ? MessageHelper.displayErrorMessage(e.errorMessage)
          : e.errorMessageKey &&
            MessageHelper.displayErrorMessage(e.errorMessageKey),
          cursor_clear();
    },
  }),
  wcService.declare({
    id: "RemoveSubscriptionItem",
    actionId: "RemoveSubscriptionItem",
    url: "AjaxRESTOrderItemDelete",
    formId: "",
    successHandler: function (e) {
      cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        e.errorCode && wcTopic.publish("OrderError", e),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxScheduledOrderCancel",
    actionId: "AjaxScheduledOrderCancel",
    url: "AjaxRESTRecurringOrSubscriptionCancel",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        cursor_clear(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.MO_ORDER_CANCELED_MSG
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  (QuickCheckoutProfile = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    pageVar: "aa",
    changed: "false",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    valueChanged: function (e) {
      QuickCheckoutProfile.changed = e;
    },
    validateForm: function (e) {
      reWhiteSpace = new RegExp(/^\s+$/);
      var t = document.forms[e],
        r = null;
      null != t.pay_expire_year &&
        (r = new Date(
          t.pay_expire_year.value,
          t.pay_expire_month.value - 1,
          1
        ));
      var s = t.curr_month.value;
      if (
        ((s = 1 == s.length ? "0" + s : t.curr_month.value),
        !AddressHelper.validateAddressForm(t, "billing_"))
      )
        return !1;
      if (!AddressHelper.validateAddressForm(t, "shipping_")) return !1;
      var a = $("#payMethodId");
      if (null != a.find(":selected").val()) {
        if (
          (null != t.pay_temp_account &&
            reWhiteSpace.test(t.pay_temp_account.value)) ||
          "" == t.pay_temp_account.value
        )
          return (
            MessageHelper.formErrorHandleClient(
              t.pay_temp_account.id,
              MessageHelper.messages.REQUIRED_FIELD_ENTER
            ),
            !1
          );
        if (
          ("true" == QuickCheckoutProfile.changed
            ? (t.pay_temp_account.name = "pay_account")
            : (QuickCheckoutProfile.changed = "false"),
          null != t.pay_expire_year &&
            t.pay_expire_year.value < t.curr_year.value)
        )
          return (
            MessageHelper.formErrorHandleClient(
              t.pay_expire_year.id,
              MessageHelper.messages.INVALID_EXPIRY_DATE
            ),
            !1
          );
        if (
          null != t.pay_expire_year &&
          t.pay_expire_year.value == t.curr_year.value &&
          s > t.pay_expire_month.value
        )
          return (
            MessageHelper.formErrorHandleClient(
              t.pay_expire_month.id,
              MessageHelper.messages.INVALID_EXPIRY_DATE
            ),
            !1
          );
      }
      return !0;
    },
    getCurrentProfile: function (e, t) {
      var r = $("input[name=" + t + "_firstName]")[0],
        s = $("input[name=" + t + "_lastName]")[0],
        a = $("input[name=" + t + "_address1]")[0],
        i = $("input[name=" + t + "_address2]")[0],
        n = $("input[name=" + t + "_zipCode]")[0],
        o = $("input[name=" + t + "_email1]")[0],
        d = $("input[name=" + t + "_phone1]")[0],
        l = $("input[name=" + t + "_city]")[0],
        c = "";
      $("input[name=" + t + "_middleName]")[0] &&
        (c = $("input[name=" + t + "_middleName]")[0]),
        (r.value = e.firstName),
        (s.value = e.lastName),
        (a.value = e.address1),
        (i.value = e.address2),
        (n.value = e.zipCode),
        (o.value = e.email1),
        (d.value = e.phone1),
        (l.value = e.city),
        c && (c.value = e.middleName);
      var u =
          t +
          "_WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_" +
          t +
          "_state_1",
        m = $("#" + u);
      if (
        ("" != e.state &&
          (void 0 !== m && null !== m
            ? (m.val(e.state), m.Select("refresh_noResizeButton"))
            : ((m = $("input[name=" + t + "_state]")[0].val()),
              m.val(e.state))),
        "" != e.country)
      ) {
        var g = $(
          "#WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_" +
            t +
            "_country_1"
        );
        g.val(e.country),
          g.Select("refresh_noResizeButton"),
          AddressHelper.loadAddressFormStatesUI(
            "QuickCheckout",
            t + "_",
            t + "_stateDiv",
            "WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_" +
              t +
              "_state_1",
            !1,
            e.state
          );
      }
    },
    showHide: function (e) {
      var t = document.getElementById("SameShippingAndBillingAddress");
      t.checked
        ? (hideElementById("shipAddr"), this.copyBillingAddress(e))
        : (showElementById("shipAddr"),
          ($("input[name=shipping_firstName]")[0].value = ""),
          ($("input[name=shipping_lastName]")[0].value = ""),
          ($("input[name=shipping_address1]")[0].value = ""),
          ($("input[name=shipping_address2]")[0].value = ""),
          ($("input[name=shipping_city]")[0].value = ""),
          ($("input[name=shipping_zipCode]")[0].value = ""),
          ($("input[name=shipping_phone1]")[0].value = ""),
          ($("input[name=shipping_email1]")[0].value = ""),
          ($("select,input[name=shipping_state]")[0].value = ""),
          $("input[name=shipping_middleName]")[0] &&
            ($("input[name=shipping_middleName]")[0].value = ""));
    },
    copyBillingAddress: function (e) {
      ($("input[name=shipping_firstName]")[0].value =
        e.billing_firstName.value),
        ($("input[name=shipping_lastName]")[0].value =
          e.billing_lastName.value),
        ($("input[name=shipping_address1]")[0].value =
          e.billing_address1.value),
        ($("input[name=shipping_address2]")[0].value =
          e.billing_address2.value),
        ($("input[name=shipping_city]")[0].value = e.billing_city.value),
        ($("input[name=shipping_zipCode]")[0].value = e.billing_zipCode.value),
        ($("input[name=shipping_phone1]")[0].value = e.billing_phone1.value),
        ($("input[name=shipping_email1]")[0].value = e.billing_email1.value),
        $("input[name=shipping_middleName]")[0] &&
          ($("input[name=shipping_middleName]")[0].value =
            e.billing_middleName.value);
      var t = $(
        "#WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_shipping_country_1"
      );
      t.val(e.billing_country.value),
        t.Select("refresh_noResizeButton"),
        AddressHelper.loadAddressFormStatesUI(
          "QuickCheckout",
          "shipping_",
          "shipping_stateDiv",
          "WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_shipping_state_1",
          !1,
          e.billing_state.value
        );
    },
    UpdateProfile: function (e) {
      var t = document.getElementById("SameShippingAndBillingAddress");
      if (
        (t.checked && this.copyBillingAddress(e), this.validateForm(e.name))
      ) {
        var r,
          s = $("#payMethodId");
        if (
          (0 !== s.length && (r = s.val()),
          (e.pay_payment_method.value = r),
          (e.pay_cc_brand.value = r),
          (e.pay_payMethodId.value = r),
          !submitRequest())
        )
          return;
        processAndSubmitForm(e);
      }
    },
  }),
  (sterlingIntegrationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    locale: "",
    jspStoreImgDir: "",
    orderBeingCanceled: "",
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        alert("-1 " + this.storeId),
        (this.catalogId = r),
        (this.locale = s),
        (this.jspStoreImgDir = a);
    },
    populateOrderLevelInfo: function (orderStr) {
      var jsonOrder = eval("(" + orderStr + ")"),
        locale = document.getElementById("Locale_String").innerHTML,
        shipmentType = 2;
      this.isNullObj(jsonOrder.Root.Order.shipmentTypeId) ||
        (shipmentType = jsonOrder.Root.Order.shipmentTypeId);
      var pmTotalNumber = 0;
      this.isNullObj(jsonOrder.Root.Order.countOfPaymentMethods) ||
        (pmTotalNumber = jsonOrder.Root.Order.countOfPaymentMethods);
      var oiTotalNumber = 1;
      if (
        (this.isNullObj(jsonOrder.Root.Order.countOfOrderLines) ||
          (oiTotalNumber = jsonOrder.Root.Order.countOfOrderLines),
        !this.isNullObj(jsonOrder.Root.Order.OrderNo))
      ) {
        var orderNo = jsonOrder.Root.Order.OrderNo;
        if (this.isNullObj(jsonOrder.Root.Order.EntryType))
          document.getElementById("OrderNo").innerHTML = orderNo;
        else {
          var entryType = jsonOrder.Root.Order.EntryType;
          "WCS" == entryType
            ? (document.getElementById("OrderNo").innerHTML =
                orderNo.substring(3))
            : (document.getElementById("OrderNo").innerHTML = orderNo);
        }
      }
      if (!this.isNullObj(jsonOrder.Root.Order.OrderDate)) {
        var orderDate = jsonOrder.Root.Order.OrderDate,
          parsedOrderDate = new Date(orderDate);
        document.getElementById("OrderDate").innerHTML = Globalize.formatDate(
          parsedOrderDate,
          {
            date: "long",
          }
        );
      }
      if (1 == shipmentType) {
        var shippingAddress = null,
          orderLinePersonInfoShipTo = null;
        this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine) ||
          (this.isNullObj(
            jsonOrder.Root.Order.OrderLines.OrderLine.PersonInfoShipTo
          )
            ? this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0]) ||
              this.isNullObj(
                jsonOrder.Root.Order.OrderLines.OrderLine[0].PersonInfoShipTo
              ) ||
              (orderLinePersonInfoShipTo =
                jsonOrder.Root.Order.OrderLines.OrderLine[0].PersonInfoShipTo)
            : (orderLinePersonInfoShipTo =
                jsonOrder.Root.Order.OrderLines.OrderLine.PersonInfoShipTo)),
          this.isNullObj(orderLinePersonInfoShipTo)
            ? this.isNullObj(jsonOrder.Root.Order.PersonInfoShipTo) ||
              this.populateAddress(
                jsonOrder.Root.Order.PersonInfoShipTo,
                "Single_Shipping_Address",
                locale
              )
            : this.populateAddress(
                orderLinePersonInfoShipTo,
                "Single_Shipping_Address",
                locale
              );
        var shippingMethod = null;
        if (
          (this.isNullObj(jsonOrder.Root.Order.Shipments) ||
            this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment) ||
            (this.isNullObj(
              jsonOrder.Root.Order.Shipments.Shipment.shipModeDescription
            )
              ? this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment[0]) ||
                this.isNullObj(
                  jsonOrder.Root.Order.Shipments.Shipment[0].shipModeDescription
                ) ||
                (shippingMethod =
                  jsonOrder.Root.Order.Shipments.Shipment[0]
                    .shipModeDescription)
              : (shippingMethod =
                  jsonOrder.Root.Order.Shipments.Shipment.shipModeDescription)),
          this.isNullObj(shippingMethod) &&
            (this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine) ||
              (this.isNullObj(
                jsonOrder.Root.Order.OrderLines.OrderLine.shipModeDescription
              )
                ? this.isNullObj(
                    jsonOrder.Root.Order.OrderLines.OrderLine[0]
                  ) ||
                  this.isNullObj(
                    jsonOrder.Root.Order.OrderLines.OrderLine[0]
                      .shipModeDescription
                  ) ||
                  (shippingMethod =
                    jsonOrder.Root.Order.OrderLines.OrderLine[0]
                      .shipModeDescription)
                : (shippingMethod =
                    jsonOrder.Root.Order.OrderLines.OrderLine
                      .shipModeDescription))),
          this.isNullObj(shippingMethod) &&
            (this.isNullObj(jsonOrder.Root.Order.CarrierServiceCode) ||
              (shippingMethod = jsonOrder.Root.Order.shipModeDescription)),
          this.isNullObj(shippingMethod) ||
            (document.getElementById("Single_Shipping_Method").innerHTML =
              shippingMethod),
          !this.isNullObj(
            document.getElementById("Single_Shipping_Instruction")
          ))
        ) {
          var instructions = null;
          if (
            (this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine) ||
              (this.isNullObj(
                jsonOrder.Root.Order.OrderLines.OrderLine.Instructions
              )
                ? this.isNullObj(
                    jsonOrder.Root.Order.OrderLines.OrderLine[0]
                  ) ||
                  this.isNullObj(
                    jsonOrder.Root.Order.OrderLines.OrderLine[0].Instructions
                  ) ||
                  (instructions =
                    jsonOrder.Root.Order.OrderLines.OrderLine[0].Instructions)
                : (instructions =
                    jsonOrder.Root.Order.OrderLines.OrderLine.Instructions)),
            !this.isNullObj(instructions) &&
              !this.isNullObj(instructions.Instruction))
          ) {
            var instruction = instructions.Instruction;
            if (this.isNullObj(instruction.InstructionType)) {
              if (!this.isNullObj(instructions.Instruction[0]))
                for (var k in instructions.Instruction)
                  this.isNullObj(instructions.Instruction[k].InstructionType) ||
                    ("SHIP" == instructions.Instruction[k].InstructionType &&
                      (this.isNullObj(
                        instructions.Instruction[k].InstructionText
                      ) ||
                        ((document.getElementById(
                          "Single_Shipping_Instruction_Label"
                        ).style.display = "inline"),
                        (document.getElementById(
                          "Single_Shipping_Instruction"
                        ).innerHTML =
                          document.getElementById("Single_Shipping_Instruction")
                            .innerHTML +
                          instructions.Instruction[k].InstructionText +
                          "<br/>"))));
            } else
              "SHIP" == instruction.InstructionType &&
                (this.isNullObj(instruction.InstructionText) ||
                  ((document.getElementById(
                    "Single_Shipping_Instruction_Label"
                  ).style.display = "inline"),
                  (document.getElementById(
                    "Single_Shipping_Instruction"
                  ).innerHTML = instruction.InstructionText)));
          }
        }
      }
      if (
        !this.isNullObj(document.getElementById("Shipping_As_Complete_Y")) &&
        !this.isNullObj(jsonOrder.Root.Order.IsShipComplete)
      ) {
        var shipAsComplete = jsonOrder.Root.Order.IsShipComplete;
        "Y" == shipAsComplete
          ? ((document.getElementById("Shipping_As_Complete_Y").style.display =
              "inline"),
            (document.getElementById("Shipping_As_Complete_N").style.display =
              "none"))
          : ((document.getElementById("Shipping_As_Complete_Y").style.display =
              "none"),
            (document.getElementById("Shipping_As_Complete_N").style.display =
              "inline"));
      }
      var currencyCode = "USD";
      this.isNullObj(jsonOrder.Root.Order.PriceInfo.Currency) ||
        (currencyCode = jsonOrder.Root.Order.PriceInfo.Currency);
      var currencyDecimals = 2;
      this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencyDecimal) ||
        (currencyDecimals = jsonOrder.Root.Order.PriceInfo.currencyDecimal);
      var currencySymbol = "$";
      this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencySymbol) ||
        (currencySymbol = jsonOrder.Root.Order.PriceInfo.currencySymbol),
        this.isNullObj(jsonOrder.Root.Order.OverallTotals.LineSubTotal) ||
          (document.getElementById("Order_SubTotal").innerHTML =
            this.formatCurrency(
              jsonOrder.Root.Order.OverallTotals.LineSubTotal,
              currencyDecimals,
              currencySymbol,
              currencyCode,
              locale
            ));
      var grandDiscount = jsonOrder.Root.Order.OverallTotals.GrandDiscount;
      this.isNullObj(grandDiscount) ||
        (grandDiscount > 0 && (grandDiscount = 0 - grandDiscount),
        (document.getElementById("Order_Discount").innerHTML =
          this.formatCurrency(
            grandDiscount,
            currencyDecimals,
            currencySymbol,
            currencyCode,
            locale
          ))),
        this.isNullObj(
          jsonOrder.Root.Order.OverallTotals.GrandShippingBaseCharge
        ) ||
          (document.getElementById("Order_Shipping").innerHTML =
            this.formatCurrency(
              jsonOrder.Root.Order.OverallTotals.GrandShippingBaseCharge,
              currencyDecimals,
              currencySymbol,
              currencyCode,
              locale
            )),
        this.isNullObj(jsonOrder.Root.Order.OverallTotals.salesTax) ||
          (document.getElementById("Order_Tax").innerHTML = this.formatCurrency(
            jsonOrder.Root.Order.OverallTotals.salesTax,
            currencyDecimals,
            currencySymbol,
            currencyCode,
            locale
          )),
        this.isNullObj(jsonOrder.Root.Order.OverallTotals.shippingTax) ||
          (document.getElementById("Order_ShippingTax").innerHTML =
            this.formatCurrency(
              jsonOrder.Root.Order.OverallTotals.shippingTax,
              currencyDecimals,
              currencySymbol,
              currencyCode,
              locale
            )),
        this.isNullObj(jsonOrder.Root.Order.OverallTotals.GrandTotal) ||
          (document.getElementById("Order_Totals").innerHTML =
            this.formatCurrency(
              jsonOrder.Root.Order.OverallTotals.GrandTotal,
              currencyDecimals,
              currencySymbol,
              currencyCode,
              locale
            )),
        0 == pmTotalNumber &&
          (this.isNullObj(jsonOrder.Root.Order.PersonInfoBillTo) ||
            this.populateAddress(
              jsonOrder.Root.Order.PersonInfoBillTo,
              "Billing_Address_With_No_Payment_Method",
              locale
            ));
      for (var i = 0; pmTotalNumber > i; i++) {
        var paymentMethod = null;
        (paymentMethod =
          1 == pmTotalNumber
            ? jsonOrder.Root.Order.PaymentMethods.PaymentMethod
            : jsonOrder.Root.Order.PaymentMethods.PaymentMethod[i]),
          this.isNullObj(paymentMethod.PersonInfoBillTo)
            ? this.isNullObj(jsonOrder.Root.Order.PersonInfoBillTo) ||
              this.populateAddress(
                jsonOrder.Root.Order.PersonInfoBillTo,
                "Billing_Address_" + i,
                locale
              )
            : this.populateAddress(
                paymentMethod.PersonInfoBillTo,
                "Billing_Address_" + i,
                locale
              ),
          this.isNullObj(paymentMethod.paymentMethodName) ||
            (document.getElementById("Payment_Method_Name_" + i).innerHTML =
              paymentMethod.paymentMethodName),
          this.isNullObj(paymentMethod.PaymentType) ||
            ("CREDIT_CARD" == paymentMethod.PaymentType &&
              ((document.getElementById("Div_CreditCard_" + i).style.display =
                "inline"),
              (document.getElementById("Div_Check_" + i).style.display =
                "none"),
              (document.getElementById("Div_LineOfCredit_" + i).style.display =
                "none"),
              this.isNullObj(paymentMethod.DisplayCreditCardNo) ||
                (document.getElementById("CreditCard_Account_" + i).innerHTML =
                  "************" + paymentMethod.DisplayCreditCardNo),
              this.isNullObj(paymentMethod.CreditCardExpDate) ||
                ((document.getElementById(
                  "CreditCard_Expiration_Month_" + i
                ).innerHTML = paymentMethod.CreditCardExpDate.substring(0, 2)),
                (document.getElementById(
                  "CreditCard_Expiration_Year_" + i
                ).innerHTML = paymentMethod.CreditCardExpDate.substring(
                  3,
                  7
                )))),
            "Check" == paymentMethod.PaymentType &&
              ((document.getElementById("Div_CreditCard_" + i).style.display =
                "none"),
              (document.getElementById("Div_Check_" + i).style.display =
                "inline"),
              (document.getElementById("Div_LineOfCredit_" + i).style.display =
                "none"),
              this.isNullObj(paymentMethod.DisplayPaymentReference1) ||
                (document.getElementById("Check_Account_" + i).innerHTML =
                  "************" + paymentMethod.DisplayPaymentReference1)),
            "LineOfCreidt" == paymentMethod.PaymentType &&
              ((document.getElementById("Div_CreditCard_" + i).style.display =
                "none"),
              (document.getElementById("Div_Check_" + i).style.display =
                "none"),
              (document.getElementById("Div_LineOfCredit_" + i).style.display =
                "inline"),
              this.isNullObj(paymentMethod.DisplayCustomerAccountNo) ||
                (document.getElementById(
                  "LineOfCredit_Account_" + i
                ).innerHTML =
                  "************" + paymentMethod.DisplayCustomerAccountNo)),
            this.isNullObj(paymentMethod.MaxChargeLimit) ||
              (document.getElementById("Payment_Method_Amount_" + i).innerHTML =
                this.formatCurrency(
                  paymentMethod.MaxChargeLimit,
                  currencyDecimals,
                  currencySymbol,
                  currencyCode,
                  locale
                )));
      }
    },
    populateAddress: function (e, t, r) {
      var s = "";
      this.isNullObj(e.AddressID) || (s = e.AddressID);
      var a = "";
      this.isNullObj(e.FirstName) || (a = e.FirstName);
      var i = "";
      this.isNullObj(e.MiddleName) || (i = e.MiddleName);
      var n = "";
      this.isNullObj(e.LastName) || (n = e.LastName);
      var o = "";
      this.isNullObj(e.AddressLine1) || (o = e.AddressLine1);
      var d = "";
      this.isNullObj(e.AddressLine2) || (d = e.AddressLine2);
      var l = "";
      this.isNullObj(e.City) || (l = e.City);
      var c = "";
      this.isNullObj(e.stateDisplayName) || (c = e.stateDisplayName);
      var u = "";
      this.isNullObj(e.countryDisplayName) || (u = e.countryDisplayName);
      var m = "";
      this.isNullObj(e.ZipCode) || (m = e.ZipCode);
      var g = "";
      this.isNullObj(e.DayPhone) || (g = e.DayPhone);
      var p = "";
      this.isNullObj(e.EMailID) || (p = e.EMailID);
      var h = "<p>" + s + "</p>";
      "ar_EG" == r
        ? ((a.length > 0 || i.length > 0 || n.length > 0) &&
            (h = h + a + "&nbsp;" + i + "&nbsp;" + n + "<br />"),
          (o.length > 0 || d.length > 0) &&
            (h = h + o + "&nbsp;" + d + "<br />"),
          l.length > 0 && (h = h + l + "<br />"),
          c.length > 0 && (h = h + c + "<br />"),
          u.length > 0 && (h = h + u + "<br />"),
          g.length > 0 && (h = h + g + "<br />"))
        : "ja_JP" == r || "ko_KR" == r || "zh_CN" == r || "zh_TW" == r
        ? ((n.length > 0 || a.length > 0) &&
            (h = h + n + "&nbsp;" + a + "<br />"),
          (u.length > 0 || m.length > 0) &&
            (h = h + u + "&nbsp;" + m + "&nbsp;<br />"),
          (c.length > 0 || l.length > 0) &&
            (h = h + c + "&nbsp;" + l + "&nbsp;<br />"),
          (o.length > 0 || d.length > 0) &&
            (h = h + o + "&nbsp;" + d + "<br />"),
          g.length > 0 && (h = h + g + "<br />"))
        : "de_DE" == r ||
          "es_ES" == r ||
          "fr_FR" == r ||
          "it_IT" == r ||
          "pl_PL" == r ||
          "ro_RO" == r ||
          "ru_RU" == r
        ? ((a.length > 0 || i.length > 0 || n.length > 0) &&
            (h = h + a + "&nbsp;" + i + "&nbsp;" + n + "<br />"),
          (o.length > 0 || d.length > 0) &&
            (h = h + o + "&nbsp;" + d + "<br />"),
          (m.length > 0 || l.length > 0) &&
            (h = h + m + "&nbsp;" + l + "&nbsp;<br />"),
          c.length > 0 && (h = h + c + "<br />"),
          u.length > 0 && (h = h + u + "<br />"),
          g.length > 0 && (h = h + g + "<br />"))
        : ((a.length > 0 || n.length > 0) &&
            (h = h + a + "&nbsp;" + n + "<br />"),
          (o.length > 0 || d.length > 0) &&
            (h = h + o + "&nbsp;" + d + "<br />"),
          (l.length > 0 || c.length > 0) &&
            (h = h + l + "&nbsp;" + c + "&nbsp;<br />"),
          (u.length > 0 || m.length > 0) &&
            (h = h + u + "&nbsp;" + m + "&nbsp;<br />"),
          g.length > 0 && (h = h + g + "<br />"),
          p.length > 0 && (h = h + p + "<br />")),
        (document.getElementById(t).innerHTML = h);
    },
    isNullObj: function (e) {
      return null != e && void 0 != typeof e ? !1 : !0;
    },
    formatCurrency: function (e, t, r, s, a) {
      return Utils.formatCurrency(e, {
        minimumFractionDigits: parseInt(t),
        maximumFractionDigits: parseInt(t),
        currency: s,
        locale: a,
      });
    },
    revertAllSpecialChars: function (e) {
      return this.isNullObj(e)
        ? e
        : e
            .replace(/&#62;/g, ">")
            .replace(/&#60;/g, "<")
            .replace(/&#39;/g, "'")
            .replace(/&#34;/g, '"')
            .replace(/&#92;/g, "\\")
            .replace(/&#38;/g, "&");
    },
    populateOrderLineInfoForSingleShipment: function (
      orderStr,
      beginIndex,
      pageSize
    ) {
      if (null != orderStr && "" !== orderStr) {
        orderStr = orderStr.replace("'", "27%");
        var jsonOrder = eval("(" + orderStr + ")"),
          imgDir = document.getElementById("Image_Dir").innerHTML,
          endIndex = document.getElementById("endIndex").innerHTML,
          locale = document.getElementById("Locale_String_S").innerHTML,
          orderLineNum = 1;
        if (
          (this.isNullObj(jsonOrder.Root.Order.countOfOrderLines) ||
            (orderLineNum = jsonOrder.Root.Order.countOfOrderLines),
          "TBODY" ==
            document.getElementById("order_details").childNodes[0].tagName)
        )
          var parentTable =
            document.getElementById("order_details").childNodes[0];
        else if (
          "TBODY" ==
          document.getElementById("order_details").childNodes[1].tagName
        )
          var parentTable =
            document.getElementById("order_details").childNodes[1];
        for (var i = beginIndex; endIndex > i; i++) {
          var orderLine = null;
          orderLine =
            1 == orderLineNum
              ? this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0])
                ? jsonOrder.Root.Order.OrderLines.OrderLine
                : jsonOrder.Root.Order.OrderLines.OrderLine[0]
              : jsonOrder.Root.Order.OrderLines.OrderLine[i];
          var nobottom = null;
          this.isNullObj(orderLine.CalculationCodes) ||
            this.isNullObj(orderLine.CalculationCodes.CalculationCode) ||
            (nobottom = "th_align_left_no_bottom"),
            this.isNullObj(nobottom) ||
              (document
                .getElementById("SingleShipment_rowHeader_product" + i)
                .setAttribute(
                  "class",
                  document
                    .getElementById("SingleShipment_rowHeader_product" + i)
                    .getAttribute("class") + nobottom
                ),
              document
                .getElementById("SingleShipment_rowHeader_product" + i)
                .setAttribute(
                  "className",
                  document
                    .getElementById("SingleShipment_rowHeader_product" + i)
                    .getAttribute("className") + nobottom
                ),
              this.isNullObj(
                document.getElementById(
                  "WC_OrderItemDetailsSummaryf_td_requestedShippingDate_" + i
                )
              ) ||
                (document
                  .getElementById(
                    "WC_OrderItemDetailsSummaryf_td_requestedShippingDate_" + i
                  )
                  .setAttribute(
                    "class",
                    document
                      .getElementById(
                        "WC_OrderItemDetailsSummaryf_td_requestedShippingDate_" +
                          i
                      )
                      .getAttribute("class") + nobottom
                  ),
                document
                  .getElementById(
                    "WC_OrderItemDetailsSummaryf_td_requestedShippingDate_" + i
                  )
                  .setAttribute(
                    "className",
                    document
                      .getElementById(
                        "WC_OrderItemDetailsSummaryf_td_requestedShippingDate_" +
                          i
                      )
                      .getAttribute("className") + nobottom
                  )),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_1_" + i)
                .setAttribute(
                  "class",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_1_" + i)
                    .getAttribute("class") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_1_" + i)
                .setAttribute(
                  "className",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_1_" + i)
                    .getAttribute("className") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_2_" + i)
                .setAttribute(
                  "class",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_2_" + i)
                    .getAttribute("class") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_2_" + i)
                .setAttribute(
                  "className",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_2_" + i)
                    .getAttribute("className") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_3_" + i)
                .setAttribute(
                  "class",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_3_" + i)
                    .getAttribute("class") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_3_" + i)
                .setAttribute(
                  "className",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_3_" + i)
                    .getAttribute("className") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_4_" + i)
                .setAttribute(
                  "class",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_4_" + i)
                    .getAttribute("class") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_4_" + i)
                .setAttribute(
                  "className",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_4_" + i)
                    .getAttribute("className") + nobottom
                ));
          var catEntryName = null,
            thumbNail = null,
            objectPath = null,
            itemID = null;
          if (
            (this.isNullObj(orderLine.Item.CatalogEntry) ||
              (this.isNullObj(orderLine.Item.CatalogEntry.objectPath) ||
                (objectPath = orderLine.Item.CatalogEntry.objectPath),
              this.isNullObj(
                orderLine.Item.CatalogEntry.CatalogEntryDescription
              ) ||
                (this.isNullObj(
                  orderLine.Item.CatalogEntry.CatalogEntryDescription
                    .catalogEntryName
                ) ||
                  (catEntryName =
                    orderLine.Item.CatalogEntry.CatalogEntryDescription
                      .catalogEntryName),
                this.isNullObj(
                  orderLine.Item.CatalogEntry.CatalogEntryDescription.thumbNail
                ) ||
                  (thumbNail =
                    orderLine.Item.CatalogEntry.CatalogEntryDescription
                      .thumbNail))),
            this.isNullObj(orderLine.Item.ItemID) ||
              (itemID = orderLine.Item.ItemID),
            this.isNullObj(thumbNail)
              ? document
                  .getElementById("Product_Thumbnail_" + i)
                  .setAttribute("src", imgDir + "images/NoImageIcon_sm.jpg")
              : ((thumbNail = this.revertAllSpecialChars(thumbNail)),
                this.isNullObj(objectPath)
                  ? document
                      .getElementById("Product_Thumbnail_" + i)
                      .setAttribute("src", thumbNail)
                  : ((objectPath = this.revertAllSpecialChars(objectPath)),
                    document
                      .getElementById("Product_Thumbnail_" + i)
                      .setAttribute("src", objectPath + thumbNail))),
            this.isNullObj(catEntryName) ||
              (document
                .getElementById("SingleShipment_rowHeader_product" + i)
                .setAttribute(
                  "abbr",
                  document
                    .getElementById("SingleShipment_rowHeader_product" + i)
                    .getAttribute("abbr") + catEntryName
                ),
              document
                .getElementById("Product_Thumbnail_" + i)
                .setAttribute("alt", catEntryName),
              (document.getElementById("Catalog_Entry_Name_" + i).innerHTML =
                catEntryName)),
            this.isNullObj(itemID) ||
              (document.getElementById("Catalog_Entry_SKU_" + i).innerHTML =
                itemID),
            !this.isNullObj(orderLine.Item.CatalogEntry) &&
              !this.isNullObj(
                orderLine.Item.CatalogEntry.catalogEntryAttributes
              ))
          ) {
            document.getElementById(
              "Catalog_Entry_Defining_Attributes_" + i
            ).style.display = "inline";
            for (var dAttr in orderLine.Item.CatalogEntry.catalogEntryAttributes
              .catalogEntryAttribute)
              document.getElementById(
                "Catalog_Entry_Defining_Attributes_" + i
              ).innerHTML =
                document.getElementById(
                  "Catalog_Entry_Defining_Attributes_" + i
                ).innerHTML +
                orderLine.Item.CatalogEntry.catalogEntryAttributes
                  .catalogEntryAttribute[dAttr].catalogEntryAttrName +
                ":" +
                orderLine.Item.CatalogEntry.catalogEntryAttributes
                  .catalogEntryAttribute[dAttr].catalogEntryAttrValue +
                "<br/>";
          }
          if (!this.isNullObj(orderLine.componentNames)) {
            var dkLabel = document.getElementById(
              "Dynamic_Kit_Components_Label_" + i
            );
            this.isNullObj(dkLabel) ||
              (document.getElementById(
                "Dynamic_Kit_Components_Label_" + i
              ).style.display = "inline");
            var ulForDK = document.getElementById(
              "Dynamic_Kit_Components_" + i
            );
            if (!this.isNullObj(ulForDK)) {
              var compNames = orderLine.componentNames.split(",");
              for (var j in compNames) {
                var li = document.createElement("li");
                (li.innerHTML = compNames[j]), ulForDK.appendChild(li);
              }
            }
          }
          if (
            !this.isNullObj(
              document.getElementById("Order_Item_Requested_Ship_Date_" + i)
            ) &&
            !this.isNullObj(orderLine.ReqShipDate)
          ) {
            var parsedReqShipDate = new Date(orderLine.ReqShipDate);
            document.getElementById(
              "Order_Item_Requested_Ship_Date_" + i
            ).innerHTML = Globalize.formatDate(parsedReqShipDate, {
              date: "long",
            });
          }
          this.isNullObj(orderLine.MaxLineStatus) ||
            (document.getElementById("Order_Item_Status_" + i).innerHTML =
              Utils.getLocalizationMessage(
                "ORDER_LINE_STATUS_" + orderLine.MaxLineStatus
              )),
            this.isNullObj(orderLine.OrderedQty) ||
              (document.getElementById("Order_Item_Quantity_" + i).innerHTML =
                Utils.formatNumber(orderLine.OrderedQty, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }));
          var currencyCode = "USD";
          this.isNullObj(jsonOrder.Root.Order.PriceInfo.Currency) ||
            (currencyCode = jsonOrder.Root.Order.PriceInfo.Currency);
          var currencyDecimals = 2;
          this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencyDecimal) ||
            (currencyDecimals = jsonOrder.Root.Order.PriceInfo.currencyDecimal);
          var currencySymbol = "$";
          this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencySymbol) ||
            (currencySymbol = jsonOrder.Root.Order.PriceInfo.currencySymbol),
            this.isNullObj(orderLine.LinePriceInfo.UnitPrice) ||
              (document.getElementById("Order_Item_Unit_Price_" + i).innerHTML =
                this.formatCurrency(
                  orderLine.LinePriceInfo.UnitPrice,
                  currencyDecimals,
                  currencySymbol,
                  currencyCode,
                  locale
                ));
          var isFree = !1;
          if (
            !this.isNullObj(orderLine.Awards) &&
            !this.isNullObj(orderLine.Awards.Award)
          )
            if (this.isNullObj(orderLine.Awards.Award.AwardType)) {
              if (!this.isNullObj(orderLine.Awards.Award[0]))
                for (var award in orderLine.Awards.Award)
                  if ("FreeGift" == orderLine.Awards.Award[award].AwardType) {
                    isFree = !0;
                    break;
                  }
            } else
              "FreeGift" == orderLine.Awards.Award.AwardType && (isFree = !0);
          if (
            (1 == isFree
              ? ((document.getElementById(
                  "Order_Item_Total_Price_Free_" + i
                ).style.display = "inline"),
                (document.getElementById(
                  "Order_Item_Total_Price_" + i
                ).style.display = "none"))
              : ((document.getElementById(
                  "Order_Item_Total_Price_Free_" + i
                ).style.display = "none"),
                (document.getElementById(
                  "Order_Item_Total_Price_" + i
                ).style.display = "inline"),
                this.isNullObj(orderLine.ComputedPrice.ExtendedPrice) ||
                  (document.getElementById(
                    "Order_Item_Total_Price_" + i
                  ).innerHTML = this.formatCurrency(
                    orderLine.ComputedPrice.ExtendedPrice,
                    currencyDecimals,
                    currencySymbol,
                    currencyCode,
                    locale
                  ))),
            !this.isNullObj(orderLine.CalculationCodes))
          ) {
            var counter = 0;
            for (var j in orderLine.CalculationCodes.CalculationCode) {
              var calCode = orderLine.CalculationCodes.CalculationCode[j],
                code = calCode.code;
              code = this.revertAllSpecialChars(code);
              var tr = document.createElement("tr");
              parentTable.insertBefore(
                tr,
                document.getElementById("Product_Line_" + (parseInt(i) + 1))
              );
              var th = document.createElement("th");
              th.setAttribute("colSpan", "4"),
                th.setAttribute(
                  "class",
                  "th_align_left_dotted_top_solid_bottom"
                ),
                th.setAttribute(
                  "className",
                  "th_align_left_dotted_top_solid_bottom"
                );
              var abbrText = document.getElementById(
                "Product_Discount_Text"
              ).innerHTML;
              th.setAttribute("abbr", abbrText + catEntryName),
                th.setAttribute(
                  "id",
                  "SingleShipment_rowHeader_discount" + i + "_" + counter
                ),
                tr.appendChild(th);
              var div = document.createElement("div");
              div.setAttribute(
                "id",
                "WC_OrderItemDetailsSummaryf_div_3_" + i + "_" + counter
              ),
                div.setAttribute("class", "itemspecs"),
                div.setAttribute("className", "itemspecs"),
                th.appendChild(div);
              var a = document.createElement("a");
              a.setAttribute("class", "discount hover_underline"),
                a.setAttribute("className", "discount hover_underline"),
                a.setAttribute(
                  "id",
                  "WC_OrderItemDetails_Link_ItemDiscount_1_" + i + "_" + counter
                );
              var url_innerHTML =
                document.getElementById("Promotion_Url").innerHTML;
              this.isNullObj(url_innerHTML) ||
                (url_innerHTML = url_innerHTML.replace(/&amp;/g, "&"));
              var promotionUrl =
                url_innerHTML + "&code=" + encodeURIComponent(code);
              a.setAttribute("href", promotionUrl), div.appendChild(a);
              var img = document.createElement("img");
              if (
                (img.setAttribute("src", imgDir + "images/empty.gif"),
                img.setAttribute("alt", abbrText + catEntryName),
                a.appendChild(img),
                !this.isNullObj(calCode.calculationCodeDescription))
              ) {
                var calCodeDesc = this.revertAllSpecialChars(
                  calCode.calculationCodeDescription
                );
                a.appendChild(document.createTextNode(calCodeDesc));
              }
              var td = document.createElement("td");
              td.setAttribute(
                "class",
                "th_align_left_dotted_top_solid_bottom total"
              ),
                td.setAttribute(
                  "className",
                  "th_align_left_dotted_top_solid_bottom total"
                ),
                td.appendChild(document.createTextNode(" ")),
                tr.appendChild(td);
              var td1 = document.createElement("td");
              td1.setAttribute(
                "class",
                "th_align_left_dotted_top_solid_bottom total"
              ),
                td1.setAttribute(
                  "className",
                  "th_align_left_dotted_top_solid_bottom total"
                ),
                td1.setAttribute(
                  "id",
                  "WC_OrderItemDetailsSummaryf_td_5_" + i + "_" + counter
                ),
                td1.setAttribute(
                  "headers",
                  "SingleShipment_rowHeader_discount" + i + "_" + counter
                ),
                td1.appendChild(
                  document.createTextNode(
                    this.formatCurrency(
                      calCode.TotalAmount,
                      currencyDecimals,
                      currencySymbol,
                      currencyCode,
                      locale
                    )
                  )
                ),
                tr.appendChild(td1),
                counter++;
            }
          }
        }
      }
    },
    populateOrderLineInfoForMultipleShipment: function (
      orderStr,
      beginIndex,
      pageSize
    ) {
      var jsonOrder = eval("(" + orderStr + ")"),
        imgDir = document.getElementById("Image_Dir").innerHTML,
        locale = document.getElementById("Locale_String_M").innerHTML,
        endIndex = document.getElementById("endIndex").innerHTML,
        orderLineNum = 1;
      if (
        (this.isNullObj(jsonOrder.Root.Order.countOfOrderLines) ||
          (orderLineNum = jsonOrder.Root.Order.countOfOrderLines),
        "TBODY" ==
          document.getElementById("order_details").childNodes[0].tagName)
      )
        var parentTable =
          document.getElementById("order_details").childNodes[0];
      else if (
        "TBODY" ==
        document.getElementById("order_details").childNodes[1].tagName
      )
        var parentTable =
          document.getElementById("order_details").childNodes[1];
      for (var i = beginIndex; endIndex > i; i++) {
        var orderLine = null;
        orderLine =
          1 == orderLineNum
            ? this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0])
              ? jsonOrder.Root.Order.OrderLines.OrderLine
              : jsonOrder.Root.Order.OrderLines.OrderLine[0]
            : jsonOrder.Root.Order.OrderLines.OrderLine[i];
        var nobottom = null;
        this.isNullObj(orderLine.CalculationCodes) ||
          this.isNullObj(orderLine.CalculationCodes.CalculationCode) ||
          (nobottom = "th_align_left_no_bottom"),
          this.isNullObj(nobottom) ||
            (document
              .getElementById("MultipleShipping_rowHeader_product" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("MultipleShipping_rowHeader_product" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("MultipleShipping_rowHeader_product" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("MultipleShipping_rowHeader_product" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_1_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_1_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_1_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_1_" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_2_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_2_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_2_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_2_" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_3_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_3_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_3_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_3_" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_4_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_4_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_4_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_4_" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_5_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_5_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_5_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_5_" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_6_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_6_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_6_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_6_" + i)
                    .getAttribute("className")
              ));
        var catEntryName = null,
          thumbNail = null,
          objectPath = null,
          itemID = null;
        if (
          (this.isNullObj(orderLine.Item.CatalogEntry) ||
            (this.isNullObj(orderLine.Item.CatalogEntry.objectPath) ||
              (objectPath = orderLine.Item.CatalogEntry.objectPath),
            this.isNullObj(
              orderLine.Item.CatalogEntry.CatalogEntryDescription
            ) ||
              (this.isNullObj(
                orderLine.Item.CatalogEntry.CatalogEntryDescription
                  .catalogEntryName
              ) ||
                (catEntryName =
                  orderLine.Item.CatalogEntry.CatalogEntryDescription
                    .catalogEntryName),
              this.isNullObj(
                orderLine.Item.CatalogEntry.CatalogEntryDescription.thumbNail
              ) ||
                (thumbNail =
                  orderLine.Item.CatalogEntry.CatalogEntryDescription
                    .thumbNail))),
          this.isNullObj(orderLine.Item.ItemID) ||
            (itemID = orderLine.Item.ItemID),
          this.isNullObj(thumbNail)
            ? document
                .getElementById("Product_Thumbnail_" + i)
                .setAttribute("src", imgDir + "images/NoImageIcon_sm.jpg")
            : ((thumbNail = this.revertAllSpecialChars(thumbNail)),
              this.isNullObj(objectPath)
                ? document
                    .getElementById("Product_Thumbnail_" + i)
                    .setAttribute("src", thumbNail)
                : ((objectPath = this.revertAllSpecialChars(objectPath)),
                  document
                    .getElementById("Product_Thumbnail_" + i)
                    .setAttribute("src", objectPath + thumbNail))),
          this.isNullObj(catEntryName) ||
            (document
              .getElementById("MultipleShipping_rowHeader_product" + i)
              .setAttribute(
                "abbr",
                document
                  .getElementById("MultipleShipping_rowHeader_product" + i)
                  .getAttribute("abbr") + catEntryName
              ),
            document
              .getElementById("Product_Thumbnail_" + i)
              .setAttribute("alt", catEntryName),
            (document.getElementById("Catalog_Entry_Name_" + i).innerHTML =
              catEntryName)),
          this.isNullObj(itemID) ||
            (document.getElementById("Catalog_Entry_SKU_" + i).innerHTML =
              itemID),
          !this.isNullObj(orderLine.Item.CatalogEntry) &&
            !this.isNullObj(orderLine.Item.CatalogEntry.catalogEntryAttributes))
        ) {
          document.getElementById(
            "Catalog_Entry_Defining_Attributes_" + i
          ).style.display = "inline";
          for (var dAttr in orderLine.Item.CatalogEntry.catalogEntryAttributes
            .catalogEntryAttribute)
            document.getElementById(
              "Catalog_Entry_Defining_Attributes_" + i
            ).innerHTML =
              document.getElementById("Catalog_Entry_Defining_Attributes_" + i)
                .innerHTML +
              orderLine.Item.CatalogEntry.catalogEntryAttributes
                .catalogEntryAttribute[dAttr].catalogEntryAttrName +
              ":" +
              orderLine.Item.CatalogEntry.catalogEntryAttributes
                .catalogEntryAttribute[dAttr].catalogEntryAttrValue +
              "<br/>";
        }
        if (!this.isNullObj(orderLine.componentNames)) {
          var dkLabel = document.getElementById(
            "Dynamic_Kit_Components_Label_" + i
          );
          this.isNullObj(dkLabel) ||
            (document.getElementById(
              "Dynamic_Kit_Components_Label_" + i
            ).style.display = "inline");
          var ulForDK = document.getElementById("Dynamic_Kit_Components_" + i);
          if (!this.isNullObj(ulForDK)) {
            var compNames = orderLine.componentNames.split(",");
            for (var j in compNames) {
              var li = document.createElement("li");
              (li.innerHTML = compNames[j]), ulForDK.appendChild(li);
            }
          }
        }
        this.isNullObj(orderLine.PersonInfoShipTo)
          ? this.isNullObj(jsonOrder.Root.Order.PersonInfoShipTo) ||
            this.populateAddress(
              jsonOrder.Root.Order.PersonInfoShipTo,
              "WC_MSOrderItemDetailsSummaryf_div_3_" + i,
              locale
            )
          : this.populateAddress(
              orderLine.PersonInfoShipTo,
              "WC_MSOrderItemDetailsSummaryf_div_3_" + i,
              locale
            );
        var shippingMethod = null;
        if (!this.isNullObj(orderLine.ShipmentLines.ShipmentLine)) {
          var shipmentKey = null;
          if (
            (this.isNullObj(orderLine.ShipmentLines.ShipmentLine.ShipmentKey)
              ? this.isNullObj(
                  orderLine.ShipmentLines.ShipmentLine[0].ShipmentKey
                ) ||
                (shipmentKey =
                  orderLine.ShipmentLines.ShipmentLine[0].ShipmentKey)
              : (shipmentKey =
                  orderLine.ShipmentLines.ShipmentLine.ShipmentKey),
            !this.isNullObj(shipmentKey) &&
              !this.isNullObj(jsonOrder.Root.Order.Shipments) &&
              !this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment))
          )
            if (
              this.isNullObj(
                jsonOrder.Root.Order.Shipments.Shipment.ShipmentKey
              )
            ) {
              if (!this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment[0]))
                for (var s in jsonOrder.Root.Order.Shipments.Shipment)
                  if (
                    jsonOrder.Root.Order.Shipments.Shipment[s].ShipmentKey ==
                    shipmentKey
                  ) {
                    this.isNullObj(
                      jsonOrder.Root.Order.Shipments.Shipment[s]
                        .shipModeDescription
                    ) ||
                      (shippingMethod =
                        jsonOrder.Root.Order.Shipments.Shipment[s]
                          .shipModeDescription);
                    break;
                  }
            } else
              jsonOrder.Root.Order.Shipments.Shipment.ShipmentKey ==
                shipmentKey &&
                (this.isNullObj(
                  jsonOrder.Root.Order.Shipments.Shipment.shipModeDescription
                ) ||
                  (shippingMethod =
                    jsonOrder.Root.Order.Shipments.Shipment
                      .shipModeDescription));
        }
        this.isNullObj(shippingMethod) &&
          (this.isNullObj(orderLine.shipModeDescription)
            ? this.isNullObj(jsonOrder.Root.Order.shipModeDescription) ||
              (shippingMethod = jsonOrder.Root.Order.shipModeDescription)
            : (shippingMethod = orderLine.shipModeDescription)),
          this.isNullObj(shippingMethod) ||
            (document.getElementById(
              "Shipping_Mode_Description_" + i
            ).innerHTML = shippingMethod);
        var isFree = !1;
        if (
          !this.isNullObj(orderLine.Awards) &&
          !this.isNullObj(orderLine.Awards.Award)
        )
          if (this.isNullObj(orderLine.Awards.Award.AwardType)) {
            if (!this.isNullObj(orderLine.Awards.Award[0]))
              for (var award in orderLine.Awards.Award)
                if ("FreeGift" == orderLine.Awards.Award[award].AwardType) {
                  isFree = !0;
                  break;
                }
          } else
            "FreeGift" == orderLine.Awards.Award.AwardType && (isFree = !0);
        if (0 == isFree) {
          if (
            !this.isNullObj(
              document.getElementById("Shipping_Instruction_" + i)
            ) &&
            !this.isNullObj(orderLine.Instructions)
          ) {
            var instructions = orderLine.Instructions;
            if (!this.isNullObj(instructions.Instruction)) {
              var instruction = instructions.Instruction;
              if (this.isNullObj(instruction.InstructionType)) {
                if (!this.isNullObj(instructions.Instruction[0]))
                  for (var k in instructions.Instruction)
                    this.isNullObj(
                      instructions.Instruction[k].InstructionType
                    ) ||
                      ("SHIP" == instructions.Instruction[k].InstructionType &&
                        (this.isNullObj(
                          instructions.Instruction[k].InstructionText
                        ) ||
                          ((document.getElementById(
                            "Shipping_Instruction_Label_" + i
                          ).style.display = "inline"),
                          (document.getElementById(
                            "Shipping_Instruction_" + i
                          ).innerHTML =
                            document.getElementById("Shipping_Instruction_" + i)
                              .innerHTML +
                            instructions.Instruction[k].InstructionText +
                            "<br/>"))));
              } else
                "SHIP" == instruction.InstructionType &&
                  (this.isNullObj(instruction.InstructionText) ||
                    ((document.getElementById(
                      "Shipping_Instruction_Label_" + i
                    ).style.display = "inline"),
                    (document.getElementById(
                      "Shipping_Instruction_" + i
                    ).innerHTML = instruction.InstructionText)));
            }
          }
          if (
            !this.isNullObj(
              document.getElementById("Order_Item_Requested_Ship_Date_" + i)
            ) &&
            !this.isNullObj(orderLine.ReqShipDate)
          ) {
            document.getElementById(
              "Requested_Shipping_Date_Label_" + i
            ).style.display = "inline";
            var parsedReqShipDate = new Date(orderLine.ReqShipDate);
            document.getElementById(
              "Order_Item_Requested_Ship_Date_" + i
            ).innerHTML = Globalize.formatDate(parsedReqShipDate, {
              date: "long",
            });
          }
        }
        this.isNullObj(orderLine.MaxLineStatus) ||
          (document.getElementById("Order_Item_Status_" + i).innerHTML =
            Utils.getLocalizationMessage(
              "ORDER_LINE_STATUS_" + orderLine.MaxLineStatus
            )),
          this.isNullObj(orderLine.OrderedQty) ||
            (document.getElementById("Order_Item_Quantity_" + i).innerHTML =
              Utils.formatNumber(orderLine.OrderedQty, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }));
        var currencyCode = "USD";
        this.isNullObj(jsonOrder.Root.Order.PriceInfo.Currency) ||
          (currencyCode = jsonOrder.Root.Order.PriceInfo.Currency);
        var currencyDecimals = 2;
        this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencyDecimal) ||
          (currencyDecimals = jsonOrder.Root.Order.PriceInfo.currencyDecimal);
        var currencySymbol = "$";
        if (
          (this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencySymbol) ||
            (currencySymbol = jsonOrder.Root.Order.PriceInfo.currencySymbol),
          this.isNullObj(orderLine.LinePriceInfo.UnitPrice) ||
            (document.getElementById("Order_Item_Unit_Price_" + i).innerHTML =
              this.formatCurrency(
                orderLine.LinePriceInfo.UnitPrice,
                currencyDecimals,
                currencySymbol,
                currencyCode,
                locale
              )),
          1 == isFree
            ? ((document.getElementById(
                "Order_Item_Total_Price_Free_" + i
              ).style.display = "inline"),
              (document.getElementById(
                "Order_Item_Total_Price_" + i
              ).style.display = "none"))
            : ((document.getElementById(
                "Order_Item_Total_Price_Free_" + i
              ).style.display = "none"),
              (document.getElementById(
                "Order_Item_Total_Price_" + i
              ).style.display = "inline"),
              this.isNullObj(orderLine.ComputedPrice.ExtendedPrice) ||
                (document.getElementById(
                  "Order_Item_Total_Price_" + i
                ).innerHTML = this.formatCurrency(
                  orderLine.ComputedPrice.ExtendedPrice,
                  currencyDecimals,
                  currencySymbol,
                  currencyCode,
                  locale
                ))),
          !this.isNullObj(orderLine.CalculationCodes))
        ) {
          var counter = 0;
          for (var j in orderLine.CalculationCodes.CalculationCode) {
            var calCode = orderLine.CalculationCodes.CalculationCode[j],
              code = calCode.code;
            code = this.revertAllSpecialChars(code);
            var tr = document.createElement("tr");
            parentTable.insertBefore(
              tr,
              document.getElementById("Product_Line_" + (parseInt(i) + 1))
            );
            var th = document.createElement("th");
            th.setAttribute("colSpan", "5"),
              th.setAttribute("class", "th_align_left_dotted_top_solid_bottom"),
              th.setAttribute(
                "className",
                "th_align_left_dotted_top_solid_bottom"
              );
            var abbrText = document.getElementById(
              "Product_Discount_Text"
            ).innerHTML;
            th.setAttribute("abbr", abbrText + catEntryName),
              th.setAttribute(
                "id",
                "MultipleShipment_rowHeader_discount" + i + "_" + counter
              ),
              tr.appendChild(th);
            var div = document.createElement("div");
            div.setAttribute(
              "id",
              "WC_MSOrderItemDetailsSummaryf_div_5_" + i + "_" + counter
            ),
              div.setAttribute("class", "itemspecs"),
              div.setAttribute("className", "itemspecs"),
              th.appendChild(div);
            var a = document.createElement("a");
            a.setAttribute("class", "discount"),
              a.setAttribute("className", "discount"),
              a.setAttribute(
                "id",
                "WC_OrderItemDetails_Link_ItemDiscount_1_" + i + "_" + counter
              );
            var url_innerHTML =
              document.getElementById("Promotion_Url").innerHTML;
            this.isNullObj(url_innerHTML) ||
              (url_innerHTML = url_innerHTML.replace(/&amp;/g, "&"));
            var promotionUrl =
              url_innerHTML + "&code=" + encodeURIComponent(code);
            a.setAttribute("href", promotionUrl), div.appendChild(a);
            var img = document.createElement("img");
            if (
              (img.setAttribute("src", imgDir + "images/empty.gif"),
              img.setAttribute("alt", abbrText + catEntryName),
              a.appendChild(img),
              !this.isNullObj(calCode.calculationCodeDescription))
            ) {
              var calCodeDesc = this.revertAllSpecialChars(
                calCode.calculationCodeDescription
              );
              a.appendChild(document.createTextNode(calCodeDesc));
            }
            var td = document.createElement("td");
            td.setAttribute(
              "class",
              "th_align_left_dotted_top_solid_bottom total"
            ),
              td.setAttribute(
                "className",
                "th_align_left_dotted_top_solid_bottom total"
              ),
              td.appendChild(document.createTextNode(" ")),
              tr.appendChild(td);
            var td1 = document.createElement("td");
            td1.setAttribute(
              "class",
              "th_align_left_dotted_top_solid_bottom total"
            ),
              td1.setAttribute(
                "className",
                "th_align_left_dotted_top_solid_bottom total"
              ),
              td1.setAttribute(
                "id",
                "WC_MSOrderItemDetailsSummaryf_td_7_" + i + "_" + counter
              ),
              td1.setAttribute(
                "headers",
                "MultipleShipment_rowHeader_discount" + i + "_" + counter
              ),
              td1.appendChild(
                document.createTextNode(
                  this.formatCurrency(
                    calCode.TotalAmount,
                    currencyDecimals,
                    currencySymbol,
                    currencyCode,
                    locale
                  )
                )
              ),
              tr.appendChild(td1),
              counter++;
          }
        }
      }
    },
    cancelOrder: function (e, t) {
      submitRequest() &&
        (cursor_wait(),
        (this.orderBeingCanceled = t),
        wcService.getServiceById("CancelExternalOrder").setUrl(e),
        wcService.invoke("CancelExternalOrder"));
    },
  }),
  wcService.declare({
    id: "CancelExternalOrder",
    actionId: "CancelExternalOrder",
    url: "AJAXProcessExternalOrder",
    formId: "",
    successHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      var r =
          "OrderDetails_status_span_" +
          sterlingIntegrationJS.orderBeingCanceled,
        s = $("#" + r);
      s.length && s.html(MessageHelper.messages.MO_OrderStatus_X),
        (r =
          "OrderDetails_cancelButton_" +
          sterlingIntegrationJS.orderBeingCanceled);
      var s = $("#" + r);
      s.length && (s.css("display", "none"), s.css("visibility", "hidden")),
        MessageHelper.hideAndClearMessage(),
        cursor_clear(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.MO_ORDER_CANCELED_MSG
        );
    },
    failureHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  });
var toggleCollapsible = function (e) {
    var t = e.querySelector(".content"),
      r = $(e).attr("aria-expanded"),
      s = document.getElementById("mainESpotHome");
    t.id.match(/homeESpotDetails/)
      ? "closed" == s.className
        ? (s.className = "expand")
        : (s.className = "closed")
      : 0,
      "true" == r
        ? (window.setTimeout(function () {
            $(e).attr("aria-expanded", "false"),
              $(t).css("transition", "max-height .2s");
          }, 0),
          window.setTimeout(function () {
            $(t).css("transition", null);
          }, 200),
          window.setTimeout(function () {
            $(t).css("display", "none");
          }, 300))
        : "false" == r &&
          ($(e).attr("aria-expanded", "true"),
          $(t).css("transition", "max-height .2s"),
          window.setTimeout(function () {
            $(t).css("transition", null);
          }, 200),
          window.setTimeout(function () {
            $(t).css("display", "block");
          }, 300));
  },
  updateGrid = function (e, t) {
    var r = t.clientWidth,
      s = $(t).attr("data-min-col-width"),
      a = $(t).attr("data-min-col-count"),
      i = Math.floor(r / s);
    a > i && (i = a);
    var n = Math.floor(100 / i) + "%";
    $(".col", t).css("width", n);
  },
  toggleExpandNav = function (e) {
    var t = byId("icon_" + e),
      r = byId("section_list_" + e);
    "arrow" == t.className
      ? ((t.className = "arrow arrow_collapsed"),
        $(r).attr("aria-expanded", "false"),
        $(r).css("display", "none"))
      : ((t.className = "arrow"),
        $(r).attr("aria-expanded", "true"),
        $(r).css("display", "block"));
  };
$(document).ready(function () {
  var e = function (e) {
    var t = e ? !e.matches : document.documentElement.clientWidth > 583;
    0 == t
      ? $(".collapsible").attr("aria-expanded", t.toString())
      : $(".collapsible:not(.collapsedOnInit)").attr(
          "aria-expanded",
          t.toString()
        );
  };
  if (window.matchMedia) {
    var t = window.matchMedia("(max-width: 600px)");
    e(t), t.addListener(e);
  } else
    e(),
      $(window).on("resize", function (t) {
        e();
      });
  Utils.onOnce(
    $(document),
    "click",
    "collapsible",
    ".collapsible .toggle",
    function (e) {
      toggleCollapsible($(e.target).parents(".collapsible")[0]),
        e.preventDefault();
    }
  ),
    Utils.onOnce(
      $(document),
      "keydown",
      "collapsible",
      ".collapsible .toggle",
      function (e) {
        (e.keyCode === KeyCodes.RETURN || e.keyCode === KeyCodes.SPACE) &&
          (toggleCollapsible($(e.target).parents(".collapsible")[0]),
          e.preventDefault());
      }
    ),
    $(".grid").each(updateGrid),
    $(window).on("resize", function (e) {
      $(".grid").each(updateGrid);
    });
}),
  ("undefined" != typeof CompareProductJS &&
    null != CompareProductJS &&
    CompareProductJS) ||
    (CompareProductJS = {
      params: [],
      compareReturnName: "",
      returnUrl: "",
      cookieKeyPrefix: "CompareItems_",
      cookieDelimiter: ";",
      maxNumberProductsAllowedToCompare: 4,
      setCommonParameters: function (e, t, r, s, a) {
        (this.params.langId = e),
          (this.params.storeId = t),
          (this.params.catalogId = r),
          (this.compareReturnName = s),
          (this.returnUrl = decodeURIComponent(a));
      },
      remove: function (e) {
        var t = this.cookieKeyPrefix + this.params.storeId,
          r = getCookie(t);
        if (null != r) {
          if ("" == r.trim())
            setCookie(t, null, {
              expires: -1,
            });
          else {
            var s = r.split(this.cookieDelimiter),
              a = "";
            for (index in s)
              s[index] != e &&
                (a = "" === a ? s[index] : a + this.cookieDelimiter + s[index]);
            setCookie(t, a, {
              path: "/",
              domain: cookieDomain,
            });
          }
          var t = this.cookieKeyPrefix + this.params.storeId,
            r = getCookie(t),
            i = "",
            n = document.URL.split("catentryId=");
          if (2 == n.length) {
            i = n[0] + "catentryId=" + r;
            for (var o = n[1].split("&"), d = 0; d < o.length; d++)
              d > 0 && (i = i + "&" + n[d]);
          }
          var i = i.replace(/&&/, "&");
          location.href = i;
        }
      },
      compareProducts: function () {
        var e =
            "CompareProductsDisplayView?storeId=" +
            this.params.storeId +
            "&catalogId=" +
            this.params.catalogId +
            "&langId=" +
            this.params.langId +
            "&compareReturnName=" +
            this.compareReturnName,
          t = this.cookieKeyPrefix + this.params.storeId,
          r = getCookie(t);
        null != r && "" != r.trim() && (e = e + "&catentryId=" + r),
          (e = e + "&returnUrl=" + encodeURIComponent(this.returnUrl)),
          (location.href = getAbsoluteURL() + e);
      },
      add2ShopCart: function (e, t, r) {
        var s = {
          storeId: WCParamJS.storeId,
          catalogId: WCParamJS.catalogId,
          langId: WCParamJS.langId,
          orderId: ".",
        };
        (s.calculateOrder = "0"),
          updateParamObject(s, "catEntryId", e, !1, -1),
          updateParamObject(s, "quantity", t, !1, -1);
        var a = "AddOrderItem",
          i = this.getSkuAttributes(e);
        null == i && (i = this.getSkuAttributes(r)),
          submitRequest() &&
            (cursor_wait(),
            shoppingActionsJS.saveAddedProductInfo(t, r, e, i),
            wcService.invoke(a, s));
      },
      getSkuAttributes: function (catEntryId) {
        var jsonDiv = null,
          node = $("#SKUAttributesJSON_" + catEntryId);
        return (
          node &&
            null != node &&
            "undefined" != node &&
            (jsonDiv = eval("(" + node.innerHTML + ")")),
          null != jsonDiv && "undefined" != jsonDiv ? jsonDiv : null
        );
      },
    });
var updateDepartmentsMenu,
  activate,
  ajaxRefresh = "",
  setAjaxRefresh = function (e) {
    ajaxRefresh = e;
  };
$(document).ready(function () {
  var e = !1,
    t = null,
    r = null,
    s = {},
    a = "departmentMenu_",
    i = function () {
      e || ($(document.documentElement).on("mousedown.wc.header", o), (e = !0));
    },
    n = function () {
      e && ($(document.documentElement).off("mousedown.wc.header"), (e = !1));
    },
    o = function (e) {
      var s = e.target;
      if (null !== t && s != document.documentElement) {
        for (
          var a = !0, i = t.getAttribute("data-parent");
          s && s != document.documentElement;

        ) {
          if (
            s == t ||
            s == r ||
            $(s).hasClass("dijitPopup") ||
            i == s.getAttribute("data-parent")
          ) {
            a = !1;
            break;
          }
          s = s.parentNode;
        }
        if (null === s)
          for (var n = $("div", t), o = 0; o < n.length; o++) {
            var l = Utils.position(n[o]);
            if (
              e.clientX >= l.x &&
              e.clientX < l.x + l.w &&
              e.clientY >= l.y &&
              e.clientY < l.y + l.h
            ) {
              a = !1;
              break;
            }
          }
        a && d(t);
      }
    },
    d = function (e) {
      s[e.id] && d(s[e.id]),
        $(e).removeClass("active"),
        $("a[data-activate='" + e.id + "']").removeClass("selected"),
        $("a[data-toggle='" + e.id + "']").removeClass("selected");
      var a = e.getAttribute("data-parent");
      delete s[a], e == t && ((t = null), (r = null), n());
    },
    l = function (e) {
      $(e).hasClass("active") ? d(e) : activate(e);
    },
    c = function () {
      $(document).on("click", "a[data-activate]", function (e) {
        var t = this.getAttribute("data-activate");
        activate(document.getElementById(t)), Utils.stopEvent(e);
      }),
        $(document).on("click", "a[data-deactivate]", function (e) {
          var t = this.getAttribute("data-deactivate");
          d(document.getElementById(t)), Utils.stopEvent(e);
        }),
        $(document).on("click", "a[data-toggle]", function (e) {
          var t = this.getAttribute("data-toggle");
          l(document.getElementById(t)), Utils.stopEvent(e);
        }),
        $(document).on("keydown", "a[data-toggle]", function (e) {
          var t;
          if (27 === e.keyCode)
            (t = this.getAttribute("data-toggle")),
              d(document.getElementById(t)),
              Utils.stopEvent(e);
          else if (40 === e.keyCode) {
            t = this.getAttribute("data-toggle");
            var r = document.getElementById(t);
            activate(r),
              $('[class*="menuLink"]', r)[0].focus(),
              Utils.stopEvent(e);
          }
        });
      var e = Utils.get_IE_version();
      e &&
        10 > e &&
        $("input[placeholder]").each(function (e, t) {
          var r = t.getAttribute("placeholder");
          if (r) {
            var s = document.createElement("label");
            (s.className = "placeholder"),
              (s.innerHTML = r),
              t.parentNode.insertBefore(s, t);
            var a = function () {
              s.style.display = t.value ? "none" : "block";
            };
            window.setTimeout(a, 200),
              $(t).on("blur focus keyup", a),
              $(s).click(function (e) {
                t.focus();
              });
          }
        });
    };
  (activate = function (e) {
    var n = e.id.slice(0, a.length) == a;
    if ("true" == ajaxRefresh && n)
      return (
        setAjaxRefresh(""),
        wcRenderContext.updateRenderContext("departmentSubMenuContext", {
          targetId: e.id,
        }),
        void (
          "function" == typeof cX &&
          setTimeout(function () {
            cX("");
          }, 1e3)
        )
      );
    var o = e.getAttribute("data-parent");
    o && s[o] && d(s[o]),
      o && activate(document.getElementById(o)),
      $(e).addClass("active"),
      $("a[data-activate='" + e.id + "']").addClass("selected");
    var l = $("a[data-toggle='" + e.id + "']");
    l.addClass("selected"),
      o &&
        ((s[o] = e),
        null === t && ((t = e), (r = l.length > 0 ? l[0] : null), i()));
  }),
    c(),
    window.setTimeout(function () {
      var e = document.getElementById("quickLinksBar"),
        t = document.getElementById("quickLinksButton"),
        r = document.getElementById("quickLinksMenu"),
        s = $("> ul > li > a", r);
      document.getElementById("signInOutQuickLink");
      $("#quickLinksMenu > ul > li").each(function (t, r) {
        "facebookQuickLinkItem" != r.id &&
          "globalLoginWidget" != r.id &&
          ((r = r.cloneNode(!0)),
          $("[id]", r).each(function (e, t) {
            t.id += "_alt";
          }),
          e.insertBefore(r, e.firstChild));
      }),
        $(t).click(function (e) {
          var t = this.getAttribute("data-toggle");
          l(document.getElementById(t)), Utils.stopEvent(e);
        }),
        $(t).keydown(function (e) {
          var t;
          40 === e.keyCode
            ? ((t = this.getAttribute("data-toggle")),
              activate(document.getElementById(t)),
              s[0].focus(),
              Utils.stopEvent(e))
            : 9 === e.keyCode || (9 === e.keyCode && e.shiftKey)
            ? d(r)
            : 27 === e.keyCode &&
              ((t = this.getAttribute("data-toggle")),
              d(document.getElementById(t)),
              Utils.stopEvent(e));
        }),
        $(r).keydown(function (e) {
          if (
            27 === e.keyCode ||
            9 === e.keyCode ||
            (9 === e.keyCode && e.shiftKey)
          )
            d(r);
          else if (27 === e.keyCode) {
            var t = this.getAttribute("data-toggle");
            d(document.getElementById(t)), Utils.stopEvent(e);
          }
        }),
        s.each(function (e, t) {
          t.setAttribute("role", "menuitem"),
            t.setAttribute("tabindex", "-1"),
            $(t).keydown(function (t) {
              switch (t.keyCode) {
                case 38:
                  s[0 === e ? s.length - 1 : e - 1].focus(), Utils.stopEvent(t);
                  break;
                case 40:
                  s[(e + 1) % s.length].focus(), Utils.stopEvent(t);
              }
            });
        });
      var a = document.getElementById("searchFilterButton");
      a &&
        $(a).keydown(function (e) {
          (9 === e.keyCode || (9 === e.keyCode && e.shiftKey)) &&
            d(document.getElementById(a.getAttribute("data-toggle")));
        });
      var i = document.getElementById("SimpleSearchForm_SearchTerm");
      i &&
        $(i).click(function (e) {
          $(
            '.selected:not(a[data-toggle="searchBar"])',
            document.getElementById("header")
          ).each(function (e, t) {
            d(document.getElementById(t.getAttribute("data-toggle")));
          });
        });
      var n = document.getElementById("searchFilterMenu");
      n &&
        $('[class*="menuLink"]', n).each(function (e, t) {
          $(t).keydown(function (r) {
            27 === r.keyCode
              ? (d(n), Utils.stopEvent(r))
              : 9 === r.keyCode || (9 === r.keyCode && r.shiftKey)
              ? d(n)
              : 38 === r.keyCode
              ? (t[0 === e ? t.length - 1 : e - 1].focus(), Utils.stopEvent(r))
              : 40 === r.keyCode &&
                (t[(e + 1) % t.length].focus(), Utils.stopEvent(r));
          });
        });
    }, 100);
  if ($(document.getElementById("header")).length > 0) {
    var u = document.getElementById("header"),
      m = Utils.getTextDirection(u),
      g = function () {
        var e = document.getElementById("logo"),
          t = document.getElementById("quickLinksBar"),
          r =
            "rtl" === m
              ? e.offsetLeft - t.offsetLeft
              : t.offsetLeft + t.offsetWidth - (e.offsetLeft + e.offsetWidth),
          s = document.getElementById("facebookQuickLinkItem");
        if (s && s.parentNode != t && r > 1024) t.insertBefore(s, t.firstChild);
        else if (s && s.parentNode == t && 1024 >= r) {
          var a = $("#quickLinksMenu > ul")[0];
          a.append(s);
        }
        var i = $("#quickLinksBar > li");
        if ($(i).length > 0) {
          var n = i[i.length - 2],
            o = i[i.length - 1];
          r -= n.offsetWidth + o.offsetWidth;
          for (var d = i.length - 3; d >= 0; d--)
            (r -= i[d].offsetWidth),
              $(i[d]).toggleClass("border-right", r >= 0);
        }
      };
    window.setTimeout(g, 200), $(window).resize(g);
  }
  (updateDepartmentsMenu = function () {
    var e =
        (document.getElementById("departmentsMenu"), $(".departmentButton")),
      t = $(".departmentMenu"),
      r = $("#departmentsMenu > li");
    r[r.length - 1];
    e.each(function (e, t) {
      $(t).keydown(function (e) {
        (9 === e.keyCode || (9 === e.keyCode && e.shiftKey)) &&
          d(document.getElementById(t.getAttribute("data-toggle")));
      });
    }),
      t.each(function (e, t) {
        $(t).click(function (e) {
          var t = this.getAttribute("data-toggle");
          null !== t && (l(document.getElementById(t)), Utils.stopEvent(e));
        });
        var r = $('[class*="menuLink"]', t);
        r.each(function (e, s) {
          $(s).keydown(function (s) {
            27 === s.keyCode
              ? (d(document.getElementById(t.getAttribute("id"))),
                Utils.stopEvent(s))
              : 9 === s.keyCode || (9 === s.keyCode && s.shiftKey)
              ? d(document.getElementById(t.getAttribute("id")))
              : 38 === s.keyCode
              ? (r[0 === e ? r.length - 1 : e - 1].focus(), Utils.stopEvent(s))
              : 40 === s.keyCode &&
                (r[(e + 1) % r.length].focus(), Utils.stopEvent(s));
          });
        });
      });
  }),
    window.setTimeout(updateDepartmentsMenu, 200);
  var p = Utils.get_IE_version();
  (!p || p > 8) && $(window).resize(updateDepartmentsMenu),
    $("#searchFilterMenu > ul > li > a").click(function (e) {
      (document.getElementById("searchFilterButton").innerHTML =
        this.innerHTML),
        (document.getElementById("categoryId").value =
          this.getAttribute("data-value")),
        d(document.getElementById("searchFilterMenu"));
    }),
    $("#searchBox > .submitButton").click(function (e) {
      var t = document.getElementById("SimpleSearchForm_SearchTerm");
      t.value = $.trim(t.value);
      var r = $.trim(t.value.replace(/'|"/g, ""));
      t.value &&
        "" !== r &&
        processAndSubmitForm(document.getElementById("searchBox"));
    });
  var h = document.getElementById("searchBox");
  h &&
    $(h).submit(function (e) {
      updateFormWithWcCommonRequestParameters(e.target);
      var t = document.getElementById("SimpleSearchForm_SearchTerm"),
        r = t.value,
        s = $.trim(t.value.replace(/'|"/g, ""));
      return (
        (t.value = s),
        t.value ? void (t.value = $.trim(r)) : (Utils.stopEvent(e), !1)
      );
    });
});
var order_updated = {
    AjaxAddOrderItem: "AjaxAddOrderItem",
    AddOrderItem: "AddOrderItem",
    AjaxAddOrderItemWithShipingInfo: "AjaxAddOrderItemWithShipingInfo",
    AjaxDeleteOrderItem: "AjaxDeleteOrderItem",
    AjaxUpdateOrderItem: "AjaxUpdateOrderItem",
    AjaxUpdateOrderShippingInfo: "AjaxUpdateOrderShippingInfo",
    AjaxOrderCalculate: "AjaxOrderCalculate",
    AjaxLogoff: "AjaxLogoff",
    AjaxSetPendingOrder: "AjaxSetPendingOrder",
    AjaxUpdatePendingOrder: "AjaxUpdatePendingOrder",
    AjaxSingleOrderCancel: "AjaxSingleOrderCancel",
    AjaxUpdateRewardOption: "AjaxUpdateRewardOption",
  },
  dialogWidget,
  update_content = !1,
  dropdownUpdated = !1,
  dropdownInit = !1,
  productAddedList = {};
wcTopic.subscribe("ProductInfo_Added", setProductAddedList),
  ("undefined" != typeof ProductTabJS &&
    null != ProductTabJS &&
    ProductTabJS) ||
    (ProductTabJS = {
      lastTabId: null,
      selectTab: function (e) {
        $("div.tab_container").each(function (e, t) {
          $(t)
            .attr("aria-selected", "false")
            .attr("class", "tab_container inactive_tab")
            .attr("tabindex", "-1");
        }),
          $("div.tab").each(function (e, t) {
            $(t).css("display", "none");
          }),
          $("#" + e)
            .attr("aria-selected", "true")
            .attr("tabindex", "0")
            .attr("class", "tab_container active_tab"),
          $("#" + e + "Widget").css("display", "block"),
          $("#" + e + "Widget").each(function (e, t) {
            t.resize && t.resize();
          }),
          (null == this.lastTabId || this.lastTabId != e) &&
            (this.lastTabId = e);
      },
      selectTabWithKeyboard: function (e, t, r) {
        (r.keyCode == keys.DOWN_ARROW || r.keyCode == keys.RIGHT_ARROW) &&
          (e++,
          $("#tab" + e)
            ? (this.selectTab("tab" + e), this.focusTab("tab" + e))
            : (this.selectTab("tab1"), this.focusTab("tab1")),
          this.cancelEvent(r)),
          (r.keyCode == keys.UP_ARROW || r.keyCode == keys.LEFT_ARROW) &&
            ($("#tab" + (e - 1))
              ? (this.selectTab("tab" + (e - 1)),
                this.focusTab("tab" + (e - 1)))
              : (this.selectTab("tab" + t), this.focusTab("tab" + t)),
            this.cancelEvent(r));
      },
      cancelEvent: function (e) {
        Utils.stopEvent(e);
      },
      focusTab: function (e) {
        return $("#" + e).hasClass("focused_tab")
          ? void $("> div", "#" + e).css("border", "1px dotted #000000")
          : ($("#" + e).addClass("focused_tab"),
            $("> div", $("#" + e)).css("border", "1px dotted #000000"),
            $("#" + e).focus(),
            void 0);
      },
      blurTab: function (e) {
        $(e).removeClass("focused_tab"),
          $("> div", "#" + e).css("border", "1px solid transparent");
      },
    }),
  ("undefined" != typeof QuickInfoJS && null != QuickInfoJS && QuickInfoJS) ||
    (QuickInfoJS = {
      productImgDimensions: "1000x1000",
      quickInfoImgDimensions: "330x330",
      catEntryParams: {},
      selectedAttributes: new Object(),
      catEntryQuantity: 1,
      itemDetailsArr: new Object(),
      params: null,
      replaceOrderItemId: "",
      itemId: "",
      selectedSkuIndex: null,
      selectedThumbnailIndex: null,
      setReplaceOrderItemId: function (e) {
        this.replaceOrderItemId = e;
      },
      setValues: function () {
        $("#catEntryParamsForJS").length &&
          (this.catEntryParams = $.parseJSON($("#catEntryParamsForJS").val())),
          (this.catEntryParams.attributes = this.selectedAttributes);
      },
      setCatEntryQuantity: function (e) {
        this.catEntryQuantity = e;
      },
      showDetails: function (e, t, r, s, a) {
        if (
          (t ? (this.params = t) : (this.params = null),
          (this.selectedAttributes = new Object()),
          (this.selectedSkuIndex = null),
          (this.selectedThumbnailIndex = null),
          submitRequest())
        ) {
          this.close(), cursor_wait();
          var i = this.setCommonParams();
          r
            ? ((this.itemId = r), (i.updateAttributes = "true"))
            : ((this.itemId = ""), (i.updateAttributes = "false")),
            a && (i.parentPage = a),
            s && (this.catEntryQuantity = s),
            (i.productId = e),
            wcRenderContext.updateRenderContext("QuickInfoContext", i);
        }
      },
      changeAttributes: function (e, t, r, s) {
        this.setReplaceOrderItemId(e), this.showDetails(t, null, r, s);
      },
      changeImage: function (e, t) {
        (this.selectedThumbnailIndex = e - 1),
          $("#quickInfoMainImage").attr(
            "src",
            this.getQuickInfoImage(
              this.catEntryParams.skus[this.selectedSkuIndex]
                .thumbnailAttachments[this.selectedThumbnailIndex].path
            )
          ),
          $(".widget_quick_info_popup .other_views li").removeClass("selected"),
          "true" === isProduct
            ? $("#quickInfoProductThumbnail" + e).addClass("selected")
            : $("#quickInfoThumbnail" + e).addClass("selected");
      },
      setSelectedAttribute: function (e, t) {
        this.selectedAttributes[e] = t;
      },
      notifyAttributeChange: function () {
        wcTopic.publish("QuickInfo_attributesChanged", [
          JSON.stringify(this.selectedAttributes),
        ]),
          this.setValues();
        var e = this.resolveSKU();
        if (-1 != e)
          wcTopic.publish(
            "DefiningAttributes_Resolved",
            e,
            this.catEntryParams.id
          ),
            QuickInfoJS.selectItem(!0);
        else {
          wcTopic.publish("DefiningAttributes_Resolved", null, null);
          var t = !1;
          for (var r in this.selectedAttributes)
            null !== this.selectedAttributes[r] &&
              "" !== this.selectedAttributes[r] &&
              (t = !0);
          t ||
            ($("div[id^='quickinfoAngleImagesArea']").css("display", "none"),
            $("div[id^='quickinfoProductAngleImagesArea']").css(
              "display",
              "block"
            ),
            this.showDetails(this.catEntryParams.id, null, null, null, ""));
        }
      },
      selectItem: function (e, t) {
        (this.displayPriceRange = e), this.setValues();
        var r = this.resolveSKU();
        if (-1 == r && t) {
          var s = -1;
          for (idx = 0; idx < this.catEntryParams.skus.length; idx++)
            for (attribute in this.catEntryParams.skus[idx].attributes)
              if (
                this.catEntryParams.attributes &&
                this.catEntryParams.skus[idx].attributes[attribute] ==
                  this.catEntryParams.attributes[attribute]
              ) {
                s = this.catEntryParams.skus[idx].id;
                break;
              }
          -1 != s && ((r = s), (this.updateItemImageOnly = t));
        }
        if (-1 != r)
          if (
            null != this.itemDetailsArr[r] &&
            "undefined" != this.itemDetailsArr[r]
          )
            this.displayItemDetails(this.itemDetailsArr[r]);
          else {
            var a = this.setCommonParams();
            (a.catalogEntryId = r),
              wcService.declare({
                id: "getCatalogEntryDetailsQI",
                actionId: "getCatalogEntryDetailsQI",
                url:
                  getAbsoluteURL() +
                  appendWcCommonRequestParameters(
                    "GetCatalogEntryDetailsByIDView"
                  ),
                formId: "",
                successHandler: function (e, t) {
                  QuickInfoJS.setItemDetails(e, t);
                },
                failureHandler: function (e, t) {
                  console.debug(
                    "QuickInfoJS.selectItem: Unexpected error occurred during an xhrPost request."
                  );
                },
              }),
              wcService.invoke("getCatalogEntryDetailsQI", a);
          }
      },
      selectSwatch: function (e, t, r, s) {
        if (
          $("[id='quickInfoSwatch_" + e + "_" + t + "']").hasClass(
            "color_swatch_disabled"
          )
        )
          return alert("return.."), !1;
        this.setValues();
        for (
          var a = $("#WC_QuickInfo_SwatchNames").val().split("_"),
            i = -1,
            n = 0;
          n < a.length;
          n++
        )
          if (a[n] == e) {
            i = n;
            break;
          }
        var o = "quickInfoSwatch_" + e + "_" + t,
          d = "WC_QuickInfo_Swatch_" + e + "_" + t,
          l = new Array();
        for (idx in this.catEntryParams.skus) {
          var c = !1,
            u = this.catEntryParams.skus[idx];
          for (attribute in u.attributes)
            if (e == attribute && t == u.attributes[attribute] && u.buyable) {
              c = !0;
              break;
            }
          if (c)
            for (attribute in u.attributes) {
              for (var m = -1, n = 0; n < a.length; n++)
                if (a[n] == attribute) {
                  m = n;
                  break;
                }
              m > i && l.push(attribute + "_" + u.attributes[attribute]);
            }
        }
        var g = new Array(),
          p = new Array();
        for (idx in this.catEntryParams.skus) {
          var u = this.catEntryParams.skus[idx];
          for (attribute in u.attributes) {
            for (var m = -1, n = 0; n < a.length; n++)
              if (a[n] == attribute) {
                m = n;
                break;
              }
            if (m > i) {
              for (
                var h = attribute + "_" + u.attributes[attribute],
                  r = "quickInfoSwatch_" + h,
                  I = "WC_QuickInfo_Swatch_" + h,
                  y = -1,
                  n = 0;
                n < l.length;
                n++
              )
                if (l[n] == h) {
                  y = n;
                  break;
                }
              for (var f = -1, n = 0; n < g.length; n++)
                if (g[n] == h) {
                  f = n;
                  break;
                }
              y > -1
                ? $("[id='" + r + "']").hasClass("color_swatch_selected") ||
                  ($("[id='" + r + "']").attr("class", "color_swatch"),
                  $("[id='" + r + "']").attr(
                    "src",
                    $("[id='" + r + "']")
                      .attr("src")
                      .replace("_disabled.png", "_enabled.png")
                  ),
                  $("[id='" + I + "']").attr("aria-disabled", "false"))
                : -1 == f &&
                  (g.push(h),
                  $("[id='" + r + "']").hasClass("color_swatch_selected") &&
                    p.push(r),
                  $("[id='" + r + "']").attr("class", "color_swatch_disabled"),
                  $("[id='" + r + "']").attr(
                    "src",
                    $("[id='" + r + "']")
                      .attr("src")
                      .replace("_enabled.png", "_disabled.png")
                  ),
                  $("[id='" + I + "']").attr("aria-disabled", "true"));
            }
            $(
              "[id='WC_QuickInfo_Swatch_" +
                attribute +
                "_" +
                u.attributes[attribute] +
                "']"
            ).attr("aria-checked", "false");
          }
        }
        for (idx in p) {
          var S = p[idx],
            v = "img[id^='" + S.substring(0, S.lastIndexOf("_")) + "']",
            _ = !1;
          $(v).each(function (e, t, r) {
            if (!_ && $(t).hasClass("color_swatch")) {
              var s = t.id.split("_");
              QuickInfoJS.selectSwatch(
                s[1],
                s[2],
                "quickInfoSwatch_" + s[1] + "_" + s[2],
                "quickInfoSwatch_" + s[1] + "_"
              ),
                QuickInfoJS.selectItem(!0),
                (_ = !0);
            }
          });
        }
        (selector = "img[id^='" + s + "']"),
          $(selector).each(function (e, t, r) {
            $(t).hasClass("color_swatch_disabled") ||
              ($(t).addClass("color_swatch"),
              $(t).hasClass("color_swatch_selected") &&
                $(t).removeClass("color_swatch_selected"));
          }),
          $("[id='" + o + "']").attr("class", "color_swatch_selected"),
          $("[id='quickinfo_swatch_selection_" + e + "']").html(t),
          $("[id='" + d + "']").attr("aria-checked", "true"),
          this.setSelectedAttribute(e, t);
      },
      setCommonParams: function () {
        var e = new Object();
        return (
          (e.storeId = WCParamJS.storeId),
          (e.catalogId = WCParamJS.catalogId),
          (e.langId = WCParamJS.langId),
          e
        );
      },
      setItemDetails: function (e, t) {
        (QuickInfoJS.itemDetailsArr[
          e.catalogEntry.catalogEntryIdentifier.uniqueID
        ] = e.catalogEntry),
          QuickInfoJS.displayItemDetails(e.catalogEntry);
      },
      displayItemDetails: function (e) {
        if (null != this.catEntryParams)
          for (idx in this.catEntryParams.skus)
            if (
              null != this.catEntryParams.skus[idx] &&
              this.catEntryParams.skus[idx].id ==
                e.catalogEntryIdentifier.uniqueID
            ) {
              var t = $("div[id^='quickinfoAngleImagesArea']"),
                r = $("div[id^='quickinfoProductAngleImagesArea']");
              if (t.length) var s = t[0];
              if (
                null != this.catEntryParams.skus[idx].thumbnailAttachments &&
                this.catEntryParams.skus[idx].thumbnailAttachments.length > 0
              ) {
                r.css("display", "none");
                var a = $("ul[id^='quickInfoAngleImagesAreaList']");
                if (a.length) {
                  var i = a[0];
                  for (
                    null != s && $(s).css("display", "block"), idx2 = 1;
                    idx2 <=
                    this.catEntryParams.skus[idx].thumbnailAttachments.length;
                    idx2++
                  ) {
                    var n = document.createElement("li"),
                      o = document.createElement("a"),
                      d = document.createElement("img");
                    (n.id = "quickInfoThumbnail" + idx2),
                      (o.href =
                        "javaScript:QuickInfoJS.changeImage(" +
                        idx2 +
                        ",'" +
                        this.catEntryParams.skus[idx].fullImageAttachments[
                          idx2 - 1
                        ].path +
                        "');"),
                      (o.id = "WC_QuickInfo_Link_thumbnail_" + idx2),
                      (o.className = "tlignore"),
                      "undefined" !=
                        this.catEntryParams.skus[idx].thumbnailAttachments[
                          idx2 - 1
                        ].shortDesc &&
                        null !=
                          this.catEntryParams.skus[idx].thumbnailAttachments[
                            idx2 - 1
                          ].shortDesc &&
                        (o.title =
                          this.catEntryParams.skus[idx].thumbnailAttachments[
                            idx2 - 1
                          ].shortDesc),
                      (d.src =
                        this.catEntryParams.skus[idx].thumbnailAttachments[
                          idx2 - 1
                        ].path),
                      "undefined" !=
                        this.catEntryParams.skus[idx].thumbnailAttachments[
                          idx2 - 1
                        ].shortDesc &&
                        null !=
                          this.catEntryParams.skus[idx].thumbnailAttachments[
                            idx2 - 1
                          ].shortDesc &&
                        (d.alt =
                          this.catEntryParams.skus[idx].thumbnailAttachments[
                            idx2 - 1
                          ].shortDesc),
                      1 == idx2 && $(i).empty(),
                      o.appendChild(d),
                      n.appendChild(o),
                      i.appendChild(n);
                  }
                }
              } else {
                var l = "block";
                for (attribute in this.selectedAttributes)
                  null != this.selectedAttributes[attribute] &&
                    "" != this.selectedAttributes[attribute] &&
                    (l = "none");
                if (null != r)
                  for (var c = 0; c < r.length; c++)
                    null != r[c] && $(r[c]).css("display", l);
                null != s && $(s).css("display", "none");
              }
              null == this.selectedThumbnailIndex &&
                (this.selectedThumbnailIndex = 0),
                (this.selectedSkuIndex = idx);
              var u = e.description[0].thumbnail;
              null != u &&
                0 != u.length &&
                $("#quickInfoMainImage").attr("src", u),
                $("#ProductInfoImage_" + this.catEntryParams.id).length &&
                  (document.getElementById(
                    "ProductInfoImage_" + this.catEntryParams.id
                  ).value = u);
            }
        if (this.updateItemImageOnly)
          return void (this.updateItemImageOnly = !1);
        if (
          ($(".widget_quick_info_popup .main_header")
            .first()
            .html(e.description[0].name),
          $("#ProductInfoName_" + this.catEntryParams.id).length &&
            (document.getElementById(
              "ProductInfoName_" + this.catEntryParams.id
            ).value = e.description[0].name),
          e.listPriced && e.listPrice > e.offerPrice)
        )
          if (null != $(".widget_quick_info_popup .old_price")[0])
            $(".widget_quick_info_popup .old_price").first().html(e.listPrice);
          else {
            var m = "<span class='old_price'>" + e.listPrice + "</span>",
              g = $(".widget_quick_info_popup .price")[0];
            $(m).before(g);
          }
        else
          null != $(".widget_quick_info_popup .old_price")[0] &&
            $(".widget_quick_info_popup .old_price").remove();
        $(".widget_quick_info_popup .price").first().html(e.offerPrice),
          $(".widget_quick_info_popup .sku")
            .first()
            .html(
              Utils.getLocalizationMessage("SKU") +
                " " +
                e.catalogEntryIdentifier.externalIdentifier.partNumber
            ),
          $("#ProductInfoPrice_" + this.catEntryParams.id).length &&
            (document.getElementById(
              "ProductInfoPrice_" + this.catEntryParams.id
            ).value = e.offerPrice);
      },
      validate: function () {
        return "ProductBean" != this.catEntryParams.type ||
          (null != this.catEntryParams.attributes &&
            "undefined" != this.catEntryParams.attributes)
          ? isPositiveInteger(this.catEntryQuantity)
            ? !0
            : (MessageHelper.displayErrorMessage(
                Utils.getLocalizationMessage.QUANTITY_INPUT_ERROR
              ),
              !1)
          : (MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage.ERR_RESOLVING_SKU
            ),
            !1);
      },
      add2ShopCart: function (e) {
        if (browseOnly)
          return void MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage.ERROR_ADD2CART_BROWSE_ONLY
          );
        if ((this.setValues(), this.validate())) {
          null == this.params &&
            ((this.params = this.setCommonParams()),
            (this.params.orderId = "."),
            (this.params.inventoryValidation = "true"),
            (this.params.calculateOrder = "0"));
          var t = "";
          if (
            "itembean" == this.catEntryParams.type.toLowerCase() ||
            "packagebean" == this.catEntryParams.type.toLowerCase() ||
            "dynamickitbean" == this.catEntryParams.type.toLowerCase()
          )
            updateParamObject(
              this.params,
              "catEntryId",
              this.catEntryParams.id,
              !1,
              -1
            ),
              updateParamObject(
                this.params,
                "quantity",
                this.catEntryQuantity,
                !1,
                -1
              ),
              (t = this.catEntryParams.id);
          else {
            var r = this.resolveSKU();
            if (-1 == r)
              return void MessageHelper.displayErrorMessage(
                Utils.getLocalizationMessage.ERR_RESOLVING_SKU
              );
            updateParamObject(this.params, "catEntryId", r, !1, -1),
              updateParamObject(
                this.params,
                "quantity",
                this.catEntryQuantity,
                !1,
                -1
              ),
              (t = r);
          }
          var s = "AddOrderItem";
          if (null != e && "undefined" != e) {
            for (i in e) this.params[i] = e[i];
            "dynamicKit" == e.catalogEntryType &&
              (s = "AddPreConfigurationToCart");
          }
          "dynamicKit" == this.params.catalogEntryType &&
            (s = "AddPreConfigurationToCart"),
            shoppingActionsJS.saveAddedProductInfo(
              this.catEntryQuantity,
              this.catEntryParams.id,
              t,
              this.selectedAttributes
            ),
            this.close(),
            submitRequest() &&
              (cursor_wait(), wcService.invoke(s, this.params));
        }
      },
      resolveSKU: function () {
        if (1 == this.catEntryParams.skus.length)
          return this.catEntryParams.skus[0].id;
        for (idx = 0; idx < this.catEntryParams.skus.length; idx++) {
          var e = 0,
            t = 0;
          for (attribute in this.catEntryParams.skus[idx].attributes) {
            if (
              (t++,
              !this.catEntryParams.attributes ||
                this.catEntryParams.skus[idx].attributes[attribute] !=
                  this.catEntryParams.attributes[attribute])
            )
              break;
            e++;
          }
          if (0 != e && e == t) return this.catEntryParams.skus[idx].id;
        }
        return -1;
      },
      showQuickInfoButton: function (e) {
        $("#" + e).css("visibility", "visible");
      },
      hideQuickInfoButton: function (e) {
        $("#" + e).css("visibility", "");
      },
      shiftTabHideQuickInfoButton: function (e, t) {
        t.shiftKey && t.keyCode === KeyCodes.TAB && this.hideQuickInfoButton(e);
      },
      close: function (e) {
        $("#quickInfoPopup").WCDialog("close"),
          null != e &&
            "undefined" != e &&
            document.getElementById(e) &&
            document.getElementById(e).focus();
      },
      setFocus: function (e) {
        if (e.keyCode === KeyCodes.ESCAPE && $("#catEntryParamsForJS").length) {
          var t = $("#catEntryParamsForJS").val(),
            r = $.parseJSON(t).id;
          document.getElementById("catalogEntry_img" + r) &&
            document.getElementById("catalogEntry_img" + r).focus();
        }
      },
      selectDefaultSwatch: function () {
        var swatchElement = $("a[id^='WC_QuickInfo_Swatch_']")[0];
        swatchElement && eval($(swatchElement).attr("href"));
      },
      replaceCartItem: function () {
        if ((this.setValues(), this.validate())) {
          var e = this.resolveSKU();
          if (-1 == e)
            return void MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage.ERR_RESOLVING_SKU
            );
          this.close();
          var t = "",
            r = "",
            s = "",
            a = $("#shipmentTypeId");
          $("#addressId_all").length && $("#shipModeId_all").length
            ? (0 === a.length || "1" != a.val()
                ? (t = $("#addressId_all").val())
                : $("#physicalStoreId").length &&
                  (s = $("#physicalStoreId").val()),
              (r = $("#shipModeId_all").val()))
            : $("#MS_ShipmentAddress_" + this.replaceOrderItemId).length &&
              $("#MS_ShippingMode_" + this.replaceOrderItemId).length &&
              ((t = $("#MS_ShipmentAddress_" + this.replaceOrderItemId).val()),
              (r = $("#MS_ShippingMode_" + this.replaceOrderItemId).val())),
            "" != this.replaceOrderItemId && categoryDisplayJS
              ? shoppingActionsJS.replaceItemAjaxHelper(
                  e,
                  this.catEntryQuantity,
                  this.replaceOrderItemId,
                  t,
                  r,
                  s
                )
              : console.error("categoryDisplayJS not defined");
        }
      },
      selectCurrentAttributes: function () {
        for (idx = 0; idx < this.catEntryParams.skus.length; idx++) {
          var e = this.catEntryParams.skus[idx];
          if (e.id == this.itemId) {
            for (attribute in e.attributes) {
              var t = $("select[alt='" + attribute + "']")[0];
              if (t)
                (t.value = e.attributes[attribute]),
                  this.setSelectedAttribute(attribute, t.value);
              else {
                var r = e.attributes[attribute];
                $("[id='quickInfoSwatch_" + attribute + "_" + r + "']")
                  .length &&
                  this.selectSwatch(
                    attribute,
                    r,
                    "quickInfoSwatch_" + attribute + "_" + r,
                    "quickInfoSwatch_" + attribute + "_"
                  );
              }
            }
            return this.notifyAttributeChange(), void this.selectItem(!0);
          }
        }
      },
    }),
  ("undefined" != typeof SearchJS && null != SearchJS && SearchJS) ||
    (SearchJS = {
      autoSuggestTimer: -1,
      autoSuggestKeystrokeDelay: 400,
      autoSuggestHover: !1,
      autoSuggestPreviousTerm: "",
      autoSuggestURL: "",
      autoSelectOption: -1,
      historyIndex: -1,
      retrievedCachedSuggestions: !1,
      TOTAL_SUGGESTED: 4,
      TOTAL_HISTORY: 2,
      AUTOSUGGEST_THRESHOLD: 1,
      DYNAMIC_AUTOSUGGEST_THRESHOLD: 1,
      CACHED_AUTOSUGGEST_OFFSET: 1e3,
      END_OF_LIST: !1,
      STATIC_CONTENT_SECTION_DIV: [
        "autoSuggestStatic_1",
        "autoSuggestStatic_2",
        "autoSuggestStatic_3",
      ],
      staticContentHeaderHistory: "",
      SearchAutoSuggestServletURL: "",
      searchDepartmentHoverTimeout: "",
      searchSuggestionHoverTimeout: "",
      mouseDownConnectHandle: null,
      searchDepartmentSelect: function (e, t) {
        return (
          $("#searchDepartmentLabel").html(t.innerHTML),
          ($("#search_categoryId").value = e),
          this.hideSearchDepartmentList(),
          !1
        );
      },
      cancelEvent: function (e) {
        e.stopPropagation && e.stopPropagation(),
          e.preventDefault && e.preventDefault(),
          (e.cancelBubble = !0),
          (e.cancel = !0),
          (e.returnValue = !1);
      },
      searchDepartmentKeyPressed: function (e, t, r, s, a) {
        if (e.keyCode === KeyCodes.RETURN) {
          this.searchDepartmentSelect(s, a);
          var i = document.getElementById("mobileSearchDropdown");
          null != i && "block" == i.style.display
            ? $("#MobileSimpleSearchForm_SearchTerm").focus()
            : document.CatalogSearchForm.searchTerm.focus();
        } else if (e.keyCode === KeyCodes.UP_ARROW)
          0 != t &&
            ($("#searchDepartmentList_" + (t - 1)).focus(),
            this.cancelEvent(e));
        else if (e.keyCode === KeyCodes.DOWN_ARROW)
          t != r &&
            ($("#searchDepartmentList_" + (t + 1)).focus(),
            this.cancelEvent(e));
        else if (e.keyCode === KeyCodes.ESCAPE) {
          var i = document.getElementById("mobileSearchDropdown");
          null != i && "block" == i.style.display
            ? $("#MobileSimpleSearchForm_SearchTerm").focus()
            : document.CatalogSearchForm.searchTerm.focus(),
            this.hideSearchDepartmentList();
        } else if (e.shiftKey && e.keyCode === KeyCodes.TAB) {
          var i = document.getElementById("mobileSearchDropdown");
          null != i && "block" == i.style.display
            ? $("#MobileSimpleSearchForm_SearchTerm").focus()
            : document.CatalogSearchForm.searchTerm.focus(),
            this.cancelEvent(e),
            this.hideSearchDepartmentList();
        } else
          e.keyCode === KeyCodes.TAB &&
            ($("#search_submit").focus(),
            this.cancelEvent(e),
            this.hideSearchDepartmentList());
        return !1;
      },
      hideSearchDepartmentList: function () {
        $("#searchDepartmentList").css("display", "none");
      },
      init: function () {
        $(document.CatalogSearchForm.searchTerm).on(
          "focus",
          $.proxy(SearchJS._onFocus, SearchJS)
        ),
          $(document.CatalogSearchForm.searchTerm).on(
            "keydown",
            $.proxy(SearchJS._onKeyDown, SearchJS)
          ),
          $(document.CatalogSearchForm.searchTerm).on(
            "keyup",
            $.proxy(SearchJS._onKeyUp, SearchJS)
          ),
          $("#searchDropdown").on(
            "keyup",
            $.proxy(SearchJS._onKeyTab, SearchJS)
          );
      },
      showSearchComponent: function () {
        var e = document.getElementById("searchDropdown");
        null != e && (e.style.display = "block");
      },
      hideSearchComponent: function () {
        var e = document.getElementById("searchDropdown");
        null != e && (e.style.display = "none");
      },
      _showMobileSearchComponent: function () {
        var e = document.getElementById("mobileSearchDropdown");
        null != e &&
          ("block" == e.style.display
            ? (DepartmentJS.close("mobileSearchDropdown"),
              (e.style.display = "none"))
            : ($(".subDeptDropdown ").each(function (e, t) {
                DepartmentJS.close(t.id);
              }),
              DepartmentJS.close("departmentsDropdown"),
              (e.style.display = "block")));
      },
      setAutoSuggestURL: function (e) {
        this.SearchAutoSuggestServletURL = getAbsoluteURL() + e;
      },
      _onFocus: function (e) {
        this.showSearchComponent(), this.retrieveCachedSuggestions();
      },
      _MobileonFocus: function (e) {
        this.showSearchComponent(), this.retrieveCachedSuggestions();
      },
      _MobileonBlur: function (e) {
        clearTimeout(this.searchSuggestionHoverTimeout),
          (this.searchSuggestionHoverTimeout = setTimeout(
            "SearchJS.showAutoSuggest(false)",
            100
          ));
      },
      _onKeyPress: function (e) {
        return e.keyCode !== KeyCodes.RETURN;
      },
      _onKeyDown: function (e) {
        e.keyCode === KeyCodes.RETURN
          ? (this._handleEnterKey(), this.cancelEvent(e))
          : e.keyCode === KeyCodes.TAB &&
            (clearTimeout(this.searchSuggestionHoverTimeout),
            (this.searchSuggestionHoverTimeout = setTimeout(
              "SearchJS.showAutoSuggest(false)",
              200
            )));
      },
      _onKeyUp: function (e) {
        var t = document.getElementById("searchDropdown");
        (t.style.display = "block"),
          this.doAutoSuggest(
            e,
            this.SearchAutoSuggestServletURL,
            document.CatalogSearchForm.searchTerm.value
          );
      },
      _onKeyTab: function (e) {
        e.keyCode === KeyCodes.TAB && $("#searchFilterButton").focus();
      },
      _MobileonKeyUp: function (e) {
        var t = document.getElementById("mobileSearchDropdown");
        (t.style.display = "block"),
          this.doAutoSuggest(
            e,
            this.SearchAutoSuggestServletURL,
            $("#MobileSimpleSearchForm_SearchTerm").val()
          );
      },
      _handleEnterKey: function () {
        (document.CatalogSearchForm.searchTerm.value = trim(
          document.CatalogSearchForm.searchTerm.value
        )),
          document.CatalogSearchForm.searchTerm.value.length > 0 &&
            (this.END_OF_LIST
              ? this.gotoAdvancedSearch(byId("advancedSearch").href)
              : "" !== this.autoSuggestURL &&
                this.autoSuggestURL != document.location.href + "#"
              ? (document.location.href = appendWcCommonRequestParameters(
                  this.autoSuggestURL
                ))
              : ((document.CatalogSearchForm.searchTerm.value = trim(
                  document.CatalogSearchForm.searchTerm.value
                )),
                submitSpecifiedForm(document.CatalogSearchForm)));
      },
      _onClick: function (e) {
        return (
          (document.CatalogSearchForm.searchTerm.value = trim(
            document.CatalogSearchForm.searchTerm.value
          )),
          document.CatalogSearchForm.searchTerm.value.length > 0 &&
            ("undefined" != typeof TealeafWCJS &&
              TealeafWCJS.processDOMEvent(e),
            submitSpecifiedForm(document.CatalogSearchForm)),
          !1
        );
      },
      _MobileonClick: function (e) {
        return (
          (document.MobileCatalogSearchForm.searchTerm.value = trim(
            document.MobileCatalogSearchForm.searchTerm.value
          )),
          document.MobileCatalogSearchForm.searchTerm.value.length > 0 &&
            ("undefined" != typeof TealeafWCJS &&
              TealeafWCJS.processDOMEvent(e),
            submitSpecifiedForm(document.MobileCatalogSearchForm)),
          !1
        );
      },
      doDynamicAutoSuggest: function (e, t, r) {
        -1 != this.autoSuggestTimer &&
          (clearTimeout(this.autoSuggestTimer), (this.autoSuggestTimer = -1)),
          (this.autoSuggestTimer = setTimeout(function () {
            var s = e + "&term=" + encodeURIComponent(t) + "&showHeader=" + r;
            $("#autoSuggestDynamic_Result_div").refreshWidget("updateUrl", s),
              console.debug("update autosuggest " + e),
              wcRenderContext.updateRenderContext("AutoSuggest_Context", {}),
              (this.autoSuggestTimer = -1);
          }, this.autoSuggestKeystrokeDelay));
      },
      gotoAdvancedSearch: function (e) {
        var t = $("#SimpleSearchForm_SearchTerm").val();
        document.location.href =
          appendWcCommonRequestParameters(e) + "&searchTerm=" + t;
      },
      showAutoSuggest: function (e) {
        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        var t = document.getElementById("autoSuggest_Result_div"),
          r = Utils.get_IE_version();
        if (r && 7 > r)
          var s = document.getElementById("autoSuggest_content_div"),
            a = document.getElementById("autoSuggestDropDownIFrame");
        if (isMobile) {
          null != t && "undefined" != typeof t
            ? e
              ? ((t.style.display = "block"),
                r &&
                  7 > r &&
                  ((a.style.height = s.scrollHeight),
                  (a.style.display = "block")),
                this.registerMouseDown(),
                $(".header__first-login").hide(),
                $(".header__search").css({ "max-height": "500px" }),
                $("#firstLogin").css({ "z-index": "19" }),
                $("#searchBox").css({ height: "500px" }),
                $("#searchDropdown").css({
                  left: "0px",
                  right: "0px",
                  width: "100%",
                }))
              : (r &&
                  7 > r &&
                  ((a.style.display = "none"), (a.style.height = 0)),
                (t.style.display = "none"),
                this.unregisterMouseDown(),
                $(".header__first-login").show(),
                $(".header__search").css({ "max-height": "64px" }),
                $("#firstLogin").css({ "z-index": "20" }),
                $("#searchBox").css({ height: "32px" }))
            : this.unregisterMouseDown();
        } else {
          null != t && "undefined" != typeof t
            ? e
              ? ((t.style.display = "block"),
                r &&
                  7 > r &&
                  ((a.style.height = s.scrollHeight),
                  (a.style.display = "block")),
                this.registerMouseDown(),
                $("#searchBox").css({ height: "225px" }))
              : (r &&
                  7 > r &&
                  ((a.style.display = "none"), (a.style.height = 0)),
                (t.style.display = "none"),
                this.unregisterMouseDown(),
                $("#searchBox").css({ height: "68px" }))
            : this.unregisterMouseDown();
        }
      },
      showAutoSuggestIfResults: function () {
        var e = document.getElementById("mobileSearchDropdown");
        "undefined" != typeof staticContent &&
        "" === $("#" + this.STATIC_CONTENT_SECTION_DIV[0]).html() &&
        "" === $("#autoSuggestHistory").html() &&
        null == document.getElementById("dynamicAutoSuggestTotalResults")
          ? this.showAutoSuggest(!1)
          : null != e && "block" == e.style.display
          ? $("#MobileSimpleSearchForm_SearchTerm").val().length <=
            this.AUTOSUGGEST_THRESHOLD
            ? this.showAutoSuggest(!1)
            : this.showAutoSuggest(!0)
          : document.CatalogSearchForm.searchTerm.value.length <=
            this.AUTOSUGGEST_THRESHOLD
          ? this.showAutoSuggest(!1)
          : this.showAutoSuggest(!0);
      },
      selectAutoSuggest: function (e) {
        var t = document.getElementById("mobileSearchDropdown");
        if (null != t && "block" == t.style.display)
          var r = document.getElementById("MobileSimpleSearchForm_SearchTerm");
        else var r = document.CatalogSearchForm.searchTerm;
        (r.value = e),
          r.focus(),
          (this.autoSuggestPreviousTerm = e),
          "undefined" != typeof TealeafWCJS &&
            TealeafWCJS.createExplicitChangeEvent(r),
          submitSpecifiedForm(document.CatalogSearchForm);
      },
      highLightSelection: function (e, t) {
        var r = document.getElementById("autoSelectOption_" + t);
        if (null != r && "undefined" != typeof r) {
          if (e) {
            r.className = "autoSuggestSelected";
            var s = document.getElementById("mobileSearchDropdown");
            if (null != s && "block" == s.style.display)
              var a = document.getElementById(
                "MobileSimpleSearchForm_SearchTerm"
              );
            else var a = document.CatalogSearchForm.searchTerm;
            $(a).attr("aria-activedescendant", "suggestionItem_" + t);
            var i = document.getElementById("dynamicAutoSuggestTotalResults");
            ((null != i && "undefined" != typeof i && t < i.value) ||
              t >= this.historyIndex) &&
              ((a.value = r.title), (this.autoSuggestPreviousTerm = r.title)),
              (this.autoSuggestURL = r.href);
          } else r.className = "";
          return !0;
        }
        return !1;
      },
      enableAutoSelect: function (e) {
        this.highLightSelection(!1, this.autoSelectOption);
        var t = document.getElementById("autoSelectOption_" + e);
        (t.className = "autoSuggestSelected"), (this.autoSelectOption = e);
      },
      resetAutoSuggestKeyword: function () {
        var e = document.getElementById("autoSuggestOriginalTerm");
        if (null != e && "undefined" != typeof e) {
          var t = document.getElementById("mobileSearchDropdown");
          if (null != t && "block" == t.style.display)
            var r = document.getElementById(
              "MobileSimpleSearchForm_SearchTerm"
            );
          else var r = document.CatalogSearchForm.searchTerm;
          (r.value = e.value), (this.autoSuggestPreviousTerm = e.value);
        }
      },
      clearAutoSuggestResults: function () {
        for (var e = 0; e < staticContent.length; e++)
          $("#" + this.STATIC_CONTENT_SECTION_DIV[e]).html("");
        (this.autoSuggestPreviousTerm = ""),
          (this.autoSuggestURL = ""),
          $("#autoSuggestDynamic_Result_div").html(""),
          this.showAutoSuggest(!1);
      },
      doAutoSuggest: function (e, t, r) {
        if (
          ((r = r.trim()),
          r.length <= this.AUTOSUGGEST_THRESHOLD && this.showAutoSuggest(!1),
          e.keyCode !== KeyCodes.RETURN)
        ) {
          if (e.keyCode === KeyCodes.TAB)
            return void (this.autoSuggestHover = !0);
          if (e.keyCode === KeyCodes.ESCAPE)
            return void this.showAutoSuggest(!1);
          if (e.keyCode !== KeyCodes.UP_ARROW) {
            if (e.keyCode !== KeyCodes.DOWN_ARROW) {
              if (
                !(
                  (r.length > this.AUTOSUGGEST_THRESHOLD &&
                    r == this.autoSuggestPreviousTerm) ||
                  ((this.autoSuggestPreviousTerm = r),
                  r.length <= this.AUTOSUGGEST_THRESHOLD)
                )
              )
                if (
                  (-1 != this.autoSuggestTimer &&
                    (clearTimeout(this.autoSuggestTimer),
                    (this.autoSuggestTimer = -1)),
                  "" !== r)
                ) {
                  this.autoSelectOption = -1;
                  this.doStaticAutoSuggest(r);
                  if (r.length > this.DYNAMIC_AUTOSUGGEST_THRESHOLD) {
                    var s = !0;
                    this.doDynamicAutoSuggest(t, r, s);
                  } else $("#autoSuggestDynamic_Result_div").html("");
                } else this.clearAutoSuggestResults();
            } else if (this.highLightSelection(!0, this.autoSelectOption + 1))
              this.highLightSelection(!1, this.autoSelectOption),
                this.autoSelectOption++;
            else if (
              this.autoSelectOption < this.CACHED_AUTOSUGGEST_OFFSET &&
              this.highLightSelection(!0, this.CACHED_AUTOSUGGEST_OFFSET)
            )
              this.highLightSelection(!1, this.autoSelectOption),
                (this.autoSelectOption = this.CACHED_AUTOSUGGEST_OFFSET),
                this.resetAutoSuggestKeyword();
            else if (!this.END_OF_LIST) {
              $("#autoSuggestAdvancedSearch").addClass("autoSuggestSelected"),
                this.highLightSelection(!1, this.autoSelectOption),
                this.autoSelectOption++,
                (this.END_OF_LIST = !0);
              var a = document.getElementById("mobileSearchDropdown");
              if (null != a && "block" == a.style.display)
                var i = document.getElementById(
                  "MobileSimpleSearchForm_SearchTerm"
                );
              else var i = document.CatalogSearchForm.searchTerm;
              $(i).attr("aria-activedescendant", "advancedSearch");
            }
          } else {
            var n = document.getElementById("dynamicAutoSuggestTotalResults");
            if (this.END_OF_LIST)
              $("#autoSuggestAdvancedSearch").removeClass(
                "autoSuggestSelected"
              ),
                (this.END_OF_LIST = !1),
                this.autoSelectOption--,
                this.highLightSelection(!0, this.autoSelectOption) ||
                  (this.autoSelectOption == this.CACHED_AUTOSUGGEST_OFFSET &&
                    null != n &&
                    "undefined" != typeof n &&
                    ((this.autoSelectOption = n.value - 1),
                    this.highLightSelection(!0, this.autoSelectOption)));
            else if (this.highLightSelection(!0, this.autoSelectOption - 1))
              this.highLightSelection(!1, this.autoSelectOption),
                this.autoSelectOption == this.historyIndex &&
                  this.resetAutoSuggestKeyword(),
                this.autoSelectOption--;
            else if (
              this.autoSelectOption == this.CACHED_AUTOSUGGEST_OFFSET &&
              null != n &&
              "undefined" != typeof n
            )
              this.highLightSelection(!1, this.CACHED_AUTOSUGGEST_OFFSET),
                (this.autoSelectOption = n.value - 1),
                this.highLightSelection(!0, this.autoSelectOption);
            else {
              this.highLightSelection(!1, this.autoSelectOption),
                (this.autoSelectOption = -1);
              document.getElementById("autoSuggestOriginalTerm");
              this.resetAutoSuggestKeyword();
            }
          }
        }
      },
      tokenizeForBidi: function (e, t, r, s) {
        var a = e.split(" > "),
          n = "",
          o = "";
        if (a.length > 0) {
          for (n += "<div class='category_list'>", i = 0; i < a.length; i++) {
            if (
              (0 != i && (n += "<span class='gt'>&nbsp; > &nbsp;</span>"),
              i == a.length - 1)
            ) {
              var d = t.toLowerCase().indexOf(s),
                l = t.substr(0, d),
                c = t.substr(d + r.length),
                u = "<span class='highlight'>" + r + "</span>";
              o = l + u + c;
            } else o = a[i];
            n += o;
          }
          n += "</div>";
        }
        return n;
      },
      // doStaticAutoSuggest: function (e) {
      //   for (
      //     var t = ["", "", "", "", "", ""],
      //       r = 0,
      //       s = e.toLowerCase(),
      //       a = this.CACHED_AUTOSUGGEST_OFFSET,
      //       i = "<div class='list_section'><div",
      //       n = "</div></div>",
      //       o = 0;
      //     o < staticContent.length;
      //     o++
      //   )
      //     for (var d = 0, l = 0; l < staticContent[o].length; l++) {
      //       var c = staticContent[o][l][0],
      //         u = staticContent[o][l][1],
      //         m = staticContent[o][l][2],
      //         g = c.toLowerCase().indexOf(s);
      //       if (-1 != g) {
      //         var p = this.tokenizeForBidi(m, c, e, s);
      //         if (
      //           ((t[o] =
      //             t[o] +
      //             "<ul class='autoSuggestDivNestedList'><li id='suggestionItem_" +
      //             a +
      //             "' role='listitem' tabindex='-1'><a id='autoSelectOption_" +
      //             a +
      //             "' title='" +
      //             escapeXml(c, !0) +
      //             "' onmouseout='this.className=\"\"; this.autoSuggestURL=\"\";' onclick='SearchJS.hideSearchComponent();' onmouseover='SearchJS.enableAutoSelect(" +
      //             a +
      //             "); this.autoSuggestURL=this.href;' href=\"" +
      //             u +
      //             '">' +
      //             p +
      //             "</a></li></ul>"),
      //           d++,
      //           a++,
      //           d >= this.TOTAL_SUGGESTED)
      //         )
      //           break;
      //       }
      //     }
      //   for (var o = 0; o < staticContent.length; o++)
      //     if (
      //       ($("#" + this.STATIC_CONTENT_SECTION_DIV[o]).html(""), "" !== t[o])
      //     ) {
      //       var h =
      //         "<ul class='autoSuggestDivNestedList'><li class='heading'><span>" +
      //         staticContentHeaders[o] +
      //         "</span></li></ul>";
      //       $("#" + this.STATIC_CONTENT_SECTION_DIV[r]).html(
      //         h +
      //           i +
      //           " role='list' title='" +
      //           staticContentHeaders[o] +
      //           "' aria-label='" +
      //           staticContentHeaders[o] +
      //           "'>" +
      //           t[o] +
      //           n
      //       ),
      //         r++;
      //     }
      //   var I = "",
      //     y = document.getElementById("autoSuggestHistory");
      //   y.innerHTML = "";
      //   var f = [];
      //   this.historyIndex = a;
      //   var S = getCookie("searchTermHistory");
      //   if ("undefined" != typeof S)
      //     for (var v = S.split("|"), d = 0, o = v.length - 1; o > 0; o--) {
      //       var _ = v[o],
      //         C = _.toLowerCase();
      //       if (C.match("^" + s) == s) {
      //         for (var A = !1, l = 0; l < f.length; l++)
      //           if (f[l] == C) {
      //             A = !0;
      //             break;
      //           }
      //         if (!A) {
      //           if (d >= this.TOTAL_HISTORY) break;
      //           (I =
      //             I +
      //             "<ul class='autoSuggestDivNestedList'><li id='suggestionItem_" +
      //             a +
      //             "' role='listitem' tabindex='-1'><a href='#' onmouseout='this.className=\"\"' onmouseover='SearchJS.enableAutoSelect(" +
      //             a +
      //             ");' onclick='SearchJS.selectAutoSuggest(this.title); return false;' title='" +
      //             _ +
      //             "' id='autoSelectOption_" +
      //             a +
      //             "'><strong>" +
      //             e +
      //             "</strong>" +
      //             _.substring(e.length, _.length) +
      //             "</a></li></ul>"),
      //             f.push(C),
      //             d++,
      //             a++;
      //         }
      //       }
      //     }
      //   if (
      //     ("" === this.staticContentHeaderHistory &&
      //       (this.staticContentHeaderHistory =
      //         Utils.getLocalizationMessage("HISTORY")),
      //     "" !== I)
      //   ) {
      //     var h =
      //       "<ul class='autoSuggestDivNestedList'><li class='heading'><span>" +
      //       this.staticContentHeaderHistory +
      //       "</span></li></ul>";
      //     (y.innerHTML =
      //       h +
      //       i +
      //       " title='" +
      //       this.staticContentHeaderHistory +
      //       "'>" +
      //       I +
      //       n),
      //       r++;
      //   }
      //   return r > 0 ? (this.showAutoSuggest(!0), !0) : !1;
      // },
      retrieveCachedSuggestions: function () {
        this.retrievedCachedSuggestions ||
          wcRenderContext.updateRenderContext("CachedSuggestions_Context", {});
      },
      // updateSearchTermHistoryCookie: function (e) {
      //   var t = "searchTermHistory",
      //     r = "|" + e,
      //     s = getCookie(t);
      //   "undefined" != typeof s && (r = setCookie(t) + r),
      //     setCookie(t, r, {
      //       path: "/",
      //       domain: cookieDomain,
      //     });
      // },
      // updateSearchTermHistoryCookieAndRedirect: function (e, t) {
      //   this.updateSearchTermHistoryCookie(e),
      //     -1 == navigator.userAgent.toLowerCase().indexOf("firefox") &&
      //       (document.location.href = appendWcCommonRequestParameters(t));
      // },
      isValidNumber: function (e) {
        return !isNaN(parseFloat(e)) && isFinite(e) && e >= 0;
      },
      validateForm: function (e) {
        (e.minPrice.value = trim(e.minPrice.value)),
          (e.maxPrice.value = trim(e.maxPrice.value));
        var t = e.minPrice.value,
          r = e.maxPrice.value,
          s = this.isValidNumber(t),
          a = this.isValidNumber(r);
        if (t.length > 0 && !s)
          return (
            MessageHelper.formErrorHandleClient(
              e.minPrice.id,
              MessageHelper.messages.EDPPaymentMethods_AMOUNT_NAN
            ),
            !1
          );
        if (r.length > 0 && !a)
          return (
            MessageHelper.formErrorHandleClient(
              e.maxPrice.id,
              MessageHelper.messages.EDPPaymentMethods_AMOUNT_NAN
            ),
            !1
          );
        if (t.length > 0 && r.length > 0 && parseFloat(t) > parseFloat(r))
          return (
            MessageHelper.formErrorHandleClient(
              e.maxPrice.id,
              MessageHelper.messages.ERROR_PRICE_RANGE
            ),
            !1
          );
        (e.searchTerm.value = trim(e.searchTerm.value)),
          (e.filterTerm.value = trim(e.filterTerm.value)),
          (e.manufacturer.value = trim(e.manufacturer.value));
        var i = e.searchTerm.value,
          n = e.filterTerm.value,
          o = e.manufacturer.value;
        return 0 == i.length && 0 == n.length && 0 == o.length
          ? (MessageHelper.formErrorHandleClient(
              e.searchTerm.id,
              MessageHelper.messages.ERROR_EMPTY_SEARCH_FIELDS
            ),
            !1)
          : void processAndSubmitForm(e);
      },
      registerMouseDown: function () {
        null == this.mouseDownConnectHandle &&
          (this.mouseDownConnectHandle = $(document.documentElement).on(
            "mousedown",
            $.proxy("handleMouseDown", this)
          ));
      },
      unregisterMouseDown: function () {
        null != this.mouseDownConnectHandle &&
          ($(document.documentElement).off("mousedown"),
          (this.mouseDownConnectHandle = null));
      },
      handleMouseDown: function (e) {
        var t = e.target;
        if (t != document.documentElement) {
          for (
            var r = document.getElementById("searchDropdown"),
              s = document.CatalogSearchForm.searchTerm,
              a = !0;
            t;

          ) {
            if (t == r || t == s) {
              a = !1;
              break;
            }
            t = t.parentNode;
          }
          a && this.showAutoSuggest(!1);
        }
      },
      declareAutoSuggestRefreshArea: function () {
        wcRenderContext.declare(
          "AutoSuggest_Context",
          ["autoSuggestDynamic_Result_div"],
          null
        );
        var e = function () {
            var e = wcRenderContext.getRenderContextProperties(
              "AutoSuggest_Context"
            );
            $("#autoSuggestDynamic_Result_div").refreshWidget("refresh", e);
          },
          t = function () {
            var e = document.getElementById("suggestedKeywordResults"),
              t = document.getElementById("suggestedProductsResults");
            null == e &&
              null == t &&
              $("#autoSuggestDynamic_Result_div").html(""),
              SearchJS.showAutoSuggestIfResults();
          };
        $("#autoSuggestDynamic_Result_div").refreshWidget({
          renderContextChangedHandler: e,
          postRefreshHandler: t,
        });
      },
      declareAutoSuggestCachedSuggestionRefreshArea: function () {
        wcRenderContext.declare(
          "CachedSuggestions_Context",
          ["autoSuggestCachedSuggestions_div"],
          null
        );
        var e = function () {
            var e = wcRenderContext.getRenderContextProperties(
              "CachedSuggestions_Context"
            );
            $("#autoSuggestCachedSuggestions_div").refreshWidget("refresh", e);
          },
          t = function () {
            var e = document.getElementById("cachedSuggestions");
            if (null == e) $("#autoSuggestCachedSuggestions_div").html("");
            else {
              for (
                var t = e.getElementsByTagName("script"), r = t.length, s = 0;
                r > s;
                s++
              ) {
                var a = document.createElement("script");
                (a.type = "text/javascript"),
                  (a.text = t[s].text),
                  document
                    .getElementById("autoSuggestCachedSuggestions_div")
                    .appendChild(a);
              }
              SearchJS.retrievedCachedSuggestions = !0;
              var i = document.getElementById("mobileSearchDropdown");
              null != i && "block" == i.style.display
                ? (searchTerm = $("#MobileSimpleSearchForm_SearchTerm").val())
                : (searchTerm = document.CatalogSearchForm.searchTerm.value),
                searchTerm.length > SearchJS.AUTOSUGGEST_THRESHOLD &&
                  SearchJS.doStaticAutoSuggest(searchTerm);
            }
          };
        $("#autoSuggestCachedSuggestions_div").refreshWidget({
          renderContextChangedHandler: e,
          postRefreshHandler: t,
        });
      },
    }),
  ("undefined" != typeof ShoppingListDialogJS &&
    null != ShoppingListDialogJS &&
    ShoppingListDialogJS) ||
    ((ShoppingListDialogJS = {
      storeParams: null,
      dialogParams: null,
      setDialogParams: function (e, t) {
        (this.storeParams = e),
          (this.dialogParams = t),
          null == this.dialogParams.image || "" == this.dialogParams.image
            ? this.fetchAddedItem()
            : this.displayItemAddedWithoutFetching();
      },
      fetchAddedItem: function () {
        var e = this.setCommonParams();
        (e.productId = this.dialogParams.catEntryId),
          (e.catalogEntryId = this.dialogParams.catEntryId),
          $.ajax({
            url: getAbsoluteURL() + "GetCatalogEntryDetailsByIDView",
            method: "post",
            dataType: "json",
            data: e,
            success: ShoppingListDialogJS.displayItemAddedDialog,
            error: function (e, t, r) {
              console.debug(
                "QuickInfoJS.selectItem: Unexpected error occurred during an xhrPost request."
              );
            },
          });
      },
      displayItemAddedDialog: function (e) {
        var t = $("#shoppingListItemAddedPopup");
        if (t.length > 0) {
          var r = e.catalogEntry.description[0];
          $("#shoppingListItemAddedImg")
            .attr("src", r.thumbnail)
            .attr("alt", r.name),
            $("#shoppingListItemAddedName").html(r.name),
            $("#shoppingListItemAddedPopup").data("wc-WCDialog").open();
        } else console.debug("shoppingListItemAddedPopup does not exist");
      },
      displayItemAddedWithoutFetching: function () {
        $("#shoppingListItemAddedPopup").length
          ? ($("#shoppingListItemAddedImg").attr(
              "src",
              this.dialogParams.image
            ),
            $("#shoppingListItemAddedImg").attr("alt", this.dialogParams.name),
            $("#shoppingListItemAddedName").html(this.dialogParams.name))
          : console.debug("shoppingListItemAddedPopup does not exist");
      },
      showDialog: function () {
        var e = $("#shoppingListItemAddedPopup");
        e.length > 0
          ? e.data("wc-WCDialog").open()
          : console.debug("shoppingListItemAddedPopup does not exist");
      },
      setCommonParams: function () {
        var e = new Object();
        return (
          (e.storeId = this.storeParams.storeId),
          (e.catalogId = this.storeParams.catalogId),
          (e.langId = this.storeParams.langId),
          e
        );
      },
      close: function () {
        $("#shoppingListItemAddedPopup").hide(),
          this.dialogParams.focusElement &&
            "" != this.dialogParams.focusElement &&
            $("#" + this.dialogParams.focusElement).focus();
      },
    }),
    wcTopic.subscribe(
      "ShoppingListItem_Added",
      ShoppingListDialogJS.showDialog
    )),
  wcRenderContext.declare(
    "WishlistDisplay_Context",
    ["WishlistDisplay_Widget"],
    {
      url: "",
    }
  ),
  wcRenderContext.declare(
    "SharedWishlistDisplay_Context",
    ["SharedWishlistDisplay_Widget"],
    {
      url: "",
    }
  ),
  (ShoppingListControllersJS = {
    declareWishlistDisplayWidgetRefreshController: function () {
      var e = $("#WishlistDisplay_Widget"),
        t = wcRenderContext.getRenderContextProperties(
          "WishlistDisplay_Context"
        ),
        r = function () {
          e.refreshWidget("refresh", t);
        };
      wcTopic.subscribe(
        [
          "ShoppingListServiceCreate",
          "ShoppingListServiceUpdate",
          "ShoppingListServiceDelete",
          "ShoppingListServiceRemoveItem",
          "ShoppingListServiceAddItem",
        ],
        function () {
          e.refreshWidget("refresh");
        }
      );
      var s = function () {
        null != $("#multipleWishlistController_select") &&
          "undefined" != $("#multipleWishlistController_select") &&
          ($("#multipleWishlistController_select").disabled = !1),
          cursor_clear();
      };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareSharedWishlistDisplayRefreshController: function () {
      var e = $("#SharedWishlistDisplay_Widget"),
        t = wcRenderContext.getRenderContextProperties(
          "SharedWishlistDisplay_Context"
        ),
        r = function () {
          e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareWishlistSelectWidgetRefreshController: function () {
      wcRenderContext.declare(
        "WishlistSelect_Context",
        ["WishlistSelect_Widget"],
        ""
      );
      var e = $("#WishlistSelect_Widget"),
        t = wcRenderContext.getRenderContextProperties(
          "WishlistSelect_Context"
        ),
        r = function () {
          e.refreshWidget("refresh", t);
        };
      wcTopic.subscribe(
        [
          "ShoppingListServiceCreate",
          "ShoppingListServiceUpdate",
          "ShoppingListServiceDelete",
          "ShoppingListServiceAddItem",
        ],
        function () {
          e.refreshWidget("refresh");
        }
      );
      var s = function () {
        cursor_clear();
        var e = $("#multipleWishlistController_select");
        null == e
          ? ((MultipleWishLists.defaultListId = null),
            (MultipleWishLists.addItemAfterCreate = null))
          : e.length > 0 &&
            ((MultipleWishLists.defaultListId = $(
              "#multipleWishlistController_select"
            ).val()),
            shoppingListJS.refreshLinkState());
      };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceCreate",
    actionId: "ShoppingListServiceCreate",
    url: getAbsoluteURL() + "AjaxRestWishListCreate",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        closeAllDialogs(),
        wcTopic.publish("ShoppingList_Changed", {
          listId: e.uniqueID,
          listName: e.descriptionName,
          action: "add",
        });
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceUpdate",
    actionId: "ShoppingListServiceUpdate",
    url: getAbsoluteURL() + "AjaxRestWishListUpdate",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        closeAllDialogs(),
        shoppingListJS.showMessageDialog(
          Utils.getLocalizationMessage("LIST_EDITED")
        ),
        wcTopic.publish("ShoppingList_Changed", {
          listId: e.uniqueID,
          listName: e.descriptionName,
          action: "edit",
        });
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceDelete",
    actionId: "ShoppingListServiceDelete",
    url: getAbsoluteURL() + "AjaxRestWishListDelete",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        closeAllDialogs(),
        shoppingListJS.showMessageDialog(
          Utils.getLocalizationMessage("LIST_DELETED")
        ),
        wcTopic.publish("ShoppingList_Changed", {
          listId: e.uniqueID,
          listName: "",
          action: "delete",
        });
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceAddItem",
    actionId: "ShoppingListServiceAddItem",
    url: getAbsoluteURL() + "AjaxRestWishListAddItem",
    formId: "",
    successHandler: function (e) {
      cursor_clear(), wcTopic.publish("ShoppingListItem_Added");
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceRemoveItem",
    actionId: "ShoppingListServiceRemoveItem",
    url: getAbsoluteURL() + "AjaxRestWishListRemoveItem",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        MessageHelper.hideAndClearMessage(),
        shoppingListJS.showMessageDialog(
          Utils.getLocalizationMessage("ITEM_REMOVED")
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceAddItemAndRemoveFromCart",
    actionId: "ShoppingListServiceAddItemAndRemoveFromCart",
    url: getAbsoluteURL() + "AjaxRestWishListAddItem",
    formId: "",
    successHandler: function (e) {
      cursor_clear(), wcTopic.publish("ShoppingListItem_Added");
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxGiftListServiceChangeGiftListStatus",
    actionId: "AjaxGiftListServiceChangeGiftListStatus",
    url: getAbsoluteURL() + "AjaxRestWishListChangeState",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        MessageHelper.hideAndClearMessage(),
        MultipleWishLists.setDefaultListId(e.uniqueID),
        MultipleWishLists.updateContextPostSwitch(e.uniqueID);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxGiftListAnnouncement",
    actionId: "AjaxGiftListAnnouncement",
    url: getAbsoluteURL() + "AjaxRESTWishListAnnounce",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        MessageHelper.hideAndClearMessage(),
        shoppingListJS.showMessageDialog(
          Utils.getLocalizationMessage("WISHLIST_EMAIL_SENT")
        ),
        $("#WishListEmailSucMsg_Div").css("display", "block"),
        $("#recipientEmail_wishListDisplay").html(
          e.recipient[0].substring(0, 25)
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  });


/* jshint esversion: 6 */
/**
 * @fileOverview Generic JS file for Persol brand
 *
 **/
/* detect mobile*/

// .includes polyfill
if (!Array.prototype.includes) {
  Array.prototype.includes = function(searchElement /*, fromIndex*/) {
    'use strict';
    if (this == null) {
      return;
    }

    var O = Object(this);
    var len = parseInt(O.length, 10) || 0;
    if (len === 0) {
      return false;
    }
    var n = parseInt(arguments[1], 10) || 0;
    var k;
    if (n >= 0) {
      k = n;
    } else {
      k = len + n;
      if (k < 0) {k = 0;}
    }
    var currentElement;
    while (k < len) {
      currentElement = O[k];
      if (searchElement === currentElement ||
         (searchElement !== searchElement && currentElement !== currentElement)) { // NaN !== NaN
        return true;
      }
      k++;
    }
    return false;
  };
}
// starts with polyfill
if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, 'startsWith', {
      value: function(search, rawPos) {
          var pos = rawPos > 0 ? rawPos|0 : 0;
          return this.substring(pos, pos + search.length) === search;
      }
  });
}
/* this remove the page positioning on his previous scroll position*/
if (!isIOS() && 'scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

var didResize;

var phoneWidth = 600;
var tabletWidth = 1024;
var countPrescription = 0;

var catalogEntryDetails = "";
var idSection;

function showSubmenu() {
  $(".nav__section").removeClass( "show") ;
  idSection= "#"+ $(this).attr('id') + "_Section";
  $( idSection ).addClass( "show" );
  $('html').addClass('no-scroll');
  $('.facet__fade').addClass('fade');
  $('.facet__fade').css('z-index','10');
  $('.facet__fade').show();

}

function hideSubmenu() {
  $( idSection ).removeClass( "show");
  $('html').removeClass('no-scroll');
  $('.facet__fade').removeClass('fade');
  $('.facet__fade').css('z-index','');
  var nav = idSection.replace("_Section","");
  $( nav ).css("text-decoration","none");

}

function hideshowallsite() {
    var allsite = $("#allsite-content").html();
    if (allsite !== ''){
        var row4 = document.getElementById("footerRow4");
        $("#allsite-content").empty();
        row4.innerHTML = allsite;
    }else;
    
    if ( $("#otherall label").hasClass("active") ){
        $("#otherall label").toggleClass('active');
        $("#footerRow4").hide();
    }
    else{
        $("#otherall label").addClass('active');
        $("#footerRow4").show();
    }
} 

function refreshNavItemSettings(isDesktop) {
if(isDesktop) {		
  $('.sale_badge').removeClass('submenu__subheader');
  $('.sale_badge').removeClass('submenu__subheader--mobile');
  $('.submenu__list-block--desktop li > a').removeClass('submenu__subheader');
  $('.submenu__list-block--desktop li > a').removeClass('submenu__subheader--mobile');
  
  if($('#closeIcon').css('display') != 'none' && $('#closeIcon').css('display') != undefined) //chiudi il menu se aperto
    document.getElementById('header__checkbox').click();
  
  $('.header__block-search').removeClass( "hidden" );
  
  $( ".nav__item" ).hover(
            function(){
            	setDDMPosition();
                $(".nav__section").removeClass( "show") ;
                idSection= "#"+ $($(this).find(".nav__link.desktop")).attr('id') + "_Section";
                $( idSection ).addClass( "show" );
               callAlgoliaServiceEspot(idSection);

                $('html').addClass('no-scroll');
                $('.facet__fade').addClass('fade');
                $('.facet__fade').css('z-index','10');
                $('.facet__fade').show();
                $(this).find(".nav__link.desktop").css("text-decoration","underline");
                $(".nav__item a[id!='"+$(this).find("a").attr("id")+"'].nav__link.desktop").css("text-decoration","none");
            },
            function(){
              //if the cursor is not in hover on the sub menu --> hide the submenu
              if($(".nav__section:hover").length < 1) {
                hideSubmenu();
              }
            }
        );
  
} else {
  //sezione mobile
  $( ".nav__item" ).unbind();
  $('.sale_badge').addClass('submenu__subheader');
  $('.sale_badge').addClass('submenu__subheader--mobile');
  $('.submenu__list-block--desktop li:not(".sale_badge") > a').addClass('submenu__subheader');
  $('.submenu__list-block--desktop li:not(".sale_badge") > a').addClass('submenu__subheader--mobile');
  //loadHeaderEspot("X_Header_NavSunglasses_BestsellersCards"); 
  //loadHeaderEspot("X_Header_NavEyeglasses_BestsellersCards");
}
}  



$(document).ready(function () {
    if (!window.mobilecheck() || !window.tabletPortraitCheck()){
        setDDMPosition();
    }
    

  if($('#page').hasClass('pdp')){

    /* handle when sticky bar doesn't become sticky on landing for HB-12208*/
    if (window.mobilecheck() || window.tabletPortraitCheck()) {
        if(!$(".shopper-action-bar").hasClass("sticky-active")){
            manageStickyElement();
        }
      }


      var timestamp = new Date().getTime() / 1000;
      var diff = timestamp - renderingPageStarterTime;
      console.log('Performance Improvements PDP - #21 - document.ready in store-persol.js (PO only) - ' + diff.toString().slice(0 , 5) + 's');
    }


  var catEntryIdSubscribe;
   // apertura section #departmentLink_sun
  $("#departmentLink_OurWorld_Section,#departmentLink_Gif_Section").addClass("vertical-carousel");
  //apertura menu mobile
  $(".nav__link.phone").click(function() {
    
      var idSection;
      $($(this).siblings()).each(function(){
          if($(this).hasClass("desktop")){
              idSection = "#"+ $(this).attr('id') + "_Section";
          }
          callAlgoliaServiceEspot(idSection); //provare questa
          console.log("idSection",idSection);
          if(idSection == "#departmentLink_collab_Section"){//quando apro collab devo vedere sempre collectio e nascondo i contenuti
              idSection= "#departmentLink_Collection_Section";
              console.log("this",this);
              if($(this).find("subheader__collection")){
                  console.log("ok");
                  $(".subheader__collection").css("display","none");
                  if($(this).find("subheader__collaboration")){
                      $(".subheader__collaboration").css("display","block");
                  }

              }
          }else if(idSection=="#departmentLink_Collection_Section"){
              if($(this).find("subheader__collection")){
                  $(".subheader__collection").css("display","block");
                  if($(this).find("subheader__collaboration")){
                      $(".subheader__collaboration").css("display","none");
                  }

              }

          }
      })

      
      if($( idSection).hasClass('show')){
          $( idSection).removeClass( "show" );
          if(isIOS()){
              document.getElementsByTagName('body')[0].classList.add('iosBody');
          }
      }
      else{
          if(isIOS()){
              document.getElementsByTagName('body')[0].classList.remove('iosBody');
          }
          $( idSection).addClass( "show" );
      }
  });
  //funzione back dopo apertuta menu mobile
  $(".nav_back--phone, .back-arrow-mobile-menu").click(backMenu);

  //enable click on span item in mobile menu
  $('.submenu__subheader--mobile').click(function() {
      if($(this).find("a").attr("href")){
          window.location = $(this).find("a").attr("href");
          return false;
       }
});
  var windowSize = window.innerWidth;
  
  refreshNavItemSettings(windowSize >= tabletWidth);

  $(".nav__link.desktop" ).focusin(
      showSubmenu
  );

  $( ".nav__section" ).hover(
      function(){
          idVoceMenu= "#"+ $(this).attr('id').replace("_Section","");
          $(idVoceMenu).css("text-decoration","underline");

      },
      function(){
          idVoceMenu= "#"+ $(this).attr('id').replace("_Section","");
          $(idVoceMenu).css("text-decoration","none");
          hideSubmenu();
      }
  );
  

  //accesibilità nav bar
  var navActive="";
  document.body.classList.add('using-mouse');
document.body.addEventListener('mousedown', function() {
      document.body.classList.add('using-mouse');
  });


  document.body.addEventListener('wheel', function() {
      document.body.classList.add('using-mouse');
  });


  document.body.addEventListener('keydown', function(e) {
      var keycode;
       if (e.key !== undefined) {
         keycode= e.key
       } else if (e.keyIdentifier !== undefined) {
          keycode=e.keyIdentifier;
      } else if (e.keyCode !== undefined) {

          keycode=e.keyCode;
      }
      console.log("key",keycode)
       if(keycode == "Tab" || keycode==9){
            document.body.classList.remove('using-mouse');

            if($(document.activeElement).hasClass("nav__link")) {
              var idSection = "#"+ $(document.activeElement).attr('id') + "_Section";//compongo id sottomenu
              var link = $(idSection).find(".submenu__item a")[0];
              navActive = document.activeElement;
              $($(idSection).find(".start-section")).focus();
            }
       }
  });

  var navActive = null;
  $(".end-section").focusin(function(){
      $($(this).closest(".nav__section")).removeClass("show"); //dopo aver visto ultimo elemento chiudi in sottomenu
      console.log("end-section")
      if(navActive) {
          var navNext = $($(navActive).closest(".nav__item")).next(); //vado al successivo nav item rispetto a quello con il focus all'inizio
          $($(navNext).find("a")).focus();
      }

  })
  // eyeglasses menu script
  $(document).ready(function(){if(storeDirectory=="PersolUS" || storeDirectory=="PersolUK"||storeDirectory=="PersolDE"){$("#li-prescription").show();}});
// sunglasses menu script
  $(document).ready(function(){if(storeDirectory=="PersolUS" || storeDirectory=="PersolUK"){$("#li-sun-prescription").show();}});


/* var map = {9: false, 16: false};
  $(document).keydown(function(e) {
      if (e.keyCode in map) {
          map[e.keyCode] = true;
          if (map[16] && map[9]) {
           if($(document.activeElement).hasClass("start-section")) {
               var Section = $($(document.activeElement).closest(".nav__section"));
               idLink= "#"+$(Section).attr('id').replace("_Section","");
               var index=$($(idLink).closest(".nav__item")).index()
               console.log(index)
              var navItem=$(".nav__items")[index+1];
              $($(navItem).find("a")).focus();
               // non funziona come dovrebbe

              }
             /*  if($(document.activeElement).hasClass("nav__link")) {
                  var navPrec = $($(document.activeElement).closest(".nav__item")).prev(); // prendo la voce di menu prec
                  $($(document.activeElement).closest(".nav__section")).removeClass("show"); // tolgo la classe show da quella in cui sto
                  var idPrec= $($(navPrec).find(".nav__link")).att("id"); //prendo l'id della precedente voce di menu
                  var idSectionPrec= "#"+ idPrec+ "_Section";//compongo l'id della section prec
                  $(idSectionPrec).addClass("show"); //mostro il sottomenu
                  $(idSectionPrec).find(".end-section").focus(); // metto il focus sull'end section

              }
          }
      }
  }).keyup(function(e) {
      if (e.keyCode in map) {
          map[e.keyCode] = false;
      }
  });*/
  windowSize = window.innerWidth;
  var windowSizePrevious = window.innerWidth;
  /* check promoCalloutCookie */
  checkPromoCookie();
  var ts;
  //stop hiding header on hover
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
      //sposto i other colors per evitare la cash delle var IOS e ANDROID in jsp
      //$('.catalog-entry-recommendation-widget.other_colors').appendTo($('.bottom-section'));
      
      if ($('.ct-promo-bannerTop').is(':visible') && $('.ct-promo-bannerTop').text() !== '') {
        //$('.long-description-widget').css("padding-top", "72px");
        
      } else {
        //$('.catalog-entry-recommendation-widget.other_colors').css("bottom", "28%");
      }
      $('.catalog-entry-recommendation-widget.other_colors').css('display','flex');
      $('.presc--body').css('height', window.innerHeight - $('.presc--content header').outerHeight()-$('.presc--content__button').outerHeight()-$('.presc--content__message').outerHeight()-70+'px'); //40px
      $('.presc--content__fade').width($('.pdp .presc--content--options label').outerWidth());
      $(document).mousemove(function(e){
          var vertical = e.pageY;
          if($('#page').hasClass('pdp') && vertical <= 20
          && !$('#header').is(":visible")
          && $('.slot4').hasClass('fixed-bottom')
          && !$('.presc').hasClass('.showed-presc')
          && !$('.op-pdp-popup-other-colors').hasClass('active')
          && !$('.shopperActions--monogram--pop-up').is(':visible')) {
              if(!window.mobilecheck() || !window.tabletPortraitCheck()){//solo in desktop
                  if($('#page').find('.ct-promo-bannerTop').length) {
                      //$("#bannerTop").css("display","flex");
                      $('#bannerTop').slideDown();
                  }
              } else{
                  if($('#page').find('.ct-promo-bannerTop').length) {
                      //$("#bannerTop").css("display","flex");
                      $('#bannerTop').slideDown();
                  }
              }
            /*   $('#header').slideDown("", function(){
                   setHeightFullImage(true)
                 }); */
              $('.freeShipping').show()
          }
          if(vertical > 120 && $('#header').is(":visible") && !$(".header__nav-menu").hasClass("opend") && !$("#headerRow1--wrapper").siblings() && !$('.presc').hasClass('.showed-presc') && !$('.op-pdp-popup-other-colors').hasClass('active') && !('.shopperActions--monogram--pop-up').is(':visible')) {
              if($('#page').find('.ct-promo-bannerTop').length) {
                  $('#bannerTop').slideUp();
              }
            //   $('#header').slideUp();
              setHeightFullImage(false)
          }
      });
      $('.pdp #header').on('mouseenter', function(){
          hideHeaderTimeout.cancel();
      }).on( 'mouseleave', function(){
          if(!$('#Header_GlobalLogin_signInQuickLink').hasClass('active')){
              hideHeaderTimeout.setup();

          }
          if(!window.mobilecheck() || !window.tabletPortraitCheck()){//solo in desktop controlla
              if($('#page').find('.ct-promo-bannerTop').length) {
                  $("#bannerTop").css("display","flex");
              }}
      });
  } else {
      if($('#page').hasClass('pdp')){
          //event for touch mobile
          $(document).bind('touchstart', function (e){
              ts = e.originalEvent.touches[0].clientY;
          });

          $(document).bind('touchend', function (e){
              var te = e.originalEvent.changedTouches[0].clientY;
              if(ts < te-100 && !$("#vm_box").is(':visible')){
                  hideHeaderTimeout.showHeader();
              }
          });

          $(".othercolors-mobile").prepend($('.catalog-entry-recommendation-widget.other_colors'));
      }
  }
  if($('#page').hasClass('pdp')){
      //retrieveS7multiimage();
      if(!window.mobilecheck() && !window.tabletPortraitCheck()){
        animationInit();
      }

      if(window.mobilecheck() || window.tabletPortraitCheck()){
          $("#monogramText3").on("keydown", function(event){
              if (event.keyCode == 13) {
                      event.preventDefault();
                      event.target.blur()
                  }
          })
      }
  }

  $(document).click(function (e) {

      // Ignore this event if preventDefault has been called.
      if (e.defaultPrevented) return;

      var popup = $(".popUp");
      var cpopup = $('.popUpPersolTechnology');
      if (cpopup.length > 0) {
          if (!cpopup.is(e.target) && cpopup.has(e.target).length == 0) {
              $.each(popup, function (index, value) {
                  if ($(this).dialog('instance')) {
                      if ($(this).dialog('isOpen'))
                          $(this).dialog('close');
                  }
              });
          }
      }


  });

  $(window).resize(function () {
      windowSize = $(document).width();
      if ((windowSize > tabletWidth) && (windowSizePrevious <= tabletWidth)) {
        refreshNavItemSettings(true);
          // We have just passed from a phone resolution to a bigger one
          if ($('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive > div').length > 0) {
              if ($('.navInfo #myAccountNavigationWidget #myAccountOptions .wrapperClose > div').hasClass("close")) {
                  $('.navInfo #myAccountNavigationWidget #myAccountOptions .content').removeAttr('style');
                  $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose').addClass("closed");
                  //$('#footerCorporateInfoSection h6').removeClass("close");
              }
          }

          if ($('#footerCorporateInfoSection h6').length > 0) {
              if ($('#footerCorporateInfoSection h6').hasClass("close")) {
                  $('#footerCorporateInfoSection ul').show();
                  $('#footerCorporateInfoSection h6').removeClass("close");
              }
          }

          if ($('#footer-sx h6').length > 0) {
              if ($('#footer-sx h6').hasClass("close")) {
                  $('#footer-sx ul').show();
                  $('#footer-sx h6').removeClass("close");
              }
          }

          if ($('.persolTech h2').length > 0) {
              if ($('.persolTech h2').hasClass("close")) {
                  $('.persolTech ul').show();
                  $('.persolTech h2').removeClass("close");
              }
          }

          if ($('.tSeries > h2').length > 0) {
              if ($('.tSeries > h2').hasClass("close")) {
                  $('.tSeries .wrapperSeries').show();
                  $('.tSeries > h2').removeClass("close");
              }
          }

          if ($('.tEvolution > h2').length > 0) {
              if ($('.tEvolution > h2').hasClass("close")) {
                  $('.tEvolution .wrapperEvolution').show();
                  $('.tEvolution > h2').removeClass("close");
              }
          }

          /*if ($('#contentWrapper.pageContent .slot5 > h2.product-details').length > 0) {
              if ($('#contentWrapper.pageContent .slot5 > h2.product-details').hasClass("close")) {
                  $('#contentWrapper.pageContent .slot5 ul').show();
                  $('#contentWrapper.pageContent .slot5 > h2.product-details').removeClass("close");
              }
          }*/

          if ($('#footerQuickLinksSection h6').length > 0) {
              if ($('#footerQuickLinksSection h6').hasClass("close")) {
                  $('#footerQuickLinksSection ul').show();
                  $('#footerQuickLinksSection h6').removeClass("close");
              }
          }
      } else if ((windowSize <= tabletWidth) && (windowSizePrevious > tabletWidth)) {
          // We have just passed from a bigger resolution of phone to a phone resolution
        refreshNavItemSettings(false);
          hideElements();
      }
      if(!(window.mobilecheck() || window.tabletPortraitCheck() && $('#page').hasClass('pdp'))){
          animationInit();
          /*Start EARLY ACCESS */
          if ($("#pdp_bottom-section .list-price").css("display") != "none" && $("#pdp_bottom-section .list-price").text() != ""){
              $("[id$=X_PDP_CustomerSegment_Tooltip].contentRecommendationWidget").css("right", "33%");
          } else $("[id$=X_PDP_CustomerSegment_Tooltip].contentRecommendationWidget").css("right", "30%");
      
          /*End EARLY ACCESS */
      }
      //  else if( window.mobilecheck() || window.tabletPortraitCheck()  && $('#page').hasClass('pdp')){
      //     didResize = true;
      //     var inHeight;
      //     if(window.innerHeight > window.startingHeight ){
      //         inHeight = window.marginScrollable + window.innerHeight - window.startingHeight ;
      //         var newHeight = window.slot2Height +  window.innerHeight - window.startingHeight ;
      //         $('.slot3').height(newHeight);
      //         $('.bottom-scrollable-section').css('margin-top', inHeight )
      //     } else {
      //         inHeight = window.slot2Height + window.startingHeight  - window.innerHeight ;
      //         $('.slot3').height(inHeight)
      //     }
      //     setInterval(function() {
      //         if (didResize) {
      //             didResize = false;
      //         }
      //     }, 300);
      // }
      // I assign the actual width resolution as the PREVIOUS because in the next check I would do I will compare it with the "resized width" (wich it will be the real actual size).
      windowSizePrevious = $(document).width();
  });

  $('.freeShipping').addClass("hidden");;

  if (!isEmpty($('#freeShippingGlobbal').html())) {
      $('.freeShipping').removeClass("hidden");
  }

  // Toggle of the PRODUCT DETAILS (Product Page) section only when the resolution is equals or less than 600px
  // $('#contentWrapper.pageContent .slot5 > h2.product-details').click(function() {
  //     if (window.innerWidth <= tabletWidth) {
  //         $('#contentWrapper.pageContent .slot5 > ul').slideToggle('400');
  //         if( $('#contentWrapper.pageContent .slot5 > h2.product-details').hasClass("close")) {
  //             $('#contentWrapper.pageContent .slot5 > h2.product-details').removeClass("close");
  //         } else {
  //             $('#contentWrapper.pageContent .slot5 > h2.product-details').addClass("close");
  //         }
  //     }
  // });c

  // Toggle of the PERSOL'S TECHNOLOGY (Product Page) section only when the resolution is equals or less than 600px
  $('.persolTech h2').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('.persolTech .tTechnology').slideToggle('400');
          if ($('.persolTech h2').hasClass("close")) {
              $('.persolTech h2').removeClass("close");
          } else {
              $('.persolTech h2').addClass("close");
          }
      }
  });

  // Toggle of the PERSOL'S TECHNOLOGY (Product Page) section only when the resolution is equals or less than 600px
  $('.tSeries > h2').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('.tSeries .wrapperSeries').slideToggle('400');
          if ($('.tSeries > h2').hasClass("close")) {
              $('.tSeries > h2').removeClass("close");
          } else {
              $('.tSeries > h2').addClass("close");
          }
      }
  });

  // Toggle of the SERIES EVOLUTION (Product Page) section only when the resolution is equals or less than 600px
  $('.tEvolution > h2').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('.tEvolution .wrapperEvolution').slideToggle('400');
          if ($('.tEvolution > h2').hasClass("close")) {
              $('.tEvolution > h2').removeClass("close");
          } else {
              $('.tEvolution > h2').addClass("close");
          }
      }
  });

  // Toggle of the SPECIAL EDITIONS section only when the resolution is equals or less than 600px
  $('#footerCorporateInfoSection h6').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('#footerCorporateInfoSection ul').slideToggle('400');
          if ($('#footerCorporateInfoSection h6').hasClass("close")) {
              $('#footerCorporateInfoSection h6').removeClass("close");
          } else {
              $('#footerCorporateInfoSection h6').addClass("close");
          }
      }
  });

  // Toggle of the PERSOL section only when the resolution is equals or less than 600px
  $('#footer-sx h6').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('#footer-sx ul').slideToggle('400');
          if ($('#footer-sx h6').hasClass("close")) {
              $('#footer-sx h6').removeClass("close");
          } else {
              $('#footer-sx h6').addClass("close");
          }
      }
  });

  // Toggle of the QUICK LINKS section only when the resolution is equals or less than 600px
  $('#footerQuickLinksSection h6').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('#footerQuickLinksSection ul').slideToggle('400');
          if ($('#footerQuickLinksSection h6').hasClass("close")) {
              $('#footerQuickLinksSection h6').removeClass("close");
          } else {
              $('#footerQuickLinksSection h6').addClass("close");
          }
      }
  });

  $("#openSeoLinks").click(function(e){
    e.preventDefault();
      $(".footer-allsites").removeClass('footer-allsites-hide');
      $('html, body').animate({scrollTop:$(document).height()}, 'slow');
  });

  $("#allSitesCloseLink").click(function(e){
    e.preventDefault();
      $(".footer-allsites").addClass('footer-allsites-hide');
  });

  $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('.navInfo #myAccountNavigationWidget #myAccountOptions .content').slideToggle('400');
          if ($('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose > div').hasClass("close")) {
              $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose > div').removeClass("close");
              $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose').removeClass("closed");
              if ((window.mobilecheck() || window.tabletPortraitCheck())){
                $('.navInfo ~ .navInfo-fade').show();
              }
          } else {
              $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose > div').addClass("close");
              $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose').addClass("closed");
              if ((window.mobilecheck() || window.tabletPortraitCheck())){
                $('.navInfo ~ .navInfo-fade').hide();
              }
          }
      }
  });

  $("#page.personal-information-page .gdpr__input-block .wrapper label").html("");

  if ($("#contentWrapper").hasClass("myAccountSummary")){
    checkEditFormInputs();
  }

  // When the page is ready, we will check if its resolution is lesser than 601 to hide the toggled elements
  if (windowSize < tabletWidth + 1)
      hideElements();

  // Display the header's "dropdown" menu
  if ($(window).width() > tabletWidth) {
      $('#departmentsMenu > li').hover(function () {
          if ($(" > section", this).length > 0) {
              $(" > section", this).stop(true, false, true).slideToggle(200);
              $(this).addClass('hover');
          }
      }, function () {
          $(" > section", this).stop(true, false, true).slideToggle(200);
          $(this).removeClass('hover');
          // $(" > section", this).stop(true, false, true).slideToggle(200);
      });
  }

  // $('#searchIcon').click(function() {
  //     if ($('#searchBar').length > 0) {
  //         $('#searchBar').slideToggle('400');
  //     }
  // });

  /* BEGIN - Responsive Header */
  /* Show/hide lateral menu */
  $('#hamResponsive .menuExpand').click(function () {
    if (window.innerWidth <= tabletWidth) {
          if ($(this).hasClass('open')) {
              /* Responsive menu is opened */
              $(this).removeClass('open');
              $('#page .siteContainer').removeClass('opened');
              $('#page').removeClass('opened');
          } else {
              /* Responsive menu is closed */
              $(this).addClass('open');
              $('#page .siteContainer').addClass('opened');
              $('#page').addClass('opened');
          }
      }
  });

  /* Add 'open' class to the item we click */
  $('#departmentsMenu .dropdownMenu > a, #departmentsMenu li.dropdownMenu > span').click(function (event) {
      if (window.innerWidth <= tabletWidth) {
          var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
          if (iOS) {
              console.log("iOS -> %o", iOS);
              $(this).one(function () {
                  console.log("iOS.one()");
                  $(this).click();
                  console.log("iOS.click()");
              });
          }
          event.preventDefault();
          if ($(this).parent().hasClass('open')) {
              $(this).parent().removeClass('open');
          } else {
              $('#departmentsMenu .dropdownMenu').removeClass('open');
              $(this).parent().addClass('open');
          }
      }
  });
  /* END - Responsive Header */

  /* BEGIN - POP UP PERSOL TECHNOLOGY */
  /* Open the pop up with properties */
  $('.persolTech .tTechnology li .openPopUp').click(function (event) {
      event.preventDefault();
      event.stopPropagation();

      if ($(this).parents('li').length > 0) {
          if ($(this).parents('li').find('.popUp').length > 0) {
              // I will create the dialog
              $(this).parents('li').find('.popUp').dialog({
                  modal: true,
                  classes: {
                      "ui-dialog": "popUpPersolTechnology popUp-" + $(this).parents('li>div').attr('id')
                  },
                  draggable: false,
                  closeText: "",
                  height: 'auto',
                  width: 'auto',
                  maxWidth: tabletWidth,
                  fluid: true, //new option
                  resizable: false,
                  close: function () {
                      // Stop the video when we close the pop up.
                      $(this).parent().find('video').get(0).pause();
                      $('.ui-widget-overlay').removeClass('custom-overlay');
                      $('body').removeAttr('style');
                  },
                  open: function () {
                      $('.ui-widget-overlay').addClass('custom-overlay');
                      $('body').css('position', 'relative');
                  }
              });
          } else {
              // I have already created the dialog, so I have just to open it
              var popUpName = '.popUp-' + $(this).parent().attr('id') + ' .popUp';
              $(popUpName).dialog('open');
          }
          // Launch the function for the new fluid option
          fluidDialog();
      }
  });

  // On window resize run function
  $(window).resize(function () {
      fluidDialog();
  });
  

  function fluidDialog() {
      var $visible = $(".ui-dialog:visible");
      $visible.each(function () {
          var $this = $(this);
          var dialog = $this.find(".ui-dialog-content").data("ui-dialog");
          // If the new fluid option is able
          if (typeof dialog !== 'undefined'
          && typeof dialog.options !== 'undefined'
          && typeof dialog.options.fluid !== 'undefined') {

              var wWidth = $(window).width();
              // Check window width against dialog width
              if (wWidth < (parseInt(dialog.options.maxWidth) + 80)) {
                  // Keep dialog from filling entire screen
                  $this.css("max-width", "90%");
              } else {
                  // Fix maxWidth bug
                  $this.css("max-width", dialog.options.maxWidth + "px");
              }
              // Reposition dialog
              dialog.option("position", dialog.options.position);
          }
      });
  }

  // Play or pause the video on clicking the image above.
  $('.popUp .video .playPause').click(function () {
      if ($(this).parent().find('video').length > 0) {
          var vid = $(this).parent().find('video').get(0);
          if ($(this).hasClass('playing')) {
              $(this).removeClass('playing');
              vid.pause();
          } else {
              $(this).addClass('playing');
              vid.play();
          }
      }
  });

  $(document).click(function (e) {
      var popup = $(".popUp");
      var cpopup = $('.popUpPersolTechnology');
      if (cpopup.length > 0) {
          if (!cpopup.is(e.target) && cpopup.has(e.target).length == 0) {
              $.each(popup, function (index, value) {
                  if ($(this).dialog('instance')) {
                      if ($(this).dialog('isOpen'))
                          $(this).dialog('close');
                  }
              });
          }
      }
  });


  $('.product_page_content .polarizedPersol').click(function (event) {
      event.preventDefault();
      event.stopPropagation();

      if ($('#lenses').parent().find('.popUp').length > 0) {
          // I will create the dialog
          $('#lenses').parent().find('.popUp').dialog({
              modal: true,
              classes: {
                  "ui-dialog": "popUpPersolTechnology popUp-lenses"
              },
              draggable: false,
              closeText: "",
              height: 'auto',
              width: 'auto',
              maxWidth: tabletWidth,
              fluid: true, //new option
              resizable: false,
              close: function () {
                  // Stop the video when we close the pop up.
                  $(this).parent().find('video').get(0).pause();
                  $('.ui-widget-overlay').removeClass('custom-overlay');
                  $('body').removeAttr('style');
              },
              open: function () {
                  $('.ui-widget-overlay').addClass('custom-overlay');
                  $('body').css('position', 'relative');
              }
          });
      } else {
          // I have already created the dialog, so I have just to open it
          var popUpName = '.popUp-lenses .popUp';
          $(popUpName).dialog('open');
      }
      // Launch the function for the new fluid option
      fluidDialog();
  });
  /* END - POP UP PERSOL TECHNOLOGY */

  /* BEGIN - POP-UP ZOOM & 360 */
  $('.viewBy > span').click(function (event) {
      if ($('#pdp-360-popup').length > 0) {
          var tabOpen = event.currentTarget.className == 'viewBy--p360' ? 1 : 0;
          $('#pdp-360-popup').dialog({
              modal: true,
              classes: {
                  "ui-dialog": "popUp-zoom360"
              },
              draggable: false,
              closeText: "",
              height: 'auto',
              width: 'auto',
              maxWidth: 800,
              fluid: true, //new option
              resizable: false,
              close: function () {
                  $('.ui-widget-overlay').removeClass('custom-overlay');
                  $('body').removeAttr('style');
              },
              open: function() {
                  $(this).parent().attr('tabindex','0');

                  var displayedImage = null;

                  if ($('#productMainImage').length) {
                      displayedImage = $('#productMainImage');
                  } else if ($('#sliderProductMainPage0').length) {
                      displayedImage = $('#sliderProductMainPage0');
                  }

                  var pathImg = "";
                  if (displayedImage != null) {
                      console.log("PSL::store-persol.js::Displayed image URL = " + displayedImage.attr('src'));
                      var displayedImageSource = displayedImage.attr('src');
                      if (displayedImageSource.includes("_noshad")) {
                          pathImg = displayedImageSource.split("_noshad")[0];
                      } else if (displayedImageSource.includes("_shad")) {
                          pathImg = displayedImageSource.split("_shad")[0];
                      } else {
                          pathImg = displayedImageSource.split("_")[0];
                      }
                  }
                  console.log("PSL::store-persol.js::Final base image URL = " + pathImg);

                  var imgZoom = pathImg + '_noshad_qt?scl=1';

                  $('.nextCircle').css("display", "none");

                  $('#pdp-360-popup--container').tabs({
                      active: tabOpen
                  });

                  $('#pdp-360-popup--container--zoom--img > img').attr('src', displayedImage.attr('src'));

                  $('#pdp-360-popup--container--zoom--img').zoom({
                      url: imgZoom,
                      on: 'grab'
                  });

                  $("#pdp-360-popup--container--360").spritespin({
                      source: [
                          pathImg + '_noshad_fr?$594$',
                          pathImg + '_noshad_qt?$594$',
                          pathImg + '_060A?$594$',
                          pathImg + '_090A?$594$',
                          pathImg + '_120A?$594$',
                          pathImg + '_150A?$594$',
                          pathImg + '_180A?$594$',
                          pathImg + '_210A?$594$',
                          pathImg + '_240A?$594$',
                          pathImg + '_270A?$594$',
                          pathImg + '_300A?$594$',
                          pathImg + '_330A?$594$'
                      ],
                      width: 595,  // width in pixels of the window/frame
                      height: 385,  // height in pixels of the window/frame
                      animate: false,
                      responsive: true,
                  });

                  $('.ui-widget-overlay').addClass('custom-overlay');
                  $('body').css('position','relative');
                  $(this).parent().find(".ui-button").attr('tabindex','0');
              }
          });
      } else {
          var popUpName = '.popUp-zoom360';
          $(popUpName).dialog('open');
      }
      // Launch the function for the new fluid option
      fluidDialog();
  });
  /* END - POP-UP ZOOM & 360 */

  /* BEGIN - SHOPPING INFO & RETURN POPUP */
  $('#ci_espot__footerCheckout_Left .left_espot #shopping').click(function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (('#ci_espot__footerCheckout_Left .left_espot #shopping-popup').length > 0) {
          // I will create the dialog
          $('#ci_espot__footerCheckout_Left .left_espot #shopping-popup').dialog({
              modal: true,
              classes: {
                  "ui-dialog": "shopping-popup"
              },
              draggable: false,
              closeText: "",
              height: 'auto',
              width: 'auto',
              maxWidth: tabletWidth,
              fluid: true, //new option
              resizable: false,
              close: function () {
                  $('.ui-widget-overlay').removeClass('custom-overlay').removeClass("shopping_overlay");
                  $('body').removeAttr('style');
              },
              open: function () {
                  $('.ui-widget-overlay').addClass('custom-overlay').addClass("shopping_overlay");
                  $('body').css('position', 'relative');
              }
          });
      } else {
          // I have already created the dialog, so I have just to open it
          $('#ci_espot__footerCheckout_Left .left_espot #shopping-popup').dialog('open');
      }
      // Launch the function for the new fluid option
      fluidDialog();
  });
  /* END - SHOPPING INFO & RETURN POPUP */
  /* START - catalogEntryDetails for Content Team */
  if ($("#page.pdp").length > 0) {
    catalogEntryDetails = JSON.parse($('#catalogEntryDetails_temp').text());
  }
  /* END - catalogEntryDetails for Content Team */


  /*HB-4558
   * prevent the background page to scroll
   */
        document.ontouchmove = function ( event ) {

            var isTouchMoveAllowed = true, target = event.target;

            while ( target !== null ) {
              if ( target.classList && target.classList.contains('submenu' ) ) {
                isTouchMoveAllowed = false;
                break;
              }
              target = target.parentNode;
            }

            if ( !isTouchMoveAllowed ) {
              event.preventDefault();
            }

       };

  //$('#attrValue_Size-menu .ui-menu-item').click(function(event) {
  $('#attrValue_Size-menu li').click(function (event) {
      // console.log("YEAH CLICK");
      if ($(this).attr('value') == 'dontClick') {
          //console.log("YEAH CLICK INSIDE");
      }
  });

  //console.log("YEAH 2");
  $('ul#attrValue_Size-menu').click(function (event) {
      //        console.log("YEAH CLICK 2 -> %o",$(this));
      //        console.log("YEAH CLICK 3 -> %o",$(this).find('li'));
      if ($(this).find('li').attr('value') == 'dontClick') {
          //console.log("YEAH CLICK INSIDE 2");
      }
  });


  /* Show default payment placement */
  var defaultPaymentPlacement = $("#defaultPaymentPlacement").val();
   showDefaultPaymentPlacement(defaultPaymentPlacement);


});


function backMenu(div){
    var idSection = $(this).closest("section");
    if(idSection.length == 0){
        idSection = $(div).closest("section")
    }
      $( idSection).hasClass('show') ?  $( idSection).removeClass( "show" ) :  $( idSection).addClass( "show" );
      $('.header__block-search').removeClass( "hidden" );
      if(isIOS()){
          document.getElementsByTagName('body')[0].classList.add('iosBody');
      }
}


// This function is for hide the toggle elements when we go through a tablet resolution (> 600 & < 1281) to a phone resolution (< 600)
function hideElements() {
  /*if ($('#contentWrapper.pageContent .slot5 > h2.product-details').length > 0) {
      $('#contentWrapper.pageContent .slot5 > h2.product-details').addClass("close");
      $('#contentWrapper.pageContent .slot5 ul').hide();
  }*/

  if ($('#footerCorporateInfoSection h6').length > 0) {
      $('#footerCorporateInfoSection h6').addClass("close");
      $('#footerCorporateInfoSection ul').hide();
  }

  if ($('#footer-sx h6').length > 0) {
      $('#footer-sx h6').addClass("close");
      $('#footer-sx ul').hide();
  }

  if ($('.persolTech h2').length > 0) {
      $('.persolTech h2').addClass("close");
      $('.persolTech ul').hide();
  }

  if ($('.tSeries > h2').length > 0) {
      $('.tSeries > h2').addClass("close");
      $('.tSeries .wrapperSeries').hide();
  }

  if ($('.tEvolution > h2').length > 0) {
      $('.tEvolution > h2').addClass("close");
      $('.tEvolution .wrapperEvolution').hide();
  }

  if ($('#footerQuickLinksSection h6').length > 0) {
      $('#footerQuickLinksSection h6').addClass("close");
      $('#footerQuickLinksSection ul').hide();
  }
}


// STATIC PAGES SCRIPTS  ///////////////////////////////////////////////////////////////////////////////////////////////

/**
* Convert URL's from received html to absolute
*/
function convertDataToAbsolute(data) {
  //Here we receive specific data of selected page
  //Now we add absolute address value 'http://www.persol.com/'
  var data_absolute = data;

  //replaces all occurrences of searchValue in data
  function replaceValues(data, searchValue, replacementValue) {
      var myString = data;
      while (myString.indexOf(searchValue) > 0) {
          myString = myString.replace(searchValue, replacementValue);
      }
      return myString;
  }

  //remove all occurrences of "this.href + "
  data_absolute = replaceValues(data_absolute, "this.href + ", "");
  data_absolute = replaceValues(data_absolute, "img src=\"/_events", "img src=\"http://www.persol.com/_events");
  data_absolute = replaceValues(data_absolute, "\"/international", "\"http://www.persol.com/international");
  data_absolute = replaceValues(data_absolute, "img src=\"/Content", "img src=\"http://www.persol.com/Content");
  data_absolute = replaceValues(data_absolute, "\"/Scripts", "\"http://www.persol.com/Scripts");
  data_absolute = replaceValues(data_absolute, ";/_events", ";http://www.persol.com/_events");
  data_absolute = replaceValues(data_absolute, "<script type=\"text/javascript\" src=\"http://www.persol.com/Scripts/custom/cufon.js\"></script>", "");
  // <script type="text/javascript" src="http://www.persol.com/Scripts/custom/cufon.js"></script>

  return data_absolute;
}

// // Vintage Celebration Page scripts  ///////////////////////////////////////////////////////////////////////////////////////////////
// $("#vintageCelebrationPage").ready(function () {
//     $("#vintageCelebrationPage .scrollVintage").click(function (event) {
//         //console.log($(this.hash).offset());
//         event.preventDefault();
//         $('html,body').animate({ scrollTop: $(this.hash).offset().top }, 1300, "easeInOutCubic");
//     });

//     $("#vintageCelebrationPage #skipVideo").click(function () {
//         event.preventDefault();
//         $("#vintageCelebrationPage #skipVideo").fadeOut("slow");
//         $("#vintageCelebrationPage #video").fadeOut("slow");
//         var iframe = document.querySelector('#player_1');
//         var player = new Vimeo.Player(iframe);

//         player.unload().then(function () {
//             // the video was unloaded
//         }).catch(function (error) {
//             // an error occurred
//         });
//     });

//     $("#vintageCelebrationPage #but_video").click(function () {
//         event.preventDefault();
//         var iframe = document.querySelector('#player_1');
//         var player = new Vimeo.Player(iframe);

//         player.play().catch(function (error) {
//             console.error('error playing the video:', error.name);
//         });
//         $("#vintageCelebrationPage #video").fadeIn("slow");
//         $("#vintageCelebrationPage #skipVideo").fadeIn("slow");
//     });

//     /* Cambio de m�todo a carga sin ajax */
//     var flipSpeed = 500;
//     var box1opened = false;
//     var box3opened = false;

//     function box1Flip() {
//         if (box3opened) {
//             box3Back();
//         }
//         $('#vintageCelebrationPage #vintage_years_box1 .one').animate({
//             marginLeft: "-960px" //moves left
//         }, flipSpeed, "easeInOutCubic");

//         $('#vintageCelebrationPage #vintage_years_box1 .two').animate({
//             marginLeft: "0px" //moves left
//         }, flipSpeed, "easeInOutCubic");
//         box1opened = true;
//     }

//     function box1Back() {
//         $('#vintageCelebrationPage #vintage_years_box1 .one').animate({
//             marginLeft: "0px" //moves right
//         }, flipSpeed, "easeInOutCubic");

//         $('#vintageCelebrationPage #vintage_years_box1 .two').animate({
//             marginLeft: "960px" //moves right
//         }, flipSpeed, "easeInOutCubic");
//         box1opened = false;
//     }

//     $('#vintageCelebrationPage #vintage_years_box1 .backTo').click(function () { box1Back(); });

//     function box3Flip() {
//         if (box1opened) {
//             box1Back();
//         }
//         $('#vintageCelebrationPage #vintage_years_box3 .one').animate({
//             marginLeft: "-960px" //moves left
//         }, flipSpeed, "easeInOutCubic");

//         $('#vintageCelebrationPage #vintage_years_box3 .two').animate({
//             marginLeft: "0px" //moves left
//         }, flipSpeed, "easeInOutCubic");
//         box3opened = true;
//     }

//     function box3Back() {
//         $('#vintageCelebrationPage #vintage_years_box3 .one').animate({
//             marginLeft: "0px" //moves right
//         }, flipSpeed, "easeInOutCubic");

//         $('#vintageCelebrationPage #vintage_years_box3 .two').animate({
//             marginLeft: "960px" //moves right
//         }, flipSpeed, "easeInOutCubic");
//         box3opened = false;
//     }

//     $('#vintageCelebrationPage #vintage_years_box3 .backTo').click(function () { box3Back(); });


//     $("#vintageCelebrationPage #btn-tabacco-virginia").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box1 .model_content").html($("#vintageCelebrationPage .ajax_tabacco-virginia").html()).promise().done(function () { box1Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-miele").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box1 .model_content").html($("#vintageCelebrationPage .ajax_miele").html()).promise().done(function () { box1Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-madreterra").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box1 .model_content").html($("#vintageCelebrationPage .ajax_madreterra").html()).promise().done(function () { box1Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-terra-di-siena").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box1 .model_content").html($("#vintageCelebrationPage .ajax_terra-di-siena").html()).promise().done(function () { box1Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-caffe").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box1 .model_content").html($("#vintageCelebrationPage .ajax_caffe").html()).promise().done(function () { box1Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-fuoco-e-ardesia").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box3 .model_content").html($("#vintageCelebrationPage .ajax_fuoco-e-ardesia").html()).promise().done(function () { box3Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-resina-e-sale").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box3 .model_content").html($("#vintageCelebrationPage .ajax_resina-e-sale").html()).promise().done(function () { box3Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-ebano-e-oro").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box3 .model_content").html($("#vintageCelebrationPage .ajax_ebano-e-oro").html()).promise().done(function () { box3Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-terra-e-oceano").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box3 .model_content").html($("#vintageCelebrationPage .ajax_terra-e-oceano").html()).promise().done(function () { box3Flip(); });
//     });

//     //Vintage Celebration Mobile Page scripts  ///////////////////////////////////////////////////////////////////////////////////////////////

//     var vintageDelay = 500;

//     $("#vintageCelebrationPage .scrollTo").click(function () {
//         event.preventDefault();
//         $('html,body').animate({ scrollTop: $(this.hash).offset().top }, 1300, "easeInOutCubic");
//     });

//     $("#vintageCelebrationPage .videoCover").click(function () {
//         event.preventDefault();
//         var iframe = document.querySelector('#player_2');
//         var player = new Vimeo.Player(iframe);

//         player.play().catch(function (error) {
//             console.error('error playing the video:', error.name);
//         });
//         $("#vintageCelebrationPage .mobile .videoCover").fadeOut("slow");
//         $("#vintageCelebrationPage .mobile #player_2").fadeIn("slow");
//     });

//     function closeHavanasSelector() {
//         $('#vintageCelebrationPage #select-btn-havanas').animate({
//             opacity: 1,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').css("pointer-events", "auto");
//         });

//         $('#vintageCelebrationPage .mobile .section-combo.havanas .shade').animate({
//             opacity: 0,
//         }, vintageDelay, function () { });
//         $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').animate({
//             opacity: 0,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').css("pointer-events", "none");
//         });
//     }
//     function closeHavanasSectionModels() {
//         $('#vintageCelebrationPage .section-models.havanas').animate({
//             opacity: 0,
//             height: "0px"
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .section-models.havanas').addClass("hidden");
//         });
//     }

//     $("#vintageCelebrationPage #select-btn-havanas").click(function () {
//         $('#vintageCelebrationPage #select-btn-havanas').animate({
//             opacity: 0,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').css("pointer-events", "none");
//         });

//         $('#vintageCelebrationPage .mobile .section-combo.havanas .shade').animate({
//             opacity: 1,
//         }, vintageDelay, function () { });
//         $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').animate({
//             opacity: 1,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').css("pointer-events", "auto");
//         });
//     });

//     $("#vintageCelebrationPage .section-combo.havanas .selector .close-btn").click(function () {
//         closeHavanasSelector();
//     });

//     $("#vintageCelebrationPage .section-models.havanas .close-btn").click(function () {
//         closeHavanasSectionModels();
//     });

//     $("#vintageCelebrationPage .section-combo.havanas .selector .link").click(function () {
//         closeHavanasSelector();
//         // console.log("Modelo: "+$(this).attr("model"));
//         var myModel = $(this).attr("model");
//         var myHeight;

//         $("#vintageCelebrationPage .section-models.havanas").removeClass("hidden");
//         $("#vintageCelebrationPage .section-models.havanas .model-container").addClass("hidden");

//         $("#vintageCelebrationPage .section-models.havanas .model-container").each(function () {
//             if ($(this).attr("model") === myModel) {
//                 $(this).removeClass("hidden");
//                 myHeight = $(this).children(".text-container").css("height");
//             }
//         });

//         $('#vintageCelebrationPage .section-models.havanas').animate({
//             opacity: 1,
//             height: myHeight
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .section-models.havanas').removeClass("hidden");
//             $('#vintageCelebrationPage .section-models.havanas').css("height", "100%");
//         });
//     });

//     function closeContemporarySelector() {
//         $('#vintageCelebrationPage #select-btn-contemporary').animate({
//             opacity: 1,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').css("pointer-events", "auto");
//         });

//         $('#vintageCelebrationPage .mobile .section-combo.contemporary .shade').animate({
//             opacity: 0,
//         }, vintageDelay, function () { });
//         $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').animate({
//             opacity: 0,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').css("pointer-events", "none");
//         });
//     }
//     function closeContemporarySectionModels() {
//         $('#vintageCelebrationPage .section-models.contemporary').animate({
//             opacity: 0,
//             height: "0px"
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .section-models.contemporary').addClass("hidden");
//         });
//     }

//     $("#vintageCelebrationPage #select-btn-contemporary").click(function () {
//         $('#vintageCelebrationPage #select-btn-contemporary').animate({
//             opacity: 0,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').css("pointer-events", "none");
//         });

//         $('#vintageCelebrationPage .mobile .section-combo.contemporary .shade').animate({
//             opacity: 1,
//         }, vintageDelay, function () { });
//         $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').animate({
//             opacity: 1,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').css("pointer-events", "auto");
//         });
//     });

//     $("#vintageCelebrationPage .section-combo.contemporary .selector .close-btn").click(function () {
//         closeContemporarySelector();
//     });

//     $("#vintageCelebrationPage .section-models.contemporary .close-btn").click(function () {
//         closeContemporarySectionModels();
//     });

//     $("#vintageCelebrationPage .section-combo.contemporary .selector .link").click(function () {
//         closeContemporarySelector();
//         // console.log("Modelo: "+$(this).attr("model"));
//         var myModel = $(this).attr("model");
//         var myHeight;

//         $("#vintageCelebrationPage .section-models.contemporary").removeClass("hidden");
//         $("#vintageCelebrationPage .section-models.contemporary .model-container").addClass("hidden");

//         $("#vintageCelebrationPage .section-models.contemporary .model-container").each(function () {
//             if ($(this).attr("model") === myModel) {
//                 $(this).removeClass("hidden");
//                 myHeight = $(this).children(".text-container").css("height");
//             }
//         });

//         $('#vintageCelebrationPage .section-models.contemporary').animate({
//             opacity: 1,
//             height: myHeight
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .section-models.contemporary').removeClass("hidden");
//             $('#vintageCelebrationPage .section-models.contemporary').css("height", "100%");
//         });
//     });


//     //control video autoplay
//     var iframe_desktop = document.querySelector('#player_1');
//     var player_desktop = null;

//     if (iframe_desktop != null) {
//         player_desktop = new Vimeo.Player(iframe_desktop);
//     }

//     var iframe_mobile = document.querySelector('#player_2');
//     var player_mobile = null;

//     if (iframe_mobile != null) {
//         player_mobile = new Vimeo.Player(iframe_mobile);
//     }

//     //check window width
//     //    console.log("window width: "+$(window).width());
//     if ($(window).width() > 930 && player_desktop != null && player_mobile != null) {
//         player_desktop.play().catch(function (error) {
//             console.error('error playing the video:', error.name);
//         });
//         player_mobile.unload().catch(function (error) {
//             console.error('error stoping the video:', error.name);
//         });
//     } else if (player_desktop != null && player_mobile != null) {
//         player_desktop.unload().catch(function (error) {
//             console.error('error stoping the video:', error.name);
//         });
//         player_mobile.unload().catch(function (error) {
//             console.error('error stoping the video:', error.name);
//         });
//     }
// });

// // Calligrapher page ///////////////////////////////////////////////////////////////////////////////////////////////
// $("calligrapherEditionPage").ready(function () {
//     $(".scrollCalligrapher").click(function (event) {
//         // console.log($(this.hash).offset());
//         event.preventDefault();
//         $('html,body').animate({ scrollTop: $(this.hash).offset().top }, 1300, "easeInOutCubic");
//     });

//     $(".mainVideo").click(function (event) {
//         event.preventDefault();
//         $(".mainVideo .playVideo").hide();
//         $(".mainVideo #play-button-video1").hide();

//         var iframe = document.querySelector('#player_1');
//         var player = new Vimeo.Player(iframe);

//         player.play().catch(function (error) {
//             console.error('error playing the video:', error.name);
//         });
//     });

//     $(".interviewVideo").click(function (event) {
//         event.preventDefault();
//         $(".interviewVideo .playVideo2").hide();
//         $(".interviewVideo #play-button-video2").hide();

//         var iframe = document.querySelector('#player_2');
//         var player = new Vimeo.Player(iframe);

//         player.play().catch(function (error) {
//             console.error('error playing the video:', error.name);
//         });
//     });
// });

// // Galleria900 scripts  ///////////////////////////////////////////////////////////////////////////////////////////////
// $(document).ready(function () {

//     var owl = $('#galleria900Page .owl-carousel');
//     var currentFrame = 0;
//     var movedWithSlide = true;

//     owl.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: true,
//         singleItem: true,
//         addClassActive: true,
//         afterMove: function () {
//             currentFrame = $(".owl-item.active .item").attr("data-slide-index");
//             updatePager();
//         }
//     });

//     function updatePager() {
//         $(".pager .item a").each(function () {
//             var itemIndex = $(this).attr("data-slide-index");
//             if (itemIndex == currentFrame) {
//                 $(this).children(".photo").removeClass("hidden");
//                 $(this).children(".point").removeClass("hidden");
//             } else {
//                 $(this).children(".photo").addClass("hidden");
//                 $(this).children(".point").addClass("hidden");
//             }
//         });
//     }

//     // Go to the next item
//     $('#galleria900Page #carousel-button-prev').click(function () {
//         owl.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#galleria900Page #carousel-button-next').click(function () {
//         owl.trigger('owl.next');
//     });

//     $(".pager .item a").click(function () {
//         currentFrame = $(this).attr("data-slide-index");
//         owl.trigger("owl.goTo", currentFrame);
//         updatePager();
//     });

// });

// //Icons Collection Page Scripts  ///////////////////////////////////////////////////////////////////////////////////////////////
// $("#iconsPage").ready(function () {
//     $('#iconsPage .but').bind("mouseenter", function () {

//         var i = $(this);

//         $('.but').removeClass('fullopt').addClass('halfopt');
//         $('.boxtitle').css('visibility', 'hidden');
//         $('.boxlink').css('visibility', 'hidden');
//         i.removeClass('halfopt').addClass('fullopt');
//         i.prev().css('visibility', 'visible');
//         i.next().css('visibility', 'visible');

//         var bgmodel = $(this).find('img').attr('alt');
//         var bg = 'bg_' + bgmodel;
//         $('#deficons_header').hide().removeClass().addClass(bg).show();
//     });
// });

// // Typewriter Subpages Scripts //////////////////////////////////////////////////////////////////////////////////////////
// $("#typewriterEditionPage").ready(function () {
//     var owl = $('#typewriterEditionPage .owl-carousel');

//     owl.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: true,
//         addClassActive: true,
//         singleItem: true
//     });

//     // Go to the next item
//     $('#typewriterEditionPage #slide_prev').click(function () {
//         owl.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#typewriterEditionPage #slide_next').click(function () {
//         owl.trigger('owl.next');
//     });

//     // Pager
//     $('#typewriterEditionPage .custom-pager .point').click(function () {
//         var currentFrame = $(this).attr("item-pos");
//         owl.trigger("owl.goTo", currentFrame);
//     });

// });

// // Reflex Edition Scripts //////////////////////////////////////////////////////////////////////////////////////////
// $("#reflexEditionPage").ready(function () {

//     var reflexDelay = 500;
//     var currentOption = 0;

//     $('#reflexEditionPage .up').click(function () {
//         var aTag = $("a[name='gale']");
//         $('html,body').animate({
//             scrollTop: aTag.offset().top
//         }, 'slow');
//     });

//     $("#reflexEditionPage a").mouseover(function () {
//         $("li img").removeAttr("title");
//     });

//     $('#reflexEditionPage .bxslider').bxSlider({
//         captions: true,
//         minSlides: 1,
//         maxSlides: 4,
//         slideWidth: 230,
//         slideMargin: 5,
//         auto: true,
//         infiniteLoop: false,
//         pager: false
//     });

//     function setActiveModel(model) {
//         //mark selected button
//         $("#reflexEditionPage .buttons-container div").removeClass("selected");
//         $("#reflexEditionPage .buttons-container div").each(function () {
//             var dn = $(this).attr("data-name");
//             if (dn == model) {
//                 $(this).addClass("selected");
//             }
//         });

//         //show image of selected model
//         $("#reflexEditionPage .moveimg img").addClass("hidden");
//         $("#reflexEditionPage .moveimg img").each(function () {
//             var dn = $(this).attr("data-name");
//             if (dn == model) {
//                 $(this).removeClass("hidden");
//             }
//         });

//         //show link of selected model
//         $("#reflexEditionPage .reflex-colori-link").addClass("hidden");
//         $("#reflexEditionPage .reflex-colori-link").each(function () {
//             var dn = $(this).attr("data-name");
//             if (dn == model) {
//                 $(this).removeClass("hidden");
//             }
//         });
//     }

//     $('#reflexEditionPage .sunBut').click(function () {
//         if (currentOption != 1) {
//             if ($(this).hasClass('stopMenu')) { } else {
//                 closeProduct();
//                 setTimeout(function () {
//                     $("#reflexEditionPage .reflex-glass-details.sun").show();
//                     $("#reflexEditionPage .reflex-glass-details.optical").hide();
//                     setActiveModel("PO3046S");
//                     openProduct("");
//                 }, reflexDelay);

//                 $(this).addClass('stopMenu').next().removeClass('stopMenu');
//                 $(this).addClass('activeMenu').next().removeClass('activeMenu');
//             }
//             setTimeout(function () {
//                 $('#reflexEditionPage #bullets-mobile').removeClass("hidden");
//                 $('#reflexEditionPage #bullets-mobile').css("opacity", "1");
//                 $('#reflexEditionPage #bullets-mobile').css("height", "auto");
//             }, reflexDelay * 2);
//             currentOption = 1;
//         }
//     });

//     $('#reflexEditionPage .optiBut').click(function () {
//         if (currentOption != 2) {
//             if ($(this).hasClass('stopMenu')) { } else {
//                 //select first item
//                 closeProduct();
//                 setTimeout(function () {
//                     $("#reflexEditionPage .reflex-glass-details.sun").hide();
//                     $("#reflexEditionPage .reflex-glass-details.optical").show();
//                     setActiveModel("PO3046V");
//                     openProduct();
//                 }, reflexDelay);

//                 $(this).addClass('stopMenu').prev().removeClass('stopMenu');
//                 $(this).addClass('activeMenu').prev().removeClass('activeMenu');
//             }

//             setTimeout(function () {
//                 $('#reflexEditionPage #bullets-mobile').removeClass("hidden");
//                 $('#reflexEditionPage #bullets-mobile').css("opacity", "1");
//                 $('#reflexEditionPage #bullets-mobile').css("height", "auto");
//             }, reflexDelay * 2);
//             currentOption = 2;
//         }
//     });

//     $('#reflexEditionPage .modelContainer .buttons-container div').click(function () {
//         //mark selected button
//         $("#reflexEditionPage .modelContainer .buttons-container div").removeClass("selected");
//         $(this).addClass("selected");

//         //show selected model
//         var modelNum = $(this).attr("data-name");

//         $("#reflexEditionPage .moveimg img").addClass("hidden");
//         //show image of selected model
//         $("#reflexEditionPage .moveimg img").each(function () {
//             var dn = $(this).attr("data-name");
//             if (dn == modelNum) {
//                 $(this).removeClass("hidden");
//             }
//         });

//         //show link of selected model
//         $("#reflexEditionPage .reflex-colori-link").addClass("hidden");
//         $("#reflexEditionPage .reflex-colori-link").each(function () {
//             var dn = $(this).attr("data-name");
//             if (dn == modelNum) {
//                 $(this).removeClass("hidden");
//             }
//         });
//     });

//     $(window).resize(function () {
//         if (currentOption > 0) {
//             var altura = $(".reflex-glass-details").height();
//             $("#reflex-glass-details-container").height(altura);
//         }
//     });

//     function openProduct() {
//         var altura = $(".reflex-glass-details").height();
//         //console.log("Altura: "+altura)
//         $('#reflex-glass-details-container').animate({
//             opacity: 1,
//             height: "" + altura + "px"
//         }, reflexDelay, function () { });

//         //        $('#reflex-glass-details').animate({
//         //            opacity: 1,
//         //            height: ""+altura+"px"
//         //        }, reflexDelay, function() {});
//     }

//     function closeProduct() {
//         $('#reflexEditionPage .optiBut').removeClass('stopMenu');
//         $('#reflexEditionPage .sunBut').removeClass('stopMenu');

//         $('.reflex-box-txt').removeClass('activeMenu');
//         $('#reflex-glass-details-container').animate({
//             opacity: 0,
//             height: "0px"
//         }, reflexDelay, function () { });

//         $("#reflex-glass-details").html("");
//     }

//     $('#reflexEditionPage #closebtn').click(function () {
//         $('#reflexEditionPage .optiBut').removeClass('stopMenu');
//         $('#reflexEditionPage .sunBut').removeClass('stopMenu');

//         $('.reflex-box-txt').removeClass('activeMenu');
//         $('#reflex-glass-details-container').animate({
//             opacity: 0,
//             height: "0px"
//         }, reflexDelay, function () { });

//         $("#reflex-glass-details").html("");

//         $('#reflexEditionPage #bullets-mobile').animate({
//             opacity: 0,
//             height: "0px"
//         }, reflexDelay, function () {
//             $('#reflexEditionPage #bullets-mobile').addClass("hidden");
//         });

//         currentOption = 0;
//     });

//     $("#reflexEditionPage #bullet_1").hover(function () {
//         $("#reflexEditionPage #tip_01").removeClass("hidden");
//     }, function () {
//         $("#reflexEditionPage #tip_01").addClass("hidden");
//     });

//     $("#reflexEditionPage #bullet_2").hover(function () {
//         $("#reflexEditionPage #tip_02").removeClass("hidden");
//     }, function () {
//         $("#reflexEditionPage #tip_02").addClass("hidden");
//     });

//     $("#reflexEditionPage #bullet_3").hover(function () {
//         $("#reflexEditionPage #tip_03").removeClass("hidden");
//     }, function () {
//         $("#reflexEditionPage #tip_03").addClass("hidden");
//     });

//     /* Gallery */
//     $('#reflexEditionPage .showgallery').click(function () {
//         if ($('#reflex-gallery-container').css('display') == 'none') {
//             $('#slideshow_reflex, #reflex-actions-on-gallery').css('display', 'none');
//             $('#reflex-gallery-container').css('display', 'block');
//             var aTag = $("a[name='gale']");
//             //          $('html,body').animate({
//             //              scrollTop: aTag.offset().top
//             //          }, 'slow');
//         }

//         $.ajax({
//             url: "http://www.persol.com/international/reflex-edition/gallery",
//             type: "POST",
//             success: function (data) {
//                 //Debug code BEGIN
//                 var a = convertDataToAbsolute(data);
//                 // console.log(a);
//                 //Debug code END
//                 $("#galleryContent").html(convertDataToAbsolute(data));
//             }
//         });
//     });

//     $('#reflexEditionPage .hidegallery').click(function () {
//         if ($('#reflex-gallery-container').css('display') == 'block') {
//             $('#reflex-gallery-container').css('display', 'none');
//             $('#slideshow_reflex, #reflex-actions-on-gallery').css('display', 'block');
//             $("#galleryContent").html('');
//             $('#dvnlcontDetail').remove();
//         }
//     });


// });

// // History Page Scripts ///////////////////////////////////////////////////////////////////////////////////////////////
// var slider = null;
// $("#historyPage").ready(function () {

//     /*Slideshow*/
//     slider = $('#historyPage .bxslider').bxSlider({
//         mode: 'fade',
//         captions: true,
//         auto: true,
//         //tickerHover: true,
//         pause: 10000,
//         pagerCustom: '#bx-pager',
//         onSlideNext: function (obj, currentindex, newindex) {
//             gotoPeriodBySlideIndex(newindex);
//         },
//         onSlidePrev: function (obj, currentindex, newindex) {
//             gotoPeriodBySlideIndex(newindex);
//         },
//         onSlideAfter: function (obj, oldindex, newindex) {
//             var degrees = 0;
//             var revdegrees = 0;
//             switch (newindex) {
//                 /*17-30*/
//                 case 0:
//                     degrees = 0;
//                     rotateArrow(8);
//                     break;
//                 case 1:
//                     degrees = 4;
//                     break;
//                 case 2:
//                     degrees = 8;
//                     break;
//                 case 3:
//                     degrees = 12;
//                     break;
//                 case 4:
//                     degrees = 16;
//                     break;
//                 case 5:
//                     degrees = 20;
//                     break;
//                 case 6:
//                     degrees = 24;
//                     break;
//                 /*30-50*/
//                 case 7:
//                     degrees = 36;
//                     rotateArrow(45);
//                     break;
//                 case 8:
//                     degrees = 40;
//                     break;
//                 case 9:
//                     degrees = 44;
//                     break;
//                 case 10:
//                     degrees = 48;
//                     break;
//                 case 11:
//                     degrees = 52;
//                     break;
//                 case 12:
//                     degrees = 56;
//                     break;
//                 /*50-70*/
//                 case 13:
//                     degrees = 67;
//                     rotateArrow(82);
//                     break;
//                 case 14:
//                     degrees = 71;
//                     break;
//                 case 15:
//                     degrees = 75;
//                     break;
//                 case 16:
//                     degrees = 79;
//                     break;
//                 case 17:
//                     degrees = 83;
//                     break;
//                 /*70-90*/
//                 case 18:
//                     degrees = 103;
//                     rotateArrow(110);
//                     break;
//                 case 19:
//                     degrees = 107;
//                     break;
//                 case 20:
//                     degrees = 111;
//                     break;
//                 case 21:
//                     degrees = 115;
//                     break;
//                 case 22:
//                     degrees = 119;
//                     break;
//                 case 23:
//                     degrees = 123;
//                     break;
//                 /*90-oggi*/
//                 case 24:
//                     degrees = 134;
//                     rotateArrow(147);
//                     break;
//                 case 25:
//                     degrees = 138;
//                     break;
//                 case 26:
//                     degrees = 142;
//                     break;
//                 case 27:
//                     degrees = 146;
//                     break;
//                 case 28:
//                     degrees = 150;
//                     break;
//                 case 29:
//                     degrees = 154;
//                     break;
//                 case 30:
//                     degrees = 159;
//                     break;
//             }
//         }
//     });

//     function rotateArrow(deg) {
//         $('#storia-cerchio').stop().animate(
//             { rotation: deg },
//             {
//                 duration: 500,
//                 step: function (now, fx) {
//                     $(this).css({ 'transform': 'rotate(' + now + 'deg)', 'opacity': '1' });
//                 }
//             }
//         );
//     }

//     /*Slideshow*/
//     $('.goto_1730').click(function () {
//         goto1730();
//         rotateArrow(8);
//         slider.goToSlide(0);
//     });

//     $('.goto_3050').click(function () {
//         goto3050();
//         rotateArrow(45);
//         slider.goToSlide(7);
//     });

//     $('.goto_5070').click(function () {
//         goto5070();
//         rotateArrow(82);
//         slider.goToSlide(13);
//     });

//     $('.goto_7090').click(function () {
//         goto7090();
//         rotateArrow(110);
//         slider.goToSlide(18);
//     });

//     $('.goto_90today').click(function () {
//         goto90oggi();
//         rotateArrow(147);
//         slider.goToSlide(24);
//     });
//     /*Cerchio dinamico*/

//     /*Funzioni cambio temporale*/
//     function goto1730() {

//         if ($('#dyn-h2excerpt').html() != html_h2excerpt_1730) {
//             $('#cerchio').fadeOut(500, function () { $('#cerchio').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/foto1-redux.png'); $('#cerchio').fadeIn(1500, function () { }); });
//             $('#storia-box-picture-sx').fadeOut(500, function () {
//                 $('#storia-box-picture-sx-img').attr("src", "https://assets.persol.com/extra/image/TargetOptical/icons/1730-1.jpg");
//                 $('#storia-box-picture-sx').fadeIn(1500, function () { });
//             });
//         }

//         $('#dyn-h2excerpt').html($('#html_h2excerpt_1730').html());
//         $('#dyn-excerpt').html($('#html_excerpt_1730').html());
//         $('.anno-big-hero').html($('#anno_big_1730').html());
//         $('.anno-small-hero').html($('#anno_small_1730').html());
//     }

//     function goto3050() {
//         if ($('#dyn-h2excerpt').html() != html_h2excerpt_3050) {
//             $('#cerchio').fadeOut(500, function () { $('#cerchio').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/foto2-redux.png'); $('#cerchio').fadeIn(1500, function () { }); });
//             $('#storia-box-picture-sx').fadeOut(500, function () {
//                 $('#storia-box-picture-sx-img').attr("src", "https://assets.persol.com/extra/image/TargetOptical/icons/3050-1.jpg");
//                 $('#storia-box-picture-sx').fadeIn(1500, function () { });
//             });
//         }

//         $('#dyn-h2excerpt').html($('#html_h2excerpt_3050').html());
//         $('#dyn-excerpt').html($('#html_excerpt_3050').html());
//         $('.anno-big-hero').html($('#anno_big_3050').html());
//         $('.anno-small-hero').html($('#anno_small_3050').html());
//     }

//     function goto5070() {
//         if ($('#dyn-h2excerpt').html() != html_h2excerpt_5070) {
//             $('#cerchio').fadeOut(500, function () { $('#cerchio').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/foto3-redux.png'); $('#cerchio').fadeIn(1500, function () { }); });
//             $('#storia-box-picture-sx').fadeOut(500, function () {
//                 $('#storia-box-picture-sx-img').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/5070-1.jpg');
//                 $('#storia-box-picture-sx').fadeIn(1500, function () { });
//             });
//         }

//         $('#dyn-h2excerpt').html($('#html_h2excerpt_5070').html());
//         $('#dyn-excerpt').html($('#html_excerpt_5070').html());
//         $('.anno-big-hero').html($('#anno_big_5070').html());
//         $('.anno-small-hero').html($('#anno_small_5070').html());
//     }

//     function goto7090() {
//         if ($('#dyn-h2excerpt').html() != html_h2excerpt_7090) {
//             $('#cerchio').fadeOut(500, function () { $('#cerchio').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/foto4-redux.png'); $('#cerchio').fadeIn(1500, function () { }); });
//             $('#storia-box-picture-sx').fadeOut(500, function () {
//                 $('#storia-box-picture-sx-img').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/7090-1.jpg');
//                 $('#storia-box-picture-sx').fadeIn(1500, function () { });
//             });
//         }

//         $('#dyn-h2excerpt').html($('#html_h2excerpt_7090').html());
//         $('#dyn-excerpt').html($('#html_excerpt_7090').html());
//         $('.anno-big-hero').html($('#anno_big_7090').html());
//         $('.anno-small-hero').html($('#anno_small_7090').html());
//     }

//     function goto90oggi() {
//         if ($('#dyn-h2excerpt').html() != html_h2excerpt_90today) {
//             $('#cerchio').fadeOut(500, function () { $('#cerchio').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/foto5-redux.png'); $('#cerchio').fadeIn(1500, function () { }); });
//             $('#storia-box-picture-sx').fadeOut(500, function () {
//                 $('#storia-box-picture-sx-img').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/90today-1.jpg');
//                 $('#storia-box-picture-sx').fadeIn(1500, function () { });
//             });
//         }

//         $('#dyn-h2excerpt').html($('#html_h2excerpt_90today').html());
//         $('#dyn-excerpt').html($('#html_excerpt_90today').html());
//         $('.anno-big-hero').html($('#anno_big_90today').html());
//         $('.anno-small-hero').html($('#anno_small_90today').html());
//     }
//     /*Funzioni cambio temporale*/

//     /*Funzioni navigazione slideshow e cambio temporale*/
//     function gotoPeriodBySlideIndex(nextindex) {
//         //alert("a");
//         if (nextindex >= 0 && nextindex <= 6) {
//             goto1730();
//         } else if (nextindex >= 7 && nextindex <= 12) {
//             goto3050();
//         } else if (nextindex >= 13 && nextindex <= 17) {
//             goto5070();
//         } else if (nextindex >= 18 && nextindex <= 23) {
//             goto7090();
//         } else {
//             goto90oggi();
//         }
//     }
//     /*Funzioni navigazione slideshow e cambio temporale*/

//     //var wrapper = document.getElementById('cn-wrapper');

//     //
//     $("#historyPage li.goto_1730").click(function () {
//         slider.goToSlide(0);
//         goto1730();
//     });
//     $("#historyPage li.goto_3050").click(function () {
//         slider.goToSlide(7);
//         goto3050();
//     });
//     $("#historyPage li.goto_5070").click(function () {
//         slider.goToSlide(13);
//     });
//     $("#historyPage li.goto_7090").click(function () {
//         slider.goToSlide(18);
//     });
//     $("#historyPage li.goto_90today").click(function () {
//         slider.goToSlide(24);
//     });

// });

// // Icons Series Scripts ///////////////////////////////////////////////////////////////////////////////////////////////
// $("#iconsSeriesPage").ready(function () {
//     $("#img_cont_1_m1").click(function () {
//         $("#img_cont_1_m2").removeClass("active-marker");
//         $("#img_cont_1_m1").addClass("active-marker");
//         $("#img_cont_1_img1").fadeIn("slow", function () { });
//         $("#img_cont_1_img2").fadeOut("slow", function () { });
//     });

//     $("#img_cont_1_m2").click(function () {
//         $("#img_cont_1_m1").removeClass("active-marker");
//         $("#img_cont_1_m2").addClass("active-marker");
//         $("#img_cont_1_img2").fadeIn("slow", function () { });
//         $("#img_cont_1_img1").fadeOut("slow", function () { });
//     });

//     $("#img_cont_2_m1").click(function () {
//         $("#img_cont_2_m2").removeClass("active-marker");
//         $("#img_cont_2_m1").addClass("active-marker");
//         $("#img_cont_2_img1").fadeIn("slow", function () { });
//         $("#img_cont_2_img2").fadeOut("slow", function () { });
//     });

//     $("#img_cont_2_m2").click(function () {
//         $("#img_cont_2_m1").removeClass("active-marker");
//         $("#img_cont_2_m2").addClass("active-marker");
//         $("#img_cont_2_img2").fadeIn("slow", function () { });
//         $("#img_cont_2_img1").fadeOut("slow", function () { });
//     });

//     $("#img_cont_3_m1").click(function () {
//         $("#img_cont_3_m2").removeClass("active-marker");
//         $("#img_cont_3_m1").addClass("active-marker");
//         $("#img_cont_3_img1").fadeIn("slow", function () { });
//         $("#img_cont_3_img2").fadeOut("slow", function () { });
//     });

//     $("#img_cont_3_m2").click(function () {
//         $("#img_cont_3_m1").removeClass("active-marker");
//         $("#img_cont_3_m2").addClass("active-marker");
//         $("#img_cont_3_img2").fadeIn("slow", function () { });
//         $("#img_cont_3_img1").fadeOut("slow", function () { });
//     });

//     $("#img_cont_4_m1").click(function () {
//         $("#img_cont_4_m2").removeClass("active-marker");
//         $("#img_cont_4_m1").addClass("active-marker");
//         $("#img_cont_4_img1").fadeIn("slow", function () { });
//         $("#img_cont_4_img2").fadeOut("slow", function () { });
//     });

//     $("#img_cont_4_m2").click(function () {
//         $("#img_cont_4_m1").removeClass("active-marker");
//         $("#img_cont_4_m2").addClass("active-marker");
//         $("#img_cont_4_img2").fadeIn("slow", function () { });
//         $("#img_cont_4_img1").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.one .pager.one").click(function () {
//         $(".twin-view-container.one .pager.one").addClass("active-marker");
//         $(".twin-view-container.one .pager.two").removeClass("active-marker");
//         $(".twin-view-container.one .twin-img.one").fadeIn("slow", function () { });
//         $(".twin-view-container.one .twin-img.two").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.one .pager.two").click(function () {
//         $(".twin-view-container.one .pager.two").addClass("active-marker");
//         $(".twin-view-container.one .pager.one").removeClass("active-marker");
//         $(".twin-view-container.one .twin-img.two").fadeIn("slow", function () { });
//         $(".twin-view-container.one .twin-img.one").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.two .pager.one").click(function () {
//         $(".twin-view-container.two .pager.one").addClass("active-marker");
//         $(".twin-view-container.two .pager.two").removeClass("active-marker");
//         $(".twin-view-container.two .twin-img.one").fadeIn("slow", function () { });
//         $(".twin-view-container.two .twin-img.two").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.two .pager.two").click(function () {
//         $(".twin-view-container.two .pager.two").addClass("active-marker");
//         $(".twin-view-container.two .pager.one").removeClass("active-marker");
//         $(".twin-view-container.two .twin-img.two").fadeIn("slow", function () { });
//         $(".twin-view-container.two .twin-img.one").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.three .pager.one").click(function () {
//         $(".twin-view-container.three .pager.one").addClass("active-marker");
//         $(".twin-view-container.three .pager.two").removeClass("active-marker");
//         $(".twin-view-container.three .twin-img.one").fadeIn("slow", function () { });
//         $(".twin-view-container.three .twin-img.two").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.three .pager.two").click(function () {
//         $(".twin-view-container.three .pager.two").addClass("active-marker");
//         $(".twin-view-container.three .pager.one").removeClass("active-marker");
//         $(".twin-view-container.three .twin-img.two").fadeIn("slow", function () { });
//         $(".twin-view-container.three .twin-img.one").fadeOut("slow", function () { });
//     });

//     //Hide on document ready;
//     $(".twin-img.two").hide();


// });

// // Icons 100 Anniversary Scripts ///////////////////////////////////////////////////////////////////////////////////////////////
// $("#iconsPersol100Page").ready(function () {
//     var sliderDesktop = $('#iconsPersol100Page .bxslider.desktop').bxSlider({
//         minSlides: 2,
//         maxSlides: 2,
//         //slideWidth: 390,
//         //slideMargin: 20,
//         moveSlides: 1,
//         pager: false,
//         speed: 1000,
//         infiniteLoop: true,
//         hideControlOnEnd: false
//     });

//     var sliderMobile = $('#iconsPersol100Page .bxslider.mobile').bxSlider({
//         minSlides: 1,
//         maxSlides: 1,
//         //slideWidth: 390,
//         //slideMargin: 20,
//         moveSlides: 1,
//         pager: false,
//         speed: 1000,
//         infiniteLoop: true,
//         hideControlOnEnd: false
//     });

//     $("#iconsPersol100Page .bx-next").click(function () {
//         sliderDesktop.goToNextSlide();
//         sliderMobile.goToNextSlide();
//         return false;
//     });

//     $("#iconsPersol100Page .bx-prev").click(function () {
//         sliderDesktop.goToPrevSlide();
//         sliderMobile.goToPrevSlide();
//         return false;
//     });

//     // tagboard.js BEGIN
//     // <script type="text/javascript" src="https://static.tagboard.com/public/js/embed.js"></script>
//     (function (window) {
//         var embedIDs = 1,
//             scrollTimer = -1,
//             previousHeight = {},

//             con = {
//                 log: function (s) { console.log(s); },
//                 warn: function (s) { console.warn ? console.warn(s) : console.log(s); },
//                 error: function (s) { console.error ? console.error(s) : console.log(s); }
//             },
//             tgbDivs = (function () {
//                 var divs = [],
//                     elems = document.getElementsByClassName('tagboard-embed');
//                 for (var i = 0; i < elems.length; ++i) {
//                     if (elems[i].nodeName === 'DIV') {
//                         divs.push(elems[i]);
//                     }
//                 }
//                 return divs;
//             })(),
//             tgbDomain = (window.tagboardOptions && window.tagboardOptions.domain) || window.tagboardDomain || "https://embeds.tagboard.com" || "http://localhost",

//             pageScrolled = function _pageScrolled() {
//                 if (scrollTimer != -1) {
//                     clearTimeout(scrollTimer);
//                 }

//                 scrollTimer = window.setTimeout(scrollFinished, 50);
//             },

//             execForFrames = function _execForFrame(func, frame_id) {
//                 // Optional frame_id to run for specific embed frame
//                 var iframes = document.getElementsByClassName('tagboard-iframe');
//                 for (var i = 0; i < iframes.length; ++i) {
//                     var ifrm = iframes[i],
//                         match = ifrm.getAttribute('tgb-frame-id') == frame_id;
//                     if (ifrm.tagName.toLowerCase() === 'iframe' && (!frame_id || match)) {
//                         func(ifrm);
//                         if (frame_id) {
//                             return;
//                         }
//                     }
//                 }
//             },

//             scrollFinished = function _scrollFinished(frame_id) {
//                 execForFrames(function (ifrm) {
//                     var divYOffset = 0;

//                     for (var element = ifrm; element != null; element = element.offsetParent) {
//                         divYOffset += element.offsetTop;
//                     }

//                     ifrm.contentWindow.postMessage('scrollPos:' + Math.max(0, window.pageYOffset - divYOffset), tgbDomain);
//                 }, frame_id);
//             },

//             setFrameHeight = function _setFrameHeight(height, frame_id) {
//                 execForFrames(function (ifrm) {
//                     if (ifrm.getAttribute('fixed-height') != 1) {
//                         var prev = parseInt(ifrm.style.height, 10),
//                             newHeight = height,
//                             event = document.createEvent("CustomEvent");

//                         if (height < prev && previousHeight[frame_id] !== height) { newHeight = prev; }

//                         ifrm.style.height = newHeight + "px";

//                         // Fire off event only if height has changed
//                         if (previousHeight[frame_id] !== height) {
//                             event.initCustomEvent("tgb.embedHeight", true, true, { height: height, iframe: ifrm }); // Because IE
//                             window.dispatchEvent(event);
//                         }

//                         previousHeight[frame_id] = height;
//                     }
//                 }, frame_id);
//             },

//             tagboardAuthWindow,
//             authRequested = function _authRequested(network, doConnect) {
//                 var top = (window.innerHeight / 2) - 300;
//                 left = (window.innerWidth / 2) - 400,
//                     authUrl = tgbDomain + "/u/auth_child?network=" + network + "&connect=" + (doConnect ? "1" : "");
//                 tagboardAuthWindow = window.open(authUrl, "tgbauthwin", "width=800,height=600,resizable=1,location=1,top=" + top + ",left=" + left);
//                 // check for window open fail - i.e. pop-up blocker doing it's thing
//                 if (!tagboardAuthWindow) {
//                     return window.tagboardAuthComplete(false, "The sign-in window was blocked due to a popup blocker. Please allow it to be opened and try again.");
//                 }

//                 function checkChild() {
//                     if (tagboardAuthWindow.closed) {
//                         return window.tagboardAuthComplete(true);
//                     }
//                     setTimeout(checkChild, 500);
//                 }

//                 checkChild();
//             },

//             insertIFrame = function _insertIFrame(div, options) {
//                 var opts = [],
//                     embedID = embedIDs++;

//                 if (options.mobilePostCount) { opts.push('mpc=' + options.mobilePostCount); }
//                 if (options.postCount) { opts.push('pc=' + options.postCount); }
//                 if (options.darkMode) { opts.push('dm=' + !!options.darkMode); }
//                 if (options.autoLoad) { opts.push('al=' + !!options.autoLoad); }
//                 if (options.inlineMedia) { opts.push('im=' + !!options.inlineMedia); }
//                 if (options.moderate) { opts.push('md=' + !!options.moderate); }

//                 opts.push('id=' + embedID);
//                 opts.push('ver=' + options.version);
//                 opts = '#' + opts.join('&');

//                 var ifrm = document.createElement("IFRAME");
//                 ifrm.setAttribute("src", tgbDomain + "/" + options.tagboard + "/embed" + opts);
//                 ifrm.setAttribute("onload", "tagboardQueryHeight(" + embedID + ")");
//                 if (options.version < 3) { ifrm.id = "tagboard-iframe"; iframe = ifrm; }
//                 ifrm.setAttribute("class", "tagboard-iframe");
//                 ifrm.setAttribute("tgb-frame-id", embedID);
//                 ifrm.name = "tagboard";
//                 ifrm.setAttribute("style", "border:0; width:100%;");
//                 ifrm.setAttribute("title", "Tagboard Social Content Web Display");
//                 if (options.fixedHeight) {
//                     ifrm.setAttribute("fixed-height", "1");
//                     ifrm.style.height = "100%";
//                 } else {
//                     ifrm.style.height = "600px"; // Default initial height
//                     ifrm.setAttribute("scrolling", "no");
//                 }
//                 div.appendChild(ifrm);
//             },

//             handleFrameMessage = function _handleFrameMessage(e) {
//                 if (e.origin == tgbDomain) {
//                     var dataObj = {};
//                     e.data.split('&').forEach(function (e) {
//                         var d = e.split(':');
//                         dataObj[d[0]] = d.length > 1 ? d[1] : d[0];
//                     });

//                     if (dataObj.height) {
//                         setFrameHeight(parseInt(dataObj.height), dataObj.frame_id);
//                     }

//                     if (dataObj.auth) {
//                         authRequested(dataObj.auth, dataObj.frame_id);
//                     }
//                     if (e.data.indexOf('tgbRemoveIframe') === 0) {
//                         var id = e.data.substr(e.data.indexOf(':') + 1);
//                         var element = document.querySelector("iframe[tgb-frame-id='" + id + "']");
//                         element.parentNode.removeChild(element);
//                     }
//                 }
//             };

//         if ((window.tagboard && typeof window.tagboard === 'string') || (window.tagboardOptions && window.tagboardOptions.tagboard)) {
//             var tagboardOptions = window.tagboardOptions || {};
//             tagboardOptions.tagboard = tagboardOptions.tagboard || window.tagboard;

//             if (window.tagboard) {
//                 tagboardOptions.version = 1;
//                 con.error("Using deprecated version of Tagboard embed. Update embed code. https://support.tagboard.com/docs/embedding-a-tagboard");
//             } else {
//                 tagboardOptions.version = 2;
//                 con.warn("Using an out-of-date version of Tagboard embed. Please update embed code. https://support.tagboard.com/docs/embedding-a-tagboard");
//             }

//             try {
//                 insertIFrame(document.getElementById("tagboard-embed"), tagboardOptions);
//             } catch (e) {
//                 con.error("Exception generating iFrame for tagboard embed: ", e);
//                 return;
//             }
//         } else if (tgbDivs.length > 0) {
//             tgbDivs.forEach(function (div) {
//                 var options = {
//                     tagboard: div.getAttribute('tgb-slug'),
//                     version: 3,
//                     mobilePostCount: div.getAttribute('tgb-mobile-count'),
//                     postCount: div.getAttribute('tgb-post-count'),
//                     darkMode: div.getAttribute('tgb-dark-mode') === 'true',
//                     autoLoad: div.getAttribute('tgb-auto-load') === 'true',
//                     fixedHeight: div.getAttribute('tgb-fixed-height') === 'true',
//                     inlineMedia: div.getAttribute('tgb-inline-media') === 'true',
//                     moderate: div.getAttribute('tgb-mod') === 'true'
//                 };
//                 if (options.tagboard && !div.getAttribute('tgb-built-iframe')) {
//                     insertIFrame(div, options);
//                     div.setAttribute('tgb-built-iframe', "1");
//                 }
//             });
//         } else {
//             //con.error("Tagboard script expected DIV with class: 'tagboard-embed'");
//             return;
//         }

//         window.tagboardQueryHeight = function queryHeight(frame_id) {
//             execForFrames(function (ifrm) {
//                 ifrm.contentWindow.postMessage('height?', tgbDomain);
//                 scrollFinished(frame_id);
//             }, frame_id);
//         };

//         window.tagboardAuthComplete = function _tagboardAuthComplete(success, failMessage) {
//             var authMessage = ["authComplete", success ? "1" : "", failMessage].join(":");
//             // close the auth child window
//             tagboardAuthWindow && typeof tagboardAuthWindow.close === "function" && tagboardAuthWindow.close();
//             // notify the embed of the auth status

//             execForFrames(function (ifrm) {
//                 ifrm.contentWindow.postMessage(authMessage, tgbDomain);
//             });
//         };

//         window.handleFrameMessage = handleFrameMessage;
//         window.pageScrolled = pageScrolled;

//         window.addEventListener('message', window.handleFrameMessage, false);
//         window.addEventListener('scroll', window.pageScrolled, false);

//         if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
//             window.addEventListener('resize', function () {
//                 execForFrames(function (ifrm) {
//                     ifrm.style.width = ifrm.parentNode.clientWidth + "px";
//                     setTimeout(function () { ifrm.style.width = "100%"; }, 2500);
//                 });
//             }, true);
//         }

//     })(window);
//     // tagboard.js END

//     $('#iconsPersol100Page .butOpen').click(function () {
//         $(this).hide();
//         $('.butClose').show();
//         $(".persol100_reg").show();
//     });

//     $('#iconsPersol100Page .butClose').click(function () {
//         $(this).hide();
//         $('.butOpen').show();
//         $(".persol100_reg").hide();
//     });


//     $('#iconsPersol100Page .play-button, .playVideo').click(function () {
//         $(this).siblings("#player_1").attr('src', $(this).siblings("iframe").attr('src') + '?autoplay=1');
//         $('.play-button, .playVideo').css("display", "none");
//     });

// });

// $("#iconsNewGenerationPage").ready(function () {

//     ! function (d, s, id) {
//         var js, fjs = d.getElementsByTagName(s)[0];
//         if (!d.getElementById(id)) {
//             js = d.createElement(s);
//             js.id = id;
//             js.src = "https://platform.twitter.com/widgets.js";
//             fjs.parentNode.insertBefore(js, fjs);
//         }
//     }(document, "script", "twitter-wjs");

//     // Owl carousel 3D
//     var owl3d = $(".owl-carousel-container-3d .owl-carousel").owlCarousel({
//         /* Not working with current owl carousel version (embedded in WCS).
//          * Needs animate.css (https://daneden.github.io/animate.css/)

//         animateOut: 'slideOutDown',
//         animateIn: 'flipInX',*/
//         loop: true,
//         margin: 10,
//         nav: true,
//         responsive: false,
//         items: 1,
//         singleItem: true
//     });

//     // Go to the next item
//     $('.owl-carousel-container-3d #slide_prev').click(function () {
//         owl3d.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('.owl-carousel-container-3d #slide_next').click(function () {
//         owl3d.trigger('owl.next');
//     });

//     // Owl carousel 2D
//     var owl2d = $(".owl-carousel-container-2d .owl-carousel").owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: true,
//         /*singleItem: true*/
//         responsive: false,
//         items: 2
//     });

//     // Go to the next item
//     $('.owl-carousel-container-2d #slide_prev').click(function () {
//         owl2d.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('.owl-carousel-container-2d #slide_next').click(function () {
//         owl2d.trigger('owl.next');
//     });

//     //Slider1 mobile
//     var owlCarousel1m = $('#iconsNewGenerationPage .owl-carousel1m');

//     owlCarousel1m.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         slideSpeed: 1000
//     });

//     // Go to the next item
//     $('#iconsNewGenerationPage #slide_prev1m').click(function () {
//         owlCarousel1m.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#iconsNewGenerationPage #slide_next1m').click(function () {
//         owlCarousel1m.trigger('owl.next');
//     });

//     //Slider2 mobile
//     var owlCarousel2m = $('#iconsNewGenerationPage .owl-carousel2m');

//     owlCarousel2m.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         slideSpeed: 1000
//     });

//     // Go to the next item
//     $('#iconsNewGenerationPage #slide_prev2m').click(function () {
//         owlCarousel2m.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#iconsNewGenerationPage #slide_next2m').click(function () {
//         owlCarousel2m.trigger('owl.next');
//     });




//     $('#iconsNewGenerationPage .play-button').click(function (ev) {
//         $("#video")[0].src += "&autoplay=1";
//         $(this).fadeOut('fast');
//         ev.preventDefault();
//     });
//     $('#iconsNewGenerationPage .play-button2').on('click', function (ev) {
//         $("#video2")[0].src += "&autoplay=1";
//         ev.preventDefault();
//         $(this).fadeOut('fast');
//     });

//     $("#iconsNewGenerationPage .scroll").click(function (event) {
//         //console.log($(this.hash).offset());
//         event.preventDefault();
//         $('html,body').animate({ scrollTop: $(this.hash).offset().top }, 1300, "easeInOutCubic");
//     });

// });

// //Technology Scripts //////////////////////////////////////////////////////////////////////////////////////////////
// $("#technology").ready(function () {
//     var techVideo = document.getElementById("techVideo");
//     var owlTech = $('#technology .owl-carousel');

//     owlTech.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: true,
//         singleItem: true,
//         autoPlay: 5000,
//         stopOnHover: true
//     });

//     // Go to the next item
//     $('#technology .carousel-prev').click(function () {
//         owlTech.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#technology .carousel-next').click(function () {
//         owlTech.trigger('owl.next');
//     });


//     $("#techVideo").bind("ended", function () {
//         $(this).addClass("play-button");
//         $(this).removeClass("pause-button");
//     });

//     $(".play-pause-button").click(function () {
//         if (techVideo.paused) {
//             techVideo.play();
//             $(this).removeClass("play-button");
//             $(this).addClass("pause-button");
//         } else {
//             techVideo.pause();
//             $(this).addClass("play-button");
//             $(this).removeClass("pause-button");
//         }
//     });

//     $(".video-container").hover(
//         function () {
//             $(".play-pause-button").fadeIn("slow");
//         }, function () {
//             $(".play-pause-button").fadeOut("slow");
//         });

// });

// // SteveMcQueen Scripts ///////////////////////////////////////////////////////////////////////////////////////////////////////
// $("#McQueenPage").ready(function () {
//     var owlCarousel1 = $('#McQueenPage #owl-carousel1');
//     var owlCarousel2 = $('#McQueenPage #owl-carousel2');
//     var owlCarousel3 = $('#McQueenPage #owl-carousel3');
//     var owlCarousel1m = $('#McQueenPage #owl-carousel1m');
//     var owlCarousel2m = $('#McQueenPage #owl-carousel2m');
//     var owlCarousel3m = $('#McQueenPage #owl-carousel3m');

//     owlCarousel1.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     owlCarousel2.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     owlCarousel3.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     owlCarousel1m.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     owlCarousel2m.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     owlCarousel3m.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     // Go to the next item
//     $('#McQueenPage .carousel-container1 .carousel-prev').click(function () {
//         owlCarousel1.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container1 .carousel-next').click(function () {
//         owlCarousel1.trigger('owl.next');
//     });
//     // Go to the next item
//     $('#McQueenPage .carousel-container2 .carousel-prev').click(function () {
//         owlCarousel2.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container2 .carousel-next').click(function () {
//         owlCarousel2.trigger('owl.next');
//     });
//     // Go to the next item
//     $('#McQueenPage .carousel-container3 .carousel-prev').click(function () {
//         owlCarousel3.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container3 .carousel-next').click(function () {
//         owlCarousel3.trigger('owl.next');
//     });

//     //MOBILE
//     // Go to the next item
//     $('#McQueenPage .carousel-container1m .carousel-prev').click(function () {
//         owlCarousel1m.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container1m .carousel-next').click(function () {
//         owlCarousel1m.trigger('owl.next');
//     });
//     // Go to the next item
//     $('#McQueenPage .carousel-container2m .carousel-prev').click(function () {
//         owlCarousel2m.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container2m .carousel-next').click(function () {
//         owlCarousel2m.trigger('owl.next');
//     });
//     // Go to the next item
//     $('#McQueenPage .carousel-container3m .carousel-prev').click(function () {
//         owlCarousel3m.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container3m .carousel-next').click(function () {
//         owlCarousel3m.trigger('owl.next');
//     });

//     // steve2017.js
//     var box_360_clicked = false;
//     var box_360_pos = 0;
//     var giftimer = null;
//     var gifcount = 1;

//     $('.area .bullet').mouseenter(function () {
//         $(this).stop(true, false).animate({ 'opacity': 0 }, 200);
//         $(this).siblings('.detail_' + $(this).attr('rel')).stop(true, false).fadeIn(200);
//         $('.menu .menu_' + $(this).attr('rel')).addClass('hover');
//     }).mouseleave(function () {
//         $(this).stop(true, false).animate({ 'opacity': 1 }, 200);
//         $(this).siblings('.detail_' + $(this).attr('rel')).stop(true, false).fadeOut(200);
//         $('.menu .menu_' + $(this).attr('rel')).removeClass('hover');
//     }).click(function () {
//         $('.menu .menu_' + $(this).attr('rel')).click();
//     });
//     var prevFocusedElement;
//     $('.menu a').click(function () {
//         var menuIndex= $(this).attr("rel");
//         prevFocusedElement=this;
//         changeTabIndex($(".menu"));
//         changeTabIndex($("#group"+menuIndex));
//         changeTabIndex($(".product_360"));
//         // changeTabIndex($("details"));


//         $(this).addClass('sel').siblings().removeClass('sel');
//         $('.area .popup_' + $(this).attr('rel')).fadeIn(500, function () {
//             if ($(this).hasClass('popup_2')) {
//                 giftimer = setInterval(function () {
//                     var left = -gifcount * 449 - 120;
//                     document.getElementById("gif-img").style.backgroundPosition = left + "px 0px";
//                     gifcount = gifcount >= 5 ? 0 : gifcount + 1;
//                 }, 2000);
//             }
//         }).siblings('.popup').fadeOut();


//         // $("popup"+menuIndex).addClass("focus");
//         $("#popup"+menuIndex).focus();


//     }).mouseenter(function () {
//         pos = $(this).attr('rel');
//         $('.area .bullet_' + pos).stop(true, false).animate({ 'opacity': 0 }, 300);
//         $('.area .detail_' + pos).stop(true, false).fadeIn(300);
//         $('.menu .menu_' + $(this).attr('rel')).addClass('hover');
//     }).mouseleave(function () {
//         lev = $(this).attr('rel');
//         $('.bullet_' + lev).show().animate({ 'opacity': 1 }, 300);
//         $('.area .detail_' + lev).stop(true, false).fadeOut(300);
//         $('.menu .menu_' + $(this).attr('rel')).removeClass('hover');
//     });



//     $('.popup .close').click(function () {
//         var menuIndex= $(this).attr("rel");

//         changeTabIndex($(".menu"));
//         changeTabIndex($("#group"+menuIndex));
//         changeTabIndex($(".product_360"));
//         // changeTabIndex($(".details"));


//         clearInterval(giftimer);
//         $('.menu a').removeClass('sel');
//         $(this).parent().fadeOut();
//         if(this.parentElement.parentElement && $(this.parentElement.parentElement).hasClass('activated-perks')){
            
//         }else{
//             prevFocusedElement.focus();
//         }
        


//     });

//     $('.product_360 .move').mousemove(function (e) {
//         if (box_360_clicked) {
//             frameid = Math.round((e.clientX - box_360_pos.left) * 12 / 520);
//             $('#frame_360_' + frameid).show().siblings('.frame').hide();
//         }
//     });


//     $('.next').click(function () {
//         var $visible = $('.frame:visible');
//         if ($visible.hasClass('last')) { $('.frame').first().show(); }
//         if ($visible.next().length) $visible.hide().next().show();
//         else {
//             $visible.hide();
//             $('.frame').first().show();
//         }
//     });

//     $('.prev').click(function () {
//         var $visible = $('.frame:visible');
//         if ($visible.prev().length) $visible.hide().prev().show();
//         else {
//             $visible.hide();
//             $('.frame').last().show();
//         }
//     });
// });

// function switch360Left() {
//     $('.product_360 .frame').hide().eq(2).show().addClass('sel');
//     $('.area .details .item, .area .details .bullet, .area .detail, .link_360').fadeOut();
//     $('.product_360').fadeIn(500, function () {
//         box_360_pos = $('.product_360').offset();

//         setTimeout(function () {

//             $('.product_360 .loading').fadeOut();

//         }, 2000);

//         $('body').mousedown(function () {
//             box_360_clicked = true;
//         }).mouseup(function () {
//             box_360_clicked = false;
//         });
//     });
// }

// function switch360Right() {
//     $('.product_360 .frame').hide().first().show().addClass('sel');
//     $('.area .details .item, .area .details .bullet, .area .detail, .link_360').fadeOut();
//     $('.product_360').fadeIn(500, function () {
//         box_360_pos = $('.product_360').offset();
//         setTimeout(function () {
//             $('.product_360 .loading').fadeOut();
//         }, 2000);

//         $('body').mousedown(function () {
//             box_360_clicked = true;
//         }).mouseup(function () {
//             box_360_clicked = false;
//         });
//     });
// }

// function switchBack() {
//     $('.product_360').fadeOut();
//     $(' .area .details .bullet, .area .detail, .link_360left, .link_360right').fadeIn();
// }


////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

$("#customerCarePage").ready(function () {
  $("#faqs dd").hide();
  $("#faqs dt").click(function () {
      $(this)
          .next("#faqs dd")
          .slideToggle(500);
      $(this)
          .toggleClass("expanded");
  });
});


// HB-1028 BEGIN Restore all loadingInternal buttons to its initial state
function showLoadingInternal(hide, id) {
  console.log("PSL::LEGACY::showLoadingInternal function invoked");
}

function disableButton(id) {
  console.log("PSL::LEGACY::disableButton function invoked");
}

function enableButton(id) {
  console.log("PSL::LEGACY::enableButton function invoked");
}

function restoreLoadingInternalButtons() {
  console.log("PSL::LEGACY::showLoadingInternal function invoked");
}
// HB-1028 END


/**
* This functions validates payment form input fields and legal terms checkbox to continue checkout
* @param payType Currently, possible values are 'cc' for Credit Card and 'paypal' for Paypal
* Related files: PersolSAS\Snippets\EDP\PaymentMethods\StandardVisa.jsp
*/
function makePayment(payType) {
  var error = false;
  var cardType;

  if (payType == 'cc') {
      var validCardNumber = $.payment.validateCardNumber($('#account1_1').val());

      //if not valid card number...
      if ($("#account1_1").val().length == 0 || !validCardNumber) {
          $("#account1_1").addClass("field-error-message");
          $('#account1_1').parent().addClass("isNotValid");
          $('#emptyCreditCard').css('display','inline-block');
          //tealiumPushFormError($('#emptyCreditCard').html());
          var message = $('#emptyCreditCard').html();
          newTealiumPushFormError(message,message);
          error = true;
      } else {
        cardType = GetCardType($("#account1_1").val());
          $("#account1_1").removeClass("field-error-message");
          $('#emptyCreditCard').css('display', 'none');
      }

      //if name on card number...
      if ($('#cc_nameoncard_1').val().trim().length == 0) {
          $('#cc_nameoncard_1').addClass("field-error-message");
          $('#cc_nameoncard_1').parent().addClass("isNotValid");
          $('#emptyNameCard').css('display','inline-block');
          var message = $('#emptyNameCard').html();
          newTealiumPushFormError(message,message);
          error=true;
      } else {
          $('#cc_nameoncard_1').removeClass("field-error-message");
          $('#emptyNameCard').css('display', 'none');
      }

      //if Month select box empty...
      var monthError, yearError;
      if ($('#expire_month_1').val() == undefined || $('#expire_month_1')[0].value == "") {
          $('#emptyExpirationDate').css('display', 'inline-block');
          $('#expire_month_1').addClass("field-error-message");
          $('#expire_month_1').parent().addClass("isNotValid");
          var message = $('#emptyExpirationDate').html();
          newTealiumPushFormError(message,message);
          error = true;
          monthError = true;
      } else {
          monthError = false;
          $('#expire_month_1').removeClass("field-error-message");
          if (!monthError && !yearError) {
              $('#emptyExpirationDate').css('display', 'none');
          }
      }

      //if Year select box empty...
      if ($('#expire_year_1').val() == undefined || $('#expire_year_1')[0].value == "") {
          $('#emptyExpirationDate').css('display', 'inline-block');
          $('#expire_year_1').addClass("field-error-message");
          $('#expire_year_1').parent().addClass("isNotValid");
          var message = $('#emptyExpirationDate').html();
          newTealiumPushFormError(message,message);
          error = true;
          yearError = true;
      } else {
          yearError = false;
          $('#expire_year_1').removeClass("field-error-message");
          if (!monthError && !yearError) {
              $('#emptyExpirationDate').css('display', 'none');
          }
      }

      //if CVV empty...
      var cvvErrors = 0;
      if( $('#cc_cvc_1').val().trim().length == 0 ){
          $('#emptyCVV').css('display','inline-block');
          $('#emptyCVV').parent().addClass("isNotValid");
          var message =$('#emptyCVV').html();
          newTealiumPushFormError(message,message);
          error = true;
          cvvErrors++;
      } else {
          $('#emptyCVV').css('display', 'none');
      }

      if (cvvErrors == 0 && !matchCreditCardCVV($("#account1_1").val(), $('#cc_cvc_1').val().trim())){
          $('#wrongCVVLength').css('display','inline-block');
          $('#emptyCVV').parent().addClass("isNotValid");
          var message = $('#wrongCVVLength').html();
          newTealiumPushFormError(message,message);
          error = true;
          cvvErrors++;
      } else {

          $('#wrongCVVLength').css('display', 'none');
      }
      if (cvvErrors > 0) {
          $('#cc_cvc_1').addClass("field-error-message");
      } else {
          $('#cc_cvc_1').removeClass("field-error-message");
      }
  }

  if ($('.card-info--wrapper--terms--input').length > 0) {
      if ($('.card-info--wrapper--terms--input')[0].checked == false) {
          $('.card-info--wrapper--terms--alert').css('display','inline-block');
          $('.card-info--wrapper--terms--input').closest("div").addClass("field-error-message");
          error = true;
      } else {
          $('.card-info--wrapper--terms--input').closest("div").removeClass("field-error-message");
          $('.card-info--wrapper--terms--alert').css('display', 'none');
      }
  }

    if ($('.pres-checkout__input').length > 0) {
    	if(storeDirectory=="PersolUK" || storeDirectory=="PersolUS" || storeDirectory=="PersolDE"){
    		if ($('#pres-checkout__input').prop('checked') === false) {
	            //            $('.card-info--wrapper--terms--alert').css('display','inline-block');
	            $('.pres-checkout__input').closest("div").addClass("pres-checkout__error--show");
	            error = true;
	        } else {
	            $('.pres-checkout__input').closest("div").removeClass("pres-checkout__error--show");
	            //            $('.card-info--wrapper--terms--alert').css('display','none');
	        }
    	}
    }
    if (countPrescription > 1) {
        $(".prescription__wrapper-error-msg").show();
        $("html, body").animate({ scrollTop: 0 }, 500);
        error = true;
    }

  // If telephone1 empty ...
  var telephoneNumber = $('#telephone1').text().trim();
  if (!MessageHelper.isValidUTF8length(telephoneNumber, 32) || !MessageHelper.IsValidPhone(telephoneNumber)) {
      error = true;
      MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_INVALIDTELEPHONE"]);
  }

  if (error) {
	  removeCheckoutLoader();
      restoreAjaxButtons();
      moveToError();
      setTimeout(removeCheckoutLoader, 250);
  } else  {
      try {
          var paymentForm = document.getElementById('PaymentForm1');

          if (payType == 'cc') {
              setCurrentId('shippingBillingPageNext');

              //Remove all payMethodId input and insert the good one
              $(paymentForm).find('input[name="payMethodId"]').remove();
              $(paymentForm).append('<input type="hidden" name="payMethodId" value="Cybersource" />');
              setCurrentId('shippingBillingPageNext');
              tealiumPushCheckoutStep(cardType);
              CheckoutPayments.processCheckout('PaymentForm');


          } else if (payType == 'paypal') {
              addCheckoutLoader();
              //Remove all payMethodId input and insert the good one
              $(paymentForm).find('input[name="payMethodId"]').remove();
              $(paymentForm).append('<input type="hidden" name="payMethodId" value="PayPal" />');
              $(paymentForm).find('input[name="customerWebId"]').val(window.forterWebId);
              $(paymentForm).find('input[name="customerIPAddress"]').val(window.ipaddress);
              $(paymentForm).find('input[name="forterToken"]').val(window.forterToken);
              setCurrentId('shippingBillingPageNext');
              //The event should not be triggered on the click, it should be triggered when the user is going to be redirected to the payment gateway
              tealiumPushCheckoutStep('PayPal');
              document.getElementById('PaymentForm1').submit();


          } else if (payType == 'affirm'){
              addCheckoutLoader();
              //Remove all payMethodId input and insert the good one
              $(paymentForm).find('input[name="payMethodId"]').remove();
              $(paymentForm).append('<input type="hidden" name="payMethodId" value="Affirm" />');
              $(paymentForm).attr('action', 'AffirmForwardCmd');
              setCurrentId('shippingBillingPageNext');
              tealiumPushCheckoutStep('Affirm');
              document.getElementById('PaymentForm1').submit();


          } else if (payType == 'klarna'){
              addCheckoutLoader();
              //Remove all payMethodId input and insert the good one
              $(paymentForm).find('input[name="payMethodId"]').remove();
              setCurrentId('shippingBillingPageNext');
              tealiumPushCheckoutStep("Klarna");

              // Call Klarna Credit authorize and retrieve authorization_token
              Klarna.Credit.authorize({}, function (res) {
                  var auth_token = res["authorization_token"];
                  var isApproved = res["approved"];
                  var show_form = res["show_form"];
                  if (!auth_token || auth_token.length == 0 || !isApproved || isApproved.length == 0) {
                      if (WCParamJS.countryCode.toUpperCase() == 'DE'){
                          MessageHelper.displayErrorMessage("Beim Autorisieren der Klarna-Zahlung ist ein Fehler aufgetreten.");
                      } else{
                          MessageHelper.displayErrorMessage("There was an error with Authorize Klarna Payment.");
                      }
                      setTimeout(removeCheckoutLoader, 250);
                  } else {
                      // Note: we need to pass the token store in auth_token to authorize against it.
                      $(paymentForm).append('<input type="hidden" name="payMethodId" value="Klarna" />');
                      $(paymentForm).append('<input type="hidden" name="checkout_token" value="' + auth_token + '" />');
                      $(paymentForm).attr('action', 'KlarnaReturnCmd');
                      document.getElementById('PaymentForm1').submit();
                  }
              });

          } else {
              console.log("PSL :: Unknown Payment Method = " + payType);
          }
      } catch (e) {
          console.error("Error in makePayment:",e);
          setTimeout(removeCheckoutLoader, 250);
      }
  }
}

$(document).ready(function() {
	//setCidCookie
	if(getUrlParam("cid") != undefined){
        var cidCookieValue = getUrlParam("cid");
        const d = new Date();
        d.setTime(d.getTime() + (28*24*60*60*1000)); //cookie 28 days
        var expires = "expires="+ d.toUTCString();
        document.cookie = "X_WC_CID=" + cidCookieValue + ";" + expires + ";path=/"
        
    }
  var windowWidth = window.innerWidth
  if (windowWidth < 1024) {
      $("#shoppingCart").appendTo("#headerRow1");
  } else {
      $("#shoppingCart").appendTo(".header__block-search");
  }

  //Search Optimization -- Init search Panel
  if (typeof fn_InitSearchPanel == 'function') {
    fn_InitSearchPanel();
}



});
$(window).resize(function() {
  var windowWidth = window.innerWidth
  if (windowWidth < 1024) {
      $("#shoppingCart").appendTo("#headerRow1");
  } else {
      $("#shoppingCart").appendTo(".header__block-search");
  }
});

// Contact Us page START ///////////////////////////////////////////////////////////////////////////////////////////////
$("ContactUsPage").ready(function() {
	
	if($('#contactus-form_EMEA').length > 0){
		manageEMEAForm();
	}else{
		manageOldForm();
	}
	
});

function validateOnlyNumberContactForm(field){
	if($(field).attr('id') == 'ContactUsForm_User_Phone'){
		$('#errorPhone .contact-us-form__error-msg').hide();
	}else{
		$(field).parent().parent().find(".error-message--form .contact-us-form__error-msg").hide();
	}
	
	phone = trim(field.value);
	var isValid = true;
    var digits = "0123456789";
    var digitsCount = 0;
    var validCharsRegexp = /^-?\d+\.?\d*$/;

    for (var i = 0; i < phone.length; i++) {
        if (digits.includes(phone[i])){
            digitsCount++;
        }
    }

    if ((digitsCount<6 || digitsCount>32 || phone.match(validCharsRegexp) == null) && phone.length != 0){
        isValid = false;
    }

    if(!isValid){
    	var errorToPlace;
        var errorMessagge = "";
        if(field.id=="ContactUsForm_User_Phone"){
        	errorMessagge = $("#error_phoneNumber").attr('value');
        	errorToPlace = $('#errorPhone');
        }else if(field.id=="ContactUsForm_User_OrderNumber"){
        	errorMessagge = $("#error_order").attr('value');
        	errorToPlace = $(field).parent().parent().find(".error-message--form");
        }
    	errorToPlace ? createErrorContactUsEmea((errorToPlace), errorMessagge) : '';
		error = true;
    }
    return isValid;
}


function validateEmailFormFieldContactForm (formField) {
	var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@(([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,3})$/;
	$('#errorEmail .contact-us-form__error-msg').hide();
	var formFieldValue = trim(formField.value);
    var isEmpty = formFieldValue == "";
	var isValid = true;
		
	if (isEmpty || !emailRegexp.test(formFieldValue)) {
		errorToPlace = document.querySelector("#errorEmail");
	    errorToPlace ? createErrorContactUsEmea($("#errorEmail"), $("#error_Email").attr('value')) : '';
		error = true;
		isValid = false;
	} 
	return isValid;
}

function manageEMEAForm(){
	/**
	*  Mattia A.M. CSE Project
	*/
	var btnSubmitContactUs = document.querySelector('#WC_ContactUsDisplay_links_1');
	if (!btnSubmitContactUs) {
		return false;
	}

	console.log("WC_ContactUsDisplay_links_1 exists");
	//Fill list of phone number;
	var urlFillPhonePrefix  = '/wcs/resources/store/' + WCParamJS.storeId + '/country/country_state_list';
	
	$.ajax({
        url: urlFillPhonePrefix,
        dataType: "json"}
    ).then(function(phoneList){
    	for(var i = 0; i < phoneList.countries.length; i++){
    		$('#containerPhoneNumber .select-items').append('<div class="listReason" id="'+ phoneList.countries[i].callingCode +'"><span>'+  phoneList.countries[i].displayName+'</span><span>'+ phoneList.countries[i].callingCode +'</span></div>')
    		if((WCParamJS.countryCode === phoneList.countries[i].code) || (WCParamJS.countryCode == 'UK' && phoneList.countries[i].code == 'GB')){
    			$('#prefixNumber').html(phoneList.countries[i].callingCode); 
    			$('#prefixNumber').attr('value', phoneList.countries[i].callingCode);
    		}
    	}
    	$('#containerPhoneNumber .listReason').on('click', function(){
    		$('#prefixNumber').html($(this).attr('id')); 
    		$('#prefixNumber').attr('value', $(this).attr('id'));
    	});
    });
	
	function toBase64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
		    reader.readAsDataURL(file);
		    reader.onload = () => resolve(reader.result);
		    reader.onerror = reject;
		});
	}
	
	btnSubmitContactUs.addEventListener('click', function(e) {
		e.preventDefault();
	    var topicValue = $('#selection4ReasonDSK').attr('codeReason');
	    var firstNameValue = document.querySelector("#ContactUsForm_User_FirstName");
	    var lastNameValue = document.querySelector("#ContactUsForm_User_LastName");
	    var emailValue = document.querySelector("#ContactUsForm_User_Email");
	    var orderValue =  document.querySelector("#ContactUsForm_User_OrderNumber");
	    var phoneNumber = $('#prefixNumber').attr('value') + document.getElementById("ContactUsForm_User_Phone").value;
	    var msgValue = document.querySelector("#ContactUs_message");
	    var file = document.querySelector('#attachInput').files[0];
	    var attach64 = null;
	    var attachName = null;
	    var error = false;

	    var allErrors = document.querySelectorAll('.contact-us-form__error-msg');
	    if (allErrors.length > 0) {
	    	allErrors.forEach(function(el) {
	        	el.remove();
	    	})
	    }
	    if(file != null){
	    	if(file.size > 2097152 || !(file.type.includes('jpeg') || file.type.includes('png') || file.type.includes('pdf'))){
		    	var errorToPlace = document.querySelector("#errorAttach");
		        errorToPlace ? createErrorContactUsEmea($("#errorAttach"), $("#error_attachment").attr('value')) : '';
		        error = true;
		    }else{
		    	attachName = file.name;
		    }
	    }
	    
	    if(document.getElementById("ContactUsForm_User_Phone").value === '' && document.getElementById("ContactUsForm_User_Phone")){
	    	phoneNumber = '';
	    }else if (document.getElementById("ContactUsForm_User_Phone").value != ''){
	    	if(!validateOnlyNumberContactForm(document.querySelector("#ContactUsForm_User_Phone"))){
		    	error = true;
		    }
	    }
	    
	    if(orderValue.value != ''){
	    	if(!validateOnlyNumberContactForm(document.querySelector("#ContactUsForm_User_OrderNumber"))){
		    	error = true;
		    }
	    }
	    
	    if (topicValue == null) {
	    	var errorToPlace = document.querySelector("#errorTopic");
	        errorToPlace ? createErrorContactUsEmea($("#errorTopic"), $("#error_topic").attr('value')) : '';
	        error = true;
	    }

	    if (firstNameValue && firstNameValue.value === '') {
	    	var errorToPlace = document.querySelector("#errorFirstname");
	        errorToPlace ? createErrorContactUsEmea($("#errorFirstname"), $("#error_firstName").attr('value')) : '';
	        error = true;
	    }
	    
	    if (lastNameValue && lastNameValue.value === '') {
	    	var errorToPlace = document.querySelector("#errorLastname");
	        errorToPlace ? createErrorContactUsEmea($("#errorLastname"), $("#error_lastName").attr('value')) : '';
	        error = true;
	    }

	    if (!validateEmailFormFieldContactForm(document.querySelector("#ContactUsForm_User_Email")) || (emailValue && emailValue.value === '')) {
	    	var errorToPlace = document.querySelector("#errorEmail");
	        errorToPlace ? createErrorContactUsEmea($("#errorEmail"), $("#error_Email").attr('value')) : '';
	        error = true;
	    }

	    if (msgValue && msgValue.value === '') {
	    	var errorToPlace = document.querySelector("#errorNotes");
	        errorToPlace ? createErrorContactUsEmea($("#errorNotes"), $("#error_desription").attr('value')) : '';
	        error = true;
	    }

	    if (error === true) {
	    	focusOnElement(document.querySelectorAll('.contact-us-form__error-msg')[0]);
	        return false;
	    }

	    var action = document.querySelector("#contactus-form_EMEA").getAttribute('action');
	    if (action) {
	    	if(attachName != null){
	    		toBase64(file).then(function (data) {
		    		attach64 = data;
		    		callContactActionEmea(action, firstNameValue,lastNameValue, emailValue, topicValue, orderValue, msgValue, attachName, attach64, phoneNumber);
		    	});
	    	}else{
	    		callContactActionEmea(action, firstNameValue,lastNameValue, emailValue, topicValue, orderValue, msgValue, attachName, attach64, phoneNumber);
	    	}
	    	
	    	// HB-16527 Disable button after first click
	    	btnSubmitContactUs.classList.add('disabled');
	    	btnSubmitContactUs.setAttribute('aria-disabled', 'true');
	    	btnSubmitContactUs.style.cursor = 'default';
	    	btnSubmitContactUs.removeEventListener('click', arguments.callee);
	    	
	    } else {
	    	// ERROR WITH ACTION
	    	console.error("Can not retrieve the form's action.");
	    }
	});
	
	a = document.getElementsByClassName("select-selected");

	for (var i = 0; i < a.length; i++) {
		a[i].addEventListener("click", function(e) {
			/*when the select box is clicked, close any other select boxes,
		    and open/close the current select box:*/
		    e.stopPropagation();
		    closeAllSelect(this);
		    this.nextElementSibling.classList.toggle("select-hide");
		    this.classList.toggle("select-arrow-active");
		});
	}
	  
	function closeAllSelect(elmnt) {
	  /*a function that will close all select boxes in the document,
	  except the current select box:*/
	  var x, y, i, xl, yl, arrNo = [];
	  x = document.getElementsByClassName("select-items");
	  y = document.getElementsByClassName("select-selected");
	  xl = x.length;
	  yl = y.length;
	  for (i = 0; i < yl; i++) {
	    if (elmnt == y[i]) {
	      arrNo.push(i)
	    } else {
	      y[i].classList.remove("select-arrow-active");
	    }
	  }
	  for (i = 0; i < xl; i++) {
	    if (arrNo.indexOf(i)) {
	      x[i].classList.add("select-hide");
	    }
	  }
	}
	
	$('#reason-of-contact .listReason').on('click', function(){
		$(this).parent().attr('codeReason',$(this).attr('id'));
		$(this).parent().siblings().text(this.textContent);
	});
	
	/*if the user clicks anywhere outside the select box,
	then close all select boxes:*/
	document.addEventListener("click", closeAllSelect);
	
	$('#textRemove').on('click', function(){
		document.getElementById('attachInput').value = "";
	});
	
	function callContactActionEmea(action, firstNameValue,lastNameValue, emailValue, topicValue, orderValue, msgValue, attachName, attach64, phoneNumber){

		$.post(action, {
			firstName: firstNameValue.value,
			lastName: lastNameValue.value,
	        email: emailValue.value,
	        intentCode: topicValue,
	        order_id: orderValue.value,
	        note: msgValue.value,
	        attachName: attachName,
	        attach64: attach64,
	        mobile: phoneNumber
	    }, function(data) {
	    	var response = data.replace(/\*/g,"");
	        response = response.replace(/\//g,"");
	        var arr = JSON.parse(response);
	        if (arr['ResponseMessage'] == '1') {
	        	var msgOK = $("#ContactUsForm_msgOK").text();
	            $("#ContactUsForm_Returnmessage").text(msgOK);
	            $("#ContactUsForm_Returnmessage").show();
	        } else {
	        	var msgKO = $("#ContactUsForm_msgKO").text();
	            $("#ContactUsForm_Returnmessage").text(msgKO);
	            $("#ContactUsForm_Returnmessage").show();
	        }
	        // Append returned message to message paragraph.
	        $("#contactus-form_EMEA").hide();
	    });

	}
}


function manageOldForm(){
	/*
	*  Daniel Rilo Ferrero - BEGIN - NERD-656
	*/
	
	var btnSubmitContactUs = document.querySelector('#WC_ContactUsDisplay_links_1');
	if (!btnSubmitContactUs) {
		return false;
	}

	console.log("WC_ContactUsDisplay_links_1 exists");

	btnSubmitContactUs.addEventListener('click', function(e) {
		e.preventDefault();
	    var topicValue = document.querySelector("#ContactUsForm_Topic");
	    var nameValue = document.querySelector("#ContactUsForm_User_Name");
	    var emailValue = document.querySelector("#ContactUsForm_User_Email");
	    var msgValue = document.querySelector("#ContactUs_message");
	    var error = false;

	    var allErrors = document.querySelectorAll('.contact-us-form__error-msg');
	    if (allErrors.length > 0) {
	    	allErrors.forEach(function(el) {
	        	el.remove();
	    	})
	    }

	    if (topicValue && topicValue.value === '') {
	    	var errorToPlace = document.querySelector("#WC_ContactUsDisplay_div_7");
	        errorToPlace ? createErrorContactUs(errorToPlace, 'Topic error') : '';
	        error = true;
	    }

	    if (nameValue && nameValue.value === '') {
	    	var errorToPlace = document.querySelector("#WC_ContactUsDisplay_div_9");
	        errorToPlace ? createErrorContactUs(errorToPlace, 'Name error') : '';
	        error = true;
	    }

	    if (emailValue && emailValue.value === '') {
	    	var errorToPlace = document.querySelector("#WC_ContactUsDisplay_div_11");
	        errorToPlace ? createErrorContactUs(errorToPlace, 'Email error') : '';
	        error = true;
	    }

	    if (msgValue && msgValue.value === '') {
	    	var errorToPlace = document.querySelector("#WC_ContactUsDisplay_div_13");
	        errorToPlace ? createErrorContactUs(errorToPlace, 'Message error') : '';
	        error = true;
	    }

	    if (error === true) {
	    	focusOnElement(document.querySelectorAll('.contact-us-form__error-msg')[0]);
	        return false;
	    }

	    var action = document.querySelector("#contactus-form").getAttribute('action');
	    if (action) {
	    	$.post(action, {
	    		name: nameValue.value,
	            email: emailValue.value,
	            topic: topicValue.value,
	            message: msgValue.value
	        }, function(data) {
	        	var response = data.replace(/\*/g,"");
	            response = response.replace(/\//g,"");
	            var arr = JSON.parse(response);
	            if (arr['ResponseMessage'] == 'MSG_SENT') {
	            	var msgOK = $("#ContactUsForm_msgOK").text();
	                $("#ContactUsForm_Returnmessage").text(msgOK);
	                $("#ContactUsForm_Returnmessage").show();
	            } else {
	            	var msgKO = $("#ContactUsForm_msgKO").text();
	                $("#ContactUsForm_Returnmessage").text(msgKO);
	                $("#ContactUsForm_Returnmessage").show();
	            }
	            // Append returned message to message paragraph.
	            $("#contactus-form").hide();
	        });
	    } else {
	    	// ERROR WITH ACTION
	    	console.error("Can not retrieve the form's action.");
	    }
	});
}

function createErrorContactUs(whereToPlaceError, errorMsg) {
  whereToPlaceError.insertAdjacentHTML('afterend','<span class="contact-us-form__error-msg" tabindex="0">' + errorMsg + '</span>');
}

function createErrorContactUsEmea(whereToPlaceError, errorMsg) {
	  whereToPlaceError.html('<span class="contact-us-form__error-msg" tabindex="0">' + errorMsg + '</span>');
	}

function focusOnElement(whereToPlaceFocus) {
  whereToPlaceFocus.focus();
}
/**
*  Daniel Rilo Ferrero - END - NERD-656
*/
//Contact Us page END ///////////////////////////////////////////////////////////////////////////////////////////////

function sleep(miliseconds) {
  console.log("Sleeping... I will wake up in " + miliseconds + " ms");
  var currentTime = new Date().getTime();
  while (currentTime + miliseconds >= new Date().getTime()) {
  }
  console.log("Waking up!");
}




/**
* @param {*} measurements
*/
function getMeasurementsDisplayValue(measurements) {
  var arrM = measurements.split(",");
  return arrM.join("-");
}

/**
* Updates the product name in the NameAndPrice widget.
*
* @param {string} catEntryId The catentryId of the selected product
* @param {string} productId The productId of the product shown
*/
function updateItemName(catEntryId, productId) {
  var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;
  //var modelCodeValueElement = document.querySelector(".model_code_display .attr-value");
 // if (modelCodeValueElement != null) {
   //     modelCodeValueElement.innerHTML = catEntry.description[0].name;
       //modelCodeValueElement = modelCodeAttr;
  //}

  if(!(window.mobilecheck() || window.tabletPortraitCheck())){
	  var modelCodeLabel= $("#tabAttr .item-descriptive-attributtes-wrapper .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
	  var modelCodeLabelPopUp = $("#detailFeatures .item-descriptive-attributtes-wrapper .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
	  var modelCodeDisplay = document.querySelector(".modelCodeDisplay_" + catEntryId);
	  
	  if(typeof modelCodeLabel != 'undefined'){
          modelCodeLabel.innerText = modelCodeDisplay.innerText;
      }
      if(typeof modelCodeLabelPopUp != 'undefined'){
      	modelCodeLabelPopUp.innerText = modelCodeDisplay.innerText;
      }
      
  } else {
	  var modelCodeLabel= $("#tabAttr .item-descriptive-attributtes-wrapper .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
	  var modelCodeLabelPopUp = $(".accordion-content .item-descriptive-attributtes-wrapper .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
	  var modelCodeLabelLoad= $(".descriptive-attributes-widget .item-descriptive-attributtes-wrapper .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
	  var modelCodeDisplay = document.querySelector(".modelCodeDisplay_" + catEntryId);
	  
	  if(typeof modelCodeLabel != 'undefined'){
          modelCodeLabel.innerText = modelCodeDisplay.innerText;
      }
      if(typeof modelCodeLabelPopUp != 'undefined'){
      	modelCodeLabelPopUp.innerText = modelCodeDisplay.innerText;
      }
      if(typeof modelCodeLabelLoad != 'undefined'){
    	modelCodeLabelLoad.innerText = modelCodeDisplay.innerText;
      }
  }
 


  var modelMeasurements = document.querySelector(".ItemMeasurements_" + catEntryId);

  var modelMeasurementsValueElement = document.querySelector("#featureMenu .descAttributeValue_modelMeasurements");
  var modelMeasurementsValueElementFirstGridMobile = document.querySelector("#tabAttr .descAttributeValue_modelMeasurements");
  
  if (modelMeasurementsValueElement != null) {
      modelMeasurementsValueElement.innerHTML = getMeasurementsDisplayValue(modelMeasurements.innerHTML);
      if (modelMeasurementsValueElementFirstGridMobile != null) {
        modelMeasurementsValueElementFirstGridMobile.innerHTML = getMeasurementsDisplayValue(modelMeasurements.innerHTML);
      }
      
  }

  var price = document.querySelector("#listPrice_" + productId);
  if(price != null){
      price.innerHTML = catEntry.listPrice;
  }

  var offer = document.querySelector("#offerPrice_" + productId);
  if(offer != null){
      offer.innerHTML = catEntry.offerPrice;
  }

}

$(".product_page_content").ready(function () {
  wcTopic.subscribe('DefiningAttributes_Resolved', updateItemName);
});




//function assureCityValue(){

// var city = $(".shipping_address_summary > .address > .city > span")[0].innerHTML.trim();
// $("#WC_UserRegistrationAddForm_AddressEntryForm_FormInput_city_1").val( city );
//}
/* HB-587 END *************************************************************************************************/


// /**
//  * HB-550 BEGIN Improve PLP loading time + HB-678 Different behavior for PLP with or without hash
//  * The next code loads dinamically plp sections using Ajax
//  */
// var isAjaxPLP = false;                  //True if we are in a PLP with ajax elements
// var isAjaxPLPHash = false;              //True if we are in a PLP with hash
// var ajaxPLPClass = "plp-ajax-section";  //Class name of PLP elements to load using Ajax
// var ajaxPLPLocked = false;              //Used to lock multiple ajax calls at the same time
// var ajaxPLPHash = "";                   //location.hash of current URL
// var ajaxPLPHashScrollDone = false;      //True if the scroll to hash was done
// var ajaxPLPNoScrollSuffix = "_noScrollToHash"; //Suffix added to collection id to stop default scroll

// $(document).ready(function () {
//     ajaxPLPSetup();

//     if (isAjaxPLP) {
//         // HB-678 BEGIN Different behavior for PLP with or without hash
//         // Without hash: Load collections from top to bottom as they become visible
//         // With hash: Load collections as they become visible
//         if (isAjaxPLPHash) {
//             //ajaxPLPLocked=true;
//             loadCategoryAjax(ajaxPLPHash);
//         } else {
//             ajaxPLPRemoveSuffix();
//             loadVisibleCategoriesAjax();
//         }
//         // HB-678 END
//     }
// });

// $(window).resize(function () {
//     if (!ajaxPLPLocked && isAjaxPLP) {
//         loadVisibleCategoriesAjax();
//         activateContent();
//     }
// });
// $(window).scroll(function () {
//     if (!ajaxPLPLocked && isAjaxPLP) {
//         loadVisibleCategoriesAjax();
//         activateContent();
//     }
// });

// $(document).ajaxComplete(function () {
//     if (isAjaxPLP) {
//         //Check if ajax load worked correctly
//         var linksError = document.querySelectorAll("a." + ajaxPLPClass + ".loaded");
//         for (var i = 0; i < linksError.length; i++) {
//             if ($(linksError[i]).next().html() == "") {
//                 $(linksError[i]).removeClass("loaded");
//                 $(linksError[i]).next().removeClass("loaded");
//             } else {
//                 //Hide ajax link image
//                 $(linksError[i]).find("img.ajaxloadingImg").hide();
//                 $(linksError[i]).hide();
//             }
//         }

//         //This is to double check that ajax img are hidden when the content is loaded
//         linksError = document.querySelectorAll("a." + ajaxPLPClass);
//         for (var i = 0; i < linksError.length; i++) {
//             if ($(linksError[i]).next().html() != "") {
//                 $(linksError[i]).addClass("loaded");
//                 $(linksError[i]).next().addClass("loaded");
//                 $(linksError[i]).find("img.ajaxloadingImg").hide();
//                 $(linksError[i]).hide();
//             }
//         }

//         //Activate inactive carousels
//         var cs = document.querySelectorAll(".wrapperCategories--owl-carousel:not(.active)");
//         for (var i = 0; i < cs.length; i++) {
//             $(cs[i]).owlCarousel({
//                 items: 1,
//                 lazyLoad: true,
//                 singleItem: true,
//                 navigation: true,
//                 navigationText: false,
//                 addClassActive: true,
//                 //The afterAction is for solve a 'problem' with the Owl Carousel Framework.
//                 //When we resize the size of the browser, the Carousel is refreshd.
//                 //This way, we can control the resize and put the colors in the nav menu.
//                 afterAction: function (event) {
//                     event.onresize = colorCarousel();
//                 }
//             });
//             $(cs[i]).addClass('active');
//         }

//         if (isAjaxPLPHash && !ajaxPLPHashScrollDone && $(ajaxPLPHash + " ." + ajaxPLPClass + ".loaded").length > 0) {
//             //Scroll to loaded category
//             $('html,body').animate(
//                 { scrollTop: $(ajaxPLPHash).offset().top },
//                 1300,
//                 "easeInOutCubic",
//                 function () {
//                     ajaxPLPLocked = false;
//                     //console.log("PSL::ajaxPLPLocked::"+ajaxPLPLocked+"::"+new Date().toString());
//                     ajaxPLPHashScrollDone = true;
//                     loadVisibleCategoriesAjax();
//                     activateContent();
//                     ajaxPLPRemoveSuffix();
//                 });
//         } else {
//             ajaxPLPLocked = false;
//             //console.log("PSL::ajaxPLPLocked::"+ajaxPLPLocked+"::"+new Date().toString());
//         }
//     }
// });


// //Initialization of Ajax PLP page
// function ajaxPLPSetup() {
//     if ($("a." + ajaxPLPClass).length > 0) {
//         isAjaxPLP = true;

//         //Add content DIV after each AjaxLink
//         var cont = 0;
//         $("a." + ajaxPLPClass).each(function () {
//             cont++;
//             $(this).html("<img class='ajaxloadingImg' src='https://assets.persol.com/extra/image/TargetOptical/icons/ajax_transparent_20x20.png' width='20' height='20'>");
//             $(this).after("<div id='loadedContent_" + cont + "' style='display:none;'></div>");
//         });

//         // HB-678 BEGIN
//         if (location.hash) {
//             //Check if hash collection exists
//             if ($(location.hash + ajaxPLPNoScrollSuffix).length > 0) {
//                 //The collection exists
//                 //console.log("PSL::ajaxPLPSetup::Collection found="+location.hash);
//                 isAjaxPLPHash = true;
//                 ajaxPLPHash = location.hash + ajaxPLPNoScrollSuffix;
//             } else {
//                 //The collection doesn't exist
//                 //console.log("PSL::ajaxPLPSetup::Collection not found="+location.hash);
//             }
//         }
//         // HB-678 END
//     }
// }

// //Remove ajaxPLPNoScrollSuffix from id in all collections to enable default scroll
// function ajaxPLPRemoveSuffix() {
//     $("div.wrapperCategories").each(function () {
//         $(this).attr('id', $(this).attr('id').replace(ajaxPLPNoScrollSuffix, ''));
//     });
// }

// function loadVisibleCategoriesAjax() {
//     if (isAjaxPLP && !ajaxPLPLocked) {
//         if (isAjaxPLPHash) {
//             //Load categories as they become visible
//             var linksArray = document.querySelectorAll("a." + ajaxPLPClass + ":not(.loaded)");
//             for (var i = 0; i < linksArray.length; i++) {
//                 if ($(linksArray[i]).visible()) {
//                     if ($(linksArray[i]).next().html() == "") {
//                         ajaxPLPLocked = true;
//                         //console.log("PSL::ajaxPLPLocked::"+ajaxPLPLocked+" "+new Date().toString());
//                         $(linksArray[i]).next().load($(linksArray[i]).attr('href'), null, activateContent($(linksArray[i]).next()));
//                         $(linksArray[i]).addClass('loaded');
//                         $(linksArray[i]).next().addClass('loaded');
//                         $(linksArray[i]).next().fadeIn(2500);

//                         break;
//                     }
//                 }
//             }

//         } else {
//             //Load visible categories FROM TOP TO BOTTOM
//             var linksArray = document.querySelectorAll("a." + ajaxPLPClass + ":not(.loaded)");
//             var loadNeeded = false;
//             for (var i = 0; i < linksArray.length; i++) {
//                 if ($(linksArray[i]).visible()) {
//                     if ($(linksArray[i]).next().html() == "") {
//                         loadNeeded = true;
//                         break;
//                     }
//                 }
//             }
//             if (loadNeeded) {
//                 if (!ajaxPLPLocked) {
//                     var firstEmptyLink = document.querySelector("a." + ajaxPLPClass + ":not(.loaded)");
//                     ajaxPLPLocked = true;
//                     $(firstEmptyLink).next().load($(firstEmptyLink).attr('href'), null, activateContent($(firstEmptyLink).next()));
//                     $(firstEmptyLink).addClass('loaded');
//                     $(firstEmptyLink).next().addClass('loaded');
//                     $(firstEmptyLink).next().fadeIn(2500);
//                 }
//             }
//         }
//     }
// }

// /**
//  * HB-678 Loads category using Ajax
//  * @param {string} categoryHash Category id hash, for example #Galleria900
//  */
// function loadCategoryAjax(categoryHash) {
//     var aElement = document.querySelector(categoryHash + " a.plp-ajax-section:not(.loaded)");
//     if (aElement == undefined) {
//         //The category was not found
//         //console.log("PSL::store-persol.js::loadCategoryAjax::Category not found or already loaded.");
//     } else {
//         //console.log("PSL::store-persol.js::loadCategoryAjax::Category found, array elements = "+aElement);
//         if ($(aElement).next().html() == "") {
//             ajaxPLPLocked = true;
//             $(aElement).next().load($(aElement).attr('href'), null, activateContent($(aElement).next()));
//             $(aElement).addClass('loaded');
//             $(aElement).next().addClass('loaded');
//             $(aElement).next().fadeIn(2500);
//         }
//     }
// }
// /* HB-678 END *************************************************************************************************/

// //Shows section
// function activateContent(contentElement) {
//     if (isAjaxPLP && contentElement !== undefined && $(contentElement).is(":hidden")) {
//         $(contentElement).fadeIn(2000);
//     }
// }

// /*
// We use a key-value variable owlColors and the 'aria-color' found in each class 'product'
// to put the background-color to each button of the carousel.
// */
// function colorCarousel() {
//     $('.wrapperCategories--owl-carousel').each(function (index) {
//         var thisItem = $(this);
//         thisItem.find('.product').each(function (indexItem) {
//             if ($(this).attr('aria-color')) {
//                 $(thisItem).find('.owl-page > span').eq(indexItem).css('background-color', owlColors[$(this).attr('aria-color')]);
//             }
//         });
//     });
// }
// /* HB-550 END *************************************************************************************************/

// /**
//  * HB-638 BEGIN Disable context menu on images
//  */
// function disableContextMenuOnImages() {
//     for (var i = 0; i < document.images.length; i++) {
//         document.images[i].addEventListener("contextmenu", function (e) {
//             e.preventDefault();
//         });
//     }
//     return false;
// }
// $(document).ready(function () {
//     //disableContextMenuOnImages();
// });
// $(document).ajaxComplete(function () {
//     //disableContextMenuOnImages();
// });
/* HB-638 END *************************************************************************************************/

/**
* Function for the checking of the State.
* If the State is California, we have to
* show a new line with a link to a popup
* with a message about some risks.
*/
// function changeState(sel) {
//   sel.value === 'CA' ? $('.prop65').addClass('shown') : $('.prop65').removeClass('shown');
// }

/**
* GDPR BEGIN
*/

/**
* Calculates if age greater than 16 years
* @param {int} year format yyyy
* @param {int} month values from 1 to 12
* @param {int} day
* @return {boolean} true if age >= 16, false otherwise
*/
function olderThan16(year, month, day) {
  var year = parseInt(year);
  var month = parseInt(month);
  var day = parseInt(day);
  var age = calculateAge(year, month, day);
  if (age >= 16)
      return true;
  return false;
}

/**
* Calculates age in years.
* @param {int} year format yyyy
* @param {int} month values from 1 to 12
* @param {int} day
* @return {int} age in years
*/
function calculateAge(year, month, day) {
  var birthdate = new Date(year, month - 1, day);
  var cur = new Date();
  var diff = cur - birthdate; // This is the difference in milliseconds
  var age = Math.floor(diff / 31557600000); // Divide by 1000*60*60*24*365.25
  return age;
}
/* GDPR END *************************************************************************************************/

/**
* Shows a price without the currency, note that the string decimals MUST match the NUMBER_OF_DECIMALS constant
* @param {String} inPrice String with price i.e. something like "$ 100.00"
* @param {boolean} If true, decimals are removed (Default false)
* @returns String without the currency "100.00"
*/
function cleanPrice(inPrice, removeDecimals) {
  if (typeof removeDecimals === 'undefined' || removeDecimals != true) {
      removeDecimals = false;
  }
  var NUMBER_OF_DECIMALS = 2;
  var numbers = "0123456789";
  var validSeparators = ",.";
  var validChars = numbers + ",.";
  var decimalSeparator = "";
  var tempPrice = "";
  var cleanedPrice = "";
  var hasDecimals = true;
  var decimalChar = ".";

  for (var i = 0; i < inPrice.length; i++) {
      if (validChars.includes(inPrice[i])) {
          tempPrice += inPrice[i];
      }
  }

  if (tempPrice.length >= NUMBER_OF_DECIMALS + 2) {
      decimalChar = tempPrice[tempPrice.length - (NUMBER_OF_DECIMALS + 1)];
      if (!validSeparators.includes(decimalChar)) {
          hasDecimals = false;
      }
  }

  if (removeDecimals) {
      if (hasDecimals) {
          tempPrice = tempPrice.substring(0, tempPrice.length - (NUMBER_OF_DECIMALS + 1));
      }
  }

  for (var i = 0; i < tempPrice.length; i++) {
      if (numbers.includes(tempPrice[i]) || tempPrice[i] == decimalChar) {
          cleanedPrice += tempPrice[i];
      }
  }

  return cleanedPrice;
}


/**
* HB-828 BEGIN Expansible address2 line in US
$(document).ready(function () {
  $(".address2_wrapper").click(function () {
      $(this).css("text-decoration", "none");
      $(this).find(".expansible_symbol").html("");
      $(this).find(".address2-input_wrapper").slideDown("fast");
      $(this).find(".optional").fadeIn("fast");
  });

  if ($(".address2_wrapper input").first().val() != "") {
      $(".address2_wrapper").click();
  }
});
*/
/* HB-828 END ******************************************************************************/

/**
* HB-1669 BEGIN Enable or disable addToCart button depending of current catentry stock
*/
function hideOrShowCartBtn (showAdd) {
  if(showAdd) {
      $("#add2CartBtnDisabled").hide();
      if(!$("#add2CartBtnDisabled").hasClass("hidden")) $("#add2CartBtnDisabled").addClass("hidden");
      $("#add2CartBtn").show();
      $("#add2CartBtn").removeClass("hidden");
  } else {
      $("#add2CartBtnDisabled").show();
      $(".namePartPriceContainer").css('visibility', 'hidden');
      $("#add2CartBtnDisabled").removeClass("hidden");
      $("#add2CartBtn").hide();
      // $('.fixed-navbar').addClass('three-columns');
      $('#pdp-presc-and-clip-on').css('visibility', 'hidden');
      if(!$("#add2CartBtn").hasClass("hidden")) $("#add2CartBtn").addClass("hidden");
  }
  createTopRecap();
}


//Show the AddToCart button when only one size available (no size combo)
$(document).ready(function () {
  if ($('.product_page_content').length > 0) {
      if ($('.namePartPriceContainer .old_price').length > 0) {
          $('.namePartPriceContainer').addClass('namePartPriceContainer--offer-price');
//            $('.product_page_content .namePartPriceContainer .vat').css('margin-right', $('.product_page_content .namePartPriceContainer--offer-price .old_price').width() + 5);
      }
  }
  /*if (typeof inventoryMap !== 'undefined') {
      var size = Object.keys(inventoryMap).length;
      if (size == 1) {
          var stock = inventoryMap[Object.keys(inventoryMap)[0]];
          if (stock > 0) {
              //Enable AddToCart button
              hideOrShowCartBtn(true)
              $("#add2CartBtnDisabled").hide();
              $("#add2CartBtn").show();
          } else {
              //Disable AddToCart button
              hideOrShowCartBtn(false)

              $("#add2CartBtnDisabled").show();
              $("#add2CartBtn").hide();
          }
      }
  }*/
  $('.namePartPriceContainer').show();
  
  //$('#add2CartBtn').show();  the addtocart button is shown already by a script in PDP_Prescription
});

/* HB-1669 END ******************************************************************************/

// Daniel Rilo - END - CREV NERD-569
$(document).ready(function () {
  /**
   * When we click ENTER, the form must be submitted
   */
  var newsletterEmail = document.getElementById('newsletterEmail');
  if (newsletterEmail !== null) {
      newsletterEmail.addEventListener('keyup', function (event) {
          event.preventDefault();
          if (event.keyCode === 13) {
              // TODO
          }
      });
  }
});

/**
* Daniel Rilo -BEGIN - WCAG
*/
window.addEventListener('load', function () {
  // Add title to he iFrame without this attribute
  document.querySelectorAll('iframe').forEach(function (el, index) {
      if (el.title === '') {
          el.title = 'iFrame number ' + index;
      }

      /**
       * @@@@@@@@@@@@@@@@@@@@@@@@@@
       * @@@@@    WIP !!!!    @@@@@
       * @@@@@@@@@@@@@@@@@@@@@@@@@@
       */
      // Loop thru iFrame attributes to remove these ones are not allowed
      // var notAllowedAttr = [
      //     'scrolling'
      // ]

      // var attrLength = el.attributes.length;
      // var notAllowedAttrLength = notAllowedAttr.length;
      // for (i=0; i < attrLength; i++) {
      //     for (j=0; j < notAllowedAttrLength; j++) {
      //         var test = '';
      //         // console.log("el.getAttribute(notAllowedAttr[j]) -> " + el.getAttribute(notAllowedAttr[j]));
      //         // console.log("el.attributes[i] -> " + el.attributes[i]);
      //         // console.log("el.attributes[i] -> %o", el.attributes[i]);
      //         // console.log("el.hasAttribute("+notAllowedAttr[j]+") -> " + el.hasAttribute(notAllowedAttr[j]));
      //         // test = notAllowedAttr[j].indexOf(el.attributes[i].name);
      //         console.log(el.getAttribute(notAllowedAttr[j]));
      //         console.log("test !== null -> " + (test !== null));
      //         // console.log(test);
      //         // test ? console.log('true') : console.log('falase');
      //         if (test !== null) {
      //             console.log("Removing " + notAllowedAttr[j]);
      //             console.log("1. %o",el);
      //             el.removeAttribute("'"+notAllowedAttr[j]+"'");
      //             console.log("2. %o",el);
      //         }
      //     }
      // }
      /**
       * @@@@@@@@@@@@@@@@@@@@@@@@@@
       * @@@@@    WIP !!!!    @@@@@
       * @@@@@@@@@@@@@@@@@@@@@@@@@@
       */
  });
})
/**
* Daniel Rilo - END - WCAG
*/

function closeMobileMenu(){
    
    $("#headerWrapper.header-fixed").removeClass("header-fixed");
    if($('#page').hasClass('pdp') ){
      $('#header').css('z-index', '5');
      hideHeaderTimeout.setup();
    }
    document.getElementById('header').classList.remove('header--opend');
    document.getElementsByTagName('html')[0].classList.remove('open-menu');
    document.getElementsByTagName('body')[0].classList.remove('open-menu');
    document.getElementById('searchBar').style.display = 'none';
    closeSearchBar();
    document.getElementsByClassName('signInContainer')[0].style.display = 'none';
    $('.signInRegisterRow').removeClass('signInOpened');
    document.getElementById('shoppingCart').style.display = 'block';
    document.getElementById('logo').style.display = 'block';
    $('#closeIcon').hide();
    $('#searchIcon').show();
    if(isPersol){
        document.getElementsByClassName('header_wishlist')[0].style.display = 'block';
    }
    if(isIOS() && sessionStorage.getItem('menu_scrollY')) {
        window.scrollTo(0,sessionStorage.getItem('menu_scrollY'));
        sessionStorage.removeItem('menu_scrollY');
        document.getElementsByTagName('body')[0].classList.remove('iosBody');
    }
    if($(this).hasClass("close-mobile-menu")){
        var headerCheckbox = document.getElementById("header__checkbox");
        headerCheckbox.checked = false;
        backMenu($(this));
    }
}

// Daniel Rilo - END - CREV NERD-569
$(document).ready(function () {
  /**
   * When we click ENTER, the form must be submitted
   */
  var newsletterEmail = document.getElementById('newsletterEmail');
  if (newsletterEmail !== null) {
      newsletterEmail.addEventListener('keyup', function (event) {
          event.preventDefault();
          if (event.keyCode === 13) {
              // TODO
          }

          newsletterEmail.checkValidity() && newsletterEmail.value !== '' ? document.querySelector('#newsLetter').classList.add('btn-visible') : document.querySelector('#newsLetter').classList.remove('btn-visible');
      });

      // newsletterEmail.addEventListener('blur', function(event) {
      // });
  }

  /**
   *
   */
    var headerChk = document.getElementById('header__checkbox');
    $(".close-mobile-menu").click(closeMobileMenu) ;
    if (headerChk !== null) {
        headerChk.addEventListener('click', function () {
        if (this.checked) {
          $("#headerWrapper").addClass("header-fixed");
              if(isIOS()){
                  sessionStorage.setItem('menu_scrollY',window.scrollY);
                  document.getElementsByTagName('body')[0].classList.add('iosBody');
              }
              /*z-index mobile pdp*/
              if($('#page').hasClass('pdp')) {
                  $('#header').css('z-index', '1001');
              }
              document.getElementById('header').classList.add('header--opend');
              document.getElementsByTagName('html')[0].classList.add('open-menu');
              document.getElementsByTagName('body')[0].classList.add('open-menu');
              document.getElementById('searchBar').style.display = 'block';
              document.getElementsByClassName('signInContainer')[0].style.display = 'flex';
              document.getElementById('shoppingCart').style.display = 'none';
             
            if(!isPersol){
                 document.getElementById('logo').style.display = 'none'; 
             }
            
             if(isPersol){ 
                document.getElementsByClassName('header_wishlist')[0].style.display = 'none'; 
             }
            
              $('#searchIcon').hide();
              $('#closeIcon').show();
              hideHeaderTimeout.cancel();
              
              //HB-17211
              if ((window.mobilecheck() || window.tabletPortraitCheck()) && pageType == 'Search'){
            	  $("#searchBar.header__search-wrapper").css("top","unset");
              }

              if ((window.mobilecheck() || window.tabletPortraitCheck()) && $("#Header_GlobalLogin").hasClass("opend")){
                $("#" + LOGINPANEL_ID + "_signInDropdown .panel .close-btn").click();
              }
          } else {
            closeMobileMenu();
          }
        var headerObj = $("#headerRow1 nav.nav");
        headerObj.attr("data-description",$(".nav__list.nav-menu").text().replace(/'/g,"\\'"));
        tealiumPushClickMenu(headerObj[0]);
      });
  }

  var navLink = document.getElementsByClassName('nav__link--phone');
  if (navLink.length > 0) {
      [].forEach.call(navLink, function (el) {
          el.addEventListener('click', function (event) {
              if (this.classList.contains('nav__link--opend')) {
                  this.classList.remove('nav__link--opend');
                 // document.getElementById("caroselOurWord").style.display = 'none';
              } else {
                  var navLength = navLink.length;
                  for (var i = 0; i < navLength; i++) {
                      navLink[i].classList.remove('nav__link--opend');
                  }
                  this.classList.add('nav__link--opend');
               //   document.getElementById("caroselOurWord").style.display = 'block';
              }
          });
      });
  }

  var menuCarousel = $('.submenu__carousel');
  if (menuCarousel.length > 0) {
      menuCarousel.owlCarousel();
  }

  var backButton = document.getElementsByClassName('submenu__back');
  if (backButton.length > 0) {
      [].forEach.call(backButton, function (el) {
          el.addEventListener('click', function (event) {
              var checkList = document.querySelectorAll('.submenu__list-item input');
              var checkListLength = checkList.length;
              for (var i = 0; i < checkListLength; i++) {
                  document.querySelector('.nav__list').classList.remove('nav_list--opend');
                  checkList[i].checked ? checkList[i].checked = false : '';
              }
             // document.querySelector('.header__first-login').classList.remove('header__first-login--opend');
          });
      });
  }

  var navInput = document.querySelectorAll('.submenu__list-item input');
  if (navInput.length > 0) {
      [].forEach.call(navInput, function (el) {
          el.addEventListener('click', function () {
              document.querySelector('.nav__list').classList.add('nav__list--opend');
            //document.querySelector('.header__first-login').classList.add('header__first-login--opend');
          });
      });
  }

  //   var navSearchIcon = document.querySelector('.header__search-icon');
  // var navSearchIcon = document.getElementById('searchIcon');
  // if (navSearchIcon !== null) {
  //     navSearchIcon.addEventListener('click', function() {
  //         var searchID = document.getElementById('searchBar');
  //         changeTabIndex($("#searchBox"));
  //         searchID.classList.contains('search--opend') ? searchID.classList.remove('search--opend') : searchID.classList.add('search--opend');
  //     });
  // }

  /**
   * Country selector:
   * Hide or show the country selector section.
   */
  var countrySelector = document.querySelector('.country-selected__wrapper');
  if (countrySelector) {
      countrySelector.addEventListener('click', function () {
          countrySelector.classList.toggle('--open');
      });
  }
  /**
      * Block for the Filters.
      */
  var facetFilter = document.getElementsByClassName('facet-sort');
  if (facetFilter.length > 0) {
      /*
      facetFilter = facetFilter[0];
      var windowScroll = window.scrollY;
      var top = facetFilter.offsetTop;
      var plp = document.getElementsByClassName('plp')[0];
      var sorting =  document.getElementsByClassName('sorting')[0];
      var wcSelectorSorting = document.getElementsByClassName('sorting__wc-selector')[0];

      window.onscroll = function() {
          windowScroll = window.scrollY;
          if (windowScroll >= top) {
              facetFilter.classList.add('facet--sticky');
              sorting.classList.add('sorting--sticky');
              plp.classList.add('plp--sticky');
              wcSelectorSorting.classList.add('sorting__wc-selector--sticky');
          } else {
              facetFilter.classList.remove('facet--sticky');
              sorting.classList.remove('sorting--sticky');
              plp.classList.remove('plp--sticky');
              wcSelectorSorting.classList.remove('sorting__wc-selector--sticky');
          }
      };
      window.onresize = function() {
          top = facetFilter.offsetTop;
      }
      var facetWidgetTitle = document.getElementsByClassName('facet__title-filter')[0];
      var facetWidget = document.getElementsByClassName('facet__widget')[0];
      facetWidgetTitle.addEventListener('click', function() {
          facetWidget.classList.contains('facet__widget--opend') ? facetWidget.classList.remove('facet__widget--opend') : facetWidget.classList.add('facet__widget--opend');
      });
      */

      var facetSubtitle = document.querySelectorAll('.facet__subtitle');
      if (facetSubtitle.length > 0) {
          [].forEach.call(facetSubtitle, function (el) {
              el.addEventListener('click', function () {
                  if (this.classList.contains('facet__subtitle--opend')) {
                      this.classList.remove('facet__subtitle--opend');
                  } else {
                      var facetSubtitleOpend = document.querySelectorAll('.facet__subtitle--opend');
                      var lengthFacet = facetSubtitleOpend.length;
                      if (lengthFacet > 0) {
                          for (var i = 0; i < lengthFacet; i++) {
                              facetSubtitleOpend[i].classList.remove('facet__subtitle--opend');
                          }
                      }
                      this.classList.add('facet__subtitle--opend');
                  }
              });
          });
      }
  }


  var sortBy = document.getElementsByClassName('sorting__dropdown');
  if (sortBy.length > 0) {
      sortBy[0].addEventListener('click', function () {
          console.log('click sortBy');
          var nameList = document.getElementsByClassName('sorting__list')[0];
          var sortWrapper = document.getElementsByClassName('sorting')[0];
          nameList.classList.contains('ui-selectmenu-button-open') ? sortWrapper.classList.add('sorting--open') : sortWrapper.classList.remove('sorting--open');
      });


      document.querySelector('body').addEventListener('click', function (e) {
          var sortingOpen = document.querySelector('.sorting__wc-selector');
          var sortWrapper = document.querySelector('.sorting')

          // If element .sorting__wc-selector exists
          // AND does not contain .ui-selectmenu-open
          // AND element .sorting contains .sorting--open
          // THEN we remove the class .sorting--open BECAUSE the combobox is closed
          if (sortingOpen && !sortingOpen.classList.contains('ui-selectmenu-open') && sortWrapper.classList.contains('sorting--open'))
              sortWrapper.classList.remove('sorting--open');
      });
  }

  var plpCarousel = $('.plp__other-product-carousel');
  var plpCarouselLength = plpCarousel.length;
  if (plpCarouselLength > 0) {
    //   $.each(plpCarousel, function (key, val) {
    //       $(this).owlCarousel({
    //           items: 3,
    //           pagination: false,
    //           navigation: true,
    //           navigationText: [
    //               "<button class='btn--owl-nav btn--owl-prev'></button>",
    //               "<button class='btn--owl-nav btn--owl-next'></button>"
    //           ],
    //           lazyLoad: true,
    //           addClassActive: true,
    //           rewindNav: false
    //       });
    //   })
  }

 
 

  /**
   * Country selector:
   * Hide or show the country selector section.
   */
  var countrySelector = document.querySelector('.country-selected__wrapper');
  if (countrySelector) {
      countrySelector.addEventListener('click', function () {
          countrySelector.classList.toggle('country-selected__wrapper--open');
          $("#footerWrapper").addClass("footer-pop-open");
      });
  }
});



function onSelectPLP(sel) {
  var str = sel.value;
  var url = window.location.href;
  var newUrl = "";
  var variable = "";
  var variable1 = "";
  var variable2 = "";
  var link = url.indexOf("?") >= 0 ? "&" : "?";

  if (url.indexOf("?orderBy=") >= 0) {
      variable = window.location.href.slice(0, window.location.href.indexOf('?orderBy='));
      variable1 = url.split("?orderBy=");
      variable2 = variable1[1];
      variable2 = variable2.slice(1);
      newUrl = variable + "?orderBy=" + str + variable2;
  } else if (url.indexOf("&orderBy=") >= 0) {
      variable = window.location.href.slice(0, window.location.href.indexOf('&orderBy='));
      variable1 = url.split("&orderBy=");
      variable2 = variable1[1];
      variable2 = variable2.slice(1);
      newUrl = variable + "&orderBy=" + str + variable2;
  } else {
      newUrl = window.location.href + link + "orderBy=" + str;
  }

  window.location.href = newUrl;
}


// Daniel Rilo - END - CREV NERD-569



/**
* Daniel Rilo -BEGIN - WCAG
*/
window.addEventListener('load', function () {
  // Add title to he iFrame without this attribute
  document.querySelectorAll('iframe').forEach(function (el, index) {
      if (el.title === '') {
          el.title = 'iFrame number ' + index;
      }
  });
})
/**
* Daniel Rilo -END - WCAG
*/

$(document).ready(function () {
  /**
   * @desc When you click on the "NEWSLETTER" link (in the footer), the "Newsletter" section show/hide.
   * @summary Show/hide Newsletter
   * @author Daniel Rilo
   */
  var btnNewsletterShowHide = document.querySelector('#sxShowNewsletter');
  if (btnNewsletterShowHide) {
      btnNewsletterShowHide.addEventListener('click', function (e) {
          e.preventDefault();

          var newsletterSection = document.querySelector('#newsLetterForm');
          newsletterSection ? newsletterSection.classList.toggle('opend') : '';
      })
  }

  var signInImg = document.querySelector('.signInRegistration__wrapper--left');
  if (signInImg) {
      signInImg.children.length < 1 ? signInImg.classList.add('signInRegistration__wrapper--hide') : '';
  }

  /**
   * @desc When you click on the Cross button, the pop up must hidden.
   * @summary Show/hide Popup
   * @author Daniel Rilo
   */
  var firstSignInPopupCloseCross = document.querySelector(".first-session__button-a");
  if (firstSignInPopupCloseCross) {
      addClosePopupSignIn(firstSignInPopupCloseCross);
  }

  /**
   * @desc When you click on the SHOP NOW button, the pop up must hidden.
   * @summary Show/hide Popup
   * @author Daniel Rilo
   */
  var firstSignInPopupCloseBtn = document.querySelector(".first-session__shop-button");
  if (firstSignInPopupCloseBtn) {
      addClosePopupSignIn(firstSignInPopupCloseBtn);
  }

  if((pageType == 'Plp' || pageType=='Static') && !(window.mobilecheck() || window.tabletPortraitCheck())) {
      mapMenuAndUnderline();
  } 
  
});


function mapMenuAndUnderline() {
  var allLinksSun = $('[data-espot-name="X_Header_NavSunglasses_Left"] a').map( function() {
      return $(this).attr('href').split('/').pop();
  }).get();

  var allLinksEye = $('[data-espot-name="X_Header_NavEyeglasses_Left"] a').map( function() {
      return $(this).attr('href').split('/').pop();
  }).get();

  var allLinksCollection = $('[data-espot-name="X_Header_NavCollections_Left"] a').map( function() {
      return $(this).attr('href').split('/').pop();
  }).get();

  var allLinksOurWorld = $("#X_Header_NavOurWorld_RightCards a").map( function() {
      return $(this).attr('href').split('/').pop();
  }).get();
  

  var currentPage = window.location.pathname.split('/').pop();

  if(allLinksSun.indexOf(currentPage) != -1) {
     $('[data-element-id="X_X_MainNav_Sun"]').addClass('underline');
  }
  else if (allLinksEye.indexOf(currentPage) != -1) {
      $('[data-element-id="X_X_MainNav_Optical"]').addClass('underline');
  }
  else if (allLinksCollection.indexOf(currentPage) != -1) {
      $('[data-element-id="X_X_MainNav_Collection"]').addClass('underline');
  }    
  else if (allLinksOurWorld.indexOf(currentPage) != -1) {
      $('[data-element-id="X_X_MainNav_World"]').addClass('underline');
  }    
}

/**
* @function addClosePopupSignIn
* @param {HTML object} item Object where I'll add the 'click' listener.
* @desc Add an Event Listener to a given HTML Object
* @summary Add Close Listener
* @author Daniel Rilo
*/
function addClosePopupSignIn(item) {
  item.addEventListener('click', function() {
      var firstSignInPopupCloseCross = document.querySelector(".first-session");
      if (firstSignInPopupCloseCross) {
          firstSignInPopupCloseCross.remove()
          noScrollFirstLogin(false);
      }
  });
}

/**
* This function keeps accesible the privacy policy link on the newsletter form input once it loses the focus.
*/
$(function(){
  $('#newsletterPolicy').focus(function(){
      $('#newsletterEmail').addClass('focus');
  })
  $('#newsletterPolicy').blur(function(){
      $('#newsletterEmail').removeClass('focus');
  })
});

/**
* Show/hide password in registration form
*/
$(document).ready(function () {
  var buttonShowPassword = document.querySelectorAll('.btn-show-hide-password');
  if (!buttonShowPassword) return false;
  buttonShowPassword.forEach(function(el) {
      el.addEventListener('click', function(e) {
          e.preventDefault();
          showHidePassword(this);
      });

      el.addEventListener('keyup', function(e) {
          if (e.keyCode == 13) showHidePassword(this);
      });
  });
});

/**
* Create sign in pop-up.
*/
$(document).ready(function () {
  $('.have_an_account').on('click', '.shipping_sign_in',function(e){
      e.preventDefault();
      e.stopPropagation();
      var signInPopUp = $(this).parent().find('#sign_in_popUp');
      if (signInPopUp.length > 0) {
          if($(window).width() < 1024) {
              signInPopUp.dialog({
                  modal: true,
                  classes: {
                      "ui-dialog": "checkout-sign-in-popup"
                  },
                  draggable: false,
                  closeText: "",
                  height: 'auto',
                  width: '100%',
                  position: 'bottom',
                  maxWidth: tabletWidth,
                  fluid: true,
                  resizable: false,
                  close: function () {
                      $('.ui-widget-overlay').removeClass('custom-overlay');
                      $('body').removeAttr('style');
                      $('body').removeClass('no-scroll');
                      $('body, html').css('height', 'auto');
                      $('body, html').css('overflow', 'visible');
                  },
                  open: function () {
                      $('.ui-widget-overlay').addClass('custom-overlay');
                      $('body').css('position', 'relative');
                      $('body').addClass('no-scroll');
                      $('body, html').css('height', '100%');
                      $('body, html').css('overflow', 'hidden');
                      $('.checkout-sign-in-popup .ui-dialog-titlebar-close').attr('aria-label','Close button');
                  }
              });
          } else {
              signInPopUp.dialog({
                  modal: false,
                  classes: {
                      "ui-dialog": "checkout-sign-in-popup"
                  },
                  draggable: false,
                  closeText: "",
                  height: 'auto',
                  width: 'auto',
                  maxWidth: tabletWidth,
                  fluid: true,
                  resizable: false,
                  close: function () {
                      $('.ui-widget-overlay').removeClass('custom-overlay');
                      $('body').removeAttr('style');
                      $('body').removeClass('no-scroll');
                  },
                  open: function () {
                      $('.ui-widget-overlay').addClass('custom-overlay');
                      $('body').css('position', 'relative');
                      $('body').addClass('no-scroll');
                      $('.checkout-sign-in-popup .ui-dialog-titlebar-close').attr('aria-label','Close button');
                  }
              });
          }
      } else {
          var checkoutSignInPopUp = $('.checkout-sign-in-popup').find('#sign_in_popUp');
          if (checkoutSignInPopUp.length > 0) {
              checkoutSignInPopUp.dialog('open');
          }
      }
  });
});

function showHidePassword(elem) {
  var inputType = elem.parentNode.querySelector('input');

  if (!inputType) return false;

  var imgType = elem.parentNode.querySelector('a img');
  var imgName = '';

  if (inputType.getAttribute('type') === 'text') {
      inputType.setAttribute('type', 'password');
      imgName = 'view.svg';
  } else {
      inputType.setAttribute('type', 'text');
      imgName = 'view-strike.svg';
  }

  imgType.src = imgType.src.substring(0, imgType.src.indexOf('view')) + imgName;
}

function noScrollFirstLogin(show) {
  show ? document.querySelector('body').classList.add('no-scroll') : document.querySelector('body').classList.remove('no-scroll');
}

/***
* Error Message
*/
displayLoginErrorMessage = function() {
  var loginError = $('.login-error');
  if (loginError.length > 0) {
      loginError.find('.myaccount_error').text(MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2030"]);
  }
};


/* START NEW PDP */
function insertCurrentGlassInOtherColors() {
  //TODO: CHECK IF THERE IS IMAGE
var url1 = $.parseJSON($('[id^="entitledItem_"]')[0].innerText)[0].ItemThumbnailImage + "&bgcolor=ffffff";
  var img1 = $('#productMainImage')[0].outerHTML;
  var url = $('#productMainImage')[0].src.replace("f8f8fb", "e3e3f0");
  var img2 = "<img class='image--hover' src=" + url + ">";
  var imgs = img1 + img2;
  $("#current-glass .img-container").html(imgs);

}



function createMiniature () {
  $("#persol_popup-images-carousel img[data-thumbnail]").each(function(index){
          var item = $("#persol_popup-images-carousel .owl-pagination .owl-page span")[index];
          var img = "<img src='" + $(this).data("thumbnail") + "' alt='" + $(this).attr("alt") + "' title='" + $(this).attr("title") + "' />"
          $(item).html(img)
      }
  )
}

handleSize = function(){
  if(window.mobilecheck() || window.tabletPortraitCheck()) {
      $('.size-option-selected').on('click',function(e){
          $('.bottom-scrollable-section').css('z-index', "1000");
         $("html").toggleClass("overflow-hidden"); 
          $("#page").addClass("hidden-scroll-body");
          e.stopPropagation();

          $('.modal-background').slideDown(0);
          manageScrollOverlay(true);
      })

      $('.definingAttributes .modal-background').on('click',function(e) {
          if(e.target.classList.contains('modal-background') && typeof closeSize === 'function') {
              closeSize();
          }
      })
  } else {
      $('.size-option-selected').on('click',function(e){

          $('.modal-background').toggle('hide');
          e.stopPropagation();
          if($('.modal-background').is(':visible')){
              managePopupTabIndex('.size-option-div', true);
          }

          for(var i = 0; i < productDisplayJS.entitledItems.length; i++){
              if(productDisplayJS.entitledItems[i].catentry_id == productDisplayJS.changedCatEntryId ){
                  $('#presc--side--button a[data-element-id="X_Pdp_Prod_AddLens"]').attr('data-prescription',productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]);
                  break;
              }
          }

      })
      /*$(window).on('click', function(e){
          if(e.target !== $('.size-option-div') && e.target !== $('.size-option-div li.size-options')){
              $('.modal-background').toggle('hide');
              $(window).off( "click")
          }
      })*/
  }
}

/* Show default payment placement */
/* PDP called function: #11
* prev function: setInventoryMapEntry()
* next function:  ()
*/
function showDefaultPaymentPlacement(payment) {
  var defaultPaymentPlacementCookie = getCookie("defaultPaymentPlacement");
  if (defaultPaymentPlacementCookie != undefined && defaultPaymentPlacementCookie != ""){
      payment = defaultPaymentPlacementCookie;
  }
  if (payment == ""){
      if (klarnaEnabled == 'true'){
          showKlarnaPlacements();
      } else if (affirmEnabled == 'true'){
          $('.pdp .affirm').show();
          $(".checkout__affirm").show();
      }
  } else {
      if (payment == 'klarna'){
          showKlarnaPlacements();
      } else if (payment == 'affirm'){
          $('.pdp .affirm').show();
          $(".checkout__affirm").show();
      }
  }
}

function initAccessibility(){
  //accessibility screen reader
  $('#owl-pdp .owl-item').attr('aria-selected','false');
  $('#owl-pdp .owl-item.active').attr('aria-selected','true');
}

function manageAccessibility(){
   // apply meta info to next and previous buttons and make them focusable
  //  $('#owl-pdp').attr('role', 'carousel');
   $('#owl-pdp .owl-item.active .popup_link').attr('tabindex','0');
   $('#owl-pdp .owl-item').attr('aria-selected','false');
   $('#owl-pdp .owl-item.active').attr('aria-selected','true');
   $('#owl-pdp .owl-pagination .owl-page').attr('role','button').attr('tabindex','0');
   $('#owl-pdp .owl-pagination .owl-page.active') .attr('title','Active Slide')
   $('#owl-pdp .owl-pagination .owl-page').on('keydown', function(e){
       if(e.keyCode == 13){
           var slideToGO = parseFloat($(this).children('.owl-numbers').html());
           $("#owl-pdp").data('owlCarousel').goTo(slideToGO - 1);
           $($('#owl-pdp .owl-pagination .owl-page')[slideToGO]).focus().attr('title','Active Slide')
           $($('#owl-pdp .owl-pagination .owl-page')[slideToGO]).attr('title','Next Slide');
           $($('#owl-pdp .owl-pagination .owl-page')[slideToGO - 2]).attr('title','Prev Slide');
       }

   })

   $('#owl-pdp .owl-item').attr('aria-selected','false');
   $('#owl-pdp .owl-item.active').attr('aria-selected','true');
}


$(document).ready(function(){
  // if page is pdp on orientation change trigger page reload
  if($('#page').hasClass('pdp')){ 
      /*
      //START Early Access
      $('.prices-container #listPrice_' + parentCatId.uniqueID).addClass('hidden-price');
      $('.prices-container #offerPrice_' + parentCatId.uniqueID).addClass('hidden-price');
      //END Early Access
      */
      window.addEventListener("orientationchange", function() {
          location.reload();
          }, false);

          
      var otherColors = $(".catalog-entry-recommendation-widget.other_colors").children(".catalogEntryRecommendationWidget");
      if(otherColors.length === 0){
          $(".catalog-entry-recommendation-widget.other_colors").addClass("other-colors-empty");
      }

      

  }

  // var zIndexSlot3 = $('.slot3').css('z-index');
  $(document).off("click", "#owl-pdp .popup_link").on("click", "#owl-pdp .popup_link", function(){
      //aumento z-index per nascondere le nav in sticky
      // $('.slot3').css('z-index', '6');
      $("html").addClass("overflow-hidden");
      $("#page-overflow-wrapper").addClass("overflow-hidden");
  $('.col12.slot3').css('position','relative');
      if($(this).attr("data-index") !== 0 || $(this).attr("data-index") !== "0")
          $("#persol_popup-images-carousel").trigger('owl.goTo', [$(this).attr("data-index")]);

      var len = $("#persol_popup-images-carousel [id^='lens-magnifier_']").length;
      var windowWidth = window.innerWidth;
      var zoomLevel = 1.5;
      if (windowWidth > 1600){
          zoomLevel = 1.8;
      }
      if(!(window.mobilecheck() || tabletPortraitCheck() )){
          for (var i = 0; i < len; i++) {
              $("#persol_popup-images-carousel #lens-magnifier_" + i + " img").mlens({
                  imgSrc: $("#persol_popup-images-carousel #lens-magnifier_" + i + " img").attr("data-big"),      // path of the hi-res version of the image
                  imgSrc2x: $("#persol_popup-images-carousel #lens-magnifier_" + i + " img").attr("data-big2x"),  // path of the hi-res @2x version of the image
                  lensShape: "circle",                // shape of the lens (circle/square)
                  lensSize: ["256px","256px"],            // lens dimensions (in px or in % with respect to image dimensions)
                  borderSize: 1,                  // size of the lens border (in px)
                  borderColor: "#bfbfbf",            // color of the lens border (#hex)
                  borderRadius: 0,                // border radius (optional, only if the shape is square)
                  imgOverlay: $("#persol_popup-images-carousel #lens-magnifier_" + i + " img").attr("data-overlay"), // path of the overlay image (optional)
                  overlayAdapt: true,    // true if the overlay image has to adapt to the lens size (boolean)
                  zoomLevel: zoomLevel,          // zoom level multiplicator (number)
                  responsive: true       // true if mlens has to be responsive (boolean)
              });
              $("#mlens_wrapper_" + i).css('position', 'relative');
          }
      }

      togglePopupCarosel(true);
  });

  $("#persol_popup-images .closeButton").click(function(){
      // $('.slot3').css('z-index', '1');
      $("html").removeClass("overflow-hidden");
      $("#page-overflow-wrapper").removeClass("overflow-hidden");
      $('.col12.slot3').css('position','');
      togglePopupCarosel(false);
      manageScrollOverlay(false);
  })

  handleSize();
//   if(window.mobilecheck() || window.tabletPortraitCheck() ){
//       $('.slot4').next().css('visibility', 'hidden')
//   }

  //variables for scroll mobile
  // lazyLoading();

  $(".promo-callout .close-icon").click(function(){
      $(".promo-callout").hide();
      setCookie('promoCalloutCookie', true, {expires: 1} )
  })

  if(!(window.mobilecheck() || window.tabletPortraitCheck())){
      $('body').on('wheel', function(event) {
          if(event.originalEvent.deltaY < 0 && document.documentElement.scrollTop <= 20){
              $('.slot3').slideDown({
                  duration:300,
                  complete:function(){
                          stickyBottomDesktop();
                          $(window).scrollTop(0);
                      }
                  });
          }
      });

      $('body').on('wheel', function(event) {
          if(event.originalEvent.deltaY < 0 && document.documentElement.scrollTop <= 20 && $('.slot3').is(":visible")){
            if(!$('#page').hasClass('pdp')){
                hideHeaderTimeout.showHeader();
            }
          }
      });
  } else {
      if (!$("#image-soldOut").is(":visible")) {
          //calcolo altezza img centrale
          if( $('.slot3 .full-image-widget').hasClass('other-colors-empty')){
              $('.slot3 .full-image-widget').css('height', window.innerHeight - $('.bottom-section').outerHeight() );
          } else{
              //$('.slot3 .full-image-widget').css('height', window.innerHeight - $('.bottom-section').outerHeight()  - $('.other_colors').outerHeight());
          }
      }
  }

  $('.you_might_also_like .product').on('click', function(){
      var url = $(this).find('a.product__image-link')[0];
      window.location.href = $(url).attr("href")
  })

  var currentImgUrl = null;
  var currentColors = null;
  var currentBadges = null;
  var currentOfferPrice;
  var currentOldPrice;
  var isCaseSlide = false;
  var currentOfferPriceNumber;
  var currentOldPriceNumber;

  //On mouse enter...
  $(document).on('mouseenter','#other_colors .other-colors-desktop .product:not(.active)', function(e) {
    //pdp offer and list price
      currentOfferPrice = window.productDisplayJS.itemPriceJsonOject[window.productDisplayJS.changedCatEntryId]['catalogEntry'].offerPrice;
      currentOldPrice = window.productDisplayJS.itemPriceJsonOject[window.productDisplayJS.changedCatEntryId]['catalogEntry'].listPrice;

      currentOfferPriceNumber = parseFloat(currentOfferPrice.replace(/[^0-9\.-]+/g,""));
      currentOldPriceNumber = parseFloat(currentOldPrice.replace(/[^0-9\.-]+/g,""));

      if(isNaN(currentOldPriceNumber)) { 
          //prendilo da FE
          if($(".namePartPriceContainer .list-price").length >0) {
              currentOldPrice =$(".namePartPriceContainer .list-price")[0].innerHTML;
              currentOldPriceNumber = parseFloat(WCCurrencyJS.format(currentOldPrice)).toFixed(2);
          }
      }

      currentColors = $(".current-product-colors").html();
      var infos = $(this).find(".attr--list span");
      var colorsToPrint = ""
      var colorsToPrintDiv = "<div class='product-colors frameProduct'>"
      var subtitleToPrint = ""
      $(infos).each(function(index){

          if($(this).hasClass('frameFitSpan')|| $(this).hasClass('polarized-span')) {
              subtitleToPrint += $(this).html();
          }
         // if((index == 1 || index == 3)) {
             //  if((!$(this).hasClass('frameFitSpan')|| $(this).hasClass('polarized-span'))){

                  if($(this).hasClass('front-color-value')){
                      colorsToPrint += $(this).html();
                      colorsToPrintDiv +=  $(this).html();
                  }else if($(this).hasClass('lens-color-value')){
                      colorsToPrint += " /";
                      colorsToPrintDiv += " /";
                      colorsToPrintDiv += $(this).html();
                      colorsToPrintDiv += "</div>";
                  }
                      
            //  }
         // }
      });
      if(!colorsToPrintDiv.includes('</div>')){//for eyeglasses 
          colorsToPrintDiv += '</div>'
      }
      if(subtitleToPrint != "<div class='sizeAndFitContainer'>"){//there are no attributes of geo fit frame fit and polarised
          subtitleToPrint += '</div>';
          $(".current-product-colors").html(colorsToPrintDiv + subtitleToPrint );
      }else{
          $(".current-product-colors").html(colorsToPrint);
      }

      

      //init badge
      if($(".long-description-widget .badge-container").length > 0){
          currentBadges = $(".long-description-widget .badge-container").html();
          if($(this).find(".badge--list").length > 0){
              var badges = $(this).find(".badge--list").html();
              $(".long-description-widget .badge-container").html(badges);
          }
      }
      //finish badge

      //var productID =  $(this).find('.catalog__image--front').attr('data-partNumber');
      //var urlOfferPrice = '/wcs/resources/store/' + WCParamJS.storeId + '/price?q=byPartNumbers&partNumber=' + productID;
      
      var catEntryID =  $(this).find('.catalog__image--front').attr('data-catalogEntryID');
      var urlOldPrice  = '/wcs/resources/store/' + WCParamJS.storeId + '/display_price?q=byCatalogEntryIdsAndPriceRuleName&catalogEntryId=' + catEntryID; //prezzo barrato

      // q=byCatalogEntryIdsAndPriceRuleName&catalogEntryId=3074457345616683669&currency=USD&checkEntitlement=false&timestamp=1589464328709
      var srcUrl = $(this).find('.catalog__image--front').attr('data-src-hover');
      var imgHover = "<img src='" + srcUrl + "' style='margin-top:"+longDescriptionWidgetMarginTop+"px'/>"
      currentImgUrl = $('.full-image-widget #slick-pdp .slick-slide.slick-active .owl-pdp__image-wrapper').html();
      if($('.full-image-widget #slick-pdp .slick-slide.slick-active .popup_link').hasClass('case')){
          $('.full-image-widget #slick-pdp .slick-slide.slick-active .popup_link').removeClass('case');
          isCaseSlide = true;
      }
      $('.full-image-widget #slick-pdp .slick-slide.slick-active .owl-pdp__image-wrapper').html(imgHover);

      //mouseover item offer and list price
      var offerPriceItem = '';
      var oldPriceItem = '';

      //START Early Access    
      offerPriceItem =  $(this).data('price');;
      //END Early Access

      if(this.getElementsByClassName('list-price').length > 0)
          oldPriceItem = WCCurrencyJS.unformat(this.getElementsByClassName('list-price')[0].innerText);

      if(offerPriceItem){
          $(".namePartPriceContainer .offer-price").html(WCCurrencyJS.format(offerPriceItem));
          if(oldPriceItem) {
              $(".namePartPriceContainer .list-price").html(WCCurrencyJS.format(oldPriceItem));
              if(oldPriceItem > offerPriceItem){
                  $(".namePartPriceContainer .list-price").show();
                  updatePriceInDiscountBadge(oldPriceItem,offerPriceItem);
              }
              else {
                  $(".namePartPriceContainer .list-price").hide();
                  $('#X_PDP_Hero__PromoBadge').addClass("hidden");
              }
          }
          else {// provo a interrogare il solr
              $.ajax({
                  url: urlOldPrice,
                  dataType: "json"}
              ).then(function(dataOld){
                  if (isEcommerceStoreJS === 'TRUE'
                      && dataOld !== undefined && dataOld[0].resultList !== undefined
                      && dataOld[0].resultList[0] !== undefined && dataOld[0].resultList[0].unitPrice !== undefined
                      && dataOld[0].resultList[0].unitPrice[0].price !== undefined &&  dataOld[0].resultList[0].unitPrice[0].price.value
                      ) {
                          oldPriceItem = parseFloat(dataOld[0].resultList[0].unitPrice);
                      }
                      if(oldPriceItem) {
                          $(".namePartPriceContainer .list-price").html(WCCurrencyJS.format(oldPriceItem));
                          if(oldPriceItem > offerPriceItem){
                              $(".namePartPriceContainer .list-price").show();
                              updatePriceInDiscountBadge(oldPriceItem,offerPriceItem);
                          }
                          else{ 
                              $(".namePartPriceContainer .list-price").hide();
                              $('#X_PDP_Hero__PromoBadge').addClass("hidden");
                          }
                      }
                      else {
                          $(".namePartPriceContainer .list-price").html("");
                          $(".namePartPriceContainer .list-price").hide();
                          $('#X_PDP_Hero__PromoBadge').addClass("hidden");
                      }
              }, function(){
                  console.log('error');
          })
          }
      } else {
          $(".namePartPriceContainer .offer-price").html(MESSAGE_NO_PRICE_AVAILABLE)
          $(".namePartPriceContainer .list-price").hide();
          $('#X_PDP_Hero__PromoBadge').addClass("hidden");
      }
  });

 $(document).on('mouseleave', '.other_colors .other-colors-desktop .product:not(.active)', function(e) {
    //On mouse leave...
    if(isCaseSlide){
          $('.full-image-widget #slick-pdp .slick-slide.slick-active .popup_link').addClass('case')
      }
      $(".full-image-widget #slick-pdp .slick-slide.slick-active .owl-pdp__image-wrapper").html(currentImgUrl);
      $(".current-product-colors").html(currentColors);
      if($(".long-description-widget .badge-container").length > 0){
        $(".long-description-widget .badge-container").html(currentBadges);
      }

      //restore base price
      var prescriptionPrice = $('.namePartPriceContainer .offer-price').attr('data-prescription-price')
      if(prescriptionPrice !== undefined && prescriptionPrice != "") {
          $(".namePartPriceContainer .offer-price").html(WCCurrencyJS.format(prescriptionPrice))

          var prescriptionPriceOld = $('.namePartPriceContainer .list-price').attr('data-prescription-price')
          if(prescriptionPriceOld !== undefined && prescriptionPriceOld != "" && $(".namePartPriceContainer .list-price").length > 0){
              $(".namePartPriceContainer .list-price").html(WCCurrencyJS.format(prescriptionPriceOld))
              if(prescriptionPriceOld > prescriptionPrice){
                  $(".namePartPriceContainer .list-price").show();
                  updatePriceInDiscountBadge(WCCurrencyJS.unformat(prescriptionPriceOld),WCCurrencyJS.unformat(prescriptionPrice));
              }
              else{
                  $(".namePartPriceContainer .list-price").hide();
                  $('#X_PDP_Hero__PromoBadge').addClass("hidden");
              }

          }
      } else {
          if(currentOfferPrice){
              $('.namePartPriceContainer .offer-price').html(currentOfferPrice);
              if(currentOfferPrice !== currentOldPrice && $('.namePartPriceContainer .list-price').length > 0) {
                  $('.namePartPriceContainer .list-price').html(currentOldPrice);
                  $(".namePartPriceContainer .list-price").show(); 
                  updatePriceInDiscountBadge(WCCurrencyJS.unformat(currentOldPrice),WCCurrencyJS.unformat(currentOfferPrice));
              }
              else {
                  $(".namePartPriceContainer .list-price").hide();
                  $('#X_PDP_Hero__PromoBadge').addClass("hidden");
              }
          } else {
              $(".namePartPriceContainer .offer-price").html(MESSAGE_NO_PRICE_AVAILABLE)
          }
      }
      //START Early Access
      if (window.lastOfferPrice != ""
            && $('.namePartPriceContainer .offer-price').length > 0){
          $('.namePartPriceContainer .offer-price')[0].innerText = window.lastOfferPrice;
      } else replacePDPMainPrice(catEntryIdSubscribe);
      //END Early Access
  });

})



var isFirstTime = true;
var endSlider;
var startSlider;
function setStickyProductDetailsNavbar() {
  if(!$('.slot3').is(':visible')){
      if(isFirstTime) {
          startSlider = Math.round($(".product-details-slider").position().top);
          endSlider = Math.round($(".product-details-slider").height() + $(".product-details-slider").position().top);
          isFirstTime = false;
      }

      var tabHeight = 40;
      var heightBlackBar = $(".slot4.fixed-navbar").height();
      if((window.pageYOffset + heightBlackBar) > (startSlider) && (window.pageYOffset + heightBlackBar) < (endSlider - tabHeight)){
          //$("#tab-products-details").addClass("sticky-bar");
          $('.slot5').css('padding-top', $('.tab-bar').height() +'px');
      } else {
          $("#tab-products-details").removeClass("sticky-bar");
          $('.slot5').css('padding-top', 0);
      }
  }
  if($('.slot3').is(':visible')) {
      //$("#tab-products-details").removeClass("sticky-bar");
      $('.slot5').css('padding-top', 0);
  }
}

//editorial JS
  animationInit = function () {
    if ($('#page').hasClass('pdp')){
        if(!(window.mobilecheck() || window.tabletPortraitCheck())){
            window.onscroll = function() {
               // var header = $('.slot4.fixed-navbar').get(0);
               // var positionSticky = header.offsetTop;
                //var slide = $('.slot3');
                //setStickyHeader(header, positionSticky, slide)
                setCtabarStickyDesktop();
                //event.preventDefault();
                //event.stopPropagation();
                //setStickyProductDetailsNavbar();
            }
        } else {
            //$('.slot4 .defining-attributes-widget').css('height', '0' );
            //window.addEventListener('scroll', animationScroll);
        }
      }
 }


function setStickyHeader (header, positionSticky, slide) {
  var st = window.pageYOffset || document.documentElement.scrollTop;

  if (st >= 20 && st > window.lastScrollTopBarAnimation && window.isFirstScrollStickyBar && !$('.shopperActions--monogram--pop-up').is(':visible')) {
      if($('#page').find('.ct-promo-bannerTop').length) {
          $('#bannerTop').slideUp();
      }
    //   $('#header').slideUp();
      $('[aria-describedby="quick_cart_container"]').hide();
      $('.freeShipping').slideUp();
      $('.long-description-widget').fadeOut();
      $('.bottom-section').css("bottom","auto");
      $('.col12.slot4.fixed-navbar.tall-bottom--mobile.fixed-bottom.sticky-bottom').css("bottom","auto");

      $("#tab-products-details").addClass("sticky-bar");

      $('.slot3').slideUp({
          duration:300,
          complete:function(){
              stickyTopDesktop();
              $(window).scrollTop(21);
          }
      });
      // if(!$(header).hasClass("sticky-top") && st >= scrollTopLimit){
      //     stickyTopDesktop();
      // }

  } else if(st < window.lastScrollTopBarAnimation && !$('.shopperActions--monogram--pop-up').is(':visible')) {
      if(!$('.slot3').is('visible') && st < 20){
          $('.slot3').slideDown({
              duration:300,
              complete:function(){
                  stickyBottomDesktop();
                  $(window).scrollTop(0);
                  }
              });
          $('.col12.slot4.fixed-navbar.tall-bottom--mobile.fixed-bottom.sticky-bottom').css("bottom","0px");
        $('.bottom-section').css("bottom","0px");
      }
  }

  window.lastScrollTopBarAnimation = st <= 20 ? 1 : st
}

function goBackToTopMobile () {
  $(window).scrollTop(0);
  hideHeaderTimeout.showHeader();
}

function createTopRecap(){
  $("#add2CartBtnNavBar").appendTo( "#fixed-top--mobile .cta-buttons" ).show();
  if($("#add2CartBtnDisabled").is(":visible")) $("#add2CartBtnNavBar").addClass('disabled')
  var url = 'https://assets.persol.com/is/image/Persol/8056597315685_000A.png?bgcolor=%23f7f7f7&impolicy=HB_parameters&wid=290&cropnorth=-7&cropsouth=-8';
  $("#fixed-top--mobile .navbar-product .product-image img").attr("src",url);
  $("#fixed-top--mobile .navbar-product .product-image, .navbar-product .product-colors").click(goBackToTopMobile)
  var prodName = $(".long-description-widget .persol-product-title").html();
  $("#fixed-top--mobile .navbar-product .product-name").html(prodName);
}

var firstTime = true;
function animationScroll(){
  if(parseInt($('#header').css('z-index')) > parseInt($('.bottom-scrollable-section').css('z-index')) && $("#MiniShopCartProductAdded").length === 0) {
      $('#header').css('z-index', '5')
  }
  if($("#fixed-top--mobile .navbar-product .product-price").html().length == 0){
      $("#fixed-top--mobile .navbar-product .product-price").html($(".prices-container .offer-price").html());
  }
  var st = $(window).scrollTop();
  var scroll = st + $("#fixed-top--mobile").height();
  event.preventDefault();
  event.stopPropagation();

  if($("#fixed-top--mobile").hasClass("animation-show") && firstTime) {
      window.productDetailTop = $('.slot5').offset().top;
      window.endSlider = parseInt($("#product-detail-carousel").height() + $('.slot5').offset().top);
      firstTime = false
  }

  if (st > window.lastScrollTopMobile){
      if( st < window.heightHiddenActions ){
          $('.slot4 .defining-attributes-widget').outerHeight(st);
      }
      if(st >= window.heightHiddenActions){
          $('.slot4 .defining-attributes-widget').outerHeight(window.heightHiddenActions);
          $('.slot4').next().css('visibility', 'visible');
      }

      var windowHeight;
      if(isSafari()){
        windowHeight = window.innerHeight-100;
      }else{
        windowHeight = window.innerHeight;
      }

      if (st >= windowHeight){
          $("#fixed-top--mobile .navbar-product .product-name").show()
          $('#fixed-top--mobile').addClass('animation-show');
      }

      //fisso la barra product detail se è presente
      if($('.slot5').length > 0){

          if(scroll >= window.productDetailTop && scroll < window.endSlider){
              $("#tab-products-details").addClass("sticky-bar");
              $('#product-detail-carousel').css('padding-top', '0');
              //$('#product-detail-carousel').css('padding-top', $('#tab-products-details').height() +'px');
          } else{
              $("#tab-products-details").removeClass("sticky-bar");
              $('#product-detail-carousel').css('padding-top', '0');
          }
      }

  } else if( st < window.lastScrollTopMobile ) {
       // upscroll code
      if($('.slot5').length > 0){

          if(scroll >= window.productDetailTop && scroll < window.endSlider){
              $("#tab-products-details").addClass("sticky-bar");
              $('#product-detail-carousel').css('padding-top', '0');
          } else {
              $('#product-detail-carousel').css('padding-top', '0');
              $("#tab-products-details").removeClass("sticky-bar");
          }
      }

      if(st <= window.innerHeight){
          $("#fixed-top--mobile .navbar-product .product-name").hide()
          $('#fixed-top--mobile').removeClass('animation-show');
      }
      if(st <= window.heightHiddenActions ){
          $('.slot4').next().css('visibility', 'hidden');
          $('.slot4 .defining-attributes-widget').css('height', 0);
          hideHeaderTimeout.showHeader();
      }
  }
      window.lastScrollTopMobile = st <= 0 ? 0 : st;
}
function pinchZoom(){
  // if(window.mobilecheck() || window.tabletPortraitCheck()){
      $("#persol_popup-images-carousel .owl-item img").swipe( {
        pinchStatus:function(event, phase, direction, distance , duration , fingerCount, pinchZoom) {
          if(fingerCount >= 2){
              event.stopPropagation();
          }
          console.log("Pinch zoom scale "+pinchZoom +"Distance pinched "+distance+"Direction " + direction);
          $(this).css('transform', 'scale('+ pinchZoom +')');
          $('#persol_popup-images-carousel .owl-carousel .owl-wrapper-outer').css('overflow', 'visible')
        },
        fingers:2,
        pinchThreshold:0
      });
  // }
}
function stickyTopDesktop(){
  window.isFirstScrollStickyBar = false;
  var header = $('.slot4').get(0);
  //$(header).removeClass("sticky-bottom");
  $(header).addClass("sticky-top");
  $("#add2CartBtn").attr("data-element-id", "X_Pdp_Stickybar_AddCart")
  $(".estimated").hide();
  $(".navbar-product .product-image, .navbar-product .product-colors").click(goBackToTopDesktop)
  var prodName = $(".long-description-widget .persol-product-title").html();
  var link = "<a>"+ $(".current-product-colors .product-colors").html().trim() +"</a>";
  $(".navbar-product .product-name").html(prodName);
  $(".navbar-product .product-colors").html(link);
  $(".navbar-placeholder").addClass("fixed-top-navbar");
  $(".bottom-section").addClass("fixed-top-navbar");
  $('.catalog-entry-recommendation-widget.other_colors').hide();/*wcag reason*/
  $('.navbar-product .product-image').focus();
}

function stickyBottomDesktop() {
  window.isFirstScrollStickyBar = true;
  var header = $('.slot4').get(0);
  $(header).removeClass("sticky-top");
  // if(!$("#add2CartBtnDisabled").is(':visible')){
      $(".estimated").show();
  $(header).addClass("sticky-bottom");
  $('.long-description-widget').show();
  $('.catalog-entry-recommendation-widget.other_colors').show();/*wcag reason*/
  $("#add2CartBtn").attr("data-element-id", "X_Pdp_Prod_AddCart")
  if(!$('#page').hasClass('pdp')) hideHeaderTimeout.showHeader();
  $(".navbar-placeholder").removeClass("fixed-top-navbar");
  $(".bottom-section").removeClass("fixed-top-navbar");
}

function goBackToTopDesktop(){
  $('.slot3').slideDown({
      duration:300,
      complete:function(){
          $(window).scrollTop(0);
          stickyBottomDesktop();
      }
  });
}

var hideHeaderTimeout = {

  hideHeader: function() {
      /*
      if($('[productAdded=yes]').length < 1){
          if($('#page').find('.ct-promo-bannerTop').length) {
              $('#bannerTop').slideUp();
          }
          $('#header').slideUp({
            complete:function(){
                setHeightFullImage(false)
            }
        })
        $('.freeShipping').slideUp()
        this.timeoutID = undefined;
    }
    */
  },

  showHeader: function() {
      if($('#page').find('.ct-promo-bannerTop').length) {
          $('#bannerTop').slideDown();
      }
      $("#header").slideDown({
          complete:function(){
              setHeightFullImage(true)
          }
      });
      $('.freeShipping').slideDown()
      this.setup();
  },

  setup: function() {
    if (window.mobilecheck() || window.tabletPortraitCheck()){
      if (typeof this.timeoutID === 'number') {
          this.cancel();
      }
      this.timeoutID = window.setTimeout(function() { this.hideHeader();  }.bind(this), 3000);
    }
  },/*
  setup: function() {

    if (typeof this.timeoutID === 'number') {

        this.cancel();

    }

    this.timeoutID = window.setTimeout(function() { this.hideHeader();  }.bind(this), 3000);

},*/

  cancel: function() {
      window.clearTimeout(this.timeoutID);
  }
}

//wcag close popup pressing escape
$(document).keyup(function (e) {
  if (e.key === "Escape") {
      if ($('.presc').hasClass('showed-presc')) {
          $('#close-prescriptions').click();
      }
      if ($('.op-pdp-popup-other-colors').hasClass("active")) {
          togglePopupOtherColors(false);
      }
      if ($('.modal-background').is(':visible')) {
          $('.modal-background').toggle('hide');
      }
      if ($('#persol_popup-images').is(':visible')) {
        $("html").removeClass("overflow-hidden");
        $("#page-overflow-wrapper").removeClass("overflow-hidden");
    $('.col12.slot3').css('position','fixed');
        togglePopupCarosel(false);
      }
      if ($('.shopperActions--monogram--pop-up').is(':visible')) {
         $('#close-monogram').click();
      }
  }
});


// ON load risposto al top
window.addEventListener('load',function(){

  if ($('#page').hasClass('pdp')){

      setTimeout(function(){
          // scrollTo(0,-1);
          calculateDistances();
          // if(window.mobilecheck()|| window.tabletPortraitCheck()){
          handleSwipeBounce();
          // }
      },0);

      window.zIndexBS = $('.bottom-scrollable-section').css('z-index');
      hideHeaderTimeout.setup();

      if(!(window.mobilecheck()|| window.tabletPortraitCheck())){
          window.lastScrollTopBarAnimation = 0;
          window.isFirstScrollStickyBar = true;
          //trigger click you may also like
          $('.slot7 .owl-item  .product').on('click', function(){
              $(this).find('a.product__image-link')[0].click()
          })
      } else {
          $('.selector-area-wrapper .size-option').on('click', function(){
              for(var i = 0; i < productDisplayJS.entitledItems.length; i++){
                  if(productDisplayJS.entitledItems[i].catentry_id == productDisplayJS.changedCatEntryId ){
                      $('#presc--side--button a[data-element-id="X_Pdp_Prod_AddLens"]').attr('data-prescription',productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]);
                      break;
                  }
              }
          });
      }

      if ($("[id$=X_PDP_CustomerSegment_Tooltip].contentRecommendationWidget").length > 0) $("[id$=X_PDP_CustomerSegment_Tooltip].contentRecommendationWidget").show();
  }
});

function checkPromoCookie (){
  var promoCookie = getCookie("promoCalloutCookie");
  if (promoCookie == null) {
      if(window.mobilecheck() || window.tabletPortraitCheck()){
          $(' .promo-callout').css('top', $('#header').outerHeight() + 10)
      }
      $(' .promo-callout-container').show()
  }
}
//wcag
function managePopupTabIndex(container, isOpen){
  if(isOpen){
      $(container).on('keydown', function(e){
          $(container).addClass('focus');
          $(container).focus();
          var focusableEls = $(container + " input:visible, "+ container + " button:visible, " + container + " a:visible, "+ container + " [tabindex]:not([tabindex='-1'])" )
          var firstFocusableEl = focusableEls[0];
          var lastFocusableEl = focusableEls[focusableEls.length - 1];
          var KEYCODE_TAB = 9;
          var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);
          if (!isTabPressed) {
              return;
          }
          if ( e.shiftKey ) /* shift + tab */ {
              if (document.activeElement === firstFocusableEl) {
                  lastFocusableEl.focus();
                  e.preventDefault();
              }
          } else /* tab */ {
              if (document.activeElement === lastFocusableEl) {
                  firstFocusableEl.focus();
                  e.preventDefault();
              }
          }
      })
  } else {
      $(container).off('keydown');
  }
}


/**
* NEW LOGIC FOR FORMS NEWSLETTER
*/

/**
* Function that open the newsletter from footer
*/
$(document).on('click','#newsletter-wrapper .newsletter-subscribe span',function() {
 changeTabIndex($('.newsletter'));
 if(checkMobilePdpPage()){
     changeFooterIndex(true)
 }
 $('.newsletter:not(.newsletter-page)').addClass('opend').focus().addClass('focus');
 $('.newsletter--fade').show();
 $('body').addClass('no-scroll');
 $('body, html').css('height', '100%');
 $('body, html').css('overflow', 'hidden');
 $("#newsletter-wrapper").hide();
 $(this).attr("data-element-id","X_HP_OverlayNewsletter");
 tealiumPushHPNewsletterSticky($(this)[0]);
});

/**
* Function close sticky and save cookie
*/
$(document).on('click','#newsletter-wrapper .closebutton',function() {
    $("#newsletter-wrapper").fadeOut('fast');
    setCookie("WELCOME_STICKY_SHOWN_"+storeDirectory,true,{expires: 10000,path: "/", domain: cookieDomain});
    $('body').removeClass('no-scroll');
    $('body, html').css('overflow', 'auto');
});

function setHeightFullImage(showHeader) {
    var longDescriptionWidgetMarginTop = $('#header').height();
    if($('.ct-promo-bannerTop').is(':visible') && $('.ct-promo-bannerTop').text() !== '') {
        longDescriptionWidgetMarginTop += $('.ct-promo-bannerTop').height();
        $('.bottom-scrollable-section').addClass('visible-bannerTop');
    } else {
        $('.bottom-scrollable-section').removeClass('visible-bannerTop');
    }

  if(!(window.mobilecheck() || window.tabletPortraitCheck())){
      if (!$("#image-soldOut").is(":visible")) {
          var fullHeight = window.innerHeight - 160;
          var fullHeightNoColor = window.innerHeight - 80;
        //   $('.full-image-widget').not('.no-prescription.other-colors-empty').css('height', fullHeight + 'px');
      }
      $('.full-image-widget.no-prescription.other-colors-empty').css('height', fullHeightNoColor + 'px')

      if($('.full-image-widget').hasClass("no-prescription") && $('.full-image-widget').hasClass("other-colors-empty")){
          $(".bottom-section").addClass("no-colors")
      }

      if(showHeader){
         // $(".long-description-widget").css("margin-top", longDescriptionWidgetMarginTop + "px");
          //$(".full-image-widget .widget_product_multiple_image_viewer .popup_link:not(.model):not(.case) .owl-pdp__image-wrapper:not('glass-img-container')").css("transform", "translateY(10%)");
      } else {
         //$(".long-description-widget").css("margin-top", "0");
          //$(".full-image-widget .widget_product_multiple_image_viewer .owl-pdp__image-wrapper").css('transform', 'translateY(0)');
      }
  }else {
      if(showHeader){
         // $(".long-description-widget").css("margin-top", longDescriptionWidgetMarginTop + "px");
          $(".full-image-widget .widget_product_multiple_image_viewer .popup_link:not(.model):not(.case) .owl-pdp__image-wrapper:not('glass-img-container')").css("transform", "translateY(10%)");
      } else {
          //$(".long-description-widget").css("margin-top", "0");
          $(".full-image-widget .widget_product_multiple_image_viewer .owl-pdp__image-wrapper").css('transform', 'translateY(0)');
      }
  }
}

/**
* Function for check email
*/
function validateFormNewsletter() {
  //var inputValue = $('#mce-EMAIL').val();
  var inputValue = $('#newsletterEmail').val();

  if (inputValue == '') {
      $('#mce-error-response').show();
      $('#mce-error-response').children().hide();
      $("#mce-error-response-empty").show();
  } else {
      $('#mce-error-response').css('display') != 'none' ? $('#mce-error-response').hide() : '';
      $('#mce-error-response').css('display') != 'none' ? $('#mce-success-response').hide() : '';

      //if (validateEmail(inputValue)) {
      if (!validateEmail(inputValue)) {
          $('#mce-error-response').show();
          $('#mce-error-response').children().hide();
          $('#mce-error-response-invalid').show();
      }
      else {
          $('#mc-embedded-subscribe-form').submit();
      }
  }
}

/* Function to validate the email */
function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}


$(document).ready(function () {
  /**
  * Function that open the newsletter from nav menu in desktop mode
  * and hide the nav menu
  */
  $('.nav-social__item-newsletter').click(function () {
      $('.header__nav-close').click();
      setTimeout(function () {
          $('.newsletter').addClass('opend').find(':focusable').first().focus().addClass('focus');
          $('.newsletter--fade').show();
          $('body').addClass('no-scroll');
          $('body, html').css('height', '100%');
          $('body, html').css('overflow', 'hidden');
          changeTabIndex($('.newsletter'));
      }, 500);
  });

  /**
  * Function that open the newsletter from nav menu in mobile mode
  */
  $('.nav-user__item--newsletter').click(function () {
      changeTabIndex($('.newsletter'));
      if(checkMobilePdpPage()){
          changeFooterIndex(true)
      }
      $('.newsletter').addClass('opend');
      $('.newsletter--fade').show();
      $('body').addClass('no-scroll');
      $('body, html').css('height', '100%');
      $('body, html').css('overflow', 'hidden');
  });

  /**
  * Function that open the newsletter from footer
  */
  $('.newsletter-cta__button, #segment-subscribe-cta').click(function () {
      if(checkMobilePdpPage()){
          changeFooterIndex(true);
      }
      changeTabIndex($('.newsletter'));
      $('.newsletter:not(.newsletter-page)').addClass('opend').focus().addClass('focus');
      $('.newsletter--fade').show();
      $('body').addClass('no-scroll');
      $('body, html').css('height', '100%');
      $('body, html').css('overflow', 'hidden');
      if (!getCookie($("#welcomePopupCookieName").val())) {
        $("#newsletter-wrapper").hide();
      }
  });

  /**
  * Function that close the newsletter
  */
  $('.newsletter__close').click(function () {
      if(checkMobilePdpPage()){
          changeFooterIndex(false)
      }
      changeTabIndex($('.newsletter'));
      $('.newsletter').removeClass('opend');
      $("#footerWrapper").removeClass("footer-pop-open");
      $('.newsletter--fade').hide();
      $('body').removeClass('no-scroll');
      $('body, html').css('height', 'auto');
      $('body, html').css('overflow', 'visible');
      if (!getCookie($("#welcomePopupCookieName").val())) {
        $("#newsletter-wrapper").show();
      }
  });

  /**
  * Function that close the newsletter when click in fade layer
  */
  $('.newsletter--fade').click(function () {
      $('.newsletter__close').click();
      $('body').removeClass('no-scroll');
      $('body, html').css('height', 'auto');
      $('body, html').css('overflow', 'visible');
  });

}).mouseup(function (e) {

});


function printEllipsis (text) {
  var checkForSpace = true;
  var index = 250;

  if(text.length < index) return;
  while (checkForSpace) {
      if(text[index] === " " || index > 300) {
          checkForSpace = false;
          // index = 180;
      } else {
          index++;
      }
  }

  return text.slice(0, index) + "...";
}


//open pop up klarna payment page
function openPopup(){
  $('.pop-container iframe').eq(0).attr('scrolling','yes');
  if (window.mobilecheck() || window.tabletPortraitCheck()){
      $(".pop-container.only-mobile").css('display','block');
      bodyScrollLock.disableBodyScroll(document.querySelector('.pop-wrap'));
  } else {
      $(".pop-container.only-desktop").css('display','block');
  }
  $("body").css("overflow","hidden");
$(".pop-bg, .pop-x").bind("click", function() {
  pop_close();
});

}

function pop_close() {
  $(".pop-container").css('display','none');
  $("body").css("overflow","auto");
$("body").unbind("click");
  if (window.mobilecheck() || window.tabletPortraitCheck()){
      bodyScrollLock.enableBodyScroll(document.querySelector('.pop-wrap'));
  }
}

function updateLastOfferUpsell(upsell){
//HB-7718
lastOfferPrice=$('.espot-complete-order-upsell #offerPrice_' + upsell).text().replace(/\s/g, '');

/*Now we create a div with list price and offer price of upsell product.
this div will be used into:
in productPageAdd2Cart (present in CommonUtilities) to set the pst in minicart.
In the end of this function we will remove this div*/

$('body').append('<div id="upsell-added-inicart"><span id="upsell-list-price">' + $('.espot-complete-order-upsell #listPrice_' + upsell).text().replace(/\s/g, '') + ' </span><span id="upsell-offer-price">' + $('.espot-complete-order-upsell #offerPrice_' + upsell).text().replace(/\s/g, '') + '</span></div>')
  if(typeof tealiumProducts === 'undefined'){
      tealiumProducts = {};
  }
  var upSellDetails = $('[data-catentry-id='+upsell+'] .product_name a');
  var upsellSku = upSellDetails.length > 0 ? upSellDetails[0].dataset.partnumber : upsell;
  if (typeof tealiumProducts[upsellSku]=== 'undefined'){
      var tealiumProduct = {};

      var listPrice = $('#listPrice_'+upsell).length > 0 ? cleanPrice($('#listPrice_'+upsell)[0].innerText) : '';
      var offerPrice = $('#offerPrice_'+upsell).length > 0 ? cleanPrice($('#offerPrice_'+upsell)[0].innerText) : '';
      if (listPrice != ""){
          listPrice = parseFloat(listPrice).toFixed(2);
      }
      else 
          listPrice = parseFloat(offerPrice).toFixed(2);

      if (offerPrice != ""){
          offerPrice = parseFloat(offerPrice).toFixed(2);
      }
      
      tealiumProduct['Sku']= upsellSku;
      tealiumProduct['ModelName']= upSellDetails.length > 0 ? upSellDetails[0].dataset.description : '';
      tealiumProduct['Category'] = upSellDetails.length > 0 ? upSellDetails[0].dataset.category.toUpperCase() : '';
      tealiumProduct['Price'] = offerPrice;
      tealiumProduct['Status'] = "Available";
      tealiumProduct['PriceFull'] = listPrice;
      tealiumProduct['Engraving'] = "N";
      tealiumProduct['Brand'] = currentBrand;
      tealiumProduct['Units'] = 1;
      
      tealiumProducts[upsellSku] = tealiumProduct;
  } else {
      tealiumProducts[upsellSku].Units++;
  }       
}

function checkEditFormInputs(){
    $(".myAccountSummary .form-group .input_field, .myAccountSummary .form-group .input_field_myacc").each(function(){
        if ($(this).val() == ''){
            $(this).siblings("label").removeClass("labelOnTop");
        } else {
            $(this).siblings("label").addClass("labelOnTop");
        }
    });
}

function setDDMPosition(){
    $("#all_section section").each(function(index,singleSection){
        if ($('#page').hasClass('plp')){
            $( singleSection ).css('top', $('#headerWrapper').height()-$('.ct-global--slider-container.ct-strip').height());
        } else {
            var globalBannerHeight = $('#contentRecommendationWidget_X_Header_GlobalBanner_X_Header_GlobalBanner').height();
            if(globalBannerHeight === undefined){
            globalBannerHeight = 0;
            }
            var headerHeight = $('#header').height();
            if ($('#page').hasClass('pdp')){
                headerHeight = $('.header__row1-wrapper').outerHeight(); 
            }
            $( singleSection ).css('top', headerHeight+globalBannerHeight-1); 
        }
    });
}

$(window).scroll(function() {
    if (!window.mobilecheck() || !window.tabletPortraitCheck()){
        setDDMPosition();
    }
});

function callAlgoliaServiceEspot(idSection){
    //I caroselli di algolia nel ddm sono inseriti qui
    if(idSection == '#departmentLink_sun_Section'){
        if(!isEspotAlreadyLoaded('X_Header_NavSunglasses_BestsellersCards')){
            loadHeaderEspot("X_Header_NavSunglasses_BestsellersCards"); 
        }
        if(!isEspotAlreadyLoaded('X_Header_NavSunglasses_IconsCards')){
            loadHeaderEspot("X_Header_NavSunglasses_IconsCards"); 
        }
    }
    else if (idSection == '#departmentLink_eyes_Section') {
        if(!isEspotAlreadyLoaded('X_Header_NavEyeglasses_BestsellersCards')){
            loadHeaderEspot("X_Header_NavEyeglasses_BestsellersCards");
        }
    }
    
}

function isEspotAlreadyLoaded(idContainer){
    var container = document.getElementById(idContainer);
    return container.childElementCount != 0;
}

document.addEventListener("DOMContentLoaded", function(event) {
  var lazyImages =[].slice.call(
   document.querySelectorAll(".telecomando-lower-container picture")
  )
  let lazyImageCheck = false; 
  if ("IntersectionObserver" in window && 'IntersectionObserverEntry' in window) {
     let lazyImageObserver = 
      new IntersectionObserver(function(entries, observer) {
         entries.forEach(function(entry) {
          if (entry.isIntersecting) {      
             let lazyImage = entry.target;
             lazyImage.lastElementChild.style.display = "block";
             lazyImageObserver.unobserve(lazyImage);
             lazyImageCheck = true;
           }
        });
         if(lazyImageCheck){
        	 setTimeout(function () {      
            	 $(".telecomando-lower-container .item").removeClass("skeleton-element");       
             }, 3000); 
         }
       });

     lazyImages.forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
     });
  } else {
    
    // Not supported, load all images immediately
    let active = false;
 
    const lazyLoad = function() {
      if (active === false) {
        active = true;
        setTimeout(function() {
          lazyImages.forEach(function(lazyImage) {
            if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
              lazyImage.lastElementChild.style.display = "block";
              lazyImageCheck = true;
              lazyImages = lazyImages.filter(function(image) {
                return image !== lazyImage;
              });
  
              if (lazyImages.length === 0) {
                document.removeEventListener("scroll", lazyLoad);
                window.removeEventListener("resize", lazyLoad);
                window.removeEventListener("orientationchange", lazyLoad);
              }
            }
            if(lazyImageCheck){
	        	setTimeout(function () {      
	              	 $(".telecomando-lower-container .item").removeClass("skeleton-element");       
	            }, 3000);
            }
          });
  
          active = false;
        }, 200);
      }
    };
  
    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad);
   }
 });


//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2017 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

AddressBookDetailJS = {

    /**
     * This function updates an address in the address book.
     * This function takes a form containing the address information and invokes 'updateAddressBook' service. 
     * After the address is updated, this function will refresh the address
     * display area using the given URL.
     * @param {string} formName The name of the form containing the address information.
     * @param {string} editSectionId The div ID of the edit section.
     */
    updateAddress: function(formName, editSectionId){

        var form = document.forms[formName];

        for (var i = 0; i < form.sbAddress.length; i++) {
            if (form.sbAddress[i].checked) {
                form.addressType.value = form.sbAddress[i].value;
            }
        }

        if(form.addressType.value == "") {
            MessageHelper.displayErrorMessage(MessageHelper.messages["AB_SELECT_ADDRTYPE"]);
            return;
        }
        /* Validate the form input fields. */
        if (this.validateAddressForm(form)) {
            console.debug("creating with form id = "+formName);

            wcService.declare({
                id: "updateAddressBook",
                actionId: "updateAddressBook",
                url: "AjaxRESTPersonChangeServiceAddressAdd",
                formId: formName,
                successHandler: function(serviceResponse) {
                    MessageHelper.displayStatusMessage(MessageHelper.messages["AB_UPDATE_SUCCESS"]);
                    cursor_clear();
                },
                failureHandler: function(serviceResponse) {
                    if (serviceResponse.errorMessage) {
                        MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                    }
                    else {
                        if (serviceResponse.errorMessageKey) {
                        MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                        }
                    }
                    cursor_clear();
                }
            });

            /*For Handling multiple clicks. */
            if(!submitRequest()){
                return;
            }
            cursor_wait();
            wcService.invoke("updateAddressBook");

            // Close Edit Section and display readOnly section.
            widgetCommonJS.toggleReadEditSection(editSectionId, 'read');
        }
    },

    validateAddressForm: function(form,prefix){
        reWhiteSpace = new RegExp(/^\s+$/);
        if(prefix == null){prefix = ""};
        if(prefix){this.setStateDivName(prefix + "stateDiv")};
        if(form != null){
            var fields="";
            if(form["UserDetailsForm_FieldsOrderByLocale"] != null && form["UserDetailsForm_FieldsOrderByLocale"].value != null && form["UserDetailsForm_FieldsOrderByLocale"].value != ""){
                fields = form["UserDetailsForm_FieldsOrderByLocale"].value.split(",");
            }
            else if(form["UserAddressForm_FieldsOrderByLocale"] != null && form["UserAddressForm_FieldsOrderByLocale"].value != null && form["UserAddressForm_FieldsOrderByLocale"].value != ""){
                fields = form["UserAddressForm_FieldsOrderByLocale"].value.split(",");
            }
            else if(form[prefix + "AddressForm_FieldsOrderByLocale"] != null && form[prefix + "AddressForm_FieldsOrderByLocale"].value != null && form[prefix + "AddressForm_FieldsOrderByLocale"].value != ""){
                fields = form[prefix + "AddressForm_FieldsOrderByLocale"].value.split(",");
            }
            else if(form["AddressForm_FieldsOrderByLocale"] != null && form["AddressForm_FieldsOrderByLocale"].value != null && form["AddressForm_FieldsOrderByLocale"].value != ""){
                fields = form["AddressForm_FieldsOrderByLocale"].value.split(",");
            }
            else if(document.getElementById("AddressForm_FieldsOrderByLocale").value!= null && document.getElementById("AddressForm_FieldsOrderByLocale").value!= ""){
                fields=document.getElementById("AddressForm_FieldsOrderByLocale").value.split(",");
            }
            var nickName = prefix + "nickName";
            var lastName = prefix + "lastName";
            var firstName = prefix + "firstName";
            var middleName = prefix + "middleName";
            var address1 = prefix + "address1";
            var address2 = prefix + "address2";
            var city = prefix + "city";
            var state = prefix + "state";
            var country = prefix + "country";
            var zipCode = prefix + "zipCode";
            var email1 = prefix + "email1";
            var phone1 = prefix + "phone1";

            for(var i=0; i<fields.length; i++){
                var field = fields[i];
                if(field == "NICK_NAME" || field == "nick_name"){
                    form[nickName].value = trim(form[nickName].value);
                    if(field == "NICK_NAME" && (form[nickName].value == "" || reWhiteSpace.test(form[nickName].value))){
                        MessageHelper.formErrorHandleClient(form[nickName].id, MessageHelper.messages["ERROR_RecipientEmpty"]);
                        return false;
                    }
                    if(!MessageHelper.isValidUTF8length(form[nickName].value, 254)){ 
                        MessageHelper.formErrorHandleClient(form.nickName.id, MessageHelper.messages["ERROR_RecipientTooLong"]); 
                        return false;
                    }
                }else if(field == "LAST_NAME" || field == "last_name"){
                    form[lastName].value = trim(form[lastName].value);
                    if(field == "LAST_NAME" && (form[lastName].value == "" || reWhiteSpace.test(form[lastName].value))){ 
                        MessageHelper.formErrorHandleClient(form[lastName].id, MessageHelper.messages["ERROR_LastNameEmpty"]);
                        return false;
                    }
                    if(!MessageHelper.isValidUTF8length(form[lastName].value, 128)){ 
                        MessageHelper.formErrorHandleClient(form[lastName].id, MessageHelper.messages["ERROR_LastNameTooLong"]);
                        return false;
                    }
                }else if(field == "FIRST_NAME" || field == "first_name"){
                    form[firstName].value = trim(form[firstName].value);
                    if(field == "FIRST_NAME" && (form[firstName].value == "" || reWhiteSpace.test(form[firstName].value))){ 
                        MessageHelper.formErrorHandleClient(form[firstName].id, MessageHelper.messages["ERROR_FirstNameEmpty"]);
                        return false;
                    }
                    if(!MessageHelper.isValidUTF8length(form[firstName].value, 128)){ 
                        MessageHelper.formErrorHandleClient(form[firstName].id, MessageHelper.messages["ERROR_FirstNameTooLong"]); 
                        return false;
                    }
                }else if(field == "MIDDLE_NAME" || field == "middle_name"){
                    form[middleName].value = trim(form[middleName].value);
                    if(field == "MIDDLE_NAME" && (form[middleName].value == "" || reWhiteSpace.test(form[middleName].value))){ 
                        MessageHelper.formErrorHandleClient(form[middleName].id, MessageHelper.messages["ERROR_MiddleNameEmpty"]);
                        return false;
                    }
                    if(!MessageHelper.isValidUTF8length(form[middleName].value, 128)){ 
                        MessageHelper.formErrorHandleClient(form[middleName].id, MessageHelper.messages["ERROR_MiddleNameTooLong"]); 
                        return false;
                    }
                }else if(field == "use_org_address" || field == 'new_line'|| field == "PASSWORD" || field == "PASSWORD_VERIFY"){
                }else if(field == "ADDRESS" || field == "address"){
                    form[address1].value = trim(form[address1].value);
                    form[address2].value = trim(form[address2].value);
                    if(field == "ADDRESS" && ((form[address1].value == "" || reWhiteSpace.test(form[address1].value)) && (form[address2].value=="" || reWhiteSpace.test(form[address2].value)))){ 
                        MessageHelper.formErrorHandleClient(form[address1].id, MessageHelper.messages["ERROR_AddressEmpty"]);
                        return false;
                    }
                    if(!MessageHelper.isValidUTF8length(form[address1].value, 100)){ 
                        MessageHelper.formErrorHandleClient(form[address1].id, MessageHelper.messages["ERROR_AddressTooLong"]); 
                        return false;
                    }
                    if(!MessageHelper.isValidUTF8length(form[address2].value, 50)){ 
                        MessageHelper.formErrorHandleClient(form[address2].id, MessageHelper.messages["ERROR_AddressTooLong"]);
                        return false;
                    }
                }else if(field == "CITY" || field == "city"){
                    form[city].value = trim(form[city].value);
                    if(field == "CITY" && (form[city].value == "" || reWhiteSpace.test(form[city].value))){ 
                        MessageHelper.formErrorHandleClient(form[city].id, MessageHelper.messages["ERROR_CityEmpty"]);
                        return false;
                    }
                    if(!MessageHelper.isValidUTF8length(form[city].value, 128)){
                        MessageHelper.formErrorHandleClient(form[city].id, MessageHelper.messages["ERROR_CityTooLong"]);
                        return false;
                    }
                }else if(field == "STATE/PROVINCE" || field == "state/province"){
                    var state = form[state];
                    if(state == null || state == ""){
                        state = document.getElementById(this.stateDivName).firstChild;
                    }
                    state.value = trim(state.value);
                    if(field == "STATE/PROVINCE" && (state.value == null || state.value == "" || reWhiteSpace.test(state.value))){
                        if(state.tagName == "SELECT" || state.tagName == "select") {
                            MessageHelper.formErrorHandleClient(state.id + "-button", MessageHelper.messages["ERROR_StateEmpty"]);
                        } else {
                            MessageHelper.formErrorHandleClient(state.id, MessageHelper.messages["ERROR_StateEmpty"]);
                        }
                        return false;
                    }
                    if(!MessageHelper.isValidUTF8length(state.value, 128)){
                        if(state.tagName == "SELECT" || state.tagName == "select") {
                            MessageHelper.formErrorHandleClient(state.id + "-button", MessageHelper.messages["ERROR_StateTooLong"]);
                        } else {
                            MessageHelper.formErrorHandleClient(state.id, MessageHelper.messages["ERROR_StateTooLong"]);
                        }
                        return false;
                    }
                }else if(field == "COUNTRY/REGION" || field == "country/region"){
                    console.log(form[country].value);
                    form[country].value = trim(form[country].value);
                    if(field == "COUNTRY/REGION" && (form[country].value == "" || reWhiteSpace.test(form[country].value))){ 
                        MessageHelper.formErrorHandleClient(form[country].id + "-button", MessageHelper.messages["ERROR_CountryEmpty"]);
                        return false;
                    }
                    if(!MessageHelper.isValidUTF8length(form[country].value, 128)){ 
                        MessageHelper.formErrorHandleClient(form[country].id + "-button", MessageHelper.messages["ERROR_CountryTooLong"]);
                        return false;
                    }
                }else if(field == "ZIP" || field == "zip"){
                    form[zipCode].value = trim(form[zipCode].value);
                    //check zip code for validation
                    if(field == "ZIP" && (form[zipCode].value=="" || reWhiteSpace.test(form[zipCode].value))){ 
                        MessageHelper.formErrorHandleClient(form[zipCode].id, MessageHelper.messages["ERROR_ZipCodeEmpty"]);
                        return false;
                    }
                    if(!MessageHelper.isValidUTF8length(form[zipCode].value, 40)){ 
                        MessageHelper.formErrorHandleClient(form[zipCode].id, MessageHelper.messages["ERROR_ZipCodeTooLong"]);
                        return false;
                    }
                }else if(field == "EMAIL1" || field == "email1"){
                    form[email1].value = trim(form[email1].value);
                    if(field == "EMAIL1" && (form[email1].value == "" || reWhiteSpace.test(form[email1].value))){
                        MessageHelper.formErrorHandleClient(form[email1].id, MessageHelper.messages["ERROR_EmailEmpty"]);
                        return false;
                    }
                    if(!MessageHelper.isValidUTF8length(form[email1].value, 256)){ 
                        MessageHelper.formErrorHandleClient(form[email1].id, MessageHelper.messages["ERROR_EmailTooLong"]);
                        return false;
                    }
                    if(!MessageHelper.isValidEmail(form[email1].value)){
                        MessageHelper.formErrorHandleClient(form[email1].id, MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]);
                        return false;
                    }
                }else if(field == "PHONE1" || field == "phone1"){
                    form[phone1].value = trim(form[phone1].value);
                    if(field == "PHONE1" && (form[phone1].value == "" || reWhiteSpace.test(form[phone1].value))){
                        MessageHelper.formErrorHandleClient(form[phone1].id, MessageHelper.messages["ERROR_PhonenumberEmpty"]);
                        return false;
                    }
                    if(!MessageHelper.isValidUTF8length(form[phone1].value, 32)){ 
                        MessageHelper.formErrorHandleClient(form[phone1].id, MessageHelper.messages["ERROR_PhoneTooLong"]);
                        return false;
                    }
                    if(!MessageHelper.IsValidPhone(form[phone1].value)){
                        MessageHelper.formErrorHandleClient(form[phone1].id, MessageHelper.messages["ERROR_INVALIDPHONE"]);
                        return false;
                    }
                }else{
                    console.debug("error: mandatory field name " + mandatoryField + " is not recognized.");
                    return false;
                }
            }
            if (form[address1] && form[address1].value == "" && form[address2].value != "") {

            form[address1].value = form[address2].value;
            form[address2].value = "";
            }
            return true;
        }
        return false;
    },

    resetFormValue: function(target_name){
        var target = $("#" + target_name);
        target.find("form").each(function(index, form){
            $(form)[0].reset();
            $(form).find("select.wcSelect").each(function(index, select){
                $(select).Select("refresh_noResizeButton");
            })
        });
    }
};

var declareAccountaddressDetailRefreshArea = function() {
    // ============================================
    // div: addressDetailRefreshArea refresh area
    var myWidgetObj = $("#addressDetailRefreshArea");

    // common render context
    if (!wcRenderContext.checkIdDefined("myAcctAddressDetailContext")) {
        wcRenderContext.declare("myAcctAddressDetailContext", ["addressDetailRefreshArea"], {addressId: "0", type: "0"});
    }
    
    var myRCProperties = wcRenderContext.getRenderContextProperties("myAcctAddressDetailContext");

    // render content changed handler
    var renderContextChangedHandler = function() {
        if (wcRenderContext.testForChangedRC("myAcctAddressDetailContext", ["addressId"]) && myRCProperties["addressId"] != "0") {
            myWidgetObj.refreshWidget("refresh", myRCProperties);
        }
    };

    // post refresh handler
    var postRefreshHandler = function() {
        myRCProperties["addressId"] = "0";
        myRCProperties["type"] = "0";
    };

    // initialize widget
    myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
};;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2017 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

AddressBookListJS = {

    /** 
     * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
     * @private
     */
    langId: "-1",
    /** 
     * This variable stores the ID of the current store. Its default value is empty.
     * @private
     */
    storeId: "",
    /** 
     * This variable stores the ID of the catalog. Its default value is empty.
     * @private
     */
    catalogId: "",
    authToken: "",
    addAddressURL: "",
    addressBookURL: "",

    /**
     * Sets the common parameters for the current page. 
     * For example, the language ID, store ID, and catalog ID.
     *
     * @param {Integer} langId The ID of the language that the store currently uses.
     * @param {Integer} storeId The ID of the current store.
     * @param {Integer} catalogId The ID of the catalog.
     * @param {Integer} authToken The authToken for current user to perform operation on server.
     * @param {String} addAddressURL The URL for adding an address.
     * @param {String} addressBookURL The URL for address book view.
     */
    setCommonParameters:function(langId,storeId,catalogId,authToken,addAddressURL,addressBookURL){
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        this.authToken = authToken;
        this.addAddressURL = addAddressURL;
        this.addressBookURL = addressBookURL;
        cursor_clear();
    },

    /**
     * Redirect to add address page.
     */
    addAddress:function(){
        setPageLocation(this.addAddressURL);
    },

    /*
     * This function creates a new address in the address book.
     * This function takes a form containing the address information and invokes 'updateAddress' service.
     * After the address is created, this function will refresh the address display area using the given URL.
     * @param {string} formName The name of the form containing the address information. 
     */
    newUpdateAddressBook: function(formName){

        var form = document.forms[formName];

        for (var i=0; i<form.sbAddress.length; i++) {
            if (form.sbAddress[i].checked) {
                form.addressType.value=form.sbAddress[i].value;
            }
        }

        if(form.addressType.value == "") {
            MessageHelper.displayErrorMessage(MessageHelper.messages["AB_SELECT_ADDRTYPE"]);
            return;
        }
        /*Validate the form input fields. */
        if (AddressBookDetailJS.validateAddressForm(form)) {
            console.debug("creating with form id = "+formName);
            wcService.declare({
                id: "updateAddress",
                actionId: "updateAddress",
                url: "AjaxPersonChangeServiceAddressAdd",
                formId: formName,
                successHandler: function(serviceResponse) {
                    cursor_clear();
                    widgetCommonJS.redirect(AddressBookListJS.addressBookURL);
                },
                failureHandler: function(serviceResponse) {
                    if (serviceResponse.errorMessage) {
                        MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                    } else if (serviceResponse.errorMessageKey) {
                        MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    }
                    cursor_clear();
                }
            });

            /*For Handling multiple clicks. */
            if(!submitRequest()){
                return;
            }
            cursor_wait();

            wcService.invoke("updateAddress");
        }
    },

    /*
     * This function deletes an address from the addressbook.
     * This function deletes an address currently selected and refreshes the address display area using the specified url.
    * @param {string} selectionName The id of the address dropdown box.
     * @param {string} addressDeleteUrl The url used to delete the address.
     * @param {string} addressUrl The url used to refresh the address display area.
     */

    newDeleteAddress: function(selectionName,addressDeleteUrl,addressUrl){

        var addressBox = $("#" + selectionName);
        if(addressBox.val() == $("#" + selectionName + " option:nth-child(1)").val()) {
            MessageHelper.formErrorHandleClient(selectionName + "-button",MessageHelper.messages["ERROR_DEFAULTADDRESS"]);
            return;
        }
        if(addressBox.val() =='') {
            MessageHelper.formErrorHandleClient(selectionName + "-button",MessageHelper.messages["ERROR_SELECTADDRESS"]);
            return;
        }
        var params = [];
        params.storeId = this.storeId;
        params.catalogId = this.catalogId;
        params.addressId = addressBox.val();
        params.URL = addressUrl;
        params.nickName = $.trim($("#" + selectionName + "-button span:nth-child(2)").text());
        wcService.declare({
            id: "AddressDelete",
            actionId: "AddressDelete",
            url: addressDeleteUrl,
            successHandler: function(serviceResponse) {
                MessageHelper.displayStatusMessage(MessageHelper.messages["AB_DELETE_SUCCESS"]);
                cursor_clear();
            },
            failureHandler: function(serviceResponse) {
                if (serviceResponse.errorMessage) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                } else {
                    if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    }
                }
                cursor_clear();
            }
        });

        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        wcService.invoke("AddressDelete",params);
    }
};

var declareAccountAddressBookRefreshArea = function() {
    // ============================================
    // div: addressBookListDiv refresh area
    var myWidgetObj = $("#addressBookListDiv");

    // common render context
    if (!wcRenderContext.checkIdDefined("myAcctAddressBookContext")) {
        wcRenderContext.declare("myAcctAddressBookContext", ["addressBookListDiv"], {addressId: "0", type: "0"});
    }
    var myRCProperties = wcRenderContext.getRenderContextProperties("myAcctAddressBookContext");

    // model change
    wcTopic.subscribe(["updateAddressBook", "AddressDelete"], function() {
        myWidgetObj.refreshWidget("refresh");
    });

    // render content changed handler
    var renderContextChangedHandler = function() {
        if (wcRenderContext.testForChangedRC("myAcctAddressBookContext", ["addressId"])) {
            myWidgetObj.refreshWidget("refresh", myRCProperties);
        }
    };

    var postRefreshHandler = function() {
        myRCProperties["addressId"] = "0";
        myRCProperties["type"] = "0";
        declareAccountaddressDetailRefreshArea();
        wcRenderContext.updateRenderContext('myAcctAddressDetailContext', {'addressId':"0", 'type':"0"});
    }
    
    // initialize widget
    myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
};//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2007, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 *@fileOverview This javascript file defines all the javascript functions used by approval comment widget
 */

	ApprovalCommentJS = {
			
		/** 
		 * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
		 * @private
		 */
		langId: "-1",
		
		/** 
		 * This variable stores the ID of the current store. Its default value is empty.
		 * @private
		 */
		storeId: "",
		
		/** 
		 * This variable stores the ID of the catalog. Its default value is empty.
		 * @private
		 */
		catalogId: "",
		
		/**
		* These variables define approve or reject status in the APRVSTATUS table. 1 for approved or 2 for rejected.
		*/
		cApproveStatus: 1,
		cRejectStatus: 2,
		
		/**
		 * Sets the common parameters for the current page. 
		 * For example, the language ID, store ID, and catalog ID.
		 *
		 * @param {Integer} langId The ID of the language that the store currently uses.
		 * @param {Integer} storeId The ID of the current store.
		 * @param {Integer} catalogId The ID of the catalog.
		 */
		setCommonParameters: function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
		},
		
		/**
		* Approves a approval record
		*/
		approveRecord: function(aprvstatus_id) {
			if(MessageHelper.utf8StringByteLength($('#approvalForm_comments').val()) > 254){ 
				MessageHelper.formErrorHandleClient($('#approvalForm_comments')[0], MessageHelper.messages["APP_COMMENT_ERR_TOO_LONG"]); 
				return false;
			}
			
			service = wcService.getServiceById('AjaxApproveRequest');
			var params = {
                storeId: this.storeId,
                catalogId: this.catalogId,
                langId: this.langId,
                aprv_act: this.cApproveStatus,
                approvalStatusId: aprvstatus_id,
                viewtask: "BuyerApprovalDetailView"
            };
			if ($("#approvalForm_comments").length) {
				params.comments = $("#approvalForm_comments").val();
			}

			/*For Handling multiple clicks. */
			if(!submitRequest()){
				return;
			}			
			cursor_wait();
			wcService.invoke('AjaxApproveRequest',params);		
		},

		/**
		* Rejects a approval record
		*/
		rejectRecord: function(aprvstatus_id) {
			if(MessageHelper.utf8StringByteLength($('#approvalForm_comments').val()) > 254){ 
				MessageHelper.formErrorHandleClient($('#approvalForm_comments')[0], MessageHelper.messages["APP_COMMENT_ERR_TOO_LONG"]); 
				return false;
			}
			
			service = wcService.getServiceById('AjaxRejectRequest');
			var params = {
                storeId: this.storeId,
                catalogId: this.catalogId,
                langId: this.langId,
                aprv_act: this.cRejectStatus,
                approvalStatusId: aprvstatus_id,
                viewtask: "BuyerApprovalDetailView"
            };
			if ($("#approvalForm_comments").length) {
				params.comments = $("#approvalForm_comments").val();
			}

			/*For Handling multiple clicks. */
			if(!submitRequest()){
				return;
			}			
			cursor_wait();
			wcService.invoke('AjaxRejectRequest',params);		
		}

	};//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 *@fileOverview This javascript file defines all the javascript functions used by buyer approval widget
 */
	BuyerApprovalListJS = {
			
		/** 
		 * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
		 * @private
		 */
		langId: "-1",
		
		/** 
		 * This variable stores the ID of the current store. Its default value is empty.
		 * @private
		 */
		storeId: "",
		
		/** 
		 * This variable stores the ID of the catalog. Its default value is empty.
		 * @private
		 */
		catalogId: "",
		
		/**
		* These variables define approve or reject status in the APRVSTATUS table. 1 for approved or 2 for rejected.
		*/
		cApproveStatus: 1,
		cRejectStatus: 2,
		
		/**
		* These variables refers to Ids of startSubmitDate and endSubmitDate element in BuyerApprovalList_ToolBar_UI.jspf.
		*/
		formStartDateId: "",
		formEndDateId: "",
		
		/**
		 * Search tool bar Id
		 */
		toolbarId: "",
		
		/**
		 * Sets the common parameters for the current page. 
		 * For example, the language ID, store ID, and catalog ID.
		 *
		 * @param {Integer} langId The ID of the language that the store currently uses.
		 * @param {Integer} storeId The ID of the current store.
		 * @param {Integer} catalogId The ID of the catalog.
		 */
		setCommonParameters: function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
		},
		
		/**
		 * Sets the common parameters for the current page. 
		 *
		 * @param {String} formStartDateId The ID of the startDate element.
		 * @param {String} formEndDateId The ID of the endDate element.
		 * @param {String} toolbarId The ID of the tool bar element.
		 */
		setToolbarCommonParameters: function(formStartDateId,formEndDateId, toolbarId){
			this.formStartDateId = formStartDateId;
			this.formEndDateId = formEndDateId;
			this.toolbarId = toolbarId;
		},
		
		/**
		* Approves a buyer record
		* @param {Long} aprvstatus_id The id of the request to be approved
		*/
		approveBuyer: function(aprvstatus_id) {
			service = wcService.getServiceById('AjaxApproveBuyerRequest');

			var params = {};
			params.storeId = this.storeId;
			params.catalogId = this.catalogId;
			params.langId = this.langId;
			params.aprv_act = this.cApproveStatus;
			params.approvalStatusId = aprvstatus_id;
			params.viewtask = "BuyerApprovalView";

			/*For Handling multiple clicks. */
			if(!submitRequest()){
				return;
			}			
			cursor_wait();
			wcService.invoke('AjaxApproveBuyerRequest',params);		
		},

		/**
		* Rejects a buyer record
		* @param {Long} aprvstatus_id The id of the request to be approved
		*/
		rejectBuyer: function(aprvstatus_id) {
			service = wcService.getServiceById('AjaxRejectBuyerRequest');

			var params = {};
			params.storeId = this.storeId;
			params.catalogId = this.catalogId;
			params.langId = this.langId;
			params.aprv_act = this.cRejectStatus;
			params.approvalStatusId = aprvstatus_id;
			params.viewtask = "BuyerApprovalView";

			/*For Handling multiple clicks. */
			if(!submitRequest()){
				return;
			}			
			cursor_wait();
			wcService.invoke('AjaxRejectBuyerRequest',params);
		},
		
		/**
		* This function is called when user selects a different page from the current page
		* @param (Object) data The object that contains data used by pagination control 
		*/
		showResultsPage:function(data){
			var pageNumber = data['pageNumber'];
			var pageSize = data['pageSize'];
			pageNumber = parseInt(pageNumber);
			pageSize = parseInt(pageSize);
			this.saveToolbarStatus();
			setCurrentId(data["linkId"]);

			if(!submitRequest()){
				return;
			}

			var beginIndex = pageSize * ( pageNumber - 1 );
			cursor_wait();

			wcRenderContext.updateRenderContext('BuyerApprovalTable_Context', {"beginIndex": beginIndex});
			MessageHelper.hideAndClearMessage();
		},
		
		/**
		 * Clear the context search term value set by search form
		 */
		reset:function(){
			this.updateContext({"beginIndex":"0", "approvalId": "", "firstName": "", "lastName":"","startDate":"","endDate":""});
		},
		
		/**
		 * Search for buyer approval requests use the search terms specified in the toolbar search form.
		 * 
		 * @param (String) formId	The id of toolbar search form element.
		 */
		doSearch:function(formId){
			var form = $("#" + formId)[0];
			var startDateValue = "";
			var endDateValue = "";
			var startDateWidgetValue = $("#" + this.formStartDateId + "_datepicker").datepicker("getDate");
			if (Utils.varExists(startDateWidgetValue)){
				startDateValue = startDateWidgetValue.toISOString().replace(/\.\d\d\dZ/, '+0000');
			}
			var endDateWidgetValue = $("#" + this.formEndDateId + "_datepicker").datepicker("getDate");
			if (Utils.varExists(endDateWidgetValue)){
				//add one day to the picked endDate.We pick a date the value for the date object
				//is yyyy-MM-dd 00:00:00(beginning of a day, we need it to be end of the a day)
				endDateWidgetValue = Utils.addDays(endDateWidgetValue, 1);
				//deduct one millisecond from the added date
				endDateWidgetValue = Utils.addMilliseconds(endDateWidgetValue, -1);
				endDateValue = endDateWidgetValue.toISOString().replace(/\.\d\d\dZ/, '+0000');
			}
			this.updateContext({
				"beginIndex":"0",
				"approvalId": form.approvalId.value.replace(/^\s+|\s+$/g, ''),
				"firstName":form.submitterFirstName.value.replace(/^\s+|\s+$/g, ''),
				"lastName":form.submitterLastName.value.replace(/^\s+|\s+$/g, ''),
				"startDate":startDateValue,
				"endDate":endDateValue
			});
		},
		
		/**
		 * Filter the buyer Approval list by status
		 * 
		 * @param (String) status The id of toolbar search form element.
		 */
		doFilter:function(status){
			this.updateContext({"beginIndex":"0", "approvalStatus": status});
		},
		
		/**
		 * Update the BuyerApprovalTable_Context context with given context object.
		 * 
		 * @param (Object)context The context object to update
		 */
		updateContext:function(context){
			this.saveToolbarStatus();
			if(!submitRequest()){
				return;
			}			
			cursor_wait();
			wcRenderContext.updateRenderContext("BuyerApprovalTable_Context", context);
			MessageHelper.hideAndClearMessage();
		},
		
		/**
		 * Save the toolbar aria-expanded attribute value
		 */
		saveToolbarStatus:function(){
			Utils.ifSelectorExists("#" + this.toolbarId, function($toolbar) {
				this.toolbarExpanded = $toolbar.attr("aria-expanded");
			}, this);
		},
		
		/**
		 * Restore the toolbar aria-expanded attribute, called by post-refresh handler
		 */
		restoreToolbarStatus:function(){
			if (Utils.varExists(this.toolbarExpanded)){
				$("#" + this.toolbarId).attr("aria-expanded", this.toolbarExpanded);
			}
		}
	};//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

// Declare context and refresh controller which are used in pagination controls of SearchBasedNavigationDisplay -- both products and articles+videos
wcRenderContext.declare("searchBasedNavigation_context", ["searchBasedNavigation_content_widget"], { "contentBeginIndex": "0", "productBeginIndex": "0", "beginIndex": "0", "orderBy": "", "facetId": "", "pageView": "", "resultType": "both", "orderByContent": "", "searchTerm": "", "facet": "", "facetLimit": "", "minPrice": "", "maxPrice": "", "pageSize": "" });

// Declare context and refresh controller which are used in pagination controls of SearchBasedNavigationDisplay to display content results (Products).
var searchBasedNavigation_controller_initProperties = {

    renderContextChangedHandler: function(refreshAreaDiv) {
        var rcProperties = wcRenderContext.getRenderContextProperties("searchBasedNavigation_context");
        var resultType = rcProperties["resultType"];
        rcProperties["pgl_widgetId"] = refreshAreaDiv.attr("pglwidgetid");
        if (["products", "both"].indexOf(resultType) > -1) {
            rcProperties["beginIndex"] = rcProperties["productBeginIndex"];
            refreshAreaDiv.refreshWidget("refresh", rcProperties);
        }

    },
    postRefreshHandler: function(widget) {
        // Handle the new facet counts, and update the values in the left navigation.  First parse the script, and then call the update function.        
        var rcProperties = wcRenderContext.getRenderContextProperties("searchBasedNavigation_context"),
            objectId = widget.attr("objectid"),
            facetCounts = byId("#facetCounts" + objectId);

        if (facetCounts != null) {
            var scripts = facetCounts.getElementsByTagName("script");
            var j = scripts.length;
            for (var i = 0; i < j; i++) {
                var newScript = document.createElement('script');
                newScript.type = "text/javascript";
                newScript.text = scripts[i].text;
                facetCounts.appendChild(newScript);
            }
            SearchBasedNavigationDisplayJS.resetFacetCounts();

            //uncomment this if you want tohide zero facet values and the facet itself
            //SearchBasedNavigationDisplayJS.removeZeroFacetValues();
            SearchBasedNavigationDisplayJS.validatePriceInput();
        }
        updateFacetCounts();
        SearchBasedNavigationDisplayJS.cleanUpAddedFacets();

        SearchBasedNavigationDisplayJS.removeEmptyFacet();
        var pairs = location.hash.substring(1).split(SearchBasedNavigationDisplayJS.contextValueSeparator);
        for (var k = 0; k < pairs.length; k++) {
            var pair = pairs[k].split(":");
            if (pair[0] == "facet") {
                var ids = pair[1].split(",");
                for (var i = 0; i < ids.length; i++) {
                    var e = byId(ids[i]);
                    if (e) {
                        e.checked = true;
                        if (e.title != "MORE") {
                            SearchBasedNavigationDisplayJS.appendFilterFacet(ids[i]);
                        }
                    }
                }
            }
        }


        var resultType = rcProperties["resultType"];
        if (["products", "both"].indexOf(resultType) > -1) {
            var currentIdValue = currentId;
            cursor_clear();
            SearchBasedNavigationDisplayJS.initControlsOnPage(objectId, rcProperties);
            shoppingActionsJS.updateSwatchListView();
            shoppingActionsJS.checkForCompare();
            var gridViewLinkId = "WC_SearchBasedNavigationResults_pagination_link_grid_categoryResults";
            var listViewLinkId = "WC_SearchBasedNavigationResults_pagination_link_list_categoryResults";
            var selectedFacet = $("#filter_" + currentIdValue + " > a")[0];
            var deSelectedFacet = $("li[id^='facet_" + currentIdValue + "']" + " .facetbutton")[0];

            if (selectedFacet != null && selectedFacet != 'undefined') {
                selectedFacet.focus();
            } else if (deSelectedFacet != null && deSelectedFacet != 'undefined') {
                deSelectedFacet.focus();
            } else if (currentIdValue == "orderBy") {
                $("#orderBy" + objectId).focus();
            } else {
                if ((currentIdValue == gridViewLinkId || currentIdValue != listViewLinkId) && byId(listViewLinkId)) {
                    byId(listViewLinkId).focus();
                }
                if ((currentIdValue == listViewLinkId || currentIdValue != gridViewLinkId) && byId(gridViewLinkId)) {
                    byId(gridViewLinkId).focus();
                }
            }
        }
        var pagesList = document.getElementById("pages_list_id");
        if (pagesList != null && !isAndroid() && !isIOS()) {
            $(pagesList).addClass("desktop");
        }
	
	/* APPLEPAY BEGIN */
	if (typeof(showApplePayButtons) == "function") {
		showApplePayButtons();
	}
	/* APPLEPAY END */
        wcTopic.publish("CMPageRefreshEvent");
    }
};

// Declare context and refresh controller which are used in pagination controls of SearchBasedNavigationDisplay to display content results (Articles and videos).
var declareSearchBasedNavigationContentController = function() {
    var widgetObj = $("#searchBasedNavigation_content_widget"),
        rcProperties = wcRenderContext.getRenderContextProperties("searchBasedNavigation_context");

    widgetObj.refreshWidget({
        renderContextChangedHandler: function() {
            var resultType = rcProperties["resultType"];
            if (["content", "both"].indexOf(resultType) > -1) {
                rcProperties["beginIndex"] = rcProperties["contentBeginIndex"];
                widgetObj.refreshWidget("refresh", rcProperties);
            }
        },
        postRefreshHandler: function() {
            var resultType = rcProperties["resultType"];
            if (["content", "both"].indexOf(resultType) > -1) {
                var currentIdValue = currentId;
                cursor_clear();
                SearchBasedNavigationDisplayJS.initControlsOnPage(widgetObj.objectId, rcProperties);
                //shoppingActionsJS.initCompare();
                if (currentIdValue == "orderByContent") {
                    byId("orderByContent").focus();
                }
            }
            wcTopic.publish("CMPageRefreshEvent");
        }
    });

};

if (typeof(SearchBasedNavigationDisplayJS) == "undefined" || SearchBasedNavigationDisplayJS == null || !SearchBasedNavigationDisplayJS) {

    SearchBasedNavigationDisplayJS = {

        /**
         * This variable is an array to contain all of the facet ID's generated from the initial search query.  This array will be the master list when applying facet filters.
         */
        contextValueSeparator: "&",
        contextKeySeparator: ":",
        widgetId: "",
        facetIdsArray: [],
        facetIdsParentArray: [],
        uniqueParentArray: [],
        selectedFacetLimitsArray: [],
        facetFromRest: [],

        init: function(widgetSuffix, searchResultUrl, widgetProperties) {
            $('#searchBasedNavigation_widget' + widgetSuffix).refreshWidget("updateUrl", matchUrlProtocol(searchResultUrl));
            var widgetInitProperties = {};
            $.extend(widgetInitProperties, WCParamJS, widgetProperties);
            this.initControlsOnPage(widgetSuffix, widgetInitProperties);
            this.updateContextProperties("searchBasedNavigation_context", widgetInitProperties);

            //			var currentContextProperties = wcRenderContext.getRenderContextProperties('searchBasedNavigation_context').properties;
        },

        initConstants: function(removeCaption, moreMsg, lessMsg, currencySymbol) {
            this.removeCaption = removeCaption;
            this.moreMsg = moreMsg;
            this.lessMsg = lessMsg;
            this.currencySymbol = currencySymbol;
        },

        initControlsOnPage: function(widgetSuffix, properties) {
            //Set state of sort by select box..
            $("#orderBy" + widgetSuffix).val(properties['orderBy']);

            $("#orderByContent").val(properties['orderByContent']);
        },

        initContentUrl: function(contentUrl) {
            $("#searchBasedNavigation_content_widget").refreshWidget("updateUrl", contentUrl);
        },

        findContainer: function(el) {
            //console.debug(el);
            while (el.parentNode) {
                el = el.parentNode;
                if (el.className == 'optionContainer') {
                    return el;
                }
            }
            return null;
        },

        resetFacetCounts: function() {
            for (var i = 0; i < this.facetIdsArray.length; i++) {
                var facetValue = byId("facet_count" + this.facetIdsArray[i]);
                var facetAcceValue = byId(this.facetIdsArray[i] + "_ACCE_Label_Count");
                if (facetValue != null) {
                    facetValue.innerHTML = 0;
                }
                if (facetAcceValue != null) {
                    facetAcceValue.innerHTML = 0;
                }
            }
        },

        removeEmptyFacet: function() {
            var widget = this.widgetId;
            for (var i = 0; i < this.facetIdsArray.length; i++) {
                var facetId = "facet_" + this.facetIdsArray[i];
                var facetValue = byId("facet_count" + this.facetIdsArray[i]);

                if (facetValue.innerHTML == '0') {
                    $("#" + facetId + widget).css("display", 'none');
                } else if (facetValue.innerHTML != '0') {
                    $("#" + facetId + widget).css("display", 'block');
                }
            }
        },

        removeZeroFacetValues: function() {
            var uniqueId = this.uniqueParentArray;
            var widget = this.widgetId;
            for (var i = 0; i < this.facetIdsArray.length; i++) {
                var facetId = "facet_" + this.facetIdsArray[i];
                var parentId = this.facetIdsParentArray[i];
                var facetValue = byId("facet_count" + this.facetIdsArray[i]);

                if (facetValue.innerHTML == '0') {
                    $("#" + facetId + widget).css("display", 'none');
                } else if (facetValue.innerHTML != '0') {
                    $("#" + facetId + widget).css("display", 'block');
                    uniqueId[parentId] = uniqueId[parentId] + 1;
                }
            }
            for (var key in uniqueId) {
                if (uniqueId[key] == 0) {
                    document.getElementById(key).style.display = 'none';
                    uniqueId[key] = 0; //reset the count
                } else if (uniqueId[key] != 0) {
                    document.getElementById(key).style.display = 'block';
                    uniqueId[key] = 0; //reset the count
                }
            }

        },
        updateFacetCount: function(id, count, value, label, image, contextPath, group, multiFacet) {
            var facetValue = byId("facet_count" + id);
            var widget = this.widgetId;
            if (facetValue != null) {
                var checkbox = byId(id);
                var facetAcceValue = byId(id + "_ACCE_Label_Count");
                if (count > 0) {
                    // Reenable the facet link
                    checkbox.disabled = false;
                    if (facetValue != null) {
                        facetValue.innerHTML = count;
                    }
                    if (facetAcceValue != null) {
                        facetAcceValue.innerHTML = count;
                    }
                }
            } else if (count > 0) {
                // there is no limit to the number of facets shown, and the user has exposed the show all link
                if (byId("facet_" + id) == null) {
                    // this facet does not exist in the list.  Insert it.
                    var divContainer = $("[id^='section_list_" + group + "']")[0];
                    var grouping = $(" > ul.facetSelect", divContainer)[0];
                    if (grouping) {
                        this.facetIdsArray.push(id);
                        var newFacet = document.createElement("li");
                        newFacet.setAttribute("onclick", "SearchBasedNavigationDisplayJS.triggerCheckBox(this)");
                        var newCheckBox = document.createElement("div");
                        var newCheckMark = document.createElement("div");
                        var facetClass = "";
                        var section = "";
                        if (!multiFacet) {
                            if (image !== "") {
                                facetClass = "singleFacet";
                            }
                            // specify which facet group to collapse when multifacets are not enabled.
                            section = group;
                        }
                        if (image !== "") {
                            facetClass = "singleFacet left";
                        }
                        if (image === "") {
                            $(newCheckBox).attr("class", "checkBox");
                            $(newCheckMark).attr("class", "checkmarkMulti");
                        }
                        $(newFacet).attr("id", "facet_" + id + widget);
                        $(newFacet).attr("class", facetClass);
                        newFacet.setAttribute("data-additionalvalues", "More")
                        var facetLabel = "<label for='" + id + "'>";
                        if (image !== "") {
                            facetLabel = facetLabel + "<span class='swatch'><span class='outline'><span id='facetLabel_" + id + "'><img src='" + image + "' title='" + label + "' alt='" + label + "'/></span> <div class='facetCountContainer'>(<span id='facet_count" + id + "'>" + count + "</span>)</div>";
                        } else {
                            facetLabel = facetLabel + "<span class='outline'><span id='facetLabel_" + id + "'>" + label + "</span> (<span id='facet_count" + id + "'>" + count + "</span>)</span>";
                        }
                        facetLabel = facetLabel + "<span class='spanacce' id='" + id + "_ACCE_Label'>" + label + " (" + count + ")</span></label>";
                        newFacet.innerHTML = "<input type='checkbox' aria-labelledby='" + id + "_ACCE_Label' id='" + id + "' value='" + value + "' onclick='javascript: SearchBasedNavigationDisplayJS.setEnabledShowMoreLinks(this, \"morelink_" + group + "\");SearchBasedNavigationDisplayJS.toggleSearchFilter(this, \"" + id + "\");'/>" + facetLabel;

                        var clearFloat = $(" > div.clear_float", grouping)[0];
                        if (clearFloat != undefined) {
                            grouping.removeChild(clearFloat);
                        }
                        grouping.appendChild(newFacet);
                        if (image === "") {
                            newFacet.appendChild(newCheckBox);
                            newCheckBox.appendChild(newCheckMark);
                        }
                    }
                }
            }
        },

        triggerCheckBox: function(elem) {
            var inputBox = elem.children[0];
            inputBox.click();
        },

        cleanUpAddedFacets: function() {
            for (var i = 0; i < this.facetIdsArray.length; i++) {
                var removeFacet = true;
                for (var j = 0; j < this.facetFromRest.length; j++) {
                    if (this.facetIdsArray[i] == this.facetFromRest[j]) {
                        removeFacet = false;
                        break;
                    }
                }
                if (removeFacet) {
                    var elem = byId("facet_" + this.facetIdsArray[i]);
                    if (elem != null) {
                        elem.parentNode.removeChild(elem);
                    }
                }
            }
        },

        setEnabledShowMoreLinks: function(element, section_id) {
            if (element.checked) {
                this.selectedFacetLimitsArray.push(section_id + "|" + element.id + "|" + element.value);
                this.removeShowMoreFromFacetLimitArray(section_id);
            } else {
                var index = this.selectedFacetLimitsArray.indexOf(section_id + "|" + element.id + "|" + element.value);
                if (index > -1) {
                    this.selectedFacetLimitsArray.splice(index, 1);
                }
            }
        },



        isValidNumber: function(n) {
            var valueToParse = n;
            valueToParse = valueToParse.replace(/^\s+|\s+$/g, "");
            valueToParse = valueToParse.replace(/\xa0/g, '');
            var valueToParse = valueToParse;

            if (Utils.getLocale() === 'ar-eg') {
                valueToParse = valueToParse.replace(',', '');
                var parsedAmountValue = Utils.round(valueToParse, 2);
            } else {
                var parsedAmountValue = Utils.round(valueToParse, 2);
            }
            return !isNaN(parsedAmountValue);
        },
        convertToInternalValue: function(val) {
            var valueToParse = val;
            valueToParse = valueToParse.replace(/^\s+|\s+$/g, "");
            valueToParse = valueToParse.replace(/\xa0/g, '');
            var valueToParse = valueToParse;

            if (Utils.getLocale() === 'ar-eg') {
                valueToParse = valueToParse.replace(',', '');
                var parsedAmountValue = Utils.round(valueToParse, 2);
            } else {
                var parsedAmountValue = Utils.round(valueToParse, 2);
            }
            return parsedAmountValue;
        },

        onGoButtonPress: function() {
            var low = $("#low_price_input").val(),
                high = $("#high_price_input").val();
            window.location.href = Utils.updateQueryStringParameter(window.location.href, {
                minPrice: low,
                maxPrice: high
            });
        },

        onPriceInput: function(event) {
            var enterPressed = (event.keyCode === KeyCodes.RETURN),
                inputValid = this.validatePriceInput(enterPressed);
            if (inputValid && enterPressed) {
                this.onGoButtonPress();
            } else {
                this.toggleGoButton(inputValid);
            }
        },

        toggleGoButton: function(enable) {
            var go = $("#price_range_go");
            if (go.length) {
                if (enable) {
                    go.attr("class", "go_button");
                    go.prop("disabled", false);
                } else {
                    go.attr("class", "go_button_disabled");
                    go.prop("disabled", true);
                }
            }
        },

        validatePriceInput: function(showErrorMsg) {
            if ($("#low_price_input").length && $("#high_price_input").length) {
                var low = $("#low_price_input").val();
                var high = $("#high_price_input").val();
                if (!this.isValidNumber(low)) {
                    if (showErrorMsg) {
                        MessageHelper.formErrorHandleClient("low_price_input", Utils.getLocalizationMessage('ERROR_FACET_PRICE_INVALID'));
                    }
                    return false;
                } else if (!this.isValidNumber(high)) {
                    if (showErrorMsg) {
                        MessageHelper.formErrorHandleClient("high_price_input", Utils.getLocalizationMessage('ERROR_FACET_PRICE_INVALID'));
                    }
                    return false;
                } else if (parseFloat(high) < parseFloat(low)) {
                    if (showErrorMsg) {
                        MessageHelper.formErrorHandleClient("high_price_input", Utils.getLocalizationMessage('ERROR_FACET_PRICE_INVALID'));
                    }
                    return false;
                } else {
                    return true;
                }
            }
            return false;
        },

        toggleShowMore: function(index, show) {
            var list = byId('more_' + index);
            var morelink = byId('morelink_' + index);
            if (list != null) {
                if (show) {
                    morelink.style.display = "none";
                    list.style.display = "inline-block";
                } else {
                    morelink.style.display = "inline-block";
                    list.style.display = "none";
                }
            }
        },

        toggleSearchFilterOnKeyDown: function(event, element, id) {
            if (event.keyCode === KeyCodes.RETURN) {
                //element.checked = !element.checked;
                this.toggleSearchFilter(element, id);
            }
        },

        toggleSearchFilter: function(element, id) {
            if (element.checked) {
                this.appendFilterFacet(id);
            } else {
                this.removeFilterFacet(id);
            }

            /*

            			if(section !== "") {
            				byId('section_' + section).style.display = "none";
            			}
            */
            this.doSearchFilter();
        },

        appendFilterPriceRange: function(currencySymbol) {

            var el = byId("price_range_input");
            var section = this.findContainer(el);
            if (section) {
                byId(section.id).style.display = "none";
            }
            /*
			byId("clear_all_filter").style.display = "block";
            
			var facetFilterList = byId("facetFilterList");
			// create facet filter list if it's not exist
			if (facetFilterList == null) {
				facetFilterList = document.createElement("ul");
				$(facetFilterList).attr("id", "facetFilterList");
				$(facetFilterList).attr("class", "facetSelectedCont");
				var facetFilterListWrapper = byId("facetFilterListWrapper");
				facetFilterListWrapper.appendChild(facetFilterList);
			}

			var filter = byId("pricefilter");
			if(filter == null) {
				filter = document.createElement("li");
				$(filter).attr("id", "pricefilter");
				$(filter).attr("class", "facetSelected");
				facetFilterList.appendChild(filter);
			}
			var label = currencySymbol + byId("low_price_input").value + " - " + currencySymbol + $("#high_price_input").val();
			filter.innerHTML = "<a role='button' href='#' onclick='wcTopic.publish(\"Facet_Remove\"); return false;'>" + "<div class='filter_option'><div class='close'></div><span>" + label + "</span><div class='clear_float'></div></div></a>";

			byId("clear_all_filter").style.display = "block";
            */
            if (this.validatePriceInput()) {
                // Promote the values from the input boxes to the internal inputs for use in the request.
                byId("low_price_value").value = this.convertToInternalValue(byId("low_price_input").value);
                byId("high_price_value").value = this.convertToInternalValue(byId("high_price_input").value);
            }

        },

        removeFilterPriceRange: function() {
            console.error("should not be calling this");
            /*
			if($("#low_price_value").length && $("#high_price_value").length) {
				byId("low_price_value").value = "";
				byId("high_price_value").value = "";
			}
			var facetFilterList = byId("facetFilterList");
			var filter = byId("pricefilter");
			if(filter != null) {
				facetFilterList.removeChild(filter);
			}

			if(facetFilterList.childNodes.length == 0) {
				byId("clear_all_filter").style.display = "none";
				byId("facetFilterListWrapper").innerHTML = "";
			}

			var el = byId("price_range_input");
			var section = this.findContainer(el);
			if(section) {
				byId(section.id).style.display = "block";
			}

			this.doSearchFilter(); */
        },

        appendFilterFacet: function(id) {
            var facetFilterList = byId("facetFilterList");
            // create facet filter list if it's not exist
            if (facetFilterList == null) {
                facetFilterList = document.createElement("ul");
                $(facetFilterList).attr("id", "facetFilterList");
                $(facetFilterList).attr("class", "facetSelectedCont");
                var facetFilterListWrapper = byId("facetFilterListWrapper");
                facetFilterListWrapper.appendChild(facetFilterList);
            }

            var filter = byId("filter_" + id);
            // do not add it again if the user clicks repeatedly
            if (filter == null) {
                filter = document.createElement("li");
                $(filter).attr("id", "filter_" + id);
                $(filter).attr("class", "facetSelected");
                var label = byId("facetLabel_" + id).innerHTML;
                var acceRemoveLabel = "<span class='spanacce' id='ACCE_Label_Remove'>" + MessageHelper.messages['REMOVE'] + "</span>";

                filter.innerHTML = "<a role='button' href='#' onclick='javascript:setCurrentId(\"" + id + "\");wcTopic.publish(\"Facet_Remove\", \"" + id + "\"); return false;'>" + "<div class='filter_option'><div class='close'></div><span>" + label + "</span>" + acceRemoveLabel + "<div class='clear_float'></div></div></a>";

                facetFilterList.appendChild(filter);
            }

            $("#facetLabel_" + id).parent().attr("class", "outline facetSelectedHighlight");

            var el = byId(id);
            var section = this.findContainer(el);
            if (section) {
                byId(section.id).style.display = "none";
            }
            byId("clear_all_filter").style.display = "block";

        },

        removeFilterFacet: function(id) {
            var facetFilterList = byId("facetFilterList");
            var filter = byId("filter_" + id);
            if (filter != null) {
                var value = byId(id).value;
                var section_id = value.split("%3A%22")[0];
                var index = this.selectedFacetLimitsArray.indexOf("morelink_" + section_id + "|" + id + "|" + value);

                if (index == -1) {
                    value = value.replace(/%3A/g, ":");
                    value = value.replace(/%22/g, '"');
                    index = this.selectedFacetLimitsArray.indexOf("morelink_" + section_id + "|" + id + "|" + value);
                }

                if (index > -1) {
                    this.selectedFacetLimitsArray.splice(index, 1);
                }
                facetFilterList.removeChild(filter);
                //byId(id).checked = false;
            }

            if (facetFilterList != null && facetFilterList.childNodes.length == 0) {
                byId("clear_all_filter").style.display = "none";
                byId("facetFilterListWrapper").innerHTML = "";
            }

            $("#facetLabel_" + id).parent().attr("class", "outline");

            var el = byId(id);
            var section = this.findContainer(el);
            if (section) {
                byId(section.id).style.display = "block";
            }
            this.doSearchFilter();
        },

        getEnabledProductFacets: function() {
            var facetForm = document.forms['productsFacets'] != null ? document.forms['productsFacets'] : document.forms['productsFacetsHorizontal'];
            var elementArray = facetForm.elements;

            var facetArray = [];
            var facetIds = [];
            if (_searchBasedNavigationFacetContext != 'undefined') {
                for (var i = 0; i < _searchBasedNavigationFacetContext.length; i++) {
                    facetArray.push(_searchBasedNavigationFacetContext[i]);
                    //facetIds.push();
                }
            }
            var facetLimits = [];
            for (var i = 0; i < elementArray.length; i++) {
                var element = elementArray[i];
                if (element.type != null && element.type.toUpperCase() == "CHECKBOX") {
                    if (element.title == "MORE") {
                        // scan for "See More" facet enablement.
                        if (element.checked) {
                            facetLimits.push(element.value);
                        }
                    } else {
                        // disable the checkbox while the search is being performed to prevent double clicks
                        //element.disabled = true;
                        if (element.checked) {
                            facetArray.push(element.value);
                            facetIds.push(element.id);
                        }
                    }
                }
            }
            // disable the price range button also
            if ($("#price_range_go").length) {
                byId("price_range_go").disabled = true;
            }

            var results = [];
            results.push(facetArray);
            results.push(facetLimits);
            results.push(facetIds);
            return results;
        },

        /**
         * @param clickedFacet the facet that was clicked
         */
        onFacetClick: function(clickedFacet) {
            console.error("deprecated: should not call this function");
            /*
			var minPrice = "",
                maxPrice = "";

			if(Utils.idExists("low_price_value", "high_price_value")) {
				minPrice = $("#low_price_value").val();
				maxPrice = $("#high_price_value").val();
			}
			if(minPrice === '' && maxPrice === '')
			{
				minPrice = window.initialMinPrice;
				maxPrice = window.initialMaxPrice;
			}
			
            var facetArray = this.getEnabledProductFacets(),
                $clickedFacet = $(clickedFacet),
                url = $clickedFacet.attr('href')
            url = Utils.updateQueryStringParameter(url, {
                "productBeginIndex": "0", 
                "facet": [$("input[type='checkbox']", $clickedFacet.parent()).val()], 
                "facetLimit": [], 
                "facetId": [$clickedFacet.data("for")], 
                "resultType":"products", 
                "minPrice": minPrice, 
                "maxPrice": maxPrice
            });
            $clickedFacet.attr('href', url)
            console.log(url);*/
            /*
			wcRenderContext.updateRenderContext('searchBasedNavigation_context', );
			*/

        },

        addShowMoreToFacetLimitArray: function(id) {
            // only add if no child facet is selected (i.e. no child is found in selectedFacetLimitsArray
            var childExist = false;
            for (var i = 0; i < this.selectedFacetLimitsArray; i++) {
                if (this.selectedFacetLimitsArray[i].indexOf(id) !== -1) {
                    childExist = true;
                    break;
                }
            }
            if (!childExist) {
                var index = id.indexOf(":");
                if (index != -1) {
                    id = id.substr(0, index);
                }
                this.selectedFacetLimitsArray.push("morelink_" + id);
            }
        },

        removeShowMoreFromFacetLimitArray: function(id) {
            var cIndex = id.indexOf(":");
            if (cIndex != -1) {
                id = id.substr(0, cIndex);
            }
            if (id.indexOf("morelink_") === -1) {
                id = "morelink_" + id;
            }
            var index = this.selectedFacetLimitsArray.indexOf(id);
            if (index != -1) {
                this.selectedFacetLimitsArray.splice(index, 1);
            }
        },

        toggleShowMore: function(element, id) {
            var label = byId("showMoreLabel_" + id);
            var divContainer = $("[id^='section_list_" + id + "']")[0];
            var grouping = $(" > ul.facetSelect > li[data-additionalvalues]", divContainer);
            if (element.checked) {
                this.addShowMoreToFacetLimitArray(element.value);
                label.innerHTML = this.lessMsg;
                var group = $(" > ul.facetSelect", divContainer)[0];
                var clearFloat = $(" > div.clear_float", group)[0];
                if (clearFloat != undefined) {
                    group.removeChild(clearFloat);
                }
                grouping.css("display", "");
            } else {
                this.removeShowMoreFromFacetLimitArray(element.value);
                grouping.css("display", "none");
                label.innerHTML = this.moreMsg;
            }
            this.doSearchFilter();
        },


        clearAllFacets: function(execute) {
            console.error("deprecated: do not call this function");
            /*
			byId("clear_all_filter").style.display = "none";
			byId("facetFilterListWrapper").innerHTML = "";
			if($("#low_price_value").length && $("#high_price_value").length) {
				byId("low_price_value").value = "";
				byId("high_price_value").value = "";
			}

			var facetForm = document.forms['productsFacets'] != null ? document.forms['productsFacets'] : document.forms['productsFacetsHorizontal'];
			var elementArray = facetForm.elements;
			for (var i=0; i < elementArray.length; i++) {
				var element = elementArray[i];
				if(element.type != null && element.type.toUpperCase() == "CHECKBOX" && element.checked && element.title != "MORE") {
					//element.checked = false;
				}
			}

			var elems = document.getElementsByTagName("*");
			for (var i=0; i < elems.length; i++) {
				// Reset all hidden facet sections (single selection facets are hidden after one facet is selected from that facet grouping)
				// and clear all selected facet highlights.
				var element = elems[i];
				if (element.id != null) {
					if (element.id.indexOf("section_") == 0 && !(element.id.indexOf("section_list") == 0)) {
						element.style.display = "block";
					}
					if (element.id.indexOf("facetLabel_") == 0) {
						$(element).parent().attr("class", "outline");
					}
				}
			}

			if(execute) {
				this.doSearchFilter();
				this.selectedFacetLimitsArray = [];
			}*/
        },

        updateContextProperties: function(contextId, properties) {
            //Set the properties in context object..
            for (key in properties) {
                wcRenderContext.getRenderContextProperties(contextId)[key] = properties[key];
            }
        },

        toggleView: function(data) {

            console.error("deprecated: do not call this function");
            /*
			var pageView = data["pageView"];
			setCurrentId(data["linkId"]);
			if(!submitRequest()){
				return;
			}
			cursor_wait();
			//console.debug("pageView = "+pageView+" controller = +searchBasedNavigation_controller");
			wcRenderContext.updateRenderContext('searchBasedNavigation_context', {"pageView": pageView,"resultType":"products", "enableSKUListView":data.enableSKUListView});
			MessageHelper.hideAndClearMessage();*/
        },

        toggleExpand: function(id) {
            var icon = byId("icon_" + id);
            var section_list = byId("section_list_" + id);
            if (icon.className == "arrow") {
                icon.className = "arrow arrow_collapsed";
                $(section_list).attr("aria-expanded", "false");
                section_list.style.display = "none";
            } else {
                icon.className = "arrow";
                $(section_list).attr("aria-expanded", "true");
                section_list.style.display = "block";
            }
        },

        sortResults: function(orderBy) {
            console.error("should not be calling this");
        },

        swatchImageClicked: function(id) {
            // This is a workaround for IE's bug for non-clickable label images.
            var e = byId(id);
            if (!e.checked) {
                e.click();
            }
        },

        clone: function(masterObj) {
            console.error("should not be calling this");
        }
    };
}
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 *  Video display widget
 */	

window.onload=function() {   
	var video = document.getElementById("videoScreen");
	if (video) {
		if(video.canPlayType && (video.canPlayType('video/mp4') || video.canPlayType('video/ogg'))) {
			
			function startVideo() {
				this.removeEventListener('play', startVideo, false);
				document.getElementById('promotionTitle').style.display = 'none';
			}
			
			function endVideo() {
				this.removeEventListener('ended', endVideo, false);
				document.getElementById('videoScreen').style.display = 'none';
				document.getElementById('videoFinished').style.display = 'block';
			}
			
			if (!video.addEventListener) {
				video.attachEvent('play', startVideo, false);
				video.attachEvent('ended', endVideo, false);
			}
			else {
				video.addEventListener('play', startVideo, false);
				video.addEventListener('ended', endVideo, false);
			}
		}
		else {
			document.getElementById('promotionTitle').style.display = 'none';
		}
	}
};//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

var FindByCSRUtilities = function(){


    this.showHide = function(nodeId, hiddenClassName, activeClassName){
        $('#'+nodeId).toggleClass(hiddenClassName);
        $('#'+nodeId).toggleClass(activeClassName);
    };

    this.changeDropDownArrow = function(nodeId, arrowClass){
        $('#'+nodeId).toggleClass(arrowClass);
    };


    this.toggleSelection = function(nodeCSS,nodeId,parentNode,cssClassName){
        // Get list of all active nodes with cssClass = nodeCSS under parentNode.
        var activeNodes = $('.'+cssClassName, "#"+parentNode);

        // Toggle the css class for the node with id = nodeId
        $('#'+nodeId,  "#"+parentNode).toggleClass(cssClassName);

        // Remove the css class for all the active nodes.
        activeNodes.removeClass(cssClassName);
    };

    this.handleErrorScenario = function(){
        var errorMessageObj = $("#errorMessageFindOrders");
        var errorSectionObj = $("#errorMessage_sectionFindOrders");
        if(errorMessageObj.length){
            var errorMessage = errorMessageObj.val();

            if(errorMessage != null && errorMessage != undefined && errorSectionObj != null){
                 $(errorSectionObj).css('display', 'block');
                 $(errorSectionObj).css('color', '#CA4200');
                 // TODO - set focus to error div..for accessibility...
                 $(errorSectionObj).text(errorMessage);
            }
        } else {

             $(errorSectionObj).css('display', 'none');
        }
    };

    this.cancelEvent =  function(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        if (e.preventDefault) {
            e.preventDefault();
        }
        e.cancelBubble = true;
        e.cancel = true;
        e.returnValue = false;
    };

    this.closeActionButtons = function(nodeCSS,parentNode,cssClassName,hiddenClassName,activeClassName){
        $('.'+nodeCSS, "#"+parentNode).removeClass(cssClassName);
    };

    this.resetActionButtonStyle = function(nodeCSS,parentNode,hiddenClassName,activeClassName){
        $('.'+nodeCSS, "#"+parentNode).addClass(hiddenClassName);
        $('.'+nodeCSS, "#"+parentNode).removeClass(activeClassName);
    };

    this.toggleCSSClass = function(nodeCSS,nodeId,parentNode,hiddenClassName,activeClassName){
        // Get the list of current nodes
        var activeNodes = $('.'+activeClassName, "#"+parentNode);

        // For the clicked node, toggle the CSS Class. If hidden then display / If displayed then hide.
        $('#'+nodeId, "#"+parentNode).toggleClass(hiddenClassName);
        $('#'+nodeId, "#"+parentNode).toggleClass(activeClassName);

        // For all activeNodes, remove the activeCSS and add the hiddenCSS
        activeNodes.removeClass(activeClassName);
        activeNodes.addClass(hiddenClassName);
    };


    this.setUserInSession = function(userId, selectedUser,landingURL){

        var renderContext = wcRenderContext.getRenderContextProperties('findOrdersSearchResultsContextCSR');
        if(selectedUser != '' && selectedUser != null) {
            renderContext["selectedUser"] = escapeXml(selectedUser, true);
        }
        if(landingURL != '' && landingURL != null){
            renderContext["landingURL"] = landingURL;
        }

    // If we are setting a forUser in session here, it has to be CSR role. Save this info in context.
        // Once user is successfully set, we will set this info in cookie.
        renderContext["WC_OnBehalf_Role_"] = "CSR";

        var params = [];
        params.runAsUserId = userId;
        params.storeId = WCParamJS.storeId;
        wcService.invoke("AjaxRunAsUserSetInSessionCSR", params);
    };

    this.onUserSetInSession = function(){
        var renderContext = wcRenderContext.getRenderContextProperties('findOrdersSearchResultsContextCSR');
        var selectedUser = renderContext["selectedUser"];
        if(selectedUser != '' && selectedUser != null){
            //write the cookie.
            setCookie("WC_BuyOnBehalf_"+WCParamJS.storeId, escapeXml(selectedUser, true), {path:'/', domain:cookieDomain});
        }
        var onBehalfRole = renderContext["WC_OnBehalf_Role_"];
        if(onBehalfRole != '' && onBehalfRole != null){
            //write the cookie.
            setCookie("WC_OnBehalf_Role_"+WCParamJS.storeId, onBehalfRole, {path:'/', domain:cookieDomain});
        }
    };



    this.enableDisableUserAccount = function(userId, status,logonId){

        //Save it in context
        var context = wcRenderContext.getRenderContextProperties("UserRegistrationAdminUpdateStatusContextCSR");
        context["userId"] = userId;

        // If userStatus is already available in context, then use it.
        // This means, the status is updated by making an Ajax call after the page is loaded and status is updated.
        var updatedStatus = context[userId+"_updatedStatus"];
        if(updatedStatus != null){
            if(updatedStatus == '0'){
                status = '1';
            } else {
                status = '0';
            }
        }
        context[userId+"_userStatus"] = status;
        // Invoke service
        wcService.invoke("AjaxRESTUserRegistrationAdminUpdateStatusCSR", {'userId' : userId, 'userStatus':status, 'logonId' : logonId});
    };

    this.onEnableDisableUserStatusAccount = function(serviceResponse){
        var message = Utils.getLocalizationMessage("CUSTOMER_ACCOUNT_ENABLE_SUCCESS");
        if(serviceResponse.userStatus == '0'){
            message = Utils.getLocalizationMessage("CUSTOMER_ACCOUNT_DISABLE_SUCCESS");
        }
        MessageHelper.displayStatusMessage(message);
        onBehalfUtilitiesJS.updateUIAndRenderContext(serviceResponse,"UserRegistrationAdminUpdateStatusContextCSR");
    };



};


$(document).ready(function() {
    findbyCSRJS = new FindByCSRUtilities();

});


/**
 * Declares a new render context for find orders  result list - To display orders based on search criteria.
 */
wcRenderContext.declare("findOrdersSearchResultsContextCSR",[],{'isPaginatedResults':'false'});


//Declare context and service for updating the status of user.
wcRenderContext.declare("UserRegistrationAdminUpdateStatusContextCSR",[],{});
wcService.declare({
    id: "AjaxRESTUserRegistrationAdminUpdateStatusCSR",
    actionId: "AjaxRESTUserRegistrationAdminUpdateStatusCSR",
    url: getAbsoluteURL() +  "AjaxRESTUserRegistrationAdminUpdate",
    formId: ""

     /**
      *  This method refreshes the panel
      *  @param (object) serviceResponse The service response object, which is the
      *  JSON object returned by the service invocation.
      */
    ,successHandler: function(serviceResponse) {
        findbyCSRJS.onEnableDisableUserStatusAccount(serviceResponse);
        cursor_clear();
    }

    /**
    * display an error message.
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation.
    */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
            if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        }
    }

});


// Service to start on-behalf user session.
wcService.declare({
    id: "AjaxRunAsUserSetInSessionCSR",
    actionId: "AjaxRunAsUserSetInSessionCSR",
    url: getAbsoluteURL() + "AjaxRunAsUserSetInSession",
    formId: ""

    /**
     * Clear messages on the page.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
     */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        //Use this CSR_SUCCESS_ACCOUNT_ACCESS
        MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("CSR_SUCCESS_CUSTOMER_ACCOUNT_ACCESS"));

        findbyCSRJS.onUserSetInSession();
        setDeleteCartCookie(); // Mini Cart cookie should be refreshed to display shoppers cart details...
        var landingURL = wcRenderContext.getRenderContextProperties('findOrdersSearchResultsContextCSR')["landingURL"];
        window.location.href = landingURL; // if landingURL is null, it reloads same page. so don't check for != ''
    }

    /**
     * Displays an error message on the page if the request failed.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
            if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        }
        cursor_clear();
    }
});


;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

var FindOrders = function(){

    this.searchListData = {
                            "progressBarId":"FindOrdersList_form_botton_1", "formId":"FindOrders_searchForm",
                            "searchButtonId":"FindOrdersList_form_botton_1", "clearButtonId":"FindOrdersList_form_botton_2",
                             "searchOptionLabel" : "searchOptionLabel"
                          },


     /**
        Setup events for Search and Clear Results button in Find Orders Page
    */
    this.setUpEvents = function(){

        var scope = this;
        var target = document.getElementById(this.searchListData.searchButtonId);
        if(target != null) {
            $(target).on("click",function(event){
                scope.doSearch();
            });
        }

        target = $("#" +this.searchListData.clearButtonId);
        if(target != null) {
            $(target).on("click",function(event){
                scope.clearFilter();
            });
        }

    };


    this.clearFilter = function(){

        this.clearSearchResults();

        // Remove search criteria..
        $('#FindOrders_searchForm input[id ^= "findOrders_"]').each(function(i, inputElement){
            inputElement.value = null;
        });

        //Remove search criteria from select menu
        $('#FindOrders_searchForm select[id ^= "findOrders_"]').each(function(j, inputElement){
            var jqueryObject = $('#' + inputElement.id);
            if(jqueryObject.length){
                jqueryObject.val('');
                jqueryObject.Select("refresh_noResizeButton");
            }

            if(inputElement.id === "findOrders_Form_Input_state") {
                $("#" + inputElement.id).replaceWith('<input type="text" id="findOrders_Form_Input_state" name="state" />');
            }
        });

        //Remove input in date pickers
        $('#datepickerFrom').val("");
        $('#datepickerTo').val("");
    };

    this.doSearch = function(){
        this.clearSearchResults();

        //Do we have any search criteria to search ?
        var doSearch = false;
        $('#'+this.searchListData.formId+' input[id ^= "findOrders_"]').each(function(i, inputElement){
                 var value = inputElement.value;
                 if(value != null && value != ''){
                     doSearch = true;
                 }
             });


        if(!doSearch){
            $('#'+this.searchListData.formId+' select[id ^= "findOrders_"]').each(function(j, inputElement){
                    var jqueryObject = $('#' + inputElement.id);
                    var value = jqueryObject.val();
                    if(value != '' ){
                        doSearch = true;
                    }
                 });
        }


        if(!doSearch) {
        	MessageHelper.formErrorHandleClient(this.searchListData.searchButtonId, Utils.getLocalizationMessage("CSR_NO_SEARCH_CRITERIA"));
            return false;
        }


        var renderContextProperties = wcRenderContext.getRenderContextProperties('findOrdersSearchResultsContext');
        renderContextProperties["searchInitialized"] = "true";

        setCurrentId(this.searchListData.progressBarId);
        if(!submitRequest()){
            return;
        }

        cursor_wait();
        var params = {};
        // code level formatting can be taken care or in js. Based on server REST need, include formatting here.
        //this.formatDate();
        $("#findOrdersRefreshArea").refreshWidget("updateFormId", this.searchListData.formId);
        wcRenderContext.updateRenderContext("findOrdersSearchResultsContext", params);

    };



    this.toggleOrderSummarySection = function(orderId){
        findbyCSRJS.showHide('orderDetailsExpandedContent_'+orderId, 'collapsed', 'expanded');
        findbyCSRJS.changeDropDownArrow('dropDownArrow_'+orderId,'expanded');
        return true;
    };

    this.handleActionDropDown = function(event,memberId){
        findbyCSRJS.cancelEvent(event);
        findbyCSRJS.toggleSelection('actionDropdown','actionDropdown_'+memberId, 'findOrdersSearchResults', 'active');
        findbyCSRJS.toggleCSSClass('actionButton','actionButton7_'+memberId,'findOrdersSearchResults','actionDropdownAnchorHide','actionDropdownAnchorDisplay');
        return false;
    }

    this.clearSearchResults = function(){
        // Remove search results
        if($("#findOrdesResultList_table").length){
            $("#findOrdesResultList_table").css("display","none");
        }
    };






    this.accessOrderDetails = function(userId, selectedUser, landingURL)
    {


        var renderContextProperties = wcRenderContext.getRenderContextProperties('findOrdersSearchResultsContext');
        // First need to set user in sesison before accessing orderDetails page...

        // in case of order details display, landing URL will be different. So set that here before calling setUserInSession command.
        // in case of guest orders, landingURL will be coming null and it will pass null as well..
        if(landingURL != '' && landingURL != null){
            renderContextProperties["landingURL"] = landingURL;
        }
        // currently landingUrl is registered customers account link...if it is guest user, landing url will be differnt..
        findbyCSRJS.setUserInSession(userId,selectedUser,landingURL);

    };


    this.lockUnlockOrder = function(orderId, isLocked, takeOverLock){

        //Save it in context
        var context = wcRenderContext.getRenderContextProperties("OrderLockUnlockContext");
        context["orderId"] = orderId;
        var takeOverLockStatus = context[orderId+"_takeOverLock"];
        if(takeOverLockStatus != null){
            //if context has already  saved data then pick up from conetxt
            takeOverLock = takeOverLockStatus;
        }

        if(takeOverLock == 'true')
        {
            //take over lock first and then call unlock order
            wcService.invoke("AjaxRESTTakeOverlock", {'orderId' : orderId, 'filterOption' : "All", 'takeOverLock' : 'Y',  'storeId': WCParamJS.storeId, 'langId':  WCParamJS.langId});

        }
        else
        {
            // this is required to set value in context back when CSR decides to unlock again..
            var lockStatus = context[orderId+"_isLocked"];
            if(lockStatus != null){
                //if context has already  saved data then pick up from conetxt
                    isLocked = lockStatus;
            }
            // Invoke service : if order is already locked, call unlock cart to unlock the same else lock it
            if(isLocked=='true')
            {
                //unlock order
                wcService.invoke("AjaxRESTOrderUnlock", {'orderId' : orderId, 'filterOption' : "All", 'isLocked':isLocked, 'storeId': WCParamJS.storeId, 'langId':  WCParamJS.langId});

            }else
            {
                //lock order...
                wcService.invoke("AjaxRESTOrderLock", {'orderId' : orderId, 'filterOption' : "All", 'isLocked':isLocked, 'storeId': WCParamJS.storeId, 'langId':  WCParamJS.langId});

            }
        }


    };



    this.onlockUnlockOrder = function(serviceResponse){

        var message = Utils.getLocalizationMessage("SUCCESS_ORDER_LOCK");
        var lockStatusText = Utils.getLocalizationMessage('UNLOCK_CUSTOMER_ORDER_CSR');
        if(serviceResponse.isLocked[0] == 'true'){
            message = Utils.getLocalizationMessage("SUCCESS_ORDER_UNLOCK");
            lockStatusText = Utils.getLocalizationMessage('LOCK_CUSTOMER_ORDER_CSR');
        }
        MessageHelper.displayStatusMessage(message);

        var renderContext = wcRenderContext.getRenderContextProperties("OrderLockUnlockContext"); //this should be orderlock related context
        var orderId = renderContext["orderId"];  // orderid
        var lockStatus = renderContext[orderId+"_isLocked"];

        // Update widget text...
        $("#orderLocked_"+orderId).html(lockStatusText);

        if($("#minishopcart_lock_"+orderId) != null){
            var node = $("#minishopcart_lock_"+orderId);
            if(renderContext[orderId+"_isLocked"] == "true")
            {
                 $(node).attr("class", "");
            }
            else
            {
                $(node).attr("class", "nodisplay");
            }
        }
    };

    this.displayCSROrderSummaryPage = function(orderId){
        document.location.href = "CSROrderSummaryView"+"?"+getCommonParametersQueryString()+"&orderId="+orderId;
    };
};


$(document).ready(function() {
    findOrdersJS = new FindOrders();
    findOrdersJS.setUpEvents();

});

function declareFindOrdersRefreshArea() {
    // ============================================
    // div: findOrdersRefreshArea refresh area
    // eclares a new refresh controller for the Find Orders List
    var myWidgetObj = $("#findOrdersRefreshArea");

    /**
     * Declares a new render context for find orders  result list - To display orders based on search criteria.
     */
    wcRenderContext.declare("findOrdersSearchResultsContext", ["findOrdersRefreshArea"], {'searchInitialized':'false', 'isPaginatedResults':'false'},"");

    var myRCProperties = wcRenderContext.getRenderContextProperties("findOrdersSearchResultsContext");
    var baseURL = getAbsoluteURL()+'FindOrdersResultListViewV2';

    var renderContextChangedHandler = function() {
        myWidgetObj.refreshWidget("updateUrl", baseURL +"?"+getCommonParametersQueryString());
        myWidgetObj.html("");
        myWidgetObj.refreshWidget("refresh", myRCProperties);
    };

    var postRefreshHandler = function() {
        findbyCSRJS.handleErrorScenario();
        console.debug("Post refresh handler of findOrdersController");
        cursor_clear();
    }

    // initialize widget
    myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});

};

//Declare context and service for updating the status of user.
wcRenderContext.declare("OrderLockUnlockContext",[],{});

wcService.declare({
        id: "AjaxRESTOrderLock",
        actionId: "AjaxRESTOrderLock",
        url:  getAbsoluteURL()+'AjaxRESTOrderLock',
        formId: ""


     /**
      *  This method refreshes the panel
      *  @param (object) serviceResponse The service response object, which is the
      *  JSON object returned by the service invocation.
      */
    ,successHandler: function(serviceResponse) {
        // set context of lock for this orderid as true... as it has been locked..

        var renderContext = wcRenderContext.getRenderContextProperties("OrderLockUnlockContext"); //this should be orderlock related context
        var orderId = renderContext["orderId"];  // orderid
        renderContext[orderId+"_isLocked"] = "true";
        findOrdersJS.onlockUnlockOrder(serviceResponse);
        cursor_clear();
    }

    /**
    * display an error message.
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation.
    */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
            if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        }
    }

});
wcService.declare({

    id: "AjaxRESTOrderUnlock",
    actionId: "AjaxRESTOrderUnlock",
    url:  getAbsoluteURL()+'AjaxRESTOrderUnlock',
    formId: ""


 /**
  *  This method refreshes the panel
  *  @param (object) serviceResponse The service response object, which is the
  *  JSON object returned by the service invocation.
  */
,successHandler: function(serviceResponse) {
    //var lockStatus = context.properties[orderId+"_isLocked"];
    // set context of lock for this orderid as false... as it has been unlocked..
    var renderContext = wcRenderContext.getRenderContextProperties("OrderLockUnlockContext"); //this should be orderlock related context
    var orderId = renderContext["orderId"];  // orderid
    renderContext[orderId+"_isLocked"] = "false";

    findOrdersJS.onlockUnlockOrder(serviceResponse);
    cursor_clear();
}

/**
* display an error message.
* @param (object) serviceResponse The service response object, which is the
* JSON object returned by the service invocation.
*/
,failureHandler: function(serviceResponse) {
    if (serviceResponse.errorMessage) {
        MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
    } else {
        if (serviceResponse.errorMessageKey) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
        }
    }
}

});

wcService.declare({

    id: "AjaxRESTTakeOverlock",
    actionId: "AjaxRESTTakeOverlock",
    url:  getAbsoluteURL()+'/AjaxRESTTakeOverlock',
    formId: ""


 /**
  *  This method refreshes the panel
  *  @param (object) serviceResponse The service response object, which is the
  *  JSON object returned by the service invocation.
  */
,successHandler: function(serviceResponse) {
    //findOrdersJS.onlockUnlockOrder(serviceResponse);
    //after successfully taking over lock, it should call unlock
    var context = wcRenderContext.getRenderContextProperties("OrderLockUnlockContext");
    var orderId = context["orderId"];
    context[orderId+"_takeOverLock"] = "false";
    findOrdersJS.lockUnlockOrder(orderId, 'true', 'false');
    cursor_clear();
}

/**
* display an error message.
* @param (object) serviceResponse The service response object, which is the
* JSON object returned by the service invocation.
*/
,failureHandler: function(serviceResponse) {
    if (serviceResponse.errorMessage) {
        MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
    } else {
        if (serviceResponse.errorMessageKey) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
        }
    }
}

});
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------


var OrderComments = function(){

    this.editIconId = "editIcon";
    this.widgetId = ''; //Id of the InlineEditBox widget
    this.mainDivId = 'orderComment'; // enclosing div which contains the InlineEditBox widget.
    this.maxCommentLength = 3000;
    this.commentsLoadStatus = new Object();

    /**
        Called after successfully loading the order comments with ajax call and
        displaying the InLineEdit widget (before displaying edit box/save/cancel buttons)
    */
    this.startUp = function(){

        //Comments are successfully loaded. Make a note of it.
        this.commentsLoadStatus[this.widgetId] = 1;
        //Update order comments section heading.
        var commentsPaginationInfo =$("#orderCommentHeading").val();
        if($("#orderCommentHeadingPaginationInfo").val() !== null){
            commentsPaginationInfo = commentsPaginationInfo +"&nbsp;"+$("#orderCommentHeadingPaginationInfo").val();
        }
        $("#orderCommentToggleLabel").html(commentsPaginationInfo);
    };

    /**
        Called after successfully saving new order comment with ajax call.
    */

    this.resetWidget = function(resetEditText){

        if($("#comment").val() != ''){
            $("#comment").val('');
        }

          // Update orderComments heading with new pagination info.
        var commentsPaginationInfo = $("#orderCommentHeading").val();
        if($("#orderCommentHeadingPaginationInfo").val() !== null){
            commentsPaginationInfo = commentsPaginationInfo +"&nbsp;"+$("#orderCommentHeadingPaginationInfo").val();
        }
        $("#orderCommentToggleLabel").html(commentsPaginationInfo);

        // Display addCommentWidget
         $("#commentWidget").remove();
         $('#addCommentWidget').show();
    }

    this.cancelEdit = function(){
        this.resetWidget();
    };

    this.showHide = function(nodeId, hiddenClassName, activeClassName){
        var node = $('#'+nodeId);
        node.toggleClass(hiddenClassName);
        node.toggleClass(activeClassName);
    };

    this.expandCollapseArea = function(){
        this.showHide('orderCommentContainer_plusImage_link', 'collapsed', 'displayInline');
        this.showHide('orderCommentContainer_minusImage_link', 'collapsed', 'displayInline');
        this.showHide('orderCommentContent', 'collapsed', 'expanded');

        if($("#orderCommentContainer_plusImage_link").hasClass('displayInline')){
            document.getElementById("orderCommentContainer_plusImage_link").focus();
        } else if($("#orderCommentContainer_minusImage_link").hasClass('displayInline')){
            document.getElementById("orderCommentContainer_minusImage_link").focus();
        }
    };

    this.loadComments = function(orderId,widgetId){
        if(this.commentsLoadStatus[widgetId] == 1){
            //Comments already loaded.
            return false;
        }

        // Fetch comments from server by making an Ajax call.
        this.widgetId = widgetId;
        wcRenderContext.updateRenderContext('orderCommentsContext', {"orderId": orderId});
    };

    this.saveComments = function(orderId, widgetId, mode){
        var orderComment = $.trim($("#comment").val());
        if(orderComment === null || orderComment.length === 0){
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('EMPTY_COMMENT'));
            this.resetWidget(false);
            return false;
        }

        if(!MessageHelper.isValidUTF8length(orderComment, this.maxCommentLength)){
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('COMMENT_LENGTH_OUT_OF_RANGE'));
            // Let the comment text be available to CSR. So that they can reduce the char count, instead of keying in again
            this.resetWidget(false);
            return false;
        }

        var params = [];
        params["mode"] = mode;
        params["orderComment"] = orderComment;
        params["orderId"] = orderId;
        cursor_wait();
        wcService.invoke("AjaxRESTAddOrderComment", params);
    };


    this.showHideorderCommentsSliderContent = function(){
        $( document ).ready(function() {
                $('#orderCommentsSlider_content').toggleClass('orderCommentsSlider_content_closed');
                $('#orderCommentsSlider_trigger').toggleClass('orderCommentsSlider_trigger_closed');
        });
    };
}
$(document).ready(function() {
    orderCommentsJS = new OrderComments();
});
    var declareOrderCommentListRefreshArea = function() {
        // ============================================
        // div: orderCommentListRefreshArea refresh area
        // Declares a new refresh controller for the fetching order level comments.
        
        /**
         * Declares a new render context for managing orderComments customers list - To display registered customers based on search criteria.
         */
        wcRenderContext.declare("orderCommentsContext", ["orderCommentListRefreshArea"], {});

        var myWidgetObj = $("#orderCommentListRefreshArea");
        var myRCProperties = wcRenderContext.getRenderContextProperties("orderCommentsContext");
        var baseURL = getAbsoluteURL()+'OrderCommentsListViewV2';

        var renderContextChangedHandler = function() {
            console.debug("renderContextChangedHandler of orderCommentListRefreshArea");
            myWidgetObj.refreshWidget("updateUrl", baseURL+"?"+getCommonParametersQueryString());
            myWidgetObj.attr("role", "region");
            myWidgetObj.attr("tabIndex", 0);
            myWidgetObj.refreshWidget("refresh", myRCProperties);
        };

        wcTopic.subscribe("AjaxRESTAddOrderComment", function() {
            console.debug("modelChangedHandler of orderCommentListRefreshArea");
            myWidgetObj.refreshWidget("updateUrl", baseURL+"?"+getCommonParametersQueryString());
            myWidgetObj.refreshWidget("refresh", myRCProperties);
        });
        
        var postRefreshHandler = function() {
             console.debug("Post refresh handler of orderCommentListRefreshArea");
             cursor_clear();
             orderCommentsJS.startUp();
        };
       
        // initialize widget
        myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
    };



// when user clicks on edit link and the InlineEditor is displayed.

$.fn.inlineEdit = function (replaceWith) {

    $(this).keypress(function (event) {

        if (event.keyCode == 13) { // Checks for the enter key
            $(this).click();
            event.preventDefault();
        }
    });

    $(this).click(function () {

        var self = $(this);
        self.hide();
        self.after(replaceWith);
        $("#comment").focus();
        $("#saveButton").addClass("button_primary saveButton");
        $("#cancelButton").addClass("button_secondary cancelButton");
        $("#comment").addClass("expandingTextArea");

    });
} 





// Service to add Order Level Comments
wcService.declare({
    id: "AjaxRESTAddOrderComment",
    actionId: "AjaxRESTAddOrderComment",
    url: getAbsoluteURL() + "AjaxRESTAddOrderComment"+"?"+getCommonParametersQueryString(),
    formId: ""

    /**
     * Clear messages on the page.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
     */
    ,successHandler: function(serviceResponse) {
        //After saving the comments, reset the widget to initial state.
        //Remove the saved comment from textArea.
        orderCommentsJS.resetWidget(true);
        cursor_clear();
    }

    /**
     * Displays an error message on the page if the request failed.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
            if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        }
        cursor_clear();
    }
});


;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------


var RegisteredCustomers = function(){


    this.searchListData = {
                            "progressBarId":"RegisteredCustomersList_form_botton_1", "formId":"RegisteredCustomersSearch_searchForm",
                            "searchButtonId":"RegisteredCustomersList_form_botton_1", "clearButtonId":"RegisteredCustomersList_form_botton_2"
                          },

    this.csrResetPasswordIds = {
                                "administratorPasswordId":"administratorPassword", "errorDivId":"csr_resetPassword_error", "errorMessageId":"csr_resetPassword_error_msg",
                                "parentNodeId":"csr_reset_password", "resetPasswordButtonId":"csr_resetPassword_button",
                                 "resetPasswordDropDownPanelId":"csr_resetPassword_dropdown_panel"
                               },

    this.csrPasswordEnabled = false,

    /**
        Setup events for Search and Clear Results button in Find Registered Customer Page
    */
    this.setUpEvents = function(){
        var scope = this;
        var target = $("#" +this.searchListData.searchButtonId);
        if(target != null) {
            $(target).on("click",function(event){
                scope.doSearch();
            });
        }

        target = $("#" +this.searchListData.clearButtonId);
        if(target != null) {
            $(target).on("click",function(event){
                scope.clearFilter();
            });
        }

    };

    /**
        Clear search results and search criteria.
    */
    this.clearFilter = function(){

        this.clearSearchResults();
        // Remove search criteria..

        $('#RegisteredCustomersSearch_searchForm input[id ^= "RegisteredCustomersSearch_"]').each(function(j, inputElement){
            inputElement.value = null;
        });

        // Remove search criteria in select menu
        $('#RegisteredCustomersSearch_searchForm select[id ^= "RegisteredCustomersSearch_"]').each(function(j, inputElement){
            var jqueryObject = $("#" + inputElement.id);
            if(jqueryObject != null){
                jqueryObject.val('');
                jqueryObject.Select("refresh_noResizeButton");
            }

            if(inputElement.id === "RegisteredCustomersSearch_Form_Input_state") {
                $("#" + inputElement.id).replaceWith('<input type="text" id="RegisteredCustomersSearch_Form_Input_state" name="state" />');
            }
        });
    };

    /**
        Search for registered customers.
    */
    this.doSearch = function(){
        this.clearSearchResults();

        //Do we have any search criteria to search ?
        var doSearch = false;
        $('#'+ this.searchListData.formId+' input[id ^= "RegisteredCustomersSearch_"]').each(function(i, inputElement){
                 var value = inputElement.value;
                 if(value != null && value != ''){
                     doSearch = true;
                 }
             });


        // Do we have some criteria in drop down boxes - State / Country ?
        if(!doSearch){
            $('#'+this.searchListData.formId+' select[id ^= "RegisteredCustomersSearch_"]').each(function(j, inputElement){
                    var jqueryObject = $('#' + inputElement.id);
                    var value = jqueryObject.val();
                    if(value != '' ){
                        doSearch = true;
                    }
                 });
        }


        if(!doSearch) {
        	MessageHelper.formErrorHandleClient(this.searchListData.searchButtonId, Utils.getLocalizationMessage("CSR_NO_SEARCH_CRITERIA"));
        	return false;
        }

        wcRenderContext.getRenderContextProperties('registeredCustomersSearchResultsContext')["searchInitializedForCustomers"] = "true";

        setCurrentId(this.searchListData.progressBarId);
        if(!submitRequest()){
            return;
        }

        cursor_wait();
        var params = {};
        $("#registeredCustomersRefreshArea").refreshWidget("updateFormId", this.searchListData.formId);
        wcRenderContext.updateRenderContext("registeredCustomersSearchResultsContext", params);
    };


    this.toggleMemberSummarySection = function(memberId){
        this.showHide('memberDetailsExpandedContent_'+memberId, 'collapsed', 'expanded');
        this.changeDropDownArrow('dropDownArrow_'+memberId,'expanded');
        return true;
    };


    this.handleActionDropDown = function(event,memberId, parentNode){
        this.cancelEvent(event);
        this.toggleSelection('actionDropdown','actionDropdown_'+memberId, parentNode, 'active');
        this.toggleCSSClass('actionButton','actionButton7_'+memberId,parentNode,'actionDropdownAnchorHide','actionDropdownAnchorDisplay');
        return false;
    }

    this.showHide = function(nodeId, hiddenClassName, activeClassName){
        $('#'+nodeId).toggleClass(hiddenClassName);
        $('#'+nodeId).toggleClass(activeClassName);
    };

    this.changeDropDownArrow = function(nodeId, arrowClass){
        $('#'+nodeId).toggleClass(arrowClass);
    };

    this.clearSearchResults = function(){
        // Remove search results
        if($("#registeredCustomersList_table") != null){
            $("#registeredCustomersList_table").css("display","none");
        }
    };

    this.toggleSelection = function(nodeCSS,nodeId,parentNode,cssClassName){
        // Get list of all active nodes with cssClass = nodeCSS under parentNode.
        var activeNodes = $('.'+cssClassName, "#"+parentNode);

        // Toggle the css class for the node with id = nodeId
        $('#'+nodeId, "#"+parentNode).toggleClass(cssClassName);

        // Remove the css class for all the active nodes.

        activeNodes.removeClass(cssClassName);
    };

    this.resetPasswordByAdminOnBehalfForBuyers = function(userId){
        wcService.invoke("AjaxRESTMemberPasswordResetByAdminOnBehalfForBuyer", {'logonId':userId, 'URL':"test"});
    };

    this.resetPasswordByAdminOnBehalf = function(userId){
        if(this.csrPasswordEnabled) {
            //  Use this when CSR password is mandatory to reset customer password.
            var administratorPassword = $("#" +this.csrResetPasswordIds.administratorPasswordId).val();
            if(administratorPassword == null || administratorPassword == ''){
                var error = Utils.getLocalizationMessage('CSR_PASSWORD_EMPTY_MESSAGE');
                this.onResetPasswordByAdminError(error);
                return false;
            }
            wcService.invoke("AjaxRESTMemberPasswordResetByAdminOnBehalf", {'administratorPassword': administratorPassword,'logonId':userId, 'URL':"test"});
        } else {
            wcService.invoke("AjaxRESTMemberPasswordResetByAdminOnBehalf", {'logonId':userId,'URL':"test"});
        }
    };

    this.resetPasswordByAdmin = function(userId,administratorPassword){
        wcService.invoke("AjaxRESTMemberPasswordResetByAdmin", {'administratorPassword' : administratorPassword, 'logonId':userId, 'URL':"test"});
    };

    this.handleCSRPasswordReset = function(event){
        this.cancelEvent(event);

        if(this.csrPasswordEnabled) {
            $("#" +this.csrResetPasswordIds.administratorPasswordId).val('');
        }
        // Change the styling of the ResetPassword button
        $('#'+this.csrResetPasswordIds.resetPasswordButtonId ,'#'+this.csrResetPasswordIds.parentNodeId).toggleClass('clicked');

        // Toggle the css class for the dropDown panel with id = nodeId
        $('#'+this.csrResetPasswordIds.resetPasswordDropDownPanelId, '#'+this.csrResetPasswordIds.parentNodeId).toggleClass('active');

        // Hide error div.
        $('#'+this.csrResetPasswordIds.errorDivId, '#'+this.csrResetPasswordIds.parentNodeId).addClass('hidden');

        return false;
    }

    this.hideErrorDiv = function(){
        // Hide error div.
        $('#'+this.csrResetPasswordIds.errorDivId, '#'+ this.csrResetPasswordIds.parentNodeId).addClass('hidden');
    }

    this.onResetPasswordByAdminError = function(errorMessage, errorResponse){
        $("#" +this.csrResetPasswordIds.errorMessageId).html(errorMessage);
        // Display error div.
        $('#'+ this.csrResetPasswordIds.errorDivId, '#'+this.csrResetPasswordIds.parentNodeId).removeClass('hidden');
        // focus to error div.
        $("#" +this.csrResetPasswordIds.errorMessageId).focus();
    }

    this.onResetPasswordByAdminSuccess = function(){
        // Change the styling of the ResetPassword button
        $('#'+this.csrResetPasswordIds.resetPasswordButtonId, '#'+ this.csrResetPasswordIds.parentNodeId).toggleClass('clicked');

        // Toggle the css class for the dropDown panel with id = nodeId
        $('#'+this.csrResetPasswordIds.resetPasswordDropDownPanelId, '#'+ this.csrResetPasswordIds.parentNodeId).toggleClass('active');
        return false;
    }

    this.handleErrorScenario = function(){
            var errorMessageObj = $("#errorMessage");
        var errorSectionObj = $("#errorMessage_section");
        if(errorMessageObj.length){
            var errorMessage = errorMessageObj[0].value;
            if(errorMessage != null && errorMessage.length != "" && errorSectionObj != null){
                 $('#errorMessage_section').css( 'display', 'block');
                 // TODO - set focus to error div..for accessibility...
                 $('#errorMessage_section').text(errorMessage);

            }
        } else {
            $('#errorMessage_section').css( 'display', 'none');
        }
    };

    this.cancelEvent =  function(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        if (e.preventDefault) {
            e.preventDefault();
        }
        e.cancelBubble = true;
        e.cancel = true;
        e.returnValue = false;
    };

    this.closeActionButtons = function(nodeCSS,parentNode,cssClassName,hiddenClassName,activeClassName){
        $('.'+nodeCSS, "#"+ parentNode).removeClass(cssClassName);
    };

    this.resetActionButtonStyle = function(nodeCSS,parentNode,hiddenClassName,activeClassName){
        $('.'+nodeCSS, "#"+parentNode).addClass(hiddenClassName);
        $('.'+nodeCSS, "#"+parentNode).removeClass(activeClassName);
    };

    this.toggleCSSClass = function(nodeCSS,nodeId,parentNode,hiddenClassName,activeClassName){
        // Get the list of current nodes
        var activeNodes = $('.'+activeClassName, "#"+parentNode);

        // For the clicked node, toggle the CSS Class. If hidden then display / If displayed then hide.
        $('#'+nodeId,"#"+ parentNode).toggleClass(hiddenClassName);
        $('#'+nodeId,"#"+ parentNode).toggleClass(activeClassName);

        // For all activeNodes, remove the activeCSS and add the hiddenCSS
        activeNodes.removeClass(activeClassName);
        activeNodes.addClass(hiddenClassName);
    };

    this.createGuestUser = function(landingURL){
        var renderContext = wcRenderContext.getRenderContextProperties('registeredCustomersSearchResultsContext');
        if((landingURL == null || landingURL == '') && !stringStartsWith(document.location.href, "https")){
            renderContext["landingURL"] = '';
        } else {
            // Reload home page
            landingURL = WCParamJS.homePageURL;
            renderContext["landingURL"] = landingURL;
        }

        var params = [];
        wcService.invoke("AjaxRESTCreateGuestUser", params);
    };

    this.createRegisteredUser = function(landingURL){
        if(landingURL != null) {
           wcRenderContext.getRenderContextProperties('registeredCustomersSearchResultsContext')["landingURL"] = landingURL;
        }

        var params = [];
        var form = $("#Register");
        if(form.guestUserId != null && form.guestUserId.value != null){
            // Guest user id exists. Use it while registering new user.
            params.userId = form.guestUserId.value;
        }
        // Do not set errorViewName, since we are making Ajax call. Handle the response back in same page.
        $(form.errorViewName).remove();
        wcService.invoke("AjaxRESTUserRegistrationAdminAdd", params);
    };

    this.setUserInSession = function(userId, selectedUser,landingURL){
        var renderContext = wcRenderContext.getRenderContextProperties('registeredCustomersSearchResultsContext');
        if(selectedUser != '' && selectedUser != null) {
            renderContext["selectedUser"] = escapeXml(selectedUser, true);
        }
        if(landingURL != '' && landingURL != null){
            renderContext["landingURL"] = landingURL;
        }
        // If we are setting a forUser in session here, it has to be CSR role. Save this info in context.
        // Once user is successfully set, we will set this info in cookie.
        renderContext["WC_OnBehalf_Role_"] = "CSR";

        var params = [];
        params.runAsUserId = userId;
        params.storeId = WCParamJS.storeId;
        wcService.invoke("AjaxRunAsUserSetInSession", params);
    };

    this.onUserSetInSession = function(){
        var renderContext = wcRenderContext.getRenderContextProperties('registeredCustomersSearchResultsContext');
        var selectedUser = renderContext["selectedUser"];
        if(selectedUser != '' && selectedUser != null){
            //write the cookie.
            setCookie("WC_BuyOnBehalf_"+WCParamJS.storeId, escapeXml(selectedUser, true), {path:'/', domain:cookieDomain});
        }
        var onBehalfRole = renderContext["WC_OnBehalf_Role_"];
        if(onBehalfRole != '' && onBehalfRole != null){
            //write the cookie.
            setCookie("WC_OnBehalf_Role_"+WCParamJS.storeId, onBehalfRole, {path:'/', domain:cookieDomain});
        }
    };


    this.enableDisableUserAccount = function(userId, status){
        //Save it in context
	var context = wcRenderContext.getRenderContextProperties("UserRegistrationAdminUpdateStatusContext");
        context["userId"] = userId;

        // If userStatus is already available in context, then use it.
        // This means, the status is updated by making an Ajax call after the page is loaded and status is updated.
	var updatedStatus = context[userId+"_updatedStatus"];
        if(updatedStatus != null){
            if(updatedStatus == '0'){
                status = '1';
            } else {
                status = '0';
            }
        }
	context[userId+"_userStatus"] = status;

        // Invoke service
        wcService.invoke("AjaxRESTUserRegistrationAdminUpdateStatus", {'userId' : userId, 'userStatus':status});
    };

    this.onEnableDisableUserStatusAccount = function(serviceResponse){
        var message = Utils.getLocalizationMessage("CUSTOMER_ACCOUNT_ENABLE_SUCCESS");
        if(serviceResponse.userStatus == '0'){
            message = Utils.getLocalizationMessage("CUSTOMER_ACCOUNT_DISABLE_SUCCESS");
        }
        MessageHelper.displayStatusMessage(message);
        onBehalfUtilitiesJS.updateUIAndRenderContext(serviceResponse,"UserRegistrationAdminUpdateStatusContext");

    };

};

$(document).ready(function() {
    registeredCustomersJS = new RegisteredCustomers();
    registeredCustomersJS.setUpEvents();
});

    /**
     * Declares a new render context for registered customers list - To display registered customers based on search criteria.
     */
     if (!wcRenderContext.checkIdDefined("UserRegistrationAdminUpdateStatusContext")) {
    wcRenderContext.declare("registeredCustomersSearchResultsContext", ["registeredCustomersRefreshArea"], {'searchInitializedForCustomers':'false', 'isPaginatedResults':'false'},"");
}
function declareRegisteredCustomersRefreshArea() {
    // ============================================
    // div: registeredCustomersRefreshArea refresh area
    // Declares a new refresh controller for the Registered Customers List
    var myWidgetObj = $("#registeredCustomersRefreshArea");

    var myRCProperties = wcRenderContext.getRenderContextProperties("registeredCustomersSearchResultsContext"),
    baseURL = getAbsoluteURL()+'RegisteredCustomersListViewV2',
    renderContextChangedHandler = function() {
	myWidgetObj.refreshWidget("updateUrl", baseURL +"?"+getCommonParametersQueryString());
        $("#registeredCustomersRefreshArea").html("");
        console.debug(myRCProperties);
        $("#registeredCustomersRefreshArea").refreshWidget("refresh", myRCProperties)
    },

    postRefreshHandler = function() {
        registeredCustomersJS.handleErrorScenario();
        console.debug("Post refresh handler of registeredCustomersController");
        cursor_clear();
    };

    // initialize widget
    myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
}

// Declare context and service for updating the status of user.
 if (!wcRenderContext.checkIdDefined("UserRegistrationAdminUpdateStatusContext")) {
wcRenderContext.declare("UserRegistrationAdminUpdateStatusContext", [], {});
}
wcService.declare({
    id: "AjaxRESTUserRegistrationAdminUpdateStatus",
    actionId: "AjaxRESTUserRegistrationAdminUpdateStatus",
    url: getAbsoluteURL() +  "AjaxRESTUserRegistrationAdminUpdate",
    formId: ""

     /**
      *  This method refreshes the panel
      *  @param (object) serviceResponse The service response object, which is the
      *  JSON object returned by the service invocation.
      */
    ,successHandler: function(serviceResponse) {
        registeredCustomersJS.onEnableDisableUserStatusAccount(serviceResponse);
        cursor_clear();
    }

    /**
    * display an error message.
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation.
    */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
            if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        }
    }

});


// Service to start on-behalf user session.
wcService.declare({
    id: "AjaxRunAsUserSetInSession",
    actionId: "AjaxRunAsUserSetInSession",
    url: getAbsoluteURL() + "AjaxRunAsUserSetInSession",
    formId: ""

    /**
     * Clear messages on the page.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
     */
    ,successHandler: function(serviceResponse) {
		if(typeof callCenterIntegrationJS != 'undefined' && callCenterIntegrationJS != undefined && callCenterIntegrationJS != null){
			var params = {};
			params.status = "success";
			params.serviceResponse = serviceResponse;
			callCenterIntegrationJS.postActionMessage(params, "START_ON_BEHALF_SESSION_RESPONSE");	
		}
        MessageHelper.hideAndClearMessage();
        MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("CSR_SUCCESS_CUSTOMER_ACCOUNT_ACCESS"));
        registeredCustomersJS.onUserSetInSession();
        setDeleteCartCookie(); // Mini Cart cookie should be refreshed to display shoppers cart details...
        var landingURL = wcRenderContext.getRenderContextProperties('registeredCustomersSearchResultsContext')["landingURL"];
        if(landingURL != "-1"){
			window.location.href = landingURL; // if landingURL is null, it reloads same page. so don't check for != ''
		}

    }

    /**
     * Displays an error message on the page if the request failed.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
     */
    ,failureHandler: function(serviceResponse) {
		if(typeof callCenterIntegrationJS != 'undefined' && callCenterIntegrationJS != undefined && callCenterIntegrationJS != null){
			var params = {};
			params.status = "error";
			params.serviceResponse = serviceResponse;
			callCenterIntegrationJS.postActionMessage(params, "START_ON_BEHALF_SESSION_RESPONSE");	
		}
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
            if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        }
        cursor_clear();
    }
});

// Service to Create Guest User and create on-behalf session
wcService.declare({
    id: "AjaxRESTCreateGuestUser",
    actionId: "AjaxRESTCreateGuestUser",
    url: getAbsoluteURL() + "AjaxRESTCreateGuestUser",
    formId: ""

    /**
     * Clear messages on the page.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
     */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("CSR_SUCCESS_NEW_GUEST_USER_CREATION"));
        var guestUserName = Utils.getLocalizationMessage("GUEST");
        // Set this new guest user in session. Start on-behalf session for guest user.
        registeredCustomersJS.setUserInSession(serviceResponse.userId, guestUserName);
    }

    /**
     * Displays an error message on the page if the request failed.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
            if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        }
        cursor_clear();
    }
});


//Declare context for user registration admin add
//wcRenderContext.declare("UserRegistrationAdminAddContext", [], {'administratorPassword':'', 'userId':''});

// Service to register new user and start on-behalf user session.
wcService.declare({
    id: "AjaxRESTUserRegistrationAdminAdd",
    actionId: "AjaxRESTUserRegistrationAdminAdd",
    url: getAbsoluteURL() + "AjaxRESTUserRegistrationAdminAdd",
    formId: "Register"

    /**
     * Clear messages on the page.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
     */
    ,successHandler: function(serviceResponse) {

        MessageHelper.hideAndClearMessage();
        MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("CSR_SUCCESS_NEW_REGISTERED_USER_CREATION"));
        registeredCustomersJS.setUserInSession(serviceResponse.userId, serviceResponse.firstName+ ' ' + serviceResponse.lastName);
        cursor_clear();
    }

    /**
     * Displays an error message on the page if the request failed.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
            if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        }
        cursor_clear();
    }
});;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file provides all the functions and variables to manage Global Login panel.
 */

/* global document, window, $, setCookie, getCookie, cookieDomain, WCParamJS, GlobalLoginJS, Utils, cursor_clear, cursor_wait, submitRequest, wc, processAndSubmitForm, invokeItemAdd, invokeOtherService, isOnPasswordUpdateForm, service */

/**
* Constant key in activePanel
*/
var KEY_ACTIVE = 'active',

    /**
    * Constant key in activePanel
    */
    KEY_SELECTED = 'selected';

GlobalLoginJS = {

    /**
     * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
     * @private
     */
    langId: "-1",

    /**
     * This variable stores the ID of the current store. Its default value is empty.
     * @private
     */
    storeId: "",

    /**
     * This variable stores the ID of the catalog. Its default value is empty.
     * @private
     */
    catalogId: "",

    /**
     * This variable stores the ID of active panels. Its default value is empty.
     * @private
     */
    activePanel: {},

    widgetsLoadedOnPage: [],

    /**
     * This variable stores the ID of active panels. Its default value is empty.
     * @private
     */
    isPanelVisible: true,

    /**
     * True if mouse down event registered, false otherwise (prevents registering
     * event more than once).
     */
    mouseDownConnectHandle: null,
    /**
     * Sets the common parameters for the current page.
     * For example, the language ID, store ID, and catalog ID.
     *
     * @param {Integer} langId The ID of the language that the store currently uses.
     * @param {Integer} storeId The ID of the current store.
     * @param {Integer} catalogId The ID of the catalog.
     */
    setCommonParameters: function (langId, storeId, catalogId) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        cursor_clear();
    },

    hideGLPanel: function (isPanelVisible) {
        this.isPanelVisible = isPanelVisible;
    },

    registerWidget: function (widgetId) {
        this.widgetsLoadedOnPage.push(widgetId);
    },

    InitHTTPSecure: function (widgetId) {
        var href = document.location.href;
        var index = href.lastIndexOf("s", 4);

        if (index != -1) {
            // Open sign in panel if loaded with HTTPS.
            GlobalLoginJS.displayPanel(widgetId);

        } else {
			// Loaded with HTTP. Change it to HTTPS along with appropriate port.
			if (WCParamJS.urlPrefixForHTTP) {
				var newHref = href.substring(WCParamJS.urlPrefixForHTTP.length);
				index = newHref.indexOf("/");
				newHref = WCParamJS.urlPrefixForHTTPS + newHref.substring(index);
			} else {
				var newHref = href.substring(0,4) + "s" + (href.substring(4));
			}
            setCookie("WC_DisplaySignInPanel_" + WCParamJS.storeId, "true", {
                path: '/',
                domain: cookieDomain
            });
            window.location = newHref;
            return;
        }
    },

    displayPanel: function (widgetId) {
        //check if the sign in panel is loaded. if loaded, toggle the dropdown. Else, trigger a refresh.
        var widgetNode = $("#" + widgetId);
        if (widgetNode.length > 0) {
            var panelLoaded = widgetNode.attr("panel-loaded");
            if (panelLoaded) {
                this.togglePanel(widgetNode);
            } else if (typeof isOnPasswordUpdateForm === 'undefined' || isOnPasswordUpdateForm == false) {
                if (!submitRequest()) {
                    return;
                }
                cursor_wait();
                wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"false", "widgetId" : widgetId});
            }
        }
    },

    togglePanel: function (widgetNode) {
        // toggle the current active global login panel.
        if (this.activePanel[KEY_ACTIVE] != null && this.activePanel[KEY_SELECTED] != null) {
            $("#" + this.activePanel[KEY_ACTIVE]).toggleClass("active");
            $("#" + this.activePanel[KEY_SELECTED]).toggleClass("selected");

            //if the current active panel is not the caller
            if (this.activePanel[KEY_ACTIVE] != widgetNode.attr("id")) {
                var toggleControl = widgetNode.attr("data-toggle-control");
                //toggle current widget
                widgetNode.toggleClass("active");
                toggleControl.toggleClass("selected");

                //set the current caller as active
                this.activePanel[KEY_ACTIVE] = widgetNode.attr("id");
                this.activePanel[KEY_SELECTED] = toggleControl;
            } else {
                delete this.activePanel.active;
                delete this.activePanel.selected;
                widgetNode.attr("panel-loaded", false);
                this.unregisterMouseDown();
            }
        } else {
            var toggleControl = widgetNode.attr("data-toggle-control");
            //no panel is active. toggle the current
            widgetNode.toggleClass("active");
            $("#" + toggleControl).toggleClass("selected");

            //set the current caller as active
            this.activePanel[KEY_ACTIVE] = widgetNode.attr("id");
            this.activePanel[KEY_SELECTED] = toggleControl;
            this.registerMouseDown();
        }
    },

    updateGlobalLoginSignInContent: function (widgetId) {
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        var redirectToPageName = getCookie("WC_RedirectToPage_" + WCParamJS.storeId);
        if (redirectToPageName != undefined && redirectToPageName != null) {
            setCookie("WC_RedirectToPage_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
        }
        wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"false", "widgetId": widgetId, "redirectToPageName": redirectToPageName});
    },

    updateGlobalLoginUserDisplay: function (displayName) {
        $("#Header_GlobalLogin_signOutQuickLinkUser").html(displayName);
    },

    updateGlobalLoginContent: function (widgetId) {
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
	    if($('#'+widgetId).length){
	    	wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"true", "widgetId": widgetId});
	    }else{
	    	cursor_clear();
	    }
    },

    updateOrganization: function (formName, widgetId) {
        var orgSetInSessionURL = widgetId + '_' + 'orgSetInSessionURL';
        var orgSetInSessionURLEle = document.getElementById(orgSetInSessionURL);
        if (orgSetInSessionURLEle != null) {
            var href = document.location.href;
            orgSetInSessionURLEle.value = href;
        }
        var form = document.forms[widgetId + '_' + formName];
        if (!submitRequest()) {
            return;
        }
        processAndSubmitForm(form);
    },

    prepareSubmit: function (widgetId) {
        var idPrefix = widgetId + "_";
        if (document.getElementById(idPrefix + "signInDropdown") != null && document.getElementById(idPrefix + "signInDropdown").className.indexOf("active") > -1) {
            document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").setAttribute("class", "errorLabel");
            document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").setAttribute("class", "errorLabel");
            var form_input_field = document.getElementById(idPrefix + "WC_AccountDisplay_FormInput_logonId_In_Logon_1");
            if (form_input_field != null) {
                if (this.isEmpty(form_input_field.value)) {
                    document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").className = document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").className + " active";
                    return false;
                }
            }
            var form_input_field = document.getElementById(idPrefix + "WC_AccountDisplay_FormInput_logonPassword_In_Logon_1");
            if (form_input_field != null) {
                if (this.isEmpty(form_input_field.value)) {
                    document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").className = document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").className + " active";
                    return false;
                }
            }
        }
        return true;
    },

    /**
     * Checks if a string is null or empty.
     * @param (string) str The string to check.
     * @return (boolean) Indicates whether the string is empty.
     */
    isEmpty: function (str) {
        var reWhiteSpace = new RegExp(/^\s+$/);
        if (str == null || str == '' || reWhiteSpace.test(str)) {
            return true;
        }
        return false;
    },

    /**
     * Updates the contract that is available to the current user.
     * @param {string} formName  The name of the form that contains the selected contracts.
     */
    updateContract: function (formName) {
        var form = document.forms[formName];

        /* For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }

        form.submit();
    },

    deleteUserLogonIdCookie: function (contractURL) {
        var userLogonIdCookie = getCookie("WC_LogonUserId_" + WCParamJS.storeId);
        if (userLogonIdCookie != null) {
            setCookie("WC_LogonUserId_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
        }
    },

    changeRememberMeState: function (jspStoreImgDir, target) {
        var targetEle = document.getElementById(target);
        if (targetEle.className.indexOf("active") > -1) {
            targetEle.className = targetEle.className.replace('active', '');
            targetEle.setAttribute("aria-checked", "false");
            targetEle.setAttribute("src", jspStoreImgDir + "images/checkbox.png");
            document.getElementById(target.replace("_img", "")).setAttribute("value", "false");
        } else {
            targetEle.className = targetEle.className + " active";
            targetEle.setAttribute("src", jspStoreImgDir + "images/checkbox_checked.png");
            targetEle.setAttribute("aria-checked", "true");
            document.getElementById(target.replace("_img", "")).setAttribute("value", "true");
        }
    },

    deleteLoginCookies: function () {
        this.deleteUserLogonIdCookie();
        setCookie("WC_BuyOnBehalf_" + WCParamJS.storeId, null, {
            path: '/',
            expires: -1,
            domain: cookieDomain
        });
    },

    /**
     * Submit a global login sign in form
     * @param (object) widgetId The form widgetId id.
     */
    submitGLSignInForm: function (formId, widgetId) {
        service = wcService.getServiceById('globalLoginAjaxLogon');
        service.setFormId(formId);
        var params = {
            widgetId: widgetId,
            isShopperLogin: 'true'
        };

        /*For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke('globalLoginAjaxLogon', params);
    },

    /**
     * After successful login and setting a contract in session, we need to process the action that the shopper
     * was performing before signing in. It will do nothing if shopper was not trying to perform any actions.
     */
    processNextURL: function () {
        var myNextURL = getCookie("WC_nextURL_" + WCParamJS.storeId);
        if (myNextURL != undefined && myNextURL.length > 0) {
            myNextURL = myNextURL.replace(/&amp;/g, "&");
            if (myNextURL.indexOf('AjaxRESTOrderItemAdd') != -1) {
                invokeItemAdd(myNextURL);
            } else {
                invokeOtherService(myNextURL);
            }
        }
    },

    registerMouseDown: function () {
        if (!this.mouseDownConnectHandle) {
            $(document.documentElement).on("mousedown", $.proxy(this.handleMouseDown, this));
            this.mouseDownConnectHandle = true;
        }
    },

    unregisterMouseDown: function () {
        if (this.mouseDownConnectHandle) {
            $(document.documentElement).off("mousedown");
            this.mouseDownConnectHandle = false;
        }
    },

    handleMouseDown: function (evt) {
        if (this.activePanel[KEY_ACTIVE] != null && this.activePanel[KEY_SELECTED] != null) {
            Utils.ifSelectorExists("#" + this.activePanel[KEY_ACTIVE], function(widgetNode) {
                var toggleControl = $("#" + this.activePanel[KEY_SELECTED]);
                var node = evt.target;
                if (node != document.documentElement) {
                    var close = true;
                    while (node && node != document.documentElement) {
                        if (Utils.elementExists("#" + node.id + "_dropdown") && Utils.elementExists("#" + widgetNode.id + "_numEntitledContracts") != null && $("#" + widgetNode.id + "_numEntitledContracts").val() > 0) {
                            var nodePosition = Utils.position(node),
                                windowHeight = window.innerHeight,
                                newHeight;
                            if (windowHeight - nodePosition.y > nodePosition.y) {
                                newHeight = windowHeight - nodePosition.y;
                            } else {
                                newHeight = nodePosition.y;
                            }
                            var dropdownHeight = $("#" + node.id + "_dropdown").get(0).clientHeight;
                            if (dropdownHeight > newHeight) {
                                $("#" + node.id + "_dropdown").css("height", newHeight + "px");
                            }
                        }
                        if (widgetNode.is(node) || toggleControl.is(node) || $(node).hasClass("dijitPopup")) {
                            close = false;
                            break;
                        }
                        node = node.parentNode;
                    }
                    node = null;
                    if (node == null) {
                        widgetNode.children("div").each(function(i, e) {
                            var position = Utils.position(e);
                            if (evt.clientX >= position.x && evt.clientX < position.x + position.w &&
                                evt.clientY >= position.y && evt.clientY < position.y + position.h) {
                                close = false;
                                return false; // breaks
                            }
                        });
                        if (Utils.elementExists("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown") &&
                            $("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown").css("display") != "none" &&
                            Utils.elementExists("#" + widgetNode.id + "_numEntitledContracts") && $("#" + widgetNode.id + "_numEntitledContracts").val() > 0) {
                            var nodePosition = Utils.position("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2"),
                                windowHeight = window.innerHeight,
                                newHeight;
                            if (windowHeight - nodePosition.y > nodePosition.y) {
                                newHeight = windowHeight - nodePosition.y;
                            } else {
                                newHeight = nodePosition.y;
                            }
                            var dropDown = $("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown"),
                                dropdownHeight = dropDown.get(0).clientHeight;
                            if (dropdownHeight > newHeight) {
                                dropDown.css("height", newHeight + "px");
                            }
                        }
                    }
                    if (close) {
                        this.togglePanel(widgetNode);
                    }
                }
            }, this);
        }
    }
};;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

$(document).ready(function () {
	if (typeof isEcommerceStoreJS !== 'undefined') {
		if (isEcommerceStoreJS !== undefined && isEcommerceStoreJS === 'TRUE') {
			window.setTimeout(function () {
				var href = document.location.href,
					index = href.lastIndexOf("s", 4),
                    widgetId = 'Header_GlobalLogin';
				//if (window.matchMedia && window.matchMedia("(max-width: 390px)").matches) {
				//	var widgetId = 'QuickLinks_GlobalLogin';
				//}
				var idPrefix = widgetId + "_";

				//update the visible sign in link 		
				// TODO: test
				if ($("#" + idPrefix + "signInQuickLink").length) {
					if (index != -1) {
						var displaySignInPanel = getCookie("WC_DisplaySignInPanel_" + WCParamJS.storeId);
						if (displaySignInPanel != undefined && displaySignInPanel != null && displaySignInPanel.toString() == "true") {
							GlobalLoginJS.updateGlobalLoginSignInContent(widgetId);
							setCookie("WC_DisplaySignInPanel_" + WCParamJS.storeId, null, {
								expires: -1,
								path: '/',
								domain: cookieDomain
							});
						}
					}
				} else {
					var logonUserCookie = getCookie("WC_LogonUserId_" + WCParamJS.storeId);
					if (logonUserCookie != undefined && logonUserCookie != null && logonUserCookie != "") {
						var logonUserName = logonUserCookie.toString(),
						//update both the sign out links
							widgetIds = GlobalLoginJS.widgetsLoadedOnPage;
						if (Utils.existsAndNotEmpty(widgetIds)) {
							// TODO: test
							widgetIds.forEach(function(registeredWidgetId) {
								var idPrefix = registeredWidgetId + "_";

								if ($("#" + idPrefix + "signOutQuickLink").length) {
									var logonUserName = logonUserCookie.toString();
									$("#" + idPrefix + "signOutQuickLinkUser").html(escapeXml(logonUserName, true));
									
									if (Utils.varExists(GlobalLoginShopOnBehalfJS)) {
										GlobalLoginShopOnBehalfJS.updateSignOutLink(registeredWidgetId);
									}
								}
							});
						}
					}
					var displayContractPanel = getCookie("WC_DisplayContractPanel_" + WCParamJS.storeId);
					if ((displayContractPanel != undefined && displayContractPanel != null && displayContractPanel.toString() == "true") || (logonUserCookie == undefined && logonUserCookie == null)) {
						if (typeof isOnPasswordUpdateForm === 'undefined' || isOnPasswordUpdateForm == false) {
							//Right after user logged in, perform Global Login Ajax call and display Global Login Contract panel.				
							GlobalLoginJS.updateGlobalLoginContent(widgetId);
						} else if (isOnPasswordUpdateForm == true) {
							GlobalLoginJS.updateGlobalLoginUserDisplay("...");
						}
					}
				}
			}, 100);
		}
	}
});;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

function declareSignInRefreshArea(thisRefreshAreaId) {
    // ============================================
    // common render context
    if (!wcRenderContext.checkIdDefined("GlobalLogin_context")) {
        wcRenderContext.declare("GlobalLogin_context", [thisRefreshAreaId], {"displayContract":"false"});
    } else {
        wcRenderContext.addRefreshAreaId("GlobalLogin_context", thisRefreshAreaId);
    }

    // render content changed handler
    var renderContextChangedHandler = function() {
        var renderContext = wcRenderContext.getRenderContextProperties("GlobalLogin_context");
        if(renderContext['widgetId'] == thisRefreshAreaId){
            $("#"+thisRefreshAreaId).refreshWidget("refresh",renderContext);
        }
    };

    // post refresh handler
    var postRefreshHandler = function() {
        cursor_clear();
        $("#" + thisRefreshAreaId).attr("panel-loaded", true);
        //Quick links
        if (window.matchMedia && window.matchMedia("(max-width: 390px)").matches) {
            $("#quickLinksButton").addClass("selected");
            $("#quickLinksMenu").addClass("active");
        }
        //toggle the panel
        GlobalLoginJS.displayPanel(thisRefreshAreaId);
        $("#" + thisRefreshAreaId + "_signInDropdown").focus();
    };

    // initialize widget
    $("#"+thisRefreshAreaId).refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
}

function declareSignOutRefreshArea(thisRefreshAreaId) {
    if (!wcRenderContext.checkIdDefined("GlobalLogin_context")) {
        wcRenderContext.declare("GlobalLogin_context", [thisRefreshAreaId], {"displayContract":"false"});
    } else {
        wcRenderContext.addRefreshAreaId("GlobalLogin_context", thisRefreshAreaId);
    }

    var renderContextChangedHandler = function() {
        var renderContext = wcRenderContext.getRenderContextProperties("GlobalLogin_context");
        if(renderContext['widgetId'] == thisRefreshAreaId){
            $("#"+thisRefreshAreaId).refreshWidget("refresh",renderContext);
        }
    };

    wcTopic.subscribe("RunAsUserSetInSession", function(message) {
        if(message.actionId == 'RunAsUserSetInSession' ){
            if (Utils.varExists(GlobalLoginShopOnBehalfJS)) {
                GlobalLoginShopOnBehalfJS.updateSignOutLink(thisRefreshAreaId);
                GlobalLoginShopOnBehalfJS.initializePanels();
            }
        }
    });

    var postRefreshHandler = function() {
        cursor_clear();
        $("#" + thisRefreshAreaId).attr("panel-loaded", true);

        var idPrefix = thisRefreshAreaId + "_";

        //initialize the caller Id for filtering it from the search results
        if (Utils.varExists(GlobalLoginShopOnBehalfJS)) {
            Utils.ifSelectorExists("#" + idPrefix + "callerId", function(hiddenField) {
                GlobalLoginShopOnBehalfJS.setCallerId(hiddenField.val());
            });
        }

        var userDisplayNameField = $("#" + idPrefix + "userDisplayNameField");
        //get the user name from the display name field.
        if (userDisplayNameField !== null) {
            //clear the old cookie and write it afresh.
            var logonUserCookie = getCookie("WC_LogonUserId_" + WCParamJS.storeId);
            if (logonUserCookie != null) {
                setCookie("WC_LogonUserId_" + WCParamJS.storeId, null, {
                    expires: -1,
                    path: '/',
                    domain: cookieDomain
                });
            }
            setCookie("WC_LogonUserId_" + WCParamJS.storeId, userDisplayNameField.val(), {
                path: '/',
                domain: cookieDomain
            });

            var updateLogonUserCookie = getCookie("WC_LogonUserId_" + WCParamJS.storeId);
            if (updateLogonUserCookie !== 'undefined' && updateLogonUserCookie.length) {
                logonUserName = updateLogonUserCookie.toString();
            } else {
                logonUserName = userDisplayNameField.val();
            }
            var widgetIds = GlobalLoginJS.widgetsLoadedOnPage;
            if (Utils.existsAndNotEmpty(widgetIds)) {
                widgetIds.forEach(function(registeredWidgetId) {
                    idPrefix = registeredWidgetId + "_";
                    Utils.ifSelectorExists("#" + idPrefix + "signOutQuickLink", function(signOutLink) {
                        $("#" + idPrefix + "signOutQuickLinkUser").html(escapeXml(logonUserName, true));

                        if (Utils.varExists(GlobalLoginShopOnBehalfJS)) {
                            GlobalLoginShopOnBehalfJS.updateSignOutLink(registeredWidgetId);
                            GlobalLoginShopOnBehalfJS.initializePanels();
                        }
                    });
                });
            }
        }
		
		var displayContractPanel = getCookie("WC_DisplayContractPanel_" + WCParamJS.storeId);
		var widgetIds = GlobalLoginJS.widgetsLoadedOnPage;
		var tempIdPrefix = "";
        if (Utils.existsAndNotEmpty(widgetIds)) {
            widgetIds.forEach(function(registeredWidgetId) {
				tempIdPrefix = registeredWidgetId + "_";
				Utils.ifSelectorExists("#" + tempIdPrefix + "activeContractIdsArrayLength", function(activeContractsInput) {
					idPrefix = registeredWidgetId + "_";
                });
			});
			var activeContractIdsArrayLength = $("#" + idPrefix + "activeContractIdsArrayLength");
			if (activeContractIdsArrayLength != null && activeContractIdsArrayLength.value > 1 && (displayContractPanel == undefined || displayContractPanel == null)) {
				setCookie("WC_DisplayContractPanel_" + WCParamJS.storeId, "true", {
					path: '/',
					domain: cookieDomain
				});
				window.location = $("#" + idPrefix + "setFirstContractInSessionURLField").val();
				return;
			}
        }
		
        if (displayContractPanel != undefined && displayContractPanel != null && displayContractPanel.toString() == "true") {
            setCookie("WC_DisplayContractPanel_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
        }
        GlobalLoginJS.processNextURL();

        //Display the sign out drop down panel on quick link when view is below 390px.
        if (window.matchMedia("(max-width: 390px)").matches) {
            $("#quickLinksButton").addClass("selected");
            $("#quickLinksMenu").addClass("active");
        }
        $("#" + thisRefreshAreaId + "_loggedInDropdown").focus();
    };

    // initialize widget
    $("#"+thisRefreshAreaId).refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});

}
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by the Global Login widget to handle the services
 * @version 1.10
 */

/* global document, window, $, wc, Utils, WCParamJS, MessageHelper, cursor_clear, getAbsoluteURL */


/**
 * This service allows customer to sign in
 * @constructor
 */
wcService.declare({
    id: "globalLoginAjaxLogon",
    actionId: "globalLoginAjaxLogon",
    url: getAbsoluteURL() + "AjaxLogon",
    formId: "",

    /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    successHandler: function (serviceResponse) {
        cursor_clear();
        var errorMessage = "";
        if (serviceResponse.ErrorCode != null) {
            var errorCode = Number(serviceResponse.ErrorCode);
            switch (errorCode) {
            case 2000:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2000"];
                break;
            case 2010:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2010"];
                break;
            case 2020:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2020"];
                break;
            case 2030:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2030"];
                break;
            case 2110:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2110"];
                break;
            case 2300:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2300"];
                break;
            case 2340:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2340"];
                break;
            case 2400:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2400"];
                break;
            case 2410:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2410"];
                break;
            case 2420:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2420"];
                break;
            case 2430:
                document.location.href = "ResetPasswordForm?storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId + "&errorCode=" + errorCode;
                break;
            case 2170:
                document.location.href = "ChangePassword?storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId + "&errorCode=" + errorCode + "&logonId=" + serviceResponse.logonId;
                break;
            case 2570:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2570"];
                    break;
                case 2440:
                    errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2440"];
                    break;
                case 2450:
                    errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2450"];
                    break;
            }
            if (document.getElementById(serviceResponse.widgetId + "_logonErrorMessage_GL") != null) {
                document.getElementById(serviceResponse.widgetId + "_logonErrorMessage_GL").innerHTML = errorMessage;
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonId_In_Logon_1").setAttribute("aria-invalid", "true");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonId_In_Logon_1").setAttribute("aria-describedby", "logonErrorMessage_GL_alt");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonPassword_In_Logon_1").setAttribute("aria-invalid", "true");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonPassword_In_Logon_1").setAttribute("aria-describedby", "logonErrorMessage_GL_alt");
            }
        } else {

            var url = serviceResponse.URL[0].replace(/&amp;/g, '&'),
                languageId = serviceResponse.langId;
            if (languageId != null && document.getElementById('langSEO' + languageId) != null) { // Need to switch language.

                var browserURL = document.location.href,
                    currentLangSEO = '/' + $('#currentLanguageSEO').val() + '/';

                if (browserURL.indexOf(currentLangSEO) !== -1) {
                    // If it's SEO URL.
                    var preferLangSEO = '/' + $('#langSEO' + languageId).val() + '/';

                    var query = url.substring(url.indexOf('?') + 1, url.length),
                        parameters = Utils.queryToObject(query);
                    if (parameters["URL"] != null) {
                        var redirectURL = parameters["URL"],
                            query2 = redirectURL.substring(redirectURL.indexOf('?') + 1, redirectURL.length),
                            parameters2 = Utils.queryToObject(query2);
                        // No redirect URL
                        if (parameters2["URL"] != null) {
                            var finalRedirectURL = parameters2["URL"];
                            if (finalRedirectURL.indexOf(currentLangSEO) != -1) {
                                // Get the prefer language, and replace with prefer language.
                                finalRedirectURL = finalRedirectURL.replace(currentLangSEO, preferLangSEO);
                                parameters2["URL"] = finalRedirectURL;
                            }
                            query2 = $.param(parameters2);
                            redirectURL = redirectURL.substring(0, redirectURL.indexOf('?')) + '?' + query2;
                        } else {
                            //Current URL is the final redirect URL.
                            redirectURL = redirectURL.toString().replace(currentLangSEO, preferLangSEO);
                        }
                        parameters["URL"] = redirectURL;
                    }
                    query = $.param(parameters);
                    url = url.substring(0, url.indexOf('?')) + '?' + query;

                } else {
                    // Not SEO URL.
                    // Parse the parameter and check whether if have langId parameter.
                    if (url.contains('?')) {
                        var query = url.substring(url.indexOf('?') + 1, url.length),
                            parameters = Utils.queryToObject(query);
                        if (parameters["langId"] != null) {
                            parameters["langId"] = languageId;
                            var query2 = $.param(parameters);
                            url = url.substring(0, url.indexOf('?')) + '?' + query2;
                        } else {
                            url = url + "&langId=" + languageId;
                        }
                    } else {
                        url = url + "?langId=" + languageId;
                    }
                }
            }

            if (serviceResponse["MERGE_CART_FAILED_SHOPCART_THRESHOLD"] == "1") {
                setCookie("MERGE_CART_FAILED_SHOPCART_THRESHOLD", "1", {path: "/", domain: cookieDomain});
            }
            window.location = url;
        }
    },

    /**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    failureHandler: function (serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
            if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        }
        cursor_clear();
    }
});;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/* global KeyCodes */
var SEARCH_CRITERIA_LAST_NAME = "lastName";

GlobalLoginShopOnBehalfJS = {

    //The topic to subscribe to
    USER_SEARCH_CRITERIA_TOPIC: "userSearchCriteriaChanged",

    firstNameSearchType: 3,

    lastNameSearchType: 3,

    updateTimer: null,

    //The timeout value
    timeOut: 1000,

    buyerSearchURL: "",

    loadedPanels: {},

    callerId: "",

    logoutURL: null,

    redirectURL: null,

    buyerData: [],

    /**
     *Sets the id of the Admin who is calling on behalf of buyer
     *@param callerId The id of the buyer admin   
     */
    setCallerId: function (callerId) {
        this.callerId = callerId;
    },

    /**
     *Sets the REST URL to be used for finding buyers
     *@param buyerSearchURL The REST URL   
     */
    setBuyerSearchURL: function (buyerSearchURL) {
        this.buyerSearchURL = buyerSearchURL;
    },

    /**
     *This method registers the panels loaded on the page.
     *@param shopOnBehalfPanelId The panel which shows the shopping on behalf options
     *@param shopForSelfPanelId the corresponding panel which shows the shop for self options.      
     */
    registerShopOnBehalfPanel: function (shopOnBehalfPanelId, shopForSelfPanelId) {
        this.loadedPanels[shopOnBehalfPanelId] = shopForSelfPanelId;
    },

    /**
     *This method checks if the current page is loaded in HTTPs.
     *@return true if the page was in HTTP; false, otherwise.   
     */
    isPageUsingHTTP: function () {
        var protocol = document.location.protocol;
        return (protocol == 'http:');
    },

    /**
     *This function reloads the page using HTTPS. Once the page is loaded, the shop on behalf
     *check box will be toggled.   
     */
    initHTTPSecure: function () {
        //reload the page with HTTPS and show the sign in panel
        var newHref = "https://" + document.location.host + document.location.pathname;
        if (Utils.existsAndNotEmpty(document.location.search)) {
            newHref = newHref + document.location.search;
        }
        //set these cookies to process the page once its reloaded.
        setCookie("WC_DisplayContractPanel_" + WCParamJS.storeId, true, {
            path: "/",
            domain: cookieDomain
        });
        setCookie("WC_ToogleOnBehalfPanel_" + WCParamJS.storeId, true, {
            path: "/",
            domain: cookieDomain
        });
        window.location.href = newHref;
        return;
    },

    /**
     *This method initializes the panels that have been registered.
     *It sets up the event listeners on these panels. This method is called
     *when the panels are loaded.              
     */
    initializePanels: function () {
        if (this.loadedPanels) {
            for (var shopOnBehalfPanelId in this.loadedPanels) {
                Utils.ifSelectorExists("#" + shopOnBehalfPanelId, function(shopOnBehalfPanel) {
                    this.initializePanel(shopOnBehalfPanelId, this.loadedPanels[shopOnBehalfPanelId]);
                }, this);
            }
        }

    },

    /**
     *This method initializes a panel. It setups the event listeners on the panel
     *@param shopOnBehalfPanelId The panel which shows the shopping on behalf options
     *@param shopForSelfPanelId the corresponding panel which shows the shop for self options.
     */
    initializePanel: function (shopOnBehalfPanelId, shopForSelfPanelId) {
        var isInitialized = $("#" + shopOnBehalfPanelId).attr("isEventsSetup");
        if (!isInitialized) {
            this.setUpEvents(shopOnBehalfPanelId);
            $("#" + shopOnBehalfPanelId).attr("isEventsSetup", true);

            //check the toggle button if the cookie has been set.
            var toogleOnBehalfPanel = getCookie("WC_ToogleOnBehalfPanel_" + WCParamJS.storeId);
            if (toogleOnBehalfPanel != null && toogleOnBehalfPanel) {
                this.toggleShopOnBehalfPanel(shopOnBehalfPanelId + "_shopOnBehalfCheckBox", shopForSelfPanelId, shopOnBehalfPanelId);

                //delete the cookie.
                setCookie("WC_ToogleOnBehalfPanel_" + WCParamJS.storeId, null, {
                    path: "/",
                    expires: -1
                });
            }
        }
        // TODO: test
        var callerId = "";
        Utils.ifSelectorExists("#" + shopOnBehalfPanelId + "_callerId", function(callerIdNode) {
            callerId = callerIdNode.html();
        });
        this.setCallerId(callerId);
    },

    /**
     * This method toggles the shop on behalf panel. If the page is loaded in HTTP,
     * this method reloads the page with HTTPs.
     *       
     * @param target The check box node
     * @param shopForSelfSectionId The ID of the panel which shows the shop for self options
     * @param shopOnBehalfOfSectionId The ID of the panel which shows the shop on behalf options          
     */
    toggleShopOnBehalfPanel: function (target, shopForSelfSectionId, shopOnBehalfOfSectionId) {
        if (this.isPageUsingHTTP()) {
            this.initHTTPSecure();
        } else {
            var $target = $("#" + target);
            if($target.length === 0) return;

            var targetSrc = $target.attr("src");
            if ($target.hasClass("uncheckedCheckBox")) {
                //shop on behalf is unchecked. Check it.
                $target.attr("src", targetSrc.replace("checkbox", "checkbox_checked"))
                    .removeClass("uncheckedCheckBox")
                    .addClass("checkedCheckBox");
                
                //show shop on behalf options.
                $("#" + shopForSelfSectionId).css('display', 'none');
                $("#" + shopOnBehalfOfSectionId).css('display', 'block');
            } else {
                //shop on behalf is checked. Uncheck it.
                $target.attr("src", targetSrc.replace("checkbox_checked", "checkbox"))
                    .removeClass("checkedCheckBox")
                    .addClass("uncheckedCheckBox");
                
                //show show for self options.
                $("#" + shopOnBehalfOfSectionId).css('display', 'none');
                $("#" + shopForSelfSectionId).css('display', 'block');
            }
        }
    },

    /**
     * Sets up events for the user search text box.
     * @param shopOnBehalfOfSectionId The shop on behalf panel Id
     */
    setUpEvents: function (shopOnBehalfOfSectionId) {
        var eventName = 'keyup',
            scope = this;
        $(document).ready(function () {
            var textBox = shopOnBehalfOfSectionId + "_buyerUserName",
                searchErrorLabel = shopOnBehalfOfSectionId + "_errorLabel";
            console.debug("Setting up  on " + eventName + " event for DOM element = " + textBox + ". ", "Topic = " + scope.USER_SEARCH_CRITERIA_TOPIC);
            Utils.ifSelectorExists("#" + textBox, function(textBoxObj) {
                wcTopic.subscribe(scope.USER_SEARCH_CRITERIA_TOPIC, function (data) {
                    //read the search input text and clear the timer.
                    data["buyerSearchInput"] = textBoxObj.val();
                    console.debug("Clearing previous timers and starting a new one. Search results will updated after " + scope.timeOut + " milliSeconds.", data);
                    clearTimeout(scope.updateTimer);
                    scope.updateTimer = setTimeout(function() {
                        scope.updateSearchResults(data);
                    }, scope.timeOut);
                });
                
                textBoxObj.on(eventName, function (event) {
                    //get the text box value and publish the data
                    var data = {
                        "buyerSearchInput": textBoxObj.val(),
                        "data-parent": textBoxObj.attr("data-parent"),
                        "originator": textBoxObj.attr("id"),
                        'searchErrorLabel': searchErrorLabel
                    };
                    console.debug("publishing ", data);
                    if (event.keyCode === KeyCodes.TAB) {
                        return;
                    } 
                    wcTopic.publish(scope.USER_SEARCH_CRITERIA_TOPIC, data);
                });
            });
        });
    },

    /**
     *This method processes the search criteria input by the user and triggers a search.
     *@param searchCriteria The raw search criteria input
     */
    updateSearchResults: function (searchCriteria) {
        console.debug("User input : ", searchCriteria.buyerSearchInput);
        //break down the search input into first name and last name.
        if (searchCriteria.buyerSearchInput !== 'undefined') {
            var searchInput = new String(searchCriteria.buyerSearchInput),
                lastName = searchInput;
            searchCriteria[SEARCH_CRITERIA_LAST_NAME] = lastName;

            this.performSearch(searchCriteria);
        }
    },

    /**
     *This method performs the buyer user search based on the search criteria specified.
     *@searchCriteria The search criteria   
     */
    performSearch: function (searchCriteria) {
        var renderContextProperties = wcRenderContext.getRenderContextProperties('GlobalLoginShopOnBehalf_context');
        var lastName = searchCriteria[SEARCH_CRITERIA_LAST_NAME];
        var previousLastName = renderContextProperties["previousLastName"];
        //search only when the previous first name or last name dont match the current
        if (lastName != previousLastName && lastName !== '') {
            //save the current search criteria as previous in the render context.
            renderContextProperties['previousLastName'] = lastName;

            $("#" + searchCriteria['originator'] + "Error").css("display", "none");
            
            setCurrentId(searchCriteria['originator']);

            //perform the search
            if (!submitRequest()) {
                return;
            }
            cursor_wait();

            //The REST service uses a GET.
            $.ajax({
                url: GlobalLoginShopOnBehalfJS.buyerSearchURL,
                dataType: "json",
                data: {
                    'lastName': lastName,
                    'lastNameSearchType': GlobalLoginShopOnBehalfJS.lastNameSearchType
                },
                headers: {
                    'Content-Type': 'text/plain; charset=utf-8'
                },
                context: this,
                success: function (response, textStatus, jqXHR) {
                    cursor_clear();
                    this.displaySearchResults(response, searchCriteria);
                },
                error: function(jqXHR, textStatus, err) {
                    cursor_clear();
                    err['errorCode'] = 'GENERICERR_MAINTEXT';
                    this.handleError(err, searchCriteria);
                }
            });
        } else {
            console.debug('input has not changed');
        }
    },

    /**
     *This method displays the user search results.
     *@param searchResults The result set 
     *@param searchCriteria The search criteria used for search.
     */
    displaySearchResults: function (searchResults, searchCriteria) {
        console.debug('Search results :', searchResults);
        var scope = this,
            $errorLabel = $("#" + searchCriteria.searchErrorLabel);
        //set up the buyer data for the search results drop down.
        var dropdownData = [],
            lastNameFirst = Utils.arrContains(['ja-jp', 'ko-kr', 'zh-cn', 'zh-tw'], Utils.getLocale());
        if (searchResults != null && Utils.existsAndNotEmpty(searchResults.userDataBeans)) {
            $errorLabel.removeClass("active");
            for (var i = 0; i < searchResults.userDataBeans.length; i++) {
                var userEntry = searchResults.userDataBeans[i];
                userEntry.displayName = "";

                var userFirstName = '',
                    userLastName = '';
                
                if (Utils.notNullOrWhiteSpace(userEntry.firstName)) {
                    userFirstName = lastNameFirst ? " " + userEntry.firstName : userEntry.firstName + " ";
                }
                
                if (Utils.notNullOrWhiteSpace(userEntry.lastName)) {
                    userLastName = userEntry.lastName;
                }
                userEntry.displayName = lastNameFirst ? userLastName + userFirstName : userFirstName + userLastName;
                
                userEntry.fullName = $.trim(userEntry.displayName);

                userEntry.displayName += " (" + userEntry.logonId + ")";
                
                userEntry.displayName = $.trim(userEntry.displayName);

                if(userEntry.userId !== scope.callerId) {
                    dropdownData.push(userEntry.displayName);
                }
            }
            this.buyerData = searchResults.userDataBeans;
        } else {
            $errorLabel.addClass('active');
        }

        //set the buyerData to the buyer user dropdown
        var $autocomplete = $("#" + searchCriteria['originator']);
        $autocomplete.autocomplete({
            "source": dropdownData,
            "select": function (event, ui) {
                        GlobalLoginShopOnBehalfJS.selectUser(event.target, ui.item.value);
                    }
        });
        $autocomplete.autocomplete("search", $autocomplete.val());
    },

    /**
     *This method displays the error when the search fails.
     *@param error Error data
     *@param searchCriteria The original search criteria      
     */
    handleError: function (error, nodeToDisplayError) {
        console.debug('An error occurred while searching for users ', error);
        var errorMessage = null;
        if (error.errorMessage != null) {
            errorMessage = error.errorMessage;
        } else if (error.errorMessageKey != null) {
            errorMessage = Utils.getLocalizationMessage(error.errorMessageKey);
        } else if (error.errorCode != null) {
            errorMessage = Utils.getLocalizationMessage(error.errorCode);
        }
        if (errorMessage == null || errorMessage === "") {
            errorMessage = Utils.getLocalizationMessage('GENERICERR_MAINTEXT');
        }
        // TODO: test
        $("#" + nodeToDisplayError).html(errorMessage)
            .css("display", "block");
    },

    /**
     *This method is invoked when the admin selects the user.
     *This method invokes the RunAsUserSetInSessionService and refreshes the panel to indicate the buyer
     *@param userDropDown The drop down node.
     *@param selectedUserName The selected user display name.
     */
    selectUser: function (userDropDown, selectedUserName) {
        var $searchUsersBox = $("#" + userDropDown.id);
        var selectedUser = $.grep(this.buyerData, function(e){ return e.displayName === selectedUserName; })[0];
        if (selectedUser != null && selectedUser.userId !== '-1') {
            var renderContextProperties = wcRenderContext.getRenderContextProperties('GlobalLoginShopOnBehalf_context');
            renderContextProperties["selectedUser"] = selectedUser;
            renderContextProperties["shopOnBehalfPanelId"] = $searchUsersBox.attr('data-parent');
            renderContextProperties["shopForSelfPanelId"] = this.loadedPanels[$searchUsersBox.attr('data-parent')];

            setCurrentId(userDropDown.id);
            if (!submitRequest()) {
                return;
            }
            cursor_wait();
            var shopOnBehalfATForm = document.forms["shopOnBehalf_AuthTokenInfo"];
            var authToken = shopOnBehalfATForm.shopOnBehalf_AuthToken.value;
            wcService.invoke("RunAsUserSetInSessionService", {
                'runAsUserId': selectedUser.userId,
                'authToken': authToken
            });
        }
    },

    /**
     *This method is invoked when the RunAsUserSetInSessionService is successful.
     *It refreshes the panel
     */
    onUserSetInSession: function () {
        var renderContextProperties = wcRenderContext.getRenderContextProperties('GlobalLoginShopOnBehalf_context');
        var selectedUser = renderContextProperties["selectedUser"];

        //write the cookie.
        setCookie("WC_BuyOnBehalf_" + WCParamJS.storeId, escapeXml(selectedUser.fullName, true), {
            path: '/',
            domain: cookieDomain
        });
        var widgetIds = GlobalLoginJS.widgetsLoadedOnPage;
        if (widgetIds != null && widgetIds.length > 0) {
            for (var i = 0; i < widgetIds.length; i++) {
                this.updateSignOutLink(widgetIds[i]);
            }
        }
        setDeleteCartCookie();
        //instead of refreshing the panel, we refresh the page to my account page to update the my account links.
        setCookie("WC_DisplayContractPanel_" + WCParamJS.storeId, true, {
            path: "/",
            domain: cookieDomain
        });
        document.location.href = "AjaxLogonForm?storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId + "&myAcctMain=1";
    },

    /**
     *This method is invoked when the user chooses an organization.
     *It invokes the OrganizationSetInSessionService service.
     *      
     *@param The organization drop down node
     */
    updateOrganization: function (organizationNode) {
        var organizationDropDown = $("#" + organizationNode.id)[0];
        var organizationSelected = organizationDropDown.value;
        var renderContextProperties = wcRenderContext.getRenderContextProperties('GlobalLoginShopOnBehalf_context');
        renderContextProperties["shopOnBehalfPanelId"] = organizationDropDown['data-parent'];
        renderContextProperties["shopForSelfPanelId"] = this.loadedPanels[organizationDropDown['data-parent']];

        setCurrentId(organizationNode.id);
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrganizationSetInSessionService", {
            'activeOrgId': organizationSelected
        });
    },

    /**
     *This method is invoked when the user chooses a contract.
     *It invokes the ContractSetInSessionService service.  
     *   
     *@param contractNode The contract drop down node.
     */
    updateContract: function (contractNode) {
        var contractDropDown = $("#" + contractNode.id)[0];
        var contractSelected = contractDropDown.value;
        var renderContextProperties = wcRenderContext.getRenderContextProperties('GlobalLoginShopOnBehalf_context');
        renderContextProperties["shopOnBehalfPanelId"] = contractDropDown['data-parent'];
        renderContextProperties["shopForSelfPanelId"] = this.loadedPanels[contractDropDown['data-parent']];

        setCurrentId(contractDropDown.id);
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("ContractSetInSessionService", {
            'contractId': contractSelected
        });
    },

    /**
     *This method clears the user set in session. It restores the session to that of the buyer admin and redirects the user to redirectURL
     */
    clearUserSetInSession: function (link, redirectURL) {
        if (link != null && link !== '') {
            setCurrentId(link.id);
        }
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        this.logoutURL = null;
        this.redirectURL = redirectURL;
        wcService.invoke("RestoreOriginalUserSetInSessionService");
    },

    /**
     * This method clears the user set in the session before logging off the buyer admin.
     */
    clearUserSetInSessionAndLogoff: function (logoutURL) {
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        this.logoutURL = logoutURL;
        this.redirectURL = null;
        wcService.invoke("RestoreOriginalUserSetInSessionService");
    },

    restoreCSRSessionAndRedirect: function (redirectURL) {
        GlobalLoginJS.deleteUserLogonIdCookie();
        GlobalLoginShopOnBehalfJS.deleteBuyerUserNameCookie();
        GlobalLoginShopOnBehalfJS.clearUserSetInSession('', redirectURL);
    },

    /**
     *This method is invoked when the for user session is successfully terminated.
     *This method reloads the current page.         
     */
    onRestoreUserSetInSession: function () {
        //clear the cookie
        setCookie("WC_BuyOnBehalf_" + WCParamJS.storeId, null, {
            path: '/',
            expires: -1,
            domain: cookieDomain
        });
        /* Page is getting reloaded.. Why to update the links now ?
				var widgetIds = GlobalLoginJS.widgetsLoadedOnPage;
                if (widgetIds != null && widgetIds.length > 0){
                	for (var i = 0; i < widgetIds.length; i++) {
                		this.updateSignOutLink(widgetIds[i]);
                	}
                }*/
		setDeleteCartCookie();
		deleteOnBehalfRoleCookie();
		if (this.redirectURL == "-1"){
			// Stay on the same page.
			return;
		} else if (this.logoutURL == null && this.redirectURL == null) {
			//refresh the page, if it's not HTTPS
			if(!stringStartsWith(document.location.href, "https")){
				document.location.reload();
			} else {
				// Reload home page
				document.location.href =  WCParamJS.homePageURL;
			}

		} else if(this.redirectURL != null && this.redirectURL != "-1"){
			document.location.href = this.redirectURL;
		}
		else {
			logout(this.logoutURL);
        }
    },

    /**
     * This method updates the sign out link to display the buyer name.
     * This method is invoked once the buyer's session is established.
     */
    updateSignOutLink: function (widgetId) {
        var idPrefix = widgetId + "_";
        // TODO: test
        Utils.ifSelectorExists("#" + idPrefix + "signOutQuickLinkUser", function(signOutLink) {
            var logonUser = "",
                logonUserCookie = getCookie("WC_LogonUserId_" + WCParamJS.storeId);
            if (typeof logonUserCookie != 'undefined') {
                logonUser = logonUserCookie;
            }
            // TODO: test
            signOutLink.html(escapeXml(logonUser, true));
            var buyerUserName = "",
                buyOnBehalfCookie = getCookie("WC_BuyOnBehalf_" + WCParamJS.storeId);
            if (typeof buyOnBehalfCookie != 'undefined') {
                buyerUserName = escapeXml(buyOnBehalfCookie, true);
            }
            if (buyerUserName !== "") {
                // TODO: test
                signOutLink.append(" (" + buyerUserName + ")");
            }
        });
    },

    deleteBuyerUserNameCookie: function () {
        setCookie("WC_BuyOnBehalf_" + WCParamJS.storeId, null, {
            expires: -1,
            path: '/',
            domain: cookieDomain
        });
        var widgetIds = GlobalLoginJS.widgetsLoadedOnPage;
        if (widgetIds != null && widgetIds.length > 0) {
            for (var i = 0; i < widgetIds.length; i++) {
                this.updateSignOutLink(widgetIds[i]);
            }
        }
    },

    resetBuyerUserNameCookie: function (buyerUserName) {
        setCookie("WC_BuyOnBehalf_" + WCParamJS.storeId, escapeXml(buyerUserName, true), {
            path: '/',
            domain: cookieDomain
        });
        var widgetIds = GlobalLoginJS.widgetsLoadedOnPage;
        if (widgetIds != null && widgetIds.length > 0) {
            for (var i = 0; i < widgetIds.length; i++) {
                this.updateSignOutLink(widgetIds[i]);
            }
        }
    },

    resetDropdown: function (dropDownNode) {
        var $dropDown = $("#" + dropDownNode.id);
        if($dropDown.length) {
            $dropDown.val("");
        }
    },
    
    declareShopOnBehalfPanelRefreshArea: function(divId) {
        // ============================================
        // div: divId refresh area
        // 
        if(typeof divId === "object") {
            divId = divId[0];
        }
        
        var myWidgetObj = $("#"+divId);
        wcRenderContext.addRefreshAreaId("GlobalLoginShopOnBehalf_context", divId);
        var myRCProperties = wcRenderContext.getRenderContextProperties("GlobalLoginShopOnBehalf_context");
        
        /** 
         * Refreshes the Global Login panel.
         * This function is called when a render context event is detected. 
         */
        var renderContextChangedHandler = function () {
            myWidgetObj.refreshWidget("refresh", myRCProperties);
        };
        
        /** 
         * Clears the progress bar
         */
        var postRefreshHandler = function () {
            delete myRCProperties.selectedUser;
            delete myRCProperties.firstName;
            delete myRCProperties.lastName;
            delete myRCProperties.previousFirstName;
            delete myRCProperties.previousLastName;
            delete myRCProperties.showOnBehalfPanel;
            GlobalLoginShopOnBehalfJS.initializePanels();
            cursor_clear();
        }
         
        // initialize widget
        myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
    }

};

/**
 * Declares a new render context for initiating on behalf session
 */
wcRenderContext.declare("GlobalLoginShopOnBehalf_context", [], {'previousLastName': null, 'firstName': null, 'lastName': null});

/**
 *  Service declaration to invoke RunAsUserSetInSession command.
 *  @constructor
 */
wcService.declare({
    id: "RunAsUserSetInSessionService",
    actionId: "RunAsUserSetInSession",
    url: "AjaxRunAsUserSetInSession",
    formId: "",

    /**
     *  This method refreshes the panel 
     *  @param (object) serviceResponse The service response object, which is the
     *  JSON object returned by the service invocation.
     */
    successHandler: function (serviceResponse) {
        GlobalLoginShopOnBehalfJS.onUserSetInSession();
        cursor_clear();
    },

    /**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    failureHandler: function (serviceResponse) {
        var renderContextProperties = wcRenderContext.getRenderContextProperties('GlobalLoginShopOnBehalf_context');
        GlobalLoginShopOnBehalfJS.handleError(serviceResponse, renderContextProperties["shopOnBehalfPanelId"] + "_ErrorField");
        cursor_clear();
    }

});

/**
 *  Service declaration to invoke OrganizationSetInSession command.
 *  @constructor
 */
wcService.declare({
    id: "OrganizationSetInSessionService",
    actionId: "OrganizationSetInSession",
    url: "AjaxOrganizationSetInSession",
    formId: "",

    /**
     *  @param (object) serviceResponse The service response object, which is the
     *  JSON object returned by the service invocation.
     */
    successHandler: function (serviceResponse) {
        console.debug("Organization set in session successfully");
        cursor_clear();
    }

    /**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    ,
    failureHandler: function (serviceResponse) {
        var renderContextProperties = wcRenderContext.getRenderContextProperties('GlobalLoginShopOnBehalf_context');
        GlobalLoginShopOnBehalfJS.handleError(serviceResponse, renderContextProperties["shopOnBehalfPanelId"] + "_ErrorField");
        cursor_clear();
    }

});

/**
 *  Service declaration to invoke the ContractSetInSessionCmd
 *  @constructor
 */
wcService.declare({
    id: "ContractSetInSessionService",
    actionId: "ContractSetInSession",
    url: "AjaxContractSetInSession",
    formId: ""

    /**
     *  This method updates the order table with the 
     *  @param (object) serviceResponse The service response object, which is the
     *  JSON object returned by the service invocation.
     */
    ,
    successHandler: function (serviceResponse) {
        cursor_clear();
    }

    /**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    ,
    failureHandler: function (serviceResponse) {
        var renderContextProperties = wcRenderContext.getRenderContextProperties('GlobalLoginShopOnBehalf_context');
        GlobalLoginShopOnBehalfJS.handleError(serviceResponse, renderContextProperties["shopOnBehalfPanelId"] + "_ErrorField");
        cursor_clear();
    }

});

/**
 *  Service declaration to invoke the ContractSetInSessionCmd
 *  @constructor
 */
wcService.declare({
    id: "RestoreOriginalUserSetInSessionService",
    actionId: "RestoreOriginalUserSetInSessionService",
    url: "AjaxRestoreOriginalUserSetInSession?" + getCommonParametersQueryString(),
    formId: "",

    /**
     *  This method updates the order table with the 
     *  @param (object) serviceResponse The service response object, which is the
     *  JSON object returned by the service invocation.
     */
    successHandler: function (serviceResponse) {
		if(typeof callCenterIntegrationJS != 'undefined' && callCenterIntegrationJS != undefined && callCenterIntegrationJS != null){
			var params = {};
			params.status = "success";
			params.serviceResponse = serviceResponse;
			callCenterIntegrationJS.postActionMessage(params,"TERMINATE_ON_BEHALF_SESSION_RESPONSE");
		}
        GlobalLoginShopOnBehalfJS.onRestoreUserSetInSession();
        cursor_clear();
    }

    /**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    ,
    failureHandler: function (serviceResponse) {
		if(typeof callCenterIntegrationJS != 'undefined' && callCenterIntegrationJS != undefined && callCenterIntegrationJS != null){
			var params = {};
			params.status = "error";
			params.serviceResponse = serviceResponse;
			callCenterIntegrationJS.postActionMessage(params, "TERMINATE_ON_BEHALF_SESSION_RESPONSE");	
		}
        var renderContextProperties = wcRenderContext.getRenderContextProperties('GlobalLoginShopOnBehalf_context');
        GlobalLoginShopOnBehalfJS.handleError(serviceResponse, renderContextProperties["shopOnBehalfPanelId"] + "_ErrorField");
        cursor_clear();
    }

});

;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2012, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This file provides the render context used to display
 * the recommendations from Coremetrics Intelligent Offer. It also
 * contains the zone population function called with the results to
 * display.
 */

/** 
 * @class The IntelligentOfferJS class defines the render context used to display
 * the recommendations from Coremetrics Intelligent Offer.
 */
IntelligentOfferJS = {
	/* The common parameters used in service calls. */
	langId: "-1",
	storeId: "",
	catalogId: "",
	widgetsCurCount: 0,
	widgetsTotalCount: 0,
	
	/**
	 * This function initializes common parameters used in all service calls.
	 * @param {int} langId The language id to use.
	 * @param {int} storeId The store id to use.
	 * @param {int} catalogId The catalog id to use.
	 */
	setCommonParameters:function(langId,storeId,catalogId){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;
	},

	/** 
	 * Declare the controller function for the Intelligent Offer Recommendations e-Marketing Spot refressh area.
	 * @param {array} contains wc site zone id and updateSwatch
	 */
	declareWC_IntelligentOfferESpot_controller: function(args) {
		var WC_zone = args[0];
		var updateSwatch = args[1];
		var contextId = "WC_IntelligentOfferESpot_context_ID_" + WC_zone;
		var containerId = "WC_IntelligentOfferESpot_container_ID_" + WC_zone;
		var myWidgetObj = $("#" + containerId);

		if (!wcRenderContext.checkIdDefined(contextId)) {
			wcRenderContext.declare(contextId, [], {partNumbers: "", zoneId: "", espotTitle: "", updateSwatch: updateSwatch});
		}
		wcRenderContext.addRefreshAreaId(contextId, containerId);
		var myRCProperties = wcRenderContext.getRenderContextProperties(contextId);
		
		// initialize widget
		myWidgetObj.refreshWidget({

			/** 
			 * Refreshes the Intelligent Offer Recommendations e-Marketing Spot area.
			 * This function is called when a render context changed event is detected. 
			 */
			renderContextChangedHandler: function() {
				myWidgetObj.refreshWidget("refresh", myRCProperties);
			},
			
			/** 
			 * Post handling for the Intelligent Offer Recommendations e-Marketing Spot area.
			 * This function is called after a successful refresh.
			 */
			postRefreshHandler: function() {
				cursor_clear();
				// updateSwatch should be set to true if swatches should be selected by default
				if(myRCProperties.updateSwatch === "true"){
					shoppingActionsJS.updateSwatchListView();
				}
				// need to process cm_cr tags
				cX("onload");
			}
		});
		this.widgetsTotalCount++;
	}
};

/**
 *  This function is the zone population function called by Coremetrics Intelligent Offer.
 *  It creates a comma separated list of the partnumbers to display, and then updates
 *  the refresh area that will display the recommendations.
 */
function io_rec_zp(a_product_ids,zone,symbolic,target_id,category,rec_attributes,target_attributes,target_header_txt) {
	if (symbolic !== '_NR_') {
		var n_recs = a_product_ids.length;
		var rec_part_numbers;
		for (var ii=0; ii < n_recs; ii++) {
			if (ii === 0) {
 				rec_part_numbers = a_product_ids[ii];
			} else {
				rec_part_numbers = rec_part_numbers + ',' + a_product_ids[ii];
			}
			
		}
		
		var zoneId = zone.replace(/\s+/g,'');
		wcRenderContext.updateRenderContext('WC_IntelligentOfferESpot_context_ID_' + zoneId, {'partNumbers':rec_part_numbers, 'zoneId': zoneId, 'espotTitle': target_header_txt});
	}
	else{
		var  rec_part_numbers;
		var zoneId = zone.replace(/\s+/g,'');
		target_header_txt = '';
		wcRenderContext.updateRenderContext('WC_IntelligentOfferESpot_context_ID_' + zoneId, {'partNumbers':rec_part_numbers, 'zoneId': zoneId, 'espotTitle': target_header_txt});
	}
};
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This javascript is used by the My Account Navigation widget to control the refresh areas.
 * @version 1.2
 */

/**
 * Declares a new refresh controller for number of order approvals.
 */
var declareNumberOfOrderApprovalsController = function() {
    var myWidgetObj = $("#NumberOfOrderApprovals_Widget");
    
    /** 
	* Refreshes the number of order approvals display if a request is approved/rejected.
	* This function is called when a modelChanged event is detected. 
	*/    	   
	wcTopic.subscribe(["AjaxApproveOrderRequest", "AjaxRejectOrderRequest", "AjaxApproveRequest", "AjaxRejectRequest"], function () {
	    myWidgetObj.refreshWidget("refresh");
	});
    
    myWidgetObj.refreshWidget({
        /** 
        * Refresh number of order approval display to keep it consistent with table
        * This function is called when a render context changed event is detected. 
        */
        renderContextChangedHandler: function() {
            // Do not refresh the count in Left Navigation bar, when the search criteria changes in the main table view.
            // Left Nav displays the count of orders to approve without any filter applied.
            //widget.refresh();
        },

        postRefreshHandler: function() {
            //cursor_clear();

        }
    });
};

/**
 * Declares a new refresh controller for number of buyer approvals.
 */
var declareNumberOfBuyerApprovalsController = function() {
    var myWidgetObj = $("#NumberOfBuyerApprovals_Widget");

    /** 
	* Refreshes the number of buyer approvals display if a request is approved/rejected.
	* This function is called when a modelChanged event is detected. 
	*/    	   
	wcTopic.subscribe(["AjaxApproveBuyerRequest", "AjaxRejectBuyerRequest", "AjaxApproveRequest", "AjaxRejectRequest"], function () {
		myWidgetObj.refreshWidget("refresh");
	});
    
    myWidgetObj.refreshWidget({
        /** 
        * Refresh number of buyer approval display to keep it consistent with table
        * This function is called when a render context changed event is detected. 
        */
        renderContextChangedHandler: function() {
            // Do not refresh the count in Left Navigation bar, when the search criteria changes in the main table view.
            // Left Nav displays the count of orders to approve without any filter applied.
        	//widget.refresh();
        },

        postRefreshHandler: function() {
            //cursor_clear();

        }
    });
};;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 *@fileOverview This javascript file defines all the javascript functions used by order approval widget
 */

	OrderApprovalListJS = {
			
		/** 
		 * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
		 * @private
		 */
		langId: "-1",
		
		/** 
		 * This variable stores the ID of the current store. Its default value is empty.
		 * @private
		 */
		storeId: "",
		
		/** 
		 * This variable stores the ID of the catalog. Its default value is empty.
		 * @private
		 */
		catalogId: "",
		
		/**
		* These variables define approve or reject status in the APRVSTATUS table. 1 for approved or 2 for rejected.
		*/
		cApproveStatus: 1,
		cRejectStatus: 2,
		
		/**
		* These variables refers to Ids of startSubmitDate and endSubmitDate element in OrderApprovalList_ToolBar_UI.jspf.
		*/
		formStartDateId: "",
		formEndDateId: "",
		
		/**
		 * Search tool bar Id
		 */
		toolbarId: "",
		
		/**
		 * Sets the common parameters for the current page. 
		 * For example, the language ID, store ID, and catalog ID.
		 *
		 * @param {Integer} langId The ID of the language that the store currently uses.
		 * @param {Integer} storeId The ID of the current store.
		 * @param {Integer} catalogId The ID of the catalog.
		 */
		setCommonParameters: function(langId,storeId,catalogId,requisitionListId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
		},
		
		/**
		 * Sets the common parameters for the current page. 
		 *
		 * @param {String} formStartDateId The ID of the startDate element.
		 * @param {String} formEndDateId The ID of the endDate element.
		 * @param {String} toolbarId The ID of the tool bar element.
		 */
		setToolbarCommonParameters: function(formStartDateId,formEndDateId, toolbarId){
			this.formStartDateId = formStartDateId;
			this.formEndDateId = formEndDateId;
			this.toolbarId = toolbarId;
		},
		
		/**
		* Approves a order record
		* @param {Long} aprvstatus_id The id of the request to be approved
		*/
		approveOrder: function(aprvstatus_id) {
			service = wcService.getServiceById('AjaxApproveOrderRequest');

			var params = {
                storeId : this.storeId,
                catalogId : this.catalogId,
                langId : this.langId,
                aprv_act : this.cApproveStatus,
                approvalStatusId : aprvstatus_id,
                viewtask : "OrderApprovalView"
            };

			/*For Handling multiple clicks. */
			if(!submitRequest()){
				return;
			}			
			cursor_wait();
			wcService.invoke('AjaxApproveOrderRequest',params);		
		},

		/**
		* Rejects a order record
		* @param {Long} aprvstatus_id The id of the request to be approved
		*/
		rejectOrder: function(aprvstatus_id) {
			service = wcService.getServiceById('AjaxRejectOrderRequest');

			var params = {
			    storeId: this.storeId,
			    catalogId: this.catalogId,
			    langId: this.langId,
			    aprv_act: this.cRejectStatus,
			    approvalStatusId: aprvstatus_id,
			    viewtask: "OrderApprovalView"
			};

			/*For Handling multiple clicks. */
			if(!submitRequest()){
				return;
			}			
			cursor_wait();
			wcService.invoke('AjaxRejectOrderRequest',params);
		},
		
		/**
		* This function is called when user selects a different page from the current page
		* @param (Object) data The object that contains data used by pagination control 
		*/
		showResultsPage:function(data){
			var pageNumber = data[0]['pageNumber'],
                pageSize = data[0]['pageSize'];
			pageNumber = parseInt(pageNumber);
			pageSize = parseInt(pageSize);

			setCurrentId(data[0]["linkId"]);

			if(!submitRequest()){
				return;
			}

			var beginIndex = pageSize * ( pageNumber - 1 );
			cursor_wait();

			wcRenderContext.updateRenderContext('OrderApprovalTable_Context', {"beginIndex": beginIndex});
			MessageHelper.hideAndClearMessage();
		},
		
		
		/**
		 * Clear the context search term value set by search form
		 */
		reset:function(){
			this.updateContext({"beginIndex":"0", "orderId": "", "firstName": "", "lastName":"","startDate":"","endDate":""});
		},
		
		/**
		 * Search for buyer approval requests use the search terms specified in the toolbar search form.
		 * 
		 * @param (String) formId	The id of toolbar search form element.
		 */
		doSearch:function(formId){
			var form = $("#" + formId)[0],
                startDateValue = "",
                endDateValue = "",
                startDateWidgetValue = $("#" + this.formStartDateId + "_datepicker").datepicker("getDate");
			if (Utils.varExists(startDateWidgetValue)){
				startDateValue = startDateWidgetValue.toISOString().replace(/\.\d\d\dZ/, '+0000');
			}
			var endDateWidgetValue = $("#" + this.formEndDateId + "_datepicker").datepicker("getDate");
			if (Utils.varExists(endDateWidgetValue)){
				//add one day to the picked endDate.We pick a date the value for the date object
				//is yyyy-MM-dd 00:00:00(beginning of a day, we need it to be end of the a day)
				endDateWidgetValue = Utils.addDays(endDateWidgetValue, 1);
				//deduct one millisecond from the added date
				endDateWidgetValue = Utils.addMilliseconds(endDateWidgetValue, -1);
				endDateValue = endDateWidgetValue.toISOString().replace(/\.\d\d\dZ/, '+0000');
			}
			this.updateContext({
			    "beginIndex": "0",
			    "orderId": form.orderId.value.replace(/^\s+|\s+$/g, ''),
			    "firstName": form.submitterFirstName.value.replace(/^\s+|\s+$/g, ''),
			    "lastName": form.submitterLastName.value.replace(/^\s+|\s+$/g, ''),
			    "startDate": startDateValue,
			    "endDate": endDateValue
			});
		},
		
		/**
		 * Filter the buyer Approval list by status
		 * 
		 * @param (String) status The id of toolbar search form element.
		 */
		doFilter:function(status){
			this.updateContext({"beginIndex":"0", "approvalStatus": status});
		},
		
		/**
		 * Update the OrderApprovalTable_Context context with given context object.
		 * 
		 * @param (Object)context The context object to update
		 */
		updateContext:function(context){
			this.saveToolbarStatus();
			if(!submitRequest()){
				return;
			}			
			cursor_wait();
			wcRenderContext.updateRenderContext("OrderApprovalTable_Context", context);
			MessageHelper.hideAndClearMessage();
		},
		
		/**
		 * Save the toolbar aria-expanded attribute value
		 */
		saveToolbarStatus:function(){
            Utils.ifSelectorExists("#" + this.toolbarId, function($toolbar) {
                this.toolbarExpanded = $toolbar.attr("aria-expanded");
            }, this);
		},
		
		/**
		 * Restore the toolbar aria-expanded attribute, called by post-refresh handler
		 */
		restoreToolbarStatus:function(){
			if (Utils.varExists(this.toolbarExpanded)){
				$("#" + this.toolbarId).attr("aria-expanded", this.toolbarExpanded);
			}
		}
	};//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This file provides all the functions and variables to manage order lists and the items within.
 * This file is included in all pages with order list actions.
 */

/**
 * This class defines the functions and variables that customers can use to re-order processed orders.
 * @class The OrderListJS class defines the functions and variables that customers can use to manage their previous orders.
 */
OrderListJS = {
    /** 
     * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
     * @private
     */
    langId: "-1",
    
    /** 
     * This variable stores the ID of the current store. Its default value is empty.
     * @private
     */
    storeId: "",
    
    /** 
     * This variable stores the ID of the catalog. Its default value is empty.
     * @private
     */
    catalogId: "",

    /** This variable stores the ID of the newly created saved order. Its default value is empty. **/
    newOrderId : "",

    /** A boolean used to indicate if the current saved order was just deleted. Its default value is false. **/
    currentOrderDeleted : false,

    /** 
     * This array stores the quantities of each product in the order. Its default value is empty.
     * @private
     */
    quantityList: {},

    /** 
     * A boolean used to indicate if the current order list is saved order list. Its default value is false.
     * @private
     */
    savedOrder: false,

    /**
     * This variable stores the current dropdown dialog element.
     * @private
     */
    dropDownDlg: null,

    /**
     * This variable stores the expiry date of a subscription. For renewal, the start date is expiry date plus one day.
     */
    subscriptionDate: "",

    /**
     * This variable stores the orderId for subscription renewal
     */
    subscriptionOrderId: "",

    /**
     * This variable stores the orderItemId for subscription renewal
     */
    subscriptionOrderItemId: "",

    /**
     * Sets the common parameters for the current page. 
     * For example, the language ID, store ID, catalog ID, and whether it's saved order list.
     *
     * @param {Integer} langId The ID of the language that the store currently uses.
     * @param {Integer} storeId The ID of the current store.
     * @param {Integer} catalogId The ID of the catalog.
     * @param {Boolean} savedOrder The indicator of saved order list.
     */
    setCommonParameters:function(langId,storeId,catalogId,savedOrder){
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        this.savedOrder = savedOrder;
        cursor_clear();
    },

    /**
     * return a boolean value which indicates whether this is a saved order list
     */
    isSavedOrder: function () {
        return this.savedOrder;
    },

    /**
     * Initialize the URL of Saved Order List widget controller.
     *
     * @param {object} widgetUrl The controller's URL.
     */
    initOrderListUrl:function(widgetPrefix, widgetUrl){
        $("#" + widgetPrefix + "OrderListTable_Widget").refreshWidget("updateUrl", widgetUrl);
    },

    /**
     * set the subscriptionDate variable
     * @param {string} The expiry date of the subscription to be renewed.
     */
    setSubscriptionDate: function (value) {
        this.subscriptionDate = value;
    },

    /**
     * return a string which indicates the start date of the renewed subscription. The start date is one day plus the end date of that subscription.
     */
    getSubscriptionDate: function () {
        var year = parseInt(this.subscriptionDate.substring(0,4),10);
        var month = parseInt(this.subscriptionDate.substring(5,7),10);
        var date = parseInt(this.subscriptionDate.substring(8,10),10);

        if(month == 2){
            if((year % 4 == 0) && (year % 100 != 0) && (year % 400 == 0))
            {
                if(date != 29)
                {
                    date = date + 1;
                    if(date < 10)
                        date = "0" + date;
                    month = "02";
                }
                else
                {
                    date = "01";
                    month = "03";
                }
            }
            else
            {
                if(date != 28)
                {
                    date = date + 1;
                    if(date < 10)
                        date = "0" + date;
                    month = "02";
                }
                else
                {
                    date = "01";
                    month = "03";
                }
            }
        }
        else if(month == 12){
            if(date != 31)
            {
                date = date + 1;
                if(date < 10)
                    date = "0" + date;
                month = "12";
            }
            else
            {
                date = "01";
                month = "01";
                year = year + 1;
            }
        }
        else if(month == 4 || month == 6 || month == 9 || month == 11){
            if(date != 30)
            {
                date = date + 1;
                if(date < 10)
                    date = "0" + date;
            }
            else
            {
                date = "01";
                month = month + 1;
            }
            if(month < 10)
                month = "0" + month;
        }
        else{
            if(date != 31)
            {
                date = date + 1;
                if(date < 10)
                    date = "0" + date;
            }
            else
            {
                date = "01";
                month = month + 1;
            }
            if(month < 10)
                month = "0" + month;
        }

        var start = this.subscriptionDate.indexOf("T",0);
        var end = this.subscriptionDate.indexOf("Z",start);
        var appendString= this.subscriptionDate.substring(start+1,end);
        var newDateString = year+'-'+month+'-'+date+'T'+appendString+'Z';
        return(newDateString);
    },

    /**
     * This function sets the url for subscriptionrenew service and then it invokes the service to renew the subscription.
     * @param {string} SubscriptionCopyURL The url for the subscription copy service.
     */
    prepareSubscriptionRenew:function(SubscriptionCopyURL){

        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        wcService.getServiceById("SubscriptionRenew").setUrl(SubscriptionCopyURL);
        wcService.invoke("SubscriptionRenew");
    },

    /**
     * This function sets the url for ordercopy service and then it invokes the service to copy the old order.
     * @param {string} OrderCopyURL The url for the order copy service.
     */
    prepareOrderCopy:function(OrderCopyURL){

        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        wcService.getServiceById("OrderCopy").setUrl(OrderCopyURL);
        wcService.invoke("OrderCopy");
    },

    /**
     * This function sets the url for ssfs order copy service and then it invokes the service to copy the old order.
     * @param {string} SSFSOrderCopyUrl The url for the ssfs order copy service.
     */
    prepareSSFSOrderCopy:function(SSFSOrderCopyUrl){

        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        wcService.getServiceById("SSFSOrderCopy").setUrl(SSFSOrderCopyUrl);
        wcService.invoke("SSFSOrderCopy");
    },

    /**
     * get the last order record info in render context
     * @param {Integer} The current page number.
     * @param {string} The last order external id in current page.
     * @param {string} The last order record info in render context.
     * @param {boolean} value either true or false. True if it's for next page. False otherwise.
     */
    getLastRecordInfo: function (currentPage, lastExtOrderId, lastRecordInfoInContext, nextOrNot) {
        var lastRecordArray = lastRecordInfoInContext.split(";");
        var refinedRecordInfoIncontext;

        if(!nextOrNot){
            //previous page
            if(lastRecordInfoInContext != '' && lastRecordInfoInContext != undefined){
                if(lastRecordInfoInContext.lastIndexOf(";")>-1){
                    refinedRecordInfoIncontext = lastRecordInfoInContext.substring(0, lastRecordInfoInContext.lastIndexOf(";"));
                }else{
                    refinedRecordInfoIncontext = "";
                }
            }
        }else{
            //next page
            if(currentPage==1 || currentPage==''|| currentPage == undefined){
                //first page
                if(lastExtOrderId !='' && lastExtOrderId!=undefined){
                    refinedRecordInfoIncontext = lastExtOrderId;
                }else{
                    refinedRecordInfoIncontext = " ";
                }
            }else{
                if(lastRecordInfoInContext != '' && lastRecordInfoInContext != undefined){
                    if(lastExtOrderId !='' && lastExtOrderId!=undefined){
                        refinedRecordInfoIncontext = lastRecordInfoInContext.concat(";").concat(lastExtOrderId);
                    }else{
                        refinedRecordInfoIncontext = lastRecordInfoInContext.concat(";").concat(" ");
                    }
                }
            }
        }

        return refinedRecordInfoIncontext;
    },

    /**
     * Displays the actions list drop down panel.
     * @param {object} event The event to retrieve the input keyboard key.
     * @param {string} dialogId The id of the content pane containing the action popup details
     */
    showActionsPopup: function(event, dialogId){
        if(event == null || event.keyCode === KeyCodes.DOWN_ARROW){
            var dialog = $("#" + dialogId).data("wc-WCDialog");
            if(dialog) {
                this.dropDownDlg = dialog;
                this.dropDownDlg.open();
            }
        }
    },

    /**
     *This function displays the Recurring Order / Subscription action popup.
     *@param {String} action This variable can be either recurring_order or subscription.
     *@param {String} subscriptionId This variable gives the subscription id to be canceled.
     *@param {String} popupIndex the index of the action popup (required to close it later)
     *@param {String} message This variable gives the message regarding cancel notice period.
     */
    showPopup:function(action, subscriptionId, popupIndex, message){
        var popup = $("#Cancel_"+action+"_popup").data("wc-WCDialog");
        if (popup !=null) {
            closeAllDialogs(); //close other dialogs(quickinfo dialog, etc) before opening this.
            popup.element.attr("data-popupIndex", popupIndex);
            popup.open();
            document.getElementById("Cancel_yes_"+action).setAttribute("onclick", "OrderListJS.cancelRecurringOrder("+ subscriptionId + "," + popupIndex + ");");

            if(document.getElementById("cancel_notice_"+action) && document.getElementById(message)){
                $("#cancel_notice_"+action).html($("#" + message).val());
            }
        }else {
            console.debug("Cancel_subscription_popup"+" does not exist");
        }
    },

    /**
     * This function cancels a recurring order.
     * @param {String} subscriptionId The unique ID of the subscription to cancel.
     * @param {int} popupIndex the index of the action drop down
     */
    cancelRecurringOrder:function(subscriptionId, popupIndex){
        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();

        var params = {
            subscriptionId: subscriptionId,
            URL: "",
            storeId: OrderListServicesDeclarationJS.storeId,
            catalogId: OrderListServicesDeclarationJS.catalogId,
            langId: OrderListServicesDeclarationJS.langId
        };
        wcService.invoke("AjaxCancelSubscription", params);
    },

    /**
     * Display order list for pagination
     */
    showResultsPage:function(data){
        var pageNumber = data['pageNumber'],
        pageSize = data['pageSize'];
        pageNumber = parseInt(pageNumber);
        pageSize = parseInt(pageSize);

        setCurrentId(data["linkId"]);

        if(!submitRequest()){
            return;
        }

        var beginIndex = pageSize * ( pageNumber - 1 );
        cursor_wait();
        wcRenderContext.updateRenderContext('OrderListTable_Context', {'beginIndex':beginIndex});
        MessageHelper.hideAndClearMessage();
    },

    /**
     * Creates an empty order.
     */
    createNewList:function() {
        var form_name = document.getElementById("OrderList_NewListForm_Name");
        if (form_name !=null && this.isEmpty(form_name.value)) {
            MessageHelper.formErrorHandleClient(form_name.id,MessageHelper.messages["LIST_TABLE_NAME_EMPTY"]); return false;
        }
        service = wcService.getServiceById('AjaxOrderCreate');
        
        var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            description: $(form_name).val()
        };
            
        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        wcService.invoke('AjaxOrderCreate',params);
    },
    
    /**
     * Deletes a saved order
     * This method is invoked by the <b>Delete</b> action.
     * @param (string) orderId The orderId of the saved order.
     */
    deleteOrder:function (orderId) {
        var params = {
            orderId: orderId,
            filterOption: "All",
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId
        };
        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxSingleOrderCancel", params);
    },
    
    /**
     * Duplicates a saved order.
     * This method is invoked by the <b>Duplicate order</b> action.
     * @param (string) orderId The order from which the new saved order is created.
     * @param (string) orderDesc The name of the saved order.
     */
    duplicateOrder:function (orderId, orderDesc) {
        MessageHelper.hideAndClearMessage();
        
        var params = {
            storeId: this.storeId,
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            fromOrderId_1: orderId,
            toOrderId: "**",
            copyOrderItemId_1: "*",
            keepOrdItemValidContract: "1",
            URL: "TableDetailsDisplayURL"
        };
        if (orderDesc != null && orderDesc != 'undefined'){
            params["description"] = orderDesc;
        }
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        wcService.invoke('AjaxSingleOrderCopy',params);
    },
    
    /**
    * Sets the selected saved order as the current order in the saved orders table.
    * This method is invoked by the <b>Set as Current Order</b> action. 
    **/
    setCurrentOrder : function (orderId) {
        if (orderId != null && orderId != 'undefined') {
            if(!submitRequest()){
                return;
            }
            var params = {
                storeId: this.storeId,
                catalogId: this.catalogId,
                langId: this.langId,
                orderId: orderId,
                URL: ""
            };
            wcService.invoke("AjaxSetPendingOrder", params);
        }
    },
    
    /**
     * Updates the current order in the database to match the order in the shopping cart.
     * This method is called when the Saved Order list page loads, and when a saved order is added/deleted. 
     * @param (string) currentOrderId The orderId to set as the current order.
     */
    updateCurrentOrder : function(currentOrderId) {
        if (currentOrderId != null) {
            var params = {
                storeId: this.storeId,
                catalogId: this.catalogId,
                langId: this.langId,
                URL: "",
                orderId: currentOrderId
            };
            wcService.invoke("AjaxUpdatePendingOrder", params);
        }
    },
    
    /**
     * Returns the order ID of the first saved order in the table.
     * @returns {String} The order ID of the first saved order if not empty, otherwise, returns null.
     * 
     **/
    getFirstSavedOrderIdFromList : function() {
        var savedOrderLink = document.getElementById("WC_OrderList_Link_2_1");
        
        if (savedOrderLink && savedOrderLink != null && savedOrderLink != 'undefined' && savedOrderLink.innerHTML != null && savedOrderLink.innerHTML != 'undefined') {
            var savedOrderText = savedOrderLink.innerHTML,
            savedOrderId = savedOrderText.split(" ")[0];
            
            return savedOrderId;
        } else {
            return null;
        }
    },
    
    /**
     * Returns the current order ID from the currentOrderJSON div.
     * @returns {String} The order ID of the current order or null if the currentOrderJSON div cannot be found.
     * 
     **/
    getCurrentOrderId : function() {
        var jsonDIV = null;
        Utils.ifSelectorExists("#currentOrderJSON", function($node) {
            jsonDIV = JSON.parse($node.html());
        });
        if (jsonDIV != null && jsonDIV != 'undefined' && jsonDIV.currentOrderId != null && jsonDIV.currentOrderId != 'undefined') {
            return jsonDIV.currentOrderId;
        }
        else {
            return null;
        }
    },
    
    /**
     * Sets the newOrderId variable. This variable is only used to store the first saved order in the list.
     * @param newOrdId The order ID of the newly created saved order.
     */
    setNewOrderId : function(newOrdId) {
        this.newOrderId = newOrdId;
    },

    /**
     * Returns the ID of the new saved order. 
     * The newOrderId variable is set only when it is the first saved order in the list.
     * @returns {String} The ID of the newly created saved order.
     */
    getNewOrderId : function() {
        return this.newOrderId;
    },
    
    /**
     * Returns the currentOrderDeleted flag. 
     * @returns {boolean} true or false indicating whether the current saved order was deleted.
     * 
     */
    isCurrentOrderDeleted : function() {
        return this.currentOrderDeleted;
    },
    
    /**
     * Sets the currentOrderDeleted flag to true or false. 
     * This flag determines if the current saved order was deleted.
     * @param currOrderDeleted A boolean (true/false) indicating if the saved order was deleted.
     */
    setCurrentOrderDeleted : function(currOrderDeleted) {
        this.currentOrderDeleted = currOrderDeleted;
    },
    
    /**
    * Opens the saved order details view for the order.
    * This method is invoked by the <b>View Details</b> action.
    * @param (string) reqListURL The URL to the 
    **/
    viewDetails : function (reqListURL) {
        document.location.href = reqListURL;
    },
    
    /**
     * Checks if a string is null or empty.
     * @param (string) str The string to check.
     * @return (boolean) Indicates whether the string is empty.
     */
    isEmpty:function (str) {
        var reWhiteSpace = new RegExp(/^\s+$/);
        if (str == null || str =='' || reWhiteSpace.test(str) ) {
            return true;
        }
        return false;
    },
    
    /**
     * Remove the quantity of the SKU (e.g. when row is hidden)
     * @param (string) restUrl The rest url for getting order items
     * @param (string) params String with the params to be passed in
     */
    getOrderItems:function(restUrl, params){
        $.get(restUrl, params, function(order, textStatus, jqXHR) {
            OrderListJS.quantityList = {};
            if (order.orderItem == null) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('MYACCOUNT_SAVEDORDERLIST_EMPTY_ADD_TO_REQ_FAIL'));
                return;
            }
            for (var i = 0; i < order.orderItem.length; i++) {
                var orderId = order.orderId;

                if (!(orderId in OrderListJS.quantityList)) {
                    OrderListJS.quantityList[orderId] = {};
                }
                OrderListJS.quantityList[orderId][order.orderItem[i].productId] = order.orderItem[i].quantity;
            }

            if (typeof addReqListsJS != 'undefined') {
                addReqListsJS.toggleDropDownMenu(true,false);
            }
        });
    },
    
    /**
     *This method locks the order specified when the buyer administrator is browsing in an on behalf mode.
     */
    lockOrderOnBehalf: function(orderId){
        var params = {
            orderId: orderId,
            filterOption: "All",
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId
        };
        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxRESTOrderLockOnBehalf", params);
    },
    
    /**
     * This method take over the lock on the order by other buyer administrator 
     * when the buyer administrator is browsing in an on behalf mode.
     */
    takeOverLockOrderOnBehalf: function(orderId, isCurrentOrder){
        var params = {
            orderId: orderId,
            filterOption: "All",
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            takeOverLock: "Y"
        };
        if (undefined !== isCurrentOrder && isCurrentOrder =='true'){
            setDeleteCartCookie();
            params["isCurrentOrder"] = 'true';
        } else {
            params["isCurrentOrder"] = 'false';
        }
        
        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxRESTOrderLockTakeOverOnBehalf", params);
    },
        
    /**
     *This method unlocks the order specified when the buyer administrator is browsing in 
     *an on behalf mode.
     */
    unlockOrderOnBehalf: function(orderId){
        var params = {
            orderId: orderId,
            filterOption: "All",
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId
        };
        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxRESTOrderUnlockOnBehalf", params);
    }
}
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * Declares a new render context for order list.
 */
wcRenderContext.declare("OrderListTable_Context", [], {beginIndex: "0"});

/**
 * Declares a new refresh controller for order list.
 */
var declareOrderDisplayRefreshArea = function(widgetPrefix) {
    var myWidgetObj = $("#" + widgetPrefix + "OrderListTable_Widget");
    wcRenderContext.addRefreshAreaId("OrderListTable_Context", widgetPrefix + "OrderListTable_Widget");
    var myRCProperties = wcRenderContext.getRenderContextProperties("OrderListTable_Context");
    
    /**
     * Displays the previous/next page of orders.
     * This function is called when a render context changed event is detected.
     */
    wcTopic.subscribe(["AjaxCancelSubscription", "AjaxOrderCreate", "AjaxSingleOrderCancel", "AjaxSingleOrderCopy", "AjaxSetPendingOrder", "AjaxRESTOrderUnlockOnBehalf", "AjaxRESTOrderLockOnBehalf", "AjaxRESTOrderLockTakeOverOnBehalf"], function () {
        myWidgetObj.refreshWidget("refresh", myRCProperties);
    });
    
    var renderContextChangedHandler = function() {
        myWidgetObj.refreshWidget("refresh", myRCProperties);
    }
    
    var postRefreshHandler = function() {
        cursor_clear();

        if(OrderListJS.isSavedOrder()) {
            // If the current saved order gets deleted, we trigger the "AjaxUpdatePendingOrder" 
             // to set the first saved order in the list as the current saved order.
             if (OrderListJS.getFirstSavedOrderIdFromList() != null && OrderListJS.isCurrentOrderDeleted() == true) {
                 OrderListJS.updateCurrentOrder(OrderListJS.getFirstSavedOrderIdFromList());
             }

             // If it's the only saved order in the list and the current saved order div is not currently set,
             // ensure that it's set as the current saved order.
             if (Utils.existsAndNotEmpty(OrderListJS.getNewOrderId())) {
                 var newOrderId = OrderListJS.getNewOrderId();
                 OrderListJS.updateCurrentOrder(newOrderId);
                 OrderListJS.setNewOrderId(null);
             }

             if (OrderListJS.isCurrentOrderDeleted() == true) {
                 OrderListJS.setCurrentOrderDeleted(false);
             }

             toggleMobileView();
        }
    }
    
    // initialize widget
    myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
};//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript contains declarations of AJAX services used within
 * WebSphere Commerce.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */
OrderListServicesDeclarationJS = {
    /* The common parameters used in service calls */
    langId: "-1",
    storeId: "",
    catalogId: "",

    /**
     * This function initializes common parameters used in all service calls.
     * @param {int} langId The language id to use.
     * @param {int} storeId The store id to use.
     * @param {int} catalogId The catalog id to use.
     */
    setCommonParameters:function(langId,storeId,catalogId){
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
    }
}

/**
 *  This service enables customer to Reorder an already existing order.
 *  @constructor
 */
wcService.declare({
    id: "OrderCopy",
    actionId: "OrderCopy",
    url: "AjaxRESTOrderCopy",
    formId: ""

    /**
     *  Copies all the items from the existing order to the shopping cart and redirects to the shopping cart page.
     *  @param (object) serviceResponse The service response object, which is the
     *  JSON object returned by the service invocation.
     */
    ,successHandler: function(serviceResponse) {
        for (var prop in serviceResponse) {
            console.debug(prop + "=" + serviceResponse[prop]);
        }
        if (serviceResponse.newOrderItemsCount != null && serviceResponse.newOrderItemsCount <= 0){
            MessageHelper.displayErrorMessage(MessageHelper.messages["CANNOT_REORDER_ANY_MSG"]);
        }
        else {
            setDeleteCartCookie();

            var postRefreshHandlerParameters = [];
            var initialURL = "AjaxRESTOrderPrepare";
            var urlRequestParams = [];
            urlRequestParams["orderId"] = serviceResponse.orderId;
            urlRequestParams["storeId"] = OrderListServicesDeclarationJS.storeId;

            postRefreshHandlerParameters.push({"URL":"AjaxCheckoutDisplayView","requestType":"GET", "requestParams":{}}); 
            var service = getCustomServiceForURLChaining(initialURL,postRefreshHandlerParameters,null);
            wcService.invoke(service.getParam("id"), urlRequestParams);
        }
    }

    /**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessageKey === "_ERR_PROD_NOT_ORDERABLE") {
            MessageHelper.displayErrorMessage(MessageHelper.messages["PRODUCT_NOT_BUYABLE"]);
        } else if (serviceResponse.errorMessageKey === "_ERR_INVALID_ADDR") {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        }else {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                    if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    }
            }
        }
        cursor_clear();
    }
}),

/**
 *  This service enables customer to Reorder an already existing order in external system.
 *  @constructor
 */
wcService.declare({
    id: "SSFSOrderCopy",
    actionId: "SSFSOrderCopy",
    url: "AjaxSSFSOrderCopy",
    formId: ""

        /**
         *  Copies all the items from the existing order to the shopping cart and redirects to the shopping cart page.
        *  @param (object) serviceResponse The service response object, which is the
        *  JSON object returned by the service invocation.
        */
    ,successHandler: function(serviceResponse) {
        for (var prop in serviceResponse) {
            console.debug(prop + "=" + serviceResponse[prop]);
        }

        setDeleteCartCookie();
        document.location.href=appendWcCommonRequestParameters("AjaxCheckoutDisplayView?langId="+OrderListServicesDeclarationJS.langId+"&storeId="+OrderListServicesDeclarationJS.storeId+"&catalogId="+OrderListServicesDeclarationJS.catalogId);
    }

    /**
    * display an error message.
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation.
    */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessageKey === "_ERR_PROD_NOT_ORDERABLE") {
            MessageHelper.displayErrorMessage(MessageHelper.messages["PRODUCT_NOT_BUYABLE"]);
        } else if (serviceResponse.errorMessageKey === "_ERR_INVALID_ADDR") {
            MessageHelper.displayErrorMessage(MessageHelper.messages["INVALID_CONTRACT"]);
        }else {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                    if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    }
            }
        }
        cursor_clear();
    }
}),

/**
 * This service cancels a subscription.
 * @constructor
 */
wcService.declare({
    id: "AjaxCancelSubscription",
    actionId: "AjaxCancelSubscription",
    url: "AjaxRESTRecurringOrSubscriptionCancel",
    formId: ""

    /**
     * Clear messages on the page.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
     */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        cursor_clear();
        closeAllDialogs();
        if(serviceResponse.subscriptionType == "RecurringOrder"){
            if(serviceResponse.state == "PendingCancel"){
                MessageHelper.displayStatusMessage(MessageHelper.messages["SCHEDULE_ORDER_PENDING_CANCEL_MSG"]);
            }
            else{
                MessageHelper.displayStatusMessage(MessageHelper.messages["SCHEDULE_ORDER_CANCEL_MSG"]);
            }
        }
        else{
            if(serviceResponse.state == "PendingCancel"){
                MessageHelper.displayStatusMessage(MessageHelper.messages["SUBSCRIPTION_PENDING_CANCEL_MSG"]);
            }
            else{
                MessageHelper.displayStatusMessage(MessageHelper.messages["SUBSCRIPTION_CANCEL_MSG"]);
            }
        }
    }

    /**
     * Displays an error message on the page if the request failed.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
            if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        }
        cursor_clear();
    }
}),

/**
 *  This service enables customer to Renew a subscription.
 *  @constructor
 */
wcService.declare({
    id: "SubscriptionRenew",
    actionId: "SubscriptionRenew",
    url: "AjaxRESTOrderCopy",
    formId: ""

    /**
     *  Copies all the items from the existing subscription to the shopping cart and calls service to update requested shipping date.
    *  @param (object) serviceResponse The service response object, which is the
    *  JSON object returned by the service invocation.
    */
    ,successHandler: function(serviceResponse) {
        for (var prop in serviceResponse) {
            console.debug(prop + "=" + serviceResponse[prop]);
        }

        var params = [];

        params.storeId      = OrderListServicesDeclarationJS.storeId;
        params.catalogId    = OrderListServicesDeclarationJS.catalogId;
        params.langId       = OrderListServicesDeclarationJS.langId;
        params.orderId      = serviceResponse.orderId;
        params.calculationUsage  = "-1,-2,-3,-4,-5,-6,-7";
        params.requestedShipDate = OrderListJS.getSubscriptionDate();

        OrderListJS.subscriptionOrderId = serviceResponse.orderId;
        OrderListJS.subscriptionOrderItemId = serviceResponse.orderItemId[0];

        wcService.invoke("SetRequestedShippingDate",params);
    }

    /**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
            MessageHelper.displayErrorMessage(MessageHelper.messages["PRODUCT_NOT_BUYABLE"]);
        } else if (serviceResponse.errorMessageKey == "_ERR_INVALID_ADDR") {
            MessageHelper.displayErrorMessage(MessageHelper.messages["INVALID_CONTRACT"]);
        }else {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                    if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    }
            }
        }
        cursor_clear();
    }

}),

/**
 *  This service sets the requested shipping date for a subscription renewal.
 *  @constructor
 */
wcService.declare({
    id: "SetRequestedShippingDate",
    actionId: "SetRequestedShippingDate",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: ""
/**
 * hides all the messages and the progress bar
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
    ,successHandler: function(serviceResponse) {
        cursor_clear();
        document.location.href=appendWcCommonRequestParameters("RESTOrderPrepare?langId="+OrderListServicesDeclarationJS.langId+"&storeId="+OrderListServicesDeclarationJS.storeId+"&catalogId="+OrderListServicesDeclarationJS.catalogId+"&orderId="+serviceResponse.orderId+"&URL=AjaxCheckoutDisplayView?langId="+OrderListServicesDeclarationJS.langId+"&storeId="+OrderListServicesDeclarationJS.storeId+"&catalogId="+OrderListServicesDeclarationJS.catalogId);
    }

    /**
 * display an error message
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessageKey == "_ERR_ORDER_ITEM_FUTURE_SHIP_DATE_OVER_MAXOFFSET") {
            var params = [];

            params.storeId      = OrderListServicesDeclarationJS.storeId;
            params.catalogId    = OrderListServicesDeclarationJS.catalogId;
            params.langId       = OrderListServicesDeclarationJS.langId;
            params.orderId      = OrderListJS.subscriptionOrderId;
            params.orderItemId      = OrderListJS.subscriptionOrderItemId;
            params.calculationUsage  = "-1,-2,-3,-4,-5,-6,-7";
            wcService.invoke("RemoveSubscriptionItem",params);

            MessageHelper.displayStatusMessage(MessageHelper.messages["CANNOT_RENEW_NOW_MSG"]);
        }
        else{
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    }
            }
            cursor_clear();
        }
    }

}),

/**
 * This service removes the subscription item from the shopping cart if renewal fails.
 * @constructor
 */
wcService.declare({
    id: "RemoveSubscriptionItem",
    actionId: "RemoveSubscriptionItem",
    url: "AjaxRESTOrderItemDelete",
    formId: ""

    /**
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    ,successHandler: function(serviceResponse) {
        cursor_clear();
    }

        /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        }
        else {
                if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
        }
        if(serviceResponse.errorCode){
            wcTopic.publish("OrderError",serviceResponse);
        }
        cursor_clear();
    }

})

/**
 * This service allows customer to create a new saved order
 * @constructor
 */
wcService.declare({
    id:"AjaxOrderCreate",
    actionId:"AjaxOrderCreate",
    url:"AjaxRESTOrderCreate",
    formId:""

     /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        cursor_clear();
        MessageHelper.displayStatusMessage(MessageHelper.messages["MYACCOUNT_SAVEDORDERLIST_CREATE_SUCCESS"]);
        
        var firstSavedOrderId = OrderListJS.getFirstSavedOrderIdFromList();
        if (firstSavedOrderId == null) {
            OrderListJS.setNewOrderId(serviceResponse.outOrderId);
        }
    }
        
    /**
     * Display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
             if (serviceResponse.errorCode == "CMN0409E")
             {
                 MessageHelper.displayErrorMessage(MessageHelper.messages["MYACCOUNT_SAVEDORDERLIST_CREATE_FAIL"]);
             }
             else
             {
                 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
             }
        } 
        else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
}),

/**
 * This service deletes an existing saved order.
 * @constructor
 */
wcService.declare({
    id:"AjaxSingleOrderCancel",
    actionId:"AjaxSingleOrderCancel",
    url:"AjaxRESTOrderCancel",
    formId:""

     /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        cursor_clear();
        MessageHelper.displayStatusMessage(MessageHelper.messages["MYACCOUNT_SAVEDORDERLIST_DELETE_SUCCESS"]);

        //set the OrderListJS.currentOrderDeleted flag to true if the current order was deleted.
        var deletedOrderId = serviceResponse.orderId;
        var currentOrderId = OrderListJS.getCurrentOrderId();
        if (currentOrderId == deletedOrderId) {
            OrderListJS.setCurrentOrderDeleted(true);
        } 
    }
        
    /**
     * Display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
             if (serviceResponse.errorCode == "CMN0409E")
             {
                 MessageHelper.displayErrorMessage(MessageHelper.messages["MYACCOUNT_SAVEDORDERLIST_DELETE_FAIL"]);
             }
             else
             {
                 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
             }
        } 
        else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
}),

/**
* This service allows customer to create a saved order from an existing order.
* @constructor
*/
wcService.declare({
    id:"AjaxSingleOrderCopy",
    actionId:"AjaxSingleOrderCopy",
    url:"AjaxRESTOrderCopy",
    formId:""

     /**
    * Hides all the messages and the progress bar.
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation.
    */
    ,successHandler: function(serviceResponse) {
        var params = {
            storeId: OrderListJS.storeId,
            catalogId: OrderListJS.catalogId,
            langId: OrderListJS.langId,
            updatePrices: "1",
            orderId: serviceResponse.orderId,
            calculationUsageId: "-1"
        };
        wcService.invoke("AjaxSingleOrderCalculate", params);
        MessageHelper.hideAndClearMessage();
        cursor_clear();
        MessageHelper.displayStatusMessage(MessageHelper.messages["MYACCOUNT_SAVEDORDERLIST_COPY_SUCCESS"]);
    }
        
    /**
    * Display an error message.
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation.
    */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
             if (serviceResponse.errorCode == "CMN0409E")
             {
                 MessageHelper.displayErrorMessage(MessageHelper.messages["MYACCOUNT_SAVEDORDERLIST_COPY_FAIL"]);
             }
             else
             {
                 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
             }
        }
        else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
}),

/**
 * Perform the order calculation operations to compute the contract prices for the order items in an order.
 * Perform the service or command call.
 */
wcService.declare({
    id: "AjaxSingleOrderCalculate",
    actionId: "AjaxSingleOrderCalculate",
    url: "AjaxRESTOrderCalculate",
    formId: ""

 /**
 * Display a success message
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */

    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        MessageHelper.displayStatusMessage(MessageHelper.messages["MYACCOUNT_SAVEDORDERLIST_CALCULATE_SUCCESS"]);
        cursor_clear();
    }

 /**
 * Display an error message
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
    ,failureHandler: function(serviceResponse) {
        
        if (serviceResponse.errorMessage) {
            if (serviceResponse.errorCode == "CMN0409E")
             {
                 MessageHelper.displayErrorMessage(MessageHelper.messages["MYACCOUNT_SAVEDORDERLIST_CALCULATE_FAIL"]);
             }
             else
             {
                 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
             }
        } 
        else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
})

/**
 * Invokes the order unlock action.
 * Perform the service or command call.
 */
wcService.declare({
    id: "AjaxRESTOrderUnlockOnBehalf",
    actionId: "AjaxRESTOrderUnlockOnBehalf",
    url: "AjaxRESTOrderUnlockOnBehalf",
    formId: ""

 /**
 * Display a success message
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */

    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        MessageHelper.displayStatusMessage(MessageHelper.messages["MYACCOUNT_SAVEDORDERLIST_ORDER_UNLOCK_SUCCESS"]);
        cursor_clear();
    }

 /**
 * Display an error message
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
    ,failureHandler: function(serviceResponse) {
        
        if (serviceResponse.errorMessage) {
                 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } 
        else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
})

/**
 * Invokes the order unlock action.
 * Perform the service or command call.
 */
wcService.declare({
    id: "AjaxRESTOrderLockOnBehalf",
    actionId: "AjaxRESTOrderLockOnBehalf",
    url: "AjaxRESTOrderLockOnBehalf",
    formId: ""

 /**
 * Display a success message
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */

    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        MessageHelper.displayStatusMessage(MessageHelper.messages["MYACCOUNT_SAVEDORDERLIST_ORDER_LOCK_SUCCESS"]);
        cursor_clear();
    }

 /**
 * Display an error message
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
    ,failureHandler: function(serviceResponse) {
        
        if (serviceResponse.errorMessage) {
                 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } 
        else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
})

/**
 * Invokes the order lock take over action.
 * Perform the service or command call.
 */
wcService.declare({
    id: "AjaxRESTOrderLockTakeOverOnBehalf",
    actionId: "AjaxRESTOrderLockTakeOverOnBehalf",
    url: "AjaxRESTOrderLockTakeOverOnBehalf",
    formId: ""

 /**
 * Display a success message
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */

    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        MessageHelper.displayStatusMessage(MessageHelper.messages["MYACCOUNT_SAVEDORDERLIST_ORDER_LOCK_SUCCESS"]);
        cursor_clear();
        if (serviceResponse['isCurrentOrder'] !== undefined && serviceResponse['isCurrentOrder'][0] == 'true'){
            document.location.reload();
            //refresh the page to update cart
        }
    }

 /**
 * Display an error message
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
    ,failureHandler: function(serviceResponse) {
        
        if (serviceResponse.errorMessage) {
                 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } 
        else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
});//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * Declares a new refresh controller for the Organization Summary widget
 */
var declareOrgSearchResultsController = function() {
	var myWidgetObj = $("#orgSearchResultsRefreshArea");
	
	wcRenderContext.declare("orgSearchResultsContext",["orgSearchResultsRefreshArea"],{"orgListDisplayType":"search","searchTerm":"", "startIndex":"0"});

	var myRCProperties = wcRenderContext.getRenderContextProperties("orgSearchResultsContext");
    
	var baseURL = getAbsoluteURL() + 'OrgListDisplayViewV2';
    
	myWidgetObj.refreshWidget({
    	renderContextChangedHandler: function() {
    		myWidgetObj.refreshWidget("updateUrl", baseURL + "?" + getCommonParametersQueryString());
    		myWidgetObj.html("");
    		console.debug(myRCProperties);
    		myWidgetObj.refreshWidget("refresh", myRCProperties);
       },

    	postRefreshHandler: function() {
    		cursor_clear();
    	}
	});
};

// onChange function for organization list select button
function OrganizationOnChange(id, displayName) {
	var data = {"newOrgId":id, "newOrgName":displayName};
	organizationListJS.updateSelectedOrgDetails(data);

	// Publish the event
	wcTopic.publish(organizationListJS.ORG_CHANGED_TOPIC,data);
}
$(document).ready(function() {

organizationListJS = {

	/** HashMap structure to manage parent - child organization relationship
	 *  Key - Parent Org Id
	 *  Value - List of child organizations under Parent Org Id.
	 *  Each object in the list contains complete details about the child organization like orgId, orgName, parentOrgId
	*/
	parentChildOrgDetails : new Object(),

	/**
	* HashMap structure.
	* Key - orgId
	* Value - orgName
	*/
	orgIdToNameMap: new Object(),

	/**
	* Array of top level parent orgIds
	*/
	parentOrgIdsArray : new Array(),

	// UniCode value for &nbps; 
	//HTML Select Option element will treat &nbps; as normal string when options element is created dynamically using script. So as a workaround use unicode format
	//indentation : "\xA0\xA0\xA0", 
	indentation : 27, // padding by 27 px for every child node

	/*
	* Topic name which gets published when the selection in organization drop down box changes.
	*/
	ORG_CHANGED_TOPIC : "organizationChanged",

	/*
	* Topic name to which this widget subscribes. Any widget can publish this topic to receive the current orgId selected in the drop down box.
	*/
	CURRENT_ORG_ID_REQUEST : "currentOrgIdRequest",

	/**
	* Topic name used to publish the current orgId.
	*/
	CURRENT_ORG_ID : "currentOrgId",

	/**
	* Current Organization selected
	*/
	CURRENT_DATA : {"newOrgId":"","newOrgName":""},
	
	/**
	* Set the indentation which can be used while displaying the tree structure
	*/
	setIndentation:function(indent){
		this.iindentation = indent;
	},

	orgSearchListData : {"searchInputFieldId":"orgNameInputField", "clearFilterButtonId":"clearFilter", "progressBarId":"searchOrgListButton", "searchParameterName":"orgName", "searchResultsDivId":"orgSearchResultsRefreshArea"},

	/**
	* This method converts the flat structure of organizaiton list into tree structure and displays the tree structure in the drop down box
	* flatStructure - List of organizations
	* selectBox - Id of the drop down box where the tree structure will be displayed
	*/
	createAndDisplayOrgTree:function(flatStructure,selectBox,selectedOrgEntityId){

		var parentOrgIdsSet = new Object();
		var seenParentOrgIds = new Object();

		//Keep track of id to Name mapping. Needed to get parentOrg Name. For Accessibility label.
		for(var i = 0; i < flatStructure.organizationDataBeans.length; i++){
			var orgDetails = flatStructure.organizationDataBeans[i];
			var orgId = orgDetails.organizationId;
			var orgName = orgDetails.displayName;
			this.orgIdToNameMap[orgId] = orgName; 
		}

		for(var i = 0; i < flatStructure.organizationDataBeans.length; i++){

			var orgDetails = flatStructure.organizationDataBeans[i];
			var orgId = orgDetails.organizationId;
			var parentOrgId = orgDetails.parentMemberId;
			var orgName = orgDetails.displayName;

			var childOrgList = this.parentChildOrgDetails[parentOrgId];
			if(childOrgList === undefined){
				childOrgList = new Array();
				this.parentChildOrgDetails[parentOrgId] = childOrgList;
			} 
			var child = new Object();
			child["orgId"] = orgId;
			child["parentOrgId"] = parentOrgId;
			child["orgName"] = orgName;
			child["parentOrgName"] = this.orgIdToNameMap[parentOrgId]; // This is for aria-label. To call out parent org Name.
			childOrgList[childOrgList.length] = child;

			// Identify the parentOrgIds
			if(!Object.prototype.hasOwnProperty.call(seenParentOrgIds, parentOrgId)){
				parentOrgIdsSet[parentOrgId] = "true";
			} 
			seenParentOrgIds[orgId] = "true";
			seenParentOrgIds[parentOrgId] = "true";
			if(Object.prototype.hasOwnProperty.call(parentOrgIdsSet, orgId)){
				delete parentOrgIdsSet[orgId];
			}
		}
		for(var i in parentOrgIdsSet){
			this.parentOrgIdsArray[this.parentOrgIdsArray.length] = i;
		}

		console.debug("Parent to Child Org Details = ", this.parentChildOrgDetails);
		console.debug("Top Level Parent Org Ids = ",this.parentOrgIdsArray);
		console.debug("Org Id to Name Map ", this.orgIdToNameMap);
		this.displayOrgTree(this.parentChildOrgDetails, this.parentOrgIdsArray, selectBox,selectedOrgEntityId);
	},

	/**
	* Displays organization structure in Tree form.
	* parentChildDetailsMap - Object containing parent to child org relationship.
	* parentIdsList - List of top level ( root ) OrgIds.
	* selectBox - id of the drop down box used to display the tree structure.
	*/
	displayOrgTree:function(parentChildDetailsMap, parentIdsList, selectBox,selectedOrgEntityId){
		var selectBoxObj = $("#" + selectBox);

		for(var i = 0; i < parentIdsList.length; i++){
			var childId = parentIdsList[i];
			this.buildOrgTreeRecursively(parentChildDetailsMap,childId, selectBoxObj, 8);
		}
		console.debug(selectBoxObj);
		// Set the selected orgEntityId in the selectBox object.
		$("#" + selectBox).Select("refresh");
	},

	/**
	* Recursively builds the tree structure mark-up.
	* parentChildDetailsMap - Object containing parent to child org relationship.
	* childId - Child Organization id
	* selectBoxObj - Drop down object where tree structure is built
	* indentation - Used to indent child orgs from parent orgs
	*/
	buildOrgTreeRecursively:function(parentChildDetailsMap,childId,parentNode,indentation){

		var childDetails = parentChildDetailsMap[childId];
		var scope = this;
		if(childDetails != null){
			for(var j = 0; j < childDetails.length; j++){
				var child = childDetails[j];
				var id1 = child['orgId'];
				var name = child['orgName'];
				var parentOrgName = child["parentOrgName"];
				var style = "padding-left:"+indentation+"px;";

				// Generate ARIA LABEL
				var ariaLevel = (indentation / this.indentation) + 1;
				//var tempString = storeNLS['ORG_TO_PARENT_ORG']; - 	// ORG_TO_PARENT_ORG : "${0} created under parent organization - ${1}",
				var stringPattern = "{0} - {1}";
				var tempString;
				if(parentOrgName != null){
					tempString = Utils.substituteStringWithMap(stringPattern, {
						0: name,
						1: parentOrgName
					});
				} else {
					// tempString = storeNLS['TOP_LEVEL_ORG']; - // TOP_LEVEL_ORG : "${0}. This is the top level organization"
					stringPattern = "{0}";
					tempString = Utils.substituteStringWithMap(stringPattern, {0: name});
				}
			
				var text = "<option aria-label = '"+ tempString +"' aria-level = '"+ariaLevel+"' style = '"+style+"'" +
						"value = '" + id1 + "'>"+name+"</option>";
				var option = {id:id1, label:text, displayName:name};
				parentNode.append(option.label);
				if(parentChildDetailsMap[id1] != null){
					this.buildOrgTreeRecursively(parentChildDetailsMap,id1, parentNode,indentation + this.indentation);
				} 
			}
		}
	},

	/**
	* For the given eventName and domNodeId, this function sets up the event with topicName = ORG_CHANGED_TOPIC
	* The data contains the orgId currently selected, with key set to "newOrgId"
	* 
	* This method also subscribes to CURRENT_ORG_ID_REQUEST topic and in response publishes CURRENT_ORG_ID with data object containing the current orgId.
	*/
	setUpEvents:function(eventName, selectBoxDivId){
		var scope = this;
		$(document).ready(function() {
			wcTopic.subscribe(scope.CURRENT_ORG_ID_REQUEST, function(data){
				console.debug("pulbish "+scope.CURRENT_ORG_ID, scope.CURRENT_DATA);
				// Add CURRENT_DATA to the data supplied by the publisher of this event.. and then publish a new event
				$.extend(data, scope.CURRENT_DATA);
				wcTopic.publish(scope.CURRENT_ORG_ID, data);
			});
		});
	},

	cancelEvent: function(e) {
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		if (e.preventDefault) {
			e.preventDefault();
		}
		e.cancelBubble = true;
		e.cancel = true;
		e.returnValue = false;
	},

	updateSelectedOrgDetails:function(data,publishEvent){
		this.CURRENT_DATA["newOrgId"] = data["newOrgId"];
		this.CURRENT_DATA["newOrgName"] = data["newOrgName"];
		console.debug("Current Organization selected", this.CURRENT_DATA);
		if(publishEvent != 'undefined' && publishEvent == 'true'){
			wcTopic.publish(this.ORG_CHANGED_TOPIC,data);
		}
	},

	updateSelectedOrgName:function(elementId,name){
		$("#" + elementId).html(name);
		var scope = this;
		$(document).ready(function() {
			wcTopic.subscribe(scope.ORG_CHANGED_TOPIC, function(data){
				$("#" + elementId).html(data.newOrgName);
			});
		});
	},
	
	getCurrentData:function(){
		return this.CURRENT_DATA;
	},

	showResultsPage:function(data){

		var pageNumber = data['pageNumber'];
		var pageSize = data['pageSize'];
		pageNumber = parseInt(pageNumber);
		pageSize = parseInt(pageSize);
		var startIndex = (pageNumber - 1) * pageSize;

		setCurrentId(data["linkId"]);

		if(!submitRequest()){
			return;
		}

		console.debug(wcRenderContext.getRenderContextProperties('orgSearchResultsContext').properties);
		var beginIndex = pageSize * ( pageNumber - 1 );
		cursor_wait();

		wcRenderContext.updateRenderContext('orgSearchResultsContext', {"startIndex": startIndex});
		MessageHelper.hideAndClearMessage();
	},

	toggleSelection:function(nodeCSS,nodeId,parentNode,cssClassName){
		// Get list of all active nodes with cssClass = nodeCSS under parentNode.
		var activeNodes = $("#" + parentNode).find('.'+cssClassName);

		// Toggle the css class for the node with id = nodeId
		$("#" + parentNode).find('#'+nodeId).toggleClass(cssClassName);

		// Remove the css class for all the active nodes.
		activeNodes.removeClass(cssClassName);
	},

	closeActionButtons:function(nodeCSS,parentNode,cssClassName,hiddenClassName,activeClassName){
		$("#" + parentNode).find('.'+nodeCSS).removeClass(cssClassName);
	},

	resetActionButtonStyle:function(nodeCSS,parentNode,hiddenClassName,activeClassName){
		$("#" + parentNode).find('.'+nodeCSS).addClass(hiddenClassName);
		$("#" + parentNode).find('.'+nodeCSS).removeClass(activeClassName);
	},

	toggleCSSClass:function(nodeCSS,nodeId,parentNode,hiddenClassName,activeClassName){
		// Get the list of current nodes
		var activeNodes = $("#" + parentNode).find('.'+activeClassName); 

		// For the clicked node, toggle the CSS Class. If hidden then display / If displayed then hide.
		$("#"+parentNode).find('#'+nodeId).toggleClass(hiddenClassName);
		$("#"+parentNode).find('#'+nodeId).toggleClass(activeClassName);

		// For all activeNodes, remove the activeCSS and add the hiddenCSS
		activeNodes.removeClass(activeClassName);
		activeNodes.addClass(hiddenClassName);
	},

	doSearch:function(){
		searchTerm = $("#" + this.orgSearchListData.searchInputFieldId).val();
		if(searchTerm == 'undefined' || searchTerm.length == 0){
			searchTerm = "*";
		}
		setCurrentId(this.orgSearchListData.progressBarId);
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		var params = {};
		params[this.orgSearchListData.searchParameterName] = searchTerm;
		params["startIndex"] = "0"; // Reset start index..This is a new search..
		wcRenderContext.updateRenderContext("orgSearchResultsContext", params);	
		$("#" + this.orgSearchListData.clearFilterButtonId).css("display","block"); // Display clearFilter button
	},

	handleSearchInput:function(event,doSearch){
		var searchTerm = $("#" + this.orgSearchListData.searchInputFieldId).val();
		if(searchTerm != 'undefined' && searchTerm.length > 0){
			$("#" + this.orgSearchListData.clearFilterButtonId).css("display","block");
		} else {
			$("#" + this.orgSearchListData.clearFilterButtonId).css("display","none");
		}
		$("#" + this.orgSearchListData.searchResultsDivId).html(""); // Clear previous search results..
		if(doSearch == 'true' && event != null && event.keyCode == KeyCodes.ENTER){
			this.doSearch();
		}
		return false;
	}

};

});;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * Declares a new render context for the Organization Member Group widget
 */
wcRenderContext.declare("orgMemberGroupContext",["orgMemberGroupRefreshArea"],{'orgEntityId':null, 'progressBarId':null});

/** 
 * Declares a new refresh controller for the Organization Member Group widget
 */
function declareOrgMemberGroupController() {
	var myWidgetObj = $("#orgMemberGroupRefreshArea");

	var myRCProperties = wcRenderContext.getRenderContextProperties("orgMemberGroupContext");

	var baseURL = getAbsoluteURL() + 'OrgMemberGroupDisplayViewV2';
	
	wcTopic.subscribe(["AjaxApprovalGroupUpdate"], function() {
		myWidgetObj.refreshWidget("updateUrl", baseURL + "?" + getCommonParametersQueryString());
		setCurrentId(myRCProperties["progressBarId"]);
		submitRequest();
		cursor_wait();
		myWidgetObj.refreshWidget("refresh", myRCProperties);
	});

	myWidgetObj.refreshWidget({
		renderContextChangedHandler: function() {},
		
		postRefreshHandler: function() {
			cursor_clear();
			widgetCommonJS.removeSectionOverlay();
       }
	});
};

organizationMemberApprovalGroupJS = {

	widgetShortName: "OrgMemberApprovalGroupWidget", // My Name
	
	/**
	*/
	updateMemberApprovalGroup:function(orgEntityId, approvalGroupCheckBoxName, checkBoxCSSClassName){

		var service = wcService.getServiceById('AjaxApprovalGroupUpdate');

		if(service == null || service == undefined){
			/**
			 */
			wcService.declare({
				id: "AjaxApprovalGroupUpdate",
				actionId: "AjaxApprovalGroupUpdate",
				url: getAbsoluteURL() + "AjaxRESTApprovalGroupUpdate",
				formId: ""
				
				/**
				 * Clear messages on the page.
				 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
				 */
				,successHandler: function(serviceResponse) {
					MessageHelper.hideAndClearMessage();
					MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("APPROVAL_MEMBER_GROUP_UPDATED"));
				}
				
				/**
				 * Displays an error message on the page if the request failed.
				 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
				 */
				,failureHandler: function(serviceResponse) {
					if (serviceResponse.errorMessage) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
					} else {
						if (serviceResponse.errorMessageKey) {
							MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						}
					}
					cursor_clear();
				}
			});
		}

		var checkBox = $('#' + approvalGroupCheckBoxName).find('.'+checkBoxCSSClassName);
		var segmentId = "";
		for(var i = 0; i < checkBox.length; i++){
			if(segmentId == ""){
				segmentId = checkBox[i].getAttribute("data-memberGroupId");
			} else {
				segmentId = segmentId +","+checkBox[i].getAttribute("data-memberGroupId");
			}
		}

		var params = [];
		params.orgEntityId = orgEntityId;
		params.segmentId = segmentId;
		params.storeId = WCParamJS.storeId;
		params.authToken =  $("#authToken").val();
		params.URL = "URL";
		
		setCurrentId(approvalGroupCheckBoxName+"Icon");
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		var context = wcRenderContext.getRenderContextProperties("orgMemberGroupContext");
		context["orgEntityId"] = orgEntityId;
		context["progressBarId"] = approvalGroupCheckBoxName+"Icon"
		wcService.invoke("AjaxApprovalGroupUpdate", params);
	},
	
	preSelectAssignedMemberGroup:function(selectedGroupIds){
		var assignedGroups = $("#" + selectedGroupIds).val();
		var assignedGroupIds = assignedGroups.split(",");
		if(assignedGroupIds.length > 0){
			var checkBox = $('#memberGroupEdit').find('.arrowForDojoQuery');
			for(var i = 0; i < checkBox.length; i++){
				var roleId = checkBox[i].getAttribute("data-memberGroupId");
				
				for(var j = 0; j < assignedGroupIds.length; j++){
					if(assignedGroupIds[j] == roleId){
						$(checkBox[i]).addClass("arrow");
						$(checkBox[i]).attr("aria-checked","true");
						break;
					} else {
						$(checkBox[i]).removeClass("arrow");
						$(checkBox[i]).attr("aria-checked","false");
					}
				}
			}
		}
	}
};;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * Declares a new render context for the Organization Roles widget
 */
wcRenderContext.declare("orgRolesContext",["orgRolesRefreshArea"],{'orgEntityId':null, "progressBarId":null});

/** 
 * Declares a new refresh controller for the Organization Roles widget
 */
function declareOrgRolesController() {
	var myWidgetObj = $("#orgRolesRefreshArea");
	
	var baseURL = getAbsoluteURL() + 'OrgRolesDisplayViewV2';
	
	var myRCProperties = wcRenderContext.getRenderContextProperties("orgRolesContext");
	
	wcTopic.subscribe(["AjaxOrgRolesUpdate"], function() {
		myWidgetObj.refreshWidget("updateUrl", baseURL + "?" + getCommonParametersQueryString());
		setCurrentId(myRCProperties["progressBarId"]);
		submitRequest();
		cursor_wait();
		myWidgetObj.refreshWidget("refresh", myRCProperties);
	});

	myWidgetObj.refreshWidget({
		renderContextChangedHandler: function() {
			myWidgetObj.refreshWidget("updateUrl", baseURL + "?" + getCommonParametersQueryString());
			if(myRCProperties["refreshWidget"] != "false"){
				myWidgetObj.html("");
				myWidgetObj.refreshWidget("refresh", myRCProperties);
			}
		},

		postRefreshHandler: function() {
			cursor_clear();
			widgetCommonJS.removeSectionOverlay();
		}
	});
};

organizationRolesJS = {

	widgetShortName: "OrgRolesWidget", // My Name
	initialSelectedRolesList: [],

	getOrgRolesUpdateService:function(actionId,postSuccessHandler,postRefreshHandlerParameters){
		
		var service = wcService.getServiceById('AjaxOrgRolesUpdate');

		if(service == null || service == undefined){
			/**
			 */
			wcService.declare({
				id: "AjaxOrgRolesUpdate",
				actionId: "AjaxOrgRolesUpdate",
				url: getAbsoluteURL() + "AjaxRESTOrganizationRoleAssign",
				formId: ""
				
				/**
				 * Clear messages on the page.
				 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
				 */
				,successHandler: function(serviceResponse) {
					MessageHelper.hideAndClearMessage();
					if(this.postRefreshHandlerParameters == null || (this.postRefreshHandlerParameters != null && this.postRefreshHandlerParameters.showSuccessMessage != 'false')){
						MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("ORG_ROLES_UPDATED"));
					}
					if(this.postSuccessHandler != null){
						cursor_clear();
						this.postSuccessHandler(serviceResponse,this.postRefreshHandlerParameters);
					}
				}
				
				/**
				 * Displays an error message on the page if the request failed.
				 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
				 */
				,failureHandler: function(serviceResponse) {
					if (serviceResponse.errorMessage) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
					} else {
						if (serviceResponse.errorMessageKey) {
							MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						}
					}
					cursor_clear();
				}
			});
			service = wcService.getServiceById('AjaxOrgRolesUpdate');
		}
		if(actionId != null && actionId != 'undefined'){
			service.setActionId(actionId);
		}
		if(postSuccessHandler != null && postSuccessHandler != 'undefined'){
			service.setParam("postSuccessHandler", postSuccessHandler);
		} else {
			service.setParam("postSuccessHandler", null);
		}
		if(postRefreshHandlerParameters != null && postRefreshHandlerParameters != 'undefined'){
			service.setParam("postRefreshHandlerParameters", postRefreshHandlerParameters);
		} else {
			service.setParam("postRefreshHandlerParameters", null);
		}
		return service;
	},

	unassignRolesForOrg:function(serviceResponse,jsonObject){
		organizationRolesJS.updateOrganizationRoles(jsonObject.orgEntityId, jsonObject.approvalGroupCheckBoxName,jsonObject.checkBoxCSSClassName,jsonObject.action);
	},

	/**
	*/
	updateOrganizationRoles:function(orgEntityId, approvalGroupCheckBoxName, checkBoxCSSClassName,action){
		var scope = this;
		// Array of checked checkBoxes.
		var checkBoxes = $("#" + approvalGroupCheckBoxName).find('.'+checkBoxCSSClassName);
		var unAssignRoles = false;
		var assignRoles = false;
		var unAssignRoleIds = [];
		var assignRoleIds = [];
		var context = wcRenderContext.getRenderContextProperties("orgRolesContext");
		var params = [];
		params.memberId = orgEntityId;
		params.authToken = $("#authToken").val();
		params.storeId = WCParamJS.storeId;
		params.URL = "PassThisToAvoidException";
		
		checkBoxes.each($.proxy(function(i, entry){
			var roleId = entry.getAttribute("data-orgRolesId");
			if(this.initialSelectedRolesList.indexOf(roleId) == -1){
				// Initial list doesn't contain this roleId. It is selected now. Update at server side.
				assignRoleIds[assignRoleIds.length] = roleId;
			}	
		},scope));

		// Loop through initial selected roles list and see if it's still checked..
		$(scope.initialSelectedRolesList).each($.proxy(function(i, entry){
			var stillChecked = false;
			for(var i = 0; i < checkBoxes.length; i++){
				var selectedRoleId = checkBoxes[i].getAttribute("data-orgRolesId");
				if(selectedRoleId == entry){
					stillChecked = true;
					break;
				}
			}
			if(!stillChecked){
				unAssignRoleIds[unAssignRoleIds.length] = entry;
			}
		},scope));


		if(assignRoleIds.length > 0){
			assignRoles = true; // Need to assign some additional roles.
		}

		if(unAssignRoleIds.length > 0){
			unAssignRoles = true; // Need to un-assign some roles.
		}

		// After the service invoke, in the SuccessHandler call this postOrgRolesAssignHandler function with postRefreshHandlerParameters
		var postOrgRolesAssignHandler = null;
		var postRefreshHandlerParameters = null;


		if((action == 'undefined' || action == null || action == "assignRole") && assignRoles){
			// Start with assignRoles. Chain this service call with unAssignRoles call, if needed
			params.action = "assignRole";
			console.debug("assignRoleIds", assignRoleIds);
			for(var i = 0; i < assignRoleIds.length; i++){
				params["roleId"+i] = assignRoleIds[i];
			}

			if(unAssignRoles){
				postOrgRolesAssignHandler = scope.unassignRolesForOrg;
				context["refreshWidget"]  = "false"; // Do not refresh Roles widget immeditely. Wait for unAssign action to complete
				postRefreshHandlerParameters = {"orgEntityId":orgEntityId,"approvalGroupCheckBoxName":approvalGroupCheckBoxName,"checkBoxCSSClassName":checkBoxCSSClassName,"action":"unassignRole"};
				postRefreshHandlerParameters.showSuccessMessage = "false"; // Do not show success message till unAssign action is also done.
			}
		} else {
			action = "unassignRole"; //Nothing to assign.. Move the chain to unassignRole;
		}
		
		if(action == "unassignRole" && unAssignRoles){
			params.action ="unassignRole";
			console.debug("unAssignRoleIds", unAssignRoleIds);
			for(var i = 0; i < unAssignRoleIds.length; i++){
				params["roleId"+i] = unAssignRoleIds[i];
			}

			context["refreshWidget"]  = "true"; // Refresh widget
		}

		if(assignRoles || unAssignRoles){
			setCurrentId(approvalGroupCheckBoxName+"Icon");
			if(!submitRequest()){
				return;
			}
			cursor_wait();
			context["orgEntityId"] = orgEntityId;
			context["progressBarId"] = approvalGroupCheckBoxName+"Icon";
			var service = this.getOrgRolesUpdateService('AjaxOrgRolesUpdate', postOrgRolesAssignHandler, postRefreshHandlerParameters);
			wcService.invoke(service.getParam("id"), params);
		} else {
			MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("ORG_ROLES_UPDATE_NO_CHNAGE"));
		}
	},

	preSelectAssignedRoles:function(selectedRoleIds){
		this.initialSelectedRolesList = [];
		var assignedRoles = $("#" + selectedRoleIds).val();
		var assignedRoleIds = assignedRoles.split(",");
		if(assignedRoleIds.length > 0){
			var checkBox = $('#orgRolesEdit').find('.arrowForDojoQuery');
			for(var i = 0; i < checkBox.length; i++){
				var roleId = checkBox[i].getAttribute("data-orgRolesId");
				
				for(var j = 0; j < assignedRoleIds.length; j++){
					if(assignedRoleIds[j] == roleId){
						$(checkBox[i]).addClass("arrow");
						$(checkBox[i]).attr("aria-checked","true");
						this.initialSelectedRolesList[this.initialSelectedRolesList.length] = roleId;
						break;
					} else {
						$(checkBox[i]).removeClass("arrow");
						$(checkBox[i]).attr("aria-checked","false");
					}
				}
			}
		}
		console.debug("List of roleIds == "+this.initialSelectedRolesList);
	},

	/**
	* Subscribe to 'organizationChanged' topic and respond to it by updating the roles available for the selected newOrgId
	*/
	subscribeToOrgChangeEvent:function(currentOrgEntityId){
		var topicName = "organizationChanged";
		var renderContext = wcRenderContext.getRenderContextProperties("orgRolesContext");
		renderContext["orgEntityId"] = currentOrgEntityId;
		$(document).ready(function() {
			wcTopic.subscribe("organizationChanged", function(data){
				var renderContext = wcRenderContext.getRenderContextProperties("orgRolesContext");
				if(renderContext["orgEntityId"] != data.newOrgId){
					// Only update if currentOrgId has changed in the drop down box...
					setCurrentId("orgRolesUpdateProgressBar");
					if(!submitRequest()){
						return;
					}
					cursor_wait();
					wcRenderContext.updateRenderContext("orgRolesContext", {'orgEntityId' : data.newOrgId, 'roleDisplayType':'create', "progressBarId":'orgRolesUpdateProgressBar'});	
				}
			});
		});
	}
};;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * Declares a new render context for the Organization Summary widget - To display basic summary of organziation
 */
wcRenderContext.declare("orgSummaryDisplayContext",["orgSummary","orgSummaryAddressRefreshArea","orgSummaryContactInfoRefreshArea"],{
	'orgEntityId':null, 
	'orgSummaryType':null,
	'progressBarId':null, 
	'widgetrefreshtype':null
});

/** 
 * Declares a new refresh controller for the Organization Summary widget
 */
var declareOrgSummaryController = function (divId) {
	var myWidgetObj = $("#" + divId);
	
	var myRCProperties = wcRenderContext.getRenderContextProperties("orgSummaryDisplayContext");

	var baseURL = getAbsoluteURL() + 'OrgSummaryDisplayViewV2';
	
	wcTopic.subscribe(["AjaxOrgSummaryUpdate"], function() {
		myWidgetObj.refreshWidget("updateUrl", baseURL + "?" + getCommonParametersQueryString());
		//properties of widget should be always in lower case. widgetRefreshType doesn't work.
		if(myRCProperties['widgetrefreshtype'] == myWidgetObj.attr("widgetrefreshtype")){
			setCurrentId(myRCProperties["progressBarId"]);
			submitRequest();
			cursor_wait();
			myWidgetObj.refreshWidget("refresh", myRCProperties);
		}
	});

	myWidgetObj.refreshWidget({
		renderContextChangedHandler: function() {
			myWidgetObj.refreshWidget("updateUrl", baseURL + "?" + getCommonParametersQueryString());
			myWidgetObj.html("");
			myWidgetObj.refreshWidget("refresh", myRCProperties);
		},

		postRefreshHandler: function() {
			cursor_clear();
			widgetCommonJS.removeSectionOverlay();
		}
	});
};


organizationSummaryJS = {

	widgetShortName: "OrgSummaryWidget", // My Name
	mandatoryFields : "",
	OrganizationCreateEditViewName:"OrganizationCreateEditView",

	//infoJsonData :{'parameterNameUsedByCommand':'fieldNameInUI'}

	orgInfoJsonData : {"orgEntityName":"orgName"},
	orgValidationData : [ {"fieldName":"orgName", "type":"any", "maxLength":"128", "required":"true", "errorMessageKey":"ERROR_OrgName"}],

	contactInfoJsonData : {"email1":"email1", "phone1":"phone1", "fax1":"fax1"},
	contactValidationData : [
								{"fieldName":"email1", "type":"email", "maxLength":"256", "required":"true", "errorMessageKey":"ERROR_Email"},
								{"fieldName":"phone1", "type":"phone", "maxLength":"32", "required":"false", "errorMessageKey":"ERROR_Phone"},
								{"fieldName":"fax1", "type":"any", "maxLength":"32", "required":"false", "errorMessageKey":"ERROR_Fax"}
							],

	addressInfoJsonData : {"address1":"address1", "city":"city", "state":"state", "country":"country", "zipCode":"zipCode"},
	addressValidationData : [
									{"fieldName":"address1", "type":"any", "maxLength":"50", "required":"nls", "errorMessageKey":"ERROR_Address"},
									{"fieldName":"city", "type":"any", "maxLength":"128", "required":"nls", "errorMessageKey":"ERROR_City"},
									{"fieldName":"state", "type":"any", "maxLength":"128", "required":"nls", "errorMessageKey":"ERROR_State"},
									{"fieldName":"country", "type":"any", "maxLength":"128", "required":"nls", "errorMessageKey":"ERROR_Country"},
									{"fieldName":"zipCode", "type":"any", "maxLength":"40", "required":"nls", "errorMessageKey":"ERROR_ZipCode"}
								],

	summaryInfoJsonData:  {'description':'orgDescription','businessCategory':'orgBusinessCategory'},
	summaryValidationData: [
								{"fieldName":"orgDescription", "type":"any", "maxLength":"512", "required":"false", "errorMessageKey":"ERROR_OrganizationDescription"},
								{"fieldName":"orgBusinessCategory", "type":"any", "maxLength":"128", "required":"false", "errorMessageKey":"ERROR_BusinessCategory"}
							],

	/**
	* Subscribe to 'organizationChanged' topic and respond to it by updating the organization summary for the newOrgId
	*/
	subscribeToOrgChangeEvent:function(currentOrgEntityId){
		var topicName = "organizationChanged";

		var renderContext = wcRenderContext.getRenderContextProperties("orgSummaryDisplayContext");
		renderContext["orgEntityId"] = currentOrgEntityId;

		$(document).ready(function() {
			wcTopic.subscribe("organizationChanged", function(data){
				var renderContext = wcRenderContext.getRenderContextProperties("orgSummaryDisplayContext");
				if(renderContext["orgEntityId"] != data.newOrgId){
					setCurrentId("orgSummaryInfoProgressBar");
					if(!submitRequest()){
						return;
					}
					cursor_wait();
					wcRenderContext.updateRenderContext("orgSummaryDisplayContext", {'orgEntityId' : data.newOrgId, 'orgSummaryType':null, "progressBarId":null});	
				}
			});

		});
	},


	/**
	* Publishes 'currentOrgIdRequest' topic.
	* Organization List widget will respond to this event and publishes the "currentOrgId" topic along with the orgId.
	* Responds to "currentOrgId" topic event by refreshing the organization summary data for the newOrgId
	*/
	publishOrgIdRequest:function(){
		var topicName = "currentOrgIdRequest";
		var scope = this;
		$(document).ready(function() {
			wcTopic.subscribe("currentOrgId", function(data){
				if(data.requestor === scope.widgetShortName){
					// The original request was from me. So respond to this event.
					wcRenderContext.updateRenderContext("orgSummaryDisplayContext", {'orgEntityId' : data.newOrgId, 'orgSummaryType':null, "progressBarId":null});	
				}
			});
			// Set the requestor to my widgetShortName. 
			// Respond to follow-up events, only if the event published was in response to my request. 
			// The requestor attribute in the data helps to check this.
			var data = {"requestor":scope.widgetShortName};
			wcTopic.publish(topicName, data);
		});
	},

	redirectToCreateEditPage:function(orgEntityCreateEditViewName, actionType){
		if(actionType == 'E'){
			// Publish an event and get back the current organizaiton ID
			var topicName = "currentOrgIdRequest";
			var scope = this;
			$(document).ready(function() {	
				wcTopic.subscribe("currentOrgId", function(data){
					if(data.requestor == "CreateEditAction"){
						// The original request was from me. So respond to this event.
						document.location.href = orgEntityCreateEditViewName+"&orgEntityId="+data.newOrgId;
					}
				});
				// Set the requestor == CreateEditAction. 
				// Respond to follow-up events, only if the event published was in response to my request. 
				// The requestor attribute in the data helps to check this.
				var data = {"requestor":"CreateEditAction"};
				wcTopic.publish(topicName, data);
			});

		} else if(actionType == 'C'){
			// Publish an event and get back the current organizaiton ID
			var topicName = "currentOrgIdRequest";
			var scope = this;
			$(document).ready(function() {
				wcTopic.subscribe("currentOrgId", function(data){
					if(data.requestor == "CreateEditAction"){
						// The original request was from me. So respond to this event.
						var url = orgEntityCreateEditViewName;
						if(data != null && data.newOrgId != null){
							url = url + "&parentOrgEntityId="+data.newOrgId;
						}
						if(data != null && data.newOrgName != null){
							url = url + "&parentOrgEntityName="+data.newOrgName;
						}
						document.location.href = url;
					}
				});
				// Set the requestor == CreateEditAction. 
				// Respond to follow-up events, only if the event published was in response to my request. 
				// The requestor attribute in the data helps to check this.
				var data = {"requestor":"CreateEditAction"};
				wcTopic.publish(topicName, data);
			});
		}

	},

	postOrgCreation:function(serviceResponse,progressBarId){
		console.debug("serviceResponse after org creation ", serviceResponse);
		console.debug(progressBarId);
		console.debug("Start updating roles for "+serviceResponse.orgEntityId);

		var checkBox = $('#orgRolesEdit').find('.arrow');
		if(checkBox.length == 0){
			MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("ORG_ROLES_UPDATE_NO_CHNAGE"));
			this.postRolesCreation(serviceResponse);
			return false;
		}

		var params = [];
		params.memberId = serviceResponse.orgEntityId;
		params.authToken = $("#authToken").val();
		params.storeId = WCParamJS.storeId;
		params.URL = "PassThisToAvoidException";
		params.action = "assignRole";

		for(var i = 0; i < checkBox.length; i++){
			var roleId = checkBox[i].getAttribute("data-orgRolesId");
			params["roleId"+i] = roleId;
		}
		
		setCurrentId(progressBarId);
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		var rolesService = organizationRolesJS.getOrgRolesUpdateService('AjaxOrgRolesUpdateDuringOrgCreate', this.postRolesCreation, serviceResponse);
		wcService.invoke(rolesService.getParam("id"), params);

	},

	postRolesCreation:function(serviceResponse, jsonObject){
		var orgEntityId = null;
		if(jsonObject != null && jsonObject != 'undefined' && jsonObject.orgEntityId != null){
			orgEntityId = jsonObject.orgEntityId;
		} else if(serviceResponse != null && serviceResponse != 'undefined' && serviceResponse.orgEntityId != null){
			orgEntityId = serviceResponse.orgEntityId;
		}
		document.location.href = organizationSummaryJS.OrganizationCreateEditViewName+"?"+getCommonParametersQueryString()+"&orgEntityId="+orgEntityId;
	},

	invokeOrgEntityCreateService:function(params,progressBarId){
		
		var service = wcService.getServiceById('AjaxOrgEntityAdd');
		var scope = this;

		if(service == null || service == undefined){
			/**
			 */
			wcService.declare({
				id: "AjaxOrgEntityAdd",
				actionId: "AjaxOrgEntityAdd",
				url: getAbsoluteURL() + "AjaxRESTOrganizationRegistration",
				formId: ""
				
				/**
				 * Clear messages on the page.
				 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
				 */
				,successHandler: function(serviceResponse) {
					MessageHelper.hideAndClearMessage();
					MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("ORG_ENTITY_CREATED_UPDATING_ROLES"));
					scope.postOrgCreation(serviceResponse,progressBarId);
				}
				
				/**
				 * Displays an error message on the page if the request failed.
				 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
				 */
				,failureHandler: function(serviceResponse) {
					if (serviceResponse.errorMessage) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
					} else {
						if (serviceResponse.errorMessageKey) {
							MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						}
					}
					cursor_clear();
				}
			});
		}
		
		setCurrentId(progressBarId);
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		params.storeId = WCParamJS.storeId;
		params.URL = "PassThisToAvoidException";
		wcService.invoke("AjaxOrgEntityAdd", params);
	},

	invokeOrgEntityUpdateService:function(orgEntityId, params,jsonData,editSectionId){
		
		var service = wcService.getServiceById('AjaxOrgSummaryUpdate');

		if(service == null || service == undefined){
			/**
			 */
			wcService.declare({
				id: "AjaxOrgSummaryUpdate",
				actionId: "AjaxOrgSummaryUpdate",
				url: getAbsoluteURL() + "AjaxRESTOrganizationUpdate",
				formId: ""
				
				/**
				 * Clear messages on the page.
				 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
				 */
				,successHandler: function(serviceResponse) {
					MessageHelper.hideAndClearMessage();
					MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("ORG_SUMMARY_UPDATED"));
				}
				
				/**
				 * Displays an error message on the page if the request failed.
				 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
				 */
				,failureHandler: function(serviceResponse) {
					if (serviceResponse.errorMessage) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
					} else {
						if (serviceResponse.errorMessageKey) {
							MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						}
					}
					cursor_clear();
				}
			});
		}
		
		setCurrentId(editSectionId+'Icon');
		if(!submitRequest()){
			return;
		}
		cursor_wait();

		for(i in jsonData){
			var node = $("#" + jsonData[i])[0];
			if(node == null || node == 'undefined'){
				node = $("[name="+jsonData[i]+"]")[0];
			}
			console.debug(" node for", jsonData[i], node);
			params[i] = node.value;
		}

		params.orgEntityId = orgEntityId;
		params.storeId = WCParamJS.storeId;
		params.URL = "PassThisToAvoidException";

		wcService.invoke("AjaxOrgSummaryUpdate", params);
	},

	updateOrgSummaryDisplayContext:function(orgEntityId, refreshType, progressBarId){
		var context = wcRenderContext.getRenderContextProperties("orgSummaryDisplayContext");
		context["orgEntityId"] = orgEntityId;
		context["orgSummaryType"] = 'edit';
		context["progressBarId"] = progressBarId;

		// Reset all
		context["orgSummaryBasicEdit"] = 'false';
		context["orgSummaryAddressEdit"] = 'false';
		context["orgSummaryContactInfoEdit"] = 'false';
		context["widgetrefreshtype"] = refreshType;

		if(refreshType == 'basic'){
			context["orgSummaryBasicEdit"] = 'true';
		} else 	if(refreshType == 'address'){
			context["orgSummaryAddressEdit"] = 'true';
		} else 	if(refreshType == 'contactInfo'){
			context["orgSummaryContactInfoEdit"] = 'true';
		}
	},

	updateOrganizationSummary:function(orgEntityId, editSectionId){
		if(!this.validateData(this.summaryValidationData)) {
			return;
		} else {
			// Close Edit Section and display readOnly section.
			widgetCommonJS.toggleReadEditSection(editSectionId, 'read')
		}
		var params = [];
		this.updateOrgSummaryDisplayContext(orgEntityId,"basic",editSectionId+"Icon");
		this.invokeOrgEntityUpdateService(orgEntityId,params,this.summaryInfoJsonData,editSectionId);
	},

	updateOrganizationAddress:function(orgEntityId, editSectionId){
		
		if(!this.validateData(this.addressValidationData)){
			return;
		} else {
			// Close Edit Section and display readOnly section.
			widgetCommonJS.toggleReadEditSection(editSectionId, 'read')
		}

		var params = [];
		this.updateOrgSummaryDisplayContext(orgEntityId,"address",editSectionId+"Icon");
		this.invokeOrgEntityUpdateService(orgEntityId,params,this.addressInfoJsonData,editSectionId);
	},

	updateOrganizationContactInfo:function(orgEntityId, editSectionId){
		if(!this.validateData(this.contactValidationData)) {
			return;
		} else {
			// Close Edit Section and display readOnly section.
			widgetCommonJS.toggleReadEditSection(editSectionId, 'read')
		}
		var params = [];
		this.updateOrgSummaryDisplayContext(orgEntityId,"contactInfo", editSectionId+"Icon");
		this.invokeOrgEntityUpdateService(orgEntityId,params,this.contactInfoJsonData,editSectionId);

	},

	updateParameterValues:function(params,jsonData){
		for(i in jsonData){
			var node = $("#" + jsonData[i])[0];
			if(node == null || node == 'undefined'){
				node = $("[name="+jsonData[i]+"]")[0];
			} 
			if(node != null){
				console.debug("for ", i, "value is ",node.value);
				params[i] = node.value;
			} else {
				console.debug("For ",  i, "value is null");
			}
		}
	},
	createOrgEntity:function(progressBarId){

		if(!this.validateData(this.orgValidationData)) return false;
		var parentMemberId = organizationListJS.getCurrentData()['newOrgId'];
		if(parentMemberId == null || parentMemberId == 'undefined' || parentMemberId.length == 0 ){
			if($("#orgNameInputField")[0] != 'undefined' && $("#orgNameInputField")[0] != null){
				MessageHelper.formErrorHandleClient("orgNameInputField", Utils.getLocalizationMessage("ERROR_ParentOrgNameEmpty"));
				return false;
			}
		}
		//if(!this.validateData(this.summaryValidationData)) return false;
		if(!this.validateData(this.addressValidationData)) return false;
		if(!this.validateData(this.contactValidationData)) return false;

		var params = [];
		this.updateParameterValues(params,this.orgInfoJsonData);
		this.updateParameterValues(params,this.summaryInfoJsonData);
		this.updateParameterValues(params,this.addressInfoJsonData);
		this.updateParameterValues(params,this.contactInfoJsonData);

		params['parentMemberId'] = parentMemberId
		params['orgEntityType'] = 'O'; // Always create organization type. OrganizationalUnit type is not supported.
		params['addToRegisteredCustomersGroup'] = 'true'; // Make this new organization as part of RegisteredCustomers member group owned by the stores owning organization.
		this.invokeOrgEntityCreateService(params,progressBarId);
	},

	setMandatoryFields:function(fields){
		this.mandatoryFields = fields;
	},

	validateData:function(validationData){
		reWhiteSpace = new RegExp(/^\s+$/);
		for(var i = 0; i < validationData.length; i++){
			//console.debug("The validation data at ",i, "is ", validationData[i]);
			var data = validationData[i];
			var fieldName = data["fieldName"];
			var fieldType = data["fieldType"];
			var node = $("[name="+fieldName+"]")[0];
			var required = data["required"];
			var dataType = data["type"];
			var maxLength = data["maxLength"];
			var errorMessageKey = data["errorMessageKey"];


			if(node != null && node != 'undefined'){
				var value = node.value;
				console.debug("value == ",value, "for fieldName ",fieldName);
				console.debug("Requried == ",required);
				console.debug("set of mandatory fields == ",this.mandtoryFields);
				console.debug("Requried by NLS rule == ",this.mandatoryFields.indexOf(fieldName));
				// IsMandatory validation
				if(required == 'true' || (required == "nls" && this.mandatoryFields.indexOf(fieldName) != "-1")){
					if(value == "" || reWhiteSpace.test(value)){
						console.debug("empty .. show error message for ",node.id);
						if(node.tagName == "SELECT" || node.tagName == "select") {
							// for jquery select menu
							MessageHelper.formErrorHandleClient(node.id + "-button", Utils.getLocalizationMessage(errorMessageKey+"Empty"));
						} else {
							MessageHelper.formErrorHandleClient(node.id, Utils.getLocalizationMessage(errorMessageKey+"Empty"));
						}
						return false;
					}
				} 

				// MaxLength validation
				if(maxLength != "-1"){
					console.debug("max length == ",maxLength);
					if(!MessageHelper.isValidUTF8length(value, data["maxLength"])){ 
						MessageHelper.formErrorHandleClient(node.id, Utils.getLocalizationMessage(errorMessageKey+"TooLong"));
						return false;
					}
				}

				// Data Type validation
				if(dataType == "email"){
					if(!MessageHelper.isValidEmail(value)){
						MessageHelper.formErrorHandleClient(node.id, Utils.getLocalizationMessage("ERROR_INVALIDEMAILFORMAT"));
						return false;
					}
				} else if(dataType == "phone"){
					if(!MessageHelper.IsValidPhone(value)){
						MessageHelper.formErrorHandleClient(node.id, Utils.getLocalizationMessage("ERROR_INVALIDPHONE"));
						return false;
					}
				} else if(dataType == "numeric"){
					if(!MessageHelper.IsNumeric(value)){
						MessageHelper.formErrorHandleClient(node.id, Utils.getLocalizationMessage("ERROR_INVALID_NUMERIC"));
						return false;
					}
				}
			}
		}
		return true;
	},
	
	resetFormValue: function(target_name){
		var target = $("#" + target_name);
 		target.find("form").each(function(index, form){
			$(form)[0].reset();
			$(form).find("select.wcSelect").each(function(index, select){
				$(select).Select("refresh_noResizeButton");
			})
		});
 	}
};;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This file provides all the functions and variables to manage member info.
 * This file is included in all pages with organization users list actions.
 */

/**
 * This service allows admin to update member info
 * @constructor
 */
wcService.declare({
	id:"OrganizationUserInfoAdminUpdateMember",
	url:"AjaxRESTUserRegistrationAdminUpdate"

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();		
		MessageHelper.displayStatusMessage(MessageHelper.messages["ORGANIZATIONUSERINFO_UPDATE_SUCCESS"]);
	}
		
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}			
});


/**
 * This service allows admin to add/create new member
 * Upon successfully creating user, the successHandler will call 
 * UserRoleManagementJS.assignRole function
 * @constructor
 */
wcService.declare({
	id:"chainedAjaxUserRegistrationAdminAdd",
	url:"AjaxRESTUserRegistrationAdminAdd",
	formId:"Register"

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		if (typeof(UserRoleManagementJS) != 'undefined' && !UserRoleManagementJS.isEmptySelectedRoles()){
			UserRoleManagementJS.chainedAssignRole(serviceResponse.userId);
		}
		else {
			document.location.href = OrganizationUserInfoJS.getChainedServiceRediretUrl();
			cursor_clear();		
			MessageHelper.displayStatusMessage(MessageHelper.messages["ORGANIZATIONUSER_CREATE_SUCCESS"]);
		}
	}
		
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}			
});


 	
	/**
	 * This class defines the functions and variables that customers can use to create, update, and view user.
	 * @class The OrganizationUserInfoJS class defines the functions and variables that can be used to manage Organization users 
	 */
	OrganizationUserInfoJS ={		
		
		widgetShortName: "OrgUserUserInfoWidget",
		/** 
		 * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
		 * @private
		 */
		langId: "-1",
		
		/** 
		 * This variable stores the ID of the current store. Its default value is empty.
		 * @private
		 */
		storeId: "",
		
		/** 
		 * This variable stores the ID of the catalog. Its default value is empty.
		 * @private
		 */
		catalogId: "",	
		
		/** 
		 * This variable stores the redirect url for chained create user service upon success.
		 * 
		 */
		chainedServiceRedirectUrl: "",	
		
		
		/**
		 * Sets the common parameters for the current page. 
		 * For example, the language ID, store ID, and catalog ID.
		 *
		 * @param {Integer} langId The ID of the language that the store currently uses.
		 * @param {Integer} storeId The ID of the current store.
		 * @param {Integer} catalogId The ID of the catalog.
		 */
		setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
			cursor_clear();
		},	
		
		/**
		 * Initialize the URL of Buyer List widget controller. 	 
		 *
		 * @param {object} userDetailsUrl The userDetails controller's URL.
		 * @param {object} userAddressUrl The userAddress controller's URL.
		 */
		initOrganizationUserInfoControllerUrls:function(userDetailsUrl,userAddressUrl){
			$("#OrganizationUserInfo_userDetail_Widget").attr("refreshurl", userDetailsUrl);
			$("#OrganizationUserInfo_userAddress_Widget").attr("refreshurl", userAddressUrl);
		},
		
		/**
		 * Initialize the Parent org info that the buyer to be created under. Will be used for constructing url return
		 * to "Organizations and buyers" page with pre-selected org. 
		 *
		 * @param {object} parentOrgName The parent Organization name.
		 * @param {object} parentOrgId The parentOrganization ID.
		 */
		initializeParentOrgInfo:function(parentOrgName, parentOrgId){
			this._parentOrgEntityName = parentOrgName;
			this._parentOrgEntityId = parentOrgId;
		},
		
		/**
		 * Update member user account status to 'Enabled' or 'Disalbed', status 0 means disabled, status 1 means enabled.
		 * 
		 * @param formId The id of the form to update
		 */
		saveUserInfoChange:function(form){
			if (! this.validateAndPrepareUserInfo(form)) return;
			wcService.getServiceById('OrganizationUserInfoAdminUpdateMember').setFormId(form.id);
			wcService.getServiceById('OrganizationUserInfoAdminUpdateMember').setActionId("OrganizationUserInfoAdminUpdateMember_" + form.id);
			if(!submitRequest()){
				return;
			}			
			cursor_wait();
			wcService.invoke('OrganizationUserInfoAdminUpdateMember');
		},
		
		/**
		 * This function validate and prepare the update form for submit, the form is used to update user info.
		 * @param {string} form The name of the form containing personal information of the customer.
		 */
		validateAndPrepareUserInfo:function(form){
			if (form.name != 'UserAddress') {
				if(typeof(form.logonPassword_old) != 'undefined' && typeof(form.logonPasswordVerify_old) != 'undefined'){
					if(form.logonPassword_old.name == "logonPassword") {
						form.logonPassword_old.name = "logonPassword_old";
						form.logonPasswordVerify_old.name = "logonPasswordVerify_old";
					}
					/*check whether the values in password and verify password fields match, if so, update the password. */ 
					if (form.logonPassword_old.value.length != 0)
					{
						if(form.logonPassword_old.value!= form.logonPasswordVerify_old.value)
						{
							MessageHelper.formErrorHandleClient(form.logonPasswordVerify_old.id,MessageHelper.messages["PWDREENTER_DO_NOT_MATCH"]);
							return false; 
						}
						form.logonPassword_old.name = "logonPassword";
						form.logonPasswordVerify_old.name = "logonPasswordVerify";
					}
				}
			}
			
			/** Uses the common validation function defined in AddressHelper class for validating first name, 
			 *  last name, street address, city, country/region, state/province, ZIP/postal code, e-mail address and phone number. 
			 */

			if(!AddressHelper.validateAddressForm(form)){
				return false;
			}
			
			/* Checks whether the customer has registered for promotional e-mails. */
			if(form.sendMeEmail && form.sendMeEmail.checked ){
			    if (form.receiveEmail) form.receiveEmail.value = true;
			}
			else {
				if (form.receiveEmail) form.receiveEmail.value = false;
			}
			
			if(form.sendMeSMSNotification && form.sendMeSMSNotification.checked){
				if (form.receiveSMSNotification) form.receiveSMSNotification.value = true;
			}
			else {
				if (form.receiveSMSNotification) form.receiveSMSNotification.value = false;
			}

			if(form.sendMeSMSPreference && form.sendMeSMSPreference.checked){
				if (form.receiveSMS)form.receiveSMS.value = true;
			}
			else {
				if (form.receiveSMS) form.receiveSMS.value = false;
			}

			if(form.mobileDeviceEnabled != null && form.mobileDeviceEnabled.value == "true"){
				if(!MyAccountDisplay.validateMobileDevice(form)){
					return false;
				}
			}
			if(form.birthdayEnabled != null && form.birthdayEnabled.value == "true"){
				if(!MyAccountDisplay.validateBirthday(form)){
					return false;
				}
			}
			return true;
		},

		/**
		* Publishes 'currentOrgIdRequest' topic.
		* Organization List widget will respond to this event and publishes the "currentOrgId" topic along with the orgId.
		* Responds to "currentOrgId" topic event by refreshing the organization summary data for the newOrgId
		*/
		publishOrgIdRequest:function(){
			var topicName = "currentOrgIdRequest";
			var scope = this;
			
			wcTopic.subscribe("currentOrgId", function(data){
				if(data.requestor === scope.widgetShortName){
					// The original request was from me. So respond to this event.
					var parentMemberIdInput = $("#WC_OrganizationUserInfo_userDetails_Form_Input_parentMemberId");
					parentMemberIdInput.attr("value",data.newOrgId);
					scope._parentOrgEntityName = data.newOrgName;
					scope._parentOrgEntityId = data.newOrgId;
				}
				// Set the requestor to my widgetShortName. 
				// Respond to follow-up events, only if the event published was in response to my request. 
				// The requestor attribute in the data helps to check this.
				var data = {"requestor":scope.widgetShortName};
				wcTopic.publish(topicName, data);
			});
		},
		
		/**
		* Subscribe to 'organizationChanged' topic.
		* Organization User Info widget will respond to this topic event by updating the parentMemberId to newOrgId
		*/
		subscribeToOrgChange:function() {
			var topicName = "organizationChanged";
			var scope = this;
			wcTopic.subscribe(topicName, function(data){
				//console.debug("organizationChanged received");
				var parentMemberIdInput = $("#WC_OrganizationUserInfo_userDetails_Form_Input_parentMemberId");
				parentMemberIdInput.attr("value",data.newOrgId);
				scope._parentOrgEntityName = data.newOrgName;
				scope._parentOrgEntityId = data.newOrgId;
			});
		},
		 	
	 	resetFormValue: function(target){
	 		$(target).find("form").each(function(index, form){
				$(form)[0].reset();
				$(form).find("select.wcSelect").each(function(index, select){
					$(select).Select("refresh_noResizeButton");
				})
			});
	 	},
	 	
	 	subscribeToToggleCancel: function(){
	 		var topicName = "sectionToggleCancelPressed";
	 		var scope = this;
	 		wcTopic.subscribe(topicName, function(data){
	 			if (data.target === 'WC_OrganizationUserInfo_userDetails_pageSection' || data.target === 'WC_OrganizationUserInfo_userAddress_pageSection'){
	 				scope.resetFormValue(document.getElementById(data.target));
	 			}
	 		});
	 	},
	 	
	 	/**
	 	 * The function is called from add/create buyer page submit button, in 'chainedAjaxUserRegistrationAdminAdd' successHandler
	 	 * will call role assignment and member group widget's service.
	 	 * @param form the user details and address form to submit
	 	 * @url the url for the store page that will be displayed upon submit success.
	 	 */
	 	chainedServicePrepareSubmit: function(form, url) {
			var random = Math.random();
			var randomPassword = random.toString(36).slice(-7); // Get last 7 chars. Will add one numeric char to make it 8 char long...
			var randomInt = Math.floor((random * 9) + 1);
			randomPassword += randomInt; //Password should contain at least one numeric character...
			if($("#logonPassword")[0] == null || $("#logonPassword")[0] == undefined){
				$(form).append( $('<input>', {
					type: "hidden",
					value: randomPassword,
					name: "logonPassword",
					id: "logonPassword",
				}));
			}
			if($("#logonPasswordVerify")[0] == null || $("#logonPasswordVerify")[0] == undefined){
				$(form).append( $('<input>', {
					type: "hidden",
					value: randomPassword,
					name: "logonPasswordVerify",
					id: "logonPasswordVerify"
				}));
			}
			if($("#passwordExpired")[0] == null || $("#passwordExpired")[0] == undefined){
				$(form).append( $('<input>', {
					type: "hidden",
					value: "1",
					name: "passwordExpired",
					id: "passwordExpired"
				}));
			}

	 		if (!LogonForm.validatePrepareForm(form)){
	 			return;
	 		}
	 		this.chainedServiceRedirectUrl = url;
	 		wcService.getServiceById('chainedAjaxUserRegistrationAdminAdd').setFormId(form.id);
			if(!submitRequest()){
				return;
			}			
			cursor_wait();
			wcService.invoke('chainedAjaxUserRegistrationAdminAdd');
	 	},
	 	
	 	/**
	 	 * Return URL with pre-selected Organization info.
	 	 */
	 	getChainedServiceRediretUrl: function(){
	 		var url = this.chainedServiceRedirectUrl;
	 		if (url != '' && this._parentOrgEntityId !== undefined && this._parentOrgEntityId !== null){
	 			url = url + '&orgEntityId='+ this._parentOrgEntityId + '&orgEntityName='+ this._parentOrgEntityName;
	 		}
	 		return url;
	 	}
	 	
	};
 	
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------


/**
 * Declares a new refresh controller for read only user details section.
 */
function declareOrganizationUserInfo_userDetail_controller() {
	var myWidgetObj = $("#OrganizationUserInfo_userDetail_Widget");
	 
	/** 
	 * Refreshes the organization users list display if a list item is updated
	 * This function is called when a modelChanged event is detected. 
	 */
	wcTopic.subscribe(["OrganizationUserInfoAdminUpdateMember_UserDetails","AjaxRESTMemberPasswordResetByAdminOnBehalfForBuyer"], function() {
		myWidgetObj.refreshWidget("refresh");
	});
	
	myWidgetObj.refreshWidget({
		/** 
		 * Clears the progress bar
		 */
		postRefreshHandler: function() {
			widgetCommonJS.removeSectionOverlay();
			cursor_clear();
			//Initialize toggle events after page refresh
			widgetCommonJS.initializeEditSectionToggleEvent();
		}
	});
};

/**
 * Declares a new refresh controller for read only user address section.
 */
function declareOrganizationUserInfo_userAddress_controller() {
	var myWidgetObj = $("#OrganizationUserInfo_userAddress_Widget");
	
	/** 
	 * Refreshes the organization users list display if a list item is updated
	 * This function is called when a modelChanged event is detected. 
	 */
	wcTopic.subscribe(["OrganizationUserInfoAdminUpdateMember_UserAddress"], function() {
		myWidgetObj.refreshWidget("refresh");
	});
	
	myWidgetObj.refreshWidget({
		/** 
		 * Clears the progress bar
		 */
		postRefreshHandler: function() {
			widgetCommonJS.removeSectionOverlay();
			cursor_clear();
			//Initialize toggle events after page refresh
			widgetCommonJS.initializeEditSectionToggleEvent();
		}
	});
};;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This file provides all the functions and variables to manage buyers list and the items within.
 * This file is included in all pages with organization users list actions.
 */

/**
 * This service allows customer to create a new requisition list
 * @constructor
 */
wcService.declare({
	id:"OrganizationUsersListAdminUpdateMember",
	actionId:"OrganizationUsersListAdminUpdateMember",
	url:"AjaxRESTUserRegistrationAdminUpdate",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();		
		MessageHelper.displayStatusMessage(MessageHelper.messages["ORGANIZATIONUSERSLIST_UPDATE_USERSTATUS_SUCCESS"]);
	}
		
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}			
});

/**
 * This class defines the functions and variables that customers can use to create, update, and view their buyers list.
 * @class The OrganizationUsersListJS class defines the functions and variables that customers can use to manage their buyers list, 
 */
OrganizationUsersListJS ={		
	
	widgetShortName: "OrgUsersListWidget",
	/** 
	 * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
	 * @private
	 */
	langId: "-1",
	
	/** 
	 * This variable stores the ID of the current store. Its default value is empty.
	 * @private
	 */
	storeId: "",
	
	/** 
	 * This variable stores the ID of the catalog. Its default value is empty.
	 * @private
	 */
	catalogId: "",	
	
	viewUserURL: "",
	
	addUserURL: "",
	
	/**
	 * Sets the common parameters for the current page. 
	 * For example, the language ID, store ID, and catalog ID.
	 *
	 * @param {Integer} langId The ID of the language that the store currently uses.
	 * @param {Integer} storeId The ID of the current store.
	 * @param {Integer} catalogId The ID of the catalog.
	 * @param {Integer} authToken The authToken for current user to perform operation on server.
	 * @param {String} viewUserURL The URL for viewing and editing user.
	 * @param {String} addUserURL The URL for adding a user.
	 */
	setCommonParameters:function(langId,storeId,catalogId,authToken,viewUserURL,addUserURL){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;
		this.authToken = authToken;
		this.viewUserURL = viewUserURL;
		this.addUserURL = addUserURL;
		cursor_clear();
	},	
	
	/**
	 * Initialize the URL of Buyer List widget controller. 	 
	 *
	 * @param {object} widgetUrl The controller's URL.
	 */
	initOrganizationUsersListUrl:function(widgetUrl){
		$("#OrganizationUsersListTable_Widget").attr("refreshurl", widgetUrl);
	},
	
	/**
	 * Initial context with Organization info.
	 */
	initContextOrgEntity:function(orgEntityId, orgEntityName){
		wcRenderContext.getRenderContextProperties("OrganizationUsersListTable_Context").orgEntityId = orgEntityId;
		wcRenderContext.getRenderContextProperties("OrganizationUsersListTable_Context").orgEntityName = orgEntityName;
	},
	
	/**
	 * Search for Organization users use the search terms specified in the toolbar search form.
	 * 
	 * @param formId	The id of toolbar search form element.
	 */
	doSearch:function(formId){
		var form = $("#" + formId);
		this.updateContext({"beginIndex":"0", "userFirstName":form[0].userFirstName.value, "userLastName":form[0].userLastName.value, "userLogonId":form[0].userLogonId.value, "userRoleId":form[0].userRoleId.value, "userAccountStatus":form[0].userAccountStatus.value});
	},
	
	/**
	 * Clear the context search term value set by search form
	 */
	reset:function(){
		this.updateContext({"beginIndex":"0", "userFirstName":"", "userLastName":"", "userLogonId":"", "userRoleId":"", "userAccountStatus":""});
	},
	
	/**
	 * Save the toolbar aria-expanded attribute value
	 */
	saveToolbarStatus:function(){
		var toolbar = $("#OrganizationUsersList_toolbar");
		if (toolbar !== undefined && toolbar !== null){
			this.toolbarExpanded = toolbar.attr("aria-expanded");
		}
	},
	
	/**
	 * Restore the toolbar aria-expanded attribute, called by post refresh handler
	 */
	restoreToolbarStatus:function(){
		if (this.toolbarExpanded !== undefined && this.toolbarExpanded !== null){
			$("#OrganizationUsersList_toolbar").attr("aria-expanded", this.toolbarExpanded);
		}
	},
	
	/**
	 * Update the OrganizationUsersListTable context with given context object.
	 * 
	 * @param context The context object to update
	 */
	updateContext:function(context){
		this.saveToolbarStatus();
		if(!submitRequest()){
			return;
		}			
		cursor_wait();
		wcRenderContext.updateRenderContext("OrganizationUsersListTable_Context", context);
	},
	
	/**
	 * Update member user account status to 'Enabled' or 'Disalbed', status 0 means disabled, status 1 means enabled.
	 * 
	 * @param memberId The is of the member to be enable or disable
	 * @param status The '0' or '1' status
	 */
	updateMemberStatus:function(memberId, status){
		var params = {};
		params.URL = "StoreView"; //old command still check the presence of the 'URL' parameter
		params.storeId = this.storeId;
		params.langId = this.langId;
		params.userId = memberId;
		params.userStatus = status;
		params.authToken = this.authToken;
		this.saveToolbarStatus();
		if(!submitRequest()){
			return;
		}			
		cursor_wait();
		wcService.invoke('OrganizationUsersListAdminUpdateMember',params);
	},
	
	/**
	 * Redirect to add user detail page.
	 */
	addUser:function(){
		var orgEntityId = wcRenderContext.getRenderContextProperties("OrganizationUsersListTable_Context")['orgEntityId'];
		var orgName = wcRenderContext.getRenderContextProperties("OrganizationUsersListTable_Context")['orgEntityName'];
		//if (parentMemberId == "") parentMemberId = "7000000000000000801"; 
		var URL = this.addUserURL + "&orgEntityId=" + orgEntityId + "&orgEntityName=" + orgName;
		setPageLocation(URL);
	},
	
	/**
	 * Redirect to view user details page.
	 * 
	 * @param memberId The ID of the user
	 */
	viewDetails:function(memberId){
		var URL = this.viewUserURL + "&memberId=" + memberId;
		setPageLocation(URL);
		return false;
	},
	
	/**
	 * Update context to show page according specific number.
	 * 
	 * @param data The data for updating context.
	 */
	showPage:function(data){
		var pageNumber = data['pageNumber'];
		var pageSize = data['pageSize'];
		pageNumber = parseInt(pageNumber);
		pageSize = parseInt(pageSize);
		var beginIndex = pageSize * ( pageNumber - 1 );
		setCurrentId(data["linkId"]);
		//client has no way to change pageSize, so default pageSize defined in EnvironmentSetup.jspf will be used
		this.updateContext({"beginIndex":beginIndex});
	},
	
	/**
	* Publishes 'currentOrgIdRequest' topic.
	* Organization List widget will respond to this event and publishes the "currentOrgId" topic along with the orgId.
	* Responds to "currentOrgId" topic event by refreshing the organization summary data for the newOrgId
	*/
	publishOrgIdRequest:function(){
		var topicName = "currentOrgIdRequest";
		var scope = this;
		$(document).ready(function() {
			wcTopic.subscribe("currentOrgId", function(data){
				if(data.requestor === scope.widgetShortName){
					// The original request was from me. So respond to this event.
					scope.toolbarExpanded = "false";
					if (data.newOrgId.replace(/^\s+|\s+$/g, '') == ''){
						return;
					}
					if(!submitRequest()){
						return;
					}			
					cursor_wait();
					wcRenderContext.updateRenderContext("OrganizationUsersListTable_Context", {"beginIndex":"0", "userFirstName":"", "userLastName":"", "userLogonId":"", "userRoleId":"", "userAccountStatus":"","orgEntityId" : data.newOrgId, "orgEntityName": data.newOrgName});
				}
			});
			// Set the requestor to my widgetShortName. 
			// Respond to follow-up events, only if the event published was in response to my request. 
			// The requestor attribute in the data helps to check this.
			var data = {"requestor":scope.widgetShortName};
			wcTopic.publish(topicName, data);
		});
	},
	
	/**
	* Subscribe to 'organizationChanged' topic.
	* Organization Users List widget will respond to this topic event by refreshing the organization user list data for the newOrgId
	*/
	subscribeToOrgChange:function(data) {
		var topicName = "organizationChanged";
		var scope = this;
		$(document).ready(function() {
			wcTopic.subscribe(topicName, function(data){
				//console.debug("organizationChanged received");
				var renderContext = wcRenderContext.getRenderContextProperties("OrganizationUsersListTable_Context");
				if(renderContext["orgEntityId"] != data.newOrgId){
					scope.toolbarExpanded = "false";
					submitRequest();
					cursor_wait();
					wcRenderContext.updateRenderContext("OrganizationUsersListTable_Context", {"beginIndex":"0", "userFirstName":"", "userLastName":"", "userLogonId":"", "userRoleId":"", "userAccountStatus":"","orgEntityId" : data.newOrgId, "orgEntityName": data.newOrgName});
				}
			});
		});
	}
};;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------


/**
 * Declares a new render context for creating a new list.
 */
wcRenderContext.declare("OrganizationUsersListTable_Context",["OrganizationUsersListTable_Widget"],{"beginIndex":"0", "userFirstName":"", "userLastName":"", "userLogonId":"", "userRoleId":"", "userAccountStatus":"", "orgEntityId":"", "OrgEntityName":""},"");

/**
 * Declares a new refresh controller for creating a new List.
 */
function declareOrganizationUsersListTable_controller() {
	var myWidgetObj = $("#OrganizationUsersListTable_Widget");
	
	var myRCProperties = wcRenderContext.getRenderContextProperties("OrganizationUsersListTable_Context");
	
	/** 
	 * Refreshes the organization users list display if a list item is updated
	 * This function is called when a modelChanged event is detected. 
	 */
	wcTopic.subscribe(["OrganizationUsersListAdminUpdateMember"], function() {
		myWidgetObj.refreshWidget("refresh", myRCProperties);
	});

	myWidgetObj.refreshWidget({
		/** 
		 * Refreshes the list table display if an item is updated.
		 * This function is called when a render context event is detected. 
		 */	
		renderContextChangedHandler: function() {
			myWidgetObj.html("");
			myWidgetObj.refreshWidget("refresh", myRCProperties);
		},
	
		/** 
		 * Clears the progress bar
		 */
		postRefreshHandler: function() {
			OrganizationUsersListJS.restoreToolbarStatus();
			cursor_clear();			 
		}
	});
};;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

function AddToRequisitionListsJS(storeId, catalogId, langId, dropDownMenuId, selectListMenuId, createListMenuId, listTypeMenuId, listNameFieldId, listTypeFieldId, addResultMenuId, buttonStyle, jsObjectName) {

    this.storeId = storeId;
    this.catalogId = catalogId;
    this.langId = langId;
    this.dropDownMenuId = dropDownMenuId;
    this.selectListMenuId = selectListMenuId;
    this.createListMenuId = createListMenuId;
    this.listTypeMenuId = listTypeMenuId;
    this.listNameFieldId = listNameFieldId;
    this.listTypeFieldId = listTypeFieldId;
    this.addResultMenuId = addResultMenuId;
    this.buttonStyle = buttonStyle;

    this.jsObjectName = jsObjectName;

    this.dropDownVisible = false;

    this.dropDownInFocus = false;

    this.pageName = "";
    this.params = {};

    var eventName = "";

    this.dropDownMenuId = "";
    this.createListMenuId = "";
    this.addResultMenuId = "";
    this.addSingleSKU = false;
    this.addBundle = false;
    this.addPDK = false;
    var product_id = 0;

    var quantity = 1; // One item to add to list by default
    var catEntryId = 0;

    var catEntryResolved = false;
	
	this.addDK = false;
	var configurationXML = "";
	

    /**
     * Re-initializes variables when product is successfully added to a list
     */
    this._initialize = function () {
        this.someRadioButtonChecked = false;
        this.createListDetailsMenuOpen = false;
        this.listTypeMenuOpen = false;
        this.dropDownOpen = false;
        this.addSingleSKU = false;
        this.addBundle = false;
        this.params.status = 'Y'; // Default to private list
    };

    /**
     * Setter for topic.subscribe callback
     */
    this.setQuantity = function (newQuantity) {
        if (newQuantity != '') {
            quantity = newQuantity;
        }
    };
    /**
     * Getter for topic.subscribe callback
     */
    this.getQuantity = function () {
        return quantity;
    };
    /**
     * Setter for topic.subscribe callback
     */
    this.setCatEntryId = function (newCatEntryId, newProductId) {
        if (newCatEntryId != null) {
            catEntryResolved = true;
            catEntryId = newCatEntryId;
            product_id = newProductId;
        } else {
            catEntryResolved = false;
        }

    };
    /**
     * Getter for topic.subscribe callback
     */
    this.getCatEntryId = function () {
        return catEntryId;
    };

    /**
     * Sets product ID to be added to cart
     */
    this.setProductId = function (newProductId) {
        product_id = newProductId;
    };

    /**
     * sets whether a PDK is being added to the list
     */
    this.setAddPDK = function (addpdk) {
        this.addPDK = addpdk;
    };

	/**
	 * sets whether a DK is being added to the requisition list
	 */
	this.setAddDK = function(adddk) {
		this.addDK = adddk;
	};

	/**
	 * sets the configuration xml of the DK
	 */
	this.setConfigurationXML = function(configXML) {
		this.configurationXML = configXML;
	};
	
	/**
	 * Converts xml accepted form to < >
	 * @param {String} str, String to be converted
	 * @return {String} converted string
	 */
	this.unEscapeXml =  function(str){
		return str.replace(/&lt;/gm, "<").replace(/&gt;/gm, ">").replace(/&#034;/gm,"\"");
	};
	
	
    /**
     * Hides the dropdown
     * @param dropDownId - dropdown node
     */
    this._hideDropDownMenu = function (dropDownId) {
        Utils.ifSelectorExists("#" + dropDownId, function (dropDown) {
            dropDown.css("display", "none");
            $('#grayOut').css("display", "none");
            $('#grayOutPopup').css("display", "none");

            this.dropDownVisible = false;
            this.dropDownInFocus = false;
            this.dropDownOpen = false;
        }, this);

        if (document.removeEventListener) {
            document.removeEventListener("keydown", this.trapTabKey, true);
        }
    };

    /**
     * Shows the dropdown
     * @param dropDownId - dropdown node id
     * @param resolveCatentry - if true, then catentry must be resolved before showing drop down menu
     */
    this._showDropDownMenu = function (dropDownId, resolveCatentry) {
        if (resolveCatentry && !catEntryResolved) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_SL_RESOLVED_SKU'));
            return;
        }

        Utils.ifSelectorExists("#" + dropDownId, function (dropDown) {
            dropDown.css("display", "block");
            var radioButtons = $('.radioButton', dropDown);
            if (radioButtons.length) {
                radioButtons[0].focus();
            }
            $('#grayOut').css("display", "block");
            $('#grayOutPopup').css("display", "block");

            this.dropDownVisible = true;
            this.dropDownInFocus = true;
            this.dropDownOpen = true;
            MessageHelper.hideAndClearMessage();
        }, this);

        if (document.addEventListener) {
            document.addEventListener("keydown", this.trapTabKey, true);
        }
    };

    /**
     * Hides the list of requisition lists
     */
    this._hideSelectList = function () {
        $("#" + this.selectListMenuId).css("display", "none");
    };

    /**
     * Shows the list of requisition lists
     */
    this._showSelectList = function () {
        $("#" + this.selectListMenuId).css("display", "block");
    };

    /**
     * Traps the tab key when in the popup
     * @event the key event
     */
    this.trapTabKey = function (event) {
        if (event.keyCode === KeyCodes.TAB) {
            var popup = $('.requisitionListContent.popup').toArray().find(function (a_popup) {
                return a_popup.offsetHeight !== 0;
            });

            if (popup) {
                var visibleFocusableItems = $('[tabindex$=\"0\"]', popup).toArray().filter(function (a_item) {
                    return a_item.offsetHeight !== 0; // visible
                });
                var focusedItem = document.activeElement;
                var numberOfFocusableItems = visibleFocusableItems.length;
                var focusedItemIndex = visibleFocusableItems.indexOf(focusedItem);

                if (event.shiftKey) {
                    //back tab - if focused on first item and user presses back-tab, go to the last focusable item
                    if (focusedItemIndex == 0) {
                        event.preventDefault();
                        visibleFocusableItems[numberOfFocusableItems - 1].focus();
                    }
                } else {
                    //forward tab - if focused on the last item and user presses tab, go to the first focusable item
                    if (focusedItemIndex == numberOfFocusableItems - 1) {
                        event.preventDefault();
                        visibleFocusableItems[0].focus();
                    }
                }
            }
        }
    };

    /**
     * Toggle showing the requisition list drop down
     * @param showSelectList - optionally choose whether the list of requisition lists should be affected by the toggle
     * @param resolveCatentry - optionally choose whether or not catentry needs to be resolved (defaults to true)
     * @param multipleSKUs - optionally choose whether or not we are adding multiple SKUs (e.g. from SKU list widget)
     * @param singleSkuId - optional single skuId being passed in from SKU list widget
     * @param addBundle - optionally choose whether or not we are adding a bundle
     */
    this.toggleDropDownMenu = function (showSelectList, resolveCatentry, multipleSKUs, singleSkuId, addBundle) {
        if (resolveCatentry == null) {
            resolveCatentry = true;
        }

        // Check to make sure quantity fields are populated when adding bundle
        if (addBundle) {
            for (var productId in shoppingActionsJS.productList) {
                var productDetails = shoppingActionsJS.productList[productId];
                var quantity = parseInt(productDetails.quantity);
                if (quantity == 0) {
                    continue;
                }
                if (productDetails.id == 0) {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
                    return;
                }
                if (isNaN(quantity) || quantity < 0) {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                    return;
                }
            }
            this.addBundle = true;
        }

        // Check to make sure quantity fields are populated if adding multiple SKUs
        if (multipleSKUs) {
            if (product_id in SKUListJS.quantityList) {
                var length = 0;
                for (var skuId in SKUListJS.quantityList[product_id]) {
                    var quantity = SKUListJS.quantityList[product_id][skuId];
                    if (!isPositiveInteger(quantity)) {
                        MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUTS_ERROR'));
                        return;
                    }
                    length++;
                }
                if (length == 0) {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUTS_ERROR'));
                    return;
                }
            } else {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUTS_ERROR'));
                return;
            }
        }

        // Check to make sure quantity field is populated when adding single SKU from SKU List widget
        if (singleSkuId) {
            var quantity = $("#" + singleSkuId + "_Mobile_Quantity_Input").val();
            if (!isPositiveInteger(quantity)) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }

            this.setQuantity(quantity);
            this.addSingleSKU = true;
        }

        if (this.dropDownOpen == false) {
            this._showDropDownMenu(dropDownMenuId, resolveCatentry);
        } else {
            this._hideDropDownMenu(dropDownMenuId);
        }
        if (showSelectList == false) {
            this._hideSelectList();
        } else {
            this._showSelectList();
        }
    };

    /**
     * Check a radio button
     * @param nodeToCheck - the radio button to check
     * @param listId - list's ID
     * @param radiovalue - list's name
     */
    this.checkRadioButton = function (nodeToCheck, listId, radioValue) {
        if (nodeToCheck) {
            $(".checked", "#" + dropDownMenuId).css("display", "none");
            $(".checked", nodeToCheck).css("display", "block");
            $(".radioButton", "#" + dropDownMenuId).attr("aria-checked", "false");
            $(nodeToCheck).attr("aria-checked", "true");
            if (radioValue !== undefined) {
                this.params.name = radioValue.replace(/&#039;/gm, "'");
            }
            this.params.requisitionListId = listId;
            this.someRadioButtonChecked = true;
        }
    };

    /**
     * Toggle showing the create list menu
     * @param state - state of the menu.  True = shown, false = hidden
     */
    this.toggleCreateListDetailsMenu = function (state) {
        // Only toggle the menu when the requested state is different from the current state
        if (this.createListDetailsMenuOpen == true && state == false) {
            $("#" + createListMenuId).css("display", "none");
            this.createListDetailsMenuOpen = false;
            $("#" + this.pageName + "scrollContainer").scrollTop($("#" + this.pageName + "scrollContainer")[0].scrollHeight);
        } else if (this.createListDetailsMenuOpen == false && state == true) {
            $("#" + createListMenuId).css("display", "block");
            this.createListDetailsMenuOpen = true;
            $("#" + this.pageName + "scrollContainer").scrollTop($("#" + this.pageName + "scrollContainer")[0].scrollHeight);
        }
    };

    /**
     * Handles a keyboard event on the list type menu
     */
    this.handleKeyEventListTypeMenu = function (event) {
        switch (event.keyCode) {
            case KeyCodes.UP_ARROW:
                event.preventDefault();
                if (this.params.status == 'Z') {
                    this.setListType('Y');
                }
                break;
            case KeyCodes.DOWN_ARROW:
                event.preventDefault();
                if (this.params.status == 'Y') {
                    this.setListType('Z');
                }
                break;
        }
    };

    /**
     * Toggle showing the list type menu when creating a new list
     */
    this.toggleListTypeMenu = function () {
        if (this.listTypeMenuOpen == true) {
            $("#" + listTypeMenuId).css("display", "none");
            this.listTypeMenuOpen = false;
            $("#" + this.pageName + "scrollContainer").scrollTop($("#" + this.pageName + "scrollContainer")[0].scrollHeight);
        } else {
            $("#" + listTypeMenuId).css("display", "block");
            this.listTypeMenuOpen = true;
            $("#" + this.pageName + "scrollContainer").scrollTop($("#" + this.pageName + "scrollContainer")[0].scrollHeight);
        }
    };

    /**
     * Set the type of list for the newly created list
     * @param listTypeToSet - 'Y' for private, 'Z' for shared/public
     */
    this.setListType = function (listTypeToSet) {
        if (this.params.status != listTypeToSet) {
            $("#" + listTypeFieldId + this.params.status).css("display", "none");
            this.params.status = listTypeToSet;
            $("#" + listTypeFieldId + this.params.status).css("display", "block");
            $("#" + this.pageName + "scrollContainer").scrollTop($("#" + this.pageName + "scrollContainer")[0].scrollHeight);
        }
    };


    /**
     * addSkus2RequisitionListAjax This function is used to add one or more SKUs to a requisition list using an AJAX call.
     **/
    this.addSkus2RequisitionListAjax = function () {
        if (this.someRadioButtonChecked == true) {
            params = {
                storeId: this.storeId,
                catalogId: this.catalogId,
                langId: this.langId,
                pageName: this.pageName,
                buttonStyle: this.buttonStyle,
                productId: product_id,
                name: this.params.name,
                status: this.params.status,
                requisitionListId: this.params.requisitionListId,
                addBundle: this.addBundle,
                addMultipleSKUs: 'true'
            };

            if (this.addSingleSKU) {
                var quantity = $("#" + catEntryId + "_Mobile_Quantity_Input").val();
                if (!isPositiveInteger(quantity)) {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                    return;
                }

                params["catEntryId_1"] = catEntryId;
                params["quantity_1"] = quantity;
            } else if (this.addBundle) {
                var i = 1;
                for (var prodId in shoppingActionsJS.productList) {
                    var productDetails = shoppingActionsJS.productList[prodId];
                    var quantity = parseInt(productDetails.quantity);
                    if (quantity == 0) {
                        continue;
                    }
                    if (productDetails.id == 0) {
                        MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
                        return;
                    }
                    if (isNaN(quantity) || quantity < 0) {
                        MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                        return;
                    }

                    params["catEntryId_" + i] = productDetails.id;
                    params["quantity_" + i] = quantity;
                    params["productId_" + i++] = prodId;
                }
            } else {
                //Get all of the SKUs and their quantities and pass in as parameters (e.g. catEntryId_1, quantity_1, catEntryId_2, quantity_2)
                if (product_id in SKUListJS.quantityList) {
                    var i = 1;
                    for (var skuId in SKUListJS.quantityList[product_id]) {
                        var quantity = SKUListJS.quantityList[product_id][skuId];
                        if (!isPositiveInteger(quantity)) {
                            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUTS_ERROR'));
                            return;
                        }
                        params["catEntryId_" + i] = skuId;
                        params["quantity_" + i++] = quantity;
                    }
                }
            }


            if (params.catEntryId_1 == null || params.quantity_1 == null) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUTS_ERROR'));
                return;
            }

            //For Handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            cursor_wait();

            if (this.createListDetailsMenuOpen) {
                params.name = $("#" + this.listNameFieldId).val().replace(/^\s+|\s+$/g, '');
                if (params.name == "") {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_SL_EMPTY_SL_NAME'));
                    return;
                }
            }
            wcService.invoke('addCatalogEntriesToCreateRequisitionList', params);
        } else {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_SL_LIST_NOT_CHOSEN'));
            return;
        }
    };

    /**
     * addOrderToRequisitionList This function is used to add an order to a requisition list.
     * @param {String} orderId the order Id being added to cart 	
     **/
    this.addOrderToRequisitionList = function () {
        if (this.someRadioButtonChecked == true) {
            params = {
                storeId: this.storeId,
                catalogId: this.catalogId,
                langId: this.langId,
                pageName: this.pageName,
                buttonStyle: this.buttonStyle,
                productId: product_id,
                name: this.params.name,
                status: this.params.status,
                requisitionListId: this.params.requisitionListId,
                addSavedOrder: 'true'
            };

            //Get all of the catEntryIds and their quantities and pass in as parameters (e.g. catEntryId_1, quantity_1, catEntryId_2, quantity_2)
            if (OrderListJS.quantityList != {}) {
                var i = 1;
                for (var orderId in OrderListJS.quantityList) {
                    for (var catEntryId in OrderListJS.quantityList[orderId]) {
                        var quantity = OrderListJS.quantityList[orderId][catEntryId];

                        params["catEntryId_" + i] = catEntryId;
                        params["quantity_" + i] = quantity;
                        i++;
                    }
                }
            }

            if (params.catEntryId_1 == null || params.quantity_1 == null) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('MYACCOUNT_SAVEDORDERLIST_EMPTY_ADD_TO_REQ_FAIL'));
                return;
            }

            //For Handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            cursor_wait();

            if (this.createListDetailsMenuOpen) {
                params.name = $("#" + this.listNameFieldId).val().replace(/^\s+|\s+$/g, '');
                if (params.name == "") {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_SL_EMPTY_SL_NAME'));
                    return;
                }
            }
            wcService.invoke('addOrderToCreateRequisitionList', params);
        } else {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_SL_LIST_NOT_CHOSEN'));
            return;
        }
    };

    /**
     * Add the product to a specific or new list
     */
    this.addToList = function () {
        if (this.someRadioButtonChecked == true) {
            params = {
                storeId: this.storeId,
                catalogId: this.catalogId,
                langId: this.langId,
                catEntryId: catEntryId,
                productId: product_id,
                pageName: this.pageName,
                buttonStyle: this.buttonStyle,
                name: this.params.name,
                status: this.params.status,
                requisitionListId: this.params.requisitionListId,
                quantity: quantity
            };
            if (quantity < 1) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }
            if (!submitRequest()) {
                return;
            }
            cursor_wait();
            if (this.createListDetailsMenuOpen) {
                params.name = $("#" + this.listNameFieldId).val().replace(/^\s+|\s+$/g, '');
                if (params.name == "") {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_SL_EMPTY_SL_NAME'));
                    return;
                }
            }
            if (this.addPDK) {
                wcService.getServiceById("addToCreateRequisitionList").setUrl(getAbsoluteURL() + "AjaxRESTRequisitionListConfigurationAdd");
            }
            wcService.invoke('addToCreateRequisitionList', params);
        } else {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_SL_LIST_NOT_CHOSEN'));
            return;
        }
    };

    /**
     * Add the product to a specific or new list
     */
    this.moveToList = function (requisitionOrderItemId) {
        if (this.someRadioButtonChecked == true) {
            params = {
                storeId: this.storeId,
                catalogId: this.catalogId,
                langId: this.langId,
                catEntryId: catEntryId,
                productId: product_id,
                pageName: this.pageName,
                buttonStyle: this.buttonStyle,
                name: this.params.name,
                status: this.params.status,
                requisitionListId: this.params.requisitionListId,
                requisitionOrderItemId: requisitionOrderItemId,
                quantity: quantity
            };
            if (quantity < 1) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }
            if (!submitRequest()) {
                return;
            }
            cursor_wait();
            if (this.createListDetailsMenuOpen) {
                params.name = $("#" + this.listNameFieldId).val().replace(/^\s+|\s+$/g, '');
                if (params.name == "") {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_SL_EMPTY_SL_NAME'));
                    return;
                }
            }
			if (this.addPDK || this.addDK) {
				if (this.addDK){
					params.configurationXML = this.unEscapeXml( this.configurationXML);
				}
				wcService.getServiceById("addToCreateRequisitionListAndDeleteFromCart").setUrl(getAbsoluteURL() + "AjaxRESTRequisitionListConfigurationAdd");
			}
            wcService.invoke('addToCreateRequisitionListAndDeleteFromCart', params);
        } else {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_SL_LIST_NOT_CHOSEN'));
            return;
        }
    };

    /**
     * Hide and reset widget after successfully adding an item to a list
     */
    this.continueShopping = function () {
        Utils.ifSelectorExists("#" + addResultMenuId, function ($addResultMenu) {
            $addResultMenu.css("display", "none");
            this.toggleDropDownMenu(true);
            this._initialize();

            if (document.removeEventListener) {
                document.removeEventListener("keydown", this.trapTabKey, true);
            }

            $("#" + this.pageName + "addToShoppingListBtn").focus();
        }, this);
    };

    /**
     * Service declaration to add a catalog entry to a requisition list.  List is created if it does not exist.
     */
    wcService.declare({
        id: "addToCreateRequisitionList",
        actionId: "addToCreateRequisitionList",
        url: getAbsoluteURL() + "AjaxRequisitionListUpdateItem",
        formId: "",

        successHandler: function (serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();

            var productName = "";
            // Get the product or SKU name
            if ($("#ProductInfoName_" + serviceResponse.productId).length) {
                productName = $("#" + "ProductInfoName_" + serviceResponse.productId).val();
            } else if ($("#ProductInfoName_" + catEntryId).length) {
                productName = $("#" + "ProductInfoName_" + catEntryId).val();
            }

            var productThumbnail = "";
            // Get the product's image or SKU image
            if ($("#ProductInfoImage_" + serviceResponse.productId).length) {
                productThumbnail = $("#" + "ProductInfoImage_" + serviceResponse.productId).val();
            } else if ($("#ProductInfoImage_" + catEntryId).length) {
                productThumbnail = $("#" + "ProductInfoImage_" + catEntryId).val();
            }

            // Refresh the widget's refresh area and show item was added to a list
            wcRenderContext.updateRenderContext("requisitionLists_content_context", {
                "showSuccess": "true",
                "listName": serviceResponse.name,
                "productName": productName,
                "productThumbnail": productThumbnail,
                "storeId": serviceResponse.storeId,
                "buttonStyle": serviceResponse.buttonStyle,
                "parentPage": serviceResponse.pageName,
                "productId": serviceResponse.productId
            });

            // Keep polling until the continue shopping button is visible after AJAX update, then focus on it
            var poll = window.setInterval(function () {
                Utils.ifSelectorExists("#" + serviceResponse.pageName + "requisitionListsContShopButton", function ($contShopButton) {
                    if ($contShopButton.get(0).offsetHeight !== 0) {
                        window.clearInterval(poll);
                        $contShopButton.focus();
                        if (document.addEventListener) {
                            document.addEventListener("keydown", this.trapTabKey, true);
                        }
                    }
                }, this);
            }, 100);
        },

        failureHandler: function (serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    });

    /**
     * Service declaration to add a catalog entry to a requisition list.  List is created if it does not exist.
     */
    wcService.declare({
        id: "addToCreateRequisitionListAndDeleteFromCart",
        actionId: "addToCreateRequisitionListAndDeleteFromCart",
        url: getAbsoluteURL() + "AjaxRESTRequisitionListUpdateItem",
        formId: "",

        successHandler: function (serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();

            var productName = "";
            // Get the product or SKU name
            if ($("#catalogEntry_name_" + serviceResponse.requisitionOrderItemId).length) {
                productName = $("#" + "catalogEntry_name_" + serviceResponse.requisitionOrderItemId).html();
            }

            var productThumbnail = "";
            // Get the product's image or SKU image
            if ($("#catalogEntry_img_" + serviceResponse.requisitionOrderItemId).length) {
                productThumbnail = document.getElementById("catalogEntry_img_" + serviceResponse.requisitionOrderItemId).childNodes[1].src;
            }

            // Refresh the widget's refresh area and show item was added to a list
            wcRenderContext.updateRenderContext("requisitionLists_content_context", {
                "showSuccess": "true",
                "listName": serviceResponse.name,
                "productName": productName,
                "productThumbnail": productThumbnail,
                "storeId": serviceResponse.storeId,
                "buttonStyle": serviceResponse.buttonStyle,
                "parentPage": serviceResponse.pageName
            });

            CheckoutHelperJS.deleteFromCart(serviceResponse.requisitionOrderItemId);

            // Keep polling until the continue shopping button is visible after AJAX update, then focus on it
            var poll = window.setInterval(function () {
                Utils.ifSelectorExists("#" + serviceResponse.pageName + "requisitionListsContShopButton", function ($contShopButton) {
                    if ($contShopButton.get(0).offsetHeight != 0) {
                        window.clearInterval(poll);
                        $contShopButton.focus();
                        if (document.addEventListener) {
                            document.addEventListener("keydown", this.trapTabKey, true);
                        }
                    }
                });
            }, 100);

            // Remove the grayOut.  User does not have chance to cancel gray out themselves when catentry is deleted from the cart 
            $("#grayOut").css("display", "none");
            $("#grayOutPopup").css("display", "none");
        },

        failureHandler: function (serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
            cursor_clear();
        }
    });

    /**
     * Service declaration to add multiple catalog entries to a requisition list.  List is created if it does not exist.
     */
    wcService.declare({
        id: "addCatalogEntriesToCreateRequisitionList",
        actionId: "addCatalogEntriesToCreateRequisitionList",
        url: getAbsoluteURL() + "AjaxRESTRequisitionListUpdateItem",
        formId: "",

        successHandler: function (serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();

            var productName = [];
            var productThumbnail = [];
            var productSKU = [];

            // Get the SKU name and thumbnail urls
            for (var i = 1;
                ("catEntryId_" + i) in serviceResponse; i++) {
                var catEntryId = serviceResponse["catEntryId_" + i];
                var productId = serviceResponse["productId_" + i]; //Used when adding bundle

                var catEntryName = Utils.selectExistingElement(["#item_name_" + catEntryId, "#ProductInfoName_" + productId]);
                if (catEntryName) {
                    productName.push(catEntryName.val());
                    Utils.ifSelectorExists("#item_sku_" + catEntryId, function (catEntrySKU) {
                        productSKU.push("(" + catEntrySKU.val() + ")");
                    });
                }

                var catEntryThumbnail = Utils.selectExistingElement(["#item_thumbnail_" + catEntryId, "#ProductInfoImage_" + catEntryId]);
                if (catEntryThumbnail) {
                    productThumbnail.push(catEntryThumbnail.val());
                } else { //Get the thumbnail image from the JSON in the HTML in the bundle case
                    Utils.ifSelectorExists("#entitledItem_" + productId, function (element) {
                        var entitledItemJSON = JSON.parse(element.html());
                        for (var j in entitledItemJSON) {
                            var entitledItem = entitledItemJSON[j];
                            if (entitledItem.catentry_id == catEntryId) {
                                if (entitledItem.ItemThumbnailImage != null) {
                                    productThumbnail.push(entitledItem.ItemThumbnailImage);
                                    break;
                                }
                            }
                        }
                    });
                }
            }

            var type = "";
            if (serviceResponse.addBundle) {
                type = 'bundle';
            }

            // Refresh the widget's refresh area and show item was added to a list
            wcRenderContext.updateRenderContext("requisitionLists_content_context", {
                "showSuccess": "true",
                "listName": serviceResponse.name,
                "productName": productName,
                "productThumbnail": productThumbnail,
                "productSKU": productSKU,
                "storeId": serviceResponse.storeId,
                "buttonStyle": serviceResponse.buttonStyle,
                "parentPage": serviceResponse.pageName,
                "productId": serviceResponse.productId,
                "addMultipleSKUs": serviceResponse.addMultipleSKUs,
                "numberOfSKUs": i - 1,
                "type": type
            });

            // Keep polling until the continue shopping button is visible after AJAX update, then focus on it
            var poll = window.setInterval(function () {
                Utils.ifSelectorExists("#" + serviceResponse.pageName + "requisitionListsContShopButton", function ($contShopButton) {
                    if ($contShopButton.get(0).offsetHeight !== 0) {
                        window.clearInterval(poll);
                        $contShopButton.focus();
                        if (document.addEventListener) {
                            document.addEventListener("keydown", this.trapTabKey, true);
                        }
                    }
                }, this);
            }, 100);

            wcTopic.publish('SKUsAddedToReqList');
        },

        failureHandler: function (serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    });

    /**
     * Service declaration to add saved order to a requisition list.  List is created if it does not exist.
     */
    wcService.declare({
        id: "addOrderToCreateRequisitionList",
        actionId: "addOrderToCreateRequisitionList",
        url: getAbsoluteURL() + "AjaxRESTRequisitionListUpdateItem",
        formId: "",

        successHandler: function (serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();

            // Refresh the widget's refresh area and show item was added to a list
            wcRenderContext.updateRenderContext("requisitionLists_content_context", {
                "showSuccess": "true",
                "listName": serviceResponse.name,
                "storeId": serviceResponse.storeId,
                "buttonStyle": serviceResponse.buttonStyle,
                "parentPage": serviceResponse.pageName,
                "productID": serviceResponse.productId,
                "addSavedOrder": serviceResponse.addSavedOrder,
                "orderId": serviceResponse.orderId
            });

            // Keep polling until the continue shopping button is visible after AJAX update, then focus on it
            var poll = window.setInterval($.proxy(function () {
                Utils.ifSelectorExists("#" + serviceResponse.pageName + "requisitionListsContShopButton", function ($contShopButton) {
                    if ($contShopButton.get(0).offsetHeight != 0) {
                        window.clearInterval(poll);
                        $contShopButton.focus();
                        if (document.addEventListener) {
                            document.addEventListener("keydown", this.trapTabKey, true);
                        }
                    }
                }, this);
            }, this), 100);
        },

        failureHandler: function (serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    });

    if (jsObjectName != 'AddToRequisitionListJS') {
        this.pageName = jsObjectName.replace('AddToRequisitionListsJS', '');
    };
    this._initialize();
}

/**
* Declares a new refresh controller
for Add To Requisition List display.*/
var declareRequsitionListsContentController = function (widgetPrefix) {
    if (!wcRenderContext.checkIdDefined("requisitionLists_content_context")) {
        wcRenderContext.declare("requisitionLists_content_context", [], {
            "showSuccess": "false"
        });
    }
    var myWidgetObj = $("#" + widgetPrefix + "requisitionlists_content_widget");
    wcRenderContext.addRefreshAreaId("requisitionLists_content_context", widgetPrefix + "requisitionlists_content_widget");
    var myRCProperties = wcRenderContext.getRenderContextProperties("requisitionLists_content_context");


    /**
     * Declares a new render context for the Requisition List display.
     */
    var renderContextChangedHandler = function () {
            var widgetId = myRCProperties["parentPage"] + "requisitionlists_content_widget";
            if (widgetId === myWidgetObj.attr("id")) {
                // Only refresh the widget associated with parentPage
                myWidgetObj.refreshWidget("refresh", myRCProperties);
            };

        },



        postRefreshHandler = function () {
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }
    myWidgetObj.refreshWidget({
        renderContextChangedHandler: renderContextChangedHandler,
        postRefreshHandler: postRefreshHandler
    });
};
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------



/** 
 * @fileOverview This javascript provides the variables and methods to manipulate the product images, and for switching 
 * the tabs used on the product pages.
 * @version 1.5
 */
			
			/** This variable stores the identifier of the image currently used for a product */
			var currentAngleImgId="productAngleProdLi0";

			function changeThumbNail(angleImgId,imgsrc){
					if (currentAngleImgId != "") {
						if(document.getElementById(currentAngleImgId) != null){
							document.getElementById(currentAngleImgId).className ='';
						}
					}
					currentAngleImgId = angleImgId;
					document.getElementById(angleImgId).className ='selected';
					document.getElementById("productMainImage").src = imgsrc;
			};//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2014 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * Function to create javascript object InventoryStatusJS
 *
 * @param {Object} storeParams params specific to a store
 * @param {Object} catEntryParams params specific to base Item
 * @param {Array} physicalStores inventory details specific to physical store
 * 
 **/
function InventoryStatusJS(storeParams, catEntryParams, physicalStores, productId) {
    this.storeParams = storeParams;
    this.catEntryParams = catEntryParams;
    this.physicalStores = physicalStores;
    this.productId = productId;
    this.isFetchInventoryStatus = false;
    this.itemId = -1;

    /**
     * Setter for itemId
     * 
     * @param Integer catEntryId
     * @param Integer productId
     */
    this.setCatEntry = function (catEntryId, productId) {
        // if it is ItemBean, no need to set the attributes, since it is not required to resolve SKU
        if (this.catEntryParams.type != "ItemBean") {

            // hiding the availability section
            $("#InventoryStatus_Availability_Section_" + this.productId).css("display", "none");

            // showing the show availability link
            $("#InventoryStatus_ShowLink_Section_" + this.productId).css("display", "block");

            // If we are able to resolve the sku, then show the inventory status 
            if (catEntryId != -1) {
                this.itemId = catEntryId;
                this.checkAvailability(this.isFetchInventoryStatus);
                this.isFetchInventoryStatus = false;
            }
        }
    };

    /**
     * Restores the Inventory Availability section to the initial state if no SKU is resolved
     * 
     * @param Integer catEntryId
     * @param Integer productId
     */
    this.restoreDefaultState = function (catEntryId, productId) {
        if (catEntryId == null) {
            // hiding the availability section
            $("#InventoryStatus_Availability_Section_" + this.productId).css("display", "none");

            // showing the show availability link
            $("#InventoryStatus_ShowLink_Section_" + this.productId).css("display", "block");
        }
    };

    /**
     * After resolving the SKU for a product, checks the inventory status online 
     * and in the stores selected by the user 
     */
    this.checkAvailability = function (allowParallelCall) {
        MessageHelper.hideAndClearMessage();

        var params = this.setCommonParams();
        if (-1 == this.itemId) {
            MessageHelper.displayErrorMessage(storeNLS['ERR_RESOLVING_SKU']);
            return;
        }
        params.itemId = this.itemId;

        // hiding the show availability link
        $("#InventoryStatus_ShowLink_Section_" + this.productId).css("display", "none");

        setCurrentId('progressbar_' + this.productId);
        // if the call is during the page load, allow parallel calls, since there may be other ajax calls in progress
        if (!allowParallelCall) {
            // For Handling multiple clicks.
            if (!submitRequest()) {
                return;
            }
        }

        cursor_wait();
        wcService.invoke("getInventoryStatus_" + this.productId, params);
    };

    /**
     * Populate the contents of the inventory details section in the product display page with the JSON returned 
     * from the server. This is the callback function that is called after the AJAX call to get the inventory 
     * details successfully returns to the client.
     * 
     * @param {object} serviceRepsonse The JSON response from the service.
     * @param {object} ioArgs The arguments from the service call.
     */
    this.populateInvDetails = function (serviceResponse, ioArgs) {
        if (serviceResponse.onlineInventory) {
            // setting the online inventory status
            $("#InventoryStatus_OnlineStatus_Img_" + this.productId).replaceWith("<img id='InventoryStatus_OnlineStatus_Img_" + this.productId + "' src='" + imageDirectoryPath + styleDirectoryPath + serviceResponse.onlineInventory.image + "' alt='' border='0' />");
            $("#InventoryStatus_OnlineStatus_" + this.productId).text(serviceResponse.onlineInventory.status);

            // removing the in store section if present
            $("#InventoryStatus_InStore_Section_" + this.productId).detach();

            // check if the physical store section is present
            if ($("#InventoryStatus_InStore_Heading_" + this.productId).length) {
                // adding the empty store section
                $("#InventoryStatus_InStore_Heading_" + this.productId).after("<div id='InventoryStatus_InStore_Section_" + this.productId + "' class='sublist'>");

                this.physicalStores = serviceResponse.inStoreInventory.stores;
                // adding the store inventory details as child elements in the store section
                for (idx = 0; idx < serviceResponse.inStoreInventory.stores.length; idx++) {
                    var store = serviceResponse.inStoreInventory.stores[idx];

                    // adding the store name
                    $("#InventoryStatus_InStore_Section_" + this.productId).append("<a id='WC_InventoryStatus_Link_" + this.productId + "_store_" + (idx + 1) + "' href='javascript:InventoryStatusJS_" + this.productId + ".fetchStoreDetails(" + store.id + ");' class='store_name'>" + store.name + "</a>");
                    // adding clear div
                    $("#InventoryStatus_InStore_Section_" + this.productId).append("<div class='clear_float'></div>");
                    // adding the image status of store name
                    $("#InventoryStatus_InStore_Section_" + this.productId).append("<span> <img src='" + imageDirectoryPath + styleDirectoryPath + store.image + "' alt='" + store.altText + "' /> </span>");
                    // adding the text status of store name
                    $("#InventoryStatus_InStore_Section_" + this.productId).append("<span class='text'>" + store.statusText + "</span>");
                    // adding clear div
                    $("#InventoryStatus_InStore_Section_" + this.productId).append("<div class='clear_float'></div>");
                    // adding spacer
                    $("#InventoryStatus_InStore_Section_" + this.productId).append("<div class='item_spacer_10px'></div>");
                }
                // add select store link
                $("#InventoryStatus_SelectStoreLink_" + this.productId).text(serviceResponse.inStoreInventory.checkStoreText);
            }

            // showing the availability section
            $("#InventoryStatus_Availability_Section_" + this.productId).css("display", "block");
        } else {
            MessageHelper.displayErrorMessage(storeNLS["INV_STATUS_RETRIEVAL_ERROR"]);
        }
        cursor_clear();
    };

    /**
     * This resolves the product SKUs to a single item by comparing the attributes selected by the user
     * 
     * @return {Integer} uniqueId, of the selected SKU.
     * 					 -1, if no match found
     */
    this.resolveSKU = function () {
        for (idx = 0; idx < this.catEntryParams.skus.length; idx++) {
            var matches = 0;
            var attributeCount = 0;
            for (attribute in this.catEntryParams.skus[idx].attributes) {
                attributeCount++;
                if (this.catEntryParams.attributes && this.catEntryParams.skus[idx].attributes[attribute] == this.catEntryParams.attributes[attribute]) {
                    matches++;
                } else {
                    break;
                }
            }
            if (matches == attributeCount) {
                return this.catEntryParams.skus[idx].id;
            }
        }
        return -1;
    };

    /**
     * Sets the store specific values such as storeId, catalogId and langId
     * to the params object and returns it
     * 
     * @return {Object} params with store specific values
     */
    this.setCommonParams = function () {
        var params = new Object();
        params.storeId = this.storeParams.storeId;
        params.catalogId = this.storeParams.catalogId;
        params.langId = this.storeParams.langId;
        return params;
    };

    /**
     * Show Store details popup after fetching the required details
     */
    this.fetchStoreDetails = function (storeId) {
        MessageHelper.hideAndClearMessage();

        var params = new Object();
        params.physicalStoreId = storeId;

        // For Handling multiple clicks.
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("getPhysicalStoreDetails_" + this.productId, params);
    };

    /**
     * Populate the contents of the store details section in the product display page with the JSON returned 
     * from the server. This is the callback function that is called after the AJAX call to get the inventory 
     * details successfully returns to the client.
     * 
     * @param {object} serviceRepsonse The JSON response from the service.
     * @param {object} ioArgs The arguments from the service call.
     */
    this.populateStoreDetails = function (serviceResponse, ioArgs) {
        var store = serviceResponse;

        // set unescaped working hours
        store.hours = this.unEscapeXml(serviceResponse.hours);

        // set inventory status
        var storeInventory = this.fetchInventoryStatus(ioArgs.physicalStoreId);

        // set store availability details
        store.imageTag = "<img src='" + imageDirectoryPath + styleDirectoryPath + storeInventory.image + "' alt='" + storeInventory.altText + "'/>";
        store.statusText = storeInventory.statusText;

        if (storeInventory.status == 'Available') {
            store.availabilityDetails = "(" + storeInventory.availableQuantity + ")"; // adding the available quantity
        } else if (storeInventory.status == 'Backorderable') {
            store.availabilityDetails = "(" + storeInventory.availableDate + ")"; // adding the available date
        } else {
            store.availabilityDetails = "";
        }
        var storeDetails = $("#Store_Details_Template_" + this.productId).html();
        $("#Store_Details_" + this.productId).html(Utils.substituteStringWithObj(storeDetails, store));

        // Display store details
        var popup = $("#InventoryStatus_Store_Details_" + this.productId).data("wc-WCDialog");
        if (popup) {
            closeAllDialogs(); //close other dialogs(quickinfo dialog, etc) before opening this. 				
            popup.open();
        } else {
            console.debug("InventoryStatus_Store_Details_" + this.productId + " does not exist");
        }
        cursor_clear();
    };

    /**
     * 
     */
    this.fetchInventoryStatus = function (storeId) {
        for (idx = 0; idx < this.physicalStores.length; idx++) {
            if (this.physicalStores[idx].id == storeId) {
                return this.physicalStores[idx];
            }
        }
        return {};
    };

    /**
     * Converts xml accepted form to < >
     * 
     * @param {String} str, String to be converted
     * 
     * @return {String} converted string
     */
    this.unEscapeXml = function (str) {
        var str = str.replace(/&lt;/gm, "<").replace(/&gt;/gm, ">");
        return str;
    };

    this.loadStoreLocator = function (storeLocatorUrl, bundleId) {
        var catalogEntryId = bundleId;
        if (null == catalogEntryId || '' == catalogEntryId) {
            catalogEntryId = this.itemId;
            if (-1 == catalogEntryId) {
                catalogEntryId = productId;
            }
        }
        loadLink(storeLocatorUrl + "&productId=" + catalogEntryId);
    }
}
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2014 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

if (typeof (MerchandisingAssociationJS) == "undefined" || MerchandisingAssociationJS == null || !MerchandisingAssociationJS) {

    MerchandisingAssociationJS = {
        storeParams: {},
        baseItemParams: {},
        merchandisingAssociations: [],
        associationIndex: 0,

        /**
         * Method to set values
         *
         * @param {Object} storeParams params specific to a store
         * @param {Object} baseItemParams params specific to base Item
         * @param {Array} merchandisingAssociations items associated with the base item
         * 
         **/
        setValues: function (storeParams, baseItemParams, merchandisingAssociations) {
            this.storeParams = storeParams;
            this.baseItemParams = baseItemParams;
            this.baseItemParams.quantity = 1;
            this.merchandisingAssociations = merchandisingAssociations;
        },

        /**
         * Setter for baseItemQuantity
         * 
         * @param Integer baseItemQuantity
         */
        setBaseItemQuantity: function (baseItemQuantity) {
            var baseItemQuantity = $.parseJSON(baseItemQuantity);
            // If the quantity is an object with multiple quantities
            if (baseItemQuantity.length) {
                for (idx = 0; idx < baseItemQuantity.length; idx++) {
                    for (idx2 = 0; idx2 < MerchandisingAssociationJS.baseItemParams.components.length; idx2++) {
                        if (MerchandisingAssociationJS.baseItemParams.components[idx2].skus) {
                            for (idx3 = 0; idx3 < MerchandisingAssociationJS.baseItemParams.components[idx2].skus.length; idx3++) {
                                if (MerchandisingAssociationJS.baseItemParams.components[idx2].skus[idx3].id == baseItemQuantity[idx].id) {
                                    MerchandisingAssociationJS.baseItemParams.components[idx2].id = baseItemQuantity[idx].id;
                                    break;
                                }
                            }
                        }
                        if (MerchandisingAssociationJS.baseItemParams.components[idx2].id == baseItemQuantity[idx].id) {
                            MerchandisingAssociationJS.baseItemParams.components[idx2].quantity = baseItemQuantity[idx].quantity;
                            break;
                        }
                    }
                }
                // If the quantity is a single value
            } else {
                MerchandisingAssociationJS.baseItemParams.quantity = baseItemQuantity;
            }
        },

        /**
         * Setter for baseItemAttributes
         * 
         * @param Integer baseItemQuantity
         */
        setBaseItemAttributes: function (baseItemAttributes) {
            this.baseItemParams.attributes = $.parseJSON(baseItemAttributes);
        },

        /**
         * Setter for baseItemAttributes. Retrieve product attributes from catentry object. 
         * 
         * @param Integer baseItemQuantity
         */
        setBaseItemAttributesFromProduct: function (catEntryId, productId) {
            var selectedAttributes = productDisplayJS.selectedAttributesList["entitledItem_" + productId];
            MerchandisingAssociationJS.setBaseItemAttributes(JSON.stringify(selectedAttributes));
        },

        /**
         * changeItem scrolls the associated catEntries up and down
         *
         * @param {int} direction +1, scrolls up and -1, scrolls down
         *
         **/
        changeItem: function (direction) {
            if ((this.associationIndex + direction) >= 0 && (this.associationIndex + direction) < this.merchandisingAssociations.length) {
                this.associationIndex = this.associationIndex + direction;
                // sets the associated item name
                $("#association_item_name").html(this.merchandisingAssociations[this.associationIndex].name);
                if (document.getElementById("ProductInfoName_" + this.merchandisingAssociations[this.associationIndex - direction].productId) != null) {
                    document.getElementById("ProductInfoName_" + this.merchandisingAssociations[this.associationIndex - direction].productId).value = this.merchandisingAssociations[this.associationIndex].name;
                    document.getElementById("ProductInfoName_" + this.merchandisingAssociations[this.associationIndex - direction].productId).id = "ProductInfoName_" + this.merchandisingAssociations[this.associationIndex].productId;
                }
                // sets the associated thumbnail image of the item
                $("#association_thumbnail").attr('src', this.merchandisingAssociations[this.associationIndex].thumbnail);
                if ($("#ProductInfoImage_" + this.merchandisingAssociations[this.associationIndex - direction].productId).length) {
                    document.getElementById("ProductInfoImage_" + this.merchandisingAssociations[this.associationIndex - direction].productId).value = this.merchandisingAssociations[this.associationIndex].thumbnail;
                    document.getElementById("ProductInfoImage_" + this.merchandisingAssociations[this.associationIndex - direction].productId).id = "ProductInfoImage_" + this.merchandisingAssociations[this.associationIndex].productId;
                }
                // sets the associated item name to alt text
                $("#association_thumbnail").attr("alt", this.merchandisingAssociations[this.associationIndex].name);
                // sets the total offered price
                $("#combined_total").html(this.merchandisingAssociations[this.associationIndex].offeredCombinedPrice);
                if ($("#ProductInfoPrice_" + this.merchandisingAssociations[this.associationIndex - direction].productId).length) {
                    document.getElementById("ProductInfoPrice_" + this.merchandisingAssociations[this.associationIndex - direction].productId).value = this.merchandisingAssociations[this.associationIndex].skuOfferPrice;
                    document.getElementById("ProductInfoPrice_" + this.merchandisingAssociations[this.associationIndex - direction].productId).id = "ProductInfoPrice_" + this.merchandisingAssociations[this.associationIndex].productId;
                }
                // sets the total list price
                $("#list_total").html(this.merchandisingAssociations[this.associationIndex].listedCombinedPrice);
                if ($("#association_url ").attr('ontouchend') == (undefined)) {
                    // sets the product url href
                    $("#association_url").attr("href", this.merchandisingAssociations[this.associationIndex].url);
                }
                // sets the product url title
                $("#association_url").attr("title", this.merchandisingAssociations[this.associationIndex].shortDesc);
                if ($("#association_url").attr('ontouchend') !== (undefined)) {
                    currentPopup = "";
                    $("association_url").attr("ontouchend", "handlePopup('" + this.merchandisingAssociations[this.associationIndex].url + "','merchandisingAssociation_QuickInfoDiv" + this.merchandisingAssociations[this.associationIndex].id + "')");
                }
                // sets the href for quick info
                $("#merchandisingAssociation_QuickInfo").attr("href", "javascript:QuickInfoJS.showDetails(" + this.merchandisingAssociations[this.associationIndex].id + ");");
                if (0 == this.associationIndex) {
                    // changing the up arrow to disabled style
                    $("#up_arrow").removeClass("up_active");
                    $("#down_arrow").addClass("down_active");
                    $("#down_arrow").focus();
                } else if ((this.merchandisingAssociations.length - 1) == this.associationIndex) {
                    // changing the down arrow to disabled style
                    $("#down_arrow").removeClass("down_active");
                    $("#up_arrow").addClass("up_active");
                    $("#up_arrow").focus();
                } else {
                    // changing the arrows to enabled style
                    $("#up_arrow").addClass("up_active");
                    $("#down_arrow").addClass("down_active");
                }
            }
        },

        setCommonParams: function () {
            var params = new Object();
            params.storeId = this.storeParams.storeId;
            params.catalogId = this.storeParams.catalogId;
            params.langId = this.storeParams.langId;
            params.orderId = ".";
            // Remove calculations for performance
            // params.calculationUsage = "-1,-2,-5,-6,-7";
            params.calculateOrder = "0";
            params.inventoryValidation = "true";
            return params;
        },

        validate: function () {
            if (this.baseItemParams.type == 'BundleBean') {
                for (idx = 0; idx < this.baseItemParams.components.length; idx++) {
                    if (!isPositiveInteger(this.baseItemParams.components[idx].quantity)) {
                        MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                        return;
                    }
                }
            } else if (this.baseItemParams.type == 'ProductBean' &&
                (null == this.baseItemParams.attributes || "undefined" == this.baseItemParams.attributes)) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
                return;
            } else if (!isPositiveInteger(this.baseItemParams.quantity)) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }
        },

        /**
         * addBoth2ShopCart Adds both base product and the associated product to the shopping cart
         *
         *
         **/
        addBoth2ShopCart: function (catEntryID_baseItem, catEntryID_MA, catEntryID_MA_quantity, associationIndex) {
            this.associationIndex = associationIndex;
            this.validate();
            if (!isPositiveInteger(catEntryID_MA_quantity)) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }
            var params = this.setCommonParams();

            shoppingActionsJS.productAddedList = new Object();
            //Add the parent product to the cart.
            if (["ItemBean", "ProducteBean", "DynamicKitBean"].indexOf(this.baseItemParams.type) > -1) {
                updateParamObject(params, "catEntryId", this.baseItemParams.id, false, -1);
                updateParamObject(params, "quantity", this.baseItemParams.quantity, false, -1);
                if (this.baseItemParams.type == 'DynamicKitBean') {
                    updateParamObject(params, "catalogEntryType", "dynamicKit", -1);
                }
                if (this.baseItemParams.type == 'ItemBean') {
                    shoppingActionsJS.saveAddedProductInfo(Math.abs(this.baseItemParams.quantity), this.baseItemParams.productId, this.baseItemParams.id, this.baseItemParams.attributes);
                } else {
                    shoppingActionsJS.saveAddedProductInfo(Math.abs(this.baseItemParams.quantity), this.baseItemParams.productId, this.baseItemParams.id, shoppingActionsJS.selectedAttributesList['entitledItem_' + this.baseItemParams.id]);
                }
            } else if (this.baseItemParams.type == 'BundleBean') {
                // Add items in the bundle
                for (idx = 0; idx < this.baseItemParams.components.length; idx++) {
                    updateParamObject(params, "catEntryId", this.baseItemParams.components[idx].id, false, -1);
                    updateParamObject(params, "quantity", this.baseItemParams.components[idx].quantity, false, -1);

                    if (this.baseItemParams.components[idx].productId != undefined) {
                        var selectedAttrList = new Object();
                        for (attr in shoppingActionsJS.selectedProducts[this.baseItemParams.components[idx].productId]) {
                            selectedAttrList[attr] = shoppingActionsJS.selectedProducts[this.baseItemParams.components[idx].productId][attr];
                        }
                        shoppingActionsJS.saveAddedProductInfo(Math.abs(this.baseItemParams.components[idx].quantity), this.baseItemParams.components[idx].productId, this.baseItemParams.components[idx].id, selectedAttrList);
                    } else {
                        shoppingActionsJS.saveAddedProductInfo(Math.abs(this.baseItemParams.components[idx].quantity), this.baseItemParams.components[idx].id, this.baseItemParams.components[idx].id, shoppingActionsJS.selectedProducts[this.baseItemParams.components[idx].id]);
                    }
                }
            } else {
                // Resolve ProductBean to an ItemBean based on the attributes in the main page
                var sku = this.resolveSKU();
                if (-1 == sku) {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
                    return;
                } else {
                    updateParamObject(params, "catEntryId", sku, false, -1);
                    updateParamObject(params, "quantity", this.baseItemParams.quantity, false, -1);
                    shoppingActionsJS.saveAddedProductInfo(Math.abs(this.baseItemParams.quantity), this.baseItemParams.id, sku, this.baseItemParams.attributes);
                }
            }
            if (["ItemBean", "PackageBean", "DynamicKitBean"].indexOf(this.merchandisingAssociations[this.associationIndex].type) > -1) {
                updateParamObject(params, "catEntryId", this.merchandisingAssociations[this.associationIndex].id, false, -1);
                updateParamObject(params, "quantity", catEntryID_MA_quantity, false, -1);
                if (this.merchandisingAssociations[this.associationIndex].productId != undefined) {
                    shoppingActionsJS.saveAddedProductInfo(Math.abs(catEntryID_MA_quantity), this.merchandisingAssociations[this.associationIndex].productId, this.merchandisingAssociations[this.associationIndex].id, shoppingActionsJS.selectedAttributesList['entitledItem_' + this.merchandisingAssociations[this.associationIndex].id]);
                } else {
                    shoppingActionsJS.saveAddedProductInfo(Math.abs(catEntryID_MA_quantity), this.merchandisingAssociations[this.associationIndex].id, this.merchandisingAssociations[this.associationIndex].id, shoppingActionsJS.selectedAttributesList['entitledItem_' + this.merchandisingAssociations[this.associationIndex].id]);
                }
                this.addItems2ShopCart(params);
            } else if (this.merchandisingAssociations[this.associationIndex].type == 'BundleBean') {
                // Add items in the bundle
                for (idx = 0; idx < this.merchandisingAssociations[this.associationIndex].components.length; idx++) {
                    updateParamObject(params, "catEntryId", this.merchandisingAssociations[this.associationIndex].components[idx].id, false, -1);
                    updateParamObject(params, "quantity", catEntryID_MA_quantity, false, -1);
                    shoppingActionsJS.saveAddedProductInfo(Math.abs(catEntryID_MA_quantity), this.merchandisingAssociations[this.associationIndex].components[idx].id, this.merchandisingAssociations[this.associationIndex].components[idx].id, shoppingActionsJS.selectedProducts[this.merchandisingAssociations[this.associationIndex].components[idx].id]);
                }
                this.addItems2ShopCart(params);
            } else {
                // Resolve ProductBean to an ItemBean based on the attributes selected
                var entitledItemJSON = null;
                if ($("#" + catEntryID_MA).length) {
                    //the json object for entitled items are already in the HTML. 
                    entitledItemJSON = eval('(' + $("#" + catEntryID_MA).html() + ')');
                } else {
                    //if $("#" + entitledItemId) is null, that means there's no <div> in the HTML that contains the JSON object. 
                    //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
                    entitledItemJSON = shoppingActionsJS.getEntitledItemJsonObject();
                }
                shoppingActionsJS.setEntitledItems(entitledItemJSON);
                var catEntryID_MA_SKU = shoppingActionsJS.getCatalogEntryId(catEntryID_MA);
                if (null == catEntryID_MA_SKU) {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
                    return;
                } else {
                    updateParamObject(params, "catEntryId", catEntryID_MA_SKU, false, -1);
                    updateParamObject(params, "quantity", catEntryID_MA_quantity, false, -1);
                    shoppingActionsJS.saveAddedProductInfo(catEntryID_MA_quantity, catEntryID_MA.split("_")[1], catEntryID_MA_SKU, shoppingActionsJS.selectedAttributesList['entitledItem_' + this.merchandisingAssociations[this.associationIndex].id]);
                    this.addItems2ShopCart(params);
                }
            }
        },

        resolveSKU: function () {
            for (idx = 0; idx < this.baseItemParams.skus.length; idx++) {
                var matches = 0;
                var attributeCount = 0;
                for (attribute in this.baseItemParams.skus[idx].attributes) {
                    attributeCount++;
                    if (this.baseItemParams.attributes && this.baseItemParams.skus[idx].attributes[attribute] == this.baseItemParams.attributes[attribute]) {
                        matches++;
                    } else {
                        break;
                    }
                }
                if (matches == attributeCount) {
                    return this.baseItemParams.skus[idx].id;
                }
            }
            return -1;
        },

        /**
         * AddItem2ShopCartAjax This function is used to add a single or multiple items to the shopping cart using an ajax call.
         *
         * @param {Object} params, parameters that needs to be passed during service invocation.
         *
         **/
        addItems2ShopCart: function (params) {
            var shopCartService = "AddOrderItem";
            if (params['catalogEntryType'] == 'dynamicKit') {
                shopCartService = "AddPreConfigurationToCart";
            }
            //For Handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            cursor_wait();
            wcService.invoke(shopCartService, params);
        },

        /**
         * This function is used to subscribe events that indicate quantity change and attribute changes.
         *
         * @param {Object} params, parameters that needs to be passed during service invocation.
         *
         **/
        subscribeToEvents: function (baseCatalogEntryId) {
            wcTopic.subscribe("Quantity_Changed", MerchandisingAssociationJS, MerchandisingAssociationJS.setBaseItemQuantity);
            wcTopic.subscribe("DefiningAttributes_Resolved_" + baseCatalogEntryId, MerchandisingAssociationJS.setBaseItemAttributesFromProduct);
        }
    }

}
;//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

// Declare refresh controller which are used in pagination controls of SearchBasedNavigationDisplay -- both products and articles+videos

// Search for this "prodRecommendationRefresh_controller" it is never defined in any refresh areas, maybe no longer in use?
/*
wc.render.declareRefreshController({
    id: "prodRecommendationRefresh_controller",
    renderContext: wcRenderContext.getRenderContextProperties("searchBasedNavigation_context"),
    url: "",
    formId: ""

    ,renderContextChangedHandler: function(message, widget) {
        var controller = this;
        var renderContext = this.renderContext;
        var resultType = renderContext.properties["resultType"];
        if (["products", "both"].indexOf(resultType) > -1){
            widget.refresh(renderContext.properties);
            console.log("espot refreshing");
        }
    }

    ,postRefreshHandler: function(widget) {
        var controller = this;
        var renderContext = this.renderContext;
        cursor_clear();

        var refreshUrl = controller.url;
        var emsName = "";
        var indexOfEMSName = refreshUrl.indexOf("emsName=", 0);
        if(indexOfEMSName >= 0){
            emsName = refreshUrl.substring(indexOfEMSName+8);
            if (emsName.indexOf("&") >= 0) {
                emsName = emsName.substring(0, emsName.indexOf("&"));
                emsName = "script_" + emsName;
            }
        }

        if (emsName !== "") {
            var espot = $('.genericESpot', $("#" + emsName).parent()).first();
            if (espot.length) {
                espot.addClass('emptyESpot');
            }
        }
        wcTopic.publish("CMPageRefreshEvent");
    }
}); */
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 *@fileOverview This javascript file defines all the javascript functions used by SKU List widget
 */

SKUListJS = {

    /** 
     * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
     * @private
     */
    langId: "-1",

    /** 
     * This variable stores the ID of the current store. Its default value is empty.
     * @private
     */
    storeId: "",

    /** 
     * This variable stores the ID of the catalog. Its default value is empty.
     * @private
     */
    catalogId: "",

    /** 
     * If set to true, then the SKU compare box will be shown. Its default value is true.
     * @private
     */
    disableProductCompare: "",

    /** 
     * This array stores the products which quantities have been updated (and can be added to the cart). Its default value is empty.
     * @private
     */
    quantityList: {},

    /**
     * This variable stores the mousedown event $.proxy handle.
     */
    mouseOverConnectHandle: false,

    /**
     * Sets the common parameters for the current page. 
     * For example, the language ID, store ID, and catalog ID.
     *
     * @param {Integer} langId The ID of the language that the store currently uses.
     * @param {Integer} storeId The ID of the current store.
     * @param {Integer} catalogId The ID of the catalog.
     * @param {Integer} disableProductCompare If set to true, will disable product compare.
     */
    setCommonParameters: function (langId, storeId, catalogId, disableProductCompare) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        this.disableProductCompare = disableProductCompare;
    },

    /**
     * Updates the quantities of the SKU if the quantities are changed.
     * @param (string) qty The quantity value to update to.
     * @param (string) productId The ID of the product.
     * @param (string) itemId The ID of the item.
     */
    updateItemQuantity: function (qty, productId, itemId) {
        if (!(productId in this.quantityList)) {
            this.quantityList[productId] = {};
        }

        if (qty.replace(/^\s+|\s+$/g, '') == '') {
            this.removeItemQuantity(productId, itemId);
            $('#invalidQuantity_' + productId + '_' + itemId).css('display', 'none');
            return;
        }

        if (!isPositiveInteger(qty)) {
            $('#invalidQuantity_' + productId + '_' + itemId).css('display', 'block');
        } else {
            $('#invalidQuantity_' + productId + '_' + itemId).css('display', 'none');
        }

        this.quantityList[productId][itemId] = qty;
    },

    /**
     * Validate item quantity.
     * @param (string) qty The quantity value to update to.
     * @param (string) skuId The ID of the sku.
     */
    validateQuantity: function (qty, skuId) {
        if (qty.replace(/^\s+|\s+$/g, '') != '' && !isPositiveInteger(qty)) {
            $('#invalidQuantity_' + skuId).css('display', 'block');
        } else {
            $('#invalidQuantity_' + skuId).css('display', 'none');
        }
    },

    /**
     * Remove the quantity of the SKU (e.g. when row is hidden)
     * @param (string) productId The ID of the product.
     * @param (string) itemId The ID of the item.
     */
    removeItemQuantity: function (productId, itemId) {
        if (productId in this.quantityList) {
            delete this.quantityList[productId][itemId];
        }
    },

    /**
     * Remove all quantities currently inputed, e.g. after successfully added to shopping cart or req list 
     */
    removeAllQuantities: function () {
        var quantityFields = $(".productDetailTable .Quantity .input_field");

        for (var i = 0; i < quantityFields.length; i++) {
            quantityFields[i].val("");
            quantityFields[i].change();
        }
    },

    /**
     * Checks if the string is an integer.
     * @param (string) str The string to check.
     * @return (boolean) Indicates whether the string is a number.
     */
    isNumber: function (str) {
        if ((str * 0) == 0) return true;
        else return false;
    },

    /**
     * Checks if a string is null or empty.
     * @param (string) str The string to check.
     * @return (boolean) Indicates whether the string is empty.
     */
    isEmpty: function (str) {
        var reWhiteSpace = new RegExp(/^\s+$/);
        if (str == null || str === '' || reWhiteSpace.test(str)) {
            return true;
        }
        return false;
    },

    /**
     * Redirects to the store locator after appending the current URL
     * @param storeLocatorUrl The store locator URL
     */
    selectStore: function (storeLocatorUrl) {
        setPageLocation(storeLocatorUrl + "&fromUrl=" + encodeURIComponent(document.URL));
    },

    /**
     * Checks the online inventory status in the stores selected by the user
     * @param productId The product ID
     * @param type The product type 
     */
    checkOnlineAvailability: function (productId) {
        var params = {
            productId: productId,
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId
        };

        var url = appendWcCommonRequestParameters("GetOnlineInventoryStatusByIDViewV2");
        cursor_wait();

        $.ajax({
            url: url,
            dataType: "json",
            data: params,
            success:
            /**
             * Populate the contents of the online store inventory details section with the JSON returned 
             * from the server. This is the callback function that is called after the AJAX call to get the online
             * inventory details successfully returns to the client.
             * 
             * @param {object} serviceResponse The JSON response from $.ajax.
             * @param {string} status The status of $.ajax call.
             */

                function (serviceResponse, status) {
                if (serviceResponse.onlineInventory) {
					for (var item in serviceResponse.onlineInventory) {
						var onlineInventoryElement = document.getElementById("WC_Sku_List_TableContent_"+item+"_OnlineAvailability");
						var mobileInventoryElement = document.getElementById("WC_Sku_List_MbileContent_"+item+"_OnlineAvailability");
						
						if (onlineInventoryElement != null) {
							onlineInventoryElement.innerHTML = "<span> <img src='" + imageDirectoryPath + styleDirectoryPath + serviceResponse.onlineInventory[item].image 
									+ "' alt='" + serviceResponse.onlineInventory[item].altText + "' /> </span>"
									+ "<span>" + serviceResponse.onlineInventory[item].status + "</span>";
						}
						if (mobileInventoryElement != null) {
							mobileInventoryElement.innerHTML = "<span> <img src='" + imageDirectoryPath + styleDirectoryPath + serviceResponse.onlineInventory[item].image 
									+ "' alt='" + serviceResponse.onlineInventory[item].altText + "' /> </span>"
									+ "<span>" + serviceResponse.onlineInventory[item].status + "</span>";
						}
					}
                } else {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("INV_STATUS_RETRIEVAL_ERROR"));
                }
                cursor_clear();
            },
            error: function (jqXHR, textStatus, err) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("INV_STATUS_RETRIEVAL_ERROR"));
                cursor_clear();
            }
        });
    },
    /**
     * Populate the select stores/check stores link depending on whether or not
     * a physical store has been selected
     */
    populateStoreLinks: function () {
        var cookieValue = getCookie("WC_physicalStores");

        if (cookieValue != null) {
            $(".check_stores.link").removeClass("nodisplay");
        } else {
            $(".select_stores.link").removeClass("nodisplay");
        }
    },

    /**
     * Checks the inventory status in the stores selected by the user
     * @param productId The product ID
     * @param itemId The item ID 
     */
    checkAvailability: function (productId, itemId) {
        var params = {
            productId: productId,
            itemId: itemId
        };

        // For Handling multiple clicks.
        if (!submitRequest()) {
            return;
        }

        var url = appendWcCommonRequestParameters("GetInventoryStatusByIDViewV2");
        cursor_wait();

        $.ajax({
            url: url,
            dataType: "json",
            data: params,
            method: "post",
            success:

            /**
             * Populate the contents of the in store inventory details section with the JSON returned 
             * from the server. This is the callback function that is called after the AJAX call to get the inventory 
             * details successfully returns to the client.
             * 
             * @param {object} serviceResponse The JSON response from $.ajax.
             * @param {string} status The status of $.ajax call.
             */

                function (serviceResponse, status) {
                if (serviceResponse.inStoreInventory) {
                    // Removing the in store section if present
                    $("#WC_InStore_Inventory_Section_" + params.itemId).detach();
                    $("#WC_InStore_Mobile_Inventory_Section_" + params.itemId).detach();


                    // Adding the empty store section
                    $("#WC_Check_Stores_Link_" + params.itemId).before("<div id='WC_InStore_Inventory_Section_" + params.itemId + "' class='sublist'>");
                    $("#WC_Check_Stores_Link_Mobile_" + params.itemId).before("<div id='WC_InStore_Mobile_Inventory_Section_" + params.itemId + "' class='sublist'>");

                    SKUListJS.physicalStores = serviceResponse.inStoreInventory.stores;

                    // Adding the store inventory details as child elements in the store section
                    for (i = 0; i < serviceResponse.inStoreInventory.stores.length; i++) {
                        var store = serviceResponse.inStoreInventory.stores[i];

                        // Adding the store name
                        $("#WC_InStore_Inventory_Section_" + params.itemId).append("<a id='WC_InStore_Inventory_Link_" + params.itemId + "_store_" + (i + 1) + "' href='#' onclick=\"SKUListJS.fetchStoreDetails('" + store.id + "', '" + params.productId + "');\" class='store_name'>" + store.name + "&nbsp;</a>");
                        $("#WC_InStore_Mobile_Inventory_Section_" + params.itemId).append("<a id='WC_InStore_Mobile_Inventory_Link_" + params.itemId + "_store_" + (i + 1) + "' href='#' onclick=\"SKUListJS.fetchStoreDetails('" + store.id + "', '" + params.productId + "');\" class='store_name'>" + store.name + "&nbsp;</a>");
                        // Adding clear div
                        $("#WC_InStore_Inventory_Section_" + params.itemId).append("<div class='clear_float'></div>");
                        $("#WC_InStore_Mobile_Inventory_Section_" + params.itemId).append("<div class='clear_float'></div>");
                        // Adding the image status of store name
                        $("#WC_InStore_Inventory_Section_" + params.itemId).append("<span> <img src='" + imageDirectoryPath + styleDirectoryPath + store.image + "' alt='" + store.altText + "' /> </span>");
                        $("#WC_InStore_Mobile_Inventory_Section_" + params.itemId).append("<span> <img src='" + imageDirectoryPath + styleDirectoryPath + store.image + "' alt='" + store.altText + "' /> </span>");
                        // Adding the text status of store name
                        $("#WC_InStore_Inventory_Section_" + params.itemId).append("<span class='text'>" + store.statusText + "</span>");
                        $("#WC_InStore_Mobile_Inventory_Section_" + params.itemId).append("<span class='text'>" + store.statusText + "</span>");
                        // Adding spacer
                        $("#WC_InStore_Inventory_Section_" + params.itemId).append("<div class='item_spacer_10px'></div>");
                        $("#WC_InStore_Mobile_Inventory_Section_" + params.itemId).append("<div class='item_spacer_10px'></div>");
                    }

                    // Change the link from Check Stores to Change Stores
                    $("#WC_Check_Stores_Link_" + params.itemId).addClass("nodisplay");
                    $("#WC_Change_Stores_Link_" + params.itemId).removeClass("nodisplay");
                    $("#WC_Check_Stores_Link_Mobile_" + params.itemId).addClass("nodisplay");
                    $("#WC_Change_Stores_Link_Mobile_" + params.itemId).removeClass("nodisplay");
                } else {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("INV_STATUS_RETRIEVAL_ERROR"));
                }
                cursor_clear();
            },
            error: function (jqXHR, textStatus, error) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("INV_STATUS_RETRIEVAL_ERROR"));
                cursor_clear();
            }
        });
    },
    /**
     * Show physical store details popup after fetching the required details
     * @param storeId The ID of the physical store
     * @param productId The ID of the product
     */
    fetchStoreDetails: function (storeId, productId) {
        MessageHelper.hideAndClearMessage();

        var params = {
            physicalStoreId: storeId,
            productId: productId
        };

        var url = appendWcCommonRequestParameters("GetStoreDetailsByIDViewV2");

        // For Handling multiple clicks.
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        $.ajax({
            url: url,
            dataType: "json",
            data: params,
            method: "post",
            success:
            /**
             * Populate the contents of the store details section in the product display page with the JSON returned 
             * from the server. This is the callback function that is called after the AJAX call to get the inventory 
             * details successfully returns to the client.
             * 
             * @param {object} serviceResponse The JSON response from $.ajax.
             * @param {string} status The status of $.ajax call.
             */
                function (serviceResponse, status) {
                var store = serviceResponse;

                // Get unescaped working hours
                store.hours = SKUListJS.unEscapeXml(serviceResponse.hours);

                // Get inventory status
                var storeInventory = SKUListJS.fetchInventoryStatus(params.physicalStoreId);

                // Get store availability details
                store.imageTag = "<img src='" + imageDirectoryPath + styleDirectoryPath + storeInventory.image + "' alt='" + storeInventory.altText + "'/>";
                store.statusText = storeInventory.statusText;

                if (storeInventory.status == 'Available') {
                    store.availabilityDetails = "(" + storeInventory.availableQuantity + ")"; // Adding the available quantity
                } else if (storeInventory.status == 'Backorderable') {
                    store.availabilityDetails = "(" + storeInventory.availableDate + ")"; // Adding the available date
                } else {
                    store.availabilityDetails = "";
                }

                var storeDetails = $("#Store_Details_Template_" + params.productId).html();
                $("#Store_Details_" + params.productId).html(Utils.substituteStringWithObj(storeDetails, store));

                // Display store details
                var popup = $("#InventoryStatus_Store_Details_" + params.productId).data("wc-WCDialog");
                if (popup) {
                    closeAllDialogs(); // Close other dialogs(quickinfo dialog, etc) before opening this. 				
                    popup.open();
                } else {
                    console.debug("InventoryStatus_Store_Details_" + params.productId + " does not exist");
                }
                cursor_clear();
            },
            error: function (jqXHR, textStatus, error) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("INV_STATUS_RETRIEVAL_ERROR"));
                cursor_clear();
            }
        });
    },


    /**
     * Returns the inventory status object for the physical store specified
     * @param storeId The storeId of the physical store
     * @return the inventory status object for the store
     */
    fetchInventoryStatus: function (storeId) {
        for (i = 0; i < this.physicalStores.length; i++) {
            if (this.physicalStores[i].id == storeId) {
                return this.physicalStores[i];
            }
        }
        return {};
    },

    /**
     * Converts xml accepted form to < >
     * @param {String} str, String to be converted
     * @return {String} converted string
     */
    unEscapeXml: function (str) {
        return str.replace(/&lt;/gm, "<").replace(/&gt;/gm, ">");
    },

    /**
     * Show SKU list table (e.g. when button is clicked)
     * @param productId the ID of the product
     **/
    showTable: function (productId, top_category, parent_category_rn, categoryId, widgetPrefix) {
        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        var skuListWidget = $("#WC_Sku_List_Table_" + productId);
        if (skuListWidget) {
            cursor_wait();
            skuListWidget.refreshWidget("refresh", {
                "catalogId": this.catalogId,
                "storeId": this.storeId,
                "productId": productId,
                "disableProductCompare": this.disableProductCompare,
                "jspStoreImgDir": imageDirectoryPath,
                "top_category": top_category,
                "parent_category_rn": parent_category_rn,
                "categoryId": categoryId,
                "widgetPrefix": widgetPrefix
            });
        }

        var ie_version = Utils.get_IE_version();
        if (ie_version < 9) {
            $("#lastShowSKUList").val(productId);
            this.mouseOverConnectHandle = $("#WC_Sku_List_Table_Hide_Button_" + productId).on("mouseover", $.proxy(this.handleMouseOver, this));
        }
    },

    handleMouseOver: function () {
        var productId = $("#lastShowSKUList").val();
        var node = $("#product_name_" + productId);
        var productInfoHeight = 0;
        while (node != null && node.tagName != "LI") {
            node = node.parentNode;
            if (node.className == "product_info") {
                productInfoHeight = node.offsetHeight;
            }
        }
        if (productInfoHeight > 280) {
            $(node).css("height", productInfoHeight + 40 + "px");
        }
        SKUListJS.arrangeProductDetailTables();
    },

    /**
     * Show the display of SKU list table and change the button to hide
     * @param widget the refresh area widget
     **/
    showTableView: function (productId) {
        var Widget = $("#WC_Sku_List_Table_" + productId);
        $(Widget).removeClass("nodisplay");
        $('#WC_Sku_List_Table_Full_' + productId).addClass('expanded');
        $('#WC_Sku_List_Table_Expand_Area_' + productId).addClass('hide');
        $('#WC_Sku_List_Table_Show_Button_' + productId).addClass('nodisplay');
        $('#WC_Sku_List_Table_Hide_Button_' + productId).removeClass('nodisplay');
        $("#WC_Sku_List_Table_Hide_Button_" + productId).focus();
    },

    /**
     * Hide the display of SKU list table and change the button to show
     * @param widget the refresh area widget
     **/
    hideTableView: function (productId) {
        $('#WC_Sku_List_Table_' + productId).addClass('nodisplay');
        $('#WC_Sku_List_Table_Expand_Area_' + productId).removeClass('hide');
        $('#WC_Sku_List_Table_Hide_Button_' + productId).addClass('nodisplay');
        $('#WC_Sku_List_Table_Show_Button_' + productId).removeClass('nodisplay');
        $("#WC_Sku_List_Table_Show_Button_" + productId).focus();
        if (!this.mouseOverConnectHandle) {
            $(document.documentElement).off("mouseover");
            this.mouseOverConnectHandle = false;
        }
    },

    /**
     * Toggle expanded content to show or hide (e.g. when button is clicked)
     * @param productId the ID of the product
     * @param row The row on which the expanded content is contained
     * @param skuId The SKU id of the sku which the row contains
     **/
    toggleExpandedContent: function (productId, row, skuId) {
        $('#WC_Sku_List_ExpandedContent_' + productId + '_' + row).toggleClass('nodisplay');
        $('#WC_Sku_List_Mobile_ExpandedContent_' + productId + '_' + row).toggleClass('nodisplay');
        $('#WC_Sku_List_Row_Header_Mobile_' + skuId).toggleClass('expanded');
        $('#WC_Sku_List_Title_Mobile_' + productId + '_' + row).toggleClass('expanded');
        $('#DropDownArrow_' + productId + '_' + row).toggleClass('expanded');
        $('#DropDownArrow_Mobile_' + productId + '_' + row).toggleClass('expanded');
        $('#DropDownButton_' + productId + '_' + row).toggleClass('expanded');
        $('#DropDownButton_Mobile_' + productId + '_' + row).toggleClass('expanded');

        if ($('#DropDownButton_' + productId + '_' + row).attr('aria-expanded') == 'false') {
            $('#DropDownButton_' + productId + '_' + row, 'aria-expanded').attr('true');
        } else {
            $('#DropDownButton_' + productId + '_' + row, 'aria-expanded').attr('false');
        }

        if ($('#DropDownButton_Mobile_' + productId + '_' + row, 'aria-expanded') == 'false') {
            $('#DropDownButton_Mobile_' + productId + '_' + row, 'aria-expanded').attr('true');
        } else {
            $('#DropDownButton_Mobile_' + productId + '_' + row, 'aria-expanded').attr('false');
        }
    },

    /**
     * Arranges the columns in all SKU list tables on the page. 
     */
    arrangeProductDetailTables: function () {
        var listTables = $(".productDetailTable");

        // For each product detail table, get the productId from the element's ID
        for (var i = 0; i < listTables.length; i++) {
            var productId = listTables[i].id.replace("WC_Sku_List_Table_", "");
            this.arrangeProductDetailTable(productId);
        }
    },

    /**
     * Arranges the columns in the SKU list table. If there is not enough space to show all attributes,
     * some columns will be pushed into the hidden expandable content area.
     * @param productId the productId
     */
    arrangeProductDetailTable: function (productId) {
        // This is the font being used in the column headers for the SKU List widget
        var HEADER_FONT = "bold 12px sans-serif"

        /* This is the minumum pixel width a column can be. Once the width of the columns has 
        gone below this amount, then a column will be removed and pushed into expandable hidden row */
        var MIN_COL_WIDTH = 90;

        // This is the maximum pixel width a column can be. 
        var MAX_COL_WIDTH = 250;

        var container = $("#WC_Sku_List_Table_" + productId).parent();
        var listTable = $("#WC_Sku_List_Table_Full_" + productId);
        var mobileTable = $("#WC_Sku_List_Table_Mobile_" + productId);

        // Check if table is already expanded and visible
        if ((listTable == null || listTable.offsetHeight == 0) && (mobileTable == null || mobileTable.offsetHeight == 0)) {
            return;
        }

        // Show the mobile view when the width of the container is 540 px or less
        if ($(container).width() <= 540) {
            $(listTable).css("display", "none");
            $(mobileTable).css("display", "block");
        } else {
            $(listTable).css("display", "block");
            $(mobileTable).css("display", "none");
        }

        var rowWidth = $(".row", listTable).first().width();

        // Get the set of anchored and unanchored columns
        var anchoredHeaders = $(".columnHeader.anchored", listTable);
        var anchoredCells = $(".gridCell.anchored", listTable);
        var unanchoredHeaders = $(".columnHeader.unanchored", listTable);
        var unanchoredCells = $(".gridCell.unanchored", listTable);

        // The remaining width of the table will be used for unanchored headers (10 pixel buffer, so that headers don't wrap) 
        var unanchoredWidth = rowWidth - 10;
        for (var i = 0; i < anchoredHeaders.length; i++) {
            unanchoredWidth -= $(anchoredHeaders[i]).width();
        }

        // Get the total number of columns in the SKU list table
        var unanchoredColumnWidth = MAX_COL_WIDTH;
        var numOfColumnsToMove = 0;

        // Find the number of unanchored columns that can be shown 
        if (unanchoredWidth / unanchoredHeaders.length < MIN_COL_WIDTH) {
            numOfColumnsToMove = Math.ceil(unanchoredHeaders.length - (unanchoredWidth / MIN_COL_WIDTH));
            if (numOfColumnsToMove > unanchoredHeaders.length) {
                numOfColumnsToMove = unanchoredHeaders.length;
            }
        }

        // After finding out the number of columns needed to be moved, calculate the width of each unanchored column
        var numOfRemainingColumns = unanchoredHeaders.length - numOfColumnsToMove;
        if (numOfRemainingColumns > 0) {
            unanchoredColumnWidth = unanchoredWidth / numOfRemainingColumns;
            if (unanchoredColumnWidth > MAX_COL_WIDTH) {
                unanchoredColumnWidth = MAX_COL_WIDTH;
            }
        } else {
            unanchoredColumnWidth = 0;
        }

        var headersToMove = [];
        var recalculateWidths = false;
        var padding = 20;

        // Bring the compare header to the front of the list, so it will get moved last
        if ($(".columnHeader.unanchored [data-filter=\"Compare\"]", listTable).length != 0) {
            unanchoredHeaders.unshift(unanchoredHeaders.pop());
        }

        // Check if any columns have a string that is too long to display in the currently calculated widths, and move those first
        for (var i = 0; i < unanchoredHeaders.length; i++) {
            if (i >= unanchoredHeaders.length - numOfColumnsToMove) {
                headersToMove.push(unanchoredHeaders[i]);
            } else {
                var attrNode = unanchoredHeaders[i].firstElementChild || unanchoredHeaders[i].firstChild //For IE8
                var attributeName = attrNode.innerHTML.replace(/^\s+|\s+$/g, '');

                if (this.hasLongWord(attributeName, unanchoredColumnWidth - padding, HEADER_FONT)) {
                    headersToMove.push(unanchoredHeaders[i]);
                    numOfColumnsToMove--;
                    recalculateWidths = true;
                }
            }
        }

        // If needed, recalculate the new unanchored column widths after moving a column that had a string that was too long
        if (recalculateWidths) {
            numOfRemainingColumns = unanchoredHeaders.length - headersToMove.length;
            if (numOfRemainingColumns > 0) {
                unanchoredColumnWidth = unanchoredWidth / numOfRemainingColumns;
                if (unanchoredColumnWidth > MAX_COL_WIDTH) {
                    unanchoredColumnWidth = MAX_COL_WIDTH;
                }
            } else {
                unanchoredColumnWidth = 0;
            }
        }

        // Show all columns initially
        $(unanchoredHeaders).css('display', 'block');
        $(unanchoredCells).css('display', 'block');

        // Set the percentage width of each unanchored column
        $(".columnHeader.unanchored, .gridCell.unanchored", listTable).css('width', unanchoredColumnWidth + 'px');

        // Hide all expanded content initially		
        $(".expandedCol", listTable).css('display', 'none');

        // If all columns can be displayed, then hide the expanded content area and the drop down button
        if (headersToMove.length == 0) {
            $(".expandedContent", listTable).addClass('nodisplay');
            $(".expandButton", listTable).css('display', 'none');
            $(".dropDownArrow", listTable).removeClass('expanded');
        }

        // Hide the amount of columns that need to be moved
        for (var i = 0; i < headersToMove.length; i++) {
            $(".expandButton", listTable).css('display', 'block');

            if ($(unanchoredHeaders).index(headersToMove[i]) !== -1) {
                // Get the CSS classname for the column that will be moved to the expanded columns
                var className = $(headersToMove[i]).attr("data-filter");

                // Hide the main column for this CSS class
                var columnToHide = $(".columnHeader.unanchored[data-filter=\"" + className + "\"], .gridCell.unanchored[data-filter=\"" + className + "\"]", listTable);
                $(columnToHide).css('display', 'none');

                // Show the attribute in the expanded content section
                var expandedColumnsToShow = $(".expandedCol[data-filter=\"" + className + "\"]", listTable);
                $(expandedColumnsToShow).css('display', 'block');

                // Set the right border of the cells in the table depending on row width to display the table lines 
                // properly according to the number of columns.
                if (typeof (expandedColumnsToShow[0]) != 'undefined') {
                    var expandedColWidth = $(expandedColumnsToShow[0]).width();
                    var expandedContentPadding = 40;
                    var numOfExpandedColumns = Math.floor((rowWidth - expandedContentPadding) / expandedColWidth);
                    if (numOfExpandedColumns > 1 && headersToMove.length > 1) {
                        if (i % numOfExpandedColumns == numOfExpandedColumns - 1) {
                            $(expandedColumnsToShow).css('borderRight', 'none');
                        } else {
                            $(expandedColumnsToShow).css('borderRight', '1px solid #ccc');
                        }
                    } else {
                        $(expandedColumnsToShow).css('borderRight', 'none');
                    }
                }
            }
        }
    },

    /**
     * Checks if any words in a string is longer than maxWidth
     * @param text The text string
     * @param maxWidth The max width for any word
     * @param font The font of the string
     */
    hasLongWord: function (text, maxWidth, font) {
        // Create a dummy canvas (render invisible with css)
        var c = document.createElement('canvas');

        if (!c.getContext) {
            return false;
        }

        var ctx = c.getContext('2d');
        // Set the context.font to the font that you are using
        ctx.font = font;

        if (ctx.measureText(text).width < maxWidth) {
            return false;
        }

        var words = text.split(' ');

        for (var w in words) {
            var word = words[w];
            var measure = ctx.measureText(word).width;

            if (measure > maxWidth) {
                return true;
            }
        }

        return false;
    },

    /**
     * Filters the SKU list so that only those with selected attributes are shown
     * @param skuId the ID of the item
     * @param productId the ID of the product
     */
    filterSkusByAttribute: function (skuId, productId) {
        var listTable = $("#WC_Sku_List_Table_" + productId);
        var selectedAttributes = productDisplayJS.selectedAttributesList;
        var productKey = "entitledItem_" + productId;

        if (productKey in selectedAttributes) {
            // Display all rows initially
            $(".row.entry, .mobileHeader", listTable).removeClass('nodisplay');

            for (var attribute in selectedAttributes[productKey]) {
                // The value of the selected attribute
                var selectedAttrValue = selectedAttributes[productKey][attribute].replace(/^\s+|\s+$/g, '');

                if (selectedAttrValue !== "") {
                    // The CSS class of the attribute has no spaces or 's or "s
                    var attrClass = attribute.replace(/ /g, "").replace(/'/g, "").replace(/"/g, "");

                    // Get all cells from the column matching the selected attribute 
                    //var attrCells = $(".gridCell." + attrClass, listTable);
                    var attrCells = $("div[data-filter='" + attrClass + "'].gridCell", listTable);

                    for (var i = 0; i < attrCells.length; i++) {
                        // If the selected attribute is not the same as the value inside a matching cell 
                        // found in the SKU list table, then remove the entire row and remove the quantities
                        var attrTextNode = attrCells[i].firstElementChild || attrCells[i].firstChild //For IE8 
                        if (selectedAttrValue != attrTextNode.innerHTML.replace(/^\s+|\s+$/g, '')) {
                            $(attrCells[i].parentNode).addClass('nodisplay');

                            // Get the SKU ID of the row that we want to remove and remove the row in mobile view as well
                            skuId = attrCells[i].parentNode.id.split("WC_Sku_List_Row_Content_")[1];
                            $("#WC_Sku_List_Row_Header_Mobile_" + skuId).addClass('nodisplay');

                            var quantityInput = $(".input_field", attrCells[i].parentNode).first();
                            quantityInput.val("");
                            quantityInput.change();
                        }
                    }
                }
            }
        }
    },

    /**
     * addSku2ShopCartAjax This function is used to add one SKU to the shopping cart using an AJAX call (from mobile view).
     * @param {String} productId the product Id being added to cart
     * @param {String} skuId the SKU Id being added to cart 	
     * @param {Object} customParams - Any additional parameters that needs to be passed during service invocation.
     **/
    addSku2ShopCartAjax: function (productId, skuId, customParams) {
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }

        var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            orderId: "."
        };
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";
        params.inventoryValidation = "true";
        params.calculateOrder = "0";
        var ajaxShopCartService = "AddOrderItem";

        shoppingActionsJS.productAddedList = {};

        var quantity = $("#" + skuId + "_Mobile_Quantity_Input").val();
        if (!isPositiveInteger(quantity)) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
            return;
        }

        params["catEntryId"] = skuId;
        params["quantity"] = quantity;

        shoppingActionsJS.saveAddedProductInfo(quantity, productId, skuId, null);

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
            if (customParams['catalogEntryType'] == 'dynamicKit') {
                ajaxShopCartService = "AddPreConfigurationToCart";
            }
        }

        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        wcService.invoke(ajaxShopCartService, params);
        if (typeof productDisplayJS != 'undefined') {
            productDisplayJS.baseItemAddedToCart = true;
        }

        if ($("#headerShopCartLink") && $("#headerShopCartLink").css('display') !== "none") {
            $("#headerShopCart").focus();
        } else if ($("#headerShopCart1")) {
            $("#headerShopCart1").focus();
        }
    },

    /**
     * addSkus2ShopCartAjax This function is used to add one or more SKUs to the shopping cart using an AJAX call.
     * @param {String} productId the product Id being added to cart 	
     * @param {Object} customParams - Any additional parameters that needs to be passed during service invocation.
     **/
    addSkus2ShopCartAjax: function (productId, customParams) {
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;

        }
        var params = {storeId: this.storeId,
catalogId: this.catalogId,
langId: this.langId,
orderId: "."};
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";
        params.inventoryValidation = "true";
        params.calculateOrder = "0";
        params.addedFromSKUList = "true";
        var ajaxShopCartService = "AddOrderItem";

        shoppingActionsJS.productAddedList = {};

        //Get all of the SKUs and their quantities and pass in as parameters (e.g. catEntryId_1, quantity_1)
        if (productId in this.quantityList) {
            var i = 1;
            for (var skuId in this.quantityList[productId]) {
                var quantity = this.quantityList[productId][skuId];
                if (!isPositiveInteger(quantity)) {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUTS_ERROR'));
                    return;
                }
                params["catEntryId_" + i] = skuId;
                params["quantity_" + i] = quantity;
                i++;

                shoppingActionsJS.saveAddedProductInfo(quantity, productId, skuId, null, true);
            }
        }

        if (params.catEntryId_1 == null || params.quantity_1 == null) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUTS_ERROR'));
            return;
        }

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
            if (customParams['catalogEntryType'] == 'dynamicKit') {
                ajaxShopCartService = "AddPreConfigurationToCart";
            }
        }

        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        wcService.invoke(ajaxShopCartService, params);
        if (typeof productDisplayJS != 'undefined') {
            productDisplayJS.baseItemAddedToCart = true;
        }

        if ($("#headerShopCartLink") && $("#headerShopCartLink").css('display') !== "none") {
            $("#headerShopCart").focus();
        } else if ($("#headerShopCart1")) {
            $("#headerShopCart1").focus();
        }
    }
}

//Declare refresh function
var declareSKUListTable_WidgetRefreshArea = function (productId) {
    if(typeof productId == "object" || typeof productId == "array") {
        productId = productId[0];
    }
    var myWidgetObj = $("#WC_Sku_List_Table_" + productId);

    var postRefreshHandler = function () {
        SKUListJS.showTableView(productId);
        SKUListJS.arrangeProductDetailTable(productId);
        SKUListJS.checkOnlineAvailability(productId);
        SKUListJS.populateStoreLinks();
        cursor_clear();
    };
    // initialize widget with properties
    myWidgetObj.refreshWidget({
        postRefreshHandler: postRefreshHandler
    });
}
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2009, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript provides all the functions needed for the B2B store logon and registration.
 * @version 1.9
 */

B2BLogonForm ={
    prepareSubmitOrgReg:function (form){
      /////////////////////////////////////////////////////////////////////////////
      // This javascript function is for 'Submit' button in the organization registration page.
      /////////////////////////////////////////////////////////////////////////////
      reWhiteSpace = new RegExp(/^\s+$/);
      if (form.org_orgEntityName !=null && (reWhiteSpace.test(form.org_orgEntityName.value) || form.org_orgEntityName.value=="")) {
         MessageHelper.formErrorHandleClient(form.org_orgEntityName.id,MessageHelper.messages["ERROR_OrgNameEmpty"]); return;
      }
      if(!AddressHelper.validateAddressForm(form,'org_')){
          return;
      }

      if (form.usr_logonId !=null && (reWhiteSpace.test(form.usr_logonId.value) || form.usr_logonId.value=="")){
        // MessageHelper.formErrorHandleClient(form.usr_logonId.id,MessageHelper.messages["ERROR_LogonIdEmpty"]); return;
      }
      if (form.usr_logonPassword !=null && (reWhiteSpace.test(form.usr_logonPassword.value) || form.usr_logonPassword.value=="")){
         MessageHelper.formErrorHandleClient(form.usr_logonPassword.id,MessageHelper.messages["ERROR_PasswordEmpty"]); return;
      }else if  (form.usr_logonPasswordVerify !=null && (reWhiteSpace.test(form.usr_logonPasswordVerify.value) || form.usr_logonPasswordVerify.value=="")) {
         MessageHelper.formErrorHandleClient(form.usr_logonPasswordVerify.id,MessageHelper.messages["ERROR_PasswordEmpty"]); return;
      }else if (form.usr_logonPasswordVerify !=null && form.usr_logonPasswordVerify.value!= form.usr_logonPassword.value) {
         MessageHelper.formErrorHandleClient(form.usr_logonPasswordVerify.id,MessageHelper.messages["PWDREENTER_DO_NOT_MATCH"]); return;
      }
      if(!AddressHelper.validateAddressForm(form,'usr_')){
         return;
      }

      if (form.usr_email1 !=null && (reWhiteSpace.test(form.usr_email1.value) || form.usr_email1.value=="")){
         MessageHelper.formErrorHandleClient(form.usr_email1.id,MessageHelper.messages["ERROR_EmailEmpty"]); return;
      }else if(!MessageHelper.isValidEmail(form.usr_email1.value)){
         MessageHelper.formErrorHandleClient(form.usr_email1.id,MessageHelper.messages["WISHLIST_INVALIDEMAILFORMAT"]);return ;
      }
      if (!MessageHelper.IsValidPhone(form.usr_phone1.value)) {
         MessageHelper.formErrorHandleClient(form.usr_phone1.id,MessageHelper.messages["ERROR_INVALIDPHONE"]);
         return ;
      }

      if(form.mobileDeviceEnabled != null && form.mobileDeviceEnabled.value == "true"){
         if(!MyAccountDisplay.validateMobileDevice(form)){
            return;
         }
      }
      if(form.birthdayEnabled != null && form.birthdayEnabled.value == "true"){
         if(!MyAccountDisplay.validateBirthday(form)){
            return;
         }
      }
      this.setSMSCheckBoxes(form);

      form.submit();
   },

    constructParentOrgDN: function (ancestorOrgs) {
      var parentOrgDN = ancestorOrgs;
      while(true) {
         var n = parentOrgDN.indexOf("/");
         if(n == -1) {
            break;
         }
         parentOrgDN = parentOrgDN.substring(0, n) + "," + orgPrefix + parentOrgDN.substring(n + 1, parentOrgDN.length);
      }
      parentOrgDN = orgPrefix + parentOrgDN;
      return parentOrgDN;
   },

   setParentMemberValue: function (){
      document.Register.parentMember.value = this.constructParentOrgDN(document.Register.ancestorOrgs.value);
   },

   fillAdminAddress: function(form, jspStoreImgDir, checkbox){
        if ($('#'+checkbox).hasClass("active")){
            $('#'+checkbox).removeClass("active");
            $('#'+checkbox).attr("aria-checked", "false");
            $('#'+checkbox).attr("src", jspStoreImgDir + "images/checkbox.png");
        } else {
            $('#'+checkbox).addClass("active");
            $('#'+checkbox).attr("src", jspStoreImgDir + "images/checkbox_checked.png");
            $('#'+checkbox).attr("aria-checked", "true");

            form.usr_address1.value = this.getFieldValue(form.org_address1);
            form.usr_address2.value = this.getFieldValue(form.org_address2);
            form.usr_zipCode.value = this.getFieldValue(form.org_zipCode);

            var $orgCountry = $('#WC_OrganizationRegistrationAddForm_AddressEntryForm_FormInput_org_country_1');
            var $usrCountry = $('#WC_OrganizationRegistrationAddForm_AddressEntryForm_FormInput_usr_country_1');

            $usrCountry.val($orgCountry.val());
            $usrCountry.Select("refresh");

            //see AddressHelper.loadAddressFormStatesUI
            AddressHelper.loadAddressFormStatesUI(form.name,'usr_','usr_stateDiv','WC_OrganizationRegistrationAddForm_AddressEntryForm_FormInput_usr_state_1',false,this.getFieldValue(form.org_state));
            form.usr_city.value = this.getFieldValue(form.org_city);
        }
   },

   getFieldValue: function (field){
      //returns the field value iff the the field value is not null or empty.
      return (field==null || field=='')?'':field.value;
   },

   setSMSCheckBoxes: function (form) {
       /*
        * In AddressForm.jsp, setSMSCheckBoxes and sendMeSMSPreference are used as the name of the checkboxes.
        * But for the command BuyerRegistrationAdd to save the data, the name of the checkboxes must be
        * converted to receiveSMSNotification and receiveSMSPreference
        * */
       if (form.sendMeSMSNotification != null) {
           var sendMeSMSNotification = $("#"+ form.sendMeSMSNotification.id);
           if (sendMeSMSNotification != null && sendMeSMSNotification.checked) {
               form.receiveSMSNotification.value = true;
           } else {
               form.receiveSMSNotification.value = false;
           }
       } else {
           form.receiveSMSNotification.value = false;
       }


       if (form.sendMeSMSPreference != null) {
           var sendMeSMSPreference =  $("#"+ form.sendMeSMSPreference.id);
           if (sendMeSMSPreference != null && sendMeSMSPreference.checked) {
               form.receiveSMS.value = true;
           } else {
               form.receiveSMS.value = false;
           }
       } else {
           form.receiveSMS.value = false;
       }
   },

   changeFormAction: function () {
        if (document.getElementById('Register').action.indexOf('UserRegistrationAdd') != -1) {
            document.getElementById('Register').action = 'BuyerRegistrationAdd';
        } else {
            document.getElementById('Register').action = 'UserRegistrationAdd';
        }

        var tempURL = document.Register.URL.value;
        document.Register.URL.value = document.Register.URLOrg.value;
        document.Register.URLOrg.value = tempURL;
    },

    toggleOrgRegistration: function () {
        $('#WC_UserRegistrationAddForm_DivForm_1').toggleClass('nodisplay');
        this.toggleInputs($('#WC_UserRegistrationAddForm_DivForm_1'));
        $('#WC_OrganizationRegistration_DivForm_1').toggleClass('nodisplay');
        $('#WC_OrganizationRegistration_DivForm_2').toggleClass('nodisplay');
        this.disableOrgInputs();
        $('#WC_UserRegistrationAddForm_Buttons_1').toggleClass('nodisplay');
        $('#WC_OrganizationRegistration_Buttons_1').toggleClass('nodisplay');
        this.changeFormAction();
    },

    toggleInputs: function (form) {
                if ($('input, select', form).attr('disabled')) {
                        $('input, select', form).removeAttr('disabled');
                } else {
                        $('input, select', form).attr('disabled', 'disabled');
                }

    },

    disableOrgInputs: function () {
        this.toggleInputs($('#WC_OrganizationRegistration_DivForm_1'));
        this.toggleInputs($('#WC_OrganizationRegistration_DivForm_2'));
    },

    checkRegisterOrg: function (checked) {
        if (checked) {
            this.switchRegistration();
        }
    },

    submitForm: function (form) {
        //check to make sure Buyer Organization is set.
        var reWhiteSpace = new RegExp(/^\s+$/);
        if (form.ancestorOrgs !=null && reWhiteSpace.test(form.ancestorOrgs.value) || form.ancestorOrgs.value=="") {
            MessageHelper.formErrorHandleClient(form.ancestorOrgs.id,MessageHelper.messages["ERROR_OrgNameEmpty"]); return;
        }

        //set the value of buyer organization
        B2BLogonForm.setParentMemberValue(form);

        //set the SMS values
        B2BLogonForm.setSMSCheckBoxes(form);

        //now submit the form
        LogonForm.prepareSubmit(form);
        return false;
    },

    switchRegistration: function (id) {
        $('#registration_arrow').toggleClass('right');
        $('#individual_link').toggleClass('nodisplay');
        $('#individual_image_on').toggleClass('nodisplay');
        $('#organization_link').toggleClass('nodisplay');
        $('#organization_image_on').toggleClass('nodisplay');
        $('#organizationDescription').toggleClass('nodisplay');
        $('#individualDescription').toggleClass('nodisplay');

        if (id == 'individual_link') {
            $('#organization_link').focus();
        } else {
            $('#individual_link').focus();
        }
        this.toggleOrgRegistration();
    },
}
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2007, 2013 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 *@fileOverview This javascript file defines all the javascript functions used by requisition list detail widget
 */

	ReqListInfoJS = {
			
		/** 
		 * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
		 * @private
		 */
		langId: "-1",
		
		/** 
		 * This variable stores the ID of the current store. Its default value is empty.
		 * @private
		 */
		storeId: "",
		
		/** 
		 * This variable stores the ID of the catalog. Its default value is empty.
		 * @private
		 */
		catalogId: "",

		/**			
		* This variable keeps track of the requisition list type. The choice can be private ('Y') or shared ('Z')
		*/
		status: "",

		/**
		 * Sets the common parameters for the current page. 
		 * For example, the language ID, store ID, and catalog ID.
		 *
		 * @param {Integer} langId The ID of the language that the store currently uses.
		 * @param {Integer} storeId The ID of the current store.
		 * @param {Integer} catalogId The ID of the catalog.
		 */
		setCommonParameters: function(langId,storeId,catalogId,status){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
			this.status = status;
		},

		/**
		* Sets the status of the requisition list and update the dropdown to display the current status.
		*
		* @param {String} status The status to set for the requisition list
		* @param {String} statusDisplay The text to show for the requisition list type dropdown (private or shared)
		* @param {String} selectDropdown id of the HTML div that represents the dropdown
		*/		
		setListStatus: function(status, statusDisplay, selectDropdown) {
			this.status = status;
			$("#reqListInfo_curStatus").html(statusDisplay);
			this.toggleSelectDropdown(selectDropdown);
		},
		
		/**
		 * Updates the name or type or both of a requisition list.
		 * @param (object) formName The form that contains the new requisition list data.
		 */
		updateReqList: function(formName) {
			MessageHelper.hideAndClearMessage();
			var form = document.forms[formName];
			if (form.reqListInfo_name!=null && this.isEmpty(form.reqListInfo_name.value)) {
				MessageHelper.formErrorHandleClient(form.reqListInfo_name.id,MessageHelper.messages["ERROR_REQUISITION_LIST_NAME_EMPTY"]); return;
			}

			form.reqListInfo_name.value = trim(form.reqListInfo_name.value);
			form.reqListInfo_type.value = this.status;
			
			//Need to give the service declaration the form with all info about all req list info
			service = wcService.getServiceById("requisitionListUpdate");
			service.setFormId(formName);
			
			if(!submitRequest()){
				return;
			}
			cursor_wait();
			
			//This only updates the name and type for req list since another command updates items separately
			//After successful name/type update, success handler will trigger quantity update service call		
			wcService.invoke('requisitionListUpdate');
		},

		/**
		* Toggles the edit area of requisition list info section
		*/
		toggleEditInfo: function() {
			if ($("#requisitionListCurrentInfo").css('display') === ('none')) {
				$("#toolbarButton1").addClass("button_primary");
				$("#requisitionListCurrentInfo").css('display', 'block');
				$("#editRequisitionListInfo").css('display', 'none');
			} else {
				$("#toolbarButton1").addClass("button_secondary");
				$("#requisitionListCurrentInfo").css('display', 'none');				
				$("#editRequisitionListInfo").css('display', 'block');	
			}
		},

		/**
		* Toggles the requisition list type dropdown
		* @param {String} selectDropdown id of the HTML div that represents the dropdown
		*/		
		toggleSelectDropdown: function(selectDropdown) {
			if ($("#"+selectDropdown).css('display') === 'none') {
				$("#"+selectDropdown).css('display', 'block');
			}	else {
				$("#"+selectDropdown).css('display', 'none');
			}
		},

		/**
		 * Checks if a string is null or empty.
		 * @param (string) str The string to check.
		 * @return (boolean) Indicates whether the string is empty.
		 */
		isEmpty: function(str) {
			var reWhiteSpace = new RegExp(/^\s+$/);
			if (str == null || str =='' || reWhiteSpace.test(str) ) {
				return true;
			}
			return false;
		},

	};//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2007, 2013 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 *@fileOverview This javascript file defines all the javascript functions used by requisition list items widget
 */

	ReqListItemsJS = {
			
		/** 
		 * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
		 * @private
		 */
		langId: "-1",
		
		/** 
		 * This variable stores the ID of the current store. Its default value is empty.
		 * @private
		 */
		storeId: "",
		
		/** 
		 * This variable stores the ID of the catalog. Its default value is empty.
		 * @private
		 */
		catalogId: "",
		
		/**
		* This variable stores the ID of the requisition list. Its default value is empty.
		*/
		requisitionListId: "",

		/**
		 * Sets the common parameters for the current page. 
		 * For example, the language ID, store ID, and catalog ID.
		 *
		 * @param {Integer} langId The ID of the language that the store currently uses.
		 * @param {Integer} storeId The ID of the current store.
		 * @param {Integer} catalogId The ID of the catalog.
		 * @param {Integer} requisitionListId The ID of the requisition list.
		 */
		setCommonParameters: function(langId,storeId,catalogId,requisitionListId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
			this.requisitionListId = requisitionListId;
		},

		/**
		 * Adds an item to the requisition list.
		 * @param (object) formName The form that contains the items to add to the requisition list.
		 */
		addItemToReqList:function(formName){
			MessageHelper.hideAndClearMessage();
			var form = document.forms[formName];
			if (form.skuAdd!=null && this.isEmpty(form.skuAdd.value.replace(/^\s+|\s+$/g, ''))) {
				MessageHelper.formErrorHandleClient(form.skuAdd.id,MessageHelper.messages["ERROR_REQUISITION_LIST_SKU_EMPTY"]); return;
			}else if (form.quantityAdd!=null && this.isEmpty(form.quantityAdd.value.replace(/^\s+|\s+$/g, ''))) {
				form.quantityAdd.value = "1";
			}else if (!this.isNumber(form.quantityAdd.value.replace(/^\s+|\s+$/g, '')) || form.quantityAdd.value.replace(/^\s+|\s+$/g, '') <= 0) {
				MessageHelper.formErrorHandleClient(form.quantityAdd.id,MessageHelper.messages["ERROR_REQUISITION_LIST_QUANTITY_ONE_OR_MORE"]); return;
			}
			
			var params = {
			requisitionListId: form.requisitionListId.value,
			partNumber: form.skuAdd.value.replace(/^\s+|\s+$/g, ''),
			quantity: form.quantityAdd.value.replace(/^\s+|\s+$/g, ''),
			operation: "addItem",
			storeId: this.storeId,
			catalogId: this.catalogId,
			langId: this.langId			
			};
			/*For Handling multiple clicks. */
			if(!submitRequest()){
				return;
			}			
			cursor_wait();
			wcService.invoke('requisitionListAddItem',params);
		},
	
		/**
		 * Updates the quantities of each item in the requisition list, if the quantities are changed.
		 * This function is automatically called by the sucessHandler of requisitionListUpdate.
		 * @see RequisitionList.updateReqList()
		 * @see MyAccountServiceDeclaration.js requisitionListUpdate declaration
		 * @param (string) requisitionListId The ID of the requisition list to update.
		 */
		updateItemQuantity:function (qtyDiv, orderItemId, row) {
		
			var params={
			requisitionListId: this.requisitionListId,
			quantity: $(qtyDiv).val(),
			orderItemId: orderItemId,
			storeId: this.storeId,
			catalogId: this.catalogId,
			langId: this.langId,
			operation: "updateQty",
			row: row
			};
			if(!submitRequest()){
				return;
			}
			cursor_wait();
			wcService.invoke('requisitionListUpdateItem',params);
		},

		/**
		* Shows the "quantity updated" message next to quantity input
		* @param {Integer} row The row number of the quantity input in the table
		*/		
		showUpdatedMessage: function(row) {
			$('#reqItem_msg_qty_updated_'+row).css('display','block');
			$('#table_r'+row+'_input2').css('border','1px solid #006ecc');
			setTimeout("ReqListItemsJS.hideUpdatedMessage("+row+")", 5000);
		},

		/**
		* Hides the "quantity updated" message next to quantity input
		* @param {Integer} row The row number of the quantity input in the table
		*/		
		hideUpdatedMessage: function(row) {
			$('#reqItem_msg_qty_updated_'+row).css('display','none');
			$('#table_r'+row+'_input2').css('border','1px solid #b7b7b7');
		},
		
		/**
		 * Deletes an item from the requisition list for the Ajax flow.
		 * @param (string) orderItemId The item to delete from the requisition list.
		 */
		deleteItemFromReqList:function (orderItemId) {
			var params = {
			requisitionListId: this.requisitionListId,
			orderItemId: orderItemId,
			quantity: "0",
			storeId: this.storeId,
			catalogId: this.catalogId,
			langId: this.langId,	
			operation: "deleteItem"
			};
			/*For Handling multiple clicks. */
			if(!submitRequest()){
				return;
			}			
			cursor_wait();
			wcService.invoke('requisitionListDeleteItem',params);
		},

		/**
		 * Adds all of the order items from the current requisition list to the current order.
		 * Checks whether the current requisition list contains items.
		 */
		addListToOrder:function () {
			var form = document.forms["RequisitionListAddToCartForm"];
			var formElements = form.elements;
			var params = {};

			for(var i = 0; i < formElements.length; i++) {
				if (formElements[i].name.indexOf("quantity") == -1 && formElements[i].name.indexOf("ProductInfo") == -1) {
					// ingore all hidden "quantity" and "ProductInfo" inputs - do not add to params
					params[formElements[i].name] = formElements[i].value;
				}
			}
									
			MessageHelper.hideAndClearMessage();
	
			//For Handling multiple clicks
			if(!submitRequest()){
				return;
			} 
			
			cursor_wait();
			service = wcService.getServiceById('requisitionListAjaxPlaceOrder');
			service.formId = form;
			wcService.invoke('requisitionListAjaxPlaceOrder', params);
		},			

		/**
		 * Adds selected item from the current requisition list to the current order.
		 * @param (String) catEntryId catentry id of the item to be added to the current order
		 * @param (String) partNumber part number of the item to be added to the current order
		 * @param (String) row row number of the item in the requisition list
		 */
		addItemToOrder:function (catEntryId,partNumber,row) {
			var form = document.forms["RequisitionListAddToCartForm"];
			var formElements = form.elements;
			var params = {};
			
			for(var i = 0; i < formElements.length; i++) {
				if (formElements[i].name.indexOf("quantity") != -1) {
					if(formElements[i].name.indexOf("quantity_"+row) != -1) {
						// just add quantity of the specified row to params
						params["quantity"] = formElements[i].value;
					}
				} else if (formElements[i].name.indexOf("ProductInfo") == -1) {
					// ingore all hidden "ProductInfo" inputs - do not add to params
					params[formElements[i].name] = formElements[i].value;
				}
			}
			params["partNumber"] = partNumber;
			params["inventoryValidation"] = true;
			params["orderId"] = ".";
			
			// used by mini shopcart
			var selectedAttrList = new Object();
			shoppingActionsJS.saveAddedProductInfo(params["quantity"], catEntryId, catEntryId, selectedAttrList);
			
			MessageHelper.hideAndClearMessage();
	
			//For Handling multiple clicks
			if(!submitRequest()){
				return;
			} 
			
			cursor_wait();
			wcService.invoke('ReqListAddOrderItem',params);
			
			// close action dropdown
			hideMenu($('#RequisitionListItems_actionButton'+row));
			hideMenu($('#RequisitionListItems_actionDropdown'+row));
		},	
			
		/**
		* This function is called when user selects a different page from the current page
		* @param (Object) data The object that contains data used by pagination control 
		*/
		showResultsPage:function(data){
			var pageNumber = data['pageNumber'];
			var pageSize = data['pageSize'];
			pageNumber = Number(pageNumber);
			pageSize = Number(pageSize);

			setCurrentId(data["linkId"]);

			if(!submitRequest()){
				return;
			}

			var beginIndex = pageSize * ( pageNumber - 1 );
			cursor_wait();

			wcRenderContext.updateRenderContext('RequisitionListItemTable_Context', {"beginIndex": beginIndex, "requisitionListId":this.requisitionListId});
			MessageHelper.hideAndClearMessage();
		},
		
		/**
		 * Checks if the string is an integer.
		 * @param (string) str The string to check.
		 * @return (boolean) Indicates whether the string is a number.
		 */
		isNumber:function (str) {
			if ((str*0)==0) return true;
			else return false;
		},		
		
		/**
		 * Checks if a string is null or empty.
		 * @param (string) str The string to check.
		 * @return (boolean) Indicates whether the string is empty.
		 */
		isEmpty: function(str) {
			var reWhiteSpace = new RegExp(/^\s+$/);
			if (str == null || str =='' || reWhiteSpace.test(str) ) {
				return true;
			}
			return false;
		},

	};//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This file provides all the functions and variables to manage requisition lists and the items within.
 * This file is included in all pages with requisition list actions.
 */


/**
 * This class defines the functions and variables that customers can use to create, update, and view their requisition lists.
 * @class The RequisitionListJS class defines the functions and variables that customers can use to manage their requisition lists, 
 */
RequisitionListJS ={		
		
	/** 
	 * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
	 * @private
	 */
	langId: "-1",
	
	/** 
	 * This variable stores the ID of the current store. Its default value is empty.
	 * @private
	 */
	storeId: "",
	
	/** 
	 * This variable stores the ID of the catalog. Its default value is empty.
	 * @private
	 */
	catalogId: "",					
	
	/**
	 * Sets the common parameters for the current page. 
	 * For example, the language ID, store ID, and catalog ID.
	 *
	 * @param {Integer} langId The ID of the language that the store currently uses.
	 * @param {Integer} storeId The ID of the current store.
	 * @param {Integer} catalogId The ID of the catalog.
	 */
	setCommonParameters:function(langId,storeId,catalogId){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;
		cursor_clear();
	},	
	
	/**
	 * Initialize the URL of Requisition List widget controller. 	 
	 *
	 * @param {object} widgetUrl The controller's URL.
	 */
	initRequisitionListUrl:function(widgetUrl){
		$("#RequisitionListTable_Widget").refreshWidget("updateUrl", widgetUrl);
	},
		
	/**
	 * Creates an empty requisition list.
	 * @param (object) formName The form which contains the name and type of the requisition list.
	 * @param (object) widgetName The widget name.
	 */
	createNewList:function() {			
		var form_name = document.getElementById("RequisitionList_NewListForm_Name");
		if (form_name !=null && this.isEmpty(form_name.value)) {
			MessageHelper.formErrorHandleClient(form_name.id,MessageHelper.messages["LIST_TABLE_NAME_EMPTY"]); return;
		}				
		service = wcService.getServiceById('requisitionListCreate');
		service.setFormId("newListDropdown");
		var params = {
		editable: "true",
		storeId: this.storeId,
		catalogId: this.catalogId,
		langId: this.langId
		};
			
		/*For Handling multiple clicks. */
		if(!submitRequest()){
			return;
		}			
		cursor_wait();
		wcService.invoke('requisitionListCreate',params);		
	},
	/**
	 * Deletes a requisition list
	 * @param (string) requisitionListId The identifier of the selected requisition list.
	 */
	deleteList:function (requisitionListId) {
		var params = {
		requisitionListId: requisitionListId,
		filterOption: "All",
		storeId: this.storeId,
		catalogId: this.catalogId,
		langId: this.langId		
		};
		/*For Handling multiple clicks. */
		if(!submitRequest()){
			return;
		}			
		cursor_wait();
		wcService.invoke('AjaxRequisitionListDelete',params);
	},
	
	/**
	 * Create a duplicated requisition list.
	 * @param (object) name The name of the new requisition.
	 * @param (object) status The status of the new requisition.
	 * @param (string) orderId The order to create the requisition list from.
	 */
	duplicateReqList:function (name,status,orderId) {
		MessageHelper.hideAndClearMessage();
						
		var params = {
		editable: "true",
		storeId: this.storeId,
		catalogId: this.catalogId,
		langId: this.langId,
		orderId: orderId,	
		name: name,
		status: status
		};
			
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		wcService.invoke('requisitionListCopy',params);		
	},		
	
	/**
	 * This function sets the url for AjaxRequisitionListSubmit service and then it invokes the service to copy the old order.
	 * @param {string} AddToCartURL The url for the order copy service.
	 */
	addReqListToCart:function(AddToCartURL){

		/*For Handling multiple clicks. */
		if(!submitRequest()){
			return;
		}   		
		cursor_wait();
		
		wcService.getServiceById("addRequisitionListToCart").setUrl(AddToCartURL);
		wcService.invoke("addRequisitionListToCart");
	},
	
	/**
	 * Checks if a string is null or empty.
	 * @param (string) str The string to check.
	 * @return (boolean) Indicates whether the string is empty.
	 */
	isEmpty:function (str) {
		var reWhiteSpace = new RegExp(/^\s+$/);
		if (str == null || str =='' || reWhiteSpace.test(str) ) {
			return true;
		}
		return false;
	},
	
	/**
	 * Uploads a new requisition list file for processing.
	 * @param (object) formObj A reference to a form element containing the new requisition list CSV to upload.
	 * @param (object) inputObject A reference to an input element to show an error message against.
	 */		
	submitAndUploadReqList:function(formObj, inputObject) {
		MessageHelper.hideAndClearMessage();
		
		if (formObj.UpLoadedFile.value=='') {
			if (inputObject) {
				MessageHelper.formErrorHandleClient(inputObject.id,MessageHelper.messages["ERROR_REQUISITION_UPLOAD_FILENAME_EMPTY"]); 
			}
			return;
		}
		formObj.submit();
	},

	/**
	 * Show requisition list results based on page number
	 * @param (object) data The object contains page number, page size, linkId
	 */
	showResultsPageNumberForRequisitionList:function(data){
		var pageNumber = data['pageNumber'];
		var pageSize = data['pageSize'];
		pageNumber = Number(pageNumber);
		pageSize = Number(pageSize);
		
		setCurrentId(data["linkId"]);
		if(!submitRequest()){
			return;
		}
		
		var beginIndex = pageSize * (pageNumber -1);
		cursor_wait();
		wcRenderContext.updateRenderContext("RequisitionListTable_Context", {"beginIndex":beginIndex , "orderBy":""},"");
	}
}

/** 
 * Add a click event listener to the <i>uploadButton</i> on the requisition list page 
 * only if the browser is not IE.
*/ 
$( document ).ready(function() { 
    var ie_version = Utils.get_IE_version();
    if (!ie_version ) {
		var RequisitionListWidgetDom = $('#RequisitionListTable_Widget');
		if (RequisitionListWidgetDom) {		
				$(RequisitionListWidgetDom).on("click", "#uploadButton", function(e){
				$('#UpLoadedFile').click();
				if (e.preventDefault) {
					e.preventDefault();
				}				
			});
		}
	};
});
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------


/**
 * Declares a new render context for creating a new list.
 */


/**
 * Declares a new refresh controller for creating a new List.
 */
function declareRequisitionListTableRefreshArea() {
    var myWidgetObj = $("#RequisitionListTable_Widget");
    wcRenderContext.declare("RequisitionListTable_Context", ["RequisitionListTable_Widget"], {
        "beginIndex": "0",
        "orderBy": ""
    }, "");




    var myRCProperties = wcRenderContext.getRenderContextProperties("RequisitionListTable_Context");


    var renderContextChangedHandler = function () {
        myWidgetObj.refreshWidget("refresh", myRCProperties);
    };
	   
    wcTopic.subscribe(['requisitionListCreate', 'AjaxRequisitionListDelete', 'requisitionListCopy'], function () {
        myWidgetObj.refreshWidget("refresh", myRCProperties);

    });

	/** 
     * Clears the progress bar*/
     var postRefreshHandler = function() {
		 cursor_clear();
		 
		 toggleMobileView();
	}

     // initialize widget
    myWidgetObj.refreshWidget({
        renderContextChangedHandler: renderContextChangedHandler,
        postRefreshHandler: postRefreshHandler
});
};
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by the Requisition List pages to handle the services for
 * creating/deleting/updating requisition lists and adding/removing/updating items from a requisition list.
 * @version 1.10
 */


/**
 * This service allows customer to create a new requisition list
 * @constructor
 */
wcService.declare({
	id:"requisitionListCreate",
	actionId:"requisitionListCreate",
	url:"AjaxRESTRequisitionListCreate",
	formId:""

	 /**
	 * Hides all the messages and the progress bar.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["MYACCOUNT_REQUISITIONLIST_CREATE_SUCCESS"]);
	}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}
}),
/**
 * This service deletes an existing requisition list.
 * @constructor
 */
wcService.declare({
	id:"AjaxRequisitionListDelete",
	actionId:"AjaxRequisitionListDelete",
	url:"AjaxRESTRequisitionListDelete",
	formId:""

	 /**
	 * Hides all the messages and the progress bar.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["MYACCOUNT_REQUISITIONLIST_DELETE_SUCCESS"]);
	}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}
}),

/**
* This service allows customer to add a requisition list to shopping cart.
* @constructor
*/
wcService.declare({
	id: "addRequisitionListToCart",
	actionId: "addRequisitionListToCart",
	url: "AjaxRESTRequisitionListSubmit",
	formId: ""

	 /**
	  *  Copies all the items from the existing order to the shopping cart.
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
	,successHandler: function(serviceResponse) {
		for (var prop in serviceResponse) {
			console.debug(prop + "=" + serviceResponse[prop]);
		}
		setDeleteCartCookie();
		cursor_clear();
		document.location.href="RESTOrderCalculate?calculationUsage=-1,-2,-3,-4,-5,-6,-7&updatePrices=1&doConfigurationValidation=Y&errorViewName=AjaxOrderItemDisplayView&orderId=.&langId="+serviceResponse.langId+"&storeId="+serviceResponse.storeId+"&catalogId="+serviceResponse.catalogId+"&URL=AjaxCheckoutDisplayView";
	}
	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
			MessageHelper.displayErrorMessage(MessageHelper.messages["PRODUCT_NOT_BUYABLE"]);
		} else if (serviceResponse.errorMessageKey == "_ERR_INVALID_ADDR") {
			MessageHelper.displayErrorMessage(MessageHelper.messages["INVALID_CONTRACT"]);
		}else {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
		}
		cursor_clear();
	}
}),

/**
* This service allows customer to create a requisition list from an existing requisition list.
* @constructor
*/
wcService.declare({
	id:"requisitionListCopy",
	actionId:"requisitionListCopy",
	url:"AjaxRESTRequisitionListCopy",
	formId:""

	 /**
	* Hides all the messages and the progress bar.
	* @param (object) serviceResponse The service response object, which is the
	* JSON object returned by the service invocation.
	*/
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["MYACCOUNT_REQUISITIONLIST_CREATE_SUCCESS"]);
	}

	/**
	* display an error message.
	* @param (object) serviceResponse The service response object, which is the
	* JSON object returned by the service invocation.
	*/
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			var errorMsg = serviceResponse.errorMessage;
			//If the errorMessage param is the generic error message
			//Display the systemMessage instead
			if(errorMsg.search("CMN3101E") != -1){
				//If systemMessage is not empty, display systemMessage
				if(serviceResponse.systemMessage){
					MessageHelper.displayErrorMessage(serviceResponse.systemMessage);
				} else {
					//If systemMessage is empty, then just display the generic error message
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
			} else {
				//If errorMessage is not generic, display errorMessage
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}
})
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 *@fileOverview This javascript file defines all the javascript functions used by saved order detail widget
 */

	SavedOrderInfoJS = {

			/** 
			 * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
			 * @private
			 */
			langId: "-1",
			
			/** 
			 * This variable stores the ID of the current store. Its default value is empty.
			 * @private
			 */
			storeId: "",
			
			/** 
			 * This variable stores the ID of the catalog. Its default value is empty.
			 * @private
			 */
			catalogId: "",

			/** 
			 * This variable stores the order ID of the saved order. Its default value is empty.
			 */
			orderId : "",
			
			/**
			 * Sets the common parameters for the current page. 
			 * For example, the language ID, store ID, and catalog ID.
			 *
			 * @param {Integer} langId The ID of the language that the store currently uses.
			 * @param {Integer} storeId The ID of the current store.
			 * @param {Integer} catalogId The ID of the catalog.
			 */
			setCommonParameters:function(langId,storeId,catalogId){
				this.langId = langId;
				this.storeId = storeId;
				this.catalogId = catalogId;
			},
	
			/**
			 * Updates the name/description of a saved order.
			 * @param (object) formName The form that contains the saved order name.
			 * 
			 */
			updateDescription: function(formName) {
				MessageHelper.hideAndClearMessage();
				var form = document.forms[formName];
				
				form.savedOrderInfo_name.value = trim(form.savedOrderInfo_name.value);
				form.oldSavedOrderInfo_name.value = trim(form.oldSavedOrderInfo_name.value);
				
				var desc = form.savedOrderInfo_name;
				var oldDesc = form.oldSavedOrderInfo_name;

				// Check to see if the order description has really changed by comparing it to the original value.
				if (desc != oldDesc) {
					//Need to give the service declaration the form with all info about saved order name info
					service = wcService.getServiceById("savedOrderUpdateDescription");
					service.setFormId(formName);
					
					if(!submitRequest()){
						return;
					}
					cursor_wait();
					
					//This updates the name/description of the saved order		
					wcService.invoke('savedOrderUpdateDescription');
				}

			},

			/**
			* Toggles the edit area of saved order info section
			*/
			toggleEditInfo:function() {
				if ($("#savedOrderCurrentInfo").css("display") === "none") {
					$("#savedOrderCurrentInfo").css("display", "block");
					$("#editSavedOrderInfo").css("display", "none");
				} else {
					$("#savedOrderCurrentInfo").css("display", "none");				
					$("#editSavedOrderInfo").css("display", "block");	
				}
			},
			
			/**
			 * Checks if a string is null or empty.
			 * @param (string) str The string to check.
			 * @return (boolean) Indicates whether the string is empty.
			 */
			isEmpty: function(str) {
				var reWhiteSpace = new RegExp(/^\s+$/);
				if (str == null || str =='' || reWhiteSpace.test(str) ) {
					return true;
				}
				return false;
			},
      
                        /**
                         *This method toggles the lock set on the order. It submits the 'savedOrderToggleLockForm' form declared.
                         *Based on the action defined in the form, the order is either locked or unlocked.                         
                         */                                                       
                        toggleOrderLock: function(){
                                document.forms['savedOrderToggleLockForm'].URL.value = document.location.href;
                                document.forms['savedOrderToggleLockForm'].submit();
                                return true;
                        }
	}
  
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 *@fileOverview This javascript file defines all the javascript functions used by saved order detail widget
 */

	SavedOrderItemsJS = {

			/** 
			 * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
			 * @private
			 */
			langId: "-1",
			
			/** 
			 * This variable stores the ID of the current store. Its default value is empty.
			 * @private
			 */
			storeId: "",
			
			/** 
			 * This variable stores the ID of the catalog. Its default value is empty.
			 * @private
			 */
			catalogId: "",

			/** 
			 * This variable stores the order ID of the saved order. Its default value is empty.
			 */
			orderId : "",
			
			/**
			 * This variable stores the current order ID. Its default value is empty.
			 */
			currentOrderId : "",
			
			/** The currently selected row. **/
			currentRow : "",
			
			/** The URL of the shopping cart used to forward the page when an order is converted to the current order. **/
			shoppingCartURL : "",
			
			/**
			 * Sets the common parameters for the current page. 
			 * For example, the language ID, store ID, and catalog ID.
			 *
			 * @param {Integer} langId The ID of the language that the store currently uses.
			 * @param {Integer} storeId The ID of the current store.
			 * @param {Integer} catalogId The ID of the catalog.
			 * @param {Integer} orderId The ID of the saved order.
			 */
			setCommonParameters:function(langId,storeId,catalogId,orderId){
				this.langId = langId;
				this.storeId = storeId;
				this.catalogId = catalogId;
				this.orderId = orderId;
			},

			/**
			 * Returns the current row.
			 * @returns {String} The current row number.
			 **/
			getCurrentRow:function() {
				return this.currentRow;
			},
			
			/**
			 * Resets the current row variable.
			 **/
			resetCurrentRow:function() {
				this.currentRow = "";
			},
			
			/**
			 * Sets the URL of the current shopping cart view.
			 *
			 * @param shoppingCartURL The URL of the shopping cart view.
			 */
			setCurrentShoppingCartURL : function(shoppingCartURL)
			{
				this.shoppingCartURL = shoppingCartURL;
			},
			
			/**
			 * Returns the URL of the shopping cart view.
			 * @returns {String} The URL of the shopping cart view.
			 **/
			getCurrentShoppingCartURL:function() {
				return this.shoppingCartURL;
			},
			
			/**
			 * Initialize the URL of Saved Order Items widget controller. 	 
			 *
			 * @param {object} widgetUrl The controller's URL.
			 */
			initSavedOrderItemsUrl:function(widgetUrl){
				$("#SavedOrderItemTable_Widget").attr("refreshurl", widgetUrl);
			},

			/**
			 * This function validates the SKU input values and their corresponding quantities 
			 * before sending the request to the server to add the SKUs to the saved order.
			 * An error message would be displayed if the inputs are invalid and the requested will be stopped.
			 * @param (object) formName The form that contains the items to add to the requisition list.
			 */
			addItemToSavedOrder:function(formName){
				MessageHelper.hideAndClearMessage();
				var form = document.forms[formName];
				if (form.skuAdd != null && this.isEmpty(form.skuAdd.value)) {
					MessageHelper.formErrorHandleClient(form.skuAdd.id,MessageHelper.messages["SAVED_ORDER_EMPTY_SKU"]); return;
				}else if (form.quantityAdd != null && this.isEmpty(form.quantityAdd.value)) {
					form.quantityAdd.value = "1";
				}else if (isNaN(form.quantityAdd.value) || form.quantityAdd.value <= 0) {
					MessageHelper.formErrorHandleClient(form.quantityAdd.id,MessageHelper.messages["ERROR_SAVED_ORDER_QUANTITY_ONE_OR_MORE"]); return;
				}
				
				var params = {
					orderId: form.orderId.value,
					partNumber: form.skuAdd.value,
					quantity: form.quantityAdd.value,
					calculationUsage : form.calculationUsage.value,
					calculateOrder: "1",
					storeId : this.storeId,
					catalogId : this.catalogId,
					langId : this.langId
				};
				
				/*For Handling multiple clicks. */
				if(!submitRequest()){
					return;
				}
				cursor_wait();
				wcService.invoke('AjaxAddSavedOrderItem',params);
			},

			/**
			 * Adds item to the current order
			 * @param {Integer} partNumber The partNumber of the item to add to the current order.
			 * @param (string) row The row number of the quantity input in the table.
			 * @param (string) catEntryId The catentry ID of the item
			 */
			addItemToCurrentOrder:function(partNumber, row, catEntryId){
				var params = {
					storeId: this.storeId,
					catalogId: this.catalogId,
					langId: this.langId,
					calculationUsage: "-1,-2,-3,-4,-5,-6,-7",
					calculateOrder: "0",
					mergeToCurrentPendingOrder: "Y",
					URL: "",
					partNumber: partNumber,
					inventoryValidation: true,
					orderId: ".",
					quantity: $("#orderItem_input_" + row).val()
				};
				
				// used by mini shopcart
				var selectedAttrList = new Object();
				shoppingActionsJS.saveAddedProductInfo(params["quantity"], catEntryId, catEntryId, selectedAttrList);
				
				MessageHelper.hideAndClearMessage();
				
				/*For Handling multiple clicks. */
				if(!submitRequest()){
					return;
				}
				cursor_wait();
				wcService.invoke('AddOrderItem',params);
				// close action dropdown
				hideMenu($('#actionButton' + row)[0]);
				hideMenu($('#actionDropdown' + row)[0]);
			},

			/**
			 * This function deletes an order item from a saved order.
			 * @param {Integer} orderItemId The ID of the order item to delete.
			 */
			deleteItem:function(orderItemId){ 
				var params = {
					orderItemId: orderItemId,
					storeId : this.storeId,
					catalogId : this.catalogId,
					langId : this.langId,
					orderId : Utils.existsAndNotEmpty(this.orderId) ? this.orderId : ".",
					calculationUsage : "-1,-2,-3,-4,-5,-6,-7",
					check: "*n"
				};
				
				//For handling multiple clicks
				if(!submitRequest()){
					return;
				}
				
				cursor_wait();
				wcService.invoke("AjaxSavedOrderDeleteItem", params);
				
			},
			
			/**
			 * Updates the quantities of each item in the saved order, if the quantities are changed.
			 * @param (string) qty The quantity value to update to.
			 * @param (string) orderItemId The ID of the saved order to update.
			 * @param (string) row The row number of the quantity input in the table.
			 */
			updateItemQuantity:function (qty, orderItemId, row) {
				if(isNaN(qty)){
					$("#orderItem_input_"+row).val($("#oldOrderItem_input_"+row).val());
					MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_SAVED_ORDER_QUANTITY_ONE_OR_MORE"]);
					return;
				} else {
					var params = {
						orderId : Utils.existsAndNotEmpty(this.orderId) ? this.orderId : ".",
						quantity: qty,
						orderItemId: orderItemId,
						storeId : this.storeId,
						catalogId : this.catalogId,
						langId : this.langId,
						calculationUsage : "-1,-2,-3,-4,-5,-6,-7",
						check: "*n",
						calculateOrder: "1"
					};
					
					this.currentRow = row;
					if(!submitRequest()){
						return;
					}
					cursor_wait();
					wcService.invoke('AjaxSavedOrderUpdateItem',params);
				}
				
			},
			
			/**
			 * Sets the selected saved order as the current order when the <b>Set as Current Order and Checkout</b> button is clicked.
			 * This method updates the current order in the database to match the order in the shopping cart.
			 *
			 * @param orderId The ID of the saved order.
			 * **/
			setCurrentOrderAndCheckout : function(orderId) {
				if (Utils.isNullOrUndefined(this.orderId)) {
					this.orderId = orderId;
				}
				
				var params = {
					storeId : this.storeId,
					catalogId : this.catalogId,
					langId : this.langId,
					URL : "AjaxOrderItemDisplayView",
					orderId : this.orderId,
					nextAction: true
				};
				
				//For handling multiple clicks
				if(!submitRequest()){
					return;
				}
				cursor_wait();
				wcService.invoke("AjaxUpdatePendingOrder", params);
			},
			
			/**
			 * Display saved order items for pagination
             * TODO: check if this is unused, it appears to be ...
			 */
			showResultsPage:function(data){
				var pageNumber = data['pageNumber'];
				var pageSize = data['pageSize'];
				pageNumber = parseInt(pageNumber);
				pageSize = parseInt(pageSize);
		
				setCurrentId(data["linkId"]);
		
				if(!submitRequest()){
					return;
				}
		
				console.debug(wcRenderContext.getRenderContextProperties("SavedOrderItemTable_Context"));
				var beginIndex = pageSize * ( pageNumber - 1 );
				cursor_wait();
				wcRenderContext.updateRenderContext('SavedOrderItemTable_Context', {'beginIndex':beginIndex});
				MessageHelper.hideAndClearMessage();
			},

			/**
			* Shows the "quantity updated" message next to quantity input
			* This function is automatically called by the successHandler of AjaxUpdateOrderItem.
			*/
			showUpdatedMessage: function() {
				$("#orderItem_msg_qty_updated_"+this.currentRow).css("display", "block");
				$("#orderItem_input_"+this.currentRow).css("border", "1px solid #006ecc");
				setTimeout("SavedOrderItemsJS.hideUpdatedMessage("+this.currentRow+")", 3000);
			},

			/**
			* Hides the "quantity updated" message next to quantity input
			* @param {Integer} row The row number of the quantity input in the table
			*/		
			hideUpdatedMessage: function(row) {
				$("#orderItem_msg_qty_updated_"+row).css("display", "none");
				$("#orderItem_input_"+row).css("border", "1px solid #b7b7b7");
			},
						
			/**
			 * Checks if a string is null or empty.
			 * @param (string) str The string to check.
			 * @return (boolean) Indicates whether the string is empty.
			 */
			isEmpty: function(str) {
				var reWhiteSpace = new RegExp(/^\s+$/);
				if (str == null || str =='' || reWhiteSpace.test(str) ) {
					return true;
				}
				return false;
			}
	};//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This file provides all the functions and variables to manage member group within.
 * This file is included in all pages with organization users member group actions.
 */

/**
 * This service allow administrator to update roles of member
 * @constructor
 */
wcService.declare({
	id:"RESTUserMbrGrpMgtMemberUpdate",
	actionId:"RESTUserMbrGrpMgtMemberUpdate",
	url:"RESTupdateMemberUser",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["USERMEMBERGROUPMANAGEMENT_UPDATE_SUCCESS"]);
	}
		
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}			
});

/**
 * This class defines the functions and variables that customers can use to create, update, and view their buyers list.
 * @class The UserMemberGroupManagementJS class defines the functions and variables that customers can use to manage their buyers list, 
 */
UserMemberGroupManagementJS = {		
	
	/**
	 * the widget name
	 * @private
	 */
	widgetShortName: "UserMemberGroupManagement",
	/** 
	 * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
	 * @private
	 */
	langId: "-1",
	
	/** 
	 * This variable stores the ID of the current store. Its default value is empty.
	 * @private
	 */
	storeId: "",
	
	/** 
	 * This variable stores the ID of the catalog. Its default value is empty.
	 * @private
	 */
	catalogId: "",
	
	/**
	 * The member group form Id.
	 * @private
	 */
	formId: "",
	
	/**
	 * The element Id for inclusion member group select dropdown widget.
	 * @private
	 */
	includeGrpDropdownId: "",
	
	/**
	 * The element id for exclusion member group select dropdown widget.
	 * @private
	 */
	excludeGrpDropdownId: "",
	
	/**
	 * The array of assigned include member group IDs.
	 * @private
	 */
	assignedIncGroups: new Array(),
	
	/**
	 * The array of assigned exclude member group IDs.
	 * @private
	 */
	assignedExcGroups: new Array(),
			
	/**
	 * Sets the common parameters for the current page. 
	 * For example, the language ID, store ID, and catalog ID.
	 * 
	 * @param {Integer} langId The ID of the language that the store currently uses.
	 * @param {Integer} storeId The ID of the current store.
	 * @param {Integer} catalogId The ID of the catalog.
	 * @param {String} formId The ID of the member group form.
	 * @param {String} includeGrpDropdownId The ID of the inclusive member group select option dropdown.
	 * @param {String} excludeGrpDropdownId The ID of the exclusive member group select option dropdown.
	 */
	setCommonParameters: function(langId,storeId,catalogId, formId, includeGrpDropdownId, excludeGrpDropdownId){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;
		this.formId = formId;
		this.includeGrpDropdownId = includeGrpDropdownId;
		this.excludeGrpDropdownId = excludeGrpDropdownId;
		cursor_clear();
	},
	
	/**
	 * Initialize assignedIncGroups and assignedExcGroups array on page load and after refresh.
	 */
	initializeData: function(){
		var form = document.getElementById(this.formId);
		var _this = this;
		if (form !== undefined && form !== null){
			
			_this.assignedExcGroups = [];
			_this.assignedIncGroups = [];

			$(form).find("input[name='addAsExplicitInclusionToMemberGroupId']").each( $.proxy(function(i, incGrp) {
				_this.assignedIncGroups.push($(incGrp).val().replace(/^\s+|\s+$/g, ''));
			}, _this));

			$(form).find("input[name='addAsExplicitExclusionToMemberGroupId']").each( $.proxy(function(i, excGrp) {
				_this.assignedExcGroups.push($(excGrp).val().replace(/^\s+|\s+$/g, ''));
			}, _this));

		}
	},
	
	/**
	 * Initialize the URL for controller 'declareUserMemberGroupManagement_controller'. 	 
	 *
	 * @param {object} widgetUrl The URL for declareUserMemberGroupManagement_controller.
	 */
	initializeControllerUrl:function(widgetUrl){
		$('#UserMemberGroupManagement').attr("refreshurl", widgetUrl);
	},
	
	/**
	 * Subscribe to press cancel button event
	 */
	subscribeToToggleCancel: function(){
		var topicName = "sectionToggleCancelPressed";
 		var scope = this;

		wcTopic.subscribe( topicName, function(data) {
			if (data.target === 'WC_UserMemberGroupManagement_pageSection'){
				scope.doCancel();
			}
		});
	},
	
	/**
	 * Handle select a include group from include group select dropdown
	 * @param (Integer) grpId The ID of the member group to select
	 */
	selectIncGrp: function(grpId){
		var _this = this;
		if (grpId != ''){
			//create the corresponding input
			var formNode = $("#" + _this.formId);
			formNode.append("<input type='hidden' name='addAsExplicitInclusionToMemberGroupId' value='" + grpId + "'/>");
			//disable corresponding entry in select dropdown
			var includeGrpDropdown = $("#" + _this.includeGrpDropdownId);
			includeGrpDropdown.val("");
			includeGrpDropdown.find("[value='" + grpId + "']").attr("disabled", true);
			includeGrpDropdown.Select("refresh");

			var excludeGrpDropdown = $("#" + _this.excludeGrpDropdownId);
			excludeGrpDropdown.find("[value='" + grpId + "']").attr("disabled", true);
			excludeGrpDropdown.Select("refresh");
			
			$(".includeMbrGrp .entryField[data-grpId='"+grpId+"']").attr("aria-hidden", "false");
		}
	},
	
	/**
	 * Handle click on a cross icon of a member group in Include member group section
	 * @param (Integer) grpId The ID of the member group to de-select
	 */
	deselectIncGrp: function(grpId){
		var _this = this;

		var formNode = $("#" + _this.formId);
		//remove the corresponding input
		$("#"+_this.formId+" input[value='"+grpId+"']").each(function(){
			this.parentNode.removeChild(this);
		});
		
		//update the select dropdown
		var includeGrpDropdown = $("#" + _this.includeGrpDropdownId);
		includeGrpDropdown.find("[value='" + grpId + "']").attr("disabled", false);
		includeGrpDropdown.Select("refresh");
		
		var excludeGrpDropdown = $("#" + _this.excludeGrpDropdownId);
		excludeGrpDropdown.find("[value='" + grpId + "']").attr("disabled", false);
		excludeGrpDropdown.Select("refresh");

		$(".includeMbrGrp .entryField[data-grpId='"+grpId+"']").attr("aria-hidden", "true");
	},
	
	/**
	 * Handle select a excluding group from exclude group select dropdown
	 * @param (Integer) grpId The ID of the member group to select 
	 */
	selectExcGrp: function(grpId){
		var _this = this;
		if (grpId != ''){
			//create the corresponding input
			var formNode = $("#" + _this.formId);
			formNode.append("<input type='hidden' name='addAsExplicitExclusionToMemberGroupId' value='" + grpId + "'/>");
			//disable corresponding entry in select dropdown
			var includeGrpDropdown = $("#" + _this.includeGrpDropdownId);
			includeGrpDropdown.find("[value='"+grpId+"']").attr("disabled", true);
			includeGrpDropdown.Select("refresh");
			
			var excludeGrpDropdown = $("#" + _this.excludeGrpDropdownId);
			excludeGrpDropdown.val("");
			excludeGrpDropdown.find("[value='"+grpId+"']").attr("disabled", true);
			excludeGrpDropdown.Select("refresh");

			$(".excludeMbrGrp .entryField[data-grpId='"+grpId+"']").attr("aria-hidden", "false");
		}
	},
	
	/**
	 * Handle click on a cross icon of a member group in Exclude member group section
	 * @param (Integer) grpId The ID of the member group to de-select
	 */
	deselectExcGrp: function(grpId){
		var _this = this;

		var formNode = $("#" + _this.formId);
		//remove the corresponding input
		formNode.children("input[value='"+grpId+"']").each(function(){
			this.parentNode.removeChild(this);
		});
		
		var includeGrpDropdown = $("#" + _this.includeGrpDropdownId);
		includeGrpDropdown.find("[value='" + grpId + "']").attr("disabled", false);
		includeGrpDropdown.Select("refresh");
		
		var excludeGrpDropdown = $("#" + _this.excludeGrpDropdownId);
		excludeGrpDropdown.find("[value='" + grpId + "']").attr("disabled", false);
		excludeGrpDropdown.Select("refresh");
		
		$(".excludeMbrGrp .entryField[data-grpId='"+grpId+"']").attr("aria-hidden", "true");
	},
	
	/**
	 * Handle cancel call back when click on 'cancel' button
	 */
	doCancel: function(){
		var scope = this;
			
		// set disable to "false" for all options
		var includeGrpDropdown = $("#" + scope.includeGrpDropdownId);
		var excludeGrpDropdown = $("#" + scope.excludeGrpDropdownId);
		includeGrpDropdown.find("option").each(function(){
			$(this).attr("disabled", false);
		});
		excludeGrpDropdown.find("option").each(function(){
			$(this).attr("disabled", false);
		});
		
		var formNode = $("#" + scope.formId);
		formNode.find("input[name='addAsExplicitInclusionToMemberGroupId']").each(function(i, incGrp) {
			incGrp.parentNode.removeChild(incGrp);
		});
		formNode.find("input[name='addAsExplicitExclusionToMemberGroupId']").each(function(i, excGrp) {
			excGrp.parentNode.removeChild(excGrp);
		});
		
		//set disabled to true for select groups
		$(scope.assignedIncGroups).each( $.proxy(function(index, incGrp){
			includeGrpDropdown.find("[value='" + incGrp + "']").attr("disabled", true);
			excludeGrpDropdown.find("[value='" + incGrp + "']").attr("disabled", true);
			var formNode = $("#" + this.formId);
			formNode.append("<input type='hidden' name='addAsExplicitInclusionToMemberGroupId' value='" + incGrp + "'/>");
		}, scope));
		
		$(scope.assignedExcGroups).each( $.proxy(function(index, excGrp){
			includeGrpDropdown.find("[value='" + excGrp + "']").attr("disabled", true);
			excludeGrpDropdown.find("[value='" + excGrp + "']").attr("disabled", true);
			var formNode = $("#" + this.formId);
			formNode.append("<input type='hidden' name='addAsExplicitExclusionToMemberGroupId' value='" + excGrp + "'/>");
		}, scope));
		
		$(".includeMbrGrp .entryField").each( $.proxy(function(index, entry){
			var grpId = $(entry).attr("data-grpId");
			if (this.assignedIncGroups.indexOf(grpId) < 0 ){
				$(entry).attr("aria-hidden", "true");
			}
			else {
				$(entry).attr("aria-hidden", "false");
			}
		}, scope));
		$(".excludeMbrGrp .entryField").each( $.proxy(function(index, entry){
			var grpId = $(entry).attr("data-grpId");
			if (this.assignedExcGroups.indexOf(grpId) < 0 ){
				$(entry).attr("aria-hidden", "true");
			}
			else {
				$(entry).attr("aria-hidden", "false");
			}
		}, scope));
		
		includeGrpDropdown.Select("refresh");
		excludeGrpDropdown.Select("refresh");
	},
	
	/**
	 * Save changes when press "Save" button
	 */
	saveChange: function(){
		
		var params = {};
		params.removeFromMemberGroupId =  this.assignedExcGroups.concat(this.assignedIncGroups);
		wcService.getServiceById('RESTUserMbrGrpMgtMemberUpdate').setFormId(this.formId);
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		wcService.invoke('RESTUserMbrGrpMgtMemberUpdate', params);
	}
};
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------



/**
 * Declares a new refresh controller for update member group select.
 */
function declareUserMemberGroupManagement_controller() {
	var myWidgetObj = $("#UserMemberGroupManagement");
	
	/** 
	 * Refreshes the organization users list display if a list item is updated
	 * This function is called when a modelChanged event is detected. 
	 */
	wcTopic.subscribe(["RESTUserMbrGrpMgtMemberUpdate","UserRoleManagementUpdate"], function() {
		myWidgetObj.refreshWidget("refresh");
	});
	
	myWidgetObj.refreshWidget({
		/** 
		 * Clears the progress bar
		 */
		postRefreshHandler: function() {
			widgetCommonJS.removeSectionOverlay();
			cursor_clear();
			UserMemberGroupManagementJS.initializeData();
			//Initialize toggle events after page refresh
			widgetCommonJS.initializeEditSectionToggleEvent();
		}
	});
};
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This file provides all the functions and variables to manage user roles within.
 * This file is included in all pages with organization users role assignment actions.
 */
/* global KeyCodes */

/**
 * This service allow administrator to assign roles of member
 * @constructor
 */
wcService.declare({
	id:"UserRoleManagementAssign",
	actionId:"UserRoleManagementAssign",
	url:"AjaxRESTMemberRoleAssign",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		if (UserRoleManagementJS.paramsToUnAssign !== undefined && UserRoleManagementJS.paramsToUnAssign !== null){
			wcService.invoke('UserRoleManagementUnassign',UserRoleManagementJS.paramsToUnAssign);
		}
		else {
			MessageHelper.hideAndClearMessage();
			UserRoleManagementJS.updateAssignedRolesMap();
			UserRoleManagementJS.updateReadOnlySummary();
			widgetCommonJS.toggleEditSection(document.getElementById('WC_UserRoleManagement_pageSection'));
			cursor_clear();
			MessageHelper.displayStatusMessage(MessageHelper.messages["USERROLEMANAGEMENT_UPDATE_SUCCESS"]);
		}
	}
		
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}			
});

/**
 * This service allow administrator to un assign roles of member
 * @constructor
 */
wcService.declare({
	id:"UserRoleManagementUnassign",
	actionId:"UserRoleManagementUnassign",
	url:"AjaxRESTMemberRoleUnassign",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		if (UserRoleManagementJS.removingAdminRole){
			cursor_clear();
			MessageHelper.displayStatusMessage(MessageHelper.messages["USERROLEMANAGEMENT_UPDATE_SUCCESS"]);
			document.location.href = UserRoleManagementJS.myAccountURL;
		}
		else {
			UserRoleManagementJS.updateAssignedRolesMap();
			UserRoleManagementJS.updateReadOnlySummary();
			widgetCommonJS.toggleEditSection(document.getElementById('WC_UserRoleManagement_pageSection'));
			cursor_clear();
			UserRoleManagementJS.paramsToUnAssign = null;
			MessageHelper.displayStatusMessage(MessageHelper.messages["USERROLEMANAGEMENT_UPDATE_SUCCESS"]);
		}
	}
		
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(MessageHelper.messages["USERROLEMANAGEMENT_UNASSIGN_FAIL"] + serviceResponse.errorMessage);
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				 MessageHelper.displayErrorMessage(MessageHelper.messages["USERROLEMANAGEMENT_UNASSIGN_FAIL"] + serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}			
});

/**
 * This service allow administrator to update roles of member
 * @constructor
 */
wcService.declare({
	id:"ChainedUserRoleManagementAssign",
	actionId:"ChainedUserRoleManagementAssign",
	url:"AjaxRESTMemberRoleAssign",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		
		document.location.href = OrganizationUserInfoJS.getChainedServiceRediretUrl();
		cursor_clear();		
		MessageHelper.displayStatusMessage(MessageHelper.messages["ORGANIZATIONUSER_CREATE_SUCCESS"]);
	}
		
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(MessageHelper.messages["USERROLEMANAGEMENT_CHAINCREATE_FAIL"] + serviceResponse.errorMessage);
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(MessageHelper.messages["USERROLEMANAGEMENT_CHAINCREATE_FAIL"] + serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}			
});
  	
/**
 * This class defines the functions and variables that customers can use to create, update, and view their buyers list.
 * @class The OrganizationUsersListJS class defines the functions and variables that customers can use to manage their buyers list, 
 */
UserRoleManagementJS = {		
	
	/**
	 * the widget name
	 * @private
	 */
	widgetShortName: "UserRoleManagement",
	
	/**
	 * the name of Buyer Administrator Role
	 * @private
	 */
	buyerAdmin: "Buyer Administrator",
	
	/** 
	 * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
	 * @private
	 */
	langId: "-1",
	
	/** 
	 * This variable stores the ID of the current store. Its default value is empty.
	 * @private
	 */
	storeId: "",
	
	/** 
	 * This variable stores the ID of the catalog. Its default value is empty.
	 * @private
	 */
	catalogId: "",
	
	/** 
	 * This variable stores the ID of member.
	 * @private
	 */
	memberId: "",
	
	/** 
	 * This variable stores the ID of the buyer admin.
	 * @private
	 */
	adminId: "",
	
	/**
	 * The id of selected Org.
	 * @private
	 */
	selectedOrg: "",
	
	/**
	 * The map contains Organization IDs and corresponding name, 
	 * at least one of the roles in the Organization is assigned to member.
	 * The key is Organization ID, value is name of a Organization.
	 */
	assignedOrgNameMap: new Object(),
	
	/**
	 * The map contains role IDs and corresponding name for roles that are
	 * currently assigned to the member.
	 * The key is Role ID, value is an array contains name of a Role and 
	 * frequence of the name appears in assigned roles. [name, freqence]
	 */
	assignedRoleNameMap: new Object(),
	
	/**
	 * The map contains Organization IDs and corresponding name, 
	 * at least one of the roles in the Organization is selected for the member.
	 * The map is initialized to assignedOrgNameMap
	 * on page load, and is updated correspondingly upon selection change
	 * The key is Organization ID, value is name of a Organization.
	 */
	selectedOrgNameMap: new Object(),
	
	/**
	 * The map contains Organization IDs and corresponding name, 
	 * for the Organizaiton currently displayed in the table.
	 * The map is initialized to assignedOrgNameMap
	 * on page load, and is updated correspondingly upon selection change
	 * The key is Organization ID, value is name of a Organization.
	 */
	currentOrgNameMap: new Object(),
	
	/**
	 * The map contains role IDs and corresponding name for roles that are
	 * currently selected for the member. The map is initialized to assignedRoleNameMap
	 * on page load, and is updated correspondingly upon selection change
	 * The key is Role ID, value is an array contains name of a Role and 
	 * frequence of the name appears in select roles. [name, freqence]
	 * the name will be removed from map is frequence equals 0
	 */
	selectedRoleNameMap: new Object(),
	
	/**
	 * The map contains role IDs and corresponding name for roles that are
	 * currently show in role selector column for a selected Organization
	 * The key is Role ID, value is name of a Role.
	 */
	selectedOrgRoleNameMap: new Object(),
	
	/**
	 * The map stores the all but hidden roles that the user has, roles in this map can be unassigned by current Admin. 
	 * The key of the map is Organization ID, the value is an array of role IDs
	 */
	assignedRolesMap: new Object(),
	
	/**
	 * The map stores the all roles that are selected by Admin for the user. 
	 * The key of the map is Organization ID, the value is an array of role IDs
	 */
	selectedRolesMap: new Object(),
	
	/**
	 * The display pattern of Org and Role for Selection summary column 
	 * The pattern is loaded from corresponding resource bundle define in widgetText
	 */
	orgDisplayPattern: "",
	
	/**
	 * The display pattern of Role for Selection summary column 
	 * The pattern is loaded from corresponding resource bundle define in widgetText
	 */
	roleDisplayPattern: "",
	
	/**
	 * The Checkbox column children html template
	 * The template is defined in UI jspf file
	 */
	roleCheckboxTemplate: "",
	
	/**
	 * The selection summary column children html template
	 * The template is defined in UI jspf file
	 */
	selectionSummaryTemplate: "",
	
	/**
	 * The read only summary view html template
	 * The template is defined in UI jspf file
	 */
	summaryViewTemplate: "",
	
	/**
	 * The prepared params for unAssign service command
	 */
	paramsToUnAssign: null,
	
	/**
	 * Indicates if we are removing admin role for the buyer him/herself, default value is false
	 */
	removingAdminRole: false,
	
	/**
	 * The URL to my account page.
	 */
	myAccountURL: "",
	
	/**
	 * Sets the common parameters for the current page. 
	 * For example, the language ID, store ID, and catalog ID.
	 *
	 * @param {Integer} langId The ID of the language that the store currently uses.
	 * @param {Integer} storeId The ID of the current store.
	 * @param {Integer} catalogId The ID of the catalog.
	 * @param {Integer} memberId The ID of the member.
	 * @param {Integer} authToken The authToken for current user to perform operation on server.
	 * @param (String) myAccountURL The url for MyAcount page
	 */
	setCommonParameters: function(langId,storeId,catalogId, memberId, adminId, authToken, myAccountURL){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;
		this.memberId = memberId;
		this.adminId = adminId;
		this.authToken = authToken;
		this.myAccountURL = myAccountURL;
		cursor_clear();
	},
	
	/**
	 * Initialize the URL of Role Assignment widget controller. 	 
	 *
	 * @param {object} roleSelectorUrl The roleSelector checkbox region controller's URL.
	 * @param {object} orgListUrl The  controller's URL for roleSelector region, which refreshes after org list change.
	 */
	initUserRoleManagementControllerUrl:function(roleSelectorUrl, orgListUrl){
		$('#UserRoleManagement_RoleSelector').attr("refreshurl", roleSelectorUrl);
		$('#UserRoleManagement_OrgList').attr("refreshurl", orgListUrl);
	},
	
	/**
	 * Handle press cancel button
	 */
	subscribeToToggleCancel: function(){
		var topicName = "sectionToggleCancelPressed";
		var scope = this;
		wcTopic.subscribe( topicName , $.proxy( function(data){
			if (data.target === 'WC_UserRoleManagement_pageSection'){
				this.selectedRolesMap = JSON.parse(JSON.stringify(this.assignedRolesMap));
				this.selectedRoleNameMap = JSON.parse(JSON.stringify(this.assignedRoleNameMap));
				this.selectedOrgNameMap = JSON.parse(JSON.stringify(this.assignedOrgNameMap));
				this.updateSelectionSummary();
				this.removingAdminRole = false;
				if (this.selectedOrg != ""){
					this.updateSelectorCheckbox(this.selectedOrg);
				}
			}
		}, this));
	},
	
	/**
	 * Upon success service response, copy the selectedRolesMap to assignedRolesMap
	 */
	updateAssignedRolesMap: function(){
		this.assignedRolesMap = JSON.parse(JSON.stringify(this.selectedRolesMap));
		this.assignedRoleNameMap = JSON.parse(JSON.stringify(this.selectedRoleNameMap));
		this.assignedOrgNameMap = JSON.parse(JSON.stringify(this.selectedOrgNameMap));
	},
	
	/**
	 * orgDisplayPattern, roleDisplayPattern
	 */
	loadDisplayPattern: function(orgPattern, rolePattern){
		this.roleDisplayPattern = rolePattern;
		this.orgDisplayPattern = orgPattern;
	},
	
	/**
	 * Read only Summary view template
	 */
	loadSummaryViewTemplate: function(orgPattern, rolePattern){
		this.summaryViewTemplate = $("#WC_UserRoleManagement_read_template").html().replace(/^\s+|\s+$/g, '');
	},
	
	/**
	 * Update currentOrgNameMap after Org list refresh
	 */
	updateCurrentOrgNameMap: function(){
		var incurrentOrgNameMap = JSON.parse($("#currentOrgNameMap").html());
		if (incurrentOrgNameMap !== undefined && incurrentOrgNameMap !== null){
			this.currentOrgNameMap = JSON.parse(JSON.stringify(incurrentOrgNameMap));
		}
	},
	
	/**
	 * assignedOrgNameMap, assignedRoleNameMap,selectedOrgNameMap, 
	 * selectedRoleNameMap, 
	 * currentOrgNameMap, 
	 * userHiddenRolesMap, assignedRolesMap, selectedRolesMap
	 * summaryViewTemplate, selectionSummary column template
	 */
	initializeDataForView: function(){
		var inassignedOrgNameMap = JSON.parse($("#assignedOrgNameMap").html());
		var inassignedRoleNameMap = JSON.parse($("#assignedRoleNameMap").html());
		var incurrentOrgNameMap = JSON.parse($("#currentOrgNameMap").html());
		if (inassignedOrgNameMap !== undefined && inassignedOrgNameMap !== null){
			this.assignedOrgNameMap = JSON.parse(JSON.stringify(inassignedOrgNameMap));
			this.selectedOrgNameMap = JSON.parse(JSON.stringify(inassignedOrgNameMap));
		}
		if (inassignedRoleNameMap !== undefined && inassignedRoleNameMap !== null){
			this.assignedRoleNameMap = JSON.parse(JSON.stringify(inassignedRoleNameMap));
			this.selectedRoleNameMap = JSON.parse(JSON.stringify(inassignedRoleNameMap));
		}
		if (incurrentOrgNameMap !== undefined && incurrentOrgNameMap !== null){
			this.currentOrgNameMap = JSON.parse(JSON.stringify(incurrentOrgNameMap));
		}
		var inSelectedOrgRoleNameMap = JSON.parse($("#selectedOrgRoleNameMap").html());
		if (inSelectedOrgRoleNameMap !== undefined && inSelectedOrgRoleNameMap !== null){
			this.selectedOrgRoleNameMap = JSON.parse(JSON.stringify(inSelectedOrgRoleNameMap));
		}
		this.selectionSummaryTemplate = $("#WC_UserRoleManagement_edit_additionalRoles_selectionSummary_panel_template").html().replace(/^\s+|\s+$/g, '');
		
		//for edit buyer
		this.assignedRolesMap = JSON.parse($("#userRoles").html());
		this.selectedRolesMap = JSON.parse($("#userRoles").html());
		
		var templateDom = $("#WC_UserRoleManagement_read_template");
		if (templateDom[0] !== undefined && templateDom[0] !== null){
			this.summaryViewTemplate = templateDom.html().replace(/^\s+|\s+$/g, '');
		}
	},
	
	/**
	 * Set role Name map in Selected Org after selecting a Org.
	 */
	setSelectedOrgRoleNameMap: function(){
		
		var inSelectedOrgRoleNameMap = JSON.parse($("#selectedOrgRoleNameMap").html());
		if (inSelectedOrgRoleNameMap !== undefined && inSelectedOrgRoleNameMap !== null){
			this.selectedOrgRoleNameMap = JSON.parse(JSON.stringify(inSelectedOrgRoleNameMap));
		}
	},
	
	/**
	 * Helper function to set userRoles and userHiddenRoles map
	 */
	setUserRolesMap:function(inArray, targetMap){
		if (inArray !== undefined && inArray !== null){
			for (var i=0; i < inArray.length; i++ ){
				var key = inArray[i][1]; //org id
				var value = inArray[i][0]; //role id
				if(Object.prototype.hasOwnProperty.call(targetMap, key)){
					if ( targetMap[key].indexOf(value)=== -1){
						targetMap[key].push(value);
					}
				}
				else{
					targetMap[key] = [value];
				}
			}
		}
	},
	
	/**
	 * Handle click on Role selector checkbox.
	 */
	toggleRoleCheckbox: function(role){
		var org = this.selectedOrg;
		this.updateSelectedRole(org, role);
		this.updateSelectorCheckbox();
		this.updateSelectionSummary();
	},
	
	/**
	 * Update selected roles and corresponding role name map
	 */
	updateSelectedRole: function(org, role){
		if (Object.prototype.hasOwnProperty.call(this.selectedRolesMap,org)){
			// has role in this org
			var index = this.selectedRolesMap[org].indexOf(role);
			if (index > -1){//exists , so remove it
				this.selectedRolesMap[org].splice(index, 1);
				if (this.selectedRolesMap[org].length == 0){//remove empty org
					delete this.selectedRolesMap[org];
					delete this.selectedOrgNameMap[org];
				}
				if (this.selectedRoleNameMap[role][1] == 1){
					delete this.selectedRoleNameMap[role];
				}
				else {
					this.selectedRoleNameMap[role][1] = this.selectedRoleNameMap[role][1] - 1;
				}
			}
			else {//does have the role, add to selected map
				this.selectedRolesMap[org].push(role);
				
				if (!Object.prototype.hasOwnProperty.call(this.selectedRoleNameMap,role)){
					this.selectedRoleNameMap[role] = [this.selectedOrgRoleNameMap[role].displayName, 1];
				}
				else{
					this.selectedRoleNameMap[role][1] = this.selectedRoleNameMap[role][1] + 1;
				}
			}
		}
		else{
			// no role was assigned from this org, create a new array for this org.
			this.selectedRolesMap[org] = [role];
			this.selectedOrgNameMap[org] = this.currentOrgNameMap[org];
			if (!Object.prototype.hasOwnProperty.call(this.selectedRoleNameMap,role)){
				this.selectedRoleNameMap[role] = [this.selectedOrgRoleNameMap[role].displayName, 1];
			}
			else{
				this.selectedRoleNameMap[role][1] = this.selectedRoleNameMap[role][1] + 1;
			}
		}
		
	}, 
	
	/**
	 * Select an Organization
	 */
	selectOrg: function(orgId){
		if (this.selectedOrg == orgId) {
			return;
		}

		$('#WC_UserRoleManagement_edit_additionalRoles_organizations div[data-orgid]').each(function(index, node){
			if (node.getAttribute('data-orgid') == orgId ){
				$(node).addClass("highlight");
				Utils.scrollIntoView(node);
			}
			else {
				$(node).removeClass("highlight");
			}
		});
		//normal select case
		if (Object.prototype.hasOwnProperty.call(this.currentOrgNameMap,orgId)){
			this.selectedOrg = orgId;
			if(!submitRequest()){
				return;
			}			
			cursor_wait();
			wcRenderContext.updateRenderContext("UserRoleManagement_RoleSelector_Context", {"orgId": orgId});
		}
		//select from summary column where the Org is not in current page, switch to search;
		else{
			this.selectedOrg = "";
			var orgNameSearch = this.selectedOrgNameMap[orgId];
			var searchInputFieldId = 'WC_UserRoleManagement_edit_additionalRoles_searchInput';
			var searchInput = document.getElementById(searchInputFieldId);
			searchInput.value = orgNameSearch;
			this.showClearFilter();
			this.updateOrgListContext(orgNameSearch, orgId, "5");// "5" is exact match search type.
		}
	},
	
	/**
	 * Update view of selector check box area, check or uncheck, highlight or not etc.
	 */
	updateSelectorCheckbox: function(){
		var panelParent = $("#WC_UserRoleManagement_edit_additionalRoles_roleSelector_panel");
		panelParent.removeClass("highlight");
		var foundCheckbox = false;
		panelParent.find(".checkBoxer").each($.proxy( function(index, aCheckbox){
			var role = aCheckbox.getAttribute("data-userRoleId");
			var org = this.selectedOrg;
			foundCheckbox = true;
			if (Object.prototype.hasOwnProperty.call(this.selectedRolesMap,org) && this.selectedRolesMap[org].indexOf(role)!== -1){
				aCheckbox.setAttribute("aria-checked", "true");
			}
			else{
				aCheckbox.setAttribute("aria-checked", "false");
			}
		}, this));
		if(foundCheckbox){
			panelParent.addClass("highlight");
		}
	},
	
	/**
	 * Update view of selection summary column.
	 */
	updateSelectionSummary: function(){
		var panelParent = $("#WC_UserRoleManagement_edit_additionalRoles_selectionSummary_panel");
		panelParent.empty();
		var selectedSummary = null;
		for ( var key in this.selectedRolesMap){
			//key is Org Id
			var displayString = "";
			var orgName = this.selectedOrgNameMap[key];
			var roleName = "";
			var roleArray = this.selectedRolesMap[key];
			$(roleArray).each( $.proxy( function(index, role){
				var rn = this.selectedRoleNameMap[role][0];
				if (roleName.length === 0){
					roleName = rn;
				}
				else {
					roleName = Utils.substituteStringWithMap(this.roleDisplayPattern, {0: roleName, 1: rn});
				}
			}, this));
			if (roleName.length > 0){
				displayString = Utils.substituteStringWithMap(this.orgDisplayPattern, {0: this.selectedOrgNameMap[key], 1: roleName});
			}
			if (displayString.length > 0){
				var aSummary = $(Utils.substituteStringWithMap(this.selectionSummaryTemplate, {0: displayString}));
				if (key == this.selectedOrg){
					aSummary.addClass("highlight");
					selectedSummary = aSummary;
				}
				aSummary.find("a").each($.proxy( function(index, a){
					var k = key; //orgId, variable in forEach scope only
					if ($(a).hasClass("icon")){
						if (k == this.selectedOrg){
							$(a).removeClass("nodisplay");
							$(a).on("click", $.proxy( function(e){
								$(this.selectedRolesMap[k]).each( $.proxy( function(index, r){
									if (this.selectedRoleNameMap[r][1] == 1){
										delete this.selectedRoleNameMap[r];
									}
									else {
										this.selectedRoleNameMap[r][1] = this.selectedRoleNameMap[r][1] -1;
									}
								}, this));
								delete this.selectedRolesMap[k];
								delete this.selectedOrgNameMap[k];
								this.updateSelectorCheckbox();
								this.updateSelectionSummary();
								e.preventDefault();
								e.stopPropagation();
							}, this));
						}
					}
					else if ($(a).hasClass("roleName")){
						$(a).on("click", $.proxy( function(e){
							this.selectOrg(k);
							e.preventDefault();
							e.stopPropagation();
						}, this));
					}
				}, this));
				panelParent.append(aSummary);
			}
		}
		if (selectedSummary != null ){
			Utils.scrollIntoView(selectedSummary);
		}
	},
	
	/**
	 * Update view of Read only summary according to assigned role map.
	 */
	updateReadOnlySummary: function(){
		
		var sectionParent = $("#WC_UserRoleManagement_read");
		if (sectionParent !== undefined && sectionParent !== null){

			sectionParent.empty();
			
			for ( var key in this.assignedRolesMap){
				//key is Org Id
				var displayString = "";
				var orgName = this.assignedOrgNameMap[key];
				var roleArray = this.assignedRolesMap[key];
				$(roleArray).each( $.proxy( function(i, role){
					var invisibleString = "<span style='visibility: hidden'>&nbsp;</span>";
					var roleName = this.assignedRoleNameMap[role][0];
					
					if ( i == 0){
						var nodeChild = $(Utils.substituteStringWithMap(this.summaryViewTemplate, {0: orgName, 1: roleName}));
					}
					else {
						var nodeChild = $(Utils.substituteStringWithMap(this.summaryViewTemplate, {0: invisibleString, 1:roleName}));
					}

					sectionParent.append(nodeChild);
					
				}, this));
			}
		}
	},
	
	updateView: function(){
		var searchInputFieldId = 'WC_UserRoleManagement_edit_additionalRoles_searchInput';
		this.updateReadOnlySummary();
		if(this.currentOrgNameMap.first !== undefined && this.currentOrgNameMap.first !== null ){
			this.selectedOrg = this.currentOrgNameMap.first;
		}
		$("#" + searchInputFieldId).on("keydown", $.proxy( function(e){
			var charOrCode = e.charCode || e.keyCode;
			if (charOrCode == KeyCodes.ENTER){
				this.doSearch();
			}
		}, this));
		this.updateOrganizationPanel();
		this.updateSelectionSummary();
		this.updateSelectorCheckbox();
		
		$('#WC_UserRoleManagement').on("keydown", ".roleSelector .checkField .checkBoxer", $.proxy( function(e){
			var charOrCode = e.charCode || e.keyCode;
			if (charOrCode == KeyCodes.SPACE || charOrCode == KeyCodes.ENTER){
				
				var checkbox = $( $(e.target).parents(".checkField")[0] ).find(".checkBoxer")[0];
				var role = checkbox.getAttribute("data-userRoleId");
				var ariaChecked = checkbox.getAttribute("aria-checked");
				if (this.adminId == this.memberId && ariaChecked == "true" && this.selectedOrgRoleNameMap[role].name == this.buyerAdmin){
					wcTopic.subscribeOnce( "adminRoleRemoveConfirmed" , $.proxy( function(data){
						if (data.action == "YES"){
							this.toggleRoleCheckbox(role);
							this.removingAdminRole = true;
						}
					}, this), this);	
					MessageHelper.showConfirmationDialog("adminRoleRemoveConfirmed",
							Utils.substituteStringWithMap(MessageHelper.messages['USERROLEMANAGEMENT_CONFIRMATIONDIALOGMESSAGE'], {0: this.selectedOrgRoleNameMap[role].displayName}));
				}else {
					this.toggleRoleCheckbox(role);
					if (this.adminId == this.memberId &&  ariaChecked != "true" && this.selectedOrgRoleNameMap[role].name == this.buyerAdmin){
						this.removingAdminRole = false;
					}
				}
				e.preventDefault();
				e.stopPropagation();
			}
		}, this));
		$('#WC_UserRoleManagement').on("click", ".roleSelector .checkField .checkBoxer", $.proxy( function(e){
			var checkbox = $( $(e.target).parents(".checkField")[0] ).find(".checkBoxer")[0];
			var role = checkbox.getAttribute("data-userRoleId");
			var ariaChecked = checkbox.getAttribute("aria-checked");
			if (this.adminId == this.memberId && ariaChecked == "true" && this.selectedOrgRoleNameMap[role].name == this.buyerAdmin){
				wcTopic.subscribeOnce( "adminRoleRemoveConfirmed" , $.proxy( function(data){
					if (data.action == "YES"){
						this.toggleRoleCheckbox(role);
						this.removingAdminRole = true;
					}
				}, this), this);
				MessageHelper.showConfirmationDialog("adminRoleRemoveConfirmed",
						Utils.substituteStringWithMap(MessageHelper.messages['USERROLEMANAGEMENT_CONFIRMATIONDIALOGMESSAGE'], {0: this.selectedOrgRoleNameMap[role].displayName}));
			}else {
				this.toggleRoleCheckbox(role);
				if (this.adminId == this.memberId && ariaChecked != "true" && this.selectedOrgRoleNameMap[role].name == this.buyerAdmin){
					this.removingAdminRole = false;
				}
			}
			e.preventDefault();
			e.stopPropagation();
		}, this));
	},
	
	/**
	 * handle Seach button press
	 */
	doSearch: function(){
		var inputFieldId = 'WC_UserRoleManagement_edit_additionalRoles_searchInput';
		var input = document.getElementById(inputFieldId);
		var orgNameSearch = input.value;
		if (orgNameSearch.replace(/^\s+|\s+$/g, '') != ""){
			this.selectedOrg = "";
			this.showClearFilter();
			this.updateOrgListContext(orgNameSearch, "");
		}
	},
	
	/**
	 * Update context to show page according specific number.
	 * 
	 * @param data The data for updating context.
	 */
	showPage:function(data){
		var pageNumber = data['pageNumber'];
		var pageSize = data['pageSize'];
			pageNumber = parseInt(pageNumber);
			pageSize = parseInt(pageSize);
		var beginIndex = pageSize * ( pageNumber - 1 );

		if(!submitRequest()){
			return;
		}			
		cursor_wait();
		wcRenderContext.updateRenderContext("UserRoleManagement_OrgList_Context", {"selectOrgId":"", "beginIndex" : beginIndex});
	},
	
	/**
	 * clear the search when press clear filter button
	 */
	clearSearch: function(){
		var inputFieldId = 'WC_UserRoleManagement_edit_additionalRoles_searchInput';
		var input = document.getElementById(inputFieldId);
		input.value='';
		this.selectedOrg = "";
		this.hideClearFilter();
		this.updateOrgListContext('', '');
	},
	
	updateOrgListContext: function(orgNameSearch, selectOrgIdTokeep, searchType){
		if (searchType === undefined || searchType === null){
			searchType = "4"; //ignore case, containing
		}
		var beginIndex = "0";
		if(!submitRequest()){
			return;
		}			
		cursor_wait();
		wcRenderContext.updateRenderContext("UserRoleManagement_OrgList_Context", {"orgNameSearch": orgNameSearch, "selectOrgId":selectOrgIdTokeep, "searchType": searchType, "beginIndex" : beginIndex});
	},
	
	/**
	 * Update to show clear filter button
	 */
	showClearFilter: function(){
		var filterButtonId = 'WC_UserRoleManagement_edit_clearFilter';
		var filterButton = $("#" + filterButtonId);
		filterButton.attr("aria-hidden", "false");
	},
	
	/**
	 * Update to hide clear filter button
	 */
	hideClearFilter: function(){
		var filterButtonId = 'WC_UserRoleManagement_edit_clearFilter';
		var filterButton = $("#" + filterButtonId);
		filterButton.attr("aria-hidden", "true");			
	},
	
	/**
	 * Update the Organizations panel after refresh, pre-select Organization
	 */
	updateOrganizationPanel: function() {
		$('#WC_UserRoleManagement_edit_additionalRoles_organizations div[data-orgid]').each($.proxy( function(index, node){
			if (node.getAttribute('data-orgid') == this.selectedOrg ){
				$(node).addClass("highlight");
				Utils.scrollIntoView(node);
			}
			else {
				$(node).removeClass("highlight");
			}
		}, this));
	},
	
	/**
	 * Save the assigned and unassigned roles to server
	 */
	saveChange: function(){
		
		var params = {};
		
		this.prepareSelectedRoleParam(params);
		
		if (params['paramsToUnAssign'] !== undefined && params['paramsToUnAssign'] !== null) {
			this.paramsToUnAssign = JSON.parse(JSON.stringify(params['paramsToUnAssign']));
		}
		
		if (params['paramsToAssign'] !== undefined && params['paramsToAssign'] !== null) {
			if(!submitRequest()){
				return;
			}
			cursor_wait();
			wcService.invoke('UserRoleManagementAssign',params['paramsToAssign']);
		}
		else if (params['paramsToUnAssign'] !== undefined && params['paramsToUnAssign'] !== null) {
			if(!submitRequest()){
				return;
			}
			cursor_wait();
			wcService.invoke('UserRoleManagementUnassign',params['paramsToUnAssign']);
		} else {
			return;
		}
		
	},

	/**
	 * The function is called by successHandler of service chainedAjaxUserRegistrationAdminAdd
	 * to assign additional roles to the member just created.
	 * @param memberId the id of the member the role to assign
	 */
	chainedAssignRole: function(memberId){
		this.memberId = memberId;
		var params = {};
		this.prepareSelectedRoleParam(params);
		// the caller (userInfo widget service successHandler) will check if any role is selected for 
		// the member, so it is guaranteed that the params['paramsToAssign'] is not null or undefined.
		wcService.invoke('ChainedUserRoleManagementAssign',params['paramsToAssign']);
	},
	
	/**
	 * Function to test if the selectedRolesMap is empty.
	 * @return (Boolean) true if this selectedRolesMap is empty, false otherwise 
	 */
	isEmptySelectedRoles: function() {
		for (var k in this.selectedRolesMap){
			return false;
		}
		return true;
	},
	
	/**
	 * Helper function for saveChange
	 */
	prepareSelectedRoleParam: function(params){
		var paramsToAssign = {};
		var paramsToUnAssign = {};
		var n1 = 0;
		var n2 = 0;
		for ( var key in this.selectedRolesMap){
			var roles = this.selectedRolesMap[key];
			for ( var i = 0; i < roles.length; i++){
				if (undefined == this.assignedRolesMap[key] || null == this.assignedRolesMap[key] 
					|| this.assignedRolesMap[key].indexOf(roles[i]) === -1 ){
					n1 = n1 + 1;
					paramsToAssign['orgEntityId' + n1] = key;
					paramsToAssign['roleId' + n1] = roles[i];
				}
			}
		}
		
		for ( var key in this.assignedRolesMap){
			var roles = this.assignedRolesMap[key];
			for ( var i = 0; i < roles.length; i++){
				if (undefined === this.selectedRolesMap[key] || null === this.selectedRolesMap[key] 
					|| this.selectedRolesMap[key].indexOf(roles[i]) === -1 ){
					n2 = n2 + 1;
					paramsToUnAssign['orgEntityId' + n2] = key;
					paramsToUnAssign['roleId' + n2] = roles[i];
				}
			}
		}
		 
		if (n1 > 0 ){
			paramsToAssign.URL = "StoreView";//old command still check the presence of the 'URL' parameter
			paramsToAssign.storeId = this.storeId;
			paramsToAssign.langId = this.langId;
			paramsToAssign.memberId = this.memberId;
			paramsToAssign.authToken = this.authToken;
			params.paramsToAssign = paramsToAssign;
		}
		if (n2 > 0){
			paramsToUnAssign.URL = "StoreView";
			paramsToUnAssign.storeId = this.storeId;
			paramsToUnAssign.langId = this.langId;
			paramsToUnAssign.memberId = this.memberId;
			paramsToUnAssign.authToken = this.authToken;
			params.paramsToUnAssign = paramsToUnAssign;
		}
	}
	
};;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * Declares a new render context for role assignment role selector check box area.
 */
wcRenderContext.declare("UserRoleManagement_RoleSelector_Context",["UserRoleManagement_RoleSelector"],{"orgId":""});
/**
 * searchType: 
 * 		4 containing, ignore case
 * 		5 match case, exact match
 * 	
 */
wcRenderContext.declare("UserRoleManagement_OrgList_Context",["UserRoleManagement_OrgList"],{"beginIndex":"0", "orgNameSearch":"", "selectOrgId":"", "searchType":"4"});


/**
 * Declares a new refresh controller for update role selector check box.
 */
function declareUserRoleManagement_RoleSelector_controller() {
	var myWidgetObj = $("#UserRoleManagement_RoleSelector");

	var myRCProperties = wcRenderContext.getRenderContextProperties("UserRoleManagement_RoleSelector_Context");
	
	myWidgetObj.refreshWidget({
		/** 
		 * Refreshes the list table display if an item is updated.
		 * This function is called when a render context event is detected. 
		 */    	   
		renderContextChangedHandler: function() {					
			myWidgetObj.refreshWidget("refresh", myRCProperties);
	    },
		
		/** 
		 * Clears the progress bar
		 */
		postRefreshHandler: function() {
			UserRoleManagementJS.setSelectedOrgRoleNameMap();
			UserRoleManagementJS.updateSelectorCheckbox();
			UserRoleManagementJS.updateSelectionSummary();
			cursor_clear();			 
		}
	});
};

/**
 * Declares a new refresh controller for update organization list in .
 */
function declareUserRoleManagement_OrgList_controller() {
	var myWidgetObj = $("#UserRoleManagement_OrgList");
	
	var myRCProperties = wcRenderContext.getRenderContextProperties("UserRoleManagement_OrgList_Context");
	
	myWidgetObj.refreshWidget({
		/** 
		 * Refreshes the list table display if an item is updated.
		 * This function is called when a render context event is detected. 
		 */    	   
		renderContextChangedHandler: function() {
			myWidgetObj.refreshWidget("refresh", myRCProperties);
	    },
		
		/** 
		 * Clears the progress bar
		 * 
		 * @param {object} widget The registered refresh area
		 */
		postRefreshHandler: function(widget) {
	
			UserRoleManagementJS.updateCurrentOrgNameMap();
			UserRoleManagementJS.setSelectedOrgRoleNameMap();
			
			if (myRCProperties.selectOrgId != ''){
				//select the org preselected by user in selection summary column
				UserRoleManagementJS.selectedOrg = myRCProperties.selectOrgId;
			}else if (UserRoleManagementJS.currentOrgNameMap.first !== undefined && UserRoleManagementJS.currentOrgNameMap.first !== null){
				//select the first org in the list shown
				UserRoleManagementJS.selectedOrg = UserRoleManagementJS.currentOrgNameMap.first;
			}else {
				UserRoleManagementJS.selectedOrg = "";
			}
			UserRoleManagementJS.updateSelectorCheckbox();
			UserRoleManagementJS.updateSelectionSummary();
			UserRoleManagementJS.updateOrganizationPanel();
			cursor_clear();
		}
	});
};
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------


/** 
 * @fileOverview This file contains all the global variables and JavaScript functions needed for wish list page in My Account section.
 * This JavaScript file defines all the functions used  by the AccountWishDisplay.jsp file.
 * @version 1.0
 */

/* Declare the namespace if it does not already exist. */
if (WishListDetailJS == null || typeof(WishListDetailJS) != "object") {
	/**
	 * @class This WishListDetailJS class defines all the variables and functions for the wish list page of My account section.
	 * The wish list page displays all the wish list item of an user and provides functions like remove from the wish list, add to cart, etc.
	 *
	 */
	var WishListDetailJS = {	
		/* Global variables used in the CompareProductDisplay page. */
			
		/** The contextChanged is a boolean flag indicating whether the context was changed and if there is a need to refresh the wish list result. */
		contextChanged:false, 

		/**
		* This function is called when user selects a different page from the current page
		* @param (Object) data The object that contains data used by pagination control 
		*/
		showResultsPage:function(data){
			var pageNumber = parseInt(data['pageNumber']) - 1,
				pageSize = parseInt(data['pageSize']),
				beginIndex = pageSize * pageNumber;

			setCurrentId(data["linkId"]);

			if(!submitRequest()){
				return;
			}

			cursor_wait();

			if($("#WishlistDisplay_Widget").length){
				wcRenderContext.updateRenderContext("WishlistDisplay_Context", {startIndex: beginIndex, currentPage: pageNumber});
			}

			if($("#SharedWishlistDisplay_Widget").length) {	
				wcRenderContext.updateRenderContext("SharedWishlistDisplay_Context", {startIndex: beginIndex, currentPage: pageNumber});
			}
			MessageHelper.hideAndClearMessage();
		},

		/**
		 * Updates the ContentURL and does not cause an Ajax refresh. 
		 * 
		 * @param {string} contentURL  the value of the controller URL.
		 */
		updateContentURL: function(contentURL) {
			if($("#WishlistDisplay_Widget").length){
				$("#WishlistDisplay_Widget").refreshWidget("updateUrl", contentURL);
			}

			if($("#SharedWishlistDisplay_Widget").length) {
				$("#SharedWishlistDisplay_Widget").refreshWidget("updateUrl", contentURL);
			}
		},

		/**
		* Updates the ContentURL and causes an Ajax refresh. 
		* 
		* @param {string} contentURL  the value of the controller URL.
		*/
		loadContentURL:function(contentURL){
			/* Handles multiple clicks */
			if(!submitRequest()){
				return;
			}   	
			cursor_wait();
			if($("#WishlistDisplay_Widget").length){
				$("#WishlistDisplay_Widget").refreshWidget("updateUrl", contentURL);
				wcRenderContext.updateRenderContext("WishlistDisplay_Context");
			}

			if($("#SharedWishlistDisplay_Widget").length) {
				$("#SharedWishlistDisplay_Widget").refreshWidget("updateUrl", contentURL);		
				wcRenderContext.updateRenderContext("SharedWishlistDisplay_Context");
			}
		}
	};
}
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This file contains all the global variables and JavaScript functions needed for wish list email widget used in My Account section.
 * This JavaScript file defines all the functions used by the WishListEmail.jsp file.
 * @version 1.0
 */

/* Declare the namespace if it does not already exist. */
if (WishListEmailJS == null || typeof(WishListEmailJS) != "object") {
	/**
	 * @class This WishListEmailJS class defines all the variables and functions for the wish list email widget used in the My account section.
	 *
	 */
	var WishListEmailJS = {
		/**
		* This function is used to clear some of the fields in the email form in wish list page after InterestItemListMessage is invoked.
		* @param {string} formId  the id of the email form in WishList page.
		*/	
		clearWishListEmailForm:function(formId){
			var form = document.getElementById(formId);
			form.recipient.value = "";
			form.sender_name.value = "";
			form.sender_email.value = "";
			form.wishlist_message.value="";
		}
	}
}




;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This javascript is used by the Approval List pages to control the refresh areas.
 * @version 1.2
 */
var declareOrderApprovalListRefreshArea = function() {
    var myWidgetObj = $("#OrderApprovalTable_Widget");

    wcRenderContext.declare("OrderApprovalTable_Context", ["OrderApprovalTable_Widget"], {"beginIndex":"0", "orderId": "", "firstName": "", "lastName":"","startDate":"","endDate":"","approvalStatus":"0"});

    wcTopic.subscribe(["AjaxApproveOrderRequest","AjaxRejectOrderRequest"], function() {
        myWidgetObj.refreshWidget("refresh", wcRenderContext.getRenderContextProperties("OrderApprovalTable_Context"));
    });

    myWidgetObj.refreshWidget({
        renderContextChangedHandler: function() {
            myWidgetObj.refreshWidget("refresh", wcRenderContext.getRenderContextProperties("OrderApprovalTable_Context"));
        }, 
        postRefreshHandler: function() {
            OrderApprovalListJS.restoreToolbarStatus();
            cursor_clear();
        }
    });
}        
 
/**
 * Declares a new refresh controller for buyer approval.
 */
var declareBuyerApprovalTableRefreshArea = function() {
	var myWidgetObj = $("#BuyerApprovalTable_Widget");
    
    /**
     * Declares a new render context for buyer approval list table
     */
	wcRenderContext.declare("BuyerApprovalTable_Context", ["BuyerApprovalTable_Widget"], {
        "beginIndex": "0",
        "approvalId": "",
        "firstName": "",
        "lastName": "",
        "startDate": "",
        "endDate": "",
        "approvalStatus": "0"
	});
  	
	wcTopic.subscribe(["AjaxApproveBuyerRequest","AjaxRejectBuyerRequest"], function() {
		myWidgetObj.refreshWidget("refresh", wcRenderContext.getRenderContextProperties("BuyerApprovalTable_Context"));
	});
    
	myWidgetObj.refreshWidget({
		renderContextChangedHandler: function () {
            myWidgetObj.refreshWidget("refresh", wcRenderContext.getRenderContextProperties("BuyerApprovalTable_Context"));
        },

        postRefreshHandler: function() {
        	BuyerApprovalListJS.restoreToolbarStatus();
            cursor_clear();
        }
	});
}

/**
 * Declares a new refresh controller for buyer approval comment.
 */
var declareApprovalCommentController = function() {    
    var myWidgetObj = $("#ApprovalComment_Widget");
    
    /**
     * Declares a new render context for approval comments widget
     */
    wcRenderContext.declare("ApprovalComment_Context", ["ApprovalComment_Widget"], {
       "approvalStatus": "all"
    });
    
    /** 
	* Refreshes the approval comment widget if a request is approved/rejected.
	* This function is called when a modelChanged event is detected. 
	* 
	* @param {string} message The model changed event message
	* @param {object} widget The registered refresh area
	*/    
    wcTopic.subscribe(["AjaxApproveRequest","AjaxRejectRequest"], function() {
		myWidgetObj.refreshWidget("refresh", wcRenderContext.getRenderContextProperties("ApprovalComment_Context"));
	});
    
    myWidgetObj.refreshWidget({
        /** 
        * This function is called when a render context changed event is detected. 
        * 
        * @param {string} message The render context changed event message
        * @param {object} widget The registered refresh area
        */
        renderContextChangedHandler: function () {
            myWidgetObj.refreshWidget("refresh", wcRenderContext.getRenderContextProperties("ApprovalComment_Context"));
        }
    });
};;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This javascript is used by the Approval List Pages to handle the services for 
 * approving/rejecting a buyer/order approval record.
 * @version 1.10
 */

/**
 * This service allows approvers and admins to approve a order request
 * @constructor
 */
wcService.declare({
	id:"AjaxApproveOrderRequest",
	actionId:"AjaxApproveOrderRequest",
	url:"AjaxRESTHandleApproval",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["APPROVAL_APPROVE_SUCCESS"]);
	}
	
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}	
}),

/**
 * This service allows approvers and admins to approve a order request
 * @constructor
 */
wcService.declare({
	id:"AjaxRejectOrderRequest",
	actionId:"AjaxRejectOrderRequest",
	url:"AjaxRESTHandleApproval",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["APPROVAL_REJECT_SUCCESS"]);
	}
	
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}	
}),

/**
 * This service allows approvers and admins to approve a buyer request
 * @constructor
 */
wcService.declare({
	id:"AjaxApproveBuyerRequest",
	actionId:"AjaxApproveBuyerRequest",
	url:"AjaxRESTHandleApproval",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["APPROVAL_APPROVE_SUCCESS"]);
	}
	
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}	
}),

/**
 * This service allows approvers and admins to approve a buyer request
 * @constructor
 */
wcService.declare({
	id:"AjaxRejectBuyerRequest",
	actionId:"AjaxRejectBuyerRequest",
	url:"AjaxRESTHandleApproval",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["APPROVAL_REJECT_SUCCESS"]);
	}
	
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}	
}),

/**
 * This service allows approvers and admins to approve a request
 * @constructor
 */
wcService.declare({
	id:"AjaxApproveRequest",
	actionId:"AjaxApproveRequest",
	url:"AjaxRESTHandleApproval",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["APPROVAL_APPROVE_SUCCESS"]);
	}
	
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}	
}),

/**
 * This service allows approvers and admins to approve a request
 * @constructor
 */
wcService.declare({
	id:"AjaxRejectRequest",
	actionId:"AjaxRejectRequest",
	url:"AjaxRESTHandleApproval",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["APPROVAL_REJECT_SUCCESS"]);
	}
	
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}	
})

	

;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2017 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

productDisplayJS = {

    /** The language ID currently in use **/
    langId: "-1",

    /** The store ID currently in use **/
    storeId: "",

    /** The catalog ID currently in use **;/
    catalogId: "",

    /** Holds the current user type such as guest or registered user. Allowed values are 'G' for guest and 'R' for registered.**/
    userType: "",

    /** A boolean used in a variety of the add to cart methods to tell whether or not the base item was added to the cart. **/
    baseItemAddedToCart: false,

    /** An array of entitled items which is used in various methods throughout ShoppingActions.js **/
    entitledItems: [],

    /** a JSON object that holds attributes of an entitled item **/
    entitledItemJsonObject: null,

    /** A map of attribute name value pairs for the currently selected attribute values **/
    selectedAttributesList: {},

    /** A map of currently selected attribute values for a catalog entry **/
    selectedAttributeValues: {},

    /** A map of HTML element ids associated with an attribute name **/
    registeredAttributeIds: {},

    /** A variable used to form the url dynamically for the more info link in the Quickinfo popup */
    moreInfoUrl: "",

    /**
     * A boolean used to to determine is it from a Qick info popup or not. 
     **/
    isPopup: false,

    /**
     * A boolean used to to determine whether or not to display the price range when the catEntry is selected. 
     **/
    displayPriceRange: true,

    /**
     * This array holds the json object returned from the service, holding the price information of the catEntry.
     **/
    itemPriceJsonOject: [],

    /** 
     * stores all name and value of all swatches 
     * this is a 2 dimension array and each record i contains the following information:
     * allSwatchesArray[i][0] - attribute name of the swatch
     * allSwatchesArray[i][1] - attribute value of the swatch
     * allSwatchesArray[i][2] - image1 of swatch (image to use for enabled state)
     * allSwatchesArray[i][3] - image2 of swatch (image to use for disabled state)
     * allSwatchesArray[i][4] - onclick action of the swatch when enabled
     **/
    allSwatchesArrayList: {},

    /**
     * stores all name and id of all dropdowns 
     **/
    allDropdownsList: {},

    /**
     * Holds the ID of the image used for swatch
     **/
    skuImageId: "",

    /**
     * The prefix of the cookie key that is used to store item IDs. 
     */
    cookieKeyPrefix: "CompareItems_",

    /**
     * The delimiter used to separate item IDs in the cookie.
     */
    cookieDelimiter: ";",

    /**
     * The maximum number of items allowed in the compare zone. 
     */
    maxNumberProductsAllowedToCompare: 4,

    /**
     * The minimum number of items allowed in the compare zone. 
     */
    minNumberProductsAllowedToCompare: 2,

    /**
     * Id of the base catalog entry. 
     */
    baseCatalogEntryId: 0,

    /**
     * An map which holds the attributes of a set of products
     */
    selectedProducts: {},

    /**
     * An array to keep the quantity of the products in a list (bundle)
     */
    productList: {},

    /**
     * stores the currency symbol
     */
    currencySymbol: "",

    /**
     * stores the compare return page name
     */
    compareReturnName: "",
    /**
     * stores the search term
     */
    searchTerm: "",

    search01: "'",

    search02: '"',

    replaceStr01: /\\\'/g,

    replaceStr02: /\\\"/g,

    ampersandChar: /&/g,

    ampersandEntityName: "&amp;",

    singleSKUProductWithoutDefiningAttribute: false,

    replaceStr001: "&#039;",
    replaceStr002: "&#034;",

    setCommonParameters: function (langId, storeId, catalogId, userType, currencySymbol) {
        productDisplayJS.langId = langId;
        productDisplayJS.storeId = storeId;
        productDisplayJS.catalogId = catalogId;
        productDisplayJS.userType = userType;
        productDisplayJS.currencySymbol = currencySymbol;
    },

    setEntitledItems: function (entitledItemArray) {
        productDisplayJS.entitledItems = entitledItemArray;
    },

    getCatalogEntryId: function (entitledItemId) {
        var attributeArray = [];
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        // there are no selected attribute and no entitled item, this must be a single sku item without defining attribute
        if (selectedAttributes == null && this.entitledItems == null) {
            return entitledItemId.substring(entitledItemId.indexOf("_") + 1);
        }
        return productDisplayJS.resolveSKU(attributeArray);
    },

    /**
     * getCatalogEntryIdforProduct Returns the catalog entry ID for a catalog entry that has the same attribute values as a specified product's selected attributes as passed in via the selectedAttributes parameter.
     *
     * @param {String[]} selectedAttributes The array of selected attributes upon which to resolve the SKU.
     *
     * @return {String} catalog entry ID of the SKU.
     *
     **/
    getCatalogEntryIdforProduct: function (selectedAttributes) {
        var attributeArray = [];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return productDisplayJS.resolveSKU(attributeArray);
    },

    /**
     * retrieves the entitledItemJsonObject
     */
    getEntitledItemJsonObject: function () {
        return productDisplayJS.entitledItemJsonObject;
    },

    /**
     * resolveSKU Resolves a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     *
     * @return {String} catentry_id The catalog entry ID of the SKU.
     *
     **/
    resolveSKU: function (attributeArray) {
        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var catentry_id = "";
        var attributeArrayCount = attributeArray.length;

        // if there is only one item, no need to check the attributes to resolve the sku
        if (this.entitledItems.length == 1) {
            return this.entitledItems[0].catentry_id;
        }
        for (x in this.entitledItems) {
            var catentry_id = this.entitledItems[x].catentry_id;
            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return catentry_id;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    if (attributeValue in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("CatEntryId:" + catentry_id + " for Attribute: " + attributeArray);
                    this.disableBuyButtonforUnbuyable(x);
                    return catentry_id;
                }
            }
        }
        return null;
    },

    /**
     * disables add2cart button in case where the buyable flag is set to false
     */
    disableBuyButtonforUnbuyable: function (entitledItemIndex) {
        var buyableFlag = this.entitledItems[entitledItemIndex].buyable;
        //disable the add to cart button
        var btn = document.getElementById("add2CartBtn");
        if (buyableFlag != null && btn != null) {
            if (buyableFlag == 'false') {
                btn.className += " add2CartButtonDisabled";
            } else {
                btn.className = btn.className.replace(" add2CartButtonDisabled", "");
            }
        }
    },

    /**
     * registerAttributeIds Register the ids of HTML attributes that are associated with the specified attribute.
     *
     * @param {String} attributeName The name of the attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     * @param {Object} ids Map of named HTML element ids
     *
     **/
    registerAttributeIds: function (attributeName, entitledItemId, ids) {
        var attributeIds = productDisplayJS.registeredAttributeIds[entitledItemId];
        if (attributeIds == null) {
            attributeIds = {};
            productDisplayJS.registeredAttributeIds[entitledItemId] = attributeIds;
        }

        attributeIds[productDisplayJS.removeQuotes(attributeName)] = ids;
    },

    /**
     * getAttributeIds Get the map of ids of HTML attributes that are associated with the specified attribute.
     *
     * @param {String} attributeName The name of the attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     *
     * @return {Object} ids Map of named HTML element ids
     *
     **/
    getAttributeIds: function (attributeName, entitledItemId) {
        var ids = null;
        var attributeIds = productDisplayJS.registeredAttributeIds[entitledItemId];
        if (attributeIds != null) {
            ids = attributeIds[productDisplayJS.removeQuotes(attributeName)];
        }
        return ids;
    },

    /**
     * setSelectedAttribute Sets the selected attribute value for a particular attribute not in reference to any catalog entry.
     *					   One place this function is used is on CachedProductOnlyDisplay.jsp where there is a drop down box of attributes.
     *					   When an attribute is selected from that drop down this method is called to update the selected value for that attribute.
     *
     * @param {String} selectedAttributeName The name of the attribute.
     * @param {String} selectedAttributeValue The value of the selected attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     * @param {String} selectedAttributeDisplayValue This is optional. The attribute display value formatted with UOM
     *
     **/
    setSelectedAttribute: function (selectedAttributeName, selectedAttributeValue, entitledItemId, skuImageId, imageField, selectedAttributeDisplayValue) {
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        if (selectedAttributes == null) {
            selectedAttributes = {};
        }
        selectedAttributeValue = selectedAttributeValue.replace(productDisplayJS.replaceStr001, productDisplayJS.search01);
        selectedAttributeValue = selectedAttributeValue.replace(productDisplayJS.replaceStr002, productDisplayJS.search02);
        selectedAttributeValue = selectedAttributeValue.replace(productDisplayJS.replaceStr01, productDisplayJS.search01);
        selectedAttributeValue = selectedAttributeValue.replace(productDisplayJS.replaceStr02, productDisplayJS.search02);
        selectedAttributeValue = selectedAttributeValue.replace(productDisplayJS.ampersandChar, productDisplayJS.ampersandEntityName);
        selectedAttributes[selectedAttributeName] = selectedAttributeValue;
        productDisplayJS.moreInfoUrl = productDisplayJS.moreInfoUrl + '&' + selectedAttributeName + '=' + selectedAttributeValue;
        productDisplayJS.selectedAttributesList[entitledItemId] = selectedAttributes;
        if (skuImageId != undefined) {
            productDisplayJS.setSKUImageId(skuImageId);
        }
        var entitledItemJSON;
        if ($("#" + entitledItemId).length && !productDisplayJS.isPopup) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#" + entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object. 
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = productDisplayJS.getEntitledItemJsonObject();
        }
        productDisplayJS.setEntitledItems(entitledItemJSON);
        var attributeIds = productDisplayJS.getAttributeIds(selectedAttributeName, entitledItemId);
        if (attributeIds != null) {
            var usedFilterValue = $("#" + attributeIds.usedFilterValueId);
            if (usedFilterValue != null) {
                if (selectedAttributeDisplayValue) {
                    $(usedFilterValue).html(selectedAttributeDisplayValue);
                } else {
                    $(usedFilterValue).html(selectedAttributeValue);
                }
            }
            if (selectedAttributeValue === "") {
                $("#" + attributeIds.usedFilterId).removeClass("visible");
                var hideCurrentUsedFilters = true;
                var dropdownList = this.allDropdownsList[entitledItemId];
                for (var i in dropdownList) {
                    if (selectedAttributes[dropdownList[i].name] !== "") {
                        hideCurrentUsedFilters = false;
                        break;
                    }
                }
                if (hideCurrentUsedFilters) {
                    $("#currentUsedFilters_" + entitledItemId).addClass("hidden");
                }
            } else {
                $("#" + attributeIds.usedFilterId).addClass("visible");
                $("#currentUsedFilters_" + entitledItemId).removeClass("hidden");
                var selectedAttributeNameId = selectedAttributeName.replace(productDisplayJS.search01, "\\\'").replace(productDisplayJS.search02, '\\\"');
                $("[id='attr_" + entitledItemId + '_' + selectedAttributeNameId + "']").addClass("hidden");
            }

            productDisplayJS.makeDropdownSelection(selectedAttributeName, selectedAttributeValue, entitledItemId);
        }
    },

    /**
     * resetSelectedAttribute Resets the the selected attribute value for the specified attribute.
     *
     * @param {String} attributeName The name of the attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     * @param {String} productUrl The url of the parent product
     *
     **/
    resetSelectedAttribute: function (attributeName, entitledItemId) {
        var attributeName = attributeName.replace(productDisplayJS.search01, "\\\'").replace(productDisplayJS.search02, '\\\"');
        $("[id='attr_" + entitledItemId + '_' + attributeName + "']").removeClass("hidden");

        var attributeIds = productDisplayJS.getAttributeIds(attributeName, entitledItemId);
        if (attributeIds != null) {
            var selectWidget = $(attributeIds.selectAttributeValueId);
            if (selectWidget.length) {
                selectWidget.val("");
                selectWidget.Select("refresh");
            }
        }

        var dropdownList = this.allDropdownsList[entitledItemId];
        var remainingSelectedAttributes = {};

        for (var i = 0; i < dropdownList.length; i++) {
            if (dropdownList[i].name.replace(/\\'/g, "'") == attributeName.replace(/\\'/g, "'")) {
                $(dropdownList[i].node).removeClass("hidden");
                $(dropdownList[i].node).val('');
                $(dropdownList[i].node).Select("refresh");
                $(dropdownList[i].node).change();
            } else {
                for (var j = 0; j < dropdownList[i].options.length; j++) {
                    if (dropdownList[i].options[j].selected === true) {
                        remainingSelectedAttributes[dropdownList[i].name] = dropdownList[i].options[j].value;
                    }
                }
            }
        }

        var urlWithoutParams = document.location.href.split('?')[0];
        var params = "?";

        var productUrl = "";
        if ($("#ProductDisplayURL").length) {
            productUrl = $("#ProductDisplayURL").html();
        }

        var displaySKUContextData = false;
        if ($("#displaySKUContextData").length) {
            displaySKUContextData = eval('(' + $("#displaySKUContextData").html() + ')');
        }

        if (displaySKUContextData && urlWithoutParams !== productUrl) {
            for (attr in remainingSelectedAttributes) {
                if (remainingSelectedAttributes.hasOwnProperty(attr)) {
                    params += attr + '=' + remainingSelectedAttributes[attr] + '&';
                }
            }

            params = params.slice(0, -1);
            params = params.replace("\\\'", "'").replace('\\\"', '"');
            document.location.replace(productUrl + params);
        }
    },

    /**
     * setSelectedAttributeName Set the selected attribute name and make the drop-down associated with the attribute visible.
     *
     * @param {String} attributeName The name of the attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     *
     **/
    setSelectedAttributeName: function (attributeName, entitledItemId) {
        var oldSelectedAttributeValuesId = productDisplayJS.selectedAttributeValues[entitledItemId];
        if (oldSelectedAttributeValuesId != null && oldSelectedAttributeValuesId !== "") {
            $("#" + oldSelectedAttributeValuesId).addClass("mobileHidden");
        }
        var selectedAttributeValuesId = null;
        var attributeIds = productDisplayJS.getAttributeIds(attributeName, entitledItemId);
        if (attributeIds != null) {
            selectedAttributeValuesId = attributeIds.attributeValuesId;
        }
        if (selectedAttributeValuesId != null && selectedAttributeValuesId !== "") {
            $("#" + selectedAttributeValuesId).removeClass("mobileHidden");
        }
        productDisplayJS.selectedAttributeValues[entitledItemId] = selectedAttributeValuesId;
    },

    /**
     * Add2ShopCartAjax This function is used to add a catalog entry to the shopping cart using an AJAX call. This will resolve the catentryId using entitledItemId and adds the item to the cart.
     *				This function will resolve the SKU based on the entitledItemId passed in and call {@link productDisplayJS.AddItem2ShopCartAjax}.
     * @param {String} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
     * @param {int} quantity The quantity of the item to add to the cart.
     * @param {String} isPopup If the value is true, then this implies that the function was called from a quick info pop-up. 	
     * @param {Object} customParams - Any additional parameters that needs to be passed during service invocation.
     *
     **/
    Add2ShopCartAjax: function (entitledItemId, quantity, isPopup, customParams) {
        var dialog = $('#quick_cart_container').data("wc-WCDialog");
        if (dialog) {
            dialog.close();
        }
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var entitledItemJSON;

        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#" + entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object. 
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = this.getEntitledItemJsonObject();
        }

        productDisplayJS.setEntitledItems(entitledItemJSON);
        var catalogEntryId = productDisplayJS.getCatalogEntryId(entitledItemId);

        if (catalogEntryId != null) {
            var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);
            productDisplayJS.AddItem2ShopCartAjax(catalogEntryId, quantity, customParams, productId);
            productDisplayJS.baseItemAddedToCart = true;

        } else if (isPopup == true) {
            $('#second_level_category_popup').css("zIndex", '1');
            MessageHelper.formErrorHandleClient('addToCartLinkAjax', Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
        } else {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
            productDisplayJS.baseItemAddedToCart = false;
        }
    },

    AddItem2ShopCartAjax: function (catEntryIdentifier, quantity, customParams, productId) {
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            orderId: "."
        };
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";
        params.inventoryValidation = "true";
        params.calculateOrder = "0";
        var ajaxShopCartService = "AddOrderItem";

        shoppingActionsJS.productAddedList = {};
        if (Array.isArray(catEntryIdentifier) && Array.isArray(quantity)) {
            for (var i = 0; i < catEntryIdentifier.length; i++) {
                if (!isPositiveInteger(quantity[i])) {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                    return;
                }
                params["catEntryId_" + (i + 1)] = catEntryIdentifier[i];
                params["quantity_" + (i + 1)] = quantity[i];
            }
        } else {
            if (!isPositiveInteger(quantity)) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }
            params.catEntryId = catEntryIdentifier;
            params.quantity = quantity;

            var selectedAttrList = {};
            for (attr in productDisplayJS.selectedAttributesList['entitledItem_' + productId]) {
                selectedAttrList[attr] = productDisplayJS.selectedAttributesList['entitledItem_' + productId][attr];
            }

            if (productId == undefined) {
                shoppingActionsJS.saveAddedProductInfo(quantity, catEntryIdentifier, catEntryIdentifier, selectedAttrList);
            } else {
                shoppingActionsJS.saveAddedProductInfo(quantity, productId, catEntryIdentifier, selectedAttrList);
            }
        }

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
            if (customParams['catalogEntryType'] == 'dynamicKit') {
                ajaxShopCartService = "AddPreConfigurationToCart";
            }
        }

        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
		
		cursor_wait();
		var addToCartEventConsumed = false;

		if(typeof callCenterIntegrationJS != 'undefined' && callCenterIntegrationJS != undefined && callCenterIntegrationJS != null){
			var catEntry = productDisplayJS.itemPriceJsonOject[params.catEntryId].catalogEntry;
			var partNumber = catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
			var wccParams = {};
			wccParams["partNumber"] = partNumber;
			addToCartEventConsumed = callCenterIntegrationJS.consumeAddToCartEvent(params,wccParams);
		}

		if(!addToCartEventConsumed) {
			wcService.invoke(ajaxShopCartService, params);
		}
        productDisplayJS.baseItemAddedToCart = true;

        if (document.getElementById("headerShopCartLink") && document.getElementById("headerShopCartLink").style.display != "none") {
            $("#headerShopCart").focus();
        } else {
            $("#headerShopCart1").focus();
        }
    },

    /* SwatchCode start */

    /**
     * Sets the ID of the image to use for swatch.
     * @param {String} skuImageId The ID of the full image element.
     **/
    setSKUImageId: function (skuImageId) {
        productDisplayJS.skuImageId = skuImageId;
    },

    /**
     * getImageForSKU Returns the full image of the catalog entry with the selected attributes as specified in the {@link productDisplayJS.selectedAttributes} value.
     *					This method uses resolveImageForSKU to find the SKU image with the selected attributes values.
     *
     * @param {String} imageField, the field name from which the image should be picked
     * @return {String} path to the SKU image.
     * 
     *
     **/
    getImageForSKU: function (entitledItemId, imageField) {
        var attributeArray = [];
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return productDisplayJS.resolveImageForSKU(attributeArray, imageField);
    },

    /**
     * resolveImageForSKU Resolves image of a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     * @param {String} imageField, the field name from which the image should be picked
     *
     * @return {String} imagePath The location of SKU image.
     *
     **/
    resolveImageForSKU: function (attributeArray, imageField) {
        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var imagePath = "";
        var attributeArrayCount = attributeArray.length;

        for (x in this.entitledItems) {
            if (null != imageField) {
                var imagePath = this.entitledItems[x][imageField];
            } else {
                var imagePath = this.entitledItems[x].ItemImage467;
            }

            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return imagePath;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    if (attributeValue in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("ItemImage:" + imagePath + " for Attribute: " + attributeArray);
                    var imageArray = [];
                    imageArray.push(imagePath);
                    imageArray.push(this.entitledItems[x].ItemThumbnailImage);
                    if (this.entitledItems[x].ItemAngleThumbnail != null && this.entitledItems[x].ItemAngleThumbnail != undefined) {
                        imageArray.push(this.entitledItems[x].ItemAngleThumbnail);
                        imageArray.push(this.entitledItems[x].ItemAngleFullImage);
                        imageArray.push(this.entitledItems[x].ItemAngleThumbnailShortDesc);
                    }
                    return imageArray;
                }
            }
        }
        return null;
    },


    /**
     * changeViewImages Updates the angle views of the SKU.
     *
     * @param {String[]} itemAngleThumbnail An array of SKU view thumbnails.
     * @param {String[]} itemAngleFullImage An array of SKU view full images.
     * @param {String[]} itemAngleThumbnailShortDesc An array of short description for the SKU view thumbnails.
     **/
    changeViewImages: function (itemAngleThumbnail, itemAngleFullImage, itemAngleThumbnailShortDesc) {
        var imageCount = 0;
        for (x in itemAngleThumbnail) {
            var prodAngleCount = imageCount;
            imageCount++;

            var thumbnailWidgets = $("ul[id^='ProductAngleImagesAreaList']");
            if ($(thumbnailWidgets).length) {
                for (var i = 0; i < thumbnailWidgets.length; i++) {
                    if (null != thumbnailWidgets[i]) {
                        var angleThumbnail = document.createElement("li");
                        var angleThumbnailLink = document.createElement("a");
                        var angleThumbnailImg = document.createElement("img");

                        angleThumbnail.id = "productAngleLi" + prodAngleCount;

                        angleThumbnailLink.href = "JavaScript:changeThumbNail('productAngleLi" + prodAngleCount + "','" + itemAngleFullImage[x] + "');";
                        angleThumbnailLink.id = "WC_CachedProductOnlyDisplay_links_1_" + imageCount;
                        if (itemAngleThumbnailShortDesc != 'undefined' && itemAngleThumbnailShortDesc != null) {
                            angleThumbnailLink.title = itemAngleThumbnailShortDesc[x];
                        }

                        angleThumbnailImg.src = itemAngleThumbnail[x];
                        angleThumbnailImg.id = "WC_CachedProductOnlyDisplay_images_1_" + imageCount;
                        if (itemAngleThumbnailShortDesc != 'undefined' && itemAngleThumbnailShortDesc != null) {
                            angleThumbnailImg.alt = itemAngleThumbnailShortDesc[x];
                        }

                        if (prodAngleCount == 0) {
                            $(thumbnailWidgets[i]).empty();
                        }

                        angleThumbnailLink.appendChild(angleThumbnailImg);
                        angleThumbnail.appendChild(angleThumbnailLink);
                        thumbnailWidgets[i].appendChild(angleThumbnail);
                    }
                }
            }
        }

        var displayImageArea = "";
        if (imageCount > 0) {
            displayImageArea = 'block';
        } else {
            displayImageArea = 'none';
        }
        var angleImageArea = $("div[id^='ProductAngleImagesArea']");
        if (angleImageArea.length) {
            for (var i = 0; i < angleImageArea.length; i++) {
                if (null != angleImageArea[i]) {
                    $(angleImageArea[i]).css("display", displayImageArea);
                }
            }
        }
    },

    /**
     * Updates the swatches selections on list view.
     * Sets up the swatches array and sku images, then selects a default swatch value.
     **/
    updateSwatchListView: function () {
        var swatchArray = $("a[id^='swatch_array_']");
        for (var i = 0; i < swatchArray.length; i++) {
            var swatchArrayElement = $(swatchArray[i]);
            eval($(swatchArrayElement).attr("href"));
        }

        var swatchSkuImage = $("a[id^='swatch_setSkuImage_']");
        for (var i = 0; i < swatchSkuImage.length; i++) {
            var swatchSkuImageElement = $(swatchSkuImage[i]);
            eval(swatchSkuImageElement.attr("href"));
        }

        var swatchDefault = $("a[id^='swatch_selectDefault_']");
        for (var i = 0; i < swatchDefault.length; i++) {
            var swatchDefaultElement = swatchDefault[i];
            eval(swatchDefaultElement.attr("href"));
        }
    },

    /**
     * Handles the case when a swatch is selected. Set the border of the selected swatch.
     * @param {String} selectedAttributeName The name of the selected swatch attribute.
     * @param {String} selectedAttributeValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     * @param {String} imageField, the field name from which the image should be picked
     * @return boolean Whether the swatch is available for selection
     **/
    selectSwatch: function (selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        if ($("#swatch_" + entitledItemId + "_" + selectedAttributeValue).hasClass("color_swatch_disabled")) {
            return;
        }
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            if (attribute == selectedAttributeName) {
                // case when the selected swatch is already selected with a value, if the value is different than
                // what's being selected, reset other swatches and deselect the previous value and update selection
                if (selectedAttributes[attribute] != selectedAttributeValue) {
                    // deselect previous value and update swatch selection
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + selectedAttributes[attribute]);
                    swatchElement.className = "color_swatch";
                    swatchElement.src = swatchElement.src.replace("_disabled.png", "_enabled.png");

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).title = swatchElement.alt;
                }
            }
            $("#swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).attr("aria-checked", "false");
        }
        this.makeSwatchSelection(selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField);
    },

    /**
     * Make swatch selection - add to selectedAttribute, select image, and update other swatches and SKU image based on current selection.
     * @param {String} swatchAttrName The name of the selected swatch attribute.
     * @param {String} swatchAttrValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.	
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     **/
    makeSwatchSelection: function (swatchAttrName, swatchAttrValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        productDisplayJS.setSelectedAttribute(swatchAttrName, swatchAttrValue, entitledItemId, skuImageId, imageField);
        document.getElementById("swatch_" + entitledItemId + "_" + swatchAttrValue).className = "color_swatch_selected";
        $("#swatch_link_" + entitledItemId + "_" + swatchAttrValue).attr("aria-checked", "true");
        document.getElementById("swatch_selection_label_" + entitledItemId + "_" + swatchAttrName).className = "header color_swatch_label";
        if ($("#swatch_selection_" + entitledItemId + "_" + swatchAttrName).css("display") == "none") {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display = "inline";
        }
        if (selectedAttributeDisplayValue != null) {
            $("#swatch_selection_" + entitledItemId + "_" + swatchAttrName).html(selectedAttributeDisplayValue);
        } else {
            $("#swatch_selection_" + entitledItemId + "_" + swatchAttrName).html(swatchAttrValue);
        }
        productDisplayJS.updateSwatchImages(swatchAttrName, entitledItemId, doNotDisable, imageField);
    },

    /**
     * Make dropdown selection.
     * @param {String} selectedAttrName The name of the selected dropdown attribute.
     * @param {String} selectedAttrValue The value of the selected dropdown attribute.
     * @param {String} entitledItemId The ID of the SKU.
     **/
    makeDropdownSelection: function (selectedAttrName, selectedAttrValue, entitledItemId) {
        //Add indexOf function to arrays for IE8
        if (!Array.prototype.indexOf) {
            Array.prototype.indexOf = function (obj, start) {
                for (var i = (start || 0), j = this.length; i < j; i++) {
                    if (this[i] === obj) {
                        return i;
                    }
                }
                return -1;
            };
        }

        var dropdownsToUpdate = [];
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        var selectedAttrValues = selectedAttributes[selectedAttrName];
        var dropdownList = productDisplayJS.allDropdownsList[entitledItemId];

        // finds out which dropdowns needs to be updated, add to dropdownsToUpdate array
        for (var i = 0; i < dropdownList.length; i++) {
            if (productDisplayJS.removeQuotes(dropdownList[i].name) != productDisplayJS.removeQuotes(selectedAttrName)) {
                dropdownsToUpdate.push(dropdownList[i]);
            }
        }

        //Finds out which attributes are entitled and add them to list of enabled
        var attributesToEnable = {};
        for (var x in productDisplayJS.entitledItems) {
            var Attributes = productDisplayJS.entitledItems[x].Attributes;

            // Turn Attributes into object
            var attrList = {};
            for (var y in Attributes) {
                var index = y.indexOf("_|_");
                var entitledDropdownName = y.substring(0, index);
                var entitledDropdownValue = y.substring(index + 3);

                attrList[entitledDropdownName] = entitledDropdownValue;
            }

            for (var attrName in attrList) {
                //the current entitled item has the selected attribute value
                if (productDisplayJS.removeQuotes(attrName) == productDisplayJS.removeQuotes(selectedAttrName) && (attrList[attrName] == selectedAttrValue || selectedAttrValue === '')) {
                    //go through the other attributes that are available to the selected attribute
                    for (var attrName2 in attrList) {
                        var attrName2NQ = productDisplayJS.removeQuotes(attrName2);
                        //only check the non-selected attribute
                        if (productDisplayJS.removeQuotes(attrName) != attrName2NQ) {
                            // Find all entitled items that match the current list of selected attributes other than attrName2
                            var matchSelectedAttributes = true;
                            for (var selected in selectedAttributes) {
                                if (productDisplayJS.removeQuotes(selected) != attrName2NQ) {
                                    if (selectedAttributes[selected] && selectedAttributes[selected] !== attrList[selected]) {
                                        matchSelectedAttributes = false;
                                    }
                                }
                            }

                            // Find all enabled values for the unselected attributes
                            if (matchSelectedAttributes && attrList[attrName2]) {
                                if (!attributesToEnable[attrName2NQ]) {
                                    attributesToEnable[attrName2NQ] = [];
                                }
                                if (attributesToEnable[attrName2NQ].indexOf(attrList[attrName2].replace(/^\s+|\s+$/g, '')) == -1) {
                                    attributesToEnable[attrName2NQ].push(attrList[attrName2].replace(/^\s+|\s+$/g, ''));
                                }
                            }
                        }
                    }
                }
            }
        }

        //Flag all attributes that should be enabled as enabled
        for (var i in dropdownsToUpdate) {
            var attrValues = attributesToEnable[productDisplayJS.removeQuotes(dropdownsToUpdate[i].name)];
            if (attrValues) {
                for (var j = 0; j < dropdownsToUpdate[i].options.length; j++) {
                    var dropdownToUpdateOption = dropdownsToUpdate[i].options[j];
                    if (attrValues.indexOf(dropdownToUpdateOption.value.replace(/^\s+|\s+$/g, '')) != -1 || dropdownToUpdateOption.value === '') {
                        dropdownToUpdateOption.enabled = true;
                    }
                }
            }
        }

        //Set all dropdown options that are enabled to disabled = false, others to disabled = true
        for (var i in dropdownsToUpdate) {
            if (dropdownsToUpdate[i].options) {
                for (var j = 0; j < dropdownsToUpdate[i].options.length; j++) {
                    var dropdownToUpdateOption = dropdownsToUpdate[i].options[j];

                    if (dropdownToUpdateOption.enabled) {
                        dropdownToUpdateOption.disabled = false;
                    } else {
                        dropdownToUpdateOption.disabled = true;
                    }

                    delete dropdownToUpdateOption.enabled;
                }

                var dropdown = $(dropdownsToUpdate[i].node);
                dropdown.Select("refresh");
            }
        }
    },

    /**
     * Constructs record and add to this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.	
     * @param {String} swatchImg1 The path to the swatch image.
	* @param {String} swatchImg2 The path to the swatch image representing disabled state.
     **/
	addToAllSwatchsArray: function(swatchName, swatchValue, swatchImg1, entitledItemId, swatchDisplayValue, swatchImg2) {
        var swatchList = this.allSwatchesArrayList[entitledItemId];
        if (swatchList == null) {
            swatchList = [];;
        }
        if (!this.existInAllSwatchsArray(swatchName, swatchValue, swatchList)) {
            var swatchRecord = [];
            swatchRecord[0] = swatchName;
            swatchRecord[1] = swatchValue;
            swatchRecord[2] = swatchImg1;
            swatchRecord[3] = swatchImg2;
            swatchRecord[4] = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchValue).onclick;
            swatchRecord[5] = null;
            swatchRecord[6] = swatchDisplayValue;
            swatchList.push(swatchRecord);
            this.allSwatchesArrayList[entitledItemId] = swatchList;
        }
    },

    /**
     * Constructs record and add to this.allDropdownsArray.
     * @param {String} attributeName The name of the dropdown attribute.
     * @param {String} dropdownId The id of the dropdown.	
     **/
    addToAllDropdownsArray: function (attributeName, dropdownId, entitledItemId) {
        var dropdownList = this.allDropdownsList[entitledItemId];
        if (dropdownList == null) {
            dropdownList = [];
        }

        var dropdownNode = productDisplayJS.findDropdownById(dropdownId);

        if (!this.existInAllDropdownsArray(attributeName, dropdownId, dropdownList)) {
            dropdownList.push({
                name: attributeName,
                id: dropdownId,
                node: dropdownNode,
                options: $(dropdownNode).find("option"),
            });
            this.allDropdownsList[entitledItemId] = dropdownList;
        }
    },

    /**
     * Checks if a swatch is already exist in this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.		
     * @return boolean Value indicating whether or not the specified swatch name and value exists in the allSwatchesArray.
     */
    existInAllSwatchsArray: function (swatchName, swatchValue, swatchList) {
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            if (attrName == swatchName && attrValue == swatchValue) {
                return true;
            }
        }
        return false;
    },

    /**
     * Checks if a dropdown already exists in this.allDropdownsArray.
     * @param {String} dropdownName The name of the dropdown.
     * @param {String} dropdownId The id of the dropdown.		
     * @return boolean Value indicating whether or not the specified dropdown name and value exists in the allDropdownsArray.
     */
    existInAllDropdownsArray: function (dropdownName, dropdownId, dropdownsList) {
        for (var i = 0; i < dropdownsList.length; i++) {
            if (dropdownsList[i].name == dropdownName && dropdownsList[i].id == dropdownId) {
                return true;
            }
        }
        return false;
    },

    /**
     * Check the entitledItems array and pre-select the first entitled SKU as the default swatch selection.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.		
     **/
    makeDefaultSwatchSelection: function (entitledItemId, doNotDisable) {
        if (this.entitledItems.length == 0) {
            if ($("#" + entitledItemId).length) {
                entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
            }
            productDisplayJS.setEntitledItems(entitledItemJSON);
        }

        // need to make selection for every single swatch
        for (x in this.entitledItems) {
            var Attributes = this.entitledItems[x].Attributes;
            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var swatchName = y.substring(0, index);
                var swatchValue = y.substring(index + 3);
                this.makeSwatchSelection(swatchName, swatchValue, entitledItemId, doNotDisable, null, imageField);
            }
            break;
        }
    },

    /**
     * Update swatch images - this is called after selection of a swatch is made, and this function checks for
     * entitlement and disable swatches that are not available
     * @param {String} selectedAttrName The attribute that is selected
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.	
     **/
    updateSwatchImages: function (selectedAttrName, entitledItemId, doNotDisable, imageField) {
        var swatchToUpdate = [];
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        var selectedAttrValue = selectedAttributes[selectedAttrName];
        var swatchList = productDisplayJS.allSwatchesArrayList[entitledItemId];

        // finds out which swatch needs to be updated, add to swatchToUpdate array
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            var attrImg1 = swatchList[i][2];
            var attrImg2 = swatchList[i][3];
            var attrOnclick = swatchList[i][4];
            var attrDisplayValue = swatchList[i][6];

            if (attrName != doNotDisable && attrName != selectedAttrName) {
                var swatchRecord = [];
                swatchRecord[0] = attrName;
                swatchRecord[1] = attrValue;
                swatchRecord[2] = attrImg1;
                swatchRecord[3] = attrImg2;
                swatchRecord[4] = attrOnclick;
                swatchRecord[5] = false;
                swatchRecord[6] = attrDisplayValue;
                swatchToUpdate.push(swatchRecord);
            }
        }

        // finds out which swatch is entitled, if it is, image should be set to enabled
        // go through entitledItems array and find out swatches that are entitled 
        for (x in productDisplayJS.entitledItems) {
            var Attributes = productDisplayJS.entitledItems[x].Attributes;

            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var entitledSwatchName = y.substring(0, index);
                var entitledSwatchValue = y.substring(index + 3);

                //the current entitled item has the selected attribute value
                if (entitledSwatchName == selectedAttrName && entitledSwatchValue == selectedAttrValue) {
                    //go through the other attributes that are available to the selected attribute
                    //exclude the one that is selected
                    for (z in Attributes) {
                        var index2 = z.indexOf("_|_");
                        var entitledSwatchName2 = z.substring(0, index2);
                        var entitledSwatchValue2 = z.substring(index2 + 3);

                        if (y != z) { //only check the attributes that are not the one selected
                            for (i in swatchToUpdate) {
                                var swatchToUpdateName = swatchToUpdate[i][0];
                                var swatchToUpdateValue = swatchToUpdate[i][1];

                                if (entitledSwatchName2 == swatchToUpdateName && entitledSwatchValue2 == swatchToUpdateValue) {
                                    swatchToUpdate[i][5] = true;
                                }
                            }
                        }
                    }
                }
            }
        }

        // Now go through swatchToUpdate array, and update swatch images
        var disabledAttributes = [];
        for (i in swatchToUpdate) {
            var swatchToUpdateName = swatchToUpdate[i][0];
            var swatchToUpdateValue = swatchToUpdate[i][1];
            var swatchToUpdateImg1 = swatchToUpdate[i][2];
            var swatchToUpdateImg2 = swatchToUpdate[i][3];
            var swatchToUpdateOnclick = swatchToUpdate[i][4];
            var swatchToUpdateEnabled = swatchToUpdate[i][5];

            if (swatchToUpdateEnabled) {
                if (document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue).className != "color_swatch_selected") {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch";
                    if (swatchToUpdateImg1 != "" && swatchToUpdateImg2 != "") {
                    	swatchElement.src = swatchToUpdateImg1;
                    }
                    else {
                    	swatchElement.src = swatchElement.src.replace("_disabled.png","_enabled.png");
                    }

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).title = swatchElement.alt;
                }
                $("#swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).attr("aria-disabled", "false");
                document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).onclick = swatchToUpdateOnclick;
            } else {
                if (swatchToUpdateName != doNotDisable) {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    var swatchLinkElement = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch_disabled";
                    swatchLinkElement.onclick = null;
                    if (swatchToUpdateImg1 != "" && swatchToUpdateImg2 != "") {
                    	swatchElement.src = swatchToUpdateImg2;
                    }
                    else {
                    	swatchElement.src = swatchElement.src.replace("_enabled.png","_disabled.png");
                    }

                    //change the title text of the swatch link
                    var titleText = Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [swatchElement.alt]);


                    $("#swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).attr("aria-disabled", "true");

                    //The previously selected attribute is now unavailable for the new selection
                    //Need to switch the selection to an available value
                    if (selectedAttributes[swatchToUpdateName] == swatchToUpdateValue) {
                        disabledAttributes.push(swatchToUpdate[i]);
                    }
                }
            }
        }

        //If there were any previously selected attributes that are now unavailable
        //Find another available value for that attribute and update other attributes according to the new selection
        for (i in disabledAttributes) {
            var disabledAttributeName = disabledAttributes[i][0];
            var disabledAttributeValue = disabledAttributes[i][1];

            for (i in swatchToUpdate) {
                var swatchToUpdateName = swatchToUpdate[i][0];
                var swatchToUpdateValue = swatchToUpdate[i][1];
                var swatchToUpdateDisplayValue = swatchToUpdate[i][6];
                var swatchToUpdateEnabled = swatchToUpdate[i][5];

                if (swatchToUpdateName == disabledAttributeName && swatchToUpdateValue != disabledAttributeValue && swatchToUpdateEnabled) {
                    productDisplayJS.makeSwatchSelection(swatchToUpdateName, swatchToUpdateValue, entitledItemId, doNotDisable, swatchToUpdateDisplayValue, imageField);
                    break;
                }
            }
        }
    },
    /* SwatchCode end */

    /** 
     * Displays price of the attribute selected with the catalog entry id.
     * 
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    displayPrice: function (catEntryId, productId) {
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;

        var tempString;
        var popup = productDisplayJS.isPopup;

        if (popup == true) {
            $("#productPrice").html(catEntry.offerPrice);
        }

        if (popup == false) {
            var innerHTML = "";

            if (!catEntry.listPriced || catEntry.listPrice <= catEntry.offerPrice) {
                innerHTML = "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            } else {
                innerHTML = "<span id='listPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='old_price'>" + catEntry.listPrice + "</span>" +
                    "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            }
            if (document.getElementById('price_display_' + productId)) {
                document.getElementById('price_display_' + productId).innerHTML = innerHTML + "<input type='hidden' id='ProductInfoPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' value='" + catEntry.offerPrice.replace(/"/g, "&#034;").replace(/'/g, "&#039;") + "'/>";
            } else if (document.getElementById('price_display_' + catEntryId)) {
                document.getElementById('price_display_' + catEntryId).innerHTML = innerHTML + "<input type='hidden' id='ProductInfoPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' value='" + catEntry.offerPrice.replace(/"/g, "&#034;").replace(/'/g, "&#039;") + "'/>";
            }

            innerHTML = "";
            if (productDisplayJS.displayPriceRange == true) {
                for (var i in catEntry.priceRange) {
                    if (catEntry.priceRange[i].endingNumberOfUnits == catEntry.priceRange[i].startingNumberOfUnits) {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else if (catEntry.priceRange[i].endingNumberOfUnits != 'null') {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_TO_Y', {
                            0: catEntry.priceRange[i].startingNumberOfUnits,
                            1: catEntry.priceRange[i].endingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_OR_MORE', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    }
                    innerHTML = innerHTML + " <span class='price'>" + catEntry.priceRange[i].localizedPrice + "</span></p>";
                }
            }
            // Append productId so that element is unique in bundle page, where there can be multiple components
            if (document.getElementById('price_display_' + productId) && innerHTML !== '') {
                $("#price_display_" + productId).html($('#price_display_' + productId).html() + '<div class="item_spacer_3px"></div><div id="priceRange_' + productId + '" class="quantity_discount">' + Utils.getLocalizationMessage('PQ_PURCHASE') + innerHTML + '</div>');
            }
        }
    },

    /** 
     * Updates the product name in the NameAndPrice widget. 
     * 
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductName: function (catEntryId, productId) {
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;

        if (productDisplayJS.isPopup == true) {
            $("#productName").html(catEntry.description[0].name);
        } else {
            if ($(".top > div[id^='PageHeading_']") != null) {
                $(".top > div[id^='PageHeading_']").each(function (i, node) {
                    if (node.childNodes != null && node.childNodes.length == 3) {
                        node.childNodes[1].innerHTML = catEntry.description[0].name;
                    }
                });
            }

            var productInfoWidgets = $("input[id^='ProductInfoName_" + productId + "']");
            if (productInfoWidgets != null) {
                for (var i = 0; i < productInfoWidgets.length; i++) {
                    if (productInfoWidgets[i] != null) {
                        $(productInfoWidgets[i]).val(catEntry.description[0].name);
                    }
                }
            }
        }
    },

    /** 
     * Updates the product part number in the NameAndPrice widget. 
     * 
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductPartNumber: function (catEntryId, productId) {
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;

        if (productDisplayJS.isPopup == true) {
            $("#productSKUValue").html(catEntry.catalogEntryIdentifier.externalIdentifier.partNumber);
        } else {
            var partnumWidgets = $("span[id^='product_SKU_" + productId + "']");
            if (partnumWidgets != null) {
                for (var i = 0; i < partnumWidgets.length; i++) {
                    if ($(partnumWidgets[i])) {
                        $(partnumWidgets[i]).html(Utils.getLocalizationMessage('SKU') + " " + catEntry.catalogEntryIdentifier.externalIdentifier.partNumber);
                    }
                }
            }
        }
    },

    /** 
     * Updates the product short description in the ShortDescription widget. 
     * 
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductShortDescription: function (catEntryId, productId) {
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;

        var shortDescWidgets = $("p[id^='product_shortdescription_" + productId + "']");
        if (shortDescWidgets != null) {
            for (var i = 0; i < shortDescWidgets.length; i++) {
                if (shortDescWidgets[i]) {
                    shortDescWidgets[i].innerHTML = catEntry.description[0].shortDescription;
                }
            }
        }
    },

    /** 
     * Updates the product long description in the LongDescription widget. 
     * 
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductLongDescription: function (catEntryId, productId) {
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;

        var longDescWidgets = $("p[id^='product_longdescription_" + productId + "']");
        if (longDescWidgets != null) {
            for (var i = 0; i < longDescWidgets.length; i++) {
                if (longDescWidgets[i]) {
                    longDescWidgets[i].innerHTML = catEntry.description[0].longDescription;
                }
            }
        }
    },

    /** 
     * Updates the product discounts in the Discounts widget. 
     * 
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductDiscount: function (catEntryId, productId) {
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;

        var newHtml = '';
        if (typeof catEntry.discounts != 'undefined') {
            for (var i = 0; i < catEntry.discounts.length; i++) {
                if (i > 0) {
                    newHtml += '<div class="clear_float"></div><div class="item_spacer_2px"></div>';
                }
                /* catEntry.discounts[i].description comes from short description associated with the promotion.
                 * If it is blank or missing, the link text is blank, thus is not clickable or displayed.
                 */
                newHtml += '<a class="promotion" href="' + catEntry.discounts[i].url + '">' + catEntry.discounts[i].description + '</a>';
            }
        }

        var discountWidgets = $("div[id^='Discounts_']");
        if (discountWidgets != null) {
            for (var i = 0; i < discountWidgets.length; i++) {
                if (discountWidgets[i]) {
                    discountWidgets[i].innerHTML = newHtml;
                }
            }
        }
    },

    /** 
     * Updates the product full image and angle images in the FullImage widget. 
     * 
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductImage: function (catEntryId, productId) {
        var newFullImage = null;
        var newAngleThumbnail = null;
        var newAngleFullImage = null;
        var newAngleThumbnailShortDesc = null;

        var skuFullImageFromService = null;
        var catEntry = null;
        if (productDisplayJS.itemPriceJsonOject[catEntryId] != null) {
            catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;
        }
        if (catEntry != null) {
            skuFullImageFromService = catEntry.description[0].fullImage;
        }

        var entitledItemId = "entitledItem_" + productId;
        var imageArr = productDisplayJS.getImageForSKU(entitledItemId);
        if (imageArr != null) {
            newAngleThumbnail = imageArr[2];
            newAngleFullImage = imageArr[3];
            newAngleThumbnailShortDesc = imageArr[4];
        }

        if (catEntryId != null) {
            newFullImage = imageArr[0];
            if (skuFullImageFromService != null && skuFullImageFromService !== "") {
                newFullImage = skuFullImageFromService;
            }
        } else if (productId != null && productDisplayJS.singleSKUProductWithoutDefiningAttribute) {
            newFullImage = productDisplayJS.entitledItems[0].ItemImage467;
            if (skuFullImageFromService != null && skuFullImageFromService !== "") {
                newFullImage = skuFullImageFromService;
            }
            newAngleThumbnail = productDisplayJS.entitledItems[0].ItemAngleThumbnail;
            newAngleFullImage = productDisplayJS.entitledItems[0].ItemAngleFullImage;
            newAngleThumbnailShortDesc = productDisplayJS.entitledItems[0].ItemAngleThumbnailShortDesc;
        } else {
            var imageFound = false;
            var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
            for (x in productDisplayJS.entitledItems) {
                var Attributes = productDisplayJS.entitledItems[x].Attributes;

                for (attribute in selectedAttributes) {
                    var matchingAttributeFound = false;
                    if (selectedAttributes[attribute] !== '') {
                        for (y in Attributes) {
                            var index = y.indexOf("_|_");
                            var entitledSwatchName = y.substring(0, index);
                            var entitledSwatchValue = y.substring(index + 3);

                            if (entitledSwatchName == attribute && entitledSwatchValue == selectedAttributes[attribute]) {
                                matchingAttributeFound = true;
                                break;
                            }
                        }

                        // No matching attributes found, so this is not the correct SKU
                        if (!matchingAttributeFound) {
                            imageFound = false;
                            break;
                        }
                        imageFound = true;
                    }
                }

                // imageFound will only be true if all attributes have been matched (so the first correct SKU)
                if (imageFound) {
                    newFullImage = productDisplayJS.entitledItems[x].ItemImage467;
                    newAngleThumbnail = productDisplayJS.entitledItems[x].ItemAngleThumbnail;
                    newAngleFullImage = productDisplayJS.entitledItems[x].ItemAngleFullImage;
                    newAngleThumbnailShortDesc = productDisplayJS.entitledItems[x].ItemAngleThumbnailShortDesc;
                    break;
                }
            }
        }

        var imgWidgets = $("img[id^='" + productDisplayJS.skuImageId + "']");
        for (var i = 0; i < imgWidgets.length; i++) {
            if (imgWidgets[i] != null && newFullImage != null) {
                imgWidgets[i].src = newFullImage;
            }
        }

        var productImgWidgets = $("input[id^='ProductInfoImage_" + productId + "']");
        for (var i = 0; i < productImgWidgets.length; i++) {
            if (productImgWidgets[i] != null && newFullImage != null) {
                productImgWidgets[i].value = newFullImage;
            }
        }

        var prodAngleImageArea = $("div[id^='ProductAngleProdImagesArea']");
        var skuAngleImageArea = $("div[id^='ProductAngleImagesArea']");

        if (newAngleThumbnail != null && newAngleFullImage != null) {
            if (prodAngleImageArea.length) {
                for (var i = 0; i < prodAngleImageArea.length; i++) {
                    if (null != prodAngleImageArea[i]) {
                        $(prodAngleImageArea[i]).css("display", 'none');
                    }
                }
            }
            productDisplayJS.changeViewImages(newAngleThumbnail, newAngleFullImage, newAngleThumbnailShortDesc);
        } else {
            var prodDisplayClass = 'block';
            var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
            for (attribute in selectedAttributes) {
                if (null != selectedAttributes[attribute] && '' != selectedAttributes[attribute]) {
                    prodDisplayClass = 'none';
                }
            }

            if (prodAngleImageArea.length) {
                for (var i = 0; i < prodAngleImageArea.length; i++) {
                    if (prodAngleImageArea[i].length) {
                        $(prodAngleImageArea[i]).css("display", prodDisplayClass);
                    }
                }
            }

            if (skuAngleImageArea != null) {
                for (var i = 0; i < skuAngleImageArea.length; i++) {
                    if (skuAngleImageArea[i].length) {
                        $(skuAngleImageArea[i]).css("display", 'none');
                    }
                }
            }
        }
    },

    /** 
     * To notify the change in attribute to other components that is subscribed to 'DefiningAttributes_Changed' or 'DefiningAttributes_Resolved' event.
     * 
     * @param {string} productId The identifier of the product.
     * @param {string} entitledItemId The identifier of the entitled item.
     * @param {boolean} isPopup If the value is true, then this implies that the function was called from a quick info pop-up.
     * @param {boolean} displayPriceRange A boolean used to to determine whether or not to display the price range when the catEntry is selected. 	
     */
    notifyAttributeChange: function (productId, entitledItemId, isPopup, displayPriceRange) {
        productDisplayJS.baseCatalogEntryId = productId;
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];

        productDisplayJS.displayPriceRange = displayPriceRange;
        productDisplayJS.isPopup = isPopup;

        var catalogEntryId = null;
        if (productDisplayJS.selectedProducts[productId]) {
            catalogEntryId = productDisplayJS.getCatalogEntryIdforProduct(productDisplayJS.selectedProducts[productId]);
        } else {
            catalogEntryId = productDisplayJS.getCatalogEntryId(entitledItemId);
        }

        if (catalogEntryId != null) {
            wcTopic.publish('DefiningAttributes_Resolved_' + productId, catalogEntryId, productId);

            //check if the json object is already present for the catEntry.
            var catEntry = productDisplayJS.itemPriceJsonOject[catalogEntryId];

            if (catEntry != null && catEntry != undefined) {
                productDisplayJS.publishAttributeResolvedEvent(catalogEntryId, productId);
            }
            //if json object is not present, call the service to get the details.
            else {
                var parameters = {
                    storeId: productDisplayJS.storeId,
                    langId: productDisplayJS.langId,
                    catalogId: productDisplayJS.catalogId,
                    catalogEntryId: catalogEntryId,
                    productId: productId
                };

                //Declare a service for retrieving catalog entry detailed information for an item...
                wcService.declare({
                    id: "getCatalogEntryDetails",
                    actionId: "getCatalogEntryDetails",
                    url: getAbsoluteURL() + appendWcCommonRequestParameters("GetCatalogEntryDetailsByIDView"),
                    formId: ""

                    ,
                    successHandler: function (serviceResponse, ioArgs) {
                        productDisplayJS.publishAttributeResolvedEventServiceResponse(serviceResponse, ioArgs);
                    }

                    ,
                    failureHandler: function (serviceResponse, ioArgs) {
                        console.debug("productDisplayJS.notifyAttributeChange: Unexpected error occurred during an xhrPost request.");
                    }

                });
                wcService.invoke("getCatalogEntryDetails", parameters);
            }
        } else {
            wcTopic.publish('DefiningAttributes_Changed', catalogEntryId, productId);
            wcTopic.publish('DefiningAttributes_Changed_' + productId, catalogEntryId, productId);
            console.debug("Publishing event 'DefiningAttributes_Changed' with params: catEntryId=" + catalogEntryId + ", productId=" + productId);
        }
    },

    /** 
     * Publishes the 'DefiningAttributes_Resolved' event using the JSON object returned from the server.
     * 
     * @param {object} serviceRepsonse The JSON response from the service.
     * @param {object} ioArgs The arguments from the service call.
     */
    publishAttributeResolvedEventServiceResponse: function (serviceResponse, ioArgs) {
        var productId = ioArgs.productId;
        //stores the json object, so that the service is not called when same catEntry is selected.
        productDisplayJS.itemPriceJsonOject[serviceResponse.catalogEntry.catalogEntryIdentifier.uniqueID] = serviceResponse;

        productDisplayJS.publishAttributeResolvedEvent(serviceResponse.catalogEntry.catalogEntryIdentifier.uniqueID, productId);
    },

    /** 
     * Publishes the 'DefiningAttributes_Resolved' event with the necessary parameters. 
     * 
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    publishAttributeResolvedEvent: function (catEntryId, productId) {
        if (!productDisplayJS.isPopup) {
            if (this.entitledItems) {
                for (x in this.entitledItems) {
                    var sku = this.entitledItems[x];
                    if (sku.catentry_id === catEntryId) {
                        if (sku.displaySKUContextData === 'true') {
                            if (document.location.href !== sku.seo_url) {
                                document.location.replace(sku.seo_url);
                            } else {
                                wcTopic.publish('DefiningAttributes_Resolved', catEntryId, productId);
                                console.debug("Publishing event 'DefiningAttributes_Resolved' with params: catEntryId=" + catEntryId + ", productId=" + productId);
                            }
                        } else {
                            wcTopic.publish('DefiningAttributes_Resolved', catEntryId, productId);
                            console.debug("Publishing event 'DefiningAttributes_Resolved' with params: catEntryId=" + catEntryId + ", productId=" + productId);
                        }
                    }
                }
            } else {
                console.debug("Publishing event 'DefiningAttributes_Resolved' with params: catEntryId=" + catEntryId + ", productId=" + productId);
                wcTopic.publish('DefiningAttributes_Resolved', catEntryId, productId);
            }
        }
    },

    /**
     * To notify the change in quantity to other components that is subscribed to ShopperActions_Changed event.
     */
    notifyQuantityChange: function (quantity) {
        wcTopic.publish('ShopperActions_Changed', quantity);
        console.debug("Publishing event 'ShopperActions_Changed' with params: quantity=" + quantity);
    },

    /**
     * To display attachment page.
     */
    showAttachmentPage: function (data) {
        var pageNumber = data['pageNumber'];
        var pageSize = data['pageSize'];
        pageNumber = Number(pageNumber);
        pageSize = Number(pageSize);

        setCurrentId(data["linkId"]);

        if (!submitRequest()) {
            return;
        }

        var beginIndex = pageSize * (pageNumber - 1);
        cursor_wait();
        wcRenderContext.updateRenderContext('AttachmentPagination_Context', {
            'beginIndex': beginIndex
        });
        MessageHelper.hideAndClearMessage();
    },

    /**
     * Register mouse down event 
     */
    registerMouseDown: function (node) {
        $(node).on("mousedown",
            function () {
                productDisplayJS.calculateScrollingHeight(node);
            }
        );
    },

    /**
     * Calculate scrolling height.
     */
    calculateScrollingHeight: function (node) {
        var selectedNode = productDisplayJS.findDropdownById(node);
        var nodePosition = null;
        if (selectedNode) {
            nodePosition = Utils.position(selectedNode);
        } else {
            return;
        }
        var windowHeight = window.innerHeight;
        if (windowHeight - nodePosition.y > nodePosition.y) {
            var newHeight = windowHeight - nodePosition.y;
        } else {
            var newHeight = nodePosition.y;
        }
        if ($("#" + node + "_dropdown").length) {
            if (windowHeight - nodePosition.y > nodePosition.y) {
                var newHeight = windowHeight - nodePosition.y;
            } else {
                var newHeight = nodePosition.y;
            }
            var dropdownHeight = $("#" + node + "_dropdown").clientHeight;
            if (dropdownHeight > newHeight) {
                $("#" + node + "_dropdown").css("height", newHeight + "px");
            }
        } else {
            //			$("#" + node + "_dropdown").css("height", windowHeight + "px");
        }
    },

    findDropdownById: function (node) {
        var newNode = productDisplayJS.removeQuotes(node);
        var nodes = $('[id^=attrValue_]');
        var foundNode = null;

        $(nodes).each(function (key, domNode) {
            var id = productDisplayJS.removeQuotes(domNode.id);
            if (newNode === id) {
                foundNode = domNode;
            }
        });

        return foundNode;
    },

    removeQuotes: function (str) {
        if (str) {
            return str.replace(/&#039;/g, '').replace(/\\'/g, '').replace(/'/g, '');
        } else {
            return str;
        }
    }
}
$(document).ready(function () {
    var ie_version = Utils.get_IE_version();
    if (ie_version < 9) {
        $(document).on("click", ".compare_target > input[type=\"checkbox\"]", function (event) {
            this.blur();
            this.focus();
        });
    }
});
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This javascript is used by the AjaxRecommendation pages to control the refresh areas.
 * @version 1.0
 */

//Declare refresh controller function used by the Ajax recommendation refresh area
var declareAjaxRecommendationRefresh_controller = function(emsName) {
    var myWidgetObj = $("#AjaxRecommendation_Widget_" + emsName);

    wcRenderContext.declare("AjaxRecommendationRefresh_Context_" + emsName, ["AjaxRecommendation_Widget_" + emsName], {});
    var myRCProperties = wcRenderContext.getRenderContextProperties("AjaxRecommendationRefresh_Context_" + emsName);
    
    // initialize widget
    myWidgetObj.refreshWidget({
        renderContextChangedHandler: function() {
            myWidgetObj.refreshWidget("refresh", myRCProperties);
        },

        /**
         * Clears the progress bar after a successful refresh.
         */
        postRefreshHandler: function() {
            cursor_clear();
            wcTopic.publish("CMPageRefreshEvent");
        }
    });
};;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

OnBehalfUtilities = function(){

	this.startCustomerService = function(node){
		var URL = node.getAttribute("data-customer-service-url");
		var buyOnBehalfName = getCookie("WC_BuyOnBehalf_"+WCParamJS.storeId);
		if(CSRWCParamJS.env_shopOnBehalfSessionEstablished === "true" && CSRWCParamJS.env_shopOnBehalfEnabled_CSR === "true"){
			//onbehalf session established by CSR. Show warning dialog before terminating it.
			wcTopic.subscribeOnce("onBehalfSessionTerminate", function(data){
				if (data.action === "YES"){
					document.location.href = URL;
				}
				if(data.action === "NO"){
				}
			});
			MessageHelper.showConfirmationDialog("onBehalfSessionTerminate",
						Utils.getLocalizationMessage('CSR_SESSION_TERMINATE_WARNING_MESSAGE', {0: escapeXml(buyOnBehalfName, true)}));
		} else {
			// Customer session is not yet started. Redirect to landing page.
			document.location.href = URL;
		}
	};

	this.updateUIAndRenderContext = function(response, masterContextName){
		
		//masterContextName - Name of the renderContext which was used to update user Status.
		// userStatus can be updated in FindOrders section or FindRegisteredCustomers section.
		// masterContext will contain the updated data.

		var userId1, userId2, updatedStatusOrder, updatedStatusUser = null;
		var contextExist = wcRenderContext.checkIdDefined("UserRegistrationAdminUpdateStatusContext");
		if (contextExist) {
			userId1 = wcRenderContext.getRenderContextProperties("UserRegistrationAdminUpdateStatusContext")["userId"];
			updatedStatusUser = wcRenderContext.getRenderContextProperties("UserRegistrationAdminUpdateStatusContext")[userId1+"_userStatus"];
		}
		
		contextExist = wcRenderContext.checkIdDefined("UserRegistrationAdminUpdateStatusContextCSR");
		if(contextExist) {
			userId2 = wcRenderContext.getRenderContextProperties("UserRegistrationAdminUpdateStatusContextCSR")["userId"];
			updatedStatusOrder = wcRenderContext.getRenderContextProperties("UserRegistrationAdminUpdateStatusContextCSR")[userId2+"_userStatus"];
		}

		var updatedStatus = null;
		var userId = null;
		if(masterContextName === "UserRegistrationAdminUpdateStatusContext"){
			updatedStatus = updatedStatusUser;
			userId = userId1;
		} else if(masterContextName === "UserRegistrationAdminUpdateStatusContextCSR") {
			updatedStatus = updatedStatusOrder;
			userId = userId2;
		}

		// Save it in context for future use.
		if(typeof(renderContextUser) !== 'undefined'){
			renderContextUser.properties[userId+"_updatedStatus"] = updatedStatus; 
		}
		if(typeof(renderContextOrder) !== 'undefined'){
			renderContextOrder.properties[userId+"_updatedStatus"] = updatedStatus; 
		}

		
		var userStatusText = Utils.getLocalizationMessage('DISABLE_CUSTOMER_ACCOUNT');
		if(updatedStatus === '0'){
			userStatusText = Utils.getLocalizationMessage('ENABLE_CUSTOMER_ACCOUNT');
		}
		// Update widget text...
		var toggleUserStatusControl = $("div[data-toggle-userStatus = 'userStatus_" + userId + "']");
		toggleUserStatusControl.forEach(function(node, index, arr){
			node.innerHTML = userStatusText;
		});
	};


	this.cancelOrder = function(orderId, reloadURL, onBehalf, authToken){
		//TODO - do we need forced cancel. ?
		wcRenderContext.getRenderContextProperties("onBehalfCommonContext")['cancelReloadURL'] = reloadURL;

		var service = wcService.getServiceById('AjaxCancelOrderAdministrator');
		if(onBehalf != null && onBehalf === 'true'){
			service.setUrl(getAbsoluteURL() +  "AjaxRESTCSROrderCancelOnbehalf");
		} else {
			service.setUrl(getAbsoluteURL() +  "AjaxRESTCSROrderCancelAsAdmin");
		}
		
		var params = [];
		params.orderId = orderId;
		params["storeId"] = WCParamJS.storeId;
		params["catalogId"] = WCParamJS.catalogId;
		params["langId"] = WCParamJS.langId;
		params["forcedCancel"] = "true";
		
		wcService.invoke("AjaxCancelOrderAdministrator", params);
	
	};

	this.unLockOrder = function(orderId, forceUnlock){
		if(forceUnlock != null && forceUnlock !== "" && forceUnlock === 'true'){
			// The order is locked by someone.. Need to first take over the lock and then unlock.
			this.takeOverLock(orderId, 'true');
			var removeHandler = wcTopic.subscribe("orderTakeOverSuccess", function(data){
				removeHandler.remove();
				// Now unlock the order.
				onBehalfUtilitiesJS.unLockOrder(orderId, "false");
			});

			return;
		}
		var service = this.getLockUnLockCartService('AjaxRESTOrderLockUnlockOnBehalf', getAbsoluteURL()+'AjaxRESTOrderUnlockOnBehalf', 'SUCCESS_ORDER_UNLOCK');
		var params = [];
		params["orderId"] = orderId;
		params["filterOption"] = "All";
		params["storeId"] = WCParamJS.storeId;
		params["catalogId"] = WCParamJS.catalogId;
		params["langId"] = WCParamJS.langId;	

		/*For Handling multiple clicks. */
		if(!submitRequest()){
			return;
		}			
		cursor_wait();
		wcService.invoke(service.getParam("id"), params);
	};

	this.lockOrder = function(orderId){
		var service = this.getLockUnLockCartService('AjaxRESTOrderLockUnlockOnBehalf', getAbsoluteURL()+'AjaxRESTOrderLockOnBehalf', 'SUCCESS_ORDER_LOCK');
		var params = [];
		params["orderId"] = orderId;
		params["filterOption"] = "All";
		params["storeId"] = WCParamJS.storeId;
		params["catalogId"] = WCParamJS.catalogId;
		params["langId"] = WCParamJS.langId;	

		/*For Handling multiple clicks. */
		if(!submitRequest()){
			return;
		}			
		cursor_wait();
		wcService.invoke(service.getParam("id"), params);
	};


	this.takeOverLock = function(orderId,publishTopic){
		var service = this.getLockUnLockCartService('AjaxRESTOrderLockUnlockOnBehalf', getAbsoluteURL()+'AjaxRESTOrderLockTakeOverOnBehalf',
				'SUCCESS_ORDER_TAKE_OVER', publishTopic);
		var params = [];
		params["orderId"] = orderId;
		params["filterOption"] = "All";
		params["takeOverLock"] = "Y"
		params["storeId"] = WCParamJS.storeId;
		params["catalogId"] = WCParamJS.catalogId;
		params["langId"] = WCParamJS.langId;	

		/*For Handling multiple clicks. */
		if(!submitRequest()){
			return;
		}			
		cursor_wait();
		wcService.invoke(service.getParam("id"), params);
	};

	this.getLockUnLockCartService = function(actionId,url,messageKey,publishTopic){

		var service = wcService.getServiceById('AjaxRESTOrderLockUnlockOnBehalf');

		if(service == null || service === undefined){

			wcService.declare({
				id: "AjaxRESTOrderLockUnlockOnBehalf",
				actionId: "AjaxRESTOrderLockUnlockOnBehalf",
				url: "",
				formId: "",
				successMessageKey:"",
				publishTopic:""
				
				/**
				 * Clear messages on the page.
				 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
				 */
				,successHandler: function(serviceResponse) {
					cursor_clear();
					if(service.getParam("publishTopic") === 'true'){
						wcTopic.publish("orderTakeOverSuccess", serviceResponse);
						return;
					}
					MessageHelper.hideAndClearMessage();
					MessageHelper.displayStatusMessage(Utils.getLocalizationMessage(service.getParam("successMessageKey")));
					setDeleteCartCookie(); // Mini Cart cookie should be refreshed to display updated cart lock status....
					if($('#quick_cart_container').length) {
						$('#quick_cart_container').hide();
					}
				}
				
				/**
				 * Displays an error message on the page if the request failed.
				 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
				 */
				,failureHandler: function(serviceResponse) {
					if (serviceResponse.errorMessage) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
					} else {
						if (serviceResponse.errorMessageKey) {
							MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						}
					}
				}
			});
			service = wcService.getServiceById('AjaxRESTOrderLockUnlockOnBehalf');
		}
		if(actionId != null && actionId !== 'undefined'){
			service.setActionId(actionId);
		}
		if(messageKey != null && messageKey !== 'undefined'){
			service.setParam("successMessageKey", messageKey);
		}
		if(publishTopic != null && publishTopic !== 'undefined'){
			service.setParam("publishTopic", publishTopic);
		} else {
			service.setParam("publishTopic", null);
		}
		if(url != null && url !== 'undefined'){
			service.setUrl(url);
		} else {
			service.setUrl(null);
		}
		return service;
	};
};


$(document).ready(function() {
	onBehalfUtilitiesJS = new OnBehalfUtilities();
});

wcRenderContext.declare("onBehalfCommonContext", [], {});
wcRenderContext.declare("orderLockStatusContext", ["orderLockStatusRefreshArea"], {});

var declareOrderLockStatusRefreshArea = function(){
	// ============================================
	// div: orderLockStatusRefreshArea refresh area
	// Declares a new refresh controller for the fetching order Lock status.
	var myWidgetObj = $("#orderLockStatusRefreshArea");
	myWidgetObj.refreshWidget("updateUrl", getAbsoluteURL() + "OrderLockStatusView?" + getCommonParametersQueryString());
	var myRCProperties = wcRenderContext.getRenderContextProperties("orderLockStatusContext");

	// model change
	wcTopic.subscribe("AjaxRESTOrderLockUnlockOnBehalf", function() {
		console.debug("modelChangedHandler of orderLockStatusController");
		myWidgetObj.refreshWidget("refresh", myRCProperties);
	});

	var postRefreshHandler = function () {
		console.debug("Post refresh handler of orderLockStatus");
		cursor_clear();
	};

	// initialize widget
	myWidgetObj.refreshWidget({postRefreshHandler: postRefreshHandler});
};

wcService.declare({
	id: "AjaxRESTMemberPasswordResetByAdminOnBehalfForBuyer",
	actionId: "AjaxRESTMemberPasswordResetByAdminOnBehalfForBuyer",
	url: getAbsoluteURL() +  "AjaxRESTMemberPasswordResetByAdminOnBehalf",
	formId: ""

	 /**
	  *  This method refreshes the panel 
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
	,successHandler: function(serviceResponse) {
		MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("RESET_PASSWORD_SUCCESS"));
		cursor_clear();
	}
	
	/**
	* display an error message.
	* @param (object) serviceResponse The service response object, which is the
	* JSON object returned by the service invocation.
	*/
	,failureHandler: function(serviceResponse) {
		 var errorMessage = Utils.getLocalizationMessage(serviceResponse.errorMessageKey);
		 if(errorMessage == null){
			if (serviceResponse.errorMessage) {
				errorMessage = serviceResponse.errorMessage;
			} else if (serviceResponse.errorMessageKey) {
				errorMessage = serviceResponse.errorMessageKey;
			}
		 }
		MessageHelper.displayErrorMessage(errorMessage);
	}

});

wcService.declare({
	id: "AjaxRESTMemberPasswordResetByAdminOnBehalf",
	actionId: "AjaxRESTMemberPasswordResetByAdminOnBehalf",
	url: getAbsoluteURL() +  "AjaxRESTMemberPasswordResetByAdminOnBehalf",
	formId: ""

	 /**
	  *  This method refreshes the panel 
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
	,successHandler: function(serviceResponse) {
		MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("RESET_PASSWORD_SUCCESS"));
		if(typeof(registeredCustomersJS) !== 'undefined'){
			registeredCustomersJS.onResetPasswordByAdminSuccess();
		}
		cursor_clear();
	}
	
	/**
	* display an error message.
	* @param (object) serviceResponse The service response object, which is the
	* JSON object returned by the service invocation.
	*/
	,failureHandler: function(serviceResponse) {
		var errorMessage = "";
		if(typeof(registeredCustomersJS) !== 'undefined'){
			 errorMessage = Utils.getLocalizationMessage(serviceResponse.errorMessageKey);
			 if(errorMessage == null){
				if (serviceResponse.errorMessage) {
					errorMessage = serviceResponse.errorMessage;
				} else if (serviceResponse.errorMessageKey) {
					errorMessage = serviceResponse.errorMessageKey;
				}
			 }
			registeredCustomersJS.onResetPasswordByAdminError(errorMessage,serviceResponse);
		}
	}

});

wcService.declare({
	id: "AjaxRESTMemberPasswordResetByAdmin",
	actionId: "AjaxRESTMemberPasswordResetByAdmin",
	url: getAbsoluteURL() +  "AjaxRESTMemberPasswordResetByAdmin",
	formId: ""

	 /**
	  *  This method refreshes the panel 
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
	,successHandler: function(serviceResponse) {
		MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("RESET_PASSWORD_SUCCESS"));
		cursor_clear();
	}
	
	/**
	* display an error message.
	* @param (object) serviceResponse The service response object, which is the
	* JSON object returned by the service invocation.
	*/
	,failureHandler: function(serviceResponse) {
		MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("ERROR_RESET_PASSWORD_ACCESS_ACCOUNT_TO_RESET"));
	}

});

wcService.declare({
	id: "AjaxCancelOrderAdministrator",
	actionId: "AjaxCancelOrderAdministrator",
	url: getAbsoluteURL() +  "AjaxRESTCSROrderCancelAsAdmin"+"?"+getCommonParametersQueryString()+"&forcedCancel=true",
	formId: ""

	 /**
	  *  This method refreshes the panel 
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
	,successHandler: function(serviceResponse) {
		MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("ORDER_CANCEL_SUCCESS"));
        var reloadURL = wcRenderContext.getRenderContextProperties("onBehalfCommonContext")['cancelReloadURL'];
		if(reloadURL !== '' && typeof(reloadURL) !== 'undefined'){
			document.location.href = reloadURL;
		} else {
			window.location.reload(1);
		}
		cursor_clear();
	}
	
	/**
	* display an error message.
	* @param (object) serviceResponse The service response object, which is the
	* JSON object returned by the service invocation.
	*/
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
	}

});
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------


widgetCommonJS = {
    toggleDisplay: function(divId){
        if ($("#"+divId).css("display") === "none") {
            $("#"+divId).css("display", "block");
        } else {
            $("#"+divId).css("display", "none");
        }
    },

    toggleCustomCheckBox: function(cssClassForQuery,cssClassToToggle,node){
        $('.'+cssClassForQuery, node).toggleClass(cssClassToToggle);
        if(node.getAttribute("aria-checked") == 'true'){
            node.setAttribute("aria-checked","false");
        } else {
            node.setAttribute("aria-checked","true");
        }
    },

    toggleCustomCheckBoxKeyPress: function(cssClassForQuery,cssClassToToggle,node,event){
        var charOrCode = event.charCode || event.keyCode;
        console.debug(charOrCode);
        if (charOrCode == KeyCodes.SPACE) { 
            widgetCommonJS.toggleCustomCheckBox(cssClassForQuery,cssClassToToggle,node);
        }
    },

    toggleReadEditSection:function(editSectionId,showSection){
        var overlay = $("#overlay");
        var editSectionMain = $("#"+editSectionId+"Main");

        if(showSection == 'edit'){
            $('#'+editSectionId).css('display', 'block');
            $("#"+editSectionId+'Icon').css('display', 'none');
            $("#"+editSectionId+'Read').css('display','none');

            if (overlay){
                $(overlay).removeClass("nodisplay");
            }
            $(editSectionMain).addClass("editView lightedSection");
        } else if(showSection == 'read'){
            $('#'+editSectionId).css('display', 'none');
            $('#'+editSectionId+'Icon').css('display', 'inline-block');
            $("#"+editSectionId+'Read').css('display','block');

            if (overlay){
                $(overlay).addClass("nodisplay");
            }
            $(editSectionMain).removeClass("lightedSection editView");
        }
    },
    focusDiv: function(divId){
        $("#"+divId).addClass("dottedBorder");
    },

    blurDiv: function(divId){
        $("#"+divId).removeClass("dottedBorder");
    },
    
    toggleEditSection: function(target){
        $(target).toggleClass("readOnly editView");
        
        var editField = $(target).find(".editField");
        var readField = $(target).find(".readField");
        var overlay = $("#overlay");
        if ($(target).hasClass("readOnly")){
            $(editField).attr("aria-hidden", "true");
            $(readField).removeAttr("aria-hidden");
            $(target).removeClass("lightedSection")
            if (overlay){
                overlay.addClass("nodisplay");
            }
        }else {
            $(readField).attr("aria-hidden", "true");
            $(editField).removeAttr("aria-hidden");
            $(target).addClass("lightedSection")
            if (overlay){
                overlay.removeClass("nodisplay");
            }
        }
    },
    
    //can be invoked by postRefreshHandler upon update
    removeSectionOverlay: function(){
        var overlay = $("#overlay");
        if (overlay){
            $(overlay).addClass("nodisplay");
        }
    },
    
    redirect:function(url, queryParams){
        if(queryParams != null && queryParams != 'undefined'){
            if(url.indexOf('?') > -1){
                url = url +"&"+queryParams;
            } else {
                url = url +"?"+queryParams;
            }
        }
        document.location.href = url;
    },
    
    initializeEditSectionToggleEvent: function (){
        //toggle edit and readonly sections, see organization user info widget
    	Utils.onOnce($(".pageSection .pageSectionTitle .editIcon[data-section-toggle]"), "click", "EditSection", function(e){
            var target = this.getAttribute("data-section-toggle");
            widgetCommonJS.toggleEditSection(document.getElementById(target));
            Utils.stopEvent(e);
        });
        //cancle button
    	Utils.onOnce($(".pageSection .editField .button_footer_line a[data-section-toggle]"), "click", "EditSection", function(e){
            var target = this.getAttribute("data-section-toggle");
            widgetCommonJS.toggleEditSection(document.getElementById(target));
            var data = {"target": target};
            wcTopic.publish("sectionToggleCancelPressed", data);
            Utils.stopEvent(e);
        });
    }
};
	
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------


if (typeof (AutoSKUSuggestJS) == "undefined" || AutoSKUSuggestJS == null || !AutoSKUSuggestJS) {

    AutoSKUSuggestJS = {

        /**
         * This variable controls the timer handler before triggering the autoSuggest.  If the user types fast, intermittent requests will be cancelled.
         * The value is initialized to -1.
         */
        autoSuggestSKUTimer: -1,

        /**
         * This variable controls the delay of the timer in milliseconds between the keystrokes before firing the search request.
         * The value is initialized to 400.
         */
        autoSuggestSKUKeystrokeDelay: 400,

        /**
         * This variable indicates whether or not the user is hovering over the autoSuggest results popup display.
         * The value is initialized to false.
         */
        skuAutoSuggestHover: false,

        /**
         * This variable stores the old search term used in the auto suggest search box
         * The value is initialized to empty string.
         */
        skuAutoSuggestPreviousTerm: "",

        /**
         * This variable stores the index of the selected auto suggestion item when using up/down arrow keys.
         * The value is initialized to -1.
         */
        autoSelectOption: -1,

        /**
         * This variable stores the index offset of the first previous history term
         * The value is initialized to -1.
         */
        historyIndex: -1,

        /**
         * This variable controls when to trigger the auto suggest box.  The number of characters greater than this threshold will trigger the auto suggest functionality.
         * The static/cached auto suggest will be performed if this threshold is exceeded.
         * The value is initialized to 0.
         */
        AUTOSUGGEST_THRESHOLD: 0,

        /**
         * This variable controls when to trigger the dynamic auto suggest.  The number of characters greater than this threshold will trigger the request for keyword search.
         * The static/cached auto suggest will be be displayed if the characters exceed the above config parameter, but exceeding this threshold will additionally perform the dynamic search to add to the results in the static/cached results.
         * This value should be greater or equal than the AUTOSUGGEST_THRESHOLD, as the dynamic autosuggest is secondary to the static/cached auto suggest.
         * The value is initialized to 0.
         */
        DYNAMIC_AUTOSUGGEST_THRESHOLD: 0,

        /**
         * URL to retrieve auto suggest keywords
         */
        SearchAutoSuggestServletURL: "",

        /**
         * Timeout variable for suggestions dropdown list
         */
        searchSuggestionHoverTimeout: "",

        /**
         * Suffix for the SKU type ahead id
         */
        suffix: "",

        /**
         * SKU type ahead input field id
         */
        inputField: "",

        /**
         * SKU type ahead add button
         */
        addButton: "",

        /**
         * SKU type ahead add button text
         */
        addButtonText: "",

        /**
         * SKU type ahead add button CSS
         */
        addButtonDisableCss: "",

        /**
         * SKU type ahead add button text CSS
         */
        addButtonTextDisableCss: "",

        init: function (inputField) {
        	if(inputField != "" && $("#" + inputField).length) {
        		$("#" + inputField).on("focus", $.proxy(AutoSKUSuggestJS._onFocus, AutoSKUSuggestJS));
        		$("#" + inputField).on("blur", $.proxy(AutoSKUSuggestJS._onBlur, AutoSKUSuggestJS));
        		$("#" + inputField).on("keyup", $.proxy(AutoSKUSuggestJS._onKeyUp, AutoSKUSuggestJS));
        	}
        },

        setAddButton: function (addButton, addButtonText, addButtonDisableCss, addButtonTextDisableCss) {
            this.addButton = addButton;
            this.addButtonText = addButtonText;
            this.addButtonDisableCss = addButtonDisableCss;
            this.addButtonTextDisableCss = addButtonTextDisableCss;
        },

        showSKUSearchComponent: function () {
            var srcElement = document.getElementById("autoSuggestBySKU_Result_div" + this.suffix);
            if (srcElement != null) {
                srcElement.style.display = 'block';
            }
        },

        setAutoSuggestURL: function (url) {
            this.SearchAutoSuggestServletURL = getAbsoluteURL() + url;
        },

        _onFocus: function (evt) {
            var target = evt.target || evt.srcElement;
            this.inputField = target.id;
            this.suffix = "_" + target.id;
            var inputFieldElement = document.getElementById(this.inputField);
            if (inputFieldElement != null && !this.isEmpty(inputFieldElement.value)) {
                this.showSKUSearchComponent();
            }
        },

        _onBlur: function (evt) {
            var target = evt.target || evt.srcElement;
            this.inputField = target.id;
            this.suffix = "_" + target.id;
            clearTimeout(this.searchSuggestionHoverTimeout);
            this.searchSuggestionHoverTimeout = setTimeout("AutoSKUSuggestJS.showSKUAutoSuggest(false)", 200);
        },

        _onKeyUp: function (evt) {
            var target = evt.target || evt.srcElement;
            this.inputField = target.id;
            this.suffix = "_" + target.id;
            var srcElement = document.getElementById("autoSuggestBySKU_Result_div" + this.suffix);
            srcElement.style.display = 'block';
            this.doSKUAutoSuggest(evt, this.SearchAutoSuggestServletURL, document.getElementById(this.inputField).value);
        },

        doDynamicSKUAutoSuggest: function (url, searchTerm) {
            // if pending autosuggest triggered, cancel it.
            if (this.skuAutoSuggestSKUTimer != -1) {
                clearTimeout(this.skuAutoSuggestSKUTimer);
                this.skuAutoSuggestSKUTimer = -1;
            };

            // call the auto suggest
            this.skuAutoSuggestSKUTimer = setTimeout(function () {
                $("#autoSuggestBySKU_Result_div" + AutoSKUSuggestJS.suffix).refreshWidget("updateUrl", url + "&term=" + encodeURIComponent(searchTerm) + "&suffix=" + encodeURIComponent(AutoSKUSuggestJS.suffix));
                console.debug("update autosuggest " + url);
                wcRenderContext.updateRenderContext("AutoSuggestSKU_Context", {});
                this.skuAutoSuggestSKUTimer = -1;
            }, this.skuAutoSuggestSKUKeystrokeDelay);
        },

        showSKUAutoSuggest: function (display) {
            var autoSuggest_Result_div = document.getElementById("autoSuggestBySKU_Result_div" + this.suffix);
            if (autoSuggest_Result_div != null && autoSuggest_Result_div != 'undefined') {
                if (display) {
                    autoSuggest_Result_div.style.display = "block";
                } else {
                    autoSuggest_Result_div.style.display = "none";
                }
            }
        },

        showSKUAutoSuggestIfResults: function () {
            // if no results, hide the autosuggest box
            var scrElement = document.getElementById("skuAddSearch" + this.suffix);
            if (scrElement == null) {
                if (document.getElementById(this.addButton) != null && document.getElementById(this.addButtonText) != null && !$("#" + this.addButton).hasClass("formButtonDisabled") && !$("#" + this.addButtonText).hasClass("formButtonGreyOut")) {
                    $("#" + this.addButton).addClass("formButtonDisabled");
                    $("#" + this.addButtonText).addClass("formButtonGreyOut");
                }
            } else {
                if (document.getElementById("enableAddButton" + this.suffix) != null && document.getElementById("enableAddButton" + this.suffix).value == "false") {
                    if (document.getElementById(this.addButton) != null && document.getElementById(this.addButtonText) != null && !$("#" + this.addButton).hasClass("formButtonDisabled") && !$("#" + this.addButtonText).hasClass("formButtonGreyOut")) {
                        $("#" + this.addButton).addClass("formButtonDisabled");
                        $("#" + this.addButtonText).addClass("formButtonGreyOut");
                    }
                } else if (document.getElementById(this.addButton) != null && document.getElementById(this.addButtonText) != null && $("#" + this.addButton).hasClass("formButtonDisabled") && $("#" + this.addButtonText).hasClass("formButtonGreyOut")) {
                    $("#" + this.addButton).removeClass("formButtonDisabled");
                    $("#" + this.addButtonText).removeClass("formButtonGreyOut");
                }
            }
            if (scrElement != null && scrElement.style.display == 'block') {
                if (document.getElementById(this.inputField).value.length <= this.AUTOSUGGEST_THRESHOLD) {
                    this.showSKUAutoSuggest(false);
                } else {
                    this.showSKUAutoSuggest(true);
                }
            }
        },

        selectAutoSuggest: function (term) {
            var scrElement = document.getElementById("skuAddSearch" + this.suffix);
            if (scrElement != null && scrElement.style.display == 'block') {
                var searchBox = document.getElementById(this.inputField);
            }
            searchBox.value = term;
            searchBox.focus();
            this.skuAutoSuggestPreviousTerm = term;
            if (document.getElementById(this.addButton) != null && document.getElementById(this.addButtonText) != null && $("#" + this.addButton).hasClass("formButtonDisabled") && $("#" + this.addButtonText).hasClass("formButtonGreyOut")) {
                $("#" + this.addButton).removeClass("formButtonDisabled");
                $("#" + this.addButtonText).removeClass("formButtonGreyOut");
            }
            this.showSKUAutoSuggest(false);
        },

        highLightSelection: function (state, index) {
            var selection = document.getElementById("skuAutoSelectOption_" + index + this.suffix);
            if (selection != null && selection != 'undefined') {
                if (state) {
                    selection.className = "autoSuggestSelected";
                    var scrElement = document.getElementById("skuAddSearch" + this.suffix);
                    if (scrElement != null && scrElement.style.display == 'block') {
                        var searchBox = document.getElementById(this.inputField);
                    }
                    searchBox.setAttribute("aria-activedescendant", "suggestionSKU_" + index);
                    var totalDynamicResults = document.getElementById("dynamicAutoSuggestSKUTotalResults" + this.suffix);
                    if ((totalDynamicResults != null && totalDynamicResults != 'undefined' && index < totalDynamicResults.value) || (index >= this.historyIndex)) {
                        searchBox.value = selection.title;
                        this.skuAutoSuggestPreviousTerm = selection.title;
                    }
                } else {
                    selection.className = "skuSearchItem";
                }
                return true;
            } else {
                return false;
            }
        },

        resetSKUAutoSuggestKeyword: function () {
            var originalKeyedSearchTerm = document.getElementById("autoSuggestSKUOriginalTerm" + this.suffix);
            if (originalKeyedSearchTerm != null && originalKeyedSearchTerm != 'undefined') {
                var scrElement = document.getElementById("skuAddSearch" + this.suffix);
                if (scrElement != null && scrElement.style.display == 'block') {
                    var searchBox = document.getElementById(this.inputField);
                }
                searchBox.value = originalKeyedSearchTerm.value;
                this.skuAutoSuggestPreviousTerm = originalKeyedSearchTerm.value;
            }
        },


        clearSKUAutoSuggestResults: function () {
            this.showSKUAutoSuggest(false);
        },

        doSKUAutoSuggest: function (event, url, searchTerm) {
            if (searchTerm.length <= this.AUTOSUGGEST_THRESHOLD) {
                this.showSKUAutoSuggest(false);
            }

            if (event.keyCode === KeyCodes.TAB) {
                this.showSKUAutoSuggest(false);
                return;
            }

            if (event.keyCode === KeyCodes.ESCAPE) {
                this.showSKUAutoSuggest(false);
                return;
            }

            if (event.keyCode === KeyCodes.RETURN) {
                var searchBox = document.getElementById(this.inputField);
                if (searchBox != null) {
                    AutoSKUSuggestJS.selectAutoSuggest(searchBox.value);
                }
                return;
            }

            if (event.keyCode === KeyCodes.UP_ARROW) {
                if (this.highLightSelection(true, this.autoSelectOption - 1)) {
                    this.highLightSelection(false, this.autoSelectOption);
                    if (this.autoSelectOption == this.historyIndex) {
                        this.resetSKUAutoSuggestKeyword();
                    }
                    this.autoSelectOption--;
                }
                return;
            }

            if (event.keyCode === KeyCodes.DOWN_ARROW) {
                if (this.highLightSelection(true, this.autoSelectOption + 1)) {
                    this.highLightSelection(false, this.autoSelectOption);
                    this.autoSelectOption++;
                }
                return;
            }

            if (searchTerm.length > this.AUTOSUGGEST_THRESHOLD && searchTerm == this.skuAutoSuggestPreviousTerm) {
                return;
            } else {
                this.skuAutoSuggestPreviousTerm = searchTerm;
            }

            if (searchTerm.length <= this.AUTOSUGGEST_THRESHOLD) {
                return;
            };

            // cancel the dynamic search if one is pending
            if (this.skuAutoSuggestSKUTimer != -1) {
                clearTimeout(this.skuAutoSuggestSKUTimer);
                this.skuAutoSuggestSKUTimer = -1;
            }

            if (searchTerm != "") {
                this.autoSelectOption = -1;
                if (searchTerm.length > this.DYNAMIC_AUTOSUGGEST_THRESHOLD) {
                    this.doDynamicSKUAutoSuggest(url, searchTerm);
                } else {
                    // clear the dynamic results
                    document.getElementById("autoSuggestBySKU_Result_div" + this.suffix).innerHTML = "";
                }
            } else {
                this.clearSKUAutoSuggestResults();
            }
        },

        /**
         * Checks if a string is null or empty.
         * @param (string) str The string to check.
         * @return (boolean) Indicates whether the string is empty.
         */
        isEmpty: function (str) {
            var reWhiteSpace = new RegExp(/^\s+$/);
            if (str == null || str == '' || reWhiteSpace.test(str)) {
                return true;
            }
            return false;
        },


        /**
         * Declares a new render context for the AutoSuggest display.
         */


        autoSKUSuggest_controller_initProperties: function (suffix) {
            if (!wcRenderContext.checkIdDefined("AutoSuggestSKU_Context")) {
                wcRenderContext.declare("AutoSuggestSKU_Context", [], "");
            }
            var myWidgetObj = $("#autoSuggestBySKU_Result_div" + suffix);
            wcRenderContext.addRefreshAreaId("AutoSuggestSKU_Context", "autoSuggestBySKU_Result_div" + suffix);
            var myRCProperties = wcRenderContext.getRenderContextProperties("AutoSuggestSKU_Context");
            
            /**
             * Displays the keyword suggestions from the search index
             * This function is called when a render context changed event is detected.
             */
            var renderContextChangedHandler = function () {
                if (myWidgetObj.attr('id') == "autoSuggestBySKU_Result_div" + AutoSKUSuggestJS.suffix) {
                    myWidgetObj.refreshWidget("refresh", myRCProperties);
                }
            },

            /**
             * Display the results.
             */
            postRefreshHandler = function () {
                AutoSKUSuggestJS.showSKUAutoSuggestIfResults();
            }
            
            myWidgetObj.refreshWidget({
                renderContextChangedHandler: renderContextChangedHandler,
                postRefreshHandler: postRefreshHandler
            });
        }
    }
};
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------
/* global document, window, jQuery, KeyCodes, Utils, handleMouseDown, showMenu, hideMenu, 
toggleMenu, toggleExpand, eventActionsInitialization, toggleExpandedContent, toggleMobileView */

(function ($) {
    var activeMenuNode = null;
    var toggleControlNode = null;
    var NAMESPACE = "MyAccountList"; // Namespace to use for all event handlers in this file

    var registerMouseDown = function () {
        Utils.onOnce($(document.documentElement), "mousedown", NAMESPACE, handleMouseDown);
    };

    var unregisterMouseDown = function () {
        $(document.documentElement).off("mousedown." + NAMESPACE);
    };

    showMenu = function (target) {

        //Ensure All menus are closed on list table
        $("div.listTable a[table-parent='listTable']").each(function (i, node) {
            hideMenu(node);
        });

        $("div.listTable div[table-parent='listTable']").each(function (i, node) {
            hideMenu(node);
        });

        $("div.listTable form[table-parent='listTable']").each(function (i, node) {
            hideMenu(node);
        });

        $(target).addClass("active");
	activeMenuNode = target;
        var toggleControl = $("div.listTable a[table-toggle='" + target.id + "']");
        toggleControl.addClass("clicked");
        toggleControlNode = toggleControl[0];
        registerMouseDown();
    };

    hideMenu = function (target) {
        $(target).removeClass("active");
        $("div.listTable a[table-toggle='" + target.id + "']").removeClass("clicked");
        unregisterMouseDown();
        activeMenuNode = null;
        toggleControlNode = null;
    };

    handleMouseDown = function (evt) {
        if (activeMenuNode !== null) {
            var node = evt.target;
            if (node != document.documentElement) {
                var close = true;
                while (node && node != document.documentElement) {
                    if (node == activeMenuNode || node == toggleControlNode || $(node).hasClass("dijitPopup")) {
                        close = false;
                        break;
                    }
                    node = node.parentNode;
                }
                if (node === null) {
                    $("div", activeMenuNode).each(function (i, child) {
                        var position = Utils.position(child);
						if (evt.clientX >= position.left && evt.clientX < position.left + position.width() &&
							evt.clientY >= position.top && evt.clientY < position.top + position.height()) {
                            close = false;
                            return false; // breaks
                        }
                    });
                }
                if (close) {
                    hideMenu(activeMenuNode);
                }
            }
        }
    };

    toggleMenu = function (target) {
        if ($(target).hasClass("active")) {
            hideMenu(target);
        } else {
            showMenu(target);
        }
    };

    toggleExpand = function (target) {
        $("div.listTable div[row-expand]").each(function (i, node) {
            var resetNodeId = $(node).attr("row-expand");
            var resetNodeElement = document.getElementById(resetNodeId);
            if (resetNodeElement != target) {
                Utils.replaceAttr($(resetNodeElement), "src", function (oldSrc) {
                    return oldSrc.replace("sort_arrow_DN.png", "sort_arrow_OFF.png")
                        .replace("sort_arrow_UP.png", "sort_arrow_OFF.png");
                });
                $(resetNodeElement).removeClass("active");
            }
        });
        var $target = $(target);
        if ($target.hasClass("active")) {
            $target.removeClass("active");
            Utils.replaceAttr($target, "src", function (oldSrc) {
                return oldSrc.replace("sort_arrow_OFF.png", "sort_arrow_UP.png")
                    .replace("sort_arrow_DN.png", "sort_arrow_UP.png");
            });
        } else {
            $target.addClass("active");
            Utils.replaceAttr($target, "src", function (oldSrc) {
                return oldSrc.replace("sort_arrow_OFF.png", "sort_arrow_DN.png")
                    .replace("sort_arrow_UP.png", "sort_arrow_DN.png");
            });
        }
    };

    eventActionsInitialization = function () {
        Utils.onOnce($(document), "click", NAMESPACE, "div.listTable div[row-expand]", function (e) {
            var target = $(this).attr("row-expand");
            toggleExpand(document.getElementById(target));
            Utils.stopEvent(e);
        });

        Utils.onOnce($(document), "click", NAMESPACE, "div.listTable a[table-toggle]", function (e) {
            var target = $(this).attr("table-toggle");
            toggleMenu(document.getElementById(target));
            Utils.stopEvent(e);
        });

        Utils.onOnce($(document), "keydown", NAMESPACE, "div.listTable a[table-toggle]", function (e) {
            if (e.keyCode === KeyCodes.TAB || (e.keyCode === KeyCodes.TAB && e.shiftKey)) {
                var target = $(this).attr("table-toggle");
                if (target !== "newListDropdown" && target !== 'uploadListDropdown') {
                    hideMenu(document.getElementById(target));
                }
            } else if (e.keyCode === KeyCodes.RETURN) {
                var target = $(this).attr("table-toggle");
                toggleMenu(document.getElementById(target));
                Utils.stopEvent(e);
            } else if (e.keyCode === KeyCodes.DOWN_ARROW) {
                var target = $(this).attr("table-toggle");
                toggleMenu(document.getElementById(target));
                var targetElem = document.getElementById(target);
                var targetMenuItem = $('[role*="menuitem"]', targetElem)[0];
                if (targetMenuItem !== null) {
                    targetMenuItem.focus();
                }
                Utils.stopEvent(e);
            }
        });
    };

    /**
     * Toggle mobile view or full view depending on size of the table's container (if < 600, show mobile)
     **/
    toggleMobileView = function () {
        var containerWidth;
        $(".listTable").each(function (i, table) {
            if($(table).parent().parent().width() > 0) {
                containerWidth = $(table).parent().parent().width();
            }
        });
        
        if (containerWidth < 600) {
            $(".fullView").css("display", "none");
            $(".listTableMobile").css("display", "block");
        } else {
            $(".fullView").each(function (i, node) {
                var $node = $(node);
                if (!$node.hasClass("nodisplay")) {
                    $node.css("display", "block");
                }
            });

            $(".listTableMobile").css("display", "none");
        }
    };

    /**
     * Toggle expanded content to show or hide (e.g. when button is clicked)
     * @param widgetName the name of the widget
     * @param row The row on which the expanded content is contained
     **/
    toggleExpandedContent = function (widgetName, row) {
        $('#WC_' + widgetName + '_Mobile_ExpandedContent_' + row).toggleClass('nodisplay');
        $('#WC_' + widgetName + '_Mobile_TableContent_ExpandButton_' + row).toggleClass('nodisplay');
        $('#WC_' + widgetName + '_Mobile_TableContent_CollapseButton_' + row).toggleClass('nodisplay');
    };

    eventActionsInitialization();

    window.setTimeout(function () {

        // the code is shared by ItemTable_UI.jspf, the query for cancel button and newListButton
        // could be empty, use forEach to handle this case.
        $("#newListButton").each(function (i, newListButton) {
            $(newListButton).on("keydown", function (e) {
                if (e.keyCode === KeyCodes.RETURN) {
                    var target = $(this).attr("table-toggle");
                    toggleMenu(document.getElementById(target));
                    var targetElem = document.getElementById(target);
                    $('[class*="input_field"]', targetElem).first().focus();
                    Utils.stopEvent(e);
                }
            });
        });

        $("form.toolbarDropdown > .createTableList > .button_secondary").each(function (i, cancelButton) {
            $(cancelButton).on("keydown", function (e) {
                if (e.keyCode === KeyCodes.TAB || (e.keyCode === KeyCodes.TAB && e.shiftKey)) {
                    var targetId = $(this).attr("id");
                    var newTargetId = targetId.replace("_NewListForm_Cancel", "_NewListForm_Name");
                    $("#" + newTargetId).focus();
                    Utils.stopEvent(e);
                } else if (e.keyCode === KeyCodes.RETURN) {
                    var target = $(this).attr("table-toggle");
                    hideMenu(document.getElementById(target));
                    $("#newListButton").focus();
                    Utils.stopEvent(e);
                }
            });
        });

        $(".actionDropdown").each(function (i, actionMenu) {
            var actionMenuItems = $('[role*="menuitem"]', actionMenu);
            actionMenuItems.each(function (j, actionMenuItem) {
                $(actionMenuItem).on("keydown", function (e) {
                    if (e.keyCode === KeyCodes.TAB) {
                        hideMenu(document.getElementById(actionMenu.getAttribute("id")));
                    } else if (e.keyCode === KeyCodes.UP_ARROW) {
                        actionMenuItems[j === 0 ? actionMenuItems.length - 1 : j - 1].focus();
                        Utils.stopEvent(e);
                    } else if (e.keyCode === KeyCodes.DOWN_ARROW) {
                        actionMenuItems[(j + 1) % actionMenuItems.length].focus();
                        Utils.stopEvent(e);
                    }
                });
            });
        });
    }, 100);
})(jQuery);
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2007, 2013 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 *@fileOverview This javascript file defines all the javascript functions used by OrderDetail_ItemTable widget
 */

	OrderDetailJS = {
			
		/** 
		 * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
		 * @private
		 */
		langId: "-1",
		
		/** 
		 * This variable stores the ID of the current store. Its default value is empty.
		 * @private
		 */
		storeId: "",
		
		/** 
		 * This variable stores the ID of the catalog. Its default value is empty.
		 * @private
		 */
		catalogId: "",
		
		/**
		* indicates whether the OrderDetail_ItemTable widget is not loaded, expanded or collapsed
		* possible values: "notLoaded", "expanded" or "collapsed"
		*/
		itemTableShown: "notLoaded",

		/**
		 * Sets the common parameters for the current page. 
		 * For example, the language ID, store ID, and catalog ID.
		 *
		 * @param {Integer} langId The ID of the language that the store currently uses.
		 * @param {Integer} storeId The ID of the current store.
		 * @param {Integer} catalogId The ID of the catalog.
		 * @param {Integer} orderId The ID of the order.
		 */
		setCommonParameters: function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
		},
	
		/**
		* By default the order item detail table isn't shown. This function will refresh the area so the table will
		* show.
		*/
		expandCollapseArea:function(){
			if (this.itemTableShown == "notLoaded") {
				/*For Handling multiple clicks. */
				if(!submitRequest()){
					return;
				}	
				cursor_wait();
				wcRenderContext.updateRenderContext('OrderDetailItemTable_Context', {"beginIndex": 0});
				this.itemTableShown = "expanded";
			} else if (this.itemTableShown == "expanded") {
				$("#orderSummaryContainer_plusImage").css("display", "inline");
				$("#orderSummaryContainer_plusImage_link").attr('tabindex', '0');

				$("#orderSummaryContainer_minusImage").css("display", "none");
				$("#orderSummaryContainer_minusImage_link").attr('tabindex', '-1');
				
				$("#OrderDetail_ItemTable_table").css("display", "none");
				this.itemTableShown = "collapsed";
			} else if (this.itemTableShown == "collapsed") {
				$("#orderSummaryContainer_plusImage").css("display", "none");
				$("#orderSummaryContainer_plusImage_link").attr('tabindex', '-1');
				
				$("#orderSummaryContainer_minusImage").css("display", "inline");
				$("#orderSummaryContainer_minusImage_link").attr('tabindex', '0');
				
				$("#OrderDetail_ItemTable_table").css("display", "block");
				this.itemTableShown = "expanded";
			}
		},
		
		/**
		* This function is called when user selects a different page from the current page
		* @param (Object) data The object that contains data used by pagination control 
		*/
		showResultsPage:function(data){
			var pageNumber = data['pageNumber'];
			var pageSize = data['pageSize'];
			pageNumber = parseInt(pageNumber);
			pageSize = parseInt(pageSize);

			setCurrentId(data["linkId"]);

			if(!submitRequest()){
				return;
			}

			var beginIndex = pageSize * ( pageNumber - 1 );
			cursor_wait();

			wcRenderContext.updateRenderContext('OrderDetailItemTable_Context', {"beginIndex": beginIndex});
			MessageHelper.hideAndClearMessage();
		},
	};//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This javascript is used by the Approval List pages to control the refresh areas.
 * @version 1.2
 */

/**
 * Declares a new refresh controller for order approval.
 */
var declareOrderDetailItemTableController = function() {
    var myWidgetObj = $("#OrderDetailItemTable_Widget");
    
    /**
     * Declares a new render context for order approval list table
     */
    wcRenderContext.declare("OrderDetailItemTable_Context", ["OrderDetailItemTable_Widget"], {
        "beginIndex": "0"
    });
    
    myWidgetObj.refreshWidget({
        /** 
        * Displays the previous/next page of order items in order approval details page
        * This function is called when a render context changed event is detected. 
        * 
        * @param {string} message The render context changed event message
        * @param {object} widget The registered refresh area
        */
        renderContextChangedHandler: function () {
            myWidgetObj.refreshWidget("refresh", wcRenderContext.getRenderContextProperties("OrderDetailItemTable_Context"));
        },

        /** 
         * Clears the progress bar
         * 
         * @param {object} widget The registered refresh area
         */
        postRefreshHandler: function(widget) {
            cursor_clear();
            $("#orderSummaryContainer_minusImage_link").focus();
        }
    });
};;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This javascript defines all the render contexts needed for the Requisition List pages.
 * @version 1.2
 */


/**
 * Declares a new render context for requisition list item table
 */
wcRenderContext.declare("RequisitionListItemTable_Context",["RequisitionListItemTable_Widget"],{"beginIndex":"0","requisitionListId":""},"");;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This javascript is used by the Requisition List pages to control the refresh areas.
 * @version 1.2
 */

if (typeof (RequistionListControllerDeclarationJS) == "undefined" || RequistionListControllerDeclarationJS == null || !RequistionListControllerDeclarationJS) {

    RequistionListControllerDeclarationJS = {
        suffix: "",
        /**
         * Declares a new refresh controller for creating a new Requisition List.
         */
        declareRequisitionListItemTableRefreshArea: function () {
            var myWidgetObj = $("#RequisitionListItemTable_Widget"),


                myRCProperties = wcRenderContext.getRenderContextProperties("RequisitionListItemTable_Context");



            wcTopic.subscribe(["requisitionListAddItem", "requisitionListDeleteItem"], function (returnAction) {
                myRCProperties["requisitionListId"] = returnAction.data.requisitionListId[0];
                myWidgetObj.refreshWidget("refresh", myRCProperties);
            });


            var renderContextChangedHandler = function () {
                myWidgetObj.refreshWidget("refresh", myRCProperties);
            };

            /** 
             * Clears the progress bar
             * 
             * @param {object} widget The registered refresh area
             */
            var postRefreshHandler = function () {
                cursor_clear();
                //After adding/deleting/updating an item
                AutoSKUSuggestJS.autoSKUSuggest_controller_initProperties(RequistionListControllerDeclarationJS.suffix);
            };
            // initialize widget
            myWidgetObj.refreshWidget({
                renderContextChangedHandler: renderContextChangedHandler,
                postRefreshHandler: postRefreshHandler
            });
        }
    }
};
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This javascript is used by the Requisition List pages to handle the services for 
 * adding/removing/updating items from a requisition list.
 * @version 1.10
 */


/**
 * This service allows customer to update an existing requisition list
 * @constructor
 */
wcService.declare({
	id:"requisitionListUpdate",
	actionId:"requisitionListUpdate",
	url:"AjaxRESTRequisitionListUpdate",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		requestSubmitted = false;
		document.location.href="RequisitionListDetailView?storeId="+serviceResponse.storeId+"&langId="+serviceResponse.langId+"&catalogId="+serviceResponse.catalogId+"&requisitionListId="+serviceResponse.requisitionListId+"&createdBy="+serviceResponse.createdBy;				
	}
	
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}	
}),

/**
 * This service allows customer to create add/update an item to an existing requisition list
 * @constructor
 */
wcService.declare({
	id:"requisitionListAddItem",
	actionId:"requisitionListAddItem",
	url:"AjaxRESTRequisitionListItemUpdate",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		
		if(serviceResponse.operation == "addItem"){
			MessageHelper.displayStatusMessage(MessageHelper.messages["REQUISITIONLIST_ADD_SUCCESS"]);
		} else if (serviceResponse.operation == "deleteItem"){
			MessageHelper.displayStatusMessage(MessageHelper.messages["REQUISITIONLIST_ITEM_DELETE_SUCCESS"]);
		} else if (serviceResponse.operation == "updateQty") {
			ReqListItemsJS.showUpdatedMessage(serviceResponse.row);
		}
	}
		
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			var errorMsg = serviceResponse.errorMessage;
			//If the errorMessage param is the generic error message
			//Display the systemMessage instead
			if (errorMsg.search("CMN1009E") !=-1 ) {
				MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_REQUISITION_LIST_INVALID_SKU"]);
			}else if(errorMsg.search("CMN3101E") != -1){
				//If systemMessage is not empty, display systemMessage
				if(serviceResponse.systemMessage){
					if (serviceResponse.errorMessageKey!=null) {
						var msgKey = serviceResponse.errorMessageKey;
						if (msgKey == '_ERR_GETTING_SKU' || msgKey =='_ERR_PROD_NOT_EXISTING') {
							MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_REQUISITION_LIST_INVALID_SKU"]);
						}else {
							MessageHelper.displayErrorMessage(serviceResponse.systemMessage);
						}
					}else{					
						MessageHelper.displayErrorMessage(serviceResponse.systemMessage);
					}
				} else {
					//If systemMessage is empty, then just display the generic error message
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
			} else {
				//If errorMessage is not generic, display errorMessage
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}			
}),

/**
 * This service allows customer to create update an item in an existing requisition list
 * @constructor
 */
wcService.declare({
	id:"requisitionListUpdateItem",
	actionId:"requisitionListUpdateItem",
	url:"AjaxRESTRequisitionListUpdateItem",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		if(serviceResponse.operation == "addItem"){
			MessageHelper.displayStatusMessage(MessageHelper.messages["REQUISITIONLIST_ADD_SUCCESS"]);
		} else if (serviceResponse.operation == "deleteItem"){
			MessageHelper.displayStatusMessage(MessageHelper.messages["REQUISITIONLIST_ITEM_DELETE_SUCCESS"]);
		} else if (serviceResponse.operation == "updateQty") {
			ReqListItemsJS.showUpdatedMessage(serviceResponse.row);
		}
	}
	
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			var errorMsg = serviceResponse.errorMessage;
			//If the errorMessage param is the generic error message
			//Display the systemMessage instead
			if (errorMsg.search("CMN1009E") !=-1 ) {
				MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_REQUISITION_LIST_INVALID_SKU"]);
			}else if(errorMsg.search("CMN3101E") != -1){
				//If systemMessage is not empty, display systemMessage
				if(serviceResponse.systemMessage){
					if (serviceResponse.errorMessageKey!=null) {
						var msgKey = serviceResponse.errorMessageKey;
						if (msgKey == '_ERR_GETTING_SKU' || msgKey =='_ERR_PROD_NOT_EXISTING') {
							MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_REQUISITION_LIST_INVALID_SKU"]);
						}else {
							MessageHelper.displayErrorMessage(serviceResponse.systemMessage);
						}
					}else{					
						MessageHelper.displayErrorMessage(serviceResponse.systemMessage);
					}
				} else {
					//If systemMessage is empty, then just display the generic error message
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
			} else {
				//If errorMessage is not generic, display errorMessage
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	},			
}),

/**
 * This service allows customer to delete an item to an existing requisition list
 * @constructor
 */
wcService.declare({
	id:"requisitionListDeleteItem",
	actionId:"requisitionListDeleteItem",
	url:"AjaxRESTRequisitionListItemDelete",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		if (serviceResponse.operation == "deleteItem"){
			MessageHelper.displayStatusMessage(MessageHelper.messages["REQUISITIONLIST_ITEM_DELETE_SUCCESS"]);
		}
	}
		
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			var errorMsg = serviceResponse.errorMessage;
			//If the errorMessage param is the generic error message
			//Display the systemMessage instead
			if (errorMsg.search("CMN1009E") !=-1 ) {
				MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_REQUISITION_LIST_INVALID_SKU"]);
			}else if(errorMsg.search("CMN3101E") != -1){
				//If systemMessage is not empty, display systemMessage
				if(serviceResponse.systemMessage){
					if (serviceResponse.errorMessageKey!=null) {
						var msgKey = serviceResponse.errorMessageKey;
						if (msgKey == '_ERR_GETTING_SKU' || msgKey =='_ERR_PROD_NOT_EXISTING') {
							MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_REQUISITION_LIST_INVALID_SKU"]);
						}else {
							MessageHelper.displayErrorMessage(serviceResponse.systemMessage);
						}
					}else{					
						MessageHelper.displayErrorMessage(serviceResponse.systemMessage);
					}
				} else {
					//If systemMessage is empty, then just display the generic error message
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
			} else {
				//If errorMessage is not generic, display errorMessage
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}			
}),

/**
 * this services allows users to submit a requisition list for order processing.
 */
wcService.declare({
	id:"requisitionListAjaxPlaceOrder",
	actionId:"AjaxAddOrderItem",
	url:"AjaxRESTRequisitionListSubmit",
	formId:""

	 /**
    * Hides all the messages and the progress bar, and redirect to the shopping cart page 
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation.
    */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		document.location.href="RESTOrderCalculate?calculationUsage=-1,-2,-3,-4,-5,-6,-7&updatePrices=1&doConfigurationValidation=Y&errorViewName=AjaxOrderItemDisplayView&orderId=.&langId="+serviceResponse.langId+"&storeId="+serviceResponse.storeId+"&catalogId="+serviceResponse.catalogId+"&URL=AjaxOrderItemDisplayView";
	}	
	/**
    * display an error message.
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation.
    */
	,failureHandler: function(serviceResponse) {
		 if (serviceResponse.errorMessage) {
		 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
		 		MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
		 	} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
 					MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
			} else {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
		 } else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}			
}), 

/**
* Add an item to a shopping cart in Ajax mode. A message is displayed after the service call.
* The URL "AjaxRESTOrderAddPreConfigurationToCart" is a superset of the URL
* "AjaxRESTOrderItemAdd", allowing dynamic kit partnumbers to be entered into the quick order form.
*/
wcService.declare({
		id: "ReqListAddOrderItem",
		actionId: "AddOrderItem",
		url: "AjaxRESTOrderAddPreConfigurationToCart",
		formId: ""
		
		/**
		* display a success message
		* @param (object) serviceResponse The service response object, which is the
		* JSON object returned by the service invocation
		*/
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
			// MessageHelper.displayStatusMessage(MessageHelper.messages["ADDED_TO_ORDER"]);
		}
		
		/**
		* display an error message
		* @param (object) serviceResponse The service response object, which is the
		* JSON object returned by the service invocation
		*/
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
			 	} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
 					MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
 				} else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			} 
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	});//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------


/** 
 * @fileOverview This javascript is used by the Saved Order pages to control the refresh areas.
 * @version 1.1
 */

/**
 * List of all the services that result in changes to a saved order
 * @static
 */
var savedorder_updated = [
    'AjaxSavedOrderDeleteItem',
    'savedOrderUpdateDescription',
    'AjaxSavedOrderUpdateItem',
    'AjaxAddOrderItem'
];

/**
 * Declares a new render context for saved order details page item table.
 */
wcRenderContext.declare("SavedOrderItemTable_Context", ["SavedOrderItemTable_Widget"], {
    "beginIndex": "0"
});

/**
 * Declares a new refresh controller for the Saved Order Items table display.
 */
var declareSavedOrderItemTableController = function() {
    var myWidgetObj = $("#SavedOrderItemTable_Widget");
    var myRCProperties = wcRenderContext.getRenderContextProperties("SavedOrderItemTable_Context");
    
    // model change
    wcTopic.subscribe(["AjaxSavedOrderDeleteItem", "AjaxSavedOrderUpdateItem", "AjaxAddOrderItem"], function(returnAction){
        myRCProperties["orderId"] = returnAction.data.orderId;
        myWidgetObj.refreshWidget("refresh", myRCProperties);
    });
    
    myWidgetObj.refreshWidget({
        renderContextChangedHandler: function() {
            myWidgetObj.refreshWidget("refresh", myRCProperties);
        },
        postRefreshHandler: function() {
            cursor_clear();
            if (Utils.existsAndNotEmpty(SavedOrderItemsJS.getCurrentRow())) {
                 SavedOrderItemsJS.showUpdatedMessage();
            }
            SavedOrderItemsJS.resetCurrentRow();
        }
    });
};

/**
 * Declares a new render context for saved order details page information area.
 */
wcRenderContext.declare("SavedOrderInfo_Context", ["SavedOrderInfo_Widget"], {});

/**
 * Declares a new refresh controller for the Saved Order Info display.
 */
var declareSavedOrderInfoController = function() {
    var widgetObj = $("#SavedOrderInfo_Widget");
    var myRCProperties = wcRenderContext.getRenderContextProperties("SavedOrderInfo_Context");
    
    /** 
     * Refreshes the saved order info display if name is updated
     * or an update/delete in the saved order items table occurs.
     * This function is called when a modelChanged event is detected. 
     */
    wcTopic.subscribe(savedorder_updated, function(returnAction) {
        // update actionId
        myRCProperties["orderId"] = returnAction.data.orderId;
        widgetObj.refreshWidget("refresh", myRCProperties);
    });
    
    widgetObj.refreshWidget({
        /** 
         * Refreshes the saved order info display if the name of the saved order is changed 
         * or an update/delete in the saved order items table occurs.
         * This function is called when a render context event is detected. 
         */
         renderContextChangedHandler: function () {
            widgetObj.refreshWidget("refresh", myRCProperties);
         },

        /** 
         * Clears the progress bar
         */
        postRefreshHandler: function() {
             cursor_clear();
        }
    });
};;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/** 
 * @fileOverview This javascript is used by the Saved order details pages to handle the services for 
 * updating saved order info and adding/removing/updating items from a saved order.
 * @version 
 */

/**
 * This service allows customer to update an existing saved order info
 * @constructor
 */
wcService.declare({
	id:"savedOrderUpdateDescription",
	actionId:"savedOrderUpdateDescription",
	url: getAbsoluteURL() + "AjaxRESTOrderCopy",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["SAVEDORDERINFO_UPDATE_SUCCESS"]);		
	}
	
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}	
});


/**
 * This service removes an item from a saved order.
 * @constructor
 */
wcService.declare({
	id:"AjaxSavedOrderDeleteItem",
	actionId:"AjaxSavedOrderDeleteItem",
	url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
	formId:""

	 /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["SAVEDORDERITEM_DELETE_SUCCESS"]);		
	}
	
	/**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}	
});

/**
 * Updates an order item in the saved order. 
 * A message is displayed after the service call.  
 * An error message will be displayed otherwise.
 * @constructor
*/
wcService.declare({
	id: "AjaxSavedOrderUpdateItem",
	actionId: "AjaxSavedOrderUpdateItem",
	url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
	formId: ""
	
	/**
     * Hides all messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
	}

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			if (serviceResponse.errorCode == "CMN1654E") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_SAVED_ORDER_QUANTITY_ONE_OR_MORE"]);
			} else {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}
});

/**
* This service adds an item to a saved order. A message is displayed after the service call.
* The URL "AjaxRESTOrderAddPreConfigurationToCart" is a superset of the URL
* "AjaxRESTOrderItemAdd", allowing dynamic kit partnumbers to be added to the saved order.
* @constructor
*/
wcService.declare({
	id: "AjaxAddSavedOrderItem",
	actionId: "AjaxAddOrderItem",
	url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
	formId: ""
	
	/**
     * Hides all messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		MessageHelper.displayStatusMessage(MessageHelper.messages["SAVEDORDERITEM_ADD_SUCCESS"]);
		cursor_clear();
	}

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
				MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_SAVED_ORDER_CONTRACT_EXPIRED"]);
			} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_SAVED_ORDER_RETRIEVE_PRICE"]);
			} else {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
		}  
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}
});

/**
 * Set the current order to be that of a saved order.
 * Perform the service or command call.
 */
wcService.declare({
	id: "AjaxSetPendingOrder",
	actionId: "AjaxSetPendingOrder",
	url: "AjaxRESTSetPendingOrder",
	formId: ""

 /**
 * display a success message
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */

	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["MYACCOUNT_SAVEDORDERLIST_SET_AS_CURRENT_SUCCESS"]);
	}
 /**
 * display an error message
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			 if (["CMN0409E", "CMN1024E"].indexOf(serviceResponse.errorCode) > -1)
			 {
				 MessageHelper.displayErrorMessage(MessageHelper.messages["MYACCOUNT_SAVEDORDERLIST_SET_AS_CURRENT_FAIL"]);
			 }
			 else
			 {
				 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			 }
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}
});

/**
 * Updates the currently selected saved order setting it to the current shopping cart.
 * The main function of this service is to keep the cpendorder database table in line with the current shopping cart.
 * Perform the service or command call.
 * @constructor
 */
wcService.declare({
	id: "AjaxUpdatePendingOrder",
	actionId: "AjaxUpdatePendingOrder",
	url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
	formId: ""

 /**
 * There is nothing to do in the event of a success of this service since it is executed in the background.
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */

	,successHandler: function(serviceResponse) {
		
		if (serviceResponse.nextAction != 'undefined' && serviceResponse.nextAction != null && serviceResponse.nextAction)
		{
			document.location.href = SavedOrderItemsJS.getCurrentShoppingCartURL();
		}
		
		cursor_clear();
	}
 /**
 * display an error message
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
	,failureHandler: function(serviceResponse) {
		
		if (serviceResponse.errorMessage) {
			if (serviceResponse.errorCode == "CMN0409E")
			 {
				 MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_SAVED_ORDER_NOT_SET_CURRENT"]);
			 }
			 else
			 {
				 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			 }
		} 
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}

});
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// Geolocation.js contains the JavaScript functions to call HTML5 Geolocation API
// to return the current device location coordinates
//
////////////////////////////////////////////////////////////////////////////////////////////////////////////

var GeolocationJS = {

    /**
     * Get the current coordinates
     * @param position      geolocation position returned by the device
     */
    showPosition: function(position) {
        if (position !== undefined && position != null) {
            storeLocatorJS.refreshResultsFromNearest(position.coords.latitude,position.coords.longitude);
        }
    },
    
    /**
     * Handle the error returned from geolocation call
     * @param error     the error returned by the device
     */
    locationError: function(error) {
        var errorMsgKey;
        switch (error.code) {
            case error.PERMISSION_DENIED:
                errorMsgKey = "LBS_ERROR_PERMISSION_DENIED";
                break;
            case error.POSITION_UNAVAILABLE:
                errorMsgKey = "LBS_ERROR_NO_USER_CURRENT_LOC";
                break;
            case error.TIMEOUT:
                errorMsgKey = "LBS_ERROR_TIMEOUT";
                break;
            default:
                break;
        }
        storeLocatorJS.refreshResultsWithLocationError(errorMsgKey);
    },
    
    /**
     * Call the HTML5 geolocation API with callback function
     */
    launch: function() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(GeolocationJS.showPosition,GeolocationJS.locationError,{timeout:10000,enableHighAccuracy:true}); 
        }
    }

};;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file contains functions that are used to manage the cookies that are used by the Store Locator
 * feature.
 *
 * @version 1.0
 *
 */
 
/**
 * The functions defined in the class are used for managing the physical store IDs and the store locator user 
 * inputs.  Both information is stored in the cookie.
 *
 * @class This PhysicalStoreCookieJS class defines all the variables and functions to add / update / delete physical
 * store IDs and store locator user inputs.
 *
 */
PhysicalStoreCookieJS = {
	/* the store array is used to store physical store IDs to the cookie */
	storeArray: null,
	
	/* the maximum number of physical store IDs to be saved */
	arrayMaxSize: 5,
	
	/**
	 * This function retrieves the physical store IDs from the cookie.  These physical stores IDs are saved
	 * in the store array.  If no physical store IDs is found in the cookie, an empty store array is created.
	 *
	 * @returns {Array} The store array that contains all physical store IDs saved in the cookie.
	 *
	 */
	getStoreIdsFromCookie:function() {
        var cookieValue = getCookie("WC_physicalStores");
		this.storeArray = new Array;
	
		if (cookieValue != null) {
			var subValue = "";
			var remainingString = cookieValue;
			var length = cookieValue.length;
			var end = remainingString.indexOf(",");
			
			/* more than 1 entry */
			if (end > 0) {
				while (end >=0) {
					subValue = remainingString.substring(0, end);
					this.addToStoreArray(subValue);
					remainingString = remainingString.substring(end+1,length);
					length = remainingString.length;
					end = remainingString.indexOf(",")
				}
				
				subValue = remainingString;
				this.addToStoreArray(subValue);
			}
			/* 0 to 1 entry */
			else {
				/* 1 entry */
				if (length > 0) {
					this.addToStoreArray(remainingString);
				}
			}
		}
		return this.storeArray;
	},
	
	/**
	 * This function checks whether adding one more physical store ID to the cookie will exceed the maximum
	 * number of stores allowed to be saved limit.  The function is default to return false; otherwise, true is
	 * returned. 
	 *
	 * @returns {boolean} The flag to indicate check result.
	 *
	 */
	isAddOneStoreIdExceedMax:function() {
		var exceedMax = false;
		
		if ((this.getNumStores() + 1) > this.arrayMaxSize) {
			exceedMax = true;
		}
		
		return exceedMax;
	},
	
	/**
	 * This function saves all the physical store IDs in the store array to the cookie.  It loops through the store 
	 * array and saves all physical store IDs into the cookie.  It also ensures the cookie do not expire after the 
	 * session closes.  
	 *
	 */
	setStoreIdsToCookie:function() {
		var newCookieValue = "";
		
		for (i=0; i<this.storeArray.length; i++) {
			newCookieValue = newCookieValue + this.storeArray[i];
			if (i < (this.storeArray.length-1)) {
				newCookieValue = newCookieValue + ",";
			}
		}
		
		if (newCookieValue.length == 0) {
			/* delete the cookie then */
			setCookie("WC_physicalStores", null, {path: "/", expires: -1, domain: cookieDomain});
		}
		else {
			/* add or update the cookie */
			setCookie("WC_physicalStores", newCookieValue, {path: "/", domain: cookieDomain});
		}
	},
	
	/**
	 * This function adds the store ID to the store array.  It ensures that the store array does contain the 
	 * information from the cookie and the store ID to be added does not exist in the store array.
	 *
	 * @param {String} record The physical store ID to be added. 
	 *
	 */
	addToStoreArray:function(record) {
		if (this.storeArray == null) {
			this.getStoreIdsFromCookie();
		}
		
		for (i=0; i<this.storeArray.length; i++) {
			if (this.storeArray[i] == record) {
				return;
			}
		}
		
		/* do not add the new record if the array has reached the max size */
		if (this.storeArray.length < this.arrayMaxSize) {
			this.storeArray.push(record);
		}
	},
	
	/**
	 * This function adds the store ID to the cookie by calling the following 2 functions:
	 *       addToStoreArray()
	 *       setStoreIdsToCookie()
	 *
	 * @param {String} record The physical store ID to be added. 
	 *
	 */
	addToCookie:function(record) {
		this.addToStoreArray(record);
		this.setStoreIdsToCookie();
	},
	
	/**
	 * This function removes the store ID from the store array.  It ensures that the store array does contain the
	 * information from the cookie and the store ID to be removed does exist in the store array.
	 *
	 * @param {String} record The physical store ID to be removed. 
	 *
	 */
	removeFromStoreArray:function(record) {
		if (this.storeArray == null) {
			this.getStoreIdsFromCookie();
		}
		
		var recordIndex = -1;
		
		for (i=0; i<this.storeArray.length; i++) {
			if (this.storeArray[i] == record) {
				recordIndex = i;
				i = this.storeArray.length;
			}
		}
				
		this.storeArray.splice(recordIndex, 1);
	},
	
	/**
	 * This function removes the store ID from the cookie by calling the following 2 functions:
	 *       removeFromStoreArray()
	 *       setStoreIdsToCookie()
	 *
	 * @param {String} record The physical store ID to be removed. 
	 *
	 */
	removeFromCookie:function(record) {
		this.removeFromStoreArray(record);
		this.setStoreIdsToCookie();
	},
	
	/**
	 * This function empties the store array.
	 *
	 */
	clearStoreArray:function() {
		this.storeArray = new Array;
	},
	
	/**
	 * This function updates the cookie with the empty store array.
	 *
	 */
	clearCookie:function() {
		this.clearStoreArray();
		this.setStoreIdsToCookie();
	},
	
	/**
	 * This function returns the number of physical stores saved in the cookie.  It ensures the store array contains 
	 * the information retrieved from the cookie before getting the number of stores.
	 *
	 * @returns {int} The number of physical stores saved.
	 *
	 */
	getNumStores:function() {
		if (this.storeArray == null) {	
			this.getStoreIdsFromCookie();
		}
		
		return this.storeArray.length;
	},
	
	/**
	 * This function retrieves the pick up store ID from the cookie.  If no pick up store ID is found in the cookie, 
	 * null is returned.
	 *
	 * @returns {String} The pick up store IDs.
	 *
	 */
	getPickUpStoreIdFromCookie:function() {
        var pickUpStoreId = getCookie("WC_pickUpStore");
		return pickUpStoreId;
	},

	/**
	 * This function adds or updates the pick up store ID to the cookie.
	 *
	 * @param {String} value The new pick up store ID. 
	 *
	 * @returns {element} .
	 *
	 */
	setPickUpStoreIdToCookie:function(value) {
		var newPickUpStoreId = value;
		if (newPickUpStoreId != null && newPickUpStoreId != "undefined" && newPickUpStoreId != "") {
			var currentPickUpStoreId = this.getPickUpStoreIdFromCookie();
			if (newPickUpStoreId != currentPickUpStoreId) {
				setCookie("WC_pickUpStore", null, {path: "/", expires: -1, domain: cookieDomain});
				setCookie("WC_pickUpStore", newPickUpStoreId, {path: "/", domain: cookieDomain});
			}
		}
	},

	/**
	 * This function clears the pick up store ID from the cookie when the parameter matches the current pick up 
	 * store ID in the cookie.
	 *
	 * @param {String} value The pick up store ID for comparison. 
	 *
	 */
	clearPickUpStoreIdFromCookie:function(value) {
		var newPickUpStoreId = value;
		if (newPickUpStoreId != null && newPickUpStoreId != "undefined" && newPickUpStoreId != "") {
			var currentPickUpStoreId = this.getPickUpStoreIdFromCookie();
			if (newPickUpStoreId == currentPickUpStoreId) {
				setCookie("WC_pickUpStore", null, {path: "/", expires: -1, domain: cookieDomain});
			}
		}
	},
	
	/**
	 * This generic function retrieves the value from the cookie based on the cookie key.  It is used to store 
	 * "country: WC_stCntry", "province: WC_stProv", "city: WC_stCity" and "search performed flag: WC_stFind".  If no 
	 * value is found in the cookie for the cookie key, null is returned.
	 *
	 * @param {String} cookieKey The key of the cookie. 
	 *
	 * @returns {String} The value obtained from the cookie.
	 *
	 */
	getValueFromCookie:function(cookieKey) {
        var cookieValue = getCookie(cookieKey);
		return cookieValue;
	},

	/**
	 * This function adds or updates the value to the cookie using the key provided.  It is used to store 
	 * "country: WC_stCntry", "province: WC_stProv", "city: WC_stCity" and "search performed flag: WC_stFind".
	 *
	 * @param {String} cookieKey The key of the cookie. 
	 * @param {String} cookieValue The new value of the cookie. 
	 *
	 */
	setValueToCookie:function(cookieKey, cookieValue) {
		var newValue = cookieValue;
		if (newValue != null && newValue != "undefined" && newValue != "") {
			var currentValue = this.getValueFromCookie(cookieKey);
			if (newValue != currentValue) {
				setCookie(cookieKey, null, {path: "/", expires: -1, domain: cookieDomain});
				setCookie(cookieKey, newValue, {path: "/", domain: cookieDomain});
			}
		}
	},

	/**
	 * This function clears the value referred by a key from the cookie.
	 *
	 * @param {String} cookieKey The key of the cookie. 
	 *
	 */
	clearValueFromCookie:function(cookieKey) {
		var currentValue = this.getValueFromCookie(cookieKey);
		if (currentValue != null && currentValue != "undefined") {
			setCookie(cookieKey, null, {path: "/", expires: -1, domain: cookieDomain});
		}
	}

}
;//<%--
//********************************************************************
//*-------------------------------------------------------------------
//* Licensed Materials - Property of IBM
//*
//* WebSphere Commerce
//*
//* (c) Copyright IBM Corp.  2016
//* All Rights Reserved
//*
//* US Government Users Restricted Rights - Use, duplication or
//* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
//*
//*-------------------------------------------------------------------
//*
//--%>

/**
 * @fileOverview This file contains functions that are used by Store Locator.
 *
 * @version 1.0
 *
 */


/**
 * The functions defined in the class are used for the Store Locator feature.
 *
 * @class This storeLocatorJS class defines all the functions to be used on pages that contain the Store Locator feature.
 *
 */
storeLocatorJS = {

    /**
     * This function initializes the state/province selection drop down list by extracting the selected value
     * of the country selection.  Nothing is done when no selected country is found.
     *
     */
    initProvinceSelections: function () {
        var countrySelectedIndex = $("#selectCountry").prop("selectedIndex");
        if (countrySelectedIndex > -1) {
            var indexToUse = countrySelectedIndex;
            var indexFromSavedId = storeLocatorJS.getSavedCountrySelectionIndex();

            if (indexFromSavedId != null && indexFromSavedId != countrySelectedIndex) {
                indexToUse = indexFromSavedId;
                $("#selectCountry")[0].options[indexToUse].selected = true;
            }
            wcRenderContext.updateRenderContext('provinceSelectionsAreaContext', {
                'countryId': $("#selectCountry")[0].options[indexToUse].value
            });
        }
    },

    /**
     * This function refreshes the city selection drop down list by extracting the selected value of the
     * state/province selection.  Nothing is done when no selected state/province is found.
     *
     */
    refreshCities: function () {
        var stateSelectedIndex = $("#selectState").prop("selectedIndex");
        if (stateSelectedIndex > -1) {
            var indexToUse = stateSelectedIndex;
            var indexFromSavedId = storeLocatorJS.getSavedProvinceSelectionIndex();
            if (indexFromSavedId != null && indexFromSavedId != stateSelectedIndex) {
                indexToUse = indexFromSavedId;
                $("#selectState")[0].options[indexToUse].selected = true;
            }
            wcRenderContext.updateRenderContext('citySelectionsAreaContext', {
                'provinceId': $("#selectState")[0].options[indexToUse].value
            });
        }
    },

    /**
     * This function refreshes the store location search results by extracting the selected value of the city
     * selection.  Nothing is done when no selected city is found.  Store location search results are refreshed
     * automatically once when a search intend (i.e. Find button is pressed) was done before.
     *
     * @param {String} fromPage Parameter value passed by the calling page.
     *
     */
    refreshSearchResults: function (fromPage) {
        var citySelectedIndex = $("#selectCity").selectedIndex;
        if (citySelectedIndex > -1) {
            var indexToUse = citySelectedIndex;
            var indexFromSavedId = storeLocatorJS.getSavedCitySelectionIndex();
            if (indexFromSavedId != null && indexFromSavedId != citySelectedIndex) {
                indexToUse = indexFromSavedId;
                $("#selectCountry")[0].options[indexToUse].value("selectCity").options[indexToUse].selected = true;
            }

            var performFindFlag = PhysicalStoreCookieJS.getValueFromCookie("WC_stFind");
            if (performFindFlag != null) {
                wcRenderContext.updateRenderContext('storeLocatorResultsAreaContext', {
                    'cityId': document.getElementById("selectCountry").options[indexToUse].value("selectCity").options[indexToUse].value,
                    'fromPage': fromPage
                });
            }
        }
    },

    /**
     * This function adds the user selected physical store to the cookie when the maximum number of physical
     * stores has not reached; otherwise, a message is displayed.
     *
     * @param {String} physicalStoreId The physical store Unique ID to be added.
     * @param {String} optionIndex The index of the physical store to be added.
     *
     * @returns {boolean} A flag to indicate whether the add is performed.
     *
     */
    addPhysicalStore: function (physicalStoreId, optionIndex) {
        if (PhysicalStoreCookieJS.isAddOneStoreIdExceedMax() == true) {
            if (document.getElementById("addPhysicalStoreToCookieButton" + optionIndex) != null) {
                MessageHelper.formErrorHandleClient("addPhysicalStoreToCookieButton" + optionIndex, MessageHelper.messages["EXCEED_PHYSICAL_STORE_SIZE"]);
                return false;
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["EXCEED_PHYSICAL_STORE_SIZE"]);
                return false;
            }
        }

        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        PhysicalStoreCookieJS.addToCookie(physicalStoreId);
        storeLocatorJS.showRemoveOption(physicalStoreId);
        return true;
    },

    /**
     * This function removes the user selected physical store from the cookie.
     *
     * @param {String} physicalStoreId The physical store Unique ID to be removed.
     *
     */
    removePhysicalStore: function (physicalStoreId) {
        PhysicalStoreCookieJS.removeFromCookie(physicalStoreId);
        PhysicalStoreCookieJS.clearPickUpStoreIdFromCookie(physicalStoreId);
        storeLocatorJS.showAddOption(physicalStoreId);
    },

    /**
     * This function shows the disabled "add physical store" option and hides the "add physical store" option
     * of the physical store.
     *
     * @param {String} physicalStoreId The physical store Unique ID.
     *
     */
    showRemoveOption: function (physicalStoreId) {
        var addDisabledDiv = $("#addPhysicalStoreToCookieDisabled" + physicalStoreId);
        var addDiv = $("#addPhysicalStoreToCookie" + physicalStoreId);

        if (addDisabledDiv != null && addDisabledDiv != "undefined") {
            $(addDisabledDiv).css("display", "block");
        }

        if (addDiv != null && addDiv != "undefined") {
            $(addDiv).css("display", "none");
        }
    },

    /**
     * This function shows the "add physical store" option and hides the disabled "add physical store" option
     * of the physical store.
     *
     * @param {String} physicalStoreId The physical store Unique ID.
     *
     */
    showAddOption: function (physicalStoreId) {
        var addDisabledDiv = $("#addPhysicalStoreToCookieDisabled" + physicalStoreId);
        var addDiv = $("#addPhysicalStoreToCookie" + physicalStoreId);

        if (addDisabledDiv != null && addDisabledDiv != "undefined") {
            $(addDisabledDiv).css("display", "none");
        }

        if (addDiv != null && addDiv != "undefined") {
            $(addDiv).css("display", "block");
        }
    },

    /**
     * This function manages the cookie values when OK button is pressed from city search.
     *
     */
    manageCookieFromCity: function () {
        PhysicalStoreCookieJS.setValueToCookie('WC_stFind', 1);
    },

    /**
     * This function refreshes the result area when a city is selected.  It refreshes the physical store
     * information.
     *
     * @param form The form that contains the "city" selections.
     * @param {String} fromPage The fromPage parameter value passed by the calling page.
     *
     */
    refreshResultsFromCity: function (form, fromPage) {
        if (form.selectCity.selectedIndex < 0) {
            MessageHelper.formErrorHandleClient(form.selectCity.id, MessageHelper.messages["MISSING_CITY"]);
            return;
        }

        /* manage cookie values */
        storeLocatorJS.manageCookieFromCity();

        /* refresh the result area */
        wcRenderContext.updateRenderContext('storeLocatorResultsAreaContext', {
            'cityId': form.selectCity.options[form.selectCity.selectedIndex].value,
            'fromPage': fromPage,
            'geoCodeLatitude': '',
            'geoCodeLongitude': '',
            'errorMsgKey': ''
        });
    },

    /**
     * This function refreshes the result area when the geolocation feature is used.  It refreshes the
     * physical store information.
     *
     * @param {String} geoCodeLatitude The user's latitude coordinate.
     * @param {String} geoCodeLongitude The user's longitude coordinate.
     *
     */
    refreshResultsFromNearest: function (geoCodeLatitude, geoCodeLongitude) {
        PhysicalStoreCookieJS.clearValueFromCookie("WC_stCntry");
        PhysicalStoreCookieJS.clearValueFromCookie("WC_stProv");
        PhysicalStoreCookieJS.clearValueFromCookie("WC_stCity");
        PhysicalStoreCookieJS.clearValueFromCookie("WC_stFind");

        /* refresh the result area */
        wcRenderContext.updateRenderContext('storeLocatorResultsAreaContext', {
            'geoCodeLatitude': geoCodeLatitude,
            'geoCodeLongitude': geoCodeLongitude,
            'errorMsgKey': ''
        });
    },

    /**
     * This function refreshes the result area when the geolocation feature is used.  It refreshes the
     * physical store information.
     *
     * @param {String} errorMsgKey The resource key for the error message.
     *
     */
    refreshResultsWithLocationError: function (errorMsgKey) {
        PhysicalStoreCookieJS.clearValueFromCookie("WC_stFind");

        /* refresh the result area */
        wcRenderContext.updateRenderContext('storeLocatorResultsAreaContext', {
            'errorMsgKey': errorMsgKey
        });
    },

    /**
     * This function refreshes the store list area.
     *
     * @param {String} fromPage The fromPage parameter value passed by the calling page.
     *
     */
    refreshStoreList: function (fromPage) {
        /* refresh the store list area */
        wcRenderContext.updateRenderContext('selectedStoreListAreaContext', {
            'fromPage': fromPage
        });
    },

    removeFromStoreList: function (fromPage, tableRowId) {
        var numStores = PhysicalStoreCookieJS.getNumStores();
        if (numStores == 0) {
            // Refresh to remove complete table and display status message
            this.refreshStoreList(fromPage);
        } else {
            // Just remove store from the table.
            var tableRow = document.getElementById(tableRowId);
            tableRow.remove();
        }
    },

    /**
     * This function hides the store list area.
     *
     */
    hideStoreList: function () {
        var storeListDiv = $("#selectedStoreListArea");
        var showListHeaderDiv = $("#showStoreListHeader");
        var hideListHeaderDiv = $("#hideStoreListHeader");

        if (storeListDiv != null && storeListDiv != "undefined") {
            $(storeListDiv).css("display", "none");
        }
        if (showListHeaderDiv != null && showListHeaderDiv != "undefined") {
            $(showListHeaderDiv).css("display", "block");
        }
        if (hideListHeaderDiv != null && hideListHeaderDiv != "undefined") {
            $(hideListHeaderDiv).css("display", "none");
        }
    },

    /**
     * This function shows the store list area.
     *
     */
    showStoreList: function () {
        var storeListDiv = $("#selectedStoreListArea");
        var showListHeaderDiv = $("#showStoreListHeader");
        var hideListHeaderDiv = $("#hideStoreListHeader");

        if (storeListDiv != null && storeListDiv != "undefined") {
            $(storeListDiv).css("display", "block");
        }
        if (showListHeaderDiv != null && showListHeaderDiv != "undefined") {
            $(showListHeaderDiv).css("display", "none");
        }
        if (hideListHeaderDiv != null && hideListHeaderDiv != "undefined") {
            $(hideListHeaderDiv).css("display", "block");
        }
    },

    /**
     * This function is called after the counry selection list is changed.
     *
     * @param {String} countryId The unique ID of the selected country.
     *
     */
    changeCountrySelection: function (countryId) {
        PhysicalStoreCookieJS.setValueToCookie("WC_stCntry", countryId);
        PhysicalStoreCookieJS.clearValueFromCookie("WC_stProv");
        PhysicalStoreCookieJS.clearValueFromCookie("WC_stCity");
        PhysicalStoreCookieJS.clearValueFromCookie("WC_stFind");

        wcRenderContext.updateRenderContext("provinceSelectionsAreaContext", {
            "countryId": countryId
        });
    },

    /**
     * This function is called after the province selection list is changed.
     *
     * @param {String} provinceId The unique ID of the selected province.
     *
     */
    changeProvinceSelection: function (provinceId) {
        PhysicalStoreCookieJS.setValueToCookie("WC_stProv", provinceId);
        PhysicalStoreCookieJS.clearValueFromCookie("WC_stCity");
        PhysicalStoreCookieJS.clearValueFromCookie("WC_stFind");

        wcRenderContext.updateRenderContext("citySelectionsAreaContext", {
            "provinceId": provinceId
        });
    },

    /**
     * This function is called after the city selection list is changed.
     *
     * @param {String} cityId The unique ID of the selected city.
     *
     */
    changeCitySelection: function (cityId) {
        PhysicalStoreCookieJS.setValueToCookie("WC_stCity", cityId);
        PhysicalStoreCookieJS.clearValueFromCookie("WC_stFind");
    },

    /**
     * This function retrieves the index of the country selection list which has a value matches the one saved in
     * the cookie.  Null is returned when cookie does not contain any saved country ID.
     *
     * @returns {int} The index of the country selection list which has a value matches the one saved in the
     * cookie.
     *
     */
    getSavedCountrySelectionIndex: function () {
        var index = null;
        var savedCountryId = PhysicalStoreCookieJS.getValueFromCookie("WC_stCntry");
        if (savedCountryId != null) {
            /* search for matching ID */
            var selectedCountryList = $("#selectCountry");
            if (selectedCountryList != null && selectedCountryList != "undefined") {
                var listSize = selectedCountryList.length;
                for (i = 0; i < listSize; i++) {
                    if (savedCountryId == selectedCountryList[0].options[i].value) {
                        index = i;
                        i = listSize;
                    }
                }
            }
        }

        return index;
    },

    /**
     * This function retrieves the index of the province selection list which has a value matches the one saved in
     * the cookie.  Null is returned when cookie does not contain any saved province ID.
     *
     * @returns {int} The index of the province selection list which has a value matches the one saved in the
     * cookie.
     *
     */
    getSavedProvinceSelectionIndex: function () {
        var index = null;
        var savedProvinceId = PhysicalStoreCookieJS.getValueFromCookie("WC_stProv");
        if (savedProvinceId != null) {
            /* search for matching ID */
            var selectedProvinceList = $("#selectState");
            if (selectedProvinceList != null && selectedProvinceList != "undefined") {
                var listSize = selectedProvinceList.length;
                for (i = 0; i < listSize; i++) {
                    if (savedProvinceId == selectedProvinceList[0].options[i].value) {
                        index = i;
                        i = listSize;
                    }
                }
            }
        }

        return index;
    },

    /**
     * This function retrieves the index of the city selection list which has a value matches the one saved in
     * the cookie.  Null is returned when cookie does not contain any saved city ID.
     *
     * @returns {int} The index of the city selection list which has a value matches the one saved in the
     * cookie.
     *
     */
    getSavedCitySelectionIndex: function () {
        var index = null;
        var savedCityId = PhysicalStoreCookieJS.getValueFromCookie("WC_stCity");
        if (savedCityId != null) {
            /* search for matching ID */
            var selectedCityList = $("#selectCity");
            if (selectedCityList != null && selectedCityList != "undefined") {
                var listSize = selectedCityList[0].options.length;
                for (i = 0; i < listSize; i++) {
                    if (savedCityId == selectedCityList[0].options[i].value) {
                        index = i;
                        i = listSize;
                    }
                }
            }
        }

        return index;
    }

}
;//<%--
//********************************************************************
//*-------------------------------------------------------------------
//* Licensed Materials - Property of IBM
//*
//* WebSphere Commerce
//*
//* (c) Copyright IBM Corp.  2016
//* All Rights Reserved
//*
//* US Government Users Restricted Rights - Use, duplication or
//* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
//*
//*-------------------------------------------------------------------
//*
//--%>

/**
 * @fileOverview This file declares the contexts of the store locator.
 *
 * @version 1.0
 *
 */


/**
 * The functions defined in the class are used to initialize the common parameters of the contexts and set the 
 * properties of a specific context.
 *
 * @class This StoreLocatorContextsJS class defines all the variables and functions for manipuating the contexts
 * of the store locator.
 *
 */
StoreLocatorContextsJS = {
    /* common paramater declarations */
    langId: "-1",
    storeId: "",
    catalogId: "",
    orderId: "",
    fromPage: "StoreLocator",

    /**
     * This function initializes the common parameters. 
     *
     * @param {String} langId The language ID. 
     * @param {String} storeId The store ID.
     * @param {String} catalogId The catalog ID.
     * @param {String} orderId The order ID.
     * @param {String} fromPage The constants indicates what the calling page is.
     *
     */
    setCommonParameters: function (langId, storeId, catalogId, orderId, fromPage) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        this.orderId = orderId;
        this.fromPage = fromPage;
    },

    /**
     * This function sets a property of a context. 
     *
     * @param {String} contextId The context identifier. 
     * @param {String} property The property name.
     * @param {String} value The property value.
     *
     */
    setContextProperty: function (contextId, property, value) {
        wcRenderContext.getRenderContextProperties(contextId)[property] = value;
    }

}


/* context declaration for "provinceSelectionsAreaContext" */
wcRenderContext.declare("provinceSelectionsAreaContext", ["provinceSelectionsArea"], ""),

    /* context declaration for "citySelectionsAreaContext" */
    wcRenderContext.declare("citySelectionsAreaContext", ["citySelectionsArea"], ""),

    /* context declaration for "storeLocatorResultsAreaContext" */
    wcRenderContext.declare("storeLocatorResultsAreaContext", ["storeLocatorResultsArea"], ""),

    /* context declaration for "selectedStoreListAreaContext" */
    wcRenderContext.declare("selectedStoreListAreaContext", ["selectedStoreListArea"], "")
;//<%--
//********************************************************************
//*-------------------------------------------------------------------
//* Licensed Materials - Property of IBM
//*
//* WebSphere Commerce
//*
//* (c) Copyright IBM Corp.  2016
//* All Rights Reserved
//*
//* US Government Users Restricted Rights - Use, duplication or
//* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
//*
//*-------------------------------------------------------------------
//*
//--%>

/**
 * @fileOverview This file declares the controllers of the store locator.
 *
 * @version 1.0
 *
 */

/**
 * The functions defined in the class are used to initialize the common parameters of the controllers and set the 
 * URL of a specific controller.
 *
 * @class This StoreLocatorContextsJS class defines all the variables and functions for manipuating the controllers
 * of the store locator.
 *
 */
StoreLocatorControllersDeclarationJS = {
    /* common paramater declarations */
    langId: "-1",
    storeId: "",
    catalogId: "",
    orderId: "",
    fromPage: "StoreLocator",

    /**
     * This function initializes the common parameters. 
     *
     * @param {String} langId The language ID. 
     * @param {String} storeId The store ID.
     * @param {String} catalogId The catalog ID.
     * @param {String} orderId The order ID.
     * @param {String} fromPage The constants indicates what the calling page is.
     *
     */
    setCommonParameters: function (langId, storeId, catalogId, orderId, fromPage) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        this.orderId = orderId;
        this.fromPage = fromPage;
    }


}


/* refresh controller declaration for "provinceSelectionsController" */
var provinceSelectionsRefreshArea = function () {

    var myWidgetObj = $("#provinceSelectionsArea"),
        myRCProperties = wcRenderContext.getRenderContextProperties("provinceSelectionsAreaContext");

    myWidgetObj.refreshWidget({
        formId: "",


        renderContextChangedHandler: function () {

            cursor_wait();
            myWidgetObj.refreshWidget("refresh", myRCProperties);
        },

        postRefreshHandler: function () {

            storeLocatorJS.refreshCities();
            cursor_clear();
        }
    });
}

/* refresh controller declaration for "citySelectionsController" */
var citySelectionsRefreshController = function () {

    var myWidgetObj = $("#citySelectionsArea"),
        myRCProperties = wcRenderContext.getRenderContextProperties("citySelectionsAreaContext");

    myWidgetObj.refreshWidget({
        formId: "",


        renderContextChangedHandler: function () {

            cursor_wait();
            myWidgetObj.refreshWidget("refresh", myRCProperties);
        },


        postRefreshHandler: function (widget) {

            storeLocatorJS.refreshSearchResults(StoreLocatorControllersDeclarationJS.fromPage);
            cursor_clear();
        }

    });
}


/* refresh controller declaration for "storeLocatorResultsController" */
var storeLocatorResultsRefreshController = function () {

    var myWidgetObj = $("#storeLocatorResultsArea"),
        myRCProperties = wcRenderContext.getRenderContextProperties("storeLocatorResultsAreaContext");

    myWidgetObj.refreshWidget({
        formId: "",



        renderContextChangedHandler: function () {
            cursor_wait();
            myWidgetObj.refreshWidget("refresh", myRCProperties);
        },

        postRefreshHandler: function () {

            var bopisTable = $("#bopis_table");
            if (bopisTable != null && bopisTable != "undefined") {
                bopisTable.focus();
            }
            var noStoreMsg = $("#no_store_message");
            if (noStoreMsg != null && noStoreMsg != "undefined") {
                noStoreMsg.focus();
            }

            cursor_clear();
        }

    });
}

/* refresh controller declaration for "selectedStoreListController" */
var selectedStoreListRefreshController = function () {

    var myWidgetObj = $("#selectedStoreListArea"),
        myRCProperties = wcRenderContext.getRenderContextProperties("selectedStoreListAreaContext");

    myWidgetObj.refreshWidget({
        formId: "",


        renderContextChangedHandler: function () {

            cursor_wait();
            myWidgetObj.refreshWidget("refresh", myRCProperties);
        },

        postRefreshHandler: function () {

            var bopisTable = $("#bopis_table");
            if (bopisTable != null && bopisTable != "undefined") {
                bopisTable.focus();
            }

            cursor_clear();
        }

    })
}

/* AJAXBUTTONS BEGIN *******************************************/
/*
Instructions:
    Create <a> or <div> tag with unique id (mandatory)
    Add class "ajaxbutton"

    MessageHelper.displayStatusMessage("Success");
    MessageHelper.displayErrorMessage("Error");

    Both functions restore launch restoreAjaxButtons();

    Note that if a component is loaded dinamically you must call at the end of the loaded jsp:
    <script>
    addAjaxButtonsEventListener();
    </script>
    or adding this:
        $(document).ajaxComplete(function(){
            addAjaxButtonsEventListener();
        });

*/
var isEdgeIE = false;
var ajaxButtonTimeOutRef;

// Add listener to all ajaxbuttons
$(document).ready(function(){
    addAjaxButtonsEventListener();

    if (isEdgeOrIExplorer()){
        isEdgeIE = true;
    }
});

function isEdgeOrIExplorer(){
    // detect IE8 and above, and Edge
    if (document.documentMode || /Edge\//.test(navigator.userAgent)) {
        return true;
    }
    return false;
}

function addAjaxButtonsEventListener(){
    var ajaxButtons = document.querySelectorAll(".ajaxbutton");
    for (var i = 0; i < ajaxButtons.length; i++) {
        ajaxButtons[i].addEventListener("click", showAjaxLoader, true);
    }
}

/**
 *  This function adds a spinner to the element that generates the event, and it should
 *  never be called directly. If you want an element to show the ajax loader, consider
 *  adding the class 'ajaxbutton' to that element
 *
 * @param {*} eventOrId This paramenter can be either the Event object generated by the clicked button
 *                  or a string that indicates the element id where we want to add the spinner
 */
function showAjaxLoader(eventOrId){
    var ERROR_ELEMENT_NOT_FOUND = "showAjaxLoader()::ajaxbutton element not found";
    var button;
    var buttonId;
    var error = false;

    if (typeof eventOrId === "object"){
        //event parameter is an Event object
        var srcElement = eventOrId.srcElement;
        while(!srcElement.classList.contains("ajaxbutton") && srcElement.tagName != "BODY"){
            srcElement = srcElement.parentElement;
        }
        if (srcElement.tagName == "BODY"){
            error = true;
        } else {
            buttonId = srcElement.id;
        }
    } else if (typeof eventOrId === "string"){
        //event parameter is a String, so we take it as elementId
        buttonId = eventOrId;
    }

    button = document.getElementById(buttonId);
    if (button == null){
        error = true;
    }

    if (error){
        console.log(ERROR_ELEMENT_NOT_FOUND);
    } else {
        var ajaxLoaderImgId = "ajaxLoaderImg_"+buttonId;
        var ajaxLoaderImgClass = "ajaxbutton__loader-image";
        var ajaxLoaderBackupId = "ajaxLoaderBackup_"+buttonId;

        if (document.getElementById(ajaxLoaderImgId) == null){
            //Add WCAG parameter
            button.setAttribute("aria-disabled", "true");
            button.setAttribute("ajaxbutton-enabled", "true");

            //Create a copy of the internal content of the button into a hidden div
            var divElement = document.createElement("div");
            divElement.setAttribute("id", ajaxLoaderBackupId);
            divElement.setAttribute("button-id", buttonId);
            //divElement.style.display = 'none';
            if(buttonId && buttonId != 'GotoCartButton2') divElement.style.visibility = "hidden"; //Use visibility hidden in order to keep ocupied space
            divElement.innerHTML = button.innerHTML;

            if (!isEdgeIE || (isPersol && buttonId && buttonId != 'GotoCartButton2')){
                button.innerHTML = "";
            }

            button.appendChild(divElement);

            //Spinner styles/image is set in CSS. Here we add the container
            divElement = document.createElement("div");
            divElement.setAttribute("id", ajaxLoaderImgId);
            divElement.setAttribute("button-id", buttonId);
            divElement.setAttribute("class", ajaxLoaderImgClass);
            button.appendChild(divElement);
        }
    }

    //If for any reason a button is not restored it will be automatically unlocked after 10sec
    ajaxButtonTimeOutRef = setTimeout(function(){restoreAjaxButtons();}, 10000);
}

/**
 * Restore an ajaxbutton to its original state
 *
 * @param {String} elementOrId
 */
function restoreAjaxButton(elementOrId){
    var ERROR_BAD_PARAMETER = "restoreAjaxButton()::Error: Bad parameter (must be an element id string or an element object)";
    var ERROR_ELEMENT_NOT_FOUND = "restoreAjaxButton()::Error: Element id not found";
    var ERROR_NO_ID = "restoreAjaxButton()::Error: Element must have an id";

    var button;
    var buttonId;

    if (elementOrId == null || (typeof elementOrId !== 'object' && typeof elementOrId !== 'string')){
        console.log(ERROR_BAD_PARAMETER);
        return;
    }

    if (typeof elementOrId === 'object') {
        button = elementOrId;
        if (typeof button.id === 'undefined'){
            console.log(ERROR_NO_ID);
            return;
        }
        buttonId = button.id;
    } else if (typeof elementOrId === 'string') {
        button = document.getElementById(elementOrId);
        if (button == null){
            console.log(ERROR_ELEMENT_NOT_FOUND);
            return;
        }
        buttonId = elementOrId;
    }

    var ajaxLoaderImgId = "ajaxLoaderImg_" + buttonId;
    var ajaxLoaderBackupId = "ajaxLoaderBackup_" + buttonId;

    //Stop all event listeners for "click" event in the capturing phase
    //button.removeEventListener("click", onclickEventBlocker, true);

    //Remove WCAG parameter
    button.removeAttribute("aria-disabled");
    button.removeAttribute("ajaxbutton-enabled");

    //Remove ajax loader container
    if (document.getElementById(ajaxLoaderImgId) != null) {
        var divElement = document.getElementById(ajaxLoaderImgId);
        divElement.parentNode.removeChild(divElement);
    }

    //Restore backup div
    if (document.getElementById(ajaxLoaderBackupId) != null) {
        var divElement = document.getElementById(ajaxLoaderBackupId);
        button.innerHTML = divElement.innerHTML;
    }
}

/**
 * Restore all ajaxbuttos to their original state
 */
function restoreAjaxButtons(){
    clearTimeout(ajaxButtonTimeOutRef);

    //Added a little timeout to ensure that the buttons restoration is always called after the showAjaxLoader
    setTimeout(function(){
        var ajaxButtons = document.querySelectorAll(".ajaxbutton");
        for (var i = 0; i < ajaxButtons.length; i++) {
            restoreAjaxButton(ajaxButtons[i]);
        }
    }, 3);
}
/* AJAXBUTTONS END *******************************************/
/********************************************************************
*-------------------------------------------------------------------
* Licensed Materials - Property of IBM
*
* WebSphere Commerce
*
* (c) Copyright IBM Corp. 2000, 2004
*
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*
*-------------------------------------------------------------------*/


function getNumericInfo(currencyCode, languageID) 
{
    curkey = "(" + currencyCode + "," + languageID + ")";
    for (i = 0; i < numericInfo["curGroup"].length; i++) {
        if (numericInfo["curGroup"][i]["curKey"].indexOf(curkey) >= 0)
            return numericInfo["curGroup"][i];
    }
    
    // if not found, return default object
    return numericInfo["default"]["currency"];
}    

function isValidCurrency(currency, currencyCode, languageID)
{
  var maxFrac;

  // scientific format is not allowed, for instance, 1e-09
  var currResult = new String(trim(currency));
  if (currResult.indexOf("e") >= 0)
      return false;

  var numResult = currencyToNumber(currency,currencyCode,languageID);
  
  if(numResult < 0)
      return false;

  currResult = new String(numResult);
  if (currResult == "NaN" || currResult.indexOf("e") >= 0)
      return false;

  ninfo = getNumericInfo(currencyCode, languageID) ;

  maxFrac  = ninfo["maxFrac"];

  if ( numberOfDecimalPlaces(numResult) > maxFrac)
  {
      return false;
  }    
  else
  {
      return true;
  }

  
}// END isValidCurrency

/****************************************************************************
* Format and validate a given currency value. If no locale is provided,
* en_US is used by default.
*
* currency - The currency value to be formatted and validated.
* locale   - The locale used to determine the currency.
*
* Returns the formatted currency if successful; string "NaN" if an invalid
* currency is provided or null if an unsupported locale value was provided.
****************************************************************************/
function formatCurrency(currency, currencyCode, languageID)
{
  var thouSep;
  var decSep;
  var minFrac;
  var maxFrac;
  var groupingSize;
  
  if ( (currency == null) || (currency == "") )	   
	return ("NaN");

  var currencyString = new String(currency);
  if ( currencyString.indexOf("-") != -1 ) 
	return ("NaN");

  ninfo = getNumericInfo(currencyCode, languageID) ;

  thouSep    = ninfo["thouSep"];
  decSep     = ninfo["decSep"];
  minFrac  = ninfo["minFrac"];
  maxFrac  = ninfo["maxFrac"];
  groupingSize = ninfo["groupingSize"];
  
  return(formatNum(currency, thouSep, decSep, minFrac, maxFrac,groupingSize));
  
}// END formatCurrency

/****************************************************************************
* Convert a properly formatted currency value to a primative numeric value.
* If no locale is provided, en_US is used by default.
*
* currency - The currency value to be formatted and validated.
* locale   - The locale used to determine the currency.
*
* Returns a primative numeric value if successfull; string "NaN" if the
* conversion has failed or null if an unsupported locale is provided.
****************************************************************************/
function currencyToNumber(currency,  currencyCode, languageID)
{
  var thouSep;
  var decSep;
  var groupingSize;

  // If no locale is specified, use en_US as default
  ninfo = getNumericInfo(currencyCode, languageID) ;

  thouSep    = ninfo["thouSep"];
  decSep     = ninfo["decSep"];
  groupingSize = ninfo["groupingSize"];
  
  return(toNum(currency, thouSep, decSep,groupingSize));
  
}// END currencyToNumber

/****************************************************************************
* Convert a primative numeric value to a particular currency. If no locale
* is provided, en_US is used by default.
*
* num    - The primative numeric value to be converted to a currency.
* locale - The locale used to determine the currency.
*
* Returns a correctly formatted currency; string "NaN" if the conversion
* failed or null if an unsupported locale was provided.
****************************************************************************/
function numberToCurrency(num, currencyCode, languageID)
{
  var thouSep;
  var decSep;
  var minFrac;
  var maxFrac;
  var groupingSize;
  
  ninfo = getNumericInfo(currencyCode, languageID) ;

  thouSep    = ninfo["thouSep"];
  decSep     = ninfo["decSep"];
  minFrac  = ninfo["minFrac"];
  maxFrac  = ninfo["maxFrac"];
  groupingSize = ninfo["groupingSize"];
  
  var buffer = numericToString(num,minFrac,decSep);
  
  return(formatNum(buffer, thouSep, decSep, minFrac, maxFrac,groupingSize));
  
}// END numberToCurrency

/****************************************************************************
* Convert a primative numeric value to a string value. If no locale
* is provided, en_US is used by default.
*
* num       - The primative numeric value to be converted.
* locale    - The locale used to determine the format.
* decPlaces - The number of decimal places for rounding purposes.
*
* Returns a correctly formatted number of type String; string "NaN" if the
* conversion failed or null if an unsupported locale was provided.
****************************************************************************/
function numberToStr(num, languageID, decPlaces)
{
  var thouSep;
  var decSep;
  var minFrac = decPlaces;
  var maxFrac = decPlaces;
  var groupingSize;

  // If no locale is specified, use en_US as default
  if(languageID != null && defined(numericInfo[languageID]))
  {
      thouSep    = numericInfo[languageID]["number"]["thouSep"];
      decSep     = numericInfo[languageID]["number"]["decSep"];
      groupingSize = numericInfo[languageID]["number"]["groupingSize"];
  }
  else
  {
    thouSep    = numericInfo["default"]["number"]["thouSep"];
    decSep     = numericInfo["default"]["number"]["decSep"];
    groupingSize = numericInfo["default"]["number"]["groupingSize"];
  }
  
  // make sure it is proper form 
  var buffer = numericToString(num,minFrac,decSep);
  
  return(formatNum(buffer, thouSep, decSep, minFrac, maxFrac,groupingSize));
  
}// END numberToStr

/****************************************************************************
* Convert a properly formatted string to a primative numeric value.
*
* num       - The number to be formatted and validated.
* locale    - The locale used to determine proper number formatting.
*
* Returns a primative numeric value or null if an unsupported locale is
* provided.
****************************************************************************/
function strToNumber(num, languageID)
{
  var thouSep;
  var decSep;
  var groupingSize;
  
  // If no locale is specified, use en_US as default
  if(languageID != null && defined(numericInfo[languageID]))
  {
      thouSep = numericInfo[languageID]["number"]["thouSep"];
      decSep  = numericInfo[languageID]["number"]["decSep"];
      groupingSize = numericInfo[languageID]["number"]["groupingSize"];
  }
  else
  {
    thouSep = numericInfo["default"]["number"]["thouSep"];
    decSep  = numericInfo["default"]["number"]["decSep"];
    groupingSize = numericInfo["default"]["number"]["groupingSize"];
  }
  
  return(toNum(num, thouSep, decSep,groupingSize));
  
}// END strToNumber

/****************************************************************************
* validate a given number.
*
* num       - The number to be formatted and validated.
* locale    - The locale used to determine proper number formatting.
* allowNegativeNumber - if negative number is valid (default is FALSE if this parameter omitted)
*
* Return true or false depending on whether num is a valid number for the given language
****************************************************************************/
function isValidNumber(num, languageID, allowNegativeNumber)
{
  var res = strToNumber(num, languageID);

  if (allowNegativeNumber == null || allowNegativeNumber == undefined)
      allowNegativeNumber = false;

  if ( (new String(res)) == "NaN" || (!allowNegativeNumber && res < 0 ) )
  {
      return false;
  }
  else
  {
      return true;
  }
  
}// END isValidNumber


/****************************************************************************
* Format and validate a given number.
*
* num       - The number to be formatted and validated.
* locale    - The locale used to determine proper number formatting.
* decPlaces - The number of decimal places for rounding purposes.
*
* Returns the formatted number of type String if successfull; Nan if an
* invalid currency is provided or null if an unsupported locale value was
* provided.
****************************************************************************/
function formatNumber(num, languageID, decPlaces)
{
  var thouSep;
  var decSep;
  var minFrac = decPlaces;
  var maxFrac = decPlaces;
  var groupingSize;
  
  // If no locale is specified, use en_US as default
  if(languageID != null && defined(numericInfo[languageID]))
  {
      thouSep = numericInfo[languageID]["number"]["thouSep"];
      decSep  = numericInfo[languageID]["number"]["decSep"];
      groupingSize = numericInfo[languageID]["number"]["groupingSize"];
  }
  else
  {
    thouSep = numericInfo["default"]["number"]["thouSep"];
    decSep  = numericInfo["default"]["number"]["decSep"];
    groupingSize = numericInfo["default"]["number"]["groupingSize"];
  }
  
  return(formatNum(num, thouSep, decSep, minFrac, maxFrac,groupingSize));
  
}// END formatNumber

/****************************************************************************
* Format and validate a given integer.
*
* num       - The number to be formatted and validated.
* locale    - The locale used to determine proper number formatting.
*
* Returns the formatted integer of type String if successfull; string "NaN"
* if an invalid integer is provided or null if an unsupported locale value
* was provided.
****************************************************************************/
function formatInteger(num, languageID)
{
  var thouSep;
  var groupingSize;

  // If no locale is specified, use en_US as default
  if(languageID != null && defined(numericInfo[languageID]))
  {
      thouSep = numericInfo[languageID]["number"]["thouSep"];
      groupingSize = numericInfo[languageID]["number"]["groupingSize"];
  }
  else
  {
    thouSep = numericInfo["default"]["number"]["thouSep"];
    groupingSize = numericInfo["default"]["number"]["groupingSize"];
  }

  return(formatInt(num, thouSep,groupingSize));
  
}// END formatInteger

/****************************************************************************
* Format and validate a given number
*
* num       - The number to be formatted and validated.
* thouSep   - The thousand separator to be used in validation and formatting.
* decSep    - The decimal separator to be used in validation and formatting.
* decPlaces - The number of decimal places for rounding purposes.
* groupingSize - Grouping size is the number of digits between grouping
*                separators in the integer portion of a number
*
* Returns the formatted number of type String or string "NaN" if an invalid
* currency value was provided.
****************************************************************************/
function formatNum(num, thouSep, decSep, minFrac, maxFrac,groupingSize)
{

  var segments;
  var leftSide;     // Value to the left of the decimal place
  var rightSide;    // Value to the right of the decimal place
  var decPos;       // Position of the decimal place in the given number
  var result = "";  // Formatted number that is returned to the user
  var buffer = "";  // Buffer used to store temporary info

  // trim the space strip out the "+" and keep the "-" of the num

  var tempNum= new String(trim(num));
  var number = new Object;
  if(tempNum.charAt(0)=="+")
  	 number = tempNum.substring(1);    	
  else if (tempNum.charAt(0)=="-") {
  	 number = tempNum.substring(1);    	
	 result += "-";
  }
  else
  	 number = tempNum;
  
  if( (number == null) || (number == "") )
    return("NaN");

  segments = number.split(decSep);

  // Determine the values on the left and right side of the decimal place
  if( (decPos = number.indexOf(decSep)) == -1)
  {
    leftSide  = segments[0];
    rightSide = null;
  }
  else if(segments.length <= 2)
  {
    if(decPos > 0)
    {
      leftSide  = segments[0];
      rightSide = segments[1];
    }
    else
    {
      leftSide  = null;
      rightSide = segments[1];
    }
  }
  else
    return("NaN");
  
  // Validate the number on the left side of the decimal place
  if(leftSide == null)
    buffer = "0";
  else
  {
    var value;
    
    segments = leftSide.split(thouSep);
    value = segments[0];
    
    if(isNaN(Number(value)))
      return("NaN");
    
    if(segments.length == 1)
      buffer = value;
    else
    {
      if(value.length <= groupingSize)
        buffer = value;
      else
        return("NaN");
        
      for(var j=1; j<segments.length; j++)
      {
        value = segments[j];
        
        if( isNaN(Number(value)) || (value.length != groupingSize) )
          return("NaN");
          
        buffer += value;
      
      }// END for
    }// END else
  }// END else
  
  // Validate the number on the right side of the decimal place
  if(rightSide != null)
  {
    if(isNaN(Number(rightSide)))
      return("NaN");
  
// allow less that the minimum fraction digits and just format properly
//    if (rightSide.length < minFrac)
//      return ("NaN");
        
    buffer += "." + rightSide;
  }
  
  // if maxFrac is null do not round the fraction digits
  if ( maxFrac == null)
	buffer = new String( Number(buffer));
  else
  {
  	// Format validated number...
  	if (buffer == Number(buffer).toString()) {
  		buffer = round(Number(buffer), maxFrac);
  	}
  }

  if(isNaN(buffer))
    return("NaN");

  segments = buffer.split(".");
  leftSide = segments[0];
  
    
  var offset;
  
  buffer = leftSide.length % groupingSize;
  
  if(buffer == 0)
    offset = groupingSize;
  else
    offset = buffer;
  
  result += leftSide.substring(0, offset);
  
  for(var k=offset; k<leftSide.length; k += groupingSize)
  {
    result += thouSep + leftSide.substring(k, k+groupingSize);
  }// END for
  
  if(maxFrac != null)
  {
    	rightSide = segments[1];

  	if(maxFrac > 0 && rightSide != null)
    	result += decSep + rightSide.substring(0, maxFrac);
  }
  else
  {
	if (segments.length == 2)
		result += decSep + rightSide;
  }
  
  return(result);
}// END formatNum

/****************************************************************************
* Format and validate a given integer
*
* num       - The number to be formatted and validated.
* thouSep   - The thousand separator to be used in validation and formatting.
* groupingSize - Grouping size is the number of digits between grouping
*                separators in the integer portion of a number
*
* Returns the formatted number of type String or string "NaN" if an invalid
* integer value was provided.
****************************************************************************/
function formatInt(num, thouSep, groupingSize)
{
  var number = new String(trim(num));
  var segments;
  var leftSide;     // Value to the left of the decimal place
  var result = "";  // Formatted number that is returned to the user
  var buffer = "";  // Buffer used to store temporary info
  
  // Validate the number on the left side of the decimal place
  if( (number == null) || (number == "") )
    return("NaN");
  else
  {
    var value;
    
    segments = number.split(thouSep);
    value = segments[0];

    if(isNaN(Number(value)))
      return("NaN");
    
    if(segments.length == 1)
      buffer = value;
    else
    {
      if(value.length <= groupingSize)
        buffer = value;
      else
        return("NaN");
        
      for(var j=1; j<segments.length; j++)
      {
        value = segments[j];
        
        if( isNaN(Number(value)) || (value.length != groupingSize) )
          return("NaN");
          
        buffer += value;
      
      }// END for
    }// END else
  }// END else
  
  for(var i=0; i<buffer.length; i++)
  {
    var ch = Number(buffer.charAt(i));
    
    if(isNaN(ch))
      return("NaN");
  }

  var offset;
  
  number = buffer;
  
  if((number.length % groupingSize) == 0)
    offset = groupingSize;
  else
    offset = number.length % groupingSize;
  
  result = number.substring(0, offset);
  
  for(var k=offset; k<number.length; k += groupingSize)
  {
    result += thouSep + number.substring(k, k+groupingSize);
  }// END for
  
  return(result);
}// END formatInt

/****************************************************************************
* Convert a number to a primitive numeric value
*
* num          - The number to be formatted and validated.
* thouSep      - The thousand separator to be used in validation and formatting.
* decSep       - The decimal separator to be used in validation and formatting.
* groupingSize - Grouping size is the number of digits between grouping
*                separators in the integer portion of a number
*
* Returns a primitive numeric value; string "NaN" if the conversion failed.
****************************************************************************/
function toNum(num, thouSep, decSep, groupingSize)
{
  var currChar;
  var buffer = "";
  var number = new String(trim(num));
  var thouHit = false;
  var decHit = false;
  var groupCount = 0;

  if( (number == null) || (number == "") )
    return("NaN");

  for(var i=0; i < number.length; i++)
  {
    currChar = number.charAt(i);
    groupCount++;

  if ( (( currChar == ' ')  && ((thouSep.charCodeAt(0) == 160) && thouSep.length == 1)) || (currChar == thouSep)  )  
  {
      if (decHit == true)
      {
          return("NaN");
      }
      if (thouHit == true)
      {
          if (groupCount-1 != groupingSize)
          {
              return("NaN");
          }
      }
      thouHit = true;
      groupCount = 0;
      continue;
    }
    else if(currChar == decSep)
    {   
        decHit = true;

        if (thouHit == true)
        {
          if (groupCount-1 != groupingSize)
          {
              return("NaN");
          }            
        }
        groupCount = 0;
        buffer += ".";
    }
     
    // Even if the decimal point is not '.' the javascript function Number() accepts '.'
    // We need the following check to prevent this
    else if ( currChar == '.')  
	return("NaN");
    else
      buffer += currChar;
  }// END for

  if (decHit == false && thouHit == true && groupCount != groupingSize)
  {
    return("NaN");
  }
  
  return(Number(buffer));
  
}// END toNum

/****************************************************************************
* Round off a primitive numeric to the given decimal places
*
* num - The number to be rounded.
* decPlaces - The number of decimal places for rounding purposes.
*
* Returns the rounder number as a String object; string "NaN" if "num" is not
* a valid number.
****************************************************************************/
function round(num, decPlaces)
{
  var decSep = ".";  // Decimal separator
  var buff;          // Buffer used to determine rounded number
  var i;             // Location of the decimal place
  
  var descrep;
  var segments;
  var leftSide;
  var rightSide;
  
  num = Number(num);

  if(isNaN(num))
    return("NaN");

  buffer = "" + Math.round(num * Math.pow(10, decPlaces)) / Math.pow(10,
                                                                   decPlaces);
  
  // Damn!! Math.round does not work correctly; so, we must double check
  // the formatting...
  i = buffer.indexOf(decSep);
  segments = buffer.split(".");

  if(i == 0)
    buffer = "0" + buffer;
  
  if(segments.length == 2)  
    descrep = decPlaces - segments[1].length;
  else
  {
    descrep = decPlaces;
    
    if(descrep > 0)
      buffer += decSep;
  }
  
  for(var j=0; j<descrep; j++)
    buffer += "0";
      
  return(buffer);
}// END round

/****************************************************************************
* Convert a primitive number into a language specific string by
* adding zeros and converting the decimal separator into the language specific
* separator
*
* This is necessary because when you convert a numeric to a string it removes the zeroes
*
* num - A primitive number
* decPlaces - The number of decimal places for rounding purposes.
* decSep - The decimal separator to replace
*
****************************************************************************/
function numericToString(num, decPlaces,decSep)
{
  var number = new String(num);
  var segments = number.split(".");
  var leftSide;     // Value to the left of the decimal place
  var rightSide;    // Value to the right of the decimal place
  var decPos;       // Position of the decimal place in the given number
  var buffer;

  if( (number == null) || (number == "") || isNaN(Number(num)))
  {
    return("NaN");
  }

  // Replace the decimal separator with the currency-specific decimal
  // separator (there isn't a thousand separator since the number was primitive numeric)
  if( (decPos = number.indexOf(".")) == -1)
  {
    leftSide  = segments[0];
    rightSide = "";
  }
  else if(segments.length <= 2)
  {
    if(decPos > 0)
    {
      leftSide  = segments[0];
      rightSide = segments[1];
    }
    else
    {
      leftSide  = "0";
      rightSide = segments[1];
    }
  }
  else
  {
    return("NaN");
  }


  // And add zeros to end of string as required for number
  while (rightSide.length < decPlaces)
  {
    rightSide += "0";
  }

  buffer = leftSide + decSep + rightSide;

  return buffer;
}

/****************************************************************************
* Return the number of decimal places after the decimal separator
*
* This is necessary because when you convert a numeric to a string it removes the zeroes
*
* num - A primitive number
*
****************************************************************************/
function numberOfDecimalPlaces(num)
{
  var number = new String(num);
  var segments = number.split(".");
  var rightSide;    // Value to the right of the decimal place
  var decPos;       // Position of the decimal place in the given number

  if( (number == null) || (number == "") || isNaN(Number(num)))
  {
    return("NaN");
  }

  // Replace the decimal separator with the currency-specific decimal
  // separator (there isn't a thousand separator since the number was primitive numeric)
  if( (decPos = number.indexOf(".")) == -1)
  {
    return 0;
  }
  else if(segments.length <= 2)
  {
    return segments[1].length;
  }
  else
  {
    return("NaN");
  }

  
}

/****************************************************************************
* Convert a properly formatted string to a primative numeric value.
*
* num       - The number to be formatted and validated.
* locale    - The locale used to determine proper number formatting.
*
* Returns a primative numeric value or null if an unsupported locale is
* provided.
****************************************************************************/
function strToInteger(intnum, languageID)
{
  var thouSep;
  var decSep;
  var groupingSize;
  
  // If no locale is specified, use en_US as default
  if(languageID != null && defined(numericInfo[languageID]))
  {
      thouSep = numericInfo[languageID]["number"]["thouSep"];
      decSep  = numericInfo[languageID]["number"]["decSep"];
      groupingSize = numericInfo[languageID]["number"]["groupingSize"];
  }
  else
  {
    thouSep = numericInfo["default"]["number"]["thouSep"];
    decSep  = numericInfo["default"]["number"]["decSep"];
    groupingSize = numericInfo["default"]["number"]["groupingSize"];
  }
  
  return(toIntegerNum(intnum, thouSep, decSep,groupingSize));
  
}// END strToNumber

/****************************************************************************
* validate a given Integer number.
*
* numint       - The number to be formatted and validated.
* locale    - The locale used to determine proper number formatting.
*
* Return true or false depending on whether num is a valid number for the given language
****************************************************************************/
function isValidInteger(numint, languageID)
{
  var res = strToInteger(numint, languageID);
  if ((new String(res)) == "NaN")
  {
      return false;
  }
  else
  {
      return true;
  }
  
}// END isValidInteger



/****************************************************************************
* validate and Convert an Integer number to a primitive numeric value
*
* intnum       - The integer number to be formatted and validated.
* thouSep      - The thousand separator to be used in validation and formatting.
* decSep       - The decimal separator to be used in validation and formatting.
* groupingSize - Grouping size is the number of digits between grouping
*                separators in the integer portion of a number
*
* Returns a primitive numeric value; string "NaN" if the conversion failed.
****************************************************************************/
function toIntegerNum(intnum, thouSep, decSep, groupingSize)
{
  var currChar;
  var buffer = "";
  var number = new String(trim(intnum));
  var thouHit = false;
  var decHit = false;
  var groupCount = 0;

  if( (number == null) || (number == "") )
    return("NaN");

  for(var i=0; i < number.length; i++)
  {
    currChar = number.charAt(i);
    groupCount++;

    if ( (( currChar == ' ')  && ((thouSep.charCodeAt(0) == 160) && thouSep.length == 1)) || (currChar == thouSep)  )  
    {
      
      if (thouHit == true)
      {
          if (groupCount-1 != groupingSize)
          {
              return("NaN");
          }
      }
      thouHit = true;
      groupCount = 0;
      continue;
    }
    else if(currChar == decSep)
    {           
              return("NaN");
    }
    // Even if the decimal point or thousand separator is not '.' the javascript function Number() accepts '.'
    // We need the following check to prevent this
    else if ( currChar == '.')  
	return("NaN");	
    else
      buffer += currChar;
  }// END for

  if (thouHit == true && groupCount != groupingSize)
  {
    return("NaN");
  }
  
  return(Number(buffer));
  
}// END toNum


/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
!function(a,b){"function"==typeof define&&define.amd?define(b):"object"==typeof module&&module.exports?module.exports=b():a.numeral=b()}(this,function(){function a(a,b){this._input=a,this._value=b}var b,c,d="2.0.6",e={},f={},g={currentLocale:"en",zeroFormat:null,nullFormat:null,defaultFormat:"0,0",scalePercentBy100:!0},h={currentLocale:g.currentLocale,zeroFormat:g.zeroFormat,nullFormat:g.nullFormat,defaultFormat:g.defaultFormat,scalePercentBy100:g.scalePercentBy100};return b=function(d){var f,g,i,j;if(b.isNumeral(d))f=d.value();else if(0===d||"undefined"==typeof d)f=0;else if(null===d||c.isNaN(d))f=null;else if("string"==typeof d)if(h.zeroFormat&&d===h.zeroFormat)f=0;else if(h.nullFormat&&d===h.nullFormat||!d.replace(/[^0-9]+/g,"").length)f=null;else{for(g in e)if(j="function"==typeof e[g].regexps.unformat?e[g].regexps.unformat():e[g].regexps.unformat,j&&d.match(j)){i=e[g].unformat;break}i=i||b._.stringToNumber,f=i(d)}else f=Number(d)||null;return new a(d,f)},b.version=d,b.isNumeral=function(b){return b instanceof a},b._=c={numberToFormat:function(a,c,d){var e,g,h,i,j,k,l,m=f[b.options.currentLocale],n=!1,o=!1,p=0,q="",r=1e12,s=1e9,t=1e6,u=1e3,v="",w=!1;if(a=a||0,g=Math.abs(a),b._.includes(c,"(")?(n=!0,c=c.replace(/[\(|\)]/g,"")):(b._.includes(c,"+")||b._.includes(c,"-"))&&(j=b._.includes(c,"+")?c.indexOf("+"):0>a?c.indexOf("-"):-1,c=c.replace(/[\+|\-]/g,"")),b._.includes(c,"a")&&(e=c.match(/a(k|m|b|t)?/),e=e?e[1]:!1,b._.includes(c," a")&&(q=" "),c=c.replace(new RegExp(q+"a[kmbt]?"),""),g>=r&&!e||"t"===e?(q+=m.abbreviations.trillion,a/=r):r>g&&g>=s&&!e||"b"===e?(q+=m.abbreviations.billion,a/=s):s>g&&g>=t&&!e||"m"===e?(q+=m.abbreviations.million,a/=t):(t>g&&g>=u&&!e||"k"===e)&&(q+=m.abbreviations.thousand,a/=u)),b._.includes(c,"[.]")&&(o=!0,c=c.replace("[.]",".")),h=a.toString().split(".")[0],i=c.split(".")[1],k=c.indexOf(","),p=(c.split(".")[0].split(",")[0].match(/0/g)||[]).length,i?(b._.includes(i,"[")?(i=i.replace("]",""),i=i.split("["),v=b._.toFixed(a,i[0].length+i[1].length,d,i[1].length)):v=b._.toFixed(a,i.length,d),h=v.split(".")[0],v=b._.includes(v,".")?m.delimiters.decimal+v.split(".")[1]:"",o&&0===Number(v.slice(1))&&(v="")):h=b._.toFixed(a,0,d),q&&!e&&Number(h)>=1e3&&q!==m.abbreviations.trillion)switch(h=String(Number(h)/1e3),q){case m.abbreviations.thousand:q=m.abbreviations.million;break;case m.abbreviations.million:q=m.abbreviations.billion;break;case m.abbreviations.billion:q=m.abbreviations.trillion}if(b._.includes(h,"-")&&(h=h.slice(1),w=!0),h.length<p)for(var x=p-h.length;x>0;x--)h="0"+h;return k>-1&&(h=h.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1"+m.delimiters.thousands)),0===c.indexOf(".")&&(h=""),l=h+v+(q?q:""),n?l=(n&&w?"(":"")+l+(n&&w?")":""):j>=0?l=0===j?(w?"-":"+")+l:l+(w?"-":"+"):w&&(l="-"+l),l},stringToNumber:function(a){var b,c,d,e=f[h.currentLocale],g=a,i={thousand:3,million:6,billion:9,trillion:12};if(h.zeroFormat&&a===h.zeroFormat)c=0;else if(h.nullFormat&&a===h.nullFormat||!a.replace(/[^0-9]+/g,"").length)c=null;else{c=1,"."!==e.delimiters.decimal&&(a=a.replace(/\./g,"").replace(e.delimiters.decimal,"."));for(b in i)if(d=new RegExp("[^a-zA-Z]"+e.abbreviations[b]+"(?:\\)|(\\"+e.currency.symbol+")?(?:\\))?)?$"),g.match(d)){c*=Math.pow(10,i[b]);break}c*=(a.split("-").length+Math.min(a.split("(").length-1,a.split(")").length-1))%2?1:-1,a=a.replace(/[^0-9\.]+/g,""),c*=Number(a)}return c},isNaN:function(a){return"number"==typeof a&&isNaN(a)},includes:function(a,b){return-1!==a.indexOf(b)},insert:function(a,b,c){return a.slice(0,c)+b+a.slice(c)},reduce:function(a,b){if(null===this)throw new TypeError("Array.prototype.reduce called on null or undefined");if("function"!=typeof b)throw new TypeError(b+" is not a function");var c,d=Object(a),e=d.length>>>0,f=0;if(3===arguments.length)c=arguments[2];else{for(;e>f&&!(f in d);)f++;if(f>=e)throw new TypeError("Reduce of empty array with no initial value");c=d[f++]}for(;e>f;f++)f in d&&(c=b(c,d[f],f,d));return c},multiplier:function(a){var b=a.toString().split(".");return b.length<2?1:Math.pow(10,b[1].length)},correctionFactor:function(){var a=Array.prototype.slice.call(arguments);return a.reduce(function(a,b){var d=c.multiplier(b);return a>d?a:d},1)},toFixed:function(a,b,c,d){var e,f,g,h,i=a.toString().split("."),j=b-(d||0);return e=2===i.length?Math.min(Math.max(i[1].length,j),b):j,g=Math.pow(10,e),h=(c(a+"e+"+e)/g).toFixed(e),d>b-e&&(f=new RegExp("\\.?0{1,"+(d-(b-e))+"}$"),h=h.replace(f,"")),h}},b.options=h,b.formats=e,b.locales=f,b.locale=function(a){return a&&(h.currentLocale=a.toLowerCase()),h.currentLocale},b.localeData=function(a){if(!a)return f[h.currentLocale];if(a=a.toLowerCase(),!f[a])throw new Error("Unknown locale : "+a);return f[a]},b.reset=function(){for(var a in g)h[a]=g[a]},b.zeroFormat=function(a){h.zeroFormat="string"==typeof a?a:null},b.nullFormat=function(a){h.nullFormat="string"==typeof a?a:null},b.defaultFormat=function(a){h.defaultFormat="string"==typeof a?a:"0.0"},b.register=function(a,b,c){if(b=b.toLowerCase(),this[a+"s"][b])throw new TypeError(b+" "+a+" already registered.");return this[a+"s"][b]=c,c},b.validate=function(a,c){var d,e,f,g,h,i,j,k;if("string"!=typeof a&&(a+="",console.warn&&console.warn("Numeral.js: Value is not string. It has been co-erced to: ",a)),a=a.trim(),a.match(/^\d+$/))return!0;if(""===a)return!1;try{j=b.localeData(c)}catch(l){j=b.localeData(b.locale())}return f=j.currency.symbol,h=j.abbreviations,d=j.delimiters.decimal,e="."===j.delimiters.thousands?"\\.":j.delimiters.thousands,k=a.match(/^[^\d]+/),null!==k&&(a=a.substr(1),k[0]!==f)?!1:(k=a.match(/[^\d]+$/),null!==k&&(a=a.slice(0,-1),k[0]!==h.thousand&&k[0]!==h.million&&k[0]!==h.billion&&k[0]!==h.trillion)?!1:(i=new RegExp(e+"{2}"),a.match(/[^\d.,]/g)?!1:(g=a.split(d),g.length>2?!1:g.length<2?!!g[0].match(/^\d+.*\d$/)&&!g[0].match(i):1===g[0].length?!!g[0].match(/^\d+$/)&&!g[0].match(i)&&!!g[1].match(/^\d+$/):!!g[0].match(/^\d+.*\d$/)&&!g[0].match(i)&&!!g[1].match(/^\d+$/))))},b.fn=a.prototype={clone:function(){return b(this)},format:function(a,c){var d,f,g,i=this._value,j=a||h.defaultFormat;if(c=c||Math.round,0===i&&null!==h.zeroFormat)f=h.zeroFormat;else if(null===i&&null!==h.nullFormat)f=h.nullFormat;else{for(d in e)if(j.match(e[d].regexps.format)){g=e[d].format;break}g=g||b._.numberToFormat,f=g(i,j,c)}return f},value:function(){return this._value},input:function(){return this._input},set:function(a){return this._value=Number(a),this},add:function(a){function b(a,b,c,e){return a+Math.round(d*b)}var d=c.correctionFactor.call(null,this._value,a);return this._value=c.reduce([this._value,a],b,0)/d,this},subtract:function(a){function b(a,b,c,e){return a-Math.round(d*b)}var d=c.correctionFactor.call(null,this._value,a);return this._value=c.reduce([a],b,Math.round(this._value*d))/d,this},multiply:function(a){function b(a,b,d,e){var f=c.correctionFactor(a,b);return Math.round(a*f)*Math.round(b*f)/Math.round(f*f)}return this._value=c.reduce([this._value,a],b,1),this},divide:function(a){function b(a,b,d,e){var f=c.correctionFactor(a,b);return Math.round(a*f)/Math.round(b*f)}return this._value=c.reduce([this._value,a],b),this},difference:function(a){return Math.abs(b(this._value).subtract(a).value())}},b.register("locale","en",{delimiters:{thousands:",",decimal:"."},abbreviations:{thousand:"k",million:"m",billion:"b",trillion:"t"},ordinal:function(a){var b=a%10;return 1===~~(a%100/10)?"th":1===b?"st":2===b?"nd":3===b?"rd":"th"},currency:{symbol:"$"}}),function(){b.register("format","bps",{regexps:{format:/(BPS)/,unformat:/(BPS)/},format:function(a,c,d){var e,f=b._.includes(c," BPS")?" ":"";return a=1e4*a,c=c.replace(/\s?BPS/,""),e=b._.numberToFormat(a,c,d),b._.includes(e,")")?(e=e.split(""),e.splice(-1,0,f+"BPS"),e=e.join("")):e=e+f+"BPS",e},unformat:function(a){return+(1e-4*b._.stringToNumber(a)).toFixed(15)}})}(),function(){var a={base:1e3,suffixes:["B","KB","MB","GB","TB","PB","EB","ZB","YB"]},c={base:1024,suffixes:["B","KiB","MiB","GiB","TiB","PiB","EiB","ZiB","YiB"]},d=a.suffixes.concat(c.suffixes.filter(function(b){return a.suffixes.indexOf(b)<0})),e=d.join("|");e="("+e.replace("B","B(?!PS)")+")",b.register("format","bytes",{regexps:{format:/([0\s]i?b)/,unformat:new RegExp(e)},format:function(d,e,f){var g,h,i,j,k=b._.includes(e,"ib")?c:a,l=b._.includes(e," b")||b._.includes(e," ib")?" ":"";for(e=e.replace(/\s?i?b/,""),h=0;h<=k.suffixes.length;h++)if(i=Math.pow(k.base,h),j=Math.pow(k.base,h+1),null===d||0===d||d>=i&&j>d){l+=k.suffixes[h],i>0&&(d/=i);break}return g=b._.numberToFormat(d,e,f),g+l},unformat:function(d){var e,f,g=b._.stringToNumber(d);if(g){for(e=a.suffixes.length-1;e>=0;e--){if(b._.includes(d,a.suffixes[e])){f=Math.pow(a.base,e);break}if(b._.includes(d,c.suffixes[e])){f=Math.pow(c.base,e);break}}g*=f||1}return g}})}(),function(){b.register("format","currency",{regexps:{format:/(\$)/},format:function(a,c,d){var e,f,g,h=b.locales[b.options.currentLocale],i={before:c.match(/^([\+|\-|\(|\s|\$]*)/)[0],after:c.match(/([\+|\-|\)|\s|\$]*)$/)[0]};for(c=c.replace(/\s?\$\s?/,""),e=b._.numberToFormat(a,c,d),a>=0?(i.before=i.before.replace(/[\-\(]/,""),i.after=i.after.replace(/[\-\)]/,"")):0>a&&!b._.includes(i.before,"-")&&!b._.includes(i.before,"(")&&(i.before="-"+i.before),g=0;g<i.before.length;g++)switch(f=i.before[g]){case"$":e=b._.insert(e,h.currency.symbol,g);break;case" ":e=b._.insert(e," ",g+h.currency.symbol.length-1)}for(g=i.after.length-1;g>=0;g--)switch(f=i.after[g]){case"$":e=g===i.after.length-1?e+h.currency.symbol:b._.insert(e,h.currency.symbol,-(i.after.length-(1+g)));break;case" ":e=g===i.after.length-1?e+" ":b._.insert(e," ",-(i.after.length-(1+g)+h.currency.symbol.length-1))}return e}})}(),function(){b.register("format","exponential",{regexps:{format:/(e\+|e-)/,unformat:/(e\+|e-)/},format:function(a,c,d){var e,f="number"!=typeof a||b._.isNaN(a)?"0e+0":a.toExponential(),g=f.split("e");return c=c.replace(/e[\+|\-]{1}0/,""),e=b._.numberToFormat(Number(g[0]),c,d),e+"e"+g[1]},unformat:function(a){function c(a,c,d,e){var f=b._.correctionFactor(a,c),g=a*f*(c*f)/(f*f);return g}var d=b._.includes(a,"e+")?a.split("e+"):a.split("e-"),e=Number(d[0]),f=Number(d[1]);return f=b._.includes(a,"e-")?f*=-1:f,b._.reduce([e,Math.pow(10,f)],c,1)}})}(),function(){b.register("format","ordinal",{regexps:{format:/(o)/},format:function(a,c,d){var e,f=b.locales[b.options.currentLocale],g=b._.includes(c," o")?" ":"";return c=c.replace(/\s?o/,""),g+=f.ordinal(a),e=b._.numberToFormat(a,c,d),e+g}})}(),function(){b.register("format","percentage",{regexps:{format:/(%)/,unformat:/(%)/},format:function(a,c,d){var e,f=b._.includes(c," %")?" ":"";return b.options.scalePercentBy100&&(a=100*a),c=c.replace(/\s?\%/,""),e=b._.numberToFormat(a,c,d),b._.includes(e,")")?(e=e.split(""),e.splice(-1,0,f+"%"),e=e.join("")):e=e+f+"%",e},unformat:function(a){var c=b._.stringToNumber(a);return b.options.scalePercentBy100?.01*c:c}})}(),function(){b.register("format","time",{regexps:{format:/(:)/,unformat:/(:)/},format:function(a,b,c){var d=Math.floor(a/60/60),e=Math.floor((a-60*d*60)/60),f=Math.round(a-60*d*60-60*e);return d+":"+(10>e?"0"+e:e)+":"+(10>f?"0"+f:f)},unformat:function(a){var b=a.split(":"),c=0;return 3===b.length?(c+=60*Number(b[0])*60,c+=60*Number(b[1]),c+=Number(b[2])):2===b.length&&(c+=60*Number(b[0]),c+=Number(b[1])),Number(c)}})}(),b});
/***********************************************************
NumberFormat Extension - 2018 Orienteed
************************************************************/
WCCurrencyJS = {
    //Set defaults to en_US
    langId : -1,            // Current languageId
    decimal : 2,            // Number of decimals in current pattern
    code : "USD",           // ISO 4217 currency codes, such as "USD" for the US dollar, "EUR" for the euro
    symbolHTML : "$",       // HTML Symbol e.g. "&pound;"
    symbolUNI : "\u0024",   // Unicode Symbol e.g. "\u00A3", "$"
    symbolPrefixed : true,  // if true, symbol is prefixed e.g. "$100.00" otherwise symbol is suffixed "100.00$"
    thouSep: ",",           // Thousands separator
    decSep: ".",            // Decimal separator
    spaceSep: false,        // true if a space exist between number and symbol e.g. "100,00 €"

    init: function(langId, decimal, code, symbolHTML){
        this.langId = langId;
        this.decimal = decimal;
        this.code = code;
        this.symbolHTML = symbolHTML;

        //TODO Set unicode symbol for remaining countries
        switch (code){
            case "GBP":
                this.symbolUNI = '\u00A3';
                break;
            case "EUR":
                this.symbolUNI = '\u20AC';
                break;
            case "USD":
                this.symbolUNI = '$';
                break;
            case "CAD":
                this.symbolUNI = 'CAD $';
                break;
            default:
                this.symbolUNI = '';
        }
        
        if(location.href.toLowerCase().includes('persol')){
        	this.symbolPrefixed = true;
        	if(langId == "-1"){
        		this.spaceSep = false;
        	}else{
        		this.spaceSep = true;
        	}
        }else{
        	switch (langId){
	            case "-1": // EN
	                this.symbolPrefixed = true;
	                this.spaceSep = false;
	                break;
	            case "-2": // FR
	                this.symbolPrefixed = false;
	                this.spaceSep = true;
	                break;
	            case "-3": // DE
	                this.symbolPrefixed = false;
	                this.spaceSep = true;
	                break;
	            case "-4": // IT
	                this.symbolPrefixed = true;
	                this.spaceSep = true;
	                break;
	            case "-5": // ES
	                this.symbolPrefixed = false;
	                this.spaceSep = true;
	                break;
	            case "-6": // PT
	                this.symbolPrefixed = true;
	                this.spaceSep = true;
	                break;
	        }
        }
        
        

        var numInfo = getNumericInfo(this.code, this.langId);
        this.thouSep = numInfo.thouSep;
        this.decSep = numInfo.decSep;
    },

    /**
     * @param {String} inPrice String with price e.g. something like "$ 100.00"
     *                          Must follow current store settings e.g. US -> "$1,000.00"
                                                                   e.g. ES -> "1.000,00 €"
     * @returns String without the currency "100.00" following current locale
     */
    unformat: function(price){
        var validChars = "0123456789.,";
        var inPrice = "";
        
        if(typeof price != 'undefined'){
        	 inPrice = price.trim();
        }
        
        var regexp1 = new RegExp(/^[0-9]{1,3}(,[0-9]{3})*(\.[0-9]+)?$/); //1,123,123.123
        var regexp2 = new RegExp(/^([0-9])*(\.[0-9]+)?$/); //123456.123
        var ERROR_BAD_FORMAT = "PSL::NumberFormatExt.js::unformat()::Error: Format doesn't match current store settings";
        var ERROR_EMPTY_STRING = "PSL::NumberFormatExt.js::unformat()::Error: Price string empty";

        if (inPrice == ""){
            console.log(ERROR_EMPTY_STRING);
            return null;
        }

        //Remove initial chars until the first number and remove trailing chars until the last number
        var beginIndex = -1;
        var endIndex = -1;
        for (var i=0; i<inPrice.length; i++){
            if (beginIndex == -1){
                if (validChars.includes(inPrice[i])){
                    beginIndex = i;
                }
            } else {
                if (validChars.includes(inPrice[i])){
                    endIndex = i;
                }
            }
        }

        inPrice = inPrice.slice(beginIndex, endIndex+1);

        //Convert nubber to US format
        inPrice = inPrice.replaceAll(this.decSep,"#DECSEP#").replaceAll(this.thouSep,"#THOUSEP#");
        inPrice = inPrice.replaceAll("#DECSEP#",".").replaceAll("#THOUSEP#",",");

        if (!regexp1.test(inPrice) && !regexp2.test(inPrice)){
            console.log(ERROR_BAD_FORMAT);
            return null;
        }

        //Remove the thousands separator and test again
        inPrice = inPrice.replaceAll(",","");

        var numVal = numeral(inPrice).value();

        if (numVal == null){
            console.log(ERROR_BAD_FORMAT);
            return null;
        }

        return numVal;
    },

    /**
     *
     * @param {Number} num Number to be converted
     * @param {Object} options (Optional) Object with options. E.g. WCCurrencyJS.format(1423.23, {"truncDecimals":"true"})
     *            Available options:
     *                  "truncDecimals" : "true|false(default)"
     */
    format: function(num, options){
        var ERROR_NOT_A_NUMBER = "PSL::NumberFormatExt.js::format()::Error: Parameter is not a number";

        if ($.isNumeric(num)){

            var numf = num;
            var space = "";
            if (this.spaceSep){
                space = " ";
            }

            //Generate conversion pattern in order to convert the number using numeral.js
            var pattern = "";
            if (this.thouSep != ""){
                pattern += "0,";
            }
            if (this.decSep != ""){
                pattern += "0.";
            }
            for (var i = 0; i < this.decimal; i++) {
                pattern += "0";
            }

            // Set separators for this page
            numf = numeral(numf).format(pattern);

            //if truncDecimals is true then we remove the decimals on the formatted string
            if (options != null && options.truncDecimals == "true"){
                if (numf.includes(".")){
                    numf = numf.substring(0, numf.indexOf("."));
                }
            }

            numf = numf.replaceAll(".","#DECSEP#").replaceAll(",","#THOUSEP#");
            numf = numf.replaceAll("#DECSEP#", this.decSep).replaceAll("#THOUSEP#", this.thouSep);

            if (this.symbolPrefixed){
                numf = "" + this.symbolUNI + space + numf;
            }else{
                numf = "" + numf + space + this.symbolUNI;
            }

            return numf;
        } else {
            console.log(ERROR_NOT_A_NUMBER);
            return NaN;
        }
    }
}

String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};

WCCurrencyJS.init(
    WCParamJS.langId,
    env_currencyDecimal,
    env_currencyCode,
    env_CurrencySymbolToFormat
);
/* Begin nocache.js */

var userType = ''; /* Indicates if the user is registered 'R' or guest 'G'*/
var userInfo = ''; /* It has all the user contact information like userId, address, email, etc */
var personInfo = ''; /* It has the person information in '/person/@self' call*/
var engravingListPrice = ''; /* This variable has the engraving list price value */
var engravingPrice = ''; /* This variable has the engraving offer price value */
var engravingPriceOriginal = ''; /* This variable is a copy of the engravingPrice before check if it's registered or guest */
var engravingListPriceFormatted = ''; /* This variable has the engraving list price value formatted */
var engravingPriceFormatted = ''; /* This variable has the engraving offer price value formatted */
var engravingPriceOriginalFormatted = ''; /* This variable has the original engraving offer price value formatted */

window.addEventListener('load', (event) => {
    getUserInfo();
});

/**
 * Function that gets all person and user info and save them in global variables.
 * @param {function} callback - function to be executed at the end of this method if exist.
 */
function getUserInfo(callback) {
    var url = '/wcs/resources/store/' + WCParamJS.storeId + '/person/@self';
    getAjaxCallInfo(url, null, userinfoCallback);

    function userinfoCallback(response) {
        personInfo = response;
        if(response.userId == '-1002'){
            userType = 'G';
            if(typeof callback !== 'undefined') {
                callback();
            }
            if (document.readyState !== 'loading') {
                afterNoCacheRESTFuntion();
            } else {
                document.addEventListener('DOMContentLoaded', function () {
                    afterNoCacheRESTFuntion();
                });
            }
        } else {
            var url = '/wcs/resources/store/' + WCParamJS.storeId + '/person/'+ response.userId;
            var params = {
                "profileName": "IBM_User_Registration_Details"
            };
            getAjaxCallInfo(url, params, getUserInfoCallback);
        }
    }

    function getUserInfoCallback(response) {
        userType = response.registerType;
        userInfo = response;
        if(typeof sessionStorage['logged']=='undefined' && userType =='R')
            sessionStorage.setItem('logged', 'true');
        if(userType === 'R' ){
            if(typeof userInfo.address.phone1 !== 'undefined' && userInfo.address.phone1 != null && localStorage.encryptedUserPhoneSHA256 == null){
                let phone1Prefix = String(localStorage.prefixNumberPhone1) + String(userInfo.address.phone1); 
                if(typeof sha256 != 'undefined') {
                    if(typeof sha256(phone1Prefix) === 'object' && typeof sha256(phone1Prefix).then === 'function')
                        sha256(phone1Prefix).then(result => {  localStorage.setItem('encryptedUserPhoneSHA256',result); } );
                    else
                        localStorage.setItem('encryptedUserPhoneSHA256',sha256(phone1Prefix));
                }
            }
            //BEGIN FIX - HB-11853
            if((isPersol || isOliver || isVogue) && typeof userInfo.address.email1 !== 'undefined' && userInfo.address.email1 != null && localStorage.encryptedEmailUserSHA256 == null){
                let emailUser = userInfo.address.email1;
                emailUser = emailUser.trim().toLowerCase();
                if(typeof sha256(emailUser) === 'object' && typeof sha256(emailUser).then === 'function')
                    sha256(emailUser).then(result => {  localStorage.setItem('encryptedEmailUserSHA256',result); } );
                else
                    localStorage.setItem('encryptedEmailUserSHA256',sha256(emailUser));
            }
            //END FIX - HB-11853

            if(algoliaActive) {
                aa('setAuthenticatedUserToken', userInfo.userId);
            }
        }
        if(typeof callback !== 'undefined') {
            callback();
        }
        if (document.readyState !== 'loading') {
            afterNoCacheRESTFuntion();
        } else {
            document.addEventListener('DOMContentLoaded', function () {
                afterNoCacheRESTFuntion();
            });
        }
    }
}

/**
 * Function that returns a html showing the current address info
 * @param {string} suffix - this suffix is passed to prevent duplicated ids (WCAG)
 * @param {JSON} data - current address info
 * @param {*} setAsVar -
 * @param {string} stateDisplayName - State Name
 * @param {string} countryDisplayName  - Country Name
 * @param {string} addressLine1 - First Address line of current address
 * @param {string} addressLine2 - Second Address line of current address
 * @param {string} addressLine3 - Third Address line of current address, only used for Carol
 *
 * @return {string} - html code with the current address info
 */
function getAddress(suffix, data, setAsVar, stateDisplayName, countryDisplayName, addressLine1, addressLine2, addressLine3) {
    var html = '<div class="address">';
    if(data.lastName || data.firstName) {
        html = html + '<div class="full-name">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + data.firstName + ' ' + data.lastName + '<br />';
        } else {
            html = html + '<span id="firstName' + suffix + '">' + data.firstName + '</span> ' +
            '<span id="lastName' + suffix + '">' + data.lastName + '</span><br/>';
        }
        html = html + '</div>';
    }

    if(data.phone1) {
        html = html + '<div class="phone">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + data.phone1 + '<br />';
        } else {
            html = html + '<span id="telephone1' + suffix + '">' + data.phone1 + '</span><br />';
        }
        html = html + '</div>';
    }

    if(data.email1) {
        html = html + '<div class="email">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + data.email1 + '<br />';
        } else {
            html = html + '<span id="emailAddress1' + suffix + '">' + data.email1 + '</span><br />';
        }
        html = html + '</div>';
        if(isPersol || isVogue) {
            html = html + '<br />';
        }
    }

    if(addressLine1 || addressLine2 || addressLine3) {
        html = html + '<div class="full-address">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + addressLine1 + ' ' + addressLine2 + '<br />';
        } else {
            html = html + '<span id="addressLine1' + suffix + '">' + addressLine1 + '</span> ' +
            '<span id="addressLine2' + suffix + '">' + addressLine2 + '</span>';
            if(isCarol) {
                html = html + '<span id="addressLine3' + suffix + '">' + addressLine3 + '</span>';
            }
            html = html + '<br/>';
        }
        html = html + '</div>';
    }
    html = html + '<input type="hidden" name="stateCode" value="' + data.state + '">';

    if(data.city || stateDisplayName) {
        if(!stateDisplayName) {
            stateDisplayName = '';
        }
        html = html + '<div class="city">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + data.city + ' ' + stateDisplayName + '<br />';
        } else {
            html = html + '<span id="city' + suffix + '">' + data.city + '</span> ' +
            '<span id="stateDisplayName' + suffix + '">' + stateDisplayName + '</span><br />';
        }
        html = html + '</div>';
    }

    if(countryDisplayName || data.zipCode) {
        html = html + '<div class="postal-code">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + countryDisplayName + ' ' + data.zipCode + '<br />';
        } else {
            html = html + '<span id="countryDisplayName' + suffix + '">' + countryDisplayName + '</span> ' +
            '<span id="postalCode' + suffix + '">' +  data.zipCode + '</span><br />';
            var tealiumOrder_ZipCode = data.zipCode;
        }
        html = html + '</div>';
    }
    html = html + '</div>';
    return html;
}

/**
 * Function that returns a html showing the current address info (used for the following countries: DE ES FR IT PL RO RU)
 * @param {string} suffix - this suffix is passed to prevent duplicated ids (WCAG)
 * @param {JSON} data - current address info
 * @param {*} setAsVar -
 * @param {string} stateDisplayName - State Name
 * @param {string} countryDisplayName  - Country Name
 * @param {string} addressLine1 - First Address line of current address
 * @param {string} addressLine2 - Second Address line of current address
 *
 * @return {string} - html code with the current address info
 */
function getAddress_DE_ES_FR_IT_PL_RO_RU(suffix, data, setAsVar, stateDisplayName, countryDisplayName, addressLine1, addressLine2) {
    var middleName = '';
    if(typeof data.middleName !== 'undefined') {
        middleName = data.middleName;
    }

    var html = '<div class="address">';
    if(data.firstName || data.lastName || middleName) {
        html = html + '<div class="full-name">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + data.firstName + ' ' + data.lastName + ' ' + middleName + '<br />';
        } else {
            html = html + '<span id="firstName' + suffix + '">' + data.firstName + '</span> ' +
            '<span id="middleName' + suffix + '">' + middleName + '</span> ' +
            '<span id="lastName' + suffix + '">' + data.lastName + '</span><br/>';
        }
        html = html + '</div>';
    }

    if(data.phone1) {
        html = html + '<div class="phone">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + data.phone1 + '<br />';
        } else {
            html = html + '<span id="telephone1' + suffix + '">' + data.phone1 + '</span><br />';
        }
        html = html + '</div>';
    }

    if(data.email1) {
        html = html + '<div class="email">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + data.email1 + '<br />';
        } else {
            html = html + '<span id="emailAddress1' + suffix + '">' + data.email1 + '</span><br />';
        }
        html = html + '</div>';
    }

    if(addressLine1 || addressLine2) {
        html = html + '<div class="full-address">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + addressLine1 + ' ' + addressLine2 + '<br />';
        } else {
            html = html + '<span id="addressLine1' + suffix + '">' + addressLine1 + '</span> ' +
            '<span id="addressLine2' + suffix + '">' + addressLine2 + '</span><br/>';
        }
        html = html + '</div>';
    }
    html = html + '<input type="hidden" name="stateCode" value="' + data.state + '">';

    if(data.city || data.zipCode) {
        html = html + '<div class="city">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + data.zipCode + ' ' + data.city + '<br />';
        } else {
            html = html + '<span id="postalCode' + suffix + '">' + data.zipCode + '</span> ' +
            '<span id="city' + suffix + '">' + data.city + '</span><br />';
        }
        html = html + '</div>';
    }

    if(stateDisplayName) {
        html = html + '<div class="state">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + stateDisplayName + '<br />';
        } else {
            html = html + '<span id="stateDisplayName' + suffix + '">' + stateDisplayName + '</span><br />';
        }
        html = html + '</div>';
    }

    if(countryDisplayName) {
        html = html + '<div class="postal-code">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + countryDisplayName + '<br />';
        } else {
            html = html + '<span id="countryDisplayName' + suffix + '">' + countryDisplayName + '</span><br />';
        }
        html = html + '</div>';
    }
    html = html + '</div>';
    return html;
}

/**
 * Function that make ajax calls to get the country and state names and then, pass all the information
 * to getAddress/getAddress_DE_ES_FR_IT_PL_RO_RU to build the html with all current address info
 * @param {string} suffix - this suffix is passed to prevent duplicated ids (WCAG)
 * @param {JSON} data - current address info
 * @param {*} setAsVar -
 * @param {*} cachedOnlineStoreMap -
 * @param {*} setIsOrg -
 * @param {string} elem - specific element selector
 */
function getAddressDisplay(suffix, data, setAsVar, cachedOnlineStoreMap, setIsOrg, elem) {
    //Set the country and state display name to the country and state codes respectively. This is in case the display name is not found.
    var countryDisplayName = data.country;
    var stateDisplayName = data.state;
    var contactCountryStateBean = '';
    var key1 = '', url = '', addressLine1 = '', addressLine2 = '', addressLine3 = '', contactAddressLine = '', contactAddressLineArray = [], html = '';
    var params = {};

    if(setAsVar && setAsVar == true) {
        var addressDisplay = '';
    }

    if(countryDisplayName && countryDisplayName.length <= 5) {
        /* Retrieve the country display name from the country code and
		   the state display name from the state code */
        key1 = 'store/' + WCParamJS.storeId + '/country/country_state_name+' + WCParamJS.langId + '+' + countryDisplayName + '+' +stateDisplayName;
        contactCountryStateBean = cachedOnlineStoreMap[key1];
        if (!contactCountryStateBean) {
            url = '/wcs/resources/store/' + WCParamJS.storeId + '/country/country_state_name';
            if(countryDisplayName){
                params["countryCode"] = countryDisplayName;
            }
            if(stateDisplayName){
                params["stateCode"] = stateDisplayName;
            }
            params["langId"] = WCParamJS.langId
            getAjaxCallInfo(url, params, getCountryInfo);
        }
    }

    /**
     * Function that receive the country info and saves the country name. Then execute the second ajax call
     * to get the state information if its needed or it continues executing insertAddressToDOM function.
     * @param {JSON} response
     */
    function getCountryInfo(response) {
        contactCountryStateBean = response;
        if(contactCountryStateBean) {
            countryDisplayName = contactCountryStateBean.countryDisplayName;
        }
        if(stateDisplayName && stateDisplayName.length <= 5 && contactCountryStateBean) {
            /* Retrieve the state display name from the state code
               This piece of code should not be needed for most cases */
            key1 = 'store/' + WCParamJS.storeId + '/country/country_state_name+' + WCParamJS.langId + '+' +stateDisplayName;
            contactCountryStateBean = cachedOnlineStoreMap[key1];
            if (!contactCountryStateBean) {
                url = '/wcs/resources/store/' + WCParamJS.storeId + '/country/country_state_name';
                if(stateDisplayName){
                    params["stateCode"] = stateDisplayName;
                }
                params["langId"] = WCParamJS.langId
                getAjaxCallInfo(url, params, getStateInfo);
            }
        } else {
            insertAddressToDOM();
        }

    }

    /**
     * Function that receive the state info and saves the state name and then
     * continues executing insertAddressToDOM function.
     * @param {JSON} response
     */
    function getStateInfo(response) {
        contactCountryStateBean = response;
        if(contactCountryStateBean) {
            stateDisplayName = contactCountryStateBean.stateDisplayName;
        }
        insertAddressToDOM();
    }

    /**
     * Function that saves the last info and gets the html built calling the getAddress
     * or getAddress_DE_ES_FR_IT_PL_RO_RU and inject it in the element passed
     */
    function insertAddressToDOM() {
        if(setIsOrg && setIsOrg == true) {
            addressLine1 = data.address1;
            addressLine2 = data.address2;
        } else {
            if(isCarol) {
                if(typeof data.addressLine === 'string') {
                    contactAddressLine = data.addressLine;
                    contactAddressLineArray = contactAddressLine.split(",");
                    addressLine1 = (data.addressLine[0]).replace('[','');
                    addressLine2 = (data.addressLine[1]).replace('[','');
                    addressLine3 = (data.addressLine[2]).replace('[','');
                } else {
                    addressLine1 = data.addressLine[0];
                    addressLine2 = data.addressLine[1];
                    addressLine3 = data.addressLine[2];
                }
            } else {
                addressLine1 = data.addressLine[0];
                addressLine2 = data.addressLine[1];
            }
        }

        if(countryCode == 'DE' || countryCode == 'ES' || countryCode == 'FR' || countryCode == 'IT' ||
        countryCode == 'PL' || countryCode == 'RO' || countryCode == 'RU') {
            html = getAddress_DE_ES_FR_IT_PL_RO_RU(suffix, data, setAsVar, stateDisplayName, countryDisplayName, addressLine1, addressLine2);
        } else {
            if(isCarol) {
                html = getAddress(suffix, data, setAsVar, stateDisplayName, countryDisplayName, addressLine1, addressLine2, addressLine3);

            } else {
                html = getAddress(suffix, data, setAsVar, stateDisplayName, countryDisplayName, addressLine1, addressLine2);
            }
        }
        $(elem).html(html);
    }
}

/**
 * This function gets all prices for engraving (for register, guest, formated prices, etc)
 * @param {function} callback - function to be executed at the end of this method if exist.
 */
function getEngravingPrice(callback) {

    var listPriceUrl = '/wcs/resources/store/' + WCParamJS.storeId + '/display_price';
    var listPriceParams = {
        "q": "byCatalogEntryIdsAndPriceRuleName",
        "catalogEntryId": engravingProductId,
        "currency": env_currencyCode,
        "checkEntitlement": "false"
    };
    if(engravingProductId){
    	getAjaxCallInfo(listPriceUrl, listPriceParams, getEngravingListPriceCallback);
    }

    /**
     * This function is a callback that saves the engraving list price
     * and makes an ajax call to get the engraving offer price
     * @param {*} response - the previous ajax call data
     */
    function getEngravingListPriceCallback(response) {
        engravingListPrice = response.resultList[0].unitPrice[0].price.value;
        if(userType === 'R') {
            engravingListPrice = 0;
        }
        var offerPriceUrl = '/wcs/resources/store/' + WCParamJS.storeId + '/price';
        var offerPriceParams = {
            "q": "byCatalogEntryIds",
            "catalogEntryId": engravingProductId,
            "currency": env_currencyCode,
            "checkEntitlement": "false"
        };
        getAjaxCallInfo(offerPriceUrl, offerPriceParams, getEngravingOfferPriceCallback);
    }

    /**
     * This function is a callback that saves the engraving offer price
     * and saves the formated prices.
     * @param {*} response - the previous ajax call data
     */
    function getEngravingOfferPriceCallback(response) {
    	if(typeof response != 'undefined') {
	        engravingPrice = engravingPriceOriginal = response.EntitledPrice[0].UnitPrice[0].price.value;
	        if(userType === 'R') {
	            engravingPrice = 0;
	        }
	        engravingListPriceFormatted = WCCurrencyJS.format(engravingListPrice);
	        engravingPriceFormatted = WCCurrencyJS.format(engravingPrice);
	        engravingPriceOriginalFormatted = WCCurrencyJS.format(engravingPriceOriginal);
	
	        if(typeof callback !== 'undefined') {
	            callback();
	        }
	
	        if (document.readyState !== 'loading') {
	            if(isPersol && $('.pdp').length > 0) {
	                shopperActionsUserCallback();
	            }
	        } else {
	            document.addEventListener('DOMContentLoaded', function () {
	                if(isPersol && $('.pdp').length > 0) {
	                    shopperActionsUserCallback();
	                }
	            });
	        }
    	}
    }

}

/**
 * Function that will be executed at the end of all ajax calls
 */
function afterNoCacheRESTFuntion() {
    if($('.GlobalLoginWidgetAlt').length > 0 && (isPersol || isVogue)){
        globalLoginSignOutCallback();
    }
    if(isCarol && userInfo !== '' && userInfo.address !== null) {
        $('.name_header').text(userInfo.address.firstName + ' ' + userInfo.address.lastName);
    }
    if(isPersol && $('.pdp').length > 0) {
        getEngravingPrice(showMonogramBlock);
    }

    if (isVogue && $("body.pdp").length>0){
        if (userType == "G"){
            $(document).ready(function(){
                $(".shopping-list-widget").hide();
            });
        } else {
            $(document).ready(function(){
                $(".shopping-list-widget").show();
                getPDPWishlistInfo();
            });
        }
    }
    if (isVogue) {
        showWishList();
    }
}

/**
 *  Function callback that gets the userType and remove adds text to monogram spans depending
 *  of userType
 *  @param {JSON} response
 */
function shopperActionsUserCallback() {
    if(!isPersol){
        if (userType === 'R') {
            var addMonogramLoyalReplace = addMonogramLoyal.replace('{0}', engravingPriceOriginalFormatted);
            var addMonogramLoyalSubtitleReplace = addMonogramLoyalSubtitle.replace('{0}', engravingPriceOriginalFormatted);
            document.querySelector('.shopperActions--monogram--title__title').innerHTML = addMonogramLoyalReplace;
            document.querySelector('.shopperActions--monogram--title__subtitle').innerHTML = addMonogramLoyalSubtitleReplace;
        } else {
            var addMonogramReplace = addMonogram.replace('{0}', engravingPriceFormatted);
            document.querySelector('.shopperActions--monogram--title__title').innerHTML = addMonogramReplace;
            document.querySelector('.shopperActions--monogram--title__subtitle').innerHTML = addMonogramSubtitle;
        }
    } 
}

/**
 * Function that inserts the userName in the globalLogin and shows it to the user
 */
function globalLoginSignOutCallback() {
    var userDisplayName = '';
    if(userInfo.address){
        if(countryCode == 'JP' || countryCode == 'KR' || countryCode == 'CN' || countryCode == 'TW') {
            userDisplayName = userInfo.address.lastName + ' ' + userInfo.address.firstName;
        } else {
            userDisplayName = userInfo.address.firstName + ' ' + userInfo.address.lastName;
        }
    }
    $('#' + LOGOUTPANEL_ID + '_signOutQuickLinkUser').text(userDisplayName);
    $('#' + LOGOUTPANEL_ID + '_signOutQuickDiv .myAccountResponsive .name').text(userDisplayName);
    $('.myAccountResponsive .firstLine').show();
}

/**
 * This function show the Add Monogram block inside PDP in Persol
 */
function showMonogramBlock() {
    if(userType === 'R') {
        $('.wishlist, .userpanel-favorites').show();
    } else {
    	if($('.shopperActions--monogram--pop-up--right--wrapper--step-one--title span')[0] != undefined) {
    		var monogram_span = $('.shopperActions--monogram--pop-up--right--wrapper--step-one--title span')[0].innerText;
    		if(!monogram_span.includes(engravingPriceFormatted)) {
    			$('.shopperActions--monogram--pop-up--right--wrapper--step-one--title span').append(' ('+engravingPriceFormatted+')');
    		}
	        $('.wishlist').hide();
	        $('.userpanel-favorites').css('display','flex');
    	}
    }
}

/**
 * This function show the wishlist if the user is registered
 */
function showWishList() {
    if(userType === 'R') {
        $('.wishlist').show();
        $('.userpanel-favorites').css('display','flex');
        $('.userpanel-acount').removeClass('userpanel-acount--guest');
    } else {
        $('userpanel-acount').addClass('userpanel-acount--guest');
        $('.wishlist, .userpanel-favorites').hide();        
    }
}
/* End nocache.js */
// -----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2006, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
// -----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by the store jsp's related to address creation and maintenance.
 * @version 1.0
 */

/**
 * The functions defined in this class enable address creation across the store.
 *
 * @class The functions and variables defined in this class validate the form
 *        input field values entered by the customer. Another set of functions
 *        help in loading the UI for the state field when there is a change in
 *        the country field. Another set of functions enable creating an address
 *        in the shopcart page and guest user checkout page.
 */
var zipCodeError= false;
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}





var continents = [
    {
      continent: 'AF',
      countries: ['DZ','AO','BW','BI','CM','CV','CF','TD','KM','YT','CG','CD','BJ','GQ','ET','ER','DJ','GA','GM','GH','GN','CI','KE','LS','LR','LY','MG','MW','ML','MR','MU','MA','MZ','NA','NE','NG','GW','RE','RW','SH','ST','SN','SC','SL','SO','ZA','ZW','SS','EH','SD','SZ','TG','TN','UG','EG','TZ','BF','ZM']
    },
    {
      continent: 'AS',
      countries: ['AF','AZ','BH','BD','AM','BT','IO','BN','MM','KH','LK','CN','TW','CX','CC','CY','GE','PS','HK','IN','ID','IR','IQ','IL','JP','KZ','JO','KP','KR','KW','KG','LA','LB','MO','MY','MV','MN','OM','NP','PK','PH','TL','QA','RU','SA','SG','VN','SY','TJ','TH','AE','TR','TM','UZ','YE','XE','XD','XS']
    },
    {
      continent: 'EU',
      countries: ['AL','UK','AD','AZ','AT','AM','BE','BA','BG','BY','HR','CY','CZ','DK','EE','FO','FI','AX','FR','GE','DE','GI','GR','VA','HU','IS','IE','IT','KZ','LV','LI','LT','LU','MT','MC','MD','ME','NL','NO','PL','PT','RO','RU','SM','RS','SK','SI','ES','SJ','SE','CH','TR','UA','MK','GB','GG','JE','IM']
    },
    {
      continent: 'NA',
      countries: ['AG','BS','BB','BM','BZ','VG','CA','KY','CR','CU','DM','DO','SV','GL','GD','GP','GT','HT','HN','JM','MQ','MX','MS','AN','CW','AW','SX','BQ','NI','UM','PA','PR','BL','KN','AI','LC','MF','PM','VC','TT','TC','US','VI']
    },
    {
        continent: 'OC',
        countries: ['AS','AU','SB','CK','FJ','PF','KI','GU','NR','NC','VU','NZ','NU','NF','MP','UM','FM','MH','PW','PG','PN','TK','TO','TV','WF','WS','XX']
    },
    {
        continent: 'SA',
        countries: ['AR','BO','BR','CL','CO','EC','FK','GF','GY','PY','PE','SR','UY','VE']
    }
  ];

function getContinent(country){
	for (var key in continents) {
	    // check if the property/key is defined in the object itself, not in parent
	    if (continents.hasOwnProperty(key)) {
	    	if(continents[key].countries.includes(country)){
	    		return continents[key].continent;
	    	}        
	    }
	}
}

//ChangeDone
AddressHelper = {
    /* The name of the state field div. */
    stateDivName: "stateDiv",
    storeCountry: "",
    storeName: "",
    /* styling class for the state field. */
    stateClass: null,
    selectedCountryCode: null,
    cityId: null,
    stateId: null,
    maxNeighborhoodChar : 31,
    validZipCode: null,
    zipCodeNotFound:false,
    validZipCodeShipping: null,
    validZipCodeBilling: null,
    isSameCountryAsStore: true,
    zipCount: 0,
    validCPF: false,
    hasTaxes: false,

    setStoreName: function (storeName) {
        this.storeName = storeName;
    },

    /**
     * This function set the value of hasTaxes
     *
     * @param {boolean} hasTaxes show if store has taxes or not
     */
    setStoreHasTaxes: function (hasTaxes) {
        this.hasTaxes = (hasTaxes == 'true');
    },

    /**
     *This method will show the WC Dialog popup
     *@param{String} widgetId The ID of the WC Dialog which should be shown
     */
    showWCDialogPopup: function (widgetId) {
        var dialog = $("#" + widgetId).data("wc-WCDialog");
        if (dialog) {
            dialog.open();
            $("#" + widgetId).css("display", "block");
            $('.ui-widget-overlay').hasClass('custom-overlay') ? '' : $('.ui-widget-overlay').addClass('custom-overlay');
        } else {
            console.debug(widgetId + " does not exist");
        }
    },

    /**
     *This method will show the WC Dialog popup
     *@param{String} widgetId The ID of the WC Dialog which should be shown
     */
    showAddEditAddressPopup: function (widgetId, addressIdDiv, storeId) {
        this.showWCDialogPopup(widgetId);
        if (addressIdDiv && addressIdDiv != '') {
            var addressId = $('#' + addressIdDiv)[0].value;
            if (addressId && addressId != '') {
                $.ajax({
                    type: "GET",
                    url: "/wcs/resources/store/" + storeId  + "/person/@self/contact/byAddressId/" + addressId,
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    success: function (data) {
                     // fill address
                        var addEditAddressForm = document.forms['addEditAddressForm'];

                        addEditAddressForm.firstName.value = data.firstName;
                        addEditAddressForm.lastName.value = data.lastName;
                        addEditAddressForm.address1.value = data.addressLine[0];
                        addEditAddressForm.state.value = data.state;
                        addEditAddressForm.city.value = data.city;
                        addEditAddressForm.zipCode.value = data.zipCode;
                        addEditAddressForm.phone1.value = data.phone1;
                        if($('#emailAddress1')[0]) {
                            addEditAddressForm.email1.value = data.email1;
                        }

                        if (typeof addEditAddressForm.addressId == 'undefined' ) {
                            $('<input>').attr({
                                type: 'hidden',
                                id: 'addressId',
                                name: 'addressId',
                                value: addressId
                            }).appendTo(addEditAddressForm);
                        } else {
                            addEditAddressForm.addressId.value = addressId;
                        }

                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {

                    }
                });
            }

        } else {
            // clears
            var addEditAddressForm = document.forms['addEditAddressForm'];

            addEditAddressForm.firstName.value = '';
            addEditAddressForm.lastName.value = '';
            addEditAddressForm.address1.value = '';
            addEditAddressForm.state.value = '';
            addEditAddressForm.city.value = '';
            addEditAddressForm.zipCode.value = '';
            addEditAddressForm.phone1.value = '';
            if (addEditAddressForm.addressId) {
                addEditAddressForm.addressId.remove();
            }
        }

    },
    /**
     * This function sets the name for the state field.
     *
     * @param {string}
     *            stateDivName The name to be set for the state field.
     */
    setStateDivName: function (stateDivName) {
        this.stateDivName = stateDivName;
    },

    /**
     * This function sets the styling class for the state field.
    *
    * @param {string}
    *            stateClass The name of the styling class to be set for the
    *            state field.
     */
    setStateClass: function (stateClass) {
        this.stateClass = stateClass;
    },

    /**
     * set selected country code on change country event
     */
    setSelectedCountryCode: function (selectedCountryCode) {
        this.selectedCountryCode = selectedCountryCode;
    },

    setStoreCountry: function (storeCountry) {
        this.storeCountry = storeCountry;
    },

    /**
     * set default selected country onload, in order to perfom zip validation
     */
    setSelectedCountryId: function (selectedCountryId) {
        this.selectedCountryId = selectedCountryId;

        var selectedCountry = document.getElementById(selectedCountryId);

        if (selectedCountry != null) {
            //set default selectedcountry code
            var currentCountryCode = null;

            if (selectedCountryId == "_state1") {
                currentCountryCode = selectedCountry.value;
            } else {
                currentCountryCode = selectedCountry.value;
            }

            this.setSelectedCountryCode(currentCountryCode);
        }


    },

    /**
     * This function return an array of countries from a global variable called
     * countries. If that variable does not already exist then it will be
     * created and populated from a JSON of country objects which should have
     * been loaded into a div on the page prior to calling this function.
     *
     * @returns {Array} countries An array of countries.
     */
    getCountryArray: function () {

        //If the countries array does not already exist then create it.

        if (document["countries"] == null) {
            countries = new Array();
            var theDiv = document.getElementById("countryListSelectionHelper");

            if (typeof theDiv == 'undefined')
                return null;
            var divJSON = eval('(' + theDiv.innerHTML + ')');
            var countriesObject = divJSON.countries;

            for (var i = 0; i < countriesObject.length; i++) {
                var countryObject = countriesObject[i];
                countries[countryObject.code] = new Object();
                countries[countryObject.code].name = countryObject.displayName;
                countries[countryObject.code].countryCallingCode = countryObject.callingCode;

                if (countryObject.states.length > 0) {
                    countries[countryObject.code].statesArray = new Array();
                    countries[countryObject.code].states = new Object();
                    for (var j = 0; j < countryObject.states.length; j++) {
                        var state = countryObject.states[j];
                        countries[countryObject.code].statesArray.push({
                            value: state.code,
                            label: state.displayName
                        });
                        countries[countryObject.code].states[state.code] = state.displayName;
                    }
                }
            }
        }

        return countries;

    },

    /**
     * This function will load the state field depending on the country
     * selection.
     *
     * @param {string}
     *            formName The name of the address form containing the state
     *            field and country field.
     * @param {string}
     *            stateDiv The name of the state field.
     * @param {string}
     *            id The id of the state field to be created.
     * @param {boolean}
     *            keepCurrentState A true or false value used to determine
     *            whether to keep the current value in the state field or to
     *            remove it.
     * @param {string}
     *            copyValue The value to be copied to the newly generated state
     *            field.
     */
    loadStatesUI: function (formName, paramPrefix, stateDiv, id, keepCurrentState, copyValue) {

        this.getCountryArray();
        var form = document.getElementById(formName);
        if (paramPrefix == null || paramPrefix == 'undefined'
            || paramPrefix == "") {
            paramPrefix = "";
        }
        var newid = paramPrefix + id;
        var currentState;
        var required;
        if ($("#" + newid).length) {
            required = ($("#" + newid)).attr("aria-required");
        }
        if (keepCurrentState != null && keepCurrentState != 'undefined'
            && keepCurrentState == true) {
            currentState = $("#" + newid).val()
        } else {
            currentState = "";
        }

        if (copyValue != null && copyValue != 'undefined' && copyValue != '') {
            currentState = copyValue;
        }
        if (id == "_state1") {
            this.setStateClass("form_input");
            var currentCountryCode = form[paramPrefix + "_country"].value;
        } else {
            var currentCountryCode = form[paramPrefix + "country"].value;
        }

        var stateDivObj = document.getElementById(stateDiv);
        if (Utils.get_IE_version()) { /* For IE */
            var stateClass = ($("#" + newid)).attr("className");
        } else {
            var stateClass = ($("#" + newid)).attr("class");
        }

        if (stateClass != "drop_down_country") {
            this.setStateClass(stateClass);
        }
        while (stateDivObj.hasChildNodes()) {
            stateDivObj.removeChild(stateDivObj.firstChild);
        }

        if (countries[currentCountryCode].states) {
            /* switch to state list. */
            stateDivObj.appendChild(this.createStateWithOptions(paramPrefix,
                currentCountryCode, currentState, id, required));
        } else {
            /* switch to state text input. */
            stateDivObj.appendChild(this.createState(paramPrefix, currentState,
                id, required));
        }
    },

    /**
     *	This function creates an input element to represent the state.
     *
     * @param {string}
     *            paramPrefix The value can be shipping, billing or blank.
     * @param {string}
     *            currentState The value in the state field.
     * @param {string}
     *            id The id of the state field.
     */
    createState: function (paramPrefix, currentState, id, required) {
        var stateInput = document.createElement("input");
        stateInput.setAttribute("id", paramPrefix + id);
        if (id == "_state1") {
            stateInput.setAttribute("name", paramPrefix + "_state");
        } else {
            stateInput.setAttribute("name", paramPrefix + "state");
        }
        if (required) {
            stateInput.setAttribute("aria-required", "true");
        }
        stateInput.setAttribute("class", this.stateClass);
        stateInput.setAttribute("className", this.stateClass);
        stateInput.setAttribute("size", "35");
        stateInput.setAttribute("maxlength", "49");
        if (currentState != null && currentState != 'undefined') {
            stateInput.setAttribute("value", currentState);
        }
        return stateInput;
    },

    /**
     * This function creates a <select> element to represent the state field and
     * loads it with the states corresponding to the country field.
     *
     * @param {string}
     *            paramPrefix The value can be shipping, billing or blank.
     * @param {string}
     *            currentCountryCode The country code of the selected country.
     * @param {string}
     *            currentState The value in the state field.
     * @param {string}
     *            id The id of the state field.
     */
    createStateWithOptions: function (paramPrefix, currentCountryCode, currentState, id, required) {

        this.getCountryArray();
        var stateSelect = document.createElement("select");
        stateSelect.setAttribute("id", paramPrefix + id);
        if (id == "_state1") {
            stateSelect.setAttribute("name", paramPrefix + "_state");
        } else {
            stateSelect.setAttribute("name", paramPrefix + "state");
        }
        if (required) {
            stateSelect.setAttribute("aria-required", "true");
        }
        stateSelect.setAttribute("class", "drop_down_country");
        stateSelect.setAttribute("className", "drop_down_country");
        /*clear old options. */
        stateSelect.options.length = 0;

        /* add all states. */
        for (state_code in countries[currentCountryCode].states) {

            aOption = document.createElement("option");
            stateSelect.options[stateSelect.length] = aOption;
            aOption.text = countries[currentCountryCode].states[state_code];
            aOption.value = state_code;

            if (state_code == currentState
                || countries[currentCountryCode].states[state_code] == currentState) {
                aOption.selected = true;
            }
        }

        return stateSelect;
    },

    /**
     * This function will load the state field for selection dropdown using
     * wc.Select in AdressForm.jsp depending on the country selection.
     *
     * @param {string}
     *            formName The name of the address form containing the state
     *            field and country field.
     * @param {string}
     *            stateDiv The name of the state field.
     * @param {string}
     *            id The id of the state field to be created.
     * @param {boolean}
     *            keepCurrentState A true or false value used to determine
     *            whether to keep the current value in the state field or to
     *            remove it.
     * @param {string}
     *            copyValue The value to be copied to the newly generated state
     *            field.
     * @param {boolean}
     *            addEmptyOption - If true, it adds 'Please Select' as the first
     *            option with value set to ''.
     */
    loadAddressFormStatesUI: function (formName, paramPrefix, stateDiv, id, keepCurrentState, copyValue, addEmptyOption) {

        this.getCountryArray();
        var form = document.getElementById(formName);
        if (paramPrefix == null || paramPrefix == 'undefined'
            || paramPrefix == "") {
            paramPrefix = "";
        }
        var newid = paramPrefix + id;
        var currentState;
        var required = false;
        if ($("#" + newid).length) {
            required = ($("#" + newid)).attr("aria-required");
        }
        if (keepCurrentState != null && keepCurrentState != 'undefined'
            && keepCurrentState == true) {
            currentState = $("#" + newid).val()
        } else {
            currentState = "";
        }

        if (copyValue != null && copyValue != 'undefined' && copyValue != '') {
            currentState = copyValue;
        }

        if (id == "_state1") {
            this.setStateClass("form_input");
            var currentCountryCode = form[paramPrefix + "_country"].value;
            this.setSelectedCountryCode(currentCountryCode);
        } else {
            var currentCountryCode = form[paramPrefix + "country"].value;
            this.setSelectedCountryCode(currentCountryCode);
        }

        var stateDivObj = document.getElementById(stateDiv);
        var stateClass = ($("#" + newid)).attr("class");

        if (stateClass !== "drop_down_country") {
            this.setStateClass(stateClass);
        }

        while (stateDivObj.hasChildNodes()) {
            stateDivObj.removeChild(stateDivObj.firstChild);
        }

        if (countries[currentCountryCode]
            && countries[currentCountryCode].statesArray) {
            /* switch to state list. */
            var statesData = countries[currentCountryCode].statesArray;
            if (addEmptyOption) {
                var option1 = new Object({
                    label: Utils.getLocalizationMessage("PLEASE_SELECT"),
                    value: ''
                });
                statesData.unshift(option1);
            }

            if (this.stateClass == "" || this.stateClass == null
                || this.stateClass == undefined
                || this.stateClass == "null") {
                this.stateClass = "wcSelect";
            }

            $('<select>').attr({
                'name': paramPrefix + 'state',
                'id': paramPrefix + id,
                'class': this.stateClass,
                required: 'required'
            }).appendTo(stateDivObj);
            statesData.forEach(function (item) {
                $('<option>').attr({
                    'value': item.value
                }).html(item.label).appendTo('#' + paramPrefix + id);
            });

            var options = {
                "wcMenuClass": "wcSelectMenu",
            }
            var statesSelect = $("#" + paramPrefix + id).Select(options);
            statesSelect.val(currentState);
            statesSelect.Select("refresh_noResizeButton");

        } else {
            /* switch to state text input. */
            stateDivObj.appendChild(this.createState(paramPrefix, currentState,
                id, required));
        }
    },

    /**
     * This function validates the address form independently from the order of the fields displayed on the form, i.e. independent from the locale.
     * A  hidden field named "fields" must be set in the jsp/jspf file that calls this method. The purpose of this hidden field is to set all the mandatory
     * input fields and the order of these fields displayed on each locale-specific address entry page, so that this method knows which input
     * fields to validate and in which order it should validate them.
     *
     * assumptions:
     **1. Mandatory fields use UPPER CASE, non-mandatory fields use lower case.
     **2. The error messages used in this method are declared in the
     * jsp/jspf files that call this method.
     *
     * @param {string} form: The name of the address form obtained from the page containing address input fields.
     * @param {string} prefix: The value is set to shipping or billing.
     * @return {boolean} return: true if no error was found, or the hidden field "fields" were not set in the jsp/jspf file that calls this
     * method, return false if form could not be found, or if there was  an error validating a particular field.
     */
    validateAddressForm: function (form, prefix) {
        reWhiteSpace = new RegExp(/^\s+$/);
        if (prefix == null) {
            prefix = ""
        };
        if (prefix) {
            this.setStateDivName(prefix + "stateDiv")
        };

        if (form != null) {
            var fieldsOrderByLocaleInput = $(form).find("input[id^='AddressForm_FieldsOrderByLocale']");
            if (fieldsOrderByLocaleInput.length>0){
                $(fieldsOrderByLocaleInput).attr("id","AddressForm_FieldsOrderByLocale");
            }

            var fields = "";
            /** The hidden field "AddressForm_FieldsOrderByLocale" is to set all the mandatory fields AND the order of the fields
            *   that are going to be displayed in each locale-dependent address form, so that the JavaScript
            *   used for validation knows which fields to validate and in which order it should validate them. **/
            if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
            	fields = document.getElementById("AddressForm_PickUp").value.split(",");
            }else{
            	if (form["UserDetailsForm_FieldsOrderByLocale"] != null
                        && form["UserDetailsForm_FieldsOrderByLocale"].value != null
                        && form["UserDetailsForm_FieldsOrderByLocale"].value != "") {
                            fields = form["UserDetailsForm_FieldsOrderByLocale"].value.split(",");
                    }
                    else if (form["UserAddressForm_FieldsOrderByLocale"] != null
                        && form["UserAddressForm_FieldsOrderByLocale"].value != null
                        && form["UserAddressForm_FieldsOrderByLocale"].value != "") {
                            fields = form["UserAddressForm_FieldsOrderByLocale"].value.split(",");
                    }
                    else if (form[prefix + "AddressForm_FieldsOrderByLocale"] != null
                        && form[prefix + "AddressForm_FieldsOrderByLocale"].value != null
                        && form[prefix + "AddressForm_FieldsOrderByLocale"].value != "") {
                            fields = form[prefix + "AddressForm_FieldsOrderByLocale"].value.split(",");
                    }
                    else if (form["AddressForm_FieldsOrderByLocale"] != null
                          && form["AddressForm_FieldsOrderByLocale"].value != null
                          && form["AddressForm_FieldsOrderByLocale"].value != "") {
                            fields = form["AddressForm_FieldsOrderByLocale"].value.split(",");
                    }
                    else if (document.getElementById("AddressForm_FieldsOrderByLocale").value != null
                          && document.getElementById("AddressForm_FieldsOrderByLocale").value != "") {
                            fields = document.getElementById("AddressForm_FieldsOrderByLocale").value.split(",");
                    }
            }
            

            var nickName = prefix + "nickName";
            var lastName = prefix + "lastName";
            var firstName = prefix + "firstName";
            var middleName = prefix + "middleName";
            var address1 = prefix + "address1";
            var address2 = prefix + "address2";
            var address3 = prefix + "address3";
            var city = prefix + "city";
            var state = prefix + "state";
            var country = prefix + "country";
            var zipCode = prefix + "zipCode";
            var email1 = prefix + "email1";
            var phone1 = prefix + "phone1";
            var cpf = prefix + "fax1";
            var neighborhood = prefix + "fax2";
            var birth_date = prefix + "birth_date";
            var birth_month = prefix + "birth_month";
            var birth_year = prefix + "birth_year";

            var isValid = true;
            for (var i = 0; i < fields.length; i++) {
                var field = fields[i];
                //console.log("PSL::"+field);
                if (field == "NICK_NAME" || field == "nick_name") {
                    if (form[nickName] != null) {
                        form[nickName].value = trim(form[nickName].value);
                        if (field == "NICK_NAME" && (form[nickName].value == "" || reWhiteSpace.test(form[nickName].value))) {
                            this.manageMultipleEmptyFields(form[nickName], MessageHelper.messages["ERROR_RecipientEmpty"], false);
                            isValid = false;
                        } else {
                            //delete error Message
                            this.manageMultipleEmptyFields(form[nickName], MessageHelper.messages["ERROR_RecipientEmpty"], true);
                        }
                        if (!MessageHelper.isValidUTF8length(form[nickName].value, 254)) {
                            MessageHelper.formErrorHandleClient( form.nickName.id, MessageHelper.messages["ERROR_RecipientTooLong"]);
                            //tealiumPushFormError(MessageHelper.messages["ERROR_RecipientTooLong"]);
                            isValid = false;
                        }
                    }
                } else if (field == "LAST_NAME" || field == "last_name") {
                    if ($(form[lastName]).attr("disabled") == undefined){
                        form[lastName].value = trim(form[lastName].value);
                        xss = new RegExp(".*[%<>&;'\0-].*");
                        if (field == "LAST_NAME" && (form[lastName].value == "" || reWhiteSpace.test(form[lastName].value))) {
                            this.manageMultipleEmptyFields(form[lastName], MessageHelper.messages["ERROR_LastNameEmpty"], false);
                            this.removeSuccesIcon(form.lastName);
                            isValid = false;
                        } else if(xss.test(form[lastName].value)){
                            this.manageMultipleEmptyFields(form[lastName],MessageHelper.messages["ERROR_LastNameEmpty"], false);
                            this.removeSuccesIcon(form.lastName);
                            isValid = false;
                        }else {
                            //delete error Message
                            this.manageMultipleEmptyFields(form[lastName], "", true);
                            this.validateNotEmpty(form.lastName,true);
                        }
                    }
                    if (!MessageHelper.isValidUTF8length(form[lastName].value, 128)) {
                        MessageHelper.formErrorHandleClient(form[lastName].id,MessageHelper.messages["ERROR_LastNameTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_LastNameTooLong"]);
                        isValid = false;
                    }
                } else if (field == "FIRST_NAME" || field == "first_name") {
                    if ($(form[firstName]).attr("disabled") == undefined){
                        form[firstName].value = trim(form[firstName].value);
                        xss = new RegExp(".*[%<>&;'\0-].*");
                        if (form[firstName].value == "" || reWhiteSpace.test(form[firstName].value)) {
                            this.manageMultipleEmptyFields(form[firstName],MessageHelper.messages["ERROR_FirstNameEmpty"], false);
                            this.removeSuccesIcon(form.firstName);
                            isValid = false;
                        }else if(xss.test(form[firstName].value)){
                        		this.manageMultipleEmptyFields(form[firstName],MessageHelper.messages["ERROR_FirstNameEmpty"], false);
                                this.removeSuccesIcon(form.firstName);
                                isValid = false;
                          } else {
                            //delete error Message
                            this.manageMultipleEmptyFields(form[firstName],MessageHelper.messages["ERROR_FirstNameEmpty"], true);
                            this.validateNotEmpty(form.firstName,true);
                        }
                    }
                    if (!MessageHelper.isValidUTF8length(form[firstName].value,128)) {
                        MessageHelper.formErrorHandleClient(form[firstName].id,MessageHelper.messages["ERROR_FirstNameTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_FirstNameTooLong"]);
                        isValid = false;
                    }
                } else if (field == "MIDDLE_NAME" || field == "middle_name") {
                    form[middleName].value = trim(form[middleName].value);
                    if (field == "MIDDLE_NAME" && (form[middleName].value == "" || reWhiteSpace.test(form[middleName].value))) {
                        this.manageMultipleEmptyFields(form[middleName],MessageHelper.messages["ERROR_MiddleNameEmpty"], false);
                        isValid = false;
                    } else {
                        //delete error Message
                        this.manageMultipleEmptyFields(form[middleName],MessageHelper.messages["ERROR_MiddleNameEmpty"], true);
                    }
                    if (!MessageHelper.isValidUTF8length(form[middleName].value, 128)) {
                        MessageHelper.formErrorHandleClient(form[middleName].id,MessageHelper.messages["ERROR_MiddleNameTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_MiddleNameTooLong"]);
                        isValid = false;
                    }
                } else if (field == "use_org_address" || field == 'new_line' || field == "PASSWORD" || field == "PASSWORD_VERIFY") {
                } else if (field == "ADDRESS" || field == "address") {
                    form[address1].value = trim(form[address1].value);
                    xss = new RegExp(".*[%<>&;'\0].*"); 
                    if (field == "ADDRESS" && (form[address1].value == "" || reWhiteSpace.test(form[address1].value))) {
                        this.manageMultipleEmptyFields(form[address1],MessageHelper.messages["ERROR_AddressEmpty"], false);
                        this.removeSuccesIcon(form.address1);
                        isValid = false;
                    } /*else if(xss.test(form[address1].value)){
                        this.manageMultipleEmptyFields(form[address1],MessageHelper.messages["ERROR_AddressEmpty"], false);
                        this.removeSuccesIcon(form.address1);
                        isValid = false;
                    }*/else {
                        //delete error Message
                        this.manageMultipleEmptyFields(form[address1],MessageHelper.messages["ERROR_AddressEmpty"], true);
                    }
                    if (!MessageHelper.isValidUTF8length(form[address1].value,100)) {
                        MessageHelper.formErrorHandleClient(form[address1].id,MessageHelper.messages["ERROR_AddressTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_AddressTooLong"]);
                        isValid = false;
                    }
                } else if (field == "ZIP" || field == "zip") {
                   var isMandatory = field == "ZIP";
                   if(zipCodeError){
                       isValid= false;
                   }
                   if (!this.validateZipCodeFormField(form[zipCode], isMandatory)){
                       isValid = false;
                   }

                } else if (field == "CITY" || field == "city") {
                    form[city].value = trim(form[city].value);
                    if (field == "CITY" && (form[city].value == "" || reWhiteSpace.test(form[city].value))) {
                        this.manageMultipleEmptyFields(form[city],MessageHelper.messages["ERROR_CityEmpty"], false);
                        this.removeSuccesIcon(form.city);
                            isValid = false;
                    } else {
                        //delete error Message
                        this.manageMultipleEmptyFields(form[city],MessageHelper.messages["ERROR_CityEmpty"], true);
                        }
                    if (!MessageHelper.isValidUTF8length(form[city].value, 128)) {
                        MessageHelper.formErrorHandleClient(form[city].id,MessageHelper.messages["ERROR_CityTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_CityTooLong"]);
                        isValid = false;
                    }
                } else if ((field == "STATE/PROVINCE" || field == "state/province") && form.action.indexOf("PersonChangeServiceAddressAdd") == -1) {
                    state = form[state];
                    if (state == null || state == "") {
                        state = document.getElementById(this.stateDivName).firstElementChild;
                    }

                   
                    if(state.value==""){
                        var stateProvince = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1');
                        state.value = trim(stateProvince.value);
                    }
                    if (state.value != undefined) {
                        state.value = trim(state.value);
                    }
                    if (field == "STATE/PROVINCE" && (state.value == null || state.value == "" || reWhiteSpace.test(state.value))) {
                        this.manageMultipleEmptyFields(state, MessageHelper.messages["ERROR_StateEmpty"], false);
                        isValid = false;
                    } else {
                        //delete error Message
                        this.manageMultipleEmptyFields(state, MessageHelper.messages["ERROR_StateEmpty"], true);
                    }
                    if (!MessageHelper.isValidUTF8length(state.value, 128)) {
                        if (state.tagName == "INPUT" || state.tagName == "input") {
                            MessageHelper.formErrorHandleClient(state.id + "-button", MessageHelper.messages["ERROR_StateTooLong"]);
                        } else {
                            MessageHelper.formErrorHandleClient(state.id, MessageHelper.messages["ERROR _StateTooLong"]);
                        }
                        //tealiumPushFormError(MessageHelper.messages["ERROR_StateTooLong"]);
                        isValid = false;
                    }
                } else if (field == "COUNTRY/REGION" || field == "country/region") {
                    form[country].value = trim(form[country].value);
                    // if (field == "COUNTRY/REGION" && (form[country].value == "" || reWhiteSpace.test(form[country].value)) || !this.isSameCountryAsStore) {
                    if (form[country].value == "" || reWhiteSpace.test(form[country].value)) {
                        this.manageMultipleEmptyFields(form[country], MessageHelper.messages["ERROR_CountryEmpty"], false);
                        isValid = false;
                    } else {
                        //delete error Message
                        this.manageMultipleEmptyFields(form[country], MessageHelper.messages["ERROR_CountryEmpty"], true)
                    }
                    if (!MessageHelper.isValidUTF8length(form[country].value, 128)) {
                        MessageHelper.formErrorHandleClient(form[country].id + "-button", MessageHelper.messages["ERROR_CountryTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_CountryTooLong"]);
                        isValid = false;
                    }
                } else if (field == "EMAIL1" || field == "email1") {
                    if  (form.name !== "Register" && form.action.indexOf("PersonChangeServiceAddressAdd") == -1){
                        var isMandatory = field == "EMAIL1";
                        if (!this.validateEmailFormField(form.email1, isMandatory)){
                            isValid = false;
                        }
                    }
                } else if ((field == "PHONE1" || field == "phone1") && (form.id.includes("shipping") || form.id.includes("billing") ||form.id.includes("recipient"))) {
                    var isMandatory = field == "PHONE1";
                    if (!this.validatePhoneNumberFormField(form.phone1, isMandatory)){
                        isValid = false;
                    }
                } else if (field == "CODICE_FISCALE" || field == "codice_fiscale") {
                    var isMandatory = field == "CODICE_FISCALE";
                    //codice fiscale is stored in the custom address field 1
                    if (!this.validateCodiceFiscaleFormField(form.addressField1, isMandatory)){
                        isValid = false;
                    }
                } else if ((field == "NUMERO" || field == "numero")){
                    var formField = form[address2];
                    var formFieldValue = trim(formField.value);
                    var isEmpty = (formFieldValue == "" || reWhiteSpace.test(formFieldValue));
                    if ((field == "NUMERO") && (isEmpty)) {
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_NUMERO_Empty"], false);
                        isValid = false;
                        console.error("Form validation error: NUMERO field empty.NEEDS COMPLETITION");
                    } else {
                        //delete error Messages
                        this.manageMultipleErrorFields(formField, "", true);
                    }
                } else if ((field == "COMPLEMENTO" || field == "complemento")){
                    var formField = form[address3];
                    var formFieldValue = trim(formField.value);
                    var isEmpty = (formFieldValue == "" || reWhiteSpace.test(formFieldValue));
                    if ((field == "COMPLEMENTO") && (isEmpty)) {
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_COMPLEMENTO_Empty"], false);
                        isValid = false;
                        console.error("Form validation error: COMPLEMENTO field empty.NEEDS COMPLETITION");
                    } else  {
                        //delete error Messages
                        this.manageMultipleErrorFields(formField, "", true);
                    }
                } else if ((field == "NEIGHBORHOOD" || field == "neighborhood")){
                    var formField = form[neighborhood];
                    var formFieldValue = trim(formField.value);
                    var isEmpty = (formFieldValue == "" || reWhiteSpace.test(formFieldValue));
                    if ((field == "NEIGHBORHOOD") && (isEmpty)) {
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_NEIGHBORHOOD_Empty"], false);
                        isValid = false;
                        console.error("Form validation error: NEIGHBORHOOD field empty.NEEDS COMPLETITION");
                    } else {
                        //delete error Messages
                        this.manageMultipleErrorFields(formField, "", true);
                    }
                } else if ((field == "CPF" || field == "cpf")){
                    var formField = form[cpf];
                    var formFieldValue = trim(formField.value);
                    var isEmpty = (formFieldValue == "" || reWhiteSpace.test(formFieldValue));
                    if ((field == "CPF") && (isEmpty)) {
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_CPF_Empty"], false);
                        isValid = false;
                        console.error("Form validation error: cpf field empty.NEEDS COMPLETITION");
                    }
                    else if(!(validateCPFCNPJ(formField, false))){
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_CPF_Invalid"], false);
                        isValid = false;
                        console.error("Form validation error: cpf field not valid");
                    } else {
                        this.manageMultipleErrorFields(formField, "", true);
                    }
                } else if ((field == "DATEOFBIRTH" || field == "dateofbirth") && $('.checkout-quick-register .dob').length == 0){
                    var formField = document.getElementsByClassName("dob__content")[0];

                    if ($(formField).parent().attr("disabled") == undefined){
                        // var formField = form[birth_date];
                        var birthdate = trim(form[birth_date].value);
                        var birthmonth = trim(form[birth_month].value);
                        var birthyear = trim(form[birth_year].value);


                        var isEmpty =  false;
                        if (  (birthdate == "" || reWhiteSpace.test(birthdate))
                            ||(birthmonth == "" || reWhiteSpace.test(birthmonth))
                            ||(birthyear == "" || reWhiteSpace.test(birthyear)) ){
                                isEmpty = true;
                        };

                        if (isEmpty) {
                            isValid = false;
                            this.manageFormErrorMessageFields(formField, MessageHelper.messages["ERROR_BIRTHDATE_Empty"]);
                        }
                        else if (!this.validateAge(birthyear)){
                            isValid = false;
                            this.manageFormErrorMessageFields(formField, MessageHelper.messages["ERROR_BIRTHDATE_Invalid"]);
                        }
                    }

                    else {
                        //delete error Messages
                        // this.manageFormErrorFields(formField, "");
                        this.deleteFormErrorMessageFields(formField);
                    }
                }
            } //end for loop

            if (!isValid) {
                $("body").scrollTop(0);

                //this if prevents js error if WCAG.js are not imported
                if(typeof moveToError === 'function'){
                    moveToError();
                }
                restoreAjaxButtons();
                return false;
            }

            return true;
        }
        // /The form is null so..
        return false;
    },
    ////************************************************************************************************* */

/**
 * Function to validate that the register user is older than 18
 * @param {*} form
 */
    validateAge: function(birthYear){
        var isValidAge=true;
        var currentYear = new Date().getFullYear();
        if (isGDPR){
            if (currentYear-birthYear<16){
                isValidAge = false;
            }
        }else if (isCarol){
            if (currentYear-birthYear<18){
                isValidAge = false;
            }
        }
        return isValidAge;
    },

    createFormErrorMessageField: function (fieldID, errorMsg) {
    //If the error message does not exist, sets a generic error message.
        // if (typeof errorMsg === 'undefined' || errorMsg == null || errorMsg == "") {
        //     errorMsg = MessageHelper.messages["ADDR_MANDATORY_FIELD"];
        // }
    //Otherwise, creates a new div to display the error message
        var errorMessageField = document.createElement('div');
        errorMessageField.setAttribute("class", "address-erros-message-cont error-message-wrapper");
        errorMessageField.innerHTML = '<span tabindex="0" id="errorMessageFieldFor_' + fieldID + '" class="error-message form-error-message wcag__error">' + errorMsg + '</span>';

        return errorMessageField;
    },

/**
 * Manage multiple address form error messages for each concerned field.
 */
    manageFormErrorMessageFields: function (field, errorMsg) {


            this.deleteFormErrorMessageFields(field);
            var errorMessageField = this.createFormErrorMessageField(field.id, errorMsg);
            $(field).addClass("field-error-message inputField--invalid");
            field.parentNode.appendChild(errorMessageField);






            //Prevents js error if WCAG.js is not imported
            if(typeof moveToError === 'function'){
                moveToError();
            }

            //Tealium filling form Errors
            //if (typeof tealiumPushFormError !== "undefined" ) {
                //tealiumPushFormError(errorMsg);
                //tealiumPushFormError(errorMsg);
            //}
    }, 

    /**
     * Deletes the error message if the field is not empty anymore.
     * @param {*} field
     */
    deleteFormErrorMessageFields: function (field){
        $("#"+field.id).parent().find(".address-erros-message-cont").remove();
        $("#"+field.id).parent().find(".error-message-wrapper").remove();
    },

    ////************************************************************************************************* */



    /**
     * mandatory field shown when one or multiple empty fields in forms
     */
    getMandatoryField: function (parentID, errorMsg, isNotEmpty) {
    //If the error message does not exist, sets a generic error message.
        if (typeof errorMsg === 'undefined' || errorMsg == null || errorMsg == "") {
            errorMsg = MessageHelper.messages["ADDR_MANDATORY_FIELD"];
        }
    //Otherwise, creates a new div to display the error message
        var mandatoryField = document.createElement('div');
        mandatoryField.setAttribute("class", "address-erros-message-cont");
        mandatoryField.innerHTML = '<span tabindex="0" id="mandatoryField_' + parentID + '" class="error-message wcag__error">' + errorMsg + '</span>';

        return mandatoryField;
    },
    /**
      * manage multiple address form empty fields add Error message for each
      * concerned field
     */
    manageMultipleEmptyFields: function (field, errorMsg, isNotEmpty) {

        var mandatoryErrorFieldId = "mandatoryField_" + field.id;

        // delete error message if field is no more empty
        var currentField = document.getElementById(mandatoryErrorFieldId);
        if (currentField != null) {
            $(field).removeClass("field-error-message");
            if (currentField.parentNode != null && currentField.parentNode.className != undefined && currentField.parentNode.className.indexOf("address-erros-message-cont") >= 0) {
                $(currentField.parentNode).remove();
            } else {
                currentField.remove();
            }
        }

        if (!isNotEmpty) {
            if (!document.getElementById(mandatoryErrorFieldId)) {
                var mandatoryField = this.getMandatoryField(field.id, errorMsg, isNotEmpty);
                if (field != null && field.parentNode != null) {
                    $(field).addClass("field-error-message");
                    // if (!isOliver && field.name != undefined && field.name.toLocaleLowerCase().indexOf('address') >= 0) {
                    //     field.after(mandatoryField);
                    // } else {
                    //     field.parentNode.appendChild(mandatoryField);
                    // }
                    if(isVogue && field.name != 'state' ){//pre modifica ||(isPersol && field.name == 'address1' && $('.myAccountSummary').length == 0) 
                        field.insertAdjacentElement('afterend', mandatoryField);
                    } else {
                        field.parentNode.insertAdjacentElement('beforeend', mandatoryField);
                    }
                    //Tealium filling form Errors
                    //tealiumPushFormError(errorMsg);
                }
            }
        }

    },


    manageMultipleErrorFields: function (field, errorMsg, isNotEmpty) {
        //Sets the field that the error will be associated to.
        var mandatoryErrorFieldId = 'mandatoryField_' + field.id;

        // Deletes the error message if the field is not empty anymore.
        if (isNotEmpty) {
            var currentField = document.getElementById(mandatoryErrorFieldId);
            if (currentField != null) {
                $(field).removeClass("field-error-message");
                currentField.remove();
            }
        } else {
            if (!document.getElementById(mandatoryErrorFieldId)) {
                var mandatoryField = this.getMandatoryField(field.id, errorMsg, isNotEmpty);
                if (field != null && field.parentNode != null) {
                    $(field).addClass("field-error-message");
                    // field.parentNode.appendChild(mandatoryField);
                    field.parentNode.insertAdjacentElement('beforeend', mandatoryField);

                    //this if prevents js error if WCAG.js are not imported
                    if(typeof moveToError === 'function'){
                        moveToError();
                    }

                    //Tealium filling form Errors
                    //if (typeof tealiumPushFormError !== "undefined" ) {
                        //tealiumPushFormError(errorMsg);
                    //}
                }
            }
        }

    },

    /**
     *
     * @param {*} formName Controls if the field is still empty
     */
    isEmpty: function (formField){
        if (formField.value == "" || reWhiteSpace.test(formField.value)){
            return true;
        }
        else{
            this.manageMultipleErrorFields(formField, "", true);
            return false;
        }
    },


    /* NEW */
    validateZipCodeFormField: function(formField, isMandatory){
        this.removeFieldErrorMessages(formField);
        var formFieldValue = trim(formField.value.toUpperCase());
        var isEmpty = formFieldValue == "";
        var isValid = true;

        if (isEmpty && isMandatory) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_ZipCodeEmpty"]);       
            //if(typeof arguments.callee.caller.caller.name !== 'undefined' && arguments.callee.caller.caller.name == 'goToOrderPaymentViewOnClickHandler')
                //tealiumPushFormError(MessageHelper.messages["ERROR_ZipCodeEmpty"]);
        } else if (!MessageHelper.isValidUTF8length(formFieldValue,40)) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_ZipCodeTooLong"]); 
            //if(typeof arguments.callee.caller.caller.name !== 'undefined' && arguments.callee.caller.caller.name == 'goToOrderPaymentViewOnClickHandler')
                //tealiumPushFormError(MessageHelper.messages["ERROR_ZipCodeTooLong"]);
        } else if (!isEmpty) {
            var zipCodeRegexp = this.getZipCodeRegexpForCurrentCountryCode();
            if (!zipCodeRegexp.test(formFieldValue)){
                isValid = false;
                this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_ZipCodeInvalid"]);
                //BEGIN HB-10030 - when the call is from goToOrderPaymentViewOnClickHandler
                //if(typeof arguments.callee.caller.caller.name !== 'undefined' && arguments.callee.caller.caller.name == 'goToOrderPaymentViewOnClickHandler')
                    //tealiumPushFormError(MessageHelper.messages["ERROR_ZipCodeInvalid"]);
                //END HB-10030
            }
        }
        if (!isValid) {
            isValid = false;
        } else if (!isEmpty) {
            //We check if the country is the same as in the store
            if (this.storeCountry == 'UK') {
                this.storeCountry = 'GB';
            }
            this.isSameCountryAsStore = (this.storeCountry === countryCode);

            this.autofillFormAddressFromZipCode(formField);

            if (this.hasTaxes && formField.form.name.includes("shipping")) {
                CheckoutHelperJS.calculateTaxesFromZipCode(formField);
            }
            isValid = true;
        }
        if(isValid){
            this.addSuccesIcon(formField);
            setTimeout(function() { 
               AddressHelper.showHiddenField(formField);
            }, 500);   
            
        }
        this.removeSuccesIcon(formField);
        return isValid;
    },

    validatePhoneNumberFormField: function(formField, isMandatory){
        var formFieldValue = trim(formField.value);
        var isEmpty = formFieldValue == "";
        var phoneNumber = formFieldValue;
        var isValid = true;

        function isCybersourceValidPhoneNumber(phone){
            var isValid = true;
            var digits = "0123456789";
            var digitsCount = 0;
            var validCharsRegexp = /[a-zA-Z0-9\-\(\)\+\,\*\.\#\/\s]/g;

            for (var i = 0; i < phone.length; i++) {
                if (digits.includes(phone[i])){
                    digitsCount++;
                }
            }

            if (digitsCount<6 || digitsCount>32 || phone.match(validCharsRegexp).length != phone.length){
                isValid = false;
            }
            
        
            return isValid;
        }

        function parsePhoneNumberSAP(phone){
            var invalidCharsSAP = "-;/+";
            var parsedPhoneNumber = "";
            for (var i = 0; i < phone.length; i++) {
                var element = phone[i];
                if (invalidCharsSAP.includes(element)){
                    parsedPhoneNumber += " ";
                } else {
                    parsedPhoneNumber += element;
                }
            }
            return parsedPhoneNumber;
        }

        this.removeFieldErrorMessages(formField);
        if (isMandatory && isEmpty) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_PhonenumberEmpty"]);
        } else if (!isCybersourceValidPhoneNumber(phoneNumber)){
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_PhoneFormatNotValid"]);
            //tealiumPushFormError(MessageHelper.messages["ERROR_PhoneFormatNotValid"]);
        } else {
            formField.value = parsePhoneNumberSAP(phoneNumber);
        }
        if (isValid){
            this.addSuccesIcon(formField);
            return true;
        }

        this.removeSuccesIcon(formField);
        return false;
    },

    validateEmailFormField: function(formField, isMandatory) {
        //var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@(([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})$/;
        this.removeFieldErrorMessages(formField);
        var formFieldValue = trim(formField.value);
        var isEmpty = formFieldValue == "";
        var isValid = true;

        this.removeFieldErrorMessages(formField);
        $(formField).next().removeClass('labelOnTop');
        if (isEmpty && isMandatory) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_EmailEmpty"]);
        } else if (!MessageHelper.isValidUTF8length(formFieldValue,256)) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_EmailTooLong"]);
            //tealiumPushFormError(MessageHelper.messages["ERROR_EmailTooLong"]);
        } else if (!emailRegexp.test(formFieldValue)) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]);
            //tealiumPushFormError(MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]);
        } else {
            //We have to clear input's email value before setting it again because of
            //the "special" behavior of the <input type="email"> tag containing spaces
            formField.value = "";
            formField.value = formFieldValue;
        }

        if (isValid) {
            this.addSuccesIcon(formField);
            return true;
        }else if(!isEmpty){
            $(formField).next().addClass('labelOnTop');//class that block label on top when the email is invalid and not empty
        }

        this.removeSuccesIcon(formField);
        return false;
    },

    validateCodiceFiscaleFormField: function(formField, isMandatory) {

        var codiceFiscaleRegexp = new RegExp(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i);

        this.removeFieldErrorMessages(formField);
        var formFieldValue = trim(formField.value);
        var isEmpty = formFieldValue == "";
        var isValid = true;

        if (isEmpty && isMandatory) {
            isValid = false;
            this.addFieldErrorMessage(formField, "Codice fiscale mandatory and empty"/*MessageHelper.messages["ERROR_EmailEmpty"]*/);
        } else if (!MessageHelper.isValidUTF8length(formFieldValue,256)) {
            isValid = false;
            this.addFieldErrorMessage(formField, "Codice fiscale too long"/*MessageHelper.messages["ERROR_EmailTooLong"]*/);
            //tealiumPushFormError(MessageHelper.messages["ERROR_EmailTooLong"]);
        } else if (!isEmpty && !codiceFiscaleRegexp.test(formFieldValue)) {
            isValid = false;
            this.addFieldErrorMessage(formField, "Codice fiscale bad format"/*MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]*/);
            //tealiumPushFormError(MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]);
        } else {
            formField.value = "";
            formField.value = formFieldValue;
        }

        if (isValid) {
            return true;
        }
        return false;
    },
    showHiddenField : function(formField){
            if(formField.matches(":-webkit-autofill") || $(formField).is(".GoogleAutoFilled")){
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input").addClass("readonly");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input").each(function(index){$( this ).prop("readonly",true)})
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input + label").addClass("labelOnTop");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").addClass("notEditableForm");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").show();
            }else{
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input").removeClass("readonly");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide.prov").find("input").addClass("readonly");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").removeClass("notEditableForm");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide.cityfield").find("input").prop("readonly",false);               
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input + label").addClass("labelOnTop");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").show();
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input").trigger("change");
            }
            
         },
      
      
    validateNotEmpty : function (formField, isMandatory) {

        this.removeFieldErrorMessages(formField);
        var formFieldValue = trim(formField.value);
        var isEmpty = formFieldValue == "";
        var isValid = true;

        if (isEmpty && isMandatory) {
            isValid = false;
        }
        if (isValid) {


            this.addSuccesIcon(formField);
            
            return true;
        }
        this.removeSuccesIcon(formField);
        
       
        return false;


    },
   
    addFieldErrorMessage: function(formField, errorText){
        var errorContainerClassName = "address-field-error-messages--" + formField.form.name +"--"+ formField.name.toLowerCase();
        var errorMessageClassName = "address-field-error-message--"+formField.name;

        //Add class to the field in order to change its CSS
        $(formField).addClass("field-error-message");
        //Create error messages container if it does not exist already
        if ($("."+errorContainerClassName).length==0){
            $(formField).parent().append("<div class='" + errorContainerClassName + " error-message wcag__error' tabindex='0'></div>");
        }
        $("."+errorContainerClassName).append("<div class='"+errorMessageClassName+"'>"+errorText+"</div>");
    },

    removeFieldErrorMessages: function(formField){
        $(formField).removeClass("field-error-message");
        var errorContainerClassName = "address-field-error-messages--" + formField.form.name +"--"+ formField.name.toLowerCase();
        if ($("."+errorContainerClassName).length>0){
            $("."+errorContainerClassName).remove();
        }
    },

    /**
     * Returns data into shipping/billing form as JSON
     */
    getJSONContactDataFromAddressForm: function (formName) {
        var form = document.forms[formName];
        var dataArray = {};
        if (form.addressType != undefined) dataArray.addressType = form.addressType.value;
        if (form.nickName != undefined) dataArray.nickName = form.nickName.value;
        if (form.firstName != undefined) dataArray.firstName = form.firstName.value;
        if (form.lastName != undefined) dataArray.lastName = form.lastName.value;
        if (form.phone1 != undefined) dataArray.phone1 = form.phone1.value;
        if (form.email1 != undefined) dataArray.email1 = form.email1.value;
        dataArray.addressLine = ["", "", ""];
        if (form.address1 != undefined) dataArray.addressLine[0] = form.address1.value;
        if (form.address2 != undefined) dataArray.addressLine[1] = form.address2.value;
		if (form.address3 != undefined) dataArray.addressLine[2] = form.address3.value;
        if (form.zipCode != undefined) dataArray.zipCode = form.zipCode.value;
        if (form.city != undefined) dataArray.city = form.city.value;
        if (form.country != undefined) dataArray.country = form.country.value;
        if (form.state != undefined) dataArray.state = form.state.value;
        if (form.fax1 != undefined) dataArray.fax1 = form.fax1.value;
        if (form.fax2 != undefined) dataArray.fax2 = form.fax2.value;

        if (countryCode == "US" || countryCode == "CA"){
            //In US and Canada Address3 field will be set as ZIPCODE-STATE. E.g. 10507-NW
            dataArray.addressLine[2] = dataArray.zipCode + "-" + dataArray.state;
        } else {
            if (form.address3 != undefined) dataArray.addressLine[2] = form.address3.value;
        }

        return JSON.stringify(dataArray);
    },

    /**
     * This function saves the address entry form when a registered customer
     * wants to edit/add a new address during checkout from his/her shopping
     * cart.
     *
     * @param {string}
     *            The id of the service that was invoked, e.g.
     *            AjaxUpdateAddressForPerson, AjaxAddAddressForPerson, etc.
     * @param {string}
     *            The name of the form containing address information.
     * @param {string}
     *            The addressTypeIn being saved.
     */

    saveShopCartAddress: function (serviceId, formName, addressTypeIn) {
        var form = document.forms[formName];
        if (addressTypeIn == 'ShippingAndBilling' || addressTypeIn == 'Shipping') {
            if (serviceId == 'AjaxUpdateAddressForPerson') {
                serviceId = 'AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout';
            } else {
                serviceId = 'AjaxAddShippingAndBillingAddressForPersonDuringCheckout';
            }
        }
        if (this.validateAddressForm(form)) {
            this.saveAddress(serviceId, formName);
        }
    },

    /**
     *
     * @param {*} addressId
     * @param {*} addressType Accepted values are "S" for Shipping, "B" for Billing, and "SB" for ShippingBilling
     */
    updateAddressCookies: function(addressId, addressType){
        var error = false;

        if (typeof addressId !== 'undefined' && addressId != null
            && typeof addressType !== 'undefined' && addressType != null){

            if (addressType === "Billing") {
                setCookie("addressId_formB_" + storeDirectory, addressId, { path: "/", domain: cookieDomain });
            } else if (addressType === "Shipping") {
                setCookie("addressId_formS_" + storeDirectory, addressId, { path: "/", domain: cookieDomain });
            } else if (addressType === "ShippingAndBilling"){
                setCookie("addressId_formS_" + storeDirectory, addressId, { path: "/", domain: cookieDomain });
                setCookie("addressId_formB_" + storeDirectory, addressId, { path: "/", domain: cookieDomain });
            } else {
                error = true;
            }
        } else {
            error = true;
        }

        if (error){
            console.log("PSL::AddressHelper.js::updateAddressCookies::Invalid parameters: "
            + "addressType = " + addressType + ", "
            + "addressId = " + addressId);
        } else {
            console.log("PSL::AddressHelper.js::updateAddressCookies::Address cookies updated");
            addressId_formS = getCookie("addressId_formS_"+storeDirectory);
            addressId_formB = getCookie("addressId_formB_"+storeDirectory);
        }
    },

    /**
     *
     */
    initAddressCookies: function(){

        function logAddressErrors(shippingAddressType, billingAddressType){
            if ((shippingAddressType == "" && billingAddressType == "")
            ||(shippingAddressType == "SB" && billingAddressType == "")
            ||(shippingAddressType == "S" && billingAddressType == "B")) {
                plog("AddressHelper.js::initAddressCookies:: Address settings OK");
            } else {
                plog("AddressHelper.js::initAddressCookies:: Address settings KO");
            }
        }

        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
        $.ajax({
            method: "GET",
            url: url,
            headers: {
                "Content-Type": "application/json",
                "Cache-Control": "no-cache, no-store, must-revalidate"
            },
            dataType: "json",
            data: {
                "timestamp": Date.now()
            },
            success: function(data, textStatus, jqXHR){
                if (typeof data.contact === 'undefined'){
                    plog("AddressHelper.js::initAddressCookies::Address not found");
                } else {
                    for (var i = 0; i<data.contact.length; i++){
                        if (data.contact[i].nickName == 'MyAddress_Shipping' || data.contact[i].nickName == 'MyAddress_Billing'){
                            AddressHelper.updateAddressCookies(data.contact[i].addressId, data.contact[i].addressType);
                        }
                    }
                }
            },
            error: function(jqXHR, exception){
                plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
            },
            complete: function(){
            }
        });
    },

    /**
     *
     * @param storeId current store id
     * @param onSuccessURL if the update is ok, go to this url
     * @returns
     */
    updateUnregisteredCheckoutAddress: function (formName1, formName2, addressIdShipping, addressIdBilling, sameAddressChecked, onSuccessURL) {
        var form1 = document.forms[formName1];
        var form2 = document.forms[formName2];
        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";

        //We are here because the user came back to this page after address addition to database
        if (addressIdShipping == addressIdBilling) {
            //The address stored in the database is SB
            if (sameAddressChecked) {
                //Update current SB address
                form1.addressType.value = "ShippingAndBilling";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);
                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::SB address updated successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"ShippingAndBilling");
                        cursor_clear();
                        location.href = onSuccessURL; 

                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error updating SB address");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            } else {
                //Change current SB address to S and add billing address.
                form1.addressType.value = "Shipping";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);

                form2.addressType.value = "Billing";
                form2.nickName.value = "MyAddress_Billing";
                var jsonDataBilling = AddressHelper.getJSONContactDataFromAddressForm(formName2);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::SB address changed to S successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"Shipping");
                        cursor_clear();
                        $.ajax({
                            type: "POST",
                            url: url,
                            headers: {
                                "Content-Type": "application/json",
                                "Cache-Control": "no-cache, no-store, must-revalidate"
                            },
                            dataType: 'json',
                            data: jsonDataBilling,
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address added successfully");
                                AddressHelper.updateAddressCookies(msg.addressId,"Billing");
                                cursor_clear();
                                 location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error adding B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error changing SB address to S");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });
            }
        } else {
            //There are two different addresses in the database
            if (sameAddressChecked) {
                //Update current S address to SB and delete current billing address.
                form1.addressType.value = "ShippingAndBilling";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::S address changed to SB successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"ShippingAndBilling");
                        cursor_clear();
                        $.ajax({
                            type: "DELETE",
                            url: url + "/MyAddress_Billing",
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address deleted successfully");
                                cursor_clear();
                                location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error deleting B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error changing S address to SB");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            } else {
                //Update current S address and B address           	
                form1.nickName.value = "MyAddress_Shipping";
                form2.nickName.value = "MyAddress_Billing";
                form2.email1.value = form1.email1.value;
                if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup' && isOliver){
            		form1.addressType.value = "Shipping";
                    form2.addressType.value = "Billing";
                }

                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);
                var jsonDataBilling = AddressHelper.getJSONContactDataFromAddressForm(formName2);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::S address updated successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"Shipping");
                        cursor_clear();
                        $.ajax({
                            type: "PUT",
                            url: url + "/MyAddress_Billing",
                            headers: {
                                "Content-Type": "application/json",
                                "Cache-Control": "no-cache, no-store, must-revalidate"
                            },
                            dataType: 'json',
                            data: jsonDataBilling,
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address updated successfully");
                                AddressHelper.updateAddressCookies(msg.addressId,"Billing");
                                cursor_clear();
                                location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error updating B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error updating S address");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            }
        }
    },

    resetUnregisteredCheckoutAddressCookies: function () {
        setCookie("addressId_formS_" + storeDirectory, "unset", { path: "/", domain: cookieDomain });
        setCookie("addressId_formB_" + storeDirectory, "unset", { path: "/", domain: cookieDomain });
    },

    /**
     * This function saves the address entry form on an unregistered user's
     * checkout page.
     *
     * @param {string} formName1 The name of the billing address form.
     * @param {string} formName2 The name of the shipping address form.
     * @param {string} stateDivName1 The name of the state field in the billing address form.
     * @param {string} stateDivName2 The name of the state field in the shipping address form.
     */
    saveUnregisteredCheckoutAddress: function (formName1, formName2, stateDivName1, stateDivName2/*, buttonId, event*/) {
        var form1 = document.forms[formName1];
        var form2 = document.forms[formName2];

        console.log("PSL::AddressHelper.js::saveUnregisteredCheckoutAddress:: Valores iniciales:");
        console.log("PSL::AddressHelper.js::saveUnregisteredCheckoutAddress:: form1.nickName.value = " + form1.nickName.value);
        if (form2) {
            console.log("PSL::AddressHelper.js::saveUnregisteredCheckoutAddress:: form2.nickName.value = " + form2.nickName.value);
        }

        this.setStateDivName(stateDivName1);
        /* Validate form input fields */
        if (this.validateAddressForm(form1)) {
            var addressNickNameBase = "MyAddress_";
            var sameaddress = document.getElementById("SameShippingAndBillingAddress");

            if (!sameaddress || sameaddress.checked) {
                if (form1.nickName.value == undefined || form1.nickName.value == "") {
                    form1.nickName.value = addressNickNameBase + "Shipping";
                }

                form1.addressType.value = 'ShippingAndBilling';
                if (form1.addressId == undefined || form1.addressId.value === '') {
                    //$(buttonId).off(event);
                    console.log("PSL::AddressHelper.js::SameSBAddress, AddShippingAddress -> form1.nickName.value = " + form1.nickName.value);
                    this.saveAddressCheckoutGuest('AddShippingAddress', 'shippingAddressCreateEditFormDiv_1');
                }
                else {
                    //$(buttonId).off(event);
                    console.log("PSL::AddressHelper.js::SameSBAddress, UpdateShippingAddress -> form1.nickName.value = " + form1.nickName.value);
                    this.saveAddressCheckoutGuest('UpdateShippingAddress', 'shippingAddressCreateEditFormDiv_1');
                }

            }
            else {
                //var form2 = document.forms[formName2];
                if (form1.nickName.value == undefined || form1.nickName.value == "") {
                    form1.nickName.value = addressNickNameBase + "Shipping";
                }
                if (form2.nickName.value == undefined || form2.nickName.value == "") {
                    form2.nickName.value = addressNickNameBase + "Billing";
                }

                console.log("PSL::AddressHelper.js:: form1.nickName.value = " + form1.nickName.value);
                console.log("PSL::AddressHelper.js:: form2.nickName.value = " + form2.nickName.value);

                // Store form1 email as billing address email
                if(!isPersol && !isOliver){
                    form2.email1.value = form1.email1.value;
                }
                

                /* Validate form input fields */
                if (this.validateAddressForm(form2)) {
                    this.setStateDivName(stateDivName2);

                    /*
                     * Note that, when want to save different shipping and billing addresses, we only call AddBillingAddress,
                     * because AddShippingAddress will be called in the successHandler of the service AddBillingAddress
                     * declared in MyAccountServicesDeclaration.js
                     * This is the out-of-the-box behavior in AuroraStorefrontStore
                     */
                    if (form2.addressId == undefined || form2.addressId.value === '') {
                        //console.log("PSL::AddressHelper.js::Add billing address");
                        //$(buttonId).off(event);
                        if (form1.addressId != undefined && form2.addressId != undefined &&
                            form2.addressId.value == form1.addressId.value) {
                            form2.addressId.value = "";
                        }
                        console.log("PSL::AddressHelper.js::SameSBAddress, AddShippingAddress -> form1.nickName.value = " + form1.nickName.value);
                        this.saveAddressCheckoutGuest('AddBillingAddress', 'billingAddressCreateEditFormDiv_1');
                    }
                    else {
                        //$(buttonId).off(event);
                        console.log("PSL::AddressHelper.js::Update billing address");
                        this.saveAddressCheckoutGuest('UpdateBillingAddress', 'billingAddressCreateEditFormDiv_1');
                    }
                }
                else {
                    //FIXME
                    restoreAjaxButton("WC_UnregisteredCheckout_links_4");
                }
            }
        }
        else {
            //FIXME over only a form
            restoreAjaxButton("WC_UnregisteredCheckout_links_4");
        }
    },

    /**
     * This function saves an address entry form to the associated service.
     *
     * @param {string}
     *            serviceId The id of the service that was invoked, e.g.
     *            AjaxUpdateAddressForPerson, AjaxAddAddressForPerson, etc.
     * @param {string}
     *            formName The name of the form containing address information.
     */
    saveAddress: function (serviceId, formName) {
        var country = document.getElementById('country');
        if (country != null) {
            country.disabled = false;
        }
        var form = document.forms[formName];
        //		if (form.address1.value == "" && form.address2.value != "") {
        //			form.address1.value = form.address2.value;
        //			form.address2.value = "";
        //		}
        var addressService = wcService.getServiceById(serviceId);
        addressService.setFormId(formName);
        /* For Handling multiple clicks */

        // should migrate this solution to GlobalLoginActions.js to avoid
        // GlobalLoginJS.updateGlobalLoginUserDisplay("...");
        var header = document.getElementById("header");
        if (header == null || !this.hasClass(header, "checkout")) {
            if (!submitRequest()) {
                return;
            }
        }

        cursor_wait();
        wcService.invoke(serviceId);
    },

    ajaxSaveAddress: function (serviceId, formName) {
        // AjaxAddAddressForPerson or AjaxUpdateAddressForPerson
        resetRequest();
        var service = serviceId;
        var country = document.getElementById('country');
        if (country != null) {
            country.disabled = false;
        }
        var form = document.forms[formName];
        if(!this.validateAddressForm(form)) {

            return false;
        } else {
            var dialog = $("#addEditAddressPopup").data("wc-WCDialog");
            if (dialog) {
                dialog.close();
                $("#addEditAddressPopup").css("display", "none");
            }

        }
        if (form.addressId != undefined && form.addressId.value != '') {
            service = 'AjaxUpdateAddressForPerson';
            form.nickName.remove();
        }
        if (form.nickName && form.nickName.value == '') {
            form.nickName.value = new Date().getTime();
        }

        var addressService = wcService.getServiceById(service);
        addressService.setFormId(formName);
        /* For Handling multiple clicks */
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke(service);
    },

    /**
     * This function saves an address entry form to the associated service only
     * in the ShippingAndBilling screen in checkout as a Guest.
     *
     * @param {string} serviceId The id of the service that was invoked, e.g. AjaxUpdateAddressForPerson, AjaxAddAddressForPerson, etc.
     * @param {string} formName The name of the form containing address information.
     */
    saveAddressCheckoutGuest: function (serviceId, formName) {
        var country = document.getElementById('country');
        if (country != null) {
            country.disabled = false;
        }
        var form = document.forms[formName];
        var addressService = wcService.getServiceById(serviceId);
        addressService.setFormId(formName);

        cursor_wait();
        wcService.invoke(serviceId);
    },

    hasClass: function (element, inputClass) {
        return (" " + element.className + " ").indexOf(" " + inputClass + " ") > -1;
    },

    /**
     * This function calls UpdateOrderItem/AjaxUpdateOrderItem service to update
     * order calculation
     */
    updateOrderAfterAddressUpdate: function () {
        var params = {
            storeId: ServicesDeclarationJS.storeId,
            catalogId: ServicesDeclarationJS.catalogId,
            langId: ServicesDeclarationJS.langId
        };
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";
        params.orderId = ".";

        cursor_wait();
        //wcService.invoke("AjaxUpdateOrderAfterAddressUpdate", params);
    },

    /**
     * This function populates the country code to mobile phone based on the
     * selected country.
     *
     * @param {string} countryDropDownId The id of the mobile country drop down list
     * @param {string} countryCallingCodeId The id of the mobile country calling code  text box.
     */
    loadCountryCode: function (countryDropDownId, countryCallingCodeId) {
        this.getCountryArray();
        var countryCode = $("#" + countryDropDownId).val()
        if (countryCode === undefined || countryCode === null)
        // we are using wc.Select
        {
            var countryDropDownWidget = $("#" + countryDropDownId);
            if (countryDropDownWidget !== undefined
                && countryDropDownWidget !== null) {
                countryCode = countryDropDownWidget.val();
            }
        }
        $("#" + countryCallingCodeId).val(
            countries[countryCode].countryCallingCode);
    },

    /**
     * This function checks for an entry in the Mobile Phone Number field. If a
     * Mobile Phone number has been entered, it enables the SMS
     * Notifications/Promotions checkbox, else it disables the SMS
     * Notifications/Promotions checkbox.
     *
     * @param {string} form The name of the form containing the Mobile Phone Number entry field.
     * @param {string} jspStoreImgDir The directory for images
     */
    enableSMSNotifications: function (form, jspStoreImgDir) {
        var form = document.forms[form];
        if (form.mobilePhone1.value !== "") {
            form.sendMeSMSNotification.disabled = false;
            form.sendMeSMSPreference.disabled = false;
            $(".checkedCheckBox.mobileOption").removeClass("disabled").attr(
                "tabindex", "0");
        } else {
            form.sendMeSMSNotification.disabled = true;
            form.sendMeSMSPreference.disabled = true;
            form.sendMeSMSNotification.checked = false;
            form.sendMeSMSPreference.checked = false;
            $(".checkedCheckBox.mobileOption").addClass("disabled").attr(
                "tabindex", "-1").removeClass("checked").attr(
                    "aria-checked", "false").attr("src",
                        jspStoreImgDir + "images/checkbox.png");
        }
    },


    /**
     * Sets the address type when a user wants to add a new address of type
     * shipping and billing during order check out.
     *
     * @param {Object}: checkbox The HTML checkbox input object.
     * @param {Object}: form The form that includes the new address information.
     */
    setAddressTypeInCreatingNewAddressDuringCheckout: function (checkbox, form) {
        if (form.addressType != null && form.originalAddressType != null) {
            if (checkbox.checked) {
                form.addressType.value = 'ShippingAndBilling';
            } else {
                form.addressType.value = form.originalAddressType.value;
            }
        }
    },

    /**
     * Set checkbox state to true when checked and false when unchecked
     *
     * @param String jspStoreImgDir The directory for store images.
     * @param String checkbox The checkbox element.
     * @param String checkboxImg The checkbox image element.
     * @param String checkedValue The value of the input when checked.
     * @param String uncheckedValue The value of the input when unchecked.
     */
    changeCheckboxState: function (jspStoreImgDir, checkbox, checkboxImg, checkedValue, uncheckedValue) {
        var $checkboxImg = $("#" + checkboxImg), $checkbox = $("#" + checkbox);
        if (!$checkboxImg.hasClass("disabled")) {
            if ($checkboxImg.hasClass("checked")) {
                $checkboxImg.removeClass("checked");
                $checkboxImg.attr("aria-checked", "false");
                $checkboxImg
                    .attr("src", jspStoreImgDir + "images/checkbox.png");
                $checkbox.attr("value", uncheckedValue);
                $checkbox.removeAttr("checked");
            } else {
                $checkboxImg.addClass("checked");
                $checkboxImg.attr("src", jspStoreImgDir
                    + "images/checkbox_checked.png");
                $checkboxImg.attr("aria-checked", "true");
                $checkbox.attr("value", checkedValue);
                $checkbox.attr("checked", "checked");
            }
        }
    },
/** FORM VALIDATIONS *************************************************************************************************************************/

    validateEmail: function (email) {
        var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var isValidEmail = emailRegexp.test(email.value);
        // managing inline style and error message
        this.manageInlineValidationError(isValidEmail, email, 'emailError');
        return isValidEmail;
    },

    validateZipCode: function (zipCodeId, countryId, stateId, cityId, lang, storeName) {
        //getting zip code value
        var countrySelected = document.getElementById(countryId).value;
        var zipCode = document.getElementById(zipCodeId);

        //getting zipcode pattern per selected country
        var selectedCountryPattern = this.returnZipCodePattern();
        var zipRegex = new RegExp(selectedCountryPattern);

        //We match it to uppercase, always have to be like 'ZIP'
        var isValidZip = zipCode != '' && zipRegex.test(zipCode.value.toUpperCase());
        var isZipCodeChange = false;

        //We check if the country is the same as in the store
        if (this.storeCountry == 'UK') {
            this.storeCountry = 'GB';
        }
        this.isSameCountryAsStore = (this.storeCountry === countrySelected);

        //managing inline style and error message
        this.manageInlineValidationError(isValidZip, zipCode, zipCodeId + '_Error');

        // if(!isSameCountryAsStore) this.manageInlineValidationError(isSameCountryAsStore, countrySelected, countryId + '_Error');
        if (isValidZip) {
            //autofill city and state with data
            if (zipCode.value !== "") {
                this.fillFormAddressWithData(zipCode, countryId, stateId, cityId, lang);
            }

            if (zipCodeId.includes("billing")) {
                this.validZipCodeBilling = true;
            } else {
                this.validZipCodeShipping = true;
            }
            var countryCode = jQuery('#' + countryId).val();
            if (zipCodeId.indexOf("shippingAddress") >= 0) {
                isZipCodeChange= (getCookie("addressId_formB_"+storeDirectory)!=undefined|| getCookie("addressId_formS_"+storeDirectory)!=undefined);
                if (this.hasTaxes) {
                    CheckoutHelperJS.calculateEstematedTax(zipCode.value, countryCode, lang, true, isZipCodeChange, storeName);
                }
            }

        } else {
            if (zipCodeId.includes("billing")) {
                this.validZipCodeBilling = false;
            } else {
                this.validZipCodeShipping = false;
            }
        }
    },

    /**
     * HB-343 , inline codice fiscale validation
     */
    validateCodiceFiscale: function (codiceId) {
        var selectedCountryCode = this.selectedCountryCode;

        if (selectedCountryCode == 'IT') {
            // getting zip code value
            var codice = document.getElementById(codiceId);

            // getting zipcode pattern per selected country
            var codiceRegex = new RegExp(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i);

            var isValidCodice = (codice == undefined || codice == null
                || codice.value == undefined || codice.value == ''
                || codiceRegex.test(codice.value));

            // managing inline style and error message
            this.manageInlineValidationError(isValidCodice, codice, codiceId + '_Error');

            return isValidCodice;

        } else {
            return true;
        }
    },

    /**
     * show,hide error message for inline validation
     * @param : isValidInput boolean for valid / invalid input
     * @param : element : input element concerned by validation
     * @param : errorMessageId : span containing error message for input
     */
    manageInlineValidationError: function (isValidInput, element, errorMessageId) {
        if (isValidInput) {
            return true;
        } else {
            return false;
        }
    },


/** END FORM VALIDATIONS *************************************************************************************************************************/

    /* NEW */
    getZipCodeRegexpForCurrentCountryCode: function () {
        var countryregex = "";

        if (countryCode == 'US') {
            countryregex = /^\d{5}$|^\d{5}-\d{4}$/;
        } else if (countryCode == 'CA') {
            countryregex = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/;
        } else if (countryCode == 'IT' || countryCode == 'FR' || countryCode == 'ES') {
            countryregex = /^\d{5}$/;
        } else if (countryCode == 'DE') {
            countryregex = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/;
        } else if (countryCode == 'GB' || countryCode == 'UK') {
            countryregex = /^GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4}$/;
        } else {
            countryregex = /./;
            plog("AddressHelper.js::getZipCodeRegexpForCurrentCountryCode()::Error: Regexp not found for countryCode:"+countryCode);
        }

        return countryregex;
    },


    /**
     * return country zipCode pattern per country
     * @param : countryCode : code of concerned country
     */
    returnZipCodePattern: function () {
        var selectedCountryCode = this.selectedCountryCode;
        var countryregex = "";

        if (selectedCountryCode == 'US') {
            countryregex = /^\d{5}$|^\d{5}-\d{4}$/;
        }
        if (selectedCountryCode == 'CA') {
            countryregex = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/;
        }
        if (selectedCountryCode == 'IT' || selectedCountryCode == 'FR' || selectedCountryCode == 'ES') {
            countryregex = /^\d{5}$/;
        }
        if (selectedCountryCode == 'DE') {
            countryregex = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/;
        }
        if (selectedCountryCode == 'GB') {
            countryregex = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/;
        }

        return countryregex;

    },


    /**
     * Calls google service to autofill Address data depending of the ZIP CODE
     *
     * @param {*} zip
     * @param {*} countryId
     * @param {*} stateId
     * @param {*} cityId
     * @param {*} lang
     */
    fillFormAddressWithData: function (zip, countryId, stateId, cityId, lang) {
        var countryCode = null;
        //case of address Book
        if (this.selectedCountryCode != null) {
            countryCode = this.selectedCountryCode;
        } else if (document.getElementById(countryId) !== null) {
            countryCode = document.getElementById(countryId).value;
        }
        var idZipCode = zip.id;

        var autofilledCity = document.getElementById(cityId);
        var autofilledState = document.getElementById(stateId);
        var autofilledStateHidden = document.getElementById(stateId + "_hidden");

        if (isCarol) {
            var autofilledAddress;
            var autofilledNeighborhood;
            if ($("#billingAddressCreateEditFormDiv_1").css("display") == "none"){
                autofilledAddress = $("#shippingAddressCreateEditFormDiv_1").find("[name='address1']");
                autofilledNeighborhood = $("#shippingAddressCreateEditFormDiv_1").find("[name='fax2']");
            } else {
                autofilledAddress = $("[name='address1']");
                autofilledNeighborhood = $("[name='fax2']");
            }
            var url = "/wcs/resources/store/"+ WCParamJS.storeId +"/customAddressValidation/byZipCode/" + zip.value;
            var neightborhoodChars = this.maxNeighborhoodChar;
            $.ajax({
                url: url,
                dataType: 'json',
                type: 'GET',
                async: false,
                success: function (data) {
                    if (data != null && data.addressInfo[0] != null) {
                        if ( data.addressInfo[0].country == null) {
                            idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = false : AddressHelper.validZipCodeShipping = false;
                            console.error("Zip code invalid / NOT FOUND, ZERO_RESULTS");
                        } else {
                            idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = true : AddressHelper.validZipCodeShipping = true;
                            if (data.addressInfo[0].city != null) {
                                autofilledCity.value = data.addressInfo[0].city;
                            }
                            if (data.addressInfo[0].state != null) {
                                autofilledState.value = data.addressInfo[0].state;
                            }
                            if (data.addressInfo[0].neighborhood != null) {
                                //Tuncate string -> OCPD-670
                                autofilledNeighborhood.val((data.addressInfo[0].neighborhood).substring(0,neightborhoodChars));
                            }
                            if (data.addressInfo[0].address != null) {
                                autofilledAddress.val(data.addressInfo[0].address);
                            }
                            $("[name='state']").parent().find("span.ui-selectmenu-text").text(data.addressInfo[0].state);
                        }
                    }
                },
                error: function(data){
                    console.log(data);
                }
            });
        } else {
            //HB-2302 BEGIN Use google address common interface
            getGoogleAddress(countryCode, zip.value, lang, function(result){
                var error = false;
                if (result.status == "error"){
                	if(result.error_description == "zipcode_not_found"){
                		AddressHelper.zipCodeNotFound = true;
                		if(autofilledState != null){
	                 		autofilledState.classList.remove("readonly");
	                 		autofilledState.readOnly = false;
                 		}
                	}
                	else {
                		error=true;
	                    console.log("PSL::AddressHelper.js::fillFormAddressWithData function ajax error (GoogleAPI):"+result.error_description);
	                    AddressHelper.validZipCode = false;
	                    idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = true : AddressHelper.validZipCodeShipping = true;
	                    AddressHelper.addFieldErrorMessage(zip, MessageHelper.messages["ERROR_ZipCodeInvalid"]);
                	}
                } else {
                	if(autofilledState != null) {
	                	autofilledState.classList.add("readonly");
	                	autofilledState.readOnly = true;
                	}
                	AddressHelper.zipCodeNotFound = false;
                    $('.prop65').removeClass('shown');
                    $('.prop65__a').attr('tabindex', '-1');
                    if (result.address.country_short === 'US' && result.address.prov_state_short === 'CA') {
                        $('.prop65').addClass('shown');
                        $('.prop65__a').attr('tabindex', '0');
                    }
                }

                //HB-1956 BEGIN
                if (!error && typeof notAllowedShippingRegions !== 'undefined'
                    && typeof result.address !== 'undefined'
                    && typeof result.address.prov_state_short !== 'undefined'
                    && !idZipCode.includes("billing")){

                    //IE fix: Array​.prototype​.includes() not working in IE
                    var notAllowedShippingRegion = false;
                    for (var i = 0; i < notAllowedShippingRegions.length; i++) {
                        if (notAllowedShippingRegions[i] == result.address.prov_state_short){
                            notAllowedShippingRegion = true;
                            break;
                        };
                    }

                    if (notAllowedShippingRegion){
                        zip.value="";
                        autofilledCity.value = "";
                        autofilledState.value = "";
                        autofilledStateHidden.value = "";

                        AddressHelper.manageMultipleEmptyFields(zip, MessageHelper.messages["ERROR_NotAllowedShippingRegion"], false);
                        error = true;
                    }
                //HB-1956 END
                }

                if (!error){
                	if(!AddressHelper.zipCodeNotFound){
                        var city = "";

                        if(document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1')!=null){
                            city = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1').value;
                        }else{
                            city = document.getElementById('WC_UserRegistrationUpdateForm_AddressEntryForm_FormInput_city_1').value;
                        }
	                	
	                	if(city==''){
	                    	autofilledCity.value = result.address.city;
	                    	$(autofilledCity).trigger("change");
	                    }
	                    
	                    if (autofilledState != null) {
	                        autofilledState.value = result.address.prov_state;
	                    }
	                    if (autofilledStateHidden != null) {
	                        autofilledStateHidden.value = result.address.prov_state_short;
	
	                    }
	
	                    AddressHelper.validZipCode = true;
	                    AddressHelper.manageMultipleEmptyFields(zip, "", true);
                	}
                	/*else {
                		if(autofilledState != null && autofilledState.value != '') {
                			autofilledStateHidden.value = autofilledState.value;
                		}
                	}*/
                }

            });
        }
    },

    /**
     * Calls google service to autofill Address data depending of the ZIP CODE
     *
     * @param {*} zip
     */
    autofillFormAddressFromZipCode: function (zipCodeFormField /*, countryId, stateId, cityId, lang*/) {

        var zipCodeFormFieldId = zipCodeFormField.id;
        var countryId = zipCodeFormFieldId.replace("_zipCode_","_country_");
        var stateId = zipCodeFormFieldId.replace("_zipCode_","_state_");
        var cityId = zipCodeFormFieldId.replace("_zipCode_","_city_");

        var countryCode = null;
        //case of address Book
        if (this.selectedCountryCode != null) {
            countryCode = this.selectedCountryCode;
        } else if (document.getElementById(countryId) !== null) {
            countryCode = document.getElementById(countryId).value;
        }
        var idZipCode = zipCodeFormField.id;

        var autofilledCity = document.getElementById(cityId);
        var autofilledState = document.getElementById(stateId);
        var autofilledStateHidden = document.getElementById(stateId + "_hidden");

        if (isCarol) {
            var autofilledAddress;
            var autofilledNeighborhood;
            if ($("#billingAddressCreateEditFormDiv_1").css("display") == "none"){
                autofilledAddress = $("#shippingAddressCreateEditFormDiv_1").find("[name='address1']");
                autofilledNeighborhood = $("#shippingAddressCreateEditFormDiv_1").find("[name='fax2']");
            } else {
                autofilledAddress = $("[name='address1']");
                autofilledNeighborhood = $("[name='fax2']");
            }
            var url = "/wcs/resources/store/"+ WCParamJS.storeId +"/customAddressValidation/byZipCode/" + zipCodeFormField.value;
            $.ajax({
                url: url,
                dataType: 'json',
                type: 'GET',
                async: false,
                success: function (data) {
                    if (data != null && data.addressInfo[0] != null) {
                        if ( data.addressInfo[0].country == null) {
                            idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = false : AddressHelper.validZipCodeShipping = false;
                            console.error("Zip code invalid / NOT FOUND, ZERO_RESULTS");
                        } else {
                            idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = true : AddressHelper.validZipCodeShipping = true;
                            if (data.addressInfo[0].city != null) {
                                autofilledCity.value = data.addressInfo[0].city;
                            }
                            if (data.addressInfo[0].state != null) {
                                autofilledState.value = data.addressInfo[0].state;
                            }
                            if (data.addressInfo[0].neighborhood != null) {
                                autofilledNeighborhood.val(data.addressInfo[0].neighborhood);
                            }
                            if (data.addressInfo[0].address != null) {
                                autofilledAddress.val(data.addressInfo[0].address);
                            }
                            $("[name='state']").parent().find("span.ui-selectmenu-text").text(data.addressInfo[0].state);
                        }
                    }
                },
                error: function(data){
                    console.log(data);
                }
            });
        } else {
            //HB-2302 BEGIN Use google address common interface
            getGoogleAddress(countryCode, zipCodeFormField.value, storeLanguage, function(result){
                var error = false;
                if (typeof zipCodeFormField.form.city !== 'undefined'){
                    AddressHelper.removeFieldErrorMessages(zipCodeFormField.form.city);
                }
                if (typeof zipCodeFormField.form.state_full !== 'undefined'){
                    AddressHelper.removeFieldErrorMessages(zipCodeFormField.form.state_full);
                }

                if (result.status == "error"){
                	if(result.error_description == "zipcode_not_found"){
                 		AddressHelper.zipCodeNotFound = true;
                 		if(autofilledState != null){
	                 		autofilledState.classList.remove("readonly");
	                 		autofilledState.readOnly = false;
                 		}
                 	}
                 	else {
                 		error=true;
	                    console.log("PSL::AddressHelper.js::autofillFormAddressFromZipCode function ajax error (GoogleAPI): "+result.error_description);
	                    console.log("PSL::AddressHelper.js::autofillFormAddressFromZipCode function ajax error: ",result.raw);
	                    AddressHelper.validZipCode = false;
	                    idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = true : AddressHelper.validZipCodeShipping = true;
	                    AddressHelper.addFieldErrorMessage(zipCodeFormField, MessageHelper.messages["ERROR_ZipCodeInvalid"]);
	                    $(zipCodeFormField.form).find("input[name=city]").val("");
	                    $(zipCodeFormField.form).find("input[name=state]").val("");
	                    $(zipCodeFormField.form).find("input[name=state_full]").val("");
                 	}
                } else {
                	if(autofilledState != null) {
	                	autofilledState.classList.add("readonly");
	                	autofilledState.readOnly = true;
                	}
                	AddressHelper.zipCodeNotFound = false;
                    $('.prop65').removeClass('shown');
                    $('.prop65__a').attr('tabindex', '-1');
                    if (result.address.country_short === 'US' && result.address.prov_state_short === 'CA') {
                        $('.prop65').addClass('shown');
                        $('.prop65__a').attr('tabindex', '0');
                    }
                }

                //HB-1956 BEGIN
                if (!error && typeof notAllowedShippingRegions !== 'undefined'
                    && typeof result.address !== 'undefined'
                    && typeof result.address.prov_state_short !== 'undefined'
                    && !idZipCode.includes("billing")){

                    //IE fix: Array​.prototype​.includes() not working in IE
                    var notAllowedShippingRegion = false;
                    for (var i = 0; i < notAllowedShippingRegions.length; i++) {
                        if (notAllowedShippingRegions[i] == result.address.prov_state_short){
                            notAllowedShippingRegion = true;
                            break;
                        };
                    }

                    if (notAllowedShippingRegion){
                        zipCodeFormField.value="";
                        autofilledCity.value = "";
                        autofilledState.value = "";
                        autofilledStateHidden.value = "";

                        AddressHelper.manageMultipleEmptyFields(zipCodeFormField, MessageHelper.messages["ERROR_NotAllowedShippingRegion"], false);
                        error = true;
                    }
                //HB-1956 END
                }

                if (!error){
                	if(!AddressHelper.zipCodeNotFound){
	                	var city = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1').value;
	                	if(city==''){
	                    	autofilledCity.value = result.address.city;
	                    	$(autofilledCity).trigger("change");
	                    }
	                    if (autofilledState != null) {
	                        autofilledState.value = result.address.prov_state;
	                    }
	                    if (autofilledStateHidden != null) {
	                        autofilledStateHidden.value = result.address.prov_state_short;
	
	                    }
	                    AddressHelper.validZipCode = true;
	                    AddressHelper.manageMultipleEmptyFields(zipCodeFormField, "", true);
                     
	                    if(($('#errorAddressValidation').is(":visible") && $('#addressValidationFirstTime').val() == 'false') || $('#errorAddressValidation').is(":hidden")){
	                    	AddressHelper.addSuccesIcon(zipCodeFormField);
	                    }
	                    
                        AddressHelper.addSuccesIcon('#'+countryId);
                        AddressHelper.addSuccesIcon('#'+stateId);
                        AddressHelper.addSuccesIcon('#'+cityId);
                        
                	}
                }else{
                    AddressHelper.removeSuccesIcon(zipCodeFormField);
                        AddressHelper.removeSuccesIcon('#'+countryId);
                        AddressHelper.removeSuccesIcon('#'+stateId);
                        AddressHelper.removeSuccesIcon('#'+cityId);
                }
                var shippingSelected = $('.shipping_method_content input[name="singleShipmentShippingMode"]:checked').attr("typeshipping").toUpperCase();
                if(shippingSelected == 'COLLECT IN STORE') {
                    autofilledCity.classList.add("blockForBoss");
                    autofilledState.classList.add("blockForBoss");
                }

            });
        }
    },

    fillFormAddressFromAddressDataObject: function(destForm, addressObj){
        if (typeof destForm.city !== 'undefined') {
            destForm.city.value = addressObj.address.city;
        }
        if (typeof destForm.state !== 'undefined') {
            destForm.state.value = addressObj.address.prov_state_short;
        }
        if (typeof destForm.state_full !== 'undefined') {
            destForm.state_full.value = addressObj.address.prov_state;
        }
        if (typeof destForm.zipCode !== 'undefined') {
            destForm.zipCode.value = addressObj.address.zipcode;
        }
    },

    /**
     * Function that launches the command to join the newsletter with the email from the Shipping address
     */
    joinNewsletter: function (form, langId, storeId) {
        reWhiteSpace = new RegExp(/^\s+$/);

        var subscriptionOn = false;
        var updateop = true;
        if ($('#joinNewsletterCheck').is(':checked')) {
        	subscriptionOn = true;
        }else{
        	if(userType == 'R' ){
        		updateop = false;
        	}
        }

        var emailValue = $("#" + form).find("input[name='email1']").val();
        if (localStorage != undefined) {
            localStorage.setItem('encryptedUserEmail',md5(emailValue.toLowerCase()).toString());
            if(isPersol || isOliver || isVogue)
                localStorage.setItem('encryptedUserEmailSHA256',sha256(emailValue.toLowerCase().trim()).toString());
        }
        var fName = $("#" + form).find("input[name='firstName']").val();
        var lName = $("#" + form).find("input[name='lastName']").val();
        
        var cidCookie = null;
        
        if(document.cookie.includes('X_WC_CID')){
        	cidCookie = $.cookie("X_WC_CID");
        }
        
        // Validation of email not in blank and well-formed
        if (emailValue != undefined && emailValue != "" && !reWhiteSpace.test(trim(emailValue))
            && MessageHelper.isValidUTF8length(emailValue, 256)
            && MessageHelper.isValidEmail(emailValue)) {
            var params = {
                storeId: storeId,
                langId: langId,
                email: emailValue,
                viewName: "",
                subscription: subscriptionOn,
                firstName: fName,
                lastName: lName,
                update: updateop,
                isCheckoutForm: true,
                cid: cidCookie
            };

            cursor_wait();

            wcService.invoke("JoinNewsletterService", params);
        }

    }, 
    joinSMS: function (fromPopup) {
        var params = {};
        var phone1Value = $("input[name='phone1']").val();
        if(phone1Value.indexOf("+") == -1 && localStorage.prefixNumberPhone1 != 'undefined'){
            var phone1ValuePrefix = String(localStorage.prefixNumberPhone1) + String(phone1Value);
        }
        
        //start CRM - BANNER
        if(fromPopup){
        	params.isFromPopup = fromPopup;
        }else{
        	params.isFromPopup = false;
        }
        //end CRM - BANNER
        
        
        if (localStorage != undefined ) {
            if(phone1ValuePrefix != undefined){
                localStorage.setItem('encryptedUserPhoneMd5',md5(phone1ValuePrefix.trim().toLowerCase()).toString());
                if(typeof sha256(phone1ValuePrefix.toString()) === 'object' && typeof sha256(phone1ValuePrefix.toString()).then === 'function')
                    sha256(phone1ValuePrefix.toString()).then(result => {  localStorage.setItem('encryptedUserPhoneSHA256',result); } ); 
                else
                    localStorage.setItem('encryptedUserPhoneSHA256',sha256(phone1ValuePrefix.toString()));
                
            }else{
                localStorage.setItem('encryptedUserPhoneMd5',md5(phone1Value.trim().toLowerCase()).toString());
                if(typeof sha256(phone1Value.toString()) === 'object' && typeof sha256(phone1Value.toString()).then === 'function')
                    sha256(phone1ValuePrefix.toString()).then(result => {  localStorage.setItem('encryptedUserPhoneSHA256',result); } );  
                else
                    localStorage.setItem('encryptedUserPhoneSHA256',sha256(phone1Value.toString())); 
            }
        }

        wcService.declare({
            id: "JoinSMSCmdService",
            actionId: "JoinSMSCmd",
            url: "JoinSMSCmd",
        
            successHandler: function(serviceResponse) {
                if(serviceResponse.responseMessage == 'duplicate'){
                    $('#mce-error-sms-duplicate').show();
                    console.log("Duplicate - This Number is already registered");
                    if(serviceResponse.userSMSOptin != 'undefined')
                        tealiumUserSMSOptin = String(serviceResponse.userSMSOptin);
                }else if(serviceResponse.responseMessage == 'success'){
                    tealiumUserSMSOptin = String(serviceResponse.userSMSOptin);
                }
                if(isVogue)
                    localStorage.setItem('tealiumUserSMSOptin',tealiumUserSMSOptin);
            },
            failureHandler: function(serviceResponse) {
                if (serviceResponse.errorMessage) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                } else {
                    if (serviceResponse.errorMessageKey) {
                        MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    }
                }
        }
        });
        if(userType == 'R'){
            params.userRegistered = 'true';
            params.user_id = userInfo.userId;
        }else{
            params.userRegistered = 'false';
            if(fromPopup){
            	 params.email = $("#homepageSmsPopupFormDiv .emailLbl input").val();
            	if(getUserId() == '-1002'){
            		userId = setUserIdentity();
            	}
            	params.user_id = userId;
            }
        }
        params.store_id = WCParamJS.storeId;
        params.language_id = WCParamJS.langId;
        params.phone1 = phone1Value;
        params.store_identifier = storeDirectory;
        
        var myaccountCheckbox = $("div[id*='WC_UserRegistrationAddForm_myAccount_CheckBoxSMS']").is(":visible");
        var checkoutCheckbox  = $("div[name*='checkbox-sms']").is(":visible");
        var homepagePopupCheckbox = $("div[id*='WC_homepageSmsPopupFormDiv_CheckBoxSMS']").is(":visible");

        if(myaccountCheckbox)
            params.receivesms = $('#WC_UserRegistrationAddForm_SMSOption_Checkbox_1').is(':checked') ? 1 : 0 ;
        if(checkoutCheckbox)
            params.receivesms = $('#WC_shippingAddressCreateEditFormDiv_1_SMSOption_Checkbox_1').is(':checked') ? 1 : 0 ;
        if(homepagePopupCheckbox)
        params.receivesms = $('#WC_homepageSmsPopupFormDiv_SMSOption_Checkbox_1').is(':checked') ? 1 : 0 ;
        else if(userType == 'R' && !checkoutCheckbox)
            tealiumUserSMSOptin  = "1";
         
        if((params.phone1 != '' && params.phone1.match(/^\d+$/) != null ) && (checkoutCheckbox))
            wcService.invoke("JoinSMSCmdService", params);    
    },

    updatePhysicalStoresArea: function (zipCodeValue) {
        if (typeof displayPhysicalStoreOptionsInCheckoutShipping != "undefined" && displayPhysicalStoreOptionsInCheckoutShipping == true && zipCodeValue == undefined) {
            var zipcode = $('#WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_zipCode_1').val();
            wcRenderContext.getRenderContextProperties('PhysicalStoresOptionsViewSBPageContext')['zipCode'] = zipcode;
            $("#physicalStoresOptionsViewSBPageArea").refreshWidget().refreshWidget("refresh", wcRenderContext.getRenderContextProperties("PhysicalStoresOptionsViewSBPageContext"));
            $('#storeLocatorResults').html("");
        } else if (zipCodeValue != undefined) {
            wcRenderContext.getRenderContextProperties('PhysicalStoresOptionsViewSBPageContext')['zipCode'] = zipCodeValue;
            $("#physicalStoresOptionsViewSBPageArea").refreshWidget().refreshWidget("refresh", wcRenderContext.getRenderContextProperties("PhysicalStoresOptionsViewSBPageContext"));
            $('#storeLocatorResults').html("");
        }
    },

    saveSelectedPhysicalStoreForOrder: function(ordersId, stloc_id) {

        console.log("saveSelectedPhysicalStoreForOrder");
        $.ajax({
            type: "POST",
            url: "OrderPhysicalStoreAddUpdate?ordersId=" + ordersId + "&stloc_id=" + stloc_id + "&storeId=" + WCParamJS.storeId,
            headers: {
                "Cache-Control": "no-cache, no-store, must-revalidate"
            },
            success: function (data) {
                console.log(" Selected physical store has been saved successfully");
            }, error: function (data) {
                console.log("An error has been occurred while trying to save the selected physical store");
            }
        });
    },

    /**
     * Funtion that fills the AddressForm from Thank you page with order data
     */
    fillFormAddressThankyouPage: function() {
        $('input[name="firstName"]').attr('value', $('.address #firstName').text());
        $('input[name="lastName"]').attr('value', $('.address #lastName').text());
        $("input[name='logonId']").attr('value', $('.address #emailAddress1').text());
        $("input[name='email1']").attr('value', $('.address #emailAddress1').text());
        $("input[name='usr_email1']").attr('value', $('.address #emailAddress1').text());
        if ($("input[name='middleName']"))
            $("input[name='middleName']").attr('value', $('.address #middleName').text());
        $("input[name='usr_address1']").attr('value', $('.address #addressLine1').text());
        $("input[name='usr_address2']").attr('value', $('.address #addressLine2').text());
        $("input[name='usr_zipCode']").attr('value', $('.address #postalCode').text());
        $("input[name='usr_city']").attr('value', $('.address #city').text());
        $("input[name='usr_state']").attr('value', $('.address #stateDisplayName').text());
        $("input[name='usr_stateName']").attr('value', $('.address #stateDisplayName').text());
        $("input[name='usr_phone1']").attr('value', $('.address #telephone1').text());
    },
        //START - new functions for checkout_3_0 Oliver/Persol
    updateUnregisteredCheckoutAddressAndGoPaymentStep: function (formName1, formName2, addressIdShipping, addressIdBilling, sameAddressChecked, onSuccessURL) {
        var form1 = document.forms[formName1];
        var form2 = document.forms[formName2];
        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";

        //We are here because the user came back to this page after address addition to database
        if (addressIdShipping == addressIdBilling) {
            //The address stored in the database is SB
            if (sameAddressChecked) {
                //Update current SB address
                form1.addressType.value = "ShippingAndBilling";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);
                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::SB address updated successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"ShippingAndBilling");
                        cursor_clear();
                        loadAddressInfo(); // added for checkout 3.0
                       // location.href = onSuccessURL; //non deve più essere indirizzato nella view succesiva 

                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error updating SB address");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            } else {
                //Change current SB address to S and add billing address.
                form1.addressType.value = "Shipping";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);

                form2.addressType.value = "Billing";
                form2.nickName.value = "MyAddress_Billing";
                var jsonDataBilling = AddressHelper.getJSONContactDataFromAddressForm(formName2);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::SB address changed to S successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"Shipping");
                        cursor_clear();
                        $.ajax({
                            type: "POST",
                            url: url,
                            headers: {
                                "Content-Type": "application/json",
                                "Cache-Control": "no-cache, no-store, must-revalidate"
                            },
                            dataType: 'json',
                            data: jsonDataBilling,
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address added successfully");
                                AddressHelper.updateAddressCookies(msg.addressId,"Billing");
                                cursor_clear();
                                 loadAddressInfo(); // added for checkout 3.0
                                 //location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error adding B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error changing SB address to S");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });
            }
        } else {
            //There are two different addresses in the database
            if (sameAddressChecked) {
                //Update current S address to SB and delete current billing address.
                form1.addressType.value = "ShippingAndBilling";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::S address changed to SB successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"ShippingAndBilling");
                        cursor_clear();
                        $.ajax({
                            type: "DELETE",
                            url: url + "/MyAddress_Billing",
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address deleted successfully");
                                cursor_clear();
                                loadAddressInfo(); // added for checkout 3.0
                                //location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error deleting B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error changing S address to SB");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            } else {
                //Update current S address and B address           	
                form1.nickName.value = "MyAddress_Shipping";
                form2.nickName.value = "MyAddress_Billing";
               // form2.email1.value = form1.email1.value;
                if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup' && isOliver){
            		form1.addressType.value = "Shipping";
                    form2.addressType.value = "Billing";
                }

                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);
                var jsonDataBilling = AddressHelper.getJSONContactDataFromAddressForm(formName2);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::S address updated successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"Shipping");
                        cursor_clear();
                        $.ajax({
                            type: "PUT",
                            url: url + "/MyAddress_Billing",
                            headers: {
                                "Content-Type": "application/json",
                                "Cache-Control": "no-cache, no-store, must-revalidate"
                            },
                            dataType: 'json',
                            data: jsonDataBilling,
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address updated successfully");
                                AddressHelper.updateAddressCookies(msg.addressId,"Billing");
                                cursor_clear();
                                loadAddressInfo(); // added for checkout 3.0
                                //location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error updating B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error updating S address");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            }
        }
    },

    addSuccesIcon: function (formField) {
          
               // $(formField).parent().addClass('validCheck');

                $(formField).parent().removeClass('isNotValid');
                
                if($(formField).siblings('.address-erros-message-cont').length > 0){
                	$(formField).siblings('.address-erros-message-cont').remove();
                }
                
                if($(formField).attr('formtmoreturn') && (isOliver || isPersol) && $('.form-page-container .find-order-wrapper .form-container .input-style input#email').length  > 0){
                	if($('.form-page-container .find-order-wrapper .form-container .input-style input#email').siblings('.address-erros-message-cont').length > 0){
                		$('.form-page-container .find-order-wrapper .form-container .input-style input#email').siblings('.address-erros-message-cont').remove();
                    }
                }
                
                if (typeof formField === 'string'){
                	if(formField.includes("country")){
                    	//$(formField).siblings('.ui-selectmenu-button').children('.ui-selectmenu-icon').hide();
                    }
                }else{
                    $(formField).parent().addClass('validCheck');
                }
                
                
    },

    removeSuccesIcon: function (formField) {
          
        $(formField).parent().removeClass('validCheck');
        if($(formField).hasClass('field-error-message')){
            $(formField).parent().addClass('isNotValid');
        }
        
        if($(formField).attr('formtmoreturn')){
        	$(formField).parent().addClass('isNotValid');
        }
        
        
        if (typeof formField === 'string'){
        	if(formField.includes("country")){
            	$(formField).siblings('.ui-selectmenu-button').children('.ui-selectmenu-icon').show();
            }
        }
}
//END - new functions for checkout_3_0 Oliver/Persol
}

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file provides utility functions for the order check-out pages.
 */

/**
 * The functions defined in this class are used for managing order information update during check-out.
 *
 * @class This CheckoutHelperJS class defines all the variables and functions for the page(s) used in the check-out process to udpate order related information, such as address, shipping method, shipping instruction, etc.
 *
 */
CheckoutHelperJS = {
    /* Global variable declarations */

    /**
     * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
     * @private
     */
    langId: "-1",

    /**
     * This variable stores the ID of the current store. Its default value is empty.
     * @private
     */

    storeId: "",

    /**
     * This variable stores the ID of the catalog. Its default value is empty.
     * @private
     */
    catalogId: "",

    /**
     * This variable stores the ID of the order, in case the current shopping cart is not being used. Its default value is empty.
     */
    orderId: "",

    /**
     * This variable stores the shipment type, either 1 for single shipment or 2 for multiple shipment. Its default value is set to empty.
     * @private
     */
    shipmentTypeId: "",


    /**
     * This array stores the item IDs in an order. It is used to save the item IDs before an address is edited or created during the order check-out.
     * @private
     */
    orderItemIds: [],

    /**
     * This constant stores the amount of time in milliseconds that the <code>updateCartWait</code> function needs to wait before updating the shopping cart.
     * @private
     * @constant
     * @see CheckoutHelperJS.updateCartWait
     */
    updateWaitTimeOut: 1500,

    /**
     * This array stores the number of key press events after a shopper has modified the quantity of an item in the shopping cart.
     * @private
     * @see CheckoutHelperJS.updateCartWait
     */
    keyPressCount: {},

    /**
     * This variable stores the true/false value that indicates if the 'SinglePageCheckout' feature is enabled/disabled.
     * When it is true, both shipping and billing information are captured in a single page. If it is false, checkout will
     * be a two step process where shipping is captured in first step and billing in second step.
     * It is set to true by default.
     *
     * @private
     */
    singlePageCheckout: true,

    /**
     * This array stores the address ID before it is updated by the user during the order check-out.
     * @private
     */
    selectedAddressesArray: {},

    /**
     * This array stores the values that indicate if the payment method input in a payment area has been changed by the user.
     *
     * @private
     */
    dataDirty: {},

    /**
     * This variable stores a value that indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     * Its default value is set to false.
     *
     * @private
     */
    fieldDirtyFlag: false,

    /**
     * This constant stores the String value representing a date that the service understands to reset a requested shipping date.
     * @private
     * @constant
     */
    resetRequestedShipDateValue: "1970-01-01T00:00:00.000Z",

    /**
     * This variable stores the value that indicates if the current page is the Shopping Cart page. It is used to determine what page to redirect to after a service call has been successfully performed.
     *
     * @private
     */
    shoppingCartPage: false,

    /**
     * This variable stores the value that indicates if the current page is the pending order details page. It is used to determine what page to redirect to after a service call has been successfully performed.
     *
     * @private
     */
    pendingOrderDetailsPage: false,

    /**
     * This variable stores the value that indicates if the requested shipping date has recently been updated. It is used to determine if certain area of the page needs to be refreshed.
     */
    RequestShippingDateAction: false,

    /**
     * Indicates whether the ShippingChargeType flexflow is enabled.
     */
    shipChargeEnabled: false,

    /**
     * The order ID.
     */
    tempOrderId: "",
    /**
     * The type of the current user.
     */
    tempUserType: "",
    /**
     * The list of emails spearated by space. Order confirmation will be sent to these emails.
     */
    tempEmailAddresses: "",
    /**
     * Indicates whether it is a Quote that is being checked out.
     */
    tempIsQuote: false,

    /**
     * The current order total.
     */
    tempOrderTotal: "0",

    /**
     * used to check if the zip code is changed
     */
    zipCountShoppingCart : 0,

    /**
     * The payment instructions allocated in the order.
     */
    tempPaymentInstructions: {},
    lastAddressLinkIdToFocus: "",
    lastFocusId: "",
    setLastFocus: function (id) {
        this.lastFocusId = id;
    },
    getLastFocus: function () {
        return this.lastFocusId;
    },
    tabPressed: function (event) {
        if (event.keyCode == 9) {
            tabPressed = true;
        }
    },
    setLastAddressLinkIdToFocus: function (lastLinkId) {
        this.lastAddressLinkIdToFocus = lastLinkId;
    },
    getLastAddressLinkIdToFocus: function () {
        return this.lastAddressLinkIdToFocus;
    },

    /**
     * Indicates whether the order is prepared already or not.
     */
    orderPrepared: "false",

    /**
     * Sets the orderPrepared variable to indicate whether the order has been through the OrderPrepare command or not. An order must be prepared before it can be submitted.
     *
     * @param {Boolean} inPrepareIndicator Whether or not the order has been prepared.
     */
    setOrderPrepared: function (inPrepareIndicator) {
        this.orderPrepared = inPrepareIndicator;
    },

    /**
     * Returns whether or not the order is prepared.
     */
    isOrderPrepared: function () {
        return this.orderPrepared;
    },

    /**
     * Save some variables needed for re-calling checkoutOrder method after a service call.
     *
     * @param {Integer} orderId The order ID.
     * @param {String} userType The type of the current user.
     * @param {String} addressListForMailNotification The list of emails spearated by space. Order confirmation will be sent to these emails.
     * @param {boolean} isQuote Optional parameter which indicates whether it is a Quote that is being checked out. If this parameter is not passed then it defaults to false.
     */
    saveCheckoutOrderParameters: function (orderId, userType, addressListForMailNotification, isQuote) {
        this.tempOrderId = orderId;
        this.tempUserType = userType;
        this.tempEmailAddresses = addressListForMailNotification;
        this.tempIsQuote = isQuote;
    },

    /**
     * Sets some internal variables needed for verifying order totals.
     *
     * @param {Object} orderTotal The current order total.
     * @param {Object} paymentInstructions The currently allocated payment instructions for the order.
     */
    setOrderPayments: function (orderTotal, paymentInstructions) {
        this.tempOrderTotal = orderTotal + 0;
        this.tempPaymentInstructions = paymentInstructions;
    },

    /**
     * Returns whether or not the order total amount has been fully allocated with payment instructions.
     */
    isOrderPaymentFullyAllocated: function () {
        var allocatedAmount = 0;
        if (this.tempPaymentInstructions.paymentInstruction != null && this.tempPaymentInstructions.paymentInstruction.length >= 1) {
            for (var i = 0; i < this.tempPaymentInstructions.paymentInstruction.length; i++) {
                allocatedAmount = allocatedAmount + parseFloat(this.tempPaymentInstructions.paymentInstruction[i].piAmount);
            }
        }

        if (allocatedAmount == this.tempOrderTotal) {
            return true;
        } else {
            var roundedAllocatedAmount = allocatedAmount.toFixed(2);
            var roundedTempOrderTotal = this.tempOrderTotal.toFixed(2);
            if (roundedAllocatedAmount == roundedTempOrderTotal) {
                return true;
            } else {
                if (allocatedAmount < this.tempOrderTotal) {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["EDPPaymentMethods_CANNOT_RECONCILE_PAYMENT_AMT"]);
                    return false;
                } else if (allocatedAmount > this.tempOrderTotal) {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["EDPPaymentMethods_PAYMENT_AMOUNT_LARGER_THAN_ORDER_AMOUNT"]);
                    return false;
                } else {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["EDPPaymentMethods_PAYMENT_AMOUNT_PROBLEM"]);
                    return false;
                }
            }
        }
    },

    /**
     * Returns the value of the internal variable with that name.
     *
     * @param {Object} paramName The value of the internal parameter.
     */
    getSavedParameter: function (paramName) {
        return this[paramName];
    },

    /**
     * Sets the ShipChargeEnabled variable to indicate whether the ShippingChargeType feature is enabled.
     *
     * @param {Boolean} enabled This parameter is set to true if the ShippingChargeType feature is enabled.
     */
    setShipChargeEnabled: function (enabled) {
        this.shipChargeEnabled = enabled;
    },

    /**
     * This function updates the input associative array params with the input key-value pair.
     * If the toArray value is true, this function creates an associative array for duplicate entries; otherwise it overwrites the existing array.
     * The function is used for updating input parameters before passing them to a service call.
     *
     * @param {Array} params The associative array to update.
     * @param {String} key The key to search for in the array.
     * @param {String} value The new value to update with when the key has been found in the array.
     * @param {Boolean} toArray If the value is true, then the function creates a new array for duplicate entries. If the value is false, no new array will be created, the existing array will be overwritten.
     * @param {Integer} index The index in the array in which the value should be updated.
     *
     * @returns {Array} params The updated associative array.
     */
    updateParamObject: function (params, key, value, toArray, index) {
        if (params == null) {
            params = [];
        }

        if (params[key] != null && toArray) {
            if ($.isArrayLike(params[key])) {
                //3rd time onwards
                if (index != null && index != "") {
                    //overwrite the old value at specified index
                    params[key][index] = value;
                } else {
                    params[key].push(value);
                }
            } else {
                //2nd time
                var tmpValue = params[key];
                params[key] = [];
                params[key].push(tmpValue);
                params[key].push(value);
            }
        } else {
            //1st time
            if (index != null && index != "" && index != -1) {
                //overwrite the old value at specified index
                params[key + "_" + index] = value;
            } else if (index == -1) {
                var i = 1;
                while (params[key + "_" + i] != null) {
                    i++;
                }
                params[key + "_" + i] = value;
            } else {
                params[key] = value;
            }
        }
        return params;
    },


    /**
     * This function shows or hides the request shipping date input field depending on the state of the corresponding checkbox.
     * If the checkbox is unchecked, the <code>OrderItemAddressShipMethodUpdate</code> service will be called to update the shipping information.
     *
     * @param {String} checkBoxName The ID of the request shipping date checkbox.
     * @param {String} divName The name of the div element that contains the request shipping date input field.
     * @param {String} suffix The suffix that is appended after the divName. It is usually the order item ID.
     */
    checkRequestShippingDateBox: function (checkBoxName, divName, suffix) {
        var thisCheckBoxName;
        var thisDivName;

        if (suffix != null && suffix != "") {
            checkBoxName = checkBoxName + "_" + suffix;
            divName = divName + "_" + suffix;
        }

        var checkBox = $("#" + checkBoxName)[0];

        if (checkBox.checked) {
            $("#" + divName).css("visibility", "visible");
            $("#" + divName).css("display", "block");
        } else {
            // If the checkbox is unchecked, hide the input field
            $("#" + divName).css("visibility", "hidden");
            $("#" + divName).css("display", "none");
            if (this.shipmentTypeId == "1") {
                $("#requestedShippingDate").blur();
            } else if (this.shipmentTypeId == "2") {
                $("#MS_requestedShippingDate_" + suffix).blur();
            }
        }

        var addressId, shipModeId = "";
        if (this.shipmentTypeId == "1") {
            addressId = document.getElementById("singleShipmentAddress").value;
            shipModeId = document.getElementById("singleShipmentShippingMode").value;
        } else if (this.shipmentTypeId == "2") {
            addressId = document.getElementById("MS_ShipmentAddress_" + suffix).value;
            shipModeId = document.getElementById("MS_ShippingMode_" + suffix).value;
        } else {
            console.debug("shipmentTypeId is undefined. Single shipment has Id 1; multiple shipment has Id 2.");
        }

        // Delete the requestedShippingDate if the checkBox is unchecked
        if (!checkBox.checked) {
            var params = [];
            params["storeId"] = this.storeId;
            params["catalogId"] = this.catalogId;
            params["langId"] = this.langId;
            params.orderId = ".";

            this.updateParamObject(params, "addressId", addressId, false, -1);
            this.updateParamObject(params, "shipModeId", shipModeId, false, -1);

           if($("#requestedShippingDate") != null || $("#MS_requestedShippingDate_" + suffix) != null){
                if(this.shipmentTypeId == "1") {
                    params["requestedShipDate"] = this.resetRequestedShipDateValue;
                } else {
                    this.updateParamObject(params, "requestedShipDate", this.resetRequestedShipDateValue, false, -1);
                }
            }

            var orderItemId = null;
            var qty = -1;
            var totalItems = document.getElementById("totalNumberOfItems").value;
            for (var i = 0; i < totalItems; i++) {
                if (document.getElementById("qty_" + (i + 1)) != null) {
                    qty = document.getElementById("qty_" + (i + 1)).value;
                }
                orderItemId = document.getElementById("orderItem_" + (i + 1)).value;
                // we need atleast one orderItemId..this is the limitation of order service..
                if (qty != -1) {
                    if (this.shipmentTypeId == "1") {
                        // Single Shipment
                        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
                        break;
                    } else if (this.shipmentTypeId == "2") {
                        // Multiple Shipment
                        if (suffix != null && suffix != "" && orderItemId == suffix) {
                            this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
                            break;
                        }
                    } else {
                        console.debug("shipmentTypeId is undefined. Single shipment has Id 1; multiple shipment has Id 2.");
                    }
                }
            }

            //For handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            cursor_wait();
            CheckoutHelperJS.RequestShippingDateAction = true;
            wcService.invoke("OrderItemAddressShipMethodUpdate", params);
        }
    },


    /**
     * This function shows or hides the shipping instruction input field depending on the state of the corresponding checkbox.
     * If the checkbox is unchecked, the <code>OrderShippingInfoUpdate</code> service will be called to update the shipping information.
     * Note that order items that have the same ship-to address and shipping method will share the same shipping instruction.
     *
     * @param {String} checkBoxName The ID of the shipping instruction checkbox.
     * @param {String} divName The name of the div element that contains the shipping instruction input field.
     * @param {String} suffix The suffix that is appended after the divName. It is usually the order item ID.
     */
    checkShippingInstructionsBox: function (checkBoxName, divName, suffix) {
        //var divName = "shippingInstructionsDiv";
        var thisCheckBoxName;
        var thisDivName;

        if (suffix != null && suffix != "") {
            thisCheckBoxName = checkBoxName + "_" + suffix;
            thisDivName = divName + "_" + suffix;
        } else {
            thisCheckBoxName = checkBoxName;
            thisDivName = divName;
        }

        var thisCheckBox = $("#" + thisCheckBoxName)[0];

        if (thisCheckBox.checked) {
            $("#" + thisDivName).css("visibility", "visible");
            $("#" + thisDivName).css("display", "block");
        } else {
            // If the checkbox is unchecked, hide the input field
            $("#" + thisDivName).css("visibility", "hidden");
            $("#" + thisDivName).css("display", "none");
        }

        // Update other shipping instructions div with same addressId and shipModeId..
        var addressId, shipModeId = "";
        if (this.shipmentTypeId == "1") {
            addressId = document.getElementById("singleShipmentAddress").value;
            shipModeId = document.getElementById("singleShipmentShippingMode").value;
        } else if (this.shipmentTypeId == "2") {
            var orderItemId, tempAddressId, tempShipModeId = "";

            //get current div's shipModeId and addressId..
            addressId = document.getElementById("MS_ShipmentAddress_" + suffix).value;
            shipModeId = document.getElementById("MS_ShippingMode_" + suffix).value;

            var totalItems = document.getElementById("totalNumberOfItems").value;
            for (var i = 0; i < totalItems; i++) {
                if (document.getElementById("qty_" + (i + 1)) != null && document.getElementById("qty_" + (i + 1)).value != -1) {
                    orderItemId = document.getElementById("orderItem_" + (i + 1)).value;
                    tempAddressId = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
                    tempShipModeId = document.getElementById("MS_ShippingMode_" + orderItemId).value;
                    if (tempShipModeId == shipModeId && tempAddressId == addressId) {
                        var tempDivName = divName + "_" + orderItemId;
                        var tempCheckBoxName = checkBoxName + "_" + orderItemId;
                        if (thisCheckBox.checked) {
                            $(tempDivName).css("visibility", "visible");
                            $(tempDivName).css("display", "block");
                            $(tempCheckBoxName).attr("checked", "checked");
                }
                        else {
                            //User doesnt want to specify shipping instructions and requested ship date..hide this div..
                            $("#" + tempDivName).css("visibility", "hidden");
                            $("#" + tempDivName).css("display", "none");
                            $("#" + tempCheckBoxName).attr("checked", "");
                        }
                    }
                }
            }
        } else {
            console.debug("shipmentTypeId is undefined. Single shipment has Id 1; multiple shipment has Id 2.");
        }

        // Delete shippingInstructions if the checkBox is unchecked
        if (!thisCheckBox.checked) {
            var params = [];
            params["storeId"] = this.storeId;
            params["catalogId"] = this.catalogId;
            params["langId"] = this.langId;
            params.orderId = ".";

            var orderItemId = null;
            if (this.shipmentTypeId == "1") {
                if (document.getElementById("shipInstructions") != null) {
                    this.updateParamObject(params, "shipInstructions", "", false);
                    document.getElementById("shipInstructions").value = "";
                }
                orderItemId = document.getElementById("orderItem_1").value;
                this.updateParamObject(params, "addressId", addressId, false);
                this.updateParamObject(params, "orderItemId", orderItemId, false);

            } else if (this.shipmentTypeId == "2") {
                if (suffix != null && suffix != "") {
                    if (document.getElementById("MS_shipInstructions_" + suffix) != null) {
                        this.updateParamObject(params, "shipInstructions", "", false);
                        document.getElementById("MS_shipInstructions_" + suffix).value = "";
                    }
                    this.updateParamObject(params, "addressId", addressId, false, -1);
                    this.updateParamObject(params, "orderItemId", suffix, false);
                    this.setShippingInstuctionsForAllOtherItems(addressId, shipModeId, "");
                }
            } else {
                console.debug("shipmentTypeId is undefined. Single shipment has Id 1; multiple shipment has Id 2.");
            }

            //For handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            cursor_wait();
            wcService.invoke("OrderShippingInfoUpdate", params);
        }
    },


    /**
     * This function sets the shipment type for the current page.
     *
     * @param {Integer} shipmentTypeId The shipment type ID, 1 for single shipment or 2 for multiple shipment.
     *
     * @see CheckoutHelperJS.getShipmentTypeId
     */
    initializeShipmentPage: function (shipmentTypeId) {
        this.shipmentTypeId = shipmentTypeId;
    },


    /**
     * This function sets the common parameters for the current page, i.e. language ID, store ID and catalog ID.
     *
     * @param {Integer} langId The ID of the language that the store currently uses.
     * @param {Integer} storeId The ID of the current store.
     * @param {Integer} catalogId The ID of the catalog.
     */
    setCommonParameters: function (langId, storeId, catalogId) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
    },


    /**
     * This function deletes an order item from the shopping cart.
     * If forWishlist is true, then the item is added to the wish list subsequently by calling the <code>AjaxDeleteOrderItemFromCart</code> service.
     *
     * @param {Integer} orderItemId The ID of the order item to delete.
     * @param {Boolean} forWishlist If the value is true, then the item is added to the wish list.
     */
    deleteFromCart: function (orderItemId, forWishlist) {

        var params = [];
        params.storeId = this.storeId;
        params.catalogId = this.catalogId;
        params.langId = this.langId;
        params.orderId = (this.orderId != null && this.orderId != 'undefined' && this.orderId != "") ? this.orderId : ".";
        params.orderItemId = orderItemId;
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.check = "*n";
        params.calculateOrder = "1";

        var x = document.getElementById("totalNumberOfItems").value;
        var y = x;
        //Now remove free items from this total number of items count..
        //x = total items and y = totalItems - totalFreeItems
        for (var i = 0; i < x; i++) {
            var qtyObj = document.getElementById("freeGift_qty_" + (i + 1));
            if (qtyObj != null || qtyObj != undefined) {
                qty = qtyObj.value;
                if (qty != null && qty != undefined && qty == -1) {
                    y = y - 1;
                }
            }

        }

        if(sessionStorage.barberiniOrderItem == orderItemId)
            sessionStorage.removeItem('barberiniOrderItem');
        
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        if (isOliver || isCarol){

            if (forWishlist) {
                wcService.invoke("AjaxDeleteOrderItemFromCart", params);
            } else {
                if (this.shoppingCartPage || this.pendingOrderDetailsPage) {
                    wcService.invoke("AjaxDeleteOrderItem", params);
                } else {
                    // HB-3398 : avoid timeout on iphone when vpn is connected.
                    /*$.ajaxSetup({
                        timeout: 2000 //Time in milliseconds
                    });*/ 
                    wcService.invoke("AjaxDeleteOrderItemForShippingBillingPage", params);
                }
            }
            // HB-1050 :: workaround
            //setTimeout(function() { window.location.href = window.location.href; }, 500);

        } else {

            if (y == 1) {
                wcService.invoke("AjaxDeleteOrderItem1", params);
            } else {
                if (forWishlist) {
                    wcService.invoke("AjaxDeleteOrderItemFromCart", params);
                } else {
                    if (this.shoppingCartPage || this.pendingOrderDetailsPage) {
                        wcService.invoke("AjaxDeleteOrderItem", params);
                    } else {
                        wcService.invoke("AjaxDeleteOrderItemForShippingBillingPage", params);
                    }
                }
            }
        }
    },

    /**
     * Only for Persol
     */
    updateDeletePresc: function () {
        var countPrescription = parseInt($("#countPresc").val());
        if (countPrescription <= 2){
            $(".prescription__wrapper-error-msg").hide();
            $("#WC_CheckoutLogonf_div_3").show();
            $(".checkout_or_seperator").show();
            $(".paypal_button_container").show();
        }
    },


    /**
     * This function is used to update the ship-to address ID of all items in the current order when the user chooses to add a new address during order check-out.
     * This function calls the <code>AjaxUpdateOrderItemsAddressId</code> service.
     *
     * @param {Integer} addressId The ID of the newly created address.
     */
    updateAddressIdOFItemsOnCreateEditAddress: function (addressId) {
        if (this.shipmentTypeId == "2" && this.orderItemIds.length == 0) {
            // If this is multiple shipment and none of the orderItems addressId is same as modified addressId, then no need make a service call.
            return;
        }
        var params = [];
        params.orderId = ".";
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";
        if (this.shipmentTypeId == "1") {
            params.addressId = addressId;
        } else {
            var orderItemId = null;
            for (var i = 0; i < this.orderItemIds.length; i++) {
                orderItemId = this.orderItemIds[i];
                this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
                this.updateParamObject(params, "addressId", addressId, false, -1);
            }
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxUpdateOrderItemsAddressId", params);
    },


    /**
     * This function is used to save the current order items list when the user edits an existing address or creates a new address during order check-out.
     *
     * @param {Integer} orderItemId The order item ID.
     * @param {String} addressId The ID of the address.
     *
     * @private
     */
    saveOrderItemsList: function (orderItemId, addressId) {
        if (orderItemId == '-1') {
            //Creating or editing shipping address for single shipment, get all the orderItemIds in the order..

            var totalItems = document.getElementById("totalNumberOfItems").value;
            // if order item section is collapsed, we only have data for the first order item. And this is the case for single shipment so it
            // is ok just to update orderItem_1
            this.orderItemIds[0] = document.getElementById("orderItem_1").value;

        } else if (orderItemId == 0 && this.shipmentTypeId == "1") {
            // Editing or creating billing address.. If it's single shipment type, then we need to save all orderItem Id's.
            // If the shipping address is same as this billing address which is edited, then after editing this addressId will change, so we need to update the orderItemIds.

            if (document.getElementById("singleShipmentAddress")) {
                if (addressId == document.getElementById("singleShipmentAddress").value) {
                    var totalItems = document.getElementById("totalNumberOfItems").value;
                    for (var i = 0; i < totalItems; i++) {
                        this.orderItemIds[i] = document.getElementById("orderItem_" + (i + 1)).value;
                    }
                } else {
                    this.orderItemIds = [];
                }
            } else {
                this.orderItemIds = [];
            }
            return;
        } else {
            // OrderItemId is passed..so it's multiple shipment, get all the orderItemIds with the same address...
            // This section is for multiple shipment and create/edit both shipping/billing address...
            var totalItems = document.getElementById("totalNumberOfItems").value;
            var temp = null;
            var orderItemId = null;
            var j = 0;

            //saving orderItemIds (used by this.updateAddressIdOFItemsOnCreateEditAddress) for  the'edit address' link
            for (var i = 0; i < totalItems; i++) {
                orderItemId = document.getElementById("orderItem_" + (i + 1)).value;
                if (document.getElementById("MS_ShipmentAddress_" + orderItemId)) {
                    temp = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
                    //addressId is -1 if 'create address' is clicked. The following if will always return false in that case.
                    if (temp == addressId) {
                        //Add this to our list..
                        this.orderItemIds[j++] = orderItemId;
                    }
                }
            }
        }
    },


    /**
     * By convention, all items in an order that have the same shipping address and shipping mode share the same shipping instruction.
     * This function is used to update the shipping instruction of all items that have the same shipping address and shipping mode.
     *
     * @param {Integer} addressId The shipping address ID.
     * @param {Integer} shipModeId The shipping mode ID.
     * @param {String} shipInstructions The shipping instruction.
     */
    setShippingInstuctionsForAllOtherItems: function (addressId, shipModeId, shipInstructions) {

        var orderItemId, addressId1, shipModeId1 = "";
        var totalItems = document.getElementById("totalNumberOfItems").value;
        for (var i = 0; i < totalItems; i++) {
            if (document.getElementById("qty_" + (i + 1)) != null && document.getElementById("qty_" + (i + 1)).value != -1) {
                orderItemId = document.getElementById("orderItem_" + (i + 1)).value;
                addressId1 = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
                shipModeId1 = document.getElementById("MS_ShippingMode_" + orderItemId).value;
                if (shipModeId1 == shipModeId && addressId1 == addressId) {
                    document.getElementById("MS_shipInstructions_" + orderItemId).value = shipInstructions;
                }
            }
        }
    },


    /**
     * When a user toggles the 'ship as complete' checkbox, the same will be updated at the server side by invoking the <code>OrderShippingInfoUpdate</code> service.
     *
     * @param {DOM Element} checkBox The 'ship as complete' checkbox object.
     */
    shipAsComplete: function (checkBox) {
        var params = [];
        params.orderId = ".";
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";
        if (checkBox.checked) {
            this.updateParamObject(params, "ShipAsComplete", "true", true);
        } else {
            this.updateParamObject(params, "ShipAsComplete", "false", true);
        }
        orderItemId = document.getElementById("orderItem_1").value;
        this.updateParamObject(params, "orderItemId", orderItemId, false);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderShippingInfoUpdate", params);
    },


    /**
     * When there is an invalid address ID in an order, this function updates all items to use the valid address ID by invoking the <code>AjaxSetAddressIdOfOrderItems</code> service.
     *
     * @param {Integer} addressId A valid address ID.
     */
    updateAddressIdForOrderItem: function (addressId) {
        if (addressId == null || addressId.length == 0) {
            return true;
        }

        var params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        this.updateParamObject(params, "addressId", addressId, false);
        wcService.invoke("AjaxSetAddressIdOfOrderItems", params);
    },


    /**
     * When there is an invalid shipping mode ID in an order, this function updates all items to use the valid shipping mode ID by invoking the <code>AjaxSetShipModeIdForOrder</code> service.
     *
     * @param {Integer} shipModeId A valid shipping mode ID.
     */
    updateShipModeIdForOrder: function (shipModeId) {
        var params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params["shipModeId"] = shipModeId;
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";
        wcService.invoke("AjaxSetShipModeIdForOrder", params);
    },

    /**
     * When there is an inconsistent requested ship date in an order when multiple shipment is disabled,
     * this function updates all items to use the the same date by invoking the <code>AjaxSetRequestedShipDateForOrder</code> service.
     *
     * @param {String} date The String representation of the requested ship date
     */
    updateRequestedShipDateForOrder: function (date) {
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        if (date != "") {
            this.updateParamObject(params, "requestedShipDate", date, false);
        } else {
            this.updateParamObject(params, "requestedShipDate", this.resetRequestedShipDateValue, false);
        }

        wcService.invoke("AjaxSetRequestedShipDateForOrder", params);
    },



    /**
     * This function is used to apply a promotion code to the order.
     *
     * @param {String} formName The name of the promotion code entry form.
     * @param {String} returnView   The name of the view that the server should redirect the browser to after a promotion code is applied.
     */
    applyPromotionCode: function (formName, orderId) {

        var form = document.forms[formName];
        form.promoCode.value = trim(form.promoCode.value);
        
        /* START - Early Access */
        if((isVogue || isPersol) && document.cookie.includes('X_WC_PR_SEGMENTS')){
        	var eaPromoCodeFlag=true;
           /* if (form.promoCode.value == 'NL-EA21-11' || form.promoCode.value == 'WCL-EA21-11' || form.promoCode.value == 'PFM-EA21-11'){
            	eaPromoCodeFlag = true;
            } else eaPromoCodeFlag = false;
        	*/
        	errorMessage = (eaPromoCodeFlag == true) ? $('#early_access_text').attr('value') : $('#generic_error_text').attr('value');
        	$(form.promoCode).addClass("error");
        	addErrorMessageToElement(document.forms.PromotionCodeForm, errorMessage);
        	if (eaPromoCodeFlag == true){
	        	$('#PromotionCodeForm input#promoCode.error, #PromotionCodeForm input#coupon-value.error').addClass('ea_input');
	        	$('#PromotionCodeForm .error-message').addClass('ea_message');
        	}
            restoreAjaxButton("WC_PromotionCodeDisplay_links_1");
            return;
        }else{
        /* END - Early Access */
        //TODO Commonize this 'if'
        
        if (isCarol){
            if (form.promoCode.value == "") {
                MessageHelper.formErrorHandleClient(form.promoCode.id, MessageHelper.messages["PROMOTION_CODE_EMPTY"]);
                return;
            }
        } else {
            var promoCodeValue = form.promoCode.value;
            $(form.promoCode).removeClass("error");
            removeErrorMessagesFromElement(document.forms.PromotionCodeForm);

            var errorMessage = "";

            if (promoCodeValue == ""){
                errorMessage = MessageHelper.messages["PROMOTION_CODE_EMPTY"];
            } else if (promoCodeValue.toUpperCase().includes("IDME_")){
                // Avoid users to manualy insert promocodes that could be valid IDME promocodes
                errorMessage = "Code not allowed";
            }

            if (errorMessage != "") {
                $(form.promoCode).addClass("error");
                addErrorMessageToElement(document.forms.PromotionCodeForm, errorMessage);
                restoreAjaxButton("WC_PromotionCodeDisplay_links_1");
                return;
            }
        }

        service = wcService.getServiceById('AjaxPromotionCodeManage');

        var params = [];
        params["taskType"] = "A";
        params["promoCode"] = trim(form.promoCode.value);
        params["storeId"] = WCParamJS.storeId;
        params["catalogId"] = WCParamJS.catalogId;
        params["langId"] = WCParamJS.langId;
        params["orderId"] = orderId;

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke('AjaxPromotionCodeManage', params);
    	}
    },


    /**
     * This function is used to remove a promotion code from the order.
     *
     * @param {String} promoCode    The promotion code to remove.
     */
    removePromotionCode: function (promoCode, orderId) {
        sessionStorage.removeItem('Order_DiscountCode');
        sessionStorage.removeItem('Order_DiscountName');
        var params = [];
        params["taskType"] = "R";
        params["promoCode"] = promoCode;
        params["storeId"] = WCParamJS.storeId;
        params["catalogId"] = WCParamJS.catalogId;
        params["langId"] = WCParamJS.langId;
        params["orderId"] = orderId;

       //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke('AjaxPromotionCodeDelete',params);

    },


    /**
     * If a customer has a coupon in his/her coupon wallet that has not been applied to an order then this function can be used to apply that coupon to the current order.
     *
     * @param {String} formName The name of the form that performs the action to apply the coupon, and holds the parameters to pass to the service.
     * @param {String} returnView The view to return to after the request has been processed.
     * @param {Integer} couponId The unique ID of the coupon. This is set into the form to be sent to the service.
     */
    applyCoupon: function (formName, returnView, couponId) {
        var form = document.forms[formName];
        form.setAttribute('action', 'CouponsAddRemove');
        form.couponId.value = couponId;
        form.taskType.value = "A";

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }

        service = wcService.getServiceById('AjaxCouponsAdd');
        service.setFormId(formName);
        cursor_wait();
        wcService.invoke('AjaxCouponsAdd');
    },


    /**
     * If a customer has a coupon in his/her coupon wallet that has been applied to an order then this function can be used to remove that coupon from the current order.
     *
     * @param {String} formName The name of the form that performs the action to remove the coupon from the order, and holds the parameters to pass to the service.
     * @param {String} returnView The view to return to after the request has been processed.
     * @param {Integer} couponId The unique ID of the coupon. This is set into the form to be sent to the service.
     */
    removeCouponFromOrder: function (formName, returnView, couponId) {
        var form = document.forms[formName];
        form.setAttribute('action', 'CouponsAddRemove');
        form.couponId.value = couponId;
        form.taskType.value = "R";

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }

        service = wcService.getServiceById('AjaxCouponsRemove');
        service.setFormId(formName);
        cursor_wait();
        wcService.invoke('AjaxCouponsRemove');
    },


    /**
     * Sets the SinglePageCheckout variable to indicate if the 'SinglePageCheckout' feature is enabled or disabled.
     *
     * @param {Boolean} singlePageCheckout. A true/false value that indicates if the 'SinglePageCheckout' feature is enabled.
     *
     * @see CheckoutHelperJS.isSinglePageCheckout
     */
    setSinglePageCheckout: function (singlePageCheckout) {
        this.singlePageCheckout = singlePageCheckout;
    },


    /**
     * Returns the singlePageCheckout variable that indicates if the 'SinglePageCheckout' feature is enabled/disabled.
     *
     * @returns {Boolean} singlePageCheckout A true/false value that indicates if the 'SinglePageCheckout' feature is
     * enabled/disabled.
     *
     * @see CheckoutHelperJS.setSinglePageCheckout
     */
    isSinglePageCheckout: function () {
        return this.singlePageCheckout;
    },


    /**
     * This function is used to submit the order by invoking the <code>AjaxSubmitOrder</code> service.
     *
     * @param {Integer} orderId The order ID.
     * @param {String} userType The type of the current user.
     * @param {String} addressListForMailNotification The list of emails separated by space. Order confirmation will be sent to these emails.
     * @param {boolean} isQuote Optional parameter which indicates whether it is a Quote that is being checked out. If this parameter is not passed then it defaults to false.
     */
    checkoutOrder: function (orderId, userType, addressListForMailNotification, isQuote) {
        if (isQuote == undefined || isQuote == null) {
            isQuote = false;
        }

        if (!this.isOrderPaymentFullyAllocated()) {
            return;
        }

        if (this.isOrderPrepared() == "false") {
            this.saveCheckoutOrderParameters(orderId, userType, addressListForMailNotification, isQuote);
            wcService.invoke("AjaxPrepareOrderForSubmit");
            return;
        }

        params = [];
        params["orderId"] = orderId;
        params["notifyMerchant"] = 1;
        params["notifyShopper"] = 1;
        params["notifyOrderSubmitted"] = 1;
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;

    var authToken = $("#PaymentsAndBill_authToken").val();
        params["authToken"] = authToken;
        var purchaseOrderForm = document.forms["purchaseOrderNumberInfo"];
        if (purchaseOrderForm) {
            var purchaseOrderNumber = purchaseOrderForm.purchase_order_number.value;
            if (purchaseOrderForm.purchaseOrderNumberRequired.value == 'true' && purchaseOrderForm.purchase_order_number.value == "") {
                MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number, MessageHelper.messages["ERROR_PONumberEmpty"]);
                return;
        }
            else if (!MessageHelper.isValidUTF8length(purchaseOrderForm.purchase_order_number.value, 128)) {
                MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number, MessageHelper.messages["ERROR_PONumberTooLong"]);
                return;
            }
        }
        params["purchaseorder_id"] = purchaseOrderNumber;
        if (userType == 'G') {
            //addressListForMailNotification contains list of emailId's spearated by space.. remove leading or trailing spaces..
            addressListForMailNotification = trim(addressListForMailNotification);

            //Get the space separated email list in an array...
            var emailList = [];
            emailList = addressListForMailNotification.split(" ");

            //Now from this array, remove repeated email Id's.. keep only unique email Id's
            var uniqueList = [];
            for (var j = 0; j < emailList.length; j++) {
                uniqueList[emailList[j]] = emailList[j];
            }

            //Get the total length of unique email id's list..
            var totalLength = 0;
            for (i in uniqueList) {
                totalLength = totalLength + 1;
            }

            //Convert the unique List array into comma separated values...
            var temp = "";
            var k = 0;
            for (i in uniqueList) {
                k = k + 1;
                temp = temp + uniqueList[i];
                if (k < totalLength) {
                    //If not last value, add , before next value..
                    temp = temp + ",";
                }
            }
            //For guest user send the email list..
            params["notify_EMailSender_recipient"] = temp;

            //setup sms phone for service
            var smsOrderNotificationCheckbox = document.getElementById("sendMeSMSNotification");
            if (smsOrderNotificationCheckbox != null && smsOrderNotificationCheckbox != "undefined") {
                if (smsOrderNotificationCheckbox.checked) {
                    var mobileCountryCode = document.getElementById("mobileCountryCode");
                    var mobilePhone1 = document.getElementById("mobilePhone1");
                    if (mobileCountryCode != null && mobileCountryCode != "undefined" && mobilePhone1 != null && mobilePhone1 != "undefined") {
                        params["SMS"] = mobileCountryCode.value + mobilePhone1.value;
                    }
                }
            }
        }


        //For handling multiple clicks
        /*
        if (!submitRequest()) {
            return;
        }
        */
        cursor_wait();

        if (!isQuote) {
            wcService.invoke("AjaxSubmitOrder", params);
        } else {
            params["URL"] = "";
            this.setOrderId(orderId);
            wcService.invoke("AjaxSubmitQuote", params);
        }
    },


    /**
     * Validates the scheduled start date and sets the cookies that are used to retrieve the start date and interval of a scheduled order.
     */
    prepareOrderSchedule: function () {
        if (document.getElementById("scheduleOrderInputSection") != null) {
            var scheduleOrderStartDateObj = $("#ScheduleOrderStartDate")[0];
            if (!this.validateDate(scheduleOrderStartDateObj, 'ScheduleOrderStartDate')) {
                return;
            }

            var interval = $("#ScheduleOrderFrequency").val();

            var key1 = "WC_ScheduleOrder_" + document.getElementById("orderIdToSchedule").value + "_strStartDate";
            var key2 = "WC_ScheduleOrder_" + document.getElementById("orderIdToSchedule").value + "_interval";

            if ((interval == "undefined") && (scheduleOrderStartDateObj.value == null)) {
                // if the order interval is '' and the specified start date is empty, remove the cookies
                   setCookie(key1, null, {expires: -1});
                   setCookie(key2, null, {expires: -1});
            } else {
                var t = $(scheduleOrderStartDateObj).datepicker("getDate");
                var now = new Date();

                t.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());

                // set start date in zulu time
                t = t.toISOString();
                setCookie(key1, t, {
                    path: "/",
                    domain: cookieDomain
                });
                setCookie(key2, interval, {
                    path: "/",
                    domain: cookieDomain
                });
            }
        }
    },


    /**
     * Schedules an order.
     *
     * @param {Integer} orderId The order ID of the scheduled order.
     * @param {String} isRecurring The flag to identify a recurring order.
     * @param {String} userType The type of the user.
     */
    scheduleOrder: function (orderId, isRecurring, userType) {
        if (!this.isOrderPaymentFullyAllocated()) {
            return;
        }
        if (userType === "G" && isRecurring) {
            MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_GUEST_USER_SUBMIT_RECURRING_ORDER"]);
            return;
        }
        var params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params["orderId"] = orderId;

    var authToken = $("#PaymentsAndBill_authToken").val();
        params["authToken"] = authToken;
        if (isRecurring != undefined && isRecurring == true) {
            params["startDate"] = getCookie("WC_ScheduleOrder_" + orderId + "_strStartDate");
            if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '1') {
                params["fulfillmentInterval"] = '1';
                params["fulfillmentIntervalUOM"] = 'DAY';
                params["timePeriod"] = '1';
                params["timePeriodUOM"] = 'DAY';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '2') {
                params["fulfillmentInterval"] = '1';
                params["fulfillmentIntervalUOM"] = 'DAY';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '3') {
                params["fulfillmentInterval"] = '1';
                params["fulfillmentIntervalUOM"] = 'WEE';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '4') {
                params["fulfillmentInterval"] = '2';
                params["fulfillmentIntervalUOM"] = 'WEE';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '5') {
                params["fulfillmentInterval"] = '3';
                params["fulfillmentIntervalUOM"] = 'WEE';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '6') {
                params["fulfillmentInterval"] = '4';
                params["fulfillmentIntervalUOM"] = 'WEE';
            }
        }
         else {
            params["strStartDate"] = getCookie("WC_ScheduleOrder_" + orderId + "_strStartDate");
            params["interval"] = getCookie("WC_ScheduleOrder_" + orderId + "_interval");
        }


        var purchaseOrderForm = document.forms["purchaseOrderNumberInfo"];
        if (purchaseOrderForm) {
            var purchaseOrderNumber = purchaseOrderForm.purchase_order_number.value;
            if (purchaseOrderForm.purchaseOrderNumberRequired.value == 'true' && purchaseOrderForm.purchase_order_number.value == "") {
                MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number, MessageHelper.messages["ERROR_PONumberEmpty"]);
                return;
            } else if (!MessageHelper.isValidUTF8length(purchaseOrderForm.purchase_order_number.value, 128)) {
                MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number, MessageHelper.messages["ERROR_PONumberTooLong"]);
                return;
            }
            params["purchaseorder_id"] = purchaseOrderNumber;
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        if (isRecurring != undefined && isRecurring == true) {
            wcService.invoke("SubmitRecurringOrder", params);
        } else {
            wcService.invoke("ScheduleOrder", params);
        }
    },


    /**
     * Checks if a date occurred in the past.
     *
     * @param {Object} dateObj The date object to be validated.
     * @param {String} elementId The ID of the element that an error message would be attached to.
     */
    validateDate: function (dateObj, elementId) {
        var now = new Date();
        if ($(dateObj).datepicker("getDate") != null && ($(dateObj).datepicker("getDate") - now < 0)) {
            //if the date is the current date, then it is valid
            if (now.toDateString() === $(dateObj).datepicker("getDate").toDateString()) {
                return true;
            }

            if ((elementId != null) && (document.getElementById(elementId) != null)) {
                MessageHelper.formErrorHandleClient(document.getElementById(elementId).id, MessageHelper.messages["PAST_DATE_ERROR"]);
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["PAST_DATE_ERROR"]);
            }
            return false;
        } else {
            return true;
        }
    },

    /**
     * Creates a new address during order check-out.
     *
     * @param {Integer} orderItemId The order item ID for a multiple shipment scenario, or 0 to indicate a shipping address needs to be created, or 1 to indicate a billing address needs to be created.
     * @param {String} addressType The type of the address to be created.
     */
    createAddress: function (orderItemId, addressType) {
        this.saveOrderItemsList(orderItemId, "-1");

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        var checkForOpera = true; //require a check of whether the browser is opera or not
        cursor_wait(checkForOpera);
        wcRenderContext.updateRenderContext('editShippingAddressContext', {
            'shippingAddress': '-1',
            'addressType': addressType
        });
        //Hide the mainContents (contains shipping/billing details, shop cart details, promotion details, orderDetails)
        this.showHideDivs('editAddressContents', 'mainContents');
    },


    /**
     * This function is used to show an area and hide an area on the current page.
     *
     * @param {String} showArea The ID of the area to show.
     * @param {String} hideArea The ID of the area to hide.
     *
     * @private
     */
    showHideDivs: function (showArea, hideArea) {
        document.getElementById(hideArea).style.display = "none";
        document.getElementById(showArea).style.display = "block";
    },


    /**
     * Restores the previous address details when a user cancels editing an existing address or cancels creating a new address.
     *
     * @see CheckoutHelperJS.cancelEditAddress
     */
    restorePreviousAddressDetails: function () {

        //For Ajax flow when the previous shipping address is not available in the array
        //Save the addresses present on server side only.. on change of address the server will be updated in ajax checkout..so can use
        //the address from server side only..
        if (this.shipmentTypeId == "2") {
            for (var i = 0; i < this.orderItemIds.length; i++) {
                //Get the orderItemId
                var orderItemId = this.orderItemIds[i];
                var element = document.getElementById("MS_ShipmentAddress_" + orderItemId);

                if (element != null && element.value == -1) {
                    //IF createAddress is selected in this box, then restore it to previously selected value..
                    element.value = document.getElementById("addressId_" + orderItemId).value;
                }
            }
        } else if (this.shipmentTypeId == "1") {
            var element = document.getElementById("singleShipmentAddress");
            if (element != null && document.getElementById("addressId_all")) {
                element.value = document.getElementById("addressId_all").value;
            }
        }

        //Restore the original billing address(es) that was updated on the server
        for (var i = 1; i < 4; i++) {
            //Find the payment forms that are present on the page
            if (document.getElementById("PaymentForm" + i) != null) {
                var paymentForm = document.getElementById("PaymentForm" + i);
                //Restore the selected billing address if it "create address" was selected
                if (paymentForm.billing_address_id.value == -1) {
                    paymentForm.billing_address_id.value = document.getElementById("selectedAddressId_" + i).value;
                }
                if (wcRenderContext.getRenderContextProperties("billingAddressDropDownBoxContext")["billingAddress" + i] == -1) {
                    wcRenderContext.getRenderContextProperties("billingAddressDropDownBoxContext")["billingAddress" + i] = paymentForm.billing_address_id.value;
                }
            }
        }
    },


    /**
     * This function is used when a user edits an existing shipping address during check-out.
     *
     * @param {String} addressSelectBoxName The ID of the address drop-down object.
     * @param {Integer} orderItemId The item ID. It is required in the a multiple shipment scenario.
     * @param {String} profileshipping The name of the quick checkout profile shipping address.
     * @param {String} profilebilling The name of the quick checkout profile billing address.
     */
    editAddress: function (addressSelectBoxName, orderItemId, profileshipping, profilebilling) {
        var addressBox = document.getElementById(addressSelectBoxName);

        //We need to save order Items having this addressId..bcs if user edits this address then the id of this address changes..
        //so all order items needs to be updated with new id.
        this.saveOrderItemsList(orderItemId, addressBox.value);

        // the quick checkout address nick name is hardcoded here..it should be same as that used in quick checkout profile page..
        if (addressBox.options[addressBox.selectedIndex].text == profileshipping || addressBox.options[addressBox.selectedIndex].text == profilebilling) {
            if (addressSelectBoxName != null) {
                MessageHelper.formErrorHandleClient(addressSelectBoxName, MessageHelper.messages["ERROR_QUICKCHECKOUT_ADDRESS_CHANGE"]);
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_QUICKCHECKOUT_ADDRESS_CHANGE"]);
            }
            return;
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        //Update the display area context..
        cursor_wait();
        wcRenderContext.updateRenderContext('editShippingAddressContext', {
            'shippingAddress': addressBox.value,
            'addressType': 'Shipping'
        });

        //Hide the mainContents (contains shipping/billing details, shop cart details, promotion details, orderDetails)
        this.showHideDivs('editAddressContents', 'mainContents');
    },


    /**
     * This function is used when a user edits an existing billing address during check-out.
     *
     * @param {Integer} orderItemId The item ID.
     * @param {Integer} paymentArea The payment area number that this billing address belongs to.
     * @param {String} profileshipping The name of the quick checkout profile shipping address.
     * @param {String} profilebilling The name of the quick checkout profile billing address.
     */
    editBillingAddress: function (orderItemId, paymentArea, profileshipping, profilebilling) {
        var form = document.forms["PaymentForm" + paymentArea];
        var addressBox = form.billing_address_id;
        //We need to save order Items having this addressId..bcs if user edits this address then the id of this address changes..
        //so all order items needs to be updated with new id..
        this.saveOrderItemsList(orderItemId, addressBox.value);
        // the quick checkout address nick name is hardcoded here..it should be same as that used in quick checkout profile page..
        if (addressBox.options[addressBox.selectedIndex].text == profileshipping || addressBox.options[addressBox.selectedIndex].text == profilebilling) {
            if (addressBox != null) {
                MessageHelper.formErrorHandleClient(addressBox, MessageHelper.messages["ERROR_QUICKCHECKOUT_ADDRESS_CHANGE"]);
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_QUICKCHECKOUT_ADDRESS_CHANGE"]);
            }
            return;
        }

        var billingAddressId = addressBox.value;
        var shippingAddressId = (document.getElementById("singleShipmentAddress")) ? document.getElementById("singleShipmentAddress").value : "noAddress";
        var addressType = (billingAddressId == shippingAddressId) ? "ShippingAndBilling" : "Billing";
        /*
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        */
        //Update the display area context..
        cursor_wait();
        wcRenderContext.updateRenderContext('editShippingAddressContext', {
            'shippingAddress': addressBox.value,
            'addressType': addressType
        });
        //Hide the mainContents (contains shipping/billing details, shop cart details, promotion details, orderDetails)
        this.showHideDivs('editAddressContents', 'mainContents');
    },

    /**
     * When a user cancels editing an address, this function is called to hide the address entry form and show the original main content of the page, then calls restorePreviousAddressDetails to restore the previous address.
     *
     * @see CheckoutHelperJS.restorePreviousAddressDetails
     */
    cancelEditAddress: function () {
        this.showHideDivs('mainContents', 'editAddressContents');
        this.restorePreviousAddressDetails();
        if (this.getLastAddressLinkIdToFocus() != null && this.getLastAddressLinkIdToFocus() != 'undefined' && this.getLastAddressLinkIdToFocus() != '') {
            document.getElementById(this.getLastAddressLinkIdToFocus()).focus();
            this.setLastAddressLinkIdToFocus('');
        }
    },

    /**
     * This function gets the shipment type Id for the order. Shipment type Id 1 is for single shipment, 2 for multiple shipment.
     *
     * @see CheckoutHelperJS.initializeShipmentPage
     */
    getShipmentTypeId: function () {
        return this.shipmentTypeId;
    },


    /**
     * Sets the dataDiry flag to indicate if payment information in the specified payment form area has been changed by the user.
     * This method should be used for payment methods involving credit card.
     * @param {Integer} paymentAreaNumber The unique payment area number.
     * @param {Boolean} flag A true/false value to indicate if the payment method input has been changed.
     *
     * @see CheckoutHelperJS.isPaymentDataDirty
     */
    paymentDataDirty: function (paymentAreaNumber, flag) {
        this.dataDirty[paymentAreaNumber] = flag;
        console.debug("Information in payment area " + paymentAreaNumber + " has been modified.");
    },

    /**
     * Returns the dataDiry flag that indicates if payment information in the specified payment form area has been changed by the user.
     *
     * @param {Integer} paymentAreaNumber The unique payment area number.
     *
     * @see CheckoutHelperJS.paymentDataDirty
     */
    isPaymentDataDirty: function (paymentAreaNumber) {
        return this.dataDirty[paymentAreaNumber];
    },


    /**
     * Sets fieldDirtyFlag to indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     *
     * @param {Boolean} value A true/false value that indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     *
     * @see CheckoutHelperJS.getFieldDirtyFlag
     */
    setFieldDirtyFlag: function (value) {
        this.fieldDirtyFlag = value;
    },


    /**
     * Returns fieldDirtyFlag that indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     *
     * @returns {Boolean} fieldDirtyFlag A true/false value that indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     *
     * @see CheckoutHelperJS.setFieldDirtyFlag
     */
    getFieldDirtyFlag: function () {
        return this.fieldDirtyFlag;
    },


    /**
     * Verifies if the dirty flag is set to true, such as when a customer changes shipping information. If the dirty
     * flag is set to true, a message displays prompting the customer to update their current order before they continue
     * to checkout. This function is used in a non-AJAX checkout flow.
     *
     * @return {Boolean} Return true if the dirty flag is set to true.
     */
    checkForDirtyFlag: function () {
        if (this.getFieldDirtyFlag()) {
            if (document.getElementById("ShoppingCart_NonAjaxUpdate") != null) {
                MessageHelper.formErrorHandleClient(document.getElementById("ShoppingCart_NonAjaxUpdate"), MessageHelper.messages["ERROR_UPDATE_FIRST_SHOPPING_CART"]);
                return true;
            } else if (document.getElementById("MultipleShipment_NonAjaxShipInfoUpdate") != null) {
                MessageHelper.formErrorHandleClient(document.getElementById("MultipleShipment_NonAjaxShipInfoUpdate"), MessageHelper.messages["ERROR_UPDATE_FIRST"]);
                return true;
            } else if (document.getElementById("SingleShipment_NonAjaxShipInfoUpdate") != null) {
                MessageHelper.formErrorHandleClient(document.getElementById("SingleShipment_NonAjaxShipInfoUpdate"), MessageHelper.messages["ERROR_UPDATE_FIRST"]);
                return true;
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_UPDATE_FIRST"]);
                return true;
            }
        }
        return false;
    },


    /**
     * This function is used to show or hide the SMS phone number field section for guest shoppers in the
     * order summary page.
     * @param {DOM Element Id} checkboxElementId The id of the checkbox for getting SMS order notifications.
     * @param {DOM Element Id} smsElementId The id of the element that contains the SMS phone number field.
     */
    showHideCheckoutSMS: function (checkboxElementId, smsElementId) {
        var smsOrderNotificationCheckbox = document.getElementById(checkboxElementId);
        if (smsOrderNotificationCheckbox != null && smsOrderNotificationCheckbox != "undefined") {
            if (smsOrderNotificationCheckbox.checked) {
                showElementById(smsElementId);
            } else {
                hideElementById(smsElementId);
            }
        }

    },

    /**
     * This function return an array of countries from a global variable called countries.
     * If that variable does not already exist then it will be created and populated from a JSON of country objects which should
     * have been loaded into a div on the page prior to calling this function.
     *
     * @returns {Array} countries An array of countries.
     **/
    getCountryArray: function () {
        //If the countries array does not already exist then create it.
        if (document["countries"] == null) {
            countries = new Array();
            var theDiv = document.getElementById("countryListSelectionHelper");

            if (typeof theDiv == 'undefined') return null;
            var divJSON = eval('(' + theDiv.innerHTML + ')');
            var countriesObject = divJSON.countries;

            for (var i = 0; i < countriesObject.length; i++) {
                var countryObject = countriesObject[i];
                countries[countryObject.code] = new Object();
                countries[countryObject.code].name = countryObject.displayName;
                countries[countryObject.code].countryCallingCode = countryObject.callingCode;

                if (countryObject.states.length > 0) {
                    countries[countryObject.code].states = new Object();
                    for (var j = 0; j < countryObject.states.length; j++) {
                        var state = countryObject.states[j];
                        countries[countryObject.code].states[state.code] = state.displayName;
                    }
                }
            }
        }

        return countries;
    },

    /**
     *  This function populates the country code to mobile phone based on the selected country.
     *  @param {string} countryDropDownId The id of the mobile country drop down list
     *  @param {string} countryCallingCodeId The id of the mobile country calling code text box.
     */
    loadCountryCode: function (countryDropDownId, countryCallingCodeId) {
        this.getCountryArray();
        var countryCode = document.getElementById(countryDropDownId).value;
        document.getElementById(countryCallingCodeId).value = countries[countryCode].countryCallingCode;
    },


    /**
     * Invokes the OrderShippingInfoUpdate service to expedite shipping for the selected order item.
     *
     * @param {DOM Element} checkBox The Expedite Shipping check-box object.
     * @param {String} inputOrderItemId The ID of the order item for which you want to expedite shipping.
     */
    expediteShipping: function (checkBox, inputOrderItemId) {

        var params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;

        if (checkBox.checked) {
            this.updateParamObject(params, "isExpedited", "true", true);
        } else {
            this.updateParamObject(params, "isExpedited", "false", true);
        }
        if (inputOrderItemId != null) {
            this.updateParamObject(params, "orderItemId", inputOrderItemId, false);
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderShippingInfoUpdate", params);
    },


    /************************************************************
     * The following methods are used on the Shopping Cart page
     ************************************************************/

    /**
     * This function updates the total on the shopping cart page when the quantity of an item has been changed.
     * It updates the total by calling <code>updateCart</code> after <code>updateWaitTimeOut</code> milliseconds have passed.
     *
     * @param {DOM Element} quantityBox The quantity input text field.
     * @param {Integer} orderItemId The ID of the order item to update.
     * @param {Object} event A keyboard event object.
     *
     * @see CheckoutHelperJS.updateCart
     */
    updateCartWait: function (quantityBox, orderItemId, event) {
        //Arrows are escaped for keyboard accesibility of table
        if (event.keyCode == KeyCodes.TAB ||
            event.keyCode == KeyCodes.DOWN_ARROW ||
            event.keyCode == KeyCodes.UP_ARROW ||
            event.keyCode == KeyCodes.LEFT_ARROW ||
            event.keyCode == KeyCodes.RIGHT_ARROW
        ) return;

        //Key pressed.. update the flag
        if (this.keyPressCount[orderItemId] == null && isNaN(this.keyPressCount[orderItemId])) {
            this.keyPressCount[orderItemId] = 0;
        }
        this.keyPressCount[orderItemId] = parseInt(this.keyPressCount[orderItemId]) + 1;
        setTimeout($.proxy(this, "updateCart", quantityBox, orderItemId, this.keyPressCount[orderItemId]), this.updateWaitTimeOut);
    },


    /**
     * This function updates the total on the shopping cart page when the quantity of an item has been changed.
     * It updates the shopping cart by calling the <code>AjaxUpdateOrderItem</code> service.
     *
     * @param {DOM Element} quantityBox The quantity input text field.
     * @param {Integer} orderItemId The ID of the order item to update.
     * @param {Integer} keyPressCountValue The count of keyPress events. If there are more keyPress events after this event was fired, then this function just returns without doing anything.
     */
    updateCart: function (quantityBox, orderItemId, keyPressCountValue) {
        if (keyPressCountValue < this.keyPressCount[orderItemId]) {
            //User has pressed one more key..that key press call will update the server..no work for me..
            return;
        }

        var quantity = (quantityBox.value);
        if (!isNonNegativeInteger(quantity)) {
            TealeafWCJS.createExplicitChangeEvent(quantityBox.id);
            MessageHelper.formErrorHandleClient(quantityBox, MessageHelper.messages["QUANTITY_INPUT_ERROR"]);
        } else {
            //Its a positive valid number > 0...Update the qty at server side..
            if (!isChrome()) {
                TealeafWCJS.createExplicitChangeEvent(quantityBox.id);
            }
            var params = [];
            params.orderId = ".";
            params["storeId"] = this.storeId;
            params["catalogId"] = this.catalogId;
            params["langId"] = this.langId;
            if (this.shoppingCartPage) {
                params.calculationUsage = "-1,-2,-5,-6,-7";
                params.inventoryValidation = "true";
            } else {
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";
            this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
            this.updateParamObject(params, "quantity", quantity, false, -1);

            //For handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            cursor_wait();

            if (quantity == 0) {
                var x = document.getElementById("totalNumberOfItems").value;
                var y = x;
                //Now remove free items from this total number of items count..
                //x = total items and y = totalItems - totalFreeItems
                for (var i = 0; i < x; i++) {
                    var qtyObj = document.getElementById("freeGift_qty_" + (i + 1));
                    if (qtyObj != null || qtyObj != undefined) {
                        qty = qtyObj.value;
                        if (qty != null && qty != undefined && qty == -1) {
                            y = y - 1;
                        }
                    }

                }

                if (y == 1) {
                    wcService.invoke("AjaxUpdateOrderItem1", params);
                } else {
                    wcService.invoke("AjaxUpdateOrderItem", params);
                }
            } else {
                wcService.invoke("AjaxUpdateOrderItem", params);
            }
        }
    },


    /**
     * Validates the quantity of all items on the 'Shopping Cart' page.
     * @param {DOM Element} form The form object that contains the table of order items.
     */
    updateShoppingCart: function (form) {

        MessageHelper.hideAndClearMessage();
        var totalItems = document.getElementById("totalNumberOfItems").value;
        if (totalItems != null) {
            for (var i = 0; i < totalItems; i++) {
                var quantity = null;
                if (form != undefined) {
                    quantity = form["quantity_" + (i + 1)];
                } else if (document.getElementById("qty_" + (i + 1)) != null) {
                    quantity = document.getElementById("qty_" + (i + 1));
                }
                //Update qty for all items
                if (quantity != null || quantity != undefined) {
                    var v = quantity.value;
                    if (!isNonNegativeInteger(v)) {
                        MessageHelper.formErrorHandleClient(quantity.id, MessageHelper.messages["QUANTITY_INPUT_ERROR"]);
                        return;
                    }
                }

            }
            return true;
        } else {
            console.debug("error: element 'totalNumberOfItems' was expected but undefined.");
            return;
        }
    },

    /**
     * If the shopper has selected to perform a recurring order in the shopping cart page, this function is used to
     * validate that all conditions for creating a recurring order are met:
     * - make sure it is a registered shopper
     * - make sure that the order does not have order items that are non-recurring (i.e disallowRecurringOrder flag set to 1)
     *
     * @param {String} userType The user type of the current user, either G (guest shopper) or R (registered shopper).
     */
    canCheckoutContinue: function (userType) {
        if ( (document.getElementById("recurringOrder") && document.getElementById("recurringOrder").checked) && ((document.getElementById("shipTypeOnline") && document.getElementById("shipTypeOnline").checked) || document.getElementById("shipTypeOnline") == null)) {
            if (document.getElementById("nonRecurringOrderItems") && document.getElementById("nonRecurringOrderItems").value != "") {
                MessageHelper.displayErrorMessage(MessageHelper.messages["RECURRINGORDER_ERROR"]);
                return false;
            } else if (userType != undefined && userType === "G") {
                MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_GUEST_USER_SUBMIT_RECURRING_ORDER"]);
                return false;
            }
        }
        return true;
    },

    /**
     *
     * validate the login fields
     *
     */
    validateLoginFields: function(){
        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
        var emailField = $("#WC_CheckoutLogon_FormInput_logonId")
            , passwordField = $("#WC_CheckoutLogon_FormInput_logonPassword")
            , hasError = false;

        //TODO Commonize this 'if'
        if (isOliver){

            emailField.parent().removeClass("field-error-message");
            passwordField.parent().removeClass("field-error-message");
            if(emailField.val() == "" && passwordField.val() == ""){
                emailField.parent().addClass("field-error-message");
                passwordField.parent().addClass("field-error-message");
                hasError = true;
            }
            if(emailField.val() == ""){
                emailField.parent().addClass("field-error-message");
                hasError = true;
            }
            if(passwordField.val() == ""){
                passwordField.parent().addClass("field-error-message");
                hasError = true;
            }
            if(!validateEmail(emailField.val().trim())){
                emailField.parent().addClass("field-error-message");
                hasError = true;
            }

        } else {

            if(emailField.val() == "" && passwordField.val() == ""){
                emailField.addClass("field-error-message");
                passwordField.addClass("field-error-message");
                hasError = true;
            }
            if(emailField.val() == ""){
                emailField.addClass("field-error-message");
                hasError = true;
            }
            if(passwordField.val() == ""){
                passwordField.addClass("field-error-message");
                hasError = true;
            }
            if(!validateEmail(emailField.val())){
                emailField.addClass("field-error-message");
                hasError = true;
            }
        }

        if(hasError){
            return false;
        }
        return true;
    },
    /**
     * Updates the shopping cart in a 'quick check-out' scenario by invoking the <code>QuickCheckOutOrderCopy</code> service.
     *
     * @param {Integer} quickOrderId The ID of the quick check-out order.
     */
    updateCartWithQuickCheckoutProfile: function (quickOrderId) {
        var postRefreshHandlerParameters = [];
        var initialURL = "AjaxRESTOrderCopy";
        var urlRequestParams = [];
        urlRequestParams["storeId"] = this.storeId;
        urlRequestParams["catalogId"] = this.catalogId;
        urlRequestParams["langId"] = this.langId;
        urlRequestParams.toOrderId = ".";
        urlRequestParams["shippingAddressFromOrderProfile"] = "1";
        urlRequestParams["shippingModeFromOrderProfile"] = "1";
        urlRequestParams["URL"] = "dummy";
        urlRequestParams["payInfoFrom"] = quickOrderId;

        postRefreshHandlerParameters.push({"URL":"AjaxRESTOrderPrepare", "requestParams":{"orderId":"."}});
        postRefreshHandlerParameters.push({"URL":"OrderShippingBillingView","requestType":"GET", "requestParams":{"quickCheckoutProfileForPayment":"true"}});
        var service = getCustomServiceForURLChaining(initialURL,postRefreshHandlerParameters,null);

        //For handling multiple clicks
        if(!submitRequest()){
            return;
        }
        cursor_wait();

        wcService.invoke(service.getParam("id"), urlRequestParams);
    },


    /************************************************************
     * End Shopping Cart page specific functions
     ************************************************************/



    /**************************************************************
     * The following methods are used on the Single Shipment page
     **************************************************************/

    /**
     * Helper function used for adding a new shipping address in a single shipment scenario.
     *
     * @param {String} addressType The type of the selected address.
     */
    addNewShippingAddress: function (addressType) {
        this.displayAddressDetails(-1, addressType);
    },

    /**
     * This function is used to update the address of all order items in a single shipment checkout-out scenario.
     *
     * @param {DOM Element} addressSelectBox The select drop-down object that contains all available addresses.
     */
    updateAddressForAllItems: function (addressSelectBox) {
        //Save it in local array..
        if (addressSelectBox.value != -1) {
            this.selectedAddressesArray[addressSelectBox.name] = addressSelectBox.value;
        }

        var addressId = addressSelectBox.value;
        if (addressId == -1) {
            return;
        }
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        var addressId = document.getElementById("singleShipmentAddress").value;
        this.updateParamObject(params, "addressId", addressId, false);
        if (typeof updateGiftRegistrantAddressForItemsExt != "undefined" && typeof updateGiftRegistrantAddressForItemsExt != null) {
            params = updateGiftRegistrantAddressForItemsExt(params, addressId);
        }

        var enabledShipInstructions = false;
        var shipInstructions;

        //Check if Shipping Instructions is enabled
        if (document.getElementById("shipInstructions") != null) {
            shipInstructions = document.getElementById("shipInstructions").value;

            reWhiteSpace = new RegExp(/^\s+$/);
            if (reWhiteSpace.test(shipInstructions)) {
                shipInstructions = "";
            }
            enabledShipInstructions = true;
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        //If Shipping Instructions is enabled & there are some shipping instructions entered
        //Update both the shipping address and shipping instructions
        //Else only update shipping address
        if (!enabledShipInstructions || shipInstructions == undefined || shipInstructions == "") {
            wcService.invoke("OrderItemAddressShipMethodUpdate", params);
        } else {
            wcService.invoke("OrderItemAddressShipInstructionsUpdate", params);
        }
    },


    /**
     * This function is used to update the shipping mode of all order items in a single shipment checkout-out scenario.
     *
     * @param {DOM Element} addressSelectBox The select drop-down object that contains all available shipping modes.
     */
    updateShipModeForAllItems: function (shipmentSelectBox) {

        var shipModeId = shipmentSelectBox.value;
        if (shipModeId == -1) {
            return;
        }
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        this.updateParamObject(params, "shipModeId", shipModeId, false);

        if (isCarol && typeof addressId !== 'undefined') {
            this.updateParamObject(params, "addressId", addressId, false);
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },


    /**
     * This function updates the shipping instruction for items in the order. It is used in a single shipment check-out scenario.
     * It calls the <code>OrderShippingInfoUpdate</code> service.
     */
    updateShippingInstructionsForAllItems: function () {

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";

        var orderItemId = null;
        var shipInstructions = document.getElementById("shipInstructions").value;

        reWhiteSpace = new RegExp(/^\s+$/);
        if (reWhiteSpace.test(shipInstructions)) {
            shipInstructions = "";
        }

        //Validate the length of the shipping instructions
        if (!MessageHelper.isValidUTF8length(shipInstructions, 4000)) {
            MessageHelper.formErrorHandleClient(document.getElementById("shipInstructions").id, MessageHelper.messages["ERROR_ShippingInstructions_TooLong"]);
            return;
        }

        orderItemId = document.getElementById("orderItem_1").value;
        this.updateParamObject(params, "orderItemId", orderItemId, false);
        this.updateParamObject(params, "shipInstructions", shipInstructions, false);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderShippingInfoUpdate", params);
    },

    /**
     * Updates the shipping charge type and account number for items in the order. This method calls the
     * <code>OrderShippingInfoUpdate</code> service and is used in both single and multiple shipment checkout scenarios.
     *
     * @param {Integer} curOrderId The order ID of the current order.
     * @param {Integer} shipModeId The ID of the shipping mode to which shipping charge applies.
     * @param {String} shipChargeType Shipping charge type selected for the shipmode.
     * @param {Integer} shipAcctNum The account number that is used when the selected shipping charge type is Charge by Carrier.
     */
    updateShippingChargeForShipModeAjax: function (curOrderId, shipModeId, shipChargeType, shipAcctNum) {

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = curOrderId;
        params.URL = "";
        params["shipModeId"] = shipModeId;
        params["shipChargTypeId"] = shipChargeType;

        // ship account number is optional field for shipping charge, if it is not specified, pass in empty
        if (shipAcctNum != null && typeof shipAcctNum !== 'undefined') {
            params["shipCarrAccntNum"] = shipAcctNum;
        } else {
            params["shipCarrAccntNum"] = "";
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxOrderShipChargeUpdate", params);
    },


    /**
     * Hides the account number field for the selected in shipping charge. If the charge by seller charge
     * type is selected, account field should not be shown.
     * @param {object} selectValue The HTML element of the shipping charge type selection
     * @param {object} acctFieldId The HTML element of the account number field
     */
    hideShipChargeAccountField: function (selectValue, acctFieldId) {

        if (document.getElementById(selectValue).value.indexOf("ByCarrier") > -1) {
            document.getElementById(acctFieldId).style.display = 'block';
        } else {
            document.getElementById(acctFieldId).style.display = 'none';
        }
    },

    /**
     * This function validates the specified requested shipping date then calls {@link CheckoutHelperJS.updateShippingDateForAllItems}
     * to update the date for all items in the current order in a single shipment scenario.
     *
     * @param {datepicker} jsDate The jQuery datepicker object containing the requested shipping date specified by the user.
     *
     * @see CheckoutHelperJS.updateRequestedShipDateForThisItem
     */

    updateRequestedShipDate: function (jsDate) {
        if (jsDate == null || jsDate.value == "")
            return;

        var t = "";
        if (jsDate.value != "") {
            t = this.formatRequestedShipDate(jsDate);
        } else {
            t = this.resetRequestedShipDateValue;
        }

        this.updateShippingDateForAllItems(t);
    },


    /**
     * This function updates the requested shipping date for all items in the order. It is called by {@link CheckoutHelperJS.updateRequestedShipDate}.
     * It calls the <code>OrderItemAddressShipMethodUpdate</code> service.
     *
     * @param {String} date The String representation of the date object, see {@link CheckoutHelperJS.updateRequestedShipDate}.
     */
    updateShippingDateForAllItems: function (date) {
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        this.updateParamObject(params, "requestedShipDate", date, false);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },


    /**
     * Displays the details of an address in a single shipment check-out scenario.
     *
     * @param {String} addressSelectBoxValue The value, i.e. address ID, of the input address select drop-down object.
     * @param {String} addressType The type of the selected address.
     */
    displayAddressDetails: function (addressSelectBoxValue, addressType) {
        //Display selected address details..
        if (addressSelectBoxValue != -1) {
            //For handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            var checkForOpera = true; //require a check of whether the browser is opera or not
            cursor_wait(checkForOpera);
            wcRenderContext.updateRenderContext('shippingAddressContext', {
                'shippingAddress': addressSelectBoxValue
            });
        } else {
            this.createAddress(-1, addressType);
        }
    },


    /************************************************************
     * End Single Shipment page specific functions
     ************************************************************/


    /****************************************************************
     * The following methods are used on the Multiple Shipment page
     ****************************************************************/

    /**
     * This function is used to move all order items into a single shipment when a shopper changes the order from multiple shipment check-out to single shipment.
     * The shipping information of the first item in the order will be used for all items after this update.
     * It calls the <code>OrderItemAddressShipMethodUpdate1</code> service to update the order.
     */
    moveAllItemsToSingleShipment: function () {
        //Get the first orderItem id..
        var orderItemId = document.getElementById("orderItem_1").value;
        //Now get the addressId and shipModeId of this orderItemId...
        var addressId = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
        //Update the shipModeId and addressId of all the items present in currentOrder...

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";

      // FIX LATER TODO
        var requestedShipDate = $("#MS_requestedShippingDate_" + orderItemId);
        if (requestedShipDate == undefined) {
            requestedShipDate = document.getElementById("MS_requestedShippingDate_" + orderItemId);
            if (requestedShipDate != null && requestedShipDate != 'undefined') {
                if (requestedShipDate.value != "") {
                    params.requestedShipDate = requestedShipDate.value;
                } else {
                    params.requestedShipDate = this.resetRequestedShipDateValue;
                }
            }
        }

        var requestedShipDateCheckbox = document.getElementById("MS_requestShippingDateCheckbox_" + orderItemId);
        if (requestedShipDateCheckbox != null && requestedShipDateCheckbox != 'undefined') {
            if (requestedShipDateCheckbox.checked) {
                if (requestedShipDate.value != "") {
                    params.requestedShipDate = this.formatRequestedShipDate(requestedShipDate);
                } else {
                    params.requestedShipDate = this.resetRequestedShipDateValue;
                }
            } else {
                params.requestedShipDate = this.resetRequestedShipDateValue;
            }
        }

        //addressId -3 is reserved for gift registry "Registrant" address.
        if (addressId == -3) {
            var totalItems = document.getElementById("totalNumberOfItems").value;
            for (var i = 2; i <= totalItems; i++) {
                if (document.getElementById("orderItem_" + i) != null && document.getElementById("orderItem_" + i) != 'undefined') {
                    var giftOrderItemId = document.getElementById("orderItem_" + i).value;
                    var validAddressId = document.getElementById("MS_ShipmentAddress_" + giftOrderItemId).value;
                    if (validAddressId != -3) {
                        this.updateParamObject(params, "addressId", validAddressId, false);
                        break;
                    }
                } else {
                    break;
                }
            }
        } else {
            this.updateParamObject(params, "addressId", addressId, false);
        }
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate1", params);
    },


    /**
     * Helper function for adding an address on the multiple shipment 'Shipping & Billing' page.
     * @param (Integer) orderItemId The ID of the order item.
     */
    addNewShippingAddressForMS: function (orderItemId) {
        this.updateAddressIdForThisItem(-1, orderItemId);

        this.orderItemIds = []; //Reset this.orderItemIds. So that previous edit/create address doesn't have effect on the new create/edit address
        //now save the orderItemId, so we can update that orderItem with the newly created addressId

        //now save the orderItemId, so we can update that orderItem with the newly created addressId
        this.orderItemIds.push(orderItemId);
    },


    /**
     * Updates the address ID for an order item in a multiple shipment check-out scenario.
     * It is used when a different address is selected from the drop down.
     * It calls the <code>OrderItemAddressShipMethodUpdate</code> service to update.
     *
     * @param {String} addressBoxValue The value, i.e. address ID, of the input select drop-down object that contains all available addresses.
     * @param {Integer} orderItemId The order item ID.
     */
    updateAddressIdForThisItem: function (addressBoxValue, orderItemId) {
        //Save it in local array..
        if (addressBoxValue != -1) {
            var addressBox = document.getElementById("MS_ShipmentAddress_" + orderItemId);
            this.selectedAddressesArray[addressBox.name] = addressBoxValue;
        }
        if (addressBoxValue == -1) return;

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";
        var addressId = addressBoxValue;
        this.updateParamObject(params, "shipToRegistrant", "0", false, -1)
        this.updateParamObject(params, "addressId", addressId, false, -1);
        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
        if (typeof updateGiftRegistrantAddressForThisItemExt != "undefined" && typeof updateGiftRegistrantAddressForThisItemExt != null) {
            params = updateGiftRegistrantAddressForThisItemExt(params, addressId);
        }
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },


    /**
     * Updates the shipping mode for an item in the order. It is used in a multiple shipment scenario.
     * It calls the <code>OrderItemAddressShipMethodUpdate</code> service.
     *
     * @param {DOM Element} shipModeBox The select drop-down object that contains all available shipping modes.
     * @param {Integer} orderItemId The ID of the order item to update.
     */
    updateShipModeForThisItem: function (shipModeBox, orderItemId) {
        var shipModeId = shipModeBox.value;
        if (shipModeId == -1) {
            return;
        }
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
        this.updateParamObject(params, "shipModeId", shipModeId, false, -1);
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },


    /**
     * Updates the shipping instruction for an item. It is used in a multiple shipment scenario.
     * It calls the <code>OrderShippingInfoUpdate</code> service.
     *
     * @param {DOM Element} textArea The input text area for shipping instruction.
     * @param {Integer} orderItemId The ID of the order item to update.
     */
    updateShippingInstructionsForThisItem: function (textArea, orderItemId) {
        var addressId = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
        var shipModeId = document.getElementById("MS_ShippingMode_" + orderItemId).value;
        var shipInstructions = textArea.value;

        reWhiteSpace = new RegExp(/^\s+$/);
        if (reWhiteSpace.test(shipInstructions)) {
            shipInstructions = "";
        }

        //Validate the length of the shipping instructions
        if (!MessageHelper.isValidUTF8length(shipInstructions, 4000)) {
            MessageHelper.formErrorHandleClient(textArea.id, MessageHelper.messages["ERROR_ShippingInstructions_TooLong"]);
            return;
        }

        this.setShippingInstuctionsForAllOtherItems(addressId, shipModeId, shipInstructions);

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";

        this.updateParamObject(params, "addressId", addressId, false, -1);
        this.updateParamObject(params, "shipModeId", shipModeId, false, -1);
        this.updateParamObject(params, "shipInstructions", shipInstructions, false, -1);
        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderShippingInfoUpdate", params);
    },


    /**
     * This function updates the requested shipping date for the current item in a multiple shipment check-out scenario.
     * It invokes the <code>OrderItemAddressShipMethodUpdate</code> service.
     *
     * @param {datepicker} jsDate The jQuery datepicker object containing the requested shipping date specified by the user.
     * @param {Integer} orderItemId The ID of the order item to update.
     */
    updateRequestedShipDateForThisItem: function (jsDate, orderItemId) {
        if (jsDate == null || jsDate.value == "")
            return;

        var t = "";
        if (jsDate.value != "") {
            t = this.formatRequestedShipDate(jsDate);
        } else if (jsDate.value == "") {
            t = this.resetRequestedShipDateValue;
        }

        var addressId = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
        var shipModeId = document.getElementById("MS_ShippingMode_" + orderItemId).value;

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
        this.updateParamObject(params, "requestedShipDate", t, false, -1);
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        CheckoutHelperJS.RequestShippingDateAction = true;
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },

    /**
     * This function formats the requested shipping date from the jQuery datepicker object into a GMT date string.
     *
     * @param {datepicker object} jsDate The jQuery datepicker object containing the requested shipping date specified by the user.
     * @return {string} String representation of the requested ship date in GMT.
     */
    formatRequestedShipDate: function (jsDate) {
        var date = $(jsDate).datepicker("getDate");
        //Set the time to 12pm to handle cases where daylight savings cause a date shift
        date.setHours(12);
        return date.toISOString();
    },


    /**
     * This function is used to bring up the address entry form when a user wants to create a new address for an item in a multiple shipment scenario.
     *
     * @param {Integer} orderItemId The ID of the order item to update.
     * @param {String} addressType The type of address to create.
     *
     * @private
     */
    createAddressForMS: function (orderItemId, addressType) {
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }

        cursor_wait();
        wcRenderContext.updateRenderContext('editShippingAddressContext', {
            'shippingAddress': '-1',
            'addressType': addressType
        });
        //Hide the mainContents (contains shipping/billing details, shop cart details, promotion details, orderDetails)
        this.showHideDivs('editAddressContents', 'mainContents');
    },


    /**
     * Helper function for adding a new address in a multiple shipment scenario.
     *
     * @param (Integer) orderItemId The ID of the item.
     * @param (String) addressType The type of the selected address.
     */
    displayAddressDetailsForMSHelper: function (orderItemId, addressType) {
        this.displayAddressDetailsForMS(-1, orderItemId, addressType);
    },


    /**
     * Displays the details of an address in a multiple shipment check-out scenario.
     *
     * @param {String} addressSelectBoxValue The value, i.e. address ID, of the input address select drop-down object.
     * @param {Integer} orderItemId The order item ID.
     * @param {String} addressType The type of the selected address.
     */
    displayAddressDetailsForMS: function (addressSelectBoxValue, orderItemId, addressType) {
        if (addressSelectBoxValue == -1) {
            this.createAddressForMS(orderItemId, addressType);
        }
    },


    /**
     * This function is used to show or hide the edit address link in multiple and single shipment page.
     * @param {DOM Element} addressSelectBox The select drop-down object that contains all available addresses.
     * @param {String} orderItemId The id of the orderItem for which the edit address link is displayed/hidden.
     */

    showHideEditAddressLink: function (addressSelectBox, orderItemId) {
        if (addressSelectBox.value == '-3') {
            if ($("#editAddressLink_" + orderItemId).length) {
                $("#editAddressLink_" + orderItemId).css("display", "none");
            }
            return;
        }
        var orgAddressList = document.getElementById("shippingOrganizationAddressList");
        if (orgAddressList) {
            var orgAddressArray = [];
            orgAddressArray = orgAddressList.value.toString().split(",");
            for (var i = 0; i < orgAddressArray.length; i++) {
                if ($("#editAddressLink_" + orderItemId).length) {

                    if (addressSelectBox.value == orgAddressArray[i]) {
                        $("#editAddressLink_" + orderItemId).css("display", "none");
                        break;
                    } else {
                        $("#editAddressLink_" + orderItemId).css("display", "block");
                    }
                }
            }
        } else {
            if ($("#editAddressLink_" + orderItemId).length) {
                $("#editAddressLink_" + orderItemId).css("display", "block");
            }
        }
    },

    /**
     * This function is used to show or hide the dialog for estemated tax in shopping cart.
     */

    showHideEstematedTaxDialog: function (flag) {
        //TODO Commonize this 'if'
        if (!isOliver && !isCarol){
            var position = $('#wcs-calculate-tax').offset();
            var yOffset = position.top  + 20;
            var xOffset = position.left - 180;
            if ($( window ).width() < 650) {
                yOffset = position.top -60;
                xOffset = 0;
            }
            $("#wcs_calTax_notification").css({top: yOffset, left: xOffset});
        }
        $(".enter-zipcode").css("display","table-row");
        

        if (flag){
            $("#wcs_calTax_notification").show();
            if(isOliver || isPersol){
                $("#wcs-calculate-tax-close").show();
                $("#wcs-calculate-tax").hide();
            }
        }
        else{
            $("#wcs_calTax_notification").hide();
            
            if(isOliver || isPersol){
                $("#tax-calculation-form").hide();
                $("#wcs-calculate-tax-close").hide();
                $("#wcs-calculate-tax").show();
            }
        }
    },

    /**
     * calls google service to autofill city provence by zip code
     */
    calculateEstematedTax : function(zipCode, country, lang, isCheckOut, isZipCodeChange, strName) {
        if (isCarol){
            if ($("#WC_UnregisteredCheckout_links_4").length>0){
                showLoadingInternal(true,'WC_UnregisteredCheckout_links_4');
            }
        }

        var zipcode = "";
        var langId = "";
        var countryCode = null;
        var isZipChange = false;
        var storeName = "";

        if(isCheckOut){
            zipcode = zipCode;
            langId = lang;
            countryCode = country;
            isZipChange = isZipCodeChange;
            storeName = strName;
        } else {
            zipcode = $('#wcs_calTax_notification #zip_code').val();
            langId = $('#wcs_calTax_notification #langId').val();
            countryCode = $('#wcs_calTax_notification #country_value').val();

            //TODO Commonize this 'if'
            if (isOliver || isCarol){
                $("#zipCodeDiv").removeClass('error');
                $("#zipCodeDiv .input-style").removeClass('error');
                if (!zipcode.match($('#wcs_calTax_notification #zip_code').attr('data-pattern')) ) {
                    // display error message
                    $("#zipCodeDiv").addClass('error');
                    $("#zipCodeDiv .input-style").addClass('error');
                    restoreAjaxButtons();
                    return false;
                }
            } else {
                $("#wcs_calTax_notification .wcs-error-message").hide();
                if (zipcode.length <5 ) {
                    // display error message.
                    $("#wcs_calTax_notification .wcs-error-message").show();
                    restoreAjaxButtons();
                    return false;
                }
            }

            /* START - Checkout 3.0 */
            //  Force recalculation of taxes when coming back from Shipping Page (it was not possible in previous checkout)
            if ((isOliver || isPersol) && this.zipCountShoppingCart < 1 && $('.tax .total_figures .amount').text().trim() != null && $('.tax .total_figures .amount').text().trim() != '') {
                this.zipCountShoppingCart++;
            }
            /* END - Checkout 3.0 */

            if(this.zipCountShoppingCart >= 1){
                isZipChange = true;
            }else{
                this.zipCountShoppingCart++;
            }

            if (!isOliver && !isCarol){
                setCurrentId('wcs-tax-button_a');
            }
        }

        //HB-2302 BEGIN Use google address common interface
        getGoogleAddress(countryCode, zipcode, langId, function(result){
            if (result.status == "error"){
                console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (GoogleAPI)");
                MessageHelper.displayErrorMessage("There was a problem while retrieving data from Google Maps API");
                if(isCheckOut){
                    CheckoutHelperJS.updateOrderSummary(isCheckOut);
                } else {
                    /* CHECKOUT 3.0 - mustache obj for checkout summary for PO/OP */
                    if (isPersol || isOliver) {
                        ajaxCallCart();
                    } else {
                        CheckoutHelperJS.showHideEstematedTaxDialog(false);
                        CheckoutHelperJS.updateOrderSummary();
                    }  
                }

            } else {
                var city = result.address.city;
                var state = result.address.prov_state_short;
                var zipcode = result.address.zipcode;
                var country = result.address.country_short;

                // submit AjaxOrderCalculate request
                var params = [];

                params.storeId      = ServicesDeclarationJS.storeId;
                params.catalogId    = ServicesDeclarationJS.catalogId;
                params.langId       = ServicesDeclarationJS.langId;

                params.updatePrices = "0";
                if(isCheckOut){
                    params.orderId = ".";
                } else {
                    params.orderId = $('#wcs_calTax_notification #orderId').val();
                }

                params.addressFlag = true;
                params.isDeliveryAddressAdded = false;
                params.zipCode = zipcode != null ? zipcode : "";
                params.city = city != null ? city : "";
                params.state = state != null ? state : "";
                params.country = country;
                params.isZipChange = isZipChange;

                var url = getAbsoluteURL() + "AjaxOrderCalculate?";
                for (var param  in params) {
                    url += param + "=" + params[param] + "&";
                }
                url += "calculationUsageId=-1&";
                url += "calculationUsageId=-2&";
                url += "calculationUsageId=-3&";
                url += "calculationUsageId=-4";

                //Make the call to AjaxOrderCalculate
                $.ajax({
                    url: url,
                    type: 'POST',
                    success: function (data) {
                        // refresh the area.
                        if(isCheckOut){
                            var url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/person/@self/contact";
                            $.ajax({
                                url: url,
                                type: 'GET',
                                headers: {
                                    "Content-Type": "application/json",
                                    "Cache-Control": "no-cache, no-store, must-revalidate"
                                },
                                data: {
                                    "timestamp": Date.now()
                                },
                                success: function (data) {
                                    if(data != undefined && data.contact != undefined){
                                        for(var i = 0; i < data.contact.length; i++){
                                            if(data.contact[i].addressType === "Billing"){
                                                setCookie("addressId_formB_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }else if(data.contact[i].addressType === "Shipping"){
                                                setCookie("addressId_formS_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }else{
                                                setCookie("addressId_formS_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                                setCookie("addressId_formB_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }
                                        }
                                    }
                                },
                                error: function(data){
                                    console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (contact)");
                                    MessageHelper.displayErrorMessage("There was a problem while retrieving current user contact data.");
                                    console.log(data);
                                },
                                complete: function(){
                                }
                            });
                            CheckoutHelperJS.updateOrderSummary(isCheckOut);
                        } else {
                            CheckoutHelperJS.showHideEstematedTaxDialog(false);
                            /* CHECKOUT 3.0 - mustache obj for checkout summary for PO/OP */
                            if (isPersol || isOliver) {
                                ajaxCallCart();
                            } else {
                                CheckoutHelperJS.updateOrderSummary();
                            }
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (AjaxOrderCalculate)");
                        MessageHelper.displayErrorMessage("There was a problem while retrieving data from taxes calculation service.");

                        if(isCheckOut){
                            CheckoutHelperJS.updateOrderSummary(isCheckOut);
                        } else {
                            CheckoutHelperJS.showHideEstematedTaxDialog(false);
                            /* CHECKOUT 3.0 - mustache obj for checkout summary for PO/OP */
                            if (isPersol || isOliver) {
                                ajaxCallCart();
                            } else {
                                CheckoutHelperJS.updateOrderSummary();
                            }
                        }
                    }
                });
            }
        });
        //HB-2302 END
    },

    /* NEW */
    calculateTaxesFromZipCode : function(zipCodeFormField) {
        var isCheckOut = (document.querySelectorAll("#page.checkout").length != 0 ||$("#page.checkout-page").length != 0)

        var zipCodeFormFieldId = zipCodeFormField.id;
        /*
        var countryId = zipCodeFormFieldId.replace("_zipCode_","_country_");
        var stateId = zipCodeFormFieldId.replace("_zipCode_","_state_");
        var cityId = zipCodeFormFieldId.replace("_zipCode_","_city_");
        */

        //HB-2302 BEGIN Use google address common interface
        getGoogleAddress(countryCode, zipCodeFormField.value, storeLanguage, function(result){
            if (result.status == "error"){
                console.log("PSL::CheckoutHelper.js::calculateTaxesFromZipCode:: getGoogleAddress error (GoogleAPI): Is the zipCode correct?");
                //MessageHelper.displayErrorMessage("There was a problem while retrieving data from Google Maps API");
                if(isCheckOut){
                    CheckoutHelperJS.updateOrderSummary(isCheckOut);
                } else {
                    CheckoutHelperJS.showHideEstematedTaxDialog(false);
                    CheckoutHelperJS.updateOrderSummary();
                }

            } else {
                var city = result.address.city;
                var state = result.address.prov_state_short;
                var zipcode = result.address.zipcode;

                // submit AjaxOrderCalculate request
                var params = [];

                params.storeId      = ServicesDeclarationJS.storeId;
                params.catalogId    = ServicesDeclarationJS.catalogId;
                params.langId       = ServicesDeclarationJS.langId;

                params.updatePrices = "0";
                if(isCheckOut){
                    params.orderId = ".";
                } else {
                    params.orderId = $('#wcs_calTax_notification #orderId').val();
                }

                params.addressFlag = true;
                params.isDeliveryAddressAdded = false;
                params.zipCode = zipcode != null ? zipcode : "";
                params.city = city != null ? city : "";
                params.state = state != null ? state : "";
                params.country = "us";
                params.isZipChange = true;//isZipChange;

                var url = getAbsoluteURL() + "AjaxOrderCalculate?";
                for (var param  in params) {
                    url += param + "=" + params[param] + "&";
                }
                url += "calculationUsageId=-1&";
                url += "calculationUsageId=-2&";
                url += "calculationUsageId=-3&";
                url += "calculationUsageId=-4";

                //Make the call to AjaxOrderCalculate
                $.ajax({
                    url: url,
                    type: 'POST',
                    success: function (data) {
                        // refresh the area.
                        if(isCheckOut){
                            var url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/person/@self/contact";
                            $.ajax({
                                url: url,
                                type: 'GET',
                                headers: {
                                    "Content-Type": "application/json",
                                    "Cache-Control": "no-cache, no-store, must-revalidate"
                                },
                                data: {
                                    "timestamp": Date.now()
                                },
                                success: function (data) {
                                    if(data != undefined && data.contact != undefined){
                                        for(var i = 0; i < data.contact.length; i++){
                                            if(data.contact[i].addressType === "Billing"){
                                                setCookie("addressId_formB_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }else if(data.contact[i].addressType === "Shipping"){
                                                setCookie("addressId_formS_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }else{
                                                setCookie("addressId_formS_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                                setCookie("addressId_formB_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }
                                        }
                                    }
                                },
                                error: function(data){
                                    console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (contact)");
                                    MessageHelper.displayErrorMessage("There was a problem while retrieving current user contact data.");
                                    console.log(data);
                                },
                                complete: function(){
                                }
                            });
                            CheckoutHelperJS.updateOrderSummary(isCheckOut);
                        } else {
                            CheckoutHelperJS.showHideEstematedTaxDialog(false);
                            CheckoutHelperJS.updateOrderSummary();
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (AjaxOrderCalculate)");
                        MessageHelper.displayErrorMessage("There was a problem while retrieving data from taxes calculation service.");

                        if(isCheckOut){
                            CheckoutHelperJS.updateOrderSummary(isCheckOut);
                        } else {
                            CheckoutHelperJS.showHideEstematedTaxDialog(false);
                            CheckoutHelperJS.updateOrderSummary();
                        }
                    }
                });
            }
        });
        //HB-2302 END
    },


    /**
     * This method updates current cart orderitems address' to the last valid shipping address
     */
    updateCurrentOrderItemsAddressToLastValidOne: function(){
        var METHODNAME = "CheckoutHelperJS.updateCurrentOrderItemsAddressToLastValidOne()";
        var shippingAddressId = getCookie("addressId_formS_" + storeDirectory);
        if (typeof shippingAddressId !== 'undefined'){
            var data = {};
            data.addressId = shippingAddressId;
            data.orderId = ".";
            data.x_calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            data.orderItem = [];
            data.orderItem[0] = {};
            data.orderItem[0].addressId = shippingAddressId;

            var stringifiedData = JSON.stringify(data);

            var url = "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self/shipping_info";
            $.ajax({
                url: url,
                type: 'PUT',
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache, no-store, must-revalidate"
                },
                dataType: 'json',
                data: stringifiedData,

                success: function (data) {
                    plog(METHODNAME + "::Order items shipping address updated OK");
                },
                error: function(jqXHR, exception){
                    plog(METHODNAME + "::Ajax error: " + getAjaxErrorMessage(jqXHR, exception));
                },
                complete: function(){
                }
            });
        }
    },

    updateOrderSummary: function(isCheckOut) {
        var countryCode = $("#countryCode").val() || $("#country").val();
        $.ajax({
            url: "CalculateView",
            type: "GET",
            async: false,
            data: "fromPage=CalculateView&storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId,
            success: function (data){

                //TODO Commonize this 'if'
                if (isOliver){

                    if(isCheckOut){
                        /*var str1 = $(data).find(".amount").text().trim();
                        str1 = str1.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                        $('.tax .total_figures').html(str1);

                        var str2 = $(data).find("#WC_SingleShipmentOrderTotalsSummary_td_10").text().trim();
                        var total = str2.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                        $('#order_total .total-amounth.total').html(total);*/
                        ajaxCallCart();//checkout 3.0
                    } else {
                        $('#order_total').html(data);
                    }

                } else if (isCarol){

                    if(isCheckOut){
                        var str1 = $(data).find(".amount").text().trim();
                        str1 = str1.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                        $('.tax .total_figures').html(str1);

                        if ($('.order-summary__total-amount--shipping') != undefined) {
                            var str2 = $(data).find(".order-summary__total-amount--shipping").text().trim();
                            str2 = str2.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                            $('.order-summary__total-amount--shipping').html(str2);
                        }

                        if ($('#order_total .total-amounth.total') != undefined) {
                            var str3 = $(data).find("#WC_SingleShipmentOrderTotalsSummary_td_10").text().trim();
                            var total = str3.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                            $('#order_total .total-amounth.total').html(total);
                        }

                        if ($('.order-summary__total-amount--total') != undefined) {
                            var str5 = $(data).find(".order-summary__total-amount--total").text().trim();
                            str5 = str5.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                            $('.order-summary__total-amount--total').html(str5);
                        }

                        if ($('.order-summary__installment-total') != undefined) {
                            var str4 = $(data).find(".order-summary__installment-total").text().trim();
                            str4 = str4.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                            $('.order-summary__installment-total').html(str4);
                        }
                    } else {
                        restoreAjaxButtons();
                        $('#order_total').html(data);
                    }

                } else {

                    if(isCheckOut){
                        // var str1 = $(data).find("#WC_SingleShipmentOrderTotalsSummary_td_6").html();
                        // var pos = str1.lastIndexOf(">");
                        // str1 = str1.substring(str1.length,pos +1);
                        // str1 = str1.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                        // $('.tax .total_figures').html(str1);

                        // var str2 = $(data).find("#WC_SingleShipmentOrderTotalsSummary_td_10").text().trim();
                        // var total = str2.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                        // $('.orderTotal .total_figures').html(total);
                        
                        // if (affirmEnabled == 'true') {
                        //     $('.affirm-as-low-as').attr('data-amount', WCCurrencyJS.unformat(total) * 100);
                        // }
                        ajaxCallCart();// checkout3.0
                    } else {
                        $('#total_breakdown').html(data);
                    }

                }

                if (affirmEnabled == 'true') {
                    affirm.ui.refresh();
                }
            },
             error: function (xhr, ajaxOptions, thrownError) {
                console.log("PSL::CheckoutHelper.js::updateOrderSummary()::"+thrownError);
             }
        });
    },

    /**
     * This function is used to show or hide the edit billing address link in multiple and single shipment page.
     * @param {DOM Element} addressSelectBox The select drop-down object that contains all available addresses.
     * @param {String} paymentAreaNumber The area number of the payment section.
     */

    showHideEditBillingAddressLink: function (addressSelectBox, paymentAreaNumber) {

        // If the value is "Please Select Billing Method first", then don't display the edit link on load.
        if ( typeof addressSelectBox !== 'undefined' && addressSelectBox !== null ){
            if (addressSelectBox.value == '-2') {
                $("#editBillingAddressLink_" + paymentAreaNumber).css("display", "none");
                return;
            }
        }

        // Gets the address Ids of all the organization addresses
        var orgAddressList = document.getElementById("shippingOrganizationAddressList");

        //if there exists organization addresses
        if (orgAddressList) {
            var orgAddressArray = [];
            orgAddressArray = orgAddressList.value.toString().split(",");

            //loops through all the organization address Ids
            for (var i = 0; i < orgAddressArray.length; i++) {

                //checks to see if the edit link divs exists
                if ($("#editBillingAddressLink_" + paymentAreaNumber).length) {

                    //compares the selected value address Id in the drop down to the organization address id
                    if (addressSelectBox.value == orgAddressArray[i]) {

                        //hides the link if a match is found and then exits the loop (exit is for the case where there might be a different org address id)
                        $("#editBillingAddressLink_" + paymentAreaNumber).css("display", "none");
                        break;
                    } else {
                        //displays it in all other cases
                        $("#editBillingAddressLink_" + paymentAreaNumber).css("display", "block");
                    }
                }
            }

        } else {

            // if no organization addresses exists, show the valid edit divs.
            if ($("#editBillingAddressLink_" + paymentAreaNumber).length) {
                $("#editBillingAddressLink_" + paymentAreaNumber).css("display", "block");
            }
        }
    },

    /**
     * Sets the order ID when it is not called form the current order.
     * The order ID is used to determine which order to act upon such as in the case of deleting an order item from an order.
     * @param {String} orderId The orderID to use.
     */
    setOrderId: function (orderId) {
        this.orderId = orderId;
    },

    /**
     * Returns the orderId.
     */
    getOrderId: function () {
        return this.orderId;
    },

    /************************************************************
     * End Multiple Shipment page specific functions
     ************************************************************/

    _toggleOrderItemDetails: function (div) {
        if (div.css("display") == "none") {
            div.css("display", "block");
            $("#orderExpandAreaBottom").css("display", "none");
            $("#OrderItemDetailsPlus").css("display", "none");
            $("#OrderItemDetailsShowPrompt").css("display", "none");
            $("#OrderItemDetailsMinus").css("display", "inline");
            $("#OrderItemDetailsHidePrompt").css("display", "inline");
            $("#OrderItemDetails_plusImage_link").css("display", "none");
            $("#OrderItemDetails_minusImage_link").css("display", "");
        } else {
            div.css("display", "none");
            $("#orderExpandAreaBottom").css("display", "block");
            $("#OrderItemDetailsPlus").css("display", "inline");
            $("#OrderItemDetailsShowPrompt").css("display", "inline");
            $("#OrderItemDetailsMinus").css("display", "none");
            $("#OrderItemDetailsHidePrompt").css("display", "none");
            $("#OrderItemDetails_plusImage_link").css("display", "");
            $("#OrderItemDetails_minusImage_link").css("display", "none");
        }
    },
    toggleOrderItemDetailsShipping: function (orderItemDetailsDiv, contextId, initializeJS) {
        var div = $("#" + orderItemDetailsDiv);
        if (div.css("display") == "none") {
            if (!div.hasClass('orderRetrieved')) {
                cursor_wait();
                wcRenderContext.updateRenderContext(contextId, {
                    'beginIndex': 0,
                    'storeId': this.storeId,
                    'catalogId': this.catalogId,
                    'langId': this.langId,
                    'initializeJS': initializeJS
                });
                div.addClass('orderRetrieved');
            }
        }
        this._toggleOrderItemDetails(div);
    },

    toggleOrderItemDetailsSummary: function (orderItemDetailsDiv, contextId, beginIndex, pageSize, exOrderId, exQuoteId, fromOrderDetails, analytics) {
        var div = $("#" + orderItemDetailsDiv);
        if (div.css("display") == "none") {
            if (!div.hasClass('orderRetrieved')) {
                cursor_wait();
                wcRenderContext.updateRenderContext(contextId, {
                    'beginIndex': '',
                    'pageSize': pageSize,
                    'externalOrderId': exOrderId,
                    'externalQuoteId': exQuoteId,
                    'isFromOrderDetailsPage': 'false',
                    'analytics': analytics
                });
                div.addClass('orderRetrieved');
            }
        }
        this._toggleOrderItemDetails(div);
    },

    /**
     * Redirect Guest User to Login/Registration Custom Checkout Step
     */
    redirectToLoginRegisterStep : function(registerLogonURL){
        window.location.href = registerLogonURL;
    },

    /**
     * Redirect Guest User to Login/Registration Custom Checkout Step
     */
     ajaxRedirectToLoginRegisterStep : function(registerLogonURL){
        window.location.href = registerLogonURL;
    },

    /**
     * Redirect PayPal checkout
     */
    redirectToPayPalCheckout : function(paypalURL){
        sessionStorage.setItem("isStepPayPalExpress", true);
        paypalURL += "&piAmount=" + $('#totalAmountForPPshortcut').val().trim();
        paypalURL += "&customerWebId=" + window.forterWebId;
        paypalURL += "&customerIPAddress=" + window.ipaddress;
        paypalURL += "&forterToken=" + window.forterToken;
        window.location.href = paypalURL;
        tealiumPushCheckoutStep('PayPalExpressCheckout');
    },

     /**
     * Only for Carol. Update and display shipping methods area passed on zipCode.
     */
    updateShippingMethodsArea : function() {
        var zipcode = $('#zipCodeField').val();
        if (zipcode.length < 9) {
            if (zipcode.length == 0) {
                $('.shipping-method__block').addClass('nodisplay');
                $('#datepicker').addClass('nodisplay');
            }
            return;
        }

        if (addressId === undefined
                || addressId === "" ||
                (oldZipCode != zipcode && storeUserType != undefined && storeUserType === "G")) {
            var addressURL = "/wcs/resources/store/"+ WCParamJS.storeId +"/customAddressValidation/byZipCode/" + zipcode;
            $.ajax({
                url: addressURL,
                dataType: 'json',
                type: 'GET',
                success: function (data) {
                    var city = null;
                    var state = null;
                    var zipcode = null;
                    //getting data
                   if (data != null && data.addressInfo[0] != null) {
                       if ( data.addressInfo[0].country == null) {
                           console.error("Zip code invalid / NOT FOUND, ZERO_RESULTS");
                       } else {
                           if (data.addressInfo[0].city != null) {
                               city = data.addressInfo[0].city;
                           }
                           if (data.addressInfo[0].state != null) {
                               state = data.addressInfo[0].state;
                           }
                           if (data.addressInfo[0].zipcode != null) {
                               zipcode = data.addressInfo[0].zipcode;
                           }
                       }

                        // submit AjaxPersonChangeServiceAddressAdd request to create new address to calculate shipping when no address
                        // assigned to the order.
                        var params = [];

                        params.storeId      = ServicesDeclarationJS.storeId;
                        params.catalogId    = ServicesDeclarationJS.catalogId;
                        params.langId       = ServicesDeclarationJS.langId;

                        params.zipCode = zipcode != null ? zipcode : "";
                        params.city = city != null ? city : "";
                        params.state = state != null ? state : "";
                        params.country = countryCode;
                        params.nickName = (nickName != null && nickName != "")? nickName : "MyAddress_Shipping";
                        if (addressId != null && addressId != '') {
                            params.addressId = addressId;
                            var url = getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate?";
                        } else {
                            var url = getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd?";
                        }

                        for (var param  in params) {
                            url += param + "=" + params[param] + "&";
                        }
                        $.ajax({
                            url: url,
                            type: 'POST',
                            success: function (data) {
                                var url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/person/@self/contact";
                                $.ajax({
                                    url: url,
                                    type: 'GET',
                                    headers: {
                                       "Content-Type": "application/json",
                                       "Cache-Control": "no-cache, no-store, must-revalidate"
                                   },
                                   data: {
                                       "timestamp": Date.now()
                                   },
                                    success: function (data) {
                                        if(data != undefined && data.contact != undefined){
                                            for(var i = 0; i < data.contact.length; i++){
                                                if((data.contact[i].addressType === "Shipping" || data.contact[i].addressType === "ShippingAndBilling") && (addressId == null || addressId == "" ||  addressId == data.contact[i].addressId)){
                                                    addressId = data.contact[i].addressId;
                                                    oldZipCode = data.contact[i].zipCode;
                                                    nickName = data.contact[i].nickName;
                                                }
                                            }
                                            wcRenderContext.getRenderContextProperties('ShippingMethodsSelectContext')['orderId']=orderId;
                                            wcRenderContext.getRenderContextProperties('ShippingMethodsSelectContext')['zipCode']=zipcode;
                                            wcRenderContext.getRenderContextProperties('ShippingMethodsSelectContext')['addressId']=addressId;

                                            $("#shippingMethodDisplayArea").refreshWidget("refresh", wcRenderContext.getRenderContextProperties("ShippingMethodsSelectContext"));
                                        }
                                    },
                                    error: function(data){
                                        console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (contact)");
                                        console.log(data);
                                    }
                                });
                                CheckoutHelperJS.updateOrderSummary(true);
                            },
                            error: function (xhr, ajaxOptions, thrownError) {
                                CheckoutHelperJS.updateOrderSummary(true);
                            }
                        });

                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {

                }
            });
        } else {
            wcRenderContext.getRenderContextProperties('ShippingMethodsSelectContext')['orderId']=orderId;
            wcRenderContext.getRenderContextProperties('ShippingMethodsSelectContext')['zipCode']=zipcode;

            $("#shippingMethodDisplayArea").refreshWidget("refresh", wcRenderContext.getRenderContextProperties("ShippingMethodsSelectContext"));
        }

    },

    /**
     * Only for Carol. Show/hide elements inside shipping methods
     */

   showHideGreyShippingMethodsElements : function(hasCEP) {
       var isCheckout = ($('.checkout-page').length > 0);
       if(isCheckout) {
           if(hasCEP == 'true'){
               $('.shipping-method').removeClass('shipping-method--grey');
               $('.physical-stores').removeClass('shipping-method--grey');
               $('#physicalStoresTitle').hide();
               $('.physical-stores > h3').hide();
               $('#shippingMethodTitle').show();
           } else {
               $('.shipping-method').addClass('shipping-method--grey');
               $('.physical-stores').addClass('shipping-method--grey');
               $('#physicalStoresTitle').show();
               $('.physical-stores > h3').show();
               $('#shippingMethodTitle').hide();
           }
       } else {
           $('#physical-stores__title').hide();
       }
     },

     /**
      * Only for Carol. Refresh controller declaration for the Shippong Method display area.
      * @constructor
      */
     declareShippingAddressesDisplayAreaController : function(widgetId) {
          wcRenderContext.declare("shippingAddressDropDownBoxContext", [], {selectedAddressId: ""});
         if(typeof widgetId == "object" || typeof widgetId == "array") {
             widgetId = widgetId[0];
         }
         var myWidgetObj = $("#" + widgetId);

         wcRenderContext.addRefreshAreaId("shippingAddressDropDownBoxContext", widgetId);
         var myRCProperties = wcRenderContext.getRenderContextProperties("shippingAddressDropDownBoxContext");

         myWidgetObj.refreshWidget({
             renderContextChangedHandler: function() {
                 var areaNumber = myRCProperties["areaNumber"];
                 var objectId = widgetId;
                     myWidgetObj.refreshWidget("refresh", {});
             },

             postRefreshHandler: function() {
                 CheckoutHelperJS.updateAddressIdOFItemsOnCreateEditAddress(selectedAddressId);
                 AddressHelper.updatePhysicalStoresArea(addressToZipCodeMap[selectedAddressId]);
             }
         });

     },
    /**
     * Only for Carol. Refresh controller declaration for the Shippong Method display area. This function to be deleted after making the grunt build.
     * @constructor
     */
    declareShippingMethodDisplayAreaController : function(widgetId, orderId, addDeclaration) {
        if (typeof addDeclaration == "undefined" || addDeclaration == true) {
            wcRenderContext.declare("ShippingMethodsSelectContext", [], {orderId:orderId,zipCode: ""});
        }
        if(typeof widgetId == "object" || typeof widgetId == "array") {
            widgetId = widgetId[0];
        }
        var myWidgetObj = $("#" + widgetId);

        wcRenderContext.addRefreshAreaId("ShippingMethodsSelectContext", widgetId);
        var myRCProperties = wcRenderContext.getRenderContextProperties("ShippingMethodsSelectContext");

        myWidgetObj.refreshWidget({
            renderContextChangedHandler: function() {
                var areaNumber = myRCProperties["areaNumber"];
                var objectId = widgetId;
                    var orderId = myRCProperties["orderId"+areaNumber];
                    myWidgetObj.refreshWidget("refresh", {"orderId": orderId,"ZipCode":""});
            },

            postRefreshHandler: function() {
                if (typeof hasValidAddress == "undefined") {
                    var forceClick = true;
                } else {
                    var forceClick = hasValidAddress;
                }
                if ($("[name=singleShipmentShippingMode]:checked")!= undefined && forceClick) {
                    $("[name=singleShipmentShippingMode]:checked").trigger('click');
                }
                //clears the progress bar set from billingdropdowndisplay.jsp
                cursor_clear();
                var params = [];

                params.storeId      = this.storeId;
                params.catalogId    = this.catalogId;
                params.langId       = this.langId;
                params.requestType = "get";
                cursor_wait();
                wcService.invoke("AjaxShippingDateUpdate", params);
            }
        });

    },

    /**
    * Only for Carol. Update shipping date then redirect.
    */
    updateShippingDateAndRedirect : function(redirectURL) {
        if (document.querySelector('input[name="singleShipmentShippingMode"]:checked') != undefined &&
                document.querySelector('input[name="singleShipmentShippingMode"]:checked').getAttribute("shipmodecode") == 'Scheduled delivery') {
            redirectToURL = redirectURL;
            var params = [];

            params.storeId      = this.storeId;
            params.catalogId    = this.catalogId;
            params.langId       = this.langId;
            params.orderId      = ".";
            params.requestType = "update";
            var time = "0700";
            if (document.querySelector('input[name="shippingSelectTime"]:checked').value == "noon") {
              time = "1200";
            } else if (document.querySelector('input[name="shippingSelectTime"]:checked').value == "night") {
              time = "1800";
            }
            var date = $("#datepicker-holder").datepicker('getDate');
            var formattedDate = $.datepicker.formatDate("yymmdd", date);
            params.shippingDate = formattedDate + time;
            cursor_wait();
            wcService.invoke("AjaxShippingDateUpdate", params);
        } else {
            CheckoutHelperJS.redirectToLoginRegisterStep(redirectURL);
        }
    }
}

function assignCustomerSegmentToUser(espotName){
  
  /*for ex- > espotName = AddToCustomerSegment_Espot*/
  /* When AddToCustomerSegment_Espot is called, activity AddToCustomerSegment_CustomerWeek is triggered*/
  /*Activiy adds the current user to customer segment, specified in the activity*/
    
  var espotServiceUrl = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/espot/" + espotName+"?"+Date.now();
    $.ajax({
      url: espotServiceUrl,
      dataType: "html",
      async: true,
      success: function(data) {
        console.log("User added to customer segment correctly");
        /* Reload page after 1st cookie creation so that the espots related to cookie can work */
        if (isPersol && $("meta[name='pageIdentifier'").attr("content") != 'POnewsletterpromo' || isVogue && $("meta[name='pageIdentifier'").attr("content") != 'MBBnewsletterpromo1'){
             if(window.location.href.toLocaleLowerCase().includes("cid") && window.location.href.toLocaleLowerCase().includes("promo") ){
                 var redirectUrl = removeParam("promo",window.location.href);
                 window.location = redirectUrl; // Reload without promo parameter
             }else{
            	 if(!window.location.href.includes("UserRegistrationForm") && !window.location.href.includes("AjaxLogonForm") ){
            		 window.location = window.location.href.split("?")[0]; // Reload without promo parameter
            	 }
             }	   
          }
      },
      error: function(data){
        console.log("Error adding user to customer segment");
      }
    });
}
     

     
function removeCustomerSegmentToUser(espotName){
  
  /*for ex- > espotName = AddToCustomerSegment_Espot*/
  /* When AddToCustomerSegment_Espot is called, activity AddToCustomerSegment_CustomerWeek is triggered*/
  /*Activiy removes the current user to customer segment, specified in the activity*/
 
  var espotServiceUrl = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/espot/" + espotName+"?"+Date.now();

    $.ajax({
        url: espotServiceUrl,
        dataType: "html",
        success: function(data) {
          console.log("User removed to customer segment correctly");
          /* Reload page after 1st cookie creation so that the espots related to cookie can work */
          if (isPersol && $("meta[name='pageIdentifier'").attr("content") != 'POnewsletterpromo' || isVogue && $("meta[name='pageIdentifier'").attr("content") != 'MBBnewsletterpromo1'){
            if(window.location.href.toLocaleLowerCase().includes("cid") && window.location.href.toLocaleLowerCase().includes("promo") ){
              var redirectUrl = removeParam("promo",window.location.href);
              window.location = redirectUrl; // Reload without promo parameter
              }else{
            	  if(!window.location.href.includes("UserRegistrationForm") && !window.location.href.includes("AjaxLogonForm") ){
             		 window.location = window.location.href.split("?")[0]; // Reload without promo parameter
             	 }
             }	 
           }
        },
        error: function(data){
          console.log("Error removing user to customer segment");
        }
    });
     
}

/*function activateCustomerWeek(){
        if(typeof getCookie(CustomerWeek.cookieName) == "undefined" || getCookie(CustomerWeek.cookieName) == ""){
        var date = new Date();
        date.setDate(date.getDate() + 14);
        setCookie(CustomerWeek.cookieName,CustomerWeek.cookieValue, {path:'/', domain:cookieDomain, expires:date.toUTCString()});
        customerWeekActive=true;
        
        if (typeof ct_customerWeek_cookieCheck !== "undefined") { 
          ct_customerWeek_cookieCheck(); //It's a content team function
          } 
      }
}*/


function assignCustomerSegment(segment){
  try {
      var currentDate = new Date();
      if ($("#customerSegmentJSONdata .left_espot").text().length > 0) {
        window.segmentsArray = JSON.parse($("#customerSegmentJSONdata .left_espot").text());
        if (segmentsArray != undefined && segmentsArray.length>0){ 
          var userCSegmentsList = [];
          $(segmentsArray).each(function(){
              /* segment is an optional parameter used to search for a specific segment without scrolling the whole segmentsArray */
              if (segment == undefined || this.customerSegment == segment){
              /* Check expiration date */
              this.startDate = new Date(this.startDate);
              this.endDate = new Date(this.endDate);
              if (this.startDate <= currentDate && currentDate <= this.endDate){
                  if(!(document.cookie.includes('X_WC_PR_SEGMENTS'))) {
                    var currentActiveSegment = this;
                    /* Call REST Service with all current customer segments */
                    userCSegmentsList = getUserSegments();
                    $(userCSegmentsList).each(function(){
                      var activeUserSegment = (this.segments != "") ? this.segments.replace("PST","").replaceAll("_","").toLowerCase() : "";
                      if (currentActiveSegment.customerSegment.toLowerCase() != activeUserSegment){
                        /* Set cookie with active customerSegment */
                        setCustomerSegmentCookie(currentActiveSegment.customerSegment, currentActiveSegment.endDate);
                        /* Call the proper Web activity URL to add the customer to the promotional segment Early Access */
                        assignCustomerSegmentToUser("AddToCustomerSegment_Espot");
                      /*
                      } else {
                        setCustomerSegmentCookie(currentActiveSegment.customerSegment, currentActiveSegment.endDate);
                      */
                      }
                    });
                  } else window.customerSegment = getCookie('X_WC_PR_SEGMENTS');
              } else if (currentDate > this.endDate && document.cookie.includes('X_WC_PR_SEGMENTS')){
                /* Delete X_WC_PR_SEGMENTS cookie */
                var customerSegment = getCookie("X_WC_PR_SEGMENTS");
                setCustomerSegmentCookie(customerSegment, this.endDate)
                /* Call the proper Web activity URL to remove the customer from the promotional segment Early Access */
                removeCustomerSegmentToUser("RemoveFromCustomerSegment_Espot");
              }
            }
          });
        }
      }
      //  Hide PDP tooltip [Replaced by Activity]
      /*
      if (document.cookie.includes('X_WC_PR_SEGMENTS')) {
        $("<style type='text/css'> #customerSegmentTooltip { display: none; } </style>").appendTo("head");
      }
      */
  } catch (e) {
    	console.error("Error in assigning customer segment",e);
    }
}

function setCustomerSegmentCookie(customerSegment, endDate){

    setCookie("X_WC_PR_SEGMENTS", customerSegment, {path:'/', domain:cookieDomain, expires: endDate});
    window.customerSegment = customerSegment;
}

/* This function gets all the customer segments active on user */

function getUserSegments(){

  var userSegments;
  var userId = getUserId();
  if (userId == "-1002") userId = setUserIdentity();
  var url = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/earlyaccess/" + "?userId=" + userId;

  $.ajax({
      url: url,
      method: "GET",
      async: false,
      success: function(data) {
        console.log("User customer segments retrieved correctly");
        userSegments = data;
      },
      error: function(data){
        console.log("Error retrieving user customer segments");
      }
  });
  return userSegments;
}



function closeTooltip(){
  $("#customerSegmentTooltip .closeButton").parent().hide();
}




function removeParam(key, sourceURL) {
  var rtn = sourceURL.split("?")[0],
      param,
      params_arr = [],
      queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
  if (queryString !== "") {
      params_arr = queryString.split("&");
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
              params_arr.splice(i, 1);
          }
      }
      if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
}

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

////////////////////////////////////////////////////
// MiniShopCartDisplay.js (Common implementation) //
////////////////////////////////////////////////////
//console.log("MiniShopCartDisplay.js (Common implementation) loaded");

function closeMiniShopCartDropDown(){
    var visiblePopup = $("div[aria-describedby=MiniShopCartProductAdded]:visible");
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;

    //Start HB-12482 
    if((window.mobilecheck() || window.tabletPortraitCheck())){
    	$("html").css("overflow", "auto");	
    }
  //End HB-12482 
    
    if (visiblePopup.length>0){
    	if(isPersol) {
    		if(productDisplayJS.priceSwitched){
                if (!isWishlistPage){
                    document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastPriceSaved;
                    document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
                    if(affirmEnabled) {
                        customizeAffirmPrice();
                    }
                } else {
                    var minicartAddedId = $("#cartDropdown .products.added .product").attr("data-minicart-id");
                    document.getElementById('offerPrice_'+ minicartAddedId).innerText = productDisplayJS.lastPriceSaved;
                    document.getElementById('listPrice_'+ minicartAddedId).innerText = productDisplayJS.lastOfferPriceSaved;
                    $('#header').removeClass("mincartOpened")
                }
		    	productDisplayJS.priceSwitched = false;
    		}
            //START Early Access
            window.lastOfferPrice = returnLastOfferPrice();
            //END Early Access
    	}
    	else if(isOliver){
    		if(productDisplayJS.priceSwitched){
                var minicartAddedId = $("#cartDropdown .products .product").attr("data-minicart-id");
    			var elements = !isWishlistPage ? document.querySelectorAll('[id=offerPrice_'+productParent+']') : document.querySelectorAll('[id=offerPrice_'+minicartAddedId+']');
        		var div;
        		for(var i = 0; i<elements.length;i++) {
        			if(elements[i].nodeName == "DIV") {
        				div = elements[i];
        			}
        		}
        		if(div != undefined) {
        			div.getElementsByClassName('price__unity')[0].innerText = productDisplayJS.lastPriceSaved;
        		}
	    	 	
                if (!isWishlistPage){
                    document.getElementById('listPrice_'+productParent).innerText = productDisplayJS.lastOfferPriceSaved;
                } else {
                    document.getElementById('listPrice_'+minicartAddedId).innerText = productDisplayJS.lastOfferPriceSaved;
                }

		    	if(affirmEnabled && !isWishlistPage) {
		    		customizeAffirmPrice();
		    	}
		    	productDisplayJS.priceSwitched = false;
    		}
    		
    		//open Vm if was opened
    		if ($.cookie("isVMOpen") == "1") {
    			moveVMOverProduct();
    			vmTryThemOn();
    		}
    	}
    	productDisplayJS.lastPriceSaved =  "";
    	productDisplayJS.lastOfferPriceSaved = "";
    	if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
    		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
    			$('#current-clipon-catentry').attr('isAdded','');
    		}else{
    			$(visiblePopup).find(".closeButton").click();
    		}
    	}else{
    		$(visiblePopup).find(".closeButton").click();
    	}
    	
    
        /*
        This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
        It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
        */
        while ($("#MiniShopCartProductAdded").length>0){
            $("#MiniShopCartProductAdded").remove();
        }
    }

    visiblePopup = $("div[aria-describedby=quick_cart_container]:visible");

    if (visiblePopup.length>0){
    	if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
    		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
    			$('#current-clipon-catentry').attr('isAdded','');
    		}else{
    			$(visiblePopup).find(".closeButton").click();
    		}
    	}else{
    		$(visiblePopup).find(".closeButton").click();
    	}

        /*
        This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
        It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
        */
        while ($("#MiniShopCartProductAdded").length>0){
            $("#MiniShopCartProductAdded").remove();
        }
    }
    if (isOliver || isPersol) { 
        manageScrollOverlay(false);
    }

    if (isPersol){
        $('.shopperActions--monogram--added--button.remove').click();
    }
    
}

/*
//Extra events for minishopcart buttons
function bindMiniShopCartEvents(){
    $("#continueShoppingButton").on("click touchstart", function(){
        closeMiniShopCartDropDown();
        return false;
    });
}

$(document).ready(bindMiniShopCartEvents);
$(document).ajaxComplete(bindMiniShopCartEvents);
*/
/*
function repositionMiniShopCart(){
    var popup = $("div[aria-describedby=quick_cart_container]:visible, div[aria-describedby=MiniShopCartProductAdded]:visible");
    $(popup).css("top",-($(window).scrollTop())+"px");
}

//Manage minishopcart's position on mobile
function onScrollMiniShopCart(){
    console.log("PSL::onScrollMiniShopCart()");
    var reposition = false;
    var popup = $("div[aria-describedby=quick_cart_container]:visible, div[aria-describedby=MiniShopCartProductAdded]:visible");
    if ($(popup).length>0){
        for (var i = 0; i < $(popup).length; i++) {
            var element = $(popup)[i];
            if (!reposition && element.clientHeight > window.innerHeight){
                reposition = true;
            }
        }
    } else {
        console.log("PSL::onScrollMiniShopCart()::No minishopcart on screen");
    }

    if (reposition){
        console.log("PSL::onScrollMiniShopCart()::Repositioning minishopcart");
        var scrollTop = $(window).scrollTop();
        $(popup).css("top",(scrollTop*(-1))+"px");
    } else {
        console.log("PSL::onScrollMiniShopCart()::No reposition needed");
    }
}

$(document.body).on('touchmove', onScrollMiniShopCart); //mobile
$(window).on('scroll', onScrollMiniShopCart);           //desktop

function repositionMiniShopCartPopup(){
    console.log("Posicionando BEGIN");
    var popup = $("div[aria-describedby=quick_cart_container]:visible, div[aria-describedby=MiniShopCartProductAdded]:visible");
    $(popup).position({
        my: "right top",
        at: "right bottom",
        of: "#miniShopCartPopupPositionReference"
    });
    console.log("Posicionando END");
}
*/

//HB-1816 BEGIN Close MiniShopCart popup when the user clicks outside of it
$(document).click(function(event) {
    //console.log("PSL::MiniShopCartDisplay.js::Document clicked");

    // Ignore this event if preventDefault has been called.
    if (event.defaultPrevented){
        //console.log("PSL::MiniShopCartDisplay.js::event.defaultPrevented");
        return;
    }

    var isFade = ($(event.target).hasClass("quickcart--fade") || $(event.target).hasClass("minishopcartadded--fade"));

    var mouseX = event.pageX;
    var mouseY = event.pageY;

    if (mouseX != undefined && mouseY != undefined){
        //console.log("PSL::MiniShopCartDisplay.js::mouseX: " + mouseX + ", mouseY: " + mouseY);

        var visiblePopup = $("div[aria-describedby=MiniShopCartProductAdded]:visible");

        if (visiblePopup.length>0){
            event.stopPropagation();
            //console.log("PSL::MiniShopCartDisplay.js::Minicart Product Added popup visible");
            var popupX = $(visiblePopup).offset().left;
            var popupY = $(visiblePopup).offset().top;
            var popupW = $(visiblePopup).outerWidth();
            var popupH = $(visiblePopup).outerHeight();
            //console.log("PSL::MiniShopCartDisplay.js::popupOffsetX: " + popupX + ", popupOffsetY: " + popupY);
            //console.log("PSL::MiniShopCartDisplay.js::popupWidth: " + popupW + ", popupHeight: " + popupH);
            if (mouseX >= popupX && mouseX <= popupX + popupW && mouseY >= popupY && mouseY <= popupY + popupH || isFade){
                //console.log("PSL::MiniShopCartDisplay.js::Click inside");
            } else {
                //console.log("PSL::MiniShopCartDisplay.js::Click outside");
                event.preventDefault();
                event.stopPropagation();
                if($('#page').hasClass('pdp') && brandCode == 'PO'){
                    hideHeaderTimeout.setup();
                    $('#header').css('z-index', '5') 
                }
                $(visiblePopup).find(".closeButton").click();

                /*
                This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
                It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
                */
                while ($("#MiniShopCartProductAdded").length>0){
                    $("#MiniShopCartProductAdded").remove();
                }

                return false;
            }
        } else {
            //console.log("PSL::MiniShopCartDisplay.js::No visible Minicart");
        }

        visiblePopup = $("div[aria-describedby=quick_cart_container]:visible");

        if (visiblePopup.length>0){
            //console.log("PSL::MiniShopCartDisplay.js::Minicart Product List popup visible");
            var popupX = $(visiblePopup).offset().left;
            var popupY = $(visiblePopup).offset().top;
            var popupW = $(visiblePopup).outerWidth();
            var popupH = $(visiblePopup).outerHeight();
            //console.log("PSL::MiniShopCartDisplay.js::popupOffsetX: " + popupX + ", popupOffsetY: " + popupY);
            //console.log("PSL::MiniShopCartDisplay.js::popupWidth: " + popupW + ", popupHeight: " + popupH);
            if (mouseX >= popupX && mouseX <= popupX + popupW && mouseY >= popupY && mouseY <= popupY + popupH || isFade){
                //console.log("PSL::MiniShopCartDisplay.js::Click inside");
            } else {
                //console.log("PSL::MiniShopCartDisplay.js::Click outside");
                event.preventDefault();
                event.stopPropagation();
                $(visiblePopup).find(".closeButton").click();
                if(brandCode == 'PO' && $('#page').hasClass('pdp')){
                    hideHeaderTimeout.setup()
                }
                /*
                This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
                It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
                */
                while ($("#MiniShopCartProductAdded").length>0){
                    $("#MiniShopCartProductAdded").remove();
                }

                return false;
            }
        } else {
            //console.log("PSL::MiniShopCartDisplay.js::No visible Minicart");
        }
    }
});
//HB-1816 END

function lockShoppingBagIcon(){
    $("#widget_minishopcart").addClass("isDisabled");
    $("#widget_minishopcart").attr("href-disabled", $("#widget_minishopcart").attr("href") );
    $("#widget_minishopcart").attr("onclick-disabled", $("#widget_minishopcart").attr("onclick") );
    $("#widget_minishopcart").removeAttr("href");
    $("#widget_minishopcart").removeAttr("onclick");
}

function unlockShoppingBagIcon(){
    $("#widget_minishopcart").attr("href", $("#widget_minishopcart").attr("href-disabled") );
    $("#widget_minishopcart").attr("onclick", $("#widget_minishopcart").attr("onclick-disabled") );
    $("#widget_minishopcart").removeAttr("href-disabled");
    $("#widget_minishopcart").removeAttr("onclick-disabled");
    $("#widget_minishopcart").removeClass("isDisabled");
}

$(document).ready(function(){
    unlockShoppingBagIcon();
});


////////////////////////////////////////////////////
// OOTB source code                               //
////////////////////////////////////////////////////
/**
 * @fileOverview This file provides the common functions which are specific to the Mini Shopping cart
 */

/**
 * map order_updated to all the services that result in changes to an order
 * @static
 */

var order_updated = {
    'AjaxAddOrderItem': 'AjaxAddOrderItem',
    'AddOrderItem': 'AddOrderItem',
    'AjaxAddOrderItemWithShipingInfo': 'AjaxAddOrderItemWithShipingInfo',
    'AjaxDeleteOrderItem': 'AjaxDeleteOrderItem',
    'AjaxUpdateOrderItem': 'AjaxUpdateOrderItem',
    'AjaxUpdateOrderShippingInfo': 'AjaxUpdateOrderShippingInfo',
    'AjaxOrderCalculate': 'AjaxOrderCalculate',
    'AjaxLogoff': 'AjaxLogoff',
    'AjaxSetPendingOrder': 'AjaxSetPendingOrder',
    'AjaxUpdatePendingOrder': 'AjaxUpdatePendingOrder',
    'AjaxSingleOrderCancel': 'AjaxSingleOrderCancel',
    'AjaxUpdateRewardOption': 'AjaxUpdateRewardOption'
};

/** This variable indicates whether the mini cart drop down is updated or not. */
var dialogWidget,
    update_content = false,
    dropdownUpdated = false,
    /** This is variable indicates whether the mini cart drop down is being initialized. */
    dropdownInit = false,
    productAddedList = {};

function declareMiniShoppingCartRefreshArea() {
    //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea()::BEGIN");
    // ============================================
    // initialize refresh area widgets
    // ============================================

    // ============================================
    // div: MiniShoppingCart refresh area
    // Declares a new refresh controller for the Mini Shopping Cart.

    // declare render context
    wcRenderContext.declare("MiniShoppingCartContext", ["MiniShoppingCart"], { status: "init" });

    /*
    /* Refreshes the mini shopping cart.
     * This function is called when a render context changed event is detected.
     */
    var renderContextChangedHandler = function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea().renderContextChangedHandler()::BEGIN");
        if (wcRenderContext.testForChangedRC("MiniShoppingCartContext", ["status"])) {
            wcRenderContext.getRenderContextProperties("MiniShoppingCartContext").deleteCartCookie = true;
            $("#MiniShoppingCart").refreshWidget("refresh", wcRenderContext.getRenderContextProperties("MiniShoppingCartContext"));
        }
    };

    // model change
    /*
     * Refreshes the mini shopping cart.
     * If a new order item is added via an Ajax service call, set the mini shopping cart to display the new order item in the dropdown.
     * Otherwise, only refresh the contents of mini shopping cart to the updated order information.
     * This function is called when a modelChanged event is detected.
     *
     * @param {string} event The model changed event
     * @param {object} returnData The data returned from the event
     */
    var events = $.extend({}, order_updated, { "AjaxDeleteOrderItemForShippingBillingPage": "AjaxDeleteOrderItemForShippingBillingPage" });
    wcTopic.subscribe(events, function(returnData) {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea().wcTopic.subscribe()::BEGIN");
        var param = [];
        if (returnData.actionId == 'AddOrderItem') {
            if (returnData.data.orderItem != null && returnData.data.orderItem[0].orderItemId != null) {
                var addedOrderItemIdString = "";
                for (var i = 0; i < returnData.data.orderItem.length; i++) {
                    if (addedOrderItemIdString !== "") {
                        addedOrderItemIdString += ",";
                    }
                    addedOrderItemIdString += returnData.data.orderItem[i].orderItemId;
                }
                param.addedOrderItemId = addedOrderItemIdString;
                param.catEntryId = returnData.data.catEntryId;
                param.productId = returnData.data.catEntryId;
            } else {
                param.addedOrderItemId = returnData.data.orderItemId + "";
                param.catEntryId = returnData.data.catEntryId;
                param.productId = returnData.data.catEntryId;
            }

            if(productDisplayJS && productDisplayJS.YMALProductFlag) { //se abbiamo aggiunto un prodotto dai prodotti suggeriti a carrello
				productDisplayJS.YMALProductFlag = false;
				showDropdown = false; //no minicart
                window.location.reload();
			} else if (productDisplayJS && productDisplayJS.RMAProductFlag){
                productDisplayJS.RMAProductFlag = false;
				showDropdown = false; //no minicart
            }
            else {
                showDropdown = true;
            }
        }
        param.deleteCartCookie = true;
        if (returnData.data.addedFromSKUList != null && returnData.data.addedFromSKUList[0] != null) {
            param.addedFromSKUList = returnData.data.addedFromSKUList[0];
        }
        if(window.skipMiniCart) {
            getNumberOfItemsInCart(itemsInCartBadge);
            goDirectToCart();
        }
        else
            $("#MiniShoppingCart").refreshWidget("refresh", param);
           
    });

    var postRefreshHandler = function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea().postRefreshHandler()::BEGIN");
        //The dialog contents has changed..so destroy the old dialog with stale data..
        destroyDialog("MiniShopCartProductAdded");

        if (showDropdown) {
            update_content = true;
            //We have added item to cart..So display the drop down with item added message..
            positionMiniShopCartDropDown("widget_minishopcart", 'MiniShopCartProductAdded', 'orderItemAdded');
            showDropdown = false;
        }

        if (!multiSessionEnabled) {
            setTimeout(() => {
                updateCartCookie();
            }, 0);
        }

        populateProductAddedDropdown();

        if (!multiSessionEnabled) {
            setTimeout(() => {
                resetDeleteCartCookie();
            }, 0);
        }
    };

    // initialize widget
    $("#MiniShoppingCart").refreshWidget({ renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler });
}

function declareMiniShopCartContentsRefreshArea() {
    //console.log("PSL::MiniShopCartDisplay.js::declareMiniShopCartContentsRefreshArea()::BEGIN");
    // ============================================
    // div: MiniShopCartContents refresh area
    // Declares a new refresh controller for the Mini Shopping Cart contents

    // Declares a new render context for the Mini Shopping Cart contents.
    wcRenderContext.declare("MiniShopCartContentsContext", ["MiniShopCartContents"], { status: "init", relativeId: "", contentId: "", contentType: "" });

    /*
     * Refreshes the mini shopping cart contents since it is out of date.
     * This function is called when a render context changed event is detected.
     */
    var renderContextChangedHandler = function(event, data) {
        if (!dropdownUpdated) {
            wcRenderContext.getRenderContextProperties("MiniShopCartContentsContext").fetchCartContents = true;
            dropdownUpdated = true;
            $("#MiniShopCartContents").refreshWidget("refresh", wcRenderContext.getRenderContextProperties("MiniShopCartContentsContext"));
        }
    };

    /*
     * Indicate that the mini cart contents are out of date upon an order change action.
     * This function is called when a modelChanged event is detected.
     */
    var events = $.extend({}, order_updated, { "AjaxDeleteOrderItemForShippingBillingPage": "AjaxDeleteOrderItemForShippingBillingPage", "AjaxRESTOrderLockUnlockOnBehalf": "AjaxRESTOrderLockUnlockOnBehalf" });
    wcTopic.subscribe(events, function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShopCartContentsRefreshArea().wcTopic.subscribe()::BEGIN");
        dropdownUpdated = false;
    });

    /*
     * Displays and positions the mini shop cart contents.
     * This function is called after a successful refresh.
     */
    var postRefreshHandler = function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShopCartContentsRefreshArea().postRefreshHandler()::BEGIN");
        var renderContextProperties = wcRenderContext.getRenderContextProperties("MiniShopCartContentsContext");
        positionMiniShopCartDropDown(renderContextProperties.relativeId, renderContextProperties.contentId, renderContextProperties.contentType);
        //
        // This is needed for CSR solution. When CSR and shopper are browsing the store in simultaenously in
        // different browsers and if CSR locks/unlocks the shoppers cart, the miniCart in shopper's browser will
        // NOT reflect the change unless shopper takes some order related actions (add/delete from cart).
        // So to update the miniCart status loadMiniCart() function is called here.
        // It doesn't make another server call. The data returned from the MiniCartContentsUI is used
        // to refresh the miniCart summary.
        //
        updateCartCookie();
        loadMiniCart(WCParamJS.commandContextCurrency, WCParamJS.langId);
    };

    // initialize widget
    $("#MiniShopCartContents").refreshWidget({ renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler });

}

/**
 * Displays the dropdown content of the mini shopping cart when the user hovers over the
 * mini shopping cart if the contents are up-to-date or retrieve the latest contents from server.
 *
 * PSL:: This OOTB function can block the minishopcart. The variable dropdownInit is true while the shopcart is loading.
 * If the user clicks the shoppingcart again while it's loading (dropdownInit variable is 'true') sometimes this flag
 * never goes back to false and the user cannot open the MSC anymore until page reload.
 * In order to solve this issue we added a function that prevents extra clicks over the shopping bag icon
 * while the minishoppingcart popup is loading (See lockShoppingBagIcon()/unlockShoppingBagIcon())
 *
 * @param {string} relativeId The id of a placeholder element to position the dropdown relatively
 * @param {string} contentId The id of the content pane containing the mini shopping cart dropdown contents
 * @param {string} contentType The content that will be shown in the expanded mini shopping cart dropdown.
 */
function showMiniShopCartDropDown(relativeId, contentId, contentType) {
    //isOnPasswordUpdateForm flag is set at UpdatePasswordForm.jsp, in other cases the variable type will always be undefined or value equals false.
    // Need this line otherwise it'll throw a isOnPasswordUpdateForm is undefined error
    //console.log("PSL::MiniShopCartDisplay.js::showMiniShopCartDropDown()::BEGIN");
    var isOnPasswordUpdateForm = isOnPasswordUpdateForm;
    if (!dropdownInit && (Utils.isUndefined(isOnPasswordUpdateForm) || isOnPasswordUpdateForm == false)) {
        dropdownInit = true;
        lockShoppingBagIcon();

        if (!dropdownUpdated) {
            //console.log("PSL::MiniShopCartDisplay.js::showMiniShopCartDropDown()::Entro por el IF");
            update_content = true;
            var params = {
                status: "load",
                relativeId: relativeId,
                contentId: contentId,
                contentType: contentType,
                page_view: "dropdown"
            };
            wcRenderContext.updateRenderContext("MiniShopCartContentsContext", params);
        } else {
            //console.log("PSL::MiniShopCartDisplay.js::showMiniShopCartDropDown()::Entro por el ELSE");
            positionMiniShopCartDropDown(relativeId, contentId, contentType);
        }
    }
}

function toggleMiniShopCartDropDown(relativeId, contentId, contentType) {
    if((brandCode == 'PO' || brandCode == 'OP') && $('#page').hasClass('pdp')) {
        // if(!(window.mobilecheck() || window.tabletPortraitCheck()))hideHeaderTimeout.cancel();
        (dialogWidget && dialogWidget._isOpen) ? $("#page-overflow-wrapper").removeClass("overflow-hidden") : $("#page-overflow-wrapper").addClass("overflow-hidden");
    }
    //console.log("PSL::MiniShopCartDisplay.js::toggleMiniShopCartDropDown()::BEGIN");}
    if (dialogWidget && dialogWidget._isOpen) {
        if((brandCode == 'PO' || brandCode == 'OP') && $('#page').hasClass('pdp')){
            hideHeaderTimeout.setup();
        }
        //console.log("PSL::MiniShopCartDisplay.js::toggleMiniShopCartDropDown()::Entro por el IF");
        dialogWidget.close();
    } else {
        //console.log("PSL::MiniShopCartDisplay.js::toggleMiniShopCartDropDown()::Entro por el ELSE");
        showMiniShopCartDropDown(relativeId, contentId, contentType);
        if((brandCode == 'PO' || brandCode == 'OP') && $('#page').hasClass('pdp')){
            hideHeaderTimeout.cancel();
        }
    }
}

/*
 * Displays the dropdown content of the mini shopping cart.
 *
 * @param {string} relativeId The id of a placeholder element to position the dropdown relatively
 * @param {string} contentId The id of the content pane containing the mini shopping cart dropdown contents
 * @param {string} contentType The content that will be shown in the expanded mini shopping cart dropdown.
 */
function positionMiniShopCartDropDown(relativeId, contentId, contentType) {
    //console.log("PSL::MiniShopCartDisplay.js::positionMiniShopCartDropDown()::BEGIN");
    var add_event_handlers = function(contentElement) {
        //console.log("PSL::MiniShopCartDisplay.js::positionMiniShopCartDropDown().add_event_handlers()::BEGIN");
        contentElement.on("wcdialogopen", function(event) {
            //deactivate(document.getElementById("header"));
            $("#" + relativeId).addClass("selected");
        });

        contentElement.on("wcdialogclose", function(event) {
            $("#" + relativeId).removeClass("selected");
        });
    };

    // Dialog is not yet created..Create one
    if (!dialogWidget /*PSL Force dialog creation */ || true) {
        var content = $("#" + contentId);
        if (contentId === "MiniShopCartProductAdded") {
            // The content may have been hidden so show it
            $("#MiniShopCartProductAddedWrapper").removeAttr("style");
        }
        dialogWidget = content.WCDialog({
            position: {
                my: "right top",
                at: "right bottom",
                of: "#widget_minishopcart"
            },
            autoOpen: false,
            open: function() {
                // Make the element show up on top of the header elements
                dialogWidget.element.parent().css("z-index", 1);

                if (contentType == 'orderItemAdded') {
                    if(isOliver && (window.tabletPortraitCheck() || window.mobilecheck())){
                        $("#MiniShopCartProductAddedWrapper").css("display", "flex");
                    }else{
                        $("#MiniShopCartProductAddedWrapper").css("display", "block");
                    }
                }
            },
            appendTo: "#headerRow1",
            title: $("#" + contentId + "_ACCE_Label").html(),
            show_title: false,
            width: "360px",
            //dialogClass: "no-close",
            modal: false
        }).data("wc-WCDialog");
        add_event_handlers(content);
        update_content = false;

		/* APPLEPAY BEGIN */
		if (typeof(showApplePayButtons) == "function") {
			showApplePayButtons();
		}
        /* APPLEPAY END */

    } else {
        dialogWidget.close();
        if (update_content) {
            if (contentType == 'orderItemAdded') {
                if(isOliver && (window.tabletPortraitCheck() || window.mobilecheck())){
                    $("#MiniShopCartProductAddedWrapper").css("display", "flex");
                }else{
                    $("#MiniShopCartProductAddedWrapper").css("display", "block");
                }
            }
            var newContent = $("#" + contentId);
            dialogWidget.update_content("#" + contentId);
            add_event_handlers(newContent);
            update_content = false;
        }
    }

    if (Utils.get_IE_version() < 7) {
        dialogWidget.css("display", "block");
    }
    
    //Start HB-12482 
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
	    $("html, body").animate({
	        scrollTop: 0
	    }, {
	        duration: 200
	    }).promise().done(function() {
	        dialogWidget.open();
	        dialogWidget.reposition();
	    });
    }else if((window.mobilecheck() || window.tabletPortraitCheck())){
    	$("html").css("overflow", "hidden");
    	$("html, body").animate({
	        //scrollTop: 0
	    }, {
	        duration: 200
	    }).promise().done(function() {
	        dialogWidget.open();
	        dialogWidget.reposition();
	    });
    }
    //End HB-12482 
    
    dropdownInit = false;

    unlockShoppingBagIcon();
}

/*
 * Store the current mini cart information in the mini cart cookie.
 */
function updateCartCookie() {
    //Save current order information into cookie
    if ($("#currentOrderQuantity").length && $("#currentOrderAmount").length && $("#currentOrderCurrency").length && $("#currentOrderId").length && $("#currentOrderLanguage").length) {
        var cartQuantity = $("#currentOrderQuantity").val();
        var cartAmount = $("#currentOrderAmount").val();
        var cartCurrency = $("#currentOrderCurrency").val();
        var cartLanguage = $("#currentOrderLanguage").val();
        var cartOrderId = $("#currentOrderId").val();
        var currentOrderLocked = $("#currentOrderLocked").val();

        //Clear out previous cookies
        var orderIdCookie = getCookie("WC_CartOrderId_" + WCParamJS.storeId);
        if (orderIdCookie != null) {
            setCookie("WC_CartOrderId_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
            var cartTotalCookie = getCookie("WC_CartTotal_" + orderIdCookie);
            if (cartTotalCookie != null) {
                setCookie("WC_CartTotal_" + orderIdCookie, null, {
                    expires: -1,
                    path: '/',
                    domain: cookieDomain
                });
            }
        }
        setCookie("WC_CartOrderId_" + WCParamJS.storeId, cartOrderId, {
            path: '/',
            domain: cookieDomain
        });
        if (cartOrderId !== "") {
            setCookie("WC_CartTotal_" + cartOrderId, cartQuantity + ";" + cartAmount + ";" + cartCurrency + ";" + cartLanguage + ";" + currentOrderLocked, {
                path: '/',
                domain: cookieDomain
            });
        }
    } else {
        setCookie("WC_CartOrderId_" + WCParamJS.storeId, "", { path: '/', domain: cookieDomain });
    }
}

function setProductAddedList(newProductAddedList) {
    productAddedList = newProductAddedList;
}

/*
 * Populates the Product Added dropdown upon an add to cart action.
 */
function populateProductAddedDropdown() {


    var search = '"';

    var replaceStr = "'";
    for (productId in productAddedList) {
        var productDetails = productAddedList[productId];

        if ($("#MiniShopCartAddedProdName_" + productId).length && productDetails[0] != null && productDetails[0].length != 0) {
            $("#MiniShopCartAddedProdName_" + productId).html(productDetails[0]);
        }

        /* OOTB - PSL:: We disabled this code because it replaces the thumbnail with the fullimage of the catentry
        if ($("#MiniShopCartAddedProdImgSrc_" + productId).length && productDetails[1] != null && productDetails[1].length != 0) {
            $("#MiniShopCartAddedProdImgSrc_" + productId).attr("src", productDetails[1]);
            document.getElementById('MiniShopCartAddedProdImgSrc_' + productId).alt = productDetails[0];
        }
        */

        if ($("#MiniShopCartAddedProdPrice_" + productId).length && productDetails[2] != null && productDetails[2].length != 0) {
            $("#MiniShopCartAddedProdPrice_" + productId).html(productDetails[2]);
        }
        if ($("#MiniShopCartAddedProdQty_" + productId).length && productDetails[3] != null && productDetails[3].length != 0) {
            $("#MiniShopCartAddedProdQty_" + productId).html(productDetails[3]);
        }

        if ($("#MiniShopCartAddedProdAttr_" + productId).length && productDetails[4] != null && productDetails[4].length != 0) {
            $("#MiniShopCartAddedProdAttr_" + productId).html("");

            for (attrName in productDetails[4]) {
                attrValue = productDetails[4][attrName];
                if (attrValue != null && attrValue != 'undefined') {
                    attrValue = attrValue.replace(/&amp;/g, "&").replace(/&#039;/g, "'").replace(/&#034;/g, '"').replace(replaceStr, search);
                }
                document.getElementById('MiniShopCartAddedProdAttr_' + productId).innerHTML += '<div>' + attrName + ': ' + attrValue + '</div>';
            }
        }
    }
    wcTopic.publish("ProductInfo_Reset");
}

/*
 * Loads mini shop cart info upon page load.
 * @param {String} contextCurrency Current currency selected.
 * @param {String} langId Current language selected.
 */
function loadMiniCart(contextCurrency, langId) {
    var updateCart = false;
    var orderIdCookie = getCookie("WC_CartOrderId_" + WCParamJS.storeId);

      if (orderIdCookie != undefined && orderIdCookie === "") {
        var subtotal = document.getElementById("minishopcart_subtotal");
        var formattedSubtotal = null;
        if ($("#currentOrderAmount").length) {
            formattedSubtotal = Utils.formatCurrency($("#currentOrderAmount").val(), {
                currency: contextCurrency
            });
        }
        if (formattedSubtotal == null && $("#currentOrderAmount").length) {
            formattedSubtotal = $("#currentOrderAmount").val();
        }

        if (subtotal != null) {
            subtotal.innerHTML = "\n " + formattedSubtotal + "\n ";
        }
        var items = document.getElementById("minishopcart_total");
        if (items != null) {
            var itemsMsg = null;
            if ($("#currentOrderQuantity").length) {
                itemMsg = $("#currentOrderQuantity").val();
            }
            if (itemsMsg == null) {
                itemsMsg = "0";
            }
            items.innerHTML = "\n " + itemsMsg + "\n ";
        }
    } else if (orderIdCookie != undefined && orderIdCookie !== "") {
        var cartCookie = getCookie("WC_CartTotal_" + orderIdCookie);

        if (cartCookie != undefined && cartCookie != null && cartCookie !== "") {
            var orderInfo = cartCookie.split(";");

            if (orderInfo != null && orderInfo.length > 3) {
                if (orderInfo[2] == contextCurrency && orderInfo[3] == langId) {
                    var subtotal = document.getElementById("minishopcart_subtotal");
                    if (subtotal != null) {
                        var formattedSubtotal = null;
                        formattedSubtotal = Utils.formatCurrency(orderInfo[1].toString(), {
                            currency: contextCurrency
                        });
                        if (formattedSubtotal == null) {
                            formattedSubtotal = orderInfo[1].toString();
                        }
                        subtotal.innerHTML = "\n " + formattedSubtotal + "\n ";
                    }
                    var currentOrderLocked = false;
                    if (orderInfo[4] != null && orderInfo[4] == 'true') {
                        var currentOrderLocked = true;
                    }
                    var items = document.getElementById("minishopcart_total");
                    var lock = document.getElementById("minishopcart_lock");
                    if (items != null) {
                        var itemsMsg = orderInfo[0].toString();
                        items.innerHTML = "\n " + itemsMsg + "\n ";
                        if (currentOrderLocked) {
                            $(items).addClass("nodisplay");
                            $(lock).removeClass("nodisplay");
                        } else {
                            $(items).removeClass("nodisplay");
                            $(lock).addClass("nodisplay");
                        }
                    }
                } else {
                    updateCart = true;
                }
            } else {
                updateCart = true;
            }
        } else {
            updateCart = true;
        }
    } else {
        updateCart = true; 
    }
    //isOnPasswordUpdateForm flag is set at UpdatePasswordForm.jsp, in other cases the variable type will always be undefined or value equals false.
    // Need this line otherwise it'll throw a isOnPasswordUpdateForm is undefined error
    var isOnPasswordUpdateForm = isOnPasswordUpdateForm;
    if (updateCart == true && (Utils.isUndefined(isOnPasswordUpdateForm) || isOnPasswordUpdateForm == false)) {
        wcRenderContext.updateRenderContext('MiniShoppingCartContext', {
            'status': 'load'
        });
    }
}


/*
 * Turn on the flag to indicate that the mini cart cookies should be refreshed.
 */
function setDeleteCartCookie() {
    setCookie("WC_DeleteCartCookie_" + WCParamJS.storeId, true, {
        path: '/',
        domain: cookieDomain
    });
}

/*
 * Check whether the mini cart cookies need to be updated or not.
 */
function checkDeleteCartCookie() {
    var deleteCartCookieVal = getCookie("WC_DeleteCartCookie_" + WCParamJS.storeId);

    if (deleteCartCookieVal != undefined && deleteCartCookieVal !== "") {
        if (deleteCartCookieVal == 'true') {
            return true;
        }
    }
    return false;
}

/*
 * Delete the flag that indicates the mini cart cookie should be refreshed.
 */
function resetDeleteCartCookie() {
    var deleteCartCookieVal = getCookie("WC_DeleteCartCookie_" + WCParamJS.storeId);

    if (deleteCartCookieVal != null) {
        setCookie("WC_DeleteCartCookie_" + WCParamJS.storeId, null, {
            expires: -1,
            path: '/',
            domain: cookieDomain
        });
    }
}
wcTopic.subscribe("ProductInfo_Added", setProductAddedList);

/* WISHLIST */

function addProductToWishlist(productIdToAdd,wishlistDiv){

    var defaultWishlistExternalId = sessionStorage.defaultWishlistExternalId;

    //  When generic user, create new user Id
    var userId = getUserId();
    if (userId == "-1002") userId = setUserIdentity();

    //If default wishlist doesn't exist, create it and add item
    if (typeof defaultWishlistExternalId == "undefined" || defaultWishlistExternalId == ""){
        var wishlistData = {};
        var itemData = {};
        itemData.productId = productIdToAdd;//productDisplayJS.changedCatEntryId;
        itemData.quantityRequested = "1.0";
        wishlistData.item = itemData;

        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/wishlist";
        wishlistUpdateAjaxRequestOngoing = true;

        return new Promise((resolve, reject) => {
            $.ajax({
                type: "POST",
                url: url,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache, no-store, must-revalidate"
                },
                dataType: 'json',
                data: JSON.stringify(wishlistData),
                success: function(data, textStatus, jqXHR){
                    console.log("WishList created and item added successfully:", data);
                    defaultWishlistExternalId = data.uniqueID;
                    sessionStorage.defaultWishlistExternalId = defaultWishlistExternalId;
                    //Once added item to wishlist, add it to wishlistObj
                    var addedProductIdArray = [];
                    addedProductIdArray.push(productIdToAdd);
                    var giftListItemID = data.item[0].giftListItemID;
                    retrieveWishlistProductsData(false, addedProductIdArray, giftListItemID);
                    resolve(data);
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    console.log("Error while creating WishList and adding item:", wishlistData);
                    console.log("Status: " + textStatus + " ; Error: " + errorThrown);
                    reject(errorThrown);
                },
                complete: function(){
                    wishlistUpdateAjaxRequestOngoing = false;
                }
            });
        })

    } else {
        var wishlistData = {};
        var itemData = {};
        itemData.productId = productIdToAdd;
        itemData.quantityRequested = "1.0";
        wishlistData.item = itemData;

        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/wishlist/" + defaultWishlistExternalId + "?addItem=true";
        wishlistUpdateAjaxRequestOngoing = true;

        return new Promise((resolve, reject) => {
            $.ajax({
                type: "PUT",
                url: url,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache, no-store, must-revalidate"
                },
                dataType: 'json',
                data: JSON.stringify(wishlistData),
                success: function(data, textStatus, jqXHR){
                    console.log("WishList updated and item added successfully:", data);
                    defaultWishlistExternalId = data.uniqueID;
                    sessionStorage.defaultWishlistExternalId = defaultWishlistExternalId;
                    //Once added item to wishlist, add it to wishlistObj
                    var addedProductIdArray = [];
                    addedProductIdArray.push(productIdToAdd);
                    var giftListItemID = data.item[0].giftListItemID;
                    retrieveWishlistProductsData(false, addedProductIdArray, giftListItemID);
                    // setWishListIconAsFavorite("${catalogEntryDetails.uniqueID}");
                    resolve(data);
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    console.log("Error while updating WishList and adding item:", wishlistData);
                    console.log("Status: " + textStatus + " ; Error: " + errorThrown);
                    reject(errorThrown);
                },
                complete: function(){
                    wishlistUpdateAjaxRequestOngoing = false;
                }
            });
        });
    }
}

function deleteProductFromWishlist(productIdToRemove,wishlistDiv){

    var wishlistUpdateAjaxRequestOngoing = false;

    if (!wishlistUpdateAjaxRequestOngoing){

        var defaultWishlistExternalId = sessionStorage.defaultWishlistExternalId;
        var wishlistObj = sessionStorage.wishlistObj;
        
        if (typeof productIdToRemove != "undefined" && productIdToRemove != "" && typeof wishlistObj != "undefined" ){
            var wishlistData = JSON.parse(wishlistObj);
            if(wishlistData[productIdToRemove] != undefined){
                var giftListItemId = wishlistData[productIdToRemove].giftListItemID;
            }

            if (typeof defaultWishlistExternalId != "undefined" && defaultWishlistExternalId != "" && giftListItemId != ""){

                var url = "/wcs/resources/store/" + WCParamJS.storeId + "/wishlist/" + defaultWishlistExternalId + "?itemId=" + giftListItemId;
                wishlistUpdateAjaxRequestOngoing = true;

                return new Promise((resolve, reject) => {            
                    $.ajax({
                        url: url,
                        type: 'DELETE',
                        success:function(data, textStatus, jqXHR){
                            console.log("Product deleted from WishList:", data);
                            //Once removed item from wishlist, remove it from wishlistObj
                            manageWishlistObject(undefined,undefined,productIdToRemove,giftListItemId,undefined);
                            var productData = JSON.parse(sessionStorage.wishlistObj);
                            var wishlistToDeleteData = {};
                            wishlistToDeleteData.isWishlistProductToDelete = true;
                            wishlistToDeleteData.productIdToRemove = productIdToRemove;
                            // If you are in the wishlist page, reload tiles without redirect
                            if ($("#page").hasClass("wishListDisplay")){
                                // If an item is removed from wishlist, render tiles again without refreshing page
                                $("#wishlist_grid .product_image[data-id=" + productIdToRemove + "]").parents("li").remove();
                                fn_plpFirstTiles(productData,undefined,true,wishlistToDeleteData);
                            }
                            resolve(data);
                        },
                        error:function(jqXHR, exception){
                            var msg = "";
                            if (jqXHR.status === 0) {
                                msg = "Not connected.\n Verify Network.";
                            } else if (jqXHR.status == 404) {
                                msg = "Requested page not found. [404]";
                            } else if (jqXHR.status == 500) {
                                msg = "Internal Server Error [500].";
                            } else if (exception === "parsererror") {
                                msg = "Requested JSON parse failed.";
                            } else if (exception === "timeout") {
                                msg = "Time out error.";
                            } else if (exception === "abort") {
                                msg = "Ajax request aborted.";
                            } else {
                                msg = "Uncaught Error.\n" + jqXHR.responseText;
                            }
                            console.log("Error while deleting product from WishList:", msg);
                            reject(msg);
                        },
                        complete:function(){
                            wishlistUpdateAjaxRequestOngoing = false;
                        }
                    });
                });
            }
        }
    }
}



function yieldToMain () {
	  return new Promise(resolve => {
	    setTimeout(resolve, 0);
	  });
 }


// Retrieve wishlist info from default wishlist 
// users can have multiple wishlists but we are just considering the default one
async function getWishlistProducts(){

    var wishlistUpdateAjaxRequestOngoing = false;

    
    await yieldToMain();
    var userId = getUserId();
    await yieldToMain();
    
    if (userId == "-1002") userId = setUserIdentity(); 

    return new Promise((resolve, reject) => {

        wishlistUpdateAjaxRequestOngoing = true;

        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/wishlist/@default";
        var parameters = {};
        parameters["timestamp"] = Date.now();

        $.ajax({
            url: url,
            type: 'GET',
            async: false,
            data: parameters,
            success: function(data) {
                resolve(data);
            },
            error: function(error) {
                console.error(error);
                reject(error);
            }
        });
    }).then(function(defaultWishlistInfo){
        console.log("defaultWishlistInfo:",defaultWishlistInfo);
        if (defaultWishlistInfo==null){
            return null;
        } else {
            if (typeof defaultWishlistInfo.GiftList != "undefined"){
                defaultWishlistExternalId = defaultWishlistInfo.GiftList[0].externalIdentifier;
                sessionStorage.defaultWishlistExternalId = defaultWishlistExternalId;

                if (typeof defaultWishlistExternalId != "undefined"){
                    var wishlistProductIdsArray = [];
                    var giftListItemsArray = defaultWishlistInfo.GiftList[0].item;
                    if (giftListItemsArray.length>0){
                            /*
                            if (item.productId == productDisplayJS.changedCatEntryId){
                                setWishListIconAsFavorite("${catalogEntryDetails.uniqueID}");
                                break;
                            }
                            */
                        
                        retrieveWishlistProductsData(true, giftListItemsArray);
                        wishlistUpdateAjaxRequestOngoing = false;
                    }
                } else {
                    //Empty wishlist case
                    console.log("WishList is empty");
                    wishlistUpdateAjaxRequestOngoing = false;
                }
            } else {
                //Empty wishlist case
                console.log("WishList is empty");
                wishlistUpdateAjaxRequestOngoing = false;
            }

            if (typeof wishlistProductIdsArray == "undefined"){
                var wishlistProductIdsArray = [];
            }
        }
    }).catch(function(){
        console.log("WishList info not found");
        wishlistUpdateAjaxRequestOngoing = false;
    });
}

//Create and update JSON Object with wishlist's products info
function manageWishlistObject(wishlistProductBeansData, wishlistProductsData, removedProductId, giftListItemID, productsGiftListObj, addedProductId) {

    if (typeof wishlistProductsData != "undefined"){
        if (typeof sessionStorage.wishlistObj != "undefined"){
            var wishlistObj = JSON.parse(sessionStorage.wishlistObj);
        } else {
            var wishlistObj = {};
        }

        $.each(wishlistProductBeansData.catalogEntryView, function (index, productBean){
            $.each(wishlistProductsData.catalogEntryView, function(index, product){
                if (productBean.uniqueID == product.parentCatalogEntryID){
                    var productId = product.uniqueID;
                    wishlistObj[productId] = product;
                    wishlistObj[productId].attributes = wishlistObj[productId].attributes.concat(productBean.attributes);

                    if (typeof productsGiftListObj != "undefined"){
                        wishlistObj[productId].giftListItemID = productsGiftListObj[productId];
                    }
                    if (typeof giftListItemID != "undefined"){
                        wishlistObj[productId].giftListItemID = giftListItemID;
                    }
                }
            });
        });


        sessionStorage.setItem("wishlistObj", JSON.stringify(wishlistObj));
        setNumberWishlistProduct($('.header_wishlist_container'), undefined);//update counter
        var partNumber = wishlistProductsData.catalogEntryView[0].partNumber;
        tealiumPushWishlistAdd(wishlistObj, addedProductId, partNumber); 
        console.log("wishlistObj: ", JSON.parse(sessionStorage.wishlistObj));
    } else if(typeof removedProductId != "undefined" && removedProductId != ""){  //remove item from wishlistObj
        if (typeof sessionStorage.wishlistObj != "undefined"){
            var wishlistObj = JSON.parse(sessionStorage.wishlistObj);

            delete wishlistObj[removedProductId];

            sessionStorage.setItem("wishlistObj", JSON.stringify(wishlistObj));
            setNumberWishlistProduct($('.header_wishlist_container'));//update counter
            console.log("wishlistObj: ", JSON.parse(sessionStorage.wishlistObj));
        } 
    }
}

// This function retrieves all the wishlist products details, given the IDs array of the products 
// in the wishlist
function retrieveWishlistProductsData(isGetWishlistProducts, products, giftListItemID) {

    var productIds = [];
    var productsGiftListObj = {};

    for(var i = 0; i<products.length; i++){
        var product = products[i];
        if (!isGetWishlistProducts){
            productIds.push(product);
        } else {
            productIds.push(product.productId);
            productsGiftListObj[product.productId] = product.giftListItemID; //object with productId and giftListItemId association -> { productId : giftListItemID }
        }
    }
  
    if (productIds.length > 0) {
        // Compose service url
        var productServiceUrl =
          (isInToolkit ? "" : WCParamJS.homePageURL) +
          "/search/resources/store/" +
          WCParamJS.storeId +
          "/productview/byIds?id=" +
          productIds.join("&id=") +
          "&catalogId=" +
          WCParamJS.catalogId +
          "&responseFormat=json&langId=" +
          WCParamJS.langId +
          "&currency=" +
          WCParamJS.commandContextCurrency +
          "&profileName=LUX_findProductByIds_Details" +
          ((window.customerSegment != undefined && window.customerSegment != "") ? ("&customerSegment=" + window.customerSegment) : "")
          ;
      
        return new Promise((resolve, reject) => {
            $.ajax({
                method: "GET",
                url: productServiceUrl,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache, no-store, must-revalidate"
                },
                data: "",
                async: false,
                success: function(data) {                   
                    resolve(data);
                },
                error: function(error) {
                    console.error(error);
                    reject(error);
                }
            });
        })
        .then(function(data){
            retrieveWishlistProductBeansData(data, giftListItemID, productsGiftListObj, products);
        });
    }
}

// We retrieve the productBeans data of the wishlist items to add more attributes (color name, badges, ecc..)
function retrieveWishlistProductBeansData(wishlistItemBeansData, giftListItemID, productsGiftListObj, addedProductId){
    
    var productBeansIds = [];

    for(var i = 0; i < wishlistItemBeansData.catalogEntryView.length; i++){
        var productBeanId = wishlistItemBeansData.catalogEntryView[i].parentCatalogEntryID;
        productBeansIds.push(productBeanId);
    }
    
    if (productBeansIds.length > 0) {
        // Compose service url
        var productServiceUrl =
          (isInToolkit ? "" : WCParamJS.homePageURL) +
          "/search/resources/store/" +
          WCParamJS.storeId +
          "/productview/byIds?id=" +
          productBeansIds.join("&id=") +
          "&catalogId=" +
          WCParamJS.catalogId +
          "&responseFormat=json&langId=" +
          WCParamJS.langId +
          "&currency=" +
          WCParamJS.commandContextCurrency +
          "&profileName=LUX_findProductByIds_Details" +
          ((window.customerSegment != undefined && window.customerSegment != "") ? ("&customerSegment=" + window.customerSegment) : "")
          ;
      
        return new Promise((resolve, reject) => {
            $.ajax({
                method: "GET",
                url: productServiceUrl,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache, no-store, must-revalidate"
                },
                data: "",
                async: false,
                success: function(data) {                   
                    resolve(data);
                },
                error: function(error) {
                    console.error(error);
                    reject(error);
                }
            });
        })
        .then(function(data){
            manageWishlistObject(data, wishlistItemBeansData, undefined, giftListItemID, productsGiftListObj, addedProductId);
        });
    }
}

//this function manages the user's click on the wishlist icon:
//if the product is present it removes it 
//if it is not present in the wishlist it adds it
function manageWishlistAction(wishlistDiv,isCart){
    var productId = $(wishlistDiv).attr("data-catentryIdItem-wishlist");
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;
    var isPlp = $(".plp").length > 0 ? true : false;
    var isDesktop = (window.tabletPortraitCheck() || window.mobilecheck()) ? false : true;
    var wishlistTotalDiv = $('.header_wishlist_container');
    var searchedWord = $('input.searchInput').val().toLowerCase();
    var isList = $('.grid_mode').hasClass('grid_mode-one-col');

    if(productId != null && typeof productId != 'undefined'){
        if($(wishlistDiv).hasClass("wishlist_product")){
            if(!isCart){
                setNumberWishlistProduct(wishlistTotalDiv, false);
                deleteProductFromWishlist(productId,wishlistDiv);
                //delete class wishlist_product
                if(typeof wishlistDiv != 'undefined'){
                    $(wishlistDiv).removeClass("wishlist_product");
                    //fix for   HB-13632
                    $(wishlistDiv).addClass("wishlist_product_disableOnHover");
                    $(wishlistDiv).mouseleave(function(){
                        $(wishlistDiv).removeClass("wishlist_product_disableOnHover");
                    });
                    // end fix for HB-13632
                }
                if(isCart){
                    tealium_data2track.push({
                        'id':'Click', 
                        'data_element_id': 'X_Cart_Prod_RemoveWishlist',
                        'data_description': 'wishlist',
                    });
                } else if(isWishlistPage){
                    tealium_data2track.push({
                        'id':'Click', 
                        'data_element_id': 'X_Wishlist_Prod_RemoveWishlist',
                        'data_description': 'wishlist',
                    });
                } else if(isPlp){
                    tealium_data2track.push({
                        'id':'Click', 
                        'data_element_id': 'X_Plp_Prod_RemoveWishlist',
                        'data_description': 'wishlist',
                    });
                    //When removing a product from wishlist in PLP, change the order of the items in the carousel (wishlist products in first positions)
                    if (isDesktop){
                        var el = $('#plp_grid div[data-catentryiditem-wishlist="' + productId + '"]').parents(".plp__other-product-carousel");
                        var gridItem = $(el).parents(".grid-item");
                        var isWishlistPLPRemoved = true;
                    }
                } else {
                    tealium_data2track.push({
                        'id':'Click', 
                        'data_element_id': 'X_Pdp_Prod_RemoveWishlist',
                        'data_description': 'wishlist',
                    });
                }
            }
        }else{
            setNumberWishlistProduct(wishlistTotalDiv, true);
            addProductToWishlist(productId,wishlistDiv);
            if(typeof wishlistDiv != 'undefined'){
                if(isCart){
                    $("div[data-catentryiditem-wishlist='"+ productId +"']").addClass("wishlist_product");//add wishlist_product class if there are two same products
                }else{
                    $(wishlistDiv).addClass("wishlist_product");
                    if (isPlp && !searchedWord){
                        if (isDesktop){
                            var el = $('#plp_grid div[data-catentryiditem-wishlist="' + productId + '"]').parents(".plp__other-product-carousel");
                            if (typeof productId != "undefined" && productId != ""){
                                replaceWishlistProductImages(wishlistDiv);
                            } else {
                                console.error("Catentry default size not found");
                            }
                        }
                    }
                }
                //fix for HB-13632
                $(wishlistDiv).addClass("wishlist_product_disableOnHover");
                $(wishlistDiv).mouseleave(function(){
                    $(wishlistDiv).removeClass("wishlist_product_disableOnHover");
                });
                //end fix for HB-13632
                
            }
            if(isCart){
                tealium_data2track.push({
                    'id':'Click', 
                    'data_element_id': 'X_Cart_Prod_AddToWishList',
                    'data_description': 'wishlist',
                    //'Click_FocusElement' : element
                });
            } else if(isPlp){
                tealium_data2track.push({
                    'id':'Click', 
                    'data_element_id': 'X_Plp_Prod_AddToWishList',
                    'data_description': 'wishlist',
                    //'Click_FocusElement' : element
                });
            } else{
                tealium_data2track.push({
                    'id':'Click', 
                    'data_element_id': 'X_Pdp_Prod_AddToWishList',
                    'data_description': 'wishlist',
                    //'Click_FocusElement' : element
                });
            }
            
        }
       
    }
   
}

// When adding a color to wishlist and moving it to first position of carousel, replace and show the front image
function replaceWishlistProductImages(wishlistDiv){
    var productUniqueId = $(wishlistDiv).parent().attr("data-id");
    var imageContainer = "";
    if (isPersol){
        imageContainer = $(wishlistDiv).siblings(".product__image-container").first(); 
    } else if (isOliver) {
        imageContainer = $(wishlistDiv).siblings(".image").children().find(".image-container");
    }
    
    //Replace front image only if the product added to wishlist is not the first one in carousel
    if ($(wishlistDiv).parents(".owl-item").index() > 0){
        try {
            if (typeof $plpSearchObj != "undefined"){
                var products = $plpSearchObj.items;
                for (product in products){
                    var currItemColors = products[product];
                    for(var i = 0; i < currItemColors.length; i++) {
                        if (currItemColors[i].uniqueID == productUniqueId){
                            if(currItemColors[i] != undefined && currItemColors[i].attributes != undefined) {
                                for(var m = 0; currItemColors[i].attributes.length > m; m++) {
                                    if(currItemColors[i].attributes[m].identifier === 'MODELNAME' && currItemColors[i].attributes[m].usage === 'Descriptive' ) {
                                        var modelNameValue = currItemColors[i].attributes[m].values[0].value;
                                    }
                                }
                            }
                            var isClipon = modelNameValue.toLowerCase().includes('clip');
                            var mustacheObj = {
                                modelName: modelNameValue != undefined ? modelNameValue : '',
                                image: function () {
                                    var stringOfThumbnail = null;
                                    if (isOliver){
                                        stringOfThumbnail =  replaceTileImgByDevice(currItemColors[i].thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                                    } else  {
                                        stringOfThumbnail =  replaceTileImgByDevice(currItemColors[i].thumbnail,'sclw=0.25&sclh=0.25','small');
                                    }
                                    return stringOfThumbnail;
                                },
                                imageScaled: function () {
                                    if (isOliver){
                                        // OP: scaling of 25% on mobile
                                        return replaceTileImgByDevice(currItemColors[i].thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                                    } else  {
                                        // PO: scaling of 25% on mobile
                                        return replaceTileImgByDevice(currItemColors[i].thumbnail,'sclw=0.25&sclh=0.25','small');
                                    }
                                },
                                replaceImageUrl: function () {
                                    var replaceImage = null;
                                    if (currItemColors[i].thumbnail != undefined) {
                                        if (isOliver){
                                            // OP: using of OV_OpPlp
                                            if (isClipon) {
                                                replaceImage = replaceTileImgByDevice(currItemColors[i].thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                                            }else{
                                                replaceImage = replaceTileImgByDevice(currItemColors[i].thumbnail2.replace('OV_OpPlp','OV_parameters_transp&WID'),'WID','small');
                                            }                                       
                                        } else {
                                            if (isClipon) {
                                                replaceImage = replaceTileImgByDevice(currItemColors[i].thumbnail, 'sclw=0.25&sclh=0.25', 'small');
                                            }else{
                                                replaceImage = replaceTileImgByDevice(currItemColors[i].thumbnail2,'sclw=0.25&sclh=0.25','small');
                                            }
                                        }
                                    }else{
                                        replaceImage = currItemColors[i].thumbnail;
                                    }
                                    return replaceImage;
                                },
                                replaceImageUrlScaled: function () {
                                    if (currItemColors[i].thumbnail != undefined) {
                                        if (isOliver){
                                            // OP: scaling of 25% on mobile
                                            if (isClipon) {
                                                return replaceTileImgByDevice(currItemColors[i].thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                                            }
                                            return replaceTileImgByDevice(currItemColors[i].thumbnail2.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                                        } else {
                                            // PO: scaling of 25% on mobile
                                            if (isClipon) {
                                                return replaceTileImgByDevice(currItemColors[i].thumbnail, 'sclw=0.25&sclh=0.25', 'small');
                                            }
                                            //AC: effettuate modifiche per persol anche se non indicate nel file excel
                                            return replaceTileImgByDevice(currItemColors[i].thumbnail2,'sclw=0.25&sclh=0.25','small');
                                        }
                                    }
                                    return currItemColors[i].thumbnail;
                                },
                            }
    
                            var templateHtml = $('#plpImageForWishlistTemplate').html();
                            html = Mustache.to_html(templateHtml, mustacheObj);
                            $(imageContainer).html(html);
                        }
                    }
                }
            }
        } catch (error) {
            console.error('Error in tile creation when adding product to wishlist', error);
        }
    }
}


// check PDP product is in wishist
function checkIsInWishlist(productId){

    if(typeof sessionStorage.wishlistObj != 'undefined'){
        var wishlistMap = JSON.parse(sessionStorage.wishlistObj);
        var productIdsInWishlist = Object.keys(wishlistMap);
  
        if(productIdsInWishlist.includes(productId)){
            return true;
        }else{
            return false;
        }
    
    }else{
        return false;
    }
    
  
  
  }

   /*wishlist*/
function init_wishlist_tooltip(){
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
        $(".wishlist-icon-container").mouseenter(function(){
            $(this).addClass("onHover");
            if($(this).hasClass("wishlist_product")){
                if (!isWishlistPage){
                    $(".infoMessage_popup_wishlist.wishlist_product").show();
                    $(".infoMessage_popup_wishlist.not_wishlist_product").hide();
                }else {
                    $(this).find(".infoMessage_popup_wishlist.wishlist_product").show();
                }
            }else{
                if (!isWishlistPage){
                    $(".infoMessage_popup_wishlist.not_wishlist_product").show();
                    $(".infoMessage_popup_wishlist.wishlist_product").hide();
                }else {
                    $(this).find(".infoMessage_popup_wishlist.not_wishlist_product").show();
                }
            }
            
        }).mouseleave(function() {
            $(this).removeClass("onHover");
            if($(this).hasClass("wishlist_product")){
                if (!isWishlistPage){
                    $(".infoMessage_popup_wishlist.wishlist_product").hide();
                } else {
                    $(this).find(".infoMessage_popup_wishlist.wishlist_product").hide();
                }
            }else{
                if (!isWishlistPage){
                    $(".infoMessage_popup_wishlist.not_wishlist_product").hide();
                } else {
                    $(this).find(".infoMessage_popup_wishlist.not_wishlist_product").hide();
                }
            }
        }).click(function(){
            $(this).removeClass("onHover");
            if($(this).hasClass("wishlist_product")){
                if (!isWishlistPage){
                    $(".infoMessage_popup_wishlist.wishlist_product").hide();
                    $(".infoMessage_popup_wishlist.not_wishlist_product").hide();
                } else {
                    $(this).find(".infoMessage_popup_wishlist.wishlist_product").hide();
                }
            }else{
                if (!isWishlistPage){
                    $(".infoMessage_popup_wishlist.wishlist_product").hide();
                    $(".infoMessage_popup_wishlist.not_wishlist_product").hide();
                } else {
                    $(this).find(".infoMessage_popup_wishlist.not_wishlist_product").hide();
                }
            }
        });
    }
}


function wishlistProductAdd2Cart(itemId){  
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;

    if (isWishlistPage){
        if (isOliver || isPersol) { 
            manageScrollOverlay(true);
        }
        
        if($("#add2CartBtn").attr("disabled") == "disabled"){
            return false;
        } else {
            fn_minicartRefresh();
            lockShoppingBagIcon();
            setCurrentId("add2CartBtn");
            resetRequest();

            productDisplayJS.Add2ShopCartAjax(itemId,1, false);
            itemId = itemId.split("_")[1];
            productPageAdd2Cart(itemId);

            if(isPersol){
            /* product.PriceFull=="" it takes to not apply discount to products already have pst*/
            if(customerWeekActive && typeof getCookie(CustomerWeek.cookieName) !== "undefined" && getCookie(CustomerWeek.cookieName) != ""){
                addPromotionsToUser("AddToCustomerSegment_Espot");
            }
            }
            
            updateTealiumProductsAddToCart(tealiumProducts, true);                    
        
            if(brandCode == 'PO'){
                $(window).scrollTop(0);
                if(!$('#header').is(':visible')){
                    $('#header').slideDown();
                    $("#bannerTop").css("display", "flex");
                }
                hideHeaderTimeout.cancel();
                $('body').css('overflow', 'hidden');
                $('#header').attr('productAdded','yes');
                $('#header').addClass("mincartOpened")
                $('body, html').css('height', '100%');
                $('body').css('display', 'block'); 

            }else if(brandCode == 'OP') {
                $('#header').attr('productAdded','yes');
            }
        }
    }
}  

function showWishlistCTAloader(productId){
    var button = $('[data-id="' + productId + '"]').find('[id^="productPageAdd2Cart"]');
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
    
        $(button).removeClass("loaded");
        button = $('[data-id="' + productId + '"]').find('[id^="add2CartBtn"]');
        $(button).removeClass("loaded");

    }else{

        $(button).find(".bag-icon").hide();
        $(button).find(".loadpanel_loader").css("display","inline-block");

    }
}


function hideWishlistCTALoader(productId){
    var button = $('[data-id="' + productId + '"]').find('[id^="productPageAdd2Cart"]');
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
    
        $(button).addClass("loaded");
        button = $('[data-id="' + productId + '"]').find('[id^="add2CartBtn"]');
        $(button).addClass("loaded");

    }else{
        
        $(button).find(".bag-icon").show();
        $("div.loadpanel_loader").hide();
    }
 }

/* This function checks replaces the current image in the minicart with the STD one for the given partnumber */
function replaceImageMinicart(imges, partnumber){
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;

    if (isWishlistPage){
        $.each(imges, function(index,img){
        var urlImg= img.dataset['src'];
        if(urlImg != undefined){
            img.dataset['src'] = urlImg;
            img.src = urlImg;
            }
        });
    }
}


function setNumberWishlistProduct(wishlistTotalDiv, isWishlistAdd){

    if (typeof sessionStorage.wishlistObj != "undefined"){
        var jsonWishlistObj =  JSON.parse(sessionStorage.wishlistObj);
        var count = Object.keys(jsonWishlistObj).length;

        //Add red dot/counter even if wishlist service has not been called yet
        if (typeof isWishlistAdd != "undefined"){
            if (isWishlistAdd){
                ++count;
            } else {
                --count;
            }
        }

        if(count > 0){
            if(isPersol){
                $(wishlistTotalDiv).html(count);
            }
            $(wishlistTotalDiv).addClass("counter-visible");
        }else{
            $(wishlistTotalDiv).removeClass("counter-visible");
        }
    }
}


//This function shows the Email me CTAs in the wishlist page
function wishlistAvailabilityCheckCTA(wishlistObj, catentryId) {

    if (typeof wishlistObj != 'undefined' && typeof catentryId != 'undefined') {

        var productWishlistObjData = wishlistObj[catentryId]; 
        var wishlistInventoryMap = productWishlistObjData.inventory;

        console.debug("wishlistAvailabilityCheckCTA processing for catentryId: "+catentryId);
        
        var flagLimitedEdition = false;
        var flagExclusive = false;

        for(var i=0;productWishlistObjData.attributes.length>i; i++) {
            if (productWishlistObjData.attributes[i].identifier === 'LIMITED_EDITION' && productWishlistObjData.attributes[i].values[0].identifier === 'True'  ) {
                flagLimitedEdition = true;
                break;
            }
            if (productWishlistObjData.attributes[i].identifier === 'EXCLUSIVE' && productWishlistObjData.attributes[i].values[0].identifier === 'True' ) {
                flagExclusive = true;
                break;
            }
        }
            var lifecycle = wishlistInventoryMap["lifeCycle"];
            var stock = wishlistInventoryMap["stock"];
            var ranking = wishlistInventoryMap["ranking"];
            var flagComingSoon = wishlistInventoryMap["flComingSoon"] == 'true';
            
            var productPrice = productWishlistObjData.price.price;

            if (lifecycle == 'ACTIVE') {
                if (stock > 0 && ranking == 2 && !flagComingSoon && productPrice != ""){
                    //ADD 2 CART
                    if((flagExclusive  == true || flagExclusive == false ) && (flagLimitedEdition == true || flagLimitedEdition == false)) {
                        $('#add2CartBtn_' + catentryId).removeClass('hidden').show();
                        $('#soldOut_' + catentryId).addClass("hidden");
                        $('#outOfStock_' + catentryId).addClass("hidden");
                    }
                    
                } else if (stock == 0) {
                    if (ranking == 2) ranking = 1;
                    // COMING SOON - BE THE FIRST TO KNOW

                    if (ranking == 1 && flagComingSoon && (flagExclusive == true || flagExclusive == false ) && (flagLimitedEdition  == true|| flagLimitedEdition == false)) {
                        $('#add2CartBtn_' + catentryId).addClass("hidden");
                        $('#soldOut_' + catentryId).addClass("hidden");
                        $('#outOfStock_' + catentryId).removeClass('hidden').show();

                    } else if (ranking == 1 && !flagComingSoon && productPrice != "") {
                        // EMAIL ME WHEN AVAILABLE --> OLD COMING BACK SOON (OUT OF STOCK)

                        $('#add2CartBtn_' + catentryId).addClass("hidden");
                        $('#soldOut_' + catentryId).addClass("hidden");
                        $('#outOfStock_' + catentryId).removeClass('hidden').show();

                    } else if (productPrice == "" || (ranking == 0 && !flagComingSoon && (flagExclusive == true || flagExclusive == false) && (flagLimitedEdition == true || flagLimitedEdition == false))) {
                        // SOLD OUT

                        $('#add2CartBtn_' + catentryId).addClass("hidden");
                        $('#soldOut_' + catentryId).removeClass('hidden').show();
                        $('#outOfStock_' + catentryId).addClass("hidden");
                    }
                }
            } else if (lifecycle == 'INACT' ) {
                if (stock > 0 && ranking == 2 && !flagComingSoon && (flagExclusive == true || flagExclusive == false) && (flagLimitedEdition == true || flagLimitedEdition  == false) && productPrice != "") {
                    //ADD 2 CART

                    $('#add2CartBtn_' + catentryId).removeClass('hidden').show();
                    $('#soldOut_' + catentryId).addClass("hidden");
                    $('#outOfStock_' + catentryId).addClass("hidden");
                } else if (stock == 0) {
                    if (ranking == 2) ranking = 1;
                    if (productPrice == "" || ((ranking == 0 || ranking == 1) && !flagComingSoon)) {
                        // SOLD OUT
                        
                        $('#add2CartBtn_' + catentryId).addClass("hidden");
                        $('#soldOut_' + catentryId).removeClass('hidden').show();
                        $('#outOfStock_' + catentryId).addClass("hidden");
                    }  
                }
            }
    }
}

/* WISHLIST */

/* START - Logic moved from EarlyAccess.js */

function getUserId(){

    var url = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self";
  
    $.ajax({
        url: url,
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        async: false,
        success: function(data) {
            console.log("User id retrieved correctly");
            window.userId = data.userId;
        },
        error: function(data){
            console.log("Error retrieving user id");
        }
    });
    return userId;
  }
  
  /* With this function, the user is converted from a generic user (-1002) to a unique guest user  */
  
function setUserIdentity(){
  
    /*
    var url = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/guestidentity";
  
    $.ajax({
        url: url,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        async: false,
        success: function(data) {
            console.log("Unique user id generated correctly");
            window.userId = data.userId;
        },
        error: function(data){
            console.log("Error generating unique user id");
        }
    });
    */
    var params = [];

    params.storeId      = WCParamJS.storeId;
    params.catalogId    = WCParamJS.catalogId;
    params.langId       = WCParamJS.langId;

    params.deleteCartCookie = true;
    params.globalLogIn = true;

    var url = getAbsoluteURL() + "AjaxOrderCalculate?";
    for (var param  in params) {
        url += param + "=" + params[param] + "&";
    }
    url += "calculationUsageId=-1&";
    url += "calculationUsageId=-2&";

    //Make the call to AjaxOrderCalculate
    $.ajax({
        url: url,
        type: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        async: false,
        success: function (data) {
            console.log("Unique user id generated correctly");
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log("Error generating unique user id");
        }
    });
    window.userId = getUserId();
    return userId;

}

function tealiumPushWishlistAdd(wishlistObj, productId, partNumber){
    var tealiumObjWishlist = {}
    var keys = Object.keys(wishlistObj);
    productId.forEach((product) => {
        var frameType = "STD";
        var category = "";
        var preorder = 0;
        var price = '';
        var priceFull = '';

        if(wishlistObj[product.productId] != undefined){
            wishlistObj[product.productId].attributes.forEach(function(attribute) {
                if(attribute.identifier == 'PRODUCTTYPE'){
                    category = attribute.values[0].value.toUpperCase();
                }
                if(attribute.identifier == 'PREORDER'){
                    preorder = 1;
                }
            });
            price = wishlistObj[product.productId].price.price;
            priceFull = wishlistObj[product.productId].price.listprice;
        }
    
        tealiumObjWishlist[product.partNumber]= {
            'Category' : category,
            'Preorder' : preorder,
            'FrameType' : frameType,
            'LensType' : 'PLANO',
            'Price' :   price,
            'PriceFull' : priceFull,
            'Engraving' : "N"
        }
    })
        
      
    tealium_data2track.push({
        'id':'ProdFavAdd', 
        'Products': tealiumObjWishlist
    });
}

/* END - Logic moved from EarlyAccess.js */


//This function loads the wishlist guest espot content by js
function returnEspotContent(espotName) {
    var espotServiceUrl = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/espot/" + espotName + '?langId=' + WCParamJS.langId;
    var content ='';
    var parameters = {};
    parameters["timestamp"] = Date.now();

    return new Promise((resolve, reject) => {
        $.ajax({
            url: espotServiceUrl,
            type: 'GET',
            data: parameters,
            async: false,
            success: function(data) {
                data["MarketingSpotData"].forEach(function(msd, index) {
                    if(msd["baseMarketingSpotActivityData"] && msd["baseMarketingSpotActivityData"][0]["baseMarketingSpotDataType"] === "MarketingContent"){
                        content = msd["baseMarketingSpotActivityData"][0]["marketingContentDescription"][0]["marketingText"]; //html text
                    }
                });
                $("#guestWishlistEspotContent").val(content);
                resolve(data);
            },
            error: function(error) {
                console.error(error);
                reject(error);
            }
        });
    });
}

